"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory();
    else if (typeof define === 'function' && define.amd)
        define("SNLibrary", [], factory);
    else if (typeof exports === 'object')
        exports["SNLibrary"] = factory();
    else
        root["SNLibrary"] = factory();
})(self, () => {
    return /******/ (() => {
        /******/ "use strict";
        /******/ var __webpack_modules__ = ({
            /***/ 87244: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentDecoder = void 0;
                class ContentDecoder {
                    decode(content) {
                        let leftPaddingLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
                        try {
                            const contentToDecode = leftPaddingLength > 0 ? content.substring(leftPaddingLength) : content;
                            const contentBuffer = Buffer.from(contentToDecode, 'base64');
                            const decodedContent = contentBuffer.toString();
                            return JSON.parse(decodedContent);
                        }
                        catch (error) {
                            return {};
                        }
                    }
                    encode(content) {
                        let leftPaddingLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
                        const stringifiedContent = JSON.stringify(content);
                        const encodedContent = Buffer.from(stringifiedContent).toString('base64');
                        return encodedContent.padStart(encodedContent.length + leftPaddingLength, '0');
                    }
                }
                exports.ContentDecoder = ContentDecoder;
                /***/ 
            }),
            /***/ 21467: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 35411: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 30717: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 97936: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 79955: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 85413: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EmailMessageIdentifier = void 0;
                var EmailMessageIdentifier;
                (function (EmailMessageIdentifier) {
                    EmailMessageIdentifier["WELCOME_EMAIL"] = "WELCOME_EMAIL";
                    EmailMessageIdentifier["ACCOUNT_CLAIM"] = "ACCOUNT_CLAIM";
                    EmailMessageIdentifier["ACCOUNT_RESET"] = "ACCOUNT_RESET";
                    EmailMessageIdentifier["ACTIVATION_CODE"] = "ACTIVATION_CODE";
                    EmailMessageIdentifier["VERSION_ADOPTION_REPORT"] = "VERSION_ADOPTION_REPORT";
                    EmailMessageIdentifier["FAILED_DROPBOX_BACKUP"] = "FAILED_DROPBOX_BACKUP";
                    EmailMessageIdentifier["FAILED_GOOGLE_DRIVE_BACKUP"] = "FAILED_GOOGLE_DRIVE_BACKUP";
                    EmailMessageIdentifier["FAILED_ONE_DRIVE_BACKUP"] = "FAILED_ONE_DRIVE_BACKUP";
                    EmailMessageIdentifier["DATA_BACKUP"] = "DATA_BACKUP";
                    EmailMessageIdentifier["FAILED_BACKUP_ATTACHMENT_TOO_BIG"] = "FAILED_BACKUP_ATTACHMENT_TOO_BIG";
                    EmailMessageIdentifier["OFFLINE_SUBSCRIPTION_ACCESS"] = "OFFLINE_SUBSCRIPTION_ACCESS";
                    EmailMessageIdentifier["SIGN_IN"] = "SIGN_IN";
                    EmailMessageIdentifier["SHARED_SUBSCRIPTION_INVITATION"] = "SHARED_SUBSCRIPTION_INVITATION";
                    EmailMessageIdentifier["ENCOURAGE_EMAIL_BACKUPS"] = "ENCOURAGE_EMAIL_BACKUPS";
                    EmailMessageIdentifier["ENCOURAGE_SUBSCRIPTION_PURCHASING"] = "ENCOURAGE_SUBSCRIPTION_PURCHASING";
                    EmailMessageIdentifier["EXIT_INTERVIEW"] = "EXIT_INTERVIEW";
                    EmailMessageIdentifier["STUDENT_DISCOUNT_REQUESTED"] = "STUDENT_DISCOUNT_REQUESTED";
                    EmailMessageIdentifier["STUDENT_DISCOUNT_APPROVED"] = "STUDENT_DISCOUNT_APPROVED";
                    EmailMessageIdentifier["MARKETING_CAMPAIGN_FILES"] = "MARKETING_CAMPAIGN_FILES";
                    EmailMessageIdentifier["MARKETING_BLACK_FRIDAY_2022"] = "MARKETING_BLACK_FRIDAY_2022";
                    EmailMessageIdentifier["MARKETING_BLACK_FRIDAY_2022_REMINDER"] = "MARKETING_BLACK_FRIDAY_2022_REMINDER";
                    EmailMessageIdentifier["PAYMENT_FAILED"] = "PAYMENT_FAILED";
                    EmailMessageIdentifier["SEND_INVOICE"] = "SEND_INVOICE";
                    EmailMessageIdentifier["DISCOUNT_NOTICE"] = "DISCOUNT_NOTICE";
                    EmailMessageIdentifier["REFUND_NOTICE"] = "REFUND_NOTICE";
                    EmailMessageIdentifier["REFUND_REQUESTED"] = "REFUND_REQUESTED";
                    EmailMessageIdentifier["RATE_ADJUSTMENT_NOTICE"] = "RATE_ADJUSTMENT_NOTICE";
                    EmailMessageIdentifier["EXIT_DISCOUNT"] = "EXIT_DISCOUNT";
                    EmailMessageIdentifier["SUBSCRIPTION_CANCELLED"] = "SUBSCRIPTION_CANCELLED";
                })(EmailMessageIdentifier = exports.EmailMessageIdentifier || (exports.EmailMessageIdentifier = {}));
                /***/ 
            }),
            /***/ 35219: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 89125: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 86070: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68597: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 38427: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 45551: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 9650: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeyParamsOrigination = void 0;
                var KeyParamsOrigination;
                (function (KeyParamsOrigination) {
                    KeyParamsOrigination["Registration"] = "registration";
                    KeyParamsOrigination["EmailChange"] = "email-change";
                    KeyParamsOrigination["PasswordChange"] = "password-change";
                    KeyParamsOrigination["ProtocolUpgrade"] = "protocol-upgrade";
                    KeyParamsOrigination["PasscodeCreate"] = "passcode-create";
                    KeyParamsOrigination["PasscodeChange"] = "passcode-change";
                })(KeyParamsOrigination = exports.KeyParamsOrigination || (exports.KeyParamsOrigination = {}));
                /***/ 
            }),
            /***/ 32806: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PaymentType = void 0;
                /* istanbul ignore file */
                var PaymentType;
                (function (PaymentType) {
                    PaymentType["Initial"] = "initial";
                    PaymentType["Renewal"] = "renewal";
                })(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
                /***/ 
            }),
            /***/ 56253: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isVersionLessThanOrEqualTo = exports.leftVersionGreaterThanOrEqualToRight = exports.compareVersions = exports.protocolVersionFromEncryptedString = exports.ProtocolVersionLength = exports.isProtocolVersionExpired = exports.ProtocolExpirationDates = exports.ProtocolVersionLastNonrootItemsKey = exports.ProtocolVersionLatest = exports.ProtocolVersion = void 0;
                var ProtocolVersion;
                (function (ProtocolVersion) {
                    ProtocolVersion["V001"] = "001";
                    ProtocolVersion["V002"] = "002";
                    ProtocolVersion["V003"] = "003";
                    ProtocolVersion["V004"] = "004";
                })(ProtocolVersion = exports.ProtocolVersion || (exports.ProtocolVersion = {}));
                exports.ProtocolVersionLatest = ProtocolVersion.V004;
                /** The last protocol version to not use root-key based items keys */
                exports.ProtocolVersionLastNonrootItemsKey = ProtocolVersion.V003;
                exports.ProtocolExpirationDates = Object.freeze({
                    [ProtocolVersion.V001]: Date.parse('2018-01-01'),
                    [ProtocolVersion.V002]: Date.parse('2020-01-01')
                });
                function isProtocolVersionExpired(version) {
                    const expireDate = exports.ProtocolExpirationDates[version];
                    if (!expireDate) {
                        return false;
                    }
                    const expired = new Date().getTime() > expireDate;
                    return expired;
                }
                exports.isProtocolVersionExpired = isProtocolVersionExpired;
                exports.ProtocolVersionLength = 3;
                function protocolVersionFromEncryptedString(string) {
                    const version = string.substring(0, exports.ProtocolVersionLength);
                    if (Object.values(ProtocolVersion).includes(version)) {
                        return version;
                    }
                    throw Error("Unrecognized protocol version ".concat(version));
                }
                exports.protocolVersionFromEncryptedString = protocolVersionFromEncryptedString;
                /**
                 *  -1 if a < b
                 *  0 if a == b
                 *  1 if a > b
                 */
                function compareVersions(a, b) {
                    const aNum = Number(a);
                    const bNum = Number(b);
                    return aNum - bNum;
                }
                exports.compareVersions = compareVersions;
                function leftVersionGreaterThanOrEqualToRight(a, b) {
                    return compareVersions(a, b) >= 0;
                }
                exports.leftVersionGreaterThanOrEqualToRight = leftVersionGreaterThanOrEqualToRight;
                function isVersionLessThanOrEqualTo(input, compareTo) {
                    return compareVersions(input, compareTo) <= 0;
                }
                exports.isVersionLessThanOrEqualTo = isVersionLessThanOrEqualTo;
                /***/ 
            }),
            /***/ 52410: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionBillingFrequency = void 0;
                /* istanbul ignore file */
                var SubscriptionBillingFrequency;
                (function (SubscriptionBillingFrequency) {
                    SubscriptionBillingFrequency[SubscriptionBillingFrequency["Monthly"] = 1] = "Monthly";
                    SubscriptionBillingFrequency[SubscriptionBillingFrequency["Annual"] = 12] = "Annual";
                    SubscriptionBillingFrequency[SubscriptionBillingFrequency["FiveYear"] = 60] = "FiveYear";
                })(SubscriptionBillingFrequency = exports.SubscriptionBillingFrequency || (exports.SubscriptionBillingFrequency = {}));
                /***/ 
            }),
            /***/ 74911: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionName = void 0;
                /* istanbul ignore file */
                var SubscriptionName;
                (function (SubscriptionName) {
                    SubscriptionName["PlusPlan"] = "PLUS_PLAN";
                    SubscriptionName["ProPlan"] = "PRO_PLAN";
                })(SubscriptionName = exports.SubscriptionName || (exports.SubscriptionName = {}));
                /***/ 
            }),
            /***/ 83402: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 62665: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 90235: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserRequestType = void 0;
                var UserRequestType;
                (function (UserRequestType) {
                    UserRequestType["ExitDiscount"] = "exit-discount";
                })(UserRequestType = exports.UserRequestType || (exports.UserRequestType = {}));
                /***/ 
            }),
            /***/ 25560: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(87244), exports);
                __exportStar(__webpack_require__(21467), exports);
                __exportStar(__webpack_require__(35411), exports);
                __exportStar(__webpack_require__(97936), exports);
                __exportStar(__webpack_require__(79955), exports);
                __exportStar(__webpack_require__(30717), exports);
                __exportStar(__webpack_require__(85413), exports);
                __exportStar(__webpack_require__(35219), exports);
                __exportStar(__webpack_require__(89125), exports);
                __exportStar(__webpack_require__(86070), exports);
                __exportStar(__webpack_require__(68597), exports);
                __exportStar(__webpack_require__(38427), exports);
                __exportStar(__webpack_require__(45551), exports);
                __exportStar(__webpack_require__(9650), exports);
                __exportStar(__webpack_require__(32806), exports);
                __exportStar(__webpack_require__(56253), exports);
                __exportStar(__webpack_require__(52410), exports);
                __exportStar(__webpack_require__(74911), exports);
                __exportStar(__webpack_require__(83402), exports);
                __exportStar(__webpack_require__(62665), exports);
                __exportStar(__webpack_require__(90235), exports);
                /***/ 
            }),
            /***/ 20875: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(25560), exports);
                /***/ 
            }),
            /***/ 50569: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.LegacySession = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const Validator_1 = __webpack_require__(42544);
                class LegacySession extends ValueObject_1.ValueObject {
                    get accessToken() {
                        return this.props.token;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(token) {
                        if (Validator_1.Validator.isNotEmpty(token).isFailed()) {
                            return Result_1.Result.fail('Could not create legacy session. Token value is empty');
                        }
                        return Result_1.Result.ok(new LegacySession({
                            token
                        }));
                    }
                }
                exports.LegacySession = LegacySession;
                /***/ 
            }),
            /***/ 89957: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 87879: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Session = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                class Session extends ValueObject_1.ValueObject {
                    get accessToken() {
                        return this.props.accessToken;
                    }
                    get refreshToken() {
                        return this.props.refreshToken;
                    }
                    isReadOnly() {
                        return this.props.readonlyAccess || false;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(accessToken, refreshToken, readonlyAccess) {
                        return Result_1.Result.ok(new Session({
                            accessToken,
                            refreshToken,
                            readonlyAccess
                        }));
                    }
                }
                exports.Session = Session;
                /***/ 
            }),
            /***/ 92932: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 65085: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SessionToken = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const Validator_1 = __webpack_require__(42544);
                class SessionToken extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    get expiresAt() {
                        return this.props.expiresAt;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(value, expiresAt) {
                        if (Validator_1.Validator.isNotEmpty(value).isFailed()) {
                            return Result_1.Result.fail('Could not create session token. Token value is empty');
                        }
                        if (Validator_1.Validator.isNotEmpty(expiresAt).isFailed()) {
                            return Result_1.Result.fail('Could not create session token. Token expiration is empty');
                        }
                        return Result_1.Result.ok(new SessionToken({
                            value,
                            expiresAt
                        }));
                    }
                }
                exports.SessionToken = SessionToken;
                /***/ 
            }),
            /***/ 38487: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43324: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CacheEntry = void 0;
                const Entity_1 = __webpack_require__(77546);
                const Result_1 = __webpack_require__(33969);
                class CacheEntry extends Entity_1.Entity {
                    constructor(props, id) {
                        super(props, id);
                    }
                    static create(props, id) {
                        return Result_1.Result.ok(new CacheEntry(props, id));
                    }
                }
                exports.CacheEntry = CacheEntry;
                /***/ 
            }),
            /***/ 78881: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 67794: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 84287: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentType = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class ContentType extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                        this.displayNamesMap = {
                            [ContentType.TYPES.ActionsExtension]: 'action-based extension',
                            [ContentType.TYPES.Component]: 'component',
                            [ContentType.TYPES.Editor]: 'editor',
                            [ContentType.TYPES.File]: 'file',
                            [ContentType.TYPES.FilesafeCredentials]: 'FileSafe credential',
                            [ContentType.TYPES.FilesafeFileMetadata]: 'FileSafe file',
                            [ContentType.TYPES.FilesafeIntegration]: 'FileSafe integration',
                            [ContentType.TYPES.ItemsKey]: 'encryption key',
                            [ContentType.TYPES.Note]: 'note',
                            [ContentType.TYPES.SmartView]: 'smart view',
                            [ContentType.TYPES.Tag]: 'tag',
                            [ContentType.TYPES.Theme]: 'theme',
                            [ContentType.TYPES.UserPrefs]: 'user preferences'
                        };
                    }
                    static create(type) {
                        if (type === null) {
                            return Result_1.Result.ok(new ContentType({
                                value: null
                            }));
                        }
                        const isValidType = Object.values(this.TYPES).includes(type);
                        if (!isValidType) {
                            return Result_1.Result.fail("Invalid content type: ".concat(type));
                        }
                        else {
                            return Result_1.Result.ok(new ContentType({
                                value: type
                            }));
                        }
                    }
                    getDisplayName() {
                        if (!this.value) {
                            return null;
                        }
                        return this.displayNamesMap[this.value] || this.value;
                    }
                }
                ContentType.TYPES = {
                    Any: '*',
                    Item: 'SF|Item',
                    KeySystemItemsKey: 'SN|KeySystemItemsKey',
                    KeySystemRootKey: 'SN|KeySystemRootKey',
                    TrustedContact: 'SN|TrustedContact',
                    VaultListing: 'SN|VaultListing',
                    RootKey: 'SN|RootKey|NoSync',
                    ItemsKey: 'SN|ItemsKey',
                    EncryptedStorage: 'SN|EncryptedStorage',
                    Note: 'Note',
                    Tag: 'Tag',
                    SmartView: 'SN|SmartTag',
                    Component: 'SN|Component',
                    Editor: 'SN|Editor',
                    ActionsExtension: 'Extension',
                    UserPrefs: 'SN|UserPreferences',
                    HistorySession: 'SN|HistorySession',
                    Theme: 'SN|Theme',
                    File: 'SN|File',
                    FilesafeCredentials: 'SN|FileSafe|Credentials',
                    FilesafeFileMetadata: 'SN|FileSafe|FileMetadata',
                    FilesafeIntegration: 'SN|FileSafe|Integration',
                    ExtensionRepo: 'SN|ExtensionRepo'
                };
                exports.ContentType = ContentType;
                /***/ 
            }),
            /***/ 4273: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 92339: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Dates = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class Dates extends ValueObject_1.ValueObject {
                    get createdAt() {
                        return this.props.createdAt;
                    }
                    get updatedAt() {
                        return this.props.updatedAt;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(createdAt, updatedAt) {
                        if (!(createdAt instanceof Date)) {
                            return Result_1.Result.fail("Could not create Dates. Creation date should be a date object, given: ".concat(createdAt));
                        }
                        if (!(updatedAt instanceof Date)) {
                            return Result_1.Result.fail("Could not create Dates. Update date should be a date object, given: ".concat(updatedAt));
                        }
                        return Result_1.Result.ok(new Dates({
                            createdAt,
                            updatedAt
                        }));
                    }
                }
                exports.Dates = Dates;
                /***/ 
            }),
            /***/ 57154: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63666: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Email = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const Validator_1 = __webpack_require__(42544);
                class Email extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(email) {
                        if (Validator_1.Validator.isString(email).isFailed()) {
                            return Result_1.Result.fail('Email must be a string');
                        }
                        const trimmedAndLowerCasedEmail = email.trim().toLowerCase();
                        const emailValidation = Validator_1.Validator.isValidEmail(trimmedAndLowerCasedEmail);
                        if (emailValidation.isFailed()) {
                            return Result_1.Result.fail(emailValidation.getError());
                        }
                        return Result_1.Result.ok(new Email({
                            value: trimmedAndLowerCasedEmail
                        }));
                    }
                }
                exports.Email = Email;
                /***/ 
            }),
            /***/ 63931: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 65180: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.RoleName = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                class RoleName extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    hasMoreOrEqualPowerTo(roleName) {
                        switch (this.value) {
                            case RoleName.NAMES.InternalTeamUser:
                                return true;
                            case RoleName.NAMES.ProUser:
                                return [RoleName.NAMES.CoreUser, RoleName.NAMES.PlusUser, RoleName.NAMES.ProUser].includes(roleName.value);
                            case RoleName.NAMES.PlusUser:
                                return [RoleName.NAMES.CoreUser, RoleName.NAMES.PlusUser].includes(roleName.value);
                            case RoleName.NAMES.CoreUser:
                            case RoleName.NAMES.VaultsUser:
                                return [RoleName.NAMES.CoreUser].includes(roleName.value);
                            /*istanbul ignore next*/
                            default:
                                throw new Error("Invalid role name: ".concat(this.value));
                        }
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(name) {
                        const isValidName = Object.values(this.NAMES).includes(name);
                        if (!isValidName) {
                            return Result_1.Result.fail("Invalid role name: ".concat(name));
                        }
                        else {
                            return Result_1.Result.ok(new RoleName({
                                value: name
                            }));
                        }
                    }
                }
                RoleName.NAMES = {
                    CoreUser: 'CORE_USER',
                    PlusUser: 'PLUS_USER',
                    ProUser: 'PRO_USER',
                    InternalTeamUser: 'INTERNAL_TEAM_USER',
                    VaultsUser: 'VAULTS_USER'
                };
                exports.RoleName = RoleName;
                /***/ 
            }),
            /***/ 60216: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.RoleNameCollection = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const RoleName_1 = __webpack_require__(65180);
                class RoleNameCollection extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    includes(roleName) {
                        for (const existingRoleName of this.props.value) {
                            if (existingRoleName.value === roleName.value) {
                                return true;
                            }
                        }
                        return false;
                    }
                    hasARoleNameWithMoreOrEqualPowerTo(roleName) {
                        for (const existingRoleName of this.props.value) {
                            if (existingRoleName.hasMoreOrEqualPowerTo(roleName)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    equals(roleNameCollection) {
                        if (this.props.value.length !== roleNameCollection.value.length) {
                            return false;
                        }
                        for (const roleName of roleNameCollection.value) {
                            if (!this.includes(roleName)) {
                                return false;
                            }
                        }
                        return true;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(roleNameStrings) {
                        const roleNames = [];
                        for (const roleNameString of roleNameStrings) {
                            const roleNameOrError = RoleName_1.RoleName.create(roleNameString);
                            if (roleNameOrError.isFailed()) {
                                return Result_1.Result.fail(roleNameOrError.getError());
                            }
                            roleNames.push(roleNameOrError.getValue());
                        }
                        return Result_1.Result.ok(new RoleNameCollection({
                            value: roleNames
                        }));
                    }
                }
                exports.RoleNameCollection = RoleNameCollection;
                /***/ 
            }),
            /***/ 78060: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 49565: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 77803: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Timestamps = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class Timestamps extends ValueObject_1.ValueObject {
                    get createdAt() {
                        return this.props.createdAt;
                    }
                    get updatedAt() {
                        return this.props.updatedAt;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(createdAt, updatedAt) {
                        if (isNaN(createdAt) || typeof createdAt !== 'number') {
                            return Result_1.Result.fail("Could not create Timestamps. Creation date should be a number, given: ".concat(createdAt));
                        }
                        if (isNaN(updatedAt) || typeof updatedAt !== 'number') {
                            return Result_1.Result.fail("Could not create Timestamps. Update date should be a number, given: ".concat(updatedAt));
                        }
                        return Result_1.Result.ok(new Timestamps({
                            createdAt,
                            updatedAt
                        }));
                    }
                }
                exports.Timestamps = Timestamps;
                /***/ 
            }),
            /***/ 95332: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 96806: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Username = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const Validator_1 = __webpack_require__(42544);
                class Username extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(username) {
                        if (Validator_1.Validator.isString(username).isFailed()) {
                            return Result_1.Result.fail('Username must be a string');
                        }
                        const trimmedAndLowerCasedUsername = username.trim().toLowerCase();
                        if (Validator_1.Validator.isNotEmpty(trimmedAndLowerCasedUsername).isFailed()) {
                            return Result_1.Result.fail('Username cannot be empty');
                        }
                        return Result_1.Result.ok(new Username({
                            value: trimmedAndLowerCasedUsername
                        }));
                    }
                    isPotentiallyAPrivateUsernameAccount() {
                        return this.value.length === 64 && !this.value.includes('@');
                    }
                }
                exports.Username = Username;
                /***/ 
            }),
            /***/ 29835: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 26477: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Uuid = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const Validator_1 = __webpack_require__(42544);
                class Uuid extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(uuid) {
                        const validUuidOrError = Validator_1.Validator.isValidUuid(uuid);
                        if (validUuidOrError.isFailed()) {
                            return Result_1.Result.fail(validUuidOrError.getError());
                        }
                        else {
                            return Result_1.Result.ok(new Uuid({
                                value: uuid
                            }));
                        }
                    }
                }
                exports.Uuid = Uuid;
                /***/ 
            }),
            /***/ 55928: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 69838: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Aggregate = void 0;
                const Entity_1 = __webpack_require__(77546);
                class Aggregate extends Entity_1.Entity {
                    constructor() {
                        super(...arguments);
                        this.changesOnAggregateRoot = [];
                    }
                    addChange(change) {
                        this.changesOnAggregateRoot.push(change);
                    }
                    flushChanges() {
                        this.changesOnAggregateRoot = [];
                    }
                    getChanges() {
                        return this.changesOnAggregateRoot;
                    }
                }
                exports.Aggregate = Aggregate;
                /***/ 
            }),
            /***/ 39653: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Change = void 0;
                const Result_1 = __webpack_require__(33969);
                class Change {
                    constructor(props) {
                        this.props = Object.freeze(props);
                    }
                    static create(props) {
                        if (!Object.values(Change.TYPES).includes(props.changeType)) {
                            return Result_1.Result.fail('Invalid change type');
                        }
                        return Result_1.Result.ok(new Change(props));
                    }
                }
                Change.TYPES = {
                    Add: 'add',
                    Remove: 'remove',
                    Modify: 'modify'
                };
                exports.Change = Change;
                /***/ 
            }),
            /***/ 24128: 
            /***/ ((__unused_webpack_module, exports) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 77546: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Entity = void 0;
                const UniqueEntityId_1 = __webpack_require__(85193);
                class Entity {
                    constructor(props, id) {
                        this.props = props;
                        this._id = id ? id : new UniqueEntityId_1.UniqueEntityId();
                    }
                    get id() {
                        return this._id;
                    }
                    equals(object) {
                        if (object == null || object == undefined) {
                            return false;
                        }
                        if (this === object) {
                            return true;
                        }
                        if (!(object instanceof Entity)) {
                            return false;
                        }
                        return this._id.equals(object._id);
                    }
                }
                exports.Entity = Entity;
                /***/ 
            }),
            /***/ 2602: 
            /***/ ((__unused_webpack_module, exports) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Id = void 0;
                class Id {
                    constructor(value) {
                        this.value = value;
                    }
                    equals(id) {
                        if (id === null || id === undefined) {
                            return false;
                        }
                        if (!(id instanceof this.constructor)) {
                            return false;
                        }
                        return id.toValue() === this.value;
                    }
                    toString() {
                        return String(this.value);
                    }
                    toValue() {
                        return this.value;
                    }
                }
                exports.Id = Id;
                /***/ 
            }),
            /***/ 33969: 
            /***/ ((__unused_webpack_module, exports) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Result = void 0;
                class Result {
                    constructor(isSuccess, error, value) {
                        this.isSuccess = isSuccess;
                        this.error = error;
                        this.value = value;
                        Object.freeze(this);
                    }
                    isFailed() {
                        return !this.isSuccess;
                    }
                    getValue() {
                        if (!this.isSuccess) {
                            throw new Error("Cannot get value of an unsuccessfull result: ".concat(this.error));
                        }
                        return this.value;
                    }
                    getError() {
                        if (this.isSuccess || this.error === undefined) {
                            throw new Error('Cannot get an error of a successfull result');
                        }
                        return this.error;
                    }
                    static ok(value) {
                        return new Result(true, undefined, value);
                    }
                    static fail(error) {
                        return new Result(false, error);
                    }
                }
                exports.Result = Result;
                /***/ 
            }),
            /***/ 85193: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                /* istanbul ignore file */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UniqueEntityId = void 0;
                const uuid_1 = __webpack_require__(31777);
                const Id_1 = __webpack_require__(2602);
                class UniqueEntityId extends Id_1.Id {
                    constructor(id) {
                        super(id ? id : (0, uuid_1.v4)());
                    }
                }
                exports.UniqueEntityId = UniqueEntityId;
                /***/ 
            }),
            /***/ 42544: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Validator = void 0;
                const Result_1 = __webpack_require__(33969);
                class Validator {
                    static isValidUuid(value) {
                        const matchesUuidRegex = String(value).toLowerCase().match(Validator.UUID_ANY_VERSION_AND_VARIANT_REGEX) !== null;
                        if (matchesUuidRegex) {
                            return Result_1.Result.ok();
                        }
                        return Result_1.Result.fail("Given value is not a valid uuid: ".concat(value));
                    }
                    static isValidEmail(value) {
                        const matchesUuidRegex = String(value).toLowerCase().match(Validator.EMAIL_REGEX) !== null;
                        if (matchesUuidRegex) {
                            return Result_1.Result.ok();
                        }
                        return Result_1.Result.fail("Given value is not a valid email address: ".concat(value));
                    }
                    static isString(value) {
                        if (typeof value === 'string') {
                            return Result_1.Result.ok();
                        }
                        return Result_1.Result.fail("Given value is not a string: ".concat(typeof value));
                    }
                    static isNotEmpty(value) {
                        if (value instanceof Array && value.length === 0) {
                            return Result_1.Result.fail("Given value is empty: ".concat(value));
                        }
                        if (value === null || value === undefined || value === '') {
                            return Result_1.Result.fail("Given value is empty: ".concat(value));
                        }
                        return Result_1.Result.ok();
                    }
                    static isNotEmptyString(value) {
                        const isStringResult = Validator.isString(value);
                        if (isStringResult.isFailed()) {
                            return isStringResult;
                        }
                        const isNotEmptyResult = Validator.isNotEmpty(value);
                        if (isNotEmptyResult.isFailed()) {
                            return isNotEmptyResult;
                        }
                        return Result_1.Result.ok();
                    }
                }
                Validator.UUID_ANY_VERSION_AND_VARIANT_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                Validator.EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                exports.Validator = Validator;
                /***/ 
            }),
            /***/ 93461: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ValueObject = void 0;
                class ValueObject {
                    constructor(props) {
                        this.props = Object.freeze(props);
                    }
                    equals(vo) {
                        if (vo === null || vo === undefined) {
                            return false;
                        }
                        return JSON.stringify(this.props) === JSON.stringify(vo.props);
                    }
                }
                exports.ValueObject = ValueObject;
                /***/ 
            }),
            /***/ 21797: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 82806: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ControllerContainer = void 0;
                class ControllerContainer {
                    constructor() {
                        this.controllerMethodsMap = new Map();
                    }
                    register(methodIdentifier, binding) {
                        this.controllerMethodsMap.set(methodIdentifier, binding);
                    }
                    get(methodIdentifier) {
                        return this.controllerMethodsMap.get(methodIdentifier);
                    }
                }
                exports.ControllerContainer = ControllerContainer;
                /***/ 
            }),
            /***/ 30048: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 95951: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EmailLevel = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class EmailLevel extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(name) {
                        const isValidName = Object.values(this.LEVELS).includes(name);
                        if (!isValidName) {
                            return Result_1.Result.fail("Invalid subscription rejection level: ".concat(name));
                        }
                        else {
                            return Result_1.Result.ok(new EmailLevel({
                                value: name
                            }));
                        }
                    }
                }
                EmailLevel.LEVELS = {
                    System: 'SYSTEM',
                    SignIn: 'SIGN_IN',
                    Marketing: 'MARKETING',
                    FailedCloudBackup: 'FAILED_CLOUD_BACKUP',
                    FailedEmailBackup: 'FAILED_EMAIL_BACKUP'
                };
                exports.EmailLevel = EmailLevel;
                /***/ 
            }),
            /***/ 78690: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 12677: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AbstractEnv = void 0;
                class AbstractEnv {
                    constructor() {
                        let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this.env = {};
                        this.overrides = overrides;
                    }
                    get(key) {
                        let optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        if (!this.env) {
                            this.load();
                        }
                        if (this.overrides[key]) {
                            return this.overrides[key];
                        }
                        if (!process.env[key] && !optional) {
                            throw new Error("Environment variable ".concat(key, " not set"));
                        }
                        return process.env[key];
                    }
                    getAll() {
                        if (!this.env) {
                            this.load();
                        }
                        return this.env;
                    }
                }
                exports.AbstractEnv = AbstractEnv;
                /***/ 
            }),
            /***/ 49321: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 26112: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NotificationPayload = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                const NotificationType_1 = __webpack_require__(1166);
                const Uuid_1 = __webpack_require__(26477);
                const NotificationPayloadIdentifierType_1 = __webpack_require__(63011);
                class NotificationPayload extends ValueObject_1.ValueObject {
                    constructor(props) {
                        super(props);
                    }
                    toString() {
                        var _a, _b;
                        return JSON.stringify({
                            version: this.props.version,
                            type: this.props.type.value,
                            primaryIdentifier: this.props.primaryIdentifier.value,
                            primaryIndentifierType: this.props.primaryIndentifierType.value,
                            secondaryIdentifier: (_a = this.props.secondaryIdentifier) === null || _a === void 0 ? void 0 : _a.value,
                            secondaryIdentifierType: (_b = this.props.secondaryIdentifierType) === null || _b === void 0 ? void 0 : _b.value
                        });
                    }
                    static createFromString(jsonPayload) {
                        try {
                            const props = JSON.parse(jsonPayload);
                            const typeOrError = NotificationType_1.NotificationType.create(props.type);
                            if (typeOrError.isFailed()) {
                                return Result_1.Result.fail(typeOrError.getError());
                            }
                            const type = typeOrError.getValue();
                            const primaryIdentifierOrError = Uuid_1.Uuid.create(props.primaryIdentifier);
                            if (primaryIdentifierOrError.isFailed()) {
                                return Result_1.Result.fail(primaryIdentifierOrError.getError());
                            }
                            const primaryIdentifier = primaryIdentifierOrError.getValue();
                            const primaryIndentifierTypeOrError = NotificationPayloadIdentifierType_1.NotificationPayloadIdentifierType.create(props.primaryIndentifierType);
                            if (primaryIndentifierTypeOrError.isFailed()) {
                                return Result_1.Result.fail(primaryIndentifierTypeOrError.getError());
                            }
                            const primaryIndentifierType = primaryIndentifierTypeOrError.getValue();
                            let secondaryIdentifier;
                            if (props.secondaryIdentifier) {
                                const secondaryIdentifierOrError = Uuid_1.Uuid.create(props.secondaryIdentifier);
                                if (secondaryIdentifierOrError.isFailed()) {
                                    return Result_1.Result.fail(secondaryIdentifierOrError.getError());
                                }
                                secondaryIdentifier = secondaryIdentifierOrError.getValue();
                            }
                            let secondaryIdentifierType;
                            if (props.secondaryIdentifierType) {
                                const secondaryIdentifierTypeOrError = NotificationPayloadIdentifierType_1.NotificationPayloadIdentifierType.create(props.secondaryIdentifierType);
                                if (secondaryIdentifierTypeOrError.isFailed()) {
                                    return Result_1.Result.fail(secondaryIdentifierTypeOrError.getError());
                                }
                                secondaryIdentifierType = secondaryIdentifierTypeOrError.getValue();
                            }
                            return NotificationPayload.create({
                                version: props.version,
                                type,
                                primaryIdentifier,
                                primaryIndentifierType,
                                secondaryIdentifier,
                                secondaryIdentifierType
                            });
                        }
                        catch (error) {
                            return Result_1.Result.fail(error.message);
                        }
                    }
                    static create(props) {
                        if (props.secondaryIdentifier === undefined && props.type.equals(NotificationType_1.NotificationType.create(NotificationType_1.NotificationType.TYPES.SharedVaultItemRemoved).getValue())) {
                            return Result_1.Result.fail("Item uuid is required for ".concat(NotificationType_1.NotificationType.TYPES.SharedVaultItemRemoved, " notification type"));
                        }
                        return Result_1.Result.ok(new NotificationPayload(props));
                    }
                }
                exports.NotificationPayload = NotificationPayload;
                /***/ 
            }),
            /***/ 63011: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NotificationPayloadIdentifierType = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class NotificationPayloadIdentifierType extends ValueObject_1.ValueObject {
                    constructor(props) {
                        super(props);
                    }
                    get value() {
                        return this.props.value;
                    }
                    static create(type) {
                        if (!Object.values(this.TYPES).includes(type)) {
                            return Result_1.Result.fail("Invalid notification payload identifier type: ".concat(type));
                        }
                        return Result_1.Result.ok(new NotificationPayloadIdentifierType({
                            value: type
                        }));
                    }
                }
                NotificationPayloadIdentifierType.TYPES = {
                    SharedVaultUuid: 'shared_vault_uuid',
                    UserUuid: 'user_uuid',
                    SharedVaultInviteUuid: 'shared_vault_invite_uuid',
                    ItemUuid: 'item_uuid'
                };
                exports.NotificationPayloadIdentifierType = NotificationPayloadIdentifierType;
                /***/ 
            }),
            /***/ 33980: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 98719: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 1166: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NotificationType = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class NotificationType extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(notificationType) {
                        const isValidType = Object.values(this.TYPES).includes(notificationType);
                        if (!isValidType) {
                            return Result_1.Result.fail("Invalid notification type: ".concat(notificationType));
                        }
                        else {
                            return Result_1.Result.ok(new NotificationType({
                                value: notificationType
                            }));
                        }
                    }
                }
                NotificationType.TYPES = {
                    SharedVaultItemRemoved: 'shared_vault_item_removed',
                    SelfRemovedFromSharedVault: 'self_removed_from_shared_vault',
                    UserRemovedFromSharedVault: 'user_removed_from_shared_vault',
                    UserDesignatedAsSurvivor: 'user_designated_as_survivor',
                    UserAddedToSharedVault: 'user_added_to_shared_vault',
                    SharedVaultInviteCanceled: 'shared_vault_invite_canceled',
                    SharedVaultFileUploaded: 'shared_vault_file_uploaded',
                    SharedVaultFileRemoved: 'shared_vault_file_removed'
                };
                exports.NotificationType = NotificationType;
                /***/ 
            }),
            /***/ 33479: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 98401: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 93738: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ServiceContainer = void 0;
                class ServiceContainer {
                    constructor() {
                        this.serviceMap = new Map();
                    }
                    register(serviceIdentifer, service) {
                        this.serviceMap.set(serviceIdentifer.value, service);
                    }
                    get(serviceIdentifer) {
                        return this.serviceMap.get(serviceIdentifer.value);
                    }
                }
                exports.ServiceContainer = ServiceContainer;
                /***/ 
            }),
            /***/ 19055: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 5775: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ServiceIdentifier = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                class ServiceIdentifier extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(name) {
                        const isValidName = Object.values(this.NAMES).includes(name);
                        if (!isValidName) {
                            return Result_1.Result.fail("Invalid subscription plan name: ".concat(name));
                        }
                        else {
                            return Result_1.Result.ok(new ServiceIdentifier({
                                value: name
                            }));
                        }
                    }
                }
                ServiceIdentifier.NAMES = {
                    AnalyticsWorker: 'AnalyticsWorker',
                    AnalyticsScheduledTask: 'AnalyticsScheduledTask',
                    ApiGateway: 'ApiGateway',
                    Auth: 'Auth',
                    AuthWorker: 'AuthWorker',
                    AuthScheduledTask: 'AuthScheduledTask',
                    SyncingServer: 'SyncingServer',
                    SyncingServerWorker: 'SyncingServerWorker',
                    Revisions: 'Revisions',
                    RevisionsWorker: 'RevisionsWorker',
                    Files: 'Files',
                    FilesWorker: 'FilesWorker',
                    SchedulerWorker: 'SchedulerWorker',
                    SchedulerScheduledTask: 'SchedulerScheduledTask',
                    Email: 'Email',
                    EmailWorker: 'EmailWorker',
                    EmailBounceProcessor: 'EmailBounceProcessor',
                    EmailScheduledTask: 'EmailScheduledTask',
                    Websockets: 'Websockets',
                    WebsocketsWorker: 'WebsocketsWorker'
                };
                exports.ServiceIdentifier = ServiceIdentifier;
                /***/ 
            }),
            /***/ 55334: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 35491: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 41406: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SettingName = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class SettingName extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    isSensitive() {
                        return [SettingName.NAMES.MfaSecret, SettingName.NAMES.ExtensionKey].includes(this.props.value);
                    }
                    isASubscriptionSetting() {
                        return [SettingName.NAMES.FileUploadBytesLimit, SettingName.NAMES.FileUploadBytesUsed, SettingName.NAMES.MuteSignInEmails].includes(this.props.value);
                    }
                    isARegularOnlySubscriptionSetting() {
                        return [SettingName.NAMES.FileUploadBytesLimit, SettingName.NAMES.FileUploadBytesUsed].includes(this.props.value);
                    }
                    isASharedAndRegularOnlySubscriptionSetting() {
                        return [SettingName.NAMES.MuteSignInEmails].includes(this.props.value);
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(name) {
                        const isValidName = Object.values(this.NAMES).includes(name);
                        if (!isValidName) {
                            return Result_1.Result.fail("Invalid setting name: ".concat(name));
                        }
                        else {
                            return Result_1.Result.ok(new SettingName({
                                value: name
                            }));
                        }
                    }
                }
                SettingName.NAMES = {
                    MfaSecret: 'MFA_SECRET',
                    ExtensionKey: 'EXTENSION_KEY',
                    EmailBackupFrequency: 'EMAIL_BACKUP_FREQUENCY',
                    DropboxBackupFrequency: 'DROPBOX_BACKUP_FREQUENCY',
                    DropboxBackupToken: 'DROPBOX_BACKUP_TOKEN',
                    OneDriveBackupFrequency: 'ONE_DRIVE_BACKUP_FREQUENCY',
                    OneDriveBackupToken: 'ONE_DRIVE_BACKUP_TOKEN',
                    GoogleDriveBackupFrequency: 'GOOGLE_DRIVE_BACKUP_FREQUENCY',
                    GoogleDriveBackupToken: 'GOOGLE_DRIVE_BACKUP_TOKEN',
                    MuteFailedBackupsEmails: 'MUTE_FAILED_BACKUPS_EMAILS',
                    MuteFailedCloudBackupsEmails: 'MUTE_FAILED_CLOUD_BACKUPS_EMAILS',
                    MuteSignInEmails: 'MUTE_SIGN_IN_EMAILS',
                    MuteMarketingEmails: 'MUTE_MARKETING_EMAILS',
                    ListedAuthorSecrets: 'LISTED_AUTHOR_SECRETS',
                    LogSessionUserAgent: 'LOG_SESSION_USER_AGENT',
                    RecoveryCodes: 'RECOVERY_CODES',
                    FileUploadBytesLimit: 'FILE_UPLOAD_BYTES_LIMIT',
                    FileUploadBytesUsed: 'FILE_UPLOAD_BYTES_USED'
                };
                exports.SettingName = SettingName;
                /***/ 
            }),
            /***/ 10262: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 94478: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultUser = void 0;
                const Entity_1 = __webpack_require__(77546);
                const Result_1 = __webpack_require__(33969);
                class SharedVaultUser extends Entity_1.Entity {
                    constructor(props, id) {
                        super(props, id);
                    }
                    static create(props, id) {
                        return Result_1.Result.ok(new SharedVaultUser(props, id));
                    }
                }
                exports.SharedVaultUser = SharedVaultUser;
                /***/ 
            }),
            /***/ 95626: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultUserPermission = void 0;
                const Result_1 = __webpack_require__(33969);
                const ValueObject_1 = __webpack_require__(93461);
                class SharedVaultUserPermission extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(sharedVaultUserPermission) {
                        const isValidPermission = Object.values(this.PERMISSIONS).includes(sharedVaultUserPermission);
                        if (!isValidPermission) {
                            return Result_1.Result.fail("Invalid shared vault user permission ".concat(sharedVaultUserPermission));
                        }
                        else {
                            return Result_1.Result.ok(new SharedVaultUserPermission({
                                value: sharedVaultUserPermission
                            }));
                        }
                    }
                }
                SharedVaultUserPermission.PERMISSIONS = {
                    Read: 'read',
                    Write: 'write',
                    Admin: 'admin'
                };
                exports.SharedVaultUserPermission = SharedVaultUserPermission;
                /***/ 
            }),
            /***/ 27369: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 76226: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 96829: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionPlanName = void 0;
                const ValueObject_1 = __webpack_require__(93461);
                const Result_1 = __webpack_require__(33969);
                class SubscriptionPlanName extends ValueObject_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(name) {
                        const isValidName = Object.values(this.NAMES).includes(name);
                        if (!isValidName) {
                            return Result_1.Result.fail("Invalid subscription plan name: ".concat(name));
                        }
                        else {
                            return Result_1.Result.ok(new SubscriptionPlanName({
                                value: name
                            }));
                        }
                    }
                }
                SubscriptionPlanName.NAMES = {
                    PlusPlan: 'PLUS_PLAN',
                    ProPlan: 'PRO_PLAN'
                };
                exports.SubscriptionPlanName = SubscriptionPlanName;
                /***/ 
            }),
            /***/ 13709: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 11829: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 17505: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 69749: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(50569), exports);
                __exportStar(__webpack_require__(89957), exports);
                __exportStar(__webpack_require__(87879), exports);
                __exportStar(__webpack_require__(92932), exports);
                __exportStar(__webpack_require__(65085), exports);
                __exportStar(__webpack_require__(38487), exports);
                __exportStar(__webpack_require__(43324), exports);
                __exportStar(__webpack_require__(78881), exports);
                __exportStar(__webpack_require__(67794), exports);
                __exportStar(__webpack_require__(84287), exports);
                __exportStar(__webpack_require__(4273), exports);
                __exportStar(__webpack_require__(92339), exports);
                __exportStar(__webpack_require__(57154), exports);
                __exportStar(__webpack_require__(63666), exports);
                __exportStar(__webpack_require__(63931), exports);
                __exportStar(__webpack_require__(65180), exports);
                __exportStar(__webpack_require__(49565), exports);
                __exportStar(__webpack_require__(60216), exports);
                __exportStar(__webpack_require__(78060), exports);
                __exportStar(__webpack_require__(77803), exports);
                __exportStar(__webpack_require__(95332), exports);
                __exportStar(__webpack_require__(96806), exports);
                __exportStar(__webpack_require__(29835), exports);
                __exportStar(__webpack_require__(26477), exports);
                __exportStar(__webpack_require__(55928), exports);
                __exportStar(__webpack_require__(69838), exports);
                __exportStar(__webpack_require__(39653), exports);
                __exportStar(__webpack_require__(24128), exports);
                __exportStar(__webpack_require__(77546), exports);
                __exportStar(__webpack_require__(2602), exports);
                __exportStar(__webpack_require__(33969), exports);
                __exportStar(__webpack_require__(85193), exports);
                __exportStar(__webpack_require__(42544), exports);
                __exportStar(__webpack_require__(93461), exports);
                __exportStar(__webpack_require__(21797), exports);
                __exportStar(__webpack_require__(82806), exports);
                __exportStar(__webpack_require__(30048), exports);
                __exportStar(__webpack_require__(95951), exports);
                __exportStar(__webpack_require__(78690), exports);
                __exportStar(__webpack_require__(12677), exports);
                __exportStar(__webpack_require__(49321), exports);
                __exportStar(__webpack_require__(26112), exports);
                __exportStar(__webpack_require__(63011), exports);
                __exportStar(__webpack_require__(33980), exports);
                __exportStar(__webpack_require__(98719), exports);
                __exportStar(__webpack_require__(1166), exports);
                __exportStar(__webpack_require__(33479), exports);
                __exportStar(__webpack_require__(98401), exports);
                __exportStar(__webpack_require__(93738), exports);
                __exportStar(__webpack_require__(19055), exports);
                __exportStar(__webpack_require__(5775), exports);
                __exportStar(__webpack_require__(55334), exports);
                __exportStar(__webpack_require__(35491), exports);
                __exportStar(__webpack_require__(41406), exports);
                __exportStar(__webpack_require__(10262), exports);
                __exportStar(__webpack_require__(94478), exports);
                __exportStar(__webpack_require__(95626), exports);
                __exportStar(__webpack_require__(27369), exports);
                __exportStar(__webpack_require__(76226), exports);
                __exportStar(__webpack_require__(96829), exports);
                __exportStar(__webpack_require__(13709), exports);
                __exportStar(__webpack_require__(11829), exports);
                __exportStar(__webpack_require__(17505), exports);
                /***/ 
            }),
            /***/ 82648: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(69749), exports);
                /***/ 
            }),
            /***/ 74350: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EmailBackupFrequency = void 0;
                var EmailBackupFrequency;
                (function (EmailBackupFrequency) {
                    EmailBackupFrequency["Disabled"] = "disabled";
                    EmailBackupFrequency["Daily"] = "daily";
                    EmailBackupFrequency["Weekly"] = "weekly";
                })(EmailBackupFrequency = exports.EmailBackupFrequency || (exports.EmailBackupFrequency = {}));
                /***/ 
            }),
            /***/ 80030: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 64684: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.LogSessionUserAgentOption = void 0;
                var LogSessionUserAgentOption;
                (function (LogSessionUserAgentOption) {
                    LogSessionUserAgentOption["Disabled"] = "disabled";
                    LogSessionUserAgentOption["Enabled"] = "enabled";
                })(LogSessionUserAgentOption = exports.LogSessionUserAgentOption || (exports.LogSessionUserAgentOption = {}));
                /***/ 
            }),
            /***/ 22208: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.MuteFailedBackupsEmailsOption = void 0;
                var MuteFailedBackupsEmailsOption;
                (function (MuteFailedBackupsEmailsOption) {
                    MuteFailedBackupsEmailsOption["Muted"] = "muted";
                    MuteFailedBackupsEmailsOption["NotMuted"] = "not_muted";
                })(MuteFailedBackupsEmailsOption = exports.MuteFailedBackupsEmailsOption || (exports.MuteFailedBackupsEmailsOption = {}));
                /***/ 
            }),
            /***/ 49532: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.MuteMarketingEmailsOption = void 0;
                var MuteMarketingEmailsOption;
                (function (MuteMarketingEmailsOption) {
                    MuteMarketingEmailsOption["Muted"] = "muted";
                    MuteMarketingEmailsOption["NotMuted"] = "not_muted";
                })(MuteMarketingEmailsOption = exports.MuteMarketingEmailsOption || (exports.MuteMarketingEmailsOption = {}));
                /***/ 
            }),
            /***/ 19639: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.MuteSignInEmailsOption = void 0;
                var MuteSignInEmailsOption;
                (function (MuteSignInEmailsOption) {
                    MuteSignInEmailsOption["Muted"] = "muted";
                    MuteSignInEmailsOption["NotMuted"] = "not_muted";
                })(MuteSignInEmailsOption = exports.MuteSignInEmailsOption || (exports.MuteSignInEmailsOption = {}));
                /***/ 
            }),
            /***/ 50174: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(74350), exports);
                __exportStar(__webpack_require__(80030), exports);
                __exportStar(__webpack_require__(64684), exports);
                __exportStar(__webpack_require__(22208), exports);
                __exportStar(__webpack_require__(49532), exports);
                __exportStar(__webpack_require__(19639), exports);
                /***/ 
            }),
            /***/ 73606: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(50174), exports);
                /***/ 
            }),
            /***/ 59154: 
            /***/ (function (module) {
                /*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */
                (function (global, factory) {
                    true ? module.exports = factory() : 0;
                })(this, function () {
                    'use strict';
                    function _typeof(obj) {
                        "@babel/helpers - typeof";
                        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
                            return typeof obj;
                        } : function (obj) {
                            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                        }, _typeof(obj);
                    }
                    function _setPrototypeOf(o, p) {
                        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                            o.__proto__ = p;
                            return o;
                        };
                        return _setPrototypeOf(o, p);
                    }
                    function _isNativeReflectConstruct() {
                        if (typeof Reflect === "undefined" || !Reflect.construct)
                            return false;
                        if (Reflect.construct.sham)
                            return false;
                        if (typeof Proxy === "function")
                            return true;
                        try {
                            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
                            return true;
                        }
                        catch (e) {
                            return false;
                        }
                    }
                    function _construct(Parent, args, Class) {
                        if (_isNativeReflectConstruct()) {
                            _construct = Reflect.construct;
                        }
                        else {
                            _construct = function _construct(Parent, args, Class) {
                                var a = [null];
                                a.push.apply(a, args);
                                var Constructor = Function.bind.apply(Parent, a);
                                var instance = new Constructor();
                                if (Class)
                                    _setPrototypeOf(instance, Class.prototype);
                                return instance;
                            };
                        }
                        return _construct.apply(null, arguments);
                    }
                    function _toConsumableArray(arr) {
                        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                    }
                    function _arrayWithoutHoles(arr) {
                        if (Array.isArray(arr))
                            return _arrayLikeToArray(arr);
                    }
                    function _iterableToArray(iter) {
                        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
                            return Array.from(iter);
                    }
                    function _unsupportedIterableToArray(o, minLen) {
                        if (!o)
                            return;
                        if (typeof o === "string")
                            return _arrayLikeToArray(o, minLen);
                        var n = Object.prototype.toString.call(o).slice(8, -1);
                        if (n === "Object" && o.constructor)
                            n = o.constructor.name;
                        if (n === "Map" || n === "Set")
                            return Array.from(o);
                        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                            return _arrayLikeToArray(o, minLen);
                    }
                    function _arrayLikeToArray(arr, len) {
                        if (len == null || len > arr.length)
                            len = arr.length;
                        for (var i = 0, arr2 = new Array(len); i < len; i++)
                            arr2[i] = arr[i];
                        return arr2;
                    }
                    function _nonIterableSpread() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
                    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
                    if (!apply) {
                        apply = function apply(fun, thisValue, args) {
                            return fun.apply(thisValue, args);
                        };
                    }
                    if (!freeze) {
                        freeze = function freeze(x) {
                            return x;
                        };
                    }
                    if (!seal) {
                        seal = function seal(x) {
                            return x;
                        };
                    }
                    if (!construct) {
                        construct = function construct(Func, args) {
                            return _construct(Func, _toConsumableArray(args));
                        };
                    }
                    var arrayForEach = unapply(Array.prototype.forEach);
                    var arrayPop = unapply(Array.prototype.pop);
                    var arrayPush = unapply(Array.prototype.push);
                    var stringToLowerCase = unapply(String.prototype.toLowerCase);
                    var stringToString = unapply(String.prototype.toString);
                    var stringMatch = unapply(String.prototype.match);
                    var stringReplace = unapply(String.prototype.replace);
                    var stringIndexOf = unapply(String.prototype.indexOf);
                    var stringTrim = unapply(String.prototype.trim);
                    var regExpTest = unapply(RegExp.prototype.test);
                    var typeErrorCreate = unconstruct(TypeError);
                    function unapply(func) {
                        return function (thisArg) {
                            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                args[_key - 1] = arguments[_key];
                            }
                            return apply(func, thisArg, args);
                        };
                    }
                    function unconstruct(func) {
                        return function () {
                            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                                args[_key2] = arguments[_key2];
                            }
                            return construct(func, args);
                        };
                    }
                    /* Add properties to a lookup table */
                    function addToSet(set, array, transformCaseFunc) {
                        var _transformCaseFunc;
                        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
                        if (setPrototypeOf) {
                            // Make 'in' and truthy checks like Boolean(set.constructor)
                            // independent of any properties defined on Object.prototype.
                            // Prevent prototype setters from intercepting set as a this value.
                            setPrototypeOf(set, null);
                        }
                        var l = array.length;
                        while (l--) {
                            var element = array[l];
                            if (typeof element === 'string') {
                                var lcElement = transformCaseFunc(element);
                                if (lcElement !== element) {
                                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                                    if (!isFrozen(array)) {
                                        array[l] = lcElement;
                                    }
                                    element = lcElement;
                                }
                            }
                            set[element] = true;
                        }
                        return set;
                    }
                    /* Shallow clone an object */
                    function clone(object) {
                        var newObject = create(null);
                        var property;
                        for (property in object) {
                            if (apply(hasOwnProperty, object, [property]) === true) {
                                newObject[property] = object[property];
                            }
                        }
                        return newObject;
                    }
                    /* IE10 doesn't support __lookupGetter__ so lets'
                     * simulate it. It also automatically checks
                     * if the prop is function or getter and behaves
                     * accordingly. */
                    function lookupGetter(object, prop) {
                        while (object !== null) {
                            var desc = getOwnPropertyDescriptor(object, prop);
                            if (desc) {
                                if (desc.get) {
                                    return unapply(desc.get);
                                }
                                if (typeof desc.value === 'function') {
                                    return unapply(desc.value);
                                }
                            }
                            object = getPrototypeOf(object);
                        }
                        function fallbackValue(element) {
                            console.warn('fallback value for', element);
                            return null;
                        }
                        return fallbackValue;
                    }
                    var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG
                    var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
                    var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
                    // We still need to know them so that we can do namespace
                    // checks properly in case one wants to add them to
                    // allow-list.
                    var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
                    var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
                    // even those that we disallow by default.
                    var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
                    var text = freeze(['#text']);
                    var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
                    var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
                    var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
                    var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);
                    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
                    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
                    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
                    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
                    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
                    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
                    );
                    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
                    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
                    );
                    var DOCTYPE_NAME = seal(/^html$/i);
                    var getGlobal = function getGlobal() {
                        return typeof window === 'undefined' ? null : window;
                    };
                    /**
                     * Creates a no-op policy for internal use only.
                     * Don't export this function outside this module!
                     * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
                     * @param {Document} document The document object (to determine policy name suffix)
                     * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
                     * are not supported).
                     */
                    var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
                        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
                            return null;
                        } // Allow the callers to control the unique policy name
                        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
                        // Policy creation with duplicate names throws in Trusted Types.
                        var suffix = null;
                        var ATTR_NAME = 'data-tt-policy-suffix';
                        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
                            suffix = document.currentScript.getAttribute(ATTR_NAME);
                        }
                        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
                        try {
                            return trustedTypes.createPolicy(policyName, {
                                createHTML: function createHTML(html) {
                                    return html;
                                },
                                createScriptURL: function createScriptURL(scriptUrl) {
                                    return scriptUrl;
                                }
                            });
                        }
                        catch (_) {
                            // Policy creation failed (most likely another DOMPurify script has
                            // already run). Skip creating the policy, as this will only cause errors
                            // if TT are enforced.
                            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
                            return null;
                        }
                    };
                    function createDOMPurify() {
                        var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
                        var DOMPurify = function DOMPurify(root) {
                            return createDOMPurify(root);
                        };
                        /**
                         * Version label, exposed for easier checks
                         * if DOMPurify is up to date or not
                         */
                        DOMPurify.version = '2.4.7';
                        /**
                         * Array of elements that DOMPurify removed during sanitation.
                         * Empty if nothing was removed.
                         */
                        DOMPurify.removed = [];
                        if (!window || !window.document || window.document.nodeType !== 9) {
                            // Not running in a browser, provide a factory function
                            // so that you can pass your own Window
                            DOMPurify.isSupported = false;
                            return DOMPurify;
                        }
                        var originalDocument = window.document;
                        var document = window.document;
                        var DocumentFragment = window.DocumentFragment, HTMLTemplateElement = window.HTMLTemplateElement, Node = window.Node, Element = window.Element, NodeFilter = window.NodeFilter, _window$NamedNodeMap = window.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window.HTMLFormElement, DOMParser = window.DOMParser, trustedTypes = window.trustedTypes;
                        var ElementPrototype = Element.prototype;
                        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
                        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
                        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
                        var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
                        // new document created via createHTMLDocument. As per the spec
                        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
                        // a new empty registry is used when creating a template contents owner
                        // document, so we use that as our parent document to ensure nothing
                        // is inherited.
                        if (typeof HTMLTemplateElement === 'function') {
                            var template = document.createElement('template');
                            if (template.content && template.content.ownerDocument) {
                                document = template.content.ownerDocument;
                            }
                        }
                        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
                        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
                        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
                        var importNode = originalDocument.importNode;
                        var documentMode = {};
                        try {
                            documentMode = clone(document).documentMode ? document.documentMode : {};
                        }
                        catch (_) { }
                        var hooks = {};
                        /**
                         * Expose whether this browser supports running the full DOMPurify.
                         */
                        DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
                        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
                        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
                        /**
                         * We consider the elements and attributes below to be safe. Ideally
                         * don't add any new ones but feel free to remove unwanted ones.
                         */
                        /* allowed element names */
                        var ALLOWED_TAGS = null;
                        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
                        /* Allowed attribute names */
                        var ALLOWED_ATTR = null;
                        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
                        /*
                         * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
                         * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
                         * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
                         * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
                         */
                        var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
                            tagNameCheck: {
                                writable: true,
                                configurable: false,
                                enumerable: true,
                                value: null
                            },
                            attributeNameCheck: {
                                writable: true,
                                configurable: false,
                                enumerable: true,
                                value: null
                            },
                            allowCustomizedBuiltInElements: {
                                writable: true,
                                configurable: false,
                                enumerable: true,
                                value: false
                            }
                        }));
                        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
                        var FORBID_TAGS = null;
                        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
                        var FORBID_ATTR = null;
                        /* Decide if ARIA attributes are okay */
                        var ALLOW_ARIA_ATTR = true;
                        /* Decide if custom data attributes are okay */
                        var ALLOW_DATA_ATTR = true;
                        /* Decide if unknown protocols are okay */
                        var ALLOW_UNKNOWN_PROTOCOLS = false;
                        /* Decide if self-closing tags in attributes are allowed.
                         * Usually removed due to a mXSS issue in jQuery 3.0 */
                        var ALLOW_SELF_CLOSE_IN_ATTR = true;
                        /* Output should be safe for common template engines.
                         * This means, DOMPurify removes data attributes, mustaches and ERB
                         */
                        var SAFE_FOR_TEMPLATES = false;
                        /* Decide if document with <html>... should be returned */
                        var WHOLE_DOCUMENT = false;
                        /* Track whether config is already set on this instance of DOMPurify. */
                        var SET_CONFIG = false;
                        /* Decide if all elements (e.g. style, script) must be children of
                         * document.body. By default, browsers might move them to document.head */
                        var FORCE_BODY = false;
                        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
                         * string (or a TrustedHTML object if Trusted Types are supported).
                         * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
                         */
                        var RETURN_DOM = false;
                        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
                         * string  (or a TrustedHTML object if Trusted Types are supported) */
                        var RETURN_DOM_FRAGMENT = false;
                        /* Try to return a Trusted Type object instead of a string, return a string in
                         * case Trusted Types are not supported  */
                        var RETURN_TRUSTED_TYPE = false;
                        /* Output should be free from DOM clobbering attacks?
                         * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
                         */
                        var SANITIZE_DOM = true;
                        /* Achieve full DOM Clobbering protection by isolating the namespace of named
                         * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
                         *
                         * HTML/DOM spec rules that enable DOM Clobbering:
                         *   - Named Access on Window (§7.3.3)
                         *   - DOM Tree Accessors (§3.1.5)
                         *   - Form Element Parent-Child Relations (§4.10.3)
                         *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
                         *   - HTMLCollection (§4.2.10.2)
                         *
                         * Namespace isolation is implemented by prefixing `id` and `name` attributes
                         * with a constant string, i.e., `user-content-`
                         */
                        var SANITIZE_NAMED_PROPS = false;
                        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
                        /* Keep element content when removing element? */
                        var KEEP_CONTENT = true;
                        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
                         * of importing it into a new Document and returning a sanitized copy */
                        var IN_PLACE = false;
                        /* Allow usage of profiles like html, svg and mathMl */
                        var USE_PROFILES = {};
                        /* Tags to ignore content of when KEEP_CONTENT is true */
                        var FORBID_CONTENTS = null;
                        var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
                        /* Tags that are safe for data: URIs */
                        var DATA_URI_TAGS = null;
                        var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
                        /* Attributes safe for values like "javascript:" */
                        var URI_SAFE_ATTRIBUTES = null;
                        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
                        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
                        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
                        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
                        /* Document namespace */
                        var NAMESPACE = HTML_NAMESPACE;
                        var IS_EMPTY_INPUT = false;
                        /* Allowed XHTML+XML namespaces */
                        var ALLOWED_NAMESPACES = null;
                        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
                        /* Parsing of strict XHTML documents */
                        var PARSER_MEDIA_TYPE;
                        var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
                        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
                        var transformCaseFunc;
                        /* Keep a reference to config to pass to hooks */
                        var CONFIG = null;
                        /* Ideally, do not touch anything below this line */
                        /* ______________________________________________ */
                        var formElement = document.createElement('form');
                        var isRegexOrFunction = function isRegexOrFunction(testValue) {
                            return testValue instanceof RegExp || testValue instanceof Function;
                        };
                        /**
                         * _parseConfig
                         *
                         * @param  {Object} cfg optional config literal
                         */
                        // eslint-disable-next-line complexity
                        var _parseConfig = function _parseConfig(cfg) {
                            if (CONFIG && CONFIG === cfg) {
                                return;
                            }
                            /* Shield configuration object from tampering */
                            if (!cfg || _typeof(cfg) !== 'object') {
                                cfg = {};
                            }
                            /* Shield configuration object from prototype pollution */
                            cfg = clone(cfg);
                            PARSER_MEDIA_TYPE =
                                // eslint-disable-next-line unicorn/prefer-includes
                                SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
                            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
                            /* Set configuration parameters */
                            ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
                            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
                            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
                            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), 
                            // eslint-disable-line indent
                            cfg.ADD_URI_SAFE_ATTR, 
                            // eslint-disable-line indent
                            transformCaseFunc // eslint-disable-line indent
                            ) // eslint-disable-line indent
                                : DEFAULT_URI_SAFE_ATTRIBUTES;
                            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), 
                            // eslint-disable-line indent
                            cfg.ADD_DATA_URI_TAGS, 
                            // eslint-disable-line indent
                            transformCaseFunc // eslint-disable-line indent
                            ) // eslint-disable-line indent
                                : DEFAULT_DATA_URI_TAGS;
                            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
                            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
                            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
                            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
                            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
                            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
                            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
                            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
                            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
                            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
                            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
                            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
                            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
                            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
                            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
                            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
                            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
                            IN_PLACE = cfg.IN_PLACE || false; // Default false
                            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
                            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
                            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
                            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
                                CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
                            }
                            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
                                CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
                            }
                            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
                                CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
                            }
                            if (SAFE_FOR_TEMPLATES) {
                                ALLOW_DATA_ATTR = false;
                            }
                            if (RETURN_DOM_FRAGMENT) {
                                RETURN_DOM = true;
                            }
                            /* Parse profile info */
                            if (USE_PROFILES) {
                                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                                ALLOWED_ATTR = [];
                                if (USE_PROFILES.html === true) {
                                    addToSet(ALLOWED_TAGS, html$1);
                                    addToSet(ALLOWED_ATTR, html);
                                }
                                if (USE_PROFILES.svg === true) {
                                    addToSet(ALLOWED_TAGS, svg$1);
                                    addToSet(ALLOWED_ATTR, svg);
                                    addToSet(ALLOWED_ATTR, xml);
                                }
                                if (USE_PROFILES.svgFilters === true) {
                                    addToSet(ALLOWED_TAGS, svgFilters);
                                    addToSet(ALLOWED_ATTR, svg);
                                    addToSet(ALLOWED_ATTR, xml);
                                }
                                if (USE_PROFILES.mathMl === true) {
                                    addToSet(ALLOWED_TAGS, mathMl$1);
                                    addToSet(ALLOWED_ATTR, mathMl);
                                    addToSet(ALLOWED_ATTR, xml);
                                }
                            }
                            /* Merge configuration parameters */
                            if (cfg.ADD_TAGS) {
                                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                                    ALLOWED_TAGS = clone(ALLOWED_TAGS);
                                }
                                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                            }
                            if (cfg.ADD_ATTR) {
                                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                                    ALLOWED_ATTR = clone(ALLOWED_ATTR);
                                }
                                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                            }
                            if (cfg.ADD_URI_SAFE_ATTR) {
                                addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
                            }
                            if (cfg.FORBID_CONTENTS) {
                                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
                                    FORBID_CONTENTS = clone(FORBID_CONTENTS);
                                }
                                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
                            }
                            /* Add #text in case KEEP_CONTENT is set to true */
                            if (KEEP_CONTENT) {
                                ALLOWED_TAGS['#text'] = true;
                            }
                            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
                            if (WHOLE_DOCUMENT) {
                                addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
                            }
                            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
                            if (ALLOWED_TAGS.table) {
                                addToSet(ALLOWED_TAGS, ['tbody']);
                                delete FORBID_TAGS.tbody;
                            } // Prevent further manipulation of configuration.
                            // Not available in IE8, Safari 5, etc.
                            if (freeze) {
                                freeze(cfg);
                            }
                            CONFIG = cfg;
                        };
                        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
                        var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
                        // namespace. We need to specify them explicitly
                        // so that they don't get erroneously deleted from
                        // HTML namespace.
                        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
                        /* Keep track of all possible SVG and MathML tags
                         * so that we can perform the namespace checks
                         * correctly. */
                        var ALL_SVG_TAGS = addToSet({}, svg$1);
                        addToSet(ALL_SVG_TAGS, svgFilters);
                        addToSet(ALL_SVG_TAGS, svgDisallowed);
                        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
                        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
                        /**
                         *
                         *
                         * @param  {Element} element a DOM element whose namespace is being checked
                         * @returns {boolean} Return false if the element has a
                         *  namespace that a spec-compliant parser would never
                         *  return. Return true otherwise.
                         */
                        var _checkValidNamespace = function _checkValidNamespace(element) {
                            var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
                            // can be null. We just simulate parent in this case.
                            if (!parent || !parent.tagName) {
                                parent = {
                                    namespaceURI: NAMESPACE,
                                    tagName: 'template'
                                };
                            }
                            var tagName = stringToLowerCase(element.tagName);
                            var parentTagName = stringToLowerCase(parent.tagName);
                            if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
                                return false;
                            }
                            if (element.namespaceURI === SVG_NAMESPACE) {
                                // The only way to switch from HTML namespace to SVG
                                // is via <svg>. If it happens via any other tag, then
                                // it should be killed.
                                if (parent.namespaceURI === HTML_NAMESPACE) {
                                    return tagName === 'svg';
                                } // The only way to switch from MathML to SVG is via`
                                // svg if parent is either <annotation-xml> or MathML
                                // text integration points.
                                if (parent.namespaceURI === MATHML_NAMESPACE) {
                                    return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                                } // We only allow elements that are defined in SVG
                                // spec. All others are disallowed in SVG namespace.
                                return Boolean(ALL_SVG_TAGS[tagName]);
                            }
                            if (element.namespaceURI === MATHML_NAMESPACE) {
                                // The only way to switch from HTML namespace to MathML
                                // is via <math>. If it happens via any other tag, then
                                // it should be killed.
                                if (parent.namespaceURI === HTML_NAMESPACE) {
                                    return tagName === 'math';
                                } // The only way to switch from SVG to MathML is via
                                // <math> and HTML integration points
                                if (parent.namespaceURI === SVG_NAMESPACE) {
                                    return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                                } // We only allow elements that are defined in MathML
                                // spec. All others are disallowed in MathML namespace.
                                return Boolean(ALL_MATHML_TAGS[tagName]);
                            }
                            if (element.namespaceURI === HTML_NAMESPACE) {
                                // The only way to switch from SVG to HTML is via
                                // HTML integration points, and from MathML to HTML
                                // is via MathML text integration points
                                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
                                    return false;
                                }
                                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
                                    return false;
                                } // We disallow tags that are specific for MathML
                                // or SVG and should never appear in HTML namespace
                                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
                            } // For XHTML and XML documents that support custom namespaces
                            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
                                return true;
                            } // The code should never reach this place (this means
                            // that the element somehow got namespace that is not
                            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
                            // Return false just in case.
                            return false;
                        };
                        /**
                         * _forceRemove
                         *
                         * @param  {Node} node a DOM node
                         */
                        var _forceRemove = function _forceRemove(node) {
                            arrayPush(DOMPurify.removed, {
                                element: node
                            });
                            try {
                                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                                node.parentNode.removeChild(node);
                            }
                            catch (_) {
                                try {
                                    node.outerHTML = emptyHTML;
                                }
                                catch (_) {
                                    node.remove();
                                }
                            }
                        };
                        /**
                         * _removeAttribute
                         *
                         * @param  {String} name an Attribute name
                         * @param  {Node} node a DOM node
                         */
                        var _removeAttribute = function _removeAttribute(name, node) {
                            try {
                                arrayPush(DOMPurify.removed, {
                                    attribute: node.getAttributeNode(name),
                                    from: node
                                });
                            }
                            catch (_) {
                                arrayPush(DOMPurify.removed, {
                                    attribute: null,
                                    from: node
                                });
                            }
                            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
                            if (name === 'is' && !ALLOWED_ATTR[name]) {
                                if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
                                    try {
                                        _forceRemove(node);
                                    }
                                    catch (_) { }
                                }
                                else {
                                    try {
                                        node.setAttribute(name, '');
                                    }
                                    catch (_) { }
                                }
                            }
                        };
                        /**
                         * _initDocument
                         *
                         * @param  {String} dirty a string of dirty markup
                         * @return {Document} a DOM, filled with the dirty markup
                         */
                        var _initDocument = function _initDocument(dirty) {
                            /* Create a HTML document */
                            var doc;
                            var leadingWhitespace;
                            if (FORCE_BODY) {
                                dirty = '<remove></remove>' + dirty;
                            }
                            else {
                                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
                                var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                                leadingWhitespace = matches && matches[0];
                            }
                            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
                                // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
                                dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
                            }
                            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
                            /*
                             * Use the DOMParser API by default, fallback later if needs be
                             * DOMParser not work for svg when has multiple root element.
                             */
                            if (NAMESPACE === HTML_NAMESPACE) {
                                try {
                                    doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
                                }
                                catch (_) { }
                            }
                            /* Use createHTMLDocument in case DOMParser is not available */
                            if (!doc || !doc.documentElement) {
                                doc = implementation.createDocument(NAMESPACE, 'template', null);
                                try {
                                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                                }
                                catch (_) { // Syntax error if dirtyPayload is invalid xml
                                }
                            }
                            var body = doc.body || doc.documentElement;
                            if (dirty && leadingWhitespace) {
                                body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
                            }
                            /* Work on whole document or just its body */
                            if (NAMESPACE === HTML_NAMESPACE) {
                                return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
                            }
                            return WHOLE_DOCUMENT ? doc.documentElement : body;
                        };
                        /**
                         * _createIterator
                         *
                         * @param  {Document} root document/fragment to create iterator for
                         * @return {Iterator} iterator instance
                         */
                        var _createIterator = function _createIterator(root) {
                            return createNodeIterator.call(root.ownerDocument || root, root, 
                            // eslint-disable-next-line no-bitwise
                            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
                        };
                        /**
                         * _isClobbered
                         *
                         * @param  {Node} elm element to check for clobbering attacks
                         * @return {Boolean} true if clobbered, false if safe
                         */
                        var _isClobbered = function _isClobbered(elm) {
                            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
                        };
                        /**
                         * _isNode
                         *
                         * @param  {Node} obj object to check whether it's a DOM node
                         * @return {Boolean} true is object is a DOM node
                         */
                        var _isNode = function _isNode(object) {
                            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
                        };
                        /**
                         * _executeHook
                         * Execute user configurable hooks
                         *
                         * @param  {String} entryPoint  Name of the hook's entry point
                         * @param  {Node} currentNode node to work on with the hook
                         * @param  {Object} data additional hook parameters
                         */
                        var _executeHook = function _executeHook(entryPoint, currentNode, data) {
                            if (!hooks[entryPoint]) {
                                return;
                            }
                            arrayForEach(hooks[entryPoint], function (hook) {
                                hook.call(DOMPurify, currentNode, data, CONFIG);
                            });
                        };
                        /**
                         * _sanitizeElements
                         *
                         * @protect nodeName
                         * @protect textContent
                         * @protect removeChild
                         *
                         * @param   {Node} currentNode to check for permission to exist
                         * @return  {Boolean} true if node was killed, false if left alive
                         */
                        var _sanitizeElements = function _sanitizeElements(currentNode) {
                            var content;
                            /* Execute a hook if present */
                            _executeHook('beforeSanitizeElements', currentNode, null);
                            /* Check if element is clobbered or can clobber */
                            if (_isClobbered(currentNode)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Check if tagname contains Unicode */
                            if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Now let's check the element's type and name */
                            var tagName = transformCaseFunc(currentNode.nodeName);
                            /* Execute a hook if present */
                            _executeHook('uponSanitizeElement', currentNode, {
                                tagName: tagName,
                                allowedTags: ALLOWED_TAGS
                            });
                            /* Detect mXSS attempts abusing namespace confusion */
                            if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Mitigate a problem with templates inside select */
                            if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Remove element if anything forbids its presence */
                            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                                /* Check if we have a custom element to handle */
                                if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName))
                                        return false;
                                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName))
                                        return false;
                                }
                                /* Keep content except for bad-listed elements */
                                if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                                    if (childNodes && parentNode) {
                                        var childCount = childNodes.length;
                                        for (var i = childCount - 1; i >= 0; --i) {
                                            parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                                        }
                                    }
                                }
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Check whether element has a valid namespace */
                            if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Make sure that older browsers don't get fallback-tag mXSS */
                            if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                                _forceRemove(currentNode);
                                return true;
                            }
                            /* Sanitize element content to be template-safe */
                            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                                /* Get the element's text content */
                                content = currentNode.textContent;
                                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                                content = stringReplace(content, ERB_EXPR$1, ' ');
                                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                                if (currentNode.textContent !== content) {
                                    arrayPush(DOMPurify.removed, {
                                        element: currentNode.cloneNode()
                                    });
                                    currentNode.textContent = content;
                                }
                            }
                            /* Execute a hook if present */
                            _executeHook('afterSanitizeElements', currentNode, null);
                            return false;
                        };
                        /**
                         * _isValidAttribute
                         *
                         * @param  {string} lcTag Lowercase tag name of containing element.
                         * @param  {string} lcName Lowercase attribute name.
                         * @param  {string} value Attribute value.
                         * @return {Boolean} Returns true if `value` is valid, otherwise false.
                         */
                        // eslint-disable-next-line complexity
                        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
                            /* Make sure attribute cannot clobber */
                            if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
                                return false;
                            }
                            /* Allow valid data-* attributes: At least one character after "-"
                                (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
                                XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
                                We don't need to check the value; it's always URI safe. */
                            if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName))
                                ;
                            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName))
                                ;
                            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                                if (
                                // First condition does a very basic check if a) it's basically a valid custom element tagname AND
                                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
                                    // Alternative, second condition checks if it's an `is`-attribute, AND
                                    // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                                    lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value)))
                                    ;
                                else {
                                    return false;
                                }
                                /* Check value is safe. First, is attr inert? If so, is safe */
                            }
                            else if (URI_SAFE_ATTRIBUTES[lcName])
                                ;
                            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, '')))
                                ;
                            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag])
                                ;
                            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, '')))
                                ;
                            else if (value) {
                                return false;
                            }
                            else
                                ;
                            return true;
                        };
                        /**
                         * _basicCustomElementCheck
                         * checks if at least one dash is included in tagName, and it's not the first char
                         * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
                         * @param {string} tagName name of the tag of the node to sanitize
                         */
                        var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
                            return tagName.indexOf('-') > 0;
                        };
                        /**
                         * _sanitizeAttributes
                         *
                         * @protect attributes
                         * @protect nodeName
                         * @protect removeAttribute
                         * @protect setAttribute
                         *
                         * @param  {Node} currentNode to sanitize
                         */
                        var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
                            var attr;
                            var value;
                            var lcName;
                            var l;
                            /* Execute a hook if present */
                            _executeHook('beforeSanitizeAttributes', currentNode, null);
                            var attributes = currentNode.attributes;
                            /* Check if we have attributes; if not we might have a text node */
                            if (!attributes) {
                                return;
                            }
                            var hookEvent = {
                                attrName: '',
                                attrValue: '',
                                keepAttr: true,
                                allowedAttributes: ALLOWED_ATTR
                            };
                            l = attributes.length;
                            /* Go backwards over all attributes; safely remove bad ones */
                            while (l--) {
                                attr = attributes[l];
                                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                                value = name === 'value' ? attr.value : stringTrim(attr.value);
                                lcName = transformCaseFunc(name);
                                /* Execute a hook if present */
                                hookEvent.attrName = lcName;
                                hookEvent.attrValue = value;
                                hookEvent.keepAttr = true;
                                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                                value = hookEvent.attrValue;
                                /* Did the hooks approve of the attribute? */
                                if (hookEvent.forceKeepAttr) {
                                    continue;
                                }
                                /* Remove attribute */
                                _removeAttribute(name, currentNode);
                                /* Did the hooks approve of the attribute? */
                                if (!hookEvent.keepAttr) {
                                    continue;
                                }
                                /* Work around a security issue in jQuery 3.0 */
                                if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                                    _removeAttribute(name, currentNode);
                                    continue;
                                }
                                /* Sanitize attribute content to be template-safe */
                                if (SAFE_FOR_TEMPLATES) {
                                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                                    value = stringReplace(value, ERB_EXPR$1, ' ');
                                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                                }
                                /* Is `value` valid for this attribute? */
                                var lcTag = transformCaseFunc(currentNode.nodeName);
                                if (!_isValidAttribute(lcTag, lcName, value)) {
                                    continue;
                                }
                                /* Full DOM Clobbering protection via namespace isolation,
                                 * Prefix id and name attributes with `user-content-`
                                 */
                                if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                                    // Remove the attribute with this value
                                    _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value
                                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                                }
                                /* Handle attributes that require Trusted Types */
                                if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                                    if (namespaceURI)
                                        ;
                                    else {
                                        switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                                            case 'TrustedHTML':
                                                {
                                                    value = trustedTypesPolicy.createHTML(value);
                                                    break;
                                                }
                                            case 'TrustedScriptURL':
                                                {
                                                    value = trustedTypesPolicy.createScriptURL(value);
                                                    break;
                                                }
                                        }
                                    }
                                }
                                /* Handle invalid data-* attribute set by try-catching it */
                                try {
                                    if (namespaceURI) {
                                        currentNode.setAttributeNS(namespaceURI, name, value);
                                    }
                                    else {
                                        /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
                                        currentNode.setAttribute(name, value);
                                    }
                                    arrayPop(DOMPurify.removed);
                                }
                                catch (_) { }
                            }
                            /* Execute a hook if present */
                            _executeHook('afterSanitizeAttributes', currentNode, null);
                        };
                        /**
                         * _sanitizeShadowDOM
                         *
                         * @param  {DocumentFragment} fragment to iterate over recursively
                         */
                        var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
                            var shadowNode;
                            var shadowIterator = _createIterator(fragment);
                            /* Execute a hook if present */
                            _executeHook('beforeSanitizeShadowDOM', fragment, null);
                            while (shadowNode = shadowIterator.nextNode()) {
                                /* Execute a hook if present */
                                _executeHook('uponSanitizeShadowNode', shadowNode, null);
                                /* Sanitize tags and elements */
                                if (_sanitizeElements(shadowNode)) {
                                    continue;
                                }
                                /* Deep shadow DOM detected */
                                if (shadowNode.content instanceof DocumentFragment) {
                                    _sanitizeShadowDOM(shadowNode.content);
                                }
                                /* Check attributes, sanitize if necessary */
                                _sanitizeAttributes(shadowNode);
                            }
                            /* Execute a hook if present */
                            _executeHook('afterSanitizeShadowDOM', fragment, null);
                        };
                        /**
                         * Sanitize
                         * Public method providing core sanitation functionality
                         *
                         * @param {String|Node} dirty string or DOM node
                         * @param {Object} configuration object
                         */
                        // eslint-disable-next-line complexity
                        DOMPurify.sanitize = function (dirty) {
                            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var body;
                            var importedNode;
                            var currentNode;
                            var oldNode;
                            var returnNode;
                            /* Make sure we have a string to sanitize.
                              DO NOT return early, as this will return the wrong type if
                              the user has requested a DOM object rather than a string */
                            IS_EMPTY_INPUT = !dirty;
                            if (IS_EMPTY_INPUT) {
                                dirty = '<!-->';
                            }
                            /* Stringify, in case dirty is an object */
                            if (typeof dirty !== 'string' && !_isNode(dirty)) {
                                if (typeof dirty.toString === 'function') {
                                    dirty = dirty.toString();
                                    if (typeof dirty !== 'string') {
                                        throw typeErrorCreate('dirty is not a string, aborting');
                                    }
                                }
                                else {
                                    throw typeErrorCreate('toString is not a function');
                                }
                            }
                            /* Check we can run. Otherwise fall back or ignore */
                            if (!DOMPurify.isSupported) {
                                if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
                                    if (typeof dirty === 'string') {
                                        return window.toStaticHTML(dirty);
                                    }
                                    if (_isNode(dirty)) {
                                        return window.toStaticHTML(dirty.outerHTML);
                                    }
                                }
                                return dirty;
                            }
                            /* Assign config vars */
                            if (!SET_CONFIG) {
                                _parseConfig(cfg);
                            }
                            /* Clean up removed elements */
                            DOMPurify.removed = [];
                            /* Check if dirty is correctly typed for IN_PLACE */
                            if (typeof dirty === 'string') {
                                IN_PLACE = false;
                            }
                            if (IN_PLACE) {
                                /* Do some early pre-sanitization to avoid unsafe root nodes */
                                if (dirty.nodeName) {
                                    var tagName = transformCaseFunc(dirty.nodeName);
                                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                                        throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                                    }
                                }
                            }
                            else if (dirty instanceof Node) {
                                /* If dirty is a DOM element, append to an empty document to avoid
                                   elements being stripped by the parser */
                                body = _initDocument('<!---->');
                                importedNode = body.ownerDocument.importNode(dirty, true);
                                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
                                    /* Node is already a body, use as is */
                                    body = importedNode;
                                }
                                else if (importedNode.nodeName === 'HTML') {
                                    body = importedNode;
                                }
                                else {
                                    // eslint-disable-next-line unicorn/prefer-dom-node-append
                                    body.appendChild(importedNode);
                                }
                            }
                            else {
                                /* Exit directly if we have nothing to do */
                                if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
                                    // eslint-disable-next-line unicorn/prefer-includes
                                    dirty.indexOf('<') === -1) {
                                    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                                }
                                /* Initialize the document to work on */
                                body = _initDocument(dirty);
                                /* Check we have a DOM node from the data */
                                if (!body) {
                                    return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
                                }
                            }
                            /* Remove first element node (ours) if FORCE_BODY is set */
                            if (body && FORCE_BODY) {
                                _forceRemove(body.firstChild);
                            }
                            /* Get node iterator */
                            var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
                            /* Now start iterating over the created document */
                            while (currentNode = nodeIterator.nextNode()) {
                                /* Fix IE's strange behavior with manipulated textNodes #89 */
                                if (currentNode.nodeType === 3 && currentNode === oldNode) {
                                    continue;
                                }
                                /* Sanitize tags and elements */
                                if (_sanitizeElements(currentNode)) {
                                    continue;
                                }
                                /* Shadow DOM detected, sanitize it */
                                if (currentNode.content instanceof DocumentFragment) {
                                    _sanitizeShadowDOM(currentNode.content);
                                }
                                /* Check attributes, sanitize if necessary */
                                _sanitizeAttributes(currentNode);
                                oldNode = currentNode;
                            }
                            oldNode = null;
                            /* If we sanitized `dirty` in-place, return it. */
                            if (IN_PLACE) {
                                return dirty;
                            }
                            /* Return sanitized string or DOM */
                            if (RETURN_DOM) {
                                if (RETURN_DOM_FRAGMENT) {
                                    returnNode = createDocumentFragment.call(body.ownerDocument);
                                    while (body.firstChild) {
                                        // eslint-disable-next-line unicorn/prefer-dom-node-append
                                        returnNode.appendChild(body.firstChild);
                                    }
                                }
                                else {
                                    returnNode = body;
                                }
                                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
                                    /*
                                      AdoptNode() is not used because internal state is not reset
                                      (e.g. the past names map of a HTMLFormElement), this is safe
                                      in theory but we would rather not risk another attack vector.
                                      The state that is cloned by importNode() is explicitly defined
                                      by the specs.
                                    */
                                    returnNode = importNode.call(originalDocument, returnNode, true);
                                }
                                return returnNode;
                            }
                            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
                            /* Serialize doctype if allowed */
                            if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
                                serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
                            }
                            /* Sanitize final string template-safe */
                            if (SAFE_FOR_TEMPLATES) {
                                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
                            }
                            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
                        };
                        /**
                         * Public method to set the configuration once
                         * setConfig
                         *
                         * @param {Object} cfg configuration object
                         */
                        DOMPurify.setConfig = function (cfg) {
                            _parseConfig(cfg);
                            SET_CONFIG = true;
                        };
                        /**
                         * Public method to remove the configuration
                         * clearConfig
                         *
                         */
                        DOMPurify.clearConfig = function () {
                            CONFIG = null;
                            SET_CONFIG = false;
                        };
                        /**
                         * Public method to check if an attribute value is valid.
                         * Uses last set config, if any. Otherwise, uses config defaults.
                         * isValidAttribute
                         *
                         * @param  {string} tag Tag name of containing element.
                         * @param  {string} attr Attribute name.
                         * @param  {string} value Attribute value.
                         * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
                         */
                        DOMPurify.isValidAttribute = function (tag, attr, value) {
                            /* Initialize shared config vars if necessary. */
                            if (!CONFIG) {
                                _parseConfig({});
                            }
                            var lcTag = transformCaseFunc(tag);
                            var lcName = transformCaseFunc(attr);
                            return _isValidAttribute(lcTag, lcName, value);
                        };
                        /**
                         * AddHook
                         * Public method to add DOMPurify hooks
                         *
                         * @param {String} entryPoint entry point for the hook to add
                         * @param {Function} hookFunction function to execute
                         */
                        DOMPurify.addHook = function (entryPoint, hookFunction) {
                            if (typeof hookFunction !== 'function') {
                                return;
                            }
                            hooks[entryPoint] = hooks[entryPoint] || [];
                            arrayPush(hooks[entryPoint], hookFunction);
                        };
                        /**
                         * RemoveHook
                         * Public method to remove a DOMPurify hook at a given entryPoint
                         * (pops it from the stack of hooks if more are present)
                         *
                         * @param {String} entryPoint entry point for the hook to remove
                         * @return {Function} removed(popped) hook
                         */
                        DOMPurify.removeHook = function (entryPoint) {
                            if (hooks[entryPoint]) {
                                return arrayPop(hooks[entryPoint]);
                            }
                        };
                        /**
                         * RemoveHooks
                         * Public method to remove all DOMPurify hooks at a given entryPoint
                         *
                         * @param  {String} entryPoint entry point for the hooks to remove
                         */
                        DOMPurify.removeHooks = function (entryPoint) {
                            if (hooks[entryPoint]) {
                                hooks[entryPoint] = [];
                            }
                        };
                        /**
                         * RemoveAllHooks
                         * Public method to remove all DOMPurify hooks
                         *
                         */
                        DOMPurify.removeAllHooks = function () {
                            hooks = {};
                        };
                        return DOMPurify;
                    }
                    var purify = createDOMPurify();
                    return purify;
                });
                /***/ 
            }),
            /***/ 84213: 
            /***/ (function (module, exports, __webpack_require__) {
                /* module decorator */ module = __webpack_require__.nmd(module);
                var __WEBPACK_AMD_DEFINE_RESULT__; /**
                 * @license
                 * Lodash <https://lodash.com/>
                 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
                 * Released under MIT license <https://lodash.com/license>
                 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
                 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
                 */
                ;
                (function () {
                    var undefined; /** Used as the semantic version number. */
                    var VERSION = '4.17.21'; /** Used as the size to enable large array optimizations. */
                    var LARGE_ARRAY_SIZE = 200; /** Error message constants. */
                    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`'; /** Used to stand-in for `undefined` hash values. */
                    var HASH_UNDEFINED = '__lodash_hash_undefined__'; /** Used as the maximum memoize cache size. */
                    var MAX_MEMOIZE_SIZE = 500; /** Used as the internal argument placeholder. */
                    var PLACEHOLDER = '__lodash_placeholder__'; /** Used to compose bitmasks for cloning. */
                    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4; /** Used to compose bitmasks for value comparisons. */
                    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2; /** Used to compose bitmasks for function metadata. */
                    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512; /** Used as default options for `_.truncate`. */
                    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...'; /** Used to detect hot functions by number of calls within a span of milliseconds. */
                    var HOT_COUNT = 800, HOT_SPAN = 16; /** Used to indicate the type of lazy iteratees. */
                    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3; /** Used as references for various `Number` constants. */
                    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0; /** Used as references for the maximum length and index of an array. */
                    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1; /** Used to associate wrap methods with their bit flags. */
                    var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]]; /** `Object#toString` result references. */
                    var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
                    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]'; /** Used to match empty string literals in compiled template source. */
                    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g; /** Used to match HTML entities and HTML characters. */
                    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source); /** Used to match template delimiters. */
                    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g; /** Used to match property names within property paths. */
                    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g; /**
                        * Used to match `RegExp`
                        * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
                        */
                    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source); /** Used to match leading whitespace. */
                    var reTrimStart = /^\s+/; /** Used to match a single whitespace character. */
                    var reWhitespace = /\s/; /** Used to match wrap detail comments. */
                    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /; /** Used to match words composed of alphanumeric characters. */
                    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g; /**
                    * Used to validate the `validate` option in `_.template` variable.
                    *
                    * Forbids characters which could potentially change the meaning of the function argument definition:
                    * - "()," (modification of function parameters)
                    * - "=" (default value)
                    * - "[]{}" (destructuring of function parameters)
                    * - "/" (beginning of a comment)
                    * - whitespace
                    */
                    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/; /** Used to match backslashes in property paths. */
                    var reEscapeChar = /\\(\\)?/g; /**
                    * Used to match
                    * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
                    */
                    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g; /** Used to match `RegExp` flags from their coerced string values. */
                    var reFlags = /\w*$/; /** Used to detect bad signed hexadecimal string values. */
                    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i; /** Used to detect binary string values. */
                    var reIsBinary = /^0b[01]+$/i; /** Used to detect host constructors (Safari). */
                    var reIsHostCtor = /^\[object .+?Constructor\]$/; /** Used to detect octal string values. */
                    var reIsOctal = /^0o[0-7]+$/i; /** Used to detect unsigned integer values. */
                    var reIsUint = /^(?:0|[1-9]\d*)$/; /** Used to match Latin Unicode letters (excluding mathematical operators). */
                    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g; /** Used to ensure capturing order of template delimiters. */
                    var reNoMatch = /($^)/; /** Used to match unescaped characters in compiled string literals. */
                    var reUnescapedString = /['\n\r\u2028\u2029\\]/g; /** Used to compose unicode character classes. */
                    var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange; /** Used to compose unicode capture groups. */
                    var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d'; /** Used to compose unicode regexes. */
                    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')'; /** Used to match apostrophes. */
                    var reApos = RegExp(rsApos, 'g'); /**
                    * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
                    * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
                    */
                    var reComboMark = RegExp(rsCombo, 'g'); /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
                    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g'); /** Used to match complex or compound words. */
                    var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g'); /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
                    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']'); /** Used to detect strings that need a more robust regexp to match words. */
                    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/; /** Used to assign default `context` object properties. */
                    var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout']; /** Used to make template sourceURLs easier to identify. */
                    var templateCounter = -1; /** Used to identify `toStringTag` values of typed arrays. */
                    var typedArrayTags = {};
                    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
                    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false; /** Used to identify `toStringTag` values supported by `_.clone`. */
                    var cloneableTags = {};
                    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
                    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false; /** Used to map Latin Unicode letters to basic Latin letters. */
                    var deburredLetters = {
                        '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A', '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a', '\xc7': 'C', '\xe7': 'c', '\xd0': 'D', '\xf0': 'd', '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E', '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e', '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I', '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i', '\xd1': 'N', '\xf1': 'n', '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O', '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o', '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U', '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u', '\xdd': 'Y', '\xfd': 'y', '\xff': 'y', '\xc6': 'Ae', '\xe6': 'ae', '\xde': 'Th', '\xfe': 'th', '\xdf': 'ss',
                        '\u0100': 'A', '\u0102': 'A', '\u0104': 'A', '\u0101': 'a', '\u0103': 'a', '\u0105': 'a', '\u0106': 'C', '\u0108': 'C', '\u010a': 'C', '\u010c': 'C', '\u0107': 'c', '\u0109': 'c', '\u010b': 'c', '\u010d': 'c', '\u010e': 'D', '\u0110': 'D', '\u010f': 'd', '\u0111': 'd', '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E', '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e', '\u011c': 'G', '\u011e': 'G', '\u0120': 'G', '\u0122': 'G', '\u011d': 'g', '\u011f': 'g', '\u0121': 'g', '\u0123': 'g', '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h', '\u0128': 'I', '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I', '\u0129': 'i', '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i', '\u0134': 'J', '\u0135': 'j', '\u0136': 'K', '\u0137': 'k', '\u0138': 'k', '\u0139': 'L', '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L', '\u013a': 'l', '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l', '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014a': 'N', '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014b': 'n', '\u014c': 'O', '\u014e': 'O', '\u0150': 'O', '\u014d': 'o', '\u014f': 'o', '\u0151': 'o', '\u0154': 'R', '\u0156': 'R', '\u0158': 'R', '\u0155': 'r', '\u0157': 'r', '\u0159': 'r', '\u015a': 'S', '\u015c': 'S', '\u015e': 'S', '\u0160': 'S', '\u015b': 's', '\u015d': 's', '\u015f': 's', '\u0161': 's', '\u0162': 'T', '\u0164': 'T', '\u0166': 'T', '\u0163': 't', '\u0165': 't', '\u0167': 't', '\u0168': 'U', '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U', '\u0169': 'u', '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u', '\u0174': 'W', '\u0175': 'w', '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y', '\u0179': 'Z', '\u017b': 'Z', '\u017d': 'Z', '\u017a': 'z', '\u017c': 'z', '\u017e': 'z', '\u0132': 'IJ', '\u0133': 'ij', '\u0152': 'Oe', '\u0153': 'oe', '\u0149': "'n", '\u017f': 's'
                    }; /** Used to map characters to HTML entities. */
                    var htmlEscapes = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }; /** Used to map HTML entities to characters. */
                    var htmlUnescapes = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" }; /** Used to escape characters for inclusion in compiled string literals. */
                    var stringEscapes = { '\\': '\\', "'": "'", '\n': 'n', '\r': 'r', '\u2028': 'u2028', '\u2029': 'u2029' }; /** Built-in method references without a dependency on `root`. */
                    var freeParseFloat = parseFloat, freeParseInt = parseInt; /** Detect free variable `global` from Node.js. */
                    var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g; /** Detect free variable `self`. */
                    var freeSelf = typeof self == 'object' && self && self.Object === Object && self; /** Used as a reference to the global object. */
                    var root = freeGlobal || freeSelf || Function('return this')(); /** Detect free variable `exports`. */
                    var freeExports = true && exports && !exports.nodeType && exports; /** Detect free variable `module`. */
                    var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module; /** Detect the popular CommonJS extension `module.exports`. */
                    var moduleExports = freeModule && freeModule.exports === freeExports; /** Detect free variable `process` from Node.js. */
                    var freeProcess = moduleExports && freeGlobal.process; /** Used to access faster Node.js helpers. */
                    var nodeUtil = function () {
                        try { // Use `util.types` for Node.js 10+.
                            var types = freeModule && freeModule.require && freeModule.require('util').types;
                            if (types) {
                                return types;
                            } // Legacy `process.binding('util')` for Node.js < 10.
                            return freeProcess && freeProcess.binding && freeProcess.binding('util');
                        }
                        catch (e) { }
                    }(); /* Node.js helper references. */
                    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray; /*--------------------------------------------------------------------------*/ /**
                         * A faster alternative to `Function#apply`, this function invokes `func`
                         * with the `this` binding of `thisArg` and the arguments of `args`.
                         *
                         * @private
                         * @param {Function} func The function to invoke.
                         * @param {*} thisArg The `this` binding of `func`.
                         * @param {Array} args The arguments to invoke `func` with.
                         * @returns {*} Returns the result of `func`.
                         */
                    function apply(func, thisArg, args) { switch (args.length) {
                        case 0: return func.call(thisArg);
                        case 1: return func.call(thisArg, args[0]);
                        case 2: return func.call(thisArg, args[0], args[1]);
                        case 3: return func.call(thisArg, args[0], args[1], args[2]);
                    } return func.apply(thisArg, args); } /**
                    * A specialized version of `baseAggregator` for arrays.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} setter The function to set `accumulator` values.
                    * @param {Function} iteratee The iteratee to transform keys.
                    * @param {Object} accumulator The initial aggregated object.
                    * @returns {Function} Returns `accumulator`.
                    */
                    function arrayAggregator(array, setter, iteratee, accumulator) { var index = -1, length = array == null ? 0 : array.length; while (++index < length) {
                        var value = array[index];
                        setter(accumulator, value, iteratee(value), array);
                    } return accumulator; } /**
                    * A specialized version of `_.forEach` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {Array} Returns `array`.
                    */
                    function arrayEach(array, iteratee) { var index = -1, length = array == null ? 0 : array.length; while (++index < length) {
                        if (iteratee(array[index], index, array) === false) {
                            break;
                        }
                    } return array; } /**
                    * A specialized version of `_.forEachRight` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {Array} Returns `array`.
                    */
                    function arrayEachRight(array, iteratee) { var length = array == null ? 0 : array.length; while (length--) {
                        if (iteratee(array[length], length, array) === false) {
                            break;
                        }
                    } return array; } /**
                    * A specialized version of `_.every` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} predicate The function invoked per iteration.
                    * @returns {boolean} Returns `true` if all elements pass the predicate check,
                    *  else `false`.
                    */
                    function arrayEvery(array, predicate) { var index = -1, length = array == null ? 0 : array.length; while (++index < length) {
                        if (!predicate(array[index], index, array)) {
                            return false;
                        }
                    } return true; } /**
                    * A specialized version of `_.filter` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} predicate The function invoked per iteration.
                    * @returns {Array} Returns the new filtered array.
                    */
                    function arrayFilter(array, predicate) { var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; while (++index < length) {
                        var value = array[index];
                        if (predicate(value, index, array)) {
                            result[resIndex++] = value;
                        }
                    } return result; } /**
                    * A specialized version of `_.includes` for arrays without support for
                    * specifying an index to search from.
                    *
                    * @private
                    * @param {Array} [array] The array to inspect.
                    * @param {*} target The value to search for.
                    * @returns {boolean} Returns `true` if `target` is found, else `false`.
                    */
                    function arrayIncludes(array, value) { var length = array == null ? 0 : array.length; return !!length && baseIndexOf(array, value, 0) > -1; } /**
                    * This function is like `arrayIncludes` except that it accepts a comparator.
                    *
                    * @private
                    * @param {Array} [array] The array to inspect.
                    * @param {*} target The value to search for.
                    * @param {Function} comparator The comparator invoked per element.
                    * @returns {boolean} Returns `true` if `target` is found, else `false`.
                    */
                    function arrayIncludesWith(array, value, comparator) { var index = -1, length = array == null ? 0 : array.length; while (++index < length) {
                        if (comparator(value, array[index])) {
                            return true;
                        }
                    } return false; } /**
                    * A specialized version of `_.map` for arrays without support for iteratee
                    * shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {Array} Returns the new mapped array.
                    */
                    function arrayMap(array, iteratee) { var index = -1, length = array == null ? 0 : array.length, result = Array(length); while (++index < length) {
                        result[index] = iteratee(array[index], index, array);
                    } return result; } /**
                    * Appends the elements of `values` to `array`.
                    *
                    * @private
                    * @param {Array} array The array to modify.
                    * @param {Array} values The values to append.
                    * @returns {Array} Returns `array`.
                    */
                    function arrayPush(array, values) { var index = -1, length = values.length, offset = array.length; while (++index < length) {
                        array[offset + index] = values[index];
                    } return array; } /**
                    * A specialized version of `_.reduce` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @param {*} [accumulator] The initial value.
                    * @param {boolean} [initAccum] Specify using the first element of `array` as
                    *  the initial value.
                    * @returns {*} Returns the accumulated value.
                    */
                    function arrayReduce(array, iteratee, accumulator, initAccum) { var index = -1, length = array == null ? 0 : array.length; if (initAccum && length) {
                        accumulator = array[++index];
                    } while (++index < length) {
                        accumulator = iteratee(accumulator, array[index], index, array);
                    } return accumulator; } /**
                    * A specialized version of `_.reduceRight` for arrays without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @param {*} [accumulator] The initial value.
                    * @param {boolean} [initAccum] Specify using the last element of `array` as
                    *  the initial value.
                    * @returns {*} Returns the accumulated value.
                    */
                    function arrayReduceRight(array, iteratee, accumulator, initAccum) { var length = array == null ? 0 : array.length; if (initAccum && length) {
                        accumulator = array[--length];
                    } while (length--) {
                        accumulator = iteratee(accumulator, array[length], length, array);
                    } return accumulator; } /**
                    * A specialized version of `_.some` for arrays without support for iteratee
                    * shorthands.
                    *
                    * @private
                    * @param {Array} [array] The array to iterate over.
                    * @param {Function} predicate The function invoked per iteration.
                    * @returns {boolean} Returns `true` if any element passes the predicate check,
                    *  else `false`.
                    */
                    function arraySome(array, predicate) { var index = -1, length = array == null ? 0 : array.length; while (++index < length) {
                        if (predicate(array[index], index, array)) {
                            return true;
                        }
                    } return false; } /**
                    * Gets the size of an ASCII `string`.
                    *
                    * @private
                    * @param {string} string The string inspect.
                    * @returns {number} Returns the string size.
                    */
                    var asciiSize = baseProperty('length'); /**
                    * Converts an ASCII `string` to an array.
                    *
                    * @private
                    * @param {string} string The string to convert.
                    * @returns {Array} Returns the converted array.
                    */
                    function asciiToArray(string) { return string.split(''); } /**
                    * Splits an ASCII `string` into an array of its words.
                    *
                    * @private
                    * @param {string} The string to inspect.
                    * @returns {Array} Returns the words of `string`.
                    */
                    function asciiWords(string) { return string.match(reAsciiWord) || []; } /**
                    * The base implementation of methods like `_.findKey` and `_.findLastKey`,
                    * without support for iteratee shorthands, which iterates over `collection`
                    * using `eachFunc`.
                    *
                    * @private
                    * @param {Array|Object} collection The collection to inspect.
                    * @param {Function} predicate The function invoked per iteration.
                    * @param {Function} eachFunc The function to iterate over `collection`.
                    * @returns {*} Returns the found element or its key, else `undefined`.
                    */
                    function baseFindKey(collection, predicate, eachFunc) { var result; eachFunc(collection, function (value, key, collection) { if (predicate(value, key, collection)) {
                        result = key;
                        return false;
                    } }); return result; } /**
                    * The base implementation of `_.findIndex` and `_.findLastIndex` without
                    * support for iteratee shorthands.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {Function} predicate The function invoked per iteration.
                    * @param {number} fromIndex The index to search from.
                    * @param {boolean} [fromRight] Specify iterating from right to left.
                    * @returns {number} Returns the index of the matched value, else `-1`.
                    */
                    function baseFindIndex(array, predicate, fromIndex, fromRight) { var length = array.length, index = fromIndex + (fromRight ? 1 : -1); while (fromRight ? index-- : ++index < length) {
                        if (predicate(array[index], index, array)) {
                            return index;
                        }
                    } return -1; } /**
                    * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {*} value The value to search for.
                    * @param {number} fromIndex The index to search from.
                    * @returns {number} Returns the index of the matched value, else `-1`.
                    */
                    function baseIndexOf(array, value, fromIndex) { return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex); } /**
                    * This function is like `baseIndexOf` except that it accepts a comparator.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {*} value The value to search for.
                    * @param {number} fromIndex The index to search from.
                    * @param {Function} comparator The comparator invoked per element.
                    * @returns {number} Returns the index of the matched value, else `-1`.
                    */
                    function baseIndexOfWith(array, value, fromIndex, comparator) { var index = fromIndex - 1, length = array.length; while (++index < length) {
                        if (comparator(array[index], value)) {
                            return index;
                        }
                    } return -1; } /**
                    * The base implementation of `_.isNaN` without support for number objects.
                    *
                    * @private
                    * @param {*} value The value to check.
                    * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                    */
                    function baseIsNaN(value) { return value !== value; } /**
                    * The base implementation of `_.mean` and `_.meanBy` without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} array The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {number} Returns the mean.
                    */
                    function baseMean(array, iteratee) { var length = array == null ? 0 : array.length; return length ? baseSum(array, iteratee) / length : NAN; } /**
                    * The base implementation of `_.property` without support for deep paths.
                    *
                    * @private
                    * @param {string} key The key of the property to get.
                    * @returns {Function} Returns the new accessor function.
                    */
                    function baseProperty(key) { return function (object) { return object == null ? undefined : object[key]; }; } /**
                    * The base implementation of `_.propertyOf` without support for deep paths.
                    *
                    * @private
                    * @param {Object} object The object to query.
                    * @returns {Function} Returns the new accessor function.
                    */
                    function basePropertyOf(object) { return function (key) { return object == null ? undefined : object[key]; }; } /**
                    * The base implementation of `_.reduce` and `_.reduceRight`, without support
                    * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
                    *
                    * @private
                    * @param {Array|Object} collection The collection to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @param {*} accumulator The initial value.
                    * @param {boolean} initAccum Specify using the first or last element of
                    *  `collection` as the initial value.
                    * @param {Function} eachFunc The function to iterate over `collection`.
                    * @returns {*} Returns the accumulated value.
                    */
                    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) { eachFunc(collection, function (value, index, collection) { accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection); }); return accumulator; } /**
                    * The base implementation of `_.sortBy` which uses `comparer` to define the
                    * sort order of `array` and replaces criteria objects with their corresponding
                    * values.
                    *
                    * @private
                    * @param {Array} array The array to sort.
                    * @param {Function} comparer The function to define sort order.
                    * @returns {Array} Returns `array`.
                    */
                    function baseSortBy(array, comparer) { var length = array.length; array.sort(comparer); while (length--) {
                        array[length] = array[length].value;
                    } return array; } /**
                    * The base implementation of `_.sum` and `_.sumBy` without support for
                    * iteratee shorthands.
                    *
                    * @private
                    * @param {Array} array The array to iterate over.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {number} Returns the sum.
                    */
                    function baseSum(array, iteratee) { var result, index = -1, length = array.length; while (++index < length) {
                        var current = iteratee(array[index]);
                        if (current !== undefined) {
                            result = result === undefined ? current : result + current;
                        }
                    } return result; } /**
                    * The base implementation of `_.times` without support for iteratee shorthands
                    * or max array length checks.
                    *
                    * @private
                    * @param {number} n The number of times to invoke `iteratee`.
                    * @param {Function} iteratee The function invoked per iteration.
                    * @returns {Array} Returns the array of results.
                    */
                    function baseTimes(n, iteratee) { var index = -1, result = Array(n); while (++index < n) {
                        result[index] = iteratee(index);
                    } return result; } /**
                    * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
                    * of key-value pairs for `object` corresponding to the property names of `props`.
                    *
                    * @private
                    * @param {Object} object The object to query.
                    * @param {Array} props The property names to get values for.
                    * @returns {Object} Returns the key-value pairs.
                    */
                    function baseToPairs(object, props) { return arrayMap(props, function (key) { return [key, object[key]]; }); } /**
                    * The base implementation of `_.trim`.
                    *
                    * @private
                    * @param {string} string The string to trim.
                    * @returns {string} Returns the trimmed string.
                    */
                    function baseTrim(string) { return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string; } /**
                    * The base implementation of `_.unary` without support for storing metadata.
                    *
                    * @private
                    * @param {Function} func The function to cap arguments for.
                    * @returns {Function} Returns the new capped function.
                    */
                    function baseUnary(func) { return function (value) { return func(value); }; } /**
                    * The base implementation of `_.values` and `_.valuesIn` which creates an
                    * array of `object` property values corresponding to the property names
                    * of `props`.
                    *
                    * @private
                    * @param {Object} object The object to query.
                    * @param {Array} props The property names to get values for.
                    * @returns {Object} Returns the array of property values.
                    */
                    function baseValues(object, props) { return arrayMap(props, function (key) { return object[key]; }); } /**
                    * Checks if a `cache` value for `key` exists.
                    *
                    * @private
                    * @param {Object} cache The cache to query.
                    * @param {string} key The key of the entry to check.
                    * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                    */
                    function cacheHas(cache, key) { return cache.has(key); } /**
                    * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
                    * that is not found in the character symbols.
                    *
                    * @private
                    * @param {Array} strSymbols The string symbols to inspect.
                    * @param {Array} chrSymbols The character symbols to find.
                    * @returns {number} Returns the index of the first unmatched string symbol.
                    */
                    function charsStartIndex(strSymbols, chrSymbols) { var index = -1, length = strSymbols.length; while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { } return index; } /**
                    * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
                    * that is not found in the character symbols.
                    *
                    * @private
                    * @param {Array} strSymbols The string symbols to inspect.
                    * @param {Array} chrSymbols The character symbols to find.
                    * @returns {number} Returns the index of the last unmatched string symbol.
                    */
                    function charsEndIndex(strSymbols, chrSymbols) { var index = strSymbols.length; while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { } return index; } /**
                    * Gets the number of `placeholder` occurrences in `array`.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {*} placeholder The placeholder to search for.
                    * @returns {number} Returns the placeholder count.
                    */
                    function countHolders(array, placeholder) { var length = array.length, result = 0; while (length--) {
                        if (array[length] === placeholder) {
                            ++result;
                        }
                    } return result; } /**
                    * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
                    * letters to basic Latin letters.
                    *
                    * @private
                    * @param {string} letter The matched letter to deburr.
                    * @returns {string} Returns the deburred letter.
                    */
                    var deburrLetter = basePropertyOf(deburredLetters); /**
                    * Used by `_.escape` to convert characters to HTML entities.
                    *
                    * @private
                    * @param {string} chr The matched character to escape.
                    * @returns {string} Returns the escaped character.
                    */
                    var escapeHtmlChar = basePropertyOf(htmlEscapes); /**
                    * Used by `_.template` to escape characters for inclusion in compiled string literals.
                    *
                    * @private
                    * @param {string} chr The matched character to escape.
                    * @returns {string} Returns the escaped character.
                    */
                    function escapeStringChar(chr) { return '\\' + stringEscapes[chr]; } /**
                    * Gets the value at `key` of `object`.
                    *
                    * @private
                    * @param {Object} [object] The object to query.
                    * @param {string} key The key of the property to get.
                    * @returns {*} Returns the property value.
                    */
                    function getValue(object, key) { return object == null ? undefined : object[key]; } /**
                    * Checks if `string` contains Unicode symbols.
                    *
                    * @private
                    * @param {string} string The string to inspect.
                    * @returns {boolean} Returns `true` if a symbol is found, else `false`.
                    */
                    function hasUnicode(string) { return reHasUnicode.test(string); } /**
                    * Checks if `string` contains a word composed of Unicode symbols.
                    *
                    * @private
                    * @param {string} string The string to inspect.
                    * @returns {boolean} Returns `true` if a word is found, else `false`.
                    */
                    function hasUnicodeWord(string) { return reHasUnicodeWord.test(string); } /**
                    * Converts `iterator` to an array.
                    *
                    * @private
                    * @param {Object} iterator The iterator to convert.
                    * @returns {Array} Returns the converted array.
                    */
                    function iteratorToArray(iterator) { var data, result = []; while (!(data = iterator.next()).done) {
                        result.push(data.value);
                    } return result; } /**
                    * Converts `map` to its key-value pairs.
                    *
                    * @private
                    * @param {Object} map The map to convert.
                    * @returns {Array} Returns the key-value pairs.
                    */
                    function mapToArray(map) { var index = -1, result = Array(map.size); map.forEach(function (value, key) { result[++index] = [key, value]; }); return result; } /**
                    * Creates a unary function that invokes `func` with its argument transformed.
                    *
                    * @private
                    * @param {Function} func The function to wrap.
                    * @param {Function} transform The argument transform.
                    * @returns {Function} Returns the new function.
                    */
                    function overArg(func, transform) { return function (arg) { return func(transform(arg)); }; } /**
                    * Replaces all `placeholder` elements in `array` with an internal placeholder
                    * and returns an array of their indexes.
                    *
                    * @private
                    * @param {Array} array The array to modify.
                    * @param {*} placeholder The placeholder to replace.
                    * @returns {Array} Returns the new array of placeholder indexes.
                    */
                    function replaceHolders(array, placeholder) { var index = -1, length = array.length, resIndex = 0, result = []; while (++index < length) {
                        var value = array[index];
                        if (value === placeholder || value === PLACEHOLDER) {
                            array[index] = PLACEHOLDER;
                            result[resIndex++] = index;
                        }
                    } return result; } /**
                    * Converts `set` to an array of its values.
                    *
                    * @private
                    * @param {Object} set The set to convert.
                    * @returns {Array} Returns the values.
                    */
                    function setToArray(set) { var index = -1, result = Array(set.size); set.forEach(function (value) { result[++index] = value; }); return result; } /**
                    * Converts `set` to its value-value pairs.
                    *
                    * @private
                    * @param {Object} set The set to convert.
                    * @returns {Array} Returns the value-value pairs.
                    */
                    function setToPairs(set) { var index = -1, result = Array(set.size); set.forEach(function (value) { result[++index] = [value, value]; }); return result; } /**
                    * A specialized version of `_.indexOf` which performs strict equality
                    * comparisons of values, i.e. `===`.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {*} value The value to search for.
                    * @param {number} fromIndex The index to search from.
                    * @returns {number} Returns the index of the matched value, else `-1`.
                    */
                    function strictIndexOf(array, value, fromIndex) { var index = fromIndex - 1, length = array.length; while (++index < length) {
                        if (array[index] === value) {
                            return index;
                        }
                    } return -1; } /**
                    * A specialized version of `_.lastIndexOf` which performs strict equality
                    * comparisons of values, i.e. `===`.
                    *
                    * @private
                    * @param {Array} array The array to inspect.
                    * @param {*} value The value to search for.
                    * @param {number} fromIndex The index to search from.
                    * @returns {number} Returns the index of the matched value, else `-1`.
                    */
                    function strictLastIndexOf(array, value, fromIndex) { var index = fromIndex + 1; while (index--) {
                        if (array[index] === value) {
                            return index;
                        }
                    } return index; } /**
                    * Gets the number of symbols in `string`.
                    *
                    * @private
                    * @param {string} string The string to inspect.
                    * @returns {number} Returns the string size.
                    */
                    function stringSize(string) { return hasUnicode(string) ? unicodeSize(string) : asciiSize(string); } /**
                    * Converts `string` to an array.
                    *
                    * @private
                    * @param {string} string The string to convert.
                    * @returns {Array} Returns the converted array.
                    */
                    function stringToArray(string) { return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string); } /**
                    * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
                    * character of `string`.
                    *
                    * @private
                    * @param {string} string The string to inspect.
                    * @returns {number} Returns the index of the last non-whitespace character.
                    */
                    function trimmedEndIndex(string) { var index = string.length; while (index-- && reWhitespace.test(string.charAt(index))) { } return index; } /**
                    * Used by `_.unescape` to convert HTML entities to characters.
                    *
                    * @private
                    * @param {string} chr The matched character to unescape.
                    * @returns {string} Returns the unescaped character.
                    */
                    var unescapeHtmlChar = basePropertyOf(htmlUnescapes); /**
                    * Gets the size of a Unicode `string`.
                    *
                    * @private
                    * @param {string} string The string inspect.
                    * @returns {number} Returns the string size.
                    */
                    function unicodeSize(string) { var result = reUnicode.lastIndex = 0; while (reUnicode.test(string)) {
                        ++result;
                    } return result; } /**
                    * Converts a Unicode `string` to an array.
                    *
                    * @private
                    * @param {string} string The string to convert.
                    * @returns {Array} Returns the converted array.
                    */
                    function unicodeToArray(string) { return string.match(reUnicode) || []; } /**
                    * Splits a Unicode `string` into an array of its words.
                    *
                    * @private
                    * @param {string} The string to inspect.
                    * @returns {Array} Returns the words of `string`.
                    */
                    function unicodeWords(string) { return string.match(reUnicodeWord) || []; } /*--------------------------------------------------------------------------*/ /**
                    * Create a new pristine `lodash` function using the `context` object.
                    *
                    * @static
                    * @memberOf _
                    * @since 1.1.0
                    * @category Util
                    * @param {Object} [context=root] The context object.
                    * @returns {Function} Returns a new `lodash` function.
                    * @example
                    *
                    * _.mixin({ 'foo': _.constant('foo') });
                    *
                    * var lodash = _.runInContext();
                    * lodash.mixin({ 'bar': lodash.constant('bar') });
                    *
                    * _.isFunction(_.foo);
                    * // => true
                    * _.isFunction(_.bar);
                    * // => false
                    *
                    * lodash.isFunction(lodash.foo);
                    * // => false
                    * lodash.isFunction(lodash.bar);
                    * // => true
                    *
                    * // Create a suped-up `defer` in Node.js.
                    * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
                    */
                    var runInContext = function runInContext(context) {
                        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps)); /** Built-in constructor references. */
                        var Array = context.Array, Date = context.Date, Error = context.Error, Function = context.Function, Math = context.Math, Object = context.Object, RegExp = context.RegExp, String = context.String, TypeError = context.TypeError; /** Used for built-in method references. */
                        var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype; /** Used to detect overreaching core-js shims. */
                        var coreJsData = context['__core-js_shared__']; /** Used to resolve the decompiled source of functions. */
                        var funcToString = funcProto.toString; /** Used to check objects for own properties. */
                        var hasOwnProperty = objectProto.hasOwnProperty; /** Used to generate unique IDs. */
                        var idCounter = 0; /** Used to detect methods masquerading as native. */
                        var maskSrcKey = function () { var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || ''); return uid ? 'Symbol(src)_1.' + uid : ''; }(); /**
                            * Used to resolve the
                            * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                            * of values.
                            */
                        var nativeObjectToString = objectProto.toString; /** Used to infer the `Object` constructor. */
                        var objectCtorString = funcToString.call(Object); /** Used to restore the original `_` reference in `_.noConflict`. */
                        var oldDash = root._; /** Used to detect if a method is native. */
                        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'); /** Built-in value references. */
                        var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
                        var defineProperty = function () { try {
                            var func = getNative(Object, 'defineProperty');
                            func({}, '', {});
                            return func;
                        }
                        catch (e) { } }(); /** Mocked built-ins. */
                        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout; /* Built-in method references for those with the same name as other `lodash` methods. */
                        var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object.keys, Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse; /* Built-in method references that are verified to be native. */
                        var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object, 'create'); /** Used to store function metadata. */
                        var metaMap = WeakMap && new WeakMap(); /** Used to lookup unminified function names. */
                        var realNames = {}; /** Used to detect maps, sets, and weakmaps. */
                        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap); /** Used to convert symbols to primitives and strings. */
                        var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined; /*------------------------------------------------------------------------*/ /**
                        * Creates a `lodash` object which wraps `value` to enable implicit method
                        * chain sequences. Methods that operate on and return arrays, collections,
                        * and functions can be chained together. Methods that retrieve a single value
                        * or may return a primitive value will automatically end the chain sequence
                        * and return the unwrapped value. Otherwise, the value must be unwrapped
                        * with `_#value`.
                        *
                        * Explicit chain sequences, which must be unwrapped with `_#value`, may be
                        * enabled using `_.chain`.
                        *
                        * The execution of chained methods is lazy, that is, it's deferred until
                        * `_#value` is implicitly or explicitly called.
                        *
                        * Lazy evaluation allows several methods to support shortcut fusion.
                        * Shortcut fusion is an optimization to merge iteratee calls; this avoids
                        * the creation of intermediate arrays and can greatly reduce the number of
                        * iteratee executions. Sections of a chain sequence qualify for shortcut
                        * fusion if the section is applied to an array and iteratees accept only
                        * one argument. The heuristic for whether a section qualifies for shortcut
                        * fusion is subject to change.
                        *
                        * Chaining is supported in custom builds as long as the `_#value` method is
                        * directly or indirectly included in the build.
                        *
                        * In addition to lodash methods, wrappers have `Array` and `String` methods.
                        *
                        * The wrapper `Array` methods are:
                        * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
                        *
                        * The wrapper `String` methods are:
                        * `replace` and `split`
                        *
                        * The wrapper methods that support shortcut fusion are:
                        * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
                        * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
                        * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
                        *
                        * The chainable wrapper methods are:
                        * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
                        * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
                        * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
                        * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
                        * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
                        * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
                        * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
                        * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
                        * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
                        * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
                        * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
                        * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
                        * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
                        * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
                        * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
                        * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
                        * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
                        * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
                        * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
                        * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
                        * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
                        * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
                        * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
                        * `zipObject`, `zipObjectDeep`, and `zipWith`
                        *
                        * The wrapper methods that are **not** chainable by default are:
                        * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
                        * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
                        * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
                        * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
                        * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
                        * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
                        * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
                        * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
                        * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
                        * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
                        * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
                        * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
                        * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
                        * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
                        * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
                        * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
                        * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
                        * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
                        * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
                        * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
                        * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
                        * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
                        * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
                        * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
                        * `upperFirst`, `value`, and `words`
                        *
                        * @name _
                        * @constructor
                        * @category Seq
                        * @param {*} value The value to wrap in a `lodash` instance.
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * var wrapped = _([1, 2, 3]);
                        *
                        * // Returns an unwrapped value.
                        * wrapped.reduce(_.add);
                        * // => 6
                        *
                        * // Returns a wrapped value.
                        * var squares = wrapped.map(square);
                        *
                        * _.isArray(squares);
                        * // => false
                        *
                        * _.isArray(squares.value());
                        * // => true
                        */
                        function lodash(value) { if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                            if (value instanceof LodashWrapper) {
                                return value;
                            }
                            if (hasOwnProperty.call(value, '__wrapped__')) {
                                return wrapperClone(value);
                            }
                        } return new LodashWrapper(value); } /**
                        * The base implementation of `_.create` without support for assigning
                        * properties to the created object.
                        *
                        * @private
                        * @param {Object} proto The object to inherit from.
                        * @returns {Object} Returns the new object.
                        */
                        var baseCreate = function () { function object() { } return function (proto) { if (!isObject(proto)) {
                            return {};
                        } if (objectCreate) {
                            return objectCreate(proto);
                        } object.prototype = proto; var result = new object(); object.prototype = undefined; return result; }; }(); /**
                        * The function whose prototype chain sequence wrappers inherit from.
                        *
                        * @private
                        */
                        function baseLodash() {
                        } /**
                                 * The base constructor for creating `lodash` wrapper objects.
                                 *
                                 * @private
                                 * @param {*} value The value to wrap.
                                 * @param {boolean} [chainAll] Enable explicit method chain sequences.
                                 */
                        function LodashWrapper(value, chainAll) { this.__wrapped__ = value; this.__actions__ = []; this.__chain__ = !!chainAll; this.__index__ = 0; this.__values__ = undefined; } /**
                        * By default, the template delimiters used by lodash are like those in
                        * embedded Ruby (ERB) as well as ES2015 template strings. Change the
                        * following template settings to use alternative delimiters.
                        *
                        * @static
                        * @memberOf _
                        * @type {Object}
                        */
                        lodash.templateSettings = {
                            'escape': reEscape,
                            'evaluate': reEvaluate,
                            'interpolate': reInterpolate,
                            'variable': '',
                            'imports': {
                                '_': lodash
                            }
                        }; // Ensure wrappers are instances of `baseLodash`.
                        lodash.prototype = baseLodash.prototype;
                        lodash.prototype.constructor = lodash;
                        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
                        LodashWrapper.prototype.constructor = LodashWrapper; /*------------------------------------------------------------------------*/ /**
                                 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {*} value The value to wrap.
                                 */
                        function LazyWrapper(value) { this.__wrapped__ = value; this.__actions__ = []; this.__dir__ = 1; this.__filtered__ = false; this.__iteratees__ = []; this.__takeCount__ = MAX_ARRAY_LENGTH; this.__views__ = []; } /**
                        * Creates a clone of the lazy wrapper object.
                        *
                        * @private
                        * @name clone
                        * @memberOf LazyWrapper
                        * @returns {Object} Returns the cloned `LazyWrapper` object.
                        */
                        function lazyClone() { var result = new LazyWrapper(this.__wrapped__); result.__actions__ = copyArray(this.__actions__); result.__dir__ = this.__dir__; result.__filtered__ = this.__filtered__; result.__iteratees__ = copyArray(this.__iteratees__); result.__takeCount__ = this.__takeCount__; result.__views__ = copyArray(this.__views__); return result; } /**
                        * Reverses the direction of lazy iteration.
                        *
                        * @private
                        * @name reverse
                        * @memberOf LazyWrapper
                        * @returns {Object} Returns the new reversed `LazyWrapper` object.
                        */
                        function lazyReverse() { if (this.__filtered__) {
                            var result = new LazyWrapper(this);
                            result.__dir__ = -1;
                            result.__filtered__ = true;
                        }
                        else {
                            result = this.clone();
                            result.__dir__ *= -1;
                        } return result; } /**
                        * Extracts the unwrapped value from its lazy wrapper.
                        *
                        * @private
                        * @name value
                        * @memberOf LazyWrapper
                        * @returns {*} Returns the unwrapped value.
                        */
                        function lazyValue() { var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__); if (!isArr || !isRight && arrLength == length && takeCount == length) {
                            return baseWrapperValue(array, this.__actions__);
                        } var result = []; outer: while (length-- && resIndex < takeCount) {
                            index += dir;
                            var iterIndex = -1, value = array[index];
                            while (++iterIndex < iterLength) {
                                var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                                if (type == LAZY_MAP_FLAG) {
                                    value = computed;
                                }
                                else if (!computed) {
                                    if (type == LAZY_FILTER_FLAG) {
                                        continue outer;
                                    }
                                    else {
                                        break outer;
                                    }
                                }
                            }
                            result[resIndex++] = value;
                        } return result; } // Ensure `LazyWrapper` is an instance of `baseLodash`.
                        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
                        LazyWrapper.prototype.constructor = LazyWrapper; /*------------------------------------------------------------------------*/ /**
                                 * Creates a hash object.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {Array} [entries] The key-value pairs to cache.
                                 */
                        function Hash(entries) { var index = -1, length = entries == null ? 0 : entries.length; this.clear(); while (++index < length) {
                            var entry = entries[index];
                            this.set(entry[0], entry[1]);
                        } } /**
                        * Removes all key-value entries from the hash.
                        *
                        * @private
                        * @name clear
                        * @memberOf Hash
                        */
                        function hashClear() { this.__data__ = nativeCreate ? nativeCreate(null) : {}; this.size = 0; } /**
                        * Removes `key` and its value from the hash.
                        *
                        * @private
                        * @name delete
                        * @memberOf Hash
                        * @param {Object} hash The hash to modify.
                        * @param {string} key The key of the value to remove.
                        * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                        */
                        function hashDelete(key) { var result = this.has(key) && delete this.__data__[key]; this.size -= result ? 1 : 0; return result; } /**
                        * Gets the hash value for `key`.
                        *
                        * @private
                        * @name get
                        * @memberOf Hash
                        * @param {string} key The key of the value to get.
                        * @returns {*} Returns the entry value.
                        */
                        function hashGet(key) { var data = this.__data__; if (nativeCreate) {
                            var result = data[key];
                            return result === HASH_UNDEFINED ? undefined : result;
                        } return hasOwnProperty.call(data, key) ? data[key] : undefined; } /**
                        * Checks if a hash value for `key` exists.
                        *
                        * @private
                        * @name has
                        * @memberOf Hash
                        * @param {string} key The key of the entry to check.
                        * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                        */
                        function hashHas(key) { var data = this.__data__; return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key); } /**
                        * Sets the hash `key` to `value`.
                        *
                        * @private
                        * @name set
                        * @memberOf Hash
                        * @param {string} key The key of the value to set.
                        * @param {*} value The value to set.
                        * @returns {Object} Returns the hash instance.
                        */
                        function hashSet(key, value) { var data = this.__data__; this.size += this.has(key) ? 0 : 1; data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value; return this; } // Add methods to `Hash`.
                        Hash.prototype.clear = hashClear;
                        Hash.prototype['delete'] = hashDelete;
                        Hash.prototype.get = hashGet;
                        Hash.prototype.has = hashHas;
                        Hash.prototype.set = hashSet; /*------------------------------------------------------------------------*/ /**
                                 * Creates an list cache object.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {Array} [entries] The key-value pairs to cache.
                                 */
                        function ListCache(entries) { var index = -1, length = entries == null ? 0 : entries.length; this.clear(); while (++index < length) {
                            var entry = entries[index];
                            this.set(entry[0], entry[1]);
                        } } /**
                        * Removes all key-value entries from the list cache.
                        *
                        * @private
                        * @name clear
                        * @memberOf ListCache
                        */
                        function listCacheClear() { this.__data__ = []; this.size = 0; } /**
                        * Removes `key` and its value from the list cache.
                        *
                        * @private
                        * @name delete
                        * @memberOf ListCache
                        * @param {string} key The key of the value to remove.
                        * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                        */
                        function listCacheDelete(key) { var data = this.__data__, index = assocIndexOf(data, key); if (index < 0) {
                            return false;
                        } var lastIndex = data.length - 1; if (index == lastIndex) {
                            data.pop();
                        }
                        else {
                            splice.call(data, index, 1);
                        } --this.size; return true; } /**
                        * Gets the list cache value for `key`.
                        *
                        * @private
                        * @name get
                        * @memberOf ListCache
                        * @param {string} key The key of the value to get.
                        * @returns {*} Returns the entry value.
                        */
                        function listCacheGet(key) { var data = this.__data__, index = assocIndexOf(data, key); return index < 0 ? undefined : data[index][1]; } /**
                        * Checks if a list cache value for `key` exists.
                        *
                        * @private
                        * @name has
                        * @memberOf ListCache
                        * @param {string} key The key of the entry to check.
                        * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                        */
                        function listCacheHas(key) { return assocIndexOf(this.__data__, key) > -1; } /**
                        * Sets the list cache `key` to `value`.
                        *
                        * @private
                        * @name set
                        * @memberOf ListCache
                        * @param {string} key The key of the value to set.
                        * @param {*} value The value to set.
                        * @returns {Object} Returns the list cache instance.
                        */
                        function listCacheSet(key, value) { var data = this.__data__, index = assocIndexOf(data, key); if (index < 0) {
                            ++this.size;
                            data.push([key, value]);
                        }
                        else {
                            data[index][1] = value;
                        } return this; } // Add methods to `ListCache`.
                        ListCache.prototype.clear = listCacheClear;
                        ListCache.prototype['delete'] = listCacheDelete;
                        ListCache.prototype.get = listCacheGet;
                        ListCache.prototype.has = listCacheHas;
                        ListCache.prototype.set = listCacheSet; /*------------------------------------------------------------------------*/ /**
                                 * Creates a map cache object to store key-value pairs.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {Array} [entries] The key-value pairs to cache.
                                 */
                        function MapCache(entries) { var index = -1, length = entries == null ? 0 : entries.length; this.clear(); while (++index < length) {
                            var entry = entries[index];
                            this.set(entry[0], entry[1]);
                        } } /**
                        * Removes all key-value entries from the map.
                        *
                        * @private
                        * @name clear
                        * @memberOf MapCache
                        */
                        function mapCacheClear() { this.size = 0; this.__data__ = { 'hash': new Hash(), 'map': new (Map || ListCache)(), 'string': new Hash() }; } /**
                        * Removes `key` and its value from the map.
                        *
                        * @private
                        * @name delete
                        * @memberOf MapCache
                        * @param {string} key The key of the value to remove.
                        * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                        */
                        function mapCacheDelete(key) { var result = getMapData(this, key)['delete'](key); this.size -= result ? 1 : 0; return result; } /**
                        * Gets the map value for `key`.
                        *
                        * @private
                        * @name get
                        * @memberOf MapCache
                        * @param {string} key The key of the value to get.
                        * @returns {*} Returns the entry value.
                        */
                        function mapCacheGet(key) { return getMapData(this, key).get(key); } /**
                        * Checks if a map value for `key` exists.
                        *
                        * @private
                        * @name has
                        * @memberOf MapCache
                        * @param {string} key The key of the entry to check.
                        * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                        */
                        function mapCacheHas(key) { return getMapData(this, key).has(key); } /**
                        * Sets the map `key` to `value`.
                        *
                        * @private
                        * @name set
                        * @memberOf MapCache
                        * @param {string} key The key of the value to set.
                        * @param {*} value The value to set.
                        * @returns {Object} Returns the map cache instance.
                        */
                        function mapCacheSet(key, value) { var data = getMapData(this, key), size = data.size; data.set(key, value); this.size += data.size == size ? 0 : 1; return this; } // Add methods to `MapCache`.
                        MapCache.prototype.clear = mapCacheClear;
                        MapCache.prototype['delete'] = mapCacheDelete;
                        MapCache.prototype.get = mapCacheGet;
                        MapCache.prototype.has = mapCacheHas;
                        MapCache.prototype.set = mapCacheSet; /*------------------------------------------------------------------------*/ /**
                                 *
                                 * Creates an array cache object to store unique values.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {Array} [values] The values to cache.
                                 */
                        function SetCache(values) { var index = -1, length = values == null ? 0 : values.length; this.__data__ = new MapCache(); while (++index < length) {
                            this.add(values[index]);
                        } } /**
                        * Adds `value` to the array cache.
                        *
                        * @private
                        * @name add
                        * @memberOf SetCache
                        * @alias push
                        * @param {*} value The value to cache.
                        * @returns {Object} Returns the cache instance.
                        */
                        function setCacheAdd(value) { this.__data__.set(value, HASH_UNDEFINED); return this; } /**
                        * Checks if `value` is in the array cache.
                        *
                        * @private
                        * @name has
                        * @memberOf SetCache
                        * @param {*} value The value to search for.
                        * @returns {number} Returns `true` if `value` is found, else `false`.
                        */
                        function setCacheHas(value) { return this.__data__.has(value); } // Add methods to `SetCache`.
                        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
                        SetCache.prototype.has = setCacheHas; /*------------------------------------------------------------------------*/ /**
                                 * Creates a stack cache object to store key-value pairs.
                                 *
                                 * @private
                                 * @constructor
                                 * @param {Array} [entries] The key-value pairs to cache.
                                 */
                        function Stack(entries) { var data = this.__data__ = new ListCache(entries); this.size = data.size; } /**
                        * Removes all key-value entries from the stack.
                        *
                        * @private
                        * @name clear
                        * @memberOf Stack
                        */
                        function stackClear() { this.__data__ = new ListCache(); this.size = 0; } /**
                        * Removes `key` and its value from the stack.
                        *
                        * @private
                        * @name delete
                        * @memberOf Stack
                        * @param {string} key The key of the value to remove.
                        * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                        */
                        function stackDelete(key) { var data = this.__data__, result = data['delete'](key); this.size = data.size; return result; } /**
                        * Gets the stack value for `key`.
                        *
                        * @private
                        * @name get
                        * @memberOf Stack
                        * @param {string} key The key of the value to get.
                        * @returns {*} Returns the entry value.
                        */
                        function stackGet(key) { return this.__data__.get(key); } /**
                        * Checks if a stack value for `key` exists.
                        *
                        * @private
                        * @name has
                        * @memberOf Stack
                        * @param {string} key The key of the entry to check.
                        * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                        */
                        function stackHas(key) { return this.__data__.has(key); } /**
                        * Sets the stack `key` to `value`.
                        *
                        * @private
                        * @name set
                        * @memberOf Stack
                        * @param {string} key The key of the value to set.
                        * @param {*} value The value to set.
                        * @returns {Object} Returns the stack cache instance.
                        */
                        function stackSet(key, value) { var data = this.__data__; if (data instanceof ListCache) {
                            var pairs = data.__data__;
                            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                                pairs.push([key, value]);
                                this.size = ++data.size;
                                return this;
                            }
                            data = this.__data__ = new MapCache(pairs);
                        } data.set(key, value); this.size = data.size; return this; } // Add methods to `Stack`.
                        Stack.prototype.clear = stackClear;
                        Stack.prototype['delete'] = stackDelete;
                        Stack.prototype.get = stackGet;
                        Stack.prototype.has = stackHas;
                        Stack.prototype.set = stackSet; /*------------------------------------------------------------------------*/ /**
                                 * Creates an array of the enumerable property names of the array-like `value`.
                                 *
                                 * @private
                                 * @param {*} value The value to query.
                                 * @param {boolean} inherited Specify returning inherited property names.
                                 * @returns {Array} Returns the array of property names.
                                 */
                        function arrayLikeKeys(value, inherited) {
                            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                            for (var key in value) {
                                if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
                                key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
                                    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                                    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
                                    isIndex(key, length)))) {
                                    result.push(key);
                                }
                            }
                            return result;
                        } /**
                                 * A specialized version of `_.sample` for arrays.
                                 *
                                 * @private
                                 * @param {Array} array The array to sample.
                                 * @returns {*} Returns the random element.
                                 */
                        function arraySample(array) { var length = array.length; return length ? array[baseRandom(0, length - 1)] : undefined; } /**
                        * A specialized version of `_.sampleSize` for arrays.
                        *
                        * @private
                        * @param {Array} array The array to sample.
                        * @param {number} n The number of elements to sample.
                        * @returns {Array} Returns the random elements.
                        */
                        function arraySampleSize(array, n) { return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length)); } /**
                        * A specialized version of `_.shuffle` for arrays.
                        *
                        * @private
                        * @param {Array} array The array to shuffle.
                        * @returns {Array} Returns the new shuffled array.
                        */
                        function arrayShuffle(array) { return shuffleSelf(copyArray(array)); } /**
                        * This function is like `assignValue` except that it doesn't assign
                        * `undefined` values.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {string} key The key of the property to assign.
                        * @param {*} value The value to assign.
                        */
                        function assignMergeValue(object, key, value) { if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
                            baseAssignValue(object, key, value);
                        } } /**
                        * Assigns `value` to `key` of `object` if the existing value is not equivalent
                        * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {string} key The key of the property to assign.
                        * @param {*} value The value to assign.
                        */
                        function assignValue(object, key, value) { var objValue = object[key]; if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
                            baseAssignValue(object, key, value);
                        } } /**
                        * Gets the index at which the `key` is found in `array` of key-value pairs.
                        *
                        * @private
                        * @param {Array} array The array to inspect.
                        * @param {*} key The key to search for.
                        * @returns {number} Returns the index of the matched value, else `-1`.
                        */
                        function assocIndexOf(array, key) { var length = array.length; while (length--) {
                            if (eq(array[length][0], key)) {
                                return length;
                            }
                        } return -1; } /**
                        * Aggregates elements of `collection` on `accumulator` with keys transformed
                        * by `iteratee` and values set by `setter`.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} setter The function to set `accumulator` values.
                        * @param {Function} iteratee The iteratee to transform keys.
                        * @param {Object} accumulator The initial aggregated object.
                        * @returns {Function} Returns `accumulator`.
                        */
                        function baseAggregator(collection, setter, iteratee, accumulator) { baseEach(collection, function (value, key, collection) { setter(accumulator, value, iteratee(value), collection); }); return accumulator; } /**
                        * The base implementation of `_.assign` without support for multiple sources
                        * or `customizer` functions.
                        *
                        * @private
                        * @param {Object} object The destination object.
                        * @param {Object} source The source object.
                        * @returns {Object} Returns `object`.
                        */
                        function baseAssign(object, source) { return object && copyObject(source, keys(source), object); } /**
                        * The base implementation of `_.assignIn` without support for multiple sources
                        * or `customizer` functions.
                        *
                        * @private
                        * @param {Object} object The destination object.
                        * @param {Object} source The source object.
                        * @returns {Object} Returns `object`.
                        */
                        function baseAssignIn(object, source) { return object && copyObject(source, keysIn(source), object); } /**
                        * The base implementation of `assignValue` and `assignMergeValue` without
                        * value checks.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {string} key The key of the property to assign.
                        * @param {*} value The value to assign.
                        */
                        function baseAssignValue(object, key, value) { if (key == '__proto__' && defineProperty) {
                            defineProperty(object, key, { 'configurable': true, 'enumerable': true, 'value': value, 'writable': true });
                        }
                        else {
                            object[key] = value;
                        } } /**
                        * The base implementation of `_.at` without support for individual paths.
                        *
                        * @private
                        * @param {Object} object The object to iterate over.
                        * @param {string[]} paths The property paths to pick.
                        * @returns {Array} Returns the picked elements.
                        */
                        function baseAt(object, paths) { var index = -1, length = paths.length, result = Array(length), skip = object == null; while (++index < length) {
                            result[index] = skip ? undefined : get(object, paths[index]);
                        } return result; } /**
                        * The base implementation of `_.clamp` which doesn't coerce arguments.
                        *
                        * @private
                        * @param {number} number The number to clamp.
                        * @param {number} [lower] The lower bound.
                        * @param {number} upper The upper bound.
                        * @returns {number} Returns the clamped number.
                        */
                        function baseClamp(number, lower, upper) { if (number === number) {
                            if (upper !== undefined) {
                                number = number <= upper ? number : upper;
                            }
                            if (lower !== undefined) {
                                number = number >= lower ? number : lower;
                            }
                        } return number; } /**
                        * The base implementation of `_.clone` and `_.cloneDeep` which tracks
                        * traversed objects.
                        *
                        * @private
                        * @param {*} value The value to clone.
                        * @param {boolean} bitmask The bitmask flags.
                        *  1 - Deep clone
                        *  2 - Flatten inherited properties
                        *  4 - Clone symbols
                        * @param {Function} [customizer] The function to customize cloning.
                        * @param {string} [key] The key of `value`.
                        * @param {Object} [object] The parent object of `value`.
                        * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
                        * @returns {*} Returns the cloned value.
                        */
                        function baseClone(value, bitmask, customizer, key, object, stack) {
                            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                            if (customizer) {
                                result = object ? customizer(value, key, object, stack) : customizer(value);
                            }
                            if (result !== undefined) {
                                return result;
                            }
                            if (!isObject(value)) {
                                return value;
                            }
                            var isArr = isArray(value);
                            if (isArr) {
                                result = initCloneArray(value);
                                if (!isDeep) {
                                    return copyArray(value, result);
                                }
                            }
                            else {
                                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                                if (isBuffer(value)) {
                                    return cloneBuffer(value, isDeep);
                                }
                                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                                    result = isFlat || isFunc ? {} : initCloneObject(value);
                                    if (!isDeep) {
                                        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                                    }
                                }
                                else {
                                    if (!cloneableTags[tag]) {
                                        return object ? value : {};
                                    }
                                    result = initCloneByTag(value, tag, isDeep);
                                }
                            } // Check for circular references and return its corresponding clone.
                            stack || (stack = new Stack());
                            var stacked = stack.get(value);
                            if (stacked) {
                                return stacked;
                            }
                            stack.set(value, result);
                            if (isSet(value)) {
                                value.forEach(function (subValue) { result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack)); });
                            }
                            else if (isMap(value)) {
                                value.forEach(function (subValue, key) { result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack)); });
                            }
                            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                            var props = isArr ? undefined : keysFunc(value);
                            arrayEach(props || value, function (subValue, key) {
                                if (props) {
                                    key = subValue;
                                    subValue = value[key];
                                } // Recursively populate clone (susceptible to call stack limits).
                                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                            });
                            return result;
                        } /**
                                 * The base implementation of `_.conforms` which doesn't clone `source`.
                                 *
                                 * @private
                                 * @param {Object} source The object of property predicates to conform to.
                                 * @returns {Function} Returns the new spec function.
                                 */
                        function baseConforms(source) { var props = keys(source); return function (object) { return baseConformsTo(object, source, props); }; } /**
                        * The base implementation of `_.conformsTo` which accepts `props` to check.
                        *
                        * @private
                        * @param {Object} object The object to inspect.
                        * @param {Object} source The object of property predicates to conform to.
                        * @returns {boolean} Returns `true` if `object` conforms, else `false`.
                        */
                        function baseConformsTo(object, source, props) { var length = props.length; if (object == null) {
                            return !length;
                        } object = Object(object); while (length--) {
                            var key = props[length], predicate = source[key], value = object[key];
                            if (value === undefined && !(key in object) || !predicate(value)) {
                                return false;
                            }
                        } return true; } /**
                        * The base implementation of `_.delay` and `_.defer` which accepts `args`
                        * to provide to `func`.
                        *
                        * @private
                        * @param {Function} func The function to delay.
                        * @param {number} wait The number of milliseconds to delay invocation.
                        * @param {Array} args The arguments to provide to `func`.
                        * @returns {number|Object} Returns the timer id or timeout object.
                        */
                        function baseDelay(func, wait, args) { if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } return setTimeout(function () { func.apply(undefined, args); }, wait); } /**
                        * The base implementation of methods like `_.difference` without support
                        * for excluding multiple arrays or iteratee shorthands.
                        *
                        * @private
                        * @param {Array} array The array to inspect.
                        * @param {Array} values The values to exclude.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of filtered values.
                        */
                        function baseDifference(array, values, iteratee, comparator) { var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length; if (!length) {
                            return result;
                        } if (iteratee) {
                            values = arrayMap(values, baseUnary(iteratee));
                        } if (comparator) {
                            includes = arrayIncludesWith;
                            isCommon = false;
                        }
                        else if (values.length >= LARGE_ARRAY_SIZE) {
                            includes = cacheHas;
                            isCommon = false;
                            values = new SetCache(values);
                        } outer: while (++index < length) {
                            var value = array[index], computed = iteratee == null ? value : iteratee(value);
                            value = comparator || value !== 0 ? value : 0;
                            if (isCommon && computed === computed) {
                                var valuesIndex = valuesLength;
                                while (valuesIndex--) {
                                    if (values[valuesIndex] === computed) {
                                        continue outer;
                                    }
                                }
                                result.push(value);
                            }
                            else if (!includes(values, computed, comparator)) {
                                result.push(value);
                            }
                        } return result; } /**
                        * The base implementation of `_.forEach` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @returns {Array|Object} Returns `collection`.
                        */
                        var baseEach = createBaseEach(baseForOwn); /**
                        * The base implementation of `_.forEachRight` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @returns {Array|Object} Returns `collection`.
                        */
                        var baseEachRight = createBaseEach(baseForOwnRight, true); /**
                        * The base implementation of `_.every` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} predicate The function invoked per iteration.
                        * @returns {boolean} Returns `true` if all elements pass the predicate check,
                        *  else `false`
                        */
                        function baseEvery(collection, predicate) { var result = true; baseEach(collection, function (value, index, collection) { result = !!predicate(value, index, collection); return result; }); return result; } /**
                        * The base implementation of methods like `_.max` and `_.min` which accepts a
                        * `comparator` to determine the extremum value.
                        *
                        * @private
                        * @param {Array} array The array to iterate over.
                        * @param {Function} iteratee The iteratee invoked per iteration.
                        * @param {Function} comparator The comparator used to compare values.
                        * @returns {*} Returns the extremum value.
                        */
                        function baseExtremum(array, iteratee, comparator) { var index = -1, length = array.length; while (++index < length) {
                            var value = array[index], current = iteratee(value);
                            if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
                                var computed = current, result = value;
                            }
                        } return result; } /**
                        * The base implementation of `_.fill` without an iteratee call guard.
                        *
                        * @private
                        * @param {Array} array The array to fill.
                        * @param {*} value The value to fill `array` with.
                        * @param {number} [start=0] The start position.
                        * @param {number} [end=array.length] The end position.
                        * @returns {Array} Returns `array`.
                        */
                        function baseFill(array, value, start, end) { var length = array.length; start = toInteger(start); if (start < 0) {
                            start = -start > length ? 0 : length + start;
                        } end = end === undefined || end > length ? length : toInteger(end); if (end < 0) {
                            end += length;
                        } end = start > end ? 0 : toLength(end); while (start < end) {
                            array[start++] = value;
                        } return array; } /**
                        * The base implementation of `_.filter` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} predicate The function invoked per iteration.
                        * @returns {Array} Returns the new filtered array.
                        */
                        function baseFilter(collection, predicate) { var result = []; baseEach(collection, function (value, index, collection) { if (predicate(value, index, collection)) {
                            result.push(value);
                        } }); return result; } /**
                        * The base implementation of `_.flatten` with support for restricting flattening.
                        *
                        * @private
                        * @param {Array} array The array to flatten.
                        * @param {number} depth The maximum recursion depth.
                        * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
                        * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
                        * @param {Array} [result=[]] The initial result value.
                        * @returns {Array} Returns the new flattened array.
                        */
                        function baseFlatten(array, depth, predicate, isStrict, result) {
                            var index = -1, length = array.length;
                            predicate || (predicate = isFlattenable);
                            result || (result = []);
                            while (++index < length) {
                                var value = array[index];
                                if (depth > 0 && predicate(value)) {
                                    if (depth > 1) { // Recursively flatten arrays (susceptible to call stack limits).
                                        baseFlatten(value, depth - 1, predicate, isStrict, result);
                                    }
                                    else {
                                        arrayPush(result, value);
                                    }
                                }
                                else if (!isStrict) {
                                    result[result.length] = value;
                                }
                            }
                            return result;
                        } /**
                                 * The base implementation of `baseForOwn` which iterates over `object`
                                 * properties returned by `keysFunc` and invokes `iteratee` for each property.
                                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                                 *
                                 * @private
                                 * @param {Object} object The object to iterate over.
                                 * @param {Function} iteratee The function invoked per iteration.
                                 * @param {Function} keysFunc The function to get the keys of `object`.
                                 * @returns {Object} Returns `object`.
                                 */
                        var baseFor = createBaseFor(); /**
                        * This function is like `baseFor` except that it iterates over properties
                        * in the opposite order.
                        *
                        * @private
                        * @param {Object} object The object to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @param {Function} keysFunc The function to get the keys of `object`.
                        * @returns {Object} Returns `object`.
                        */
                        var baseForRight = createBaseFor(true); /**
                        * The base implementation of `_.forOwn` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Object} object The object to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        */
                        function baseForOwn(object, iteratee) { return object && baseFor(object, iteratee, keys); } /**
                        * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Object} object The object to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        */
                        function baseForOwnRight(object, iteratee) { return object && baseForRight(object, iteratee, keys); } /**
                        * The base implementation of `_.functions` which creates an array of
                        * `object` function property names filtered from `props`.
                        *
                        * @private
                        * @param {Object} object The object to inspect.
                        * @param {Array} props The property names to filter.
                        * @returns {Array} Returns the function names.
                        */
                        function baseFunctions(object, props) { return arrayFilter(props, function (key) { return isFunction(object[key]); }); } /**
                        * The base implementation of `_.get` without support for default values.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path of the property to get.
                        * @returns {*} Returns the resolved value.
                        */
                        function baseGet(object, path) { path = castPath(path, object); var index = 0, length = path.length; while (object != null && index < length) {
                            object = object[toKey(path[index++])];
                        } return index && index == length ? object : undefined; } /**
                        * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
                        * `keysFunc` and `symbolsFunc` to get the enumerable property names and
                        * symbols of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {Function} keysFunc The function to get the keys of `object`.
                        * @param {Function} symbolsFunc The function to get the symbols of `object`.
                        * @returns {Array} Returns the array of property names and symbols.
                        */
                        function baseGetAllKeys(object, keysFunc, symbolsFunc) { var result = keysFunc(object); return isArray(object) ? result : arrayPush(result, symbolsFunc(object)); } /**
                        * The base implementation of `getTag` without fallbacks for buggy environments.
                        *
                        * @private
                        * @param {*} value The value to query.
                        * @returns {string} Returns the `toStringTag`.
                        */
                        function baseGetTag(value) { if (value == null) {
                            return value === undefined ? undefinedTag : nullTag;
                        } return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value); } /**
                        * The base implementation of `_.gt` which doesn't coerce arguments.
                        *
                        * @private
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is greater than `other`,
                        *  else `false`.
                        */
                        function baseGt(value, other) { return value > other; } /**
                        * The base implementation of `_.has` without support for deep paths.
                        *
                        * @private
                        * @param {Object} [object] The object to query.
                        * @param {Array|string} key The key to check.
                        * @returns {boolean} Returns `true` if `key` exists, else `false`.
                        */
                        function baseHas(object, key) { return object != null && hasOwnProperty.call(object, key); } /**
                        * The base implementation of `_.hasIn` without support for deep paths.
                        *
                        * @private
                        * @param {Object} [object] The object to query.
                        * @param {Array|string} key The key to check.
                        * @returns {boolean} Returns `true` if `key` exists, else `false`.
                        */
                        function baseHasIn(object, key) { return object != null && key in Object(object); } /**
                        * The base implementation of `_.inRange` which doesn't coerce arguments.
                        *
                        * @private
                        * @param {number} number The number to check.
                        * @param {number} start The start of the range.
                        * @param {number} end The end of the range.
                        * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
                        */
                        function baseInRange(number, start, end) { return number >= nativeMin(start, end) && number < nativeMax(start, end); } /**
                        * The base implementation of methods like `_.intersection`, without support
                        * for iteratee shorthands, that accepts an array of arrays to inspect.
                        *
                        * @private
                        * @param {Array} arrays The arrays to inspect.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of shared values.
                        */
                        function baseIntersection(arrays, iteratee, comparator) { var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = []; while (othIndex--) {
                            var array = arrays[othIndex];
                            if (othIndex && iteratee) {
                                array = arrayMap(array, baseUnary(iteratee));
                            }
                            maxLength = nativeMin(array.length, maxLength);
                            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                        } array = arrays[0]; var index = -1, seen = caches[0]; outer: while (++index < length && result.length < maxLength) {
                            var value = array[index], computed = iteratee ? iteratee(value) : value;
                            value = comparator || value !== 0 ? value : 0;
                            if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                                othIndex = othLength;
                                while (--othIndex) {
                                    var cache = caches[othIndex];
                                    if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                                        continue outer;
                                    }
                                }
                                if (seen) {
                                    seen.push(computed);
                                }
                                result.push(value);
                            }
                        } return result; } /**
                        * The base implementation of `_.invert` and `_.invertBy` which inverts
                        * `object` with values transformed by `iteratee` and set by `setter`.
                        *
                        * @private
                        * @param {Object} object The object to iterate over.
                        * @param {Function} setter The function to set `accumulator` values.
                        * @param {Function} iteratee The iteratee to transform values.
                        * @param {Object} accumulator The initial inverted object.
                        * @returns {Function} Returns `accumulator`.
                        */
                        function baseInverter(object, setter, iteratee, accumulator) { baseForOwn(object, function (value, key, object) { setter(accumulator, iteratee(value), key, object); }); return accumulator; } /**
                        * The base implementation of `_.invoke` without support for individual
                        * method arguments.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path of the method to invoke.
                        * @param {Array} args The arguments to invoke the method with.
                        * @returns {*} Returns the result of the invoked method.
                        */
                        function baseInvoke(object, path, args) { path = castPath(path, object); object = parent(object, path); var func = object == null ? object : object[toKey(last(path))]; return func == null ? undefined : apply(func, object, args); } /**
                        * The base implementation of `_.isArguments`.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                        */
                        function baseIsArguments(value) { return isObjectLike(value) && baseGetTag(value) == argsTag; } /**
                        * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
                        */
                        function baseIsArrayBuffer(value) { return isObjectLike(value) && baseGetTag(value) == arrayBufferTag; } /**
                        * The base implementation of `_.isDate` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                        */
                        function baseIsDate(value) { return isObjectLike(value) && baseGetTag(value) == dateTag; } /**
                        * The base implementation of `_.isEqual` which supports partial comparisons
                        * and tracks traversed objects.
                        *
                        * @private
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @param {boolean} bitmask The bitmask flags.
                        *  1 - Unordered comparison
                        *  2 - Partial comparison
                        * @param {Function} [customizer] The function to customize comparisons.
                        * @param {Object} [stack] Tracks traversed `value` and `other` objects.
                        * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                        */
                        function baseIsEqual(value, other, bitmask, customizer, stack) { if (value === other) {
                            return true;
                        } if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
                            return value !== value && other !== other;
                        } return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack); } /**
                        * A specialized version of `baseIsEqual` for arrays and objects which performs
                        * deep comparisons and tracks traversed objects enabling objects with circular
                        * references to be compared.
                        *
                        * @private
                        * @param {Object} object The object to compare.
                        * @param {Object} other The other object to compare.
                        * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                        * @param {Function} customizer The function to customize comparisons.
                        * @param {Function} equalFunc The function to determine equivalents of values.
                        * @param {Object} [stack] Tracks traversed `object` and `other` objects.
                        * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                        */
                        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) { var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other); objTag = objTag == argsTag ? objectTag : objTag; othTag = othTag == argsTag ? objectTag : othTag; var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag; if (isSameTag && isBuffer(object)) {
                            if (!isBuffer(other)) {
                                return false;
                            }
                            objIsArr = true;
                            objIsObj = false;
                        } if (isSameTag && !objIsObj) {
                            stack || (stack = new Stack());
                            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                        } if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                            if (objIsWrapped || othIsWrapped) {
                                var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                                stack || (stack = new Stack());
                                return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                            }
                        } if (!isSameTag) {
                            return false;
                        } stack || (stack = new Stack()); return equalObjects(object, other, bitmask, customizer, equalFunc, stack); } /**
                        * The base implementation of `_.isMap` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a map, else `false`.
                        */
                        function baseIsMap(value) { return isObjectLike(value) && getTag(value) == mapTag; } /**
                        * The base implementation of `_.isMatch` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Object} object The object to inspect.
                        * @param {Object} source The object of property values to match.
                        * @param {Array} matchData The property names, values, and compare flags to match.
                        * @param {Function} [customizer] The function to customize comparisons.
                        * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                        */
                        function baseIsMatch(object, source, matchData, customizer) { var index = matchData.length, length = index, noCustomizer = !customizer; if (object == null) {
                            return !length;
                        } object = Object(object); while (index--) {
                            var data = matchData[index];
                            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                                return false;
                            }
                        } while (++index < length) {
                            data = matchData[index];
                            var key = data[0], objValue = object[key], srcValue = data[1];
                            if (noCustomizer && data[2]) {
                                if (objValue === undefined && !(key in object)) {
                                    return false;
                                }
                            }
                            else {
                                var stack = new Stack();
                                if (customizer) {
                                    var result = customizer(objValue, srcValue, key, object, source, stack);
                                }
                                if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                                    return false;
                                }
                            }
                        } return true; } /**
                        * The base implementation of `_.isNative` without bad shim checks.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a native function,
                        *  else `false`.
                        */
                        function baseIsNative(value) { if (!isObject(value) || isMasked(value)) {
                            return false;
                        } var pattern = isFunction(value) ? reIsNative : reIsHostCtor; return pattern.test(toSource(value)); } /**
                        * The base implementation of `_.isRegExp` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
                        */
                        function baseIsRegExp(value) { return isObjectLike(value) && baseGetTag(value) == regexpTag; } /**
                        * The base implementation of `_.isSet` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a set, else `false`.
                        */
                        function baseIsSet(value) { return isObjectLike(value) && getTag(value) == setTag; } /**
                        * The base implementation of `_.isTypedArray` without Node.js optimizations.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                        */
                        function baseIsTypedArray(value) { return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)]; } /**
                        * The base implementation of `_.iteratee`.
                        *
                        * @private
                        * @param {*} [value=_.identity] The value to convert to an iteratee.
                        * @returns {Function} Returns the iteratee.
                        */
                        function baseIteratee(value) {
                            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                            if (typeof value == 'function') {
                                return value;
                            }
                            if (value == null) {
                                return identity;
                            }
                            if (typeof value == 'object') {
                                return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                            }
                            return property(value);
                        } /**
                                 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
                                 *
                                 * @private
                                 * @param {Object} object The object to query.
                                 * @returns {Array} Returns the array of property names.
                                 */
                        function baseKeys(object) { if (!isPrototype(object)) {
                            return nativeKeys(object);
                        } var result = []; for (var key in Object(object)) {
                            if (hasOwnProperty.call(object, key) && key != 'constructor') {
                                result.push(key);
                            }
                        } return result; } /**
                        * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property names.
                        */
                        function baseKeysIn(object) { if (!isObject(object)) {
                            return nativeKeysIn(object);
                        } var isProto = isPrototype(object), result = []; for (var key in object) {
                            if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                                result.push(key);
                            }
                        } return result; } /**
                        * The base implementation of `_.lt` which doesn't coerce arguments.
                        *
                        * @private
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is less than `other`,
                        *  else `false`.
                        */
                        function baseLt(value, other) { return value < other; } /**
                        * The base implementation of `_.map` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} iteratee The function invoked per iteration.
                        * @returns {Array} Returns the new mapped array.
                        */
                        function baseMap(collection, iteratee) { var index = -1, result = isArrayLike(collection) ? Array(collection.length) : []; baseEach(collection, function (value, key, collection) { result[++index] = iteratee(value, key, collection); }); return result; } /**
                        * The base implementation of `_.matches` which doesn't clone `source`.
                        *
                        * @private
                        * @param {Object} source The object of property values to match.
                        * @returns {Function} Returns the new spec function.
                        */
                        function baseMatches(source) { var matchData = getMatchData(source); if (matchData.length == 1 && matchData[0][2]) {
                            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                        } return function (object) { return object === source || baseIsMatch(object, source, matchData); }; } /**
                        * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
                        *
                        * @private
                        * @param {string} path The path of the property to get.
                        * @param {*} srcValue The value to match.
                        * @returns {Function} Returns the new spec function.
                        */
                        function baseMatchesProperty(path, srcValue) { if (isKey(path) && isStrictComparable(srcValue)) {
                            return matchesStrictComparable(toKey(path), srcValue);
                        } return function (object) { var objValue = get(object, path); return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG); }; } /**
                        * The base implementation of `_.merge` without support for multiple sources.
                        *
                        * @private
                        * @param {Object} object The destination object.
                        * @param {Object} source The source object.
                        * @param {number} srcIndex The index of `source`.
                        * @param {Function} [customizer] The function to customize merged values.
                        * @param {Object} [stack] Tracks traversed source values and their merged
                        *  counterparts.
                        */
                        function baseMerge(object, source, srcIndex, customizer, stack) { if (object === source) {
                            return;
                        } baseFor(source, function (srcValue, key) { stack || (stack = new Stack()); if (isObject(srcValue)) {
                            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                        }
                        else {
                            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                            if (newValue === undefined) {
                                newValue = srcValue;
                            }
                            assignMergeValue(object, key, newValue);
                        } }, keysIn); } /**
                        * A specialized version of `baseMerge` for arrays and objects which performs
                        * deep merges and tracks traversed objects enabling objects with circular
                        * references to be merged.
                        *
                        * @private
                        * @param {Object} object The destination object.
                        * @param {Object} source The source object.
                        * @param {string} key The key of the value to merge.
                        * @param {number} srcIndex The index of `source`.
                        * @param {Function} mergeFunc The function to merge values.
                        * @param {Function} [customizer] The function to customize assigned values.
                        * @param {Object} [stack] Tracks traversed source values and their merged
                        *  counterparts.
                        */
                        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                            if (stacked) {
                                assignMergeValue(object, key, stacked);
                                return;
                            }
                            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                            var isCommon = newValue === undefined;
                            if (isCommon) {
                                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                                newValue = srcValue;
                                if (isArr || isBuff || isTyped) {
                                    if (isArray(objValue)) {
                                        newValue = objValue;
                                    }
                                    else if (isArrayLikeObject(objValue)) {
                                        newValue = copyArray(objValue);
                                    }
                                    else if (isBuff) {
                                        isCommon = false;
                                        newValue = cloneBuffer(srcValue, true);
                                    }
                                    else if (isTyped) {
                                        isCommon = false;
                                        newValue = cloneTypedArray(srcValue, true);
                                    }
                                    else {
                                        newValue = [];
                                    }
                                }
                                else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                                    newValue = objValue;
                                    if (isArguments(objValue)) {
                                        newValue = toPlainObject(objValue);
                                    }
                                    else if (!isObject(objValue) || isFunction(objValue)) {
                                        newValue = initCloneObject(srcValue);
                                    }
                                }
                                else {
                                    isCommon = false;
                                }
                            }
                            if (isCommon) { // Recursively merge objects and arrays (susceptible to call stack limits).
                                stack.set(srcValue, newValue);
                                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                                stack['delete'](srcValue);
                            }
                            assignMergeValue(object, key, newValue);
                        } /**
                                 * The base implementation of `_.nth` which doesn't coerce arguments.
                                 *
                                 * @private
                                 * @param {Array} array The array to query.
                                 * @param {number} n The index of the element to return.
                                 * @returns {*} Returns the nth element of `array`.
                                 */
                        function baseNth(array, n) { var length = array.length; if (!length) {
                            return;
                        } n += n < 0 ? length : 0; return isIndex(n, length) ? array[n] : undefined; } /**
                        * The base implementation of `_.orderBy` without param guards.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
                        * @param {string[]} orders The sort orders of `iteratees`.
                        * @returns {Array} Returns the new sorted array.
                        */
                        function baseOrderBy(collection, iteratees, orders) { if (iteratees.length) {
                            iteratees = arrayMap(iteratees, function (iteratee) { if (isArray(iteratee)) {
                                return function (value) { return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee); };
                            } return iteratee; });
                        }
                        else {
                            iteratees = [identity];
                        } var index = -1; iteratees = arrayMap(iteratees, baseUnary(getIteratee())); var result = baseMap(collection, function (value, key, collection) { var criteria = arrayMap(iteratees, function (iteratee) { return iteratee(value); }); return { 'criteria': criteria, 'index': ++index, 'value': value }; }); return baseSortBy(result, function (object, other) { return compareMultiple(object, other, orders); }); } /**
                        * The base implementation of `_.pick` without support for individual
                        * property identifiers.
                        *
                        * @private
                        * @param {Object} object The source object.
                        * @param {string[]} paths The property paths to pick.
                        * @returns {Object} Returns the new object.
                        */
                        function basePick(object, paths) { return basePickBy(object, paths, function (value, path) { return hasIn(object, path); }); } /**
                        * The base implementation of  `_.pickBy` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Object} object The source object.
                        * @param {string[]} paths The property paths to pick.
                        * @param {Function} predicate The function invoked per property.
                        * @returns {Object} Returns the new object.
                        */
                        function basePickBy(object, paths, predicate) { var index = -1, length = paths.length, result = {}; while (++index < length) {
                            var path = paths[index], value = baseGet(object, path);
                            if (predicate(value, path)) {
                                baseSet(result, castPath(path, object), value);
                            }
                        } return result; } /**
                        * A specialized version of `baseProperty` which supports deep paths.
                        *
                        * @private
                        * @param {Array|string} path The path of the property to get.
                        * @returns {Function} Returns the new accessor function.
                        */
                        function basePropertyDeep(path) { return function (object) { return baseGet(object, path); }; } /**
                        * The base implementation of `_.pullAllBy` without support for iteratee
                        * shorthands.
                        *
                        * @private
                        * @param {Array} array The array to modify.
                        * @param {Array} values The values to remove.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns `array`.
                        */
                        function basePullAll(array, values, iteratee, comparator) { var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array; if (array === values) {
                            values = copyArray(values);
                        } if (iteratee) {
                            seen = arrayMap(array, baseUnary(iteratee));
                        } while (++index < length) {
                            var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                            while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
                                if (seen !== array) {
                                    splice.call(seen, fromIndex, 1);
                                }
                                splice.call(array, fromIndex, 1);
                            }
                        } return array; } /**
                        * The base implementation of `_.pullAt` without support for individual
                        * indexes or capturing the removed elements.
                        *
                        * @private
                        * @param {Array} array The array to modify.
                        * @param {number[]} indexes The indexes of elements to remove.
                        * @returns {Array} Returns `array`.
                        */
                        function basePullAt(array, indexes) { var length = array ? indexes.length : 0, lastIndex = length - 1; while (length--) {
                            var index = indexes[length];
                            if (length == lastIndex || index !== previous) {
                                var previous = index;
                                if (isIndex(index)) {
                                    splice.call(array, index, 1);
                                }
                                else {
                                    baseUnset(array, index);
                                }
                            }
                        } return array; } /**
                        * The base implementation of `_.random` without support for returning
                        * floating-point numbers.
                        *
                        * @private
                        * @param {number} lower The lower bound.
                        * @param {number} upper The upper bound.
                        * @returns {number} Returns the random number.
                        */
                        function baseRandom(lower, upper) { return lower + nativeFloor(nativeRandom() * (upper - lower + 1)); } /**
                        * The base implementation of `_.range` and `_.rangeRight` which doesn't
                        * coerce arguments.
                        *
                        * @private
                        * @param {number} start The start of the range.
                        * @param {number} end The end of the range.
                        * @param {number} step The value to increment or decrement by.
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Array} Returns the range of numbers.
                        */
                        function baseRange(start, end, step, fromRight) { var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length); while (length--) {
                            result[fromRight ? length : ++index] = start;
                            start += step;
                        } return result; } /**
                        * The base implementation of `_.repeat` which doesn't coerce arguments.
                        *
                        * @private
                        * @param {string} string The string to repeat.
                        * @param {number} n The number of times to repeat the string.
                        * @returns {string} Returns the repeated string.
                        */
                        function baseRepeat(string, n) {
                            var result = '';
                            if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
                                return result;
                            } // Leverage the exponentiation by squaring algorithm for a faster repeat.
                            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
                            do {
                                if (n % 2) {
                                    result += string;
                                }
                                n = nativeFloor(n / 2);
                                if (n) {
                                    string += string;
                                }
                            } while (n);
                            return result;
                        } /**
                                 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
                                 *
                                 * @private
                                 * @param {Function} func The function to apply a rest parameter to.
                                 * @param {number} [start=func.length-1] The start position of the rest parameter.
                                 * @returns {Function} Returns the new function.
                                 */
                        function baseRest(func, start) { return setToString(overRest(func, start, identity), func + ''); } /**
                        * The base implementation of `_.sample`.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to sample.
                        * @returns {*} Returns the random element.
                        */
                        function baseSample(collection) { return arraySample(values(collection)); } /**
                        * The base implementation of `_.sampleSize` without param guards.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to sample.
                        * @param {number} n The number of elements to sample.
                        * @returns {Array} Returns the random elements.
                        */
                        function baseSampleSize(collection, n) { var array = values(collection); return shuffleSelf(array, baseClamp(n, 0, array.length)); } /**
                        * The base implementation of `_.set`.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to set.
                        * @param {*} value The value to set.
                        * @param {Function} [customizer] The function to customize path creation.
                        * @returns {Object} Returns `object`.
                        */
                        function baseSet(object, path, value, customizer) { if (!isObject(object)) {
                            return object;
                        } path = castPath(path, object); var index = -1, length = path.length, lastIndex = length - 1, nested = object; while (nested != null && ++index < length) {
                            var key = toKey(path[index]), newValue = value;
                            if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                                return object;
                            }
                            if (index != lastIndex) {
                                var objValue = nested[key];
                                newValue = customizer ? customizer(objValue, key, nested) : undefined;
                                if (newValue === undefined) {
                                    newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                                }
                            }
                            assignValue(nested, key, newValue);
                            nested = nested[key];
                        } return object; } /**
                        * The base implementation of `setData` without support for hot loop shorting.
                        *
                        * @private
                        * @param {Function} func The function to associate metadata with.
                        * @param {*} data The metadata.
                        * @returns {Function} Returns `func`.
                        */
                        var baseSetData = !metaMap ? identity : function (func, data) { metaMap.set(func, data); return func; }; /**
                        * The base implementation of `setToString` without support for hot loop shorting.
                        *
                        * @private
                        * @param {Function} func The function to modify.
                        * @param {Function} string The `toString` result.
                        * @returns {Function} Returns `func`.
                        */
                        var baseSetToString = !defineProperty ? identity : function (func, string) { return defineProperty(func, 'toString', { 'configurable': true, 'enumerable': false, 'value': constant(string), 'writable': true }); }; /**
                        * The base implementation of `_.shuffle`.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to shuffle.
                        * @returns {Array} Returns the new shuffled array.
                        */
                        function baseShuffle(collection) { return shuffleSelf(values(collection)); } /**
                        * The base implementation of `_.slice` without an iteratee call guard.
                        *
                        * @private
                        * @param {Array} array The array to slice.
                        * @param {number} [start=0] The start position.
                        * @param {number} [end=array.length] The end position.
                        * @returns {Array} Returns the slice of `array`.
                        */
                        function baseSlice(array, start, end) { var index = -1, length = array.length; if (start < 0) {
                            start = -start > length ? 0 : length + start;
                        } end = end > length ? length : end; if (end < 0) {
                            end += length;
                        } length = start > end ? 0 : end - start >>> 0; start >>>= 0; var result = Array(length); while (++index < length) {
                            result[index] = array[index + start];
                        } return result; } /**
                        * The base implementation of `_.some` without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} predicate The function invoked per iteration.
                        * @returns {boolean} Returns `true` if any element passes the predicate check,
                        *  else `false`.
                        */
                        function baseSome(collection, predicate) { var result; baseEach(collection, function (value, index, collection) { result = predicate(value, index, collection); return !result; }); return !!result; } /**
                        * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
                        * performs a binary search of `array` to determine the index at which `value`
                        * should be inserted into `array` in order to maintain its sort order.
                        *
                        * @private
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @param {boolean} [retHighest] Specify returning the highest qualified index.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        */
                        function baseSortedIndex(array, value, retHighest) { var low = 0, high = array == null ? low : array.length; if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                            while (low < high) {
                                var mid = low + high >>> 1, computed = array[mid];
                                if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                                    low = mid + 1;
                                }
                                else {
                                    high = mid;
                                }
                            }
                            return high;
                        } return baseSortedIndexBy(array, value, identity, retHighest); } /**
                        * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
                        * which invokes `iteratee` for `value` and each element of `array` to compute
                        * their sort ranking. The iteratee is invoked with one argument; (value).
                        *
                        * @private
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @param {Function} iteratee The iteratee invoked per element.
                        * @param {boolean} [retHighest] Specify returning the highest qualified index.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        */
                        function baseSortedIndexBy(array, value, iteratee, retHighest) { var low = 0, high = array == null ? 0 : array.length; if (high === 0) {
                            return 0;
                        } value = iteratee(value); var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined; while (low < high) {
                            var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                            if (valIsNaN) {
                                var setLow = retHighest || othIsReflexive;
                            }
                            else if (valIsUndefined) {
                                setLow = othIsReflexive && (retHighest || othIsDefined);
                            }
                            else if (valIsNull) {
                                setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                            }
                            else if (valIsSymbol) {
                                setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                            }
                            else if (othIsNull || othIsSymbol) {
                                setLow = false;
                            }
                            else {
                                setLow = retHighest ? computed <= value : computed < value;
                            }
                            if (setLow) {
                                low = mid + 1;
                            }
                            else {
                                high = mid;
                            }
                        } return nativeMin(high, MAX_ARRAY_INDEX); } /**
                        * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
                        * support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array} array The array to inspect.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @returns {Array} Returns the new duplicate free array.
                        */
                        function baseSortedUniq(array, iteratee) { var index = -1, length = array.length, resIndex = 0, result = []; while (++index < length) {
                            var value = array[index], computed = iteratee ? iteratee(value) : value;
                            if (!index || !eq(computed, seen)) {
                                var seen = computed;
                                result[resIndex++] = value === 0 ? 0 : value;
                            }
                        } return result; } /**
                        * The base implementation of `_.toNumber` which doesn't ensure correct
                        * conversions of binary, hexadecimal, or octal string values.
                        *
                        * @private
                        * @param {*} value The value to process.
                        * @returns {number} Returns the number.
                        */
                        function baseToNumber(value) { if (typeof value == 'number') {
                            return value;
                        } if (isSymbol(value)) {
                            return NAN;
                        } return +value; } /**
                        * The base implementation of `_.toString` which doesn't convert nullish
                        * values to empty strings.
                        *
                        * @private
                        * @param {*} value The value to process.
                        * @returns {string} Returns the string.
                        */
                        function baseToString(value) {
                            if (typeof value == 'string') {
                                return value;
                            }
                            if (isArray(value)) { // Recursively convert values (susceptible to call stack limits).
                                return arrayMap(value, baseToString) + '';
                            }
                            if (isSymbol(value)) {
                                return symbolToString ? symbolToString.call(value) : '';
                            }
                            var result = value + '';
                            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                        } /**
                                 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
                                 *
                                 * @private
                                 * @param {Array} array The array to inspect.
                                 * @param {Function} [iteratee] The iteratee invoked per element.
                                 * @param {Function} [comparator] The comparator invoked per element.
                                 * @returns {Array} Returns the new duplicate free array.
                                 */
                        function baseUniq(array, iteratee, comparator) { var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result; if (comparator) {
                            isCommon = false;
                            includes = arrayIncludesWith;
                        }
                        else if (length >= LARGE_ARRAY_SIZE) {
                            var set = iteratee ? null : createSet(array);
                            if (set) {
                                return setToArray(set);
                            }
                            isCommon = false;
                            includes = cacheHas;
                            seen = new SetCache();
                        }
                        else {
                            seen = iteratee ? [] : result;
                        } outer: while (++index < length) {
                            var value = array[index], computed = iteratee ? iteratee(value) : value;
                            value = comparator || value !== 0 ? value : 0;
                            if (isCommon && computed === computed) {
                                var seenIndex = seen.length;
                                while (seenIndex--) {
                                    if (seen[seenIndex] === computed) {
                                        continue outer;
                                    }
                                }
                                if (iteratee) {
                                    seen.push(computed);
                                }
                                result.push(value);
                            }
                            else if (!includes(seen, computed, comparator)) {
                                if (seen !== result) {
                                    seen.push(computed);
                                }
                                result.push(value);
                            }
                        } return result; } /**
                        * The base implementation of `_.unset`.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The property path to unset.
                        * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                        */
                        function baseUnset(object, path) { path = castPath(path, object); object = parent(object, path); return object == null || delete object[toKey(last(path))]; } /**
                        * The base implementation of `_.update`.
                        *
                        * @private
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to update.
                        * @param {Function} updater The function to produce the updated value.
                        * @param {Function} [customizer] The function to customize path creation.
                        * @returns {Object} Returns `object`.
                        */
                        function baseUpdate(object, path, updater, customizer) { return baseSet(object, path, updater(baseGet(object, path)), customizer); } /**
                        * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
                        * without support for iteratee shorthands.
                        *
                        * @private
                        * @param {Array} array The array to query.
                        * @param {Function} predicate The function invoked per iteration.
                        * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Array} Returns the slice of `array`.
                        */
                        function baseWhile(array, predicate, isDrop, fromRight) { var length = array.length, index = fromRight ? length : -1; while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) { } return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index); } /**
                        * The base implementation of `wrapperValue` which returns the result of
                        * performing a sequence of actions on the unwrapped `value`, where each
                        * successive action is supplied the return value of the previous.
                        *
                        * @private
                        * @param {*} value The unwrapped value.
                        * @param {Array} actions Actions to perform to resolve the unwrapped value.
                        * @returns {*} Returns the resolved value.
                        */
                        function baseWrapperValue(value, actions) { var result = value; if (result instanceof LazyWrapper) {
                            result = result.value();
                        } return arrayReduce(actions, function (result, action) { return action.func.apply(action.thisArg, arrayPush([result], action.args)); }, result); } /**
                        * The base implementation of methods like `_.xor`, without support for
                        * iteratee shorthands, that accepts an array of arrays to inspect.
                        *
                        * @private
                        * @param {Array} arrays The arrays to inspect.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of values.
                        */
                        function baseXor(arrays, iteratee, comparator) { var length = arrays.length; if (length < 2) {
                            return length ? baseUniq(arrays[0]) : [];
                        } var index = -1, result = Array(length); while (++index < length) {
                            var array = arrays[index], othIndex = -1;
                            while (++othIndex < length) {
                                if (othIndex != index) {
                                    result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                                }
                            }
                        } return baseUniq(baseFlatten(result, 1), iteratee, comparator); } /**
                        * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
                        *
                        * @private
                        * @param {Array} props The property identifiers.
                        * @param {Array} values The property values.
                        * @param {Function} assignFunc The function to assign values.
                        * @returns {Object} Returns the new object.
                        */
                        function baseZipObject(props, values, assignFunc) { var index = -1, length = props.length, valsLength = values.length, result = {}; while (++index < length) {
                            var value = index < valsLength ? values[index] : undefined;
                            assignFunc(result, props[index], value);
                        } return result; } /**
                        * Casts `value` to an empty array if it's not an array like object.
                        *
                        * @private
                        * @param {*} value The value to inspect.
                        * @returns {Array|Object} Returns the cast array-like object.
                        */
                        function castArrayLikeObject(value) { return isArrayLikeObject(value) ? value : []; } /**
                        * Casts `value` to `identity` if it's not a function.
                        *
                        * @private
                        * @param {*} value The value to inspect.
                        * @returns {Function} Returns cast function.
                        */
                        function castFunction(value) { return typeof value == 'function' ? value : identity; } /**
                        * Casts `value` to a path array if it's not one.
                        *
                        * @private
                        * @param {*} value The value to inspect.
                        * @param {Object} [object] The object to query keys on.
                        * @returns {Array} Returns the cast property path array.
                        */
                        function castPath(value, object) { if (isArray(value)) {
                            return value;
                        } return isKey(value, object) ? [value] : stringToPath(toString(value)); } /**
                        * A `baseRest` alias which can be replaced with `identity` by module
                        * replacement plugins.
                        *
                        * @private
                        * @type {Function}
                        * @param {Function} func The function to apply a rest parameter to.
                        * @returns {Function} Returns the new function.
                        */
                        var castRest = baseRest; /**
                        * Casts `array` to a slice if it's needed.
                        *
                        * @private
                        * @param {Array} array The array to inspect.
                        * @param {number} start The start position.
                        * @param {number} [end=array.length] The end position.
                        * @returns {Array} Returns the cast slice.
                        */
                        function castSlice(array, start, end) { var length = array.length; end = end === undefined ? length : end; return !start && end >= length ? array : baseSlice(array, start, end); } /**
                        * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
                        *
                        * @private
                        * @param {number|Object} id The timer id or timeout object of the timer to clear.
                        */
                        var clearTimeout = ctxClearTimeout || function (id) { return root.clearTimeout(id); }; /**
                        * Creates a clone of  `buffer`.
                        *
                        * @private
                        * @param {Buffer} buffer The buffer to clone.
                        * @param {boolean} [isDeep] Specify a deep clone.
                        * @returns {Buffer} Returns the cloned buffer.
                        */
                        function cloneBuffer(buffer, isDeep) { if (isDeep) {
                            return buffer.slice();
                        } var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length); buffer.copy(result); return result; } /**
                        * Creates a clone of `arrayBuffer`.
                        *
                        * @private
                        * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
                        * @returns {ArrayBuffer} Returns the cloned array buffer.
                        */
                        function cloneArrayBuffer(arrayBuffer) { var result = new arrayBuffer.constructor(arrayBuffer.byteLength); new Uint8Array(result).set(new Uint8Array(arrayBuffer)); return result; } /**
                        * Creates a clone of `dataView`.
                        *
                        * @private
                        * @param {Object} dataView The data view to clone.
                        * @param {boolean} [isDeep] Specify a deep clone.
                        * @returns {Object} Returns the cloned data view.
                        */
                        function cloneDataView(dataView, isDeep) { var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer; return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength); } /**
                        * Creates a clone of `regexp`.
                        *
                        * @private
                        * @param {Object} regexp The regexp to clone.
                        * @returns {Object} Returns the cloned regexp.
                        */
                        function cloneRegExp(regexp) { var result = new regexp.constructor(regexp.source, reFlags.exec(regexp)); result.lastIndex = regexp.lastIndex; return result; } /**
                        * Creates a clone of the `symbol` object.
                        *
                        * @private
                        * @param {Object} symbol The symbol object to clone.
                        * @returns {Object} Returns the cloned symbol object.
                        */
                        function cloneSymbol(symbol) { return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {}; } /**
                        * Creates a clone of `typedArray`.
                        *
                        * @private
                        * @param {Object} typedArray The typed array to clone.
                        * @param {boolean} [isDeep] Specify a deep clone.
                        * @returns {Object} Returns the cloned typed array.
                        */
                        function cloneTypedArray(typedArray, isDeep) { var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer; return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length); } /**
                        * Compares values to sort them in ascending order.
                        *
                        * @private
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {number} Returns the sort order indicator for `value`.
                        */
                        function compareAscending(value, other) { if (value !== other) {
                            var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                            var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
                                return 1;
                            }
                            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
                                return -1;
                            }
                        } return 0; } /**
                        * Used by `_.orderBy` to compare multiple properties of a value to another
                        * and stable sort them.
                        *
                        * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
                        * specify an order of "desc" for descending or "asc" for ascending sort order
                        * of corresponding values.
                        *
                        * @private
                        * @param {Object} object The object to compare.
                        * @param {Object} other The other object to compare.
                        * @param {boolean[]|string[]} orders The order to sort by for each property.
                        * @returns {number} Returns the sort order indicator for `object`.
                        */
                        function compareMultiple(object, other, orders) {
                            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
                            while (++index < length) {
                                var result = compareAscending(objCriteria[index], othCriteria[index]);
                                if (result) {
                                    if (index >= ordersLength) {
                                        return result;
                                    }
                                    var order = orders[index];
                                    return result * (order == 'desc' ? -1 : 1);
                                }
                            } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
                            // that causes it, under certain circumstances, to provide the same value for
                            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
                            // for more details.
                            //
                            // This also ensures a stable sort in V8 and other engines.
                            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
                            return object.index - other.index;
                        } /**
                                 * Creates an array that is the composition of partially applied arguments,
                                 * placeholders, and provided arguments into a single array of arguments.
                                 *
                                 * @private
                                 * @param {Array} args The provided arguments.
                                 * @param {Array} partials The arguments to prepend to those provided.
                                 * @param {Array} holders The `partials` placeholder indexes.
                                 * @params {boolean} [isCurried] Specify composing for a curried function.
                                 * @returns {Array} Returns the new array of composed arguments.
                                 */
                        function composeArgs(args, partials, holders, isCurried) { var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried; while (++leftIndex < leftLength) {
                            result[leftIndex] = partials[leftIndex];
                        } while (++argsIndex < holdersLength) {
                            if (isUncurried || argsIndex < argsLength) {
                                result[holders[argsIndex]] = args[argsIndex];
                            }
                        } while (rangeLength--) {
                            result[leftIndex++] = args[argsIndex++];
                        } return result; } /**
                        * This function is like `composeArgs` except that the arguments composition
                        * is tailored for `_.partialRight`.
                        *
                        * @private
                        * @param {Array} args The provided arguments.
                        * @param {Array} partials The arguments to append to those provided.
                        * @param {Array} holders The `partials` placeholder indexes.
                        * @params {boolean} [isCurried] Specify composing for a curried function.
                        * @returns {Array} Returns the new array of composed arguments.
                        */
                        function composeArgsRight(args, partials, holders, isCurried) { var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried; while (++argsIndex < rangeLength) {
                            result[argsIndex] = args[argsIndex];
                        } var offset = argsIndex; while (++rightIndex < rightLength) {
                            result[offset + rightIndex] = partials[rightIndex];
                        } while (++holdersIndex < holdersLength) {
                            if (isUncurried || argsIndex < argsLength) {
                                result[offset + holders[holdersIndex]] = args[argsIndex++];
                            }
                        } return result; } /**
                        * Copies the values of `source` to `array`.
                        *
                        * @private
                        * @param {Array} source The array to copy values from.
                        * @param {Array} [array=[]] The array to copy values to.
                        * @returns {Array} Returns `array`.
                        */
                        function copyArray(source, array) { var index = -1, length = source.length; array || (array = Array(length)); while (++index < length) {
                            array[index] = source[index];
                        } return array; } /**
                        * Copies properties of `source` to `object`.
                        *
                        * @private
                        * @param {Object} source The object to copy properties from.
                        * @param {Array} props The property identifiers to copy.
                        * @param {Object} [object={}] The object to copy properties to.
                        * @param {Function} [customizer] The function to customize copied values.
                        * @returns {Object} Returns `object`.
                        */
                        function copyObject(source, props, object, customizer) { var isNew = !object; object || (object = {}); var index = -1, length = props.length; while (++index < length) {
                            var key = props[index];
                            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                            if (newValue === undefined) {
                                newValue = source[key];
                            }
                            if (isNew) {
                                baseAssignValue(object, key, newValue);
                            }
                            else {
                                assignValue(object, key, newValue);
                            }
                        } return object; } /**
                        * Copies own symbols of `source` to `object`.
                        *
                        * @private
                        * @param {Object} source The object to copy symbols from.
                        * @param {Object} [object={}] The object to copy symbols to.
                        * @returns {Object} Returns `object`.
                        */
                        function copySymbols(source, object) { return copyObject(source, getSymbols(source), object); } /**
                        * Copies own and inherited symbols of `source` to `object`.
                        *
                        * @private
                        * @param {Object} source The object to copy symbols from.
                        * @param {Object} [object={}] The object to copy symbols to.
                        * @returns {Object} Returns `object`.
                        */
                        function copySymbolsIn(source, object) { return copyObject(source, getSymbolsIn(source), object); } /**
                        * Creates a function like `_.groupBy`.
                        *
                        * @private
                        * @param {Function} setter The function to set accumulator values.
                        * @param {Function} [initializer] The accumulator object initializer.
                        * @returns {Function} Returns the new aggregator function.
                        */
                        function createAggregator(setter, initializer) { return function (collection, iteratee) { var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {}; return func(collection, setter, getIteratee(iteratee, 2), accumulator); }; } /**
                        * Creates a function like `_.assign`.
                        *
                        * @private
                        * @param {Function} assigner The function to assign values.
                        * @returns {Function} Returns the new assigner function.
                        */
                        function createAssigner(assigner) { return baseRest(function (object, sources) { var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined; customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined; if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                            customizer = length < 3 ? undefined : customizer;
                            length = 1;
                        } object = Object(object); while (++index < length) {
                            var source = sources[index];
                            if (source) {
                                assigner(object, source, index, customizer);
                            }
                        } return object; }); } /**
                        * Creates a `baseEach` or `baseEachRight` function.
                        *
                        * @private
                        * @param {Function} eachFunc The function to iterate over a collection.
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Function} Returns the new base function.
                        */
                        function createBaseEach(eachFunc, fromRight) { return function (collection, iteratee) { if (collection == null) {
                            return collection;
                        } if (!isArrayLike(collection)) {
                            return eachFunc(collection, iteratee);
                        } var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection); while (fromRight ? index-- : ++index < length) {
                            if (iteratee(iterable[index], index, iterable) === false) {
                                break;
                            }
                        } return collection; }; } /**
                        * Creates a base function for methods like `_.forIn` and `_.forOwn`.
                        *
                        * @private
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Function} Returns the new base function.
                        */
                        function createBaseFor(fromRight) { return function (object, iteratee, keysFunc) { var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length; while (length--) {
                            var key = props[fromRight ? length : ++index];
                            if (iteratee(iterable[key], key, iterable) === false) {
                                break;
                            }
                        } return object; }; } /**
                        * Creates a function that wraps `func` to invoke it with the optional `this`
                        * binding of `thisArg`.
                        *
                        * @private
                        * @param {Function} func The function to wrap.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @param {*} [thisArg] The `this` binding of `func`.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createBind(func, bitmask, thisArg) { var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func); function wrapper() { var fn = this && this !== root && this instanceof wrapper ? Ctor : func; return fn.apply(isBind ? thisArg : this, arguments); } return wrapper; } /**
                        * Creates a function like `_.lowerFirst`.
                        *
                        * @private
                        * @param {string} methodName The name of the `String` case method to use.
                        * @returns {Function} Returns the new case function.
                        */
                        function createCaseFirst(methodName) { return function (string) { string = toString(string); var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined; var chr = strSymbols ? strSymbols[0] : string.charAt(0); var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1); return chr[methodName]() + trailing; }; } /**
                        * Creates a function like `_.camelCase`.
                        *
                        * @private
                        * @param {Function} callback The function to combine each word.
                        * @returns {Function} Returns the new compounder function.
                        */
                        function createCompounder(callback) { return function (string) { return arrayReduce(words(deburr(string).replace(reApos, '')), callback, ''); }; } /**
                        * Creates a function that produces an instance of `Ctor` regardless of
                        * whether it was invoked as part of a `new` expression or by `call` or `apply`.
                        *
                        * @private
                        * @param {Function} Ctor The constructor to wrap.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createCtor(Ctor) {
                            return function () {
                                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                                // for more details.
                                var args = arguments;
                                switch (args.length) {
                                    case 0: return new Ctor();
                                    case 1: return new Ctor(args[0]);
                                    case 2: return new Ctor(args[0], args[1]);
                                    case 3: return new Ctor(args[0], args[1], args[2]);
                                    case 4: return new Ctor(args[0], args[1], args[2], args[3]);
                                    case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                                    case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                                }
                                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args); // Mimic the constructor's `return` behavior.
                                // See https://es5.github.io/#x13.2.2 for more details.
                                return isObject(result) ? result : thisBinding;
                            };
                        } /**
                                 * Creates a function that wraps `func` to enable currying.
                                 *
                                 * @private
                                 * @param {Function} func The function to wrap.
                                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                                 * @param {number} arity The arity of `func`.
                                 * @returns {Function} Returns the new wrapped function.
                                 */
                        function createCurry(func, bitmask, arity) { var Ctor = createCtor(func); function wrapper() { var length = arguments.length, args = Array(length), index = length, placeholder = getHolder(wrapper); while (index--) {
                            args[index] = arguments[index];
                        } var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder); length -= holders.length; if (length < arity) {
                            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                        } var fn = this && this !== root && this instanceof wrapper ? Ctor : func; return apply(fn, this, args); } return wrapper; } /**
                        * Creates a `_.find` or `_.findLast` function.
                        *
                        * @private
                        * @param {Function} findIndexFunc The function to find the collection index.
                        * @returns {Function} Returns the new find function.
                        */
                        function createFind(findIndexFunc) { return function (collection, predicate, fromIndex) { var iterable = Object(collection); if (!isArrayLike(collection)) {
                            var iteratee = getIteratee(predicate, 3);
                            collection = keys(collection);
                            predicate = function predicate(key) { return iteratee(iterable[key], key, iterable); };
                        } var index = findIndexFunc(collection, predicate, fromIndex); return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined; }; } /**
                        * Creates a `_.flow` or `_.flowRight` function.
                        *
                        * @private
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Function} Returns the new flow function.
                        */
                        function createFlow(fromRight) { return flatRest(function (funcs) { var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru; if (fromRight) {
                            funcs.reverse();
                        } while (index--) {
                            var func = funcs[index];
                            if (typeof func != 'function') {
                                throw new TypeError(FUNC_ERROR_TEXT);
                            }
                            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                                var wrapper = new LodashWrapper([], true);
                            }
                        } index = wrapper ? index : length; while (++index < length) {
                            func = funcs[index];
                            var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                            }
                            else {
                                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                            }
                        } return function () { var args = arguments, value = args[0]; if (wrapper && args.length == 1 && isArray(value)) {
                            return wrapper.plant(value).value();
                        } var index = 0, result = length ? funcs[index].apply(this, args) : value; while (++index < length) {
                            result = funcs[index].call(this, result);
                        } return result; }; }); } /**
                        * Creates a function that wraps `func` to invoke it with optional `this`
                        * binding of `thisArg`, partial application, and currying.
                        *
                        * @private
                        * @param {Function|string} func The function or method name to wrap.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @param {*} [thisArg] The `this` binding of `func`.
                        * @param {Array} [partials] The arguments to prepend to those provided to
                        *  the new function.
                        * @param {Array} [holders] The `partials` placeholder indexes.
                        * @param {Array} [partialsRight] The arguments to append to those provided
                        *  to the new function.
                        * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
                        * @param {Array} [argPos] The argument positions of the new function.
                        * @param {number} [ary] The arity cap of `func`.
                        * @param {number} [arity] The arity of `func`.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) { var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func); function wrapper() { var length = arguments.length, args = Array(length), index = length; while (index--) {
                            args[index] = arguments[index];
                        } if (isCurried) {
                            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                        } if (partials) {
                            args = composeArgs(args, partials, holders, isCurried);
                        } if (partialsRight) {
                            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                        } length -= holdersCount; if (isCurried && length < arity) {
                            var newHolders = replaceHolders(args, placeholder);
                            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                        } var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func; length = args.length; if (argPos) {
                            args = reorder(args, argPos);
                        }
                        else if (isFlip && length > 1) {
                            args.reverse();
                        } if (isAry && ary < length) {
                            args.length = ary;
                        } if (this && this !== root && this instanceof wrapper) {
                            fn = Ctor || createCtor(fn);
                        } return fn.apply(thisBinding, args); } return wrapper; } /**
                        * Creates a function like `_.invertBy`.
                        *
                        * @private
                        * @param {Function} setter The function to set accumulator values.
                        * @param {Function} toIteratee The function to resolve iteratees.
                        * @returns {Function} Returns the new inverter function.
                        */
                        function createInverter(setter, toIteratee) { return function (object, iteratee) { return baseInverter(object, setter, toIteratee(iteratee), {}); }; } /**
                        * Creates a function that performs a mathematical operation on two values.
                        *
                        * @private
                        * @param {Function} operator The function to perform the operation.
                        * @param {number} [defaultValue] The value used for `undefined` arguments.
                        * @returns {Function} Returns the new mathematical operation function.
                        */
                        function createMathOperation(operator, defaultValue) { return function (value, other) { var result; if (value === undefined && other === undefined) {
                            return defaultValue;
                        } if (value !== undefined) {
                            result = value;
                        } if (other !== undefined) {
                            if (result === undefined) {
                                return other;
                            }
                            if (typeof value == 'string' || typeof other == 'string') {
                                value = baseToString(value);
                                other = baseToString(other);
                            }
                            else {
                                value = baseToNumber(value);
                                other = baseToNumber(other);
                            }
                            result = operator(value, other);
                        } return result; }; } /**
                        * Creates a function like `_.over`.
                        *
                        * @private
                        * @param {Function} arrayFunc The function to iterate over iteratees.
                        * @returns {Function} Returns the new over function.
                        */
                        function createOver(arrayFunc) { return flatRest(function (iteratees) { iteratees = arrayMap(iteratees, baseUnary(getIteratee())); return baseRest(function (args) { var thisArg = this; return arrayFunc(iteratees, function (iteratee) { return apply(iteratee, thisArg, args); }); }); }); } /**
                        * Creates the padding for `string` based on `length`. The `chars` string
                        * is truncated if the number of characters exceeds `length`.
                        *
                        * @private
                        * @param {number} length The padding length.
                        * @param {string} [chars=' '] The string used as padding.
                        * @returns {string} Returns the padding for `string`.
                        */
                        function createPadding(length, chars) { chars = chars === undefined ? ' ' : baseToString(chars); var charsLength = chars.length; if (charsLength < 2) {
                            return charsLength ? baseRepeat(chars, length) : chars;
                        } var result = baseRepeat(chars, nativeCeil(length / stringSize(chars))); return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length); } /**
                        * Creates a function that wraps `func` to invoke it with the `this` binding
                        * of `thisArg` and `partials` prepended to the arguments it receives.
                        *
                        * @private
                        * @param {Function} func The function to wrap.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @param {*} thisArg The `this` binding of `func`.
                        * @param {Array} partials The arguments to prepend to those provided to
                        *  the new function.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createPartial(func, bitmask, thisArg, partials) { var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func); function wrapper() { var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func; while (++leftIndex < leftLength) {
                            args[leftIndex] = partials[leftIndex];
                        } while (argsLength--) {
                            args[leftIndex++] = arguments[++argsIndex];
                        } return apply(fn, isBind ? thisArg : this, args); } return wrapper; } /**
                        * Creates a `_.range` or `_.rangeRight` function.
                        *
                        * @private
                        * @param {boolean} [fromRight] Specify iterating from right to left.
                        * @returns {Function} Returns the new range function.
                        */
                        function createRange(fromRight) {
                            return function (start, end, step) {
                                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                                    end = step = undefined;
                                } // Ensure the sign of `-0` is preserved.
                                start = toFinite(start);
                                if (end === undefined) {
                                    end = start;
                                    start = 0;
                                }
                                else {
                                    end = toFinite(end);
                                }
                                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                                return baseRange(start, end, step, fromRight);
                            };
                        } /**
                                 * Creates a function that performs a relational operation on two values.
                                 *
                                 * @private
                                 * @param {Function} operator The function to perform the operation.
                                 * @returns {Function} Returns the new relational operation function.
                                 */
                        function createRelationalOperation(operator) { return function (value, other) { if (!(typeof value == 'string' && typeof other == 'string')) {
                            value = toNumber(value);
                            other = toNumber(other);
                        } return operator(value, other); }; } /**
                        * Creates a function that wraps `func` to continue currying.
                        *
                        * @private
                        * @param {Function} func The function to wrap.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @param {Function} wrapFunc The function to create the `func` wrapper.
                        * @param {*} placeholder The placeholder value.
                        * @param {*} [thisArg] The `this` binding of `func`.
                        * @param {Array} [partials] The arguments to prepend to those provided to
                        *  the new function.
                        * @param {Array} [holders] The `partials` placeholder indexes.
                        * @param {Array} [argPos] The argument positions of the new function.
                        * @param {number} [ary] The arity cap of `func`.
                        * @param {number} [arity] The arity of `func`.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) { var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials; bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG; bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG); if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                        } var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity]; var result = wrapFunc.apply(undefined, newData); if (isLaziable(func)) {
                            setData(result, newData);
                        } result.placeholder = placeholder; return setWrapToString(result, func, bitmask); } /**
                        * Creates a function like `_.round`.
                        *
                        * @private
                        * @param {string} methodName The name of the `Math` method to use when rounding.
                        * @returns {Function} Returns the new round function.
                        */
                        function createRound(methodName) {
                            var func = Math[methodName];
                            return function (number, precision) {
                                number = toNumber(number);
                                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                                if (precision && nativeIsFinite(number)) { // Shift with exponential notation to avoid floating-point issues.
                                    // See [MDN](https://mdn.io/round#Examples) for more details.
                                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                                    pair = (toString(value) + 'e').split('e');
                                    return +(pair[0] + 'e' + (+pair[1] - precision));
                                }
                                return func(number);
                            };
                        } /**
                                 * Creates a set object of `values`.
                                 *
                                 * @private
                                 * @param {Array} values The values to add to the set.
                                 * @returns {Object} Returns the new set.
                                 */
                        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) { return new Set(values); }; /**
                        * Creates a `_.toPairs` or `_.toPairsIn` function.
                        *
                        * @private
                        * @param {Function} keysFunc The function to get the keys of a given object.
                        * @returns {Function} Returns the new pairs function.
                        */
                        function createToPairs(keysFunc) { return function (object) { var tag = getTag(object); if (tag == mapTag) {
                            return mapToArray(object);
                        } if (tag == setTag) {
                            return setToPairs(object);
                        } return baseToPairs(object, keysFunc(object)); }; } /**
                        * Creates a function that either curries or invokes `func` with optional
                        * `this` binding and partially applied arguments.
                        *
                        * @private
                        * @param {Function|string} func The function or method name to wrap.
                        * @param {number} bitmask The bitmask flags.
                        *    1 - `_.bind`
                        *    2 - `_.bindKey`
                        *    4 - `_.curry` or `_.curryRight` of a bound function
                        *    8 - `_.curry`
                        *   16 - `_.curryRight`
                        *   32 - `_.partial`
                        *   64 - `_.partialRight`
                        *  128 - `_.rearg`
                        *  256 - `_.ary`
                        *  512 - `_.flip`
                        * @param {*} [thisArg] The `this` binding of `func`.
                        * @param {Array} [partials] The arguments to be partially applied.
                        * @param {Array} [holders] The `partials` placeholder indexes.
                        * @param {Array} [argPos] The argument positions of the new function.
                        * @param {number} [ary] The arity cap of `func`.
                        * @param {number} [arity] The arity of `func`.
                        * @returns {Function} Returns the new wrapped function.
                        */
                        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) { var isBindKey = bitmask & WRAP_BIND_KEY_FLAG; if (!isBindKey && typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } var length = partials ? partials.length : 0; if (!length) {
                            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                            partials = holders = undefined;
                        } ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0); arity = arity === undefined ? arity : toInteger(arity); length -= holders ? holders.length : 0; if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                            var partialsRight = partials, holdersRight = holders;
                            partials = holders = undefined;
                        } var data = isBindKey ? undefined : getData(func); var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity]; if (data) {
                            mergeData(newData, data);
                        } func = newData[0]; bitmask = newData[1]; thisArg = newData[2]; partials = newData[3]; holders = newData[4]; arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0); if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
                            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                        } if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                            var result = createBind(func, bitmask, thisArg);
                        }
                        else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
                            result = createCurry(func, bitmask, arity);
                        }
                        else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
                            result = createPartial(func, bitmask, thisArg, partials);
                        }
                        else {
                            result = createHybrid.apply(undefined, newData);
                        } var setter = data ? baseSetData : setData; return setWrapToString(setter(result, newData), func, bitmask); } /**
                        * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
                        * of source objects to the destination object for all destination properties
                        * that resolve to `undefined`.
                        *
                        * @private
                        * @param {*} objValue The destination value.
                        * @param {*} srcValue The source value.
                        * @param {string} key The key of the property to assign.
                        * @param {Object} object The parent object of `objValue`.
                        * @returns {*} Returns the value to assign.
                        */
                        function customDefaultsAssignIn(objValue, srcValue, key, object) { if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                            return srcValue;
                        } return objValue; } /**
                        * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
                        * objects into destination objects that are passed thru.
                        *
                        * @private
                        * @param {*} objValue The destination value.
                        * @param {*} srcValue The source value.
                        * @param {string} key The key of the property to merge.
                        * @param {Object} object The parent object of `objValue`.
                        * @param {Object} source The parent object of `srcValue`.
                        * @param {Object} [stack] Tracks traversed source values and their merged
                        *  counterparts.
                        * @returns {*} Returns the value to assign.
                        */
                        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                            if (isObject(objValue) && isObject(srcValue)) { // Recursively merge objects and arrays (susceptible to call stack limits).
                                stack.set(srcValue, objValue);
                                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                                stack['delete'](srcValue);
                            }
                            return objValue;
                        } /**
                                 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
                                 * objects.
                                 *
                                 * @private
                                 * @param {*} value The value to inspect.
                                 * @param {string} key The key of the property to inspect.
                                 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
                                 */
                        function customOmitClone(value) { return isPlainObject(value) ? undefined : value; } /**
                        * A specialized version of `baseIsEqualDeep` for arrays with support for
                        * partial deep comparisons.
                        *
                        * @private
                        * @param {Array} array The array to compare.
                        * @param {Array} other The other array to compare.
                        * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                        * @param {Function} customizer The function to customize comparisons.
                        * @param {Function} equalFunc The function to determine equivalents of values.
                        * @param {Object} stack Tracks traversed `array` and `other` objects.
                        * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
                        */
                        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                                return false;
                            } // Check that cyclic values are equal.
                            var arrStacked = stack.get(array);
                            var othStacked = stack.get(other);
                            if (arrStacked && othStacked) {
                                return arrStacked == other && othStacked == array;
                            }
                            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
                            stack.set(array, other);
                            stack.set(other, array); // Ignore non-index properties.
                            while (++index < arrLength) {
                                var arrValue = array[index], othValue = other[index];
                                if (customizer) {
                                    var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                                }
                                if (compared !== undefined) {
                                    if (compared) {
                                        continue;
                                    }
                                    result = false;
                                    break;
                                } // Recursively compare arrays (susceptible to call stack limits).
                                if (seen) {
                                    if (!arraySome(other, function (othValue, othIndex) { if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                                        return seen.push(othIndex);
                                    } })) {
                                        result = false;
                                        break;
                                    }
                                }
                                else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                                    result = false;
                                    break;
                                }
                            }
                            stack['delete'](array);
                            stack['delete'](other);
                            return result;
                        } /**
                                 * A specialized version of `baseIsEqualDeep` for comparing objects of
                                 * the same `toStringTag`.
                                 *
                                 * **Note:** This function only supports comparing values with tags of
                                 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                                 *
                                 * @private
                                 * @param {Object} object The object to compare.
                                 * @param {Object} other The other object to compare.
                                 * @param {string} tag The `toStringTag` of the objects to compare.
                                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                                 * @param {Function} customizer The function to customize comparisons.
                                 * @param {Function} equalFunc The function to determine equivalents of values.
                                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                                 */
                        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                            switch (tag) {
                                case dataViewTag:
                                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                                        return false;
                                    }
                                    object = object.buffer;
                                    other = other.buffer;
                                case arrayBufferTag:
                                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                                        return false;
                                    }
                                    return true;
                                case boolTag:
                                case dateTag:
                                case numberTag: // Coerce booleans to `1` or `0` and dates to milliseconds.
                                    // Invalid dates are coerced to `NaN`.
                                    return eq(+object, +other);
                                case errorTag: return object.name == other.name && object.message == other.message;
                                case regexpTag:
                                case stringTag: // Coerce regexes to strings and treat strings, primitives and objects,
                                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                                    // for more details.
                                    return object == other + '';
                                case mapTag: var convert = mapToArray;
                                case setTag:
                                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                                    convert || (convert = setToArray);
                                    if (object.size != other.size && !isPartial) {
                                        return false;
                                    } // Assume cyclic values are equal.
                                    var stacked = stack.get(object);
                                    if (stacked) {
                                        return stacked == other;
                                    }
                                    bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).
                                    stack.set(object, other);
                                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                                    stack['delete'](object);
                                    return result;
                                case symbolTag: if (symbolValueOf) {
                                    return symbolValueOf.call(object) == symbolValueOf.call(other);
                                }
                            }
                            return false;
                        } /**
                                 * A specialized version of `baseIsEqualDeep` for objects with support for
                                 * partial deep comparisons.
                                 *
                                 * @private
                                 * @param {Object} object The object to compare.
                                 * @param {Object} other The other object to compare.
                                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                                 * @param {Function} customizer The function to customize comparisons.
                                 * @param {Function} equalFunc The function to determine equivalents of values.
                                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                                 */
                        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                            if (objLength != othLength && !isPartial) {
                                return false;
                            }
                            var index = objLength;
                            while (index--) {
                                var key = objProps[index];
                                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                                    return false;
                                }
                            } // Check that cyclic values are equal.
                            var objStacked = stack.get(object);
                            var othStacked = stack.get(other);
                            if (objStacked && othStacked) {
                                return objStacked == other && othStacked == object;
                            }
                            var result = true;
                            stack.set(object, other);
                            stack.set(other, object);
                            var skipCtor = isPartial;
                            while (++index < objLength) {
                                key = objProps[index];
                                var objValue = object[key], othValue = other[key];
                                if (customizer) {
                                    var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                                } // Recursively compare objects (susceptible to call stack limits).
                                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                                    result = false;
                                    break;
                                }
                                skipCtor || (skipCtor = key == 'constructor');
                            }
                            if (result && !skipCtor) {
                                var objCtor = object.constructor, othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.
                                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
                                    result = false;
                                }
                            }
                            stack['delete'](object);
                            stack['delete'](other);
                            return result;
                        } /**
                                 * A specialized version of `baseRest` which flattens the rest array.
                                 *
                                 * @private
                                 * @param {Function} func The function to apply a rest parameter to.
                                 * @returns {Function} Returns the new function.
                                 */
                        function flatRest(func) { return setToString(overRest(func, undefined, flatten), func + ''); } /**
                        * Creates an array of own enumerable property names and symbols of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property names and symbols.
                        */
                        function getAllKeys(object) { return baseGetAllKeys(object, keys, getSymbols); } /**
                        * Creates an array of own and inherited enumerable property names and
                        * symbols of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property names and symbols.
                        */
                        function getAllKeysIn(object) { return baseGetAllKeys(object, keysIn, getSymbolsIn); } /**
                        * Gets metadata for `func`.
                        *
                        * @private
                        * @param {Function} func The function to query.
                        * @returns {*} Returns the metadata for `func`.
                        */
                        var getData = !metaMap ? noop : function (func) { return metaMap.get(func); }; /**
                        * Gets the name of `func`.
                        *
                        * @private
                        * @param {Function} func The function to query.
                        * @returns {string} Returns the function name.
                        */
                        function getFuncName(func) { var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0; while (length--) {
                            var data = array[length], otherFunc = data.func;
                            if (otherFunc == null || otherFunc == func) {
                                return data.name;
                            }
                        } return result; } /**
                        * Gets the argument placeholder value for `func`.
                        *
                        * @private
                        * @param {Function} func The function to inspect.
                        * @returns {*} Returns the placeholder value.
                        */
                        function getHolder(func) { var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func; return object.placeholder; } /**
                        * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
                        * this function returns the custom method, otherwise it returns `baseIteratee`.
                        * If arguments are provided, the chosen function is invoked with them and
                        * its result is returned.
                        *
                        * @private
                        * @param {*} [value] The value to convert to an iteratee.
                        * @param {number} [arity] The arity of the created iteratee.
                        * @returns {Function} Returns the chosen function or its result.
                        */
                        function getIteratee() { var result = lodash.iteratee || iteratee; result = result === iteratee ? baseIteratee : result; return arguments.length ? result(arguments[0], arguments[1]) : result; } /**
                        * Gets the data for `map`.
                        *
                        * @private
                        * @param {Object} map The map to query.
                        * @param {string} key The reference key.
                        * @returns {*} Returns the map data.
                        */
                        function getMapData(map, key) { var data = map.__data__; return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map; } /**
                        * Gets the property names, values, and compare flags of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the match data of `object`.
                        */
                        function getMatchData(object) { var result = keys(object), length = result.length; while (length--) {
                            var key = result[length], value = object[key];
                            result[length] = [key, value, isStrictComparable(value)];
                        } return result; } /**
                        * Gets the native function at `key` of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {string} key The key of the method to get.
                        * @returns {*} Returns the function if it's native, else `undefined`.
                        */
                        function getNative(object, key) { var value = getValue(object, key); return baseIsNative(value) ? value : undefined; } /**
                        * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                        *
                        * @private
                        * @param {*} value The value to query.
                        * @returns {string} Returns the raw `toStringTag`.
                        */
                        function getRawTag(value) { var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag]; try {
                            value[symToStringTag] = undefined;
                            var unmasked = true;
                        }
                        catch (e) { } var result = nativeObjectToString.call(value); if (unmasked) {
                            if (isOwn) {
                                value[symToStringTag] = tag;
                            }
                            else {
                                delete value[symToStringTag];
                            }
                        } return result; } /**
                        * Creates an array of the own enumerable symbols of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of symbols.
                        */
                        var getSymbols = !nativeGetSymbols ? stubArray : function (object) { if (object == null) {
                            return [];
                        } object = Object(object); return arrayFilter(nativeGetSymbols(object), function (symbol) { return propertyIsEnumerable.call(object, symbol); }); }; /**
                        * Creates an array of the own and inherited enumerable symbols of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of symbols.
                        */
                        var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) { var result = []; while (object) {
                            arrayPush(result, getSymbols(object));
                            object = getPrototype(object);
                        } return result; }; /**
                        * Gets the `toStringTag` of `value`.
                        *
                        * @private
                        * @param {*} value The value to query.
                        * @returns {string} Returns the `toStringTag`.
                        */
                        var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
                        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
                            getTag = function getTag(value) { var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : ''; if (ctorString) {
                                switch (ctorString) {
                                    case dataViewCtorString: return dataViewTag;
                                    case mapCtorString: return mapTag;
                                    case promiseCtorString: return promiseTag;
                                    case setCtorString: return setTag;
                                    case weakMapCtorString: return weakMapTag;
                                }
                            } return result; };
                        } /**
                                 * Gets the view, applying any `transforms` to the `start` and `end` positions.
                                 *
                                 * @private
                                 * @param {number} start The start of the view.
                                 * @param {number} end The end of the view.
                                 * @param {Array} transforms The transformations to apply to the view.
                                 * @returns {Object} Returns an object containing the `start` and `end`
                                 *  positions of the view.
                                 */
                        function getView(start, end, transforms) { var index = -1, length = transforms.length; while (++index < length) {
                            var data = transforms[index], size = data.size;
                            switch (data.type) {
                                case 'drop':
                                    start += size;
                                    break;
                                case 'dropRight':
                                    end -= size;
                                    break;
                                case 'take':
                                    end = nativeMin(end, start + size);
                                    break;
                                case 'takeRight':
                                    start = nativeMax(start, end - size);
                                    break;
                            }
                        } return { 'start': start, 'end': end }; } /**
                        * Extracts wrapper details from the `source` body comment.
                        *
                        * @private
                        * @param {string} source The source to inspect.
                        * @returns {Array} Returns the wrapper details.
                        */
                        function getWrapDetails(source) { var match = source.match(reWrapDetails); return match ? match[1].split(reSplitDetails) : []; } /**
                        * Checks if `path` exists on `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path to check.
                        * @param {Function} hasFunc The function to check properties.
                        * @returns {boolean} Returns `true` if `path` exists, else `false`.
                        */
                        function hasPath(object, path, hasFunc) { path = castPath(path, object); var index = -1, length = path.length, result = false; while (++index < length) {
                            var key = toKey(path[index]);
                            if (!(result = object != null && hasFunc(object, key))) {
                                break;
                            }
                            object = object[key];
                        } if (result || ++index != length) {
                            return result;
                        } length = object == null ? 0 : object.length; return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object)); } /**
                        * Initializes an array clone.
                        *
                        * @private
                        * @param {Array} array The array to clone.
                        * @returns {Array} Returns the initialized clone.
                        */
                        function initCloneArray(array) {
                            var length = array.length, result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.
                            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                                result.index = array.index;
                                result.input = array.input;
                            }
                            return result;
                        } /**
                                 * Initializes an object clone.
                                 *
                                 * @private
                                 * @param {Object} object The object to clone.
                                 * @returns {Object} Returns the initialized clone.
                                 */
                        function initCloneObject(object) { return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {}; } /**
                        * Initializes an object clone based on its `toStringTag`.
                        *
                        * **Note:** This function only supports cloning values with tags of
                        * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
                        *
                        * @private
                        * @param {Object} object The object to clone.
                        * @param {string} tag The `toStringTag` of the object to clone.
                        * @param {boolean} [isDeep] Specify a deep clone.
                        * @returns {Object} Returns the initialized clone.
                        */
                        function initCloneByTag(object, tag, isDeep) { var Ctor = object.constructor; switch (tag) {
                            case arrayBufferTag: return cloneArrayBuffer(object);
                            case boolTag:
                            case dateTag: return new Ctor(+object);
                            case dataViewTag: return cloneDataView(object, isDeep);
                            case float32Tag:
                            case float64Tag:
                            case int8Tag:
                            case int16Tag:
                            case int32Tag:
                            case uint8Tag:
                            case uint8ClampedTag:
                            case uint16Tag:
                            case uint32Tag: return cloneTypedArray(object, isDeep);
                            case mapTag: return new Ctor();
                            case numberTag:
                            case stringTag: return new Ctor(object);
                            case regexpTag: return cloneRegExp(object);
                            case setTag: return new Ctor();
                            case symbolTag: return cloneSymbol(object);
                        } } /**
                        * Inserts wrapper `details` in a comment at the top of the `source` body.
                        *
                        * @private
                        * @param {string} source The source to modify.
                        * @returns {Array} details The details to insert.
                        * @returns {string} Returns the modified source.
                        */
                        function insertWrapDetails(source, details) { var length = details.length; if (!length) {
                            return source;
                        } var lastIndex = length - 1; details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex]; details = details.join(length > 2 ? ', ' : ' '); return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n'); } /**
                        * Checks if `value` is a flattenable `arguments` object or array.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
                        */
                        function isFlattenable(value) { return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]); } /**
                        * Checks if `value` is a valid array-like index.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
                        * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
                        */
                        function isIndex(value, length) { var type = typeof value; length = length == null ? MAX_SAFE_INTEGER : length; return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length; } /**
                        * Checks if the given arguments are from an iteratee call.
                        *
                        * @private
                        * @param {*} value The potential iteratee value argument.
                        * @param {*} index The potential iteratee index or key argument.
                        * @param {*} object The potential iteratee object argument.
                        * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
                        *  else `false`.
                        */
                        function isIterateeCall(value, index, object) { if (!isObject(object)) {
                            return false;
                        } var type = typeof index; if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                            return eq(object[index], value);
                        } return false; } /**
                        * Checks if `value` is a property name and not a property path.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @param {Object} [object] The object to query keys on.
                        * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
                        */
                        function isKey(value, object) { if (isArray(value)) {
                            return false;
                        } var type = typeof value; if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
                            return true;
                        } return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object); } /**
                        * Checks if `value` is suitable for use as unique object key.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
                        */
                        function isKeyable(value) { var type = typeof value; return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null; } /**
                        * Checks if `func` has a lazy counterpart.
                        *
                        * @private
                        * @param {Function} func The function to check.
                        * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
                        *  else `false`.
                        */
                        function isLaziable(func) { var funcName = getFuncName(func), other = lodash[funcName]; if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
                            return false;
                        } if (func === other) {
                            return true;
                        } var data = getData(other); return !!data && func === data[0]; } /**
                        * Checks if `func` has its source masked.
                        *
                        * @private
                        * @param {Function} func The function to check.
                        * @returns {boolean} Returns `true` if `func` is masked, else `false`.
                        */
                        function isMasked(func) { return !!maskSrcKey && maskSrcKey in func; } /**
                        * Checks if `func` is capable of being masked.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
                        */
                        var isMaskable = coreJsData ? isFunction : stubFalse; /**
                        * Checks if `value` is likely a prototype object.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
                        */
                        function isPrototype(value) { var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto; return value === proto; } /**
                        * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
                        *
                        * @private
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` if suitable for strict
                        *  equality comparisons, else `false`.
                        */
                        function isStrictComparable(value) { return value === value && !isObject(value); } /**
                        * A specialized version of `matchesProperty` for source values suitable
                        * for strict equality comparisons, i.e. `===`.
                        *
                        * @private
                        * @param {string} key The key of the property to get.
                        * @param {*} srcValue The value to match.
                        * @returns {Function} Returns the new spec function.
                        */
                        function matchesStrictComparable(key, srcValue) { return function (object) { if (object == null) {
                            return false;
                        } return object[key] === srcValue && (srcValue !== undefined || key in Object(object)); }; } /**
                        * A specialized version of `_.memoize` which clears the memoized function's
                        * cache when it exceeds `MAX_MEMOIZE_SIZE`.
                        *
                        * @private
                        * @param {Function} func The function to have its output memoized.
                        * @returns {Function} Returns the new memoized function.
                        */
                        function memoizeCapped(func) { var result = memoize(func, function (key) { if (cache.size === MAX_MEMOIZE_SIZE) {
                            cache.clear();
                        } return key; }); var cache = result.cache; return result; } /**
                        * Merges the function metadata of `source` into `data`.
                        *
                        * Merging metadata reduces the number of wrappers used to invoke a function.
                        * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
                        * may be applied regardless of execution order. Methods like `_.ary` and
                        * `_.rearg` modify function arguments, making the order in which they are
                        * executed important, preventing the merging of metadata. However, we make
                        * an exception for a safe combined case where curried functions have `_.ary`
                        * and or `_.rearg` applied.
                        *
                        * @private
                        * @param {Array} data The destination metadata.
                        * @param {Array} source The source metadata.
                        * @returns {Array} Returns `data`.
                        */
                        function mergeData(data, source) {
                            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG; // Exit early if metadata can't be merged.
                            if (!(isCommon || isCombo)) {
                                return data;
                            } // Use source `thisArg` if available.
                            if (srcBitmask & WRAP_BIND_FLAG) {
                                data[2] = source[2]; // Set when currying a bound function.
                                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                            } // Compose partial arguments.
                            var value = source[3];
                            if (value) {
                                var partials = data[3];
                                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                            } // Compose partial right arguments.
                            value = source[5];
                            if (value) {
                                partials = data[5];
                                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                            } // Use source `argPos` if available.
                            value = source[7];
                            if (value) {
                                data[7] = value;
                            } // Use source `ary` if it's smaller.
                            if (srcBitmask & WRAP_ARY_FLAG) {
                                data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                            } // Use source `arity` if one is not provided.
                            if (data[9] == null) {
                                data[9] = source[9];
                            } // Use source `func` and merge bitmasks.
                            data[0] = source[0];
                            data[1] = newBitmask;
                            return data;
                        } /**
                                 * This function is like
                                 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                                 * except that it includes inherited enumerable properties.
                                 *
                                 * @private
                                 * @param {Object} object The object to query.
                                 * @returns {Array} Returns the array of property names.
                                 */
                        function nativeKeysIn(object) { var result = []; if (object != null) {
                            for (var key in Object(object)) {
                                result.push(key);
                            }
                        } return result; } /**
                        * Converts `value` to a string using `Object.prototype.toString`.
                        *
                        * @private
                        * @param {*} value The value to convert.
                        * @returns {string} Returns the converted string.
                        */
                        function objectToString(value) { return nativeObjectToString.call(value); } /**
                        * A specialized version of `baseRest` which transforms the rest array.
                        *
                        * @private
                        * @param {Function} func The function to apply a rest parameter to.
                        * @param {number} [start=func.length-1] The start position of the rest parameter.
                        * @param {Function} transform The rest array transform.
                        * @returns {Function} Returns the new function.
                        */
                        function overRest(func, start, transform) { start = nativeMax(start === undefined ? func.length - 1 : start, 0); return function () { var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length); while (++index < length) {
                            array[index] = args[start + index];
                        } index = -1; var otherArgs = Array(start + 1); while (++index < start) {
                            otherArgs[index] = args[index];
                        } otherArgs[start] = transform(array); return apply(func, this, otherArgs); }; } /**
                        * Gets the parent value at `path` of `object`.
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {Array} path The path to get the parent value of.
                        * @returns {*} Returns the parent value.
                        */
                        function parent(object, path) { return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1)); } /**
                        * Reorder `array` according to the specified indexes where the element at
                        * the first index is assigned as the first element, the element at
                        * the second index is assigned as the second element, and so on.
                        *
                        * @private
                        * @param {Array} array The array to reorder.
                        * @param {Array} indexes The arranged array indexes.
                        * @returns {Array} Returns `array`.
                        */
                        function reorder(array, indexes) { var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array); while (length--) {
                            var index = indexes[length];
                            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                        } return array; } /**
                        * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
                        *
                        * @private
                        * @param {Object} object The object to query.
                        * @param {string} key The key of the property to get.
                        * @returns {*} Returns the property value.
                        */
                        function safeGet(object, key) { if (key === 'constructor' && typeof object[key] === 'function') {
                            return;
                        } if (key == '__proto__') {
                            return;
                        } return object[key]; } /**
                        * Sets metadata for `func`.
                        *
                        * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
                        * period of time, it will trip its breaker and transition to an identity
                        * function to avoid garbage collection pauses in V8. See
                        * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
                        * for more details.
                        *
                        * @private
                        * @param {Function} func The function to associate metadata with.
                        * @param {*} data The metadata.
                        * @returns {Function} Returns `func`.
                        */
                        var setData = shortOut(baseSetData); /**
                        * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
                        *
                        * @private
                        * @param {Function} func The function to delay.
                        * @param {number} wait The number of milliseconds to delay invocation.
                        * @returns {number|Object} Returns the timer id or timeout object.
                        */
                        var setTimeout = ctxSetTimeout || function (func, wait) { return root.setTimeout(func, wait); }; /**
                        * Sets the `toString` method of `func` to return `string`.
                        *
                        * @private
                        * @param {Function} func The function to modify.
                        * @param {Function} string The `toString` result.
                        * @returns {Function} Returns `func`.
                        */
                        var setToString = shortOut(baseSetToString); /**
                        * Sets the `toString` method of `wrapper` to mimic the source of `reference`
                        * with wrapper details in a comment at the top of the source body.
                        *
                        * @private
                        * @param {Function} wrapper The function to modify.
                        * @param {Function} reference The reference function.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @returns {Function} Returns `wrapper`.
                        */
                        function setWrapToString(wrapper, reference, bitmask) { var source = reference + ''; return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask))); } /**
                        * Creates a function that'll short out and invoke `identity` instead
                        * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
                        * milliseconds.
                        *
                        * @private
                        * @param {Function} func The function to restrict.
                        * @returns {Function} Returns the new shortable function.
                        */
                        function shortOut(func) { var count = 0, lastCalled = 0; return function () { var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled); lastCalled = stamp; if (remaining > 0) {
                            if (++count >= HOT_COUNT) {
                                return arguments[0];
                            }
                        }
                        else {
                            count = 0;
                        } return func.apply(undefined, arguments); }; } /**
                        * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
                        *
                        * @private
                        * @param {Array} array The array to shuffle.
                        * @param {number} [size=array.length] The size of `array`.
                        * @returns {Array} Returns `array`.
                        */
                        function shuffleSelf(array, size) { var index = -1, length = array.length, lastIndex = length - 1; size = size === undefined ? length : size; while (++index < size) {
                            var rand = baseRandom(index, lastIndex), value = array[rand];
                            array[rand] = array[index];
                            array[index] = value;
                        } array.length = size; return array; } /**
                        * Converts `string` to a property path array.
                        *
                        * @private
                        * @param {string} string The string to convert.
                        * @returns {Array} Returns the property path array.
                        */
                        var stringToPath = memoizeCapped(function (string) { var result = []; if (string.charCodeAt(0) === 46 /* . */) {
                            result.push('');
                        } string.replace(rePropName, function (match, number, quote, subString) { result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match); }); return result; }); /**
                        * Converts `value` to a string key if it's not a string or symbol.
                        *
                        * @private
                        * @param {*} value The value to inspect.
                        * @returns {string|symbol} Returns the key.
                        */
                        function toKey(value) { if (typeof value == 'string' || isSymbol(value)) {
                            return value;
                        } var result = value + ''; return result == '0' && 1 / value == -INFINITY ? '-0' : result; } /**
                        * Converts `func` to its source code.
                        *
                        * @private
                        * @param {Function} func The function to convert.
                        * @returns {string} Returns the source code.
                        */
                        function toSource(func) { if (func != null) {
                            try {
                                return funcToString.call(func);
                            }
                            catch (e) { }
                            try {
                                return func + '';
                            }
                            catch (e) { }
                        } return ''; } /**
                        * Updates wrapper `details` based on `bitmask` flags.
                        *
                        * @private
                        * @returns {Array} details The details to modify.
                        * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                        * @returns {Array} Returns `details`.
                        */
                        function updateWrapDetails(details, bitmask) { arrayEach(wrapFlags, function (pair) { var value = '_.' + pair[0]; if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                            details.push(value);
                        } }); return details.sort(); } /**
                        * Creates a clone of `wrapper`.
                        *
                        * @private
                        * @param {Object} wrapper The wrapper to clone.
                        * @returns {Object} Returns the cloned wrapper.
                        */
                        function wrapperClone(wrapper) { if (wrapper instanceof LazyWrapper) {
                            return wrapper.clone();
                        } var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__); result.__actions__ = copyArray(wrapper.__actions__); result.__index__ = wrapper.__index__; result.__values__ = wrapper.__values__; return result; } /*------------------------------------------------------------------------*/ /**
                        * Creates an array of elements split into groups the length of `size`.
                        * If `array` can't be split evenly, the final chunk will be the remaining
                        * elements.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to process.
                        * @param {number} [size=1] The length of each chunk
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the new array of chunks.
                        * @example
                        *
                        * _.chunk(['a', 'b', 'c', 'd'], 2);
                        * // => [['a', 'b'], ['c', 'd']]
                        *
                        * _.chunk(['a', 'b', 'c', 'd'], 3);
                        * // => [['a', 'b', 'c'], ['d']]
                        */
                        function chunk(array, size, guard) { if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
                            size = 1;
                        }
                        else {
                            size = nativeMax(toInteger(size), 0);
                        } var length = array == null ? 0 : array.length; if (!length || size < 1) {
                            return [];
                        } var index = 0, resIndex = 0, result = Array(nativeCeil(length / size)); while (index < length) {
                            result[resIndex++] = baseSlice(array, index, index += size);
                        } return result; } /**
                        * Creates an array with all falsey values removed. The values `false`, `null`,
                        * `0`, `""`, `undefined`, and `NaN` are falsey.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to compact.
                        * @returns {Array} Returns the new array of filtered values.
                        * @example
                        *
                        * _.compact([0, 1, false, 2, '', 3]);
                        * // => [1, 2, 3]
                        */
                        function compact(array) { var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; while (++index < length) {
                            var value = array[index];
                            if (value) {
                                result[resIndex++] = value;
                            }
                        } return result; } /**
                        * Creates a new array concatenating `array` with any additional arrays
                        * and/or values.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to concatenate.
                        * @param {...*} [values] The values to concatenate.
                        * @returns {Array} Returns the new concatenated array.
                        * @example
                        *
                        * var array = [1];
                        * var other = _.concat(array, 2, [3], [[4]]);
                        *
                        * console.log(other);
                        * // => [1, 2, 3, [4]]
                        *
                        * console.log(array);
                        * // => [1]
                        */
                        function concat() { var length = arguments.length; if (!length) {
                            return [];
                        } var args = Array(length - 1), array = arguments[0], index = length; while (index--) {
                            args[index - 1] = arguments[index];
                        } return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1)); } /**
                        * Creates an array of `array` values not included in the other given arrays
                        * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons. The order and references of result values are
                        * determined by the first array.
                        *
                        * **Note:** Unlike `_.pullAll`, this method returns a new array.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {...Array} [values] The values to exclude.
                        * @returns {Array} Returns the new array of filtered values.
                        * @see _.without, _.xor
                        * @example
                        *
                        * _.difference([2, 1], [2, 3]);
                        * // => [1]
                        */
                        var difference = baseRest(function (array, values) { return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : []; }); /**
                        * This method is like `_.difference` except that it accepts `iteratee` which
                        * is invoked for each element of `array` and `values` to generate the criterion
                        * by which they're compared. The order and references of result values are
                        * determined by the first array. The iteratee is invoked with one argument:
                        * (value).
                        *
                        * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {...Array} [values] The values to exclude.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns the new array of filtered values.
                        * @example
                        *
                        * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                        * // => [1.2]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
                        * // => [{ 'x': 2 }]
                        */
                        var differenceBy = baseRest(function (array, values) { var iteratee = last(values); if (isArrayLikeObject(iteratee)) {
                            iteratee = undefined;
                        } return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : []; }); /**
                        * This method is like `_.difference` except that it accepts `comparator`
                        * which is invoked to compare elements of `array` to `values`. The order and
                        * references of result values are determined by the first array. The comparator
                        * is invoked with two arguments: (arrVal, othVal).
                        *
                        * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {...Array} [values] The values to exclude.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of filtered values.
                        * @example
                        *
                        * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                        *
                        * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
                        * // => [{ 'x': 2, 'y': 1 }]
                        */
                        var differenceWith = baseRest(function (array, values) { var comparator = last(values); if (isArrayLikeObject(comparator)) {
                            comparator = undefined;
                        } return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : []; }); /**
                        * Creates a slice of `array` with `n` elements dropped from the beginning.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.5.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {number} [n=1] The number of elements to drop.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.drop([1, 2, 3]);
                        * // => [2, 3]
                        *
                        * _.drop([1, 2, 3], 2);
                        * // => [3]
                        *
                        * _.drop([1, 2, 3], 5);
                        * // => []
                        *
                        * _.drop([1, 2, 3], 0);
                        * // => [1, 2, 3]
                        */
                        function drop(array, n, guard) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } n = guard || n === undefined ? 1 : toInteger(n); return baseSlice(array, n < 0 ? 0 : n, length); } /**
                        * Creates a slice of `array` with `n` elements dropped from the end.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {number} [n=1] The number of elements to drop.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.dropRight([1, 2, 3]);
                        * // => [1, 2]
                        *
                        * _.dropRight([1, 2, 3], 2);
                        * // => [1]
                        *
                        * _.dropRight([1, 2, 3], 5);
                        * // => []
                        *
                        * _.dropRight([1, 2, 3], 0);
                        * // => [1, 2, 3]
                        */
                        function dropRight(array, n, guard) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } n = guard || n === undefined ? 1 : toInteger(n); n = length - n; return baseSlice(array, 0, n < 0 ? 0 : n); } /**
                        * Creates a slice of `array` excluding elements dropped from the end.
                        * Elements are dropped until `predicate` returns falsey. The predicate is
                        * invoked with three arguments: (value, index, array).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': true },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': false }
                        * ];
                        *
                        * _.dropRightWhile(users, function(o) { return !o.active; });
                        * // => objects for ['barney']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
                        * // => objects for ['barney', 'fred']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.dropRightWhile(users, ['active', false]);
                        * // => objects for ['barney']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.dropRightWhile(users, 'active');
                        * // => objects for ['barney', 'fred', 'pebbles']
                        */
                        function dropRightWhile(array, predicate) { return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : []; } /**
                        * Creates a slice of `array` excluding elements dropped from the beginning.
                        * Elements are dropped until `predicate` returns falsey. The predicate is
                        * invoked with three arguments: (value, index, array).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': false },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': true }
                        * ];
                        *
                        * _.dropWhile(users, function(o) { return !o.active; });
                        * // => objects for ['pebbles']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.dropWhile(users, { 'user': 'barney', 'active': false });
                        * // => objects for ['fred', 'pebbles']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.dropWhile(users, ['active', false]);
                        * // => objects for ['pebbles']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.dropWhile(users, 'active');
                        * // => objects for ['barney', 'fred', 'pebbles']
                        */
                        function dropWhile(array, predicate) { return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : []; } /**
                        * Fills elements of `array` with `value` from `start` up to, but not
                        * including, `end`.
                        *
                        * **Note:** This method mutates `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.2.0
                        * @category Array
                        * @param {Array} array The array to fill.
                        * @param {*} value The value to fill `array` with.
                        * @param {number} [start=0] The start position.
                        * @param {number} [end=array.length] The end position.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = [1, 2, 3];
                        *
                        * _.fill(array, 'a');
                        * console.log(array);
                        * // => ['a', 'a', 'a']
                        *
                        * _.fill(Array(3), 2);
                        * // => [2, 2, 2]
                        *
                        * _.fill([4, 6, 8, 10], '*', 1, 3);
                        * // => [4, '*', '*', 10]
                        */
                        function fill(array, value, start, end) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                            start = 0;
                            end = length;
                        } return baseFill(array, value, start, end); } /**
                        * This method is like `_.find` except that it returns the index of the first
                        * element `predicate` returns truthy for instead of the element itself.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param {number} [fromIndex=0] The index to search from.
                        * @returns {number} Returns the index of the found element, else `-1`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': false },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': true }
                        * ];
                        *
                        * _.findIndex(users, function(o) { return o.user == 'barney'; });
                        * // => 0
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.findIndex(users, { 'user': 'fred', 'active': false });
                        * // => 1
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.findIndex(users, ['active', false]);
                        * // => 0
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.findIndex(users, 'active');
                        * // => 2
                        */
                        function findIndex(array, predicate, fromIndex) { var length = array == null ? 0 : array.length; if (!length) {
                            return -1;
                        } var index = fromIndex == null ? 0 : toInteger(fromIndex); if (index < 0) {
                            index = nativeMax(length + index, 0);
                        } return baseFindIndex(array, getIteratee(predicate, 3), index); } /**
                        * This method is like `_.findIndex` except that it iterates over elements
                        * of `collection` from right to left.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param {number} [fromIndex=array.length-1] The index to search from.
                        * @returns {number} Returns the index of the found element, else `-1`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': true },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': false }
                        * ];
                        *
                        * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
                        * // => 2
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.findLastIndex(users, { 'user': 'barney', 'active': true });
                        * // => 0
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.findLastIndex(users, ['active', false]);
                        * // => 2
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.findLastIndex(users, 'active');
                        * // => 0
                        */
                        function findLastIndex(array, predicate, fromIndex) { var length = array == null ? 0 : array.length; if (!length) {
                            return -1;
                        } var index = length - 1; if (fromIndex !== undefined) {
                            index = toInteger(fromIndex);
                            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                        } return baseFindIndex(array, getIteratee(predicate, 3), index, true); } /**
                        * Flattens `array` a single level deep.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to flatten.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * _.flatten([1, [2, [3, [4]], 5]]);
                        * // => [1, 2, [3, [4]], 5]
                        */
                        function flatten(array) { var length = array == null ? 0 : array.length; return length ? baseFlatten(array, 1) : []; } /**
                        * Recursively flattens `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to flatten.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * _.flattenDeep([1, [2, [3, [4]], 5]]);
                        * // => [1, 2, 3, 4, 5]
                        */
                        function flattenDeep(array) { var length = array == null ? 0 : array.length; return length ? baseFlatten(array, INFINITY) : []; } /**
                        * Recursively flatten `array` up to `depth` times.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.4.0
                        * @category Array
                        * @param {Array} array The array to flatten.
                        * @param {number} [depth=1] The maximum recursion depth.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * var array = [1, [2, [3, [4]], 5]];
                        *
                        * _.flattenDepth(array, 1);
                        * // => [1, 2, [3, [4]], 5]
                        *
                        * _.flattenDepth(array, 2);
                        * // => [1, 2, 3, [4], 5]
                        */
                        function flattenDepth(array, depth) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } depth = depth === undefined ? 1 : toInteger(depth); return baseFlatten(array, depth); } /**
                        * The inverse of `_.toPairs`; this method returns an object composed
                        * from key-value `pairs`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} pairs The key-value pairs.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * _.fromPairs([['a', 1], ['b', 2]]);
                        * // => { 'a': 1, 'b': 2 }
                        */
                        function fromPairs(pairs) { var index = -1, length = pairs == null ? 0 : pairs.length, result = {}; while (++index < length) {
                            var pair = pairs[index];
                            result[pair[0]] = pair[1];
                        } return result; } /**
                        * Gets the first element of `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @alias first
                        * @category Array
                        * @param {Array} array The array to query.
                        * @returns {*} Returns the first element of `array`.
                        * @example
                        *
                        * _.head([1, 2, 3]);
                        * // => 1
                        *
                        * _.head([]);
                        * // => undefined
                        */
                        function head(array) { return array && array.length ? array[0] : undefined; } /**
                        * Gets the index at which the first occurrence of `value` is found in `array`
                        * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons. If `fromIndex` is negative, it's used as the
                        * offset from the end of `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {*} value The value to search for.
                        * @param {number} [fromIndex=0] The index to search from.
                        * @returns {number} Returns the index of the matched value, else `-1`.
                        * @example
                        *
                        * _.indexOf([1, 2, 1, 2], 2);
                        * // => 1
                        *
                        * // Search from the `fromIndex`.
                        * _.indexOf([1, 2, 1, 2], 2, 2);
                        * // => 3
                        */
                        function indexOf(array, value, fromIndex) { var length = array == null ? 0 : array.length; if (!length) {
                            return -1;
                        } var index = fromIndex == null ? 0 : toInteger(fromIndex); if (index < 0) {
                            index = nativeMax(length + index, 0);
                        } return baseIndexOf(array, value, index); } /**
                        * Gets all but the last element of `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.initial([1, 2, 3]);
                        * // => [1, 2]
                        */
                        function initial(array) { var length = array == null ? 0 : array.length; return length ? baseSlice(array, 0, -1) : []; } /**
                        * Creates an array of unique values that are included in all given arrays
                        * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons. The order and references of result values are
                        * determined by the first array.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @returns {Array} Returns the new array of intersecting values.
                        * @example
                        *
                        * _.intersection([2, 1], [2, 3]);
                        * // => [2]
                        */
                        var intersection = baseRest(function (arrays) { var mapped = arrayMap(arrays, castArrayLikeObject); return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : []; }); /**
                        * This method is like `_.intersection` except that it accepts `iteratee`
                        * which is invoked for each element of each `arrays` to generate the criterion
                        * by which they're compared. The order and references of result values are
                        * determined by the first array. The iteratee is invoked with one argument:
                        * (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns the new array of intersecting values.
                        * @example
                        *
                        * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                        * // => [2.1]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                        * // => [{ 'x': 1 }]
                        */
                        var intersectionBy = baseRest(function (arrays) { var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject); if (iteratee === last(mapped)) {
                            iteratee = undefined;
                        }
                        else {
                            mapped.pop();
                        } return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : []; }); /**
                        * This method is like `_.intersection` except that it accepts `comparator`
                        * which is invoked to compare elements of `arrays`. The order and references
                        * of result values are determined by the first array. The comparator is
                        * invoked with two arguments: (arrVal, othVal).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of intersecting values.
                        * @example
                        *
                        * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                        * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                        *
                        * _.intersectionWith(objects, others, _.isEqual);
                        * // => [{ 'x': 1, 'y': 2 }]
                        */
                        var intersectionWith = baseRest(function (arrays) { var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject); comparator = typeof comparator == 'function' ? comparator : undefined; if (comparator) {
                            mapped.pop();
                        } return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : []; }); /**
                        * Converts all elements in `array` into a string separated by `separator`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to convert.
                        * @param {string} [separator=','] The element separator.
                        * @returns {string} Returns the joined string.
                        * @example
                        *
                        * _.join(['a', 'b', 'c'], '~');
                        * // => 'a~b~c'
                        */
                        function join(array, separator) { return array == null ? '' : nativeJoin.call(array, separator); } /**
                        * Gets the last element of `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @returns {*} Returns the last element of `array`.
                        * @example
                        *
                        * _.last([1, 2, 3]);
                        * // => 3
                        */
                        function last(array) { var length = array == null ? 0 : array.length; return length ? array[length - 1] : undefined; } /**
                        * This method is like `_.indexOf` except that it iterates over elements of
                        * `array` from right to left.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {*} value The value to search for.
                        * @param {number} [fromIndex=array.length-1] The index to search from.
                        * @returns {number} Returns the index of the matched value, else `-1`.
                        * @example
                        *
                        * _.lastIndexOf([1, 2, 1, 2], 2);
                        * // => 3
                        *
                        * // Search from the `fromIndex`.
                        * _.lastIndexOf([1, 2, 1, 2], 2, 2);
                        * // => 1
                        */
                        function lastIndexOf(array, value, fromIndex) { var length = array == null ? 0 : array.length; if (!length) {
                            return -1;
                        } var index = length; if (fromIndex !== undefined) {
                            index = toInteger(fromIndex);
                            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                        } return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true); } /**
                        * Gets the element at index `n` of `array`. If `n` is negative, the nth
                        * element from the end is returned.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.11.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {number} [n=0] The index of the element to return.
                        * @returns {*} Returns the nth element of `array`.
                        * @example
                        *
                        * var array = ['a', 'b', 'c', 'd'];
                        *
                        * _.nth(array, 1);
                        * // => 'b'
                        *
                        * _.nth(array, -2);
                        * // => 'c';
                        */
                        function nth(array, n) { return array && array.length ? baseNth(array, toInteger(n)) : undefined; } /**
                        * Removes all given values from `array` using
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons.
                        *
                        * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
                        * to remove elements from an array by predicate.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {...*} [values] The values to remove.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
                        *
                        * _.pull(array, 'a', 'c');
                        * console.log(array);
                        * // => ['b', 'b']
                        */
                        var pull = baseRest(pullAll); /**
                        * This method is like `_.pull` except that it accepts an array of values to remove.
                        *
                        * **Note:** Unlike `_.difference`, this method mutates `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {Array} values The values to remove.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
                        *
                        * _.pullAll(array, ['a', 'c']);
                        * console.log(array);
                        * // => ['b', 'b']
                        */
                        function pullAll(array, values) { return array && array.length && values && values.length ? basePullAll(array, values) : array; } /**
                        * This method is like `_.pullAll` except that it accepts `iteratee` which is
                        * invoked for each element of `array` and `values` to generate the criterion
                        * by which they're compared. The iteratee is invoked with one argument: (value).
                        *
                        * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {Array} values The values to remove.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
                        *
                        * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
                        * console.log(array);
                        * // => [{ 'x': 2 }]
                        */
                        function pullAllBy(array, values, iteratee) { return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array; } /**
                        * This method is like `_.pullAll` except that it accepts `comparator` which
                        * is invoked to compare elements of `array` to `values`. The comparator is
                        * invoked with two arguments: (arrVal, othVal).
                        *
                        * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.6.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {Array} values The values to remove.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
                        *
                        * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
                        * console.log(array);
                        * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
                        */
                        function pullAllWith(array, values, comparator) { return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array; } /**
                        * Removes elements from `array` corresponding to `indexes` and returns an
                        * array of removed elements.
                        *
                        * **Note:** Unlike `_.at`, this method mutates `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {...(number|number[])} [indexes] The indexes of elements to remove.
                        * @returns {Array} Returns the new array of removed elements.
                        * @example
                        *
                        * var array = ['a', 'b', 'c', 'd'];
                        * var pulled = _.pullAt(array, [1, 3]);
                        *
                        * console.log(array);
                        * // => ['a', 'c']
                        *
                        * console.log(pulled);
                        * // => ['b', 'd']
                        */
                        var pullAt = flatRest(function (array, indexes) { var length = array == null ? 0 : array.length, result = baseAt(array, indexes); basePullAt(array, arrayMap(indexes, function (index) { return isIndex(index, length) ? +index : index; }).sort(compareAscending)); return result; }); /**
                        * Removes all elements from `array` that `predicate` returns truthy for
                        * and returns an array of the removed elements. The predicate is invoked
                        * with three arguments: (value, index, array).
                        *
                        * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
                        * to pull elements from an array by value.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new array of removed elements.
                        * @example
                        *
                        * var array = [1, 2, 3, 4];
                        * var evens = _.remove(array, function(n) {
                        *   return n % 2 == 0;
                        * });
                        *
                        * console.log(array);
                        * // => [1, 3]
                        *
                        * console.log(evens);
                        * // => [2, 4]
                        */
                        function remove(array, predicate) { var result = []; if (!(array && array.length)) {
                            return result;
                        } var index = -1, indexes = [], length = array.length; predicate = getIteratee(predicate, 3); while (++index < length) {
                            var value = array[index];
                            if (predicate(value, index, array)) {
                                result.push(value);
                                indexes.push(index);
                            }
                        } basePullAt(array, indexes); return result; } /**
                        * Reverses `array` so that the first element becomes the last, the second
                        * element becomes the second to last, and so on.
                        *
                        * **Note:** This method mutates `array` and is based on
                        * [`Array#reverse`](https://mdn.io/Array/reverse).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to modify.
                        * @returns {Array} Returns `array`.
                        * @example
                        *
                        * var array = [1, 2, 3];
                        *
                        * _.reverse(array);
                        * // => [3, 2, 1]
                        *
                        * console.log(array);
                        * // => [3, 2, 1]
                        */
                        function reverse(array) { return array == null ? array : nativeReverse.call(array); } /**
                        * Creates a slice of `array` from `start` up to, but not including, `end`.
                        *
                        * **Note:** This method is used instead of
                        * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
                        * returned.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to slice.
                        * @param {number} [start=0] The start position.
                        * @param {number} [end=array.length] The end position.
                        * @returns {Array} Returns the slice of `array`.
                        */
                        function slice(array, start, end) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                            start = 0;
                            end = length;
                        }
                        else {
                            start = start == null ? 0 : toInteger(start);
                            end = end === undefined ? length : toInteger(end);
                        } return baseSlice(array, start, end); } /**
                        * Uses a binary search to determine the lowest index at which `value`
                        * should be inserted into `array` in order to maintain its sort order.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        * @example
                        *
                        * _.sortedIndex([30, 50], 40);
                        * // => 1
                        */
                        function sortedIndex(array, value) { return baseSortedIndex(array, value); } /**
                        * This method is like `_.sortedIndex` except that it accepts `iteratee`
                        * which is invoked for `value` and each element of `array` to compute their
                        * sort ranking. The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        * @example
                        *
                        * var objects = [{ 'x': 4 }, { 'x': 5 }];
                        *
                        * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
                        * // => 0
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
                        * // => 0
                        */
                        function sortedIndexBy(array, value, iteratee) { return baseSortedIndexBy(array, value, getIteratee(iteratee, 2)); } /**
                        * This method is like `_.indexOf` except that it performs a binary
                        * search on a sorted `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {*} value The value to search for.
                        * @returns {number} Returns the index of the matched value, else `-1`.
                        * @example
                        *
                        * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
                        * // => 1
                        */
                        function sortedIndexOf(array, value) { var length = array == null ? 0 : array.length; if (length) {
                            var index = baseSortedIndex(array, value);
                            if (index < length && eq(array[index], value)) {
                                return index;
                            }
                        } return -1; } /**
                        * This method is like `_.sortedIndex` except that it returns the highest
                        * index at which `value` should be inserted into `array` in order to
                        * maintain its sort order.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        * @example
                        *
                        * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
                        * // => 4
                        */
                        function sortedLastIndex(array, value) { return baseSortedIndex(array, value, true); } /**
                        * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
                        * which is invoked for `value` and each element of `array` to compute their
                        * sort ranking. The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The sorted array to inspect.
                        * @param {*} value The value to evaluate.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {number} Returns the index at which `value` should be inserted
                        *  into `array`.
                        * @example
                        *
                        * var objects = [{ 'x': 4 }, { 'x': 5 }];
                        *
                        * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
                        * // => 1
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
                        * // => 1
                        */
                        function sortedLastIndexBy(array, value, iteratee) { return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true); } /**
                        * This method is like `_.lastIndexOf` except that it performs a binary
                        * search on a sorted `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {*} value The value to search for.
                        * @returns {number} Returns the index of the matched value, else `-1`.
                        * @example
                        *
                        * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
                        * // => 3
                        */
                        function sortedLastIndexOf(array, value) { var length = array == null ? 0 : array.length; if (length) {
                            var index = baseSortedIndex(array, value, true) - 1;
                            if (eq(array[index], value)) {
                                return index;
                            }
                        } return -1; } /**
                        * This method is like `_.uniq` except that it's designed and optimized
                        * for sorted arrays.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @returns {Array} Returns the new duplicate free array.
                        * @example
                        *
                        * _.sortedUniq([1, 1, 2]);
                        * // => [1, 2]
                        */
                        function sortedUniq(array) { return array && array.length ? baseSortedUniq(array) : []; } /**
                        * This method is like `_.uniqBy` except that it's designed and optimized
                        * for sorted arrays.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {Function} [iteratee] The iteratee invoked per element.
                        * @returns {Array} Returns the new duplicate free array.
                        * @example
                        *
                        * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
                        * // => [1.1, 2.3]
                        */
                        function sortedUniqBy(array, iteratee) { return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : []; } /**
                        * Gets all but the first element of `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.tail([1, 2, 3]);
                        * // => [2, 3]
                        */
                        function tail(array) { var length = array == null ? 0 : array.length; return length ? baseSlice(array, 1, length) : []; } /**
                        * Creates a slice of `array` with `n` elements taken from the beginning.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {number} [n=1] The number of elements to take.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.take([1, 2, 3]);
                        * // => [1]
                        *
                        * _.take([1, 2, 3], 2);
                        * // => [1, 2]
                        *
                        * _.take([1, 2, 3], 5);
                        * // => [1, 2, 3]
                        *
                        * _.take([1, 2, 3], 0);
                        * // => []
                        */
                        function take(array, n, guard) { if (!(array && array.length)) {
                            return [];
                        } n = guard || n === undefined ? 1 : toInteger(n); return baseSlice(array, 0, n < 0 ? 0 : n); } /**
                        * Creates a slice of `array` with `n` elements taken from the end.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {number} [n=1] The number of elements to take.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * _.takeRight([1, 2, 3]);
                        * // => [3]
                        *
                        * _.takeRight([1, 2, 3], 2);
                        * // => [2, 3]
                        *
                        * _.takeRight([1, 2, 3], 5);
                        * // => [1, 2, 3]
                        *
                        * _.takeRight([1, 2, 3], 0);
                        * // => []
                        */
                        function takeRight(array, n, guard) { var length = array == null ? 0 : array.length; if (!length) {
                            return [];
                        } n = guard || n === undefined ? 1 : toInteger(n); n = length - n; return baseSlice(array, n < 0 ? 0 : n, length); } /**
                        * Creates a slice of `array` with elements taken from the end. Elements are
                        * taken until `predicate` returns falsey. The predicate is invoked with
                        * three arguments: (value, index, array).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': true },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': false }
                        * ];
                        *
                        * _.takeRightWhile(users, function(o) { return !o.active; });
                        * // => objects for ['fred', 'pebbles']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
                        * // => objects for ['pebbles']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.takeRightWhile(users, ['active', false]);
                        * // => objects for ['fred', 'pebbles']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.takeRightWhile(users, 'active');
                        * // => []
                        */
                        function takeRightWhile(array, predicate) { return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : []; } /**
                        * Creates a slice of `array` with elements taken from the beginning. Elements
                        * are taken until `predicate` returns falsey. The predicate is invoked with
                        * three arguments: (value, index, array).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Array
                        * @param {Array} array The array to query.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the slice of `array`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'active': false },
                        *   { 'user': 'fred',    'active': false },
                        *   { 'user': 'pebbles', 'active': true }
                        * ];
                        *
                        * _.takeWhile(users, function(o) { return !o.active; });
                        * // => objects for ['barney', 'fred']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.takeWhile(users, { 'user': 'barney', 'active': false });
                        * // => objects for ['barney']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.takeWhile(users, ['active', false]);
                        * // => objects for ['barney', 'fred']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.takeWhile(users, 'active');
                        * // => []
                        */
                        function takeWhile(array, predicate) { return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : []; } /**
                        * Creates an array of unique values, in order, from all given arrays using
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @returns {Array} Returns the new array of combined values.
                        * @example
                        *
                        * _.union([2], [1, 2]);
                        * // => [2, 1]
                        */
                        var union = baseRest(function (arrays) { return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true)); }); /**
                        * This method is like `_.union` except that it accepts `iteratee` which is
                        * invoked for each element of each `arrays` to generate the criterion by
                        * which uniqueness is computed. Result values are chosen from the first
                        * array in which the value occurs. The iteratee is invoked with one argument:
                        * (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns the new array of combined values.
                        * @example
                        *
                        * _.unionBy([2.1], [1.2, 2.3], Math.floor);
                        * // => [2.1, 1.2]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                        * // => [{ 'x': 1 }, { 'x': 2 }]
                        */
                        var unionBy = baseRest(function (arrays) { var iteratee = last(arrays); if (isArrayLikeObject(iteratee)) {
                            iteratee = undefined;
                        } return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)); }); /**
                        * This method is like `_.union` except that it accepts `comparator` which
                        * is invoked to compare elements of `arrays`. Result values are chosen from
                        * the first array in which the value occurs. The comparator is invoked
                        * with two arguments: (arrVal, othVal).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of combined values.
                        * @example
                        *
                        * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                        * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                        *
                        * _.unionWith(objects, others, _.isEqual);
                        * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
                        */
                        var unionWith = baseRest(function (arrays) { var comparator = last(arrays); comparator = typeof comparator == 'function' ? comparator : undefined; return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator); }); /**
                        * Creates a duplicate-free version of an array, using
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons, in which only the first occurrence of each element
                        * is kept. The order of result values is determined by the order they occur
                        * in the array.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @returns {Array} Returns the new duplicate free array.
                        * @example
                        *
                        * _.uniq([2, 1, 2]);
                        * // => [2, 1]
                        */
                        function uniq(array) { return array && array.length ? baseUniq(array) : []; } /**
                        * This method is like `_.uniq` except that it accepts `iteratee` which is
                        * invoked for each element in `array` to generate the criterion by which
                        * uniqueness is computed. The order of result values is determined by the
                        * order they occur in the array. The iteratee is invoked with one argument:
                        * (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns the new duplicate free array.
                        * @example
                        *
                        * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
                        * // => [2.1, 1.2]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
                        * // => [{ 'x': 1 }, { 'x': 2 }]
                        */
                        function uniqBy(array, iteratee) { return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : []; } /**
                        * This method is like `_.uniq` except that it accepts `comparator` which
                        * is invoked to compare elements of `array`. The order of result values is
                        * determined by the order they occur in the array.The comparator is invoked
                        * with two arguments: (arrVal, othVal).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new duplicate free array.
                        * @example
                        *
                        * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
                        *
                        * _.uniqWith(objects, _.isEqual);
                        * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
                        */
                        function uniqWith(array, comparator) { comparator = typeof comparator == 'function' ? comparator : undefined; return array && array.length ? baseUniq(array, undefined, comparator) : []; } /**
                        * This method is like `_.zip` except that it accepts an array of grouped
                        * elements and creates an array regrouping the elements to their pre-zip
                        * configuration.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.2.0
                        * @category Array
                        * @param {Array} array The array of grouped elements to process.
                        * @returns {Array} Returns the new array of regrouped elements.
                        * @example
                        *
                        * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
                        * // => [['a', 1, true], ['b', 2, false]]
                        *
                        * _.unzip(zipped);
                        * // => [['a', 'b'], [1, 2], [true, false]]
                        */
                        function unzip(array) { if (!(array && array.length)) {
                            return [];
                        } var length = 0; array = arrayFilter(array, function (group) { if (isArrayLikeObject(group)) {
                            length = nativeMax(group.length, length);
                            return true;
                        } }); return baseTimes(length, function (index) { return arrayMap(array, baseProperty(index)); }); } /**
                        * This method is like `_.unzip` except that it accepts `iteratee` to specify
                        * how regrouped values should be combined. The iteratee is invoked with the
                        * elements of each group: (...group).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.8.0
                        * @category Array
                        * @param {Array} array The array of grouped elements to process.
                        * @param {Function} [iteratee=_.identity] The function to combine
                        *  regrouped values.
                        * @returns {Array} Returns the new array of regrouped elements.
                        * @example
                        *
                        * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
                        * // => [[1, 10, 100], [2, 20, 200]]
                        *
                        * _.unzipWith(zipped, _.add);
                        * // => [3, 30, 300]
                        */
                        function unzipWith(array, iteratee) { if (!(array && array.length)) {
                            return [];
                        } var result = unzip(array); if (iteratee == null) {
                            return result;
                        } return arrayMap(result, function (group) { return apply(iteratee, undefined, group); }); } /**
                        * Creates an array excluding all given values using
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * for equality comparisons.
                        *
                        * **Note:** Unlike `_.pull`, this method returns a new array.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {Array} array The array to inspect.
                        * @param {...*} [values] The values to exclude.
                        * @returns {Array} Returns the new array of filtered values.
                        * @see _.difference, _.xor
                        * @example
                        *
                        * _.without([2, 1, 2, 3], 1, 2);
                        * // => [3]
                        */
                        var without = baseRest(function (array, values) { return isArrayLikeObject(array) ? baseDifference(array, values) : []; }); /**
                        * Creates an array of unique values that is the
                        * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
                        * of the given arrays. The order of result values is determined by the order
                        * they occur in the arrays.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.4.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @returns {Array} Returns the new array of filtered values.
                        * @see _.difference, _.without
                        * @example
                        *
                        * _.xor([2, 1], [2, 3]);
                        * // => [1, 3]
                        */
                        var xor = baseRest(function (arrays) { return baseXor(arrayFilter(arrays, isArrayLikeObject)); }); /**
                        * This method is like `_.xor` except that it accepts `iteratee` which is
                        * invoked for each element of each `arrays` to generate the criterion by
                        * which by which they're compared. The order of result values is determined
                        * by the order they occur in the arrays. The iteratee is invoked with one
                        * argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Array} Returns the new array of filtered values.
                        * @example
                        *
                        * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
                        * // => [1.2, 3.4]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
                        * // => [{ 'x': 2 }]
                        */
                        var xorBy = baseRest(function (arrays) { var iteratee = last(arrays); if (isArrayLikeObject(iteratee)) {
                            iteratee = undefined;
                        } return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2)); }); /**
                        * This method is like `_.xor` except that it accepts `comparator` which is
                        * invoked to compare elements of `arrays`. The order of result values is
                        * determined by the order they occur in the arrays. The comparator is invoked
                        * with two arguments: (arrVal, othVal).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to inspect.
                        * @param {Function} [comparator] The comparator invoked per element.
                        * @returns {Array} Returns the new array of filtered values.
                        * @example
                        *
                        * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
                        * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
                        *
                        * _.xorWith(objects, others, _.isEqual);
                        * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
                        */
                        var xorWith = baseRest(function (arrays) { var comparator = last(arrays); comparator = typeof comparator == 'function' ? comparator : undefined; return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator); }); /**
                        * Creates an array of grouped elements, the first of which contains the
                        * first elements of the given arrays, the second of which contains the
                        * second elements of the given arrays, and so on.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to process.
                        * @returns {Array} Returns the new array of grouped elements.
                        * @example
                        *
                        * _.zip(['a', 'b'], [1, 2], [true, false]);
                        * // => [['a', 1, true], ['b', 2, false]]
                        */
                        var zip = baseRest(unzip); /**
                        * This method is like `_.fromPairs` except that it accepts two arrays,
                        * one of property identifiers and one of corresponding values.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.4.0
                        * @category Array
                        * @param {Array} [props=[]] The property identifiers.
                        * @param {Array} [values=[]] The property values.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * _.zipObject(['a', 'b'], [1, 2]);
                        * // => { 'a': 1, 'b': 2 }
                        */
                        function zipObject(props, values) { return baseZipObject(props || [], values || [], assignValue); } /**
                        * This method is like `_.zipObject` except that it supports property paths.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.1.0
                        * @category Array
                        * @param {Array} [props=[]] The property identifiers.
                        * @param {Array} [values=[]] The property values.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
                        * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
                        */
                        function zipObjectDeep(props, values) { return baseZipObject(props || [], values || [], baseSet); } /**
                        * This method is like `_.zip` except that it accepts `iteratee` to specify
                        * how grouped values should be combined. The iteratee is invoked with the
                        * elements of each group: (...group).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.8.0
                        * @category Array
                        * @param {...Array} [arrays] The arrays to process.
                        * @param {Function} [iteratee=_.identity] The function to combine
                        *  grouped values.
                        * @returns {Array} Returns the new array of grouped elements.
                        * @example
                        *
                        * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
                        *   return a + b + c;
                        * });
                        * // => [111, 222]
                        */
                        var zipWith = baseRest(function (arrays) { var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined; iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined; return unzipWith(arrays, iteratee); }); /*------------------------------------------------------------------------*/ /**
                        * Creates a `lodash` wrapper instance that wraps `value` with explicit method
                        * chain sequences enabled. The result of such sequences must be unwrapped
                        * with `_#value`.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.3.0
                        * @category Seq
                        * @param {*} value The value to wrap.
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'age': 36 },
                        *   { 'user': 'fred',    'age': 40 },
                        *   { 'user': 'pebbles', 'age': 1 }
                        * ];
                        *
                        * var youngest = _
                        *   .chain(users)
                        *   .sortBy('age')
                        *   .map(function(o) {
                        *     return o.user + ' is ' + o.age;
                        *   })
                        *   .head()
                        *   .value();
                        * // => 'pebbles is 1'
                        */
                        function chain(value) { var result = lodash(value); result.__chain__ = true; return result; } /**
                        * This method invokes `interceptor` and returns `value`. The interceptor
                        * is invoked with one argument; (value). The purpose of this method is to
                        * "tap into" a method chain sequence in order to modify intermediate results.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Seq
                        * @param {*} value The value to provide to `interceptor`.
                        * @param {Function} interceptor The function to invoke.
                        * @returns {*} Returns `value`.
                        * @example
                        *
                        * _([1, 2, 3])
                        *  .tap(function(array) {
                        *    // Mutate input array.
                        *    array.pop();
                        *  })
                        *  .reverse()
                        *  .value();
                        * // => [2, 1]
                        */
                        function tap(value, interceptor) { interceptor(value); return value; } /**
                        * This method is like `_.tap` except that it returns the result of `interceptor`.
                        * The purpose of this method is to "pass thru" values replacing intermediate
                        * results in a method chain sequence.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Seq
                        * @param {*} value The value to provide to `interceptor`.
                        * @param {Function} interceptor The function to invoke.
                        * @returns {*} Returns the result of `interceptor`.
                        * @example
                        *
                        * _('  abc  ')
                        *  .chain()
                        *  .trim()
                        *  .thru(function(value) {
                        *    return [value];
                        *  })
                        *  .value();
                        * // => ['abc']
                        */
                        function thru(value, interceptor) { return interceptor(value); } /**
                        * This method is the wrapper version of `_.at`.
                        *
                        * @name at
                        * @memberOf _
                        * @since 1.0.0
                        * @category Seq
                        * @param {...(string|string[])} [paths] The property paths to pick.
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
                        *
                        * _(object).at(['a[0].b.c', 'a[1]']).value();
                        * // => [3, 4]
                        */
                        var wrapperAt = flatRest(function (paths) { var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) { return baseAt(object, paths); }; if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
                            return this.thru(interceptor);
                        } value = value.slice(start, +start + (length ? 1 : 0)); value.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined }); return new LodashWrapper(value, this.__chain__).thru(function (array) { if (length && !array.length) {
                            array.push(undefined);
                        } return array; }); }); /**
                        * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
                        *
                        * @name chain
                        * @memberOf _
                        * @since 0.1.0
                        * @category Seq
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney', 'age': 36 },
                        *   { 'user': 'fred',   'age': 40 }
                        * ];
                        *
                        * // A sequence without explicit chaining.
                        * _(users).head();
                        * // => { 'user': 'barney', 'age': 36 }
                        *
                        * // A sequence with explicit chaining.
                        * _(users)
                        *   .chain()
                        *   .head()
                        *   .pick('user')
                        *   .value();
                        * // => { 'user': 'barney' }
                        */
                        function wrapperChain() { return chain(this); } /**
                        * Executes the chain sequence and returns the wrapped result.
                        *
                        * @name commit
                        * @memberOf _
                        * @since 3.2.0
                        * @category Seq
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * var array = [1, 2];
                        * var wrapped = _(array).push(3);
                        *
                        * console.log(array);
                        * // => [1, 2]
                        *
                        * wrapped = wrapped.commit();
                        * console.log(array);
                        * // => [1, 2, 3]
                        *
                        * wrapped.last();
                        * // => 3
                        *
                        * console.log(array);
                        * // => [1, 2, 3]
                        */
                        function wrapperCommit() { return new LodashWrapper(this.value(), this.__chain__); } /**
                        * Gets the next value on a wrapped object following the
                        * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
                        *
                        * @name next
                        * @memberOf _
                        * @since 4.0.0
                        * @category Seq
                        * @returns {Object} Returns the next iterator value.
                        * @example
                        *
                        * var wrapped = _([1, 2]);
                        *
                        * wrapped.next();
                        * // => { 'done': false, 'value': 1 }
                        *
                        * wrapped.next();
                        * // => { 'done': false, 'value': 2 }
                        *
                        * wrapped.next();
                        * // => { 'done': true, 'value': undefined }
                        */
                        function wrapperNext() { if (this.__values__ === undefined) {
                            this.__values__ = toArray(this.value());
                        } var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++]; return { 'done': done, 'value': value }; } /**
                        * Enables the wrapper to be iterable.
                        *
                        * @name Symbol.iterator
                        * @memberOf _
                        * @since 4.0.0
                        * @category Seq
                        * @returns {Object} Returns the wrapper object.
                        * @example
                        *
                        * var wrapped = _([1, 2]);
                        *
                        * wrapped[Symbol.iterator]() === wrapped;
                        * // => true
                        *
                        * Array.from(wrapped);
                        * // => [1, 2]
                        */
                        function wrapperToIterator() { return this; } /**
                        * Creates a clone of the chain sequence planting `value` as the wrapped value.
                        *
                        * @name plant
                        * @memberOf _
                        * @since 3.2.0
                        * @category Seq
                        * @param {*} value The value to plant.
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * var wrapped = _([1, 2]).map(square);
                        * var other = wrapped.plant([3, 4]);
                        *
                        * other.value();
                        * // => [9, 16]
                        *
                        * wrapped.value();
                        * // => [1, 4]
                        */
                        function wrapperPlant(value) { var result, parent = this; while (parent instanceof baseLodash) {
                            var clone = wrapperClone(parent);
                            clone.__index__ = 0;
                            clone.__values__ = undefined;
                            if (result) {
                                previous.__wrapped__ = clone;
                            }
                            else {
                                result = clone;
                            }
                            var previous = clone;
                            parent = parent.__wrapped__;
                        } previous.__wrapped__ = value; return result; } /**
                        * This method is the wrapper version of `_.reverse`.
                        *
                        * **Note:** This method mutates the wrapped array.
                        *
                        * @name reverse
                        * @memberOf _
                        * @since 0.1.0
                        * @category Seq
                        * @returns {Object} Returns the new `lodash` wrapper instance.
                        * @example
                        *
                        * var array = [1, 2, 3];
                        *
                        * _(array).reverse().value()
                        * // => [3, 2, 1]
                        *
                        * console.log(array);
                        * // => [3, 2, 1]
                        */
                        function wrapperReverse() { var value = this.__wrapped__; if (value instanceof LazyWrapper) {
                            var wrapped = value;
                            if (this.__actions__.length) {
                                wrapped = new LazyWrapper(this);
                            }
                            wrapped = wrapped.reverse();
                            wrapped.__actions__.push({ 'func': thru, 'args': [reverse], 'thisArg': undefined });
                            return new LodashWrapper(wrapped, this.__chain__);
                        } return this.thru(reverse); } /**
                        * Executes the chain sequence to resolve the unwrapped value.
                        *
                        * @name value
                        * @memberOf _
                        * @since 0.1.0
                        * @alias toJSON, valueOf
                        * @category Seq
                        * @returns {*} Returns the resolved unwrapped value.
                        * @example
                        *
                        * _([1, 2, 3]).value();
                        * // => [1, 2, 3]
                        */
                        function wrapperValue() { return baseWrapperValue(this.__wrapped__, this.__actions__); } /*------------------------------------------------------------------------*/ /**
                        * Creates an object composed of keys generated from the results of running
                        * each element of `collection` thru `iteratee`. The corresponding value of
                        * each key is the number of times the key was returned by `iteratee`. The
                        * iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.5.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                        * @returns {Object} Returns the composed aggregate object.
                        * @example
                        *
                        * _.countBy([6.1, 4.2, 6.3], Math.floor);
                        * // => { '4': 1, '6': 2 }
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.countBy(['one', 'two', 'three'], 'length');
                        * // => { '3': 2, '5': 1 }
                        */
                        var countBy = createAggregator(function (result, value, key) { if (hasOwnProperty.call(result, key)) {
                            ++result[key];
                        }
                        else {
                            baseAssignValue(result, key, 1);
                        } }); /**
                        * Checks if `predicate` returns truthy for **all** elements of `collection`.
                        * Iteration is stopped once `predicate` returns falsey. The predicate is
                        * invoked with three arguments: (value, index|key, collection).
                        *
                        * **Note:** This method returns `true` for
                        * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
                        * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
                        * elements of empty collections.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {boolean} Returns `true` if all elements pass the predicate check,
                        *  else `false`.
                        * @example
                        *
                        * _.every([true, 1, null, 'yes'], Boolean);
                        * // => false
                        *
                        * var users = [
                        *   { 'user': 'barney', 'age': 36, 'active': false },
                        *   { 'user': 'fred',   'age': 40, 'active': false }
                        * ];
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.every(users, { 'user': 'barney', 'active': false });
                        * // => false
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.every(users, ['active', false]);
                        * // => true
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.every(users, 'active');
                        * // => false
                        */
                        function every(collection, predicate, guard) { var func = isArray(collection) ? arrayEvery : baseEvery; if (guard && isIterateeCall(collection, predicate, guard)) {
                            predicate = undefined;
                        } return func(collection, getIteratee(predicate, 3)); } /**
                        * Iterates over elements of `collection`, returning an array of all elements
                        * `predicate` returns truthy for. The predicate is invoked with three
                        * arguments: (value, index|key, collection).
                        *
                        * **Note:** Unlike `_.remove`, this method returns a new array.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new filtered array.
                        * @see _.reject
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney', 'age': 36, 'active': true },
                        *   { 'user': 'fred',   'age': 40, 'active': false }
                        * ];
                        *
                        * _.filter(users, function(o) { return !o.active; });
                        * // => objects for ['fred']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.filter(users, { 'age': 36, 'active': true });
                        * // => objects for ['barney']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.filter(users, ['active', false]);
                        * // => objects for ['fred']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.filter(users, 'active');
                        * // => objects for ['barney']
                        *
                        * // Combining several predicates using `_.overEvery` or `_.overSome`.
                        * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
                        * // => objects for ['fred', 'barney']
                        */
                        function filter(collection, predicate) { var func = isArray(collection) ? arrayFilter : baseFilter; return func(collection, getIteratee(predicate, 3)); } /**
                        * Iterates over elements of `collection`, returning the first element
                        * `predicate` returns truthy for. The predicate is invoked with three
                        * arguments: (value, index|key, collection).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param {number} [fromIndex=0] The index to search from.
                        * @returns {*} Returns the matched element, else `undefined`.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'age': 36, 'active': true },
                        *   { 'user': 'fred',    'age': 40, 'active': false },
                        *   { 'user': 'pebbles', 'age': 1,  'active': true }
                        * ];
                        *
                        * _.find(users, function(o) { return o.age < 40; });
                        * // => object for 'barney'
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.find(users, { 'age': 1, 'active': true });
                        * // => object for 'pebbles'
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.find(users, ['active', false]);
                        * // => object for 'fred'
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.find(users, 'active');
                        * // => object for 'barney'
                        */
                        var find = createFind(findIndex); /**
                        * This method is like `_.find` except that it iterates over elements of
                        * `collection` from right to left.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param {number} [fromIndex=collection.length-1] The index to search from.
                        * @returns {*} Returns the matched element, else `undefined`.
                        * @example
                        *
                        * _.findLast([1, 2, 3, 4], function(n) {
                        *   return n % 2 == 1;
                        * });
                        * // => 3
                        */
                        var findLast = createFind(findLastIndex); /**
                        * Creates a flattened array of values by running each element in `collection`
                        * thru `iteratee` and flattening the mapped results. The iteratee is invoked
                        * with three arguments: (value, index|key, collection).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * function duplicate(n) {
                        *   return [n, n];
                        * }
                        *
                        * _.flatMap([1, 2], duplicate);
                        * // => [1, 1, 2, 2]
                        */
                        function flatMap(collection, iteratee) { return baseFlatten(map(collection, iteratee), 1); } /**
                        * This method is like `_.flatMap` except that it recursively flattens the
                        * mapped results.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.7.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * function duplicate(n) {
                        *   return [[[n, n]]];
                        * }
                        *
                        * _.flatMapDeep([1, 2], duplicate);
                        * // => [1, 1, 2, 2]
                        */
                        function flatMapDeep(collection, iteratee) { return baseFlatten(map(collection, iteratee), INFINITY); } /**
                        * This method is like `_.flatMap` except that it recursively flattens the
                        * mapped results up to `depth` times.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.7.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @param {number} [depth=1] The maximum recursion depth.
                        * @returns {Array} Returns the new flattened array.
                        * @example
                        *
                        * function duplicate(n) {
                        *   return [[[n, n]]];
                        * }
                        *
                        * _.flatMapDepth([1, 2], duplicate, 2);
                        * // => [[1, 1], [2, 2]]
                        */
                        function flatMapDepth(collection, iteratee, depth) { depth = depth === undefined ? 1 : toInteger(depth); return baseFlatten(map(collection, iteratee), depth); } /**
                        * Iterates over elements of `collection` and invokes `iteratee` for each element.
                        * The iteratee is invoked with three arguments: (value, index|key, collection).
                        * Iteratee functions may exit iteration early by explicitly returning `false`.
                        *
                        * **Note:** As with other "Collections" methods, objects with a "length"
                        * property are iterated like arrays. To avoid this behavior use `_.forIn`
                        * or `_.forOwn` for object iteration.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @alias each
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array|Object} Returns `collection`.
                        * @see _.forEachRight
                        * @example
                        *
                        * _.forEach([1, 2], function(value) {
                        *   console.log(value);
                        * });
                        * // => Logs `1` then `2`.
                        *
                        * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
                        *   console.log(key);
                        * });
                        * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                        */
                        function forEach(collection, iteratee) { var func = isArray(collection) ? arrayEach : baseEach; return func(collection, getIteratee(iteratee, 3)); } /**
                        * This method is like `_.forEach` except that it iterates over elements of
                        * `collection` from right to left.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @alias eachRight
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array|Object} Returns `collection`.
                        * @see _.forEach
                        * @example
                        *
                        * _.forEachRight([1, 2], function(value) {
                        *   console.log(value);
                        * });
                        * // => Logs `2` then `1`.
                        */
                        function forEachRight(collection, iteratee) { var func = isArray(collection) ? arrayEachRight : baseEachRight; return func(collection, getIteratee(iteratee, 3)); } /**
                        * Creates an object composed of keys generated from the results of running
                        * each element of `collection` thru `iteratee`. The order of grouped values
                        * is determined by the order they occur in `collection`. The corresponding
                        * value of each key is an array of elements responsible for generating the
                        * key. The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                        * @returns {Object} Returns the composed aggregate object.
                        * @example
                        *
                        * _.groupBy([6.1, 4.2, 6.3], Math.floor);
                        * // => { '4': [4.2], '6': [6.1, 6.3] }
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.groupBy(['one', 'two', 'three'], 'length');
                        * // => { '3': ['one', 'two'], '5': ['three'] }
                        */
                        var groupBy = createAggregator(function (result, value, key) { if (hasOwnProperty.call(result, key)) {
                            result[key].push(value);
                        }
                        else {
                            baseAssignValue(result, key, [value]);
                        } }); /**
                        * Checks if `value` is in `collection`. If `collection` is a string, it's
                        * checked for a substring of `value`, otherwise
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * is used for equality comparisons. If `fromIndex` is negative, it's used as
                        * the offset from the end of `collection`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object|string} collection The collection to inspect.
                        * @param {*} value The value to search for.
                        * @param {number} [fromIndex=0] The index to search from.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                        * @returns {boolean} Returns `true` if `value` is found, else `false`.
                        * @example
                        *
                        * _.includes([1, 2, 3], 1);
                        * // => true
                        *
                        * _.includes([1, 2, 3], 1, 2);
                        * // => false
                        *
                        * _.includes({ 'a': 1, 'b': 2 }, 1);
                        * // => true
                        *
                        * _.includes('abcd', 'bc');
                        * // => true
                        */
                        function includes(collection, value, fromIndex, guard) { collection = isArrayLike(collection) ? collection : values(collection); fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0; var length = collection.length; if (fromIndex < 0) {
                            fromIndex = nativeMax(length + fromIndex, 0);
                        } return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1; } /**
                        * Invokes the method at `path` of each element in `collection`, returning
                        * an array of the results of each invoked method. Any additional arguments
                        * are provided to each invoked method. If `path` is a function, it's invoked
                        * for, and `this` bound to, each element in `collection`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Array|Function|string} path The path of the method to invoke or
                        *  the function invoked per iteration.
                        * @param {...*} [args] The arguments to invoke each method with.
                        * @returns {Array} Returns the array of results.
                        * @example
                        *
                        * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
                        * // => [[1, 5, 7], [1, 2, 3]]
                        *
                        * _.invokeMap([123, 456], String.prototype.split, '');
                        * // => [['1', '2', '3'], ['4', '5', '6']]
                        */
                        var invokeMap = baseRest(function (collection, path, args) { var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array(collection.length) : []; baseEach(collection, function (value) { result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args); }); return result; }); /**
                        * Creates an object composed of keys generated from the results of running
                        * each element of `collection` thru `iteratee`. The corresponding value of
                        * each key is the last element responsible for generating the key. The
                        * iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
                        * @returns {Object} Returns the composed aggregate object.
                        * @example
                        *
                        * var array = [
                        *   { 'dir': 'left', 'code': 97 },
                        *   { 'dir': 'right', 'code': 100 }
                        * ];
                        *
                        * _.keyBy(array, function(o) {
                        *   return String.fromCharCode(o.code);
                        * });
                        * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
                        *
                        * _.keyBy(array, 'dir');
                        * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
                        */
                        var keyBy = createAggregator(function (result, value, key) { baseAssignValue(result, key, value); }); /**
                        * Creates an array of values by running each element in `collection` thru
                        * `iteratee`. The iteratee is invoked with three arguments:
                        * (value, index|key, collection).
                        *
                        * Many lodash methods are guarded to work as iteratees for methods like
                        * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
                        *
                        * The guarded methods are:
                        * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
                        * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
                        * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
                        * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new mapped array.
                        * @example
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * _.map([4, 8], square);
                        * // => [16, 64]
                        *
                        * _.map({ 'a': 4, 'b': 8 }, square);
                        * // => [16, 64] (iteration order is not guaranteed)
                        *
                        * var users = [
                        *   { 'user': 'barney' },
                        *   { 'user': 'fred' }
                        * ];
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.map(users, 'user');
                        * // => ['barney', 'fred']
                        */
                        function map(collection, iteratee) { var func = isArray(collection) ? arrayMap : baseMap; return func(collection, getIteratee(iteratee, 3)); } /**
                        * This method is like `_.sortBy` except that it allows specifying the sort
                        * orders of the iteratees to sort by. If `orders` is unspecified, all values
                        * are sorted in ascending order. Otherwise, specify an order of "desc" for
                        * descending or "asc" for ascending sort order of corresponding values.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
                        *  The iteratees to sort by.
                        * @param {string[]} [orders] The sort orders of `iteratees`.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                        * @returns {Array} Returns the new sorted array.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'fred',   'age': 48 },
                        *   { 'user': 'barney', 'age': 34 },
                        *   { 'user': 'fred',   'age': 40 },
                        *   { 'user': 'barney', 'age': 36 }
                        * ];
                        *
                        * // Sort by `user` in ascending order and by `age` in descending order.
                        * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
                        * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
                        */
                        function orderBy(collection, iteratees, orders, guard) { if (collection == null) {
                            return [];
                        } if (!isArray(iteratees)) {
                            iteratees = iteratees == null ? [] : [iteratees];
                        } orders = guard ? undefined : orders; if (!isArray(orders)) {
                            orders = orders == null ? [] : [orders];
                        } return baseOrderBy(collection, iteratees, orders); } /**
                        * Creates an array of elements split into two groups, the first of which
                        * contains elements `predicate` returns truthy for, the second of which
                        * contains elements `predicate` returns falsey for. The predicate is
                        * invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the array of grouped elements.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney',  'age': 36, 'active': false },
                        *   { 'user': 'fred',    'age': 40, 'active': true },
                        *   { 'user': 'pebbles', 'age': 1,  'active': false }
                        * ];
                        *
                        * _.partition(users, function(o) { return o.active; });
                        * // => objects for [['fred'], ['barney', 'pebbles']]
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.partition(users, { 'age': 1, 'active': false });
                        * // => objects for [['pebbles'], ['barney', 'fred']]
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.partition(users, ['active', false]);
                        * // => objects for [['barney', 'pebbles'], ['fred']]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.partition(users, 'active');
                        * // => objects for [['fred'], ['barney', 'pebbles']]
                        */
                        var partition = createAggregator(function (result, value, key) { result[key ? 0 : 1].push(value); }, function () { return [[], []]; }); /**
                        * Reduces `collection` to a value which is the accumulated result of running
                        * each element in `collection` thru `iteratee`, where each successive
                        * invocation is supplied the return value of the previous. If `accumulator`
                        * is not given, the first element of `collection` is used as the initial
                        * value. The iteratee is invoked with four arguments:
                        * (accumulator, value, index|key, collection).
                        *
                        * Many lodash methods are guarded to work as iteratees for methods like
                        * `_.reduce`, `_.reduceRight`, and `_.transform`.
                        *
                        * The guarded methods are:
                        * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
                        * and `sortBy`
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @param {*} [accumulator] The initial value.
                        * @returns {*} Returns the accumulated value.
                        * @see _.reduceRight
                        * @example
                        *
                        * _.reduce([1, 2], function(sum, n) {
                        *   return sum + n;
                        * }, 0);
                        * // => 3
                        *
                        * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                        *   (result[value] || (result[value] = [])).push(key);
                        *   return result;
                        * }, {});
                        * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
                        */
                        function reduce(collection, iteratee, accumulator) { var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3; return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach); } /**
                        * This method is like `_.reduce` except that it iterates over elements of
                        * `collection` from right to left.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @param {*} [accumulator] The initial value.
                        * @returns {*} Returns the accumulated value.
                        * @see _.reduce
                        * @example
                        *
                        * var array = [[0, 1], [2, 3], [4, 5]];
                        *
                        * _.reduceRight(array, function(flattened, other) {
                        *   return flattened.concat(other);
                        * }, []);
                        * // => [4, 5, 2, 3, 0, 1]
                        */
                        function reduceRight(collection, iteratee, accumulator) { var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3; return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight); } /**
                        * The opposite of `_.filter`; this method returns the elements of `collection`
                        * that `predicate` does **not** return truthy for.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the new filtered array.
                        * @see _.filter
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney', 'age': 36, 'active': false },
                        *   { 'user': 'fred',   'age': 40, 'active': true }
                        * ];
                        *
                        * _.reject(users, function(o) { return !o.active; });
                        * // => objects for ['fred']
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.reject(users, { 'age': 40, 'active': true });
                        * // => objects for ['barney']
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.reject(users, ['active', false]);
                        * // => objects for ['fred']
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.reject(users, 'active');
                        * // => objects for ['barney']
                        */
                        function reject(collection, predicate) { var func = isArray(collection) ? arrayFilter : baseFilter; return func(collection, negate(getIteratee(predicate, 3))); } /**
                        * Gets a random element from `collection`.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to sample.
                        * @returns {*} Returns the random element.
                        * @example
                        *
                        * _.sample([1, 2, 3, 4]);
                        * // => 2
                        */
                        function sample(collection) { var func = isArray(collection) ? arraySample : baseSample; return func(collection); } /**
                        * Gets `n` random elements at unique keys from `collection` up to the
                        * size of `collection`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to sample.
                        * @param {number} [n=1] The number of elements to sample.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the random elements.
                        * @example
                        *
                        * _.sampleSize([1, 2, 3], 2);
                        * // => [3, 1]
                        *
                        * _.sampleSize([1, 2, 3], 4);
                        * // => [2, 3, 1]
                        */
                        function sampleSize(collection, n, guard) { if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
                            n = 1;
                        }
                        else {
                            n = toInteger(n);
                        } var func = isArray(collection) ? arraySampleSize : baseSampleSize; return func(collection, n); } /**
                        * Creates an array of shuffled values, using a version of the
                        * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to shuffle.
                        * @returns {Array} Returns the new shuffled array.
                        * @example
                        *
                        * _.shuffle([1, 2, 3, 4]);
                        * // => [4, 1, 3, 2]
                        */
                        function shuffle(collection) { var func = isArray(collection) ? arrayShuffle : baseShuffle; return func(collection); } /**
                        * Gets the size of `collection` by returning its length for array-like
                        * values or the number of own enumerable string keyed properties for objects.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object|string} collection The collection to inspect.
                        * @returns {number} Returns the collection size.
                        * @example
                        *
                        * _.size([1, 2, 3]);
                        * // => 3
                        *
                        * _.size({ 'a': 1, 'b': 2 });
                        * // => 2
                        *
                        * _.size('pebbles');
                        * // => 7
                        */
                        function size(collection) { if (collection == null) {
                            return 0;
                        } if (isArrayLike(collection)) {
                            return isString(collection) ? stringSize(collection) : collection.length;
                        } var tag = getTag(collection); if (tag == mapTag || tag == setTag) {
                            return collection.size;
                        } return baseKeys(collection).length; } /**
                        * Checks if `predicate` returns truthy for **any** element of `collection`.
                        * Iteration is stopped once `predicate` returns truthy. The predicate is
                        * invoked with three arguments: (value, index|key, collection).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {boolean} Returns `true` if any element passes the predicate check,
                        *  else `false`.
                        * @example
                        *
                        * _.some([null, 0, 'yes', false], Boolean);
                        * // => true
                        *
                        * var users = [
                        *   { 'user': 'barney', 'active': true },
                        *   { 'user': 'fred',   'active': false }
                        * ];
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.some(users, { 'user': 'barney', 'active': false });
                        * // => false
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.some(users, ['active', false]);
                        * // => true
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.some(users, 'active');
                        * // => true
                        */
                        function some(collection, predicate, guard) { var func = isArray(collection) ? arraySome : baseSome; if (guard && isIterateeCall(collection, predicate, guard)) {
                            predicate = undefined;
                        } return func(collection, getIteratee(predicate, 3)); } /**
                        * Creates an array of elements, sorted in ascending order by the results of
                        * running each element in a collection thru each iteratee. This method
                        * performs a stable sort, that is, it preserves the original sort order of
                        * equal elements. The iteratees are invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Collection
                        * @param {Array|Object} collection The collection to iterate over.
                        * @param {...(Function|Function[])} [iteratees=[_.identity]]
                        *  The iteratees to sort by.
                        * @returns {Array} Returns the new sorted array.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'fred',   'age': 48 },
                        *   { 'user': 'barney', 'age': 36 },
                        *   { 'user': 'fred',   'age': 30 },
                        *   { 'user': 'barney', 'age': 34 }
                        * ];
                        *
                        * _.sortBy(users, [function(o) { return o.user; }]);
                        * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
                        *
                        * _.sortBy(users, ['user', 'age']);
                        * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
                        */
                        var sortBy = baseRest(function (collection, iteratees) { if (collection == null) {
                            return [];
                        } var length = iteratees.length; if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
                            iteratees = [];
                        }
                        else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
                            iteratees = [iteratees[0]];
                        } return baseOrderBy(collection, baseFlatten(iteratees, 1), []); }); /*------------------------------------------------------------------------*/ /**
                        * Gets the timestamp of the number of milliseconds that have elapsed since
                        * the Unix epoch (1 January 1970 00:00:00 UTC).
                        *
                        * @static
                        * @memberOf _
                        * @since 2.4.0
                        * @category Date
                        * @returns {number} Returns the timestamp.
                        * @example
                        *
                        * _.defer(function(stamp) {
                        *   console.log(_.now() - stamp);
                        * }, _.now());
                        * // => Logs the number of milliseconds it took for the deferred invocation.
                        */
                        var now = ctxNow || function () { return root.Date.now(); }; /*------------------------------------------------------------------------*/ /**
                        * The opposite of `_.before`; this method creates a function that invokes
                        * `func` once it's called `n` or more times.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {number} n The number of calls before `func` is invoked.
                        * @param {Function} func The function to restrict.
                        * @returns {Function} Returns the new restricted function.
                        * @example
                        *
                        * var saves = ['profile', 'settings'];
                        *
                        * var done = _.after(saves.length, function() {
                        *   console.log('done saving!');
                        * });
                        *
                        * _.forEach(saves, function(type) {
                        *   asyncSave({ 'type': type, 'complete': done });
                        * });
                        * // => Logs 'done saving!' after the two async saves have completed.
                        */
                        function after(n, func) { if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } n = toInteger(n); return function () { if (--n < 1) {
                            return func.apply(this, arguments);
                        } }; } /**
                        * Creates a function that invokes `func`, with up to `n` arguments,
                        * ignoring any additional arguments.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Function
                        * @param {Function} func The function to cap arguments for.
                        * @param {number} [n=func.length] The arity cap.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Function} Returns the new capped function.
                        * @example
                        *
                        * _.map(['6', '8', '10'], _.ary(parseInt, 1));
                        * // => [6, 8, 10]
                        */
                        function ary(func, n, guard) { n = guard ? undefined : n; n = func && n == null ? func.length : n; return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n); } /**
                        * Creates a function that invokes `func`, with the `this` binding and arguments
                        * of the created function, while it's called less than `n` times. Subsequent
                        * calls to the created function return the result of the last `func` invocation.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Function
                        * @param {number} n The number of calls at which `func` is no longer invoked.
                        * @param {Function} func The function to restrict.
                        * @returns {Function} Returns the new restricted function.
                        * @example
                        *
                        * jQuery(element).on('click', _.before(5, addContactToList));
                        * // => Allows adding up to 4 contacts to the list.
                        */
                        function before(n, func) { var result; if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } n = toInteger(n); return function () { if (--n > 0) {
                            result = func.apply(this, arguments);
                        } if (n <= 1) {
                            func = undefined;
                        } return result; }; } /**
                        * Creates a function that invokes `func` with the `this` binding of `thisArg`
                        * and `partials` prepended to the arguments it receives.
                        *
                        * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
                        * may be used as a placeholder for partially applied arguments.
                        *
                        * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
                        * property of bound functions.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to bind.
                        * @param {*} thisArg The `this` binding of `func`.
                        * @param {...*} [partials] The arguments to be partially applied.
                        * @returns {Function} Returns the new bound function.
                        * @example
                        *
                        * function greet(greeting, punctuation) {
                        *   return greeting + ' ' + this.user + punctuation;
                        * }
                        *
                        * var object = { 'user': 'fred' };
                        *
                        * var bound = _.bind(greet, object, 'hi');
                        * bound('!');
                        * // => 'hi fred!'
                        *
                        * // Bound with placeholders.
                        * var bound = _.bind(greet, object, _, '!');
                        * bound('hi');
                        * // => 'hi fred!'
                        */
                        var bind = baseRest(function (func, thisArg, partials) { var bitmask = WRAP_BIND_FLAG; if (partials.length) {
                            var holders = replaceHolders(partials, getHolder(bind));
                            bitmask |= WRAP_PARTIAL_FLAG;
                        } return createWrap(func, bitmask, thisArg, partials, holders); }); /**
                        * Creates a function that invokes the method at `object[key]` with `partials`
                        * prepended to the arguments it receives.
                        *
                        * This method differs from `_.bind` by allowing bound functions to reference
                        * methods that may be redefined or don't yet exist. See
                        * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
                        * for more details.
                        *
                        * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
                        * builds, may be used as a placeholder for partially applied arguments.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.10.0
                        * @category Function
                        * @param {Object} object The object to invoke the method on.
                        * @param {string} key The key of the method.
                        * @param {...*} [partials] The arguments to be partially applied.
                        * @returns {Function} Returns the new bound function.
                        * @example
                        *
                        * var object = {
                        *   'user': 'fred',
                        *   'greet': function(greeting, punctuation) {
                        *     return greeting + ' ' + this.user + punctuation;
                        *   }
                        * };
                        *
                        * var bound = _.bindKey(object, 'greet', 'hi');
                        * bound('!');
                        * // => 'hi fred!'
                        *
                        * object.greet = function(greeting, punctuation) {
                        *   return greeting + 'ya ' + this.user + punctuation;
                        * };
                        *
                        * bound('!');
                        * // => 'hiya fred!'
                        *
                        * // Bound with placeholders.
                        * var bound = _.bindKey(object, 'greet', _, '!');
                        * bound('hi');
                        * // => 'hiya fred!'
                        */
                        var bindKey = baseRest(function (object, key, partials) { var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG; if (partials.length) {
                            var holders = replaceHolders(partials, getHolder(bindKey));
                            bitmask |= WRAP_PARTIAL_FLAG;
                        } return createWrap(key, bitmask, object, partials, holders); }); /**
                        * Creates a function that accepts arguments of `func` and either invokes
                        * `func` returning its result, if at least `arity` number of arguments have
                        * been provided, or returns a function that accepts the remaining `func`
                        * arguments, and so on. The arity of `func` may be specified if `func.length`
                        * is not sufficient.
                        *
                        * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
                        * may be used as a placeholder for provided arguments.
                        *
                        * **Note:** This method doesn't set the "length" property of curried functions.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Function
                        * @param {Function} func The function to curry.
                        * @param {number} [arity=func.length] The arity of `func`.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Function} Returns the new curried function.
                        * @example
                        *
                        * var abc = function(a, b, c) {
                        *   return [a, b, c];
                        * };
                        *
                        * var curried = _.curry(abc);
                        *
                        * curried(1)(2)(3);
                        * // => [1, 2, 3]
                        *
                        * curried(1, 2)(3);
                        * // => [1, 2, 3]
                        *
                        * curried(1, 2, 3);
                        * // => [1, 2, 3]
                        *
                        * // Curried with placeholders.
                        * curried(1)(_, 3)(2);
                        * // => [1, 2, 3]
                        */
                        function curry(func, arity, guard) { arity = guard ? undefined : arity; var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity); result.placeholder = curry.placeholder; return result; } /**
                        * This method is like `_.curry` except that arguments are applied to `func`
                        * in the manner of `_.partialRight` instead of `_.partial`.
                        *
                        * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
                        * builds, may be used as a placeholder for provided arguments.
                        *
                        * **Note:** This method doesn't set the "length" property of curried functions.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Function
                        * @param {Function} func The function to curry.
                        * @param {number} [arity=func.length] The arity of `func`.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Function} Returns the new curried function.
                        * @example
                        *
                        * var abc = function(a, b, c) {
                        *   return [a, b, c];
                        * };
                        *
                        * var curried = _.curryRight(abc);
                        *
                        * curried(3)(2)(1);
                        * // => [1, 2, 3]
                        *
                        * curried(2, 3)(1);
                        * // => [1, 2, 3]
                        *
                        * curried(1, 2, 3);
                        * // => [1, 2, 3]
                        *
                        * // Curried with placeholders.
                        * curried(3)(1, _)(2);
                        * // => [1, 2, 3]
                        */
                        function curryRight(func, arity, guard) { arity = guard ? undefined : arity; var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity); result.placeholder = curryRight.placeholder; return result; } /**
                        * Creates a debounced function that delays invoking `func` until after `wait`
                        * milliseconds have elapsed since the last time the debounced function was
                        * invoked. The debounced function comes with a `cancel` method to cancel
                        * delayed `func` invocations and a `flush` method to immediately invoke them.
                        * Provide `options` to indicate whether `func` should be invoked on the
                        * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
                        * with the last arguments provided to the debounced function. Subsequent
                        * calls to the debounced function return the result of the last `func`
                        * invocation.
                        *
                        * **Note:** If `leading` and `trailing` options are `true`, `func` is
                        * invoked on the trailing edge of the timeout only if the debounced function
                        * is invoked more than once during the `wait` timeout.
                        *
                        * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
                        * until to the next tick, similar to `setTimeout` with a timeout of `0`.
                        *
                        * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
                        * for details over the differences between `_.debounce` and `_.throttle`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to debounce.
                        * @param {number} [wait=0] The number of milliseconds to delay.
                        * @param {Object} [options={}] The options object.
                        * @param {boolean} [options.leading=false]
                        *  Specify invoking on the leading edge of the timeout.
                        * @param {number} [options.maxWait]
                        *  The maximum time `func` is allowed to be delayed before it's invoked.
                        * @param {boolean} [options.trailing=true]
                        *  Specify invoking on the trailing edge of the timeout.
                        * @returns {Function} Returns the new debounced function.
                        * @example
                        *
                        * // Avoid costly calculations while the window size is in flux.
                        * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
                        *
                        * // Invoke `sendMail` when clicked, debouncing subsequent calls.
                        * jQuery(element).on('click', _.debounce(sendMail, 300, {
                        *   'leading': true,
                        *   'trailing': false
                        * }));
                        *
                        * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
                        * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
                        * var source = new EventSource('/stream');
                        * jQuery(source).on('message', debounced);
                        *
                        * // Cancel the trailing debounced invocation.
                        * jQuery(window).on('popstate', debounced.cancel);
                        */
                        function debounce(func, wait, options) {
                            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                            if (typeof func != 'function') {
                                throw new TypeError(FUNC_ERROR_TEXT);
                            }
                            wait = toNumber(wait) || 0;
                            if (isObject(options)) {
                                leading = !!options.leading;
                                maxing = 'maxWait' in options;
                                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                                trailing = 'trailing' in options ? !!options.trailing : trailing;
                            }
                            function invokeFunc(time) { var args = lastArgs, thisArg = lastThis; lastArgs = lastThis = undefined; lastInvokeTime = time; result = func.apply(thisArg, args); return result; }
                            function leadingEdge(time) {
                                lastInvokeTime = time; // Start the timer for the trailing edge.
                                timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.
                                return leading ? invokeFunc(time) : result;
                            }
                            function remainingWait(time) { var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall; return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting; }
                            function shouldInvoke(time) {
                                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
                                // trailing edge, the system time has gone backwards and we're treating
                                // it as the trailing edge, or we've hit the `maxWait` limit.
                                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                            }
                            function timerExpired() {
                                var time = now();
                                if (shouldInvoke(time)) {
                                    return trailingEdge(time);
                                } // Restart the timer.
                                timerId = setTimeout(timerExpired, remainingWait(time));
                            }
                            function trailingEdge(time) {
                                timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
                                // debounced at least once.
                                if (trailing && lastArgs) {
                                    return invokeFunc(time);
                                }
                                lastArgs = lastThis = undefined;
                                return result;
                            }
                            function cancel() { if (timerId !== undefined) {
                                clearTimeout(timerId);
                            } lastInvokeTime = 0; lastArgs = lastCallTime = lastThis = timerId = undefined; }
                            function flush() { return timerId === undefined ? result : trailingEdge(now()); }
                            function debounced() {
                                var time = now(), isInvoking = shouldInvoke(time);
                                lastArgs = arguments;
                                lastThis = this;
                                lastCallTime = time;
                                if (isInvoking) {
                                    if (timerId === undefined) {
                                        return leadingEdge(lastCallTime);
                                    }
                                    if (maxing) { // Handle invocations in a tight loop.
                                        clearTimeout(timerId);
                                        timerId = setTimeout(timerExpired, wait);
                                        return invokeFunc(lastCallTime);
                                    }
                                }
                                if (timerId === undefined) {
                                    timerId = setTimeout(timerExpired, wait);
                                }
                                return result;
                            }
                            debounced.cancel = cancel;
                            debounced.flush = flush;
                            return debounced;
                        } /**
                                 * Defers invoking the `func` until the current call stack has cleared. Any
                                 * additional arguments are provided to `func` when it's invoked.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 0.1.0
                                 * @category Function
                                 * @param {Function} func The function to defer.
                                 * @param {...*} [args] The arguments to invoke `func` with.
                                 * @returns {number} Returns the timer id.
                                 * @example
                                 *
                                 * _.defer(function(text) {
                                 *   console.log(text);
                                 * }, 'deferred');
                                 * // => Logs 'deferred' after one millisecond.
                                 */
                        var defer = baseRest(function (func, args) { return baseDelay(func, 1, args); }); /**
                        * Invokes `func` after `wait` milliseconds. Any additional arguments are
                        * provided to `func` when it's invoked.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to delay.
                        * @param {number} wait The number of milliseconds to delay invocation.
                        * @param {...*} [args] The arguments to invoke `func` with.
                        * @returns {number} Returns the timer id.
                        * @example
                        *
                        * _.delay(function(text) {
                        *   console.log(text);
                        * }, 1000, 'later');
                        * // => Logs 'later' after one second.
                        */
                        var delay = baseRest(function (func, wait, args) { return baseDelay(func, toNumber(wait) || 0, args); }); /**
                        * Creates a function that invokes `func` with arguments reversed.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Function
                        * @param {Function} func The function to flip arguments for.
                        * @returns {Function} Returns the new flipped function.
                        * @example
                        *
                        * var flipped = _.flip(function() {
                        *   return _.toArray(arguments);
                        * });
                        *
                        * flipped('a', 'b', 'c', 'd');
                        * // => ['d', 'c', 'b', 'a']
                        */
                        function flip(func) { return createWrap(func, WRAP_FLIP_FLAG); } /**
                        * Creates a function that memoizes the result of `func`. If `resolver` is
                        * provided, it determines the cache key for storing the result based on the
                        * arguments provided to the memoized function. By default, the first argument
                        * provided to the memoized function is used as the map cache key. The `func`
                        * is invoked with the `this` binding of the memoized function.
                        *
                        * **Note:** The cache is exposed as the `cache` property on the memoized
                        * function. Its creation may be customized by replacing the `_.memoize.Cache`
                        * constructor with one whose instances implement the
                        * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
                        * method interface of `clear`, `delete`, `get`, `has`, and `set`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to have its output memoized.
                        * @param {Function} [resolver] The function to resolve the cache key.
                        * @returns {Function} Returns the new memoized function.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': 2 };
                        * var other = { 'c': 3, 'd': 4 };
                        *
                        * var values = _.memoize(_.values);
                        * values(object);
                        * // => [1, 2]
                        *
                        * values(other);
                        * // => [3, 4]
                        *
                        * object.a = 2;
                        * values(object);
                        * // => [1, 2]
                        *
                        * // Modify the result cache.
                        * values.cache.set(object, ['a', 'b']);
                        * values(object);
                        * // => ['a', 'b']
                        *
                        * // Replace `_.memoize.Cache`.
                        * _.memoize.Cache = WeakMap;
                        */
                        function memoize(func, resolver) { if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } var memoized = function memoized() { var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache; if (cache.has(key)) {
                            return cache.get(key);
                        } var result = func.apply(this, args); memoized.cache = cache.set(key, result) || cache; return result; }; memoized.cache = new (memoize.Cache || MapCache)(); return memoized; } // Expose `MapCache`.
                        memoize.Cache = MapCache; /**
                                 * Creates a function that negates the result of the predicate `func`. The
                                 * `func` predicate is invoked with the `this` binding and arguments of the
                                 * created function.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 3.0.0
                                 * @category Function
                                 * @param {Function} predicate The predicate to negate.
                                 * @returns {Function} Returns the new negated function.
                                 * @example
                                 *
                                 * function isEven(n) {
                                 *   return n % 2 == 0;
                                 * }
                                 *
                                 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
                                 * // => [1, 3, 5]
                                 */
                        function negate(predicate) { if (typeof predicate != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } return function () { var args = arguments; switch (args.length) {
                            case 0: return !predicate.call(this);
                            case 1: return !predicate.call(this, args[0]);
                            case 2: return !predicate.call(this, args[0], args[1]);
                            case 3: return !predicate.call(this, args[0], args[1], args[2]);
                        } return !predicate.apply(this, args); }; } /**
                        * Creates a function that is restricted to invoking `func` once. Repeat calls
                        * to the function return the value of the first invocation. The `func` is
                        * invoked with the `this` binding and arguments of the created function.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to restrict.
                        * @returns {Function} Returns the new restricted function.
                        * @example
                        *
                        * var initialize = _.once(createApplication);
                        * initialize();
                        * initialize();
                        * // => `createApplication` is invoked once
                        */
                        function once(func) { return before(2, func); } /**
                        * Creates a function that invokes `func` with its arguments transformed.
                        *
                        * @static
                        * @since 4.0.0
                        * @memberOf _
                        * @category Function
                        * @param {Function} func The function to wrap.
                        * @param {...(Function|Function[])} [transforms=[_.identity]]
                        *  The argument transforms.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * function doubled(n) {
                        *   return n * 2;
                        * }
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * var func = _.overArgs(function(x, y) {
                        *   return [x, y];
                        * }, [square, doubled]);
                        *
                        * func(9, 3);
                        * // => [81, 6]
                        *
                        * func(10, 5);
                        * // => [100, 10]
                        */
                        var overArgs = castRest(function (func, transforms) { transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee())); var funcsLength = transforms.length; return baseRest(function (args) { var index = -1, length = nativeMin(args.length, funcsLength); while (++index < length) {
                            args[index] = transforms[index].call(this, args[index]);
                        } return apply(func, this, args); }); }); /**
                        * Creates a function that invokes `func` with `partials` prepended to the
                        * arguments it receives. This method is like `_.bind` except it does **not**
                        * alter the `this` binding.
                        *
                        * The `_.partial.placeholder` value, which defaults to `_` in monolithic
                        * builds, may be used as a placeholder for partially applied arguments.
                        *
                        * **Note:** This method doesn't set the "length" property of partially
                        * applied functions.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.2.0
                        * @category Function
                        * @param {Function} func The function to partially apply arguments to.
                        * @param {...*} [partials] The arguments to be partially applied.
                        * @returns {Function} Returns the new partially applied function.
                        * @example
                        *
                        * function greet(greeting, name) {
                        *   return greeting + ' ' + name;
                        * }
                        *
                        * var sayHelloTo = _.partial(greet, 'hello');
                        * sayHelloTo('fred');
                        * // => 'hello fred'
                        *
                        * // Partially applied with placeholders.
                        * var greetFred = _.partial(greet, _, 'fred');
                        * greetFred('hi');
                        * // => 'hi fred'
                        */
                        var partial = baseRest(function (func, partials) { var holders = replaceHolders(partials, getHolder(partial)); return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders); }); /**
                        * This method is like `_.partial` except that partially applied arguments
                        * are appended to the arguments it receives.
                        *
                        * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
                        * builds, may be used as a placeholder for partially applied arguments.
                        *
                        * **Note:** This method doesn't set the "length" property of partially
                        * applied functions.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.0.0
                        * @category Function
                        * @param {Function} func The function to partially apply arguments to.
                        * @param {...*} [partials] The arguments to be partially applied.
                        * @returns {Function} Returns the new partially applied function.
                        * @example
                        *
                        * function greet(greeting, name) {
                        *   return greeting + ' ' + name;
                        * }
                        *
                        * var greetFred = _.partialRight(greet, 'fred');
                        * greetFred('hi');
                        * // => 'hi fred'
                        *
                        * // Partially applied with placeholders.
                        * var sayHelloTo = _.partialRight(greet, 'hello', _);
                        * sayHelloTo('fred');
                        * // => 'hello fred'
                        */
                        var partialRight = baseRest(function (func, partials) { var holders = replaceHolders(partials, getHolder(partialRight)); return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders); }); /**
                        * Creates a function that invokes `func` with arguments arranged according
                        * to the specified `indexes` where the argument value at the first index is
                        * provided as the first argument, the argument value at the second index is
                        * provided as the second argument, and so on.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Function
                        * @param {Function} func The function to rearrange arguments for.
                        * @param {...(number|number[])} indexes The arranged argument indexes.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var rearged = _.rearg(function(a, b, c) {
                        *   return [a, b, c];
                        * }, [2, 0, 1]);
                        *
                        * rearged('b', 'c', 'a')
                        * // => ['a', 'b', 'c']
                        */
                        var rearg = flatRest(function (func, indexes) { return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes); }); /**
                        * Creates a function that invokes `func` with the `this` binding of the
                        * created function and arguments from `start` and beyond provided as
                        * an array.
                        *
                        * **Note:** This method is based on the
                        * [rest parameter](https://mdn.io/rest_parameters).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Function
                        * @param {Function} func The function to apply a rest parameter to.
                        * @param {number} [start=func.length-1] The start position of the rest parameter.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var say = _.rest(function(what, names) {
                        *   return what + ' ' + _.initial(names).join(', ') +
                        *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
                        * });
                        *
                        * say('hello', 'fred', 'barney', 'pebbles');
                        * // => 'hello fred, barney, & pebbles'
                        */
                        function rest(func, start) { if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } start = start === undefined ? start : toInteger(start); return baseRest(func, start); } /**
                        * Creates a function that invokes `func` with the `this` binding of the
                        * create function and an array of arguments much like
                        * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
                        *
                        * **Note:** This method is based on the
                        * [spread operator](https://mdn.io/spread_operator).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.2.0
                        * @category Function
                        * @param {Function} func The function to spread arguments over.
                        * @param {number} [start=0] The start position of the spread.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var say = _.spread(function(who, what) {
                        *   return who + ' says ' + what;
                        * });
                        *
                        * say(['fred', 'hello']);
                        * // => 'fred says hello'
                        *
                        * var numbers = Promise.all([
                        *   Promise.resolve(40),
                        *   Promise.resolve(36)
                        * ]);
                        *
                        * numbers.then(_.spread(function(x, y) {
                        *   return x + y;
                        * }));
                        * // => a Promise of 76
                        */
                        function spread(func, start) { if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } start = start == null ? 0 : nativeMax(toInteger(start), 0); return baseRest(function (args) { var array = args[start], otherArgs = castSlice(args, 0, start); if (array) {
                            arrayPush(otherArgs, array);
                        } return apply(func, this, otherArgs); }); } /**
                        * Creates a throttled function that only invokes `func` at most once per
                        * every `wait` milliseconds. The throttled function comes with a `cancel`
                        * method to cancel delayed `func` invocations and a `flush` method to
                        * immediately invoke them. Provide `options` to indicate whether `func`
                        * should be invoked on the leading and/or trailing edge of the `wait`
                        * timeout. The `func` is invoked with the last arguments provided to the
                        * throttled function. Subsequent calls to the throttled function return the
                        * result of the last `func` invocation.
                        *
                        * **Note:** If `leading` and `trailing` options are `true`, `func` is
                        * invoked on the trailing edge of the timeout only if the throttled function
                        * is invoked more than once during the `wait` timeout.
                        *
                        * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
                        * until to the next tick, similar to `setTimeout` with a timeout of `0`.
                        *
                        * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
                        * for details over the differences between `_.throttle` and `_.debounce`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {Function} func The function to throttle.
                        * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
                        * @param {Object} [options={}] The options object.
                        * @param {boolean} [options.leading=true]
                        *  Specify invoking on the leading edge of the timeout.
                        * @param {boolean} [options.trailing=true]
                        *  Specify invoking on the trailing edge of the timeout.
                        * @returns {Function} Returns the new throttled function.
                        * @example
                        *
                        * // Avoid excessively updating the position while scrolling.
                        * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
                        *
                        * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
                        * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
                        * jQuery(element).on('click', throttled);
                        *
                        * // Cancel the trailing throttled invocation.
                        * jQuery(window).on('popstate', throttled.cancel);
                        */
                        function throttle(func, wait, options) { var leading = true, trailing = true; if (typeof func != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } if (isObject(options)) {
                            leading = 'leading' in options ? !!options.leading : leading;
                            trailing = 'trailing' in options ? !!options.trailing : trailing;
                        } return debounce(func, wait, { 'leading': leading, 'maxWait': wait, 'trailing': trailing }); } /**
                        * Creates a function that accepts up to one argument, ignoring any
                        * additional arguments.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Function
                        * @param {Function} func The function to cap arguments for.
                        * @returns {Function} Returns the new capped function.
                        * @example
                        *
                        * _.map(['6', '8', '10'], _.unary(parseInt));
                        * // => [6, 8, 10]
                        */
                        function unary(func) { return ary(func, 1); } /**
                        * Creates a function that provides `value` to `wrapper` as its first
                        * argument. Any additional arguments provided to the function are appended
                        * to those provided to the `wrapper`. The wrapper is invoked with the `this`
                        * binding of the created function.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Function
                        * @param {*} value The value to wrap.
                        * @param {Function} [wrapper=identity] The wrapper function.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var p = _.wrap(_.escape, function(func, text) {
                        *   return '<p>' + func(text) + '</p>';
                        * });
                        *
                        * p('fred, barney, & pebbles');
                        * // => '<p>fred, barney, &amp; pebbles</p>'
                        */
                        function wrap(value, wrapper) { return partial(castFunction(wrapper), value); } /*------------------------------------------------------------------------*/ /**
                        * Casts `value` as an array if it's not one.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.4.0
                        * @category Lang
                        * @param {*} value The value to inspect.
                        * @returns {Array} Returns the cast array.
                        * @example
                        *
                        * _.castArray(1);
                        * // => [1]
                        *
                        * _.castArray({ 'a': 1 });
                        * // => [{ 'a': 1 }]
                        *
                        * _.castArray('abc');
                        * // => ['abc']
                        *
                        * _.castArray(null);
                        * // => [null]
                        *
                        * _.castArray(undefined);
                        * // => [undefined]
                        *
                        * _.castArray();
                        * // => []
                        *
                        * var array = [1, 2, 3];
                        * console.log(_.castArray(array) === array);
                        * // => true
                        */
                        function castArray() { if (!arguments.length) {
                            return [];
                        } var value = arguments[0]; return isArray(value) ? value : [value]; } /**
                        * Creates a shallow clone of `value`.
                        *
                        * **Note:** This method is loosely based on the
                        * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
                        * and supports cloning arrays, array buffers, booleans, date objects, maps,
                        * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
                        * arrays. The own enumerable properties of `arguments` objects are cloned
                        * as plain objects. An empty object is returned for uncloneable values such
                        * as error objects, functions, DOM nodes, and WeakMaps.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to clone.
                        * @returns {*} Returns the cloned value.
                        * @see _.cloneDeep
                        * @example
                        *
                        * var objects = [{ 'a': 1 }, { 'b': 2 }];
                        *
                        * var shallow = _.clone(objects);
                        * console.log(shallow[0] === objects[0]);
                        * // => true
                        */
                        function clone(value) { return baseClone(value, CLONE_SYMBOLS_FLAG); } /**
                        * This method is like `_.clone` except that it accepts `customizer` which
                        * is invoked to produce the cloned value. If `customizer` returns `undefined`,
                        * cloning is handled by the method instead. The `customizer` is invoked with
                        * up to four arguments; (value [, index|key, object, stack]).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to clone.
                        * @param {Function} [customizer] The function to customize cloning.
                        * @returns {*} Returns the cloned value.
                        * @see _.cloneDeepWith
                        * @example
                        *
                        * function customizer(value) {
                        *   if (_.isElement(value)) {
                        *     return value.cloneNode(false);
                        *   }
                        * }
                        *
                        * var el = _.cloneWith(document.body, customizer);
                        *
                        * console.log(el === document.body);
                        * // => false
                        * console.log(el.nodeName);
                        * // => 'BODY'
                        * console.log(el.childNodes.length);
                        * // => 0
                        */
                        function cloneWith(value, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; return baseClone(value, CLONE_SYMBOLS_FLAG, customizer); } /**
                        * This method is like `_.clone` except that it recursively clones `value`.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.0.0
                        * @category Lang
                        * @param {*} value The value to recursively clone.
                        * @returns {*} Returns the deep cloned value.
                        * @see _.clone
                        * @example
                        *
                        * var objects = [{ 'a': 1 }, { 'b': 2 }];
                        *
                        * var deep = _.cloneDeep(objects);
                        * console.log(deep[0] === objects[0]);
                        * // => false
                        */
                        function cloneDeep(value) { return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG); } /**
                        * This method is like `_.cloneWith` except that it recursively clones `value`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to recursively clone.
                        * @param {Function} [customizer] The function to customize cloning.
                        * @returns {*} Returns the deep cloned value.
                        * @see _.cloneWith
                        * @example
                        *
                        * function customizer(value) {
                        *   if (_.isElement(value)) {
                        *     return value.cloneNode(true);
                        *   }
                        * }
                        *
                        * var el = _.cloneDeepWith(document.body, customizer);
                        *
                        * console.log(el === document.body);
                        * // => false
                        * console.log(el.nodeName);
                        * // => 'BODY'
                        * console.log(el.childNodes.length);
                        * // => 20
                        */
                        function cloneDeepWith(value, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer); } /**
                        * Checks if `object` conforms to `source` by invoking the predicate
                        * properties of `source` with the corresponding property values of `object`.
                        *
                        * **Note:** This method is equivalent to `_.conforms` when `source` is
                        * partially applied.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.14.0
                        * @category Lang
                        * @param {Object} object The object to inspect.
                        * @param {Object} source The object of property predicates to conform to.
                        * @returns {boolean} Returns `true` if `object` conforms, else `false`.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': 2 };
                        *
                        * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
                        * // => true
                        *
                        * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
                        * // => false
                        */
                        function conformsTo(object, source) { return source == null || baseConformsTo(object, source, keys(source)); } /**
                        * Performs a
                        * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                        * comparison between two values to determine if they are equivalent.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                        * @example
                        *
                        * var object = { 'a': 1 };
                        * var other = { 'a': 1 };
                        *
                        * _.eq(object, object);
                        * // => true
                        *
                        * _.eq(object, other);
                        * // => false
                        *
                        * _.eq('a', 'a');
                        * // => true
                        *
                        * _.eq('a', Object('a'));
                        * // => false
                        *
                        * _.eq(NaN, NaN);
                        * // => true
                        */
                        function eq(value, other) { return value === other || value !== value && other !== other; } /**
                        * Checks if `value` is greater than `other`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.9.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is greater than `other`,
                        *  else `false`.
                        * @see _.lt
                        * @example
                        *
                        * _.gt(3, 1);
                        * // => true
                        *
                        * _.gt(3, 3);
                        * // => false
                        *
                        * _.gt(1, 3);
                        * // => false
                        */
                        var gt = createRelationalOperation(baseGt); /**
                        * Checks if `value` is greater than or equal to `other`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.9.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is greater than or equal to
                        *  `other`, else `false`.
                        * @see _.lte
                        * @example
                        *
                        * _.gte(3, 1);
                        * // => true
                        *
                        * _.gte(3, 3);
                        * // => true
                        *
                        * _.gte(1, 3);
                        * // => false
                        */
                        var gte = createRelationalOperation(function (value, other) { return value >= other; }); /**
                        * Checks if `value` is likely an `arguments` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                        *  else `false`.
                        * @example
                        *
                        * _.isArguments(function() { return arguments; }());
                        * // => true
                        *
                        * _.isArguments([1, 2, 3]);
                        * // => false
                        */
                        var isArguments = baseIsArguments(function () { return arguments; }()) ? baseIsArguments : function (value) { return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee'); }; /**
                        * Checks if `value` is classified as an `Array` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an array, else `false`.
                        * @example
                        *
                        * _.isArray([1, 2, 3]);
                        * // => true
                        *
                        * _.isArray(document.body.children);
                        * // => false
                        *
                        * _.isArray('abc');
                        * // => false
                        *
                        * _.isArray(_.noop);
                        * // => false
                        */
                        var isArray = Array.isArray; /**
                        * Checks if `value` is classified as an `ArrayBuffer` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
                        * @example
                        *
                        * _.isArrayBuffer(new ArrayBuffer(2));
                        * // => true
                        *
                        * _.isArrayBuffer(new Array(2));
                        * // => false
                        */
                        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer; /**
                        * Checks if `value` is array-like. A value is considered array-like if it's
                        * not a function and has a `value.length` that's an integer greater than or
                        * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
                        * @example
                        *
                        * _.isArrayLike([1, 2, 3]);
                        * // => true
                        *
                        * _.isArrayLike(document.body.children);
                        * // => true
                        *
                        * _.isArrayLike('abc');
                        * // => true
                        *
                        * _.isArrayLike(_.noop);
                        * // => false
                        */
                        function isArrayLike(value) { return value != null && isLength(value.length) && !isFunction(value); } /**
                        * This method is like `_.isArrayLike` except that it also checks if `value`
                        * is an object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an array-like object,
                        *  else `false`.
                        * @example
                        *
                        * _.isArrayLikeObject([1, 2, 3]);
                        * // => true
                        *
                        * _.isArrayLikeObject(document.body.children);
                        * // => true
                        *
                        * _.isArrayLikeObject('abc');
                        * // => false
                        *
                        * _.isArrayLikeObject(_.noop);
                        * // => false
                        */
                        function isArrayLikeObject(value) { return isObjectLike(value) && isArrayLike(value); } /**
                        * Checks if `value` is classified as a boolean primitive or object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
                        * @example
                        *
                        * _.isBoolean(false);
                        * // => true
                        *
                        * _.isBoolean(null);
                        * // => false
                        */
                        function isBoolean(value) { return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag; } /**
                        * Checks if `value` is a buffer.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
                        * @example
                        *
                        * _.isBuffer(new Buffer(2));
                        * // => true
                        *
                        * _.isBuffer(new Uint8Array(2));
                        * // => false
                        */
                        var isBuffer = nativeIsBuffer || stubFalse; /**
                        * Checks if `value` is classified as a `Date` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                        * @example
                        *
                        * _.isDate(new Date);
                        * // => true
                        *
                        * _.isDate('Mon April 23 2012');
                        * // => false
                        */
                        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate; /**
                        * Checks if `value` is likely a DOM element.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
                        * @example
                        *
                        * _.isElement(document.body);
                        * // => true
                        *
                        * _.isElement('<body>');
                        * // => false
                        */
                        function isElement(value) { return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value); } /**
                        * Checks if `value` is an empty object, collection, map, or set.
                        *
                        * Objects are considered empty if they have no own enumerable string keyed
                        * properties.
                        *
                        * Array-like values such as `arguments` objects, arrays, buffers, strings, or
                        * jQuery-like collections are considered empty if they have a `length` of `0`.
                        * Similarly, maps and sets are considered empty if they have a `size` of `0`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is empty, else `false`.
                        * @example
                        *
                        * _.isEmpty(null);
                        * // => true
                        *
                        * _.isEmpty(true);
                        * // => true
                        *
                        * _.isEmpty(1);
                        * // => true
                        *
                        * _.isEmpty([1, 2, 3]);
                        * // => false
                        *
                        * _.isEmpty({ 'a': 1 });
                        * // => false
                        */
                        function isEmpty(value) { if (value == null) {
                            return true;
                        } if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
                            return !value.length;
                        } var tag = getTag(value); if (tag == mapTag || tag == setTag) {
                            return !value.size;
                        } if (isPrototype(value)) {
                            return !baseKeys(value).length;
                        } for (var key in value) {
                            if (hasOwnProperty.call(value, key)) {
                                return false;
                            }
                        } return true; } /**
                        * Performs a deep comparison between two values to determine if they are
                        * equivalent.
                        *
                        * **Note:** This method supports comparing arrays, array buffers, booleans,
                        * date objects, error objects, maps, numbers, `Object` objects, regexes,
                        * sets, strings, symbols, and typed arrays. `Object` objects are compared
                        * by their own, not inherited, enumerable properties. Functions and DOM
                        * nodes are compared by strict equality, i.e. `===`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                        * @example
                        *
                        * var object = { 'a': 1 };
                        * var other = { 'a': 1 };
                        *
                        * _.isEqual(object, other);
                        * // => true
                        *
                        * object === other;
                        * // => false
                        */
                        function isEqual(value, other) { return baseIsEqual(value, other); } /**
                        * This method is like `_.isEqual` except that it accepts `customizer` which
                        * is invoked to compare values. If `customizer` returns `undefined`, comparisons
                        * are handled by the method instead. The `customizer` is invoked with up to
                        * six arguments: (objValue, othValue [, index|key, object, other, stack]).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @param {Function} [customizer] The function to customize comparisons.
                        * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                        * @example
                        *
                        * function isGreeting(value) {
                        *   return /^h(?:i|ello)$/.test(value);
                        * }
                        *
                        * function customizer(objValue, othValue) {
                        *   if (isGreeting(objValue) && isGreeting(othValue)) {
                        *     return true;
                        *   }
                        * }
                        *
                        * var array = ['hello', 'goodbye'];
                        * var other = ['hi', 'goodbye'];
                        *
                        * _.isEqualWith(array, other, customizer);
                        * // => true
                        */
                        function isEqualWith(value, other, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; var result = customizer ? customizer(value, other) : undefined; return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result; } /**
                        * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
                        * `SyntaxError`, `TypeError`, or `URIError` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
                        * @example
                        *
                        * _.isError(new Error);
                        * // => true
                        *
                        * _.isError(Error);
                        * // => false
                        */
                        function isError(value) { if (!isObjectLike(value)) {
                            return false;
                        } var tag = baseGetTag(value); return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value); } /**
                        * Checks if `value` is a finite primitive number.
                        *
                        * **Note:** This method is based on
                        * [`Number.isFinite`](https://mdn.io/Number/isFinite).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
                        * @example
                        *
                        * _.isFinite(3);
                        * // => true
                        *
                        * _.isFinite(Number.MIN_VALUE);
                        * // => true
                        *
                        * _.isFinite(Infinity);
                        * // => false
                        *
                        * _.isFinite('3');
                        * // => false
                        */
                        function isFinite(value) { return typeof value == 'number' && nativeIsFinite(value); } /**
                        * Checks if `value` is classified as a `Function` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a function, else `false`.
                        * @example
                        *
                        * _.isFunction(_);
                        * // => true
                        *
                        * _.isFunction(/abc/);
                        * // => false
                        */
                        function isFunction(value) {
                            if (!isObject(value)) {
                                return false;
                            } // The use of `Object#toString` avoids issues with the `typeof` operator
                            // in Safari 9 which returns 'object' for typed arrays and other constructors.
                            var tag = baseGetTag(value);
                            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
                        } /**
                                 * Checks if `value` is an integer.
                                 *
                                 * **Note:** This method is based on
                                 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 4.0.0
                                 * @category Lang
                                 * @param {*} value The value to check.
                                 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
                                 * @example
                                 *
                                 * _.isInteger(3);
                                 * // => true
                                 *
                                 * _.isInteger(Number.MIN_VALUE);
                                 * // => false
                                 *
                                 * _.isInteger(Infinity);
                                 * // => false
                                 *
                                 * _.isInteger('3');
                                 * // => false
                                 */
                        function isInteger(value) { return typeof value == 'number' && value == toInteger(value); } /**
                        * Checks if `value` is a valid array-like length.
                        *
                        * **Note:** This method is loosely based on
                        * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
                        * @example
                        *
                        * _.isLength(3);
                        * // => true
                        *
                        * _.isLength(Number.MIN_VALUE);
                        * // => false
                        *
                        * _.isLength(Infinity);
                        * // => false
                        *
                        * _.isLength('3');
                        * // => false
                        */
                        function isLength(value) { return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER; } /**
                        * Checks if `value` is the
                        * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
                        * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is an object, else `false`.
                        * @example
                        *
                        * _.isObject({});
                        * // => true
                        *
                        * _.isObject([1, 2, 3]);
                        * // => true
                        *
                        * _.isObject(_.noop);
                        * // => true
                        *
                        * _.isObject(null);
                        * // => false
                        */
                        function isObject(value) { var type = typeof value; return value != null && (type == 'object' || type == 'function'); } /**
                        * Checks if `value` is object-like. A value is object-like if it's not `null`
                        * and has a `typeof` result of "object".
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                        * @example
                        *
                        * _.isObjectLike({});
                        * // => true
                        *
                        * _.isObjectLike([1, 2, 3]);
                        * // => true
                        *
                        * _.isObjectLike(_.noop);
                        * // => false
                        *
                        * _.isObjectLike(null);
                        * // => false
                        */
                        function isObjectLike(value) { return value != null && typeof value == 'object'; } /**
                        * Checks if `value` is classified as a `Map` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a map, else `false`.
                        * @example
                        *
                        * _.isMap(new Map);
                        * // => true
                        *
                        * _.isMap(new WeakMap);
                        * // => false
                        */
                        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap; /**
                        * Performs a partial deep comparison between `object` and `source` to
                        * determine if `object` contains equivalent property values.
                        *
                        * **Note:** This method is equivalent to `_.matches` when `source` is
                        * partially applied.
                        *
                        * Partial comparisons will match empty array and empty object `source`
                        * values against any array or object value, respectively. See `_.isEqual`
                        * for a list of supported value comparisons.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Lang
                        * @param {Object} object The object to inspect.
                        * @param {Object} source The object of property values to match.
                        * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': 2 };
                        *
                        * _.isMatch(object, { 'b': 2 });
                        * // => true
                        *
                        * _.isMatch(object, { 'b': 1 });
                        * // => false
                        */
                        function isMatch(object, source) { return object === source || baseIsMatch(object, source, getMatchData(source)); } /**
                        * This method is like `_.isMatch` except that it accepts `customizer` which
                        * is invoked to compare values. If `customizer` returns `undefined`, comparisons
                        * are handled by the method instead. The `customizer` is invoked with five
                        * arguments: (objValue, srcValue, index|key, object, source).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {Object} object The object to inspect.
                        * @param {Object} source The object of property values to match.
                        * @param {Function} [customizer] The function to customize comparisons.
                        * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                        * @example
                        *
                        * function isGreeting(value) {
                        *   return /^h(?:i|ello)$/.test(value);
                        * }
                        *
                        * function customizer(objValue, srcValue) {
                        *   if (isGreeting(objValue) && isGreeting(srcValue)) {
                        *     return true;
                        *   }
                        * }
                        *
                        * var object = { 'greeting': 'hello' };
                        * var source = { 'greeting': 'hi' };
                        *
                        * _.isMatchWith(object, source, customizer);
                        * // => true
                        */
                        function isMatchWith(object, source, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; return baseIsMatch(object, source, getMatchData(source), customizer); } /**
                        * Checks if `value` is `NaN`.
                        *
                        * **Note:** This method is based on
                        * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
                        * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
                        * `undefined` and other non-number values.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                        * @example
                        *
                        * _.isNaN(NaN);
                        * // => true
                        *
                        * _.isNaN(new Number(NaN));
                        * // => true
                        *
                        * isNaN(undefined);
                        * // => true
                        *
                        * _.isNaN(undefined);
                        * // => false
                        */
                        function isNaN(value) {
                            // Perform the `toStringTag` check first to avoid errors with some
                            // ActiveX objects in IE.
                            return isNumber(value) && value != +value;
                        } /**
                                 * Checks if `value` is a pristine native function.
                                 *
                                 * **Note:** This method can't reliably detect native functions in the presence
                                 * of the core-js package because core-js circumvents this kind of detection.
                                 * Despite multiple requests, the core-js maintainer has made it clear: any
                                 * attempt to fix the detection will be obstructed. As a result, we're left
                                 * with little choice but to throw an error. Unfortunately, this also affects
                                 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
                                 * which rely on core-js.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 3.0.0
                                 * @category Lang
                                 * @param {*} value The value to check.
                                 * @returns {boolean} Returns `true` if `value` is a native function,
                                 *  else `false`.
                                 * @example
                                 *
                                 * _.isNative(Array.prototype.push);
                                 * // => true
                                 *
                                 * _.isNative(_);
                                 * // => false
                                 */
                        function isNative(value) { if (isMaskable(value)) {
                            throw new Error(CORE_ERROR_TEXT);
                        } return baseIsNative(value); } /**
                        * Checks if `value` is `null`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
                        * @example
                        *
                        * _.isNull(null);
                        * // => true
                        *
                        * _.isNull(void 0);
                        * // => false
                        */
                        function isNull(value) { return value === null; } /**
                        * Checks if `value` is `null` or `undefined`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
                        * @example
                        *
                        * _.isNil(null);
                        * // => true
                        *
                        * _.isNil(void 0);
                        * // => true
                        *
                        * _.isNil(NaN);
                        * // => false
                        */
                        function isNil(value) { return value == null; } /**
                        * Checks if `value` is classified as a `Number` primitive or object.
                        *
                        * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
                        * classified as numbers, use the `_.isFinite` method.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a number, else `false`.
                        * @example
                        *
                        * _.isNumber(3);
                        * // => true
                        *
                        * _.isNumber(Number.MIN_VALUE);
                        * // => true
                        *
                        * _.isNumber(Infinity);
                        * // => true
                        *
                        * _.isNumber('3');
                        * // => false
                        */
                        function isNumber(value) { return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag; } /**
                        * Checks if `value` is a plain object, that is, an object created by the
                        * `Object` constructor or one with a `[[Prototype]]` of `null`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.8.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        * }
                        *
                        * _.isPlainObject(new Foo);
                        * // => false
                        *
                        * _.isPlainObject([1, 2, 3]);
                        * // => false
                        *
                        * _.isPlainObject({ 'x': 0, 'y': 0 });
                        * // => true
                        *
                        * _.isPlainObject(Object.create(null));
                        * // => true
                        */
                        function isPlainObject(value) { if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                            return false;
                        } var proto = getPrototype(value); if (proto === null) {
                            return true;
                        } var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor; return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString; } /**
                        * Checks if `value` is classified as a `RegExp` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.1.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
                        * @example
                        *
                        * _.isRegExp(/abc/);
                        * // => true
                        *
                        * _.isRegExp('/abc/');
                        * // => false
                        */
                        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp; /**
                        * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
                        * double precision number which isn't the result of a rounded unsafe integer.
                        *
                        * **Note:** This method is based on
                        * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
                        * @example
                        *
                        * _.isSafeInteger(3);
                        * // => true
                        *
                        * _.isSafeInteger(Number.MIN_VALUE);
                        * // => false
                        *
                        * _.isSafeInteger(Infinity);
                        * // => false
                        *
                        * _.isSafeInteger('3');
                        * // => false
                        */
                        function isSafeInteger(value) { return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER; } /**
                        * Checks if `value` is classified as a `Set` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a set, else `false`.
                        * @example
                        *
                        * _.isSet(new Set);
                        * // => true
                        *
                        * _.isSet(new WeakSet);
                        * // => false
                        */
                        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet; /**
                        * Checks if `value` is classified as a `String` primitive or object.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a string, else `false`.
                        * @example
                        *
                        * _.isString('abc');
                        * // => true
                        *
                        * _.isString(1);
                        * // => false
                        */
                        function isString(value) { return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag; } /**
                        * Checks if `value` is classified as a `Symbol` primitive or object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
                        * @example
                        *
                        * _.isSymbol(Symbol.iterator);
                        * // => true
                        *
                        * _.isSymbol('abc');
                        * // => false
                        */
                        function isSymbol(value) { return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag; } /**
                        * Checks if `value` is classified as a typed array.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                        * @example
                        *
                        * _.isTypedArray(new Uint8Array);
                        * // => true
                        *
                        * _.isTypedArray([]);
                        * // => false
                        */
                        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray; /**
                        * Checks if `value` is `undefined`.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
                        * @example
                        *
                        * _.isUndefined(void 0);
                        * // => true
                        *
                        * _.isUndefined(null);
                        * // => false
                        */
                        function isUndefined(value) { return value === undefined; } /**
                        * Checks if `value` is classified as a `WeakMap` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
                        * @example
                        *
                        * _.isWeakMap(new WeakMap);
                        * // => true
                        *
                        * _.isWeakMap(new Map);
                        * // => false
                        */
                        function isWeakMap(value) { return isObjectLike(value) && getTag(value) == weakMapTag; } /**
                        * Checks if `value` is classified as a `WeakSet` object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.3.0
                        * @category Lang
                        * @param {*} value The value to check.
                        * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
                        * @example
                        *
                        * _.isWeakSet(new WeakSet);
                        * // => true
                        *
                        * _.isWeakSet(new Set);
                        * // => false
                        */
                        function isWeakSet(value) { return isObjectLike(value) && baseGetTag(value) == weakSetTag; } /**
                        * Checks if `value` is less than `other`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.9.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is less than `other`,
                        *  else `false`.
                        * @see _.gt
                        * @example
                        *
                        * _.lt(1, 3);
                        * // => true
                        *
                        * _.lt(3, 3);
                        * // => false
                        *
                        * _.lt(3, 1);
                        * // => false
                        */
                        var lt = createRelationalOperation(baseLt); /**
                        * Checks if `value` is less than or equal to `other`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.9.0
                        * @category Lang
                        * @param {*} value The value to compare.
                        * @param {*} other The other value to compare.
                        * @returns {boolean} Returns `true` if `value` is less than or equal to
                        *  `other`, else `false`.
                        * @see _.gte
                        * @example
                        *
                        * _.lte(1, 3);
                        * // => true
                        *
                        * _.lte(3, 3);
                        * // => true
                        *
                        * _.lte(3, 1);
                        * // => false
                        */
                        var lte = createRelationalOperation(function (value, other) { return value <= other; }); /**
                        * Converts `value` to an array.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {Array} Returns the converted array.
                        * @example
                        *
                        * _.toArray({ 'a': 1, 'b': 2 });
                        * // => [1, 2]
                        *
                        * _.toArray('abc');
                        * // => ['a', 'b', 'c']
                        *
                        * _.toArray(1);
                        * // => []
                        *
                        * _.toArray(null);
                        * // => []
                        */
                        function toArray(value) { if (!value) {
                            return [];
                        } if (isArrayLike(value)) {
                            return isString(value) ? stringToArray(value) : copyArray(value);
                        } if (symIterator && value[symIterator]) {
                            return iteratorToArray(value[symIterator]());
                        } var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values; return func(value); } /**
                        * Converts `value` to a finite number.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.12.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {number} Returns the converted number.
                        * @example
                        *
                        * _.toFinite(3.2);
                        * // => 3.2
                        *
                        * _.toFinite(Number.MIN_VALUE);
                        * // => 5e-324
                        *
                        * _.toFinite(Infinity);
                        * // => 1.7976931348623157e+308
                        *
                        * _.toFinite('3.2');
                        * // => 3.2
                        */
                        function toFinite(value) { if (!value) {
                            return value === 0 ? value : 0;
                        } value = toNumber(value); if (value === INFINITY || value === -INFINITY) {
                            var sign = value < 0 ? -1 : 1;
                            return sign * MAX_INTEGER;
                        } return value === value ? value : 0; } /**
                        * Converts `value` to an integer.
                        *
                        * **Note:** This method is loosely based on
                        * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {number} Returns the converted integer.
                        * @example
                        *
                        * _.toInteger(3.2);
                        * // => 3
                        *
                        * _.toInteger(Number.MIN_VALUE);
                        * // => 0
                        *
                        * _.toInteger(Infinity);
                        * // => 1.7976931348623157e+308
                        *
                        * _.toInteger('3.2');
                        * // => 3
                        */
                        function toInteger(value) { var result = toFinite(value), remainder = result % 1; return result === result ? remainder ? result - remainder : result : 0; } /**
                        * Converts `value` to an integer suitable for use as the length of an
                        * array-like object.
                        *
                        * **Note:** This method is based on
                        * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {number} Returns the converted integer.
                        * @example
                        *
                        * _.toLength(3.2);
                        * // => 3
                        *
                        * _.toLength(Number.MIN_VALUE);
                        * // => 0
                        *
                        * _.toLength(Infinity);
                        * // => 4294967295
                        *
                        * _.toLength('3.2');
                        * // => 3
                        */
                        function toLength(value) { return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0; } /**
                        * Converts `value` to a number.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to process.
                        * @returns {number} Returns the number.
                        * @example
                        *
                        * _.toNumber(3.2);
                        * // => 3.2
                        *
                        * _.toNumber(Number.MIN_VALUE);
                        * // => 5e-324
                        *
                        * _.toNumber(Infinity);
                        * // => Infinity
                        *
                        * _.toNumber('3.2');
                        * // => 3.2
                        */
                        function toNumber(value) { if (typeof value == 'number') {
                            return value;
                        } if (isSymbol(value)) {
                            return NAN;
                        } if (isObject(value)) {
                            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                            value = isObject(other) ? other + '' : other;
                        } if (typeof value != 'string') {
                            return value === 0 ? value : +value;
                        } value = baseTrim(value); var isBinary = reIsBinary.test(value); return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value; } /**
                        * Converts `value` to a plain object flattening inherited enumerable string
                        * keyed properties of `value` to own properties of the plain object.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {Object} Returns the converted plain object.
                        * @example
                        *
                        * function Foo() {
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.assign({ 'a': 1 }, new Foo);
                        * // => { 'a': 1, 'b': 2 }
                        *
                        * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
                        * // => { 'a': 1, 'b': 2, 'c': 3 }
                        */
                        function toPlainObject(value) { return copyObject(value, keysIn(value)); } /**
                        * Converts `value` to a safe integer. A safe integer can be compared and
                        * represented correctly.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {number} Returns the converted integer.
                        * @example
                        *
                        * _.toSafeInteger(3.2);
                        * // => 3
                        *
                        * _.toSafeInteger(Number.MIN_VALUE);
                        * // => 0
                        *
                        * _.toSafeInteger(Infinity);
                        * // => 9007199254740991
                        *
                        * _.toSafeInteger('3.2');
                        * // => 3
                        */
                        function toSafeInteger(value) { return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0; } /**
                        * Converts `value` to a string. An empty string is returned for `null`
                        * and `undefined` values. The sign of `-0` is preserved.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Lang
                        * @param {*} value The value to convert.
                        * @returns {string} Returns the converted string.
                        * @example
                        *
                        * _.toString(null);
                        * // => ''
                        *
                        * _.toString(-0);
                        * // => '-0'
                        *
                        * _.toString([1, 2, 3]);
                        * // => '1,2,3'
                        */
                        function toString(value) { return value == null ? '' : baseToString(value); } /*------------------------------------------------------------------------*/ /**
                        * Assigns own enumerable string keyed properties of source objects to the
                        * destination object. Source objects are applied from left to right.
                        * Subsequent sources overwrite property assignments of previous sources.
                        *
                        * **Note:** This method mutates `object` and is loosely based on
                        * [`Object.assign`](https://mdn.io/Object/assign).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.10.0
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} [sources] The source objects.
                        * @returns {Object} Returns `object`.
                        * @see _.assignIn
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        * }
                        *
                        * function Bar() {
                        *   this.c = 3;
                        * }
                        *
                        * Foo.prototype.b = 2;
                        * Bar.prototype.d = 4;
                        *
                        * _.assign({ 'a': 0 }, new Foo, new Bar);
                        * // => { 'a': 1, 'c': 3 }
                        */
                        var assign = createAssigner(function (object, source) { if (isPrototype(source) || isArrayLike(source)) {
                            copyObject(source, keys(source), object);
                            return;
                        } for (var key in source) {
                            if (hasOwnProperty.call(source, key)) {
                                assignValue(object, key, source[key]);
                            }
                        } }); /**
                        * This method is like `_.assign` except that it iterates over own and
                        * inherited source properties.
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @alias extend
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} [sources] The source objects.
                        * @returns {Object} Returns `object`.
                        * @see _.assign
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        * }
                        *
                        * function Bar() {
                        *   this.c = 3;
                        * }
                        *
                        * Foo.prototype.b = 2;
                        * Bar.prototype.d = 4;
                        *
                        * _.assignIn({ 'a': 0 }, new Foo, new Bar);
                        * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
                        */
                        var assignIn = createAssigner(function (object, source) { copyObject(source, keysIn(source), object); }); /**
                        * This method is like `_.assignIn` except that it accepts `customizer`
                        * which is invoked to produce the assigned values. If `customizer` returns
                        * `undefined`, assignment is handled by the method instead. The `customizer`
                        * is invoked with five arguments: (objValue, srcValue, key, object, source).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @alias extendWith
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} sources The source objects.
                        * @param {Function} [customizer] The function to customize assigned values.
                        * @returns {Object} Returns `object`.
                        * @see _.assignWith
                        * @example
                        *
                        * function customizer(objValue, srcValue) {
                        *   return _.isUndefined(objValue) ? srcValue : objValue;
                        * }
                        *
                        * var defaults = _.partialRight(_.assignInWith, customizer);
                        *
                        * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                        * // => { 'a': 1, 'b': 2 }
                        */
                        var assignInWith = createAssigner(function (object, source, srcIndex, customizer) { copyObject(source, keysIn(source), object, customizer); }); /**
                        * This method is like `_.assign` except that it accepts `customizer`
                        * which is invoked to produce the assigned values. If `customizer` returns
                        * `undefined`, assignment is handled by the method instead. The `customizer`
                        * is invoked with five arguments: (objValue, srcValue, key, object, source).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} sources The source objects.
                        * @param {Function} [customizer] The function to customize assigned values.
                        * @returns {Object} Returns `object`.
                        * @see _.assignInWith
                        * @example
                        *
                        * function customizer(objValue, srcValue) {
                        *   return _.isUndefined(objValue) ? srcValue : objValue;
                        * }
                        *
                        * var defaults = _.partialRight(_.assignWith, customizer);
                        *
                        * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                        * // => { 'a': 1, 'b': 2 }
                        */
                        var assignWith = createAssigner(function (object, source, srcIndex, customizer) { copyObject(source, keys(source), object, customizer); }); /**
                        * Creates an array of values corresponding to `paths` of `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.0.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {...(string|string[])} [paths] The property paths to pick.
                        * @returns {Array} Returns the picked values.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
                        *
                        * _.at(object, ['a[0].b.c', 'a[1]']);
                        * // => [3, 4]
                        */
                        var at = flatRest(baseAt); /**
                        * Creates an object that inherits from the `prototype` object. If a
                        * `properties` object is given, its own enumerable string keyed properties
                        * are assigned to the created object.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.3.0
                        * @category Object
                        * @param {Object} prototype The object to inherit from.
                        * @param {Object} [properties] The properties to assign to the object.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * function Shape() {
                        *   this.x = 0;
                        *   this.y = 0;
                        * }
                        *
                        * function Circle() {
                        *   Shape.call(this);
                        * }
                        *
                        * Circle.prototype = _.create(Shape.prototype, {
                        *   'constructor': Circle
                        * });
                        *
                        * var circle = new Circle;
                        * circle instanceof Circle;
                        * // => true
                        *
                        * circle instanceof Shape;
                        * // => true
                        */
                        function create(prototype, properties) { var result = baseCreate(prototype); return properties == null ? result : baseAssign(result, properties); } /**
                        * Assigns own and inherited enumerable string keyed properties of source
                        * objects to the destination object for all destination properties that
                        * resolve to `undefined`. Source objects are applied from left to right.
                        * Once a property is set, additional values of the same property are ignored.
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} [sources] The source objects.
                        * @returns {Object} Returns `object`.
                        * @see _.defaultsDeep
                        * @example
                        *
                        * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                        * // => { 'a': 1, 'b': 2 }
                        */
                        var defaults = baseRest(function (object, sources) { object = Object(object); var index = -1; var length = sources.length; var guard = length > 2 ? sources[2] : undefined; if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                            length = 1;
                        } while (++index < length) {
                            var source = sources[index];
                            var props = keysIn(source);
                            var propsIndex = -1;
                            var propsLength = props.length;
                            while (++propsIndex < propsLength) {
                                var key = props[propsIndex];
                                var value = object[key];
                                if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                                    object[key] = source[key];
                                }
                            }
                        } return object; }); /**
                        * This method is like `_.defaults` except that it recursively assigns
                        * default properties.
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.10.0
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} [sources] The source objects.
                        * @returns {Object} Returns `object`.
                        * @see _.defaults
                        * @example
                        *
                        * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
                        * // => { 'a': { 'b': 2, 'c': 3 } }
                        */
                        var defaultsDeep = baseRest(function (args) { args.push(undefined, customDefaultsMerge); return apply(mergeWith, undefined, args); }); /**
                        * This method is like `_.find` except that it returns the key of the first
                        * element `predicate` returns truthy for instead of the element itself.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.1.0
                        * @category Object
                        * @param {Object} object The object to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {string|undefined} Returns the key of the matched element,
                        *  else `undefined`.
                        * @example
                        *
                        * var users = {
                        *   'barney':  { 'age': 36, 'active': true },
                        *   'fred':    { 'age': 40, 'active': false },
                        *   'pebbles': { 'age': 1,  'active': true }
                        * };
                        *
                        * _.findKey(users, function(o) { return o.age < 40; });
                        * // => 'barney' (iteration order is not guaranteed)
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.findKey(users, { 'age': 1, 'active': true });
                        * // => 'pebbles'
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.findKey(users, ['active', false]);
                        * // => 'fred'
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.findKey(users, 'active');
                        * // => 'barney'
                        */
                        function findKey(object, predicate) { return baseFindKey(object, getIteratee(predicate, 3), baseForOwn); } /**
                        * This method is like `_.findKey` except that it iterates over elements of
                        * a collection in the opposite order.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Object
                        * @param {Object} object The object to inspect.
                        * @param {Function} [predicate=_.identity] The function invoked per iteration.
                        * @returns {string|undefined} Returns the key of the matched element,
                        *  else `undefined`.
                        * @example
                        *
                        * var users = {
                        *   'barney':  { 'age': 36, 'active': true },
                        *   'fred':    { 'age': 40, 'active': false },
                        *   'pebbles': { 'age': 1,  'active': true }
                        * };
                        *
                        * _.findLastKey(users, function(o) { return o.age < 40; });
                        * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.findLastKey(users, { 'age': 36, 'active': true });
                        * // => 'barney'
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.findLastKey(users, ['active', false]);
                        * // => 'fred'
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.findLastKey(users, 'active');
                        * // => 'pebbles'
                        */
                        function findLastKey(object, predicate) { return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight); } /**
                        * Iterates over own and inherited enumerable string keyed properties of an
                        * object and invokes `iteratee` for each property. The iteratee is invoked
                        * with three arguments: (value, key, object). Iteratee functions may exit
                        * iteration early by explicitly returning `false`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.3.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        * @see _.forInRight
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.forIn(new Foo, function(value, key) {
                        *   console.log(key);
                        * });
                        * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
                        */
                        function forIn(object, iteratee) { return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn); } /**
                        * This method is like `_.forIn` except that it iterates over properties of
                        * `object` in the opposite order.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        * @see _.forIn
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.forInRight(new Foo, function(value, key) {
                        *   console.log(key);
                        * });
                        * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
                        */
                        function forInRight(object, iteratee) { return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn); } /**
                        * Iterates over own enumerable string keyed properties of an object and
                        * invokes `iteratee` for each property. The iteratee is invoked with three
                        * arguments: (value, key, object). Iteratee functions may exit iteration
                        * early by explicitly returning `false`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.3.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        * @see _.forOwnRight
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.forOwn(new Foo, function(value, key) {
                        *   console.log(key);
                        * });
                        * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                        */
                        function forOwn(object, iteratee) { return object && baseForOwn(object, getIteratee(iteratee, 3)); } /**
                        * This method is like `_.forOwn` except that it iterates over properties of
                        * `object` in the opposite order.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.0.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns `object`.
                        * @see _.forOwn
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.forOwnRight(new Foo, function(value, key) {
                        *   console.log(key);
                        * });
                        * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
                        */
                        function forOwnRight(object, iteratee) { return object && baseForOwnRight(object, getIteratee(iteratee, 3)); } /**
                        * Creates an array of function property names from own enumerable properties
                        * of `object`.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The object to inspect.
                        * @returns {Array} Returns the function names.
                        * @see _.functionsIn
                        * @example
                        *
                        * function Foo() {
                        *   this.a = _.constant('a');
                        *   this.b = _.constant('b');
                        * }
                        *
                        * Foo.prototype.c = _.constant('c');
                        *
                        * _.functions(new Foo);
                        * // => ['a', 'b']
                        */
                        function functions(object) { return object == null ? [] : baseFunctions(object, keys(object)); } /**
                        * Creates an array of function property names from own and inherited
                        * enumerable properties of `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The object to inspect.
                        * @returns {Array} Returns the function names.
                        * @see _.functions
                        * @example
                        *
                        * function Foo() {
                        *   this.a = _.constant('a');
                        *   this.b = _.constant('b');
                        * }
                        *
                        * Foo.prototype.c = _.constant('c');
                        *
                        * _.functionsIn(new Foo);
                        * // => ['a', 'b', 'c']
                        */
                        function functionsIn(object) { return object == null ? [] : baseFunctions(object, keysIn(object)); } /**
                        * Gets the value at `path` of `object`. If the resolved value is
                        * `undefined`, the `defaultValue` is returned in its place.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.7.0
                        * @category Object
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path of the property to get.
                        * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                        * @returns {*} Returns the resolved value.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                        *
                        * _.get(object, 'a[0].b.c');
                        * // => 3
                        *
                        * _.get(object, ['a', '0', 'b', 'c']);
                        * // => 3
                        *
                        * _.get(object, 'a.b.c', 'default');
                        * // => 'default'
                        */
                        function get(object, path, defaultValue) { var result = object == null ? undefined : baseGet(object, path); return result === undefined ? defaultValue : result; } /**
                        * Checks if `path` is a direct property of `object`.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path to check.
                        * @returns {boolean} Returns `true` if `path` exists, else `false`.
                        * @example
                        *
                        * var object = { 'a': { 'b': 2 } };
                        * var other = _.create({ 'a': _.create({ 'b': 2 }) });
                        *
                        * _.has(object, 'a');
                        * // => true
                        *
                        * _.has(object, 'a.b');
                        * // => true
                        *
                        * _.has(object, ['a', 'b']);
                        * // => true
                        *
                        * _.has(other, 'a');
                        * // => false
                        */
                        function has(object, path) { return object != null && hasPath(object, path, baseHas); } /**
                        * Checks if `path` is a direct or inherited property of `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path to check.
                        * @returns {boolean} Returns `true` if `path` exists, else `false`.
                        * @example
                        *
                        * var object = _.create({ 'a': _.create({ 'b': 2 }) });
                        *
                        * _.hasIn(object, 'a');
                        * // => true
                        *
                        * _.hasIn(object, 'a.b');
                        * // => true
                        *
                        * _.hasIn(object, ['a', 'b']);
                        * // => true
                        *
                        * _.hasIn(object, 'b');
                        * // => false
                        */
                        function hasIn(object, path) { return object != null && hasPath(object, path, baseHasIn); } /**
                        * Creates an object composed of the inverted keys and values of `object`.
                        * If `object` contains duplicate values, subsequent values overwrite
                        * property assignments of previous values.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.7.0
                        * @category Object
                        * @param {Object} object The object to invert.
                        * @returns {Object} Returns the new inverted object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': 2, 'c': 1 };
                        *
                        * _.invert(object);
                        * // => { '1': 'c', '2': 'b' }
                        */
                        var invert = createInverter(function (result, value, key) { if (value != null && typeof value.toString != 'function') {
                            value = nativeObjectToString.call(value);
                        } result[value] = key; }, constant(identity)); /**
                        * This method is like `_.invert` except that the inverted object is generated
                        * from the results of running each element of `object` thru `iteratee`. The
                        * corresponding inverted value of each inverted key is an array of keys
                        * responsible for generating the inverted value. The iteratee is invoked
                        * with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.1.0
                        * @category Object
                        * @param {Object} object The object to invert.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {Object} Returns the new inverted object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': 2, 'c': 1 };
                        *
                        * _.invertBy(object);
                        * // => { '1': ['a', 'c'], '2': ['b'] }
                        *
                        * _.invertBy(object, function(value) {
                        *   return 'group' + value;
                        * });
                        * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
                        */
                        var invertBy = createInverter(function (result, value, key) { if (value != null && typeof value.toString != 'function') {
                            value = nativeObjectToString.call(value);
                        } if (hasOwnProperty.call(result, value)) {
                            result[value].push(key);
                        }
                        else {
                            result[value] = [key];
                        } }, getIteratee); /**
                        * Invokes the method at `path` of `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path of the method to invoke.
                        * @param {...*} [args] The arguments to invoke the method with.
                        * @returns {*} Returns the result of the invoked method.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
                        *
                        * _.invoke(object, 'a[0].b.c.slice', 1, 3);
                        * // => [2, 3]
                        */
                        var invoke = baseRest(baseInvoke); /**
                        * Creates an array of the own enumerable property names of `object`.
                        *
                        * **Note:** Non-object values are coerced to objects. See the
                        * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                        * for more details.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property names.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.keys(new Foo);
                        * // => ['a', 'b'] (iteration order is not guaranteed)
                        *
                        * _.keys('hi');
                        * // => ['0', '1']
                        */
                        function keys(object) { return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object); } /**
                        * Creates an array of the own and inherited enumerable property names of `object`.
                        *
                        * **Note:** Non-object values are coerced to objects.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property names.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.keysIn(new Foo);
                        * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
                        */
                        function keysIn(object) { return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object); } /**
                        * The opposite of `_.mapValues`; this method creates an object with the
                        * same values as `object` and keys generated by running each own enumerable
                        * string keyed property of `object` thru `iteratee`. The iteratee is invoked
                        * with three arguments: (value, key, object).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.8.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns the new mapped object.
                        * @see _.mapValues
                        * @example
                        *
                        * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
                        *   return key + value;
                        * });
                        * // => { 'a1': 1, 'b2': 2 }
                        */
                        function mapKeys(object, iteratee) { var result = {}; iteratee = getIteratee(iteratee, 3); baseForOwn(object, function (value, key, object) { baseAssignValue(result, iteratee(value, key, object), value); }); return result; } /**
                        * Creates an object with the same keys as `object` and values generated
                        * by running each own enumerable string keyed property of `object` thru
                        * `iteratee`. The iteratee is invoked with three arguments:
                        * (value, key, object).
                        *
                        * @static
                        * @memberOf _
                        * @since 2.4.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Object} Returns the new mapped object.
                        * @see _.mapKeys
                        * @example
                        *
                        * var users = {
                        *   'fred':    { 'user': 'fred',    'age': 40 },
                        *   'pebbles': { 'user': 'pebbles', 'age': 1 }
                        * };
                        *
                        * _.mapValues(users, function(o) { return o.age; });
                        * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.mapValues(users, 'age');
                        * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                        */
                        function mapValues(object, iteratee) { var result = {}; iteratee = getIteratee(iteratee, 3); baseForOwn(object, function (value, key, object) { baseAssignValue(result, key, iteratee(value, key, object)); }); return result; } /**
                        * This method is like `_.assign` except that it recursively merges own and
                        * inherited enumerable string keyed properties of source objects into the
                        * destination object. Source properties that resolve to `undefined` are
                        * skipped if a destination value exists. Array and plain object properties
                        * are merged recursively. Other objects and value types are overridden by
                        * assignment. Source objects are applied from left to right. Subsequent
                        * sources overwrite property assignments of previous sources.
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.5.0
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} [sources] The source objects.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * var object = {
                        *   'a': [{ 'b': 2 }, { 'd': 4 }]
                        * };
                        *
                        * var other = {
                        *   'a': [{ 'c': 3 }, { 'e': 5 }]
                        * };
                        *
                        * _.merge(object, other);
                        * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
                        */
                        var merge = createAssigner(function (object, source, srcIndex) { baseMerge(object, source, srcIndex); }); /**
                        * This method is like `_.merge` except that it accepts `customizer` which
                        * is invoked to produce the merged values of the destination and source
                        * properties. If `customizer` returns `undefined`, merging is handled by the
                        * method instead. The `customizer` is invoked with six arguments:
                        * (objValue, srcValue, key, object, source, stack).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The destination object.
                        * @param {...Object} sources The source objects.
                        * @param {Function} customizer The function to customize assigned values.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * function customizer(objValue, srcValue) {
                        *   if (_.isArray(objValue)) {
                        *     return objValue.concat(srcValue);
                        *   }
                        * }
                        *
                        * var object = { 'a': [1], 'b': [2] };
                        * var other = { 'a': [3], 'b': [4] };
                        *
                        * _.mergeWith(object, other, customizer);
                        * // => { 'a': [1, 3], 'b': [2, 4] }
                        */
                        var mergeWith = createAssigner(function (object, source, srcIndex, customizer) { baseMerge(object, source, srcIndex, customizer); }); /**
                        * The opposite of `_.pick`; this method creates an object composed of the
                        * own and inherited enumerable property paths of `object` that are not omitted.
                        *
                        * **Note:** This method is considerably slower than `_.pick`.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The source object.
                        * @param {...(string|string[])} [paths] The property paths to omit.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': '2', 'c': 3 };
                        *
                        * _.omit(object, ['a', 'c']);
                        * // => { 'b': '2' }
                        */
                        var omit = flatRest(function (object, paths) { var result = {}; if (object == null) {
                            return result;
                        } var isDeep = false; paths = arrayMap(paths, function (path) { path = castPath(path, object); isDeep || (isDeep = path.length > 1); return path; }); copyObject(object, getAllKeysIn(object), result); if (isDeep) {
                            result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                        } var length = paths.length; while (length--) {
                            baseUnset(result, paths[length]);
                        } return result; }); /**
                        * The opposite of `_.pickBy`; this method creates an object composed of
                        * the own and inherited enumerable string keyed properties of `object` that
                        * `predicate` doesn't return truthy for. The predicate is invoked with two
                        * arguments: (value, key).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The source object.
                        * @param {Function} [predicate=_.identity] The function invoked per property.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': '2', 'c': 3 };
                        *
                        * _.omitBy(object, _.isNumber);
                        * // => { 'b': '2' }
                        */
                        function omitBy(object, predicate) { return pickBy(object, negate(getIteratee(predicate))); } /**
                        * Creates an object composed of the picked `object` properties.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The source object.
                        * @param {...(string|string[])} [paths] The property paths to pick.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': '2', 'c': 3 };
                        *
                        * _.pick(object, ['a', 'c']);
                        * // => { 'a': 1, 'c': 3 }
                        */
                        var pick = flatRest(function (object, paths) { return object == null ? {} : basePick(object, paths); }); /**
                        * Creates an object composed of the `object` properties `predicate` returns
                        * truthy for. The predicate is invoked with two arguments: (value, key).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The source object.
                        * @param {Function} [predicate=_.identity] The function invoked per property.
                        * @returns {Object} Returns the new object.
                        * @example
                        *
                        * var object = { 'a': 1, 'b': '2', 'c': 3 };
                        *
                        * _.pickBy(object, _.isNumber);
                        * // => { 'a': 1, 'c': 3 }
                        */
                        function pickBy(object, predicate) { if (object == null) {
                            return {};
                        } var props = arrayMap(getAllKeysIn(object), function (prop) { return [prop]; }); predicate = getIteratee(predicate); return basePickBy(object, props, function (value, path) { return predicate(value, path[0]); }); } /**
                        * This method is like `_.get` except that if the resolved value is a
                        * function it's invoked with the `this` binding of its parent object and
                        * its result is returned.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The object to query.
                        * @param {Array|string} path The path of the property to resolve.
                        * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                        * @returns {*} Returns the resolved value.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
                        *
                        * _.result(object, 'a[0].b.c1');
                        * // => 3
                        *
                        * _.result(object, 'a[0].b.c2');
                        * // => 4
                        *
                        * _.result(object, 'a[0].b.c3', 'default');
                        * // => 'default'
                        *
                        * _.result(object, 'a[0].b.c3', _.constant('default'));
                        * // => 'default'
                        */
                        function result(object, path, defaultValue) {
                            path = castPath(path, object);
                            var index = -1, length = path.length; // Ensure the loop is entered when path is empty.
                            if (!length) {
                                length = 1;
                                object = undefined;
                            }
                            while (++index < length) {
                                var value = object == null ? undefined : object[toKey(path[index])];
                                if (value === undefined) {
                                    index = length;
                                    value = defaultValue;
                                }
                                object = isFunction(value) ? value.call(object) : value;
                            }
                            return object;
                        } /**
                                 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
                                 * it's created. Arrays are created for missing index properties while objects
                                 * are created for all other missing properties. Use `_.setWith` to customize
                                 * `path` creation.
                                 *
                                 * **Note:** This method mutates `object`.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 3.7.0
                                 * @category Object
                                 * @param {Object} object The object to modify.
                                 * @param {Array|string} path The path of the property to set.
                                 * @param {*} value The value to set.
                                 * @returns {Object} Returns `object`.
                                 * @example
                                 *
                                 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                                 *
                                 * _.set(object, 'a[0].b.c', 4);
                                 * console.log(object.a[0].b.c);
                                 * // => 4
                                 *
                                 * _.set(object, ['x', '0', 'y', 'z'], 5);
                                 * console.log(object.x[0].y.z);
                                 * // => 5
                                 */
                        function set(object, path, value) { return object == null ? object : baseSet(object, path, value); } /**
                        * This method is like `_.set` except that it accepts `customizer` which is
                        * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
                        * path creation is handled by the method instead. The `customizer` is invoked
                        * with three arguments: (nsValue, key, nsObject).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to set.
                        * @param {*} value The value to set.
                        * @param {Function} [customizer] The function to customize assigned values.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * var object = {};
                        *
                        * _.setWith(object, '[0][1]', 'a', Object);
                        * // => { '0': { '1': 'a' } }
                        */
                        function setWith(object, path, value, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; return object == null ? object : baseSet(object, path, value, customizer); } /**
                        * Creates an array of own enumerable string keyed-value pairs for `object`
                        * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
                        * entries are returned.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @alias entries
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the key-value pairs.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.toPairs(new Foo);
                        * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
                        */
                        var toPairs = createToPairs(keys); /**
                        * Creates an array of own and inherited enumerable string keyed-value pairs
                        * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
                        * or set, its entries are returned.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @alias entriesIn
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the key-value pairs.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.toPairsIn(new Foo);
                        * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
                        */
                        var toPairsIn = createToPairs(keysIn); /**
                        * An alternative to `_.reduce`; this method transforms `object` to a new
                        * `accumulator` object which is the result of running each of its own
                        * enumerable string keyed properties thru `iteratee`, with each invocation
                        * potentially mutating the `accumulator` object. If `accumulator` is not
                        * provided, a new object with the same `[[Prototype]]` will be used. The
                        * iteratee is invoked with four arguments: (accumulator, value, key, object).
                        * Iteratee functions may exit iteration early by explicitly returning `false`.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.3.0
                        * @category Object
                        * @param {Object} object The object to iterate over.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @param {*} [accumulator] The custom accumulator value.
                        * @returns {*} Returns the accumulated value.
                        * @example
                        *
                        * _.transform([2, 3, 4], function(result, n) {
                        *   result.push(n *= n);
                        *   return n % 2 == 0;
                        * }, []);
                        * // => [4, 9]
                        *
                        * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                        *   (result[value] || (result[value] = [])).push(key);
                        * }, {});
                        * // => { '1': ['a', 'c'], '2': ['b'] }
                        */
                        function transform(object, iteratee, accumulator) { var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object); iteratee = getIteratee(iteratee, 4); if (accumulator == null) {
                            var Ctor = object && object.constructor;
                            if (isArrLike) {
                                accumulator = isArr ? new Ctor() : [];
                            }
                            else if (isObject(object)) {
                                accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                            }
                            else {
                                accumulator = {};
                            }
                        } (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) { return iteratee(accumulator, value, index, object); }); return accumulator; } /**
                        * Removes the property at `path` of `object`.
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Object
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to unset.
                        * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': 7 } }] };
                        * _.unset(object, 'a[0].b.c');
                        * // => true
                        *
                        * console.log(object);
                        * // => { 'a': [{ 'b': {} }] };
                        *
                        * _.unset(object, ['a', '0', 'b', 'c']);
                        * // => true
                        *
                        * console.log(object);
                        * // => { 'a': [{ 'b': {} }] };
                        */
                        function unset(object, path) { return object == null ? true : baseUnset(object, path); } /**
                        * This method is like `_.set` except that accepts `updater` to produce the
                        * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
                        * is invoked with one argument: (value).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.6.0
                        * @category Object
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to set.
                        * @param {Function} updater The function to produce the updated value.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                        *
                        * _.update(object, 'a[0].b.c', function(n) { return n * n; });
                        * console.log(object.a[0].b.c);
                        * // => 9
                        *
                        * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
                        * console.log(object.x[0].y.z);
                        * // => 0
                        */
                        function update(object, path, updater) { return object == null ? object : baseUpdate(object, path, castFunction(updater)); } /**
                        * This method is like `_.update` except that it accepts `customizer` which is
                        * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
                        * path creation is handled by the method instead. The `customizer` is invoked
                        * with three arguments: (nsValue, key, nsObject).
                        *
                        * **Note:** This method mutates `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.6.0
                        * @category Object
                        * @param {Object} object The object to modify.
                        * @param {Array|string} path The path of the property to set.
                        * @param {Function} updater The function to produce the updated value.
                        * @param {Function} [customizer] The function to customize assigned values.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * var object = {};
                        *
                        * _.updateWith(object, '[0][1]', _.constant('a'), Object);
                        * // => { '0': { '1': 'a' } }
                        */
                        function updateWith(object, path, updater, customizer) { customizer = typeof customizer == 'function' ? customizer : undefined; return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer); } /**
                        * Creates an array of the own enumerable string keyed property values of `object`.
                        *
                        * **Note:** Non-object values are coerced to objects.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property values.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.values(new Foo);
                        * // => [1, 2] (iteration order is not guaranteed)
                        *
                        * _.values('hi');
                        * // => ['h', 'i']
                        */
                        function values(object) { return object == null ? [] : baseValues(object, keys(object)); } /**
                        * Creates an array of the own and inherited enumerable string keyed property
                        * values of `object`.
                        *
                        * **Note:** Non-object values are coerced to objects.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Object
                        * @param {Object} object The object to query.
                        * @returns {Array} Returns the array of property values.
                        * @example
                        *
                        * function Foo() {
                        *   this.a = 1;
                        *   this.b = 2;
                        * }
                        *
                        * Foo.prototype.c = 3;
                        *
                        * _.valuesIn(new Foo);
                        * // => [1, 2, 3] (iteration order is not guaranteed)
                        */
                        function valuesIn(object) { return object == null ? [] : baseValues(object, keysIn(object)); } /*------------------------------------------------------------------------*/ /**
                        * Clamps `number` within the inclusive `lower` and `upper` bounds.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Number
                        * @param {number} number The number to clamp.
                        * @param {number} [lower] The lower bound.
                        * @param {number} upper The upper bound.
                        * @returns {number} Returns the clamped number.
                        * @example
                        *
                        * _.clamp(-10, -5, 5);
                        * // => -5
                        *
                        * _.clamp(10, -5, 5);
                        * // => 5
                        */
                        function clamp(number, lower, upper) { if (upper === undefined) {
                            upper = lower;
                            lower = undefined;
                        } if (upper !== undefined) {
                            upper = toNumber(upper);
                            upper = upper === upper ? upper : 0;
                        } if (lower !== undefined) {
                            lower = toNumber(lower);
                            lower = lower === lower ? lower : 0;
                        } return baseClamp(toNumber(number), lower, upper); } /**
                        * Checks if `n` is between `start` and up to, but not including, `end`. If
                        * `end` is not specified, it's set to `start` with `start` then set to `0`.
                        * If `start` is greater than `end` the params are swapped to support
                        * negative ranges.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.3.0
                        * @category Number
                        * @param {number} number The number to check.
                        * @param {number} [start=0] The start of the range.
                        * @param {number} end The end of the range.
                        * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
                        * @see _.range, _.rangeRight
                        * @example
                        *
                        * _.inRange(3, 2, 4);
                        * // => true
                        *
                        * _.inRange(4, 8);
                        * // => true
                        *
                        * _.inRange(4, 2);
                        * // => false
                        *
                        * _.inRange(2, 2);
                        * // => false
                        *
                        * _.inRange(1.2, 2);
                        * // => true
                        *
                        * _.inRange(5.2, 4);
                        * // => false
                        *
                        * _.inRange(-3, -2, -6);
                        * // => true
                        */
                        function inRange(number, start, end) { start = toFinite(start); if (end === undefined) {
                            end = start;
                            start = 0;
                        }
                        else {
                            end = toFinite(end);
                        } number = toNumber(number); return baseInRange(number, start, end); } /**
                        * Produces a random number between the inclusive `lower` and `upper` bounds.
                        * If only one argument is provided a number between `0` and the given number
                        * is returned. If `floating` is `true`, or either `lower` or `upper` are
                        * floats, a floating-point number is returned instead of an integer.
                        *
                        * **Note:** JavaScript follows the IEEE-754 standard for resolving
                        * floating-point values which can produce unexpected results.
                        *
                        * @static
                        * @memberOf _
                        * @since 0.7.0
                        * @category Number
                        * @param {number} [lower=0] The lower bound.
                        * @param {number} [upper=1] The upper bound.
                        * @param {boolean} [floating] Specify returning a floating-point number.
                        * @returns {number} Returns the random number.
                        * @example
                        *
                        * _.random(0, 5);
                        * // => an integer between 0 and 5
                        *
                        * _.random(5);
                        * // => also an integer between 0 and 5
                        *
                        * _.random(5, true);
                        * // => a floating-point number between 0 and 5
                        *
                        * _.random(1.2, 5.2);
                        * // => a floating-point number between 1.2 and 5.2
                        */
                        function random(lower, upper, floating) { if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
                            upper = floating = undefined;
                        } if (floating === undefined) {
                            if (typeof upper == 'boolean') {
                                floating = upper;
                                upper = undefined;
                            }
                            else if (typeof lower == 'boolean') {
                                floating = lower;
                                lower = undefined;
                            }
                        } if (lower === undefined && upper === undefined) {
                            lower = 0;
                            upper = 1;
                        }
                        else {
                            lower = toFinite(lower);
                            if (upper === undefined) {
                                upper = lower;
                                lower = 0;
                            }
                            else {
                                upper = toFinite(upper);
                            }
                        } if (lower > upper) {
                            var temp = lower;
                            lower = upper;
                            upper = temp;
                        } if (floating || lower % 1 || upper % 1) {
                            var rand = nativeRandom();
                            return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                        } return baseRandom(lower, upper); } /*------------------------------------------------------------------------*/ /**
                        * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the camel cased string.
                        * @example
                        *
                        * _.camelCase('Foo Bar');
                        * // => 'fooBar'
                        *
                        * _.camelCase('--foo-bar--');
                        * // => 'fooBar'
                        *
                        * _.camelCase('__FOO_BAR__');
                        * // => 'fooBar'
                        */
                        var camelCase = createCompounder(function (result, word, index) { word = word.toLowerCase(); return result + (index ? capitalize(word) : word); }); /**
                        * Converts the first character of `string` to upper case and the remaining
                        * to lower case.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to capitalize.
                        * @returns {string} Returns the capitalized string.
                        * @example
                        *
                        * _.capitalize('FRED');
                        * // => 'Fred'
                        */
                        function capitalize(string) { return upperFirst(toString(string).toLowerCase()); } /**
                        * Deburrs `string` by converting
                        * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
                        * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
                        * letters to basic Latin letters and removing
                        * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to deburr.
                        * @returns {string} Returns the deburred string.
                        * @example
                        *
                        * _.deburr('déjà vu');
                        * // => 'deja vu'
                        */
                        function deburr(string) { string = toString(string); return string && string.replace(reLatin, deburrLetter).replace(reComboMark, ''); } /**
                        * Checks if `string` ends with the given target string.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to inspect.
                        * @param {string} [target] The string to search for.
                        * @param {number} [position=string.length] The position to search up to.
                        * @returns {boolean} Returns `true` if `string` ends with `target`,
                        *  else `false`.
                        * @example
                        *
                        * _.endsWith('abc', 'c');
                        * // => true
                        *
                        * _.endsWith('abc', 'b');
                        * // => false
                        *
                        * _.endsWith('abc', 'b', 2);
                        * // => true
                        */
                        function endsWith(string, target, position) { string = toString(string); target = baseToString(target); var length = string.length; position = position === undefined ? length : baseClamp(toInteger(position), 0, length); var end = position; position -= target.length; return position >= 0 && string.slice(position, end) == target; } /**
                        * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
                        * corresponding HTML entities.
                        *
                        * **Note:** No other characters are escaped. To escape additional
                        * characters use a third-party library like [_he_](https://mths.be/he).
                        *
                        * Though the ">" character is escaped for symmetry, characters like
                        * ">" and "/" don't need escaping in HTML and have no special meaning
                        * unless they're part of a tag or unquoted attribute value. See
                        * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
                        * (under "semi-related fun fact") for more details.
                        *
                        * When working with HTML you should always
                        * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
                        * XSS vectors.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category String
                        * @param {string} [string=''] The string to escape.
                        * @returns {string} Returns the escaped string.
                        * @example
                        *
                        * _.escape('fred, barney, & pebbles');
                        * // => 'fred, barney, &amp; pebbles'
                        */
                        function escape(string) { string = toString(string); return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string; } /**
                        * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
                        * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to escape.
                        * @returns {string} Returns the escaped string.
                        * @example
                        *
                        * _.escapeRegExp('[lodash](https://lodash.com/)');
                        * // => '\[lodash\]\(https://lodash\.com/\)'
                        */
                        function escapeRegExp(string) { string = toString(string); return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string; } /**
                        * Converts `string` to
                        * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the kebab cased string.
                        * @example
                        *
                        * _.kebabCase('Foo Bar');
                        * // => 'foo-bar'
                        *
                        * _.kebabCase('fooBar');
                        * // => 'foo-bar'
                        *
                        * _.kebabCase('__FOO_BAR__');
                        * // => 'foo-bar'
                        */
                        var kebabCase = createCompounder(function (result, word, index) { return result + (index ? '-' : '') + word.toLowerCase(); }); /**
                        * Converts `string`, as space separated words, to lower case.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the lower cased string.
                        * @example
                        *
                        * _.lowerCase('--Foo-Bar--');
                        * // => 'foo bar'
                        *
                        * _.lowerCase('fooBar');
                        * // => 'foo bar'
                        *
                        * _.lowerCase('__FOO_BAR__');
                        * // => 'foo bar'
                        */
                        var lowerCase = createCompounder(function (result, word, index) { return result + (index ? ' ' : '') + word.toLowerCase(); }); /**
                        * Converts the first character of `string` to lower case.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the converted string.
                        * @example
                        *
                        * _.lowerFirst('Fred');
                        * // => 'fred'
                        *
                        * _.lowerFirst('FRED');
                        * // => 'fRED'
                        */
                        var lowerFirst = createCaseFirst('toLowerCase'); /**
                        * Pads `string` on the left and right sides if it's shorter than `length`.
                        * Padding characters are truncated if they can't be evenly divided by `length`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to pad.
                        * @param {number} [length=0] The padding length.
                        * @param {string} [chars=' '] The string used as padding.
                        * @returns {string} Returns the padded string.
                        * @example
                        *
                        * _.pad('abc', 8);
                        * // => '  abc   '
                        *
                        * _.pad('abc', 8, '_-');
                        * // => '_-abc_-_'
                        *
                        * _.pad('abc', 3);
                        * // => 'abc'
                        */
                        function pad(string, length, chars) { string = toString(string); length = toInteger(length); var strLength = length ? stringSize(string) : 0; if (!length || strLength >= length) {
                            return string;
                        } var mid = (length - strLength) / 2; return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars); } /**
                        * Pads `string` on the right side if it's shorter than `length`. Padding
                        * characters are truncated if they exceed `length`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to pad.
                        * @param {number} [length=0] The padding length.
                        * @param {string} [chars=' '] The string used as padding.
                        * @returns {string} Returns the padded string.
                        * @example
                        *
                        * _.padEnd('abc', 6);
                        * // => 'abc   '
                        *
                        * _.padEnd('abc', 6, '_-');
                        * // => 'abc_-_'
                        *
                        * _.padEnd('abc', 3);
                        * // => 'abc'
                        */
                        function padEnd(string, length, chars) { string = toString(string); length = toInteger(length); var strLength = length ? stringSize(string) : 0; return length && strLength < length ? string + createPadding(length - strLength, chars) : string; } /**
                        * Pads `string` on the left side if it's shorter than `length`. Padding
                        * characters are truncated if they exceed `length`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to pad.
                        * @param {number} [length=0] The padding length.
                        * @param {string} [chars=' '] The string used as padding.
                        * @returns {string} Returns the padded string.
                        * @example
                        *
                        * _.padStart('abc', 6);
                        * // => '   abc'
                        *
                        * _.padStart('abc', 6, '_-');
                        * // => '_-_abc'
                        *
                        * _.padStart('abc', 3);
                        * // => 'abc'
                        */
                        function padStart(string, length, chars) { string = toString(string); length = toInteger(length); var strLength = length ? stringSize(string) : 0; return length && strLength < length ? createPadding(length - strLength, chars) + string : string; } /**
                        * Converts `string` to an integer of the specified radix. If `radix` is
                        * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
                        * hexadecimal, in which case a `radix` of `16` is used.
                        *
                        * **Note:** This method aligns with the
                        * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
                        *
                        * @static
                        * @memberOf _
                        * @since 1.1.0
                        * @category String
                        * @param {string} string The string to convert.
                        * @param {number} [radix=10] The radix to interpret `value` by.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {number} Returns the converted integer.
                        * @example
                        *
                        * _.parseInt('08');
                        * // => 8
                        *
                        * _.map(['6', '08', '10'], _.parseInt);
                        * // => [6, 8, 10]
                        */
                        function parseInt(string, radix, guard) { if (guard || radix == null) {
                            radix = 0;
                        }
                        else if (radix) {
                            radix = +radix;
                        } return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0); } /**
                        * Repeats the given string `n` times.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to repeat.
                        * @param {number} [n=1] The number of times to repeat the string.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {string} Returns the repeated string.
                        * @example
                        *
                        * _.repeat('*', 3);
                        * // => '***'
                        *
                        * _.repeat('abc', 2);
                        * // => 'abcabc'
                        *
                        * _.repeat('abc', 0);
                        * // => ''
                        */
                        function repeat(string, n, guard) { if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
                            n = 1;
                        }
                        else {
                            n = toInteger(n);
                        } return baseRepeat(toString(string), n); } /**
                        * Replaces matches for `pattern` in `string` with `replacement`.
                        *
                        * **Note:** This method is based on
                        * [`String#replace`](https://mdn.io/String/replace).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to modify.
                        * @param {RegExp|string} pattern The pattern to replace.
                        * @param {Function|string} replacement The match replacement.
                        * @returns {string} Returns the modified string.
                        * @example
                        *
                        * _.replace('Hi Fred', 'Fred', 'Barney');
                        * // => 'Hi Barney'
                        */
                        function replace() { var args = arguments, string = toString(args[0]); return args.length < 3 ? string : string.replace(args[1], args[2]); } /**
                        * Converts `string` to
                        * [snake case](https://en.wikipedia.org/wiki/Snake_case).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the snake cased string.
                        * @example
                        *
                        * _.snakeCase('Foo Bar');
                        * // => 'foo_bar'
                        *
                        * _.snakeCase('fooBar');
                        * // => 'foo_bar'
                        *
                        * _.snakeCase('--FOO-BAR--');
                        * // => 'foo_bar'
                        */
                        var snakeCase = createCompounder(function (result, word, index) { return result + (index ? '_' : '') + word.toLowerCase(); }); /**
                        * Splits `string` by `separator`.
                        *
                        * **Note:** This method is based on
                        * [`String#split`](https://mdn.io/String/split).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to split.
                        * @param {RegExp|string} separator The separator pattern to split by.
                        * @param {number} [limit] The length to truncate results to.
                        * @returns {Array} Returns the string segments.
                        * @example
                        *
                        * _.split('a-b-c', '-', 2);
                        * // => ['a', 'b']
                        */
                        function split(string, separator, limit) { if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
                            separator = limit = undefined;
                        } limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0; if (!limit) {
                            return [];
                        } string = toString(string); if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                            separator = baseToString(separator);
                            if (!separator && hasUnicode(string)) {
                                return castSlice(stringToArray(string), 0, limit);
                            }
                        } return string.split(separator, limit); } /**
                        * Converts `string` to
                        * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
                        *
                        * @static
                        * @memberOf _
                        * @since 3.1.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the start cased string.
                        * @example
                        *
                        * _.startCase('--foo-bar--');
                        * // => 'Foo Bar'
                        *
                        * _.startCase('fooBar');
                        * // => 'Foo Bar'
                        *
                        * _.startCase('__FOO_BAR__');
                        * // => 'FOO BAR'
                        */
                        var startCase = createCompounder(function (result, word, index) { return result + (index ? ' ' : '') + upperFirst(word); }); /**
                        * Checks if `string` starts with the given target string.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to inspect.
                        * @param {string} [target] The string to search for.
                        * @param {number} [position=0] The position to search from.
                        * @returns {boolean} Returns `true` if `string` starts with `target`,
                        *  else `false`.
                        * @example
                        *
                        * _.startsWith('abc', 'a');
                        * // => true
                        *
                        * _.startsWith('abc', 'b');
                        * // => false
                        *
                        * _.startsWith('abc', 'b', 1);
                        * // => true
                        */
                        function startsWith(string, target, position) { string = toString(string); position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length); target = baseToString(target); return string.slice(position, position + target.length) == target; } /**
                        * Creates a compiled template function that can interpolate data properties
                        * in "interpolate" delimiters, HTML-escape interpolated data properties in
                        * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
                        * properties may be accessed as free variables in the template. If a setting
                        * object is given, it takes precedence over `_.templateSettings` values.
                        *
                        * **Note:** In the development build `_.template` utilizes
                        * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
                        * for easier debugging.
                        *
                        * For more information on precompiling templates see
                        * [lodash's custom builds documentation](https://lodash.com/custom-builds).
                        *
                        * For more information on Chrome extension sandboxes see
                        * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category String
                        * @param {string} [string=''] The template string.
                        * @param {Object} [options={}] The options object.
                        * @param {RegExp} [options.escape=_.templateSettings.escape]
                        *  The HTML "escape" delimiter.
                        * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
                        *  The "evaluate" delimiter.
                        * @param {Object} [options.imports=_.templateSettings.imports]
                        *  An object to import into the template as free variables.
                        * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
                        *  The "interpolate" delimiter.
                        * @param {string} [options.sourceURL='lodash.templateSources[n]']
                        *  The sourceURL of the compiled template.
                        * @param {string} [options.variable='obj']
                        *  The data object variable name.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Function} Returns the compiled template function.
                        * @example
                        *
                        * // Use the "interpolate" delimiter to create a compiled template.
                        * var compiled = _.template('hello <%= user %>!');
                        * compiled({ 'user': 'fred' });
                        * // => 'hello fred!'
                        *
                        * // Use the HTML "escape" delimiter to escape data property values.
                        * var compiled = _.template('<b><%- value %></b>');
                        * compiled({ 'value': '<script>' });
                        * // => '<b>&lt;script&gt;</b>'
                        *
                        * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
                        * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
                        * compiled({ 'users': ['fred', 'barney'] });
                        * // => '<li>fred</li><li>barney</li>'
                        *
                        * // Use the internal `print` function in "evaluate" delimiters.
                        * var compiled = _.template('<% print("hello " + user); %>!');
                        * compiled({ 'user': 'barney' });
                        * // => 'hello barney!'
                        *
                        * // Use the ES template literal delimiter as an "interpolate" delimiter.
                        * // Disable support by replacing the "interpolate" delimiter.
                        * var compiled = _.template('hello ${ user }!');
                        * compiled({ 'user': 'pebbles' });
                        * // => 'hello pebbles!'
                        *
                        * // Use backslashes to treat delimiters as plain text.
                        * var compiled = _.template('<%= "\\<%- value %\\>" %>');
                        * compiled({ 'value': 'ignored' });
                        * // => '<%- value %>'
                        *
                        * // Use the `imports` option to import `jQuery` as `jq`.
                        * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
                        * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
                        * compiled({ 'users': ['fred', 'barney'] });
                        * // => '<li>fred</li><li>barney</li>'
                        *
                        * // Use the `sourceURL` option to specify a custom sourceURL for the template.
                        * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
                        * compiled(data);
                        * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
                        *
                        * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
                        * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
                        * compiled.source;
                        * // => function(data) {
                        * //   var __t, __p = '';
                        * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
                        * //   return __p;
                        * // }
                        *
                        * // Use custom template delimiters.
                        * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
                        * var compiled = _.template('hello {{ user }}!');
                        * compiled({ 'user': 'mustache' });
                        * // => 'hello mustache!'
                        *
                        * // Use the `source` property to inline compiled templates for meaningful
                        * // line numbers in error messages and stack traces.
                        * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
                        *   var JST = {\
                        *     "main": ' + _.template(mainText).source + '\
                        *   };\
                        * ');
                        */
                        function template(string, options, guard) {
                            // (http://ejohn.org/blog/javascript-micro-templating/)
                            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
                            var settings = lodash.templateSettings;
                            if (guard && isIterateeCall(string, options, guard)) {
                                options = undefined;
                            }
                            string = toString(string);
                            options = assignInWith({}, options, settings, customDefaultsAssignIn);
                            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
                            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '"; // Compile the regexp to match each delimiter.
                            var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g'); // Use a sourceURL for easier debugging.
                            // The sourceURL gets injected into the source that's eval-ed, so be careful
                            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
                            // and escape the comment, thus injecting code that gets evaled.
                            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                            string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                                interpolateValue || (interpolateValue = esTemplateValue); // Escape characters that can't be included in string literals.
                                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar); // Replace delimiters with snippets.
                                if (escapeValue) {
                                    isEscaping = true;
                                    source += "' +\n__e(" + escapeValue + ") +\n'";
                                }
                                if (evaluateValue) {
                                    isEvaluating = true;
                                    source += "';\n" + evaluateValue + ";\n__p += '";
                                }
                                if (interpolateValue) {
                                    source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                                }
                                index = offset + match.length; // The JS engine embedded in Adobe products needs `match` returned in
                                // order to produce the correct `offset` value.
                                return match;
                            });
                            source += "';\n"; // If `variable` is not specified wrap a with-statement around the generated
                            // code to add the data object to the top of the scope chain.
                            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
                            if (!variable) {
                                source = 'with (obj) {\n' + source + '\n}\n';
                            } // Throw an error if a forbidden character was found in `variable`, to prevent
                            // potential command injection attacks.
                            else if (reForbiddenIdentifierChars.test(variable)) {
                                throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                            } // Cleanup code by stripping empty strings.
                            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;'); // Frame code as the function body.
                            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                            var result = attempt(function () { return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues); }); // Provide the compiled function's source by its `toString` method or
                            // the `source` property as a convenience for inlining compiled templates.
                            result.source = source;
                            if (isError(result)) {
                                throw result;
                            }
                            return result;
                        } /**
                                 * Converts `string`, as a whole, to lower case just like
                                 * [String#toLowerCase](https://mdn.io/toLowerCase).
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 4.0.0
                                 * @category String
                                 * @param {string} [string=''] The string to convert.
                                 * @returns {string} Returns the lower cased string.
                                 * @example
                                 *
                                 * _.toLower('--Foo-Bar--');
                                 * // => '--foo-bar--'
                                 *
                                 * _.toLower('fooBar');
                                 * // => 'foobar'
                                 *
                                 * _.toLower('__FOO_BAR__');
                                 * // => '__foo_bar__'
                                 */
                        function toLower(value) { return toString(value).toLowerCase(); } /**
                        * Converts `string`, as a whole, to upper case just like
                        * [String#toUpperCase](https://mdn.io/toUpperCase).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the upper cased string.
                        * @example
                        *
                        * _.toUpper('--foo-bar--');
                        * // => '--FOO-BAR--'
                        *
                        * _.toUpper('fooBar');
                        * // => 'FOOBAR'
                        *
                        * _.toUpper('__foo_bar__');
                        * // => '__FOO_BAR__'
                        */
                        function toUpper(value) { return toString(value).toUpperCase(); } /**
                        * Removes leading and trailing whitespace or specified characters from `string`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to trim.
                        * @param {string} [chars=whitespace] The characters to trim.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {string} Returns the trimmed string.
                        * @example
                        *
                        * _.trim('  abc  ');
                        * // => 'abc'
                        *
                        * _.trim('-_-abc-_-', '_-');
                        * // => 'abc'
                        *
                        * _.map(['  foo  ', '  bar  '], _.trim);
                        * // => ['foo', 'bar']
                        */
                        function trim(string, chars, guard) { string = toString(string); if (string && (guard || chars === undefined)) {
                            return baseTrim(string);
                        } if (!string || !(chars = baseToString(chars))) {
                            return string;
                        } var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1; return castSlice(strSymbols, start, end).join(''); } /**
                        * Removes trailing whitespace or specified characters from `string`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to trim.
                        * @param {string} [chars=whitespace] The characters to trim.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {string} Returns the trimmed string.
                        * @example
                        *
                        * _.trimEnd('  abc  ');
                        * // => '  abc'
                        *
                        * _.trimEnd('-_-abc-_-', '_-');
                        * // => '-_-abc'
                        */
                        function trimEnd(string, chars, guard) { string = toString(string); if (string && (guard || chars === undefined)) {
                            return string.slice(0, trimmedEndIndex(string) + 1);
                        } if (!string || !(chars = baseToString(chars))) {
                            return string;
                        } var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1; return castSlice(strSymbols, 0, end).join(''); } /**
                        * Removes leading whitespace or specified characters from `string`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to trim.
                        * @param {string} [chars=whitespace] The characters to trim.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {string} Returns the trimmed string.
                        * @example
                        *
                        * _.trimStart('  abc  ');
                        * // => 'abc  '
                        *
                        * _.trimStart('-_-abc-_-', '_-');
                        * // => 'abc-_-'
                        */
                        function trimStart(string, chars, guard) { string = toString(string); if (string && (guard || chars === undefined)) {
                            return string.replace(reTrimStart, '');
                        } if (!string || !(chars = baseToString(chars))) {
                            return string;
                        } var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars)); return castSlice(strSymbols, start).join(''); } /**
                        * Truncates `string` if it's longer than the given maximum string length.
                        * The last characters of the truncated string are replaced with the omission
                        * string which defaults to "...".
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to truncate.
                        * @param {Object} [options={}] The options object.
                        * @param {number} [options.length=30] The maximum string length.
                        * @param {string} [options.omission='...'] The string to indicate text is omitted.
                        * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
                        * @returns {string} Returns the truncated string.
                        * @example
                        *
                        * _.truncate('hi-diddly-ho there, neighborino');
                        * // => 'hi-diddly-ho there, neighbo...'
                        *
                        * _.truncate('hi-diddly-ho there, neighborino', {
                        *   'length': 24,
                        *   'separator': ' '
                        * });
                        * // => 'hi-diddly-ho there,...'
                        *
                        * _.truncate('hi-diddly-ho there, neighborino', {
                        *   'length': 24,
                        *   'separator': /,? +/
                        * });
                        * // => 'hi-diddly-ho there...'
                        *
                        * _.truncate('hi-diddly-ho there, neighborino', {
                        *   'omission': ' [...]'
                        * });
                        * // => 'hi-diddly-ho there, neig [...]'
                        */
                        function truncate(string, options) { var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION; if (isObject(options)) {
                            var separator = 'separator' in options ? options.separator : separator;
                            length = 'length' in options ? toInteger(options.length) : length;
                            omission = 'omission' in options ? baseToString(options.omission) : omission;
                        } string = toString(string); var strLength = string.length; if (hasUnicode(string)) {
                            var strSymbols = stringToArray(string);
                            strLength = strSymbols.length;
                        } if (length >= strLength) {
                            return string;
                        } var end = length - stringSize(omission); if (end < 1) {
                            return omission;
                        } var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end); if (separator === undefined) {
                            return result + omission;
                        } if (strSymbols) {
                            end += result.length - end;
                        } if (isRegExp(separator)) {
                            if (string.slice(end).search(separator)) {
                                var match, substring = result;
                                if (!separator.global) {
                                    separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                                }
                                separator.lastIndex = 0;
                                while (match = separator.exec(substring)) {
                                    var newEnd = match.index;
                                }
                                result = result.slice(0, newEnd === undefined ? end : newEnd);
                            }
                        }
                        else if (string.indexOf(baseToString(separator), end) != end) {
                            var index = result.lastIndexOf(separator);
                            if (index > -1) {
                                result = result.slice(0, index);
                            }
                        } return result + omission; } /**
                        * The inverse of `_.escape`; this method converts the HTML entities
                        * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
                        * their corresponding characters.
                        *
                        * **Note:** No other HTML entities are unescaped. To unescape additional
                        * HTML entities use a third-party library like [_he_](https://mths.be/he).
                        *
                        * @static
                        * @memberOf _
                        * @since 0.6.0
                        * @category String
                        * @param {string} [string=''] The string to unescape.
                        * @returns {string} Returns the unescaped string.
                        * @example
                        *
                        * _.unescape('fred, barney, &amp; pebbles');
                        * // => 'fred, barney, & pebbles'
                        */
                        function unescape(string) { string = toString(string); return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string; } /**
                        * Converts `string`, as space separated words, to upper case.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the upper cased string.
                        * @example
                        *
                        * _.upperCase('--foo-bar');
                        * // => 'FOO BAR'
                        *
                        * _.upperCase('fooBar');
                        * // => 'FOO BAR'
                        *
                        * _.upperCase('__foo_bar__');
                        * // => 'FOO BAR'
                        */
                        var upperCase = createCompounder(function (result, word, index) { return result + (index ? ' ' : '') + word.toUpperCase(); }); /**
                        * Converts the first character of `string` to upper case.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category String
                        * @param {string} [string=''] The string to convert.
                        * @returns {string} Returns the converted string.
                        * @example
                        *
                        * _.upperFirst('fred');
                        * // => 'Fred'
                        *
                        * _.upperFirst('FRED');
                        * // => 'FRED'
                        */
                        var upperFirst = createCaseFirst('toUpperCase'); /**
                        * Splits `string` into an array of its words.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category String
                        * @param {string} [string=''] The string to inspect.
                        * @param {RegExp|string} [pattern] The pattern to match words.
                        * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                        * @returns {Array} Returns the words of `string`.
                        * @example
                        *
                        * _.words('fred, barney, & pebbles');
                        * // => ['fred', 'barney', 'pebbles']
                        *
                        * _.words('fred, barney, & pebbles', /[^, ]+/g);
                        * // => ['fred', 'barney', '&', 'pebbles']
                        */
                        function words(string, pattern, guard) { string = toString(string); pattern = guard ? undefined : pattern; if (pattern === undefined) {
                            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                        } return string.match(pattern) || []; } /*------------------------------------------------------------------------*/ /**
                        * Attempts to invoke `func`, returning either the result or the caught error
                        * object. Any additional arguments are provided to `func` when it's invoked.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Util
                        * @param {Function} func The function to attempt.
                        * @param {...*} [args] The arguments to invoke `func` with.
                        * @returns {*} Returns the `func` result or error object.
                        * @example
                        *
                        * // Avoid throwing errors for invalid selectors.
                        * var elements = _.attempt(function(selector) {
                        *   return document.querySelectorAll(selector);
                        * }, '>_>');
                        *
                        * if (_.isError(elements)) {
                        *   elements = [];
                        * }
                        */
                        var attempt = baseRest(function (func, args) { try {
                            return apply(func, undefined, args);
                        }
                        catch (e) {
                            return isError(e) ? e : new Error(e);
                        } }); /**
                        * Binds methods of an object to the object itself, overwriting the existing
                        * method.
                        *
                        * **Note:** This method doesn't set the "length" property of bound functions.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {Object} object The object to bind and assign the bound methods to.
                        * @param {...(string|string[])} methodNames The object method names to bind.
                        * @returns {Object} Returns `object`.
                        * @example
                        *
                        * var view = {
                        *   'label': 'docs',
                        *   'click': function() {
                        *     console.log('clicked ' + this.label);
                        *   }
                        * };
                        *
                        * _.bindAll(view, ['click']);
                        * jQuery(element).on('click', view.click);
                        * // => Logs 'clicked docs' when clicked.
                        */
                        var bindAll = flatRest(function (object, methodNames) { arrayEach(methodNames, function (key) { key = toKey(key); baseAssignValue(object, key, bind(object[key], object)); }); return object; }); /**
                        * Creates a function that iterates over `pairs` and invokes the corresponding
                        * function of the first predicate to return truthy. The predicate-function
                        * pairs are invoked with the `this` binding and arguments of the created
                        * function.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {Array} pairs The predicate-function pairs.
                        * @returns {Function} Returns the new composite function.
                        * @example
                        *
                        * var func = _.cond([
                        *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
                        *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
                        *   [_.stubTrue,                      _.constant('no match')]
                        * ]);
                        *
                        * func({ 'a': 1, 'b': 2 });
                        * // => 'matches A'
                        *
                        * func({ 'a': 0, 'b': 1 });
                        * // => 'matches B'
                        *
                        * func({ 'a': '1', 'b': '2' });
                        * // => 'no match'
                        */
                        function cond(pairs) { var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee(); pairs = !length ? [] : arrayMap(pairs, function (pair) { if (typeof pair[1] != 'function') {
                            throw new TypeError(FUNC_ERROR_TEXT);
                        } return [toIteratee(pair[0]), pair[1]]; }); return baseRest(function (args) { var index = -1; while (++index < length) {
                            var pair = pairs[index];
                            if (apply(pair[0], this, args)) {
                                return apply(pair[1], this, args);
                            }
                        } }); } /**
                        * Creates a function that invokes the predicate properties of `source` with
                        * the corresponding property values of a given object, returning `true` if
                        * all predicates return truthy, else `false`.
                        *
                        * **Note:** The created function is equivalent to `_.conformsTo` with
                        * `source` partially applied.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {Object} source The object of property predicates to conform to.
                        * @returns {Function} Returns the new spec function.
                        * @example
                        *
                        * var objects = [
                        *   { 'a': 2, 'b': 1 },
                        *   { 'a': 1, 'b': 2 }
                        * ];
                        *
                        * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
                        * // => [{ 'a': 1, 'b': 2 }]
                        */
                        function conforms(source) { return baseConforms(baseClone(source, CLONE_DEEP_FLAG)); } /**
                        * Creates a function that returns `value`.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.4.0
                        * @category Util
                        * @param {*} value The value to return from the new function.
                        * @returns {Function} Returns the new constant function.
                        * @example
                        *
                        * var objects = _.times(2, _.constant({ 'a': 1 }));
                        *
                        * console.log(objects);
                        * // => [{ 'a': 1 }, { 'a': 1 }]
                        *
                        * console.log(objects[0] === objects[1]);
                        * // => true
                        */
                        function constant(value) { return function () { return value; }; } /**
                        * Checks `value` to determine whether a default value should be returned in
                        * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
                        * or `undefined`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.14.0
                        * @category Util
                        * @param {*} value The value to check.
                        * @param {*} defaultValue The default value.
                        * @returns {*} Returns the resolved value.
                        * @example
                        *
                        * _.defaultTo(1, 10);
                        * // => 1
                        *
                        * _.defaultTo(undefined, 10);
                        * // => 10
                        */
                        function defaultTo(value, defaultValue) { return value == null || value !== value ? defaultValue : value; } /**
                        * Creates a function that returns the result of invoking the given functions
                        * with the `this` binding of the created function, where each successive
                        * invocation is supplied the return value of the previous.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Util
                        * @param {...(Function|Function[])} [funcs] The functions to invoke.
                        * @returns {Function} Returns the new composite function.
                        * @see _.flowRight
                        * @example
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * var addSquare = _.flow([_.add, square]);
                        * addSquare(1, 2);
                        * // => 9
                        */
                        var flow = createFlow(); /**
                        * This method is like `_.flow` except that it creates a function that
                        * invokes the given functions from right to left.
                        *
                        * @static
                        * @since 3.0.0
                        * @memberOf _
                        * @category Util
                        * @param {...(Function|Function[])} [funcs] The functions to invoke.
                        * @returns {Function} Returns the new composite function.
                        * @see _.flow
                        * @example
                        *
                        * function square(n) {
                        *   return n * n;
                        * }
                        *
                        * var addSquare = _.flowRight([square, _.add]);
                        * addSquare(1, 2);
                        * // => 9
                        */
                        var flowRight = createFlow(true); /**
                        * This method returns the first argument it receives.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {*} value Any value.
                        * @returns {*} Returns `value`.
                        * @example
                        *
                        * var object = { 'a': 1 };
                        *
                        * console.log(_.identity(object) === object);
                        * // => true
                        */
                        function identity(value) { return value; } /**
                        * Creates a function that invokes `func` with the arguments of the created
                        * function. If `func` is a property name, the created function returns the
                        * property value for a given element. If `func` is an array or object, the
                        * created function returns `true` for elements that contain the equivalent
                        * source properties, otherwise it returns `false`.
                        *
                        * @static
                        * @since 4.0.0
                        * @memberOf _
                        * @category Util
                        * @param {*} [func=_.identity] The value to convert to a callback.
                        * @returns {Function} Returns the callback.
                        * @example
                        *
                        * var users = [
                        *   { 'user': 'barney', 'age': 36, 'active': true },
                        *   { 'user': 'fred',   'age': 40, 'active': false }
                        * ];
                        *
                        * // The `_.matches` iteratee shorthand.
                        * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
                        * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
                        *
                        * // The `_.matchesProperty` iteratee shorthand.
                        * _.filter(users, _.iteratee(['user', 'fred']));
                        * // => [{ 'user': 'fred', 'age': 40 }]
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.map(users, _.iteratee('user'));
                        * // => ['barney', 'fred']
                        *
                        * // Create custom iteratee shorthands.
                        * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
                        *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
                        *     return func.test(string);
                        *   };
                        * });
                        *
                        * _.filter(['abc', 'def'], /ef/);
                        * // => ['def']
                        */
                        function iteratee(func) { return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG)); } /**
                        * Creates a function that performs a partial deep comparison between a given
                        * object and `source`, returning `true` if the given object has equivalent
                        * property values, else `false`.
                        *
                        * **Note:** The created function is equivalent to `_.isMatch` with `source`
                        * partially applied.
                        *
                        * Partial comparisons will match empty array and empty object `source`
                        * values against any array or object value, respectively. See `_.isEqual`
                        * for a list of supported value comparisons.
                        *
                        * **Note:** Multiple values can be checked by combining several matchers
                        * using `_.overSome`
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Util
                        * @param {Object} source The object of property values to match.
                        * @returns {Function} Returns the new spec function.
                        * @example
                        *
                        * var objects = [
                        *   { 'a': 1, 'b': 2, 'c': 3 },
                        *   { 'a': 4, 'b': 5, 'c': 6 }
                        * ];
                        *
                        * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
                        * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
                        *
                        * // Checking for several possible values
                        * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
                        * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
                        */
                        function matches(source) { return baseMatches(baseClone(source, CLONE_DEEP_FLAG)); } /**
                        * Creates a function that performs a partial deep comparison between the
                        * value at `path` of a given object to `srcValue`, returning `true` if the
                        * object value is equivalent, else `false`.
                        *
                        * **Note:** Partial comparisons will match empty array and empty object
                        * `srcValue` values against any array or object value, respectively. See
                        * `_.isEqual` for a list of supported value comparisons.
                        *
                        * **Note:** Multiple values can be checked by combining several matchers
                        * using `_.overSome`
                        *
                        * @static
                        * @memberOf _
                        * @since 3.2.0
                        * @category Util
                        * @param {Array|string} path The path of the property to get.
                        * @param {*} srcValue The value to match.
                        * @returns {Function} Returns the new spec function.
                        * @example
                        *
                        * var objects = [
                        *   { 'a': 1, 'b': 2, 'c': 3 },
                        *   { 'a': 4, 'b': 5, 'c': 6 }
                        * ];
                        *
                        * _.find(objects, _.matchesProperty('a', 4));
                        * // => { 'a': 4, 'b': 5, 'c': 6 }
                        *
                        * // Checking for several possible values
                        * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
                        * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
                        */
                        function matchesProperty(path, srcValue) { return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG)); } /**
                        * Creates a function that invokes the method at `path` of a given object.
                        * Any additional arguments are provided to the invoked method.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.7.0
                        * @category Util
                        * @param {Array|string} path The path of the method to invoke.
                        * @param {...*} [args] The arguments to invoke the method with.
                        * @returns {Function} Returns the new invoker function.
                        * @example
                        *
                        * var objects = [
                        *   { 'a': { 'b': _.constant(2) } },
                        *   { 'a': { 'b': _.constant(1) } }
                        * ];
                        *
                        * _.map(objects, _.method('a.b'));
                        * // => [2, 1]
                        *
                        * _.map(objects, _.method(['a', 'b']));
                        * // => [2, 1]
                        */
                        var method = baseRest(function (path, args) { return function (object) { return baseInvoke(object, path, args); }; }); /**
                        * The opposite of `_.method`; this method creates a function that invokes
                        * the method at a given path of `object`. Any additional arguments are
                        * provided to the invoked method.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.7.0
                        * @category Util
                        * @param {Object} object The object to query.
                        * @param {...*} [args] The arguments to invoke the method with.
                        * @returns {Function} Returns the new invoker function.
                        * @example
                        *
                        * var array = _.times(3, _.constant),
                        *     object = { 'a': array, 'b': array, 'c': array };
                        *
                        * _.map(['a[2]', 'c[0]'], _.methodOf(object));
                        * // => [2, 0]
                        *
                        * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
                        * // => [2, 0]
                        */
                        var methodOf = baseRest(function (object, args) { return function (path) { return baseInvoke(object, path, args); }; }); /**
                        * Adds all own enumerable string keyed function properties of a source
                        * object to the destination object. If `object` is a function, then methods
                        * are added to its prototype as well.
                        *
                        * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
                        * avoid conflicts caused by modifying the original.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {Function|Object} [object=lodash] The destination object.
                        * @param {Object} source The object of functions to add.
                        * @param {Object} [options={}] The options object.
                        * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
                        * @returns {Function|Object} Returns `object`.
                        * @example
                        *
                        * function vowels(string) {
                        *   return _.filter(string, function(v) {
                        *     return /[aeiou]/i.test(v);
                        *   });
                        * }
                        *
                        * _.mixin({ 'vowels': vowels });
                        * _.vowels('fred');
                        * // => ['e']
                        *
                        * _('fred').vowels().value();
                        * // => ['e']
                        *
                        * _.mixin({ 'vowels': vowels }, { 'chain': false });
                        * _('fred').vowels();
                        * // => ['e']
                        */
                        function mixin(object, source, options) { var props = keys(source), methodNames = baseFunctions(source, props); if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                            options = source;
                            source = object;
                            object = this;
                            methodNames = baseFunctions(source, keys(source));
                        } var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object); arrayEach(methodNames, function (methodName) { var func = source[methodName]; object[methodName] = func; if (isFunc) {
                            object.prototype[methodName] = function () { var chainAll = this.__chain__; if (chain || chainAll) {
                                var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                                result.__chain__ = chainAll;
                                return result;
                            } return func.apply(object, arrayPush([this.value()], arguments)); };
                        } }); return object; } /**
                        * Reverts the `_` variable to its previous value and returns a reference to
                        * the `lodash` function.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @returns {Function} Returns the `lodash` function.
                        * @example
                        *
                        * var lodash = _.noConflict();
                        */
                        function noConflict() { if (root._ === this) {
                            root._ = oldDash;
                        } return this; } /**
                        * This method returns `undefined`.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.3.0
                        * @category Util
                        * @example
                        *
                        * _.times(2, _.noop);
                        * // => [undefined, undefined]
                        */
                        function noop() {
                        } /**
                                 * Creates a function that gets the argument at index `n`. If `n` is negative,
                                 * the nth argument from the end is returned.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @since 4.0.0
                                 * @category Util
                                 * @param {number} [n=0] The index of the argument to return.
                                 * @returns {Function} Returns the new pass-thru function.
                                 * @example
                                 *
                                 * var func = _.nthArg(1);
                                 * func('a', 'b', 'c', 'd');
                                 * // => 'b'
                                 *
                                 * var func = _.nthArg(-2);
                                 * func('a', 'b', 'c', 'd');
                                 * // => 'c'
                                 */
                        function nthArg(n) { n = toInteger(n); return baseRest(function (args) { return baseNth(args, n); }); } /**
                        * Creates a function that invokes `iteratees` with the arguments it receives
                        * and returns their results.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {...(Function|Function[])} [iteratees=[_.identity]]
                        *  The iteratees to invoke.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var func = _.over([Math.max, Math.min]);
                        *
                        * func(1, 2, 3, 4);
                        * // => [4, 1]
                        */
                        var over = createOver(arrayMap); /**
                        * Creates a function that checks if **all** of the `predicates` return
                        * truthy when invoked with the arguments it receives.
                        *
                        * Following shorthands are possible for providing predicates.
                        * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
                        * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {...(Function|Function[])} [predicates=[_.identity]]
                        *  The predicates to check.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var func = _.overEvery([Boolean, isFinite]);
                        *
                        * func('1');
                        * // => true
                        *
                        * func(null);
                        * // => false
                        *
                        * func(NaN);
                        * // => false
                        */
                        var overEvery = createOver(arrayEvery); /**
                        * Creates a function that checks if **any** of the `predicates` return
                        * truthy when invoked with the arguments it receives.
                        *
                        * Following shorthands are possible for providing predicates.
                        * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
                        * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {...(Function|Function[])} [predicates=[_.identity]]
                        *  The predicates to check.
                        * @returns {Function} Returns the new function.
                        * @example
                        *
                        * var func = _.overSome([Boolean, isFinite]);
                        *
                        * func('1');
                        * // => true
                        *
                        * func(null);
                        * // => true
                        *
                        * func(NaN);
                        * // => false
                        *
                        * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
                        * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
                        */
                        var overSome = createOver(arraySome); /**
                        * Creates a function that returns the value at `path` of a given object.
                        *
                        * @static
                        * @memberOf _
                        * @since 2.4.0
                        * @category Util
                        * @param {Array|string} path The path of the property to get.
                        * @returns {Function} Returns the new accessor function.
                        * @example
                        *
                        * var objects = [
                        *   { 'a': { 'b': 2 } },
                        *   { 'a': { 'b': 1 } }
                        * ];
                        *
                        * _.map(objects, _.property('a.b'));
                        * // => [2, 1]
                        *
                        * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
                        * // => [1, 2]
                        */
                        function property(path) { return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path); } /**
                        * The opposite of `_.property`; this method creates a function that returns
                        * the value at a given path of `object`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.0.0
                        * @category Util
                        * @param {Object} object The object to query.
                        * @returns {Function} Returns the new accessor function.
                        * @example
                        *
                        * var array = [0, 1, 2],
                        *     object = { 'a': array, 'b': array, 'c': array };
                        *
                        * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
                        * // => [2, 0]
                        *
                        * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
                        * // => [2, 0]
                        */
                        function propertyOf(object) { return function (path) { return object == null ? undefined : baseGet(object, path); }; } /**
                        * Creates an array of numbers (positive and/or negative) progressing from
                        * `start` up to, but not including, `end`. A step of `-1` is used if a negative
                        * `start` is specified without an `end` or `step`. If `end` is not specified,
                        * it's set to `start` with `start` then set to `0`.
                        *
                        * **Note:** JavaScript follows the IEEE-754 standard for resolving
                        * floating-point values which can produce unexpected results.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {number} [start=0] The start of the range.
                        * @param {number} end The end of the range.
                        * @param {number} [step=1] The value to increment or decrement by.
                        * @returns {Array} Returns the range of numbers.
                        * @see _.inRange, _.rangeRight
                        * @example
                        *
                        * _.range(4);
                        * // => [0, 1, 2, 3]
                        *
                        * _.range(-4);
                        * // => [0, -1, -2, -3]
                        *
                        * _.range(1, 5);
                        * // => [1, 2, 3, 4]
                        *
                        * _.range(0, 20, 5);
                        * // => [0, 5, 10, 15]
                        *
                        * _.range(0, -4, -1);
                        * // => [0, -1, -2, -3]
                        *
                        * _.range(1, 4, 0);
                        * // => [1, 1, 1]
                        *
                        * _.range(0);
                        * // => []
                        */
                        var range = createRange(); /**
                        * This method is like `_.range` except that it populates values in
                        * descending order.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {number} [start=0] The start of the range.
                        * @param {number} end The end of the range.
                        * @param {number} [step=1] The value to increment or decrement by.
                        * @returns {Array} Returns the range of numbers.
                        * @see _.inRange, _.range
                        * @example
                        *
                        * _.rangeRight(4);
                        * // => [3, 2, 1, 0]
                        *
                        * _.rangeRight(-4);
                        * // => [-3, -2, -1, 0]
                        *
                        * _.rangeRight(1, 5);
                        * // => [4, 3, 2, 1]
                        *
                        * _.rangeRight(0, 20, 5);
                        * // => [15, 10, 5, 0]
                        *
                        * _.rangeRight(0, -4, -1);
                        * // => [-3, -2, -1, 0]
                        *
                        * _.rangeRight(1, 4, 0);
                        * // => [1, 1, 1]
                        *
                        * _.rangeRight(0);
                        * // => []
                        */
                        var rangeRight = createRange(true); /**
                        * This method returns a new empty array.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.13.0
                        * @category Util
                        * @returns {Array} Returns the new empty array.
                        * @example
                        *
                        * var arrays = _.times(2, _.stubArray);
                        *
                        * console.log(arrays);
                        * // => [[], []]
                        *
                        * console.log(arrays[0] === arrays[1]);
                        * // => false
                        */
                        function stubArray() { return []; } /**
                        * This method returns `false`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.13.0
                        * @category Util
                        * @returns {boolean} Returns `false`.
                        * @example
                        *
                        * _.times(2, _.stubFalse);
                        * // => [false, false]
                        */
                        function stubFalse() { return false; } /**
                        * This method returns a new empty object.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.13.0
                        * @category Util
                        * @returns {Object} Returns the new empty object.
                        * @example
                        *
                        * var objects = _.times(2, _.stubObject);
                        *
                        * console.log(objects);
                        * // => [{}, {}]
                        *
                        * console.log(objects[0] === objects[1]);
                        * // => false
                        */
                        function stubObject() { return {}; } /**
                        * This method returns an empty string.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.13.0
                        * @category Util
                        * @returns {string} Returns the empty string.
                        * @example
                        *
                        * _.times(2, _.stubString);
                        * // => ['', '']
                        */
                        function stubString() { return ''; } /**
                        * This method returns `true`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.13.0
                        * @category Util
                        * @returns {boolean} Returns `true`.
                        * @example
                        *
                        * _.times(2, _.stubTrue);
                        * // => [true, true]
                        */
                        function stubTrue() { return true; } /**
                        * Invokes the iteratee `n` times, returning an array of the results of
                        * each invocation. The iteratee is invoked with one argument; (index).
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {number} n The number of times to invoke `iteratee`.
                        * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                        * @returns {Array} Returns the array of results.
                        * @example
                        *
                        * _.times(3, String);
                        * // => ['0', '1', '2']
                        *
                        *  _.times(4, _.constant(0));
                        * // => [0, 0, 0, 0]
                        */
                        function times(n, iteratee) { n = toInteger(n); if (n < 1 || n > MAX_SAFE_INTEGER) {
                            return [];
                        } var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH); iteratee = getIteratee(iteratee); n -= MAX_ARRAY_LENGTH; var result = baseTimes(length, iteratee); while (++index < n) {
                            iteratee(index);
                        } return result; } /**
                        * Converts `value` to a property path array.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Util
                        * @param {*} value The value to convert.
                        * @returns {Array} Returns the new property path array.
                        * @example
                        *
                        * _.toPath('a.b.c');
                        * // => ['a', 'b', 'c']
                        *
                        * _.toPath('a[0].b.c');
                        * // => ['a', '0', 'b', 'c']
                        */
                        function toPath(value) { if (isArray(value)) {
                            return arrayMap(value, toKey);
                        } return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value))); } /**
                        * Generates a unique ID. If `prefix` is given, the ID is appended to it.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Util
                        * @param {string} [prefix=''] The value to prefix the ID with.
                        * @returns {string} Returns the unique ID.
                        * @example
                        *
                        * _.uniqueId('contact_');
                        * // => 'contact_104'
                        *
                        * _.uniqueId();
                        * // => '105'
                        */
                        function uniqueId(prefix) { var id = ++idCounter; return toString(prefix) + id; } /*------------------------------------------------------------------------*/ /**
                        * Adds two numbers.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.4.0
                        * @category Math
                        * @param {number} augend The first number in an addition.
                        * @param {number} addend The second number in an addition.
                        * @returns {number} Returns the total.
                        * @example
                        *
                        * _.add(6, 4);
                        * // => 10
                        */
                        var add = createMathOperation(function (augend, addend) { return augend + addend; }, 0); /**
                        * Computes `number` rounded up to `precision`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.10.0
                        * @category Math
                        * @param {number} number The number to round up.
                        * @param {number} [precision=0] The precision to round up to.
                        * @returns {number} Returns the rounded up number.
                        * @example
                        *
                        * _.ceil(4.006);
                        * // => 5
                        *
                        * _.ceil(6.004, 2);
                        * // => 6.01
                        *
                        * _.ceil(6040, -2);
                        * // => 6100
                        */
                        var ceil = createRound('ceil'); /**
                        * Divide two numbers.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.7.0
                        * @category Math
                        * @param {number} dividend The first number in a division.
                        * @param {number} divisor The second number in a division.
                        * @returns {number} Returns the quotient.
                        * @example
                        *
                        * _.divide(6, 4);
                        * // => 1.5
                        */
                        var divide = createMathOperation(function (dividend, divisor) { return dividend / divisor; }, 1); /**
                        * Computes `number` rounded down to `precision`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.10.0
                        * @category Math
                        * @param {number} number The number to round down.
                        * @param {number} [precision=0] The precision to round down to.
                        * @returns {number} Returns the rounded down number.
                        * @example
                        *
                        * _.floor(4.006);
                        * // => 4
                        *
                        * _.floor(0.046, 2);
                        * // => 0.04
                        *
                        * _.floor(4060, -2);
                        * // => 4000
                        */
                        var floor = createRound('floor'); /**
                        * Computes the maximum value of `array`. If `array` is empty or falsey,
                        * `undefined` is returned.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @returns {*} Returns the maximum value.
                        * @example
                        *
                        * _.max([4, 2, 8, 6]);
                        * // => 8
                        *
                        * _.max([]);
                        * // => undefined
                        */
                        function max(array) { return array && array.length ? baseExtremum(array, identity, baseGt) : undefined; } /**
                        * This method is like `_.max` except that it accepts `iteratee` which is
                        * invoked for each element in `array` to generate the criterion by which
                        * the value is ranked. The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {*} Returns the maximum value.
                        * @example
                        *
                        * var objects = [{ 'n': 1 }, { 'n': 2 }];
                        *
                        * _.maxBy(objects, function(o) { return o.n; });
                        * // => { 'n': 2 }
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.maxBy(objects, 'n');
                        * // => { 'n': 2 }
                        */
                        function maxBy(array, iteratee) { return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined; } /**
                        * Computes the mean of the values in `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @returns {number} Returns the mean.
                        * @example
                        *
                        * _.mean([4, 2, 8, 6]);
                        * // => 5
                        */
                        function mean(array) { return baseMean(array, identity); } /**
                        * This method is like `_.mean` except that it accepts `iteratee` which is
                        * invoked for each element in `array` to generate the value to be averaged.
                        * The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.7.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {number} Returns the mean.
                        * @example
                        *
                        * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
                        *
                        * _.meanBy(objects, function(o) { return o.n; });
                        * // => 5
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.meanBy(objects, 'n');
                        * // => 5
                        */
                        function meanBy(array, iteratee) { return baseMean(array, getIteratee(iteratee, 2)); } /**
                        * Computes the minimum value of `array`. If `array` is empty or falsey,
                        * `undefined` is returned.
                        *
                        * @static
                        * @since 0.1.0
                        * @memberOf _
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @returns {*} Returns the minimum value.
                        * @example
                        *
                        * _.min([4, 2, 8, 6]);
                        * // => 2
                        *
                        * _.min([]);
                        * // => undefined
                        */
                        function min(array) { return array && array.length ? baseExtremum(array, identity, baseLt) : undefined; } /**
                        * This method is like `_.min` except that it accepts `iteratee` which is
                        * invoked for each element in `array` to generate the criterion by which
                        * the value is ranked. The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {*} Returns the minimum value.
                        * @example
                        *
                        * var objects = [{ 'n': 1 }, { 'n': 2 }];
                        *
                        * _.minBy(objects, function(o) { return o.n; });
                        * // => { 'n': 1 }
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.minBy(objects, 'n');
                        * // => { 'n': 1 }
                        */
                        function minBy(array, iteratee) { return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined; } /**
                        * Multiply two numbers.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.7.0
                        * @category Math
                        * @param {number} multiplier The first number in a multiplication.
                        * @param {number} multiplicand The second number in a multiplication.
                        * @returns {number} Returns the product.
                        * @example
                        *
                        * _.multiply(6, 4);
                        * // => 24
                        */
                        var multiply = createMathOperation(function (multiplier, multiplicand) { return multiplier * multiplicand; }, 1); /**
                        * Computes `number` rounded to `precision`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.10.0
                        * @category Math
                        * @param {number} number The number to round.
                        * @param {number} [precision=0] The precision to round to.
                        * @returns {number} Returns the rounded number.
                        * @example
                        *
                        * _.round(4.006);
                        * // => 4
                        *
                        * _.round(4.006, 2);
                        * // => 4.01
                        *
                        * _.round(4060, -2);
                        * // => 4100
                        */
                        var round = createRound('round'); /**
                        * Subtract two numbers.
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Math
                        * @param {number} minuend The first number in a subtraction.
                        * @param {number} subtrahend The second number in a subtraction.
                        * @returns {number} Returns the difference.
                        * @example
                        *
                        * _.subtract(6, 4);
                        * // => 2
                        */
                        var subtract = createMathOperation(function (minuend, subtrahend) { return minuend - subtrahend; }, 0); /**
                        * Computes the sum of the values in `array`.
                        *
                        * @static
                        * @memberOf _
                        * @since 3.4.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @returns {number} Returns the sum.
                        * @example
                        *
                        * _.sum([4, 2, 8, 6]);
                        * // => 20
                        */
                        function sum(array) { return array && array.length ? baseSum(array, identity) : 0; } /**
                        * This method is like `_.sum` except that it accepts `iteratee` which is
                        * invoked for each element in `array` to generate the value to be summed.
                        * The iteratee is invoked with one argument: (value).
                        *
                        * @static
                        * @memberOf _
                        * @since 4.0.0
                        * @category Math
                        * @param {Array} array The array to iterate over.
                        * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                        * @returns {number} Returns the sum.
                        * @example
                        *
                        * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
                        *
                        * _.sumBy(objects, function(o) { return o.n; });
                        * // => 20
                        *
                        * // The `_.property` iteratee shorthand.
                        * _.sumBy(objects, 'n');
                        * // => 20
                        */
                        function sumBy(array, iteratee) { return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0; } /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
                        lodash.after = after;
                        lodash.ary = ary;
                        lodash.assign = assign;
                        lodash.assignIn = assignIn;
                        lodash.assignInWith = assignInWith;
                        lodash.assignWith = assignWith;
                        lodash.at = at;
                        lodash.before = before;
                        lodash.bind = bind;
                        lodash.bindAll = bindAll;
                        lodash.bindKey = bindKey;
                        lodash.castArray = castArray;
                        lodash.chain = chain;
                        lodash.chunk = chunk;
                        lodash.compact = compact;
                        lodash.concat = concat;
                        lodash.cond = cond;
                        lodash.conforms = conforms;
                        lodash.constant = constant;
                        lodash.countBy = countBy;
                        lodash.create = create;
                        lodash.curry = curry;
                        lodash.curryRight = curryRight;
                        lodash.debounce = debounce;
                        lodash.defaults = defaults;
                        lodash.defaultsDeep = defaultsDeep;
                        lodash.defer = defer;
                        lodash.delay = delay;
                        lodash.difference = difference;
                        lodash.differenceBy = differenceBy;
                        lodash.differenceWith = differenceWith;
                        lodash.drop = drop;
                        lodash.dropRight = dropRight;
                        lodash.dropRightWhile = dropRightWhile;
                        lodash.dropWhile = dropWhile;
                        lodash.fill = fill;
                        lodash.filter = filter;
                        lodash.flatMap = flatMap;
                        lodash.flatMapDeep = flatMapDeep;
                        lodash.flatMapDepth = flatMapDepth;
                        lodash.flatten = flatten;
                        lodash.flattenDeep = flattenDeep;
                        lodash.flattenDepth = flattenDepth;
                        lodash.flip = flip;
                        lodash.flow = flow;
                        lodash.flowRight = flowRight;
                        lodash.fromPairs = fromPairs;
                        lodash.functions = functions;
                        lodash.functionsIn = functionsIn;
                        lodash.groupBy = groupBy;
                        lodash.initial = initial;
                        lodash.intersection = intersection;
                        lodash.intersectionBy = intersectionBy;
                        lodash.intersectionWith = intersectionWith;
                        lodash.invert = invert;
                        lodash.invertBy = invertBy;
                        lodash.invokeMap = invokeMap;
                        lodash.iteratee = iteratee;
                        lodash.keyBy = keyBy;
                        lodash.keys = keys;
                        lodash.keysIn = keysIn;
                        lodash.map = map;
                        lodash.mapKeys = mapKeys;
                        lodash.mapValues = mapValues;
                        lodash.matches = matches;
                        lodash.matchesProperty = matchesProperty;
                        lodash.memoize = memoize;
                        lodash.merge = merge;
                        lodash.mergeWith = mergeWith;
                        lodash.method = method;
                        lodash.methodOf = methodOf;
                        lodash.mixin = mixin;
                        lodash.negate = negate;
                        lodash.nthArg = nthArg;
                        lodash.omit = omit;
                        lodash.omitBy = omitBy;
                        lodash.once = once;
                        lodash.orderBy = orderBy;
                        lodash.over = over;
                        lodash.overArgs = overArgs;
                        lodash.overEvery = overEvery;
                        lodash.overSome = overSome;
                        lodash.partial = partial;
                        lodash.partialRight = partialRight;
                        lodash.partition = partition;
                        lodash.pick = pick;
                        lodash.pickBy = pickBy;
                        lodash.property = property;
                        lodash.propertyOf = propertyOf;
                        lodash.pull = pull;
                        lodash.pullAll = pullAll;
                        lodash.pullAllBy = pullAllBy;
                        lodash.pullAllWith = pullAllWith;
                        lodash.pullAt = pullAt;
                        lodash.range = range;
                        lodash.rangeRight = rangeRight;
                        lodash.rearg = rearg;
                        lodash.reject = reject;
                        lodash.remove = remove;
                        lodash.rest = rest;
                        lodash.reverse = reverse;
                        lodash.sampleSize = sampleSize;
                        lodash.set = set;
                        lodash.setWith = setWith;
                        lodash.shuffle = shuffle;
                        lodash.slice = slice;
                        lodash.sortBy = sortBy;
                        lodash.sortedUniq = sortedUniq;
                        lodash.sortedUniqBy = sortedUniqBy;
                        lodash.split = split;
                        lodash.spread = spread;
                        lodash.tail = tail;
                        lodash.take = take;
                        lodash.takeRight = takeRight;
                        lodash.takeRightWhile = takeRightWhile;
                        lodash.takeWhile = takeWhile;
                        lodash.tap = tap;
                        lodash.throttle = throttle;
                        lodash.thru = thru;
                        lodash.toArray = toArray;
                        lodash.toPairs = toPairs;
                        lodash.toPairsIn = toPairsIn;
                        lodash.toPath = toPath;
                        lodash.toPlainObject = toPlainObject;
                        lodash.transform = transform;
                        lodash.unary = unary;
                        lodash.union = union;
                        lodash.unionBy = unionBy;
                        lodash.unionWith = unionWith;
                        lodash.uniq = uniq;
                        lodash.uniqBy = uniqBy;
                        lodash.uniqWith = uniqWith;
                        lodash.unset = unset;
                        lodash.unzip = unzip;
                        lodash.unzipWith = unzipWith;
                        lodash.update = update;
                        lodash.updateWith = updateWith;
                        lodash.values = values;
                        lodash.valuesIn = valuesIn;
                        lodash.without = without;
                        lodash.words = words;
                        lodash.wrap = wrap;
                        lodash.xor = xor;
                        lodash.xorBy = xorBy;
                        lodash.xorWith = xorWith;
                        lodash.zip = zip;
                        lodash.zipObject = zipObject;
                        lodash.zipObjectDeep = zipObjectDeep;
                        lodash.zipWith = zipWith; // Add aliases.
                        lodash.entries = toPairs;
                        lodash.entriesIn = toPairsIn;
                        lodash.extend = assignIn;
                        lodash.extendWith = assignInWith; // Add methods to `lodash.prototype`.
                        mixin(lodash, lodash); /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
                        lodash.add = add;
                        lodash.attempt = attempt;
                        lodash.camelCase = camelCase;
                        lodash.capitalize = capitalize;
                        lodash.ceil = ceil;
                        lodash.clamp = clamp;
                        lodash.clone = clone;
                        lodash.cloneDeep = cloneDeep;
                        lodash.cloneDeepWith = cloneDeepWith;
                        lodash.cloneWith = cloneWith;
                        lodash.conformsTo = conformsTo;
                        lodash.deburr = deburr;
                        lodash.defaultTo = defaultTo;
                        lodash.divide = divide;
                        lodash.endsWith = endsWith;
                        lodash.eq = eq;
                        lodash.escape = escape;
                        lodash.escapeRegExp = escapeRegExp;
                        lodash.every = every;
                        lodash.find = find;
                        lodash.findIndex = findIndex;
                        lodash.findKey = findKey;
                        lodash.findLast = findLast;
                        lodash.findLastIndex = findLastIndex;
                        lodash.findLastKey = findLastKey;
                        lodash.floor = floor;
                        lodash.forEach = forEach;
                        lodash.forEachRight = forEachRight;
                        lodash.forIn = forIn;
                        lodash.forInRight = forInRight;
                        lodash.forOwn = forOwn;
                        lodash.forOwnRight = forOwnRight;
                        lodash.get = get;
                        lodash.gt = gt;
                        lodash.gte = gte;
                        lodash.has = has;
                        lodash.hasIn = hasIn;
                        lodash.head = head;
                        lodash.identity = identity;
                        lodash.includes = includes;
                        lodash.indexOf = indexOf;
                        lodash.inRange = inRange;
                        lodash.invoke = invoke;
                        lodash.isArguments = isArguments;
                        lodash.isArray = isArray;
                        lodash.isArrayBuffer = isArrayBuffer;
                        lodash.isArrayLike = isArrayLike;
                        lodash.isArrayLikeObject = isArrayLikeObject;
                        lodash.isBoolean = isBoolean;
                        lodash.isBuffer = isBuffer;
                        lodash.isDate = isDate;
                        lodash.isElement = isElement;
                        lodash.isEmpty = isEmpty;
                        lodash.isEqual = isEqual;
                        lodash.isEqualWith = isEqualWith;
                        lodash.isError = isError;
                        lodash.isFinite = isFinite;
                        lodash.isFunction = isFunction;
                        lodash.isInteger = isInteger;
                        lodash.isLength = isLength;
                        lodash.isMap = isMap;
                        lodash.isMatch = isMatch;
                        lodash.isMatchWith = isMatchWith;
                        lodash.isNaN = isNaN;
                        lodash.isNative = isNative;
                        lodash.isNil = isNil;
                        lodash.isNull = isNull;
                        lodash.isNumber = isNumber;
                        lodash.isObject = isObject;
                        lodash.isObjectLike = isObjectLike;
                        lodash.isPlainObject = isPlainObject;
                        lodash.isRegExp = isRegExp;
                        lodash.isSafeInteger = isSafeInteger;
                        lodash.isSet = isSet;
                        lodash.isString = isString;
                        lodash.isSymbol = isSymbol;
                        lodash.isTypedArray = isTypedArray;
                        lodash.isUndefined = isUndefined;
                        lodash.isWeakMap = isWeakMap;
                        lodash.isWeakSet = isWeakSet;
                        lodash.join = join;
                        lodash.kebabCase = kebabCase;
                        lodash.last = last;
                        lodash.lastIndexOf = lastIndexOf;
                        lodash.lowerCase = lowerCase;
                        lodash.lowerFirst = lowerFirst;
                        lodash.lt = lt;
                        lodash.lte = lte;
                        lodash.max = max;
                        lodash.maxBy = maxBy;
                        lodash.mean = mean;
                        lodash.meanBy = meanBy;
                        lodash.min = min;
                        lodash.minBy = minBy;
                        lodash.stubArray = stubArray;
                        lodash.stubFalse = stubFalse;
                        lodash.stubObject = stubObject;
                        lodash.stubString = stubString;
                        lodash.stubTrue = stubTrue;
                        lodash.multiply = multiply;
                        lodash.nth = nth;
                        lodash.noConflict = noConflict;
                        lodash.noop = noop;
                        lodash.now = now;
                        lodash.pad = pad;
                        lodash.padEnd = padEnd;
                        lodash.padStart = padStart;
                        lodash.parseInt = parseInt;
                        lodash.random = random;
                        lodash.reduce = reduce;
                        lodash.reduceRight = reduceRight;
                        lodash.repeat = repeat;
                        lodash.replace = replace;
                        lodash.result = result;
                        lodash.round = round;
                        lodash.runInContext = runInContext;
                        lodash.sample = sample;
                        lodash.size = size;
                        lodash.snakeCase = snakeCase;
                        lodash.some = some;
                        lodash.sortedIndex = sortedIndex;
                        lodash.sortedIndexBy = sortedIndexBy;
                        lodash.sortedIndexOf = sortedIndexOf;
                        lodash.sortedLastIndex = sortedLastIndex;
                        lodash.sortedLastIndexBy = sortedLastIndexBy;
                        lodash.sortedLastIndexOf = sortedLastIndexOf;
                        lodash.startCase = startCase;
                        lodash.startsWith = startsWith;
                        lodash.subtract = subtract;
                        lodash.sum = sum;
                        lodash.sumBy = sumBy;
                        lodash.template = template;
                        lodash.times = times;
                        lodash.toFinite = toFinite;
                        lodash.toInteger = toInteger;
                        lodash.toLength = toLength;
                        lodash.toLower = toLower;
                        lodash.toNumber = toNumber;
                        lodash.toSafeInteger = toSafeInteger;
                        lodash.toString = toString;
                        lodash.toUpper = toUpper;
                        lodash.trim = trim;
                        lodash.trimEnd = trimEnd;
                        lodash.trimStart = trimStart;
                        lodash.truncate = truncate;
                        lodash.unescape = unescape;
                        lodash.uniqueId = uniqueId;
                        lodash.upperCase = upperCase;
                        lodash.upperFirst = upperFirst; // Add aliases.
                        lodash.each = forEach;
                        lodash.eachRight = forEachRight;
                        lodash.first = head;
                        mixin(lodash, function () { var source = {}; baseForOwn(lodash, function (func, methodName) { if (!hasOwnProperty.call(lodash.prototype, methodName)) {
                            source[methodName] = func;
                        } }); return source; }(), { 'chain': false }); /*------------------------------------------------------------------------*/ /**
                                 * The semantic version number.
                                 *
                                 * @static
                                 * @memberOf _
                                 * @type {string}
                                 */
                        lodash.VERSION = VERSION; // Assign default placeholders.
                        arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) { lodash[methodName].placeholder = lodash; }); // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
                        arrayEach(['drop', 'take'], function (methodName, index) { LazyWrapper.prototype[methodName] = function (n) { n = n === undefined ? 1 : nativeMax(toInteger(n), 0); var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone(); if (result.__filtered__) {
                            result.__takeCount__ = nativeMin(n, result.__takeCount__);
                        }
                        else {
                            result.__views__.push({ 'size': nativeMin(n, MAX_ARRAY_LENGTH), 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
                        } return result; }; LazyWrapper.prototype[methodName + 'Right'] = function (n) { return this.reverse()[methodName](n).reverse(); }; }); // Add `LazyWrapper` methods that accept an `iteratee` value.
                        arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) { var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG; LazyWrapper.prototype[methodName] = function (iteratee) { var result = this.clone(); result.__iteratees__.push({ 'iteratee': getIteratee(iteratee, 3), 'type': type }); result.__filtered__ = result.__filtered__ || isFilter; return result; }; }); // Add `LazyWrapper` methods for `_.head` and `_.last`.
                        arrayEach(['head', 'last'], function (methodName, index) { var takeName = 'take' + (index ? 'Right' : ''); LazyWrapper.prototype[methodName] = function () { return this[takeName](1).value()[0]; }; }); // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
                        arrayEach(['initial', 'tail'], function (methodName, index) { var dropName = 'drop' + (index ? '' : 'Right'); LazyWrapper.prototype[methodName] = function () { return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1); }; });
                        LazyWrapper.prototype.compact = function () { return this.filter(identity); };
                        LazyWrapper.prototype.find = function (predicate) { return this.filter(predicate).head(); };
                        LazyWrapper.prototype.findLast = function (predicate) { return this.reverse().find(predicate); };
                        LazyWrapper.prototype.invokeMap = baseRest(function (path, args) { if (typeof path == 'function') {
                            return new LazyWrapper(this);
                        } return this.map(function (value) { return baseInvoke(value, path, args); }); });
                        LazyWrapper.prototype.reject = function (predicate) { return this.filter(negate(getIteratee(predicate))); };
                        LazyWrapper.prototype.slice = function (start, end) { start = toInteger(start); var result = this; if (result.__filtered__ && (start > 0 || end < 0)) {
                            return new LazyWrapper(result);
                        } if (start < 0) {
                            result = result.takeRight(-start);
                        }
                        else if (start) {
                            result = result.drop(start);
                        } if (end !== undefined) {
                            end = toInteger(end);
                            result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                        } return result; };
                        LazyWrapper.prototype.takeRightWhile = function (predicate) { return this.reverse().takeWhile(predicate).reverse(); };
                        LazyWrapper.prototype.toArray = function () { return this.take(MAX_ARRAY_LENGTH); }; // Add `LazyWrapper` methods to `lodash.prototype`.
                        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
                            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
                            if (!lodashFunc) {
                                return;
                            }
                            lodash.prototype[methodName] = function () {
                                var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                                var interceptor = function interceptor(value) { var result = lodashFunc.apply(lodash, arrayPush([value], args)); return isTaker && chainAll ? result[0] : result; };
                                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) { // Avoid lazy use if the iteratee has a "length" value other than `1`.
                                    isLazy = useLazy = false;
                                }
                                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                                if (!retUnwrapped && useLazy) {
                                    value = onlyLazy ? value : new LazyWrapper(this);
                                    var result = func.apply(value, args);
                                    result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
                                    return new LodashWrapper(result, chainAll);
                                }
                                if (isUnwrapped && onlyLazy) {
                                    return func.apply(this, args);
                                }
                                result = this.thru(interceptor);
                                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                            };
                        }); // Add `Array` methods to `lodash.prototype`.
                        arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) { var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName); lodash.prototype[methodName] = function () { var args = arguments; if (retUnwrapped && !this.__chain__) {
                            var value = this.value();
                            return func.apply(isArray(value) ? value : [], args);
                        } return this[chainName](function (value) { return func.apply(isArray(value) ? value : [], args); }); }; }); // Map minified method names to their real names.
                        baseForOwn(LazyWrapper.prototype, function (func, methodName) { var lodashFunc = lodash[methodName]; if (lodashFunc) {
                            var key = lodashFunc.name + '';
                            if (!hasOwnProperty.call(realNames, key)) {
                                realNames[key] = [];
                            }
                            realNames[key].push({ 'name': methodName, 'func': lodashFunc });
                        } });
                        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }]; // Add methods to `LazyWrapper`.
                        LazyWrapper.prototype.clone = lazyClone;
                        LazyWrapper.prototype.reverse = lazyReverse;
                        LazyWrapper.prototype.value = lazyValue; // Add chain sequence methods to the `lodash` wrapper.
                        lodash.prototype.at = wrapperAt;
                        lodash.prototype.chain = wrapperChain;
                        lodash.prototype.commit = wrapperCommit;
                        lodash.prototype.next = wrapperNext;
                        lodash.prototype.plant = wrapperPlant;
                        lodash.prototype.reverse = wrapperReverse;
                        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue; // Add lazy aliases.
                        lodash.prototype.first = lodash.prototype.head;
                        if (symIterator) {
                            lodash.prototype[symIterator] = wrapperToIterator;
                        }
                        return lodash;
                    }; /*--------------------------------------------------------------------------*/ // Export lodash.
                    var _ = runInContext(); // Some AMD build optimizers, like r.js, check for condition patterns like:
                    if (true) { // Expose Lodash on the global object to prevent errors when Lodash is
                        // loaded by a script tag in the presence of an AMD loader.
                        // See http://requirejs.org/docs/errors.html#mismatch for more details.
                        // Use `_.noConflict` to remove Lodash from the global object.
                        root._ = _; // Define as an anonymous module so, through path mapping, it can be
                        // referenced as the "underscore" module.
                        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return _; }).call(exports, __webpack_require__, exports, module),
                            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                    } // Check for `exports` after `define` in case a build optimizer adds it.
                    else { }
                }).call(this);
                /***/ 
            }),
            /***/ 70439: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                // A linked list to keep track of recently-used-ness
                const Yallist = __webpack_require__(37520);
                const MAX = Symbol('max');
                const LENGTH = Symbol('length');
                const LENGTH_CALCULATOR = Symbol('lengthCalculator');
                const ALLOW_STALE = Symbol('allowStale');
                const MAX_AGE = Symbol('maxAge');
                const DISPOSE = Symbol('dispose');
                const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet');
                const LRU_LIST = Symbol('lruList');
                const CACHE = Symbol('cache');
                const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet');
                const naiveLength = () => 1;
                // lruList is a yallist where the head is the youngest
                // item, and the tail is the oldest.  the list contains the Hit
                // objects as the entries.
                // Each Hit object has a reference to its Yallist.Node.  This
                // never changes.
                //
                // cache is a Map (or PseudoMap) that matches the keys to
                // the Yallist.Node object.
                class LRUCache {
                    constructor(options) {
                        if (typeof options === 'number')
                            options = {
                                max: options
                            };
                        if (!options)
                            options = {};
                        if (options.max && (typeof options.max !== 'number' || options.max < 0))
                            throw new TypeError('max must be a non-negative number');
                        // Kind of weird to have a default max of Infinity, but oh well.
                        const max = this[MAX] = options.max || Infinity;
                        const lc = options.length || naiveLength;
                        this[LENGTH_CALCULATOR] = typeof lc !== 'function' ? naiveLength : lc;
                        this[ALLOW_STALE] = options.stale || false;
                        if (options.maxAge && typeof options.maxAge !== 'number')
                            throw new TypeError('maxAge must be a number');
                        this[MAX_AGE] = options.maxAge || 0;
                        this[DISPOSE] = options.dispose;
                        this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
                        this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
                        this.reset();
                    }
                    // resize the cache when the max changes.
                    set max(mL) {
                        if (typeof mL !== 'number' || mL < 0)
                            throw new TypeError('max must be a non-negative number');
                        this[MAX] = mL || Infinity;
                        trim(this);
                    }
                    get max() {
                        return this[MAX];
                    }
                    set allowStale(allowStale) {
                        this[ALLOW_STALE] = !!allowStale;
                    }
                    get allowStale() {
                        return this[ALLOW_STALE];
                    }
                    set maxAge(mA) {
                        if (typeof mA !== 'number')
                            throw new TypeError('maxAge must be a non-negative number');
                        this[MAX_AGE] = mA;
                        trim(this);
                    }
                    get maxAge() {
                        return this[MAX_AGE];
                    }
                    // resize the cache when the lengthCalculator changes.
                    set lengthCalculator(lC) {
                        if (typeof lC !== 'function')
                            lC = naiveLength;
                        if (lC !== this[LENGTH_CALCULATOR]) {
                            this[LENGTH_CALCULATOR] = lC;
                            this[LENGTH] = 0;
                            this[LRU_LIST].forEach(hit => {
                                hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
                                this[LENGTH] += hit.length;
                            });
                        }
                        trim(this);
                    }
                    get lengthCalculator() {
                        return this[LENGTH_CALCULATOR];
                    }
                    get length() {
                        return this[LENGTH];
                    }
                    get itemCount() {
                        return this[LRU_LIST].length;
                    }
                    rforEach(fn, thisp) {
                        thisp = thisp || this;
                        for (let walker = this[LRU_LIST].tail; walker !== null;) {
                            const prev = walker.prev;
                            forEachStep(this, fn, walker, thisp);
                            walker = prev;
                        }
                    }
                    forEach(fn, thisp) {
                        thisp = thisp || this;
                        for (let walker = this[LRU_LIST].head; walker !== null;) {
                            const next = walker.next;
                            forEachStep(this, fn, walker, thisp);
                            walker = next;
                        }
                    }
                    keys() {
                        return this[LRU_LIST].toArray().map(k => k.key);
                    }
                    values() {
                        return this[LRU_LIST].toArray().map(k => k.value);
                    }
                    reset() {
                        if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) {
                            this[LRU_LIST].forEach(hit => this[DISPOSE](hit.key, hit.value));
                        }
                        this[CACHE] = new Map(); // hash of items by key
                        this[LRU_LIST] = new Yallist(); // list of items in order of use recency
                        this[LENGTH] = 0; // length of items in the list
                    }
                    dump() {
                        return this[LRU_LIST].map(hit => isStale(this, hit) ? false : {
                            k: hit.key,
                            v: hit.value,
                            e: hit.now + (hit.maxAge || 0)
                        }).toArray().filter(h => h);
                    }
                    dumpLru() {
                        return this[LRU_LIST];
                    }
                    set(key, value, maxAge) {
                        maxAge = maxAge || this[MAX_AGE];
                        if (maxAge && typeof maxAge !== 'number')
                            throw new TypeError('maxAge must be a number');
                        const now = maxAge ? Date.now() : 0;
                        const len = this[LENGTH_CALCULATOR](value, key);
                        if (this[CACHE].has(key)) {
                            if (len > this[MAX]) {
                                del(this, this[CACHE].get(key));
                                return false;
                            }
                            const node = this[CACHE].get(key);
                            const item = node.value;
                            // dispose of the old one before overwriting
                            // split out into 2 ifs for better coverage tracking
                            if (this[DISPOSE]) {
                                if (!this[NO_DISPOSE_ON_SET])
                                    this[DISPOSE](key, item.value);
                            }
                            item.now = now;
                            item.maxAge = maxAge;
                            item.value = value;
                            this[LENGTH] += len - item.length;
                            item.length = len;
                            this.get(key);
                            trim(this);
                            return true;
                        }
                        const hit = new Entry(key, value, len, now, maxAge);
                        // oversized objects fall out of cache automatically.
                        if (hit.length > this[MAX]) {
                            if (this[DISPOSE])
                                this[DISPOSE](key, value);
                            return false;
                        }
                        this[LENGTH] += hit.length;
                        this[LRU_LIST].unshift(hit);
                        this[CACHE].set(key, this[LRU_LIST].head);
                        trim(this);
                        return true;
                    }
                    has(key) {
                        if (!this[CACHE].has(key))
                            return false;
                        const hit = this[CACHE].get(key).value;
                        return !isStale(this, hit);
                    }
                    get(key) {
                        return get(this, key, true);
                    }
                    peek(key) {
                        return get(this, key, false);
                    }
                    pop() {
                        const node = this[LRU_LIST].tail;
                        if (!node)
                            return null;
                        del(this, node);
                        return node.value;
                    }
                    del(key) {
                        del(this, this[CACHE].get(key));
                    }
                    load(arr) {
                        // reset the cache
                        this.reset();
                        const now = Date.now();
                        // A previous serialized cache has the most recent items first
                        for (let l = arr.length - 1; l >= 0; l--) {
                            const hit = arr[l];
                            const expiresAt = hit.e || 0;
                            if (expiresAt === 0)
                                // the item was created without expiration in a non aged cache
                                this.set(hit.k, hit.v);
                            else {
                                const maxAge = expiresAt - now;
                                // dont add already expired items
                                if (maxAge > 0) {
                                    this.set(hit.k, hit.v, maxAge);
                                }
                            }
                        }
                    }
                    prune() {
                        this[CACHE].forEach((value, key) => get(this, key, false));
                    }
                }
                const get = (self, key, doUse) => {
                    const node = self[CACHE].get(key);
                    if (node) {
                        const hit = node.value;
                        if (isStale(self, hit)) {
                            del(self, node);
                            if (!self[ALLOW_STALE])
                                return undefined;
                        }
                        else {
                            if (doUse) {
                                if (self[UPDATE_AGE_ON_GET])
                                    node.value.now = Date.now();
                                self[LRU_LIST].unshiftNode(node);
                            }
                        }
                        return hit.value;
                    }
                };
                const isStale = (self, hit) => {
                    if (!hit || !hit.maxAge && !self[MAX_AGE])
                        return false;
                    const diff = Date.now() - hit.now;
                    return hit.maxAge ? diff > hit.maxAge : self[MAX_AGE] && diff > self[MAX_AGE];
                };
                const trim = self => {
                    if (self[LENGTH] > self[MAX]) {
                        for (let walker = self[LRU_LIST].tail; self[LENGTH] > self[MAX] && walker !== null;) {
                            // We know that we're about to delete this one, and also
                            // what the next least recently used key will be, so just
                            // go ahead and set it now.
                            const prev = walker.prev;
                            del(self, walker);
                            walker = prev;
                        }
                    }
                };
                const del = (self, node) => {
                    if (node) {
                        const hit = node.value;
                        if (self[DISPOSE])
                            self[DISPOSE](hit.key, hit.value);
                        self[LENGTH] -= hit.length;
                        self[CACHE].delete(hit.key);
                        self[LRU_LIST].removeNode(node);
                    }
                };
                class Entry {
                    constructor(key, value, length, now, maxAge) {
                        this.key = key;
                        this.value = value;
                        this.length = length;
                        this.now = now;
                        this.maxAge = maxAge || 0;
                    }
                }
                const forEachStep = (self, fn, node, thisp) => {
                    let hit = node.value;
                    if (isStale(self, hit)) {
                        del(self, node);
                        if (!self[ALLOW_STALE])
                            hit = undefined;
                    }
                    if (hit)
                        fn.call(thisp, hit.value, hit.key, self);
                };
                module.exports = LRUCache;
                /***/ 
            }),
            /***/ 74732: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const ANY = Symbol('SemVer ANY');
                // hoisted class for cyclic dependency
                class Comparator {
                    static get ANY() {
                        return ANY;
                    }
                    constructor(comp, options) {
                        options = parseOptions(options);
                        if (comp instanceof Comparator) {
                            if (comp.loose === !!options.loose) {
                                return comp;
                            }
                            else {
                                comp = comp.value;
                            }
                        }
                        comp = comp.trim().split(/\s+/).join(' ');
                        debug('comparator', comp, options);
                        this.options = options;
                        this.loose = !!options.loose;
                        this.parse(comp);
                        if (this.semver === ANY) {
                            this.value = '';
                        }
                        else {
                            this.value = this.operator + this.semver.version;
                        }
                        debug('comp', this);
                    }
                    parse(comp) {
                        const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
                        const m = comp.match(r);
                        if (!m) {
                            throw new TypeError("Invalid comparator: ".concat(comp));
                        }
                        this.operator = m[1] !== undefined ? m[1] : '';
                        if (this.operator === '=') {
                            this.operator = '';
                        }
                        // if it literally is just '>' or '' then allow anything.
                        if (!m[2]) {
                            this.semver = ANY;
                        }
                        else {
                            this.semver = new SemVer(m[2], this.options.loose);
                        }
                    }
                    toString() {
                        return this.value;
                    }
                    test(version) {
                        debug('Comparator.test', version, this.options.loose);
                        if (this.semver === ANY || version === ANY) {
                            return true;
                        }
                        if (typeof version === 'string') {
                            try {
                                version = new SemVer(version, this.options);
                            }
                            catch (er) {
                                return false;
                            }
                        }
                        return cmp(version, this.operator, this.semver, this.options);
                    }
                    intersects(comp, options) {
                        if (!(comp instanceof Comparator)) {
                            throw new TypeError('a Comparator is required');
                        }
                        if (this.operator === '') {
                            if (this.value === '') {
                                return true;
                            }
                            return new Range(comp.value, options).test(this.value);
                        }
                        else if (comp.operator === '') {
                            if (comp.value === '') {
                                return true;
                            }
                            return new Range(this.value, options).test(comp.semver);
                        }
                        options = parseOptions(options);
                        // Special cases where nothing can possibly be lower
                        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) {
                            return false;
                        }
                        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) {
                            return false;
                        }
                        // Same direction increasing (> or >=)
                        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) {
                            return true;
                        }
                        // Same direction decreasing (< or <=)
                        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) {
                            return true;
                        }
                        // same SemVer and both sides are inclusive (<= or >=)
                        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) {
                            return true;
                        }
                        // opposite directions less than
                        if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) {
                            return true;
                        }
                        // opposite directions greater than
                        if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) {
                            return true;
                        }
                        return false;
                    }
                }
                module.exports = Comparator;
                const parseOptions = __webpack_require__(81042);
                const { safeRe: re, t } = __webpack_require__(47045);
                const cmp = __webpack_require__(30706);
                const debug = __webpack_require__(52997);
                const SemVer = __webpack_require__(47566);
                const Range = __webpack_require__(13246);
                /***/ 
            }),
            /***/ 13246: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                // hoisted class for cyclic dependency
                class Range {
                    constructor(range, options) {
                        options = parseOptions(options);
                        if (range instanceof Range) {
                            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) {
                                return range;
                            }
                            else {
                                return new Range(range.raw, options);
                            }
                        }
                        if (range instanceof Comparator) {
                            // just put it in the set and return
                            this.raw = range.value;
                            this.set = [[range]];
                            this.format();
                            return this;
                        }
                        this.options = options;
                        this.loose = !!options.loose;
                        this.includePrerelease = !!options.includePrerelease;
                        // First reduce all whitespace as much as possible so we do not have to rely
                        // on potentially slow regexes like \s*. This is then stored and used for
                        // future error messages as well.
                        this.raw = range.trim().split(/\s+/).join(' ');
                        // First, split on ||
                        this.set = this.raw.split('||')
                            // map the range to a 2d array of comparators
                            .map(r => this.parseRange(r.trim()))
                            // throw out any comparator lists that are empty
                            // this generally means that it was not a valid range, which is allowed
                            // in loose mode, but will still throw if the WHOLE range is invalid.
                            .filter(c => c.length);
                        if (!this.set.length) {
                            throw new TypeError("Invalid SemVer Range: ".concat(this.raw));
                        }
                        // if we have any that are not the null set, throw out null sets.
                        if (this.set.length > 1) {
                            // keep the first one, in case they're all null sets
                            const first = this.set[0];
                            this.set = this.set.filter(c => !isNullSet(c[0]));
                            if (this.set.length === 0) {
                                this.set = [first];
                            }
                            else if (this.set.length > 1) {
                                // if we have any that are *, then the range is just *
                                for (const c of this.set) {
                                    if (c.length === 1 && isAny(c[0])) {
                                        this.set = [c];
                                        break;
                                    }
                                }
                            }
                        }
                        this.format();
                    }
                    format() {
                        this.range = this.set.map(comps => comps.join(' ').trim()).join('||').trim();
                        return this.range;
                    }
                    toString() {
                        return this.range;
                    }
                    parseRange(range) {
                        // memoize range parsing for performance.
                        // this is a very hot path, and fully deterministic.
                        const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
                        const memoKey = memoOpts + ':' + range;
                        const cached = cache.get(memoKey);
                        if (cached) {
                            return cached;
                        }
                        const loose = this.options.loose;
                        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
                        const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
                        range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
                        debug('hyphen replace', range);
                        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
                        range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
                        debug('comparator trim', range);
                        // `~ 1.2.3` => `~1.2.3`
                        range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
                        debug('tilde trim', range);
                        // `^ 1.2.3` => `^1.2.3`
                        range = range.replace(re[t.CARETTRIM], caretTrimReplace);
                        debug('caret trim', range);
                        // At this point, the range is completely trimmed and
                        // ready to be split into comparators.
                        let rangeList = range.split(' ').map(comp => parseComparator(comp, this.options)).join(' ').split(/\s+/)
                            // >=0.0.0 is equivalent to *
                            .map(comp => replaceGTE0(comp, this.options));
                        if (loose) {
                            // in loose mode, throw out any that are not valid comparators
                            rangeList = rangeList.filter(comp => {
                                debug('loose invalid filter', comp, this.options);
                                return !!comp.match(re[t.COMPARATORLOOSE]);
                            });
                        }
                        debug('range list', rangeList);
                        // if any comparators are the null set, then replace with JUST null set
                        // if more than one comparator, remove any * comparators
                        // also, don't include the same comparator more than once
                        const rangeMap = new Map();
                        const comparators = rangeList.map(comp => new Comparator(comp, this.options));
                        for (const comp of comparators) {
                            if (isNullSet(comp)) {
                                return [comp];
                            }
                            rangeMap.set(comp.value, comp);
                        }
                        if (rangeMap.size > 1 && rangeMap.has('')) {
                            rangeMap.delete('');
                        }
                        const result = [...rangeMap.values()];
                        cache.set(memoKey, result);
                        return result;
                    }
                    intersects(range, options) {
                        if (!(range instanceof Range)) {
                            throw new TypeError('a Range is required');
                        }
                        return this.set.some(thisComparators => {
                            return isSatisfiable(thisComparators, options) && range.set.some(rangeComparators => {
                                return isSatisfiable(rangeComparators, options) && thisComparators.every(thisComparator => {
                                    return rangeComparators.every(rangeComparator => {
                                        return thisComparator.intersects(rangeComparator, options);
                                    });
                                });
                            });
                        });
                    }
                    // if ANY of the sets match ALL of its comparators, then pass
                    test(version) {
                        if (!version) {
                            return false;
                        }
                        if (typeof version === 'string') {
                            try {
                                version = new SemVer(version, this.options);
                            }
                            catch (er) {
                                return false;
                            }
                        }
                        for (let i = 0; i < this.set.length; i++) {
                            if (testSet(this.set[i], version, this.options)) {
                                return true;
                            }
                        }
                        return false;
                    }
                }
                module.exports = Range;
                const LRU = __webpack_require__(70439);
                const cache = new LRU({
                    max: 1000
                });
                const parseOptions = __webpack_require__(81042);
                const Comparator = __webpack_require__(74732);
                const debug = __webpack_require__(52997);
                const SemVer = __webpack_require__(47566);
                const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = __webpack_require__(47045);
                const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = __webpack_require__(46212);
                const isNullSet = c => c.value === '<0.0.0-0';
                const isAny = c => c.value === '';
                // take a set of comparators and determine whether there
                // exists a version which can satisfy it
                const isSatisfiable = (comparators, options) => {
                    let result = true;
                    const remainingComparators = comparators.slice();
                    let testComparator = remainingComparators.pop();
                    while (result && remainingComparators.length) {
                        result = remainingComparators.every(otherComparator => {
                            return testComparator.intersects(otherComparator, options);
                        });
                        testComparator = remainingComparators.pop();
                    }
                    return result;
                };
                // comprised of xranges, tildes, stars, and gtlt's at this point.
                // already replaced the hyphen ranges
                // turn into a set of JUST comparators.
                const parseComparator = (comp, options) => {
                    debug('comp', comp, options);
                    comp = replaceCarets(comp, options);
                    debug('caret', comp);
                    comp = replaceTildes(comp, options);
                    debug('tildes', comp);
                    comp = replaceXRanges(comp, options);
                    debug('xrange', comp);
                    comp = replaceStars(comp, options);
                    debug('stars', comp);
                    return comp;
                };
                const isX = id => !id || id.toLowerCase() === 'x' || id === '*';
                // ~, ~> --> * (any, kinda silly)
                // ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
                // ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
                // ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
                // ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
                // ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
                // ~0.0.1 --> >=0.0.1 <0.1.0-0
                const replaceTildes = (comp, options) => {
                    return comp.trim().split(/\s+/).map(c => replaceTilde(c, options)).join(' ');
                };
                const replaceTilde = (comp, options) => {
                    const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
                    return comp.replace(r, (_, M, m, p, pr) => {
                        debug('tilde', comp, _, M, m, p, pr);
                        let ret;
                        if (isX(M)) {
                            ret = '';
                        }
                        else if (isX(m)) {
                            ret = ">=".concat(M, ".0.0 <").concat(+M + 1, ".0.0-0");
                        }
                        else if (isX(p)) {
                            // ~1.2 == >=1.2.0 <1.3.0-0
                            ret = ">=".concat(M, ".").concat(m, ".0 <").concat(M, ".").concat(+m + 1, ".0-0");
                        }
                        else if (pr) {
                            debug('replaceTilde pr', pr);
                            ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
                        }
                        else {
                            // ~1.2.3 == >=1.2.3 <1.3.0-0
                            ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(M, ".").concat(+m + 1, ".0-0");
                        }
                        debug('tilde return', ret);
                        return ret;
                    });
                };
                // ^ --> * (any, kinda silly)
                // ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
                // ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
                // ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
                // ^1.2.3 --> >=1.2.3 <2.0.0-0
                // ^1.2.0 --> >=1.2.0 <2.0.0-0
                // ^0.0.1 --> >=0.0.1 <0.0.2-0
                // ^0.1.0 --> >=0.1.0 <0.2.0-0
                const replaceCarets = (comp, options) => {
                    return comp.trim().split(/\s+/).map(c => replaceCaret(c, options)).join(' ');
                };
                const replaceCaret = (comp, options) => {
                    debug('caret', comp, options);
                    const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
                    const z = options.includePrerelease ? '-0' : '';
                    return comp.replace(r, (_, M, m, p, pr) => {
                        debug('caret', comp, _, M, m, p, pr);
                        let ret;
                        if (isX(M)) {
                            ret = '';
                        }
                        else if (isX(m)) {
                            ret = ">=".concat(M, ".0.0").concat(z, " <").concat(+M + 1, ".0.0-0");
                        }
                        else if (isX(p)) {
                            if (M === '0') {
                                ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
                            }
                            else {
                                ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(+M + 1, ".0.0-0");
                            }
                        }
                        else if (pr) {
                            debug('replaceCaret pr', pr);
                            if (M === '0') {
                                if (m === '0') {
                                    ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                                }
                                else {
                                    ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
                                }
                            }
                            else {
                                ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(+M + 1, ".0.0-0");
                            }
                        }
                        else {
                            debug('no pr');
                            if (M === '0') {
                                if (m === '0') {
                                    ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                                }
                                else {
                                    ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
                                }
                            }
                            else {
                                ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(+M + 1, ".0.0-0");
                            }
                        }
                        debug('caret return', ret);
                        return ret;
                    });
                };
                const replaceXRanges = (comp, options) => {
                    debug('replaceXRanges', comp, options);
                    return comp.split(/\s+/).map(c => replaceXRange(c, options)).join(' ');
                };
                const replaceXRange = (comp, options) => {
                    comp = comp.trim();
                    const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
                    return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
                        debug('xRange', comp, ret, gtlt, M, m, p, pr);
                        const xM = isX(M);
                        const xm = xM || isX(m);
                        const xp = xm || isX(p);
                        const anyX = xp;
                        if (gtlt === '=' && anyX) {
                            gtlt = '';
                        }
                        // if we're including prereleases in the match, then we need
                        // to fix this to -0, the lowest possible prerelease value
                        pr = options.includePrerelease ? '-0' : '';
                        if (xM) {
                            if (gtlt === '>' || gtlt === '<') {
                                // nothing is allowed
                                ret = '<0.0.0-0';
                            }
                            else {
                                // nothing is forbidden
                                ret = '*';
                            }
                        }
                        else if (gtlt && anyX) {
                            // we know patch is an x, because we have any x at all.
                            // replace X with 0
                            if (xm) {
                                m = 0;
                            }
                            p = 0;
                            if (gtlt === '>') {
                                // >1 => >=2.0.0
                                // >1.2 => >=1.3.0
                                gtlt = '>=';
                                if (xm) {
                                    M = +M + 1;
                                    m = 0;
                                    p = 0;
                                }
                                else {
                                    m = +m + 1;
                                    p = 0;
                                }
                            }
                            else if (gtlt === '<=') {
                                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                                gtlt = '<';
                                if (xm) {
                                    M = +M + 1;
                                }
                                else {
                                    m = +m + 1;
                                }
                            }
                            if (gtlt === '<') {
                                pr = '-0';
                            }
                            ret = "".concat(gtlt + M, ".").concat(m, ".").concat(p).concat(pr);
                        }
                        else if (xm) {
                            ret = ">=".concat(M, ".0.0").concat(pr, " <").concat(+M + 1, ".0.0-0");
                        }
                        else if (xp) {
                            ret = ">=".concat(M, ".").concat(m, ".0").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
                        }
                        debug('xRange return', ret);
                        return ret;
                    });
                };
                // Because * is AND-ed with everything else in the comparator,
                // and '' means "any version", just remove the *s entirely.
                const replaceStars = (comp, options) => {
                    debug('replaceStars', comp, options);
                    // Looseness is ignored here.  star is always as loose as it gets!
                    return comp.trim().replace(re[t.STAR], '');
                };
                const replaceGTE0 = (comp, options) => {
                    debug('replaceGTE0', comp, options);
                    return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
                };
                // This function is passed to string.replace(re[t.HYPHENRANGE])
                // M, m, patch, prerelease, build
                // 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
                // 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
                // 1.2 - 3.4 => >=1.2.0 <3.5.0-0
                const hyphenReplace = incPr => ($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) => {
                    if (isX(fM)) {
                        from = '';
                    }
                    else if (isX(fm)) {
                        from = ">=".concat(fM, ".0.0").concat(incPr ? '-0' : '');
                    }
                    else if (isX(fp)) {
                        from = ">=".concat(fM, ".").concat(fm, ".0").concat(incPr ? '-0' : '');
                    }
                    else if (fpr) {
                        from = ">=".concat(from);
                    }
                    else {
                        from = ">=".concat(from).concat(incPr ? '-0' : '');
                    }
                    if (isX(tM)) {
                        to = '';
                    }
                    else if (isX(tm)) {
                        to = "<".concat(+tM + 1, ".0.0-0");
                    }
                    else if (isX(tp)) {
                        to = "<".concat(tM, ".").concat(+tm + 1, ".0-0");
                    }
                    else if (tpr) {
                        to = "<=".concat(tM, ".").concat(tm, ".").concat(tp, "-").concat(tpr);
                    }
                    else if (incPr) {
                        to = "<".concat(tM, ".").concat(tm, ".").concat(+tp + 1, "-0");
                    }
                    else {
                        to = "<=".concat(to);
                    }
                    return "".concat(from, " ").concat(to).trim();
                };
                const testSet = (set, version, options) => {
                    for (let i = 0; i < set.length; i++) {
                        if (!set[i].test(version)) {
                            return false;
                        }
                    }
                    if (version.prerelease.length && !options.includePrerelease) {
                        // Find the set of versions that are allowed to have prereleases
                        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
                        // That should allow `1.2.3-pr.2` to pass.
                        // However, `1.2.4-alpha.notready` should NOT be allowed,
                        // even though it's within the range set by the comparators.
                        for (let i = 0; i < set.length; i++) {
                            debug(set[i].semver);
                            if (set[i].semver === Comparator.ANY) {
                                continue;
                            }
                            if (set[i].semver.prerelease.length > 0) {
                                const allowed = set[i].semver;
                                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) {
                                    return true;
                                }
                            }
                        }
                        // Version has a -pre, but it's not one of the ones we like.
                        return false;
                    }
                    return true;
                };
                /***/ 
            }),
            /***/ 47566: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const debug = __webpack_require__(52997);
                const { MAX_LENGTH, MAX_SAFE_INTEGER } = __webpack_require__(46212);
                const { safeRe: re, t } = __webpack_require__(47045);
                const parseOptions = __webpack_require__(81042);
                const { compareIdentifiers } = __webpack_require__(70476);
                class SemVer {
                    constructor(version, options) {
                        options = parseOptions(options);
                        if (version instanceof SemVer) {
                            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) {
                                return version;
                            }
                            else {
                                version = version.version;
                            }
                        }
                        else if (typeof version !== 'string') {
                            throw new TypeError("Invalid version. Must be a string. Got type \"".concat(typeof version, "\"."));
                        }
                        if (version.length > MAX_LENGTH) {
                            throw new TypeError("version is longer than ".concat(MAX_LENGTH, " characters"));
                        }
                        debug('SemVer', version, options);
                        this.options = options;
                        this.loose = !!options.loose;
                        // this isn't actually relevant for versions, but keep it so that we
                        // don't run into trouble passing this.options around.
                        this.includePrerelease = !!options.includePrerelease;
                        const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
                        if (!m) {
                            throw new TypeError("Invalid Version: ".concat(version));
                        }
                        this.raw = version;
                        // these are actually numbers
                        this.major = +m[1];
                        this.minor = +m[2];
                        this.patch = +m[3];
                        if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
                            throw new TypeError('Invalid major version');
                        }
                        if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
                            throw new TypeError('Invalid minor version');
                        }
                        if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
                            throw new TypeError('Invalid patch version');
                        }
                        // numberify any prerelease numeric ids
                        if (!m[4]) {
                            this.prerelease = [];
                        }
                        else {
                            this.prerelease = m[4].split('.').map(id => {
                                if (/^[0-9]+$/.test(id)) {
                                    const num = +id;
                                    if (num >= 0 && num < MAX_SAFE_INTEGER) {
                                        return num;
                                    }
                                }
                                return id;
                            });
                        }
                        this.build = m[5] ? m[5].split('.') : [];
                        this.format();
                    }
                    format() {
                        this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
                        if (this.prerelease.length) {
                            this.version += "-".concat(this.prerelease.join('.'));
                        }
                        return this.version;
                    }
                    toString() {
                        return this.version;
                    }
                    compare(other) {
                        debug('SemVer.compare', this.version, this.options, other);
                        if (!(other instanceof SemVer)) {
                            if (typeof other === 'string' && other === this.version) {
                                return 0;
                            }
                            other = new SemVer(other, this.options);
                        }
                        if (other.version === this.version) {
                            return 0;
                        }
                        return this.compareMain(other) || this.comparePre(other);
                    }
                    compareMain(other) {
                        if (!(other instanceof SemVer)) {
                            other = new SemVer(other, this.options);
                        }
                        return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
                    }
                    comparePre(other) {
                        if (!(other instanceof SemVer)) {
                            other = new SemVer(other, this.options);
                        }
                        // NOT having a prerelease is > having one
                        if (this.prerelease.length && !other.prerelease.length) {
                            return -1;
                        }
                        else if (!this.prerelease.length && other.prerelease.length) {
                            return 1;
                        }
                        else if (!this.prerelease.length && !other.prerelease.length) {
                            return 0;
                        }
                        let i = 0;
                        do {
                            const a = this.prerelease[i];
                            const b = other.prerelease[i];
                            debug('prerelease compare', i, a, b);
                            if (a === undefined && b === undefined) {
                                return 0;
                            }
                            else if (b === undefined) {
                                return 1;
                            }
                            else if (a === undefined) {
                                return -1;
                            }
                            else if (a === b) {
                                continue;
                            }
                            else {
                                return compareIdentifiers(a, b);
                            }
                        } while (++i);
                    }
                    compareBuild(other) {
                        if (!(other instanceof SemVer)) {
                            other = new SemVer(other, this.options);
                        }
                        let i = 0;
                        do {
                            const a = this.build[i];
                            const b = other.build[i];
                            debug('prerelease compare', i, a, b);
                            if (a === undefined && b === undefined) {
                                return 0;
                            }
                            else if (b === undefined) {
                                return 1;
                            }
                            else if (a === undefined) {
                                return -1;
                            }
                            else if (a === b) {
                                continue;
                            }
                            else {
                                return compareIdentifiers(a, b);
                            }
                        } while (++i);
                    }
                    // preminor will bump the version up to the next minor release, and immediately
                    // down to pre-release. premajor and prepatch work the same way.
                    inc(release, identifier, identifierBase) {
                        switch (release) {
                            case 'premajor':
                                this.prerelease.length = 0;
                                this.patch = 0;
                                this.minor = 0;
                                this.major++;
                                this.inc('pre', identifier, identifierBase);
                                break;
                            case 'preminor':
                                this.prerelease.length = 0;
                                this.patch = 0;
                                this.minor++;
                                this.inc('pre', identifier, identifierBase);
                                break;
                            case 'prepatch':
                                // If this is already a prerelease, it will bump to the next version
                                // drop any prereleases that might already exist, since they are not
                                // relevant at this point.
                                this.prerelease.length = 0;
                                this.inc('patch', identifier, identifierBase);
                                this.inc('pre', identifier, identifierBase);
                                break;
                            // If the input is a non-prerelease version, this acts the same as
                            // prepatch.
                            case 'prerelease':
                                if (this.prerelease.length === 0) {
                                    this.inc('patch', identifier, identifierBase);
                                }
                                this.inc('pre', identifier, identifierBase);
                                break;
                            case 'major':
                                // If this is a pre-major version, bump up to the same major version.
                                // Otherwise increment major.
                                // 1.0.0-5 bumps to 1.0.0
                                // 1.1.0 bumps to 2.0.0
                                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
                                    this.major++;
                                }
                                this.minor = 0;
                                this.patch = 0;
                                this.prerelease = [];
                                break;
                            case 'minor':
                                // If this is a pre-minor version, bump up to the same minor version.
                                // Otherwise increment minor.
                                // 1.2.0-5 bumps to 1.2.0
                                // 1.2.1 bumps to 1.3.0
                                if (this.patch !== 0 || this.prerelease.length === 0) {
                                    this.minor++;
                                }
                                this.patch = 0;
                                this.prerelease = [];
                                break;
                            case 'patch':
                                // If this is not a pre-release version, it will increment the patch.
                                // If it is a pre-release it will bump up to the same patch version.
                                // 1.2.0-5 patches to 1.2.0
                                // 1.2.0 patches to 1.2.1
                                if (this.prerelease.length === 0) {
                                    this.patch++;
                                }
                                this.prerelease = [];
                                break;
                            // This probably shouldn't be used publicly.
                            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
                            case 'pre':
                                {
                                    const base = Number(identifierBase) ? 1 : 0;
                                    if (!identifier && identifierBase === false) {
                                        throw new Error('invalid increment argument: identifier is empty');
                                    }
                                    if (this.prerelease.length === 0) {
                                        this.prerelease = [base];
                                    }
                                    else {
                                        let i = this.prerelease.length;
                                        while (--i >= 0) {
                                            if (typeof this.prerelease[i] === 'number') {
                                                this.prerelease[i]++;
                                                i = -2;
                                            }
                                        }
                                        if (i === -1) {
                                            // didn't increment anything
                                            if (identifier === this.prerelease.join('.') && identifierBase === false) {
                                                throw new Error('invalid increment argument: identifier already exists');
                                            }
                                            this.prerelease.push(base);
                                        }
                                    }
                                    if (identifier) {
                                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                                        let prerelease = [identifier, base];
                                        if (identifierBase === false) {
                                            prerelease = [identifier];
                                        }
                                        if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                                            if (isNaN(this.prerelease[1])) {
                                                this.prerelease = prerelease;
                                            }
                                        }
                                        else {
                                            this.prerelease = prerelease;
                                        }
                                    }
                                    break;
                                }
                            default:
                                throw new Error("invalid increment argument: ".concat(release));
                        }
                        this.raw = this.format();
                        if (this.build.length) {
                            this.raw += "+".concat(this.build.join('.'));
                        }
                        return this;
                    }
                }
                module.exports = SemVer;
                /***/ 
            }),
            /***/ 53245: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const parse = __webpack_require__(92293);
                const clean = (version, options) => {
                    const s = parse(version.trim().replace(/^[=v]+/, ''), options);
                    return s ? s.version : null;
                };
                module.exports = clean;
                /***/ 
            }),
            /***/ 30706: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const eq = __webpack_require__(88119);
                const neq = __webpack_require__(86530);
                const gt = __webpack_require__(99480);
                const gte = __webpack_require__(4975);
                const lt = __webpack_require__(17604);
                const lte = __webpack_require__(13818);
                const cmp = (a, op, b, loose) => {
                    switch (op) {
                        case '===':
                            if (typeof a === 'object') {
                                a = a.version;
                            }
                            if (typeof b === 'object') {
                                b = b.version;
                            }
                            return a === b;
                        case '!==':
                            if (typeof a === 'object') {
                                a = a.version;
                            }
                            if (typeof b === 'object') {
                                b = b.version;
                            }
                            return a !== b;
                        case '':
                        case '=':
                        case '==':
                            return eq(a, b, loose);
                        case '!=':
                            return neq(a, b, loose);
                        case '>':
                            return gt(a, b, loose);
                        case '>=':
                            return gte(a, b, loose);
                        case '<':
                            return lt(a, b, loose);
                        case '<=':
                            return lte(a, b, loose);
                        default:
                            throw new TypeError("Invalid operator: ".concat(op));
                    }
                };
                module.exports = cmp;
                /***/ 
            }),
            /***/ 14767: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const parse = __webpack_require__(92293);
                const { safeRe: re, t } = __webpack_require__(47045);
                const coerce = (version, options) => {
                    if (version instanceof SemVer) {
                        return version;
                    }
                    if (typeof version === 'number') {
                        version = String(version);
                    }
                    if (typeof version !== 'string') {
                        return null;
                    }
                    options = options || {};
                    let match = null;
                    if (!options.rtl) {
                        match = version.match(re[t.COERCE]);
                    }
                    else {
                        // Find the right-most coercible string that does not share
                        // a terminus with a more left-ward coercible string.
                        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
                        //
                        // Walk through the string checking with a /g regexp
                        // Manually set the index so as to pick up overlapping matches.
                        // Stop when we get a match that ends at the string end, since no
                        // coercible string can be more right-ward without the same terminus.
                        let next;
                        while ((next = re[t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)) {
                            if (!match || next.index + next[0].length !== match.index + match[0].length) {
                                match = next;
                            }
                            re[t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
                        }
                        // leave it in a clean state
                        re[t.COERCERTL].lastIndex = -1;
                    }
                    if (match === null) {
                        return null;
                    }
                    return parse("".concat(match[2], ".").concat(match[3] || '0', ".").concat(match[4] || '0'), options);
                };
                module.exports = coerce;
                /***/ 
            }),
            /***/ 46525: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const compareBuild = (a, b, loose) => {
                    const versionA = new SemVer(a, loose);
                    const versionB = new SemVer(b, loose);
                    return versionA.compare(versionB) || versionA.compareBuild(versionB);
                };
                module.exports = compareBuild;
                /***/ 
            }),
            /***/ 97957: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const compareLoose = (a, b) => compare(a, b, true);
                module.exports = compareLoose;
                /***/ 
            }),
            /***/ 23969: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const compare = (a, b, loose) => new SemVer(a, loose).compare(new SemVer(b, loose));
                module.exports = compare;
                /***/ 
            }),
            /***/ 15713: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const parse = __webpack_require__(92293);
                const diff = (version1, version2) => {
                    const v1 = parse(version1, null, true);
                    const v2 = parse(version2, null, true);
                    const comparison = v1.compare(v2);
                    if (comparison === 0) {
                        return null;
                    }
                    const v1Higher = comparison > 0;
                    const highVersion = v1Higher ? v1 : v2;
                    const lowVersion = v1Higher ? v2 : v1;
                    const highHasPre = !!highVersion.prerelease.length;
                    const lowHasPre = !!lowVersion.prerelease.length;
                    if (lowHasPre && !highHasPre) {
                        // Going from prerelease -> no prerelease requires some special casing
                        // If the low version has only a major, then it will always be a major
                        // Some examples:
                        // 1.0.0-1 -> 1.0.0
                        // 1.0.0-1 -> 1.1.1
                        // 1.0.0-1 -> 2.0.0
                        if (!lowVersion.patch && !lowVersion.minor) {
                            return 'major';
                        }
                        // Otherwise it can be determined by checking the high version
                        if (highVersion.patch) {
                            // anything higher than a patch bump would result in the wrong version
                            return 'patch';
                        }
                        if (highVersion.minor) {
                            // anything higher than a minor bump would result in the wrong version
                            return 'minor';
                        }
                        // bumping major/minor/patch all have same result
                        return 'major';
                    }
                    // add the `pre` prefix if we are going to a prerelease version
                    const prefix = highHasPre ? 'pre' : '';
                    if (v1.major !== v2.major) {
                        return prefix + 'major';
                    }
                    if (v1.minor !== v2.minor) {
                        return prefix + 'minor';
                    }
                    if (v1.patch !== v2.patch) {
                        return prefix + 'patch';
                    }
                    // high and low are preleases
                    return 'prerelease';
                };
                module.exports = diff;
                /***/ 
            }),
            /***/ 88119: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const eq = (a, b, loose) => compare(a, b, loose) === 0;
                module.exports = eq;
                /***/ 
            }),
            /***/ 99480: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const gt = (a, b, loose) => compare(a, b, loose) > 0;
                module.exports = gt;
                /***/ 
            }),
            /***/ 4975: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const gte = (a, b, loose) => compare(a, b, loose) >= 0;
                module.exports = gte;
                /***/ 
            }),
            /***/ 31528: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const inc = (version, release, options, identifier, identifierBase) => {
                    if (typeof options === 'string') {
                        identifierBase = identifier;
                        identifier = options;
                        options = undefined;
                    }
                    try {
                        return new SemVer(version instanceof SemVer ? version.version : version, options).inc(release, identifier, identifierBase).version;
                    }
                    catch (er) {
                        return null;
                    }
                };
                module.exports = inc;
                /***/ 
            }),
            /***/ 17604: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const lt = (a, b, loose) => compare(a, b, loose) < 0;
                module.exports = lt;
                /***/ 
            }),
            /***/ 13818: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const lte = (a, b, loose) => compare(a, b, loose) <= 0;
                module.exports = lte;
                /***/ 
            }),
            /***/ 85685: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const major = (a, loose) => new SemVer(a, loose).major;
                module.exports = major;
                /***/ 
            }),
            /***/ 49597: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const minor = (a, loose) => new SemVer(a, loose).minor;
                module.exports = minor;
                /***/ 
            }),
            /***/ 86530: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const neq = (a, b, loose) => compare(a, b, loose) !== 0;
                module.exports = neq;
                /***/ 
            }),
            /***/ 92293: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const parse = function parse(version, options) {
                    let throwErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    if (version instanceof SemVer) {
                        return version;
                    }
                    try {
                        return new SemVer(version, options);
                    }
                    catch (er) {
                        if (!throwErrors) {
                            return null;
                        }
                        throw er;
                    }
                };
                module.exports = parse;
                /***/ 
            }),
            /***/ 79708: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const patch = (a, loose) => new SemVer(a, loose).patch;
                module.exports = patch;
                /***/ 
            }),
            /***/ 55558: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const parse = __webpack_require__(92293);
                const prerelease = (version, options) => {
                    const parsed = parse(version, options);
                    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
                };
                module.exports = prerelease;
                /***/ 
            }),
            /***/ 8552: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compare = __webpack_require__(23969);
                const rcompare = (a, b, loose) => compare(b, a, loose);
                module.exports = rcompare;
                /***/ 
            }),
            /***/ 92143: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compareBuild = __webpack_require__(46525);
                const rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose));
                module.exports = rsort;
                /***/ 
            }),
            /***/ 47311: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const Range = __webpack_require__(13246);
                const satisfies = (version, range, options) => {
                    try {
                        range = new Range(range, options);
                    }
                    catch (er) {
                        return false;
                    }
                    return range.test(version);
                };
                module.exports = satisfies;
                /***/ 
            }),
            /***/ 11517: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const compareBuild = __webpack_require__(46525);
                const sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose));
                module.exports = sort;
                /***/ 
            }),
            /***/ 25443: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const parse = __webpack_require__(92293);
                const valid = (version, options) => {
                    const v = parse(version, options);
                    return v ? v.version : null;
                };
                module.exports = valid;
                /***/ 
            }),
            /***/ 27374: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                // just pre-load all the stuff that index.js lazily exports
                const internalRe = __webpack_require__(47045);
                const constants = __webpack_require__(46212);
                const SemVer = __webpack_require__(47566);
                const identifiers = __webpack_require__(70476);
                const parse = __webpack_require__(92293);
                const valid = __webpack_require__(25443);
                const clean = __webpack_require__(53245);
                const inc = __webpack_require__(31528);
                const diff = __webpack_require__(15713);
                const major = __webpack_require__(85685);
                const minor = __webpack_require__(49597);
                const patch = __webpack_require__(79708);
                const prerelease = __webpack_require__(55558);
                const compare = __webpack_require__(23969);
                const rcompare = __webpack_require__(8552);
                const compareLoose = __webpack_require__(97957);
                const compareBuild = __webpack_require__(46525);
                const sort = __webpack_require__(11517);
                const rsort = __webpack_require__(92143);
                const gt = __webpack_require__(99480);
                const lt = __webpack_require__(17604);
                const eq = __webpack_require__(88119);
                const neq = __webpack_require__(86530);
                const gte = __webpack_require__(4975);
                const lte = __webpack_require__(13818);
                const cmp = __webpack_require__(30706);
                const coerce = __webpack_require__(14767);
                const Comparator = __webpack_require__(74732);
                const Range = __webpack_require__(13246);
                const satisfies = __webpack_require__(47311);
                const toComparators = __webpack_require__(58052);
                const maxSatisfying = __webpack_require__(39225);
                const minSatisfying = __webpack_require__(21433);
                const minVersion = __webpack_require__(88598);
                const validRange = __webpack_require__(5011);
                const outside = __webpack_require__(36854);
                const gtr = __webpack_require__(27028);
                const ltr = __webpack_require__(40178);
                const intersects = __webpack_require__(34729);
                const simplifyRange = __webpack_require__(91047);
                const subset = __webpack_require__(74632);
                module.exports = {
                    parse,
                    valid,
                    clean,
                    inc,
                    diff,
                    major,
                    minor,
                    patch,
                    prerelease,
                    compare,
                    rcompare,
                    compareLoose,
                    compareBuild,
                    sort,
                    rsort,
                    gt,
                    lt,
                    eq,
                    neq,
                    gte,
                    lte,
                    cmp,
                    coerce,
                    Comparator,
                    Range,
                    satisfies,
                    toComparators,
                    maxSatisfying,
                    minSatisfying,
                    minVersion,
                    validRange,
                    outside,
                    gtr,
                    ltr,
                    intersects,
                    simplifyRange,
                    subset,
                    SemVer,
                    re: internalRe.re,
                    src: internalRe.src,
                    tokens: internalRe.t,
                    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
                    RELEASE_TYPES: constants.RELEASE_TYPES,
                    compareIdentifiers: identifiers.compareIdentifiers,
                    rcompareIdentifiers: identifiers.rcompareIdentifiers
                };
                /***/ 
            }),
            /***/ 46212: 
            /***/ ((module) => {
                // Note: this is the semver.org version of the spec that it implements
                // Not necessarily the package version of this code.
                const SEMVER_SPEC_VERSION = '2.0.0';
                const MAX_LENGTH = 256;
                const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
                // Max safe segment length for coercion.
                const MAX_SAFE_COMPONENT_LENGTH = 16;
                // Max safe length for a build identifier. The max length minus 6 characters for
                // the shortest version with a build 0.0.0+BUILD.
                const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
                const RELEASE_TYPES = ['major', 'premajor', 'minor', 'preminor', 'patch', 'prepatch', 'prerelease'];
                module.exports = {
                    MAX_LENGTH,
                    MAX_SAFE_COMPONENT_LENGTH,
                    MAX_SAFE_BUILD_LENGTH,
                    MAX_SAFE_INTEGER,
                    RELEASE_TYPES,
                    SEMVER_SPEC_VERSION,
                    FLAG_INCLUDE_PRERELEASE: 0b001,
                    FLAG_LOOSE: 0b010
                };
                /***/ 
            }),
            /***/ 52997: 
            /***/ ((module) => {
                const debug = typeof process === 'object' && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? function () {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }
                    return console.error('SEMVER', ...args);
                } : () => { };
                module.exports = debug;
                /***/ 
            }),
            /***/ 70476: 
            /***/ ((module) => {
                const numeric = /^[0-9]+$/;
                const compareIdentifiers = (a, b) => {
                    const anum = numeric.test(a);
                    const bnum = numeric.test(b);
                    if (anum && bnum) {
                        a = +a;
                        b = +b;
                    }
                    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
                };
                const rcompareIdentifiers = (a, b) => compareIdentifiers(b, a);
                module.exports = {
                    compareIdentifiers,
                    rcompareIdentifiers
                };
                /***/ 
            }),
            /***/ 81042: 
            /***/ ((module) => {
                // parse out just the options we care about
                const looseOption = Object.freeze({
                    loose: true
                });
                const emptyOpts = Object.freeze({});
                const parseOptions = options => {
                    if (!options) {
                        return emptyOpts;
                    }
                    if (typeof options !== 'object') {
                        return looseOption;
                    }
                    return options;
                };
                module.exports = parseOptions;
                /***/ 
            }),
            /***/ 47045: 
            /***/ ((module, exports, __webpack_require__) => {
                const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = __webpack_require__(46212);
                const debug = __webpack_require__(52997);
                exports = module.exports = {};
                // The actual regexps go on exports.re
                const re = exports.re = [];
                const safeRe = exports.safeRe = [];
                const src = exports.src = [];
                const t = exports.t = {};
                let R = 0;
                const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
                // Replace some greedy regex tokens to prevent regex dos issues. These regex are
                // used internally via the safeRe object since all inputs in this library get
                // normalized first to trim and collapse all extra whitespace. The original
                // regexes are exported for userland consumption and lower level usage. A
                // future breaking change could export the safer regex only with a note that
                // all input should have extra whitespace removed.
                const safeRegexReplacements = [['\\s', 1], ['\\d', MAX_LENGTH], [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH]];
                const makeSafeRegex = value => {
                    for (const [token, max] of safeRegexReplacements) {
                        value = value.split("".concat(token, "*")).join("".concat(token, "{0,").concat(max, "}")).split("".concat(token, "+")).join("".concat(token, "{1,").concat(max, "}"));
                    }
                    return value;
                };
                const createToken = (name, value, isGlobal) => {
                    const safe = makeSafeRegex(value);
                    const index = R++;
                    debug(name, index, value);
                    t[name] = index;
                    src[index] = value;
                    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
                    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
                };
                // The following Regular Expressions can be used for tokenizing,
                // validating, and parsing SemVer version strings.
                // ## Numeric Identifier
                // A single `0`, or a non-zero digit followed by zero or more digits.
                createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
                createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
                // ## Non-numeric Identifier
                // Zero or more digits, followed by a letter or hyphen, and then zero or
                // more letters, digits, or hyphens.
                createToken('NONNUMERICIDENTIFIER', "\\d*[a-zA-Z-]".concat(LETTERDASHNUMBER, "*"));
                // ## Main Version
                // Three dot-separated numeric identifiers.
                createToken('MAINVERSION', "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")"));
                createToken('MAINVERSIONLOOSE', "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")"));
                // ## Pre-release Version Identifier
                // A numeric identifier, or a non-numeric identifier.
                createToken('PRERELEASEIDENTIFIER', "(?:".concat(src[t.NUMERICIDENTIFIER], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
                createToken('PRERELEASEIDENTIFIERLOOSE', "(?:".concat(src[t.NUMERICIDENTIFIERLOOSE], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
                // ## Pre-release Version
                // Hyphen, followed by one or more dot-separated pre-release version
                // identifiers.
                createToken('PRERELEASE', "(?:-(".concat(src[t.PRERELEASEIDENTIFIER], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIER], ")*))"));
                createToken('PRERELEASELOOSE', "(?:-?(".concat(src[t.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIERLOOSE], ")*))"));
                // ## Build Metadata Identifier
                // Any combination of digits, letters, or hyphens.
                createToken('BUILDIDENTIFIER', "".concat(LETTERDASHNUMBER, "+"));
                // ## Build Metadata
                // Plus sign, followed by one or more period-separated build metadata
                // identifiers.
                createToken('BUILD', "(?:\\+(".concat(src[t.BUILDIDENTIFIER], "(?:\\.").concat(src[t.BUILDIDENTIFIER], ")*))"));
                // ## Full Version String
                // A main version, followed optionally by a pre-release version and
                // build metadata.
                // Note that the only major, minor, patch, and pre-release sections of
                // the version string are capturing groups.  The build metadata is not a
                // capturing group, because it should not ever be used in version
                // comparison.
                createToken('FULLPLAIN', "v?".concat(src[t.MAINVERSION]).concat(src[t.PRERELEASE], "?").concat(src[t.BUILD], "?"));
                createToken('FULL', "^".concat(src[t.FULLPLAIN], "$"));
                // like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
                // also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
                // common in the npm registry.
                createToken('LOOSEPLAIN', "[v=\\s]*".concat(src[t.MAINVERSIONLOOSE]).concat(src[t.PRERELEASELOOSE], "?").concat(src[t.BUILD], "?"));
                createToken('LOOSE', "^".concat(src[t.LOOSEPLAIN], "$"));
                createToken('GTLT', '((?:<|>)?=?)');
                // Something like "2.*" or "1.2.x".
                // Note that "x.x" is a valid xRange identifer, meaning "any version"
                // Only the first item is strictly required.
                createToken('XRANGEIDENTIFIERLOOSE', "".concat(src[t.NUMERICIDENTIFIERLOOSE], "|x|X|\\*"));
                createToken('XRANGEIDENTIFIER', "".concat(src[t.NUMERICIDENTIFIER], "|x|X|\\*"));
                createToken('XRANGEPLAIN', "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:".concat(src[t.PRERELEASE], ")?").concat(src[t.BUILD], "?") + ")?)?");
                createToken('XRANGEPLAINLOOSE', "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(src[t.PRERELEASELOOSE], ")?").concat(src[t.BUILD], "?") + ")?)?");
                createToken('XRANGE', "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAIN], "$"));
                createToken('XRANGELOOSE', "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAINLOOSE], "$"));
                // Coercion.
                // Extract anything that could conceivably be a part of a valid semver
                createToken('COERCE', "".concat('(^|[^\\d])' + '(\\d{1,').concat(MAX_SAFE_COMPONENT_LENGTH, "})") + "(?:\\.(\\d{1,".concat(MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:\\.(\\d{1,".concat(MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:$|[^\\d])");
                createToken('COERCERTL', src[t.COERCE], true);
                // Tilde ranges.
                // Meaning is "reasonably at or greater than"
                createToken('LONETILDE', '(?:~>?)');
                createToken('TILDETRIM', "(\\s*)".concat(src[t.LONETILDE], "\\s+"), true);
                exports.tildeTrimReplace = '$1~';
                createToken('TILDE', "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAIN], "$"));
                createToken('TILDELOOSE', "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAINLOOSE], "$"));
                // Caret ranges.
                // Meaning is "at least and backwards compatible with"
                createToken('LONECARET', '(?:\\^)');
                createToken('CARETTRIM', "(\\s*)".concat(src[t.LONECARET], "\\s+"), true);
                exports.caretTrimReplace = '$1^';
                createToken('CARET', "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAIN], "$"));
                createToken('CARETLOOSE', "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAINLOOSE], "$"));
                // A simple gt/lt/eq thing, or just "" to indicate "any version"
                createToken('COMPARATORLOOSE', "^".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], ")$|^$"));
                createToken('COMPARATOR', "^".concat(src[t.GTLT], "\\s*(").concat(src[t.FULLPLAIN], ")$|^$"));
                // An expression to strip any whitespace between the gtlt and the thing
                // it modifies, so that `> 1.2.3` ==> `>1.2.3`
                createToken('COMPARATORTRIM', "(\\s*)".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], "|").concat(src[t.XRANGEPLAIN], ")"), true);
                exports.comparatorTrimReplace = '$1$2$3';
                // Something like `1.2.3 - 1.2.4`
                // Note that these all use the loose form, because they'll be
                // checked against either the strict or loose comparator form
                // later.
                createToken('HYPHENRANGE', "^\\s*(".concat(src[t.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAIN], ")") + "\\s*$");
                createToken('HYPHENRANGELOOSE', "^\\s*(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s*$");
                // Star ranges basically just allow anything at all.
                createToken('STAR', '(<|>)?=?\\s*\\*');
                // >=0.0.0 is like a star
                createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
                createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');
                /***/ 
            }),
            /***/ 27028: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                // Determine if version is greater than all the versions possible in the range.
                const outside = __webpack_require__(36854);
                const gtr = (version, range, options) => outside(version, range, '>', options);
                module.exports = gtr;
                /***/ 
            }),
            /***/ 34729: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const Range = __webpack_require__(13246);
                const intersects = (r1, r2, options) => {
                    r1 = new Range(r1, options);
                    r2 = new Range(r2, options);
                    return r1.intersects(r2, options);
                };
                module.exports = intersects;
                /***/ 
            }),
            /***/ 40178: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const outside = __webpack_require__(36854);
                // Determine if version is less than all the versions possible in the range
                const ltr = (version, range, options) => outside(version, range, '<', options);
                module.exports = ltr;
                /***/ 
            }),
            /***/ 39225: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const Range = __webpack_require__(13246);
                const maxSatisfying = (versions, range, options) => {
                    let max = null;
                    let maxSV = null;
                    let rangeObj = null;
                    try {
                        rangeObj = new Range(range, options);
                    }
                    catch (er) {
                        return null;
                    }
                    versions.forEach(v => {
                        if (rangeObj.test(v)) {
                            // satisfies(v, range, options)
                            if (!max || maxSV.compare(v) === -1) {
                                // compare(max, v, true)
                                max = v;
                                maxSV = new SemVer(max, options);
                            }
                        }
                    });
                    return max;
                };
                module.exports = maxSatisfying;
                /***/ 
            }),
            /***/ 21433: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const Range = __webpack_require__(13246);
                const minSatisfying = (versions, range, options) => {
                    let min = null;
                    let minSV = null;
                    let rangeObj = null;
                    try {
                        rangeObj = new Range(range, options);
                    }
                    catch (er) {
                        return null;
                    }
                    versions.forEach(v => {
                        if (rangeObj.test(v)) {
                            // satisfies(v, range, options)
                            if (!min || minSV.compare(v) === 1) {
                                // compare(min, v, true)
                                min = v;
                                minSV = new SemVer(min, options);
                            }
                        }
                    });
                    return min;
                };
                module.exports = minSatisfying;
                /***/ 
            }),
            /***/ 88598: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const Range = __webpack_require__(13246);
                const gt = __webpack_require__(99480);
                const minVersion = (range, loose) => {
                    range = new Range(range, loose);
                    let minver = new SemVer('0.0.0');
                    if (range.test(minver)) {
                        return minver;
                    }
                    minver = new SemVer('0.0.0-0');
                    if (range.test(minver)) {
                        return minver;
                    }
                    minver = null;
                    for (let i = 0; i < range.set.length; ++i) {
                        const comparators = range.set[i];
                        let setMin = null;
                        comparators.forEach(comparator => {
                            // Clone to avoid manipulating the comparator's semver object.
                            const compver = new SemVer(comparator.semver.version);
                            switch (comparator.operator) {
                                case '>':
                                    if (compver.prerelease.length === 0) {
                                        compver.patch++;
                                    }
                                    else {
                                        compver.prerelease.push(0);
                                    }
                                    compver.raw = compver.format();
                                /* fallthrough */
                                case '':
                                case '>=':
                                    if (!setMin || gt(compver, setMin)) {
                                        setMin = compver;
                                    }
                                    break;
                                case '<':
                                case '<=':
                                    /* Ignore maximum versions */
                                    break;
                                /* istanbul ignore next */
                                default:
                                    throw new Error("Unexpected operation: ".concat(comparator.operator));
                            }
                        });
                        if (setMin && (!minver || gt(minver, setMin))) {
                            minver = setMin;
                        }
                    }
                    if (minver && range.test(minver)) {
                        return minver;
                    }
                    return null;
                };
                module.exports = minVersion;
                /***/ 
            }),
            /***/ 36854: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const SemVer = __webpack_require__(47566);
                const Comparator = __webpack_require__(74732);
                const { ANY } = Comparator;
                const Range = __webpack_require__(13246);
                const satisfies = __webpack_require__(47311);
                const gt = __webpack_require__(99480);
                const lt = __webpack_require__(17604);
                const lte = __webpack_require__(13818);
                const gte = __webpack_require__(4975);
                const outside = (version, range, hilo, options) => {
                    version = new SemVer(version, options);
                    range = new Range(range, options);
                    let gtfn, ltefn, ltfn, comp, ecomp;
                    switch (hilo) {
                        case '>':
                            gtfn = gt;
                            ltefn = lte;
                            ltfn = lt;
                            comp = '>';
                            ecomp = '>=';
                            break;
                        case '<':
                            gtfn = lt;
                            ltefn = gte;
                            ltfn = gt;
                            comp = '<';
                            ecomp = '<=';
                            break;
                        default:
                            throw new TypeError('Must provide a hilo val of "<" or ">"');
                    }
                    // If it satisfies the range it is not outside
                    if (satisfies(version, range, options)) {
                        return false;
                    }
                    // From now on, variable terms are as if we're in "gtr" mode.
                    // but note that everything is flipped for the "ltr" function.
                    for (let i = 0; i < range.set.length; ++i) {
                        const comparators = range.set[i];
                        let high = null;
                        let low = null;
                        comparators.forEach(comparator => {
                            if (comparator.semver === ANY) {
                                comparator = new Comparator('>=0.0.0');
                            }
                            high = high || comparator;
                            low = low || comparator;
                            if (gtfn(comparator.semver, high.semver, options)) {
                                high = comparator;
                            }
                            else if (ltfn(comparator.semver, low.semver, options)) {
                                low = comparator;
                            }
                        });
                        // If the edge version comparator has a operator then our version
                        // isn't outside it
                        if (high.operator === comp || high.operator === ecomp) {
                            return false;
                        }
                        // If the lowest version comparator has an operator and our version
                        // is less than it then it isn't higher than the range
                        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) {
                            return false;
                        }
                        else if (low.operator === ecomp && ltfn(version, low.semver)) {
                            return false;
                        }
                    }
                    return true;
                };
                module.exports = outside;
                /***/ 
            }),
            /***/ 91047: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                // given a set of versions and a range, create a "simplified" range
                // that includes the same versions that the original range does
                // If the original range is shorter than the simplified one, return that.
                const satisfies = __webpack_require__(47311);
                const compare = __webpack_require__(23969);
                module.exports = (versions, range, options) => {
                    const set = [];
                    let first = null;
                    let prev = null;
                    const v = versions.sort((a, b) => compare(a, b, options));
                    for (const version of v) {
                        const included = satisfies(version, range, options);
                        if (included) {
                            prev = version;
                            if (!first) {
                                first = version;
                            }
                        }
                        else {
                            if (prev) {
                                set.push([first, prev]);
                            }
                            prev = null;
                            first = null;
                        }
                    }
                    if (first) {
                        set.push([first, null]);
                    }
                    const ranges = [];
                    for (const [min, max] of set) {
                        if (min === max) {
                            ranges.push(min);
                        }
                        else if (!max && min === v[0]) {
                            ranges.push('*');
                        }
                        else if (!max) {
                            ranges.push(">=".concat(min));
                        }
                        else if (min === v[0]) {
                            ranges.push("<=".concat(max));
                        }
                        else {
                            ranges.push("".concat(min, " - ").concat(max));
                        }
                    }
                    const simplified = ranges.join(' || ');
                    const original = typeof range.raw === 'string' ? range.raw : String(range);
                    return simplified.length < original.length ? simplified : range;
                };
                /***/ 
            }),
            /***/ 74632: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const Range = __webpack_require__(13246);
                const Comparator = __webpack_require__(74732);
                const { ANY } = Comparator;
                const satisfies = __webpack_require__(47311);
                const compare = __webpack_require__(23969);
                // Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
                // - Every simple range `r1, r2, ...` is a null set, OR
                // - Every simple range `r1, r2, ...` which is not a null set is a subset of
                //   some `R1, R2, ...`
                //
                // Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
                // - If c is only the ANY comparator
                //   - If C is only the ANY comparator, return true
                //   - Else if in prerelease mode, return false
                //   - else replace c with `[>=0.0.0]`
                // - If C is only the ANY comparator
                //   - if in prerelease mode, return true
                //   - else replace C with `[>=0.0.0]`
                // - Let EQ be the set of = comparators in c
                // - If EQ is more than one, return true (null set)
                // - Let GT be the highest > or >= comparator in c
                // - Let LT be the lowest < or <= comparator in c
                // - If GT and LT, and GT.semver > LT.semver, return true (null set)
                // - If any C is a = range, and GT or LT are set, return false
                // - If EQ
                //   - If GT, and EQ does not satisfy GT, return true (null set)
                //   - If LT, and EQ does not satisfy LT, return true (null set)
                //   - If EQ satisfies every C, return true
                //   - Else return false
                // - If GT
                //   - If GT.semver is lower than any > or >= comp in C, return false
                //   - If GT is >=, and GT.semver does not satisfy every C, return false
                //   - If GT.semver has a prerelease, and not in prerelease mode
                //     - If no C has a prerelease and the GT.semver tuple, return false
                // - If LT
                //   - If LT.semver is greater than any < or <= comp in C, return false
                //   - If LT is <=, and LT.semver does not satisfy every C, return false
                //   - If GT.semver has a prerelease, and not in prerelease mode
                //     - If no C has a prerelease and the LT.semver tuple, return false
                // - Else return true
                const subset = function subset(sub, dom) {
                    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    if (sub === dom) {
                        return true;
                    }
                    sub = new Range(sub, options);
                    dom = new Range(dom, options);
                    let sawNonNull = false;
                    OUTER: for (const simpleSub of sub.set) {
                        for (const simpleDom of dom.set) {
                            const isSub = simpleSubset(simpleSub, simpleDom, options);
                            sawNonNull = sawNonNull || isSub !== null;
                            if (isSub) {
                                continue OUTER;
                            }
                        }
                        // the null set is a subset of everything, but null simple ranges in
                        // a complex range should be ignored.  so if we saw a non-null range,
                        // then we know this isn't a subset, but if EVERY simple range was null,
                        // then it is a subset.
                        if (sawNonNull) {
                            return false;
                        }
                    }
                    return true;
                };
                const minimumVersionWithPreRelease = [new Comparator('>=0.0.0-0')];
                const minimumVersion = [new Comparator('>=0.0.0')];
                const simpleSubset = (sub, dom, options) => {
                    if (sub === dom) {
                        return true;
                    }
                    if (sub.length === 1 && sub[0].semver === ANY) {
                        if (dom.length === 1 && dom[0].semver === ANY) {
                            return true;
                        }
                        else if (options.includePrerelease) {
                            sub = minimumVersionWithPreRelease;
                        }
                        else {
                            sub = minimumVersion;
                        }
                    }
                    if (dom.length === 1 && dom[0].semver === ANY) {
                        if (options.includePrerelease) {
                            return true;
                        }
                        else {
                            dom = minimumVersion;
                        }
                    }
                    const eqSet = new Set();
                    let gt, lt;
                    for (const c of sub) {
                        if (c.operator === '>' || c.operator === '>=') {
                            gt = higherGT(gt, c, options);
                        }
                        else if (c.operator === '<' || c.operator === '<=') {
                            lt = lowerLT(lt, c, options);
                        }
                        else {
                            eqSet.add(c.semver);
                        }
                    }
                    if (eqSet.size > 1) {
                        return null;
                    }
                    let gtltComp;
                    if (gt && lt) {
                        gtltComp = compare(gt.semver, lt.semver, options);
                        if (gtltComp > 0) {
                            return null;
                        }
                        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) {
                            return null;
                        }
                    }
                    // will iterate one or zero times
                    for (const eq of eqSet) {
                        if (gt && !satisfies(eq, String(gt), options)) {
                            return null;
                        }
                        if (lt && !satisfies(eq, String(lt), options)) {
                            return null;
                        }
                        for (const c of dom) {
                            if (!satisfies(eq, String(c), options)) {
                                return false;
                            }
                        }
                        return true;
                    }
                    let higher, lower;
                    let hasDomLT, hasDomGT;
                    // if the subset has a prerelease, we need a comparator in the superset
                    // with the same tuple and a prerelease, or it's not a subset
                    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
                    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
                    // exception: <1.2.3-0 is the same as <1.2.3
                    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) {
                        needDomLTPre = false;
                    }
                    for (const c of dom) {
                        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
                        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
                        if (gt) {
                            if (needDomGTPre) {
                                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) {
                                    needDomGTPre = false;
                                }
                            }
                            if (c.operator === '>' || c.operator === '>=') {
                                higher = higherGT(gt, c, options);
                                if (higher === c && higher !== gt) {
                                    return false;
                                }
                            }
                            else if (gt.operator === '>=' && !satisfies(gt.semver, String(c), options)) {
                                return false;
                            }
                        }
                        if (lt) {
                            if (needDomLTPre) {
                                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) {
                                    needDomLTPre = false;
                                }
                            }
                            if (c.operator === '<' || c.operator === '<=') {
                                lower = lowerLT(lt, c, options);
                                if (lower === c && lower !== lt) {
                                    return false;
                                }
                            }
                            else if (lt.operator === '<=' && !satisfies(lt.semver, String(c), options)) {
                                return false;
                            }
                        }
                        if (!c.operator && (lt || gt) && gtltComp !== 0) {
                            return false;
                        }
                    }
                    // if there was a < or >, and nothing in the dom, then must be false
                    // UNLESS it was limited by another range in the other direction.
                    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
                    if (gt && hasDomLT && !lt && gtltComp !== 0) {
                        return false;
                    }
                    if (lt && hasDomGT && !gt && gtltComp !== 0) {
                        return false;
                    }
                    // we needed a prerelease range in a specific tuple, but didn't get one
                    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
                    // because it includes prereleases in the 1.2.3 tuple
                    if (needDomGTPre || needDomLTPre) {
                        return false;
                    }
                    return true;
                };
                // >=1.2.3 is lower than >1.2.3
                const higherGT = (a, b, options) => {
                    if (!a) {
                        return b;
                    }
                    const comp = compare(a.semver, b.semver, options);
                    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
                };
                // <=1.2.3 is higher than <1.2.3
                const lowerLT = (a, b, options) => {
                    if (!a) {
                        return b;
                    }
                    const comp = compare(a.semver, b.semver, options);
                    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
                };
                module.exports = subset;
                /***/ 
            }),
            /***/ 58052: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const Range = __webpack_require__(13246);
                // Mostly just for testing and legacy API reasons
                const toComparators = (range, options) => new Range(range, options).set.map(comp => comp.map(c => c.value).join(' ').trim().split(' '));
                module.exports = toComparators;
                /***/ 
            }),
            /***/ 5011: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                const Range = __webpack_require__(13246);
                const validRange = (range, options) => {
                    try {
                        // Return '*' instead of '' so that truthiness works.
                        // This will throw if it's invalid anyway
                        return new Range(range, options).range || '*';
                    }
                    catch (er) {
                        return null;
                    }
                };
                module.exports = validRange;
                /***/ 
            }),
            /***/ 31777: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                Object.defineProperty(exports, "NIL", ({
                    enumerable: true,
                    get: function get() {
                        return _nil.default;
                    }
                }));
                Object.defineProperty(exports, "parse", ({
                    enumerable: true,
                    get: function get() {
                        return _parse.default;
                    }
                }));
                Object.defineProperty(exports, "stringify", ({
                    enumerable: true,
                    get: function get() {
                        return _stringify.default;
                    }
                }));
                Object.defineProperty(exports, "v1", ({
                    enumerable: true,
                    get: function get() {
                        return _v.default;
                    }
                }));
                Object.defineProperty(exports, "v3", ({
                    enumerable: true,
                    get: function get() {
                        return _v2.default;
                    }
                }));
                Object.defineProperty(exports, "v4", ({
                    enumerable: true,
                    get: function get() {
                        return _v3.default;
                    }
                }));
                Object.defineProperty(exports, "v5", ({
                    enumerable: true,
                    get: function get() {
                        return _v4.default;
                    }
                }));
                Object.defineProperty(exports, "validate", ({
                    enumerable: true,
                    get: function get() {
                        return _validate.default;
                    }
                }));
                Object.defineProperty(exports, "version", ({
                    enumerable: true,
                    get: function get() {
                        return _version.default;
                    }
                }));
                var _v = _interopRequireDefault(__webpack_require__(53108));
                var _v2 = _interopRequireDefault(__webpack_require__(95532));
                var _v3 = _interopRequireDefault(__webpack_require__(7210));
                var _v4 = _interopRequireDefault(__webpack_require__(53025));
                var _nil = _interopRequireDefault(__webpack_require__(8239));
                var _version = _interopRequireDefault(__webpack_require__(26507));
                var _validate = _interopRequireDefault(__webpack_require__(53946));
                var _stringify = _interopRequireDefault(__webpack_require__(40835));
                var _parse = _interopRequireDefault(__webpack_require__(5366));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /***/ 
            }),
            /***/ 95645: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                /*
                 * Browser-compatible JavaScript MD5
                 *
                 * Modification of JavaScript MD5
                 * https://github.com/blueimp/JavaScript-MD5
                 *
                 * Copyright 2011, Sebastian Tschan
                 * https://blueimp.net
                 *
                 * Licensed under the MIT license:
                 * https://opensource.org/licenses/MIT
                 *
                 * Based on
                 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
                 * Digest Algorithm, as defined in RFC 1321.
                 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
                 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
                 * Distributed under the BSD License
                 * See http://pajhome.org.uk/crypt/md5 for more info.
                 */
                function md5(bytes) {
                    if (typeof bytes === 'string') {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = new Uint8Array(msg.length);
                        for (let i = 0; i < msg.length; ++i) {
                            bytes[i] = msg.charCodeAt(i);
                        }
                    }
                    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
                }
                /*
                 * Convert an array of little-endian words to an array of bytes
                 */
                function md5ToHexEncodedArray(input) {
                    const output = [];
                    const length32 = input.length * 32;
                    const hexTab = '0123456789abcdef';
                    for (let i = 0; i < length32; i += 8) {
                        const x = input[i >> 5] >>> i % 32 & 0xff;
                        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
                        output.push(hex);
                    }
                    return output;
                }
                /**
                 * Calculate output length with padding and bit length
                 */
                function getOutputLength(inputLength8) {
                    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
                }
                /*
                 * Calculate the MD5 of an array of little-endian words, and a bit length.
                 */
                function wordsToMd5(x, len) {
                    /* append padding */
                    x[len >> 5] |= 0x80 << len % 32;
                    x[getOutputLength(len) - 1] = len;
                    let a = 1732584193;
                    let b = -271733879;
                    let c = -1732584194;
                    let d = 271733878;
                    for (let i = 0; i < x.length; i += 16) {
                        const olda = a;
                        const oldb = b;
                        const oldc = c;
                        const oldd = d;
                        a = md5ff(a, b, c, d, x[i], 7, -680876936);
                        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
                        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
                        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
                        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
                        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
                        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
                        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
                        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
                        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
                        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
                        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
                        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
                        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
                        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
                        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
                        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
                        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
                        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
                        b = md5gg(b, c, d, a, x[i], 20, -373897302);
                        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
                        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
                        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
                        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
                        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
                        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
                        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
                        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
                        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
                        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
                        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
                        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
                        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
                        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
                        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
                        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
                        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
                        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
                        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
                        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
                        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
                        d = md5hh(d, a, b, c, x[i], 11, -358537222);
                        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
                        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
                        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
                        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
                        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
                        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
                        a = md5ii(a, b, c, d, x[i], 6, -198630844);
                        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
                        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
                        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
                        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
                        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
                        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
                        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
                        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
                        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
                        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
                        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
                        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
                        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
                        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
                        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
                        a = safeAdd(a, olda);
                        b = safeAdd(b, oldb);
                        c = safeAdd(c, oldc);
                        d = safeAdd(d, oldd);
                    }
                    return [a, b, c, d];
                }
                /*
                 * Convert an array bytes to an array of little-endian words
                 * Characters >255 have their high-byte silently ignored.
                 */
                function bytesToWords(input) {
                    if (input.length === 0) {
                        return [];
                    }
                    const length8 = input.length * 8;
                    const output = new Uint32Array(getOutputLength(length8));
                    for (let i = 0; i < length8; i += 8) {
                        output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
                    }
                    return output;
                }
                /*
                 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
                 * to work around bugs in some JS interpreters.
                 */
                function safeAdd(x, y) {
                    const lsw = (x & 0xffff) + (y & 0xffff);
                    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
                    return msw << 16 | lsw & 0xffff;
                }
                /*
                 * Bitwise rotate a 32-bit number to the left.
                 */
                function bitRotateLeft(num, cnt) {
                    return num << cnt | num >>> 32 - cnt;
                }
                /*
                 * These functions implement the four basic operations the algorithm uses.
                 */
                function md5cmn(q, a, b, x, s, t) {
                    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
                }
                function md5ff(a, b, c, d, x, s, t) {
                    return md5cmn(b & c | ~b & d, a, b, x, s, t);
                }
                function md5gg(a, b, c, d, x, s, t) {
                    return md5cmn(b & d | c & ~d, a, b, x, s, t);
                }
                function md5hh(a, b, c, d, x, s, t) {
                    return md5cmn(b ^ c ^ d, a, b, x, s, t);
                }
                function md5ii(a, b, c, d, x, s, t) {
                    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
                }
                var _default = md5;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 88945: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
                var _default = {
                    randomUUID
                };
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 8239: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _default = '00000000-0000-0000-0000-000000000000';
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 5366: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _validate = _interopRequireDefault(__webpack_require__(53946));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function parse(uuid) {
                    if (!(0, _validate.default)(uuid)) {
                        throw TypeError('Invalid UUID');
                    }
                    let v;
                    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
                    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
                    arr[1] = v >>> 16 & 0xff;
                    arr[2] = v >>> 8 & 0xff;
                    arr[3] = v & 0xff; // Parse ........-####-....-....-............
                    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
                    arr[5] = v & 0xff; // Parse ........-....-####-....-............
                    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
                    arr[7] = v & 0xff; // Parse ........-....-....-####-............
                    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
                    arr[9] = v & 0xff; // Parse ........-....-....-....-############
                    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
                    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
                    arr[11] = v / 0x100000000 & 0xff;
                    arr[12] = v >>> 24 & 0xff;
                    arr[13] = v >>> 16 & 0xff;
                    arr[14] = v >>> 8 & 0xff;
                    arr[15] = v & 0xff;
                    return arr;
                }
                var _default = parse;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 66979: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 52185: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = rng;
                // Unique ID creation requires a high quality random # generator. In the browser we therefore
                // require the crypto API and do not support built-in fallback to lower quality random number
                // generators (like Math.random()).
                let getRandomValues;
                const rnds8 = new Uint8Array(16);
                function rng() {
                    // lazy load so that environments that need to polyfill have a chance to do so
                    if (!getRandomValues) {
                        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
                        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
                        if (!getRandomValues) {
                            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
                        }
                    }
                    return getRandomValues(rnds8);
                }
                /***/ 
            }),
            /***/ 2743: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                // Adapted from Chris Veness' SHA1 code at
                // http://www.movable-type.co.uk/scripts/sha1.html
                function f(s, x, y, z) {
                    switch (s) {
                        case 0:
                            return x & y ^ ~x & z;
                        case 1:
                            return x ^ y ^ z;
                        case 2:
                            return x & y ^ x & z ^ y & z;
                        case 3:
                            return x ^ y ^ z;
                    }
                }
                function ROTL(x, n) {
                    return x << n | x >>> 32 - n;
                }
                function sha1(bytes) {
                    const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
                    const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
                    if (typeof bytes === 'string') {
                        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
                        bytes = [];
                        for (let i = 0; i < msg.length; ++i) {
                            bytes.push(msg.charCodeAt(i));
                        }
                    }
                    else if (!Array.isArray(bytes)) {
                        // Convert Array-like to Array
                        bytes = Array.prototype.slice.call(bytes);
                    }
                    bytes.push(0x80);
                    const l = bytes.length / 4 + 2;
                    const N = Math.ceil(l / 16);
                    const M = new Array(N);
                    for (let i = 0; i < N; ++i) {
                        const arr = new Uint32Array(16);
                        for (let j = 0; j < 16; ++j) {
                            arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
                        }
                        M[i] = arr;
                    }
                    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
                    M[N - 1][14] = Math.floor(M[N - 1][14]);
                    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
                    for (let i = 0; i < N; ++i) {
                        const W = new Uint32Array(80);
                        for (let t = 0; t < 16; ++t) {
                            W[t] = M[i][t];
                        }
                        for (let t = 16; t < 80; ++t) {
                            W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
                        }
                        let a = H[0];
                        let b = H[1];
                        let c = H[2];
                        let d = H[3];
                        let e = H[4];
                        for (let t = 0; t < 80; ++t) {
                            const s = Math.floor(t / 20);
                            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
                            e = d;
                            d = c;
                            c = ROTL(b, 30) >>> 0;
                            b = a;
                            a = T;
                        }
                        H[0] = H[0] + a >>> 0;
                        H[1] = H[1] + b >>> 0;
                        H[2] = H[2] + c >>> 0;
                        H[3] = H[3] + d >>> 0;
                        H[4] = H[4] + e >>> 0;
                    }
                    return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
                }
                var _default = sha1;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 40835: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                exports.unsafeStringify = unsafeStringify;
                var _validate = _interopRequireDefault(__webpack_require__(53946));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
                 * Convert array of 16 byte values to UUID string format of the form:
                 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
                 */
                const byteToHex = [];
                for (let i = 0; i < 256; ++i) {
                    byteToHex.push((i + 0x100).toString(16).slice(1));
                }
                function unsafeStringify(arr) {
                    let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    // Note: Be careful editing this code!  It's been tuned for performance
                    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
                    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
                }
                function stringify(arr) {
                    let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
                    // of the following:
                    // - One or more input array values don't map to a hex octet (leading to
                    // "undefined" in the uuid)
                    // - Invalid input values for the RFC `version` or `variant` fields
                    if (!(0, _validate.default)(uuid)) {
                        throw TypeError('Stringified UUID is invalid');
                    }
                    return uuid;
                }
                var _default = stringify;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 53108: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _rng = _interopRequireDefault(__webpack_require__(52185));
                var _stringify = __webpack_require__(40835);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                // **`v1()` - Generate time-based UUID**
                //
                // Inspired by https://github.com/LiosK/UUID.js
                // and http://docs.python.org/library/uuid.html
                let _nodeId;
                let _clockseq; // Previous uuid creation time
                let _lastMSecs = 0;
                let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
                function v1(options, buf, offset) {
                    let i = buf && offset || 0;
                    const b = buf || new Array(16);
                    options = options || {};
                    let node = options.node || _nodeId;
                    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
                    // specified.  We do this lazily to minimize issues related to insufficient
                    // system entropy.  See #189
                    if (node == null || clockseq == null) {
                        const seedBytes = options.random || (options.rng || _rng.default)();
                        if (node == null) {
                            // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
                            node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
                        }
                        if (clockseq == null) {
                            // Per 4.2.2, randomize (14 bit) clockseq
                            clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
                        }
                    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
                    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
                    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
                    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
                    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
                    // cycle to simulate higher resolution clock
                    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
                    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
                    if (dt < 0 && options.clockseq === undefined) {
                        clockseq = clockseq + 1 & 0x3fff;
                    } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
                    // time interval
                    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
                        nsecs = 0;
                    } // Per 4.2.1.2 Throw error if too many uuids are requested
                    if (nsecs >= 10000) {
                        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    }
                    _lastMSecs = msecs;
                    _lastNSecs = nsecs;
                    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
                    msecs += 12219292800000; // `time_low`
                    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
                    b[i++] = tl >>> 24 & 0xff;
                    b[i++] = tl >>> 16 & 0xff;
                    b[i++] = tl >>> 8 & 0xff;
                    b[i++] = tl & 0xff; // `time_mid`
                    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
                    b[i++] = tmh >>> 8 & 0xff;
                    b[i++] = tmh & 0xff; // `time_high_and_version`
                    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
                    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
                    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
                    b[i++] = clockseq & 0xff; // `node`
                    for (let n = 0; n < 6; ++n) {
                        b[i + n] = node[n];
                    }
                    return buf || (0, _stringify.unsafeStringify)(b);
                }
                var _default = v1;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 95532: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _v = _interopRequireDefault(__webpack_require__(78183));
                var _md = _interopRequireDefault(__webpack_require__(95645));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v3 = (0, _v.default)('v3', 0x30, _md.default);
                var _default = v3;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 78183: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.URL = exports.DNS = void 0;
                exports["default"] = v35;
                var _stringify = __webpack_require__(40835);
                var _parse = _interopRequireDefault(__webpack_require__(5366));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function stringToBytes(str) {
                    str = unescape(encodeURIComponent(str)); // UTF8 escape
                    const bytes = [];
                    for (let i = 0; i < str.length; ++i) {
                        bytes.push(str.charCodeAt(i));
                    }
                    return bytes;
                }
                const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
                exports.DNS = DNS;
                const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
                exports.URL = URL;
                function v35(name, version, hashfunc) {
                    function generateUUID(value, namespace, buf, offset) {
                        var _namespace;
                        if (typeof value === 'string') {
                            value = stringToBytes(value);
                        }
                        if (typeof namespace === 'string') {
                            namespace = (0, _parse.default)(namespace);
                        }
                        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
                            throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
                        } // Compute hash of namespace and value, Per 4.3
                        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
                        // hashfunc([...namespace, ... value])`
                        let bytes = new Uint8Array(16 + value.length);
                        bytes.set(namespace);
                        bytes.set(value, namespace.length);
                        bytes = hashfunc(bytes);
                        bytes[6] = bytes[6] & 0x0f | version;
                        bytes[8] = bytes[8] & 0x3f | 0x80;
                        if (buf) {
                            offset = offset || 0;
                            for (let i = 0; i < 16; ++i) {
                                buf[offset + i] = bytes[i];
                            }
                            return buf;
                        }
                        return (0, _stringify.unsafeStringify)(bytes);
                    } // Function#name is not settable on some platforms (#270)
                    try {
                        generateUUID.name = name; // eslint-disable-next-line no-empty
                    }
                    catch (err) { } // For CommonJS default export support
                    generateUUID.DNS = DNS;
                    generateUUID.URL = URL;
                    return generateUUID;
                }
                /***/ 
            }),
            /***/ 7210: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _native = _interopRequireDefault(__webpack_require__(88945));
                var _rng = _interopRequireDefault(__webpack_require__(52185));
                var _stringify = __webpack_require__(40835);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function v4(options, buf, offset) {
                    if (_native.default.randomUUID && !buf && !options) {
                        return _native.default.randomUUID();
                    }
                    options = options || {};
                    const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
                    rnds[6] = rnds[6] & 0x0f | 0x40;
                    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
                    if (buf) {
                        offset = offset || 0;
                        for (let i = 0; i < 16; ++i) {
                            buf[offset + i] = rnds[i];
                        }
                        return buf;
                    }
                    return (0, _stringify.unsafeStringify)(rnds);
                }
                var _default = v4;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 53025: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _v = _interopRequireDefault(__webpack_require__(78183));
                var _sha = _interopRequireDefault(__webpack_require__(2743));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                const v5 = (0, _v.default)('v5', 0x50, _sha.default);
                var _default = v5;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 53946: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _regex = _interopRequireDefault(__webpack_require__(66979));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function validate(uuid) {
                    return typeof uuid === 'string' && _regex.default.test(uuid);
                }
                var _default = validate;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 26507: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports["default"] = void 0;
                var _validate = _interopRequireDefault(__webpack_require__(53946));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function version(uuid) {
                    if (!(0, _validate.default)(uuid)) {
                        throw TypeError('Invalid UUID');
                    }
                    return parseInt(uuid.slice(14, 15), 16);
                }
                var _default = version;
                exports["default"] = _default;
                /***/ 
            }),
            /***/ 82908: 
            /***/ ((module) => {
                module.exports = function (Yallist) {
                    Yallist.prototype[Symbol.iterator] = function* () {
                        for (let walker = this.head; walker; walker = walker.next) {
                            yield walker.value;
                        }
                    };
                };
                /***/ 
            }),
            /***/ 37520: 
            /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
                module.exports = Yallist;
                Yallist.Node = Node;
                Yallist.create = Yallist;
                function Yallist(list) {
                    var self = this;
                    if (!(self instanceof Yallist)) {
                        self = new Yallist();
                    }
                    self.tail = null;
                    self.head = null;
                    self.length = 0;
                    if (list && typeof list.forEach === 'function') {
                        list.forEach(function (item) {
                            self.push(item);
                        });
                    }
                    else if (arguments.length > 0) {
                        for (var i = 0, l = arguments.length; i < l; i++) {
                            self.push(arguments[i]);
                        }
                    }
                    return self;
                }
                Yallist.prototype.removeNode = function (node) {
                    if (node.list !== this) {
                        throw new Error('removing node which does not belong to this list');
                    }
                    var next = node.next;
                    var prev = node.prev;
                    if (next) {
                        next.prev = prev;
                    }
                    if (prev) {
                        prev.next = next;
                    }
                    if (node === this.head) {
                        this.head = next;
                    }
                    if (node === this.tail) {
                        this.tail = prev;
                    }
                    node.list.length--;
                    node.next = null;
                    node.prev = null;
                    node.list = null;
                    return next;
                };
                Yallist.prototype.unshiftNode = function (node) {
                    if (node === this.head) {
                        return;
                    }
                    if (node.list) {
                        node.list.removeNode(node);
                    }
                    var head = this.head;
                    node.list = this;
                    node.next = head;
                    if (head) {
                        head.prev = node;
                    }
                    this.head = node;
                    if (!this.tail) {
                        this.tail = node;
                    }
                    this.length++;
                };
                Yallist.prototype.pushNode = function (node) {
                    if (node === this.tail) {
                        return;
                    }
                    if (node.list) {
                        node.list.removeNode(node);
                    }
                    var tail = this.tail;
                    node.list = this;
                    node.prev = tail;
                    if (tail) {
                        tail.next = node;
                    }
                    this.tail = node;
                    if (!this.head) {
                        this.head = node;
                    }
                    this.length++;
                };
                Yallist.prototype.push = function () {
                    for (var i = 0, l = arguments.length; i < l; i++) {
                        push(this, arguments[i]);
                    }
                    return this.length;
                };
                Yallist.prototype.unshift = function () {
                    for (var i = 0, l = arguments.length; i < l; i++) {
                        unshift(this, arguments[i]);
                    }
                    return this.length;
                };
                Yallist.prototype.pop = function () {
                    if (!this.tail) {
                        return undefined;
                    }
                    var res = this.tail.value;
                    this.tail = this.tail.prev;
                    if (this.tail) {
                        this.tail.next = null;
                    }
                    else {
                        this.head = null;
                    }
                    this.length--;
                    return res;
                };
                Yallist.prototype.shift = function () {
                    if (!this.head) {
                        return undefined;
                    }
                    var res = this.head.value;
                    this.head = this.head.next;
                    if (this.head) {
                        this.head.prev = null;
                    }
                    else {
                        this.tail = null;
                    }
                    this.length--;
                    return res;
                };
                Yallist.prototype.forEach = function (fn, thisp) {
                    thisp = thisp || this;
                    for (var walker = this.head, i = 0; walker !== null; i++) {
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.next;
                    }
                };
                Yallist.prototype.forEachReverse = function (fn, thisp) {
                    thisp = thisp || this;
                    for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.prev;
                    }
                };
                Yallist.prototype.get = function (n) {
                    for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
                        // abort out of the list early if we hit a cycle
                        walker = walker.next;
                    }
                    if (i === n && walker !== null) {
                        return walker.value;
                    }
                };
                Yallist.prototype.getReverse = function (n) {
                    for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
                        // abort out of the list early if we hit a cycle
                        walker = walker.prev;
                    }
                    if (i === n && walker !== null) {
                        return walker.value;
                    }
                };
                Yallist.prototype.map = function (fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for (var walker = this.head; walker !== null;) {
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.next;
                    }
                    return res;
                };
                Yallist.prototype.mapReverse = function (fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for (var walker = this.tail; walker !== null;) {
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.prev;
                    }
                    return res;
                };
                Yallist.prototype.reduce = function (fn, initial) {
                    var acc;
                    var walker = this.head;
                    if (arguments.length > 1) {
                        acc = initial;
                    }
                    else if (this.head) {
                        walker = this.head.next;
                        acc = this.head.value;
                    }
                    else {
                        throw new TypeError('Reduce of empty list with no initial value');
                    }
                    for (var i = 0; walker !== null; i++) {
                        acc = fn(acc, walker.value, i);
                        walker = walker.next;
                    }
                    return acc;
                };
                Yallist.prototype.reduceReverse = function (fn, initial) {
                    var acc;
                    var walker = this.tail;
                    if (arguments.length > 1) {
                        acc = initial;
                    }
                    else if (this.tail) {
                        walker = this.tail.prev;
                        acc = this.tail.value;
                    }
                    else {
                        throw new TypeError('Reduce of empty list with no initial value');
                    }
                    for (var i = this.length - 1; walker !== null; i--) {
                        acc = fn(acc, walker.value, i);
                        walker = walker.prev;
                    }
                    return acc;
                };
                Yallist.prototype.toArray = function () {
                    var arr = new Array(this.length);
                    for (var i = 0, walker = this.head; walker !== null; i++) {
                        arr[i] = walker.value;
                        walker = walker.next;
                    }
                    return arr;
                };
                Yallist.prototype.toArrayReverse = function () {
                    var arr = new Array(this.length);
                    for (var i = 0, walker = this.tail; walker !== null; i++) {
                        arr[i] = walker.value;
                        walker = walker.prev;
                    }
                    return arr;
                };
                Yallist.prototype.slice = function (from, to) {
                    to = to || this.length;
                    if (to < 0) {
                        to += this.length;
                    }
                    from = from || 0;
                    if (from < 0) {
                        from += this.length;
                    }
                    var ret = new Yallist();
                    if (to < from || to < 0) {
                        return ret;
                    }
                    if (from < 0) {
                        from = 0;
                    }
                    if (to > this.length) {
                        to = this.length;
                    }
                    for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
                        walker = walker.next;
                    }
                    for (; walker !== null && i < to; i++, walker = walker.next) {
                        ret.push(walker.value);
                    }
                    return ret;
                };
                Yallist.prototype.sliceReverse = function (from, to) {
                    to = to || this.length;
                    if (to < 0) {
                        to += this.length;
                    }
                    from = from || 0;
                    if (from < 0) {
                        from += this.length;
                    }
                    var ret = new Yallist();
                    if (to < from || to < 0) {
                        return ret;
                    }
                    if (from < 0) {
                        from = 0;
                    }
                    if (to > this.length) {
                        to = this.length;
                    }
                    for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
                        walker = walker.prev;
                    }
                    for (; walker !== null && i > from; i--, walker = walker.prev) {
                        ret.push(walker.value);
                    }
                    return ret;
                };
                Yallist.prototype.splice = function (start, deleteCount) {
                    if (start > this.length) {
                        start = this.length - 1;
                    }
                    if (start < 0) {
                        start = this.length + start;
                    }
                    for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
                        walker = walker.next;
                    }
                    var ret = [];
                    for (var i = 0; walker && i < deleteCount; i++) {
                        ret.push(walker.value);
                        walker = this.removeNode(walker);
                    }
                    if (walker === null) {
                        walker = this.tail;
                    }
                    if (walker !== this.head && walker !== this.tail) {
                        walker = walker.prev;
                    }
                    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i++) {
                        walker = insert(this, walker, i + 2 < 2 || arguments.length <= i + 2 ? undefined : arguments[i + 2]);
                    }
                    return ret;
                };
                Yallist.prototype.reverse = function () {
                    var head = this.head;
                    var tail = this.tail;
                    for (var walker = head; walker !== null; walker = walker.prev) {
                        var p = walker.prev;
                        walker.prev = walker.next;
                        walker.next = p;
                    }
                    this.head = tail;
                    this.tail = head;
                    return this;
                };
                function insert(self, node, value) {
                    var inserted = node === self.head ? new Node(value, null, node, self) : new Node(value, node, node.next, self);
                    if (inserted.next === null) {
                        self.tail = inserted;
                    }
                    if (inserted.prev === null) {
                        self.head = inserted;
                    }
                    self.length++;
                    return inserted;
                }
                function push(self, item) {
                    self.tail = new Node(item, self.tail, null, self);
                    if (!self.head) {
                        self.head = self.tail;
                    }
                    self.length++;
                }
                function unshift(self, item) {
                    self.head = new Node(item, null, self.head, self);
                    if (!self.tail) {
                        self.tail = self.head;
                    }
                    self.length++;
                }
                function Node(value, prev, next, list) {
                    if (!(this instanceof Node)) {
                        return new Node(value, prev, next, list);
                    }
                    this.list = list;
                    this.value = value;
                    if (prev) {
                        prev.next = this;
                        this.prev = prev;
                    }
                    else {
                        this.prev = null;
                    }
                    if (next) {
                        next.prev = this;
                        this.next = next;
                    }
                    else {
                        this.next = null;
                    }
                }
                try {
                    // add if support for Symbol.iterator is present
                    __webpack_require__(82908)(Yallist);
                }
                catch (er) { }
                /***/ 
            }),
            /***/ 26927: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ApiVersion = void 0;
                var ApiVersion;
                (function (ApiVersion) {
                    ApiVersion["v0"] = "20200115";
                    ApiVersion["v1"] = "20240226";
                })(ApiVersion || (exports.ApiVersion = ApiVersion = {}));
                /***/ 
            }),
            /***/ 57819: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(26927), exports);
                /***/ 
            }),
            /***/ 7941: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthApiOperations = void 0;
                var AuthApiOperations;
                (function (AuthApiOperations) {
                    AuthApiOperations[AuthApiOperations["GenerateRecoveryCodes"] = 0] = "GenerateRecoveryCodes";
                    AuthApiOperations[AuthApiOperations["GetRecoveryKeyParams"] = 1] = "GetRecoveryKeyParams";
                    AuthApiOperations[AuthApiOperations["SignInWithRecoveryCodes"] = 2] = "SignInWithRecoveryCodes";
                })(AuthApiOperations || (exports.AuthApiOperations = AuthApiOperations = {}));
                /***/ 
            }),
            /***/ 80605: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthApiService = void 0;
                const ApiCallError_1 = __webpack_require__(29898);
                const ErrorMessage_1 = __webpack_require__(38130);
                const AuthApiOperations_1 = __webpack_require__(7941);
                class AuthApiService {
                    constructor(authServer, apiVersion) {
                        this.authServer = authServer;
                        this.apiVersion = apiVersion;
                        this.operationsInProgress = new Map();
                    }
                    generateRecoveryCodes() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthApiOperations_1.AuthApiOperations.GenerateRecoveryCodes)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.GenerateRecoveryCodes, true);
                            try {
                                const response = yield this.authServer.generateRecoveryCodes();
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.GenerateRecoveryCodes, false);
                            }
                        });
                    }
                    recoveryKeyParams(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthApiOperations_1.AuthApiOperations.GetRecoveryKeyParams)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.GetRecoveryKeyParams, true);
                            try {
                                const response = yield this.authServer.recoveryKeyParams({
                                    api_version: this.apiVersion,
                                    code_challenge: dto.codeChallenge,
                                    recovery_codes: dto.recoveryCodes,
                                    username: dto.username
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.GetRecoveryKeyParams, false);
                            }
                        });
                    }
                    signInWithRecoveryCodes(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthApiOperations_1.AuthApiOperations.SignInWithRecoveryCodes)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.SignInWithRecoveryCodes, true);
                            try {
                                const response = yield this.authServer.signInWithRecoveryCodes({
                                    api_version: this.apiVersion,
                                    code_verifier: dto.codeVerifier,
                                    password: dto.password,
                                    recovery_codes: dto.recoveryCodes,
                                    username: dto.username,
                                    hvm_token: dto.hvmToken
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthApiOperations_1.AuthApiOperations.SignInWithRecoveryCodes, false);
                            }
                        });
                    }
                }
                exports.AuthApiService = AuthApiService;
                /***/ 
            }),
            /***/ 73987: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 66527: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthenticatorApiOperations = void 0;
                var AuthenticatorApiOperations;
                (function (AuthenticatorApiOperations) {
                    AuthenticatorApiOperations[AuthenticatorApiOperations["List"] = 0] = "List";
                    AuthenticatorApiOperations[AuthenticatorApiOperations["Delete"] = 1] = "Delete";
                    AuthenticatorApiOperations[AuthenticatorApiOperations["GenerateRegistrationOptions"] = 2] = "GenerateRegistrationOptions";
                    AuthenticatorApiOperations[AuthenticatorApiOperations["GenerateAuthenticationOptions"] = 3] = "GenerateAuthenticationOptions";
                    AuthenticatorApiOperations[AuthenticatorApiOperations["VerifyRegistrationResponse"] = 4] = "VerifyRegistrationResponse";
                })(AuthenticatorApiOperations || (exports.AuthenticatorApiOperations = AuthenticatorApiOperations = {}));
                /***/ 
            }),
            /***/ 60356: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthenticatorApiService = void 0;
                const ErrorMessage_1 = __webpack_require__(38130);
                const ApiCallError_1 = __webpack_require__(29898);
                const AuthenticatorApiOperations_1 = __webpack_require__(66527);
                class AuthenticatorApiService {
                    constructor(authenticatorServer) {
                        this.authenticatorServer = authenticatorServer;
                        this.operationsInProgress = new Map();
                    }
                    list() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthenticatorApiOperations_1.AuthenticatorApiOperations.List)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.List, true);
                            try {
                                const response = yield this.authenticatorServer.list({});
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.List, false);
                            }
                        });
                    }
                    delete(authenticatorId) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthenticatorApiOperations_1.AuthenticatorApiOperations.Delete)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.Delete, true);
                            try {
                                const response = yield this.authenticatorServer.delete({
                                    authenticatorId
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.Delete, false);
                            }
                        });
                    }
                    generateRegistrationOptions() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateRegistrationOptions)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateRegistrationOptions, true);
                            try {
                                const response = yield this.authenticatorServer.generateRegistrationOptions();
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateRegistrationOptions, false);
                            }
                        });
                    }
                    verifyRegistrationResponse(userUuid, name, attestationResponse) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthenticatorApiOperations_1.AuthenticatorApiOperations.VerifyRegistrationResponse)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.VerifyRegistrationResponse, true);
                            try {
                                const response = yield this.authenticatorServer.verifyRegistrationResponse({
                                    userUuid,
                                    name,
                                    attestationResponse
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.VerifyRegistrationResponse, false);
                            }
                        });
                    }
                    generateAuthenticationOptions(username) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateAuthenticationOptions)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateAuthenticationOptions, true);
                            try {
                                const response = yield this.authenticatorServer.generateAuthenticationOptions({
                                    username
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(AuthenticatorApiOperations_1.AuthenticatorApiOperations.GenerateAuthenticationOptions, false);
                            }
                        });
                    }
                }
                exports.AuthenticatorApiService = AuthenticatorApiService;
                /***/ 
            }),
            /***/ 4405: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23624: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.RevisionApiOperations = void 0;
                var RevisionApiOperations;
                (function (RevisionApiOperations) {
                    RevisionApiOperations[RevisionApiOperations["List"] = 0] = "List";
                    RevisionApiOperations[RevisionApiOperations["Delete"] = 1] = "Delete";
                    RevisionApiOperations[RevisionApiOperations["Get"] = 2] = "Get";
                })(RevisionApiOperations || (exports.RevisionApiOperations = RevisionApiOperations = {}));
                /***/ 
            }),
            /***/ 33416: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.RevisionApiService = void 0;
                const ErrorMessage_1 = __webpack_require__(38130);
                const ApiCallError_1 = __webpack_require__(29898);
                const RevisionApiOperations_1 = __webpack_require__(23624);
                class RevisionApiService {
                    constructor(revisionServer) {
                        this.revisionServer = revisionServer;
                        this.operationsInProgress = new Map();
                    }
                    listRevisions(itemUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(RevisionApiOperations_1.RevisionApiOperations.List)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.List, true);
                            try {
                                const response = yield this.revisionServer.listRevisions({
                                    itemUuid
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.List, false);
                            }
                        });
                    }
                    getRevision(itemUuid, revisionUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(RevisionApiOperations_1.RevisionApiOperations.Get)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.Get, true);
                            try {
                                const response = yield this.revisionServer.getRevision({
                                    itemUuid,
                                    revisionUuid
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.Get, false);
                            }
                        });
                    }
                    deleteRevision(itemUuid, revisionUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(RevisionApiOperations_1.RevisionApiOperations.Delete)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.Delete, true);
                            try {
                                const response = yield this.revisionServer.deleteRevision({
                                    itemUuid,
                                    revisionUuid
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(RevisionApiOperations_1.RevisionApiOperations.Delete, false);
                            }
                        });
                    }
                }
                exports.RevisionApiService = RevisionApiService;
                /***/ 
            }),
            /***/ 68888: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 17737: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionApiOperations = void 0;
                var SubscriptionApiOperations;
                (function (SubscriptionApiOperations) {
                    SubscriptionApiOperations[SubscriptionApiOperations["Inviting"] = 0] = "Inviting";
                    SubscriptionApiOperations[SubscriptionApiOperations["CancelingInvite"] = 1] = "CancelingInvite";
                    SubscriptionApiOperations[SubscriptionApiOperations["ListingInvites"] = 2] = "ListingInvites";
                    SubscriptionApiOperations[SubscriptionApiOperations["AcceptingInvite"] = 3] = "AcceptingInvite";
                    SubscriptionApiOperations[SubscriptionApiOperations["ConfirmAppleIAP"] = 4] = "ConfirmAppleIAP";
                    SubscriptionApiOperations[SubscriptionApiOperations["GetSubscription"] = 5] = "GetSubscription";
                    SubscriptionApiOperations[SubscriptionApiOperations["GetAvailableSubscriptions"] = 6] = "GetAvailableSubscriptions";
                })(SubscriptionApiOperations || (exports.SubscriptionApiOperations = SubscriptionApiOperations = {}));
                /***/ 
            }),
            /***/ 37856: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionApiService = void 0;
                const ErrorMessage_1 = __webpack_require__(38130);
                const ApiCallError_1 = __webpack_require__(29898);
                const responses_1 = __webpack_require__(95658);
                const SubscriptionApiOperations_1 = __webpack_require__(17737);
                class SubscriptionApiService {
                    constructor(subscriptionServer, apiVersion) {
                        this.subscriptionServer = subscriptionServer;
                        this.apiVersion = apiVersion;
                        this.operationsInProgress = new Map();
                    }
                    listInvites() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.ListingInvites)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.ListingInvites, true);
                            try {
                                const response = yield this.subscriptionServer.listInvites({
                                    [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.ListingInvites, false);
                            }
                        });
                    }
                    cancelInvite(inviteUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.CancelingInvite)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.CancelingInvite, true);
                            try {
                                const response = yield this.subscriptionServer.cancelInvite({
                                    [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion,
                                    inviteUuid
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.CancelingInvite, false);
                            }
                        });
                    }
                    invite(inviteeEmail) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.Inviting)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.Inviting, true);
                            try {
                                const response = yield this.subscriptionServer.invite({
                                    [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion,
                                    identifier: inviteeEmail
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.Inviting, false);
                            }
                        });
                    }
                    acceptInvite(inviteUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.AcceptingInvite)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.AcceptingInvite, true);
                            try {
                                const response = yield this.subscriptionServer.acceptInvite({
                                    inviteUuid
                                });
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.AcceptingInvite, false);
                            }
                        });
                    }
                    confirmAppleIAP(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.ConfirmAppleIAP)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.ConfirmAppleIAP, true);
                            try {
                                const response = yield this.subscriptionServer.confirmAppleIAP(params);
                                return response;
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.ConfirmAppleIAP, false);
                            }
                        });
                    }
                    getUserSubscription(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.GetSubscription)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.GetSubscription, true);
                            try {
                                const response = yield this.subscriptionServer.getUserSubscription(params);
                                return response;
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.GetSubscription, false);
                            }
                        });
                    }
                    getAvailableSubscriptions() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(SubscriptionApiOperations_1.SubscriptionApiOperations.GetAvailableSubscriptions)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.GetAvailableSubscriptions, true);
                            try {
                                const response = yield this.subscriptionServer.getAvailableSubscriptions();
                                return response;
                            }
                            finally {
                                this.operationsInProgress.set(SubscriptionApiOperations_1.SubscriptionApiOperations.GetAvailableSubscriptions, false);
                            }
                        });
                    }
                }
                exports.SubscriptionApiService = SubscriptionApiService;
                /***/ 
            }),
            /***/ 57898: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 13167: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserApiOperations = void 0;
                var UserApiOperations;
                (function (UserApiOperations) {
                    UserApiOperations[UserApiOperations["Registering"] = 0] = "Registering";
                    UserApiOperations[UserApiOperations["SubmittingRequest"] = 1] = "SubmittingRequest";
                    UserApiOperations[UserApiOperations["DeletingAccount"] = 2] = "DeletingAccount";
                    UserApiOperations[UserApiOperations["UpdatingUser"] = 3] = "UpdatingUser";
                })(UserApiOperations || (exports.UserApiOperations = UserApiOperations = {}));
                /***/ 
            }),
            /***/ 45869: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserApiService = void 0;
                const ErrorMessage_1 = __webpack_require__(38130);
                const ApiCallError_1 = __webpack_require__(29898);
                const responses_1 = __webpack_require__(95658);
                const UserApiOperations_1 = __webpack_require__(13167);
                class UserApiService {
                    constructor(userServer, userRequestServer, apiVersion) {
                        this.userServer = userServer;
                        this.userRequestServer = userRequestServer;
                        this.apiVersion = apiVersion;
                        this.operationsInProgress = new Map();
                    }
                    deleteAccount(userUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.lockOperation(UserApiOperations_1.UserApiOperations.DeletingAccount);
                            try {
                                const response = yield this.userServer.deleteAccount({
                                    userUuid: userUuid
                                });
                                this.unlockOperation(UserApiOperations_1.UserApiOperations.DeletingAccount);
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                        });
                    }
                    submitUserRequest(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.lockOperation(UserApiOperations_1.UserApiOperations.SubmittingRequest);
                            try {
                                const response = yield this.userRequestServer.submitUserRequest({
                                    userUuid: dto.userUuid,
                                    requestType: dto.requestType
                                });
                                this.unlockOperation(UserApiOperations_1.UserApiOperations.SubmittingRequest);
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                        });
                    }
                    register(registerDTO) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.lockOperation(UserApiOperations_1.UserApiOperations.Registering);
                            try {
                                const response = yield this.userServer.register(Object.assign({
                                    [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion,
                                    password: registerDTO.serverPassword,
                                    email: registerDTO.email,
                                    hvm_token: registerDTO.hvmToken,
                                    ephemeral: registerDTO.ephemeral
                                }, registerDTO.keyParams.getPortableValue()));
                                this.unlockOperation(UserApiOperations_1.UserApiOperations.Registering);
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericRegistrationFail);
                            }
                        });
                    }
                    updateUser(updateDTO) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.lockOperation(UserApiOperations_1.UserApiOperations.UpdatingUser);
                            try {
                                const response = yield this.userServer.update({
                                    [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion,
                                    user_uuid: updateDTO.userUuid
                                });
                                this.unlockOperation(UserApiOperations_1.UserApiOperations.UpdatingUser);
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                        });
                    }
                    lockOperation(operation) {
                        if (this.operationsInProgress.get(operation)) {
                            throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                        }
                        this.operationsInProgress.set(operation, true);
                    }
                    unlockOperation(operation) {
                        this.operationsInProgress.set(operation, false);
                    }
                }
                exports.UserApiService = UserApiService;
                /***/ 
            }),
            /***/ 56824: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 67958: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.WebSocketApiOperations = void 0;
                var WebSocketApiOperations;
                (function (WebSocketApiOperations) {
                    WebSocketApiOperations[WebSocketApiOperations["CreatingConnectionToken"] = 0] = "CreatingConnectionToken";
                })(WebSocketApiOperations || (exports.WebSocketApiOperations = WebSocketApiOperations = {}));
                /***/ 
            }),
            /***/ 62984: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.WebSocketApiService = void 0;
                const ErrorMessage_1 = __webpack_require__(38130);
                const ApiCallError_1 = __webpack_require__(29898);
                const WebSocketApiOperations_1 = __webpack_require__(67958);
                class WebSocketApiService {
                    constructor(webSocketServer) {
                        this.webSocketServer = webSocketServer;
                        this.operationsInProgress = new Map();
                    }
                    createConnectionToken() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.operationsInProgress.get(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken)) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
                            }
                            this.operationsInProgress.set(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken, true);
                            try {
                                const response = yield this.webSocketServer.createConnectionToken({});
                                this.operationsInProgress.set(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken, false);
                                return response;
                            }
                            catch (error) {
                                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
                            }
                        });
                    }
                }
                exports.WebSocketApiService = WebSocketApiService;
                /***/ 
            }),
            /***/ 95736: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 37729: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(7941), exports);
                __exportStar(__webpack_require__(80605), exports);
                __exportStar(__webpack_require__(73987), exports);
                __exportStar(__webpack_require__(66527), exports);
                __exportStar(__webpack_require__(60356), exports);
                __exportStar(__webpack_require__(4405), exports);
                __exportStar(__webpack_require__(23624), exports);
                __exportStar(__webpack_require__(33416), exports);
                __exportStar(__webpack_require__(68888), exports);
                __exportStar(__webpack_require__(17737), exports);
                __exportStar(__webpack_require__(37856), exports);
                __exportStar(__webpack_require__(57898), exports);
                __exportStar(__webpack_require__(13167), exports);
                __exportStar(__webpack_require__(45869), exports);
                __exportStar(__webpack_require__(56824), exports);
                __exportStar(__webpack_require__(62984), exports);
                __exportStar(__webpack_require__(95736), exports);
                /***/ 
            }),
            /***/ 29898: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ApiCallError = void 0;
                class ApiCallError extends Error {
                    constructor(message) {
                        super(message);
                        Object.setPrototypeOf(this, ApiCallError.prototype);
                    }
                }
                exports.ApiCallError = ApiCallError;
                /***/ 
            }),
            /***/ 38130: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ErrorMessage = void 0;
                var ErrorMessage;
                (function (ErrorMessage) {
                    ErrorMessage["RegistrationInProgress"] = "An existing registration request is already in progress.";
                    ErrorMessage["GenericRegistrationFail"] = "A server error occurred while trying to register. Please try again.";
                    ErrorMessage["RateLimited"] = "Too many successive server requests. Please wait a few minutes and try again.";
                    ErrorMessage["InsufficientPasswordMessage"] = "Your password must be at least %LENGTH% characters in length. For your security, please choose a longer password or, ideally, a passphrase, and try again.";
                    ErrorMessage["PasscodeRequired"] = "Your passcode is required in order to register for an account.";
                    ErrorMessage["GenericInProgress"] = "An existing request is already in progress.";
                    ErrorMessage["GenericFail"] = "A server error occurred. Please try again.";
                })(ErrorMessage || (exports.ErrorMessage = ErrorMessage = {}));
                /***/ 
            }),
            /***/ 65148: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(29898), exports);
                __exportStar(__webpack_require__(38130), exports);
                /***/ 
            }),
            /***/ 60256: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FetchRequestHandler = void 0;
                const responses_1 = __webpack_require__(95658);
                const models_1 = __webpack_require__(22325);
                const lodash_1 = __webpack_require__(84213);
                const Error_1 = __webpack_require__(65148);
                class FetchRequestHandler {
                    constructor(snjsVersion, appVersion, environment, logger) {
                        this.snjsVersion = snjsVersion;
                        this.appVersion = appVersion;
                        this.environment = environment;
                        this.logger = logger;
                    }
                    handleRequest(httpRequest) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const request = this.createRequest(httpRequest);
                            const response = yield this.runRequest(request, this.createRequestBody(httpRequest));
                            return response;
                        });
                    }
                    createRequest(httpRequest) {
                        if (httpRequest.params && httpRequest.verb === responses_1.HttpVerb.Get && Object.keys(httpRequest.params).length > 0) {
                            httpRequest.url = this.urlForUrlAndParams(httpRequest.url, httpRequest.params);
                        }
                        const headers = {};
                        if (!httpRequest.external) {
                            headers['X-SNJS-Version'] = this.snjsVersion;
                            const appVersionHeaderValue = "".concat(models_1.Environment[this.environment], "-").concat(this.appVersion);
                            headers['X-Application-Version'] = appVersionHeaderValue;
                            if (httpRequest.authentication) {
                                headers['Authorization'] = 'Bearer ' + httpRequest.authentication;
                            }
                        }
                        let contentTypeIsSet = false;
                        if (httpRequest.customHeaders && httpRequest.customHeaders.length > 0) {
                            httpRequest.customHeaders.forEach(_ref => {
                                let { key, value } = _ref;
                                headers[key] = value;
                                if (key === 'Content-Type') {
                                    contentTypeIsSet = true;
                                }
                            });
                        }
                        if (!contentTypeIsSet && !httpRequest.external) {
                            headers['Content-Type'] = 'application/json';
                        }
                        return new Request(httpRequest.url, {
                            method: httpRequest.verb,
                            headers,
                            credentials: 'include'
                        });
                    }
                    runRequest(request, body) {
                        return __awaiter(this, void 0, void 0, function* () {
                            try {
                                const fetchResponse = yield fetch(request, {
                                    body
                                });
                                const response = yield this.handleFetchResponse(fetchResponse);
                                return response;
                            }
                            catch (error) {
                                return {
                                    status: responses_1.HttpStatusCode.InternalServerError,
                                    headers: new Map(),
                                    data: {
                                        error: {
                                            message: 'message' in error ? error.message : 'Unknown error'
                                        }
                                    }
                                };
                            }
                        });
                    }
                    handleFetchResponse(fetchResponse) {
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function* () {
                            const httpStatus = fetchResponse.status;
                            const response = {
                                status: httpStatus,
                                headers: new Map(),
                                data: {}
                            };
                            fetchResponse.headers.forEach((value, key) => {
                                ;
                                response.headers.set(key, value);
                            });
                            try {
                                if (httpStatus !== responses_1.HttpStatusCode.NoContent) {
                                    let body;
                                    const contentTypeHeader = ((_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type')) || ((_b = response.headers) === null || _b === void 0 ? void 0 : _b.get('Content-Type'));
                                    if (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.includes('application/json')) {
                                        body = JSON.parse(yield fetchResponse.text());
                                    }
                                    else {
                                        body = yield fetchResponse.arrayBuffer();
                                    }
                                    /**
                                     * v0 APIs do not have a `data` top-level object. In such cases, mimic
                                     * the newer response body style by putting all the top-level
                                     * properties inside a `data` object.
                                     */
                                    if (!body.data) {
                                        response.data = body;
                                    }
                                    if (!(0, lodash_1.isString)(body)) {
                                        Object.assign(response, body);
                                    }
                                }
                            }
                            catch (error) {
                                this.logger.error(JSON.stringify(error));
                            }
                            if (httpStatus >= responses_1.HttpStatusCode.Success && httpStatus < responses_1.HttpStatusCode.InternalServerError) {
                                if (httpStatus === responses_1.HttpStatusCode.Forbidden && (0, responses_1.isErrorResponse)(response)) {
                                    if (!response.data.error) {
                                        response.data.error = {
                                            message: Error_1.ErrorMessage.RateLimited
                                        };
                                    }
                                    else {
                                        response.data.error.message = Error_1.ErrorMessage.RateLimited;
                                    }
                                }
                                return response;
                            }
                            else {
                                const errorResponse = response;
                                if (!errorResponse.data) {
                                    errorResponse.data = {
                                        error: {
                                            message: 'Unknown error'
                                        }
                                    };
                                }
                                if ((0, lodash_1.isString)(errorResponse.data)) {
                                    errorResponse.data = {
                                        error: {
                                            message: errorResponse.data
                                        }
                                    };
                                }
                                if (!errorResponse.data.error) {
                                    errorResponse.data.error = {
                                        message: 'Unknown error'
                                    };
                                }
                                return errorResponse;
                            }
                        });
                    }
                    urlForUrlAndParams(url, params) {
                        const keyValueString = Object.keys(params).map(key => {
                            return key + '=' + encodeURIComponent(params[key]);
                        }).join('&');
                        if (url.includes('?')) {
                            return url + '&' + keyValueString;
                        }
                        else {
                            return url + '?' + keyValueString;
                        }
                    }
                    createRequestBody(httpRequest) {
                        if (httpRequest.params !== undefined && [responses_1.HttpVerb.Post, responses_1.HttpVerb.Put, responses_1.HttpVerb.Patch, responses_1.HttpVerb.Delete].includes(httpRequest.verb)) {
                            return JSON.stringify(httpRequest.params);
                        }
                        return httpRequest.rawBytes;
                    }
                }
                exports.FetchRequestHandler = FetchRequestHandler;
                /***/ 
            }),
            /***/ 56176: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 93763: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.HttpService = void 0;
                const utils_1 = __webpack_require__(87901);
                const domain_core_1 = __webpack_require__(82648);
                const responses_1 = __webpack_require__(95658);
                const Paths_1 = __webpack_require__(41325);
                const FetchRequestHandler_1 = __webpack_require__(60256);
                class HttpService {
                    constructor(environment, appVersion, snjsVersion, apiVersion, logger) {
                        this.environment = environment;
                        this.appVersion = appVersion;
                        this.snjsVersion = snjsVersion;
                        this.apiVersion = apiVersion;
                        this.logger = logger;
                        this.__simulateNextSessionRefreshResponseDrop = false;
                        this.loggingEnabled = false;
                        this.requestHandler = new FetchRequestHandler_1.FetchRequestHandler(this.snjsVersion, this.appVersion, this.environment, this.logger);
                    }
                    setCallbacks(updateMetaCallback, refreshSessionCallback) {
                        this.updateMetaCallback = updateMetaCallback;
                        this.refreshSessionCallback = refreshSessionCallback;
                    }
                    deinit() {
                        ;
                        this.session = undefined;
                        this.updateMetaCallback = undefined;
                        this.refreshSessionCallback = undefined;
                    }
                    setSession(session) {
                        this.session = session;
                    }
                    setHost(host) {
                        this.host = host;
                    }
                    getHost() {
                        return this.host;
                    }
                    getSessionAccessToken() {
                        if (!this.session) {
                            return undefined;
                        }
                        if (this.session instanceof domain_core_1.Session) {
                            return this.session.accessToken.value;
                        }
                        else {
                            return this.session.accessToken;
                        }
                    }
                    get(path, params, options) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.host) {
                                throw new Error('Attempting to make network request before host is set');
                            }
                            return this.runHttp({
                                url: (0, utils_1.joinPaths)(this.host, path),
                                params,
                                verb: responses_1.HttpVerb.Get,
                                authentication: (_a = options === null || options === void 0 ? void 0 : options.authentication) !== null && _a !== void 0 ? _a : this.getSessionAccessToken()
                            });
                        });
                    }
                    getExternal(url, params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: responses_1.HttpVerb.Get,
                                external: true
                            });
                        });
                    }
                    post(path, params, options) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.host) {
                                throw new Error('Attempting to make network request before host is set');
                            }
                            return this.runHttp({
                                url: (0, utils_1.joinPaths)(this.host, path),
                                params,
                                verb: responses_1.HttpVerb.Post,
                                authentication: (_a = options === null || options === void 0 ? void 0 : options.authentication) !== null && _a !== void 0 ? _a : this.getSessionAccessToken(),
                                customHeaders: options === null || options === void 0 ? void 0 : options.headers
                            });
                        });
                    }
                    put(path, params, options) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url: (0, utils_1.joinPaths)(this.host, path),
                                params,
                                verb: responses_1.HttpVerb.Put,
                                authentication: (_a = options === null || options === void 0 ? void 0 : options.authentication) !== null && _a !== void 0 ? _a : this.getSessionAccessToken()
                            });
                        });
                    }
                    patch(path, params, options) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url: (0, utils_1.joinPaths)(this.host, path),
                                params,
                                verb: responses_1.HttpVerb.Patch,
                                authentication: (_a = options === null || options === void 0 ? void 0 : options.authentication) !== null && _a !== void 0 ? _a : this.getSessionAccessToken()
                            });
                        });
                    }
                    delete(path, params, options) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url: (0, utils_1.joinPaths)(this.host, path),
                                params,
                                verb: responses_1.HttpVerb.Delete,
                                authentication: (_a = options === null || options === void 0 ? void 0 : options.authentication) !== null && _a !== void 0 ? _a : this.getSessionAccessToken()
                            });
                        });
                    }
                    runHttp(httpRequest) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.__latencySimulatorMs) {
                                yield (0, utils_1.sleep)(this.__latencySimulatorMs, true);
                            }
                            httpRequest.params = httpRequest.params ? this.params(httpRequest.params) : undefined;
                            const isRefreshRequest = httpRequest.url === (0, utils_1.joinPaths)(this.host, Paths_1.Paths.v1.refreshSession);
                            if (this.inProgressRefreshSessionPromise && !isRefreshRequest) {
                                yield this.inProgressRefreshSessionPromise;
                                httpRequest.authentication = this.getSessionAccessToken();
                            }
                            const response = yield this.requestHandler.handleRequest(httpRequest);
                            if (this.loggingEnabled && (0, responses_1.isErrorResponse)(response)) {
                                this.logger.error('Request failed', httpRequest, response);
                            }
                            if (response.meta && !httpRequest.external) {
                                (_a = this.updateMetaCallback) === null || _a === void 0 ? void 0 : _a.call(this, response.meta);
                            }
                            if (response.status === responses_1.HttpStatusCode.ExpiredAccessToken && !isRefreshRequest && !httpRequest.external) {
                                if (this.inProgressRefreshSessionPromise) {
                                    yield this.inProgressRefreshSessionPromise;
                                }
                                else {
                                    const hasSessionTokenRenewedInBetweenOurRequest = httpRequest.authentication !== this.getSessionAccessToken();
                                    if (!hasSessionTokenRenewedInBetweenOurRequest) {
                                        this.inProgressRefreshSessionPromise = this.refreshSession();
                                        const isSessionRefreshedResultOrError = yield this.inProgressRefreshSessionPromise;
                                        let isSessionRefreshed = false;
                                        if (!isSessionRefreshedResultOrError.isFailed()) {
                                            isSessionRefreshed = !(0, responses_1.isErrorResponse)(isSessionRefreshedResultOrError.getValue());
                                        }
                                        this.inProgressRefreshSessionPromise = undefined;
                                        if (!isSessionRefreshed) {
                                            return response;
                                        }
                                    }
                                }
                                httpRequest.authentication = this.getSessionAccessToken();
                                return this.runHttp(httpRequest);
                            }
                            return response;
                        });
                    }
                    refreshSession() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.session) {
                                return domain_core_1.Result.fail('No session to refresh');
                            }
                            if (this.session instanceof domain_core_1.LegacySession) {
                                return domain_core_1.Result.fail('Cannot refresh legacy session');
                            }
                            const response = yield this.post(Paths_1.Paths.v1.refreshSession, {
                                access_token: this.session.accessToken.value,
                                refresh_token: this.session.refreshToken.value
                            });
                            if (this.__simulateNextSessionRefreshResponseDrop) {
                                this.__simulateNextSessionRefreshResponseDrop = false;
                                return domain_core_1.Result.fail('Simulating a dropped response');
                            }
                            if ((0, responses_1.isErrorResponse)(response)) {
                                return domain_core_1.Result.ok(response);
                            }
                            if (response.meta) {
                                (_a = this.updateMetaCallback) === null || _a === void 0 ? void 0 : _a.call(this, response.meta);
                            }
                            const accessTokenOrError = domain_core_1.SessionToken.create(response.data.session.access_token, response.data.session.access_expiration);
                            if (accessTokenOrError.isFailed()) {
                                return domain_core_1.Result.fail(accessTokenOrError.getError());
                            }
                            const accessToken = accessTokenOrError.getValue();
                            const refreshTokenOrError = domain_core_1.SessionToken.create(response.data.session.refresh_token, response.data.session.refresh_expiration);
                            if (refreshTokenOrError.isFailed()) {
                                return domain_core_1.Result.fail(refreshTokenOrError.getError());
                            }
                            const refreshToken = refreshTokenOrError.getValue();
                            const sessionOrError = domain_core_1.Session.create(accessToken, refreshToken, response.data.session.readonly_access);
                            if (sessionOrError.isFailed()) {
                                return domain_core_1.Result.fail(sessionOrError.getError());
                            }
                            this.setSession(sessionOrError.getValue());
                            this.refreshSessionCallback(this.session);
                            return domain_core_1.Result.ok(response);
                        });
                    }
                    params(inParams) {
                        const params = Object.assign(Object.assign({}, inParams), {
                            [responses_1.ApiEndpointParam.ApiVersion]: this.apiVersion
                        });
                        return params;
                    }
                }
                exports.HttpService = HttpService;
                /***/ 
            }),
            /***/ 11751: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23792: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.XMLHttpRequestState = void 0;
                var XMLHttpRequestState;
                (function (XMLHttpRequestState) {
                    XMLHttpRequestState[XMLHttpRequestState["Completed"] = 4] = "Completed";
                })(XMLHttpRequestState || (exports.XMLHttpRequestState = XMLHttpRequestState = {}));
                /***/ 
            }),
            /***/ 59774: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(93763), exports);
                __exportStar(__webpack_require__(60256), exports);
                __exportStar(__webpack_require__(56176), exports);
                __exportStar(__webpack_require__(11751), exports);
                __exportStar(__webpack_require__(23792), exports);
                /***/ 
            }),
            /***/ 6813: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 4960: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 8433: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 72548: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 37280: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 25618: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 1179: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68805: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 90327: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 57726: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 75146: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 45512: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 15829: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 609: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 79329: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 30163: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 33488: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 19298: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const responses_1 = __webpack_require__(95658);
                /***/ 
            }),
            /***/ 57826: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74815: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 72816: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(6813), exports);
                __exportStar(__webpack_require__(4960), exports);
                __exportStar(__webpack_require__(8433), exports);
                __exportStar(__webpack_require__(72548), exports);
                __exportStar(__webpack_require__(37280), exports);
                __exportStar(__webpack_require__(25618), exports);
                __exportStar(__webpack_require__(1179), exports);
                __exportStar(__webpack_require__(68805), exports);
                __exportStar(__webpack_require__(90327), exports);
                __exportStar(__webpack_require__(57726), exports);
                __exportStar(__webpack_require__(75146), exports);
                __exportStar(__webpack_require__(45512), exports);
                __exportStar(__webpack_require__(15829), exports);
                __exportStar(__webpack_require__(609), exports);
                __exportStar(__webpack_require__(79329), exports);
                __exportStar(__webpack_require__(30163), exports);
                __exportStar(__webpack_require__(33488), exports);
                __exportStar(__webpack_require__(19298), exports);
                __exportStar(__webpack_require__(57826), exports);
                __exportStar(__webpack_require__(74815), exports);
                /***/ 
            }),
            /***/ 63404: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 62299: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 30785: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 86237: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 89996: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 27528: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 98259: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 51109: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 89304: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 9712: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 6605: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 25513: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 99614: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68533: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 66722: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 6497: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 96741: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 5209: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 5918: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39761: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(63404), exports);
                __exportStar(__webpack_require__(62299), exports);
                __exportStar(__webpack_require__(30785), exports);
                __exportStar(__webpack_require__(86237), exports);
                __exportStar(__webpack_require__(89996), exports);
                __exportStar(__webpack_require__(27528), exports);
                __exportStar(__webpack_require__(98259), exports);
                __exportStar(__webpack_require__(51109), exports);
                __exportStar(__webpack_require__(89304), exports);
                __exportStar(__webpack_require__(98259), exports);
                __exportStar(__webpack_require__(51109), exports);
                __exportStar(__webpack_require__(89304), exports);
                __exportStar(__webpack_require__(9712), exports);
                __exportStar(__webpack_require__(6605), exports);
                __exportStar(__webpack_require__(25513), exports);
                __exportStar(__webpack_require__(99614), exports);
                __exportStar(__webpack_require__(68533), exports);
                __exportStar(__webpack_require__(66722), exports);
                __exportStar(__webpack_require__(6497), exports);
                __exportStar(__webpack_require__(96741), exports);
                __exportStar(__webpack_require__(5209), exports);
                __exportStar(__webpack_require__(5918), exports);
                /***/ 
            }),
            /***/ 1807: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AsymmetricMessageServer = void 0;
                const Paths_1 = __webpack_require__(18109);
                class AsymmetricMessageServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    createMessage(params) {
                        return this.httpService.post(Paths_1.AsymmetricMessagesPaths.createMessage, {
                            recipient_uuid: params.recipientUuid,
                            encrypted_message: params.encryptedMessage,
                            replaceability_identifier: params.replaceabilityIdentifier
                        });
                    }
                    getInboundUserMessages() {
                        return this.httpService.get(Paths_1.AsymmetricMessagesPaths.getInboundUserMessages());
                    }
                    getOutboundUserMessages() {
                        return this.httpService.get(Paths_1.AsymmetricMessagesPaths.getOutboundUserMessages());
                    }
                    getMessages() {
                        return this.httpService.get(Paths_1.AsymmetricMessagesPaths.getMessages);
                    }
                    deleteMessage(params) {
                        return this.httpService.delete(Paths_1.AsymmetricMessagesPaths.deleteMessage(params.messageUuid));
                    }
                    deleteAllInboundMessages() {
                        return this.httpService.delete(Paths_1.AsymmetricMessagesPaths.deleteAllInboundMessages);
                    }
                }
                exports.AsymmetricMessageServer = AsymmetricMessageServer;
                /***/ 
            }),
            /***/ 71101: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 18109: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AsymmetricMessagesPaths = void 0;
                exports.AsymmetricMessagesPaths = {
                    createMessage: '/v1/messages',
                    getMessages: '/v1/messages',
                    updateMessage: messageUuid => "/v1/messages/".concat(messageUuid),
                    getInboundUserMessages: () => '/v1/messages',
                    getOutboundUserMessages: () => '/v1/messages/outbound',
                    deleteMessage: messageUuid => "/v1/messages/".concat(messageUuid),
                    deleteAllInboundMessages: '/v1/messages/inbound'
                };
                /***/ 
            }),
            /***/ 8982: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthServer = void 0;
                const Paths_1 = __webpack_require__(41325);
                class AuthServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    generateRecoveryCodes() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.generateRecoveryCodes);
                        });
                    }
                    recoveryKeyParams(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.recoveryKeyParams, params);
                        });
                    }
                    signInWithRecoveryCodes(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.signInWithRecoveryCodes, params);
                        });
                    }
                }
                exports.AuthServer = AuthServer;
                /***/ 
            }),
            /***/ 75325: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 41325: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const SessionPaths = {
                    refreshSession: '/v1/sessions/refresh'
                };
                const RecoveryPaths = {
                    generateRecoveryCodes: '/v1/recovery/codes',
                    recoveryKeyParams: '/v1/recovery/login-params',
                    signInWithRecoveryCodes: '/v1/recovery/login'
                };
                exports.Paths = {
                    v1: Object.assign(Object.assign({}, SessionPaths), RecoveryPaths)
                };
                /***/ 
            }),
            /***/ 24610: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AuthenticatorServer = void 0;
                const Paths_1 = __webpack_require__(35821);
                class AuthenticatorServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    list(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.listAuthenticators, params);
                        });
                    }
                    delete(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.delete(Paths_1.Paths.v1.deleteAuthenticator(params.authenticatorId), params);
                        });
                    }
                    generateRegistrationOptions() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.generateRegistrationOptions);
                        });
                    }
                    verifyRegistrationResponse(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.verifyRegistrationResponse, params);
                        });
                    }
                    generateAuthenticationOptions(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.generateAuthenticationOptions, params);
                        });
                    }
                }
                exports.AuthenticatorServer = AuthenticatorServer;
                /***/ 
            }),
            /***/ 1471: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 35821: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const AuthenticatorPaths = {
                    listAuthenticators: '/v1/authenticators',
                    deleteAuthenticator: authenticatorId => "/v1/authenticators/".concat(authenticatorId),
                    generateRegistrationOptions: '/v1/authenticators/generate-registration-options',
                    verifyRegistrationResponse: '/v1/authenticators/verify-registration',
                    generateAuthenticationOptions: '/v1/authenticators/generate-authentication-options'
                };
                exports.Paths = {
                    v1: Object.assign({}, AuthenticatorPaths)
                };
                /***/ 
            }),
            /***/ 92272: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const RevisionsPaths = {
                    listRevisions: itemUuid => "/v2/items/".concat(itemUuid, "/revisions"),
                    getRevision: (itemUuid, revisionUuid) => "/v2/items/".concat(itemUuid, "/revisions/").concat(revisionUuid),
                    deleteRevision: (itemUuid, revisionUuid) => "/v2/items/".concat(itemUuid, "/revisions/").concat(revisionUuid)
                };
                exports.Paths = {
                    v2: Object.assign({}, RevisionsPaths)
                };
                /***/ 
            }),
            /***/ 9784: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.RevisionServer = void 0;
                const Paths_1 = __webpack_require__(92272);
                class RevisionServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    listRevisions(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v2.listRevisions(params.itemUuid));
                        });
                    }
                    getRevision(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v2.getRevision(params.itemUuid, params.revisionUuid));
                        });
                    }
                    deleteRevision(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.delete(Paths_1.Paths.v2.deleteRevision(params.itemUuid, params.revisionUuid));
                        });
                    }
                }
                exports.RevisionServer = RevisionServer;
                /***/ 
            }),
            /***/ 35213: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 83625: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultsPaths = void 0;
                exports.SharedVaultsPaths = {
                    getSharedVaults: '/v1/shared-vaults',
                    createSharedVault: '/v1/shared-vaults',
                    deleteSharedVault: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid),
                    updateSharedVault: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid),
                    createSharedVaultFileValetToken: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid, "/valet-tokens")
                };
                /***/ 
            }),
            /***/ 29497: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultServer = void 0;
                const Paths_1 = __webpack_require__(83625);
                class SharedVaultServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    getSharedVaults() {
                        return this.httpService.get(Paths_1.SharedVaultsPaths.getSharedVaults);
                    }
                    createSharedVault() {
                        return this.httpService.post(Paths_1.SharedVaultsPaths.createSharedVault);
                    }
                    deleteSharedVault(params) {
                        return this.httpService.delete(Paths_1.SharedVaultsPaths.deleteSharedVault(params.sharedVaultUuid));
                    }
                    createSharedVaultFileValetToken(params) {
                        let headers = undefined;
                        if (params.sharedVaultOwnerUuid) {
                            headers = [{
                                    key: 'x-shared-vault-owner-context',
                                    value: params.sharedVaultOwnerUuid
                                }];
                        }
                        return this.httpService.post(Paths_1.SharedVaultsPaths.createSharedVaultFileValetToken(params.sharedVaultUuid), {
                            file_uuid: params.fileUuid,
                            remote_identifier: params.remoteIdentifier,
                            operation: params.operation,
                            unencrypted_file_size: params.unencryptedFileSize,
                            move_operation_type: params.moveOperationType,
                            shared_vault_to_shared_vault_move_target_uuid: params.sharedVaultToSharedVaultMoveTargetUuid
                        }, {
                            headers
                        });
                    }
                }
                exports.SharedVaultServer = SharedVaultServer;
                /***/ 
            }),
            /***/ 41773: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39593: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultInvitesPaths = void 0;
                exports.SharedVaultInvitesPaths = {
                    createInvite: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites"),
                    updateInvite: (sharedVaultUuid, inviteUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites/").concat(inviteUuid),
                    acceptInvite: (sharedVaultUuid, inviteUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites/").concat(inviteUuid, "/accept"),
                    declineInvite: (sharedVaultUuid, inviteUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites/").concat(inviteUuid, "/decline"),
                    getInboundUserInvites: () => '/v1/shared-vaults/invites',
                    getOutboundUserInvites: () => '/v1/shared-vaults/invites/outbound',
                    getSharedVaultInvites: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites"),
                    deleteInvite: (sharedVaultUuid, inviteUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites/").concat(inviteUuid),
                    deleteAllSharedVaultInvites: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid, "/invites"),
                    deleteAllInboundInvites: '/v1/shared-vaults/invites/inbound',
                    deleteAllOutboundInvites: '/v1/shared-vaults/invites/outbound'
                };
                /***/ 
            }),
            /***/ 55784: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultInvitesServer = void 0;
                const Paths_1 = __webpack_require__(39593);
                class SharedVaultInvitesServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    createInvite(params) {
                        return this.httpService.post(Paths_1.SharedVaultInvitesPaths.createInvite(params.sharedVaultUuid), {
                            recipient_uuid: params.recipientUuid,
                            encrypted_message: params.encryptedMessage,
                            permission: params.permission.value
                        });
                    }
                    updateInvite(params) {
                        var _a;
                        return this.httpService.patch(Paths_1.SharedVaultInvitesPaths.updateInvite(params.sharedVaultUuid, params.inviteUuid), {
                            encrypted_message: params.encryptedMessage,
                            permission: (_a = params.permission) === null || _a === void 0 ? void 0 : _a.value
                        });
                    }
                    acceptInvite(params) {
                        return this.httpService.post(Paths_1.SharedVaultInvitesPaths.acceptInvite(params.sharedVaultUuid, params.inviteUuid));
                    }
                    declineInvite(params) {
                        return this.httpService.post(Paths_1.SharedVaultInvitesPaths.declineInvite(params.sharedVaultUuid, params.inviteUuid));
                    }
                    getInboundUserInvites() {
                        return this.httpService.get(Paths_1.SharedVaultInvitesPaths.getInboundUserInvites());
                    }
                    getOutboundUserInvites() {
                        return this.httpService.get(Paths_1.SharedVaultInvitesPaths.getOutboundUserInvites());
                    }
                    getSharedVaultInvites(params) {
                        return this.httpService.get(Paths_1.SharedVaultInvitesPaths.getSharedVaultInvites(params.sharedVaultUuid));
                    }
                    deleteInvite(params) {
                        return this.httpService.delete(Paths_1.SharedVaultInvitesPaths.deleteInvite(params.sharedVaultUuid, params.inviteUuid));
                    }
                    deleteAllSharedVaultInvites(params) {
                        return this.httpService.delete(Paths_1.SharedVaultInvitesPaths.deleteAllSharedVaultInvites(params.sharedVaultUuid));
                    }
                    deleteAllInboundInvites() {
                        return this.httpService.delete(Paths_1.SharedVaultInvitesPaths.deleteAllInboundInvites);
                    }
                    deleteAllOutboundInvites() {
                        return this.httpService.delete(Paths_1.SharedVaultInvitesPaths.deleteAllOutboundInvites);
                    }
                }
                exports.SharedVaultInvitesServer = SharedVaultInvitesServer;
                /***/ 
            }),
            /***/ 49224: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 77183: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultUsersPaths = void 0;
                exports.SharedVaultUsersPaths = {
                    getSharedVaultUsers: sharedVaultUuid => "/v1/shared-vaults/".concat(sharedVaultUuid, "/users"),
                    deleteSharedVaultUser: (sharedVaultUuid, userUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/users/").concat(userUuid),
                    designateSurvivor: (sharedVaultUuid, sharedVaultMemberUuid) => "/v1/shared-vaults/".concat(sharedVaultUuid, "/users/").concat(sharedVaultMemberUuid, "/designate-survivor")
                };
                /***/ 
            }),
            /***/ 75569: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SharedVaultUsersServer = void 0;
                const Paths_1 = __webpack_require__(77183);
                class SharedVaultUsersServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    designateSurvivor(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.SharedVaultUsersPaths.designateSurvivor(params.sharedVaultUuid.value, params.sharedVaultMemberUuid.value));
                        });
                    }
                    getSharedVaultUsers(params) {
                        return this.httpService.get(Paths_1.SharedVaultUsersPaths.getSharedVaultUsers(params.sharedVaultUuid));
                    }
                    deleteSharedVaultUser(params) {
                        return this.httpService.delete(Paths_1.SharedVaultUsersPaths.deleteSharedVaultUser(params.sharedVaultUuid, params.userUuid));
                    }
                }
                exports.SharedVaultUsersServer = SharedVaultUsersServer;
                /***/ 
            }),
            /***/ 7307: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63385: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const SharingPaths = {
                    invite: '/v1/subscription-invites',
                    acceptInvite: inviteUuid => "/v1/subscription-invites/".concat(inviteUuid, "/accept"),
                    declineInvite: inviteUuid => "/v1/subscription-invites/".concat(inviteUuid, "/decline"),
                    cancelInvite: inviteUuid => "/v1/subscription-invites/".concat(inviteUuid),
                    listInvites: '/v1/subscription-invites'
                };
                const UserSubscriptionPaths = {
                    subscription: userUuid => "/v1/users/".concat(userUuid, "/subscription")
                };
                const ApplePaths = {
                    confirmAppleIAP: '/v1/subscriptions/apple_iap_confirm'
                };
                const UnauthenticatedSubscriptionsPaths = {
                    availableSubscriptions: '/v2/subscriptions'
                };
                exports.Paths = {
                    v1: Object.assign(Object.assign(Object.assign(Object.assign({}, SharingPaths), ApplePaths), UserSubscriptionPaths), UnauthenticatedSubscriptionsPaths)
                };
                /***/ 
            }),
            /***/ 83527: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SubscriptionServer = void 0;
                const Paths_1 = __webpack_require__(63385);
                class SubscriptionServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    acceptInvite(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.acceptInvite(params.inviteUuid), params);
                        });
                    }
                    declineInvite(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.declineInvite(params.inviteUuid), params);
                        });
                    }
                    cancelInvite(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.delete(Paths_1.Paths.v1.cancelInvite(params.inviteUuid), params);
                        });
                    }
                    listInvites(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.listInvites, params);
                        });
                    }
                    invite(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.invite, params);
                        });
                    }
                    confirmAppleIAP(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.confirmAppleIAP, params);
                        });
                    }
                    getUserSubscription(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.subscription(params.userUuid), params);
                        });
                    }
                    getAvailableSubscriptions() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.get(Paths_1.Paths.v1.availableSubscriptions);
                        });
                    }
                }
                exports.SubscriptionServer = SubscriptionServer;
                /***/ 
            }),
            /***/ 79804: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 32288: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const UserPaths = {
                    register: '/v1/users',
                    updateAccount: userUuid => "/v1/users/".concat(userUuid),
                    deleteAccount: userUuid => "/v1/users/".concat(userUuid)
                };
                exports.Paths = {
                    v1: Object.assign({}, UserPaths)
                };
                /***/ 
            }),
            /***/ 87466: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserServer = void 0;
                const Paths_1 = __webpack_require__(32288);
                class UserServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    deleteAccount(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.delete(Paths_1.Paths.v1.deleteAccount(params.userUuid), params);
                        });
                    }
                    register(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.register, params);
                        });
                    }
                    update(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.patch(Paths_1.Paths.v1.updateAccount(params.user_uuid), params);
                        });
                    }
                }
                exports.UserServer = UserServer;
                /***/ 
            }),
            /***/ 14786: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 4633: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const UserRequestPaths = {
                    submitUserRequest: userUuid => "/v1/users/".concat(userUuid, "/requests")
                };
                exports.Paths = {
                    v1: Object.assign({}, UserRequestPaths)
                };
                /***/ 
            }),
            /***/ 59181: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserRequestServer = void 0;
                const Paths_1 = __webpack_require__(4633);
                class UserRequestServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    submitUserRequest(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.submitUserRequest(params.userUuid), params);
                        });
                    }
                }
                exports.UserRequestServer = UserRequestServer;
                /***/ 
            }),
            /***/ 39594: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 1276: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Paths = void 0;
                const TokenPaths = {
                    createConnectionToken: '/v1/sockets/tokens'
                };
                exports.Paths = {
                    v1: Object.assign({}, TokenPaths)
                };
                /***/ 
            }),
            /***/ 81355: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.WebSocketServer = void 0;
                const Paths_1 = __webpack_require__(1276);
                class WebSocketServer {
                    constructor(httpService) {
                        this.httpService = httpService;
                    }
                    createConnectionToken(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.httpService.post(Paths_1.Paths.v1.createConnectionToken, params);
                        });
                    }
                }
                exports.WebSocketServer = WebSocketServer;
                /***/ 
            }),
            /***/ 7404: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 87267: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(8982), exports);
                __exportStar(__webpack_require__(75325), exports);
                __exportStar(__webpack_require__(24610), exports);
                __exportStar(__webpack_require__(1471), exports);
                __exportStar(__webpack_require__(9784), exports);
                __exportStar(__webpack_require__(35213), exports);
                __exportStar(__webpack_require__(1807), exports);
                __exportStar(__webpack_require__(71101), exports);
                __exportStar(__webpack_require__(29497), exports);
                __exportStar(__webpack_require__(41773), exports);
                __exportStar(__webpack_require__(75569), exports);
                __exportStar(__webpack_require__(7307), exports);
                __exportStar(__webpack_require__(83527), exports);
                __exportStar(__webpack_require__(79804), exports);
                __exportStar(__webpack_require__(55784), exports);
                __exportStar(__webpack_require__(49224), exports);
                __exportStar(__webpack_require__(87466), exports);
                __exportStar(__webpack_require__(14786), exports);
                __exportStar(__webpack_require__(59181), exports);
                __exportStar(__webpack_require__(39594), exports);
                __exportStar(__webpack_require__(81355), exports);
                __exportStar(__webpack_require__(7404), exports);
                /***/ 
            }),
            /***/ 74907: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(57819), exports);
                __exportStar(__webpack_require__(37729), exports);
                __exportStar(__webpack_require__(65148), exports);
                __exportStar(__webpack_require__(59774), exports);
                __exportStar(__webpack_require__(72816), exports);
                __exportStar(__webpack_require__(39761), exports);
                __exportStar(__webpack_require__(87267), exports);
                /***/ 
            }),
            /***/ 70781: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(74907), exports);
                /***/ 
            }),
            /***/ 73936: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ U: () => ( /* binding */deconstructEncryptedPayloadString),
                    /* harmony export */ q: () => ( /* binding */doesPayloadRequireSigning)
                    /* harmony export */ 
                });
                /* harmony import */ var _V004AlgorithmTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99299);
                function doesPayloadRequireSigning(payload) {
                    return payload.shared_vault_uuid != undefined;
                }
                function deconstructEncryptedPayloadString(payloadString) {
                    var _a;
                    /** Base64 encoding of JSON.stringify({}) */
                    const EmptyAdditionalDataString = 'e30=';
                    const components = payloadString.split(_V004AlgorithmTypes__WEBPACK_IMPORTED_MODULE_0__ /* .V004PartitionCharacter */.X);
                    return {
                        version: components[0],
                        nonce: components[1],
                        ciphertext: components[2],
                        authenticatedData: components[3],
                        additionalData: (_a = components[4]) !== null && _a !== void 0 ? _a : EmptyAdditionalDataString
                    };
                }
                /***/ 
            }),
            /***/ 99299: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ X: () => ( /* binding */V004PartitionCharacter),
                    /* harmony export */ s: () => ( /* binding */V004AsymmetricCiphertextPrefix)
                    /* harmony export */ 
                });
                const V004AsymmetricCiphertextPrefix = '004_Asym';
                const V004PartitionCharacter = ':';
                /***/ 
            }),
            /***/ 86999: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    qX: () => ( /* reexport */BackupFileType),
                    lx: () => ( /* reexport */ComputePrivateUsername),
                    Nv: () => ( /* reexport */Create001KeyParams),
                    H$: () => ( /* reexport */Create002KeyParams),
                    mU: () => ( /* reexport */Create003KeyParams),
                    ao: () => ( /* reexport */Create004KeyParams),
                    jl: () => ( /* reexport */CreateAnyKeyParams),
                    nJ: () => ( /* reexport */CreateDecryptionSplitWithKeyLookup),
                    Ak: () => ( /* reexport */CreateEncryptionSplitWithKeyLookup),
                    C4: () => ( /* reexport */CreateNewRootKey),
                    $l: () => ( /* reexport */EncryptionOperators),
                    FX: () => ( /* reexport */FillRootKeyContent),
                    sP: () => ( /* reexport */FindPayloadInDecryptionSplit),
                    G6: () => ( /* reexport */FindPayloadInEncryptionSplit),
                    tn: () => ( /* reexport */ItemsKeyMutator),
                    LW: () => ( /* reexport */KeyParamsFromApiResponse),
                    fD: () => ( /* reexport */KeyRecoveryStrings),
                    yv: () => ( /* reexport */KeySystemItemsKey),
                    NC: () => ( /* reexport */KeySystemItemsKeyMutator),
                    nx: () => ( /* reexport */ProtocolVersionForKeyParams),
                    rU: () => ( /* reexport */SNItemsKey),
                    d1: () => ( /* reexport */SNProtocolOperator001),
                    QR: () => ( /* reexport */SNProtocolOperator002),
                    Er: () => ( /* reexport */SNProtocolOperator003),
                    iN: () => ( /* reexport */SNProtocolOperator004),
                    t$: () => ( /* reexport */SNRootKey),
                    Gw: () => ( /* reexport */SNRootKeyParams),
                    xg: () => ( /* reexport */SplitPayloadsByEncryptionType),
                    KX: () => ( /* reexport */StandardException),
                    xo: () => ( /* reexport */V001Algorithm),
                    $4: () => ( /* reexport */V002Algorithm),
                    _0: () => ( /* reexport */V003Algorithm),
                    eC: () => ( /* reexport */V004Algorithm),
                    Am: () => ( /* reexport */ValidKeyParamsKeys),
                    ZP: () => ( /* reexport */createOperatorForVersion),
                    UH: () => ( /* reexport */V004AlgorithmHelpers /* deconstructEncryptedPayloadString */.U),
                    oO: () => ( /* reexport */decryptPayload),
                    qw: () => ( /* reexport */V004AlgorithmHelpers /* doesPayloadRequireSigning */.q),
                    Gl: () => ( /* reexport */encryptPayload),
                    xi: () => ( /* reexport */encryptedInputParametersFromPayload),
                    XL: () => ( /* reexport */isErrorDecryptingParameters),
                    dS: () => ( /* reexport */isItemsKey),
                    mX: () => ( /* reexport */isKeySystemItemsKey)
                });
                // EXTERNAL MODULE: ../sncrypto-common/dist/index.js
                var dist = __webpack_require__(98418);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Algorithm.ts
                const V001Algorithm = Object.freeze({
                    SaltSeedLength: 128,
                    /**
                     * V001 supported a variable PBKDF2 cost
                     */
                    PbkdfMinCost: 3000,
                    PbkdfCostsUsed: [3000, 5000, 10000, 60000],
                    PbkdfOutputLength: 512,
                    EncryptionKeyLength: 256
                });
                const V002Algorithm = Object.freeze({
                    SaltSeedLength: 128,
                    /**
                     * V002 supported a variable PBKDF2 cost
                     */
                    PbkdfMinCost: 3000,
                    /**
                     * While some 002 accounts also used costs in V001.PbkdfCostsUsed,
                     * the vast majority used costs >= 100,000
                     */
                    PbkdfCostsUsed: V001Algorithm.PbkdfCostsUsed.concat([100000, 101000, 102000, 103000]),
                    /** Possible costs used, but statistically more likely these were 001 accounts */
                    ImprobablePbkdfCostsUsed: [3000, 5000],
                    PbkdfOutputLength: 768,
                    EncryptionKeyLength: 256,
                    EncryptionIvLength: 128
                });
                const V003Algorithm = Object.freeze({
                    SaltSeedLength: 256,
                    PbkdfCost: 110000,
                    PbkdfOutputLength: 768,
                    EncryptionKeyLength: 256,
                    EncryptionIvLength: 128
                });
                const V004Algorithm = Object.freeze({
                    ArgonSaltSeedLength: 256,
                    ArgonSaltLength: 128,
                    ArgonIterations: 5,
                    ArgonMemLimit: 67108864,
                    ArgonOutputKeyBytes: 64,
                    EncryptionKeyLength: 256,
                    EncryptionNonceLength: 192,
                    AsymmetricEncryptionNonceLength: 192,
                    MasterKeyEncryptionKeyPairSubKeyNumber: 1,
                    MasterKeyEncryptionKeyPairSubKeyContext: 'sn-pkc-e',
                    MasterKeyEncryptionKeyPairSubKeyBytes: dist.SodiumConstant.crypto_box_SEEDBYTES,
                    MasterKeySigningKeyPairSubKeyNumber: 2,
                    MasterKeySigningKeyPairSubKeyContext: 'sn-pkc-s',
                    MasterKeySigningKeyPairSubKeyBytes: dist.SodiumConstant.crypto_sign_SEEDBYTES,
                    PayloadKeyHashingKeySubKeyNumber: 1,
                    PayloadKeyHashingKeySubKeyContext: 'sn-sym-h',
                    PayloadKeyHashingKeySubKeyBytes: dist.SodiumConstant.crypto_generichash_KEYBYTES
                });
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Backups/BackupFileType.ts
                var BackupFileType;
                (function (BackupFileType) {
                    BackupFileType["Encrypted"] = "Encrypted";
                    /**
                     * Generated when an export is made from an application with no account and no passcode. The
                     * items are encrypted, but the items keys are not.
                     */
                    BackupFileType["EncryptedWithNonEncryptedItemsKey"] = "EncryptedWithNonEncryptedItemsKey";
                    BackupFileType["FullyDecrypted"] = "FullyDecrypted";
                    BackupFileType["Corrupt"] = "Corrupt";
                })(BackupFileType || (BackupFileType = {}));
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var src = __webpack_require__(82648);
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/ItemsKey/ItemsKey.ts
                function isItemsKey(x) {
                    return x.content_type === src.ContentType.TYPES.ItemsKey;
                }
                /**
                 * A key used to encrypt other items. Items keys are synced and persisted.
                 */
                class SNItemsKey extends models_dist.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.keyVersion = payload.content.version;
                        this.isDefault = payload.content.isDefault;
                        this.itemsKey = this.payload.content.itemsKey;
                    }
                    /** Do not duplicate items keys. Always keep original */
                    strategyWhenConflictingWithItem(_item, _previousRevision) {
                        return models_dist.ConflictStrategy.KeepBase;
                    }
                    get dataAuthenticationKey() {
                        if (this.keyVersion === models_dist.ProtocolVersion.V004) {
                            throw 'Attempting to access legacy data authentication key.';
                        }
                        return this.payload.content.dataAuthenticationKey;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/ItemsKey/ItemsKeyMutator.ts
                class ItemsKeyMutator extends models_dist.DecryptedItemMutator {
                    set isDefault(isDefault) {
                        this.mutableContent.isDefault = isDefault;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/ItemsKey/Registration.ts
                (0, models_dist.RegisterItemClass)(src.ContentType.TYPES.ItemsKey, SNItemsKey, ItemsKeyMutator);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/KeySystemItemsKey/KeySystemItemsKey.ts
                function isKeySystemItemsKey(x) {
                    return x.content_type === src.ContentType.TYPES.KeySystemItemsKey;
                }
                /**
                 * A key used to encrypt other items. Items keys are synced and persisted.
                 */
                class KeySystemItemsKey extends models_dist.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.creationTimestamp = payload.content.creationTimestamp;
                        this.keyVersion = payload.content.version;
                        this.itemsKey = this.payload.content.itemsKey;
                        this.rootKeyToken = this.payload.content.rootKeyToken;
                    }
                    /** Do not duplicate vault items keys. Always keep original */
                    strategyWhenConflictingWithItem(_item, _previousRevision) {
                        return models_dist.ConflictStrategy.KeepBase;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/KeySystemItemsKey/KeySystemItemsKeyMutator.ts
                class KeySystemItemsKeyMutator extends models_dist.DecryptedItemMutator {
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/KeySystemItemsKey/Registration.ts
                (0, models_dist.RegisterItemClass)(src.ContentType.TYPES.KeySystemItemsKey, KeySystemItemsKey, KeySystemItemsKeyMutator);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var dist_src = __webpack_require__(20875);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/ProtocolVersionForKeyParams.ts
                function ProtocolVersionForKeyParams(response) {
                    if (response.version) {
                        return response.version;
                    }
                    /**
                     * 001 and 002 key params (as stored locally) may not report a version number.
                     * In some cases it may be impossible to differentiate between 001 and 002 params,
                     * but there are a few rules we can use to find a best fit.
                     */
                    /**
                     * First try to determine by cost. If the cost appears in V002 costs but not V001 costs,
                     * we know it's 002.
                     */
                    const cost = response.pw_cost;
                    const appearsInV001 = V001Algorithm.PbkdfCostsUsed.includes(cost);
                    const appearsInV002 = V002Algorithm.PbkdfCostsUsed.includes(cost);
                    if (appearsInV001 && !appearsInV002) {
                        return dist_src.ProtocolVersion.V001;
                    }
                    else if (appearsInV002 && !appearsInV001) {
                        return dist_src.ProtocolVersion.V002;
                    }
                    else if (appearsInV002 && appearsInV001) {
                        /**
                         * If the cost appears in both versions, we can be certain it's 002 if it's missing
                         * the pw_nonce property. (However late versions of 002 also used a pw_nonce, so its
                         * presence doesn't automatically indicate 001.)
                         */
                        if (!response.pw_nonce) {
                            return dist_src.ProtocolVersion.V002;
                        }
                        else {
                            /**
                             * We're now at the point that the cost has appeared in both versions, and a pw_nonce
                             * is present. We'll have to go with what is more statistically likely.
                             */
                            if (V002Algorithm.ImprobablePbkdfCostsUsed.includes(cost)) {
                                return dist_src.ProtocolVersion.V001;
                            }
                            else {
                                return dist_src.ProtocolVersion.V002;
                            }
                        }
                    }
                    else {
                        /** Doesn't appear in either V001 or V002; unlikely possibility. */
                        return dist_src.ProtocolVersion.V002;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/ValidKeyParamsKeys.ts
                const ValidKeyParamsKeys = ['identifier', 'pw_cost', 'pw_nonce', 'pw_salt', 'version', 'origination', 'created'];
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/RootKeyParams.ts
                class SNRootKeyParams {
                    constructor(content) {
                        this.content = Object.assign(Object.assign({}, content), {
                            origination: content.origination || dist_src.KeyParamsOrigination.Registration,
                            version: content.version || ProtocolVersionForKeyParams(content)
                        });
                    }
                    get isKeyParamsObject() {
                        return true;
                    }
                    get identifier() {
                        return this.content004.identifier || this.content002.email;
                    }
                    get version() {
                        return this.content.version;
                    }
                    get origination() {
                        return this.content.origination;
                    }
                    get content001() {
                        return this.content;
                    }
                    get content002() {
                        return this.content;
                    }
                    get content003() {
                        return this.content;
                    }
                    get content004() {
                        return this.content;
                    }
                    get createdDate() {
                        if (!this.content004.created) {
                            return undefined;
                        }
                        return new Date(Number(this.content004.created));
                    }
                    compare(other) {
                        if (this.version !== other.version) {
                            return false;
                        }
                        if ([dist_src.ProtocolVersion.V004, dist_src.ProtocolVersion.V003].includes(this.version)) {
                            return this.identifier === other.identifier && this.content004.pw_nonce === other.content003.pw_nonce;
                        }
                        else if ([dist_src.ProtocolVersion.V002, dist_src.ProtocolVersion.V001].includes(this.version)) {
                            return this.identifier === other.identifier && this.content002.pw_salt === other.content001.pw_salt;
                        }
                        else {
                            throw Error('Unhandled version in KeyParams.compare');
                        }
                    }
                    getPortableValue() {
                        return (0, utils_dist.pickByCopy)(this.content, ValidKeyParamsKeys);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/RootKey.ts
                /**
                 * A root key is a local only construct that houses the key used for the encryption
                 * and decryption of items keys. A root key extends SNItem for local convenience, but is
                 * not part of the syncing or storage ecosystem—root keys are managed independently.
                 */
                class SNRootKey extends models_dist.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.keyParams = new SNRootKeyParams(payload.content.keyParams);
                    }
                    get keyVersion() {
                        return this.content.version;
                    }
                    /**
                     * When the root key is used to encrypt items, we use the masterKey directly.
                     */
                    get itemsKey() {
                        return this.masterKey;
                    }
                    get masterKey() {
                        return this.content.masterKey;
                    }
                    /**
                     * serverPassword is not persisted as part of keychainValue, so if loaded from disk,
                     * this value may be undefined.
                     */
                    get serverPassword() {
                        return this.content.serverPassword;
                    }
                    get encryptionKeyPair() {
                        return this.content.encryptionKeyPair;
                    }
                    get signingKeyPair() {
                        return this.content.signingKeyPair;
                    }
                    /** 003 and below only. */
                    get dataAuthenticationKey() {
                        return this.content.dataAuthenticationKey;
                    }
                    compare(otherKey) {
                        if (this.keyVersion !== otherKey.keyVersion) {
                            return false;
                        }
                        if (this.serverPassword && otherKey.serverPassword) {
                            return (0, dist.timingSafeEqual)(this.masterKey, otherKey.masterKey) && (0, dist.timingSafeEqual)(this.serverPassword, otherKey.serverPassword);
                        }
                        else {
                            return (0, dist.timingSafeEqual)(this.masterKey, otherKey.masterKey);
                        }
                    }
                    /**
                     * @returns Object suitable for persist in storage when wrapped
                     */
                    persistableValueWhenWrapping() {
                        return Object.assign(Object.assign({}, this.getKeychainValue()), {
                            keyParams: this.keyParams.getPortableValue()
                        });
                    }
                    /**
                     * @returns Object that is suitable for persisting in a keychain
                     */
                    getKeychainValue() {
                        const values = {
                            version: this.keyVersion,
                            masterKey: this.masterKey,
                            encryptionKeyPair: this.encryptionKeyPair,
                            signingKeyPair: this.signingKeyPair
                        };
                        if (this.dataAuthenticationKey) {
                            values.dataAuthenticationKey = this.dataAuthenticationKey;
                        }
                        return values;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/Functions.ts
                function CreateNewRootKey(content) {
                    const uuid = utils_dist.UuidGenerator.GenerateUuid();
                    const payload = new models_dist.DecryptedPayload(Object.assign({
                        uuid: uuid,
                        content_type: src.ContentType.TYPES.RootKey,
                        content: FillRootKeyContent(content)
                    }, (0, models_dist.PayloadTimestampDefaults)()));
                    return new SNRootKey(payload);
                }
                function FillRootKeyContent(content) {
                    if (!content.version) {
                        if (content.dataAuthenticationKey) {
                            /**
                             * If there's no version stored, it must be either 001 or 002.
                             * If there's a dataAuthenticationKey, it has to be 002. Otherwise it's 001.
                             */
                            content.version = models_dist.ProtocolVersion.V002;
                        }
                        else {
                            content.version = models_dist.ProtocolVersion.V001;
                        }
                    }
                    return (0, models_dist.FillItemContentSpecialized)(content);
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/RootKey/KeyParamsFunctions.ts
                function Create001KeyParams(keyParams) {
                    return CreateAnyKeyParams(keyParams);
                }
                function Create002KeyParams(keyParams) {
                    return CreateAnyKeyParams(keyParams);
                }
                function Create003KeyParams(keyParams) {
                    return CreateAnyKeyParams(keyParams);
                }
                function Create004KeyParams(keyParams) {
                    return CreateAnyKeyParams(keyParams);
                }
                function CreateAnyKeyParams(keyParams) {
                    if ('content' in keyParams) {
                        throw Error('Raw key params shouldnt have content; perhaps you passed in a SNRootKeyParams object.');
                    }
                    return new SNRootKeyParams(keyParams);
                }
                function KeyParamsFromApiResponse(response, identifier) {
                    const rawKeyParams = {
                        identifier: identifier || response.identifier,
                        pw_cost: response.pw_cost,
                        pw_nonce: response.pw_nonce,
                        pw_salt: response.pw_salt,
                        version: ProtocolVersionForKeyParams(response),
                        origination: response.origination,
                        created: response.created
                    };
                    return CreateAnyKeyParams(rawKeyParams);
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Keys/Utils/KeyRecoveryStrings.ts
                const KeyRecoveryStrings = {
                    KeyRecoveryLoginFlowPrompt: keyParams => {
                        var _a;
                        const dateString = (_a = keyParams.createdDate) === null || _a === void 0 ? void 0 : _a.toLocaleString();
                        switch (keyParams.origination) {
                            case dist_src.KeyParamsOrigination.EmailChange:
                                return "Enter your account password as it was when you changed your email on ".concat(dateString, ".");
                            case dist_src.KeyParamsOrigination.PasswordChange:
                                return "Enter your account password after it was changed on ".concat(dateString, ".");
                            case dist_src.KeyParamsOrigination.Registration:
                                return "Enter your account password as it was when you registered ".concat(dateString, ".");
                            case dist_src.KeyParamsOrigination.ProtocolUpgrade:
                                return "Enter your account password as it was when you upgraded your encryption version on ".concat(dateString, ".");
                            case dist_src.KeyParamsOrigination.PasscodeChange:
                                return "Enter your application passcode after it was changed on ".concat(dateString, ".");
                            case dist_src.KeyParamsOrigination.PasscodeCreate:
                                return "Enter your application passcode as it was when you created it on ".concat(dateString, ".");
                            default:
                                throw Error('Unhandled KeyParamsOrigination case for KeyRecoveryLoginFlowPrompt');
                        }
                    },
                    KeyRecoveryLoginFlowReason: 'Your account password is required to revalidate your session.',
                    KeyRecoveryLoginFlowInvalidPassword: 'Incorrect credentials entered. Please try again.',
                    KeyRecoveryRootKeyReplaced: 'Your credentials have successfully been updated.',
                    KeyRecoveryPasscodeRequiredTitle: 'Passcode Required',
                    KeyRecoveryPasscodeRequiredText: 'You must enter your passcode in order to save your new credentials.',
                    KeyRecoveryPasswordRequired: 'Your account password is required to recover an encryption key.',
                    KeyRecoveryKeyRecovered: 'Your key has successfully been recovered.',
                    KeyRecoveryUnableToRecover: 'Unable to recover your key with the attempted password. Please try again.'
                };
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/001/Operator001.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const NO_IV = '00000000000000000000000000000000';
                /**
                 * @deprecated
                 * A legacy operator no longer used to generate new accounts
                 */
                class SNProtocolOperator001 {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    getEncryptionDisplayName() {
                        return 'AES-256';
                    }
                    get version() {
                        return dist_src.ProtocolVersion.V001;
                    }
                    generateNewItemsKeyContent() {
                        const keyLength = V001Algorithm.EncryptionKeyLength;
                        const itemsKey = this.crypto.generateRandomKey(keyLength);
                        const response = (0, models_dist.FillItemContent)({
                            itemsKey: itemsKey,
                            version: dist_src.ProtocolVersion.V001
                        });
                        return response;
                    }
                    /**
                     * Creates a new random items key to use for item encryption.
                     * The consumer must save/sync this item.
                     */
                    createItemsKey() {
                        const payload = new models_dist.DecryptedPayload(Object.assign({
                            uuid: utils_dist.UuidGenerator.GenerateUuid(),
                            content_type: src.ContentType.TYPES.ItemsKey,
                            content: this.generateNewItemsKeyContent()
                        }, (0, models_dist.PayloadTimestampDefaults)()));
                        return (0, models_dist.CreateDecryptedItemFromPayload)(payload);
                    }
                    createRootKey(identifier, password, origination) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const pwCost = V001Algorithm.PbkdfMinCost;
                            const pwNonce = this.crypto.generateRandomKey(V001Algorithm.SaltSeedLength);
                            const pwSalt = yield this.crypto.unsafeSha1(identifier + 'SN' + pwNonce);
                            const keyParams = Create001KeyParams({
                                email: identifier,
                                pw_cost: pwCost,
                                pw_nonce: pwNonce,
                                pw_salt: pwSalt,
                                version: dist_src.ProtocolVersion.V001,
                                origination,
                                created: "".concat(Date.now())
                            });
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    getPayloadAuthenticatedDataForExternalUse(_encrypted) {
                        return undefined;
                    }
                    computeRootKey(password, keyParams) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    decryptString(ciphertext, key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.crypto.aes256CbcDecrypt(ciphertext, NO_IV, key);
                        });
                    }
                    encryptString(text, key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.crypto.aes256CbcEncrypt(text, NO_IV, key);
                        });
                    }
                    generateEncryptedParametersAsync(payload, key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            /**
                             * Generate new item key that is double the key size.
                             * Will be split to create encryption key and authentication key.
                             */
                            const itemKey = this.crypto.generateRandomKey(V001Algorithm.EncryptionKeyLength * 2);
                            const encItemKey = yield this.encryptString(itemKey, key.itemsKey);
                            /** Encrypt content */
                            const ek = (0, utils_dist.firstHalfOfString)(itemKey);
                            const ak = (0, utils_dist.secondHalfOfString)(itemKey);
                            const contentCiphertext = yield this.encryptString(JSON.stringify(payload.content), ek);
                            const ciphertext = key.keyVersion + contentCiphertext;
                            const authHash = yield this.crypto.hmac256(ciphertext, ak);
                            if (!authHash) {
                                throw Error('Error generating hmac256 authHash');
                            }
                            return {
                                uuid: payload.uuid,
                                content_type: payload.content_type,
                                items_key_id: isItemsKey(key) ? key.uuid : undefined,
                                content: ciphertext,
                                enc_item_key: encItemKey,
                                auth_hash: authHash,
                                version: this.version,
                                key_system_identifier: payload.key_system_identifier,
                                shared_vault_uuid: payload.shared_vault_uuid
                            };
                        });
                    }
                    generateDecryptedParametersAsync(encrypted, key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!encrypted.enc_item_key) {
                                console.error(Error('Missing item encryption key, skipping decryption.'));
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            let encryptedItemKey = encrypted.enc_item_key;
                            encryptedItemKey = this.version + encryptedItemKey;
                            const itemKeyComponents = this.encryptionComponentsFromString(encryptedItemKey, key.itemsKey);
                            const itemKey = yield this.decryptString(itemKeyComponents.ciphertext, itemKeyComponents.key);
                            if (!itemKey) {
                                console.error('Error decrypting parameters', encrypted);
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            const ek = (0, utils_dist.firstHalfOfString)(itemKey);
                            const itemParams = this.encryptionComponentsFromString(encrypted.content, ek);
                            const content = yield this.decryptString(itemParams.ciphertext, itemParams.key);
                            if (!content) {
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            else {
                                return {
                                    uuid: encrypted.uuid,
                                    content: JSON.parse(content),
                                    signatureData: {
                                        required: false,
                                        contentHash: ''
                                    }
                                };
                            }
                        });
                    }
                    encryptionComponentsFromString(string, encryptionKey) {
                        const encryptionVersion = string.substring(0, dist_src.ProtocolVersionLength);
                        return {
                            ciphertext: string.substring(dist_src.ProtocolVersionLength, string.length),
                            version: encryptionVersion,
                            key: encryptionKey
                        };
                    }
                    deriveKey(password, keyParams) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const derivedKey = yield this.crypto.pbkdf2(password, keyParams.content001.pw_salt, keyParams.content001.pw_cost, V001Algorithm.PbkdfOutputLength);
                            if (!derivedKey) {
                                throw Error('Error deriving PBKDF2 key');
                            }
                            const partitions = (0, utils_dist.splitString)(derivedKey, 2);
                            return CreateNewRootKey({
                                serverPassword: partitions[0],
                                masterKey: partitions[1],
                                version: dist_src.ProtocolVersion.V001,
                                keyParams: keyParams.getPortableValue()
                            });
                        });
                    }
                    createRandomizedKeySystemRootKey(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    createUserInputtedKeySystemRootKey(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    deriveUserInputtedKeySystemRootKey(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    createKeySystemItemsKey(_uuid, _keySystemIdentifier, _sharedVaultUuid) {
                        throw new Error('Method not implemented.');
                    }
                    versionForAsymmetricallyEncryptedString(_encryptedString) {
                        throw new Error('Method not implemented.');
                    }
                    asymmetricEncrypt(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    asymmetricDecrypt(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    asymmetricDecryptOwnMessage(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    asymmetricSignatureVerifyDetached(_encryptedString) {
                        throw new Error('Method not implemented.');
                    }
                    asymmetricStringGetAdditionalData(_dto) {
                        throw new Error('Method not implemented.');
                    }
                    getSenderPublicKeySetFromAsymmetricallyEncryptedString(_string) {
                        throw new Error('Method not implemented.');
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/002/Operator002.ts
                var Operator002_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * @deprecated
                 * A legacy operator no longer used to generate new accounts.
                 */
                class SNProtocolOperator002 extends SNProtocolOperator001 {
                    get version() {
                        return dist_src.ProtocolVersion.V002;
                    }
                    generateNewItemsKeyContent() {
                        const keyLength = V002Algorithm.EncryptionKeyLength;
                        const itemsKey = this.crypto.generateRandomKey(keyLength);
                        const authKey = this.crypto.generateRandomKey(keyLength);
                        const response = models_dist.FillItemContent({
                            itemsKey: itemsKey,
                            dataAuthenticationKey: authKey,
                            version: dist_src.ProtocolVersion.V002
                        });
                        return response;
                    }
                    /**
                     * Creates a new random items key to use for item encryption.
                     * The consumer must save/sync this item.
                     */
                    createItemsKey() {
                        const payload = new models_dist.DecryptedPayload(Object.assign({
                            uuid: utils_dist.UuidGenerator.GenerateUuid(),
                            content_type: src.ContentType.TYPES.ItemsKey,
                            content: this.generateNewItemsKeyContent()
                        }, (0, models_dist.PayloadTimestampDefaults)()));
                        return models_dist.CreateDecryptedItemFromPayload(payload);
                    }
                    createRootKey(identifier, password, origination) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            const pwCost = utils_dist.lastElement(V002Algorithm.PbkdfCostsUsed);
                            const pwNonce = this.crypto.generateRandomKey(V002Algorithm.SaltSeedLength);
                            const pwSalt = yield this.crypto.unsafeSha1(identifier + ':' + pwNonce);
                            const keyParams = Create002KeyParams({
                                email: identifier,
                                pw_nonce: pwNonce,
                                pw_cost: pwCost,
                                pw_salt: pwSalt,
                                version: dist_src.ProtocolVersion.V002,
                                origination,
                                created: "".concat(Date.now())
                            });
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    /**
                     * Note that version 002 supported "dynamic" iteration counts. Some accounts
                     * may have had costs of 5000, and others of 101000. Therefore, when computing
                     * the root key, we must use the value returned by the server.
                     */
                    computeRootKey(password, keyParams) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    decryptString002(text, key, iv) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            return this.crypto.aes256CbcDecrypt(text, iv, key);
                        });
                    }
                    encryptString002(text, key, iv) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            return this.crypto.aes256CbcEncrypt(text, iv, key);
                        });
                    }
                    /**
                     * @param keyParams Supplied only when encrypting an items key
                     */
                    encryptTextParams(string, encryptionKey, authKey, uuid, version, keyParams) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            const iv = this.crypto.generateRandomKey(V002Algorithm.EncryptionIvLength);
                            const contentCiphertext = yield this.encryptString002(string, encryptionKey, iv);
                            const ciphertextToAuth = [version, uuid, iv, contentCiphertext].join(':');
                            const authHash = yield this.crypto.hmac256(ciphertextToAuth, authKey);
                            if (!authHash) {
                                throw Error('Error generating hmac256 authHash');
                            }
                            const components = [version, authHash, uuid, iv, contentCiphertext];
                            if (keyParams) {
                                const keyParamsString = this.crypto.base64Encode(JSON.stringify(keyParams.content));
                                components.push(keyParamsString);
                            }
                            const fullCiphertext = components.join(':');
                            return fullCiphertext;
                        });
                    }
                    decryptTextParams(ciphertextToAuth, contentCiphertext, encryptionKey, iv, authHash, authKey) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            if (!encryptionKey) {
                                throw 'Attempting to decryptTextParams with null encryptionKey';
                            }
                            const localAuthHash = yield this.crypto.hmac256(ciphertextToAuth, authKey);
                            if (!localAuthHash) {
                                throw Error('Error generating hmac256 localAuthHash');
                            }
                            if (this.crypto.timingSafeEqual(authHash, localAuthHash) === false) {
                                console.error(Error('Auth hash does not match.'));
                                return null;
                            }
                            return this.decryptString002(contentCiphertext, encryptionKey, iv);
                        });
                    }
                    getPayloadAuthenticatedDataForExternalUse(encrypted) {
                        const itemKeyComponents = this.encryptionComponentsFromString002(encrypted.enc_item_key);
                        const authenticatedData = itemKeyComponents.keyParams;
                        if (!authenticatedData) {
                            return undefined;
                        }
                        const decoded = JSON.parse(this.crypto.base64Decode(authenticatedData));
                        const data = Object.assign({}, decoded);
                        return data;
                    }
                    generateEncryptedParametersAsync(payload, key) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            /**
                             * Generate new item key that is double the key size.
                             * Will be split to create encryption key and authentication key.
                             */
                            const itemKey = this.crypto.generateRandomKey(V002Algorithm.EncryptionKeyLength * 2);
                            const encItemKey = yield this.encryptTextParams(itemKey, key.itemsKey, key.dataAuthenticationKey, payload.uuid, key.keyVersion, key instanceof SNRootKey ? key.keyParams : undefined);
                            const ek = utils_dist.firstHalfOfString(itemKey);
                            const ak = utils_dist.secondHalfOfString(itemKey);
                            const ciphertext = yield this.encryptTextParams(JSON.stringify(payload.content), ek, ak, payload.uuid, key.keyVersion, key instanceof SNRootKey ? key.keyParams : undefined);
                            return {
                                uuid: payload.uuid,
                                content_type: payload.content_type,
                                items_key_id: isItemsKey(key) ? key.uuid : undefined,
                                content: ciphertext,
                                enc_item_key: encItemKey,
                                version: this.version,
                                key_system_identifier: payload.key_system_identifier,
                                shared_vault_uuid: payload.shared_vault_uuid
                            };
                        });
                    }
                    generateDecryptedParametersAsync(encrypted, key) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            if (!encrypted.enc_item_key) {
                                console.error(Error('Missing item encryption key, skipping decryption.'));
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            const encryptedItemKey = encrypted.enc_item_key;
                            const itemKeyComponents = this.encryptionComponentsFromString002(encryptedItemKey, key.itemsKey, key.dataAuthenticationKey);
                            const itemKey = yield this.decryptTextParams(itemKeyComponents.ciphertextToAuth, itemKeyComponents.contentCiphertext, itemKeyComponents.encryptionKey, itemKeyComponents.iv, itemKeyComponents.authHash, itemKeyComponents.authKey);
                            if (!itemKey) {
                                console.error('Error decrypting item_key parameters', encrypted);
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            const ek = utils_dist.firstHalfOfString(itemKey);
                            const ak = utils_dist.secondHalfOfString(itemKey);
                            const itemParams = this.encryptionComponentsFromString002(encrypted.content, ek, ak);
                            const content = yield this.decryptTextParams(itemParams.ciphertextToAuth, itemParams.contentCiphertext, itemParams.encryptionKey, itemParams.iv, itemParams.authHash, itemParams.authKey);
                            if (!content) {
                                return {
                                    uuid: encrypted.uuid,
                                    errorDecrypting: true
                                };
                            }
                            else {
                                return {
                                    uuid: encrypted.uuid,
                                    content: JSON.parse(content),
                                    signatureData: {
                                        required: false,
                                        contentHash: ''
                                    }
                                };
                            }
                        });
                    }
                    deriveKey(password, keyParams) {
                        return Operator002_awaiter(this, void 0, void 0, function* () {
                            const derivedKey = yield this.crypto.pbkdf2(password, keyParams.content002.pw_salt, keyParams.content002.pw_cost, V002Algorithm.PbkdfOutputLength);
                            if (!derivedKey) {
                                throw Error('Error deriving PBKDF2 key');
                            }
                            const partitions = utils_dist.splitString(derivedKey, 3);
                            return CreateNewRootKey({
                                serverPassword: partitions[0],
                                masterKey: partitions[1],
                                dataAuthenticationKey: partitions[2],
                                version: dist_src.ProtocolVersion.V002,
                                keyParams: keyParams.getPortableValue()
                            });
                        });
                    }
                    encryptionComponentsFromString002(string, encryptionKey, authKey) {
                        const components = string.split(':');
                        return {
                            encryptionVersion: components[0],
                            authHash: components[1],
                            uuid: components[2],
                            iv: components[3],
                            contentCiphertext: components[4],
                            keyParams: components[5],
                            ciphertextToAuth: [components[0], components[2], components[3], components[4]].join(':'),
                            encryptionKey: encryptionKey,
                            authKey: authKey
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/003/Operator003.ts
                var Operator003_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * @legacy
                 * Non-expired operator but no longer used for generating new accounts.
                 * This operator subclasses the 002 operator to share functionality that has not
                 * changed, and overrides functions where behavior may differ.
                 */
                class SNProtocolOperator003 extends SNProtocolOperator002 {
                    get version() {
                        return dist_src.ProtocolVersion.V003;
                    }
                    generateNewItemsKeyContent() {
                        const keyLength = V003Algorithm.EncryptionKeyLength;
                        const itemsKey = this.crypto.generateRandomKey(keyLength);
                        const authKey = this.crypto.generateRandomKey(keyLength);
                        const response = (0, models_dist.FillItemContent)({
                            itemsKey: itemsKey,
                            dataAuthenticationKey: authKey,
                            version: dist_src.ProtocolVersion.V003
                        });
                        return response;
                    }
                    /**
                     * Creates a new random items key to use for item encryption.
                     * The consumer must save/sync this item.
                     */
                    createItemsKey() {
                        const content = this.generateNewItemsKeyContent();
                        const payload = new models_dist.DecryptedPayload(Object.assign({
                            uuid: utils_dist.UuidGenerator.GenerateUuid(),
                            content_type: src.ContentType.TYPES.ItemsKey,
                            content: (0, models_dist.FillItemContent)(content)
                        }, (0, models_dist.PayloadTimestampDefaults)()));
                        return (0, models_dist.CreateDecryptedItemFromPayload)(payload);
                    }
                    computeRootKey(password, keyParams) {
                        return Operator003_awaiter(this, void 0, void 0, function* () {
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    deriveKey(password, keyParams) {
                        return Operator003_awaiter(this, void 0, void 0, function* () {
                            const salt = yield this.generateSalt(keyParams.content003.identifier, dist_src.ProtocolVersion.V003, V003Algorithm.PbkdfCost, keyParams.content003.pw_nonce);
                            const derivedKey = yield this.crypto.pbkdf2(password, salt, V003Algorithm.PbkdfCost, V003Algorithm.PbkdfOutputLength);
                            if (!derivedKey) {
                                throw Error('Error deriving PBKDF2 key');
                            }
                            const partitions = (0, utils_dist.splitString)(derivedKey, 3);
                            return CreateNewRootKey({
                                serverPassword: partitions[0],
                                masterKey: partitions[1],
                                dataAuthenticationKey: partitions[2],
                                version: dist_src.ProtocolVersion.V003,
                                keyParams: keyParams.getPortableValue()
                            });
                        });
                    }
                    createRootKey(identifier, password, origination) {
                        return Operator003_awaiter(this, void 0, void 0, function* () {
                            const version = dist_src.ProtocolVersion.V003;
                            const pwNonce = this.crypto.generateRandomKey(V003Algorithm.SaltSeedLength);
                            const keyParams = Create003KeyParams({
                                identifier: identifier,
                                pw_nonce: pwNonce,
                                version: version,
                                origination: origination,
                                created: "".concat(Date.now())
                            });
                            return this.deriveKey(password, keyParams);
                        });
                    }
                    generateSalt(identifier, version, cost, nonce) {
                        return Operator003_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.crypto.sha256([identifier, 'SF', version, cost, nonce].join(':'));
                            return result;
                        });
                    }
                }
                // EXTERNAL MODULE: ../encryption/src/Domain/Operator/004/V004AlgorithmTypes.ts
                var V004AlgorithmTypes = __webpack_require__(99299);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Utils/CreateConsistentBase64JsonPayload.ts
                class CreateConsistentBase64JsonPayloadUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(jsonObject) {
                        return this.crypto.base64Encode(JSON.stringify(utils_dist.sortedCopy(utils_dist.omitUndefinedCopy(jsonObject))));
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Asymmetric/AsymmetricEncrypt.ts
                class AsymmetricEncrypt004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.base64DataUsecase = new CreateConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(dto) {
                        const nonce = this.crypto.generateRandomKey(V004Algorithm.AsymmetricEncryptionNonceLength);
                        const ciphertext = this.crypto.sodiumCryptoBoxEasyEncrypt(dto.stringToEncrypt, nonce, dto.recipientPublicKey, dto.senderKeyPair.privateKey);
                        const additionalData = {
                            signingData: {
                                publicKey: dto.senderSigningKeyPair.publicKey,
                                signature: this.crypto.sodiumCryptoSign(ciphertext, dto.senderSigningKeyPair.privateKey)
                            },
                            senderPublicKey: dto.senderKeyPair.publicKey
                        };
                        const components = [V004AlgorithmTypes /* V004AsymmetricCiphertextPrefix */.s, nonce, ciphertext, this.base64DataUsecase.execute(additionalData)];
                        return components.join(':');
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Utils/ParseConsistentBase64JsonPayload.ts
                class ParseConsistentBase64JsonPayloadUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(stringifiedData) {
                        return JSON.parse(this.crypto.base64Decode(stringifiedData));
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Asymmetric/AsymmetricDecrypt.ts
                class AsymmetricDecrypt004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(dto) {
                        const [_, nonce, ciphertext, additionalDataString] = dto.stringToDecrypt.split(':');
                        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
                        try {
                            const plaintext = this.crypto.sodiumCryptoBoxEasyDecrypt(ciphertext, nonce, additionalData.senderPublicKey, dto.recipientSecretKey);
                            if (!plaintext) {
                                return null;
                            }
                            const signatureVerified = this.crypto.sodiumCryptoSignVerify(ciphertext, additionalData.signingData.signature, additionalData.signingData.publicKey);
                            return {
                                plaintext,
                                signatureVerified,
                                signaturePublicKey: additionalData.signingData.publicKey,
                                senderPublicKey: additionalData.senderPublicKey
                            };
                        }
                        catch (error) {
                            return null;
                        }
                    }
                }
                // EXTERNAL MODULE: ../encryption/src/Domain/Operator/004/V004AlgorithmHelpers.ts
                var V004AlgorithmHelpers = __webpack_require__(73936);
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Utils/StringToAuthenticatedData.ts
                class StringToAuthenticatedDataUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(rawAuthenticatedData, override) {
                        const base = JSON.parse(this.crypto.base64Decode(rawAuthenticatedData));
                        return (0, utils_dist.sortedCopy)(Object.assign(Object.assign({}, base), override));
                    }
                    executeRaw(rawAuthenticatedData) {
                        const base = JSON.parse(this.crypto.base64Decode(rawAuthenticatedData));
                        return base;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Hash/HashString.ts
                class HashStringUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(string, hashingKey) {
                        return this.crypto.sodiumCryptoGenericHash(string, hashingKey.key);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateSymmetricPayloadSignatureResult.ts
                /**
                 * Embedded signatures check the signature on the symmetric string, but this string can change every time we encrypt
                 * the payload, even though its content hasn't changed. This would mean that if we received a signed payload from User B,
                 * then saved this payload into local storage by encrypting it, we would lose the signature of the content it came with, and
                 * it would instead be overwritten by our local user signature, which would always pass.
                 *
                 * In addition to embedded signature verification, we'll also hang on to a sticky signature of the content, which
                 * remains the same until the hash changes. We do not perform any static verification on this data; instead, clients
                 * can compute authenticity of the content on demand.
                 */
                class GenerateSymmetricPayloadSignatureResultUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                        this.hashUseCase = new HashStringUseCase(this.crypto);
                    }
                    execute(payload, hashingKey, contentKeyParameters, contentParameters) {
                        const contentKeyHash = this.hashUseCase.execute(contentKeyParameters.plaintext, hashingKey);
                        const contentHash = this.hashUseCase.execute(contentParameters.plaintext, hashingKey);
                        const contentKeyAdditionalData = this.parseBase64Usecase.execute(contentKeyParameters.additionalData);
                        const contentAdditionalData = this.parseBase64Usecase.execute(contentParameters.additionalData);
                        const verificationRequired = (0, V004AlgorithmHelpers /* doesPayloadRequireSigning */.q)(payload);
                        if (!contentKeyAdditionalData.signingData || !contentAdditionalData.signingData) {
                            if (verificationRequired) {
                                return {
                                    required: true,
                                    contentHash: contentHash,
                                    result: {
                                        passes: false,
                                        publicKey: '',
                                        signature: ''
                                    }
                                };
                            }
                            return {
                                required: false,
                                contentHash: contentHash
                            };
                        }
                        if (contentKeyAdditionalData.signingData.publicKey !== contentAdditionalData.signingData.publicKey) {
                            return {
                                required: verificationRequired,
                                contentHash: contentHash,
                                result: {
                                    passes: false,
                                    publicKey: '',
                                    signature: ''
                                }
                            };
                        }
                        const commonPublicKey = contentKeyAdditionalData.signingData.publicKey;
                        const contentKeySignatureVerified = this.verifySignature(contentKeyHash, contentKeyAdditionalData.signingData.signature, commonPublicKey);
                        const contentSignatureVerified = this.verifySignature(contentHash, contentAdditionalData.signingData.signature, commonPublicKey);
                        let passesStickyContentVerification = true;
                        const previousSignatureResult = payload.signatureData;
                        if (previousSignatureResult) {
                            const previousSignatureStillApplicable = previousSignatureResult.contentHash === contentHash;
                            if (previousSignatureStillApplicable) {
                                if (previousSignatureResult.required) {
                                    passesStickyContentVerification = previousSignatureResult.result.passes;
                                }
                                else if (previousSignatureResult.result) {
                                    passesStickyContentVerification = previousSignatureResult.result.passes;
                                }
                            }
                        }
                        const passesAllVerification = contentKeySignatureVerified && contentSignatureVerified && passesStickyContentVerification;
                        return {
                            required: verificationRequired,
                            contentHash: contentHash,
                            result: {
                                passes: passesAllVerification,
                                publicKey: commonPublicKey,
                                signature: contentAdditionalData.signingData.signature
                            }
                        };
                    }
                    verifySignature(contentHash, signature, publicKey) {
                        return this.crypto.sodiumCryptoSignVerify(contentHash, signature, publicKey);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Hash/DeriveHashingKey.ts
                class DeriveHashingKeyUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(key) {
                        const hashingKey = this.crypto.sodiumCryptoKdfDeriveFromKey(key.itemsKey, V004Algorithm.PayloadKeyHashingKeySubKeyNumber, V004Algorithm.PayloadKeyHashingKeySubKeyBytes, V004Algorithm.PayloadKeyHashingKeySubKeyContext);
                        return {
                            key: hashingKey
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateDecryptedParameters.ts
                class GenerateDecryptedParametersUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.base64DataUsecase = new CreateConsistentBase64JsonPayloadUseCase(this.crypto);
                        this.stringToAuthenticatedDataUseCase = new StringToAuthenticatedDataUseCase(this.crypto);
                        this.signingVerificationUseCase = new GenerateSymmetricPayloadSignatureResultUseCase(this.crypto);
                        this.deriveHashingKeyUseCase = new DeriveHashingKeyUseCase(this.crypto);
                    }
                    execute(encrypted, key) {
                        const contentKeyResult = this.decryptContentKey(encrypted, key);
                        if (!contentKeyResult) {
                            console.error('Error decrypting contentKey from parameters', encrypted);
                            return {
                                uuid: encrypted.uuid,
                                errorDecrypting: true
                            };
                        }
                        const contentResult = this.decryptContent(encrypted, contentKeyResult.decrypted);
                        if (!contentResult) {
                            return {
                                uuid: encrypted.uuid,
                                errorDecrypting: true
                            };
                        }
                        const hashingKey = this.deriveHashingKeyUseCase.execute(key);
                        const signatureVerificationResult = this.signingVerificationUseCase.execute(encrypted, hashingKey, {
                            additionalData: contentKeyResult.components.additionalData,
                            plaintext: contentKeyResult.decrypted
                        }, {
                            additionalData: contentResult.components.additionalData,
                            plaintext: contentResult.decrypted
                        });
                        return {
                            uuid: encrypted.uuid,
                            content: JSON.parse(contentResult.decrypted),
                            signatureData: signatureVerificationResult
                        };
                    }
                    decryptContent(encrypted, contentKey) {
                        const contentComponents = (0, V004AlgorithmHelpers /* deconstructEncryptedPayloadString */.U)(encrypted.content);
                        return this.decrypt(encrypted, contentComponents, contentKey);
                    }
                    decryptContentKey(encrypted, key) {
                        const contentKeyComponents = (0, V004AlgorithmHelpers /* deconstructEncryptedPayloadString */.U)(encrypted.enc_item_key);
                        return this.decrypt(encrypted, contentKeyComponents, key.itemsKey);
                    }
                    decrypt(encrypted, components, key) {
                        const rawAuthenticatedData = this.stringToAuthenticatedDataUseCase.executeRaw(components.authenticatedData);
                        const doesRawContainLegacyUppercaseUuid = /[A-Z]/.test(rawAuthenticatedData.u);
                        const authenticatedData = this.stringToAuthenticatedDataUseCase.execute(components.authenticatedData, {
                            u: doesRawContainLegacyUppercaseUuid ? encrypted.uuid.toUpperCase() : encrypted.uuid,
                            v: encrypted.version,
                            ksi: encrypted.key_system_identifier,
                            svu: encrypted.shared_vault_uuid
                        });
                        const authenticatedDataString = this.base64DataUsecase.execute(authenticatedData);
                        const decrypted = this.crypto.xchacha20Decrypt(components.ciphertext, components.nonce, key, authenticatedDataString);
                        if (!decrypted) {
                            return null;
                        }
                        return {
                            decrypted,
                            components: components,
                            authenticatedDataString
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateAuthenticatedData.ts
                class GenerateAuthenticatedDataUseCase {
                    execute(payload, key) {
                        const baseData = {
                            u: payload.uuid,
                            v: models_dist.ProtocolVersion.V004
                        };
                        if (payload.key_system_identifier) {
                            baseData.ksi = payload.key_system_identifier;
                        }
                        if (payload.shared_vault_uuid) {
                            baseData.svu = payload.shared_vault_uuid;
                        }
                        if ((0, models_dist.ContentTypeUsesRootKeyEncryption)(payload.content_type)) {
                            return Object.assign(Object.assign({}, baseData), {
                                kp: key.keyParams.content
                            });
                        }
                        else if ((0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(payload.content_type)) {
                            if (!(0, models_dist.isKeySystemRootKey)(key)) {
                                throw Error("Attempting to use non-key system root key ".concat(key.content_type, " for item content type ").concat(payload.content_type));
                            }
                            return Object.assign(Object.assign({}, baseData), {
                                kp: key.keyParams
                            });
                        }
                        else {
                            if (!isItemsKey(key) && !isKeySystemItemsKey(key)) {
                                throw Error('Attempting to use non-items key for regular item.');
                            }
                            return baseData;
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateEncryptedProtocolString.ts
                class GenerateEncryptedProtocolStringUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(plaintext, rawKey, authenticatedData, additionalData) {
                        const nonce = this.crypto.generateRandomKey(V004Algorithm.EncryptionNonceLength);
                        const ciphertext = this.encryptString(plaintext, rawKey, nonce, authenticatedData);
                        const components = [models_dist.ProtocolVersion.V004, nonce, ciphertext, authenticatedData, additionalData];
                        return components.join(V004AlgorithmTypes /* V004PartitionCharacter */.X);
                    }
                    encryptString(plaintext, rawKey, nonce, authenticatedData) {
                        if (!nonce) {
                            throw 'encryptString null nonce';
                        }
                        if (!rawKey) {
                            throw 'encryptString null rawKey';
                        }
                        return this.crypto.xchacha20Encrypt(plaintext, nonce, rawKey, authenticatedData);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateSymmetricAdditionalData.ts
                class GenerateSymmetricAdditionalDataUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.hashUseCase = new HashStringUseCase(this.crypto);
                    }
                    execute(payloadPlaintext, hashingKey, signingKeyPair) {
                        const plaintextHash = this.hashUseCase.execute(payloadPlaintext, hashingKey);
                        if (!signingKeyPair) {
                            return {
                                additionalData: {},
                                plaintextHash
                            };
                        }
                        const signature = this.crypto.sodiumCryptoSign(plaintextHash, signingKeyPair.privateKey);
                        return {
                            additionalData: {
                                signingData: {
                                    publicKey: signingKeyPair.publicKey,
                                    signature
                                }
                            },
                            plaintextHash
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GenerateEncryptedParameters.ts
                class GenerateEncryptedParametersUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.generateProtocolStringUseCase = new GenerateEncryptedProtocolStringUseCase(this.crypto);
                        this.generateAuthenticatedDataUseCase = new GenerateAuthenticatedDataUseCase();
                        this.generateAdditionalDataUseCase = new GenerateSymmetricAdditionalDataUseCase(this.crypto);
                        this.encodeBase64DataUsecase = new CreateConsistentBase64JsonPayloadUseCase(this.crypto);
                        this.deriveHashingKeyUseCase = new DeriveHashingKeyUseCase(this.crypto);
                    }
                    execute(payload, key, signingKeyPair) {
                        if ((0, V004AlgorithmHelpers /* doesPayloadRequireSigning */.q)(payload) && !signingKeyPair) {
                            throw Error('Payload requires signing but no signing key pair was provided.');
                        }
                        const commonAuthenticatedData = this.generateAuthenticatedDataUseCase.execute(payload, key);
                        const hashingKey = this.deriveHashingKeyUseCase.execute(key);
                        const { contentKey, encryptedContentKey } = this.generateEncryptedContentKey(key, hashingKey, commonAuthenticatedData, signingKeyPair);
                        const { encryptedContent } = this.generateEncryptedContent(payload, hashingKey, contentKey, commonAuthenticatedData, signingKeyPair);
                        return {
                            uuid: payload.uuid,
                            content_type: payload.content_type,
                            items_key_id: isItemsKey(key) || isKeySystemItemsKey(key) ? key.uuid : undefined,
                            content: encryptedContent,
                            enc_item_key: encryptedContentKey,
                            version: models_dist.ProtocolVersion.V004,
                            key_system_identifier: payload.key_system_identifier,
                            shared_vault_uuid: payload.shared_vault_uuid
                        };
                    }
                    generateEncryptedContent(payload, hashingKey, contentKey, commonAuthenticatedData, signingKeyPair) {
                        const content = JSON.stringify(payload.content);
                        const { additionalData } = this.generateAdditionalDataUseCase.execute(content, hashingKey, signingKeyPair);
                        const encryptedContent = this.generateProtocolStringUseCase.execute(content, contentKey, this.encodeBase64DataUsecase.execute(commonAuthenticatedData), this.encodeBase64DataUsecase.execute(additionalData));
                        return {
                            encryptedContent
                        };
                    }
                    generateEncryptedContentKey(key, hashingKey, commonAuthenticatedData, signingKeyPair) {
                        const contentKey = this.crypto.generateRandomKey(V004Algorithm.EncryptionKeyLength);
                        const { additionalData } = this.generateAdditionalDataUseCase.execute(contentKey, hashingKey, signingKeyPair);
                        const encryptedContentKey = this.generateProtocolStringUseCase.execute(contentKey, key.itemsKey, this.encodeBase64DataUsecase.execute(commonAuthenticatedData), this.encodeBase64DataUsecase.execute(additionalData));
                        return {
                            contentKey,
                            encryptedContentKey
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/RootKey/DeriveRootKey.ts
                var DeriveRootKey_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeriveRootKeyUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(password, keyParams) {
                        return DeriveRootKey_awaiter(this, void 0, void 0, function* () {
                            const seed = keyParams.content004.pw_nonce;
                            const salt = yield this.generateSalt(keyParams.content004.identifier, seed);
                            const derivedKey = this.crypto.argon2(password, salt, V004Algorithm.ArgonIterations, V004Algorithm.ArgonMemLimit, V004Algorithm.ArgonOutputKeyBytes);
                            const partitions = (0, utils_dist.splitString)(derivedKey, 2);
                            const masterKey = partitions[0];
                            const serverPassword = partitions[1];
                            const encryptionKeyPairSeed = this.crypto.sodiumCryptoKdfDeriveFromKey(masterKey, V004Algorithm.MasterKeyEncryptionKeyPairSubKeyNumber, V004Algorithm.MasterKeyEncryptionKeyPairSubKeyBytes, V004Algorithm.MasterKeyEncryptionKeyPairSubKeyContext);
                            const encryptionKeyPair = this.crypto.sodiumCryptoBoxSeedKeypair(encryptionKeyPairSeed);
                            const signingKeyPairSeed = this.crypto.sodiumCryptoKdfDeriveFromKey(masterKey, V004Algorithm.MasterKeySigningKeyPairSubKeyNumber, V004Algorithm.MasterKeySigningKeyPairSubKeyBytes, V004Algorithm.MasterKeySigningKeyPairSubKeyContext);
                            const signingKeyPair = this.crypto.sodiumCryptoSignSeedKeypair(signingKeyPairSeed);
                            return CreateNewRootKey({
                                masterKey,
                                serverPassword,
                                version: models_dist.ProtocolVersion.V004,
                                keyParams: keyParams.getPortableValue(),
                                encryptionKeyPair,
                                signingKeyPair
                            });
                        });
                    }
                    /**
                     * We require both a client-side component and a server-side component in generating a
                     * salt. This way, a comprimised server cannot benefit from sending the same seed value
                     * for every user. We mix a client-controlled value that is globally unique
                     * (their identifier), with a server controlled value to produce a salt for our KDF.
                     * @param identifier
                     * @param seed
                     */
                    generateSalt(identifier, seed) {
                        return DeriveRootKey_awaiter(this, void 0, void 0, function* () {
                            const hash = yield this.crypto.sha256([identifier, seed].join(V004AlgorithmTypes /* V004PartitionCharacter */.X));
                            return (0, utils_dist.truncateHexString)(hash, V004Algorithm.ArgonSaltLength);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Symmetric/GetPayloadAuthenticatedDataDetached.ts
                class GetPayloadAuthenticatedDataDetachedUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseStringUseCase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(encrypted) {
                        const contentKeyComponents = (0, V004AlgorithmHelpers /* deconstructEncryptedPayloadString */.U)(encrypted.enc_item_key);
                        const authenticatedDataString = contentKeyComponents.authenticatedData;
                        const result = this.parseStringUseCase.execute(authenticatedDataString);
                        return result;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/RootKey/CreateRootKey.ts
                var CreateRootKey_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateRootKeyUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(identifier, password, origination) {
                        return CreateRootKey_awaiter(this, void 0, void 0, function* () {
                            const version = dist_src.ProtocolVersion.V004;
                            const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
                            const keyParams = Create004KeyParams({
                                identifier: identifier,
                                pw_nonce: seed,
                                version: version,
                                origination: origination,
                                created: "".concat(Date.now())
                            });
                            const usecase = new DeriveRootKeyUseCase(this.crypto);
                            return usecase.execute(password, keyParams);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/KeySystem/CreateKeySystemItemsKey.ts
                class CreateKeySystemItemsKeyUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(dto) {
                        const key = this.crypto.generateRandomKey(V004Algorithm.EncryptionKeyLength);
                        const content = (0, models_dist.FillItemContentSpecialized)({
                            itemsKey: key,
                            creationTimestamp: new Date().getTime(),
                            version: models_dist.ProtocolVersion.V004,
                            rootKeyToken: dto.rootKeyToken
                        });
                        const transferPayload = Object.assign({
                            uuid: dto.uuid,
                            content_type: src.ContentType.TYPES.KeySystemItemsKey,
                            key_system_identifier: dto.keySystemIdentifier,
                            shared_vault_uuid: dto.sharedVaultUuid,
                            content: content,
                            dirty: true
                        }, (0, models_dist.PayloadTimestampDefaults)());
                        const payload = new models_dist.DecryptedPayload(transferPayload);
                        return (0, models_dist.CreateDecryptedItemFromPayload)(payload);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/KeySystem/DeriveKeySystemRootKey.ts
                class DeriveKeySystemRootKeyUseCase {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(dto) {
                        const seed = dto.keyParams.seed;
                        const salt = this.generateSalt(dto.keyParams.systemIdentifier, seed);
                        const derivedKey = this.crypto.argon2(dto.password, salt, V004Algorithm.ArgonIterations, V004Algorithm.ArgonMemLimit, V004Algorithm.ArgonOutputKeyBytes);
                        const partitions = (0, utils_dist.splitString)(derivedKey, 2);
                        const masterKey = partitions[0];
                        const token = partitions[1];
                        const uuid = utils_dist.UuidGenerator.GenerateUuid();
                        const content = {
                            systemIdentifier: dto.keyParams.systemIdentifier,
                            key: masterKey,
                            keyVersion: models_dist.ProtocolVersion.V004,
                            keyParams: dto.keyParams,
                            token
                        };
                        const payload = new models_dist.DecryptedPayload(Object.assign({
                            uuid: uuid,
                            content_type: src.ContentType.TYPES.KeySystemRootKey,
                            content: (0, models_dist.FillItemContentSpecialized)(content)
                        }, (0, models_dist.PayloadTimestampDefaults)()));
                        return new models_dist.KeySystemRootKey(payload);
                    }
                    generateSalt(identifier, seed) {
                        const hash = this.crypto.sodiumCryptoGenericHash([identifier, seed].join(V004AlgorithmTypes /* V004PartitionCharacter */.X));
                        return (0, utils_dist.truncateHexString)(hash, V004Algorithm.ArgonSaltLength);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/KeySystem/CreateRandomKeySystemRootKey.ts
                class CreateRandomKeySystemRootKey {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(dto) {
                        const version = models_dist.ProtocolVersion.V004;
                        const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
                        const randomPassword = this.crypto.generateRandomKey(32);
                        const keyParams = {
                            systemIdentifier: dto.systemIdentifier,
                            passwordType: models_dist.KeySystemPasswordType.Randomized,
                            creationTimestamp: new Date().getTime(),
                            seed,
                            version
                        };
                        const usecase = new DeriveKeySystemRootKeyUseCase(this.crypto);
                        return usecase.execute({
                            password: randomPassword,
                            keyParams
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/KeySystem/CreateUserInputKeySystemRootKey.ts
                class CreateUserInputKeySystemRootKey {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute(dto) {
                        const version = models_dist.ProtocolVersion.V004;
                        const seed = this.crypto.generateRandomKey(V004Algorithm.ArgonSaltSeedLength);
                        const keyParams = {
                            systemIdentifier: dto.systemIdentifier,
                            passwordType: models_dist.KeySystemPasswordType.UserInputted,
                            creationTimestamp: new Date().getTime(),
                            seed,
                            version
                        };
                        const usecase = new DeriveKeySystemRootKeyUseCase(this.crypto);
                        return usecase.execute({
                            password: dto.userInputtedPassword,
                            keyParams
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Asymmetric/AsymmetricSignatureVerificationDetached.ts
                class AsymmetricSignatureVerificationDetached004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(dto) {
                        const [_, __, ciphertext, additionalDataString] = dto.encryptedString.split(':');
                        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
                        try {
                            const signatureVerified = this.crypto.sodiumCryptoSignVerify(ciphertext, additionalData.signingData.signature, additionalData.signingData.publicKey);
                            return {
                                signatureVerified,
                                signaturePublicKey: additionalData.signingData.publicKey,
                                senderPublicKey: additionalData.senderPublicKey
                            };
                        }
                        catch (error) {
                            return {
                                signatureVerified: false
                            };
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Asymmetric/AsymmetricStringGetAdditionalData.ts
                class AsymmetricStringGetAdditionalData004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(dto) {
                        const [_, __, ___, additionalDataString] = dto.encryptedString.split(':');
                        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
                        return src.Result.ok(additionalData);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/UseCase/Asymmetric/AsymmetricDecryptOwnMessage.ts
                class AsymmetricDecryptOwnMessage004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                    }
                    execute(dto) {
                        const [_, nonce, ciphertext, additionalDataString] = dto.message.split(':');
                        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
                        try {
                            const plaintext = this.crypto.sodiumCryptoBoxEasyDecrypt(ciphertext, nonce, dto.recipientPublicKey, dto.ownPrivateKey);
                            if (!plaintext) {
                                return src.Result.fail('Could not decrypt message');
                            }
                            const signatureVerified = this.crypto.sodiumCryptoSignVerify(ciphertext, additionalData.signingData.signature, additionalData.signingData.publicKey);
                            return src.Result.ok({
                                plaintext,
                                signatureVerified,
                                signaturePublicKey: additionalData.signingData.publicKey,
                                senderPublicKey: additionalData.senderPublicKey
                            });
                        }
                        catch (error) {
                            return src.Result.fail('Could not decrypt message');
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/004/Operator004.ts
                var Operator004_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SNProtocolOperator004 {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    getEncryptionDisplayName() {
                        return 'XChaCha20-Poly1305';
                    }
                    get version() {
                        return dist_src.ProtocolVersion.V004;
                    }
                    generateNewItemsKeyContent() {
                        const itemsKey = this.crypto.generateRandomKey(V004Algorithm.EncryptionKeyLength);
                        const response = (0, models_dist.FillItemContentSpecialized)({
                            itemsKey: itemsKey,
                            version: dist_src.ProtocolVersion.V004
                        });
                        return response;
                    }
                    /**
                     * Creates a new random items key to use for item encryption.
                     * The consumer must save/sync this item.
                     */
                    createItemsKey() {
                        const payload = new models_dist.DecryptedPayload(Object.assign({
                            uuid: utils_dist.UuidGenerator.GenerateUuid(),
                            content_type: src.ContentType.TYPES.ItemsKey,
                            content: this.generateNewItemsKeyContent(),
                            key_system_identifier: undefined,
                            shared_vault_uuid: undefined
                        }, (0, models_dist.PayloadTimestampDefaults)()));
                        return (0, models_dist.CreateDecryptedItemFromPayload)(payload);
                    }
                    createRandomizedKeySystemRootKey(dto) {
                        const usecase = new CreateRandomKeySystemRootKey(this.crypto);
                        return usecase.execute(dto);
                    }
                    createUserInputtedKeySystemRootKey(dto) {
                        const usecase = new CreateUserInputKeySystemRootKey(this.crypto);
                        return usecase.execute(dto);
                    }
                    deriveUserInputtedKeySystemRootKey(dto) {
                        const usecase = new DeriveKeySystemRootKeyUseCase(this.crypto);
                        return usecase.execute({
                            keyParams: dto.keyParams,
                            password: dto.userInputtedPassword
                        });
                    }
                    createKeySystemItemsKey(uuid, keySystemIdentifier, sharedVaultUuid, rootKeyToken) {
                        const usecase = new CreateKeySystemItemsKeyUseCase(this.crypto);
                        return usecase.execute({
                            uuid,
                            keySystemIdentifier,
                            sharedVaultUuid,
                            rootKeyToken
                        });
                    }
                    computeRootKey(password, keyParams) {
                        return Operator004_awaiter(this, void 0, void 0, function* () {
                            const usecase = new DeriveRootKeyUseCase(this.crypto);
                            return usecase.execute(password, keyParams);
                        });
                    }
                    createRootKey(identifier, password, origination) {
                        return Operator004_awaiter(this, void 0, void 0, function* () {
                            const usecase = new CreateRootKeyUseCase(this.crypto);
                            return usecase.execute(identifier, password, origination);
                        });
                    }
                    getPayloadAuthenticatedDataForExternalUse(encrypted) {
                        const usecase = new GetPayloadAuthenticatedDataDetachedUseCase(this.crypto);
                        return usecase.execute(encrypted);
                    }
                    generateEncryptedParameters(payload, key, signingKeyPair) {
                        const usecase = new GenerateEncryptedParametersUseCase(this.crypto);
                        return usecase.execute(payload, key, signingKeyPair);
                    }
                    generateDecryptedParameters(encrypted, key) {
                        const usecase = new GenerateDecryptedParametersUseCase(this.crypto);
                        return usecase.execute(encrypted, key);
                    }
                    asymmetricEncrypt(dto) {
                        const usecase = new AsymmetricEncrypt004(this.crypto);
                        return usecase.execute(dto);
                    }
                    asymmetricDecrypt(dto) {
                        const usecase = new AsymmetricDecrypt004(this.crypto);
                        return usecase.execute(dto);
                    }
                    asymmetricDecryptOwnMessage(dto) {
                        const usecase = new AsymmetricDecryptOwnMessage004(this.crypto);
                        return usecase.execute(dto);
                    }
                    asymmetricSignatureVerifyDetached(encryptedString) {
                        const usecase = new AsymmetricSignatureVerificationDetached004(this.crypto);
                        return usecase.execute({
                            encryptedString
                        });
                    }
                    asymmetricStringGetAdditionalData(dto) {
                        const usecase = new AsymmetricStringGetAdditionalData004(this.crypto);
                        return usecase.execute(dto);
                    }
                    getSenderPublicKeySetFromAsymmetricallyEncryptedString(string) {
                        const [_, __, ___, additionalDataString] = string.split(':');
                        const parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
                        const additionalData = parseBase64Usecase.execute(additionalDataString);
                        return {
                            encryption: additionalData.senderPublicKey,
                            signing: additionalData.signingData.publicKey
                        };
                    }
                    versionForAsymmetricallyEncryptedString(string) {
                        const [versionPrefix] = string.split(':');
                        const version = versionPrefix.split('_')[0];
                        return version;
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/Functions.ts
                function createOperatorForVersion(version, crypto) {
                    if (version === models_dist.ProtocolVersion.V001) {
                        return new SNProtocolOperator001(crypto);
                    }
                    else if (version === models_dist.ProtocolVersion.V002) {
                        return new SNProtocolOperator002(crypto);
                    }
                    else if (version === models_dist.ProtocolVersion.V003) {
                        return new SNProtocolOperator003(crypto);
                    }
                    else if (version === models_dist.ProtocolVersion.V004) {
                        return new SNProtocolOperator004(crypto);
                    }
                    else {
                        throw Error("Unable to find operator for version ".concat(version));
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/EncryptionOperators.ts
                class EncryptionOperators {
                    constructor(crypto) {
                        this.crypto = crypto;
                        this.operators = {};
                        this.crypto = crypto;
                    }
                    deinit() {
                        ;
                        this.crypto = undefined;
                        this.operators = {};
                    }
                    operatorForVersion(version) {
                        const operatorKey = version;
                        let operator = this.operators[operatorKey];
                        if (!operator) {
                            operator = createOperatorForVersion(version, this.crypto);
                            this.operators[operatorKey] = operator;
                        }
                        return operator;
                    }
                    /**
                     * Returns the operator corresponding to the latest protocol version
                     */
                    defaultOperator() {
                        return this.operatorForVersion(dist_src.ProtocolVersionLatest);
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Types/EncryptedParameters.ts
                function isErrorDecryptingParameters(x) {
                    return x.errorDecrypting;
                }
                function encryptedInputParametersFromPayload(payload) {
                    return {
                        uuid: payload.uuid,
                        content: payload.content,
                        content_type: payload.content_type,
                        items_key_id: payload.items_key_id,
                        enc_item_key: payload.enc_item_key,
                        version: payload.version,
                        auth_hash: payload.auth_hash,
                        key_system_identifier: payload.key_system_identifier,
                        shared_vault_uuid: payload.shared_vault_uuid,
                        signatureData: payload.signatureData
                    };
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/OperatorInterface/TypeCheck.ts
                function isAsyncOperator(operator) {
                    return 'generateEncryptedParametersAsync' in operator;
                }
                function isSyncOperator(operator) {
                    return !isAsyncOperator(operator);
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Operator/OperatorWrapper.ts
                var OperatorWrapper_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function encryptPayload(payload, key, operatorManager, signingKeyPair) {
                    return OperatorWrapper_awaiter(this, void 0, void 0, function* () {
                        const operator = operatorManager.operatorForVersion(key.keyVersion);
                        let result = undefined;
                        if (isAsyncOperator(operator)) {
                            result = yield operator.generateEncryptedParametersAsync(payload, key);
                        }
                        else {
                            result = operator.generateEncryptedParameters(payload, key, signingKeyPair);
                        }
                        if (!result) {
                            throw 'Unable to generate encryption parameters';
                        }
                        return result;
                    });
                }
                function decryptPayload(payload, key, operatorManager) {
                    return OperatorWrapper_awaiter(this, void 0, void 0, function* () {
                        const operator = operatorManager.operatorForVersion(payload.version);
                        try {
                            if (isAsyncOperator(operator)) {
                                return yield operator.generateDecryptedParametersAsync(encryptedInputParametersFromPayload(payload), key);
                            }
                            else {
                                return operator.generateDecryptedParameters(encryptedInputParametersFromPayload(payload), key);
                            }
                        }
                        catch (e) {
                            console.error('Error decrypting payload', payload, e);
                            return {
                                uuid: payload.uuid,
                                errorDecrypting: true
                            };
                        }
                    });
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Split/EncryptionSplit.ts
                function CreateEncryptionSplitWithKeyLookup(payloadSplit) {
                    const result = {};
                    if (payloadSplit.rootKeyEncryption) {
                        result.usesRootKeyWithKeyLookup = {
                            items: payloadSplit.rootKeyEncryption
                        };
                    }
                    if (payloadSplit.keySystemRootKeyEncryption) {
                        result.usesKeySystemRootKeyWithKeyLookup = {
                            items: payloadSplit.keySystemRootKeyEncryption
                        };
                    }
                    if (payloadSplit.itemsKeyEncryption) {
                        result.usesItemsKeyWithKeyLookup = {
                            items: payloadSplit.itemsKeyEncryption
                        };
                    }
                    return result;
                }
                function CreateDecryptionSplitWithKeyLookup(payloadSplit) {
                    const result = {};
                    if (payloadSplit.rootKeyEncryption) {
                        result.usesRootKeyWithKeyLookup = {
                            items: payloadSplit.rootKeyEncryption
                        };
                    }
                    if (payloadSplit.keySystemRootKeyEncryption) {
                        result.usesKeySystemRootKeyWithKeyLookup = {
                            items: payloadSplit.keySystemRootKeyEncryption
                        };
                    }
                    if (payloadSplit.itemsKeyEncryption) {
                        result.usesItemsKeyWithKeyLookup = {
                            items: payloadSplit.itemsKeyEncryption
                        };
                    }
                    return result;
                }
                function FindPayloadInEncryptionSplit(uuid, split) {
                    var _a, _b, _c, _d, _e, _f;
                    const inUsesItemsKey = (_a = split.usesItemsKey) === null || _a === void 0 ? void 0 : _a.items.find(item => item.uuid === uuid);
                    if (inUsesItemsKey) {
                        return inUsesItemsKey;
                    }
                    const inUsesRootKey = (_b = split.usesRootKey) === null || _b === void 0 ? void 0 : _b.items.find(item => item.uuid === uuid);
                    if (inUsesRootKey) {
                        return inUsesRootKey;
                    }
                    const inUsesKeySystemRootKey = (_c = split.usesKeySystemRootKey) === null || _c === void 0 ? void 0 : _c.items.find(item => item.uuid === uuid);
                    if (inUsesKeySystemRootKey) {
                        return inUsesKeySystemRootKey;
                    }
                    const inUsesItemsKeyWithKeyLookup = (_d = split.usesItemsKeyWithKeyLookup) === null || _d === void 0 ? void 0 : _d.items.find(item => item.uuid === uuid);
                    if (inUsesItemsKeyWithKeyLookup) {
                        return inUsesItemsKeyWithKeyLookup;
                    }
                    const inUsesRootKeyWithKeyLookup = (_e = split.usesRootKeyWithKeyLookup) === null || _e === void 0 ? void 0 : _e.items.find(item => item.uuid === uuid);
                    if (inUsesRootKeyWithKeyLookup) {
                        return inUsesRootKeyWithKeyLookup;
                    }
                    const inUsesKeySystemRootKeyWithKeyLookup = (_f = split.usesKeySystemRootKeyWithKeyLookup) === null || _f === void 0 ? void 0 : _f.items.find(item => item.uuid === uuid);
                    if (inUsesKeySystemRootKeyWithKeyLookup) {
                        return inUsesKeySystemRootKeyWithKeyLookup;
                    }
                    throw Error('Cannot find payload in encryption split');
                }
                function FindPayloadInDecryptionSplit(uuid, split) {
                    var _a, _b, _c, _d, _e, _f;
                    const inUsesItemsKey = (_a = split.usesItemsKey) === null || _a === void 0 ? void 0 : _a.items.find(item => item.uuid === uuid);
                    if (inUsesItemsKey) {
                        return inUsesItemsKey;
                    }
                    const inUsesRootKey = (_b = split.usesRootKey) === null || _b === void 0 ? void 0 : _b.items.find(item => item.uuid === uuid);
                    if (inUsesRootKey) {
                        return inUsesRootKey;
                    }
                    const inUsesKeySystemRootKey = (_c = split.usesKeySystemRootKey) === null || _c === void 0 ? void 0 : _c.items.find(item => item.uuid === uuid);
                    if (inUsesKeySystemRootKey) {
                        return inUsesKeySystemRootKey;
                    }
                    const inUsesItemsKeyWithKeyLookup = (_d = split.usesItemsKeyWithKeyLookup) === null || _d === void 0 ? void 0 : _d.items.find(item => item.uuid === uuid);
                    if (inUsesItemsKeyWithKeyLookup) {
                        return inUsesItemsKeyWithKeyLookup;
                    }
                    const inUsesRootKeyWithKeyLookup = (_e = split.usesRootKeyWithKeyLookup) === null || _e === void 0 ? void 0 : _e.items.find(item => item.uuid === uuid);
                    if (inUsesRootKeyWithKeyLookup) {
                        return inUsesRootKeyWithKeyLookup;
                    }
                    const inUsesKeySystemRootKeyWithKeyLookup = (_f = split.usesKeySystemRootKeyWithKeyLookup) === null || _f === void 0 ? void 0 : _f.items.find(item => item.uuid === uuid);
                    if (inUsesKeySystemRootKeyWithKeyLookup) {
                        return inUsesKeySystemRootKeyWithKeyLookup;
                    }
                    throw Error('Cannot find payload in encryption split');
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Split/Functions.ts
                function SplitPayloadsByEncryptionType(payloads) {
                    const usesRootKey = [];
                    const usesItemsKey = [];
                    const usesKeySystemRootKey = [];
                    for (const item of payloads) {
                        if ((0, models_dist.ContentTypeUsesRootKeyEncryption)(item.content_type)) {
                            usesRootKey.push(item);
                        }
                        else if ((0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(item.content_type)) {
                            usesKeySystemRootKey.push(item);
                        }
                        else {
                            usesItemsKey.push(item);
                        }
                    }
                    return {
                        rootKeyEncryption: usesRootKey.length > 0 ? usesRootKey : undefined,
                        itemsKeyEncryption: usesItemsKey.length > 0 ? usesItemsKey : undefined,
                        keySystemRootKeyEncryption: usesKeySystemRootKey.length > 0 ? usesKeySystemRootKey : undefined
                    };
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/StandardException.ts
                class StandardException {
                    constructor(message) {
                        let log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        this.message = message;
                        if (log) {
                            console.error('StandardException raised: ', message);
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/Username/PrivateUsername.ts
                var PrivateUsername_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const PrivateUserNameV1 = 'StandardNotes-PrivateUsername-V1';
                function ComputePrivateUsername(crypto, usernameInput) {
                    return PrivateUsername_awaiter(this, void 0, void 0, function* () {
                        const result = yield crypto.hmac256(yield crypto.sha256(PrivateUserNameV1), yield crypto.sha256(usernameInput.trim().toLowerCase()));
                        if (result == undefined) {
                            return undefined;
                        }
                        return result;
                    });
                }
                ; // CONCATENATED MODULE: ../encryption/src/Domain/index.ts
                ; // CONCATENATED MODULE: ../encryption/src/index.ts
                /***/ 
            }),
            /***/ 46981: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentAction = void 0;
                var ComponentAction;
                (function (ComponentAction) {
                    ComponentAction["SetSize"] = "set-size";
                    ComponentAction["StreamItems"] = "stream-items";
                    ComponentAction["StreamContextItem"] = "stream-context-item";
                    ComponentAction["SaveItems"] = "save-items";
                    ComponentAction["CreateItem"] = "create-item";
                    ComponentAction["CreateItems"] = "create-items";
                    ComponentAction["DeleteItems"] = "delete-items";
                    ComponentAction["SetComponentData"] = "set-component-data";
                    ComponentAction["RequestPermissions"] = "request-permissions";
                    ComponentAction["DuplicateItem"] = "duplicate-item";
                    ComponentAction["ComponentRegistered"] = "component-registered";
                    ComponentAction["ActivateThemes"] = "themes";
                    ComponentAction["Reply"] = "reply";
                    ComponentAction["ThemesActivated"] = "themes-activated";
                    ComponentAction["KeyDown"] = "key-down";
                    ComponentAction["KeyUp"] = "key-up";
                    ComponentAction["Click"] = "click";
                })(ComponentAction || (exports.ComponentAction = ComponentAction = {}));
                /***/ 
            }),
            /***/ 40611: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentArea = void 0;
                var ComponentArea;
                (function (ComponentArea) {
                    ComponentArea["Editor"] = "editor-editor";
                    ComponentArea["Themes"] = "themes";
                    ComponentArea["EditorStack"] = "editor-stack";
                })(ComponentArea || (exports.ComponentArea = ComponentArea = {}));
                /***/ 
            }),
            /***/ 92898: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentFlag = void 0;
                var ComponentFlag;
                (function (ComponentFlag) {
                    ComponentFlag["New"] = "New";
                    ComponentFlag["Deprecated"] = "Deprecated";
                })(ComponentFlag || (exports.ComponentFlag = ComponentFlag = {}));
                /***/ 
            }),
            /***/ 45556: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 6812: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.noteTypeForEditorIdentifier = exports.NoteType = void 0;
                const Features_1 = __webpack_require__(36178);
                var NoteType;
                (function (NoteType) {
                    NoteType["Authentication"] = "authentication";
                    NoteType["Code"] = "code";
                    NoteType["Markdown"] = "markdown";
                    NoteType["RichText"] = "rich-text";
                    NoteType["Spreadsheet"] = "spreadsheet";
                    NoteType["Task"] = "task";
                    NoteType["Plain"] = "plain-text";
                    NoteType["Super"] = "super";
                    NoteType["Unknown"] = "unknown";
                })(NoteType || (exports.NoteType = NoteType = {}));
                function noteTypeForEditorIdentifier(identifier) {
                    const feature = (0, Features_1.FindNativeFeature)(identifier);
                    if (feature && feature.note_type) {
                        return feature.note_type;
                    }
                    return NoteType.Unknown;
                }
                exports.noteTypeForEditorIdentifier = noteTypeForEditorIdentifier;
                /***/ 
            }),
            /***/ 75482: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 7675: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 92164: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 15077: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 45661: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43834: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 36178: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.GetDeprecatedEditors = exports.GetDarkThemeFeature = exports.GetNativeThemes = exports.GetPlainNoteFeature = exports.GetSuperNoteFeature = exports.GetIframeEditors = exports.GetIframeAndNativeEditors = exports.FindNativeTheme = exports.FindNativeFeature = exports.GetFeatures = void 0;
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const ServerFeatures_1 = __webpack_require__(4891);
                const ClientFeatures_1 = __webpack_require__(9711);
                const DeprecatedFeatures_1 = __webpack_require__(10379);
                const ExperimentalFeatures_1 = __webpack_require__(85771);
                const IframeEditors_1 = __webpack_require__(2258);
                const Themes_1 = __webpack_require__(88280);
                const NativeEditors_1 = __webpack_require__(88277);
                const ComponentArea_1 = __webpack_require__(40611);
                function GetFeatures() {
                    return [...(0, ServerFeatures_1.serverFeatures)(), ...(0, ClientFeatures_1.clientFeatures)(), ...(0, Themes_1.themes)(), ...(0, NativeEditors_1.nativeEditors)(), ...(0, IframeEditors_1.IframeEditors)(), ...(0, ExperimentalFeatures_1.experimentalFeatures)(), ...(0, DeprecatedFeatures_1.GetDeprecatedFeatures)()];
                }
                exports.GetFeatures = GetFeatures;
                function FindNativeFeature(identifier) {
                    return GetFeatures().find(f => f.identifier === identifier);
                }
                exports.FindNativeFeature = FindNativeFeature;
                function FindNativeTheme(identifier) {
                    return (0, Themes_1.themes)().find(t => t.identifier === identifier);
                }
                exports.FindNativeTheme = FindNativeTheme;
                function GetIframeAndNativeEditors() {
                    return [...(0, IframeEditors_1.IframeEditors)(), ...(0, NativeEditors_1.nativeEditors)()];
                }
                exports.GetIframeAndNativeEditors = GetIframeAndNativeEditors;
                function GetIframeEditors() {
                    return (0, IframeEditors_1.IframeEditors)();
                }
                exports.GetIframeEditors = GetIframeEditors;
                function GetSuperNoteFeature() {
                    return FindNativeFeature(NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SuperEditor);
                }
                exports.GetSuperNoteFeature = GetSuperNoteFeature;
                function GetPlainNoteFeature() {
                    return FindNativeFeature(NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.PlainEditor);
                }
                exports.GetPlainNoteFeature = GetPlainNoteFeature;
                function GetNativeThemes() {
                    return (0, Themes_1.themes)();
                }
                exports.GetNativeThemes = GetNativeThemes;
                function GetDarkThemeFeature() {
                    return (0, Themes_1.themes)().find(t => t.identifier === NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DarkTheme);
                }
                exports.GetDarkThemeFeature = GetDarkThemeFeature;
                function GetDeprecatedEditors() {
                    return (0, DeprecatedFeatures_1.GetDeprecatedFeatures)().filter(f => f.area === ComponentArea_1.ComponentArea.Editor);
                }
                exports.GetDeprecatedEditors = GetDeprecatedEditors;
                /***/ 
            }),
            /***/ 49774: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 84135: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ExperimentalFeatures = exports.NativeFeatureIdentifier = void 0;
                const domain_core_1 = __webpack_require__(82648);
                class NativeFeatureIdentifier extends domain_core_1.ValueObject {
                    get value() {
                        return this.props.value;
                    }
                    constructor(props) {
                        super(props);
                    }
                    static create(type) {
                        const isValidType = Object.values(this.TYPES).includes(type);
                        if (!isValidType) {
                            return domain_core_1.Result.fail("Invalid feature identifier: ".concat(type));
                        }
                        else {
                            return domain_core_1.Result.ok(new NativeFeatureIdentifier({
                                value: type
                            }));
                        }
                    }
                }
                exports.NativeFeatureIdentifier = NativeFeatureIdentifier;
                NativeFeatureIdentifier.TYPES = {
                    DailyEmailBackup: 'org.standardnotes.daily-email-backup',
                    Files: 'org.standardnotes.files',
                    FilesLowStorageTier: 'org.standardnotes.files-low-storage-tier',
                    FilesMaximumStorageTier: 'org.standardnotes.files-max-storage-tier',
                    ListedCustomDomain: 'org.standardnotes.listed-custom-domain',
                    NoteHistory30Days: 'org.standardnotes.note-history-30',
                    NoteHistory365Days: 'org.standardnotes.note-history-365',
                    NoteHistoryUnlimited: 'org.standardnotes.note-history-unlimited',
                    SignInAlerts: 'com.standardnotes.sign-in-alerts',
                    SmartFilters: 'org.standardnotes.smart-filters',
                    TagNesting: 'org.standardnotes.tag-nesting',
                    TwoFactorAuth: 'org.standardnotes.two-factor-auth',
                    UniversalSecondFactor: 'org.standardnotes.universal-second-factor',
                    SubscriptionSharing: 'org.standardnotes.subscription-sharing',
                    AutobiographyTheme: 'org.standardnotes.theme-autobiography',
                    DynamicTheme: 'org.standardnotes.theme-dynamic',
                    DarkTheme: 'org.standardnotes.theme-focus',
                    FuturaTheme: 'org.standardnotes.theme-futura',
                    MidnightTheme: 'org.standardnotes.theme-midnight',
                    SolarizedDarkTheme: 'org.standardnotes.theme-solarized-dark',
                    TitaniumTheme: 'org.standardnotes.theme-titanium',
                    ProtonTheme: 'com.standardnotes.theme-proton',
                    PlainEditor: 'com.standardnotes.plain-text',
                    SuperEditor: 'com.standardnotes.super-editor',
                    SheetsEditor: 'org.standardnotes.standard-sheets',
                    TokenVaultEditor: 'org.standardnotes.token-vault',
                    Clipper: 'org.standardnotes.clipper',
                    Vaults: 'org.standardnotes.vaults',
                    SharedVaults: 'org.standardnotes.shared-vaults',
                    DeprecatedCodeEditor: 'org.standardnotes.code-editor',
                    DeprecatedMarkdownProEditor: 'org.standardnotes.advanced-markdown-editor',
                    DeprecatedPlusEditor: 'org.standardnotes.plus-editor',
                    DeprecatedTaskEditor: 'org.standardnotes.simple-task-editor',
                    DeprecatedMarkdownVisualEditor: 'org.standardnotes.markdown-visual-editor',
                    DeprecatedBoldEditor: 'org.standardnotes.bold-editor',
                    DeprecatedMarkdownBasicEditor: 'org.standardnotes.simple-markdown-editor',
                    DeprecatedMarkdownMathEditor: 'org.standardnotes.fancy-markdown-editor',
                    DeprecatedMarkdownMinimistEditor: 'org.standardnotes.minimal-markdown-editor',
                    DeprecatedFoldersComponent: 'org.standardnotes.folders',
                    DeprecatedFileSafe: 'org.standardnotes.file-safe',
                    LegacyFileSafeIdentifier: 'org.standardnotes.legacy.file-safe'
                };
                /**
                 * Identifier for standalone filesafe instance offered as legacy installable via extensions-server
                 */
                exports.ExperimentalFeatures = [NativeFeatureIdentifier.TYPES.Vaults];
                /***/ 
            }),
            /***/ 39219: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 42116: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 95100: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 58635: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isEditorFeatureDescription = exports.isIframeComponentFeatureDescription = exports.isThemeFeatureDescription = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ComponentArea_1 = __webpack_require__(40611);
                function isThemeFeatureDescription(feature) {
                    return 'content_type' in feature && feature.content_type === domain_core_1.ContentType.TYPES.Theme;
                }
                exports.isThemeFeatureDescription = isThemeFeatureDescription;
                function isIframeComponentFeatureDescription(feature) {
                    return 'content_type' in feature && feature.content_type === domain_core_1.ContentType.TYPES.Component && [ComponentArea_1.ComponentArea.Editor, ComponentArea_1.ComponentArea.EditorStack].includes(feature.area);
                }
                exports.isIframeComponentFeatureDescription = isIframeComponentFeatureDescription;
                function isEditorFeatureDescription(feature) {
                    return feature.note_type != undefined || feature.area === ComponentArea_1.ComponentArea.Editor;
                }
                exports.isEditorFeatureDescription = isEditorFeatureDescription;
                /***/ 
            }),
            /***/ 53908: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 9711: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.clientFeatures = void 0;
                const PermissionName_1 = __webpack_require__(80);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const domain_core_1 = __webpack_require__(82648);
                function clientFeatures() {
                    return [{
                            name: 'Tag Nesting',
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TagNesting,
                            permission_name: PermissionName_1.PermissionName.TagNesting,
                            description: 'Organize your tags into folders.'
                        }, {
                            name: 'Smart Filters',
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SmartFilters,
                            permission_name: PermissionName_1.PermissionName.SmartFilters,
                            description: 'Create smart filters for viewing notes matching specific criteria.'
                        }, {
                            name: 'Encrypted files',
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Files,
                            permission_name: PermissionName_1.PermissionName.Files,
                            description: ''
                        }, {
                            name: 'Clipper',
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Clipper,
                            permission_name: PermissionName_1.PermissionName.Clipper,
                            description: ''
                        }];
                }
                exports.clientFeatures = clientFeatures;
                /***/ 
            }),
            /***/ 10379: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.GetDeprecatedFeatures = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const PermissionName_1 = __webpack_require__(80);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const NoteType_1 = __webpack_require__(6812);
                const FillEditorComponentDefaults_1 = __webpack_require__(38732);
                const ComponentAction_1 = __webpack_require__(46981);
                const ComponentArea_1 = __webpack_require__(40611);
                function GetDeprecatedFeatures() {
                    const code = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Code',
                        spellcheckControl: true,
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedCodeEditor,
                        permission_name: PermissionName_1.PermissionName.DeprecatedCodeEditor,
                        note_type: NoteType_1.NoteType.Code,
                        file_type: 'txt',
                        interchangeable: true,
                        deprecated: true,
                        index_path: 'index.html',
                        description: 'Syntax highlighting and convenient keyboard shortcuts for over 120 programming' + ' languages. Ideal for code snippets and procedures.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/code.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const plus = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Rich Text',
                        note_type: NoteType_1.NoteType.RichText,
                        file_type: 'html',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedPlusEditor,
                        permission_name: PermissionName_1.PermissionName.DeprecatedPlusEditor,
                        spellcheckControl: true,
                        deprecated: true,
                        description: 'From highlighting to custom font sizes and colors, to tables and lists, this editor is perfect for crafting any document.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/plus-editor.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const markdown = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Markdown',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedMarkdownProEditor,
                        note_type: NoteType_1.NoteType.Markdown,
                        file_type: 'md',
                        permission_name: PermissionName_1.PermissionName.DeprecatedMarkdownProEditor,
                        spellcheckControl: true,
                        deprecated: true,
                        description: 'A fully featured Markdown editor that supports live preview, a styling toolbar, and split pane support.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/adv-markdown.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const task = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Checklist',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedTaskEditor,
                        note_type: NoteType_1.NoteType.Task,
                        spellcheckControl: true,
                        file_type: 'md',
                        interchangeable: false,
                        deprecated: true,
                        permission_name: PermissionName_1.PermissionName.DeprecatedTaskEditor,
                        description: 'A great way to manage short-term and long-term to-do"s. You can mark tasks as completed, change their order, and edit the text naturally in place.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/task-editor.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const bold = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Alternative Rich Text',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedBoldEditor,
                        note_type: NoteType_1.NoteType.RichText,
                        file_type: 'html',
                        component_permissions: [{
                                name: ComponentAction_1.ComponentAction.StreamContextItem,
                                content_types: [domain_core_1.ContentType.TYPES.Note]
                            }, {
                                name: ComponentAction_1.ComponentAction.StreamItems,
                                content_types: [domain_core_1.ContentType.TYPES.FilesafeCredentials, domain_core_1.ContentType.TYPES.FilesafeFileMetadata, domain_core_1.ContentType.TYPES.FilesafeIntegration]
                            }],
                        spellcheckControl: true,
                        deprecated: true,
                        permission_name: PermissionName_1.PermissionName.BoldEditor,
                        description: 'A simple and peaceful rich editor that helps you write and think clearly.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/bold.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const markdownBasic = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Basic Markdown',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedMarkdownBasicEditor,
                        note_type: NoteType_1.NoteType.Markdown,
                        spellcheckControl: true,
                        file_type: 'md',
                        deprecated: true,
                        permission_name: PermissionName_1.PermissionName.MarkdownBasicEditor,
                        description: 'A Markdown editor with dynamic split-pane preview.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/simple-markdown.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const markdownAlt = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Markdown Alternative',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedMarkdownVisualEditor,
                        note_type: NoteType_1.NoteType.Markdown,
                        file_type: 'md',
                        deprecated: true,
                        permission_name: PermissionName_1.PermissionName.MarkdownVisualEditor,
                        spellcheckControl: true,
                        description: 'A WYSIWYG-style Markdown editor that renders Markdown in preview-mode while you type without displaying any syntax.',
                        index_path: 'build/index.html',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const markdownMinimist = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Minimal Markdown',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedMarkdownMinimistEditor,
                        note_type: NoteType_1.NoteType.Markdown,
                        file_type: 'md',
                        index_path: 'index.html',
                        permission_name: PermissionName_1.PermissionName.MarkdownMinimistEditor,
                        spellcheckControl: true,
                        deprecated: true,
                        description: 'A minimal Markdown editor with live rendering and in-text search via Ctrl/Cmd + F',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/min-markdown.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const markdownMath = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Markdown with Math',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedMarkdownMathEditor,
                        spellcheckControl: true,
                        permission_name: PermissionName_1.PermissionName.MarkdownMathEditor,
                        note_type: NoteType_1.NoteType.Markdown,
                        file_type: 'md',
                        deprecated: true,
                        index_path: 'index.html',
                        description: 'A beautiful split-pane Markdown editor with synced-scroll, LaTeX support, and colorful syntax.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/fancy-markdown.jpg',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const filesafe = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'FileSafe',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DeprecatedFileSafe,
                        component_permissions: [{
                                name: ComponentAction_1.ComponentAction.StreamContextItem,
                                content_types: [domain_core_1.ContentType.TYPES.Note]
                            }, {
                                name: ComponentAction_1.ComponentAction.StreamItems,
                                content_types: [domain_core_1.ContentType.TYPES.FilesafeCredentials, domain_core_1.ContentType.TYPES.FilesafeFileMetadata, domain_core_1.ContentType.TYPES.FilesafeIntegration]
                            }],
                        permission_name: PermissionName_1.PermissionName.ComponentFilesafe,
                        area: ComponentArea_1.ComponentArea.EditorStack,
                        deprecated: true,
                        description: 'Encrypted attachments for your notes using your Dropbox, Google Drive, or WebDAV server. Limited to 50MB per file.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/FileSafe-banner.png',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    return [code, plus, markdown, task, bold, markdownBasic, markdownMinimist, markdownMath, markdownAlt, filesafe];
                }
                exports.GetDeprecatedFeatures = GetDeprecatedFeatures;
                /***/ 
            }),
            /***/ 85771: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.experimentalFeatures = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const PermissionName_1 = __webpack_require__(80);
                function experimentalFeatures() {
                    return [{
                            name: 'Private vaults',
                            description: 'Private vaults allow you to store notes, files and tags into separate, encrypted vaults.',
                            availableInRoles: [domain_core_1.RoleName.NAMES.CoreUser, domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.Vaults,
                            permission_name: PermissionName_1.PermissionName.Vaults
                        }];
                }
                exports.experimentalFeatures = experimentalFeatures;
                /***/ 
            }),
            /***/ 2258: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.IframeEditors = void 0;
                const PermissionName_1 = __webpack_require__(80);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const NoteType_1 = __webpack_require__(6812);
                const FillEditorComponentDefaults_1 = __webpack_require__(38732);
                const domain_core_1 = __webpack_require__(82648);
                function IframeEditors() {
                    const tokenvault = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Authenticator',
                        note_type: NoteType_1.NoteType.Authentication,
                        file_type: 'json',
                        interchangeable: false,
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TokenVaultEditor,
                        permission_name: PermissionName_1.PermissionName.TokenVaultEditor,
                        description: 'Encrypt and protect your 2FA secrets for all your internet accounts. Authenticator handles your 2FA secrets so that you never lose them again, or have to start over when you get a new device.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/token-vault.png',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const spreadsheets = (0, FillEditorComponentDefaults_1.FillIframeEditorDefaults)({
                        name: 'Spreadsheet',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SheetsEditor,
                        note_type: NoteType_1.NoteType.Spreadsheet,
                        file_type: 'json',
                        interchangeable: false,
                        permission_name: PermissionName_1.PermissionName.SheetsEditor,
                        description: 'A powerful spreadsheet editor with formatting and formula support. Not recommended for large data sets, as encryption of such data may decrease editor performance.',
                        thumbnail_url: 'https://assets.standardnotes.com/screenshots/models/editors/spreadsheets.png',
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    return [tokenvault, spreadsheets];
                }
                exports.IframeEditors = IframeEditors;
                /***/ 
            }),
            /***/ 88277: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.nativeEditors = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const NoteType_1 = __webpack_require__(6812);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const PermissionName_1 = __webpack_require__(80);
                function nativeEditors() {
                    return [{
                            name: 'Super',
                            note_type: NoteType_1.NoteType.Super,
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SuperEditor,
                            spellcheckControl: true,
                            file_type: 'json',
                            interchangeable: false,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            permission_name: PermissionName_1.PermissionName.SuperEditor,
                            description: 'The best way to edit notes. Type / to bring up the block selection menu, or @ to embed images or link other tags and notes. Type - then space to start a list, or [] then space to start a checklist. Drag and drop an image or file to embed it in your note. Cmd/Ctrl + F to bring up search and replace.'
                        }, {
                            name: 'Plain Text',
                            note_type: NoteType_1.NoteType.Plain,
                            spellcheckControl: true,
                            file_type: 'txt',
                            interchangeable: true,
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.PlainEditor,
                            availableInRoles: [domain_core_1.RoleName.NAMES.CoreUser, domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                            permission_name: PermissionName_1.PermissionName.PlainEditor
                        }];
                }
                exports.nativeEditors = nativeEditors;
                /***/ 
            }),
            /***/ 4891: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.serverFeatures = void 0;
                const PermissionName_1 = __webpack_require__(80);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const domain_core_1 = __webpack_require__(82648);
                function serverFeatures() {
                    return [{
                            name: 'Two factor authentication',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TwoFactorAuth,
                            permission_name: PermissionName_1.PermissionName.TwoFactorAuth,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'U2F authentication',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.UniversalSecondFactor,
                            permission_name: PermissionName_1.PermissionName.UniversalSecondFactor,
                            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Unlimited note history',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.NoteHistoryUnlimited,
                            permission_name: PermissionName_1.PermissionName.NoteHistoryUnlimited,
                            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: '365 days note history',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.NoteHistory365Days,
                            permission_name: PermissionName_1.PermissionName.NoteHistory365Days,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser]
                        }, {
                            name: 'Email backups',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DailyEmailBackup,
                            permission_name: PermissionName_1.PermissionName.DailyEmailBackup,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Sign-in email alerts',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SignInAlerts,
                            permission_name: PermissionName_1.PermissionName.SignInAlerts,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Files maximum storage tier',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.FilesMaximumStorageTier,
                            permission_name: PermissionName_1.PermissionName.FilesMaximumStorageTier,
                            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Files low storage tier',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.FilesLowStorageTier,
                            permission_name: PermissionName_1.PermissionName.FilesLowStorageTier,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser]
                        }, {
                            name: 'Files medium storage tier',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SubscriptionSharing,
                            permission_name: PermissionName_1.PermissionName.SubscriptionSharing,
                            availableInRoles: [domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Listed Custom Domain',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.ListedCustomDomain,
                            permission_name: PermissionName_1.PermissionName.ListedCustomDomain,
                            availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                        }, {
                            name: 'Shared Vaults',
                            identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SharedVaults,
                            permission_name: PermissionName_1.PermissionName.SharedVaults,
                            availableInRoles: [domain_core_1.RoleName.NAMES.InternalTeamUser]
                        }];
                }
                exports.serverFeatures = serverFeatures;
                /***/ 
            }),
            /***/ 88280: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.themes = void 0;
                const PermissionName_1 = __webpack_require__(80);
                const NativeFeatureIdentifier_1 = __webpack_require__(84135);
                const FillThemeComponentDefaults_1 = __webpack_require__(82504);
                const domain_core_1 = __webpack_require__(82648);
                function themes() {
                    const midnight = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        name: 'Midnight',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.MidnightTheme,
                        permission_name: PermissionName_1.PermissionName.MidnightTheme,
                        isDark: true,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#086DD6',
                            foreground_color: '#ffffff',
                            border_color: '#086DD6'
                        },
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser]
                    });
                    const futura = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Futura',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.FuturaTheme,
                        permission_name: PermissionName_1.PermissionName.FuturaTheme,
                        isDark: true,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#fca429',
                            foreground_color: '#ffffff',
                            border_color: '#fca429'
                        }
                    });
                    const solarizedDark = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Solarized Dark',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.SolarizedDarkTheme,
                        permission_name: PermissionName_1.PermissionName.SolarizedDarkTheme,
                        isDark: true,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#2AA198',
                            foreground_color: '#ffffff',
                            border_color: '#2AA198'
                        }
                    });
                    const autobiography = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Autobiography',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.AutobiographyTheme,
                        permission_name: PermissionName_1.PermissionName.AutobiographyTheme,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#9D7441',
                            foreground_color: '#ECE4DB',
                            border_color: '#9D7441'
                        }
                    });
                    const dark = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.CoreUser, domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Dark',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DarkTheme,
                        permission_name: PermissionName_1.PermissionName.FocusedTheme,
                        clientControlled: true,
                        isDark: true,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#a464c2',
                            foreground_color: '#ffffff',
                            border_color: '#a464c2'
                        }
                    });
                    const titanium = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Titanium',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.TitaniumTheme,
                        permission_name: PermissionName_1.PermissionName.TitaniumTheme,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#6e2b9e',
                            foreground_color: '#ffffff',
                            border_color: '#6e2b9e'
                        }
                    });
                    const dynamic = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Dynamic Panels',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.DynamicTheme,
                        permission_name: PermissionName_1.PermissionName.ThemeDynamic,
                        layerable: true,
                        no_mobile: true
                    });
                    const proton = (0, FillThemeComponentDefaults_1.FillThemeComponentDefaults)({
                        availableInRoles: [domain_core_1.RoleName.NAMES.CoreUser, domain_core_1.RoleName.NAMES.PlusUser, domain_core_1.RoleName.NAMES.ProUser],
                        name: 'Carbon',
                        identifier: NativeFeatureIdentifier_1.NativeFeatureIdentifier.TYPES.ProtonTheme,
                        permission_name: PermissionName_1.PermissionName.ProtonTheme,
                        dock_icon: {
                            type: 'circle',
                            background_color: '#16141c',
                            foreground_color: '#ffffff',
                            border_color: '#4a4658'
                        }
                    });
                    return [midnight, futura, solarizedDark, autobiography, dark, proton, titanium, dynamic];
                }
                exports.themes = themes;
                /***/ 
            }),
            /***/ 38732: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FillIframeEditorDefaults = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ComponentAction_1 = __webpack_require__(46981);
                const ComponentArea_1 = __webpack_require__(40611);
                function FillIframeEditorDefaults(component) {
                    if (!component.index_path) {
                        component.index_path = 'dist/index.html';
                    }
                    if (!component.component_permissions) {
                        component.component_permissions = [{
                                name: ComponentAction_1.ComponentAction.StreamContextItem,
                                content_types: [domain_core_1.ContentType.TYPES.Note]
                            }];
                    }
                    component.content_type = domain_core_1.ContentType.TYPES.Component;
                    if (!component.area) {
                        component.area = ComponentArea_1.ComponentArea.Editor;
                    }
                    if (component.interchangeable == undefined) {
                        component.interchangeable = true;
                    }
                    return component;
                }
                exports.FillIframeEditorDefaults = FillIframeEditorDefaults;
                /***/ 
            }),
            /***/ 82504: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FillThemeComponentDefaults = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ComponentArea_1 = __webpack_require__(40611);
                function FillThemeComponentDefaults(theme) {
                    if (!theme.index_path) {
                        theme.index_path = 'index.css';
                    }
                    theme.content_type = domain_core_1.ContentType.TYPES.Theme;
                    if (!theme.area) {
                        theme.area = ComponentArea_1.ComponentArea.Themes;
                    }
                    return theme;
                }
                exports.FillThemeComponentDefaults = FillThemeComponentDefaults;
                /***/ 
            }),
            /***/ 93625: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PermissionName = void 0;
                var PermissionName;
                (function (PermissionName) {
                    PermissionName["AccountSwitcher"] = "app:account-switcher";
                    PermissionName["AutobiographyTheme"] = "theme:autobiography";
                    PermissionName["BoldEditor"] = "editor:bold";
                    PermissionName["DeprecatedCodeEditor"] = "editor:code-editor";
                    PermissionName["ComponentFilesafe"] = "component:filesafe";
                    PermissionName["ComponentFolders"] = "component:folders";
                    PermissionName["DailyEmailBackup"] = "server:daily-email-backup";
                    PermissionName["Files"] = "app:files";
                    PermissionName["FilesMaximumStorageTier"] = "server:files-max-storage-tier";
                    PermissionName["FilesLowStorageTier"] = "server:files-low-storage-tier";
                    PermissionName["FocusedTheme"] = "theme:focused";
                    PermissionName["FocusMode"] = "app:focus-mode";
                    PermissionName["FuturaTheme"] = "theme:futura";
                    PermissionName["ListedCustomDomain"] = "listed:custom-domain";
                    PermissionName["MarkdownBasicEditor"] = "editor:markdown-basic";
                    PermissionName["MarkdownMathEditor"] = "editor:markdown-math";
                    PermissionName["MarkdownMinimistEditor"] = "editor:markdown-minimist";
                    PermissionName["DeprecatedMarkdownProEditor"] = "editor:markdown-pro";
                    PermissionName["MarkdownVisualEditor"] = "editor:markdown-visual";
                    PermissionName["MidnightTheme"] = "theme:midnight";
                    PermissionName["NoteHistory30Days"] = "server:note-history-30-days";
                    PermissionName["NoteHistory365Days"] = "server:note-history-365-days";
                    PermissionName["NoteHistoryUnlimited"] = "server:note-history-unlimited";
                    PermissionName["PlainEditor"] = "editor:plain";
                    PermissionName["DeprecatedPlusEditor"] = "editor:plus";
                    PermissionName["SheetsEditor"] = "editor:sheets";
                    PermissionName["SignInAlerts"] = "server:sign-in-alerts";
                    PermissionName["SmartFilters"] = "app:smart-filters";
                    PermissionName["SolarizedDarkTheme"] = "theme:solarized-dark";
                    PermissionName["TagNesting"] = "app:tag-nesting";
                    PermissionName["DeprecatedTaskEditor"] = "editor:task-editor";
                    PermissionName["ThemeDynamic"] = "theme:dynamic";
                    PermissionName["TitaniumTheme"] = "theme:titanium";
                    PermissionName["TokenVaultEditor"] = "editor:token-vault";
                    PermissionName["TwoFactorAuth"] = "server:two-factor-auth";
                    PermissionName["UniversalSecondFactor"] = "server:universal-second-factor";
                    PermissionName["SubscriptionSharing"] = "server:subscription-sharing";
                    PermissionName["SuperEditor"] = "editor:super-editor";
                    PermissionName["Clipper"] = "app:clipper";
                    PermissionName["Vaults"] = "app:vaults";
                    PermissionName["SharedVaults"] = "server:shared-vaults";
                    PermissionName["ProtonTheme"] = "theme:proton";
                })(PermissionName || (exports.PermissionName = PermissionName = {}));
                /***/ 
            }),
            /***/ 34404: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(7675), exports);
                __exportStar(__webpack_require__(84135), exports);
                __exportStar(__webpack_require__(36178), exports);
                __exportStar(__webpack_require__(58635), exports);
                __exportStar(__webpack_require__(95100), exports);
                __exportStar(__webpack_require__(15077), exports);
                __exportStar(__webpack_require__(39219), exports);
                __exportStar(__webpack_require__(49774), exports);
                __exportStar(__webpack_require__(45661), exports);
                __exportStar(__webpack_require__(92164), exports);
                __exportStar(__webpack_require__(43834), exports);
                __exportStar(__webpack_require__(42116), exports);
                __exportStar(__webpack_require__(53908), exports);
                __exportStar(__webpack_require__(93625), exports);
                __exportStar(__webpack_require__(80), exports);
                __exportStar(__webpack_require__(46981), exports);
                __exportStar(__webpack_require__(40611), exports);
                __exportStar(__webpack_require__(92898), exports);
                __exportStar(__webpack_require__(45556), exports);
                __exportStar(__webpack_require__(6812), exports);
                __exportStar(__webpack_require__(75482), exports);
                /***/ 
            }),
            /***/ 80215: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(34404), exports);
                /***/ 
            }),
            /***/ 86311: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    M1: () => ( /* reexport */ByteChunker),
                    BI: () => ( /* reexport */DownloadAndDecryptFileOperation),
                    y4: () => ( /* reexport */EncryptAndUploadFileOperation),
                    yW: () => ( /* reexport */FileBackupsConstantsV1),
                    YT: () => ( /* reexport */FileDecryptor),
                    VA: () => ( /* reexport */FileDownloader),
                    IL: () => ( /* reexport */FileEncryptor),
                    F9: () => ( /* reexport */FileMemoryCache),
                    bA: () => ( /* reexport */FileUploader),
                    WE: () => ( /* reexport */OrderedByteChunker),
                    Qc: () => ( /* reexport */fileProgressToHumanReadableString),
                    mQ: () => ( /* reexport */readAndDecryptBackupFileUsingBackupService),
                    Qf: () => ( /* reexport */readAndDecryptBackupFileUsingFileSystemAPI)
                });
                // EXTERNAL MODULE: ../utils/dist/index.js
                var dist = __webpack_require__(87901);
                ; // CONCATENATED MODULE: ../files/src/Domain/Cache/FileMemoryCache.ts
                class FileMemoryCache {
                    constructor(maxSize) {
                        this.maxSize = maxSize;
                        this.cache = {};
                        this.orderedQueue = [];
                    }
                    add(uuid, data) {
                        if (data.encryptedBytes.length > this.maxSize) {
                            return false;
                        }
                        while (this.size + data.encryptedBytes.length > this.maxSize) {
                            this.remove(this.orderedQueue[0]);
                        }
                        this.cache[uuid] = data;
                        this.orderedQueue.push(uuid);
                        return true;
                    }
                    get size() {
                        return Object.values(this.cache).map(bytes => bytes.encryptedBytes.length).reduce((total, fileLength) => total + fileLength, 0);
                    }
                    get(uuid) {
                        return this.cache[uuid];
                    }
                    remove(uuid) {
                        delete this.cache[uuid];
                        (0, dist.removeFromArray)(this.orderedQueue, uuid);
                    }
                    clear() {
                        this.cache = {};
                        this.orderedQueue = [];
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Chunker/ByteChunker.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ByteChunker {
                    constructor(minimumChunkSize, onChunk) {
                        this.minimumChunkSize = minimumChunkSize;
                        this.onChunk = onChunk;
                        this.loggingEnabled = false;
                        this.bytes = new Uint8Array();
                        this.index = 1;
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    log() {
                        if (!this.loggingEnabled) {
                            return;
                        }
                        // eslint-disable-next-line no-console
                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }
                        console.log(args);
                    }
                    addBytes(bytes, isLast) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.bytes = new Uint8Array([...this.bytes, ...bytes]);
                            this.log("Chunker adding ".concat(bytes.length, ", total size ").concat(this.bytes.length));
                            if (this.bytes.length >= this.minimumChunkSize || isLast) {
                                yield this.popBytes(isLast);
                            }
                        });
                    }
                    popBytes(isLast) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const maxIndex = Math.max(this.minimumChunkSize, this.bytes.length);
                            const chunk = this.bytes.slice(0, maxIndex);
                            this.bytes = new Uint8Array([...this.bytes.slice(maxIndex)]);
                            this.log("Chunker popping ".concat(chunk.length, ", total size in queue ").concat(this.bytes.length));
                            yield this.onChunk({
                                data: chunk,
                                index: this.index++,
                                isLast
                            });
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Chunker/OrderedByteChunker.ts
                var OrderedByteChunker_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class OrderedByteChunker {
                    constructor(chunkSizes, source, onChunk) {
                        this.chunkSizes = chunkSizes;
                        this.source = source;
                        this.onChunk = onChunk;
                        this.bytes = new Uint8Array();
                        this.index = 1;
                        this.remainingChunks = [];
                        this.remainingChunks = chunkSizes.slice();
                        this.fileSize = chunkSizes.reduce((acc, size) => acc + size, 0);
                    }
                    get bytesPopped() {
                        return this.fileSize - this.bytesRemaining;
                    }
                    get bytesRemaining() {
                        return this.remainingChunks.reduce((acc, size) => acc + size, 0);
                    }
                    needsPop() {
                        return this.remainingChunks.length > 0 && this.bytes.length >= this.remainingChunks[0];
                    }
                    addBytes(bytes) {
                        return OrderedByteChunker_awaiter(this, void 0, void 0, function* () {
                            this.bytes = new Uint8Array([...this.bytes, ...bytes]);
                            if (this.needsPop()) {
                                yield this.popBytes();
                            }
                        });
                    }
                    popBytes() {
                        return OrderedByteChunker_awaiter(this, void 0, void 0, function* () {
                            const readUntil = this.remainingChunks[0];
                            const chunk = this.bytes.slice(0, readUntil);
                            this.bytes = new Uint8Array([...this.bytes.slice(readUntil)]);
                            this.remainingChunks.shift();
                            yield this.onChunk({
                                data: chunk,
                                index: this.index++,
                                isLast: this.index === this.chunkSizes.length - 1,
                                progress: {
                                    encryptedFileSize: this.fileSize,
                                    encryptedBytesDownloaded: this.bytesPopped,
                                    encryptedBytesRemaining: this.bytesRemaining,
                                    percentComplete: this.bytesPopped / this.fileSize * 100.0,
                                    source: this.source
                                }
                            });
                            if (this.needsPop()) {
                                yield this.popBytes();
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Device/FileBackupsConstantsV1.ts
                const FileBackupsConstantsV1 = {
                    Version: '1.0.0',
                    MetadataFileName: 'metadata.sn.json',
                    BinaryFileName: 'file.encrypted'
                };
                // EXTERNAL MODULE: ../responses/dist/index.js
                var responses_dist = __webpack_require__(95658);
                ; // CONCATENATED MODULE: ../files/src/Domain/UseCase/FileDownloader.ts
                var FileDownloader_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class FileDownloader {
                    constructor(file, api, valetToken) {
                        this.file = file;
                        this.api = api;
                        this.valetToken = valetToken;
                        this.aborted = false;
                        this.abortDeferred = (0, dist.Deferred)();
                        this.totalBytesDownloaded = 0;
                    }
                    getProgress() {
                        const encryptedSize = this.file.encryptedChunkSizes.reduce((total, chunk) => total + chunk, 0);
                        return {
                            encryptedFileSize: encryptedSize,
                            encryptedBytesDownloaded: this.totalBytesDownloaded,
                            encryptedBytesRemaining: encryptedSize - this.totalBytesDownloaded,
                            percentComplete: this.totalBytesDownloaded / encryptedSize * 100.0,
                            source: 'network'
                        };
                    }
                    run(onEncryptedBytes) {
                        return FileDownloader_awaiter(this, void 0, void 0, function* () {
                            return this.performDownload(onEncryptedBytes);
                        });
                    }
                    performDownload(onEncryptedBytes) {
                        return FileDownloader_awaiter(this, void 0, void 0, function* () {
                            const chunkIndex = 0;
                            const startRange = 0;
                            const onRemoteBytesReceived = bytes => FileDownloader_awaiter(this, void 0, void 0, function* () {
                                if (this.aborted) {
                                    return;
                                }
                                this.totalBytesDownloaded += bytes.byteLength;
                                yield onEncryptedBytes(bytes, this.getProgress(), this.abort);
                            });
                            const downloadPromise = this.api.downloadFile({
                                file: this.file,
                                chunkIndex,
                                valetToken: this.valetToken,
                                contentRangeStart: startRange,
                                onBytesReceived: onRemoteBytesReceived,
                                ownershipType: this.file.shared_vault_uuid ? 'shared-vault' : 'user'
                            });
                            const result = yield Promise.race([this.abortDeferred.promise, downloadPromise]);
                            return result;
                        });
                    }
                    abort() {
                        this.aborted = true;
                        this.abortDeferred.resolve('aborted');
                    }
                }
                // EXTERNAL MODULE: ../sncrypto-common/dist/index.js
                var sncrypto_common_dist = __webpack_require__(98418);
                ; // CONCATENATED MODULE: ../files/src/Domain/UseCase/FileDecryptor.ts
                class FileDecryptor {
                    constructor(file, crypto) {
                        this.file = file;
                        this.crypto = crypto;
                        this.decryptor = this.crypto.xchacha20StreamInitDecryptor(this.file.encryptionHeader, this.file.key);
                    }
                    decryptBytes(encryptedBytes) {
                        const result = this.crypto.xchacha20StreamDecryptorPush(this.decryptor, encryptedBytes, this.file.remoteIdentifier);
                        if (result === false) {
                            return undefined;
                        }
                        const isFinal = result.tag === sncrypto_common_dist.SodiumTag.CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_FINAL;
                        return {
                            decryptedBytes: result.message,
                            isFinalChunk: isFinal
                        };
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Operations/DownloadAndDecrypt.ts
                var DownloadAndDecrypt_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DownloadAndDecryptFileOperation {
                    constructor(file, crypto, api, valetToken) {
                        this.file = file;
                        this.crypto = crypto;
                        this.api = api;
                        this.downloader = new FileDownloader(this.file, this.api, valetToken);
                    }
                    createDecryptor() {
                        return new FileDecryptor(this.file, this.crypto);
                    }
                    run(onBytes) {
                        return DownloadAndDecrypt_awaiter(this, void 0, void 0, function* () {
                            const decryptor = this.createDecryptor();
                            let decryptError;
                            const onDownloadBytes = (encryptedBytes, progress, abortDownload) => DownloadAndDecrypt_awaiter(this, void 0, void 0, function* () {
                                const result = decryptor.decryptBytes(encryptedBytes);
                                if (!result || result.decryptedBytes.length === 0) {
                                    decryptError = new responses_dist.ClientDisplayableError('Failed to decrypt chunk');
                                    abortDownload();
                                    return;
                                }
                                const decryptedBytes = result.decryptedBytes;
                                yield onBytes({
                                    decrypted: {
                                        decryptedBytes
                                    },
                                    encrypted: {
                                        encryptedBytes
                                    },
                                    progress
                                });
                            });
                            const downloadResult = yield this.downloader.run(onDownloadBytes);
                            return {
                                success: downloadResult instanceof responses_dist.ClientDisplayableError ? false : true,
                                error: downloadResult === 'aborted' ? undefined : downloadResult || decryptError,
                                aborted: downloadResult === 'aborted'
                            };
                        });
                    }
                    abort() {
                        this.downloader.abort();
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/UseCase/FileUploader.ts
                var FileUploader_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class FileUploader {
                    constructor(apiService) {
                        this.apiService = apiService;
                    }
                    uploadBytes(encryptedBytes, ownershipType, chunkId, apiToken) {
                        return FileUploader_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.apiService.uploadFileBytes(apiToken, ownershipType, chunkId, encryptedBytes);
                            return result;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/UseCase/FileEncryptor.ts
                class FileEncryptor {
                    constructor(file, crypto) {
                        this.file = file;
                        this.crypto = crypto;
                    }
                    initializeHeader() {
                        this.stream = this.crypto.xchacha20StreamInitEncryptor(this.file.key);
                        return this.stream.header;
                    }
                    pushBytes(decryptedBytes, isFinalChunk) {
                        if (!this.stream) {
                            throw new Error('FileEncryptor must call initializeHeader first');
                        }
                        const tag = isFinalChunk ? sncrypto_common_dist.SodiumTag.CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_FINAL : undefined;
                        const encryptedBytes = this.crypto.xchacha20StreamEncryptorPush(this.stream, decryptedBytes, this.file.remoteIdentifier, tag);
                        return encryptedBytes;
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Operations/EncryptAndUpload.ts
                var EncryptAndUpload_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class EncryptAndUploadFileOperation {
                    constructor(file, valetToken, crypto, api, vault) {
                        this.file = file;
                        this.valetToken = valetToken;
                        this.crypto = crypto;
                        this.api = api;
                        this.vault = vault;
                        this.encryptedChunkSizes = [];
                        this.totalBytesPushedInDecryptedTerms = 0;
                        this.totalBytesUploadedInDecryptedTerms = 0;
                        this.encryptor = new FileEncryptor(file, this.crypto);
                        this.uploader = new FileUploader(this.api);
                        this.encryptionHeader = this.encryptor.initializeHeader();
                    }
                    getValetToken() {
                        return this.valetToken;
                    }
                    getProgress() {
                        const reportedDecryptedSize = this.file.decryptedSize;
                        return {
                            decryptedFileSize: reportedDecryptedSize,
                            decryptedBytesUploaded: this.totalBytesUploadedInDecryptedTerms,
                            decryptedBytesRemaining: reportedDecryptedSize - this.totalBytesUploadedInDecryptedTerms,
                            percentComplete: this.totalBytesUploadedInDecryptedTerms / reportedDecryptedSize * 100.0
                        };
                    }
                    getResult() {
                        return {
                            encryptionHeader: this.encryptionHeader,
                            finalDecryptedSize: this.totalBytesPushedInDecryptedTerms,
                            key: this.file.key,
                            remoteIdentifier: this.file.remoteIdentifier
                        };
                    }
                    pushBytes(decryptedBytes, chunkId, isFinalChunk) {
                        return EncryptAndUpload_awaiter(this, void 0, void 0, function* () {
                            this.totalBytesPushedInDecryptedTerms += decryptedBytes.byteLength;
                            const encryptedBytes = this.encryptBytes(decryptedBytes, isFinalChunk);
                            this.encryptedChunkSizes.push(encryptedBytes.length);
                            const uploadSuccess = yield this.uploadBytes(encryptedBytes, chunkId);
                            if (uploadSuccess) {
                                this.totalBytesUploadedInDecryptedTerms += decryptedBytes.byteLength;
                            }
                            return uploadSuccess;
                        });
                    }
                    encryptBytes(decryptedBytes, isFinalChunk) {
                        const encryptedBytes = this.encryptor.pushBytes(decryptedBytes, isFinalChunk);
                        return encryptedBytes;
                    }
                    uploadBytes(encryptedBytes, chunkId) {
                        return EncryptAndUpload_awaiter(this, void 0, void 0, function* () {
                            const success = yield this.uploader.uploadBytes(encryptedBytes, this.vault && this.vault.sharing ? 'shared-vault' : 'user', chunkId, this.valetToken);
                            return success;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Service/ReadAndDecryptBackupFileFileSystemAPI.ts
                var ReadAndDecryptBackupFileFileSystemAPI_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function readAndDecryptBackupFileUsingFileSystemAPI(fileHandle, file, fileSystem, crypto, onDecryptedBytes) {
                    return ReadAndDecryptBackupFileFileSystemAPI_awaiter(this, void 0, void 0, function* () {
                        const decryptor = new FileDecryptor(file, crypto);
                        const byteChunker = new OrderedByteChunker(file.encryptedChunkSizes, 'local', chunk => ReadAndDecryptBackupFileFileSystemAPI_awaiter(this, void 0, void 0, function* () {
                            const decryptResult = decryptor.decryptBytes(chunk.data);
                            if (!decryptResult) {
                                return;
                            }
                            yield onDecryptedBytes(decryptResult.decryptedBytes);
                        }));
                        const readResult = yield fileSystem.readFile(fileHandle, encryptedBytes => ReadAndDecryptBackupFileFileSystemAPI_awaiter(this, void 0, void 0, function* () {
                            yield byteChunker.addBytes(encryptedBytes);
                        }));
                        return readResult;
                    });
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Logging.ts
                const isDev = false || "production" === 'test';
                var LoggingDomain;
                (function (LoggingDomain) {
                    LoggingDomain[LoggingDomain["FilesPackage"] = 0] = "FilesPackage";
                })(LoggingDomain || (LoggingDomain = {}));
                const LoggingStatus = {
                    [LoggingDomain.FilesPackage]: false
                };
                const DomainColor = {
                    [LoggingDomain.FilesPackage]: 'green'
                };
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function log(domain) {
                    if (!isDev || !LoggingStatus[domain]) {
                        return;
                    }
                    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }
                    (0, dist.logWithColor)(LoggingDomain[domain], DomainColor[domain], ...args);
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Service/ReadAndDecryptBackupFileUsingBackupService.ts
                var ReadAndDecryptBackupFileUsingBackupService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function readAndDecryptBackupFileUsingBackupService(file, backupService, crypto, onDecryptedBytes) {
                    return ReadAndDecryptBackupFileUsingBackupService_awaiter(this, void 0, void 0, function* () {
                        log(LoggingDomain.FilesPackage, 'Reading and decrypting backup file', file.uuid, 'chunk sizes', file.encryptedChunkSizes);
                        const decryptor = new FileDecryptor(file, crypto);
                        const byteChunker = new OrderedByteChunker(file.encryptedChunkSizes, 'local', chunk => ReadAndDecryptBackupFileUsingBackupService_awaiter(this, void 0, void 0, function* () {
                            log(LoggingDomain.FilesPackage, 'OrderedByteChunker did pop bytes', chunk.data.length, chunk.progress);
                            const decryptResult = decryptor.decryptBytes(chunk.data);
                            if (!decryptResult) {
                                return;
                            }
                            yield onDecryptedBytes(Object.assign(Object.assign({}, chunk), {
                                data: decryptResult.decryptedBytes
                            }));
                        }));
                        const readResult = yield backupService.readEncryptedFileFromBackup(file.uuid, chunk => ReadAndDecryptBackupFileUsingBackupService_awaiter(this, void 0, void 0, function* () {
                            log(LoggingDomain.FilesPackage, 'Got file chunk from backup service', chunk.data.length, chunk.progress);
                            yield byteChunker.addBytes(chunk.data);
                        }));
                        log(LoggingDomain.FilesPackage, 'Finished reading and decrypting backup file', file.uuid);
                        return readResult;
                    });
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/Types/FileDownloadProgress.ts
                function fileProgressToHumanReadableString(progress, fileName, options) {
                    const progressPercent = Math.floor(progress.percentComplete);
                    const sourceString = progress.source === 'network' ? '' : progress.source === 'memcache' ? 'from cache' : 'from backup';
                    let result = "Downloading file ".concat(sourceString, " \"").concat(fileName, "\"");
                    if (options.showPercent) {
                        result += " (".concat(progressPercent, "%)");
                    }
                    return result;
                }
                ; // CONCATENATED MODULE: ../files/src/Domain/index.ts
                ; // CONCATENATED MODULE: ../files/src/index.ts
                /***/ 
            }),
            /***/ 56974: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 15866: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 35376: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 76317: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentViewerEvent = void 0;
                var ComponentViewerEvent;
                (function (ComponentViewerEvent) {
                    ComponentViewerEvent["FeatureStatusUpdated"] = "FeatureStatusUpdated";
                })(ComponentViewerEvent || (exports.ComponentViewerEvent = ComponentViewerEvent = {}));
                /***/ 
            }),
            /***/ 88076: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68763: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeyboardModifier = void 0;
                var KeyboardModifier;
                (function (KeyboardModifier) {
                    KeyboardModifier["Shift"] = "Shift";
                    KeyboardModifier["Ctrl"] = "Control";
                    KeyboardModifier["Meta"] = "Meta";
                })(KeyboardModifier || (exports.KeyboardModifier = KeyboardModifier = {}));
                /***/ 
            }),
            /***/ 75895: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74601: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 3668: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 42405: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FillItemContentSpecialized = exports.FillItemContent = void 0;
                const DefaultAppDomain_1 = __webpack_require__(71458);
                const AppDataField_1 = __webpack_require__(68716);
                /**
                 * Modifies the input object to fill in any missing required values from the
                 * content body.
                 */
                function FillItemContent(content) {
                    if (!content.references) {
                        content.references = [];
                    }
                    if (!content.appData) {
                        content.appData = {
                            [DefaultAppDomain_1.DefaultAppDomain]: {}
                        };
                    }
                    if (!content.appData[DefaultAppDomain_1.DefaultAppDomain]) {
                        content.appData[DefaultAppDomain_1.DefaultAppDomain] = {};
                    }
                    if (!content.appData[DefaultAppDomain_1.DefaultAppDomain][AppDataField_1.AppDataField.UserModifiedDate]) {
                        content.appData[DefaultAppDomain_1.DefaultAppDomain][AppDataField_1.AppDataField.UserModifiedDate] = new Date().toString();
                    }
                    return content;
                }
                exports.FillItemContent = FillItemContent;
                function FillItemContentSpecialized(content) {
                    return FillItemContent(content);
                }
                exports.FillItemContentSpecialized = FillItemContentSpecialized;
                /***/ 
            }),
            /***/ 95698: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 55930: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 36186: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80537: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.createComponentCreatedContextPayload = void 0;
                function createComponentCreatedContextPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        uuid: fromPayload.uuid
                    };
                }
                exports.createComponentCreatedContextPayload = createComponentCreatedContextPayload;
                /***/ 
            }),
            /***/ 1482: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateComponentRetrievedContextPayload = void 0;
                function CreateComponentRetrievedContextPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        uuid: fromPayload.uuid
                    };
                }
                exports.CreateComponentRetrievedContextPayload = CreateComponentRetrievedContextPayload;
                /***/ 
            }),
            /***/ 69087: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 70359: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.checkRemotePayloadAllowed = exports.FilterDisallowedRemotePayloadsAndMap = void 0;
                const TransferPayload_1 = __webpack_require__(78381);
                function CreateFilteredServerItem(item) {
                    return Object.assign(Object.assign({}, item), {
                        __passed_filter__: true
                    });
                }
                function FilterDisallowedRemotePayloadsAndMap(payloads) {
                    const filtered = [];
                    const disallowed = [];
                    for (const payload of payloads) {
                        const result = checkRemotePayloadAllowed(payload);
                        if (result.allowed === undefined) {
                            disallowed.push(payload);
                        }
                        else {
                            filtered.push(CreateFilteredServerItem(result.allowed));
                        }
                    }
                    return {
                        filtered,
                        disallowed
                    };
                }
                exports.FilterDisallowedRemotePayloadsAndMap = FilterDisallowedRemotePayloadsAndMap;
                function checkRemotePayloadAllowed(payload) {
                    if ((0, TransferPayload_1.isCorruptTransferPayload)(payload)) {
                        return {
                            disallowed: payload
                        };
                    }
                    if ((0, TransferPayload_1.isEncryptedTransferPayload)(payload) || payload.content == undefined) {
                        return {
                            allowed: payload
                        };
                    }
                    else {
                        return {
                            disallowed: payload
                        };
                    }
                }
                exports.checkRemotePayloadAllowed = checkRemotePayloadAllowed;
                /***/ 
            }),
            /***/ 13214: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateDecryptedBackupFileContextPayload = exports.CreateEncryptedBackupFileContextPayload = void 0;
                function CreateEncryptedBackupFileContextPayload(fromPayload) {
                    return {
                        auth_hash: fromPayload.auth_hash,
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        duplicate_of: fromPayload.duplicate_of,
                        enc_item_key: fromPayload.enc_item_key,
                        items_key_id: fromPayload.items_key_id,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid
                    };
                }
                exports.CreateEncryptedBackupFileContextPayload = CreateEncryptedBackupFileContextPayload;
                function CreateDecryptedBackupFileContextPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid
                    };
                }
                exports.CreateDecryptedBackupFileContextPayload = CreateDecryptedBackupFileContextPayload;
                /***/ 
            }),
            /***/ 84034: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateDeletedLocalStorageContextPayload = exports.CreateDecryptedLocalStorageContextPayload = exports.CreateEncryptedLocalStorageContextPayload = exports.isEncryptedLocalStoragePayload = void 0;
                const utils_1 = __webpack_require__(87901);
                const TransferPayload_1 = __webpack_require__(78381);
                function isEncryptedLocalStoragePayload(p) {
                    return (0, TransferPayload_1.isEncryptedTransferPayload)(p);
                }
                exports.isEncryptedLocalStoragePayload = isEncryptedLocalStoragePayload;
                function CreateEncryptedLocalStorageContextPayload(fromPayload) {
                    return {
                        auth_hash: fromPayload.auth_hash,
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        dirty: fromPayload.dirty != undefined ? fromPayload.dirty : false,
                        duplicate_of: fromPayload.duplicate_of,
                        enc_item_key: fromPayload.enc_item_key,
                        errorDecrypting: fromPayload.errorDecrypting,
                        items_key_id: fromPayload.items_key_id,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        waitingForKey: fromPayload.waitingForKey,
                        user_uuid: fromPayload.user_uuid,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid,
                        last_edited_by_uuid: fromPayload.last_edited_by_uuid,
                        signatureData: fromPayload.signatureData
                    };
                }
                exports.CreateEncryptedLocalStorageContextPayload = CreateEncryptedLocalStorageContextPayload;
                function CreateDecryptedLocalStorageContextPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        content: fromPayload.content,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        dirty: (0, utils_1.useBoolean)(fromPayload.dirty, false),
                        user_uuid: fromPayload.user_uuid,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid,
                        last_edited_by_uuid: fromPayload.last_edited_by_uuid,
                        signatureData: fromPayload.signatureData
                    };
                }
                exports.CreateDecryptedLocalStorageContextPayload = CreateDecryptedLocalStorageContextPayload;
                function CreateDeletedLocalStorageContextPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        content: undefined,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: true,
                        dirty: true,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        user_uuid: fromPayload.user_uuid,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid,
                        last_edited_by_uuid: fromPayload.last_edited_by_uuid,
                        signatureData: fromPayload.signatureData
                    };
                }
                exports.CreateDeletedLocalStorageContextPayload = CreateDeletedLocalStorageContextPayload;
                /***/ 
            }),
            /***/ 51600: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateOfflineSyncPushContextPayload = void 0;
                const Payload_1 = __webpack_require__(59180);
                function CreateOfflineSyncPushContextPayload(fromPayload) {
                    const base = {
                        content: undefined,
                        content_type: fromPayload.content_type,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid
                    };
                    if ((0, Payload_1.isDecryptedPayload)(fromPayload)) {
                        return Object.assign(Object.assign({}, base), {
                            content: fromPayload.content
                        });
                    }
                    else {
                        return Object.assign(Object.assign({}, base), {
                            deleted: fromPayload.deleted
                        });
                    }
                }
                exports.CreateOfflineSyncPushContextPayload = CreateOfflineSyncPushContextPayload;
                /***/ 
            }),
            /***/ 30429: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateOfflineSyncSavedPayload = void 0;
                const Payload_1 = __webpack_require__(59180);
                function CreateOfflineSyncSavedPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        deleted: (0, Payload_1.isDeletedPayload)(fromPayload),
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid
                    };
                }
                exports.CreateOfflineSyncSavedPayload = CreateOfflineSyncSavedPayload;
                /***/ 
            }),
            /***/ 18592: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateDeletedServerSyncPushPayload = exports.CreateEncryptedServerSyncPushPayload = void 0;
                function CreateEncryptedServerSyncPushPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: false,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        content: fromPayload.content,
                        enc_item_key: fromPayload.enc_item_key,
                        items_key_id: fromPayload.items_key_id,
                        auth_hash: fromPayload.auth_hash,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid
                    };
                }
                exports.CreateEncryptedServerSyncPushPayload = CreateEncryptedServerSyncPushPayload;
                function CreateDeletedServerSyncPushPayload(fromPayload) {
                    return {
                        content_type: fromPayload.content_type,
                        created_at_timestamp: fromPayload.created_at_timestamp,
                        created_at: fromPayload.created_at,
                        deleted: true,
                        duplicate_of: fromPayload.duplicate_of,
                        updated_at_timestamp: fromPayload.updated_at_timestamp,
                        updated_at: fromPayload.updated_at,
                        uuid: fromPayload.uuid,
                        content: undefined,
                        key_system_identifier: fromPayload.key_system_identifier,
                        shared_vault_uuid: fromPayload.shared_vault_uuid
                    };
                }
                exports.CreateDeletedServerSyncPushPayload = CreateDeletedServerSyncPushPayload;
                /***/ 
            }),
            /***/ 2116: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateServerSyncSavedPayload = void 0;
                const utils_1 = __webpack_require__(87901);
                function CreateServerSyncSavedPayload(from) {
                    return {
                        content_type: from.content_type,
                        created_at_timestamp: from.created_at_timestamp,
                        created_at: from.created_at,
                        deleted: (0, utils_1.useBoolean)(from.deleted, false),
                        updated_at_timestamp: from.updated_at_timestamp,
                        updated_at: from.updated_at,
                        uuid: from.uuid,
                        key_system_identifier: from.key_system_identifier,
                        shared_vault_uuid: from.shared_vault_uuid,
                        user_uuid: from.user_uuid,
                        duplicate_of: from.duplicate_of,
                        last_edited_by_uuid: from.last_edited_by_uuid
                    };
                }
                exports.CreateServerSyncSavedPayload = CreateServerSyncSavedPayload;
                /***/ 
            }),
            /***/ 18973: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 7563: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43740: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DecryptedItem = void 0;
                const utils_1 = __webpack_require__(87901);
                const AppDataField_1 = __webpack_require__(68716);
                const DefaultAppDomain_1 = __webpack_require__(71458);
                const GenericItem_1 = __webpack_require__(97127);
                const ItemContentsEqual_1 = __webpack_require__(41035);
                class DecryptedItem extends GenericItem_1.GenericItem {
                    constructor(payload) {
                        super(payload);
                        this.protected = false;
                        this.trashed = false;
                        this.pinned = false;
                        this.archived = false;
                        this.locked = false;
                        this.starred = false;
                        const userModVal = this.getAppDomainValueWithDefault(AppDataField_1.AppDataField.UserModifiedDate, this.serverUpdatedAt || 0);
                        this.userModifiedDate = new Date(userModVal);
                        this.conflictOf = payload.content.conflict_of;
                        this.updatedAtString = (0, utils_1.dateToLocalizedString)(this.userModifiedDate);
                        this.protected = (0, utils_1.useBoolean)(this.payload.content.protected, false);
                        this.trashed = (0, utils_1.useBoolean)(this.payload.content.trashed, false);
                        this.starred = (0, utils_1.useBoolean)(this.payload.content.starred, false);
                        this.pinned = this.getAppDomainValueWithDefault(AppDataField_1.AppDataField.Pinned, false);
                        this.archived = this.getAppDomainValueWithDefault(AppDataField_1.AppDataField.Archived, false);
                        this.locked = this.getAppDomainValueWithDefault(AppDataField_1.AppDataField.Locked, false);
                    }
                    static DefaultAppDomain() {
                        return DefaultAppDomain_1.DefaultAppDomain;
                    }
                    get content() {
                        return this.payload.content;
                    }
                    get references() {
                        return this.payload.content.references || [];
                    }
                    isReferencingItem(item) {
                        return this.references.find(r => r.uuid === item.uuid) != undefined;
                    }
                    /**
                     * Inside of content is a record called `appData` (which should have been called `domainData`).
                     * It was named `appData` as a way to indicate that it can house data for multiple apps.
                     * Each key of appData is a domain string, which was originally designed
                     * to allow for multiple 3rd party apps who share access to the same data to store data
                     * in an isolated location. This design premise is antiquited and no longer pursued,
                     * however we continue to use it as not to uncesesarily create a large data migration
                     * that would require users to sync all their data.
                     *
                     * domainData[DomainKey] will give you another Record<string, any>.
                     *
                     * Currently appData['org.standardnotes.sn'] returns an object of type AppData.
                     * And appData['org.standardnotes.sn.components] returns an object of type ComponentData
                     */
                    getDomainData(domain) {
                        const domainData = this.payload.content.appData;
                        if (!domainData) {
                            return undefined;
                        }
                        const data = domainData[domain];
                        return data;
                    }
                    getAppDomainValue(key) {
                        const appData = this.getDomainData(DefaultAppDomain_1.DefaultAppDomain);
                        return appData === null || appData === void 0 ? void 0 : appData[key];
                    }
                    getAppDomainValueWithDefault(key, defaultValue) {
                        const appData = this.getDomainData(DefaultAppDomain_1.DefaultAppDomain);
                        return (appData === null || appData === void 0 ? void 0 : appData[key]) || defaultValue;
                    }
                    payloadRepresentation(override) {
                        return this.payload.copy(override);
                    }
                    /**
                     * During sync conflicts, when determing whether to create a duplicate for an item,
                     * we can omit keys that have no meaningful weight and can be ignored. For example,
                     * if one component has active = true and another component has active = false,
                     * it would be needless to duplicate them, so instead we ignore that value.
                     */
                    contentKeysToIgnoreWhenCheckingEquality() {
                        return ['conflict_of'];
                    }
                    /** Same as `contentKeysToIgnoreWhenCheckingEquality`, but keys inside appData[Item.AppDomain] */
                    appDataContentKeysToIgnoreWhenCheckingEquality() {
                        return [AppDataField_1.AppDataField.UserModifiedDate];
                    }
                    getContentCopy() {
                        return JSON.parse(JSON.stringify(this.content));
                    }
                    isItemContentEqualWith(otherItem) {
                        return (0, ItemContentsEqual_1.ItemContentsEqual)(this.payload.content, otherItem.payload.content, this.contentKeysToIgnoreWhenCheckingEquality(), this.appDataContentKeysToIgnoreWhenCheckingEquality());
                    }
                }
                exports.DecryptedItem = DecryptedItem;
                /***/ 
            }),
            /***/ 78438: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeletedItem = void 0;
                const GenericItem_1 = __webpack_require__(97127);
                class DeletedItem extends GenericItem_1.GenericItem {
                    constructor(payload) {
                        super(payload);
                        this.deleted = true;
                    }
                    payloadRepresentation(override) {
                        return this.payload.copy(override);
                    }
                }
                exports.DeletedItem = DeletedItem;
                /***/ 
            }),
            /***/ 80406: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EncryptedItem = void 0;
                const GenericItem_1 = __webpack_require__(97127);
                class EncryptedItem extends GenericItem_1.GenericItem {
                    constructor(payload) {
                        super(payload);
                    }
                    get version() {
                        return this.payload.version;
                    }
                    payloadRepresentation(override) {
                        return this.payload.copy(override);
                    }
                    get errorDecrypting() {
                        return this.payload.errorDecrypting;
                    }
                    get waitingForKey() {
                        return this.payload.waitingForKey;
                    }
                    get content() {
                        return this.payload.content;
                    }
                    get auth_hash() {
                        return this.payload.auth_hash;
                    }
                }
                exports.EncryptedItem = EncryptedItem;
                /***/ 
            }),
            /***/ 97127: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.GenericItem = void 0;
                const utils_1 = __webpack_require__(87901);
                const ItemContentsDiffer_1 = __webpack_require__(33545);
                const PayloadSource_1 = __webpack_require__(89223);
                const ConflictStrategy_1 = __webpack_require__(43610);
                const SingletonStrategy_1 = __webpack_require__(94515);
                const TypeCheck_1 = __webpack_require__(63418);
                class GenericItem {
                    constructor(payload) {
                        this.payload = payload;
                        this.duplicateOf = payload.duplicate_of;
                        this.createdAtString = this.created_at && (0, utils_1.dateToLocalizedString)(this.created_at);
                        this.userModifiedDate = this.serverUpdatedAt || new Date();
                        this.updatedAtString = (0, utils_1.dateToLocalizedString)(this.userModifiedDate);
                        const timeToAllowSubclassesToFinishConstruction = 0;
                        setTimeout(() => {
                            (0, utils_1.deepFreeze)(this);
                        }, timeToAllowSubclassesToFinishConstruction);
                    }
                    get uuid() {
                        return this.payload.uuid;
                    }
                    get content_type() {
                        return this.payload.content_type;
                    }
                    get created_at() {
                        return this.payload.created_at;
                    }
                    get key_system_identifier() {
                        return this.payload.key_system_identifier;
                    }
                    get user_uuid() {
                        return this.payload.user_uuid;
                    }
                    get shared_vault_uuid() {
                        return this.payload.shared_vault_uuid;
                    }
                    get last_edited_by_uuid() {
                        return this.payload.last_edited_by_uuid;
                    }
                    get signatureData() {
                        return this.payload.signatureData;
                    }
                    /**
                     * The date timestamp the server set for this item upon it being synced
                     * Undefined if never synced to a remote server.
                     */
                    get serverUpdatedAt() {
                        return this.payload.serverUpdatedAt;
                    }
                    get serverUpdatedAtTimestamp() {
                        return this.payload.updated_at_timestamp;
                    }
                    /** @deprecated Use serverUpdatedAt instead */
                    get updated_at() {
                        return this.serverUpdatedAt;
                    }
                    get dirty() {
                        return this.payload.dirty;
                    }
                    get lastSyncBegan() {
                        return this.payload.lastSyncBegan;
                    }
                    get lastSyncEnd() {
                        return this.payload.lastSyncEnd;
                    }
                    get duplicate_of() {
                        return this.payload.duplicate_of;
                    }
                    payloadRepresentation(override) {
                        return this.payload.copy(override);
                    }
                    /** Whether the item has never been synced to a server */
                    get neverSynced() {
                        return !this.serverUpdatedAt || this.serverUpdatedAt.getTime() === 0;
                    }
                    /**
                     * Subclasses can override this getter to return true if they want only
                     * one of this item to exist, depending on custom criteria.
                     */
                    get isSingleton() {
                        return false;
                    }
                    /** The predicate by which singleton items should be unique */
                    singletonPredicate() {
                        throw 'Must override SNItem.singletonPredicate';
                    }
                    get singletonStrategy() {
                        return SingletonStrategy_1.SingletonStrategy.KeepEarliest;
                    }
                    /**
                     * Subclasses can override this method and provide their own opinion on whether
                     * they want to be duplicated. For example, if this.content.x = 12 and
                     * item.content.x = 13, this function can be overriden to always return
                     * ConflictStrategy.KeepBase to say 'don't create a duplicate at all, the
                     * change is not important.'
                     *
                     * In the default implementation, we create a duplicate if content differs.
                     * However, if they only differ by references, we KEEP_LEFT_MERGE_REFS.
                     *
                     * Left returns to our current item, and Right refers to the incoming item.
                     */
                    strategyWhenConflictingWithItem(item, previousRevision) {
                        if ((0, TypeCheck_1.isEncryptedErroredItem)(this)) {
                            return ConflictStrategy_1.ConflictStrategy.KeepBaseDuplicateApply;
                        }
                        if (this.isSingleton) {
                            return ConflictStrategy_1.ConflictStrategy.KeepBase;
                        }
                        if ((0, TypeCheck_1.isDeletedItem)(this)) {
                            return ConflictStrategy_1.ConflictStrategy.KeepApply;
                        }
                        if ((0, TypeCheck_1.isDeletedItem)(item)) {
                            if (this.payload.source === PayloadSource_1.PayloadSource.FileImport) {
                                return ConflictStrategy_1.ConflictStrategy.KeepBase;
                            }
                            return ConflictStrategy_1.ConflictStrategy.KeepApply;
                        }
                        if (!(0, TypeCheck_1.isDecryptedItem)(item) || !(0, TypeCheck_1.isDecryptedItem)(this)) {
                            return ConflictStrategy_1.ConflictStrategy.KeepBaseDuplicateApply;
                        }
                        const contentDiffers = (0, ItemContentsDiffer_1.ItemContentsDiffer)(this, item);
                        if (!contentDiffers) {
                            return ConflictStrategy_1.ConflictStrategy.KeepApply;
                        }
                        const itemsAreDifferentExcludingRefs = (0, ItemContentsDiffer_1.ItemContentsDiffer)(this, item, ['references']);
                        if (itemsAreDifferentExcludingRefs) {
                            if (previousRevision) {
                                /**
                                 * If previousRevision.content === incomingValue.content, this means the
                                 * change that was rejected by the server is in fact a legitimate change,
                                 * because the value the client had previously matched with the server's,
                                 * and this new change is being built on top of that state, and should therefore
                                 * be chosen as the winner, with no need for a conflict.
                                 */
                                if (!(0, ItemContentsDiffer_1.ItemContentsDiffer)(previousRevision.itemFromPayload(), item)) {
                                    return ConflictStrategy_1.ConflictStrategy.KeepBase;
                                }
                            }
                            const twentySeconds = 20000;
                            if (
                            /**
                             * If the incoming item comes from an import, treat it as
                             * less important than the existing one.
                             */
                            item.payload.source === PayloadSource_1.PayloadSource.FileImport ||
                                /**
                                 * If the user is actively editing our item, duplicate the incoming item
                                 * to avoid creating surprises in the client's UI.
                                 */
                                Date.now() - this.userModifiedDate.getTime() < twentySeconds) {
                                return ConflictStrategy_1.ConflictStrategy.KeepBaseDuplicateApply;
                            }
                            else {
                                return ConflictStrategy_1.ConflictStrategy.DuplicateBaseKeepApply;
                            }
                        }
                        else {
                            /** Only the references have changed; merge them. */
                            return ConflictStrategy_1.ConflictStrategy.KeepBaseMergeRefs;
                        }
                    }
                    satisfiesPredicate(predicate) {
                        return predicate.matchesItem(this);
                    }
                }
                exports.GenericItem = GenericItem;
                /***/ 
            }),
            /***/ 81667: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91251: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 89169: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 12421: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63418: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isEncryptedErroredItem = exports.isDecryptedOrDeletedItem = exports.isDeletedItem = exports.isNotEncryptedItem = exports.isEncryptedItem = exports.isDecryptedItem = void 0;
                const TypeCheck_1 = __webpack_require__(13566);
                function isDecryptedItem(item) {
                    return 'payload' in item && (0, TypeCheck_1.isDecryptedPayload)(item.payload);
                }
                exports.isDecryptedItem = isDecryptedItem;
                function isEncryptedItem(item) {
                    return (0, TypeCheck_1.isEncryptedPayload)(item.payload);
                }
                exports.isEncryptedItem = isEncryptedItem;
                function isNotEncryptedItem(item) {
                    return !isEncryptedItem(item);
                }
                exports.isNotEncryptedItem = isNotEncryptedItem;
                function isDeletedItem(item) {
                    return (0, TypeCheck_1.isDeletedPayload)(item.payload);
                }
                exports.isDeletedItem = isDeletedItem;
                function isDecryptedOrDeletedItem(item) {
                    return isDecryptedItem(item) || isDeletedItem(item);
                }
                exports.isDecryptedOrDeletedItem = isDecryptedOrDeletedItem;
                function isEncryptedErroredItem(item) {
                    return isEncryptedItem(item) && item.errorDecrypting === true;
                }
                exports.isEncryptedErroredItem = isEncryptedErroredItem;
                /***/ 
            }),
            /***/ 589: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 14584: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DecryptedItemMutator = void 0;
                const utils_1 = __webpack_require__(87901);
                const MutationType_1 = __webpack_require__(4250);
                const AppDataField_1 = __webpack_require__(68716);
                const DefaultAppDomain_1 = __webpack_require__(71458);
                const ItemMutator_1 = __webpack_require__(56634);
                const DirtyCounter_1 = __webpack_require__(13743);
                class DecryptedItemMutator extends ItemMutator_1.ItemMutator {
                    constructor(item, type) {
                        super(item, type);
                        const mutableCopy = (0, utils_1.Copy)(this.immutablePayload.content);
                        this.mutableContent = mutableCopy;
                    }
                    getResult() {
                        if (this.type === MutationType_1.MutationType.NonDirtying) {
                            return this.immutablePayload.copy({
                                content: this.mutableContent
                            });
                        }
                        if (this.type === MutationType_1.MutationType.UpdateUserTimestamps) {
                            this.userModifiedDate = new Date();
                        }
                        else {
                            const currentValue = this.immutableItem.userModifiedDate;
                            if (!currentValue) {
                                this.userModifiedDate = new Date(this.immutableItem.serverUpdatedAt);
                            }
                        }
                        const result = this.immutablePayload.copy({
                            content: this.mutableContent,
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            signatureData: undefined,
                            last_edited_by_uuid: undefined
                        });
                        return result;
                    }
                    setBeginSync(began, globalDirtyIndex) {
                        this.immutablePayload = this.immutablePayload.copy({
                            content: this.mutableContent,
                            lastSyncBegan: began,
                            globalDirtyIndexAtLastSync: globalDirtyIndex
                        });
                    }
                    /** Not recommended to use as this might break item schema if used incorrectly */
                    setCustomContent(content) {
                        this.mutableContent = (0, utils_1.Copy)(content);
                    }
                    set userModifiedDate(date) {
                        this.setAppDataItem(AppDataField_1.AppDataField.UserModifiedDate, date);
                    }
                    set conflictOf(conflictOf) {
                        this.mutableContent.conflict_of = conflictOf;
                    }
                    set protected(isProtected) {
                        this.mutableContent.protected = isProtected;
                    }
                    set trashed(trashed) {
                        this.mutableContent.trashed = trashed;
                    }
                    set starred(starred) {
                        this.mutableContent.starred = starred;
                    }
                    set pinned(pinned) {
                        this.setAppDataItem(AppDataField_1.AppDataField.Pinned, pinned);
                    }
                    set archived(archived) {
                        this.setAppDataItem(AppDataField_1.AppDataField.Archived, archived);
                    }
                    set locked(locked) {
                        this.setAppDataItem(AppDataField_1.AppDataField.Locked, locked);
                    }
                    /**
                     * Overwrites the entirety of this domain's data with the data arg.
                     */
                    setDomainData(data, domain) {
                        if (!this.mutableContent.appData) {
                            this.mutableContent.appData = {
                                [DefaultAppDomain_1.DefaultAppDomain]: {}
                            };
                        }
                        this.mutableContent.appData[domain] = data;
                    }
                    /**
                     * First gets the domain data for the input domain.
                     * Then sets data[key] = value
                     */
                    setDomainDataKey(key, value, domain) {
                        if (!this.mutableContent.appData) {
                            this.mutableContent.appData = {
                                [DefaultAppDomain_1.DefaultAppDomain]: {}
                            };
                        }
                        if (!this.mutableContent.appData[domain]) {
                            this.mutableContent.appData[domain] = {};
                        }
                        const domainData = this.mutableContent.appData[domain];
                        domainData[key] = value;
                    }
                    setAppDataItem(key, value) {
                        this.setDomainDataKey(key, value, DefaultAppDomain_1.DefaultAppDomain);
                    }
                    e2ePendingRefactor_addItemAsRelationship(item) {
                        const references = this.mutableContent.references || [];
                        if (!references.find(r => r.uuid === item.uuid)) {
                            references.push({
                                uuid: item.uuid,
                                content_type: item.content_type
                            });
                        }
                        this.mutableContent.references = references;
                    }
                    removeItemAsRelationship(item) {
                        let references = this.mutableContent.references || [];
                        references = references.filter(r => r.uuid !== item.uuid);
                        this.mutableContent.references = references;
                    }
                }
                exports.DecryptedItemMutator = DecryptedItemMutator;
                /***/ 
            }),
            /***/ 94220: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeleteItemMutator = void 0;
                const DeletedPayload_1 = __webpack_require__(452);
                const ItemMutator_1 = __webpack_require__(56634);
                const MutationType_1 = __webpack_require__(4250);
                const DirtyCounter_1 = __webpack_require__(13743);
                class DeleteItemMutator extends ItemMutator_1.ItemMutator {
                    getDeletedResult() {
                        const dirtying = this.type !== MutationType_1.MutationType.NonDirtying;
                        const result = new DeletedPayload_1.DeletedPayload(Object.assign(Object.assign({}, this.immutablePayload.ejected()), {
                            deleted: true,
                            content: undefined,
                            dirty: dirtying ? true : this.immutablePayload.dirty,
                            dirtyIndex: dirtying ? (0, DirtyCounter_1.getIncrementedDirtyIndex)() : this.immutablePayload.dirtyIndex
                        }), this.immutablePayload.source);
                        return result;
                    }
                    getResult() {
                        throw Error('Must use getDeletedResult');
                    }
                }
                exports.DeleteItemMutator = DeleteItemMutator;
                /***/ 
            }),
            /***/ 56634: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemMutator = void 0;
                const MutationType_1 = __webpack_require__(4250);
                const DirtyCounter_1 = __webpack_require__(13743);
                const ContentTypeUsesRootKeyEncryption_1 = __webpack_require__(21662);
                /**
                 * An item mutator takes in an item, and an operation, and returns the resulting payload.
                 * Subclasses of mutators can modify the content field directly, but cannot modify the payload directly.
                 * All changes to the payload must occur by copying the payload and reassigning its value.
                 */
                class ItemMutator {
                    constructor(item, type) {
                        this.immutableItem = item;
                        this.type = type;
                        this.immutablePayload = item.payload;
                    }
                    getUuid() {
                        return this.immutablePayload.uuid;
                    }
                    getItem() {
                        return this.immutableItem;
                    }
                    getResult() {
                        if (this.type === MutationType_1.MutationType.NonDirtying) {
                            return this.immutablePayload.copy();
                        }
                        const result = this.immutablePayload.copy({
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)()
                        });
                        return result;
                    }
                    setBeginSync(began, globalDirtyIndex) {
                        this.immutablePayload = this.immutablePayload.copy({
                            lastSyncBegan: began,
                            globalDirtyIndexAtLastSync: globalDirtyIndex
                        });
                    }
                    set key_system_identifier(keySystemIdentifier) {
                        if ((0, ContentTypeUsesRootKeyEncryption_1.ContentTypeUsesRootKeyEncryption)(this.immutableItem.content_type)) {
                            throw new Error('Cannot set key_system_identifier on a root key encrypted item');
                        }
                        this.immutablePayload = this.immutablePayload.copy({
                            key_system_identifier: keySystemIdentifier
                        });
                    }
                    set shared_vault_uuid(sharedVaultUuid) {
                        if ((0, ContentTypeUsesRootKeyEncryption_1.ContentTypeUsesRootKeyEncryption)(this.immutableItem.content_type)) {
                            throw new Error('Cannot set shared_vault_uuid on a root key encrypted item');
                        }
                        this.immutablePayload = this.immutablePayload.copy({
                            shared_vault_uuid: sharedVaultUuid
                        });
                    }
                    set errorDecrypting(_) {
                        throw Error('This method is no longer implemented');
                    }
                    set updated_at(_) {
                        throw Error('This method is no longer implemented');
                    }
                    set updated_at_timestamp(_) {
                        throw Error('This method is no longer implemented');
                    }
                }
                exports.ItemMutator = ItemMutator;
                /***/ 
            }),
            /***/ 8898: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68716: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AppDataField = void 0;
                var AppDataField;
                (function (AppDataField) {
                    AppDataField["Pinned"] = "pinned";
                    AppDataField["Archived"] = "archived";
                    AppDataField["Locked"] = "locked";
                    AppDataField["UserModifiedDate"] = "client_updated_at";
                    AppDataField["DefaultEditor"] = "defaultEditor";
                    AppDataField["MobileRules"] = "mobileRules";
                    AppDataField["NotAvailableOnMobile"] = "notAvailableOnMobile";
                    AppDataField["MobileActive"] = "mobileActive";
                    AppDataField["LastSize"] = "lastSize";
                    AppDataField["LegacyPrefersPlainEditor"] = "prefersPlainEditor";
                    AppDataField["ComponentInstallError"] = "installError";
                })(AppDataField || (exports.AppDataField = AppDataField = {}));
                /***/ 
            }),
            /***/ 43610: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ConflictStrategy = void 0;
                var ConflictStrategy;
                (function (ConflictStrategy) {
                    ConflictStrategy[ConflictStrategy["KeepBase"] = 1] = "KeepBase";
                    ConflictStrategy[ConflictStrategy["KeepApply"] = 2] = "KeepApply";
                    ConflictStrategy[ConflictStrategy["KeepBaseDuplicateApply"] = 3] = "KeepBaseDuplicateApply";
                    ConflictStrategy[ConflictStrategy["DuplicateBaseKeepApply"] = 4] = "DuplicateBaseKeepApply";
                    ConflictStrategy[ConflictStrategy["KeepBaseMergeRefs"] = 5] = "KeepBaseMergeRefs";
                })(ConflictStrategy || (exports.ConflictStrategy = ConflictStrategy = {}));
                /***/ 
            }),
            /***/ 71458: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentDataDomain = exports.DefaultAppDomain = void 0;
                exports.DefaultAppDomain = 'org.standardnotes.sn';
                /* This domain will be used to save context item client data */
                exports.ComponentDataDomain = 'org.standardnotes.sn.components';
                /***/ 
            }),
            /***/ 15579: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91298: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 4250: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.MutationType = void 0;
                var MutationType;
                (function (MutationType) {
                    MutationType[MutationType["UpdateUserTimestamps"] = 1] = "UpdateUserTimestamps";
                    /**
                     * The item was changed as part of an internal operation, such as a migration, or, a user
                     * interaction that shouldn't modify timestamps (pinning, protecting, etc).
                     */
                    MutationType[MutationType["NoUpdateUserTimestamps"] = 2] = "NoUpdateUserTimestamps";
                    /**
                     * The item was changed as part of an internal function that wishes to modify
                     * internal item properties, such as lastSyncBegan, without modifying the item's dirty
                     * state. By default all other mutation types will result in a dirtied result.
                     */
                    MutationType[MutationType["NonDirtying"] = 3] = "NonDirtying";
                })(MutationType || (exports.MutationType = MutationType = {}));
                /***/ 
            }),
            /***/ 94515: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SingletonStrategy = void 0;
                var SingletonStrategy;
                (function (SingletonStrategy) {
                    SingletonStrategy[SingletonStrategy["KeepEarliest"] = 1] = "KeepEarliest";
                })(SingletonStrategy || (exports.SingletonStrategy = SingletonStrategy = {}));
                /***/ 
            }),
            /***/ 50292: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(89661), exports);
                __exportStar(__webpack_require__(78961), exports);
                __exportStar(__webpack_require__(2445), exports);
                __exportStar(__webpack_require__(64236), exports);
                __exportStar(__webpack_require__(4744), exports);
                __exportStar(__webpack_require__(27542), exports);
                __exportStar(__webpack_require__(96933), exports);
                __exportStar(__webpack_require__(77533), exports);
                __exportStar(__webpack_require__(80421), exports);
                __exportStar(__webpack_require__(43740), exports);
                __exportStar(__webpack_require__(43740), exports);
                __exportStar(__webpack_require__(78438), exports);
                __exportStar(__webpack_require__(80406), exports);
                __exportStar(__webpack_require__(97127), exports);
                __exportStar(__webpack_require__(81667), exports);
                __exportStar(__webpack_require__(91251), exports);
                __exportStar(__webpack_require__(89169), exports);
                __exportStar(__webpack_require__(12421), exports);
                __exportStar(__webpack_require__(63418), exports);
                __exportStar(__webpack_require__(589), exports);
                __exportStar(__webpack_require__(14584), exports);
                __exportStar(__webpack_require__(94220), exports);
                __exportStar(__webpack_require__(56634), exports);
                __exportStar(__webpack_require__(8898), exports);
                __exportStar(__webpack_require__(68716), exports);
                __exportStar(__webpack_require__(43610), exports);
                __exportStar(__webpack_require__(71458), exports);
                __exportStar(__webpack_require__(15579), exports);
                __exportStar(__webpack_require__(91298), exports);
                __exportStar(__webpack_require__(4250), exports);
                __exportStar(__webpack_require__(94515), exports);
                /***/ 
            }),
            /***/ 89262: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DecryptedPayload = void 0;
                const utils_1 = __webpack_require__(87901);
                const ItemContent_1 = __webpack_require__(42405);
                const PayloadSource_1 = __webpack_require__(89223);
                const PurePayload_1 = __webpack_require__(33264);
                class DecryptedPayload extends PurePayload_1.PurePayload {
                    constructor(rawPayload) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PayloadSource_1.PayloadSource.Constructor;
                        super(rawPayload, source);
                        this.content = (0, utils_1.Copy)((0, ItemContent_1.FillItemContent)(rawPayload.content));
                        this.deleted = false;
                    }
                    get references() {
                        return this.content.references || [];
                    }
                    getReference(uuid) {
                        const result = this.references.find(ref => ref.uuid === uuid);
                        if (!result) {
                            throw new Error('Reference not found');
                        }
                        return result;
                    }
                    ejected() {
                        return Object.assign(Object.assign({}, super.ejected()), {
                            content: this.content,
                            deleted: this.deleted
                        });
                    }
                    copy(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new DecryptedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                    copyAsSyncResolved(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new DecryptedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                }
                exports.DecryptedPayload = DecryptedPayload;
                /***/ 
            }),
            /***/ 452: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeletedPayload = void 0;
                const PayloadSource_1 = __webpack_require__(89223);
                const PurePayload_1 = __webpack_require__(33264);
                class DeletedPayload extends PurePayload_1.PurePayload {
                    constructor(rawPayload) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PayloadSource_1.PayloadSource.Constructor;
                        super(rawPayload, source);
                        this.deleted = true;
                        this.content = undefined;
                    }
                    get discardable() {
                        return !this.dirty;
                    }
                    ejected() {
                        return Object.assign(Object.assign({}, super.ejected()), {
                            deleted: this.deleted,
                            content: undefined
                        });
                    }
                    copy(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new DeletedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                    copyAsSyncResolved(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new DeletedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                }
                exports.DeletedPayload = DeletedPayload;
                /***/ 
            }),
            /***/ 86731: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EncryptedPayload = void 0;
                const ProtocolVersionFromEncryptedString_1 = __webpack_require__(80910);
                const PayloadSource_1 = __webpack_require__(89223);
                const PurePayload_1 = __webpack_require__(33264);
                class EncryptedPayload extends PurePayload_1.PurePayload {
                    constructor(rawPayload) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PayloadSource_1.PayloadSource.Constructor;
                        super(rawPayload, source);
                        const versionResult = (0, ProtocolVersionFromEncryptedString_1.ProtocolVersionFromEncryptedString)(rawPayload.content);
                        if (versionResult.isFailed()) {
                            throw new Error('EncryptedPayload constructor versionResult is failed');
                        }
                        this.auth_hash = rawPayload.auth_hash;
                        this.content = rawPayload.content;
                        this.deleted = false;
                        this.enc_item_key = rawPayload.enc_item_key;
                        this.errorDecrypting = rawPayload.errorDecrypting;
                        this.items_key_id = rawPayload.items_key_id;
                        this.version = versionResult.getValue();
                        this.waitingForKey = rawPayload.waitingForKey;
                    }
                    ejected() {
                        return Object.assign(Object.assign({}, super.ejected()), {
                            enc_item_key: this.enc_item_key,
                            items_key_id: this.items_key_id,
                            auth_hash: this.auth_hash,
                            errorDecrypting: this.errorDecrypting,
                            waitingForKey: this.waitingForKey,
                            content: this.content,
                            deleted: this.deleted
                        });
                    }
                    copy(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new EncryptedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                    copyAsSyncResolved(override) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.source;
                        const result = new EncryptedPayload(Object.assign(Object.assign({}, this.ejected()), override), source);
                        return result;
                    }
                }
                exports.EncryptedPayload = EncryptedPayload;
                /***/ 
            }),
            /***/ 33264: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PurePayload = void 0;
                const utils_1 = __webpack_require__(87901);
                const PayloadSource_1 = __webpack_require__(89223);
                const ContentTypeUsesRootKeyEncryption_1 = __webpack_require__(21662);
                class PurePayload {
                    constructor(rawPayload) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PayloadSource_1.PayloadSource.Constructor;
                        var _a, _b, _c, _d;
                        if (!rawPayload.uuid) {
                            throw Error("Attempting to construct payload with null uuid\n        Content type: ".concat(rawPayload.content_type));
                        }
                        if (rawPayload.key_system_identifier && (0, ContentTypeUsesRootKeyEncryption_1.ContentTypeUsesRootKeyEncryption)(rawPayload.content_type)) {
                            throw new Error('Rootkey-encrypted payload should not have a key system identifier');
                        }
                        this.source = source;
                        this.uuid = rawPayload.uuid;
                        this.content = rawPayload.content;
                        this.content_type = rawPayload.content_type;
                        this.deleted = (0, utils_1.useBoolean)(rawPayload.deleted, false);
                        this.dirty = rawPayload.dirty;
                        this.duplicate_of = rawPayload.duplicate_of;
                        this.updated_at = new Date(rawPayload.updated_at || 0);
                        this.updated_at_timestamp = rawPayload.updated_at_timestamp || 0;
                        if (this.updated_at_timestamp < 0) {
                            this.updated_at_timestamp = 0;
                            this.updated_at = new Date(0);
                        }
                        this.created_at = new Date(rawPayload.created_at || new Date());
                        this.created_at_timestamp = rawPayload.created_at_timestamp || 0;
                        if (this.created_at_timestamp < 0) {
                            this.created_at_timestamp = this.updated_at_timestamp;
                            this.created_at = this.updated_at;
                        }
                        this.lastSyncBegan = rawPayload.lastSyncBegan ? new Date(rawPayload.lastSyncBegan) : undefined;
                        this.lastSyncEnd = rawPayload.lastSyncEnd ? new Date(rawPayload.lastSyncEnd) : undefined;
                        this.dirtyIndex = rawPayload.dirtyIndex;
                        this.globalDirtyIndexAtLastSync = rawPayload.globalDirtyIndexAtLastSync;
                        this.user_uuid = (_a = rawPayload.user_uuid) !== null && _a !== void 0 ? _a : undefined;
                        this.key_system_identifier = (_b = rawPayload.key_system_identifier) !== null && _b !== void 0 ? _b : undefined;
                        this.shared_vault_uuid = (_c = rawPayload.shared_vault_uuid) !== null && _c !== void 0 ? _c : undefined;
                        this.last_edited_by_uuid = (_d = rawPayload.last_edited_by_uuid) !== null && _d !== void 0 ? _d : undefined;
                        this.signatureData = rawPayload.signatureData;
                        const timeToAllowSubclassesToFinishConstruction = 0;
                        setTimeout(() => {
                            (0, utils_1.deepFreeze)(this);
                        }, timeToAllowSubclassesToFinishConstruction);
                    }
                    ejected() {
                        const comprehensive = {
                            uuid: this.uuid,
                            content: this.content,
                            deleted: this.deleted,
                            content_type: this.content_type,
                            created_at: this.created_at,
                            updated_at: this.updated_at,
                            created_at_timestamp: this.created_at_timestamp,
                            updated_at_timestamp: this.updated_at_timestamp,
                            dirty: this.dirty,
                            duplicate_of: this.duplicate_of,
                            dirtyIndex: this.dirtyIndex,
                            globalDirtyIndexAtLastSync: this.globalDirtyIndexAtLastSync,
                            lastSyncBegan: this.lastSyncBegan,
                            lastSyncEnd: this.lastSyncEnd,
                            key_system_identifier: this.key_system_identifier,
                            user_uuid: this.user_uuid,
                            shared_vault_uuid: this.shared_vault_uuid,
                            last_edited_by_uuid: this.last_edited_by_uuid,
                            signatureData: this.signatureData
                        };
                        return comprehensive;
                    }
                    get serverUpdatedAt() {
                        return this.updated_at;
                    }
                    get serverUpdatedAtTimestamp() {
                        return this.updated_at_timestamp;
                    }
                }
                exports.PurePayload = PurePayload;
                /***/ 
            }),
            /***/ 83732: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 75310: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 3008: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 59296: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 13566: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isErrorDecryptingPayload = exports.isDeletedPayload = exports.isEncryptedPayload = exports.isDecryptedPayload = void 0;
                const TransferPayload_1 = __webpack_require__(78381);
                function isDecryptedPayload(payload) {
                    return (0, TransferPayload_1.isDecryptedTransferPayload)(payload);
                }
                exports.isDecryptedPayload = isDecryptedPayload;
                function isEncryptedPayload(payload) {
                    return (0, TransferPayload_1.isEncryptedTransferPayload)(payload);
                }
                exports.isEncryptedPayload = isEncryptedPayload;
                function isDeletedPayload(payload) {
                    return (0, TransferPayload_1.isDeletedTransferPayload)(payload);
                }
                exports.isDeletedPayload = isDeletedPayload;
                function isErrorDecryptingPayload(payload) {
                    return (0, TransferPayload_1.isErrorDecryptingTransferPayload)(payload);
                }
                exports.isErrorDecryptingPayload = isErrorDecryptingPayload;
                /***/ 
            }),
            /***/ 92238: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 55340: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadTimestampDefaults = void 0;
                function PayloadTimestampDefaults() {
                    return {
                        updated_at: new Date(0),
                        created_at: new Date(),
                        updated_at_timestamp: 0,
                        created_at_timestamp: 0
                    };
                }
                exports.PayloadTimestampDefaults = PayloadTimestampDefaults;
                /***/ 
            }),
            /***/ 21989: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadVaultOverrides = void 0;
                function PayloadVaultOverrides(vault) {
                    if (!vault) {
                        return {};
                    }
                    return {
                        key_system_identifier: vault.systemIdentifier,
                        shared_vault_uuid: vault.isSharedVaultListing() ? vault.sharing.sharedVaultUuid : undefined
                    };
                }
                exports.PayloadVaultOverrides = PayloadVaultOverrides;
                /***/ 
            }),
            /***/ 62935: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isPayloadSourceRetrieved = exports.isPayloadSourceInternalChange = exports.PayloadEmitSource = void 0;
                var PayloadEmitSource;
                (function (PayloadEmitSource) {
                    /** When an observer registers to stream items, the items are pushed immediately to the observer */
                    PayloadEmitSource[PayloadEmitSource["InitialObserverRegistrationPush"] = 1] = "InitialObserverRegistrationPush";
                    /**
                     * Payload when a client modifies item property then maps it to update UI.
                     * This also indicates that the item was dirtied
                     */
                    PayloadEmitSource[PayloadEmitSource["LocalChanged"] = 2] = "LocalChanged";
                    PayloadEmitSource[PayloadEmitSource["LocalInserted"] = 3] = "LocalInserted";
                    PayloadEmitSource[PayloadEmitSource["LocalDatabaseLoaded"] = 4] = "LocalDatabaseLoaded";
                    /** The payload returned by offline sync operation */
                    PayloadEmitSource[PayloadEmitSource["OfflineSyncSaved"] = 5] = "OfflineSyncSaved";
                    PayloadEmitSource[PayloadEmitSource["LocalRetrieved"] = 6] = "LocalRetrieved";
                    PayloadEmitSource[PayloadEmitSource["FileImport"] = 7] = "FileImport";
                    PayloadEmitSource[PayloadEmitSource["ComponentRetrieved"] = 8] = "ComponentRetrieved";
                    /** Payloads received from an external component with the intention of creating a new item */
                    PayloadEmitSource[PayloadEmitSource["ComponentCreated"] = 9] = "ComponentCreated";
                    /**
                     * When the payloads are about to sync, they are emitted by the sync service with updated
                     * values of lastSyncBegan. Payloads emitted from this source indicate that these payloads
                     * have been saved to disk, and are about to be synced
                     */
                    PayloadEmitSource[PayloadEmitSource["PreSyncSave"] = 10] = "PreSyncSave";
                    PayloadEmitSource[PayloadEmitSource["RemoteRetrieved"] = 11] = "RemoteRetrieved";
                    PayloadEmitSource[PayloadEmitSource["RemoteSaved"] = 12] = "RemoteSaved";
                    PayloadEmitSource[PayloadEmitSource["DesktopComponentSync"] = 13] = "DesktopComponentSync";
                })(PayloadEmitSource || (exports.PayloadEmitSource = PayloadEmitSource = {}));
                /**
                 * Whether the changed payload represents only an internal change that shouldn't
                 * require a UI refresh
                 */
                function isPayloadSourceInternalChange(source) {
                    return [PayloadEmitSource.RemoteSaved, PayloadEmitSource.PreSyncSave].includes(source);
                }
                exports.isPayloadSourceInternalChange = isPayloadSourceInternalChange;
                function isPayloadSourceRetrieved(source) {
                    return [PayloadEmitSource.RemoteRetrieved, PayloadEmitSource.ComponentRetrieved].includes(source);
                }
                exports.isPayloadSourceRetrieved = isPayloadSourceRetrieved;
                /***/ 
            }),
            /***/ 89223: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadSource = void 0;
                var PayloadSource;
                (function (PayloadSource) {
                    /**
                     * Payloads with a source of Constructor means that the payload was created
                     * in isolated space by the caller, and does not yet have any app-related affiliation.
                     */
                    PayloadSource[PayloadSource["Constructor"] = 1] = "Constructor";
                    PayloadSource[PayloadSource["LocalDatabaseLoaded"] = 2] = "LocalDatabaseLoaded";
                    PayloadSource[PayloadSource["RemoteRetrieved"] = 3] = "RemoteRetrieved";
                    PayloadSource[PayloadSource["RemoteSaved"] = 4] = "RemoteSaved";
                    PayloadSource[PayloadSource["FileImport"] = 5] = "FileImport";
                })(PayloadSource || (exports.PayloadSource = PayloadSource = {}));
                /***/ 
            }),
            /***/ 59180: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(33264), exports);
                __exportStar(__webpack_require__(89262), exports);
                __exportStar(__webpack_require__(86731), exports);
                __exportStar(__webpack_require__(452), exports);
                __exportStar(__webpack_require__(83732), exports);
                __exportStar(__webpack_require__(75310), exports);
                __exportStar(__webpack_require__(3008), exports);
                __exportStar(__webpack_require__(59296), exports);
                __exportStar(__webpack_require__(13566), exports);
                __exportStar(__webpack_require__(92238), exports);
                __exportStar(__webpack_require__(89223), exports);
                __exportStar(__webpack_require__(62935), exports);
                __exportStar(__webpack_require__(55340), exports);
                __exportStar(__webpack_require__(21989), exports);
                /***/ 
            }),
            /***/ 89661: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 2445: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 78961: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentReferenceType = void 0;
                var ContentReferenceType;
                (function (ContentReferenceType) {
                    ContentReferenceType["TagToParentTag"] = "TagToParentTag";
                    ContentReferenceType["TagToFile"] = "TagToFile";
                    ContentReferenceType["FileToNote"] = "FileToNote";
                    ContentReferenceType["FileToFile"] = "FileToFile";
                    ContentReferenceType["NoteToNote"] = "NoteToNote";
                })(ContentReferenceType || (exports.ContentReferenceType = ContentReferenceType = {}));
                /***/ 
            }),
            /***/ 64236: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 4744: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isTagToParentTagReference = exports.isLegacyTagToNoteReference = exports.isReference = exports.isLegacyAnonymousReference = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ContenteReferenceType_1 = __webpack_require__(78961);
                const isLegacyAnonymousReference = x => {
                    return x.reference_type === undefined;
                };
                exports.isLegacyAnonymousReference = isLegacyAnonymousReference;
                const isReference = x => {
                    return x.reference_type !== undefined;
                };
                exports.isReference = isReference;
                const isLegacyTagToNoteReference = (x, currentItem) => {
                    const isReferenceToANote = x.content_type === domain_core_1.ContentType.TYPES.Note;
                    const isReferenceFromATag = currentItem.content_type === domain_core_1.ContentType.TYPES.Tag;
                    return isReferenceToANote && isReferenceFromATag;
                };
                exports.isLegacyTagToNoteReference = isLegacyTagToNoteReference;
                const isTagToParentTagReference = x => {
                    return (0, exports.isReference)(x) && x.reference_type === ContenteReferenceType_1.ContentReferenceType.TagToParentTag;
                };
                exports.isTagToParentTagReference = isTagToParentTagReference;
                /***/ 
            }),
            /***/ 27542: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 96933: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 77533: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80421: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 69421: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 57978: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 95520: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 7834: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 49762: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isCorruptTransferPayload = exports.isDeletedTransferPayload = exports.isErrorDecryptingTransferPayload = exports.isEncryptedTransferPayload = exports.isDecryptedTransferPayload = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const utils_1 = __webpack_require__(87901);
                function isDecryptedTransferPayload(payload) {
                    return (0, utils_1.isObject)(payload.content);
                }
                exports.isDecryptedTransferPayload = isDecryptedTransferPayload;
                function isEncryptedTransferPayload(payload) {
                    return 'content' in payload && (0, utils_1.isString)(payload.content);
                }
                exports.isEncryptedTransferPayload = isEncryptedTransferPayload;
                function isErrorDecryptingTransferPayload(payload) {
                    return isEncryptedTransferPayload(payload) && payload.errorDecrypting === true;
                }
                exports.isErrorDecryptingTransferPayload = isErrorDecryptingTransferPayload;
                function isDeletedTransferPayload(payload) {
                    return 'deleted' in payload && payload.deleted === true;
                }
                exports.isDeletedTransferPayload = isDeletedTransferPayload;
                function isCorruptTransferPayload(payload) {
                    const invalidDeletedState = payload.deleted === true && payload.content != undefined;
                    const contenTypeOrError = domain_core_1.ContentType.create(payload.content_type);
                    return payload.uuid == undefined || invalidDeletedState || contenTypeOrError.isFailed();
                }
                exports.isCorruptTransferPayload = isCorruptTransferPayload;
                /***/ 
            }),
            /***/ 78381: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(69421), exports);
                __exportStar(__webpack_require__(57978), exports);
                __exportStar(__webpack_require__(95520), exports);
                __exportStar(__webpack_require__(7834), exports);
                __exportStar(__webpack_require__(49762), exports);
                /***/ 
            }),
            /***/ 21907: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 66675: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.InvitationStatus = void 0;
                var InvitationStatus;
                (function (InvitationStatus) {
                    InvitationStatus["Sent"] = "sent";
                    InvitationStatus["Canceled"] = "canceled";
                    InvitationStatus["Accepted"] = "accepted";
                    InvitationStatus["Declined"] = "declined";
                })(InvitationStatus || (exports.InvitationStatus = InvitationStatus = {}));
                /***/ 
            }),
            /***/ 90656: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.InviteeIdentifierType = void 0;
                var InviteeIdentifierType;
                (function (InviteeIdentifierType) {
                    InviteeIdentifierType["Email"] = "email";
                    InviteeIdentifierType["Hash"] = "hash";
                    InviteeIdentifierType["Uuid"] = "uuid";
                })(InviteeIdentifierType || (exports.InviteeIdentifierType = InviteeIdentifierType = {}));
                /***/ 
            }),
            /***/ 93715: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.InviterIdentifierType = void 0;
                var InviterIdentifierType;
                (function (InviterIdentifierType) {
                    InviterIdentifierType["Email"] = "email";
                    InviterIdentifierType["Uuid"] = "uuid";
                })(InviterIdentifierType || (exports.InviterIdentifierType = InviterIdentifierType = {}));
                /***/ 
            }),
            /***/ 84457: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Environment = void 0;
                var Environment;
                (function (Environment) {
                    Environment[Environment["Web"] = 1] = "Web";
                    Environment[Environment["Desktop"] = 2] = "Desktop";
                    Environment[Environment["Mobile"] = 3] = "Mobile";
                    Environment[Environment["Clipper"] = 4] = "Clipper";
                })(Environment || (exports.Environment = Environment = {}));
                /***/ 
            }),
            /***/ 656: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Platform = void 0;
                var Platform;
                (function (Platform) {
                    Platform[Platform["Ios"] = 1] = "Ios";
                    Platform[Platform["Android"] = 2] = "Android";
                    Platform[Platform["MacWeb"] = 3] = "MacWeb";
                    Platform[Platform["MacDesktop"] = 4] = "MacDesktop";
                    Platform[Platform["WindowsWeb"] = 5] = "WindowsWeb";
                    Platform[Platform["WindowsDesktop"] = 6] = "WindowsDesktop";
                    Platform[Platform["LinuxWeb"] = 7] = "LinuxWeb";
                    Platform[Platform["LinuxDesktop"] = 8] = "LinuxDesktop";
                })(Platform || (exports.Platform = Platform = {}));
                /***/ 
            }),
            /***/ 255: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 62846: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeySystemPasswordType = void 0;
                var KeySystemPasswordType;
                (function (KeySystemPasswordType) {
                    KeySystemPasswordType["UserInputted"] = "user_inputted";
                    KeySystemPasswordType["Randomized"] = "randomized";
                })(KeySystemPasswordType || (exports.KeySystemPasswordType = KeySystemPasswordType = {}));
                /***/ 
            }),
            /***/ 29899: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 22296: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 52174: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isVersionLessThanOrEqualTo = exports.leftVersionGreaterThanOrEqualToRight = exports.compareVersions = exports.ProtocolVersionLength = exports.isProtocolVersionExpired = exports.ProtocolExpirationDates = exports.ProtocolVersionLastNonrootItemsKey = exports.ProtocolVersionLatest = exports.ProtocolVersion = void 0;
                var ProtocolVersion;
                (function (ProtocolVersion) {
                    ProtocolVersion["V001"] = "001";
                    ProtocolVersion["V002"] = "002";
                    ProtocolVersion["V003"] = "003";
                    ProtocolVersion["V004"] = "004";
                })(ProtocolVersion || (exports.ProtocolVersion = ProtocolVersion = {}));
                exports.ProtocolVersionLatest = ProtocolVersion.V004;
                /** The last protocol version to not use root-key based items keys */
                exports.ProtocolVersionLastNonrootItemsKey = ProtocolVersion.V003;
                exports.ProtocolExpirationDates = Object.freeze({
                    [ProtocolVersion.V001]: Date.parse('2018-01-01'),
                    [ProtocolVersion.V002]: Date.parse('2020-01-01')
                });
                function isProtocolVersionExpired(version) {
                    const expireDate = exports.ProtocolExpirationDates[version];
                    if (!expireDate) {
                        return false;
                    }
                    const expired = new Date().getTime() > expireDate;
                    return expired;
                }
                exports.isProtocolVersionExpired = isProtocolVersionExpired;
                exports.ProtocolVersionLength = 3;
                /**
                 *  -1 if a < b
                 *  0 if a == b
                 *  1 if a > b
                 */
                function compareVersions(a, b) {
                    const aNum = Number(a);
                    const bNum = Number(b);
                    return aNum - bNum;
                }
                exports.compareVersions = compareVersions;
                function leftVersionGreaterThanOrEqualToRight(a, b) {
                    return compareVersions(a, b) >= 0;
                }
                exports.leftVersionGreaterThanOrEqualToRight = leftVersionGreaterThanOrEqualToRight;
                function isVersionLessThanOrEqualTo(input, compareTo) {
                    return compareVersions(input, compareTo) <= 0;
                }
                exports.isVersionLessThanOrEqualTo = isVersionLessThanOrEqualTo;
                /***/ 
            }),
            /***/ 80910: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ProtocolVersionFromEncryptedString = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ProtocolVersion_1 = __webpack_require__(52174);
                function ProtocolVersionFromEncryptedString(string) {
                    try {
                        const version = string.substring(0, ProtocolVersion_1.ProtocolVersionLength);
                        if (Object.values(ProtocolVersion_1.ProtocolVersion).includes(version)) {
                            return domain_core_1.Result.ok(version);
                        }
                    }
                    catch (error) {
                        return domain_core_1.Result.fail(JSON.stringify(error));
                    }
                    return domain_core_1.Result.fail("Invalid encrypted string ".concat(string));
                }
                exports.ProtocolVersionFromEncryptedString = ProtocolVersionFromEncryptedString;
                /***/ 
            }),
            /***/ 87192: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 71109: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 32099: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 55430: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 33738: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 64130: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.AsymmetricMessagePayloadType = void 0;
                var AsymmetricMessagePayloadType;
                (function (AsymmetricMessagePayloadType) {
                    AsymmetricMessagePayloadType["ContactShare"] = "contact-share";
                    AsymmetricMessagePayloadType["SharedVaultRootKeyChanged"] = "shared-vault-root-key-changed";
                    AsymmetricMessagePayloadType["SenderKeypairChanged"] = "sender-keypair-changed";
                    AsymmetricMessagePayloadType["SharedVaultMetadataChanged"] = "shared-vault-metadata-changed";
                    /**
                     * Shared Vault Invites conform to the asymmetric message protocol, but are sent via the dedicated
                     * SharedVaultInvite model and not the AsymmetricMessage model on the server side.
                     */
                    AsymmetricMessagePayloadType["SharedVaultInvite"] = "shared-vault-invite";
                })(AsymmetricMessagePayloadType || (exports.AsymmetricMessagePayloadType = AsymmetricMessagePayloadType = {}));
                /***/ 
            }),
            /***/ 18018: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 14770: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 45698: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63070: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 32151: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 71165: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Collection = void 0;
                const utils_1 = __webpack_require__(87901);
                const lodash_1 = __webpack_require__(84213);
                class Collection {
                    constructor() {
                        let copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        let mapCopy = arguments.length > 1 ? arguments[1] : undefined;
                        let typedMapCopy = arguments.length > 2 ? arguments[2] : undefined;
                        let referenceMapCopy = arguments.length > 3 ? arguments[3] : undefined;
                        let conflictMapCopy = arguments.length > 4 ? arguments[4] : undefined;
                        this.map = {};
                        this.typedMap = {};
                        /** An array of uuids of items that are dirty */
                        this.dirtyIndex = new Set();
                        /** An array of uuids of items that are not marked as deleted */
                        this.nondeletedIndex = new Set();
                        /** An array of uuids of items that are errorDecrypting or waitingForKey */
                        this.invalidsIndex = new Set();
                        this.isDecryptedElement = e => {
                            return (0, utils_1.isObject)(e.content);
                        };
                        this.isEncryptedElement = e => {
                            return 'content' in e && (0, utils_1.isString)(e.content);
                        };
                        this.isErrorDecryptingElement = e => {
                            return this.isEncryptedElement(e);
                        };
                        this.isDeletedElement = e => {
                            return 'deleted' in e && e.deleted === true;
                        };
                        this.isNonDeletedElement = e => {
                            return !this.isDeletedElement(e);
                        };
                        if (copy) {
                            this.map = mapCopy;
                            this.typedMap = typedMapCopy;
                            this.referenceMap = referenceMapCopy;
                            this.conflictMap = conflictMapCopy;
                        }
                        else {
                            this.referenceMap = new utils_1.UuidMap();
                            this.conflictMap = new utils_1.UuidMap();
                        }
                    }
                    uuids() {
                        return Object.keys(this.map);
                    }
                    all(contentType) {
                        var _a;
                        if (contentType) {
                            if (Array.isArray(contentType)) {
                                const elements = [];
                                for (const type of contentType) {
                                    (0, utils_1.extendArray)(elements, this.typedMap[type] || []);
                                }
                                return elements;
                            }
                            else {
                                return ((_a = this.typedMap[contentType]) === null || _a === void 0 ? void 0 : _a.slice()) || [];
                            }
                        }
                        else {
                            return Object.keys(this.map).map(uuid => {
                                return this.map[uuid];
                            });
                        }
                    }
                    /** Returns all elements that are not marked as deleted */
                    nondeletedElements() {
                        const uuids = Array.from(this.nondeletedIndex);
                        return this.findAll(uuids).filter(this.isNonDeletedElement);
                    }
                    /** Returns all elements that are errorDecrypting or waitingForKey */
                    invalidElements() {
                        const uuids = Array.from(this.invalidsIndex);
                        return this.findAll(uuids);
                    }
                    /** Returns all elements that are marked as dirty */
                    dirtyElements() {
                        const uuids = Array.from(this.dirtyIndex);
                        return this.findAll(uuids);
                    }
                    findAll(uuids) {
                        const results = [];
                        for (const id of uuids) {
                            const element = this.map[id];
                            if (element) {
                                results.push(element);
                            }
                        }
                        return results;
                    }
                    find(uuid) {
                        return this.map[uuid];
                    }
                    has(uuid) {
                        return this.find(uuid) != undefined;
                    }
                    /**
                     * If an item is not found, an `undefined` element
                     * will be inserted into the array.
                     */
                    findAllIncludingBlanks(uuids) {
                        const results = [];
                        for (const id of uuids) {
                            const element = this.map[id];
                            results.push(element);
                        }
                        return results;
                    }
                    set(elements) {
                        elements = Array.isArray(elements) ? elements : [elements];
                        if (elements.length === 0) {
                            console.warn('Attempting to set 0 elements onto collection');
                            return;
                        }
                        for (const element of elements) {
                            this.map[element.uuid] = element;
                            this.setToTypedMap(element);
                            if (this.isErrorDecryptingElement(element)) {
                                this.invalidsIndex.add(element.uuid);
                            }
                            else {
                                this.invalidsIndex.delete(element.uuid);
                            }
                            if (this.isDecryptedElement(element)) {
                                const conflictOf = element.content.conflict_of;
                                if (conflictOf && !element.content.trashed) {
                                    this.conflictMap.establishRelationship(conflictOf, element.uuid);
                                }
                                const isConflictOfButTrashed = conflictOf && element.content.trashed;
                                const isInConflictMapButIsNotConflictOf = !conflictOf && this.conflictMap.getInverseRelationships(element.uuid).length > 0;
                                const isInConflictMapButDoesNotHaveConflicts = this.conflictMap.existsInDirectMap(element.uuid) && this.conflictMap.getDirectRelationships(element.uuid).length === 0;
                                if (isInConflictMapButIsNotConflictOf || isInConflictMapButDoesNotHaveConflicts || isConflictOfButTrashed) {
                                    this.conflictMap.removeFromMap(element.uuid);
                                }
                                this.referenceMap.setAllRelationships(element.uuid, element.references.map(r => r.uuid));
                            }
                            if (element.dirty) {
                                this.dirtyIndex.add(element.uuid);
                            }
                            else {
                                this.dirtyIndex.delete(element.uuid);
                            }
                            if (element.deleted) {
                                this.nondeletedIndex.delete(element.uuid);
                                if (this.conflictMap.existsInDirectMap(element.uuid) || this.conflictMap.existsInInverseMap(element.uuid)) {
                                    this.conflictMap.removeFromMap(element.uuid);
                                }
                            }
                            else {
                                this.nondeletedIndex.add(element.uuid);
                            }
                        }
                    }
                    discard(elements) {
                        elements = Array.isArray(elements) ? elements : [elements];
                        for (const element of elements) {
                            this.deleteFromTypedMap(element);
                            delete this.map[element.uuid];
                            this.conflictMap.removeFromMap(element.uuid);
                            this.referenceMap.removeFromMap(element.uuid);
                        }
                    }
                    uuidReferencesForUuid(uuid) {
                        return this.referenceMap.getDirectRelationships(uuid);
                    }
                    uuidsThatReferenceUuid(uuid) {
                        return this.referenceMap.getInverseRelationships(uuid);
                    }
                    referencesForElement(element) {
                        const uuids = this.referenceMap.getDirectRelationships(element.uuid);
                        return this.findAll(uuids);
                    }
                    conflictsOf(uuid) {
                        const uuids = this.conflictMap.getDirectRelationships(uuid);
                        return this.findAll(uuids);
                    }
                    elementsReferencingElement(element, contentType) {
                        const uuids = this.uuidsThatReferenceUuid(element.uuid);
                        const items = this.findAll(uuids);
                        if (!contentType) {
                            return items;
                        }
                        return items.filter(item => item.content_type === contentType);
                    }
                    setToTypedMap(element) {
                        const array = this.typedMap[element.content_type] || [];
                        (0, lodash_1.remove)(array, {
                            uuid: element.uuid
                        });
                        array.push(element);
                        this.typedMap[element.content_type] = array;
                    }
                    deleteFromTypedMap(element) {
                        const array = this.typedMap[element.content_type] || [];
                        (0, lodash_1.remove)(array, {
                            uuid: element.uuid
                        });
                        this.typedMap[element.content_type] = array;
                    }
                    uuidsOfItemsWithConflicts() {
                        return this.conflictMap.getAllDirectKeys();
                    }
                }
                exports.Collection = Collection;
                /***/ 
            }),
            /***/ 92207: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CollectionSort = void 0;
                exports.CollectionSort = {
                    CreatedAt: 'created_at',
                    UpdatedAt: 'userModifiedDate',
                    Title: 'title'
                };
                /***/ 
            }),
            /***/ 36883: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemCollection = void 0;
                const TypeCheck_1 = __webpack_require__(63418);
                const Collection_1 = __webpack_require__(71165);
                class ItemCollection extends Collection_1.Collection {
                    onChange(delta) {
                        const changedOrInserted = delta.changed.concat(delta.inserted);
                        if (changedOrInserted.length > 0) {
                            this.set(changedOrInserted);
                        }
                        this.discard(delta.discarded);
                    }
                    findDecrypted(uuid) {
                        const result = this.find(uuid);
                        if (!result) {
                            return undefined;
                        }
                        return (0, TypeCheck_1.isDecryptedItem)(result) ? result : undefined;
                    }
                    findAllDecrypted(uuids) {
                        return this.findAll(uuids).filter(TypeCheck_1.isDecryptedItem);
                    }
                    findAllDecryptedWithBlanks(uuids) {
                        const results = this.findAllIncludingBlanks(uuids);
                        const mapped = results.map(i => {
                            if (i == undefined || (0, TypeCheck_1.isDecryptedItem)(i)) {
                                return i;
                            }
                            return undefined;
                        });
                        return mapped;
                    }
                    allDecrypted(contentType) {
                        return this.all(contentType).filter(TypeCheck_1.isDecryptedItem);
                    }
                }
                exports.ItemCollection = ItemCollection;
                /***/ 
            }),
            /***/ 17441: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemCounter = void 0;
                const utils_1 = __webpack_require__(87901);
                const Tag_1 = __webpack_require__(4862);
                const Item_1 = __webpack_require__(50292);
                const CollectionCriteriaValidator_1 = __webpack_require__(45408);
                const ExcludeVaultsCriteriaValidator_1 = __webpack_require__(19688);
                const ExclusiveVaultCriteriaValidator_1 = __webpack_require__(52197);
                const HiddenContentCriteriaValidator_1 = __webpack_require__(59017);
                const CustomFilterCriteriaValidator_1 = __webpack_require__(79256);
                const VaultDisplayOptionsTypes_1 = __webpack_require__(41574);
                const domain_core_1 = __webpack_require__(82648);
                class ItemCounter {
                    constructor(collection) {
                        let observers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                        this.collection = collection;
                        this.observers = observers;
                        this.tagToItemsMap = {};
                        this.allCountableItems = new Set();
                        this.countableItemsByType = new Map();
                        this.isItemCountable = item => {
                            if ((0, Item_1.isDecryptedItem)(item)) {
                                const passesFilters = this.passesAllFilters(item);
                                return passesFilters && !item.archived && !item.trashed && !item.conflictOf;
                            }
                            return false;
                        };
                    }
                    addCountChangeObserver(observer) {
                        this.observers.push(observer);
                        const thislessEventObservers = this.observers;
                        return () => {
                            (0, utils_1.removeFromArray)(thislessEventObservers, observer);
                        };
                    }
                    setDisplayOptions(options) {
                        this.displayOptions = options;
                        this.receiveItemChanges(this.collection.all());
                    }
                    setVaultDisplayOptions(options) {
                        this.vaultDisplayOptions = options;
                        this.receiveItemChanges(this.collection.all());
                    }
                    allCountableItemsCount() {
                        return this.allCountableItems.size;
                    }
                    allCountableNotesCount() {
                        var _a;
                        return ((_a = this.countableItemsByType.get(domain_core_1.ContentType.TYPES.Note)) === null || _a === void 0 ? void 0 : _a.size) || 0;
                    }
                    allCountableFilesCount() {
                        var _a;
                        return ((_a = this.countableItemsByType.get(domain_core_1.ContentType.TYPES.File)) === null || _a === void 0 ? void 0 : _a.size) || 0;
                    }
                    countableItemsForTag(tag) {
                        var _a;
                        return ((_a = this.tagToItemsMap[tag.uuid]) === null || _a === void 0 ? void 0 : _a.size) || 0;
                    }
                    onChange(delta) {
                        const items = [...delta.changed, ...delta.inserted, ...delta.discarded].filter(i => i.content_type === domain_core_1.ContentType.TYPES.Note || i.content_type === domain_core_1.ContentType.TYPES.File);
                        const tags = [...delta.changed, ...delta.inserted].filter(Item_1.isDecryptedItem).filter(Tag_1.isTag);
                        this.receiveItemChanges(items);
                        this.receiveTagChanges(tags);
                    }
                    passesAllFilters(element) {
                        if (!this.displayOptions) {
                            return true;
                        }
                        const filters = [new CollectionCriteriaValidator_1.CollectionCriteriaValidator(this.collection, element)];
                        if (this.vaultDisplayOptions) {
                            const options = this.vaultDisplayOptions.getOptions();
                            if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(options)) {
                                filters.push(new ExcludeVaultsCriteriaValidator_1.ExcludeVaultsCriteriaValidator([...options.exclude, ...options.locked], element));
                            }
                            else {
                                filters.push(new ExclusiveVaultCriteriaValidator_1.ExclusiveVaultCriteriaValidator(options.exclusive, element));
                            }
                        }
                        if ('hiddenContentTypes' in this.displayOptions && this.displayOptions.hiddenContentTypes) {
                            filters.push(new HiddenContentCriteriaValidator_1.HiddenContentCriteriaValidator(this.displayOptions.hiddenContentTypes, element));
                        }
                        if ('customFilter' in this.displayOptions && this.displayOptions.customFilter) {
                            filters.push(new CustomFilterCriteriaValidator_1.CustomFilterCriteriaValidator(this.displayOptions.customFilter, element));
                        }
                        return filters.every(f => f.passes());
                    }
                    notifyObservers(tagUuid) {
                        for (const observer of this.observers) {
                            observer(tagUuid);
                        }
                    }
                    receiveTagChanges(tags) {
                        for (const tag of tags) {
                            const uuids = tag.references.filter(ref => ref.content_type === domain_core_1.ContentType.TYPES.Note || ref.content_type === domain_core_1.ContentType.TYPES.File).map(ref => ref.uuid);
                            const countableUuids = uuids.filter(uuid => this.allCountableItems.has(uuid));
                            const previousSet = this.tagToItemsMap[tag.uuid];
                            this.tagToItemsMap[tag.uuid] = new Set(countableUuids);
                            if ((previousSet === null || previousSet === void 0 ? void 0 : previousSet.size) !== countableUuids.length) {
                                this.notifyObservers(tag.uuid);
                            }
                        }
                    }
                    receiveItemChanges(items) {
                        var _a, _b;
                        const previousAllCount = this.allCountableItems.size;
                        for (const item of items) {
                            const isCountable = this.isItemCountable(item);
                            if (isCountable) {
                                this.allCountableItems.add(item.uuid);
                                if (!this.countableItemsByType.has(item.content_type)) {
                                    this.countableItemsByType.set(item.content_type, new Set());
                                }
                                (_a = this.countableItemsByType.get(item.content_type)) === null || _a === void 0 ? void 0 : _a.add(item.uuid);
                            }
                            else {
                                this.allCountableItems.delete(item.uuid);
                                (_b = this.countableItemsByType.get(item.content_type)) === null || _b === void 0 ? void 0 : _b.delete(item.uuid);
                            }
                            const associatedTagUuids = this.collection.uuidsThatReferenceUuid(item.uuid);
                            for (const tagUuid of associatedTagUuids) {
                                const set = this.setForTag(tagUuid);
                                const previousCount = set.size;
                                if (isCountable) {
                                    set.add(item.uuid);
                                }
                                else {
                                    set.delete(item.uuid);
                                }
                                if (previousCount !== set.size) {
                                    this.notifyObservers(tagUuid);
                                }
                            }
                        }
                        if (previousAllCount !== this.allCountableItems.size) {
                            this.notifyObservers(undefined);
                        }
                    }
                    setForTag(uuid) {
                        let set = this.tagToItemsMap[uuid];
                        if (!set) {
                            set = new Set();
                            this.tagToItemsMap[uuid] = set;
                        }
                        return set;
                    }
                }
                exports.ItemCounter = ItemCounter;
                /***/ 
            }),
            /***/ 51833: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ImmutablePayloadCollection = void 0;
                const PayloadCollection_1 = __webpack_require__(19759);
                class ImmutablePayloadCollection extends PayloadCollection_1.PayloadCollection {
                    get payloads() {
                        return this.all();
                    }
                    /** We don't use a constructor for this because we don't want the constructor to have
                     * side-effects, such as calling collection.set(). */
                    static WithPayloads() {
                        let payloads = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        const collection = new ImmutablePayloadCollection();
                        if (payloads.length > 0) {
                            collection.set(payloads);
                        }
                        Object.freeze(collection);
                        return collection;
                    }
                    static FromCollection(collection) {
                        const mapCopy = Object.freeze(Object.assign({}, collection.map));
                        const typedMapCopy = Object.freeze(Object.assign({}, collection.typedMap));
                        const referenceMapCopy = Object.freeze(collection.referenceMap.makeCopy());
                        const conflictMapCopy = Object.freeze(collection.conflictMap.makeCopy());
                        const result = new ImmutablePayloadCollection(true, mapCopy, typedMapCopy, referenceMapCopy, conflictMapCopy);
                        Object.freeze(result);
                        return result;
                    }
                    mutableCopy() {
                        const mapCopy = Object.assign({}, this.map);
                        const typedMapCopy = Object.assign({}, this.typedMap);
                        const referenceMapCopy = this.referenceMap.makeCopy();
                        const conflictMapCopy = this.conflictMap.makeCopy();
                        const result = new PayloadCollection_1.PayloadCollection(true, mapCopy, typedMapCopy, referenceMapCopy, conflictMapCopy);
                        return result;
                    }
                }
                exports.ImmutablePayloadCollection = ImmutablePayloadCollection;
                /***/ 
            }),
            /***/ 19759: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadCollection = void 0;
                const Collection_1 = __webpack_require__(71165);
                class PayloadCollection extends Collection_1.Collection {
                    integrityPayloads() {
                        const nondeletedElements = this.nondeletedElements();
                        return nondeletedElements.map(item => ({
                            uuid: item.uuid,
                            updated_at_timestamp: item.serverUpdatedAtTimestamp
                        }));
                    }
                }
                exports.PayloadCollection = PayloadCollection;
                /***/ 
            }),
            /***/ 9611: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.extendSyncDelta = void 0;
                const utils_1 = __webpack_require__(87901);
                function extendSyncDelta(base, extendWith) {
                    (0, utils_1.extendArray)(base.emits, extendWith.emits);
                    if (extendWith.ignored) {
                        if (!base.ignored) {
                            base.ignored = [];
                        }
                        (0, utils_1.extendArray)(base.ignored, extendWith.ignored);
                    }
                }
                exports.extendSyncDelta = extendSyncDelta;
                /***/ 
            }),
            /***/ 38067: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ConflictDelta = void 0;
                const utils_1 = __webpack_require__(87901);
                const domain_core_1 = __webpack_require__(82648);
                const ItemGenerator_1 = __webpack_require__(73277);
                const HistoryMap_1 = __webpack_require__(97873);
                const ConflictStrategy_1 = __webpack_require__(43610);
                const PayloadsByDuplicating_1 = __webpack_require__(27446);
                const PayloadContentsEqual_1 = __webpack_require__(37807);
                const TypeCheck_1 = __webpack_require__(13566);
                const ItemsKeyDelta_1 = __webpack_require__(38656);
                const DirtyCounter_1 = __webpack_require__(13743);
                class ConflictDelta {
                    constructor(baseCollection, basePayload, applyPayload, historyMap) {
                        this.baseCollection = baseCollection;
                        this.basePayload = basePayload;
                        this.applyPayload = applyPayload;
                        this.historyMap = historyMap;
                    }
                    result() {
                        if (this.applyPayload.content_type === domain_core_1.ContentType.TYPES.ItemsKey) {
                            const keyDelta = new ItemsKeyDelta_1.ItemsKeyDelta(this.baseCollection, [this.applyPayload]);
                            return keyDelta.result();
                        }
                        const strategy = this.getConflictStrategy();
                        return {
                            emits: this.handleStrategy(strategy),
                            ignored: []
                        };
                    }
                    getConflictStrategy() {
                        const isBaseErrored = (0, TypeCheck_1.isErrorDecryptingPayload)(this.basePayload);
                        const isApplyErrored = (0, TypeCheck_1.isErrorDecryptingPayload)(this.applyPayload);
                        if (isBaseErrored || isApplyErrored) {
                            if (isBaseErrored && !isApplyErrored) {
                                return ConflictStrategy_1.ConflictStrategy.KeepBaseDuplicateApply;
                            }
                            else if (!isBaseErrored && isApplyErrored) {
                                return ConflictStrategy_1.ConflictStrategy.DuplicateBaseKeepApply;
                            }
                            else if (isBaseErrored && isApplyErrored) {
                                return ConflictStrategy_1.ConflictStrategy.KeepApply;
                            }
                        }
                        else if ((0, TypeCheck_1.isDecryptedPayload)(this.basePayload)) {
                            /**
                             * Ensure no conflict has already been created with the incoming content.
                             * This can occur in a multi-page sync request where in the middle of the request,
                             * we make changes to many items, including duplicating, but since we are still not
                             * uploading the changes until after the multi-page request completes, we may have
                             * already conflicted this item.
                             */
                            const existingConflict = this.baseCollection.conflictsOf(this.applyPayload.uuid)[0];
                            if (existingConflict && (0, TypeCheck_1.isDecryptedPayload)(existingConflict) && (0, TypeCheck_1.isDecryptedPayload)(this.applyPayload) && (0, PayloadContentsEqual_1.PayloadContentsEqual)(existingConflict, this.applyPayload)) {
                                /** Conflict exists and its contents are the same as incoming value, do not make duplicate */
                                return ConflictStrategy_1.ConflictStrategy.KeepBase;
                            }
                            else {
                                const tmpBaseItem = (0, ItemGenerator_1.CreateDecryptedItemFromPayload)(this.basePayload);
                                const tmpApplyItem = (0, ItemGenerator_1.CreateItemFromPayload)(this.applyPayload);
                                const historyEntries = this.historyMap[this.basePayload.uuid] || [];
                                const previousRevision = HistoryMap_1.historyMapFunctions.getNewestRevision(historyEntries);
                                return tmpBaseItem.strategyWhenConflictingWithItem(tmpApplyItem, previousRevision);
                            }
                        }
                        else if ((0, TypeCheck_1.isDeletedPayload)(this.basePayload) || (0, TypeCheck_1.isDeletedPayload)(this.applyPayload)) {
                            const baseDeleted = (0, TypeCheck_1.isDeletedPayload)(this.basePayload);
                            const applyDeleted = (0, TypeCheck_1.isDeletedPayload)(this.applyPayload);
                            if (baseDeleted && applyDeleted) {
                                return ConflictStrategy_1.ConflictStrategy.KeepApply;
                            }
                            else {
                                return ConflictStrategy_1.ConflictStrategy.KeepApply;
                            }
                        }
                        throw Error('Unhandled strategy in Conflict Delta getConflictStrategy');
                    }
                    handleStrategy(strategy) {
                        if (strategy === ConflictStrategy_1.ConflictStrategy.KeepBase) {
                            return this.handleKeepBaseStrategy();
                        }
                        if (strategy === ConflictStrategy_1.ConflictStrategy.KeepApply) {
                            return this.handleKeepApplyStrategy();
                        }
                        if (strategy === ConflictStrategy_1.ConflictStrategy.KeepBaseDuplicateApply) {
                            return this.handleKeepBaseDuplicateApplyStrategy();
                        }
                        if (strategy === ConflictStrategy_1.ConflictStrategy.DuplicateBaseKeepApply) {
                            return this.handleDuplicateBaseKeepApply();
                        }
                        if (strategy === ConflictStrategy_1.ConflictStrategy.KeepBaseMergeRefs) {
                            return this.handleKeepBaseMergeRefsStrategy();
                        }
                        throw Error('Unhandled strategy in conflict delta payloadsByHandlingStrategy');
                    }
                    handleKeepBaseStrategy() {
                        const updatedAt = this.applyPayload.serverUpdatedAt;
                        const updatedAtTimestamp = this.applyPayload.updated_at_timestamp;
                        const leftPayload = this.basePayload.copyAsSyncResolved({
                            updated_at: updatedAt,
                            updated_at_timestamp: updatedAtTimestamp,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            dirty: true,
                            lastSyncEnd: new Date()
                        }, this.applyPayload.source);
                        return [leftPayload];
                    }
                    handleKeepApplyStrategy() {
                        const result = this.applyPayload.copyAsSyncResolved({
                            lastSyncBegan: this.basePayload.lastSyncBegan,
                            lastSyncEnd: new Date(),
                            dirty: false
                        }, this.applyPayload.source);
                        return [result];
                    }
                    handleKeepBaseDuplicateApplyStrategy() {
                        const updatedAt = this.applyPayload.serverUpdatedAt;
                        const updatedAtTimestamp = this.applyPayload.updated_at_timestamp;
                        const leftPayload = this.basePayload.copyAsSyncResolved({
                            updated_at: updatedAt,
                            updated_at_timestamp: updatedAtTimestamp,
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            lastSyncEnd: new Date()
                        }, this.applyPayload.source);
                        const rightPayloads = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: this.applyPayload,
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: this.applyPayload.source
                        });
                        return [leftPayload].concat(rightPayloads);
                    }
                    handleDuplicateBaseKeepApply() {
                        const leftPayloads = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: this.basePayload,
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: this.applyPayload.source
                        });
                        const rightPayload = this.applyPayload.copyAsSyncResolved({
                            lastSyncBegan: this.basePayload.lastSyncBegan,
                            dirty: false,
                            lastSyncEnd: new Date()
                        }, this.applyPayload.source);
                        return leftPayloads.concat([rightPayload]);
                    }
                    handleKeepBaseMergeRefsStrategy() {
                        if (!(0, TypeCheck_1.isDecryptedPayload)(this.basePayload) || !(0, TypeCheck_1.isDecryptedPayload)(this.applyPayload)) {
                            return [];
                        }
                        const refs = (0, utils_1.uniqCombineObjArrays)(this.basePayload.content.references, this.applyPayload.content.references, ['uuid', 'content_type']);
                        const updatedAt = this.applyPayload.serverUpdatedAt;
                        const updatedAtTimestamp = this.applyPayload.updated_at_timestamp;
                        const payload = this.basePayload.copyAsSyncResolved({
                            updated_at: updatedAt,
                            updated_at_timestamp: updatedAtTimestamp,
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            lastSyncEnd: new Date(),
                            content: Object.assign(Object.assign({}, this.basePayload.content), {
                                references: refs
                            })
                        }, this.applyPayload.source);
                        return [payload];
                    }
                }
                exports.ConflictDelta = ConflictDelta;
                /***/ 
            }),
            /***/ 33076: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaFileImport = void 0;
                const Conflict_1 = __webpack_require__(38067);
                const Payload_1 = __webpack_require__(59180);
                const DeltaEmit_1 = __webpack_require__(9611);
                const DirtyCounter_1 = __webpack_require__(13743);
                class DeltaFileImport {
                    constructor(baseCollection, applyPayloads, historyMap) {
                        this.baseCollection = baseCollection;
                        this.applyPayloads = applyPayloads;
                        this.historyMap = historyMap;
                    }
                    result() {
                        const result = {
                            emits: [],
                            ignored: [],
                            source: Payload_1.PayloadEmitSource.FileImport
                        };
                        for (const payload of this.applyPayloads) {
                            const resolved = this.resolvePayload(payload, result);
                            (0, DeltaEmit_1.extendSyncDelta)(result, resolved);
                        }
                        return result;
                    }
                    resolvePayload(payload, currentResults) {
                        /**
                         * Check to see if we've already processed a payload for this id.
                         * If so, that would be the latest value, and not what's in the base collection.
                         */
                        /*
                         * Find the most recently created conflict if available, as that
                         * would contain the most recent value.
                         */
                        let current = currentResults.emits.find(candidate => {
                            return (0, Payload_1.isDecryptedPayload)(candidate) && candidate.content.conflict_of === payload.uuid;
                        });
                        /**
                         * If no latest conflict, find by uuid directly.
                         */
                        if (!current) {
                            current = currentResults.emits.find(candidate => {
                                return candidate.uuid === payload.uuid;
                            });
                        }
                        /**
                         * If not found in current results, use the base value.
                         */
                        if (!current) {
                            const base = this.baseCollection.find(payload.uuid);
                            if (base && (0, Payload_1.isDecryptedPayload)(base)) {
                                current = base;
                            }
                        }
                        /**
                         * If the current doesn't exist, we're creating a new item from payload.
                         */
                        if (!current) {
                            return {
                                emits: [payload.copyAsSyncResolved({
                                        dirty: true,
                                        dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                                        lastSyncEnd: new Date(0)
                                    })],
                                ignored: []
                            };
                        }
                        const delta = new Conflict_1.ConflictDelta(this.baseCollection, current, payload, this.historyMap);
                        return delta.result();
                    }
                }
                exports.DeltaFileImport = DeltaFileImport;
                /***/ 
            }),
            /***/ 38656: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemsKeyDelta = void 0;
                const Payload_1 = __webpack_require__(59180);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                class ItemsKeyDelta {
                    constructor(baseCollection, applyPayloads) {
                        this.baseCollection = baseCollection;
                        this.applyPayloads = applyPayloads;
                    }
                    result() {
                        const emits = [];
                        const ignored = [];
                        for (const apply of this.applyPayloads) {
                            const base = this.baseCollection.find(apply.uuid);
                            if (!base) {
                                emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(apply, this.baseCollection));
                                continue;
                            }
                            if ((0, Payload_1.isEncryptedPayload)(apply) && (0, Payload_1.isDecryptedPayload)(base)) {
                                const keepBaseWithApplyTimestamps = base.copyAsSyncResolved({
                                    updated_at_timestamp: apply.updated_at_timestamp,
                                    updated_at: apply.updated_at,
                                    dirty: false,
                                    lastSyncEnd: new Date()
                                });
                                emits.push(keepBaseWithApplyTimestamps);
                                ignored.push(apply);
                            }
                            else {
                                emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(apply, this.baseCollection));
                            }
                        }
                        return {
                            emits: emits,
                            ignored
                        };
                    }
                }
                exports.ItemsKeyDelta = ItemsKeyDelta;
                /***/ 
            }),
            /***/ 9910: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaOfflineSaved = void 0;
                const Payload_1 = __webpack_require__(59180);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                class DeltaOfflineSaved {
                    constructor(baseCollection, applyContextualPayloads) {
                        this.baseCollection = baseCollection;
                        this.applyContextualPayloads = applyContextualPayloads;
                    }
                    result() {
                        const processed = [];
                        for (const apply of this.applyContextualPayloads) {
                            const base = this.baseCollection.find(apply.uuid);
                            if (!base) {
                                continue;
                            }
                            processed.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(base, this.baseCollection));
                        }
                        return {
                            emits: processed,
                            source: Payload_1.PayloadEmitSource.OfflineSyncSaved
                        };
                    }
                }
                exports.DeltaOfflineSaved = DeltaOfflineSaved;
                /***/ 
            }),
            /***/ 28504: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaOutOfSync = void 0;
                const Payload_1 = __webpack_require__(59180);
                const TypeCheck_1 = __webpack_require__(13566);
                const PayloadContentsEqual_1 = __webpack_require__(37807);
                const Conflict_1 = __webpack_require__(38067);
                const domain_core_1 = __webpack_require__(82648);
                const ItemsKeyDelta_1 = __webpack_require__(38656);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                const DeltaEmit_1 = __webpack_require__(9611);
                class DeltaOutOfSync {
                    constructor(baseCollection, applyCollection, historyMap) {
                        this.baseCollection = baseCollection;
                        this.applyCollection = applyCollection;
                        this.historyMap = historyMap;
                    }
                    result() {
                        const result = {
                            emits: [],
                            ignored: [],
                            source: Payload_1.PayloadEmitSource.RemoteRetrieved
                        };
                        for (const apply of this.applyCollection.all()) {
                            if (apply.content_type === domain_core_1.ContentType.TYPES.ItemsKey) {
                                const itemsKeyDeltaEmit = new ItemsKeyDelta_1.ItemsKeyDelta(this.baseCollection, [apply]).result();
                                (0, DeltaEmit_1.extendSyncDelta)(result, itemsKeyDeltaEmit);
                                continue;
                            }
                            const base = this.baseCollection.find(apply.uuid);
                            if (!base) {
                                result.emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(apply, this.baseCollection));
                                continue;
                            }
                            const isBaseDecrypted = (0, TypeCheck_1.isDecryptedPayload)(base);
                            const isApplyDecrypted = (0, TypeCheck_1.isDecryptedPayload)(apply);
                            const needsConflict = isApplyDecrypted !== isBaseDecrypted || isApplyDecrypted && isBaseDecrypted && !(0, PayloadContentsEqual_1.PayloadContentsEqual)(apply, base);
                            if (needsConflict) {
                                const delta = new Conflict_1.ConflictDelta(this.baseCollection, base, apply, this.historyMap);
                                (0, DeltaEmit_1.extendSyncDelta)(result, delta.result());
                            }
                            else {
                                result.emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(apply, this.baseCollection));
                            }
                        }
                        return result;
                    }
                }
                exports.DeltaOutOfSync = DeltaOutOfSync;
                /***/ 
            }),
            /***/ 9579: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaRemoteDataConflicts = void 0;
                const Conflict_1 = __webpack_require__(38067);
                const Payload_1 = __webpack_require__(59180);
                const DeltaEmit_1 = __webpack_require__(9611);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                class DeltaRemoteDataConflicts {
                    constructor(baseCollection, conflicts, historyMap) {
                        this.baseCollection = baseCollection;
                        this.conflicts = conflicts;
                        this.historyMap = historyMap;
                    }
                    result() {
                        const result = {
                            emits: [],
                            ignored: [],
                            source: Payload_1.PayloadEmitSource.RemoteRetrieved
                        };
                        for (const conflict of this.conflicts) {
                            const base = this.baseCollection.find(conflict.server_item.uuid);
                            const isBaseDeleted = base == undefined;
                            if (isBaseDeleted) {
                                result.emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(conflict.server_item, this.baseCollection));
                                continue;
                            }
                            const delta = new Conflict_1.ConflictDelta(this.baseCollection, base, conflict.server_item, this.historyMap);
                            (0, DeltaEmit_1.extendSyncDelta)(result, delta.result());
                        }
                        return result;
                    }
                }
                exports.DeltaRemoteDataConflicts = DeltaRemoteDataConflicts;
                /***/ 
            }),
            /***/ 34319: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaRemoteRejected = void 0;
                const PayloadSource_1 = __webpack_require__(89223);
                const Payload_1 = __webpack_require__(59180);
                const SyncResolvedPayload_1 = __webpack_require__(84625);
                const responses_1 = __webpack_require__(95658);
                const PayloadsByDuplicating_1 = __webpack_require__(27446);
                const domain_core_1 = __webpack_require__(82648);
                class DeltaRemoteRejected {
                    constructor(baseCollection, conflicts) {
                        this.baseCollection = baseCollection;
                        this.conflicts = conflicts;
                    }
                    result() {
                        const results = [];
                        const vaultErrors = [responses_1.ConflictType.SharedVaultInsufficientPermissionsError, responses_1.ConflictType.SharedVaultNotMemberError, responses_1.ConflictType.SharedVaultInvalidState, responses_1.ConflictType.SharedVaultSnjsVersionError];
                        for (const conflict of this.conflicts) {
                            if (vaultErrors.includes(conflict.type)) {
                                results.push(...this.handleVaultError(conflict));
                            }
                            else if ((0, responses_1.conflictParamsHasServerItemAndUnsavedItem)(conflict)) {
                                results.push(...this.getResultForConflictWithServerItemAndUnsavedItem(conflict));
                            }
                            else if ((0, responses_1.conflictParamsHasOnlyServerItem)(conflict)) {
                                results.push(...this.getResultForConflictWithOnlyServerItem(conflict));
                            }
                            else if ((0, responses_1.conflictParamsHasOnlyUnsavedItem)(conflict)) {
                                results.push(...this.getResultForConflictWithOnlyUnsavedItem(conflict));
                            }
                        }
                        return {
                            emits: results,
                            source: Payload_1.PayloadEmitSource.RemoteSaved
                        };
                    }
                    handleVaultError(conflict) {
                        const base = this.baseCollection.find(conflict.unsaved_item.uuid);
                        if (!base) {
                            return [];
                        }
                        if (conflict.type === responses_1.ConflictType.SharedVaultNotMemberError) {
                            return this.resultByDuplicatingBasePayloadAsNonVaultedAndRemovingBaseItemLocally(base);
                        }
                        if (base.content_type === domain_core_1.ContentType.TYPES.KeySystemItemsKey) {
                            return this.discardChangesOfBasePayload(base);
                        }
                        if (conflict.server_item) {
                            return this.resultByDuplicatingBasePayloadAsNonVaultedAndTakingServerPayloadAsCanonical(base, conflict.server_item);
                        }
                        else {
                            return this.resultByDuplicatingBasePayloadAsNonVaultedAndDiscardingChangesOfOriginal(base);
                        }
                    }
                    discardChangesOfBasePayload(base) {
                        const undirtiedPayload = base.copyAsSyncResolved({
                            dirty: false,
                            lastSyncEnd: new Date()
                        }, PayloadSource_1.PayloadSource.RemoteSaved);
                        return [undirtiedPayload];
                    }
                    getResultForConflictWithOnlyUnsavedItem(conflict) {
                        const base = this.baseCollection.find(conflict.unsaved_item.uuid);
                        if (!base) {
                            return [];
                        }
                        const result = base.copyAsSyncResolved({
                            dirty: false,
                            lastSyncEnd: new Date()
                        }, PayloadSource_1.PayloadSource.RemoteSaved);
                        return [result];
                    }
                    getResultForConflictWithOnlyServerItem(conflict) {
                        const base = this.baseCollection.find(conflict.server_item.uuid);
                        if (!base) {
                            return [];
                        }
                        return this.resultByDuplicatingBasePayloadIntoNewUuidAndTakingServerPayloadAsCanonical(base, conflict.server_item);
                    }
                    getResultForConflictWithServerItemAndUnsavedItem(conflict) {
                        const base = this.baseCollection.find(conflict.server_item.uuid);
                        if (!base) {
                            return [];
                        }
                        return this.resultByDuplicatingBasePayloadIntoNewUuidAndTakingServerPayloadAsCanonical(base, conflict.server_item);
                    }
                    resultByDuplicatingBasePayloadIntoNewUuidAndTakingServerPayloadAsCanonical(basePayload, serverPayload) {
                        const duplicateBasePayloadIntoNewUuid = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: basePayload,
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: serverPayload.source
                        });
                        const takeServerPayloadAsCanonical = serverPayload.copyAsSyncResolved({
                            lastSyncBegan: basePayload.lastSyncBegan,
                            dirty: false,
                            lastSyncEnd: new Date()
                        }, serverPayload.source);
                        return duplicateBasePayloadIntoNewUuid.concat([takeServerPayloadAsCanonical]);
                    }
                    resultByDuplicatingBasePayloadAsNonVaultedAndTakingServerPayloadAsCanonical(basePayload, serverPayload) {
                        const duplicateBasePayloadIntoNewUuid = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: basePayload.copy({
                                key_system_identifier: undefined,
                                shared_vault_uuid: undefined
                            }),
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: serverPayload.source
                        });
                        const takeServerPayloadAsCanonical = serverPayload.copyAsSyncResolved({
                            lastSyncBegan: basePayload.lastSyncBegan,
                            dirty: false,
                            lastSyncEnd: new Date()
                        }, serverPayload.source);
                        return duplicateBasePayloadIntoNewUuid.concat([takeServerPayloadAsCanonical]);
                    }
                    resultByDuplicatingBasePayloadAsNonVaultedAndDiscardingChangesOfOriginal(basePayload) {
                        const duplicateBasePayloadWithoutVault = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: basePayload.copy({
                                key_system_identifier: undefined,
                                shared_vault_uuid: undefined
                            }),
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: basePayload.source
                        });
                        return [...duplicateBasePayloadWithoutVault, ...this.discardChangesOfBasePayload(basePayload)];
                    }
                    resultByDuplicatingBasePayloadAsNonVaultedAndRemovingBaseItemLocally(basePayload) {
                        const duplicateBasePayloadWithoutVault = (0, PayloadsByDuplicating_1.PayloadsByDuplicating)({
                            payload: basePayload.copy({
                                key_system_identifier: undefined,
                                shared_vault_uuid: undefined
                            }),
                            baseCollection: this.baseCollection,
                            isConflict: true,
                            source: basePayload.source
                        });
                        const locallyDeletedBasePayload = new Payload_1.DeletedPayload(Object.assign(Object.assign(Object.assign({}, basePayload), {
                            content: undefined,
                            deleted: true,
                            key_system_identifier: undefined,
                            shared_vault_uuid: undefined
                        }), (0, SyncResolvedPayload_1.BuildSyncResolvedParams)({
                            dirty: false,
                            lastSyncEnd: new Date()
                        })), PayloadSource_1.PayloadSource.RemoteSaved);
                        return [...duplicateBasePayloadWithoutVault, locallyDeletedBasePayload];
                    }
                }
                exports.DeltaRemoteRejected = DeltaRemoteRejected;
                /***/ 
            }),
            /***/ 79603: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaRemoteRetrieved = void 0;
                const Conflict_1 = __webpack_require__(38067);
                const TypeCheck_1 = __webpack_require__(13566);
                const Payload_1 = __webpack_require__(59180);
                const domain_core_1 = __webpack_require__(82648);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                const ItemsKeyDelta_1 = __webpack_require__(38656);
                const DeltaEmit_1 = __webpack_require__(9611);
                class DeltaRemoteRetrieved {
                    constructor(baseCollection, applyCollection, itemsSavedOrSaving, historyMap) {
                        this.baseCollection = baseCollection;
                        this.applyCollection = applyCollection;
                        this.itemsSavedOrSaving = itemsSavedOrSaving;
                        this.historyMap = historyMap;
                    }
                    isUuidOfPayloadCurrentlySavingOrSaved(uuid) {
                        return this.itemsSavedOrSaving.find(i => i.uuid === uuid) != undefined;
                    }
                    result() {
                        const result = {
                            emits: [],
                            ignored: [],
                            source: Payload_1.PayloadEmitSource.RemoteRetrieved
                        };
                        const conflicted = [];
                        /**
                         * If we have retrieved an item that was saved as part of this ongoing sync operation,
                         * or if the item is locally dirty, filter it out of retrieved_items, and add to potential conflicts.
                         */
                        for (const apply of this.applyCollection.all()) {
                            if (apply.content_type === domain_core_1.ContentType.TYPES.ItemsKey || apply.content_type === domain_core_1.ContentType.TYPES.KeySystemItemsKey) {
                                const itemsKeyDeltaEmit = new ItemsKeyDelta_1.ItemsKeyDelta(this.baseCollection, [apply]).result();
                                (0, DeltaEmit_1.extendSyncDelta)(result, itemsKeyDeltaEmit);
                                continue;
                            }
                            const isSavedOrSaving = this.isUuidOfPayloadCurrentlySavingOrSaved(apply.uuid);
                            if (isSavedOrSaving) {
                                conflicted.push(apply);
                                continue;
                            }
                            const base = this.baseCollection.find(apply.uuid);
                            if ((base === null || base === void 0 ? void 0 : base.dirty) && !(0, TypeCheck_1.isErrorDecryptingPayload)(base)) {
                                conflicted.push(apply);
                                continue;
                            }
                            result.emits.push((0, ApplyDirtyState_1.payloadByFinalizingSyncState)(apply, this.baseCollection));
                        }
                        /**
                         * For any potential conflict above, we compare the values with current
                         * local values, and if they differ, we create a new payload that is a copy
                         * of the server payload.
                         */
                        for (const conflict of conflicted) {
                            if (!(0, TypeCheck_1.isDecryptedPayload)(conflict)) {
                                continue;
                            }
                            const base = this.baseCollection.find(conflict.uuid);
                            if (!base) {
                                continue;
                            }
                            const delta = new Conflict_1.ConflictDelta(this.baseCollection, base, conflict, this.historyMap);
                            (0, DeltaEmit_1.extendSyncDelta)(result, delta.result());
                        }
                        return result;
                    }
                }
                exports.DeltaRemoteRetrieved = DeltaRemoteRetrieved;
                /***/ 
            }),
            /***/ 50910: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaRemoteSaved = void 0;
                const DeletedPayload_1 = __webpack_require__(452);
                const PayloadSource_1 = __webpack_require__(89223);
                const TypeCheck_1 = __webpack_require__(13566);
                const Payload_1 = __webpack_require__(59180);
                const ApplyDirtyState_1 = __webpack_require__(72990);
                const SyncResolvedPayload_1 = __webpack_require__(84625);
                const DirtyCounter_1 = __webpack_require__(13743);
                class DeltaRemoteSaved {
                    constructor(baseCollection, applyContextualPayloads) {
                        this.baseCollection = baseCollection;
                        this.applyContextualPayloads = applyContextualPayloads;
                    }
                    result() {
                        const processed = [];
                        for (const apply of this.applyContextualPayloads) {
                            const base = this.baseCollection.find(apply.uuid);
                            if (!base) {
                                const discarded = new DeletedPayload_1.DeletedPayload(Object.assign(Object.assign(Object.assign({}, apply), {
                                    deleted: true,
                                    content: undefined
                                }), (0, SyncResolvedPayload_1.BuildSyncResolvedParams)({
                                    dirty: false,
                                    lastSyncEnd: new Date()
                                })), PayloadSource_1.PayloadSource.RemoteSaved);
                                processed.push(discarded);
                                continue;
                            }
                            /**
                             * If we save an item, but while in transit it is deleted locally, we want to keep
                             * local deletion status, and not old (false) deleted value that was sent to server.
                             */
                            if ((0, TypeCheck_1.isDeletedPayload)(base)) {
                                const baseWasDeletedAfterThisRequest = !apply.deleted;
                                const regularDeletedPayload = apply.deleted;
                                if (baseWasDeletedAfterThisRequest) {
                                    const result = new DeletedPayload_1.DeletedPayload(Object.assign(Object.assign(Object.assign({}, apply), {
                                        deleted: true,
                                        content: undefined,
                                        dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)()
                                    }), (0, SyncResolvedPayload_1.BuildSyncResolvedParams)({
                                        dirty: true,
                                        lastSyncEnd: new Date()
                                    })), PayloadSource_1.PayloadSource.RemoteSaved);
                                    processed.push(result);
                                }
                                else if (regularDeletedPayload) {
                                    const discarded = base.copy(Object.assign(Object.assign(Object.assign({}, apply), {
                                        deleted: true
                                    }), (0, SyncResolvedPayload_1.BuildSyncResolvedParams)({
                                        dirty: false,
                                        lastSyncEnd: new Date()
                                    })), PayloadSource_1.PayloadSource.RemoteSaved);
                                    processed.push(discarded);
                                }
                            }
                            else {
                                const result = (0, ApplyDirtyState_1.payloadByFinalizingSyncState)(base.copy(Object.assign(Object.assign({}, apply), {
                                    deleted: false
                                }), PayloadSource_1.PayloadSource.RemoteSaved), this.baseCollection);
                                processed.push(result);
                            }
                        }
                        return {
                            emits: processed,
                            source: Payload_1.PayloadEmitSource.RemoteSaved
                        };
                    }
                }
                exports.DeltaRemoteSaved = DeltaRemoteSaved;
                /***/ 
            }),
            /***/ 16484: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeltaRemoteUuidConflicts = void 0;
                const utils_1 = __webpack_require__(87901);
                const ImmutablePayloadCollection_1 = __webpack_require__(51833);
                const PayloadsByAlternatingUuid_1 = __webpack_require__(15005);
                const TypeCheck_1 = __webpack_require__(13566);
                const Payload_1 = __webpack_require__(59180);
                /**
                 * UUID conflicts can occur if a user attmpts to import an old data
                 * backup with uuids from the old account into a new account.
                 * In uuid_conflict, we receive the value we attmpted to save.
                 */
                class DeltaRemoteUuidConflicts {
                    constructor(baseCollection, conflicts) {
                        this.baseCollection = baseCollection;
                        this.conflicts = conflicts;
                    }
                    result() {
                        const results = [];
                        const baseCollectionCopy = this.baseCollection.mutableCopy();
                        for (const conflict of this.conflicts) {
                            /**
                             * The payload in question may have been modified as part of alternating a uuid for
                             * another item. For example, alternating a uuid for a note will also affect the
                             * referencing tag, which would be added to `results`, but could also be inside
                             * of this.applyCollection. In this case we'd prefer the most recently modified value.
                             */
                            const moreRecent = results.find(r => r.uuid === conflict.unsaved_item.uuid);
                            const useApply = moreRecent || conflict.unsaved_item;
                            if (!(0, TypeCheck_1.isDecryptedPayload)(useApply)) {
                                continue;
                            }
                            const alternateResults = (0, PayloadsByAlternatingUuid_1.PayloadsByAlternatingUuid)(useApply, ImmutablePayloadCollection_1.ImmutablePayloadCollection.FromCollection(baseCollectionCopy));
                            baseCollectionCopy.set(alternateResults);
                            (0, utils_1.filterFromArray)(results, r => (0, utils_1.Uuids)(alternateResults).includes(r.uuid));
                            (0, utils_1.extendArray)(results, alternateResults);
                        }
                        return {
                            emits: results,
                            source: Payload_1.PayloadEmitSource.RemoteRetrieved
                        };
                    }
                }
                exports.DeltaRemoteUuidConflicts = DeltaRemoteUuidConflicts;
                /***/ 
            }),
            /***/ 72990: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.payloadsByFinalizingSyncState = exports.payloadByFinalizingSyncState = void 0;
                const DirtyCounter_1 = __webpack_require__(13743);
                function payloadByFinalizingSyncState(payload, baseCollection) {
                    const basePayload = baseCollection.find(payload.uuid);
                    if (!basePayload) {
                        return payload.copyAsSyncResolved({
                            dirty: false,
                            lastSyncEnd: new Date()
                        });
                    }
                    const stillDirty = basePayload.dirtyIndex && basePayload.globalDirtyIndexAtLastSync ? basePayload.dirtyIndex > basePayload.globalDirtyIndexAtLastSync : false;
                    return payload.copyAsSyncResolved({
                        dirty: stillDirty,
                        dirtyIndex: stillDirty ? (0, DirtyCounter_1.getIncrementedDirtyIndex)() : undefined,
                        lastSyncEnd: new Date()
                    });
                }
                exports.payloadByFinalizingSyncState = payloadByFinalizingSyncState;
                function payloadsByFinalizingSyncState(payloads, baseCollection) {
                    return payloads.map(p => payloadByFinalizingSyncState(p, baseCollection));
                }
                exports.payloadsByFinalizingSyncState = payloadsByFinalizingSyncState;
                /***/ 
            }),
            /***/ 84625: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.BuildSyncResolvedParams = void 0;
                function BuildSyncResolvedParams(params) {
                    return params;
                }
                exports.BuildSyncResolvedParams = BuildSyncResolvedParams;
                /***/ 
            }),
            /***/ 22517: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(38067), exports);
                __exportStar(__webpack_require__(33076), exports);
                __exportStar(__webpack_require__(28504), exports);
                __exportStar(__webpack_require__(9579), exports);
                __exportStar(__webpack_require__(79603), exports);
                __exportStar(__webpack_require__(50910), exports);
                __exportStar(__webpack_require__(9910), exports);
                __exportStar(__webpack_require__(16484), exports);
                __exportStar(__webpack_require__(34319), exports);
                __exportStar(__webpack_require__(9611), exports);
                /***/ 
            }),
            /***/ 13743: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.getCurrentDirtyIndex = exports.getIncrementedDirtyIndex = void 0;
                let dirtyIndex = 0;
                function getIncrementedDirtyIndex() {
                    dirtyIndex++;
                    return dirtyIndex;
                }
                exports.getIncrementedDirtyIndex = getIncrementedDirtyIndex;
                function getCurrentDirtyIndex() {
                    return dirtyIndex;
                }
                exports.getCurrentDirtyIndex = getCurrentDirtyIndex;
                /***/ 
            }),
            /***/ 55823: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91176: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.computeFiltersForDisplayOptions = exports.computeUnifiedFilterForDisplayOptions = void 0;
                const CompoundPredicate_1 = __webpack_require__(8698);
                const ItemWithTags_1 = __webpack_require__(50149);
                const SearchUtilities_1 = __webpack_require__(35509);
                const SmartView_1 = __webpack_require__(41138);
                const domain_core_1 = __webpack_require__(82648);
                function computeUnifiedFilterForDisplayOptions(options, collection) {
                    let additionalFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    const filters = computeFiltersForDisplayOptions(options, collection).concat(additionalFilters);
                    return item => {
                        return (0, SearchUtilities_1.itemPassesFilters)(item, filters);
                    };
                }
                exports.computeUnifiedFilterForDisplayOptions = computeUnifiedFilterForDisplayOptions;
                function computeFiltersForDisplayOptions(options, collection) {
                    var _a;
                    const filters = [];
                    let viewsPredicate = undefined;
                    if (options.views && options.views.length > 0) {
                        const compoundPredicate = new CompoundPredicate_1.CompoundPredicate('and', options.views.map(t => t.predicate));
                        viewsPredicate = compoundPredicate;
                        filters.push(item => {
                            if (compoundPredicate.keypathIncludesString('tags')) {
                                const noteWithTags = ItemWithTags_1.ItemWithTags.Create(item.payload, item, collection.elementsReferencingElement(item, domain_core_1.ContentType.TYPES.Tag));
                                return compoundPredicate.matchesItem(noteWithTags);
                            }
                            else {
                                return compoundPredicate.matchesItem(item);
                            }
                        });
                    }
                    if (options.tags && options.tags.length > 0) {
                        for (const tag of options.tags) {
                            filters.push(item => tag.isReferencingItem(item));
                        }
                    }
                    if (options.includePinned === false && !(viewsPredicate === null || viewsPredicate === void 0 ? void 0 : viewsPredicate.keypathIncludesString('pinned'))) {
                        filters.push(item => !item.pinned);
                    }
                    if (options.includeProtected === false && !(viewsPredicate === null || viewsPredicate === void 0 ? void 0 : viewsPredicate.keypathIncludesString('protected'))) {
                        filters.push(item => !item.protected);
                    }
                    if (options.includeTrashed === false && !(viewsPredicate === null || viewsPredicate === void 0 ? void 0 : viewsPredicate.keypathIncludesString('trashed'))) {
                        filters.push(item => !item.trashed);
                    }
                    if (options.includeArchived === false && !(viewsPredicate === null || viewsPredicate === void 0 ? void 0 : viewsPredicate.keypathIncludesString('archived'))) {
                        filters.push(item => !item.archived);
                    }
                    if (options.searchQuery) {
                        const query = options.searchQuery;
                        filters.push(item => (0, SearchUtilities_1.itemMatchesQuery)(item, query, collection));
                    }
                    if (!(viewsPredicate === null || viewsPredicate === void 0 ? void 0 : viewsPredicate.keypathIncludesString('conflict_of')) && !((_a = options.views) === null || _a === void 0 ? void 0 : _a.some(v => v.uuid === SmartView_1.SystemViewId.TrashedNotes))) {
                        filters.push(item => !item.conflictOf);
                    }
                    return filters;
                }
                exports.computeFiltersForDisplayOptions = computeFiltersForDisplayOptions;
                /***/ 
            }),
            /***/ 40257: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemDisplayController = void 0;
                const utils_1 = __webpack_require__(87901);
                const Item_1 = __webpack_require__(50292);
                const SortTwoItems_1 = __webpack_require__(99548);
                const CollectionCriteriaValidator_1 = __webpack_require__(45408);
                const CustomFilterCriteriaValidator_1 = __webpack_require__(79256);
                const ExcludeVaultsCriteriaValidator_1 = __webpack_require__(19688);
                const ExclusiveVaultCriteriaValidator_1 = __webpack_require__(52197);
                const HiddenContentCriteriaValidator_1 = __webpack_require__(59017);
                const VaultDisplayOptionsTypes_1 = __webpack_require__(41574);
                class ItemDisplayController {
                    constructor(collection, contentTypes, options, vaultOptions) {
                        this.collection = collection;
                        this.contentTypes = contentTypes;
                        this.options = options;
                        this.vaultOptions = vaultOptions;
                        this.sortMap = {};
                        this.sortedItems = [];
                        this.needsSort = true;
                        this.filterThenSortElements(this.collection.all(this.contentTypes));
                    }
                    items() {
                        return this.sortedItems;
                    }
                    hasExclusiveVaultOptions() {
                        return this.vaultOptions ? !(0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.vaultOptions.getOptions()) : false;
                    }
                    getDisplayOptions() {
                        return this.options;
                    }
                    setVaultDisplayOptions(vaultOptions) {
                        this.vaultOptions = vaultOptions;
                        this.needsSort = true;
                        this.filterThenSortElements(this.collection.all(this.contentTypes));
                    }
                    setDisplayOptions(displayOptions) {
                        this.options = Object.assign(Object.assign({}, this.options), displayOptions);
                        this.needsSort = true;
                        this.filterThenSortElements(this.collection.all(this.contentTypes));
                    }
                    onCollectionChange(delta) {
                        const items = [...delta.changed, ...delta.inserted, ...delta.discarded].filter(i => this.contentTypes.includes(i.content_type));
                        this.filterThenSortElements(items);
                    }
                    passesAllFilters(element) {
                        const filters = [new CollectionCriteriaValidator_1.CollectionCriteriaValidator(this.collection, element)];
                        if (this.vaultOptions) {
                            const options = this.vaultOptions.getOptions();
                            if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(options)) {
                                filters.push(new ExcludeVaultsCriteriaValidator_1.ExcludeVaultsCriteriaValidator([...options.exclude, ...options.locked], element));
                            }
                            else {
                                filters.push(new ExclusiveVaultCriteriaValidator_1.ExclusiveVaultCriteriaValidator(options.exclusive, element));
                            }
                        }
                        if ('hiddenContentTypes' in this.options && this.options.hiddenContentTypes) {
                            filters.push(new HiddenContentCriteriaValidator_1.HiddenContentCriteriaValidator(this.options.hiddenContentTypes, element));
                        }
                        if ('customFilter' in this.options && this.options.customFilter) {
                            filters.push(new CustomFilterCriteriaValidator_1.CustomFilterCriteriaValidator(this.options.customFilter, element));
                        }
                        return filters.every(f => f.passes());
                    }
                    filterThenSortElements(elements) {
                        for (const element of elements) {
                            const previousIndex = this.sortMap[element.uuid];
                            const previousElement = previousIndex != undefined ? this.sortedItems[previousIndex] : undefined;
                            const remove = () => {
                                if (previousIndex != undefined) {
                                    delete this.sortMap[element.uuid];
                                    this.sortedItems[previousIndex] = undefined;
                                    /** Since an element is being removed from the array, we need to recompute
                                     * the new positions for elements that are staying */
                                    this.needsSort = true;
                                }
                            };
                            if ((0, Item_1.isDeletedItem)(element) || (0, Item_1.isEncryptedItem)(element)) {
                                remove();
                                continue;
                            }
                            const passes = this.passesAllFilters(element);
                            if (passes) {
                                if (previousElement != undefined) {
                                    /** Check to see if the element has changed its sort value. If so, we need to re-sort. */
                                    const previousValue = previousElement[this.options.sortBy];
                                    const newValue = element[this.options.sortBy];
                                    /** Replace the current element with the new one. */
                                    this.sortedItems[previousIndex] = element;
                                    /** If the pinned status of the element has changed, it needs to be resorted */
                                    const pinChanged = previousElement.pinned !== element.pinned;
                                    if (!(0, utils_1.compareValues)(previousValue, newValue) || pinChanged) {
                                        /** Needs resort because its re-sort value has changed,
                                         * and thus its position might change */
                                        this.needsSort = true;
                                    }
                                }
                                else {
                                    /** Has not yet been inserted */
                                    this.sortedItems.push(element);
                                    /** Needs re-sort because we're just pushing the element to the end here */
                                    this.needsSort = true;
                                }
                            }
                            else {
                                /** Doesn't pass filter, remove from sorted and filtered */
                                remove();
                            }
                        }
                        if (this.needsSort) {
                            this.needsSort = false;
                            this.resortItems();
                        }
                    }
                    /** Resort the sortedItems array, and update the saved positions */
                    resortItems() {
                        const resorted = this.sortedItems.sort((a, b) => {
                            return (0, SortTwoItems_1.sortTwoItems)(a, b, this.options.sortBy, this.options.sortDirection);
                        });
                        /**
                         * Now that resorted contains the sorted elements (but also can contain undefined element)
                         * we create another array that filters out any of the undefinedes. We also keep track of the
                         * current index while we loop and set that in the this.sortMap.
                         * */
                        const results = [];
                        let currentIndex = 0;
                        /** @O(n) */
                        for (const element of resorted) {
                            if (!element) {
                                continue;
                            }
                            results.push(element);
                            this.sortMap[element.uuid] = currentIndex;
                            currentIndex++;
                        }
                        this.sortedItems = results;
                    }
                }
                exports.ItemDisplayController = ItemDisplayController;
                /***/ 
            }),
            /***/ 50149: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemWithTags = void 0;
                const utils_1 = __webpack_require__(87901);
                const Item_1 = __webpack_require__(50292);
                class ItemWithTags extends Item_1.DecryptedItem {
                    constructor(payload, item, tags) {
                        super(payload);
                        this.item = item;
                        this.tags = tags;
                        this.transferInItemPropertiesSoRootLevelPredicateKeyPathsCanBeMatched(item);
                        this.tags = tags || payload.content.tags;
                    }
                    transferInItemPropertiesSoRootLevelPredicateKeyPathsCanBeMatched(item) {
                        Object.assign(this, (0, utils_1.omitByCopy)(item, ['title', 'text']));
                    }
                    static Create(payload, item, tags) {
                        return new ItemWithTags(payload, item, tags);
                    }
                    get tagsCount() {
                        var _a;
                        return ((_a = this.tags) === null || _a === void 0 ? void 0 : _a.length) || 0;
                    }
                    get title() {
                        return this.item.title;
                    }
                    get text() {
                        return this.item.text;
                    }
                }
                exports.ItemWithTags = ItemWithTags;
                /***/ 
            }),
            /***/ 35509: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.itemMatchesQuery = exports.itemPassesFilters = exports.notesAndFilesMatchingOptions = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const DisplayOptionsToFilters_1 = __webpack_require__(91176);
                var MatchResult;
                (function (MatchResult) {
                    MatchResult[MatchResult["None"] = 0] = "None";
                    MatchResult[MatchResult["Title"] = 1] = "Title";
                    MatchResult[MatchResult["Text"] = 2] = "Text";
                    MatchResult[MatchResult["TitleAndText"] = 3] = "TitleAndText";
                    MatchResult[MatchResult["Uuid"] = 5] = "Uuid";
                })(MatchResult || (MatchResult = {}));
                function notesAndFilesMatchingOptions(options, fromItems, collection) {
                    const filters = (0, DisplayOptionsToFilters_1.computeFiltersForDisplayOptions)(options, collection);
                    return fromItems.filter(item => {
                        return itemPassesFilters(item, filters);
                    });
                }
                exports.notesAndFilesMatchingOptions = notesAndFilesMatchingOptions;
                function itemPassesFilters(item, filters) {
                    for (const filter of filters) {
                        if (!filter(item)) {
                            return false;
                        }
                    }
                    return true;
                }
                exports.itemPassesFilters = itemPassesFilters;
                function itemMatchesQuery(itemToMatch, searchQuery, collection) {
                    const itemTags = collection.elementsReferencingElement(itemToMatch, domain_core_1.ContentType.TYPES.Tag);
                    const someTagsMatches = itemTags.some(tag => matchResultForStringQuery(tag, searchQuery.query) !== MatchResult.None);
                    if (itemToMatch.protected && !searchQuery.includeProtectedNoteText) {
                        const match = matchResultForStringQuery(itemToMatch, searchQuery.query);
                        return match === MatchResult.Title || match === MatchResult.TitleAndText || someTagsMatches;
                    }
                    return matchResultForStringQuery(itemToMatch, searchQuery.query) !== MatchResult.None || someTagsMatches;
                }
                exports.itemMatchesQuery = itemMatchesQuery;
                function matchResultForStringQuery(item, searchString) {
                    var _a, _b;
                    if (searchString.length === 0) {
                        return MatchResult.TitleAndText;
                    }
                    const title = (_a = item.title) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                    const text = (_b = item.text) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                    const lowercaseText = searchString.toLowerCase();
                    const words = lowercaseText.split(' ');
                    const quotedText = stringBetweenQuotes(lowercaseText);
                    if (quotedText) {
                        return ((title === null || title === void 0 ? void 0 : title.includes(quotedText)) ? MatchResult.Title : MatchResult.None) + ((text === null || text === void 0 ? void 0 : text.includes(quotedText)) ? MatchResult.Text : MatchResult.None);
                    }
                    if (stringIsUuid(lowercaseText)) {
                        return item.uuid === lowercaseText ? MatchResult.Uuid : MatchResult.None;
                    }
                    const matchesTitle = title && words.every(word => {
                        return title.indexOf(word) >= 0;
                    });
                    const matchesBody = text && words.every(word => {
                        return text.indexOf(word) >= 0;
                    });
                    return (matchesTitle ? MatchResult.Title : 0) + (matchesBody ? MatchResult.Text : 0);
                }
                function stringBetweenQuotes(text) {
                    const matches = text.match(/"(.*?)"/);
                    return matches ? matches[1] : null;
                }
                function stringIsUuid(text) {
                    const matches = text.match(/\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/);
                    return matches ? true : false;
                }
                /***/ 
            }),
            /***/ 29816: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74379: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 99548: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.sortTwoItems = exports.KeepSameOrder = exports.SortRightFirst = exports.SortLeftFirst = void 0;
                const utils_1 = __webpack_require__(87901);
                const CollectionSort_1 = __webpack_require__(92207);
                exports.SortLeftFirst = -1;
                exports.SortRightFirst = 1;
                exports.KeepSameOrder = 0;
                /** @O(n * log(n)) */
                function sortTwoItems(a, b, sortBy, sortDirection) {
                    let bypassPinCheck = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                    /** If the elements are undefined, move to beginning */
                    if (!a) {
                        return exports.SortLeftFirst;
                    }
                    if (!b) {
                        return exports.SortRightFirst;
                    }
                    if (!bypassPinCheck) {
                        if (a.pinned && b.pinned) {
                            return sortTwoItems(a, b, sortBy, sortDirection, true);
                        }
                        if (a.pinned) {
                            return exports.SortLeftFirst;
                        }
                        if (b.pinned) {
                            return exports.SortRightFirst;
                        }
                    }
                    const aValue = a[sortBy] || '';
                    const bValue = b[sortBy] || '';
                    const smallerNaturallyComesFirst = sortDirection === 'asc';
                    let compareResult = exports.KeepSameOrder;
                    /**
                     * Check for string length due to issue on React Native 0.65.1
                     * where empty strings causes crash:
                     * https://github.com/facebook/react-native/issues/32174
                     * */
                    if (sortBy === CollectionSort_1.CollectionSort.Title && (0, utils_1.isString)(aValue) && (0, utils_1.isString)(bValue) && aValue.length > 0 && bValue.length > 0) {
                        compareResult = aValue.localeCompare(bValue, 'en', {
                            numeric: true
                        });
                    }
                    else if (aValue > bValue) {
                        compareResult = exports.SortRightFirst;
                    }
                    else if (aValue < bValue) {
                        compareResult = exports.SortLeftFirst;
                    }
                    else {
                        compareResult = exports.KeepSameOrder;
                    }
                    const isLeftSmaller = compareResult === exports.SortLeftFirst;
                    const isLeftBigger = compareResult === exports.SortRightFirst;
                    if (isLeftSmaller) {
                        if (smallerNaturallyComesFirst) {
                            return exports.SortLeftFirst;
                        }
                        else {
                            return exports.SortRightFirst;
                        }
                    }
                    else if (isLeftBigger) {
                        if (smallerNaturallyComesFirst) {
                            return exports.SortRightFirst;
                        }
                        else {
                            return exports.SortLeftFirst;
                        }
                    }
                    else {
                        return exports.KeepSameOrder;
                    }
                }
                exports.sortTwoItems = sortTwoItems;
                /***/ 
            }),
            /***/ 93974: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 45408: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CollectionCriteriaValidator = void 0;
                class CollectionCriteriaValidator {
                    constructor(collection, element) {
                        this.collection = collection;
                        this.element = element;
                    }
                    passes() {
                        return this.collection.has(this.element.uuid);
                    }
                }
                exports.CollectionCriteriaValidator = CollectionCriteriaValidator;
                /***/ 
            }),
            /***/ 79256: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CustomFilterCriteriaValidator = void 0;
                class CustomFilterCriteriaValidator {
                    constructor(customFilter, element) {
                        this.customFilter = customFilter;
                        this.element = element;
                    }
                    passes() {
                        return this.customFilter(this.element);
                    }
                }
                exports.CustomFilterCriteriaValidator = CustomFilterCriteriaValidator;
                /***/ 
            }),
            /***/ 19688: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ExcludeVaultsCriteriaValidator = void 0;
                class ExcludeVaultsCriteriaValidator {
                    constructor(excludeVaults, element) {
                        this.excludeVaults = excludeVaults;
                        this.element = element;
                    }
                    passes() {
                        const doesElementBelongToExcludedVault = this.excludeVaults.some(vault => this.element.key_system_identifier === vault);
                        return !doesElementBelongToExcludedVault;
                    }
                }
                exports.ExcludeVaultsCriteriaValidator = ExcludeVaultsCriteriaValidator;
                /***/ 
            }),
            /***/ 52197: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ExclusiveVaultCriteriaValidator = void 0;
                class ExclusiveVaultCriteriaValidator {
                    constructor(exclusiveVault, element) {
                        this.exclusiveVault = exclusiveVault;
                        this.element = element;
                    }
                    passes() {
                        return this.element.key_system_identifier === this.exclusiveVault;
                    }
                }
                exports.ExclusiveVaultCriteriaValidator = ExclusiveVaultCriteriaValidator;
                /***/ 
            }),
            /***/ 59017: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.HiddenContentCriteriaValidator = void 0;
                class HiddenContentCriteriaValidator {
                    constructor(hiddenContentTypes, element) {
                        this.hiddenContentTypes = hiddenContentTypes;
                        this.element = element;
                    }
                    passes() {
                        return !this.hiddenContentTypes.includes(this.element.content_type);
                    }
                }
                exports.HiddenContentCriteriaValidator = HiddenContentCriteriaValidator;
                /***/ 
            }),
            /***/ 67104: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.VaultDisplayOptions = void 0;
                const utils_1 = __webpack_require__(87901);
                const VaultDisplayOptionsTypes_1 = __webpack_require__(41574);
                function KeySystemIdentifiers(vaults) {
                    return vaults.map(vault => vault.systemIdentifier);
                }
                class VaultDisplayOptions {
                    constructor(options) {
                        this.options = options;
                    }
                    getOptions() {
                        return this.options;
                    }
                    getExclusivelyShownVault() {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            throw new Error('Not in exclusive display mode');
                        }
                        return this.options.exclusive;
                    }
                    isInExclusiveDisplayMode() {
                        return !(0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options);
                    }
                    isVaultExplicitlyExcluded(vault) {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            return this.options.exclude.some(excludedVault => excludedVault === vault.systemIdentifier);
                        }
                        else if (this.options.exclusive) {
                            return this.options.exclusive !== vault.systemIdentifier;
                        }
                        throw new Error('Invalid vault display options');
                    }
                    isVaultExclusivelyShown(vault) {
                        return !(0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options) && this.options.exclusive === vault.systemIdentifier;
                    }
                    isVaultDisabledOrLocked(vault) {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            const matchingLocked = this.options.locked.find(lockedVault => lockedVault === vault.systemIdentifier);
                            if (matchingLocked) {
                                return true;
                            }
                        }
                        return this.isVaultExplicitlyExcluded(vault);
                    }
                    getPersistableValue() {
                        return this.options;
                    }
                    newOptionsByIntakingLockedVaults(lockedVaults) {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            return new VaultDisplayOptions({
                                exclude: this.options.exclude,
                                locked: KeySystemIdentifiers(lockedVaults)
                            });
                        }
                        else {
                            return new VaultDisplayOptions({
                                exclusive: this.options.exclusive
                            });
                        }
                    }
                    newOptionsByExcludingVault(vault, lockedVaults) {
                        return this.newOptionsByExcludingVaults([vault], lockedVaults);
                    }
                    newOptionsByExcludingVaults(vaults, lockedVaults) {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            return new VaultDisplayOptions({
                                exclude: (0, utils_1.uniqueArray)([...this.options.exclude, ...KeySystemIdentifiers(vaults)]),
                                locked: KeySystemIdentifiers(lockedVaults)
                            });
                        }
                        else {
                            return new VaultDisplayOptions({
                                exclude: KeySystemIdentifiers(vaults),
                                locked: KeySystemIdentifiers(lockedVaults)
                            });
                        }
                    }
                    newOptionsByUnexcludingVault(vault, lockedVaults) {
                        if ((0, VaultDisplayOptionsTypes_1.isExclusionaryOptionsValue)(this.options)) {
                            return new VaultDisplayOptions({
                                exclude: this.options.exclude.filter(excludedVault => excludedVault !== vault.systemIdentifier),
                                locked: KeySystemIdentifiers(lockedVaults)
                            });
                        }
                        else {
                            return new VaultDisplayOptions({
                                exclude: [],
                                locked: KeySystemIdentifiers(lockedVaults)
                            });
                        }
                    }
                    static FromPersistableValue(value) {
                        return new VaultDisplayOptions(value);
                    }
                }
                exports.VaultDisplayOptions = VaultDisplayOptions;
                /***/ 
            }),
            /***/ 41574: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isExclusionaryOptionsValue = void 0;
                function isExclusionaryOptionsValue(options) {
                    return 'exclude' in options || 'locked' in options;
                }
                exports.isExclusionaryOptionsValue = isExclusionaryOptionsValue;
                /***/ 
            }),
            /***/ 30561: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(55823), exports);
                __exportStar(__webpack_require__(91176), exports);
                __exportStar(__webpack_require__(40257), exports);
                __exportStar(__webpack_require__(50149), exports);
                __exportStar(__webpack_require__(29816), exports);
                __exportStar(__webpack_require__(35509), exports);
                __exportStar(__webpack_require__(74379), exports);
                __exportStar(__webpack_require__(93974), exports);
                __exportStar(__webpack_require__(67104), exports);
                __exportStar(__webpack_require__(41574), exports);
                /***/ 
            }),
            /***/ 87332: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentTypeUsesKeySystemRootKeyEncryption = void 0;
                const domain_core_1 = __webpack_require__(82648);
                function ContentTypeUsesKeySystemRootKeyEncryption(contentType) {
                    return contentType === domain_core_1.ContentType.TYPES.KeySystemItemsKey;
                }
                exports.ContentTypeUsesKeySystemRootKeyEncryption = ContentTypeUsesKeySystemRootKeyEncryption;
                /***/ 
            }),
            /***/ 21662: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentTypeUsesRootKeyEncryption = void 0;
                const ContentTypesUsingRootKeyEncryption_1 = __webpack_require__(96084);
                function ContentTypeUsesRootKeyEncryption(contentType) {
                    return (0, ContentTypesUsingRootKeyEncryption_1.ContentTypesUsingRootKeyEncryption)().includes(contentType);
                }
                exports.ContentTypeUsesRootKeyEncryption = ContentTypeUsesRootKeyEncryption;
                /***/ 
            }),
            /***/ 96084: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContentTypesUsingRootKeyEncryption = void 0;
                const domain_core_1 = __webpack_require__(82648);
                function ContentTypesUsingRootKeyEncryption() {
                    return [domain_core_1.ContentType.TYPES.RootKey, domain_core_1.ContentType.TYPES.ItemsKey, domain_core_1.ContentType.TYPES.EncryptedStorage, domain_core_1.ContentType.TYPES.TrustedContact, domain_core_1.ContentType.TYPES.KeySystemRootKey];
                }
                exports.ContentTypesUsingRootKeyEncryption = ContentTypesUsingRootKeyEncryption;
                /***/ 
            }),
            /***/ 47469: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74958: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isNativeFeature = exports.isItemBasedFeature = exports.isUIFeatureAnIframeFeature = void 0;
                const features_1 = __webpack_require__(80215);
                function isUIFeatureAnIframeFeature(x) {
                    return (0, features_1.isIframeComponentFeatureDescription)(x.featureDescription);
                }
                exports.isUIFeatureAnIframeFeature = isUIFeatureAnIframeFeature;
                function isItemBasedFeature(x) {
                    return 'uuid' in x;
                }
                exports.isItemBasedFeature = isItemBasedFeature;
                function isNativeFeature(x) {
                    return !('uuid' in x);
                }
                exports.isNativeFeature = isNativeFeature;
                /***/ 
            }),
            /***/ 36053: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UIFeature = void 0;
                const features_1 = __webpack_require__(80215);
                const TypeGuards_1 = __webpack_require__(74958);
                const domain_core_1 = __webpack_require__(82648);
                const Component_1 = __webpack_require__(52659);
                class UIFeature {
                    constructor(item) {
                        this.item = item;
                    }
                    get isComponent() {
                        return (0, TypeGuards_1.isItemBasedFeature)(this.item);
                    }
                    get isThemeComponent() {
                        return (0, TypeGuards_1.isItemBasedFeature)(this.item) && (0, Component_1.isTheme)(this.item);
                    }
                    get asComponent() {
                        if ((0, TypeGuards_1.isItemBasedFeature)(this.item)) {
                            return this.item;
                        }
                        throw new Error('Cannot cast item to component');
                    }
                    get asTheme() {
                        if ((0, TypeGuards_1.isItemBasedFeature)(this.item)) {
                            return this.item;
                        }
                        throw new Error('Cannot cast item to component');
                    }
                    get asFeatureDescription() {
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return this.item;
                        }
                        throw new Error('Cannot cast item to feature description');
                    }
                    get isNativeFeature() {
                        return (0, features_1.FindNativeFeature)(this.featureIdentifier) !== undefined;
                    }
                    get uniqueIdentifier() {
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            const nativeFeature = features_1.NativeFeatureIdentifier.create(this.item.identifier);
                            return nativeFeature.getValue();
                        }
                        else {
                            return domain_core_1.Uuid.create(this.item.uuid).getValue();
                        }
                    }
                    get featureIdentifier() {
                        return this.item.identifier;
                    }
                    get noteType() {
                        var _a;
                        if ((0, TypeGuards_1.isNativeFeature)(this.item) && (0, features_1.isEditorFeatureDescription)(this.item)) {
                            return (_a = this.item.note_type) !== null && _a !== void 0 ? _a : features_1.NoteType.Unknown;
                        }
                        else if ((0, TypeGuards_1.isItemBasedFeature)(this.item)) {
                            return this.item.noteType;
                        }
                        throw new Error('Invalid component or feature description');
                    }
                    get fileType() {
                        var _a, _b;
                        if ((0, TypeGuards_1.isNativeFeature)(this.item) && (0, features_1.isEditorFeatureDescription)(this.item)) {
                            return this.item.file_type;
                        }
                        else if ((0, TypeGuards_1.isItemBasedFeature)(this.item) && (0, features_1.isEditorFeatureDescription)(this.item.package_info)) {
                            return (_b = (_a = this.item.package_info) === null || _a === void 0 ? void 0 : _a.file_type) !== null && _b !== void 0 ? _b : 'txt';
                        }
                        throw new Error('Invalid component or feature description');
                    }
                    get displayName() {
                        var _a;
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return (_a = this.item.name) !== null && _a !== void 0 ? _a : '';
                        }
                        else {
                            return this.item.displayName;
                        }
                    }
                    get description() {
                        var _a, _b;
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return (_a = this.item.description) !== null && _a !== void 0 ? _a : '';
                        }
                        else {
                            return (_b = this.item.package_info.description) !== null && _b !== void 0 ? _b : '';
                        }
                    }
                    get deprecationMessage() {
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return this.item.deprecation_message;
                        }
                        else {
                            return this.item.deprecationMessage;
                        }
                    }
                    get expirationDate() {
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return this.item.expires_at ? new Date(this.item.expires_at) : undefined;
                        }
                        else {
                            return this.item.valid_until;
                        }
                    }
                    get featureDescription() {
                        if ((0, TypeGuards_1.isNativeFeature)(this.item)) {
                            return this.item;
                        }
                        else {
                            return this.item.package_info;
                        }
                    }
                    get acquiredPermissions() {
                        var _a;
                        if ((0, TypeGuards_1.isNativeFeature)(this.item) && (0, features_1.isIframeComponentFeatureDescription)(this.item)) {
                            return (_a = this.item.component_permissions) !== null && _a !== void 0 ? _a : [];
                        }
                        else if ((0, TypeGuards_1.isItemBasedFeature)(this.item)) {
                            return this.item.permissions;
                        }
                        throw new Error('Invalid component or feature description');
                    }
                    get area() {
                        if ('area' in this.item) {
                            return this.item.area;
                        }
                        return features_1.ComponentArea.Editor;
                    }
                    get layerable() {
                        var _a;
                        if ((0, TypeGuards_1.isItemBasedFeature)(this.item) && (0, Component_1.isTheme)(this.item)) {
                            return this.item.layerableTheme;
                        }
                        else if ((0, features_1.isThemeFeatureDescription)(this.asFeatureDescription)) {
                            return (_a = this.asFeatureDescription.layerable) !== null && _a !== void 0 ? _a : false;
                        }
                        return false;
                    }
                    get dockIcon() {
                        if ((0, TypeGuards_1.isItemBasedFeature)(this.item) && (0, Component_1.isTheme)(this.item)) {
                            return this.asTheme.package_info.dock_icon;
                        }
                        else if ((0, features_1.isThemeFeatureDescription)(this.asFeatureDescription)) {
                            return this.asFeatureDescription.dock_icon;
                        }
                        return undefined;
                    }
                }
                exports.UIFeature = UIFeature;
                /***/ 
            }),
            /***/ 18284: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 24715: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateHistoryEntryForPayload = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const HistoryEntry_1 = __webpack_require__(69375);
                const NoteHistoryEntry_1 = __webpack_require__(94068);
                function CreateHistoryEntryForPayload(payload, previousEntry) {
                    const type = payload.content_type;
                    const historyItemClass = historyClassForContentType(type);
                    const entry = new historyItemClass(payload, previousEntry);
                    return entry;
                }
                exports.CreateHistoryEntryForPayload = CreateHistoryEntryForPayload;
                function historyClassForContentType(contentType) {
                    switch (contentType) {
                        case domain_core_1.ContentType.TYPES.Note:
                            return NoteHistoryEntry_1.NoteHistoryEntry;
                        default:
                            return HistoryEntry_1.HistoryEntry;
                    }
                }
                /***/ 
            }),
            /***/ 69375: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.HistoryEntry = void 0;
                const utils_1 = __webpack_require__(87901);
                const ItemGenerator_1 = __webpack_require__(73277);
                class HistoryEntry {
                    constructor(payload, previousEntry) {
                        var _a;
                        this.defaultContentKeyToDiffOn = 'text';
                        this.payload = payload.copy();
                        this.previousEntry = previousEntry;
                        this.hasPreviousEntry = !(0, utils_1.isNullOrUndefined)(previousEntry);
                        /** We'll try to compute the delta based on an assumed
                         * content property of `text`, if it exists. */
                        const propertyValue = this.payload.content[this.defaultContentKeyToDiffOn];
                        if (propertyValue) {
                            if (previousEntry) {
                                const previousValue = ((_a = previousEntry.payload.content[this.defaultContentKeyToDiffOn]) === null || _a === void 0 ? void 0 : _a.length) || 0;
                                this.textCharDiffLength = propertyValue.length - previousValue;
                            }
                            else {
                                this.textCharDiffLength = propertyValue.length;
                            }
                        }
                        else {
                            this.textCharDiffLength = 0;
                        }
                    }
                    itemFromPayload() {
                        return (0, ItemGenerator_1.CreateDecryptedItemFromPayload)(this.payload);
                    }
                    isSameAsEntry(entry) {
                        if (!entry) {
                            return false;
                        }
                        const lhs = this.itemFromPayload();
                        const rhs = entry.itemFromPayload();
                        const datesEqual = lhs.userModifiedDate.getTime() === rhs.userModifiedDate.getTime();
                        if (!datesEqual) {
                            return false;
                        }
                        /** Dates are the same, but because JS is only accurate to milliseconds,
                         * items can have different content but same dates */
                        return lhs.isItemContentEqualWith(rhs);
                    }
                    isDiscardable() {
                        return false;
                    }
                    operationVector() {
                        /**
                         * We'll try to use the value of `textCharDiffLength`
                         * to help determine this, if it's set
                         */
                        if (this.textCharDiffLength !== undefined) {
                            if (!this.hasPreviousEntry || this.textCharDiffLength === 0) {
                                return 0;
                            }
                            else if (this.textCharDiffLength < 0) {
                                return -1;
                            }
                            else {
                                return 1;
                            }
                        }
                        /** Otherwise use a default value of 1 */
                        return 1;
                    }
                    deltaSize() {
                        /**
                         * Up to the subclass to determine how large the delta was,
                         * i.e number of characters changed.
                         * But this general class won't be able to determine which property it
                         * should diff on, or even its format.
                         */
                        /**
                         * We can return the `textCharDiffLength` if it's set,
                         * otherwise, just return 1;
                         */
                        if (this.textCharDiffLength !== undefined) {
                            return Math.abs(this.textCharDiffLength);
                        }
                        /**
                         * Otherwise return 1 here to constitute a basic positive delta.
                         * The value returned should always be positive. Override `operationVector`
                         * to return the direction of the delta.
                         */
                        return 1;
                    }
                }
                exports.HistoryEntry = HistoryEntry;
                /***/ 
            }),
            /***/ 30545: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 97873: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.historyMapFunctions = void 0;
                exports.historyMapFunctions = {
                    getNewestRevision: history => {
                        return history[0];
                    }
                };
                /***/ 
            }),
            /***/ 94068: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NoteHistoryEntry = void 0;
                const utils_1 = __webpack_require__(87901);
                const HistoryEntry_1 = __webpack_require__(69375);
                class NoteHistoryEntry extends HistoryEntry_1.HistoryEntry {
                    previewTitle() {
                        if (this.payload.updated_at.getTime() > 0) {
                            return this.payload.updated_at.toLocaleString();
                        }
                        else {
                            return this.payload.created_at.toLocaleString();
                        }
                    }
                    previewSubTitle() {
                        if (!this.hasPreviousEntry) {
                            return "".concat(this.textCharDiffLength, " characters loaded");
                        }
                        else if (this.textCharDiffLength < 0) {
                            return "".concat(this.textCharDiffLength * -1, " characters removed");
                        }
                        else if (this.textCharDiffLength > 0) {
                            return "".concat(this.textCharDiffLength, " characters added");
                        }
                        else {
                            return 'Title or metadata changed';
                        }
                    }
                    isDiscardable() {
                        return (0, utils_1.isEmpty)(this.payload.content.text);
                    }
                }
                exports.NoteHistoryEntry = NoteHistoryEntry;
                /***/ 
            }),
            /***/ 78274: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(24715), exports);
                __exportStar(__webpack_require__(69375), exports);
                __exportStar(__webpack_require__(97873), exports);
                __exportStar(__webpack_require__(94068), exports);
                __exportStar(__webpack_require__(30545), exports);
                /***/ 
            }),
            /***/ 47479: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateItemDelta = void 0;
                function CreateItemDelta(partial) {
                    return {
                        changed: partial.changed || [],
                        inserted: partial.inserted || [],
                        discarded: partial.discarded || [],
                        ignored: partial.ignored || [],
                        unerrored: partial.unerrored || []
                    };
                }
                exports.CreateItemDelta = CreateItemDelta;
                /***/ 
            }),
            /***/ 21626: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 8698: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CompoundPredicate = void 0;
                class CompoundPredicate {
                    constructor(operator, predicates) {
                        this.operator = operator;
                        this.predicates = predicates;
                    }
                    matchesItem(item) {
                        if (this.operator === 'and') {
                            for (const subPredicate of this.predicates) {
                                if (!subPredicate.matchesItem(item)) {
                                    return false;
                                }
                            }
                            return true;
                        }
                        if (this.operator === 'or') {
                            for (const subPredicate of this.predicates) {
                                if (subPredicate.matchesItem(item)) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        return false;
                    }
                    keypathIncludesString(verb) {
                        for (const subPredicate of this.predicates) {
                            if (subPredicate.keypathIncludesString(verb)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    toJson() {
                        return {
                            operator: this.operator,
                            value: this.predicates.map(predicate => predicate.toJson())
                        };
                    }
                }
                exports.CompoundPredicate = CompoundPredicate;
                /***/ 
            }),
            /***/ 26550: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.predicateFromDSLString = exports.predicateFromJson = exports.includesPredicateFromArguments = exports.notPredicateFromArguments = exports.compoundPredicateFromArguments = exports.predicateFromArguments = void 0;
                const CompoundPredicate_1 = __webpack_require__(8698);
                const IncludesPredicate_1 = __webpack_require__(80389);
                const Interface_1 = __webpack_require__(21271);
                const NotPredicate_1 = __webpack_require__(73067);
                const Predicate_1 = __webpack_require__(78688);
                function predicateFromArguments(keypath, operator, value) {
                    if (Interface_1.AllPredicateCompoundOperators.includes(operator)) {
                        return compoundPredicateFromArguments(operator, value);
                    }
                    else if (operator === 'not') {
                        return new NotPredicate_1.NotPredicate(predicateFromJson(value));
                    }
                    else if (operator === 'includes' && keypath) {
                        if (isSureValue(value)) {
                            return new Predicate_1.Predicate(keypath, operator, value);
                        }
                        else {
                            return new IncludesPredicate_1.IncludesPredicate(keypath, predicateFromJson(value));
                        }
                    }
                    else if (keypath) {
                        return new Predicate_1.Predicate(keypath, operator, value);
                    }
                    throw Error('Invalid predicate arguments');
                }
                exports.predicateFromArguments = predicateFromArguments;
                function compoundPredicateFromArguments(operator, value) {
                    const subPredicates = value.map(jsonPredicate => {
                        return predicateFromJson(jsonPredicate);
                    });
                    return new CompoundPredicate_1.CompoundPredicate(operator, subPredicates);
                }
                exports.compoundPredicateFromArguments = compoundPredicateFromArguments;
                function notPredicateFromArguments(value) {
                    const subPredicate = predicateFromJson(value);
                    return new NotPredicate_1.NotPredicate(subPredicate);
                }
                exports.notPredicateFromArguments = notPredicateFromArguments;
                function includesPredicateFromArguments(keypath, value) {
                    const subPredicate = predicateFromJson(value);
                    return new IncludesPredicate_1.IncludesPredicate(keypath, subPredicate);
                }
                exports.includesPredicateFromArguments = includesPredicateFromArguments;
                function predicateFromJson(values) {
                    if (Array.isArray(values)) {
                        throw Error('Invalid predicateFromJson value');
                    }
                    return predicateFromArguments(values.keypath, values.operator, isValuePredicateInArrayForm(values.value) ? predicateDSLArrayToJsonPredicate(values.value) : values.value);
                }
                exports.predicateFromJson = predicateFromJson;
                function predicateFromDSLString(dsl) {
                    try {
                        const components = JSON.parse(dsl.substring(1, dsl.length));
                        components.shift();
                        const predicateJson = predicateDSLArrayToJsonPredicate(components);
                        return predicateFromJson(predicateJson);
                    }
                    catch (e) {
                        throw Error("Invalid smart view syntax ".concat(JSON.stringify(e)));
                    }
                }
                exports.predicateFromDSLString = predicateFromDSLString;
                function isValuePredicateInArrayForm(value) {
                    return Array.isArray(value) && Interface_1.AllPredicateOperators.includes(value[1]);
                }
                function isSureValue(value) {
                    if (Interface_1.SureValueNonObjectTypesAsStrings.includes(typeof value)) {
                        return true;
                    }
                    if (Array.isArray(value)) {
                        return !isValuePredicateInArrayForm(value);
                    }
                    return false;
                }
                function predicateDSLArrayToJsonPredicate(predicateArray) {
                    const predicateValue = predicateArray[2];
                    let resolvedPredicateValue;
                    if (Array.isArray(predicateValue)) {
                        const level1CondensedValue = predicateValue;
                        if (Array.isArray(level1CondensedValue[0])) {
                            const level2CondensedValue = level1CondensedValue;
                            resolvedPredicateValue = level2CondensedValue.map(subPredicate => predicateDSLArrayToJsonPredicate(subPredicate));
                        }
                        else if (isValuePredicateInArrayForm(predicateValue[1])) {
                            const level2CondensedValue = level1CondensedValue;
                            resolvedPredicateValue = predicateDSLArrayToJsonPredicate(level2CondensedValue);
                        }
                        else {
                            const level2CondensedValue = predicateValue;
                            resolvedPredicateValue = level2CondensedValue;
                        }
                    }
                    else {
                        const level1CondensedValue = predicateValue;
                        resolvedPredicateValue = level1CondensedValue;
                    }
                    return {
                        keypath: predicateArray[0],
                        operator: predicateArray[1],
                        value: resolvedPredicateValue
                    };
                }
                /***/ 
            }),
            /***/ 80389: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.IncludesPredicate = void 0;
                class IncludesPredicate {
                    constructor(keypath, predicate) {
                        this.keypath = keypath;
                        this.predicate = predicate;
                    }
                    matchesItem(item) {
                        const keyPathComponents = this.keypath.split('.');
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const valueAtKeyPath = keyPathComponents.reduce((previous, current) => {
                            return previous && previous[current];
                        }, item);
                        if (!Array.isArray(valueAtKeyPath)) {
                            return false;
                        }
                        return valueAtKeyPath.some(subItem => this.predicate.matchesItem(subItem));
                    }
                    keypathIncludesString(verb) {
                        return this.keypath.includes(verb);
                    }
                    toJson() {
                        return {
                            keypath: this.keypath,
                            operator: 'includes',
                            value: this.predicate.toJson()
                        };
                    }
                }
                exports.IncludesPredicate = IncludesPredicate;
                /***/ 
            }),
            /***/ 21271: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SureValueNonObjectTypesAsStrings = exports.AllPredicateOperators = exports.AllNonCompoundPredicateOperators = exports.AllPredicateCompoundOperators = void 0;
                exports.AllPredicateCompoundOperators = ['and', 'or'];
                exports.AllNonCompoundPredicateOperators = ['!=', '=', '<', '>', '<=', '>=', 'startsWith', 'in', 'matches', 'not', 'includes'];
                exports.AllPredicateOperators = [...exports.AllPredicateCompoundOperators, ...exports.AllNonCompoundPredicateOperators];
                exports.SureValueNonObjectTypesAsStrings = ['number', 'string', 'boolean'];
                /***/ 
            }),
            /***/ 73067: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NotPredicate = void 0;
                class NotPredicate {
                    constructor(predicate) {
                        this.predicate = predicate;
                    }
                    matchesItem(item) {
                        return !this.predicate.matchesItem(item);
                    }
                    keypathIncludesString(verb) {
                        return this.predicate.keypathIncludesString(verb);
                    }
                    toJson() {
                        return {
                            operator: 'not',
                            value: this.predicate.toJson()
                        };
                    }
                }
                exports.NotPredicate = NotPredicate;
                /***/ 
            }),
            /***/ 21014: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.valueMatchesTargetValue = void 0;
                const utils_1 = __webpack_require__(87901);
                const Utils_1 = __webpack_require__(58506);
                function valueMatchesTargetValue(value, operator, targetValue) {
                    if (targetValue == undefined) {
                        return false;
                    }
                    if (typeof targetValue === 'string' && targetValue.includes('.ago')) {
                        targetValue = (0, Utils_1.dateFromDSLDateString)(targetValue);
                    }
                    if (typeof targetValue === 'string') {
                        targetValue = targetValue.toLowerCase();
                    }
                    if (typeof value === 'string') {
                        value = value.toLowerCase();
                    }
                    if (value instanceof Date && typeof targetValue === 'string') {
                        targetValue = new Date(targetValue);
                    }
                    if (operator === 'not') {
                        return !valueMatchesTargetValue(value, '=', targetValue);
                    }
                    const falseyValues = [false, '', null, undefined, NaN];
                    if (value == undefined) {
                        const isExpectingFalseyValue = falseyValues.includes(targetValue);
                        if (operator === '!=') {
                            return !isExpectingFalseyValue;
                        }
                        else {
                            return isExpectingFalseyValue;
                        }
                    }
                    if (operator === '=') {
                        if (Array.isArray(value)) {
                            return JSON.stringify(value) === JSON.stringify(targetValue);
                        }
                        else {
                            return value === targetValue;
                        }
                    }
                    if (operator === '!=') {
                        if (Array.isArray(value)) {
                            return JSON.stringify(value) !== JSON.stringify(targetValue);
                        }
                        else {
                            return value !== targetValue;
                        }
                    }
                    if (operator === '<') {
                        return value < targetValue;
                    }
                    if (operator === '>') {
                        return value > targetValue;
                    }
                    if (operator === '<=') {
                        return value <= targetValue;
                    }
                    if (operator === '>=') {
                        return value >= targetValue;
                    }
                    if (operator === 'startsWith') {
                        return value.startsWith(targetValue);
                    }
                    if (operator === 'in' && Array.isArray(targetValue)) {
                        return targetValue.includes(value);
                    }
                    if (operator === 'includes') {
                        if ((0, utils_1.isString)(value)) {
                            return value.includes(targetValue);
                        }
                        if ((0, utils_1.isString)(targetValue) && ((0, utils_1.isString)(value) || Array.isArray(value))) {
                            return value.includes(targetValue);
                        }
                    }
                    if (operator === 'matches') {
                        const regex = new RegExp(targetValue);
                        return regex.test(value);
                    }
                    return false;
                }
                exports.valueMatchesTargetValue = valueMatchesTargetValue;
                /***/ 
            }),
            /***/ 78688: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Predicate = void 0;
                const Operator_1 = __webpack_require__(21014);
                /**
                 * A local-only construct that defines a built query that
                 * can be used to dynamically search items.
                 */
                class Predicate {
                    constructor(keypath, operator, targetValue) {
                        this.keypath = keypath;
                        this.operator = operator;
                        this.targetValue = targetValue;
                        if (this.targetValue === 'true' || this.targetValue === 'false') {
                            this.targetValue = JSON.parse(this.targetValue);
                        }
                    }
                    keypathIncludesString(verb) {
                        return this.keypath.includes(verb);
                    }
                    matchesItem(item) {
                        const keyPathComponents = this.keypath.split('.');
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const valueAtKeyPath = keyPathComponents.reduce((previous, current) => {
                            return previous && previous[current];
                        }, item);
                        return (0, Operator_1.valueMatchesTargetValue)(valueAtKeyPath, this.operator, this.targetValue);
                    }
                    toJson() {
                        return {
                            keypath: this.keypath,
                            operator: this.operator,
                            value: this.targetValue
                        };
                    }
                }
                exports.Predicate = Predicate;
                /***/ 
            }),
            /***/ 58506: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.dateFromDSLDateString = void 0;
                /**
                 * Predicate date strings are of form "x.days.ago" or "x.hours.ago"
                 */
                function dateFromDSLDateString(string) {
                    const comps = string.split('.');
                    const unit = comps[1];
                    const date = new Date();
                    const offset = parseInt(comps[0]);
                    if (unit === 'days') {
                        date.setDate(date.getDate() - offset);
                    }
                    else if (unit === 'hours') {
                        date.setHours(date.getHours() - offset);
                    }
                    else if (unit === 'months') {
                        date.setMonth(date.getMonth() - offset);
                    }
                    else if (unit === 'years') {
                        date.setFullYear(date.getFullYear() - offset);
                    }
                    return date;
                }
                exports.dateFromDSLDateString = dateFromDSLDateString;
                /***/ 
            }),
            /***/ 59020: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNActionsExtension = void 0;
                const DecryptedItem_1 = __webpack_require__(43740);
                const ConflictStrategy_1 = __webpack_require__(43610);
                /**
                 * Related to the SNActionsService and the local Action model.
                 */
                class SNActionsExtension extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.actions = [];
                        this.name = payload.content.name || '';
                        this.description = payload.content.description || '';
                        this.url = payload.content.hosted_url || payload.content.url;
                        this.supported_types = payload.content.supported_types;
                        this.package_info = this.payload.content.package_info || {};
                        this.deprecation = payload.content.deprecation;
                        this.actions = payload.content.actions;
                    }
                    get displayName() {
                        return this.name;
                    }
                    get thirdPartyPackageInfo() {
                        return this.package_info;
                    }
                    get isListedExtension() {
                        return this.package_info.identifier === 'org.standardnotes.listed';
                    }
                    actionsWithContextForItem(item) {
                        return this.actions.filter(action => {
                            return action.context === item.content_type || action.context === 'Item';
                        });
                    }
                    /** Do not duplicate. Always keep original */
                    strategyWhenConflictingWithItem(_item, _previousRevision) {
                        return ConflictStrategy_1.ConflictStrategy.KeepBase;
                    }
                }
                exports.SNActionsExtension = SNActionsExtension;
                /***/ 
            }),
            /***/ 27539: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ActionsExtensionMutator = void 0;
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                class ActionsExtensionMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    set description(description) {
                        this.mutableContent.description = description;
                    }
                    set supported_types(supported_types) {
                        this.mutableContent.supported_types = supported_types;
                    }
                    set actions(actions) {
                        this.mutableContent.actions = actions;
                    }
                    set deprecation(deprecation) {
                        this.mutableContent.deprecation = deprecation;
                    }
                }
                exports.ActionsExtensionMutator = ActionsExtensionMutator;
                /***/ 
            }),
            /***/ 82531: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ActionVerb = exports.ActionAccessType = void 0;
                var ActionAccessType;
                (function (ActionAccessType) {
                    ActionAccessType["Encrypted"] = "encrypted";
                    ActionAccessType["Decrypted"] = "decrypted";
                })(ActionAccessType || (exports.ActionAccessType = ActionAccessType = {}));
                var ActionVerb;
                (function (ActionVerb) {
                    ActionVerb["Get"] = "get";
                    ActionVerb["Render"] = "render";
                    ActionVerb["Show"] = "show";
                    ActionVerb["Post"] = "post";
                    ActionVerb["Nested"] = "nested";
                })(ActionVerb || (exports.ActionVerb = ActionVerb = {}));
                /***/ 
            }),
            /***/ 40826: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(59020), exports);
                __exportStar(__webpack_require__(27539), exports);
                __exportStar(__webpack_require__(82531), exports);
                /***/ 
            }),
            /***/ 35922: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentItem = void 0;
                const utils_1 = __webpack_require__(87901);
                const features_1 = __webpack_require__(80215);
                const AppDataField_1 = __webpack_require__(68716);
                const ConflictStrategy_1 = __webpack_require__(43610);
                const DecryptedItem_1 = __webpack_require__(43740);
                const Predicate_1 = __webpack_require__(78688);
                const domain_core_1 = __webpack_require__(82648);
                /**
                 * Components are mostly iframe based extensions that communicate with the SN parent
                 * via the postMessage API. However, a theme can also be a component, which is activated
                 * only by its url.
                 */
                class ComponentItem extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        var _a, _b, _c;
                        super(payload);
                        this.permissions = [];
                        if (payload.content.hosted_url && (0, utils_1.isValidUrl)(payload.content.hosted_url)) {
                            this.hosted_url = payload.content.hosted_url;
                        }
                        else if (payload.content.url && (0, utils_1.isValidUrl)(payload.content.url)) {
                            this.hosted_url = payload.content.url;
                        }
                        else if (payload.content.legacy_url && (0, utils_1.isValidUrl)(payload.content.legacy_url)) {
                            this.hosted_url = payload.content.legacy_url;
                        }
                        this.local_url = payload.content.local_url;
                        this.valid_until = new Date(payload.content.valid_until || 0);
                        this.offlineOnly = (_a = payload.content.offlineOnly) !== null && _a !== void 0 ? _a : false;
                        this.name = payload.content.name;
                        if (this.content_type === domain_core_1.ContentType.TYPES.Theme) {
                            this.area = features_1.ComponentArea.Themes;
                        }
                        else {
                            this.area = payload.content.area;
                        }
                        this.package_info = payload.content.package_info || {};
                        this.permissions = payload.content.permissions || [];
                        this.autoupdateDisabled = (_b = payload.content.autoupdateDisabled) !== null && _b !== void 0 ? _b : false;
                        this.disassociatedItemIds = payload.content.disassociatedItemIds || [];
                        this.associatedItemIds = payload.content.associatedItemIds || [];
                        /**
                         * @legacy
                         * We don't want to set this.url directly, as we'd like to phase it out.
                         * If the content.url exists, we'll transfer it to legacy_url. We'll only
                         * need to set this if content.hosted_url is blank, otherwise,
                         * hosted_url is the url replacement.
                         */
                        this.legacy_url = !payload.content.hosted_url ? payload.content.url : undefined;
                        this.legacyComponentData = this.payload.content.componentData || {};
                        this.legacyActive = (_c = payload.content.active) !== null && _c !== void 0 ? _c : false;
                    }
                    /** Do not duplicate components under most circumstances. Always keep original */
                    strategyWhenConflictingWithItem(_item, _previousRevision) {
                        return ConflictStrategy_1.ConflictStrategy.KeepBase;
                    }
                    get isSingleton() {
                        return true;
                    }
                    get displayName() {
                        var _a;
                        return ((_a = (0, features_1.FindNativeFeature)(this.identifier)) === null || _a === void 0 ? void 0 : _a.name) || this.name;
                    }
                    singletonPredicate() {
                        const uniqueIdentifierPredicate = new Predicate_1.Predicate('identifier', '=', this.identifier);
                        return uniqueIdentifierPredicate;
                    }
                    isTheme() {
                        return this.content_type === domain_core_1.ContentType.TYPES.Theme || this.area === features_1.ComponentArea.Themes;
                    }
                    /** @deprecated Use global application PrefKey.DefaultEditorIdentifier */
                    legacyIsDefaultEditor() {
                        return this.getAppDomainValue(AppDataField_1.AppDataField.DefaultEditor) === true;
                    }
                    hasValidHostedUrl() {
                        return (this.hosted_url || this.legacy_url) != undefined;
                    }
                    contentKeysToIgnoreWhenCheckingEquality() {
                        const componentKeys = ['active', 'disassociatedItemIds', 'associatedItemIds'];
                        const superKeys = super.contentKeysToIgnoreWhenCheckingEquality();
                        return [...componentKeys, ...superKeys];
                    }
                    isExplicitlyEnabledForItem(uuid) {
                        return this.associatedItemIds.indexOf(uuid) !== -1;
                    }
                    isExplicitlyDisabledForItem(uuid) {
                        return this.disassociatedItemIds.indexOf(uuid) !== -1;
                    }
                    get isExpired() {
                        return this.valid_until.getTime() > 0 && this.valid_until <= new Date();
                    }
                    get identifier() {
                        return this.package_info.identifier;
                    }
                    get thirdPartyPackageInfo() {
                        return this.package_info;
                    }
                    get noteType() {
                        var _a;
                        if ((0, features_1.isEditorFeatureDescription)(this.package_info)) {
                            return (_a = this.package_info.note_type) !== null && _a !== void 0 ? _a : features_1.NoteType.Unknown;
                        }
                        return features_1.NoteType.Unknown;
                    }
                    get isDeprecated() {
                        var _a;
                        let flags = (_a = this.package_info.flags) !== null && _a !== void 0 ? _a : [];
                        flags = flags.map(flag => flag.toLowerCase());
                        return flags.includes(features_1.ComponentFlag.Deprecated);
                    }
                    get deprecationMessage() {
                        return this.package_info.deprecation_message;
                    }
                    get layerableTheme() {
                        var _a;
                        if (!this.isTheme()) {
                            return false;
                        }
                        const themePackageInfo = this.package_info;
                        return (_a = themePackageInfo === null || themePackageInfo === void 0 ? void 0 : themePackageInfo.layerable) !== null && _a !== void 0 ? _a : false;
                    }
                }
                exports.ComponentItem = ComponentItem;
                /***/ 
            }),
            /***/ 12740: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80755: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43246: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ComponentMutator = void 0;
                const utils_1 = __webpack_require__(87901);
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                class ComponentMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    set package_info(package_info) {
                        this.mutableContent.package_info = package_info;
                    }
                    set local_url(local_url) {
                        this.mutableContent.local_url = local_url;
                    }
                    set hosted_url(hosted_url) {
                        this.mutableContent.hosted_url = hosted_url;
                    }
                    set valid_until(valid_until) {
                        this.mutableContent.valid_until = valid_until;
                    }
                    set permissions(permissions) {
                        this.mutableContent.permissions = permissions;
                    }
                    set name(name) {
                        this.mutableContent.name = name;
                    }
                    set offlineOnly(offlineOnly) {
                        this.mutableContent.offlineOnly = offlineOnly;
                    }
                    associateWithItem(uuid) {
                        const associated = this.mutableContent.associatedItemIds || [];
                        (0, utils_1.addIfUnique)(associated, uuid);
                        this.mutableContent.associatedItemIds = associated;
                    }
                    disassociateWithItem(uuid) {
                        const disassociated = this.mutableContent.disassociatedItemIds || [];
                        (0, utils_1.addIfUnique)(disassociated, uuid);
                        this.mutableContent.disassociatedItemIds = disassociated;
                    }
                    removeAssociatedItemId(uuid) {
                        (0, utils_1.removeFromArray)(this.mutableContent.associatedItemIds || [], uuid);
                    }
                    removeDisassociatedItemId(uuid) {
                        (0, utils_1.removeFromArray)(this.mutableContent.disassociatedItemIds || [], uuid);
                    }
                }
                exports.ComponentMutator = ComponentMutator;
                /***/ 
            }),
            /***/ 78446: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 54218: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isComponentOrTheme = exports.isTheme = exports.isComponent = void 0;
                const Item_1 = __webpack_require__(50292);
                const domain_core_1 = __webpack_require__(82648);
                function isComponent(x) {
                    if (!(0, Item_1.isDecryptedItem)(x)) {
                        return false;
                    }
                    return x.content_type === domain_core_1.ContentType.TYPES.Component;
                }
                exports.isComponent = isComponent;
                function isTheme(x) {
                    if (!(0, Item_1.isDecryptedItem)(x)) {
                        return false;
                    }
                    return x.content_type === domain_core_1.ContentType.TYPES.Theme;
                }
                exports.isTheme = isTheme;
                function isComponentOrTheme(x) {
                    if (!(0, Item_1.isDecryptedItem)(x)) {
                        return false;
                    }
                    return x.content_type === domain_core_1.ContentType.TYPES.Component || x.content_type === domain_core_1.ContentType.TYPES.Theme;
                }
                exports.isComponentOrTheme = isComponentOrTheme;
                /***/ 
            }),
            /***/ 52659: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(35922), exports);
                __exportStar(__webpack_require__(43246), exports);
                __exportStar(__webpack_require__(12740), exports);
                __exportStar(__webpack_require__(80755), exports);
                __exportStar(__webpack_require__(78446), exports);
                __exportStar(__webpack_require__(54218), exports);
                /***/ 
            }),
            /***/ 55159: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNEditor = void 0;
                const DecryptedItem_1 = __webpack_require__(43740);
                /**
                 * @deprecated
                 * Editor objects are depracated in favor of ComponentItem objects
                 */
                class SNEditor extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.notes = [];
                        this.data = {};
                        this.url = payload.content.url;
                        this.name = payload.content.name;
                        this.data = payload.content.data || {};
                        this.isDefault = payload.content.default;
                        this.systemEditor = payload.content.systemEditor;
                    }
                }
                exports.SNEditor = SNEditor;
                /***/ 
            }),
            /***/ 10123: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(55159), exports);
                /***/ 
            }),
            /***/ 73886: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNFeatureRepo = void 0;
                const utils_1 = __webpack_require__(87901);
                const DecryptedItem_1 = __webpack_require__(43740);
                class SNFeatureRepo extends DecryptedItem_1.DecryptedItem {
                    get migratedToUserSetting() {
                        return (0, utils_1.useBoolean)(this.payload.content.migratedToUserSetting, false);
                    }
                    get migratedToOfflineEntitlements() {
                        return (0, utils_1.useBoolean)(this.payload.content.migratedToOfflineEntitlements, false);
                    }
                    get onlineUrl() {
                        return this.payload.content.url;
                    }
                    get offlineFeaturesUrl() {
                        return this.payload.content.offlineFeaturesUrl;
                    }
                    get offlineKey() {
                        return this.payload.content.offlineKey;
                    }
                }
                exports.SNFeatureRepo = SNFeatureRepo;
                /***/ 
            }),
            /***/ 75299: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FeatureRepoMutator = void 0;
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                class FeatureRepoMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    set migratedToUserSetting(migratedToUserSetting) {
                        this.mutableContent.migratedToUserSetting = migratedToUserSetting;
                    }
                    set migratedToOfflineEntitlements(migratedToOfflineEntitlements) {
                        this.mutableContent.migratedToOfflineEntitlements = migratedToOfflineEntitlements;
                    }
                    set offlineFeaturesUrl(offlineFeaturesUrl) {
                        this.mutableContent.offlineFeaturesUrl = offlineFeaturesUrl;
                    }
                    set offlineKey(offlineKey) {
                        this.mutableContent.offlineKey = offlineKey;
                    }
                }
                exports.FeatureRepoMutator = FeatureRepoMutator;
                /***/ 
            }),
            /***/ 12310: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(73886), exports);
                __exportStar(__webpack_require__(75299), exports);
                /***/ 
            }),
            /***/ 86154: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FileItem = exports.isFile = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const DecryptedItem_1 = __webpack_require__(43740);
                const Item_1 = __webpack_require__(50292);
                const isFile = x => x.content_type === domain_core_1.ContentType.TYPES.File;
                exports.isFile = isFile;
                class FileItem extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.remoteIdentifier = this.content.remoteIdentifier;
                        this.name = this.content.name;
                        this.key = this.content.key;
                        if (this.content.size && this.content.chunkSizes) {
                            this.decryptedSize = this.content.size;
                            this.encryptedChunkSizes = this.content.chunkSizes;
                        }
                        else {
                            this.decryptedSize = this.content.decryptedSize;
                            this.encryptedChunkSizes = this.content.encryptedChunkSizes;
                        }
                        this.encryptionHeader = this.content.encryptionHeader;
                        this.mimeType = this.content.mimeType;
                    }
                    strategyWhenConflictingWithItem(item) {
                        if (item.key !== this.key || item.encryptionHeader !== this.encryptionHeader || item.remoteIdentifier !== this.remoteIdentifier || JSON.stringify(item.encryptedChunkSizes) !== JSON.stringify(this.encryptedChunkSizes)) {
                            return Item_1.ConflictStrategy.KeepBaseDuplicateApply;
                        }
                        return Item_1.ConflictStrategy.KeepBase;
                    }
                    get encryptedSize() {
                        return this.encryptedChunkSizes.reduce((total, chunk) => total + chunk, 0);
                    }
                    get title() {
                        return this.name;
                    }
                }
                exports.FileItem = FileItem;
                /***/ 
            }),
            /***/ 78037: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 82422: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FileMutator = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const ContenteReferenceType_1 = __webpack_require__(78961);
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                class FileMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    set name(newName) {
                        this.mutableContent.name = newName;
                    }
                    set encryptionHeader(encryptionHeader) {
                        this.mutableContent.encryptionHeader = encryptionHeader;
                    }
                    addNote(note) {
                        const reference = {
                            reference_type: ContenteReferenceType_1.ContentReferenceType.FileToNote,
                            content_type: domain_core_1.ContentType.TYPES.Note,
                            uuid: note.uuid
                        };
                        const references = this.mutableContent.references || [];
                        references.push(reference);
                        this.mutableContent.references = references;
                    }
                    removeNote(note) {
                        const references = this.immutableItem.references.filter(ref => ref.uuid !== note.uuid);
                        this.mutableContent.references = references;
                    }
                    addFile(file) {
                        if (this.immutableItem.isReferencingItem(file)) {
                            return;
                        }
                        const reference = {
                            uuid: file.uuid,
                            content_type: domain_core_1.ContentType.TYPES.File,
                            reference_type: ContenteReferenceType_1.ContentReferenceType.FileToFile
                        };
                        this.mutableContent.references.push(reference);
                    }
                    removeFile(file) {
                        this.mutableContent.references = this.mutableContent.references.filter(r => r.uuid !== file.uuid);
                    }
                }
                exports.FileMutator = FileMutator;
                /***/ 
            }),
            /***/ 33447: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.FileProtocolV1Constants = void 0;
                var FileProtocolV1Constants;
                (function (FileProtocolV1Constants) {
                    FileProtocolV1Constants[FileProtocolV1Constants["KeySize"] = 256] = "KeySize";
                })(FileProtocolV1Constants || (exports.FileProtocolV1Constants = FileProtocolV1Constants = {}));
                /***/ 
            }),
            /***/ 25698: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(86154), exports);
                __exportStar(__webpack_require__(82422), exports);
                __exportStar(__webpack_require__(78037), exports);
                __exportStar(__webpack_require__(33447), exports);
                /***/ 
            }),
            /***/ 87500: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 2836: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 52493: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 82412: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23811: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 19725: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 82818: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeySystemRootKey = exports.isKeySystemRootKey = void 0;
                const Item_1 = __webpack_require__(50292);
                const domain_core_1 = __webpack_require__(82648);
                function isKeySystemRootKey(x) {
                    return x.content_type === domain_core_1.ContentType.TYPES.KeySystemRootKey;
                }
                exports.isKeySystemRootKey = isKeySystemRootKey;
                class KeySystemRootKey extends Item_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.keyParams = payload.content.keyParams;
                        this.systemIdentifier = payload.content.systemIdentifier;
                        this.key = payload.content.key;
                        this.keyVersion = payload.content.keyVersion;
                        this.token = payload.content.token;
                    }
                    strategyWhenConflictingWithItem(item, _previousRevision) {
                        const baseKeyTimestamp = this.keyParams.creationTimestamp;
                        const incomingKeyTimestamp = item.keyParams.creationTimestamp;
                        return incomingKeyTimestamp > baseKeyTimestamp ? Item_1.ConflictStrategy.KeepApply : Item_1.ConflictStrategy.KeepBase;
                    }
                    get itemsKey() {
                        return this.key;
                    }
                    get key_system_identifier() {
                        return undefined;
                    }
                    get shared_vault_uuid() {
                        return undefined;
                    }
                    isEqual(other) {
                        return this.itemsKey === other.itemsKey && this.token === other.token;
                    }
                }
                exports.KeySystemRootKey = KeySystemRootKey;
                /***/ 
            }),
            /***/ 95132: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 31750: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 64836: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeySystemRootKeyMutator = void 0;
                const Item_1 = __webpack_require__(50292);
                class KeySystemRootKeyMutator extends Item_1.DecryptedItemMutator {
                }
                exports.KeySystemRootKeyMutator = KeySystemRootKeyMutator;
                /***/ 
            }),
            /***/ 28819: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.KeySystemRootKeyStorageMode = void 0;
                var KeySystemRootKeyStorageMode;
                (function (KeySystemRootKeyStorageMode) {
                    KeySystemRootKeyStorageMode["Synced"] = "synced";
                    KeySystemRootKeyStorageMode["Local"] = "local";
                    KeySystemRootKeyStorageMode["Ephemeral"] = "ephemeral";
                })(KeySystemRootKeyStorageMode || (exports.KeySystemRootKeyStorageMode = KeySystemRootKeyStorageMode = {}));
                /***/ 
            }),
            /***/ 2636: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNNote = exports.isNote = void 0;
                const AppDataField_1 = __webpack_require__(68716);
                const features_1 = __webpack_require__(80215);
                const DecryptedItem_1 = __webpack_require__(43740);
                const domain_core_1 = __webpack_require__(82648);
                const isNote = x => x.content_type === domain_core_1.ContentType.TYPES.Note;
                exports.isNote = isNote;
                class SNNote extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.hidePreview = false;
                        this.title = String(this.payload.content.title || '');
                        this.text = String(this.payload.content.text || '');
                        this.hidePreview = Boolean(this.payload.content.hidePreview);
                        this.preview_plain = String(this.payload.content.preview_plain || '');
                        this.preview_html = String(this.payload.content.preview_html || '');
                        this.spellcheck = this.payload.content.spellcheck;
                        this.editorWidth = this.payload.content.editorWidth;
                        this.noteType = this.payload.content.noteType;
                        this.editorIdentifier = this.payload.content.editorIdentifier;
                        this.authorizedForListed = this.payload.content.authorizedForListed || false;
                        if (!this.noteType) {
                            const prefersPlain = this.getAppDomainValueWithDefault(AppDataField_1.AppDataField.LegacyPrefersPlainEditor, false);
                            if (prefersPlain) {
                                this.noteType = features_1.NoteType.Plain;
                            }
                        }
                    }
                }
                exports.SNNote = SNNote;
                /***/ 
            }),
            /***/ 38856: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39273: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NoteMutator = void 0;
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                const Item_1 = __webpack_require__(50292);
                const domain_core_1 = __webpack_require__(82648);
                class NoteMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    set title(title) {
                        this.mutableContent.title = title;
                    }
                    set text(text) {
                        this.mutableContent.text = text;
                    }
                    set hidePreview(hidePreview) {
                        this.mutableContent.hidePreview = hidePreview;
                    }
                    set preview_plain(preview_plain) {
                        this.mutableContent.preview_plain = preview_plain;
                    }
                    set preview_html(preview_html) {
                        this.mutableContent.preview_html = preview_html;
                    }
                    set spellcheck(spellcheck) {
                        this.mutableContent.spellcheck = spellcheck;
                    }
                    set editorWidth(editorWidth) {
                        this.mutableContent.editorWidth = editorWidth;
                    }
                    set noteType(noteType) {
                        this.mutableContent.noteType = noteType;
                    }
                    set editorIdentifier(identifier) {
                        this.mutableContent.editorIdentifier = identifier;
                    }
                    set authorizedForListed(authorizedForListed) {
                        this.mutableContent.authorizedForListed = authorizedForListed;
                    }
                    toggleSpellcheck() {
                        if (this.mutableContent.spellcheck == undefined) {
                            this.mutableContent.spellcheck = false;
                        }
                        else {
                            this.mutableContent.spellcheck = !this.mutableContent.spellcheck;
                        }
                    }
                    addNote(note) {
                        if (this.immutableItem.isReferencingItem(note)) {
                            return;
                        }
                        const reference = {
                            uuid: note.uuid,
                            content_type: domain_core_1.ContentType.TYPES.Note,
                            reference_type: Item_1.ContentReferenceType.NoteToNote
                        };
                        this.mutableContent.references.push(reference);
                    }
                    removeNote(note) {
                        this.mutableContent.references = this.mutableContent.references.filter(r => r.uuid !== note.uuid);
                    }
                }
                exports.NoteMutator = NoteMutator;
                /***/ 
            }),
            /***/ 42006: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(2636), exports);
                __exportStar(__webpack_require__(39273), exports);
                __exportStar(__webpack_require__(38856), exports);
                /***/ 
            }),
            /***/ 12775: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SmartView = exports.isSmartView = exports.isSystemView = exports.SMART_TAG_DSL_PREFIX = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const DecryptedItem_1 = __webpack_require__(43740);
                const Generators_1 = __webpack_require__(26550);
                const SystemViewId_1 = __webpack_require__(78748);
                const SmartViewIcons_1 = __webpack_require__(47899);
                exports.SMART_TAG_DSL_PREFIX = '![';
                function isSystemView(view) {
                    return Object.values(SystemViewId_1.SystemViewId).includes(view.uuid);
                }
                exports.isSystemView = isSystemView;
                const isSmartView = x => x.content_type === domain_core_1.ContentType.TYPES.SmartView;
                exports.isSmartView = isSmartView;
                class SmartView extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.title = String(this.content.title || '');
                        if (isSystemView(this)) {
                            this.iconString = (0, SmartViewIcons_1.systemViewIcon)(this.uuid);
                        }
                        else {
                            this.iconString = this.payload.content.iconString || SmartViewIcons_1.SmartViewDefaultIconName;
                        }
                        this.preferences = this.payload.content.preferences;
                        try {
                            this.predicate = this.content.predicate && (0, Generators_1.predicateFromJson)(this.content.predicate);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    }
                }
                exports.SmartView = SmartView;
                /***/ 
            }),
            /***/ 11070: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.BuildSmartViews = void 0;
                const DecryptedPayload_1 = __webpack_require__(89262);
                const SmartView_1 = __webpack_require__(12775);
                const SystemViewId_1 = __webpack_require__(78748);
                const ItemContent_1 = __webpack_require__(42405);
                const Predicate_1 = __webpack_require__(78688);
                const CompoundPredicate_1 = __webpack_require__(8698);
                const Payload_1 = __webpack_require__(59180);
                const domain_core_1 = __webpack_require__(82648);
                function BuildSmartViews(options) {
                    const notes = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.AllNotes,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Notes',
                            predicate: allNotesPredicate(options).toJson()
                        })
                    })));
                    const files = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.Files,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Files',
                            predicate: filesPredicate(options).toJson()
                        })
                    })));
                    const archived = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.ArchivedNotes,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Archived',
                            predicate: archivedNotesPredicate(options).toJson()
                        })
                    })));
                    const trash = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.TrashedNotes,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Trash',
                            predicate: trashedNotesPredicate(options).toJson()
                        })
                    })));
                    const untagged = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.UntaggedNotes,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Untagged',
                            predicate: untaggedNotesPredicate(options).toJson()
                        })
                    })));
                    const starred = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.StarredNotes,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Starred',
                            predicate: starredNotesPredicate(options).toJson()
                        })
                    })));
                    const conflicts = new SmartView_1.SmartView(new DecryptedPayload_1.DecryptedPayload(Object.assign(Object.assign({
                        uuid: SystemViewId_1.SystemViewId.Conflicts,
                        content_type: domain_core_1.ContentType.TYPES.SmartView
                    }, (0, Payload_1.PayloadTimestampDefaults)()), {
                        content: (0, ItemContent_1.FillItemContent)({
                            title: 'Conflicts',
                            predicate: conflictsPredicate(options).toJson()
                        })
                    })));
                    return [notes, files, starred, archived, trash, untagged, conflicts];
                }
                exports.BuildSmartViews = BuildSmartViews;
                function allNotesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note)];
                    if (options.includeTrashed === false) {
                        subPredicates.push(new Predicate_1.Predicate('trashed', '=', false));
                    }
                    if (options.includeArchived === false) {
                        subPredicates.push(new Predicate_1.Predicate('archived', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function filesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.File)];
                    if (options.includeTrashed === false) {
                        subPredicates.push(new Predicate_1.Predicate('trashed', '=', false));
                    }
                    if (options.includeArchived === false) {
                        subPredicates.push(new Predicate_1.Predicate('archived', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function archivedNotesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('archived', '=', true), new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note)];
                    if (options.includeTrashed === false) {
                        subPredicates.push(new Predicate_1.Predicate('trashed', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function trashedNotesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('trashed', '=', true), new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note)];
                    if (options.includeArchived === false) {
                        subPredicates.push(new Predicate_1.Predicate('archived', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function untaggedNotesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note), new Predicate_1.Predicate('tagsCount', '=', 0)];
                    if (options.includeArchived === false) {
                        subPredicates.push(new Predicate_1.Predicate('archived', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function starredNotesPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('starred', '=', true), new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note)];
                    if (options.includeTrashed === false) {
                        subPredicates.push(new Predicate_1.Predicate('trashed', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                function conflictsPredicate(options) {
                    const subPredicates = [new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.Note)];
                    if (options.includeTrashed === false) {
                        subPredicates.push(new Predicate_1.Predicate('trashed', '=', false));
                    }
                    if (options.includeArchived === false) {
                        subPredicates.push(new Predicate_1.Predicate('archived', '=', false));
                    }
                    if (options.includeProtected === false) {
                        subPredicates.push(new Predicate_1.Predicate('protected', '=', false));
                    }
                    if (options.includePinned === false) {
                        subPredicates.push(new Predicate_1.Predicate('pinned', '=', false));
                    }
                    const predicate = new CompoundPredicate_1.CompoundPredicate('and', subPredicates);
                    return predicate;
                }
                /***/ 
            }),
            /***/ 50986: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 47899: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SmartViewDefaultIconName = exports.systemViewIcon = exports.SmartViewIcons = void 0;
                const SystemViewId_1 = __webpack_require__(78748);
                exports.SmartViewIcons = {
                    [SystemViewId_1.SystemViewId.AllNotes]: 'notes',
                    [SystemViewId_1.SystemViewId.Files]: 'folder',
                    [SystemViewId_1.SystemViewId.ArchivedNotes]: 'archive',
                    [SystemViewId_1.SystemViewId.TrashedNotes]: 'trash',
                    [SystemViewId_1.SystemViewId.UntaggedNotes]: 'hashtag-off',
                    [SystemViewId_1.SystemViewId.StarredNotes]: 'star-filled',
                    [SystemViewId_1.SystemViewId.Conflicts]: 'merge'
                };
                function systemViewIcon(id) {
                    return exports.SmartViewIcons[id];
                }
                exports.systemViewIcon = systemViewIcon;
                exports.SmartViewDefaultIconName = 'restore';
                /***/ 
            }),
            /***/ 54196: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SmartViewMutator = void 0;
                const Tag_1 = __webpack_require__(87458);
                class SmartViewMutator extends Tag_1.TagMutator {
                    constructor(item, type) {
                        super(item, type);
                    }
                    set predicate(predicate) {
                        this.mutableContent.predicate = predicate;
                    }
                }
                exports.SmartViewMutator = SmartViewMutator;
                /***/ 
            }),
            /***/ 78748: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SystemViewId = void 0;
                var SystemViewId;
                (function (SystemViewId) {
                    SystemViewId["AllNotes"] = "all-notes";
                    SystemViewId["Files"] = "files";
                    SystemViewId["ArchivedNotes"] = "archived-notes";
                    SystemViewId["TrashedNotes"] = "trashed-notes";
                    SystemViewId["UntaggedNotes"] = "untagged-notes";
                    SystemViewId["StarredNotes"] = "starred-notes";
                    SystemViewId["Conflicts"] = "conflicts";
                })(SystemViewId || (exports.SystemViewId = SystemViewId = {}));
                /***/ 
            }),
            /***/ 41138: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(12775), exports);
                __exportStar(__webpack_require__(11070), exports);
                __exportStar(__webpack_require__(78748), exports);
                __exportStar(__webpack_require__(50986), exports);
                __exportStar(__webpack_require__(54196), exports);
                __exportStar(__webpack_require__(47899), exports);
                /***/ 
            }),
            /***/ 4862: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNTag = exports.isTag = exports.DefaultTagIconName = exports.TagFolderDelimitter = void 0;
                const DecryptedItem_1 = __webpack_require__(43740);
                const Functions_1 = __webpack_require__(4744);
                const domain_core_1 = __webpack_require__(82648);
                exports.TagFolderDelimitter = '.';
                exports.DefaultTagIconName = 'hashtag';
                const isTag = x => x.content_type === domain_core_1.ContentType.TYPES.Tag;
                exports.isTag = isTag;
                class SNTag extends DecryptedItem_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.title = this.payload.content.title || '';
                        this.expanded = this.payload.content.expanded != undefined ? this.payload.content.expanded : true;
                        this.iconString = this.payload.content.iconString || exports.DefaultTagIconName;
                        this.preferences = this.payload.content.preferences;
                    }
                    get isDailyEntry() {
                        var _a;
                        return ((_a = this.preferences) === null || _a === void 0 ? void 0 : _a.entryMode) === 'daily';
                    }
                    get noteReferences() {
                        const references = this.payload.references;
                        return references.filter(ref => ref.content_type === domain_core_1.ContentType.TYPES.Note);
                    }
                    get noteCount() {
                        return this.noteReferences.length;
                    }
                    get parentId() {
                        const reference = this.references.find(Functions_1.isTagToParentTagReference);
                        return reference === null || reference === void 0 ? void 0 : reference.uuid;
                    }
                    static arrayToDisplayString(tags) {
                        return tags.sort((a, b) => {
                            return a.title > b.title ? 1 : -1;
                        }).map(tag => {
                            return '#' + tag.title;
                        }).join(' ');
                    }
                }
                exports.SNTag = SNTag;
                /***/ 
            }),
            /***/ 33913: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74332: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.TagMutator = void 0;
                const Functions_1 = __webpack_require__(4744);
                const ContenteReferenceType_1 = __webpack_require__(78961);
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                const domain_core_1 = __webpack_require__(82648);
                class TagMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    constructor(item, type) {
                        super(item, type);
                        this.mutablePreferences = this.mutableContent.preferences;
                    }
                    set title(title) {
                        this.mutableContent.title = title;
                    }
                    set expanded(expanded) {
                        this.mutableContent.expanded = expanded;
                    }
                    set iconString(iconString) {
                        this.mutableContent.iconString = iconString;
                    }
                    get preferences() {
                        if (!this.mutablePreferences) {
                            this.mutableContent.preferences = {};
                            this.mutablePreferences = this.mutableContent.preferences;
                        }
                        return this.mutablePreferences;
                    }
                    set preferences(preferences) {
                        this.mutablePreferences = preferences;
                        this.mutableContent.preferences = this.mutablePreferences;
                    }
                    makeChildOf(tag) {
                        const references = this.immutableItem.references.filter(ref => !(0, Functions_1.isTagToParentTagReference)(ref));
                        const reference = {
                            reference_type: ContenteReferenceType_1.ContentReferenceType.TagToParentTag,
                            content_type: domain_core_1.ContentType.TYPES.Tag,
                            uuid: tag.uuid
                        };
                        references.push(reference);
                        this.mutableContent.references = references;
                    }
                    unsetParent() {
                        this.mutableContent.references = this.immutableItem.references.filter(ref => !(0, Functions_1.isTagToParentTagReference)(ref));
                    }
                    addFile(file) {
                        if (this.immutableItem.isReferencingItem(file)) {
                            return;
                        }
                        const reference = {
                            reference_type: ContenteReferenceType_1.ContentReferenceType.TagToFile,
                            content_type: domain_core_1.ContentType.TYPES.File,
                            uuid: file.uuid
                        };
                        this.mutableContent.references.push(reference);
                    }
                    removeFile(file) {
                        this.mutableContent.references = this.mutableContent.references.filter(r => r.uuid !== file.uuid);
                    }
                    addNote(note) {
                        if (this.immutableItem.isReferencingItem(note)) {
                            return;
                        }
                        this.mutableContent.references.push({
                            uuid: note.uuid,
                            content_type: note.content_type
                        });
                    }
                    removeNote(note) {
                        this.mutableContent.references = this.mutableContent.references.filter(r => r.uuid !== note.uuid);
                    }
                }
                exports.TagMutator = TagMutator;
                /***/ 
            }),
            /***/ 72680: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 87458: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(4862), exports);
                __exportStar(__webpack_require__(74332), exports);
                __exportStar(__webpack_require__(33913), exports);
                __exportStar(__webpack_require__(72680), exports);
                /***/ 
            }),
            /***/ 82602: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63195: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.TrustedContactMutator = void 0;
                const Item_1 = __webpack_require__(50292);
                const ContactPublicKeySet_1 = __webpack_require__(68092);
                class TrustedContactMutator extends Item_1.DecryptedItemMutator {
                    set name(newName) {
                        this.mutableContent.name = newName;
                    }
                    addPublicKey(keySet) {
                        const newKey = new ContactPublicKeySet_1.ContactPublicKeySet({
                            encryption: keySet.encryption,
                            signing: keySet.signing,
                            timestamp: new Date(),
                            previousKeySet: this.immutableItem.publicKeySet
                        });
                        this.mutableContent.publicKeySet = newKey;
                    }
                    replacePublicKeySet(publicKeySet) {
                        this.mutableContent.publicKeySet = publicKeySet;
                    }
                }
                exports.TrustedContactMutator = TrustedContactMutator;
                /***/ 
            }),
            /***/ 68092: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ContactPublicKeySet = void 0;
                class ContactPublicKeySet {
                    constructor(dto) {
                        this.encryption = dto.encryption;
                        this.signing = dto.signing;
                        this.timestamp = dto.timestamp;
                        this.previousKeySet = dto.previousKeySet;
                    }
                    findKeySetWithSigningKey(signingKey) {
                        if (this.signing === signingKey) {
                            return this;
                        }
                        if (this.previousKeySet) {
                            return this.previousKeySet.findKeySetWithSigningKey(signingKey);
                        }
                        return undefined;
                    }
                    findKeySetWithPublicKey(publicKey) {
                        if (this.encryption === publicKey) {
                            return this;
                        }
                        if (this.previousKeySet) {
                            return this.previousKeySet.findKeySetWithPublicKey(publicKey);
                        }
                        return undefined;
                    }
                    asJson() {
                        return {
                            encryption: this.encryption,
                            signing: this.signing,
                            timestamp: this.timestamp,
                            previousKeySet: this.previousKeySet ? this.previousKeySet.asJson() : undefined
                        };
                    }
                    mutableCopy() {
                        return new ContactPublicKeySet({
                            encryption: this.encryption,
                            signing: this.signing,
                            timestamp: this.timestamp,
                            previousKeySet: this.previousKeySet ? ContactPublicKeySet.FromJson(this.previousKeySet.asJson()) : undefined
                        });
                    }
                    static FromJson(json) {
                        return new ContactPublicKeySet({
                            encryption: json.encryption,
                            signing: json.signing,
                            timestamp: new Date(json.timestamp),
                            previousKeySet: json.previousKeySet ? ContactPublicKeySet.FromJson(json.previousKeySet) : undefined
                        });
                    }
                }
                exports.ContactPublicKeySet = ContactPublicKeySet;
                /***/ 
            }),
            /***/ 21436: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 79609: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.TrustedContact = void 0;
                const Item_1 = __webpack_require__(50292);
                const ContactPublicKeySet_1 = __webpack_require__(68092);
                const Predicate_1 = __webpack_require__(78688);
                const PublicKeyTrustStatus_1 = __webpack_require__(19332);
                class TrustedContact extends Item_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.name = payload.content.name;
                        this.contactUuid = payload.content.contactUuid;
                        this.publicKeySet = ContactPublicKeySet_1.ContactPublicKeySet.FromJson(payload.content.publicKeySet);
                        this.isMe = payload.content.isMe;
                    }
                    get isSingleton() {
                        return true;
                    }
                    singletonPredicate() {
                        return TrustedContact.singletonPredicate;
                    }
                    hasCurrentOrPreviousSigningPublicKey(signingPublicKey) {
                        return this.publicKeySet.findKeySetWithSigningKey(signingPublicKey) !== undefined;
                    }
                    getTrustStatusForPublicKey(encryptionPublicKey) {
                        if (this.publicKeySet.encryption === encryptionPublicKey) {
                            return PublicKeyTrustStatus_1.PublicKeyTrustStatus.Trusted;
                        }
                        const previous = this.publicKeySet.findKeySetWithPublicKey(encryptionPublicKey);
                        if (previous) {
                            return PublicKeyTrustStatus_1.PublicKeyTrustStatus.Previous;
                        }
                        return PublicKeyTrustStatus_1.PublicKeyTrustStatus.NotTrusted;
                    }
                    getTrustStatusForSigningPublicKey(signingPublicKey) {
                        if (this.publicKeySet.signing === signingPublicKey) {
                            return PublicKeyTrustStatus_1.PublicKeyTrustStatus.Trusted;
                        }
                        const previous = this.publicKeySet.findKeySetWithSigningKey(signingPublicKey);
                        if (previous) {
                            return PublicKeyTrustStatus_1.PublicKeyTrustStatus.Previous;
                        }
                        return PublicKeyTrustStatus_1.PublicKeyTrustStatus.NotTrusted;
                    }
                    strategyWhenConflictingWithItem(_item, _previousRevision) {
                        return Item_1.ConflictStrategy.KeepBase;
                    }
                }
                exports.TrustedContact = TrustedContact;
                TrustedContact.singletonPredicate = new Predicate_1.Predicate('isMe', '=', true);
                /***/ 
            }),
            /***/ 15845: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 5478: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 19332: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PublicKeyTrustStatus = void 0;
                var PublicKeyTrustStatus;
                (function (PublicKeyTrustStatus) {
                    PublicKeyTrustStatus["Trusted"] = "Trusted";
                    PublicKeyTrustStatus["Previous"] = "Previous";
                    PublicKeyTrustStatus["NotTrusted"] = "NotTrusted";
                })(PublicKeyTrustStatus || (exports.PublicKeyTrustStatus = PublicKeyTrustStatus = {}));
                /***/ 
            }),
            /***/ 79319: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68933: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EditorFontSize = void 0;
                var EditorFontSize;
                (function (EditorFontSize) {
                    EditorFontSize["ExtraSmall"] = "ExtraSmall";
                    EditorFontSize["Small"] = "Small";
                    EditorFontSize["Normal"] = "Normal";
                    EditorFontSize["Medium"] = "Medium";
                    EditorFontSize["Large"] = "Large";
                })(EditorFontSize || (exports.EditorFontSize = EditorFontSize = {}));
                /***/ 
            }),
            /***/ 97876: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EditorLineHeightValues = exports.EditorLineHeight = void 0;
                var EditorLineHeight;
                (function (EditorLineHeight) {
                    EditorLineHeight["None"] = "None";
                    EditorLineHeight["Tight"] = "Tight";
                    EditorLineHeight["Snug"] = "Snug";
                    EditorLineHeight["Normal"] = "Normal";
                    EditorLineHeight["Relaxed"] = "Relaxed";
                    EditorLineHeight["Loose"] = "Loose";
                })(EditorLineHeight || (exports.EditorLineHeight = EditorLineHeight = {}));
                // https://tailwindcss.com/docs/line-height
                exports.EditorLineHeightValues = {
                    None: 1,
                    Tight: 1.25,
                    Snug: 1.375,
                    Normal: 1.5,
                    Relaxed: 1.625,
                    Loose: 2
                };
                /***/ 
            }),
            /***/ 20610: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.EditorLineWidth = void 0;
                var EditorLineWidth;
                (function (EditorLineWidth) {
                    EditorLineWidth["Narrow"] = "Narrow";
                    EditorLineWidth["Wide"] = "Wide";
                    EditorLineWidth["Dynamic"] = "Dynamic";
                    EditorLineWidth["FullWidth"] = "FullWidth";
                })(EditorLineWidth || (exports.EditorLineWidth = EditorLineWidth = {}));
                /***/ 
            }),
            /***/ 23688: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.NewNoteTitleFormat = void 0;
                var NewNoteTitleFormat;
                (function (NewNoteTitleFormat) {
                    NewNoteTitleFormat["CurrentDateAndTime"] = "CurrentDateAndTime";
                    NewNoteTitleFormat["CurrentNoteCount"] = "CurrentNoteCount";
                    NewNoteTitleFormat["CustomFormat"] = "CustomFormat";
                    NewNoteTitleFormat["Empty"] = "Empty";
                })(NewNoteTitleFormat || (exports.NewNoteTitleFormat = NewNoteTitleFormat = {}));
                /***/ 
            }),
            /***/ 68126: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PrefDefaults = void 0;
                const features_1 = __webpack_require__(80215);
                const CollectionSort_1 = __webpack_require__(92207);
                const EditorFontSize_1 = __webpack_require__(68933);
                const EditorLineHeight_1 = __webpack_require__(97876);
                const EditorLineWidth_1 = __webpack_require__(20610);
                const PrefKey_1 = __webpack_require__(70659);
                const NewNoteTitleFormat_1 = __webpack_require__(23688);
                exports.PrefDefaults = {
                    [PrefKey_1.PrefKey.TagsPanelWidth]: 220,
                    [PrefKey_1.PrefKey.NotesPanelWidth]: 350,
                    [PrefKey_1.PrefKey.EditorWidth]: null,
                    [PrefKey_1.PrefKey.EditorLeft]: null,
                    [PrefKey_1.PrefKey.DEPRECATED_EditorMonospaceEnabled]: false,
                    [PrefKey_1.PrefKey.EditorSpellcheck]: true,
                    [PrefKey_1.PrefKey.EditorResizersEnabled]: false,
                    [PrefKey_1.PrefKey.DEPRECATED_EditorLineHeight]: EditorLineHeight_1.EditorLineHeight.Normal,
                    [PrefKey_1.PrefKey.DEPRECATED_EditorLineWidth]: EditorLineWidth_1.EditorLineWidth.FullWidth,
                    [PrefKey_1.PrefKey.DEPRECATED_EditorFontSize]: EditorFontSize_1.EditorFontSize.Normal,
                    [PrefKey_1.PrefKey.SortNotesBy]: CollectionSort_1.CollectionSort.CreatedAt,
                    [PrefKey_1.PrefKey.SortNotesReverse]: false,
                    [PrefKey_1.PrefKey.NotesShowArchived]: false,
                    [PrefKey_1.PrefKey.NotesShowTrashed]: false,
                    [PrefKey_1.PrefKey.NotesHidePinned]: false,
                    [PrefKey_1.PrefKey.NotesHideProtected]: false,
                    [PrefKey_1.PrefKey.NotesHideNotePreview]: false,
                    [PrefKey_1.PrefKey.NotesHideDate]: false,
                    [PrefKey_1.PrefKey.NotesHideTags]: false,
                    [PrefKey_1.PrefKey.NotesHideEditorIcon]: false,
                    [PrefKey_1.PrefKey.DEPRECATED_UseSystemColorScheme]: false,
                    [PrefKey_1.PrefKey.DEPRECATED_UseTranslucentUI]: true,
                    [PrefKey_1.PrefKey.DEPRECATED_AutoLightThemeIdentifier]: 'Default',
                    [PrefKey_1.PrefKey.DEPRECATED_AutoDarkThemeIdentifier]: features_1.NativeFeatureIdentifier.TYPES.DarkTheme,
                    [PrefKey_1.PrefKey.NoteAddToParentFolders]: true,
                    [PrefKey_1.PrefKey.NewNoteTitleFormat]: NewNoteTitleFormat_1.NewNoteTitleFormat.CurrentDateAndTime,
                    [PrefKey_1.PrefKey.CustomNoteTitleFormat]: 'YYYY-MM-DD [at] hh:mm A',
                    [PrefKey_1.PrefKey.UpdateSavingStatusIndicator]: true,
                    [PrefKey_1.PrefKey.PaneGesturesEnabled]: true,
                    [PrefKey_1.PrefKey.MomentsDefaultTagUuid]: undefined,
                    [PrefKey_1.PrefKey.ClipperDefaultTagUuid]: undefined,
                    [PrefKey_1.PrefKey.DefaultEditorIdentifier]: features_1.NativeFeatureIdentifier.TYPES.PlainEditor,
                    [PrefKey_1.PrefKey.SuperNoteExportFormat]: 'json',
                    [PrefKey_1.PrefKey.SuperNoteExportEmbedBehavior]: 'reference',
                    [PrefKey_1.PrefKey.SuperNoteExportUseMDFrontmatter]: true,
                    [PrefKey_1.PrefKey.SuperNoteExportPDFPageSize]: 'A4',
                    [PrefKey_1.PrefKey.SystemViewPreferences]: {},
                    [PrefKey_1.PrefKey.AuthenticatorNames]: '',
                    [PrefKey_1.PrefKey.ComponentPreferences]: {},
                    [PrefKey_1.PrefKey.DEPRECATED_ActiveThemes]: [],
                    [PrefKey_1.PrefKey.ActiveComponents]: [],
                    [PrefKey_1.PrefKey.AlwaysShowSuperToolbar]: true,
                    [PrefKey_1.PrefKey.AddImportsToTag]: true,
                    [PrefKey_1.PrefKey.AlwaysCreateNewTagForImports]: true,
                    [PrefKey_1.PrefKey.ExistingTagForImports]: undefined
                };
                /***/ 
            }),
            /***/ 70659: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PrefKey = void 0;
                var PrefKey;
                (function (PrefKey) {
                    PrefKey["TagsPanelWidth"] = "tagsPanelWidth";
                    PrefKey["NotesPanelWidth"] = "notesPanelWidth";
                    PrefKey["EditorWidth"] = "editorWidth";
                    PrefKey["EditorLeft"] = "editorLeft";
                    PrefKey["EditorSpellcheck"] = "spellcheck";
                    PrefKey["EditorResizersEnabled"] = "marginResizersEnabled";
                    PrefKey["SortNotesBy"] = "sortBy";
                    PrefKey["SortNotesReverse"] = "sortReverse";
                    PrefKey["NotesShowArchived"] = "showArchived";
                    PrefKey["NotesShowTrashed"] = "showTrashed";
                    PrefKey["NotesHideProtected"] = "hideProtected";
                    PrefKey["NotesHidePinned"] = "hidePinned";
                    PrefKey["NotesHideNotePreview"] = "hideNotePreview";
                    PrefKey["NotesHideDate"] = "hideDate";
                    PrefKey["NotesHideTags"] = "hideTags";
                    PrefKey["NotesHideEditorIcon"] = "hideEditorIcon";
                    PrefKey["NoteAddToParentFolders"] = "noteAddToParentFolders";
                    PrefKey["NewNoteTitleFormat"] = "newNoteTitleFormat";
                    PrefKey["CustomNoteTitleFormat"] = "customNoteTitleFormat";
                    PrefKey["UpdateSavingStatusIndicator"] = "updateSavingStatusIndicator";
                    PrefKey["DefaultEditorIdentifier"] = "defaultEditorIdentifier";
                    PrefKey["MomentsDefaultTagUuid"] = "momentsDefaultTagUuid";
                    PrefKey["ClipperDefaultTagUuid"] = "clipperDefaultTagUuid";
                    PrefKey["SystemViewPreferences"] = "systemViewPreferences";
                    PrefKey["SuperNoteExportFormat"] = "superNoteExportFormat";
                    PrefKey["SuperNoteExportEmbedBehavior"] = "superNoteExportEmbedBehavior";
                    PrefKey["SuperNoteExportUseMDFrontmatter"] = "superNoteExportUseMDFrontmatter";
                    PrefKey["SuperNoteExportPDFPageSize"] = "superNoteExportPDFPageSize";
                    PrefKey["AuthenticatorNames"] = "authenticatorNames";
                    PrefKey["PaneGesturesEnabled"] = "paneGesturesEnabled";
                    PrefKey["ComponentPreferences"] = "componentPreferences";
                    PrefKey["ActiveComponents"] = "activeComponents";
                    PrefKey["AlwaysShowSuperToolbar"] = "alwaysShowSuperToolbar";
                    PrefKey["AddImportsToTag"] = "addImportsToTag";
                    PrefKey["AlwaysCreateNewTagForImports"] = "alwaysCreateNewTagForImports";
                    PrefKey["ExistingTagForImports"] = "existingTagForImports";
                    PrefKey["DEPRECATED_ActiveThemes"] = "activeThemes";
                    PrefKey["DEPRECATED_UseSystemColorScheme"] = "useSystemColorScheme";
                    PrefKey["DEPRECATED_UseTranslucentUI"] = "useTranslucentUI";
                    PrefKey["DEPRECATED_AutoLightThemeIdentifier"] = "autoLightThemeIdentifier";
                    PrefKey["DEPRECATED_AutoDarkThemeIdentifier"] = "autoDarkThemeIdentifier";
                    PrefKey["DEPRECATED_EditorMonospaceEnabled"] = "monospaceFont";
                    PrefKey["DEPRECATED_EditorLineHeight"] = "editorLineHeight";
                    PrefKey["DEPRECATED_EditorLineWidth"] = "editorLineWidth";
                    PrefKey["DEPRECATED_EditorFontSize"] = "editorFontSize";
                })(PrefKey || (exports.PrefKey = PrefKey = {}));
                /***/ 
            }),
            /***/ 87070: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SNUserPrefs = void 0;
                const domain_core_1 = __webpack_require__(82648);
                const DecryptedItem_1 = __webpack_require__(43740);
                const Predicate_1 = __webpack_require__(78688);
                class SNUserPrefs extends DecryptedItem_1.DecryptedItem {
                    get isSingleton() {
                        return true;
                    }
                    singletonPredicate() {
                        return SNUserPrefs.singletonPredicate;
                    }
                    getPref(key) {
                        return this.getAppDomainValue(key);
                    }
                }
                exports.SNUserPrefs = SNUserPrefs;
                SNUserPrefs.singletonPredicate = new Predicate_1.Predicate('content_type', '=', domain_core_1.ContentType.TYPES.UserPrefs);
                /***/ 
            }),
            /***/ 34660: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UserPrefsMutator = void 0;
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                class UserPrefsMutator extends DecryptedItemMutator_1.DecryptedItemMutator {
                    setPref(key, value) {
                        this.setAppDataItem(key, value);
                    }
                }
                exports.UserPrefsMutator = UserPrefsMutator;
                /***/ 
            }),
            /***/ 53840: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(87070), exports);
                __exportStar(__webpack_require__(34660), exports);
                __exportStar(__webpack_require__(70659), exports);
                __exportStar(__webpack_require__(97876), exports);
                __exportStar(__webpack_require__(68933), exports);
                __exportStar(__webpack_require__(20610), exports);
                __exportStar(__webpack_require__(23688), exports);
                __exportStar(__webpack_require__(79319), exports);
                __exportStar(__webpack_require__(68126), exports);
                /***/ 
            }),
            /***/ 3396: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.VaultListing = exports.DefaultVaultIconName = void 0;
                const Item_1 = __webpack_require__(50292);
                exports.DefaultVaultIconName = 'safe-square';
                class VaultListing extends Item_1.DecryptedItem {
                    constructor(payload) {
                        super(payload);
                        this.systemIdentifier = payload.content.systemIdentifier;
                        this.rootKeyParams = payload.content.rootKeyParams;
                        this.keyStorageMode = payload.content.keyStorageMode;
                        this.name = payload.content.name;
                        this.description = payload.content.description;
                        this.iconString = payload.content.iconString || exports.DefaultVaultIconName;
                        this.sharing = payload.content.sharing;
                    }
                    strategyWhenConflictingWithItem(item, _previousRevision) {
                        const baseKeyTimestamp = this.rootKeyParams.creationTimestamp;
                        const incomingKeyTimestamp = item.rootKeyParams.creationTimestamp;
                        return incomingKeyTimestamp > baseKeyTimestamp ? Item_1.ConflictStrategy.KeepApply : Item_1.ConflictStrategy.KeepBase;
                    }
                    get keyPasswordType() {
                        return this.rootKeyParams.passwordType;
                    }
                    isSharedVaultListing() {
                        return this.sharing != undefined;
                    }
                    get key_system_identifier() {
                        return undefined;
                    }
                    get shared_vault_uuid() {
                        return undefined;
                    }
                }
                exports.VaultListing = VaultListing;
                /***/ 
            }),
            /***/ 52897: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 59402: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 82259: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.VaultListingMutator = void 0;
                const Item_1 = __webpack_require__(50292);
                class VaultListingMutator extends Item_1.DecryptedItemMutator {
                    set name(name) {
                        this.mutableContent.name = name;
                    }
                    set description(description) {
                        this.mutableContent.description = description;
                    }
                    set iconString(iconString) {
                        this.mutableContent.iconString = iconString;
                    }
                    set sharing(sharing) {
                        this.mutableContent.sharing = sharing;
                    }
                    set rootKeyParams(rootKeyParams) {
                        this.mutableContent.rootKeyParams = rootKeyParams;
                    }
                    set keyStorageMode(keyStorageMode) {
                        this.mutableContent.keyStorageMode = keyStorageMode;
                    }
                }
                exports.VaultListingMutator = VaultListingMutator;
                /***/ 
            }),
            /***/ 44957: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 53555: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 40249: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SureFindItem = exports.FindItem = void 0;
                function FindItem(items, uuid) {
                    return items.find(item => item.uuid === uuid);
                }
                exports.FindItem = FindItem;
                function SureFindItem(items, uuid) {
                    return FindItem(items, uuid);
                }
                exports.SureFindItem = SureFindItem;
                /***/ 
            }),
            /***/ 33545: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemContentsDiffer = void 0;
                const ItemContentsEqual_1 = __webpack_require__(41035);
                function ItemContentsDiffer(item1, item2) {
                    let excludeContentKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    return !(0, ItemContentsEqual_1.ItemContentsEqual)(item1.content, item2.content, [...item1.contentKeysToIgnoreWhenCheckingEquality(), ...excludeContentKeys], item1.appDataContentKeysToIgnoreWhenCheckingEquality());
                }
                exports.ItemContentsDiffer = ItemContentsDiffer;
                /***/ 
            }),
            /***/ 41035: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ItemContentsEqual = void 0;
                const utils_1 = __webpack_require__(87901);
                const DefaultAppDomain_1 = __webpack_require__(71458);
                function ItemContentsEqual(leftContent, rightContent, keysToIgnore, appDataKeysToIgnore) {
                    /* Create copies of objects before running omit as not to modify source values directly. */
                    const leftContentCopy = (0, utils_1.sortedCopy)(leftContent);
                    if (leftContentCopy.appData) {
                        const domainData = leftContentCopy.appData[DefaultAppDomain_1.DefaultAppDomain];
                        (0, utils_1.omitInPlace)(domainData, appDataKeysToIgnore);
                        /**
                         * We don't want to disqualify comparison if one object contains an empty domain object
                         * and the other doesn't contain a domain object. This can happen if you create an item
                         * without setting dirty, which means it won't be initialized with a client_updated_at
                         */
                        if (domainData) {
                            if (Object.keys(domainData).length === 0) {
                                delete leftContentCopy.appData;
                            }
                        }
                        else {
                            delete leftContentCopy.appData;
                        }
                    }
                    (0, utils_1.omitInPlace)(leftContentCopy, keysToIgnore);
                    const rightContentCopy = (0, utils_1.sortedCopy)(rightContent);
                    if (rightContentCopy.appData) {
                        const domainData = rightContentCopy.appData[DefaultAppDomain_1.DefaultAppDomain];
                        (0, utils_1.omitInPlace)(domainData, appDataKeysToIgnore);
                        if (domainData) {
                            if (Object.keys(domainData).length === 0) {
                                delete rightContentCopy.appData;
                            }
                        }
                        else {
                            delete rightContentCopy.appData;
                        }
                    }
                    (0, utils_1.omitInPlace)(rightContentCopy, keysToIgnore);
                    return JSON.stringify(leftContentCopy) === JSON.stringify(rightContentCopy);
                }
                exports.ItemContentsEqual = ItemContentsEqual;
                /***/ 
            }),
            /***/ 73277: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateItemFromPayload = exports.CreateDecryptedItemFromPayload = exports.RegisterItemClass = exports.CreateDecryptedMutatorForItem = void 0;
                const EncryptedItem_1 = __webpack_require__(80406);
                const File_1 = __webpack_require__(86154);
                const FeatureRepo_1 = __webpack_require__(73886);
                const ActionsExtension_1 = __webpack_require__(59020);
                const Component_1 = __webpack_require__(35922);
                const Editor_1 = __webpack_require__(55159);
                const DecryptedItem_1 = __webpack_require__(43740);
                const Note_1 = __webpack_require__(2636);
                const SmartView_1 = __webpack_require__(12775);
                const Tag_1 = __webpack_require__(4862);
                const UserPrefs_1 = __webpack_require__(87070);
                const FileMutator_1 = __webpack_require__(82422);
                const UserPrefsMutator_1 = __webpack_require__(34660);
                const ActionsExtensionMutator_1 = __webpack_require__(27539);
                const ComponentMutator_1 = __webpack_require__(43246);
                const TagMutator_1 = __webpack_require__(74332);
                const NoteMutator_1 = __webpack_require__(39273);
                const DecryptedItemMutator_1 = __webpack_require__(14584);
                const DeletedItem_1 = __webpack_require__(78438);
                const SmartView_2 = __webpack_require__(41138);
                const TrustedContact_1 = __webpack_require__(79609);
                const TrustedContactMutator_1 = __webpack_require__(63195);
                const KeySystemRootKey_1 = __webpack_require__(82818);
                const KeySystemRootKeyMutator_1 = __webpack_require__(64836);
                const VaultListing_1 = __webpack_require__(3396);
                const VaultListingMutator_1 = __webpack_require__(82259);
                const Payload_1 = __webpack_require__(59180);
                const domain_core_1 = __webpack_require__(82648);
                const ContentTypeClassMapping = {
                    [domain_core_1.ContentType.TYPES.ActionsExtension]: {
                        itemClass: ActionsExtension_1.SNActionsExtension,
                        mutatorClass: ActionsExtensionMutator_1.ActionsExtensionMutator
                    },
                    [domain_core_1.ContentType.TYPES.Component]: {
                        itemClass: Component_1.ComponentItem,
                        mutatorClass: ComponentMutator_1.ComponentMutator
                    },
                    [domain_core_1.ContentType.TYPES.KeySystemRootKey]: {
                        itemClass: KeySystemRootKey_1.KeySystemRootKey,
                        mutatorClass: KeySystemRootKeyMutator_1.KeySystemRootKeyMutator
                    },
                    [domain_core_1.ContentType.TYPES.TrustedContact]: {
                        itemClass: TrustedContact_1.TrustedContact,
                        mutatorClass: TrustedContactMutator_1.TrustedContactMutator
                    },
                    [domain_core_1.ContentType.TYPES.VaultListing]: {
                        itemClass: VaultListing_1.VaultListing,
                        mutatorClass: VaultListingMutator_1.VaultListingMutator
                    },
                    [domain_core_1.ContentType.TYPES.Editor]: {
                        itemClass: Editor_1.SNEditor
                    },
                    [domain_core_1.ContentType.TYPES.ExtensionRepo]: {
                        itemClass: FeatureRepo_1.SNFeatureRepo
                    },
                    [domain_core_1.ContentType.TYPES.File]: {
                        itemClass: File_1.FileItem,
                        mutatorClass: FileMutator_1.FileMutator
                    },
                    [domain_core_1.ContentType.TYPES.Note]: {
                        itemClass: Note_1.SNNote,
                        mutatorClass: NoteMutator_1.NoteMutator
                    },
                    [domain_core_1.ContentType.TYPES.SmartView]: {
                        itemClass: SmartView_1.SmartView,
                        mutatorClass: SmartView_2.SmartViewMutator
                    },
                    [domain_core_1.ContentType.TYPES.Tag]: {
                        itemClass: Tag_1.SNTag,
                        mutatorClass: TagMutator_1.TagMutator
                    },
                    [domain_core_1.ContentType.TYPES.Theme]: {
                        itemClass: Component_1.ComponentItem,
                        mutatorClass: ComponentMutator_1.ComponentMutator
                    },
                    [domain_core_1.ContentType.TYPES.UserPrefs]: {
                        itemClass: UserPrefs_1.SNUserPrefs,
                        mutatorClass: UserPrefsMutator_1.UserPrefsMutator
                    }
                };
                function CreateDecryptedMutatorForItem(item, type) {
                    var _a;
                    const lookupValue = (_a = ContentTypeClassMapping[item.content_type]) === null || _a === void 0 ? void 0 : _a.mutatorClass;
                    if (lookupValue) {
                        return new lookupValue(item, type);
                    }
                    else {
                        return new DecryptedItemMutator_1.DecryptedItemMutator(item, type);
                    }
                }
                exports.CreateDecryptedMutatorForItem = CreateDecryptedMutatorForItem;
                function RegisterItemClass(contentType, itemClass, mutatorClass) {
                    const entry = {
                        itemClass: itemClass,
                        mutatorClass: mutatorClass
                    };
                    ContentTypeClassMapping[contentType] = entry;
                }
                exports.RegisterItemClass = RegisterItemClass;
                function CreateDecryptedItemFromPayload(payload) {
                    const lookupClass = ContentTypeClassMapping[payload.content_type];
                    const itemClass = lookupClass ? lookupClass.itemClass : DecryptedItem_1.DecryptedItem;
                    const item = new itemClass(payload);
                    return item;
                }
                exports.CreateDecryptedItemFromPayload = CreateDecryptedItemFromPayload;
                function CreateItemFromPayload(payload) {
                    if ((0, Payload_1.isDecryptedPayload)(payload)) {
                        return CreateDecryptedItemFromPayload(payload);
                    }
                    else if ((0, Payload_1.isEncryptedPayload)(payload)) {
                        return new EncryptedItem_1.EncryptedItem(payload);
                    }
                    else if ((0, Payload_1.isDeletedPayload)(payload)) {
                        return new DeletedItem_1.DeletedItem(payload);
                    }
                    else {
                        throw Error('Unhandled case in CreateItemFromPayload');
                    }
                }
                exports.CreateItemFromPayload = CreateItemFromPayload;
                /***/ 
            }),
            /***/ 74527: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CopyPayloadWithContentOverride = void 0;
                const CreatePayload_1 = __webpack_require__(88141);
                function CopyPayloadWithContentOverride(payload, contentOverride) {
                    const params = Object.assign(Object.assign({}, payload.ejected()), {
                        content: Object.assign(Object.assign({}, payload.content), contentOverride)
                    });
                    const result = (0, CreatePayload_1.CreatePayload)(params, payload.source);
                    return result;
                }
                exports.CopyPayloadWithContentOverride = CopyPayloadWithContentOverride;
                /***/ 
            }),
            /***/ 88141: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreatePayload = void 0;
                const EncryptedPayload_1 = __webpack_require__(86731);
                const DeletedPayload_1 = __webpack_require__(452);
                const DecryptedPayload_1 = __webpack_require__(89262);
                const TransferPayload_1 = __webpack_require__(78381);
                function CreatePayload(from, source) {
                    if ((0, TransferPayload_1.isDecryptedTransferPayload)(from)) {
                        return new DecryptedPayload_1.DecryptedPayload(from, source);
                    }
                    else if ((0, TransferPayload_1.isEncryptedTransferPayload)(from)) {
                        return new EncryptedPayload_1.EncryptedPayload(from, source);
                    }
                    else if ((0, TransferPayload_1.isDeletedTransferPayload)(from)) {
                        return new DeletedPayload_1.DeletedPayload(from, source);
                    }
                    else {
                        throw Error('Unhandled case in CreatePayload');
                    }
                }
                exports.CreatePayload = CreatePayload;
                /***/ 
            }),
            /***/ 15658: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SureFindPayload = exports.FindPayload = void 0;
                function FindPayload(payloads, uuid) {
                    return payloads.find(payload => payload.uuid === uuid);
                }
                exports.FindPayload = FindPayload;
                function SureFindPayload(payloads, uuid) {
                    return FindPayload(payloads, uuid);
                }
                exports.SureFindPayload = SureFindPayload;
                /***/ 
            }),
            /***/ 37807: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadContentsEqual = void 0;
                const ItemGenerator_1 = __webpack_require__(73277);
                /**
                 * Compares the .content fields for equality, creating new SNItem objects
                 * to properly handle .content intricacies.
                 */
                function PayloadContentsEqual(payloadA, payloadB) {
                    const itemA = (0, ItemGenerator_1.CreateDecryptedItemFromPayload)(payloadA);
                    const itemB = (0, ItemGenerator_1.CreateDecryptedItemFromPayload)(payloadB);
                    return itemA.isItemContentEqualWith(itemB);
                }
                exports.PayloadContentsEqual = PayloadContentsEqual;
                /***/ 
            }),
            /***/ 50723: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.CreateNonDecryptedPayloadSplit = exports.CreatePayloadSplitWithDiscardables = exports.CreatePayloadSplit = void 0;
                const TypeCheck_1 = __webpack_require__(13566);
                function CreatePayloadSplit(payloads) {
                    const split = {
                        encrypted: [],
                        decrypted: [],
                        deleted: []
                    };
                    for (const payload of payloads) {
                        if ((0, TypeCheck_1.isDecryptedPayload)(payload)) {
                            split.decrypted.push(payload);
                        }
                        else if ((0, TypeCheck_1.isEncryptedPayload)(payload)) {
                            split.encrypted.push(payload);
                        }
                        else if ((0, TypeCheck_1.isDeletedPayload)(payload)) {
                            split.deleted.push(payload);
                        }
                        else {
                            throw Error('Unhandled case in CreatePayloadSplit');
                        }
                    }
                    return split;
                }
                exports.CreatePayloadSplit = CreatePayloadSplit;
                function CreatePayloadSplitWithDiscardables(payloads) {
                    const split = {
                        encrypted: [],
                        decrypted: [],
                        deleted: [],
                        discardable: []
                    };
                    for (const payload of payloads) {
                        if ((0, TypeCheck_1.isDecryptedPayload)(payload)) {
                            split.decrypted.push(payload);
                        }
                        else if ((0, TypeCheck_1.isEncryptedPayload)(payload)) {
                            split.encrypted.push(payload);
                        }
                        else if ((0, TypeCheck_1.isDeletedPayload)(payload)) {
                            if (payload.discardable) {
                                split.discardable.push(payload);
                            }
                            else {
                                split.deleted.push(payload);
                            }
                        }
                        else {
                            throw Error('Unhandled case in CreatePayloadSplitWithDiscardables');
                        }
                    }
                    return split;
                }
                exports.CreatePayloadSplitWithDiscardables = CreatePayloadSplitWithDiscardables;
                function CreateNonDecryptedPayloadSplit(payloads) {
                    const split = {
                        encrypted: [],
                        deleted: []
                    };
                    for (const payload of payloads) {
                        if ((0, TypeCheck_1.isEncryptedPayload)(payload)) {
                            split.encrypted.push(payload);
                        }
                        else if ((0, TypeCheck_1.isDeletedPayload)(payload)) {
                            split.deleted.push(payload);
                        }
                        else {
                            throw Error('Unhandled case in CreateNonDecryptedPayloadSplit');
                        }
                    }
                    return split;
                }
                exports.CreateNonDecryptedPayloadSplit = CreateNonDecryptedPayloadSplit;
                /***/ 
            }),
            /***/ 15005: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadsByAlternatingUuid = void 0;
                const DeletedPayload_1 = __webpack_require__(452);
                const utils_1 = __webpack_require__(87901);
                const TypeCheck_1 = __webpack_require__(13566);
                const PayloadsByUpdatingReferencingPayloadReferences_1 = __webpack_require__(72208);
                const DirtyCounter_1 = __webpack_require__(13743);
                const domain_core_1 = __webpack_require__(82648);
                /**
                 * Return the payloads that result if you alternated the uuid for the payload.
                 * Alternating a UUID involves instructing related items to drop old references of a uuid
                 * for the new one.
                 * @returns An array of payloads that have changed as a result of copying.
                 */
                function PayloadsByAlternatingUuid(payload, baseCollection) {
                    const results = [];
                    /**
                     * We need to clone payload and give it a new uuid,
                     * then delete item with old uuid from db (cannot modify uuids in our IndexedDB setup)
                     */
                    const copy = payload.copyAsSyncResolved({
                        uuid: utils_1.UuidGenerator.GenerateUuid(),
                        dirty: true,
                        dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                        lastSyncBegan: undefined,
                        lastSyncEnd: new Date(),
                        duplicate_of: payload.uuid
                    });
                    results.push(copy);
                    /**
                     * Get the payloads that make reference to payload and remove
                     * payload as a relationship, instead adding the new copy.
                     */
                    const updatedReferencing = (0, PayloadsByUpdatingReferencingPayloadReferences_1.PayloadsByUpdatingReferencingPayloadReferences)(payload, baseCollection, [copy], [payload.uuid]);
                    (0, utils_1.extendArray)(results, updatedReferencing);
                    if (payload.content_type === domain_core_1.ContentType.TYPES.ItemsKey) {
                        /**
                         * Update any payloads who are still encrypted and whose items_key_id point to this uuid
                         */
                        const matchingPayloads = baseCollection.all().filter(p => (0, TypeCheck_1.isEncryptedPayload)(p) && p.items_key_id === payload.uuid);
                        const adjustedPayloads = matchingPayloads.map(a => a.copyAsSyncResolved({
                            items_key_id: copy.uuid,
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            lastSyncEnd: new Date()
                        }));
                        if (adjustedPayloads.length > 0) {
                            (0, utils_1.extendArray)(results, adjustedPayloads);
                        }
                    }
                    const deletedSelf = new DeletedPayload_1.DeletedPayload({
                        created_at: payload.created_at,
                        updated_at: payload.updated_at,
                        created_at_timestamp: payload.created_at_timestamp,
                        updated_at_timestamp: payload.updated_at_timestamp,
                        /**
                         * Do not set as dirty; this item is non-syncable
                         * and should be immediately discarded
                         */
                        dirty: false,
                        content: undefined,
                        uuid: payload.uuid,
                        content_type: payload.content_type,
                        deleted: true
                    }, payload.source);
                    results.push(deletedSelf);
                    return results;
                }
                exports.PayloadsByAlternatingUuid = PayloadsByAlternatingUuid;
                /***/ 
            }),
            /***/ 27446: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadsByDuplicating = void 0;
                const utils_1 = __webpack_require__(87901);
                const PayloadsByUpdatingReferencingPayloadReferences_1 = __webpack_require__(72208);
                const TypeCheck_1 = __webpack_require__(13566);
                const DirtyCounter_1 = __webpack_require__(13743);
                /**
                 * Copies payload and assigns it a new uuid.
                 * @returns An array of payloads that have changed as a result of copying.
                 */
                function PayloadsByDuplicating(dto) {
                    const { payload, baseCollection, isConflict, additionalContent, source } = dto;
                    const results = [];
                    const override = {
                        uuid: utils_1.UuidGenerator.GenerateUuid(),
                        dirty: true,
                        dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                        lastSyncBegan: undefined,
                        lastSyncEnd: new Date(),
                        duplicate_of: payload.uuid
                    };
                    let copy;
                    if ((0, TypeCheck_1.isDecryptedPayload)(payload)) {
                        const contentOverride = Object.assign(Object.assign({}, payload.content), additionalContent);
                        if (isConflict) {
                            contentOverride.conflict_of = payload.uuid;
                        }
                        copy = payload.copyAsSyncResolved(Object.assign(Object.assign({}, override), {
                            content: contentOverride,
                            deleted: false
                        }));
                    }
                    else {
                        copy = payload.copyAsSyncResolved(Object.assign({}, override), source || payload.source);
                    }
                    results.push(copy);
                    if ((0, TypeCheck_1.isDecryptedPayload)(payload) && (0, TypeCheck_1.isDecryptedPayload)(copy)) {
                        /**
                         * Get the payloads that make reference to payload and add the copy.
                         */
                        const updatedReferencing = (0, PayloadsByUpdatingReferencingPayloadReferences_1.PayloadsByUpdatingReferencingPayloadReferences)(payload, baseCollection, [copy]);
                        (0, utils_1.extendArray)(results, updatedReferencing);
                    }
                    return results;
                }
                exports.PayloadsByDuplicating = PayloadsByDuplicating;
                /***/ 
            }),
            /***/ 72208: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.PayloadsByUpdatingReferencingPayloadReferences = void 0;
                const lodash_1 = __webpack_require__(84213);
                const Payload_1 = __webpack_require__(59180);
                const DirtyCounter_1 = __webpack_require__(13743);
                function PayloadsByUpdatingReferencingPayloadReferences(payload, baseCollection) {
                    let add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    let removeIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
                    const referencingPayloads = baseCollection.elementsReferencingElement(payload).filter(Payload_1.isDecryptedPayload);
                    const results = [];
                    for (const referencingPayload of referencingPayloads) {
                        const references = referencingPayload.content.references.slice();
                        const reference = referencingPayload.getReference(payload.uuid);
                        for (const addPayload of add) {
                            const newReference = Object.assign(Object.assign({}, reference), {
                                uuid: addPayload.uuid,
                                content_type: addPayload.content_type
                            });
                            references.push(newReference);
                        }
                        for (const id of removeIds) {
                            (0, lodash_1.remove)(references, {
                                uuid: id
                            });
                        }
                        const result = referencingPayload.copyAsSyncResolved({
                            dirty: true,
                            dirtyIndex: (0, DirtyCounter_1.getIncrementedDirtyIndex)(),
                            lastSyncEnd: new Date(),
                            content: Object.assign(Object.assign({}, referencingPayload.content), {
                                references
                            })
                        });
                        results.push(result);
                    }
                    return results;
                }
                exports.PayloadsByUpdatingReferencingPayloadReferences = PayloadsByUpdatingReferencingPayloadReferences;
                /***/ 
            }),
            /***/ 64475: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(56974), exports);
                __exportStar(__webpack_require__(15866), exports);
                __exportStar(__webpack_require__(35376), exports);
                __exportStar(__webpack_require__(76317), exports);
                __exportStar(__webpack_require__(88076), exports);
                __exportStar(__webpack_require__(68763), exports);
                __exportStar(__webpack_require__(75895), exports);
                __exportStar(__webpack_require__(74601), exports);
                __exportStar(__webpack_require__(3668), exports);
                __exportStar(__webpack_require__(42405), exports);
                __exportStar(__webpack_require__(95698), exports);
                __exportStar(__webpack_require__(55930), exports);
                __exportStar(__webpack_require__(36186), exports);
                __exportStar(__webpack_require__(80537), exports);
                __exportStar(__webpack_require__(1482), exports);
                __exportStar(__webpack_require__(69087), exports);
                __exportStar(__webpack_require__(70359), exports);
                __exportStar(__webpack_require__(13214), exports);
                __exportStar(__webpack_require__(84034), exports);
                __exportStar(__webpack_require__(51600), exports);
                __exportStar(__webpack_require__(30429), exports);
                __exportStar(__webpack_require__(18592), exports);
                __exportStar(__webpack_require__(2116), exports);
                __exportStar(__webpack_require__(18973), exports);
                __exportStar(__webpack_require__(7563), exports);
                __exportStar(__webpack_require__(50292), exports);
                __exportStar(__webpack_require__(59180), exports);
                __exportStar(__webpack_require__(78381), exports);
                __exportStar(__webpack_require__(21907), exports);
                __exportStar(__webpack_require__(66675), exports);
                __exportStar(__webpack_require__(90656), exports);
                __exportStar(__webpack_require__(93715), exports);
                __exportStar(__webpack_require__(84457), exports);
                __exportStar(__webpack_require__(656), exports);
                __exportStar(__webpack_require__(255), exports);
                __exportStar(__webpack_require__(62846), exports);
                __exportStar(__webpack_require__(29899), exports);
                __exportStar(__webpack_require__(22296), exports);
                __exportStar(__webpack_require__(52174), exports);
                __exportStar(__webpack_require__(80910), exports);
                __exportStar(__webpack_require__(87192), exports);
                __exportStar(__webpack_require__(71109), exports);
                __exportStar(__webpack_require__(32099), exports);
                __exportStar(__webpack_require__(55430), exports);
                __exportStar(__webpack_require__(33738), exports);
                __exportStar(__webpack_require__(64130), exports);
                __exportStar(__webpack_require__(18018), exports);
                __exportStar(__webpack_require__(14770), exports);
                __exportStar(__webpack_require__(45698), exports);
                __exportStar(__webpack_require__(63070), exports);
                __exportStar(__webpack_require__(32151), exports);
                __exportStar(__webpack_require__(92207), exports);
                __exportStar(__webpack_require__(36883), exports);
                __exportStar(__webpack_require__(17441), exports);
                __exportStar(__webpack_require__(51833), exports);
                __exportStar(__webpack_require__(19759), exports);
                __exportStar(__webpack_require__(22517), exports);
                __exportStar(__webpack_require__(13743), exports);
                __exportStar(__webpack_require__(30561), exports);
                __exportStar(__webpack_require__(40257), exports);
                __exportStar(__webpack_require__(93974), exports);
                __exportStar(__webpack_require__(96084), exports);
                __exportStar(__webpack_require__(87332), exports);
                __exportStar(__webpack_require__(21662), exports);
                __exportStar(__webpack_require__(47469), exports);
                __exportStar(__webpack_require__(74958), exports);
                __exportStar(__webpack_require__(36053), exports);
                __exportStar(__webpack_require__(18284), exports);
                __exportStar(__webpack_require__(78274), exports);
                __exportStar(__webpack_require__(47479), exports);
                __exportStar(__webpack_require__(21626), exports);
                __exportStar(__webpack_require__(8698), exports);
                __exportStar(__webpack_require__(26550), exports);
                __exportStar(__webpack_require__(80389), exports);
                __exportStar(__webpack_require__(21271), exports);
                __exportStar(__webpack_require__(21271), exports);
                __exportStar(__webpack_require__(73067), exports);
                __exportStar(__webpack_require__(21014), exports);
                __exportStar(__webpack_require__(78688), exports);
                __exportStar(__webpack_require__(58506), exports);
                __exportStar(__webpack_require__(40826), exports);
                __exportStar(__webpack_require__(52659), exports);
                __exportStar(__webpack_require__(10123), exports);
                __exportStar(__webpack_require__(12310), exports);
                __exportStar(__webpack_require__(25698), exports);
                __exportStar(__webpack_require__(87500), exports);
                __exportStar(__webpack_require__(2836), exports);
                __exportStar(__webpack_require__(52493), exports);
                __exportStar(__webpack_require__(82412), exports);
                __exportStar(__webpack_require__(23811), exports);
                __exportStar(__webpack_require__(19725), exports);
                __exportStar(__webpack_require__(82818), exports);
                __exportStar(__webpack_require__(95132), exports);
                __exportStar(__webpack_require__(31750), exports);
                __exportStar(__webpack_require__(64836), exports);
                __exportStar(__webpack_require__(28819), exports);
                __exportStar(__webpack_require__(42006), exports);
                __exportStar(__webpack_require__(41138), exports);
                __exportStar(__webpack_require__(87458), exports);
                __exportStar(__webpack_require__(82602), exports);
                __exportStar(__webpack_require__(63195), exports);
                __exportStar(__webpack_require__(68092), exports);
                __exportStar(__webpack_require__(21436), exports);
                __exportStar(__webpack_require__(79609), exports);
                __exportStar(__webpack_require__(15845), exports);
                __exportStar(__webpack_require__(5478), exports);
                __exportStar(__webpack_require__(19332), exports);
                __exportStar(__webpack_require__(53840), exports);
                __exportStar(__webpack_require__(3396), exports);
                __exportStar(__webpack_require__(52897), exports);
                __exportStar(__webpack_require__(59402), exports);
                __exportStar(__webpack_require__(82259), exports);
                __exportStar(__webpack_require__(44957), exports);
                __exportStar(__webpack_require__(53555), exports);
                __exportStar(__webpack_require__(40249), exports);
                __exportStar(__webpack_require__(33545), exports);
                __exportStar(__webpack_require__(41035), exports);
                __exportStar(__webpack_require__(73277), exports);
                __exportStar(__webpack_require__(74527), exports);
                __exportStar(__webpack_require__(88141), exports);
                __exportStar(__webpack_require__(15658), exports);
                __exportStar(__webpack_require__(37807), exports);
                __exportStar(__webpack_require__(15005), exports);
                __exportStar(__webpack_require__(27446), exports);
                __exportStar(__webpack_require__(50723), exports);
                /***/ 
            }),
            /***/ 22325: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(64475), exports);
                /***/ 
            }),
            /***/ 34789: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 88645: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 29590: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 77345: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 79594: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 81563: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 29547: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 89398: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 41278: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 48126: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 60346: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39881: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 11706: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 74113: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68224: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 14116: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 22893: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 94764: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.isClientDisplayableError = exports.ClientDisplayableError = void 0;
                const Http_1 = __webpack_require__(92961);
                class ClientDisplayableError {
                    constructor(text, title, tag) {
                        this.text = text;
                        this.title = title;
                        this.tag = tag;
                        console.error('Client Displayable Error:', text, title || '', tag || '');
                    }
                    static FromError(error) {
                        return new ClientDisplayableError(error.message, undefined, error.tag);
                    }
                    static FromString(text) {
                        return new ClientDisplayableError(text);
                    }
                    static FromNetworkError(error) {
                        return new ClientDisplayableError((0, Http_1.getErrorFromErrorResponse)(error).message);
                    }
                }
                exports.ClientDisplayableError = ClientDisplayableError;
                function isClientDisplayableError(error) {
                    return error instanceof ClientDisplayableError;
                }
                exports.isClientDisplayableError = isClientDisplayableError;
                /***/ 
            }),
            /***/ 89408: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23632: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 37525: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 22039: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43129: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 27196: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 43630: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 53980: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 46707: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 13838: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 95573: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 42338: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 32176: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DeprecatedStatusCode = void 0;
                var DeprecatedStatusCode;
                (function (DeprecatedStatusCode) {
                    DeprecatedStatusCode[DeprecatedStatusCode["LocalValidationError"] = 10] = "LocalValidationError";
                    DeprecatedStatusCode[DeprecatedStatusCode["CanceledMfa"] = 11] = "CanceledMfa";
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusMinSuccess"] = 200] = "HttpStatusMinSuccess";
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusNoContent"] = 204] = "HttpStatusNoContent";
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusMaxSuccess"] = 299] = "HttpStatusMaxSuccess";
                    /** The session's access token is expired, but the refresh token is valid */
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusExpiredAccessToken"] = 498] = "HttpStatusExpiredAccessToken";
                    /** The session's access token and refresh token are expired, user must reauthenticate */
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusInvalidSession"] = 401] = "HttpStatusInvalidSession";
                    /** User's IP is rate-limited. */
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpStatusForbidden"] = 403] = "HttpStatusForbidden";
                    DeprecatedStatusCode[DeprecatedStatusCode["HttpBadRequest"] = 400] = "HttpBadRequest";
                })(DeprecatedStatusCode || (exports.DeprecatedStatusCode = DeprecatedStatusCode = {}));
                /***/ 
            }),
            /***/ 67545: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ErrorTag = void 0;
                var ErrorTag;
                (function (ErrorTag) {
                    ErrorTag["MfaInvalid"] = "mfa-invalid";
                    ErrorTag["MfaRequired"] = "mfa-required";
                    ErrorTag["U2FRequired"] = "u2f-required";
                    ErrorTag["RefreshTokenInvalid"] = "invalid-refresh-token";
                    ErrorTag["RefreshTokenExpired"] = "expired-refresh-token";
                    ErrorTag["AccessTokenExpired"] = "expired-access-token";
                    ErrorTag["ParametersInvalid"] = "invalid-parameters";
                    ErrorTag["RevokedSession"] = "revoked-session";
                    ErrorTag["AuthInvalid"] = "invalid-auth";
                    ErrorTag["ReadOnlyAccess"] = "read-only-access";
                    ErrorTag["ExpiredItemShare"] = "expired-item-share";
                    ErrorTag["ClientValidationError"] = "client-validation-error";
                    ErrorTag["ClientCanceledMfa"] = "client-canceled-mfa";
                })(ErrorTag || (exports.ErrorTag = ErrorTag = {}));
                /***/ 
            }),
            /***/ 64404: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 48379: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 11910: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 44323: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 53251: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23269: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.getErrorFromErrorResponse = exports.getErrorMessageFromErrorResponseBody = exports.getCaptchaHeader = exports.isErrorResponse = void 0;
                function isErrorResponse(response) {
                    var _a;
                    return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.error) != undefined || response.status >= 400;
                }
                exports.isErrorResponse = isErrorResponse;
                function getCaptchaHeader(response) {
                    var _a;
                    const captchaHeader = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('x-captcha-required');
                    if (captchaHeader) {
                        return captchaHeader;
                    }
                    return null;
                }
                exports.getCaptchaHeader = getCaptchaHeader;
                function getErrorMessageFromErrorResponseBody(data, defaultMessage) {
                    let errorMessage = defaultMessage || 'Unknown error';
                    if (data && typeof data === 'object' && 'error' in data && data.error && typeof data.error === 'object' && 'message' in data.error) {
                        errorMessage = data.error.message;
                    }
                    return errorMessage;
                }
                exports.getErrorMessageFromErrorResponseBody = getErrorMessageFromErrorResponseBody;
                function getErrorFromErrorResponse(response) {
                    const embeddedError = response.data.error;
                    if (embeddedError) {
                        return embeddedError;
                    }
                    return {
                        message: 'Unknown error'
                    };
                }
                exports.getErrorFromErrorResponse = getErrorFromErrorResponse;
                /***/ 
            }),
            /***/ 58009: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 95778: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.HttpStatusCode = void 0;
                var HttpStatusCode;
                (function (HttpStatusCode) {
                    HttpStatusCode[HttpStatusCode["Success"] = 200] = "Success";
                    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
                    HttpStatusCode[HttpStatusCode["MultipleChoices"] = 300] = "MultipleChoices";
                    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
                    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
                    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
                    HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
                    HttpStatusCode[HttpStatusCode["ExpiredAccessToken"] = 498] = "ExpiredAccessToken";
                    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
                })(HttpStatusCode || (exports.HttpStatusCode = HttpStatusCode = {}));
                /***/ 
            }),
            /***/ 37204: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.HttpVerb = void 0;
                var HttpVerb;
                (function (HttpVerb) {
                    HttpVerb["Get"] = "GET";
                    HttpVerb["Post"] = "POST";
                    HttpVerb["Put"] = "PUT";
                    HttpVerb["Patch"] = "PATCH";
                    HttpVerb["Delete"] = "DELETE";
                })(HttpVerb || (exports.HttpVerb = HttpVerb = {}));
                /***/ 
            }),
            /***/ 92961: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(67545), exports);
                __exportStar(__webpack_require__(48379), exports);
                __exportStar(__webpack_require__(11910), exports);
                __exportStar(__webpack_require__(44323), exports);
                __exportStar(__webpack_require__(53251), exports);
                __exportStar(__webpack_require__(23269), exports);
                __exportStar(__webpack_require__(58009), exports);
                __exportStar(__webpack_require__(37204), exports);
                __exportStar(__webpack_require__(46707), exports);
                __exportStar(__webpack_require__(13838), exports);
                __exportStar(__webpack_require__(95573), exports);
                __exportStar(__webpack_require__(42338), exports);
                __exportStar(__webpack_require__(32176), exports);
                __exportStar(__webpack_require__(95778), exports);
                __exportStar(__webpack_require__(64404), exports);
                /***/ 
            }),
            /***/ 72646: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ApiEndpointParam = void 0;
                var ApiEndpointParam;
                (function (ApiEndpointParam) {
                    ApiEndpointParam["LastSyncToken"] = "sync_token";
                    ApiEndpointParam["PaginationToken"] = "cursor_token";
                    ApiEndpointParam["SyncDlLimit"] = "limit";
                    ApiEndpointParam["SyncPayloads"] = "items";
                    ApiEndpointParam["ApiVersion"] = "api";
                    ApiEndpointParam["SharedVaultUuids"] = "shared_vault_uuids";
                })(ApiEndpointParam || (exports.ApiEndpointParam = ApiEndpointParam = {}));
                /***/ 
            }),
            /***/ 21799: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 6579: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.conflictParamsHasOnlyUnsavedItem = exports.conflictParamsHasOnlyServerItem = exports.conflictParamsHasServerItemAndUnsavedItem = void 0;
                function conflictParamsHasServerItemAndUnsavedItem(params) {
                    return params.server_item !== undefined && params.unsaved_item !== undefined;
                }
                exports.conflictParamsHasServerItemAndUnsavedItem = conflictParamsHasServerItemAndUnsavedItem;
                function conflictParamsHasOnlyServerItem(params) {
                    return params.server_item !== undefined;
                }
                exports.conflictParamsHasOnlyServerItem = conflictParamsHasOnlyServerItem;
                function conflictParamsHasOnlyUnsavedItem(params) {
                    return params.unsaved_item !== undefined;
                }
                exports.conflictParamsHasOnlyUnsavedItem = conflictParamsHasOnlyUnsavedItem;
                /***/ 
            }),
            /***/ 68655: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ConflictType = void 0;
                var ConflictType;
                (function (ConflictType) {
                    ConflictType["ConflictingData"] = "sync_conflict";
                    ConflictType["UuidConflict"] = "uuid_conflict";
                    ConflictType["ContentTypeError"] = "content_type_error";
                    ConflictType["ContentError"] = "content_error";
                    ConflictType["ReadOnlyError"] = "readonly_error";
                    ConflictType["UuidError"] = "uuid_error";
                    ConflictType["InvalidServerItem"] = "invalid_server_item";
                    ConflictType["SharedVaultSnjsVersionError"] = "shared_vault_snjs_version_error";
                    ConflictType["SharedVaultInsufficientPermissionsError"] = "shared_vault_insufficient_permissions_error";
                    ConflictType["SharedVaultNotMemberError"] = "shared_vault_not_member_error";
                    ConflictType["SharedVaultInvalidState"] = "shared_vault_invalid_state";
                })(ConflictType || (exports.ConflictType = ConflictType = {}));
                /***/ 
            }),
            /***/ 95833: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 46911: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 20459: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                const ApiEndpointParam_1 = __webpack_require__(72646);
                /***/ 
            }),
            /***/ 74397: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80653: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 96579: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 42374: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 51658: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 22487: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 20421: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 20780: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 34455: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 6976: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 1539: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 81526: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 13177: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 86682: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 2564: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.ValetTokenOperation = void 0;
                var ValetTokenOperation;
                (function (ValetTokenOperation) {
                    ValetTokenOperation["Read"] = "read";
                    ValetTokenOperation["Write"] = "write";
                    ValetTokenOperation["Delete"] = "delete";
                    ValetTokenOperation["Move"] = "move";
                })(ValetTokenOperation || (exports.ValetTokenOperation = ValetTokenOperation = {}));
                /***/ 
            }),
            /***/ 98819: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 9283: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39805: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 28022: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 80933: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 22906: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 65802: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 44877: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 13562: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 23324: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 35956: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(88645), exports);
                __exportStar(__webpack_require__(29590), exports);
                __exportStar(__webpack_require__(77345), exports);
                __exportStar(__webpack_require__(79594), exports);
                __exportStar(__webpack_require__(29547), exports);
                __exportStar(__webpack_require__(89398), exports);
                __exportStar(__webpack_require__(41278), exports);
                __exportStar(__webpack_require__(48126), exports);
                __exportStar(__webpack_require__(60346), exports);
                __exportStar(__webpack_require__(39881), exports);
                __exportStar(__webpack_require__(11706), exports);
                __exportStar(__webpack_require__(74113), exports);
                __exportStar(__webpack_require__(68224), exports);
                __exportStar(__webpack_require__(14116), exports);
                __exportStar(__webpack_require__(22893), exports);
                __exportStar(__webpack_require__(81563), exports);
                /** Temps are awaiting final publish state on server repo */
                __exportStar(__webpack_require__(13177), exports);
                __exportStar(__webpack_require__(86682), exports);
                __exportStar(__webpack_require__(2564), exports);
                __exportStar(__webpack_require__(81526), exports);
                __exportStar(__webpack_require__(94764), exports);
                __exportStar(__webpack_require__(89408), exports);
                __exportStar(__webpack_require__(23632), exports);
                __exportStar(__webpack_require__(37525), exports);
                __exportStar(__webpack_require__(22039), exports);
                __exportStar(__webpack_require__(43129), exports);
                __exportStar(__webpack_require__(43630), exports);
                __exportStar(__webpack_require__(53980), exports);
                __exportStar(__webpack_require__(27196), exports);
                __exportStar(__webpack_require__(92961), exports);
                __exportStar(__webpack_require__(34455), exports);
                __exportStar(__webpack_require__(1539), exports);
                __exportStar(__webpack_require__(6976), exports);
                __exportStar(__webpack_require__(34789), exports);
                __exportStar(__webpack_require__(72646), exports);
                __exportStar(__webpack_require__(21799), exports);
                __exportStar(__webpack_require__(6579), exports);
                __exportStar(__webpack_require__(68655), exports);
                __exportStar(__webpack_require__(95833), exports);
                __exportStar(__webpack_require__(20459), exports);
                __exportStar(__webpack_require__(74397), exports);
                __exportStar(__webpack_require__(80653), exports);
                __exportStar(__webpack_require__(46911), exports);
                __exportStar(__webpack_require__(96579), exports);
                __exportStar(__webpack_require__(42374), exports);
                __exportStar(__webpack_require__(51658), exports);
                __exportStar(__webpack_require__(22487), exports);
                __exportStar(__webpack_require__(20421), exports);
                __exportStar(__webpack_require__(98819), exports);
                __exportStar(__webpack_require__(9283), exports);
                __exportStar(__webpack_require__(39805), exports);
                __exportStar(__webpack_require__(28022), exports);
                __exportStar(__webpack_require__(80933), exports);
                __exportStar(__webpack_require__(22906), exports);
                __exportStar(__webpack_require__(65802), exports);
                __exportStar(__webpack_require__(44877), exports);
                __exportStar(__webpack_require__(13562), exports);
                __exportStar(__webpack_require__(23324), exports);
                __exportStar(__webpack_require__(20780), exports);
                __exportStar(__webpack_require__(34455), exports);
                __exportStar(__webpack_require__(6976), exports);
                __exportStar(__webpack_require__(1539), exports);
                /***/ 
            }),
            /***/ 95658: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(35956), exports);
                /***/ 
            }),
            /***/ 55668: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    WLG: () => ( /* reexport */API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS),
                    gQA: () => ( /* reexport */API_MESSAGE_FAILED_ACCESS_PURCHASE),
                    qIx: () => ( /* reexport */API_MESSAGE_FAILED_CREATE_FILE_TOKEN),
                    mvL: () => ( /* reexport */API_MESSAGE_FAILED_DOWNLOADING_EXTENSION),
                    Zq2: () => ( /* reexport */API_MESSAGE_FAILED_GET_SETTINGS),
                    EaW: () => ( /* reexport */API_MESSAGE_FAILED_LISTED_REGISTRATION),
                    iMd: () => ( /* reexport */API_MESSAGE_FAILED_OFFLINE_ACTIVATION),
                    WZ6: () => ( /* reexport */API_MESSAGE_FAILED_OFFLINE_FEATURES),
                    BMD: () => ( /* reexport */API_MESSAGE_FAILED_SUBSCRIPTION_INFO),
                    oBV: () => ( /* reexport */API_MESSAGE_FAILED_UPDATE_SETTINGS),
                    aWs: () => ( /* reexport */API_MESSAGE_FALLBACK_LOGIN_FAIL),
                    Z15: () => ( /* reexport */API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL),
                    oe5: () => ( /* reexport */API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL),
                    VpG: () => ( /* reexport */API_MESSAGE_GENERIC_INVALID_LOGIN),
                    Cj$: () => ( /* reexport */API_MESSAGE_GENERIC_REGISTRATION_FAIL),
                    TwN: () => ( /* reexport */API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL),
                    gEn: () => ( /* reexport */API_MESSAGE_GENERIC_SYNC_FAIL),
                    lO_: () => ( /* reexport */API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL),
                    aXB: () => ( /* reexport */API_MESSAGE_INVALID_SESSION),
                    TYJ: () => ( /* reexport */API_MESSAGE_LOGIN_IN_PROGRESS),
                    jN7: () => ( /* reexport */API_MESSAGE_RATE_LIMITED),
                    vfv: () => ( /* reexport */API_MESSAGE_REGISTRATION_IN_PROGRESS),
                    z6z: () => ( /* reexport */API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS),
                    CV: () => ( /* reexport */API_MESSAGE_UNTRUSTED_EXTENSIONS_WARNING),
                    wcN: () => ( /* reexport */AbstractService),
                    nmV: () => ( /* reexport */AcceptVaultInvite),
                    oF7: () => ( /* reexport */AccountEvent),
                    c9N: () => ( /* reexport */AlertService),
                    Sf$: () => ( /* reexport */ApiServiceEvent),
                    mxT: () => ( /* reexport */AppleIAPProductId),
                    n9K: () => ( /* reexport */ApplicationEvent),
                    U3K: () => ( /* reexport */ApplicationOptionsDefaults),
                    Ugm: () => ( /* reexport */ApplicationStage),
                    WXh: () => ( /* reexport */AsymmetricMessageService),
                    El: () => ( /* reexport */AuthManager),
                    F8w: () => ( /* reexport */AuthenticatorManager),
                    D$B: () => ( /* reexport */AuthorizeVaultDeletion),
                    L$3: () => ( /* reexport */ButtonType),
                    V1G: () => ( /* reexport */CHANGING_PASSCODE),
                    tv4: () => ( /* reexport */Challenge),
                    gqK: () => ( /* reexport */ChallengeKeyboardType),
                    GnZ: () => ( /* reexport */ChallengeModalTitle),
                    FEo: () => ( /* reexport */ChallengePrompt),
                    fD2: () => ( /* reexport */ChallengePromptTitle),
                    Ps8: () => ( /* reexport */ChallengeReason),
                    NiJ: () => ( /* reexport */ChallengeStrings),
                    tQn: () => ( /* reexport */ChallengeValidation),
                    EdL: () => ( /* reexport */ChangeAndSaveItem),
                    tuB: () => ( /* reexport */ChangeVaultKeyOptions),
                    KH1: () => ( /* reexport */ChangeVaultStorageMode),
                    kQg: () => ( /* reexport */ComponentViewerError),
                    euo: () => ( /* reexport */ContactBelongsToVault),
                    yqc: () => ( /* reexport */ContactService),
                    EFn: () => ( /* reexport */ContactServiceEvent),
                    b$E: () => ( /* reexport */ConvertToSharedVault),
                    KL0: () => ( /* reexport */CreateChallengeValue),
                    ocI: () => ( /* reexport */CreateDecryptedBackupFile),
                    D6l: () => ( /* reexport */CreateEncryptedBackupFile),
                    Nwx: () => ( /* reexport */CreateNewDefaultItemsKey),
                    Yw: () => ( /* reexport */CreateNewItemsKeyWithRollback),
                    Dk4: () => ( /* reexport */CreateOrEditContact),
                    zEM: () => ( /* reexport */CreateSharedVault),
                    TQm: () => ( /* reexport */CreateVault),
                    Y7C: () => ( /* reexport */CredentialsChangeStrings),
                    liL: () => ( /* reexport */DO_NOT_CLOSE_APPLICATION),
                    vV3: () => ( /* reexport */DecryptBackupFile),
                    ZXN: () => ( /* reexport */DecryptBackupPayloads),
                    eyx: () => ( /* reexport */DecryptErroredPayloads),
                    suI: () => ( /* reexport */DecryptErroredTypeAPayloads),
                    zW4: () => ( /* reexport */DecryptItemsKeyByPromptingUser),
                    nGw: () => ( /* reexport */DecryptItemsKeyWithUserFallback),
                    $M4: () => ( /* reexport */DecryptMessage),
                    EQN: () => ( /* reexport */DecryptOwnMessage),
                    gzl: () => ( /* reexport */DecryptTypeAPayload),
                    qXV: () => ( /* reexport */DecryptTypeAPayloadWithKeyLookup),
                    CYv: () => ( /* reexport */DeinitMode),
                    u4P: () => ( /* reexport */DeinitSource),
                    z8s: () => ( /* reexport */DeleteContact),
                    KLn: () => ( /* reexport */DeleteSharedVault),
                    jGD: () => ( /* reexport */DeleteThirdPartyVault),
                    Rws: () => ( /* reexport */DeleteVault),
                    X2V: () => ( /* reexport */DesignateSurvivor),
                    WEs: () => ( /* reexport */DetermineKeyToUse),
                    Ydb: () => ( /* reexport */DiscardItemsLocally),
                    R53: () => ( /* reexport */EXPIRED_PROTOCOL_VERSION),
                    ZQj: () => ( /* reexport */EditContact),
                    S1n: () => ( /* reexport */EncryptMessage),
                    i6C: () => ( /* reexport */EncryptTypeAPayload),
                    k6d: () => ( /* reexport */EncryptTypeAPayloadWithKeyLookup),
                    C6q: () => ( /* reexport */EncryptionService),
                    fa_: () => ( /* reexport */EncryptionServiceEvent),
                    kov: () => ( /* reexport */ErrorAlertStrings),
                    iKc: () => ( /* reexport */FeatureStatus),
                    Usi: () => ( /* reexport */FeaturesEvent),
                    aax: () => ( /* reexport */FileBackupsDirectoryName),
                    IpN: () => ( /* reexport */FileService),
                    exs: () => ( /* reexport */FilesBackupService),
                    VD3: () => ( /* reexport */FindContact),
                    iPu: () => ( /* reexport */FindDefaultItemsKey),
                    ug$: () => ( /* reexport */GenerateUuid),
                    s$_: () => ( /* reexport */GetAllContacts),
                    KCz: () => ( /* reexport */GetBackupFileType),
                    DZq: () => ( /* reexport */GetFilePassword),
                    cdY: () => ( /* reexport */GetHost),
                    Vxn: () => ( /* reexport */GetInboundMessages),
                    Byj: () => ( /* reexport */GetKeyPairs),
                    qk9: () => ( /* reexport */GetMessageAdditionalData),
                    WUT: () => ( /* reexport */GetOutboundMessages),
                    tlz: () => ( /* reexport */GetOwnedSharedVaults),
                    Tog: () => ( /* reexport */GetSharedVaults),
                    xOS: () => ( /* reexport */GetSortedPayloadsByPriority),
                    pqE: () => ( /* reexport */GetTrustedPayload),
                    P9M: () => ( /* reexport */GetUntrustedPayload),
                    dDs: () => ( /* reexport */GetVault),
                    bDv: () => ( /* reexport */GetVaultContacts),
                    $qZ: () => ( /* reexport */GetVaultItems),
                    PDt: () => ( /* reexport */GetVaultUsers),
                    r0l: () => ( /* reexport */GetVaults),
                    qjc: () => ( /* reexport */HandleKeyPairChange),
                    cjV: () => ( /* reexport */HandleRootKeyChangedMessage),
                    tGH: () => ( /* reexport */HomeServerService),
                    $cH: () => ( /* reexport */INVALID_EXTENSION_URL),
                    CVE: () => ( /* reexport */INVALID_PASSWORD),
                    nIe: () => ( /* reexport */INVALID_PASSWORD_COST),
                    Ens: () => ( /* reexport */ImportData),
                    CEH: () => ( /* reexport */InMemoryStore),
                    l4I: () => ( /* reexport */InfoStrings),
                    Bw1: () => ( /* reexport */InsufficientPasswordMessage),
                    ezr: () => ( /* reexport */IntegrityEvent),
                    yim: () => ( /* reexport */IntegrityService),
                    Ehg: () => ( /* reexport */InternalEventBus),
                    WNP: () => ( /* reexport */InternalEventPublishStrategy),
                    KK4: () => ( /* reexport */InternalFeature),
                    BbS: () => ( /* reexport */InternalFeatureService),
                    RAe: () => ( /* reexport */InviteToVault),
                    Y8x: () => ( /* reexport */IsApplicationUsingThirdPartyHost),
                    hEi: () => ( /* reexport */IsReadonlyVaultMember),
                    o1e: () => ( /* reexport */IsVaultAdmin),
                    hjk: () => ( /* reexport */IsVaultOwner),
                    uMm: () => ( /* reexport */ItemRelationshipDirection),
                    kNl: () => ( /* reexport */ItemSignatureValidationResult),
                    oQ4: () => ( /* reexport */ItemsEncryptionService),
                    UEW: () => ( /* reexport */KeyMode),
                    Pn4: () => ( /* reexport */KeySystemKeyManager),
                    mHn: () => ( /* reexport */KeychainRecoveryStrings),
                    Z7G: () => ( /* reexport */LeaveVault),
                    Icj: () => ( /* reexport */LegacyKeys1_0_0),
                    dH$: () => ( /* reexport */LocalPrefKey),
                    sNv: () => ( /* reexport */MobileUnlockTiming),
                    cZu: () => ( /* reexport */MoveItemsToVault),
                    cU9: () => ( /* reexport */NonwrappedStorageKey),
                    gqp: () => ( /* reexport */NotificationService),
                    JQe: () => ( /* reexport */NotificationServiceEvent),
                    cVV: () => ( /* reexport */NotifyVaultUsersOfKeyRotation),
                    _Bl: () => ( /* reexport */OUTDATED_PROTOCOL_ALERT_IGNORE),
                    WZd: () => ( /* reexport */PreferencesServiceEvent),
                    Klw: () => ( /* reexport */ProcessAcceptedVaultInvite),
                    Hh3: () => ( /* reexport */ProtectionEvent),
                    GUt: () => ( /* reexport */ProtocolUpgradeStrings),
                    vL5: () => ( /* reexport */REMOVING_PASSCODE),
                    Bq2: () => ( /* reexport */RawStorageKey),
                    HSp: () => ( /* reexport */ReencryptTypeAItems),
                    rc1: () => ( /* reexport */RegisterStrings),
                    fF_: () => ( /* reexport */RemoveItemFromVault),
                    $sG: () => ( /* reexport */RemoveItemsFromMemory),
                    YxU: () => ( /* reexport */RemoveVaultMember),
                    xRL: () => ( /* reexport */ReplaceContactData),
                    HLD: () => ( /* reexport */ResendAllMessages),
                    IF$: () => ( /* reexport */ResendMessage),
                    F0Y: () => ( /* reexport */ReuploadAllInvites),
                    afr: () => ( /* reexport */ReuploadInvite),
                    s7t: () => ( /* reexport */ReuploadVaultInvites),
                    t9U: () => ( /* reexport */RevisionManager),
                    wtP: () => ( /* reexport */RootKeyManager),
                    PqX: () => ( /* reexport */RotateVaultKey),
                    TpP: () => ( /* reexport */SETTING_PASSCODE),
                    Ld1: () => ( /* reexport */SelfContactManager),
                    uzh: () => ( /* reexport */SendMessage),
                    u3X: () => ( /* reexport */SendOwnContactChangeMessage),
                    $SL: () => ( /* reexport */SendVaultDataChangedMessage),
                    Iup: () => ( /* reexport */SendVaultInvite),
                    Foy: () => ( /* reexport */SendVaultKeyChangedMessage),
                    VxG: () => ( /* reexport */ServerErrorStrings),
                    Pxr: () => ( /* reexport */SessionEvent),
                    K9E: () => ( /* reexport */SessionStrings),
                    q62: () => ( /* reexport */SetHost),
                    uLb: () => ( /* reexport */ShareContactWithVault),
                    cnh: () => ( /* reexport */SharedVaultService),
                    $_C: () => ( /* reexport */SharedVaultServiceEvent),
                    Mwm: () => ( /* reexport */SignInStrings),
                    kNs: () => ( /* reexport */StaticItemCounter),
                    Bjn: () => ( /* reexport */StatusService),
                    rW4: () => ( /* reexport */StatusServiceEvent),
                    QtK: () => ( /* reexport */StorageKey),
                    eIN: () => ( /* reexport */StoragePersistencePolicies),
                    qt7: () => ( /* reexport */StorageValueModes),
                    OC4: () => ( /* reexport */StrictSignInFailed),
                    LF2: () => ( /* reexport */SubscriptionManager),
                    lKe: () => ( /* reexport */SubscriptionManagerEvent),
                    XEg: () => ( /* reexport */SyncBackoffService),
                    wMo: () => ( /* reexport */SyncEvent),
                    _Jh: () => ( /* reexport */SyncLocalVaultsWithRemoteSharedVaults),
                    YCg: () => ( /* reexport */SyncMode),
                    BUK: () => ( /* reexport */SyncOpStatus),
                    Sii: () => ( /* reexport */SyncQueueStrategy),
                    Lbd: () => ( /* reexport */SyncSource),
                    OU3: () => ( /* reexport */TextBackupsDirectoryName),
                    I4j: () => ( /* reexport */UNKNOWN_ERROR),
                    VnT: () => ( /* reexport */UNSUPPORTED_KEY_DERIVATION),
                    fnl: () => ( /* reexport */UNSUPPORTED_PROTOCOL_VERSION),
                    RsP: () => ( /* reexport */UPGRADING_ENCRYPTION),
                    KDu: () => ( /* reexport */UserService),
                    Lv2: () => ( /* reexport */ValidateItemSigner),
                    EGP: () => ( /* reexport */ValidateVaultPassword),
                    dDH: () => ( /* reexport */ValueModesKeys),
                    hZp: () => ( /* reexport */VaultInviteService),
                    Z$T: () => ( /* reexport */VaultInviteServiceEvent),
                    PHC: () => ( /* reexport */VaultLockService),
                    h21: () => ( /* reexport */VaultLockServiceEvent),
                    RDE: () => ( /* reexport */VaultService),
                    ccW: () => ( /* reexport */VaultServiceEvent),
                    k7Z: () => ( /* reexport */VaultUserCache),
                    igb: () => ( /* reexport */VaultUserService),
                    UR5: () => ( /* reexport */VaultUserServiceEvent),
                    B5f: () => ( /* reexport */WebAppEvent),
                    BV4: () => ( /* reexport */WebSocketsService),
                    fAX: () => ( /* reexport */WebSocketsServiceEvent),
                    ufS: () => ( /* reexport */isChunkFullEntry),
                    qr4: () => ( /* reexport */isComponentViewerItemReadonlyItem),
                    dse: () => ( /* reexport */isDesktopDevice),
                    Or9: () => ( /* reexport */isFullEntryLoadChunkResponse),
                    s2G: () => ( /* reexport */isMobileDevice),
                    xLN: () => ( /* reexport */namespacedKey)
                });
                ; // CONCATENATED MODULE: ../services/src/Domain/Alert/AlertService.ts
                /* istanbul ignore file */
                var ButtonType;
                (function (ButtonType) {
                    ButtonType[ButtonType["Info"] = 0] = "Info";
                    ButtonType[ButtonType["Danger"] = 1] = "Danger";
                })(ButtonType || (ButtonType = {}));
                class AlertService {
                    showErrorAlert(error) {
                        return this.alert(error.text, error.title);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Api/ApiServiceEvent.ts
                /* istanbul ignore file */
                var ApiServiceEvent;
                (function (ApiServiceEvent) {
                    ApiServiceEvent["MetaReceived"] = "MetaReceived";
                    ApiServiceEvent["SessionRefreshed"] = "SessionRefreshed";
                })(ApiServiceEvent || (ApiServiceEvent = {}));
                // EXTERNAL MODULE: ../responses/dist/index.js
                var dist = __webpack_require__(95658);
                ; // CONCATENATED MODULE: ../services/src/Domain/Api/WebSocketsServiceEvent.ts
                var WebSocketsServiceEvent;
                (function (WebSocketsServiceEvent) {
                    WebSocketsServiceEvent["UserRoleMessageReceived"] = "WebSocketMessageReceived";
                    WebSocketsServiceEvent["NotificationAddedForUser"] = "NotificationAddedForUser";
                    WebSocketsServiceEvent["MessageSentToUser"] = "MessageSentToUser";
                    WebSocketsServiceEvent["UserInvitedToSharedVault"] = "UserInvitedToSharedVault";
                    WebSocketsServiceEvent["ItemsChangedOnServer"] = "ItemsChangedOnServer";
                })(WebSocketsServiceEvent || (WebSocketsServiceEvent = {}));
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                ; // CONCATENATED MODULE: ../services/src/Domain/Internal/InternalEventPublishStrategy.ts
                var InternalEventPublishStrategy;
                (function (InternalEventPublishStrategy) {
                    InternalEventPublishStrategy["ASYNC"] = "ASYNC";
                    InternalEventPublishStrategy["SEQUENCE"] = "SEQUENCE";
                })(InternalEventPublishStrategy || (InternalEventPublishStrategy = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Service/AbstractService.ts
                /* istanbul ignore file */
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AbstractService {
                    constructor(internalEventBus) {
                        this.internalEventBus = internalEventBus;
                        this.eventObservers = [];
                        this.loggingEnabled = false;
                        this.criticalPromises = [];
                        this.eventDisposers = [];
                    }
                    addEventObserver(observer) {
                        this.eventObservers.push(observer);
                        const thislessEventObservers = this.eventObservers;
                        return () => {
                            (0, utils_dist.removeFromArray)(thislessEventObservers, observer);
                        };
                    }
                    notifyEvent(eventName, data) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            for (const observer of this.eventObservers) {
                                yield observer(eventName, data);
                            }
                            (_a = this.internalEventBus) === null || _a === void 0 ? void 0 : _a.publish({
                                type: eventName,
                                payload: data
                            });
                        });
                    }
                    notifyEventSync(eventName, data) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            for (const observer of this.eventObservers) {
                                yield observer(eventName, data);
                            }
                            yield (_a = this.internalEventBus) === null || _a === void 0 ? void 0 : _a.publishSync({
                                type: eventName,
                                payload: data
                            }, InternalEventPublishStrategy.SEQUENCE);
                        });
                    }
                    getDiagnostics() {
                        return Promise.resolve(undefined);
                    }
                    /**
                     * Called by application to allow services to momentarily block deinit until
                     * sensitive operations complete.
                     */
                    blockDeinit() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield Promise.all(this.criticalPromises);
                        });
                    }
                    /**
                     * Called by application before restart.
                     * Subclasses should deregister any observers/timers
                     */
                    deinit() {
                        this.eventObservers.length = 0;
                        this.internalEventBus = undefined;
                        this.criticalPromises = undefined;
                        for (const disposer of this.eventDisposers) {
                            disposer();
                        }
                        this.eventDisposers = [];
                    }
                    /**
                     * A critical function is one that should block signing out or destroying application
                     * session until the crticial function has completed. For example, persisting keys to
                     * disk is a critical operation, and should be wrapped in this function call. The
                     * parent application instance will await all criticial functions via the `blockDeinit`
                     * function before signing out and deiniting.
                     */
                    executeCriticalFunction(func) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const promise = func();
                            this.criticalPromises.push(promise);
                            return promise;
                        });
                    }
                    getServiceName() {
                        return this.constructor.name;
                    }
                    isApplicationService() {
                        return true;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Storage/StorageKeys.ts
                /**
                 * Unmanaged keys stored in root storage.
                 * Raw storage keys exist outside of StorageManager domain
                 */
                var RawStorageKey;
                (function (RawStorageKey) {
                    RawStorageKey["StorageObject"] = "storage";
                    RawStorageKey["DescriptorRecord"] = "descriptors";
                    RawStorageKey["SnjsVersion"] = "snjs_version";
                    RawStorageKey["HomeServerEnabled"] = "home_server_enabled";
                    RawStorageKey["HomeServerDataLocation"] = "home_serve_data_location";
                })(RawStorageKey || (RawStorageKey = {}));
                /**
                 * Keys used for retrieving and saving simple key/value pairs.
                 * These keys are managed and are embedded inside RawStorageKey.StorageObject
                 */
                var StorageKey;
                (function (StorageKey) {
                    StorageKey["RootKeyParams"] = "ROOT_KEY_PARAMS";
                    StorageKey["WrappedRootKey"] = "WRAPPED_ROOT_KEY";
                    StorageKey["RootKeyWrapperKeyParams"] = "ROOT_KEY_WRAPPER_KEY_PARAMS";
                    StorageKey["Session"] = "session";
                    StorageKey["User"] = "user";
                    StorageKey["ServerHost"] = "server";
                    StorageKey["LegacyUuid"] = "uuid";
                    StorageKey["LastSyncToken"] = "syncToken";
                    StorageKey["PaginationToken"] = "cursorToken";
                    StorageKey["BiometricsState"] = "biometrics_state";
                    StorageKey["MobilePasscodeTiming"] = "passcode_timing";
                    StorageKey["MobileBiometricsTiming"] = "biometrics_timing";
                    StorageKey["MobilePasscodeKeyboardType"] = "passcodeKeyboardType";
                    StorageKey["MobilePreferences"] = "preferences";
                    StorageKey["MobileScreenshotPrivacyEnabled"] = "screenshotPrivacy_enabled";
                    StorageKey["ProtectionExpirey"] = "SessionExpiresAtKey";
                    StorageKey["ProtectionSessionLength"] = "SessionLengthKey";
                    StorageKey["KeyRecoveryUndecryptableItems"] = "key_recovery_undecryptable";
                    StorageKey["WebSocketUrl"] = "webSocket_url";
                    StorageKey["UserRoles"] = "user_roles";
                    StorageKey["OfflineUserRoles"] = "offline_user_roles";
                    StorageKey["ExperimentalFeatures"] = "experimental_features";
                    StorageKey["DeinitMode"] = "deinit_mode";
                    StorageKey["CodeVerifier"] = "code_verifier";
                    StorageKey["LaunchPriorityUuids"] = "launch_priority_uuids";
                    StorageKey["LastReadChangelogVersion"] = "last_read_changelog_version";
                    StorageKey["MomentsEnabled"] = "moments_enabled";
                    StorageKey["TextBackupsEnabled"] = "text_backups_enabled";
                    StorageKey["TextBackupsLocation"] = "text_backups_location";
                    StorageKey["PlaintextBackupsEnabled"] = "plaintext_backups_enabled";
                    StorageKey["PlaintextBackupsLocation"] = "plaintext_backups_location";
                    StorageKey["FileBackupsEnabled"] = "file_backups_enabled";
                    StorageKey["FileBackupsLocation"] = "file_backups_location";
                    StorageKey["VaultSelectionOptions"] = "vault_selection_options";
                    StorageKey["Subscription"] = "subscription";
                    StorageKey["LocalPreferences"] = "local_preferences";
                })(StorageKey || (StorageKey = {}));
                var NonwrappedStorageKey;
                (function (NonwrappedStorageKey) {
                    NonwrappedStorageKey["MobileFirstRun"] = "first_run";
                })(NonwrappedStorageKey || (NonwrappedStorageKey = {}));
                function namespacedKey(namespace, key) {
                    return "".concat(namespace, "-").concat(key);
                }
                const LegacyKeys1_0_0 = {
                    WebPasscodeParamsKey: 'offlineParams',
                    MobilePasscodeParamsKey: 'pc_params',
                    AllAccountKeyParamsKey: 'auth_params',
                    WebEncryptedStorageKey: 'encryptedStorage',
                    MobileWrappedRootKeyKey: 'encrypted_account_keys',
                    MobileBiometricsPrefs: 'biometrics_prefs',
                    AllMigrations: 'migrations',
                    MobileThemesCache: 'ThemePreferencesKey',
                    MobileLightTheme: 'lightTheme',
                    MobileDarkTheme: 'darkTheme',
                    MobileLastExportDate: 'LastExportDateKey',
                    MobileDoNotWarnUnsupportedEditors: 'DoNotShowAgainUnsupportedEditorsKey',
                    MobileOptionsState: 'options',
                    MobilePasscodeKeyboardType: 'passcodeKeyboardType'
                };
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ../services/src/Domain/Api/WebsocketsService.ts
                var WebsocketsService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class WebSocketsService extends AbstractService {
                    constructor(storageService, webSocketUrl, webSocketApiService, internalEventBus) {
                        super(internalEventBus);
                        this.storageService = storageService;
                        this.webSocketUrl = webSocketUrl;
                        this.webSocketApiService = webSocketApiService;
                        this.internalEventBus = internalEventBus;
                        this.CLOSE_CONNECTION_CODE = 3123;
                        this.HEARTBEAT_DELAY = 360000;
                    }
                    setWebSocketUrl(url) {
                        this.webSocketUrl = url;
                        this.storageService.setValue(StorageKey.WebSocketUrl, url);
                    }
                    loadWebSocketUrl() {
                        const storedValue = this.storageService.getValue(StorageKey.WebSocketUrl);
                        this.webSocketUrl = storedValue || this.webSocketUrl || window._websocket_url;
                    }
                    startWebSocketConnection() {
                        return WebsocketsService_awaiter(this, void 0, void 0, function* () {
                            if (!this.webSocketUrl) {
                                return src.Result.fail('WebSocket URL is not set');
                            }
                            const webSocketConectionToken = yield this.createWebSocketConnectionToken();
                            if (webSocketConectionToken === undefined) {
                                return src.Result.fail('Failed to create WebSocket connection token');
                            }
                            try {
                                this.webSocket = new WebSocket("".concat(this.webSocketUrl, "?authToken=").concat(webSocketConectionToken));
                                this.webSocket.onmessage = this.onWebSocketMessage.bind(this);
                                this.webSocket.onclose = this.onWebSocketClose.bind(this);
                                this.webSocket.onopen = this.beginWebSocketHeartbeat.bind(this);
                                return src.Result.ok();
                            }
                            catch (error) {
                                return src.Result.fail("Error starting WebSocket connection: ".concat(error.message));
                            }
                        });
                    }
                    isWebSocketConnectionOpen() {
                        var _a;
                        return ((_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN;
                    }
                    closeWebSocketConnection() {
                        var _a;
                        (_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.close(this.CLOSE_CONNECTION_CODE, 'Closing application');
                    }
                    beginWebSocketHeartbeat() {
                        this.webSocketHeartbeatInterval = setInterval(this.websocketHeartbeat.bind(this), this.HEARTBEAT_DELAY);
                    }
                    websocketHeartbeat() {
                        var _a;
                        if (((_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                            this.webSocket.send('ping');
                        }
                    }
                    onWebSocketMessage(messageEvent) {
                        const eventData = JSON.parse(messageEvent.data);
                        switch (eventData.type) {
                            case 'ITEMS_CHANGED_ON_SERVER':
                                void this.notifyEvent(WebSocketsServiceEvent.ItemsChangedOnServer, eventData);
                                break;
                            case 'USER_ROLES_CHANGED':
                                void this.notifyEvent(WebSocketsServiceEvent.UserRoleMessageReceived, eventData);
                                break;
                            case 'NOTIFICATION_ADDED_FOR_USER':
                                void this.notifyEvent(WebSocketsServiceEvent.NotificationAddedForUser, eventData.payload);
                                break;
                            case 'MESSAGE_SENT_TO_USER':
                                void this.notifyEvent(WebSocketsServiceEvent.MessageSentToUser, eventData.payload);
                                break;
                            case 'USER_INVITED_TO_SHARED_VAULT':
                                void this.notifyEvent(WebSocketsServiceEvent.UserInvitedToSharedVault, eventData.payload);
                                break;
                            default:
                                break;
                        }
                    }
                    onWebSocketClose(event) {
                        var _a;
                        if (this.webSocketHeartbeatInterval) {
                            clearInterval(this.webSocketHeartbeatInterval);
                        }
                        this.webSocketHeartbeatInterval = undefined;
                        const closedByApplication = event.code === this.CLOSE_CONNECTION_CODE;
                        if (closedByApplication) {
                            this.webSocket = undefined;
                            return;
                        }
                        if (((_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CLOSED) {
                            void this.startWebSocketConnection();
                        }
                    }
                    createWebSocketConnectionToken() {
                        return WebsocketsService_awaiter(this, void 0, void 0, function* () {
                            try {
                                const response = yield this.webSocketApiService.createConnectionToken();
                                if ((0, dist.isErrorResponse)(response)) {
                                    console.error(response.data.error);
                                    return undefined;
                                }
                                return response.data.token;
                            }
                            catch (error) {
                                console.error('Caught error:', error.message);
                                return undefined;
                            }
                        });
                    }
                    deinit() {
                        super.deinit();
                        this.storageService = undefined;
                        this.webSocketApiService = undefined;
                        this.closeWebSocketConnection();
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Application/ApplicationStage.ts
                /* istanbul ignore file */
                var ApplicationStage;
                (function (ApplicationStage) {
                    ApplicationStage[ApplicationStage["PreparingForLaunch_0"] = 0] = "PreparingForLaunch_0";
                    ApplicationStage[ApplicationStage["ReadyForLaunch_05"] = 0.5] = "ReadyForLaunch_05";
                    ApplicationStage[ApplicationStage["StorageDecrypted_09"] = 0.9] = "StorageDecrypted_09";
                    ApplicationStage[ApplicationStage["Launched_10"] = 1] = "Launched_10";
                    ApplicationStage[ApplicationStage["LoadingDatabase_11"] = 1.1] = "LoadingDatabase_11";
                    ApplicationStage[ApplicationStage["LoadedDatabase_12"] = 1.2] = "LoadedDatabase_12";
                    ApplicationStage[ApplicationStage["FullSyncCompleted_13"] = 1.3] = "FullSyncCompleted_13";
                    ApplicationStage[ApplicationStage["SignedIn_30"] = 3] = "SignedIn_30";
                })(ApplicationStage || (ApplicationStage = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Application/DeinitMode.ts
                /* istanbul ignore file */
                var DeinitMode;
                (function (DeinitMode) {
                    DeinitMode["Soft"] = "Soft";
                    DeinitMode["Hard"] = "Hard";
                })(DeinitMode || (DeinitMode = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Application/DeinitSource.ts
                /* istanbul ignore file */
                var DeinitSource;
                (function (DeinitSource) {
                    DeinitSource[DeinitSource["SignOut"] = 1] = "SignOut";
                    DeinitSource[DeinitSource["Lock"] = 2] = "Lock";
                    DeinitSource[DeinitSource["SwitchWorkspace"] = 3] = "SwitchWorkspace";
                    DeinitSource[DeinitSource["SignOutAll"] = 4] = "SignOutAll";
                })(DeinitSource || (DeinitSource = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Application/Options/Defaults.ts
                const ApplicationOptionsDefaults = {
                    loadBatchSize: 700,
                    sleepBetweenBatches: 10,
                    allowMultipleSelection: true,
                    allowNoteSelectionStatePersistence: true
                };
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                ; // CONCATENATED MODULE: ../services/src/Domain/Event/SyncEvent.ts
                /* istanbul ignore file */
                var SyncEvent;
                (function (SyncEvent) {
                    /**
                     * A potentially multi-round trip that keeps syncing until all items have been uploaded.
                     * However, this event will still trigger if there are more items waiting to be downloaded on the
                     * server
                     */
                    SyncEvent["SyncCompletedWithAllItemsUploaded"] = "SyncCompletedWithAllItemsUploaded";
                    SyncEvent["SyncCompletedWithAllItemsUploadedAndDownloaded"] = "SyncCompletedWithAllItemsUploadedAndDownloaded";
                    SyncEvent["PaginatedSyncRequestCompleted"] = "PaginatedSyncRequestCompleted";
                    SyncEvent["SyncDidBeginProcessing"] = "sync:did-begin-processing";
                    SyncEvent["DownloadFirstSyncCompleted"] = "sync:download-first-completed";
                    SyncEvent["SyncTakingTooLong"] = "sync:taking-too-long";
                    SyncEvent["SyncError"] = "sync:error";
                    SyncEvent["InvalidSession"] = "sync:invalid-session";
                    SyncEvent["MajorDataChange"] = "major-data-change";
                    SyncEvent["LocalDataIncrementalLoad"] = "local-data-incremental-load";
                    SyncEvent["LocalDataLoaded"] = "local-data-loaded";
                    SyncEvent["EnterOutOfSync"] = "enter-out-of-sync";
                    SyncEvent["ExitOutOfSync"] = "exit-out-of-sync";
                    SyncEvent["StatusChanged"] = "status-changed";
                    SyncEvent["DatabaseWriteError"] = "database-write-error";
                    SyncEvent["DatabaseReadError"] = "database-read-error";
                    SyncEvent["SyncRequestsIntegrityCheck"] = "sync:requests-integrity-check";
                    SyncEvent["ReceivedRemoteSharedVaults"] = "received-shared-vaults";
                    SyncEvent["ReceivedSharedVaultInvites"] = "received-shared-vault-invites";
                    SyncEvent["ReceivedNotifications"] = "received-user-events";
                    SyncEvent["ReceivedAsymmetricMessages"] = "received-asymmetric-messages";
                    SyncEvent["TooManyRequests"] = "too-many-requests";
                })(SyncEvent || (SyncEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/AsymmetricMessageService.ts
                var AsymmetricMessageService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AsymmetricMessageService extends AbstractService {
                    constructor(encryption, mutator, sessions, sync, messageServer, _createOrEditContact, _findContact, _replaceContactData, _getTrustedPayload, _getVault, _handleRootKeyChangedMessage, _getOutboundMessagesUseCase, _getInboundMessagesUseCase, _getUntrustedPayload, _getKeyPairs, eventBus) {
                        super(eventBus);
                        this.encryption = encryption;
                        this.mutator = mutator;
                        this.sessions = sessions;
                        this.sync = sync;
                        this.messageServer = messageServer;
                        this._createOrEditContact = _createOrEditContact;
                        this._findContact = _findContact;
                        this._replaceContactData = _replaceContactData;
                        this._getTrustedPayload = _getTrustedPayload;
                        this._getVault = _getVault;
                        this._handleRootKeyChangedMessage = _handleRootKeyChangedMessage;
                        this._getOutboundMessagesUseCase = _getOutboundMessagesUseCase;
                        this._getInboundMessagesUseCase = _getInboundMessagesUseCase;
                        this._getUntrustedPayload = _getUntrustedPayload;
                        this._getKeyPairs = _getKeyPairs;
                        this.handledMessages = new Set();
                    }
                    deinit() {
                        super.deinit();
                        this.messageServer = undefined;
                        this.encryption = undefined;
                        this.mutator = undefined;
                        this._createOrEditContact = undefined;
                        this._findContact = undefined;
                        this._replaceContactData = undefined;
                        this._getTrustedPayload = undefined;
                        this._getVault = undefined;
                        this._handleRootKeyChangedMessage = undefined;
                        this._getOutboundMessagesUseCase = undefined;
                        this._getInboundMessagesUseCase = undefined;
                        this._getUntrustedPayload = undefined;
                    }
                    handleEvent(event) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case SyncEvent.ReceivedAsymmetricMessages:
                                    void this.handleRemoteReceivedAsymmetricMessages(event.payload);
                                    break;
                                case WebSocketsServiceEvent.MessageSentToUser:
                                    void this.handleRemoteReceivedAsymmetricMessages([event.payload.message]);
                                    break;
                            }
                        });
                    }
                    getOutboundMessages() {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            return this._getOutboundMessagesUseCase.execute();
                        });
                    }
                    getInboundMessages() {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            return this._getInboundMessagesUseCase.execute();
                        });
                    }
                    downloadAndProcessInboundMessages() {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            const messages = yield this.getInboundMessages();
                            if (messages.isFailed()) {
                                return;
                            }
                            yield this.handleRemoteReceivedAsymmetricMessages(messages.getValue());
                        });
                    }
                    sortServerMessages(messages) {
                        const SortedPriorityTypes = [models_dist.AsymmetricMessagePayloadType.SenderKeypairChanged];
                        const priority = [];
                        const regular = [];
                        const allMessagesOldestFirst = messages.slice().sort((a, b) => a.created_at_timestamp - b.created_at_timestamp);
                        const messageTypeMap = {};
                        for (const message of allMessagesOldestFirst) {
                            const messageType = this.getServerMessageType(message);
                            if (!messageType) {
                                continue;
                            }
                            messageTypeMap[message.uuid] = messageType;
                            if (SortedPriorityTypes.includes(messageType)) {
                                priority.push(message);
                            }
                            else {
                                regular.push(message);
                            }
                        }
                        const sortedPriority = priority.sort((a, b) => {
                            const typeA = messageTypeMap[a.uuid];
                            const typeB = messageTypeMap[b.uuid];
                            if (typeA !== typeB) {
                                return SortedPriorityTypes.indexOf(typeA) - SortedPriorityTypes.indexOf(typeB);
                            }
                            return a.created_at_timestamp - b.created_at_timestamp;
                        });
                        const regularMessagesOldestFirst = regular.sort((a, b) => a.created_at_timestamp - b.created_at_timestamp);
                        return [...sortedPriority, ...regularMessagesOldestFirst];
                    }
                    getServerMessageType(message) {
                        const result = this.getUntrustedMessagePayload(message);
                        if (result.isFailed()) {
                            return undefined;
                        }
                        return result.getValue().type;
                    }
                    handleRemoteReceivedAsymmetricMessages(messages) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            if (messages.length === 0) {
                                return;
                            }
                            const sortedMessages = this.sortServerMessages(messages);
                            for (const message of sortedMessages) {
                                const trustedPayload = this.getTrustedMessagePayload(message);
                                if (trustedPayload.isFailed()) {
                                    continue;
                                }
                                yield this.handleTrustedMessageResult(message, trustedPayload.getValue());
                            }
                            void this.sync.sync();
                        });
                    }
                    handleTrustedMessageResult(message, payload) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            if (this.handledMessages.has(message.uuid)) {
                                return;
                            }
                            this.handledMessages.add(message.uuid);
                            if (payload.type === models_dist.AsymmetricMessagePayloadType.ContactShare) {
                                yield this.handleTrustedContactShareMessage(message, payload);
                            }
                            else if (payload.type === models_dist.AsymmetricMessagePayloadType.SenderKeypairChanged) {
                                yield this.handleTrustedSenderKeypairChangedMessage(message, payload);
                            }
                            else if (payload.type === models_dist.AsymmetricMessagePayloadType.SharedVaultRootKeyChanged) {
                                yield this.handleTrustedSharedVaultRootKeyChangedMessage(message, payload);
                            }
                            else if (payload.type === models_dist.AsymmetricMessagePayloadType.SharedVaultMetadataChanged) {
                                yield this.handleTrustedVaultMetadataChangedMessage(message, payload);
                            }
                            else if (payload.type === models_dist.AsymmetricMessagePayloadType.SharedVaultInvite) {
                                throw new Error('Shared vault invites payloads are not handled as part of asymmetric messages');
                            }
                            yield this.deleteMessageAfterProcessing(message);
                        });
                    }
                    getUntrustedMessagePayload(message) {
                        const keys = this._getKeyPairs.execute();
                        if (keys.isFailed()) {
                            return src.Result.fail(keys.getError());
                        }
                        const result = this._getUntrustedPayload.execute({
                            privateKey: keys.getValue().encryption.privateKey,
                            payload: message
                        });
                        if (result.isFailed()) {
                            return src.Result.fail(result.getError());
                        }
                        return result;
                    }
                    getTrustedMessagePayload(message) {
                        const contact = this._findContact.execute({
                            userUuid: message.sender_uuid
                        });
                        if (contact.isFailed()) {
                            return src.Result.fail(contact.getError());
                        }
                        const keys = this._getKeyPairs.execute();
                        if (keys.isFailed()) {
                            return src.Result.fail(keys.getError());
                        }
                        const result = this._getTrustedPayload.execute({
                            privateKey: keys.getValue().encryption.privateKey,
                            sender: contact.getValue(),
                            ownUserUuid: this.sessions.userUuid,
                            payload: message
                        });
                        if (result.isFailed()) {
                            return src.Result.fail(result.getError());
                        }
                        return result;
                    }
                    deleteMessageAfterProcessing(message) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            yield this.messageServer.deleteMessage({
                                messageUuid: message.uuid
                            });
                        });
                    }
                    handleTrustedVaultMetadataChangedMessage(_message, trustedPayload) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            const vault = this._getVault.execute({
                                sharedVaultUuid: trustedPayload.data.sharedVaultUuid
                            });
                            if (vault.isFailed()) {
                                return;
                            }
                            yield this.mutator.changeItem(vault.getValue(), mutator => {
                                mutator.name = trustedPayload.data.name;
                                mutator.description = trustedPayload.data.description;
                            }, models_dist.MutationType.UpdateUserTimestamps, models_dist.PayloadEmitSource.RemoteRetrieved);
                        });
                    }
                    handleTrustedContactShareMessage(_message, trustedPayload) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            if (trustedPayload.data.trustedContact.isMe) {
                                return;
                            }
                            yield this._replaceContactData.execute(trustedPayload.data.trustedContact);
                        });
                    }
                    handleTrustedSenderKeypairChangedMessage(message, trustedPayload) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            yield this._createOrEditContact.execute({
                                contactUuid: message.sender_uuid,
                                publicKey: trustedPayload.data.newEncryptionPublicKey,
                                signingPublicKey: trustedPayload.data.newSigningPublicKey
                            });
                        });
                    }
                    handleTrustedSharedVaultRootKeyChangedMessage(_message, trustedPayload) {
                        return AsymmetricMessageService_awaiter(this, void 0, void 0, function* () {
                            yield this._handleRootKeyChangedMessage.execute(trustedPayload);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/GetInboundMessages.ts
                var GetInboundMessages_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetInboundMessages {
                    constructor(messageServer) {
                        this.messageServer = messageServer;
                    }
                    execute() {
                        return GetInboundMessages_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.messageServer.getMessages();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return src.Result.ok(response.data.messages);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/GetOutboundMessages.ts
                var GetOutboundMessages_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetOutboundMessages {
                    constructor(messageServer) {
                        this.messageServer = messageServer;
                    }
                    execute() {
                        return GetOutboundMessages_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.messageServer.getOutboundUserMessages();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return src.Result.ok(response.data.messages);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/GetTrustedPayload.ts
                class GetTrustedPayload {
                    constructor(decryptMessage) {
                        this.decryptMessage = decryptMessage;
                    }
                    execute(dto) {
                        const result = this.decryptMessage.execute({
                            message: dto.payload.encrypted_message,
                            sender: dto.sender,
                            privateKey: dto.privateKey
                        });
                        if (result.isFailed()) {
                            return result;
                        }
                        const recipientUuid = result.getValue().data.recipientUuid;
                        if (recipientUuid !== dto.ownUserUuid) {
                            return src.Result.fail('Message is not for this user');
                        }
                        return result;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/GetUntrustedPayload.ts
                class GetUntrustedPayload {
                    constructor(decryptMessage) {
                        this.decryptMessage = decryptMessage;
                    }
                    execute(dto) {
                        const result = this.decryptMessage.execute({
                            message: dto.payload.encrypted_message,
                            sender: undefined,
                            privateKey: dto.privateKey
                        });
                        return result;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/HandleRootKeyChangedMessage.ts
                var HandleRootKeyChangedMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class HandleRootKeyChangedMessage {
                    constructor(mutator, sync, _getVault, _decryptErroredPayloads) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this._getVault = _getVault;
                        this._decryptErroredPayloads = _decryptErroredPayloads;
                    }
                    execute(message) {
                        return HandleRootKeyChangedMessage_awaiter(this, void 0, void 0, function* () {
                            const rootKeyContent = message.data.rootKey;
                            yield this.mutator.createItem(src.ContentType.TYPES.KeySystemRootKey, (0, models_dist.FillItemContent)(rootKeyContent), true);
                            const vault = this._getVault.execute({
                                keySystemIdentifier: rootKeyContent.systemIdentifier
                            });
                            if (!vault.isFailed()) {
                                yield this.mutator.changeItem(vault.getValue(), mutator => {
                                    mutator.rootKeyParams = rootKeyContent.keyParams;
                                });
                            }
                            yield this._decryptErroredPayloads.execute();
                            void this.sync.sync({
                                sourceDescription: 'Not awaiting due to this event handler running from sync response'
                            });
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/ProcessAcceptedVaultInvite.ts
                var ProcessAcceptedVaultInvite_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ProcessAcceptedVaultInvite {
                    constructor(mutator, sync, _createOrEditContact) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this._createOrEditContact = _createOrEditContact;
                    }
                    execute(message, sharedVaultUuid, ownerUuid) {
                        return ProcessAcceptedVaultInvite_awaiter(this, void 0, void 0, function* () {
                            const { rootKey: rootKeyContent, trustedContacts, metadata } = message.data;
                            const content = {
                                systemIdentifier: rootKeyContent.systemIdentifier,
                                rootKeyParams: rootKeyContent.keyParams,
                                keyStorageMode: models_dist.KeySystemRootKeyStorageMode.Synced,
                                name: metadata.name,
                                description: metadata.description,
                                iconString: metadata.iconString,
                                sharing: {
                                    sharedVaultUuid: sharedVaultUuid,
                                    ownerUserUuid: ownerUuid,
                                    fileBytesUsed: metadata.fileBytesUsed,
                                    designatedSurvivor: metadata.designatedSurvivor
                                }
                            };
                            yield this.mutator.createItem(src.ContentType.TYPES.KeySystemRootKey, (0, models_dist.FillItemContent)(rootKeyContent), true);
                            yield this.mutator.createItem(src.ContentType.TYPES.VaultListing, (0, models_dist.FillItemContentSpecialized)(content), true);
                            for (const contact of trustedContacts) {
                                yield this._createOrEditContact.execute({
                                    name: contact.name,
                                    contactUuid: contact.contactUuid,
                                    publicKey: contact.publicKeySet.encryption,
                                    signingPublicKey: contact.publicKeySet.signing
                                });
                            }
                            void this.sync.sync({
                                sourceDescription: 'Not awaiting due to this event handler running from sync response'
                            });
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/ResendAllMessages.ts
                var ResendAllMessages_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ResendAllMessages {
                    constructor(resendMessage, decryptOwnMessage, messageServer, findContact) {
                        this.resendMessage = resendMessage;
                        this.decryptOwnMessage = decryptOwnMessage;
                        this.messageServer = messageServer;
                        this.findContact = findContact;
                    }
                    messagesToExcludeFromResending() {
                        /**
                         * Sender key pair changed messages should never be re-encrypted with new keys as they must use the
                         * previous keys used by the sender before their keypair changed.
                         */
                        return [models_dist.AsymmetricMessagePayloadType.SenderKeypairChanged];
                    }
                    execute(params) {
                        var _a, _b;
                        return ResendAllMessages_awaiter(this, void 0, void 0, function* () {
                            const messages = yield this.messageServer.getOutboundUserMessages();
                            if ((0, dist.isErrorResponse)(messages)) {
                                return src.Result.fail('Failed to get outbound user messages');
                            }
                            const errors = [];
                            for (const message of messages.data.messages) {
                                const recipient = this.findContact.execute({
                                    userUuid: message.recipient_uuid
                                });
                                if (recipient.isFailed()) {
                                    errors.push("Contact not found for invite ".concat(message.recipient_uuid));
                                    continue;
                                }
                                const decryptionResult = this.decryptOwnMessage.execute({
                                    message: message.encrypted_message,
                                    privateKey: (_b = (_a = params.previousKeys) === null || _a === void 0 ? void 0 : _a.encryption.privateKey) !== null && _b !== void 0 ? _b : params.keys.encryption.privateKey,
                                    recipientPublicKey: recipient.getValue().publicKeySet.encryption
                                });
                                if (decryptionResult.isFailed()) {
                                    errors.push("Failed to decrypt message ".concat(message.uuid));
                                    continue;
                                }
                                const decryptedMessage = decryptionResult.getValue();
                                if (this.messagesToExcludeFromResending().includes(decryptedMessage.type)) {
                                    continue;
                                }
                                yield this.resendMessage.execute({
                                    keys: params.keys,
                                    previousKeys: params.previousKeys,
                                    decryptedMessage: decryptedMessage,
                                    rawMessage: message,
                                    recipient: recipient.getValue()
                                });
                                yield this.messageServer.deleteMessage({
                                    messageUuid: message.uuid
                                });
                            }
                            if (errors.length > 0) {
                                return src.Result.fail(errors.join(', '));
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/ResendMessage.ts
                var ResendMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ResendMessage {
                    constructor(sendMessage, encryptMessage) {
                        this.sendMessage = sendMessage;
                        this.encryptMessage = encryptMessage;
                    }
                    execute(params) {
                        return ResendMessage_awaiter(this, void 0, void 0, function* () {
                            const encryptedMessage = this.encryptMessage.execute({
                                message: params.decryptedMessage,
                                keys: params.keys,
                                recipientPublicKey: params.recipient.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const sendMessageResult = yield this.sendMessage.execute({
                                recipientUuid: params.recipient.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                replaceabilityIdentifier: params.rawMessage.replaceability_identifier || undefined
                            });
                            return sendMessageResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/SendMessage.ts
                var SendMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SendMessage {
                    constructor(messageServer) {
                        this.messageServer = messageServer;
                    }
                    execute(params) {
                        return SendMessage_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.messageServer.createMessage({
                                recipientUuid: params.recipientUuid,
                                encryptedMessage: params.encryptedMessage,
                                replaceabilityIdentifier: params.replaceabilityIdentifier
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return src.Result.ok(response.data.message);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Auth/AuthManager.ts
                var AuthManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AuthManager extends AbstractService {
                    constructor(authApiService, internalEventBus) {
                        super(internalEventBus);
                        this.authApiService = authApiService;
                        this.internalEventBus = internalEventBus;
                    }
                    generateRecoveryCodes() {
                        return AuthManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authApiService.generateRecoveryCodes();
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                return result.data.recoveryCodes;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    recoveryKeyParams(dto) {
                        return AuthManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authApiService.recoveryKeyParams(dto);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                return result.data.keyParams;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    signInWithRecoveryCodes(dto) {
                        return AuthManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authApiService.signInWithRecoveryCodes(dto);
                                const captchaURL = (0, dist.getCaptchaHeader)(result);
                                if (captchaURL) {
                                    return {
                                        success: false,
                                        captchaURL
                                    };
                                }
                                if ((0, dist.isErrorResponse)(result)) {
                                    return {
                                        success: false,
                                        captchaURL: ''
                                    };
                                }
                                return {
                                    success: true,
                                    keyParams: result.data.key_params,
                                    session: result.data.session,
                                    user: result.data.user
                                };
                            }
                            catch (error) {
                                return {
                                    success: false,
                                    captchaURL: ''
                                };
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Authenticator/AuthenticatorManager.ts
                /* istanbul ignore file */
                var AuthenticatorManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AuthenticatorManager extends AbstractService {
                    constructor(authenticatorApiService, preferencesService, internalEventBus) {
                        super(internalEventBus);
                        this.authenticatorApiService = authenticatorApiService;
                        this.preferencesService = preferencesService;
                        this.internalEventBus = internalEventBus;
                    }
                    list() {
                        return AuthenticatorManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authenticatorApiService.list();
                                if ((0, dist.isErrorResponse)(result)) {
                                    return [];
                                }
                                const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
                                const nameDecoratedAuthenticators = result.data.authenticators.map(authenticator => ({
                                    id: authenticator.id,
                                    name: authenticatorNames.has(authenticator.id) ? authenticatorNames.get(authenticator.id) : 'Security Key'
                                }));
                                return nameDecoratedAuthenticators;
                            }
                            catch (error) {
                                return [];
                            }
                        });
                    }
                    delete(authenticatorId) {
                        return AuthenticatorManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authenticatorApiService.delete(authenticatorId.value);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
                                authenticatorNames.delete(authenticatorId.value);
                                yield this.preferencesService.setValue(models_dist.PrefKey.AuthenticatorNames, JSON.stringify([...authenticatorNames]));
                                return true;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    generateRegistrationOptions() {
                        return AuthenticatorManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authenticatorApiService.generateRegistrationOptions();
                                if ((0, dist.isErrorResponse)(result)) {
                                    return null;
                                }
                                return result.data.options;
                            }
                            catch (error) {
                                return null;
                            }
                        });
                    }
                    verifyRegistrationResponse(userUuid, name, registrationCredential) {
                        return AuthenticatorManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authenticatorApiService.verifyRegistrationResponse(userUuid.value, name, registrationCredential);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                const authenticatorNames = this.getAuthenticatorNamesFromPreferences();
                                authenticatorNames.set(result.data.id, name);
                                yield this.preferencesService.setValue(models_dist.PrefKey.AuthenticatorNames, JSON.stringify([...authenticatorNames]));
                                return true;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    generateAuthenticationOptions(username) {
                        return AuthenticatorManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.authenticatorApiService.generateAuthenticationOptions(username.value);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return null;
                                }
                                return result.data.options;
                            }
                            catch (error) {
                                return null;
                            }
                        });
                    }
                    getAuthenticatorNamesFromPreferences() {
                        let authenticatorNames = new Map();
                        const authenticatorNamesFromPreferences = this.preferencesService.getValue(models_dist.PrefKey.AuthenticatorNames);
                        if (authenticatorNamesFromPreferences !== undefined) {
                            try {
                                authenticatorNames = new Map(JSON.parse(authenticatorNamesFromPreferences));
                            }
                            catch (error) {
                                authenticatorNames = new Map();
                            }
                        }
                        return authenticatorNames;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Event/ApplicationEvent.ts
                var ApplicationEvent;
                (function (ApplicationEvent) {
                    ApplicationEvent["SignedIn"] = "Application:SignedIn";
                    ApplicationEvent["SignedOut"] = "Application:SignedOut";
                    /** When a full, potentially multi-page sync completes */
                    ApplicationEvent["CompletedFullSync"] = "Application:CompletedFullSync";
                    ApplicationEvent["FailedSync"] = "Application:FailedSync";
                    ApplicationEvent["HighLatencySync"] = "Application:HighLatencySync";
                    ApplicationEvent["EnteredOutOfSync"] = "Application:EnteredOutOfSync";
                    ApplicationEvent["ExitedOutOfSync"] = "Application:ExitedOutOfSync";
                    ApplicationEvent["ApplicationStageChanged"] = "Application:ApplicationStageChanged";
                    /**
                     * The application has finished its prepareForLaunch state and is now ready for unlock
                     * Called when the application has initialized and is ready for launch, but before
                     * the application has been unlocked, if applicable. Use this to do pre-launch
                     * configuration, but do not attempt to access user data like notes or tags.
                     */
                    ApplicationEvent["Started"] = "Application:Started";
                    /**
                     * The applicaiton is fully unlocked and ready for i/o
                     * Called when the application has been fully decrypted and unlocked. Use this to
                     * to begin streaming data like notes and tags.
                     */
                    ApplicationEvent["Launched"] = "Application:Launched";
                    ApplicationEvent["LocalDataLoaded"] = "Application:LocalDataLoaded";
                    /**
                     * When the root key or root key wrapper changes. Includes events like account state
                     * changes (registering, signing in, changing pw, logging out) and passcode state
                     * changes (adding, removing, changing).
                     */
                    ApplicationEvent["KeyStatusChanged"] = "Application:KeyStatusChanged";
                    ApplicationEvent["MajorDataChange"] = "Application:MajorDataChange";
                    ApplicationEvent["CompletedRestart"] = "Application:CompletedRestart";
                    ApplicationEvent["LocalDataIncrementalLoad"] = "Application:LocalDataIncrementalLoad";
                    ApplicationEvent["SyncStatusChanged"] = "Application:SyncStatusChanged";
                    ApplicationEvent["WillSync"] = "Application:WillSync";
                    ApplicationEvent["InvalidSyncSession"] = "Application:InvalidSyncSession";
                    ApplicationEvent["LocalDatabaseReadError"] = "Application:LocalDatabaseReadError";
                    ApplicationEvent["LocalDatabaseWriteError"] = "Application:LocalDatabaseWriteError";
                    /**
                     * When a single roundtrip completes with sync, in a potentially multi-page sync request.
                     * If just a single roundtrip, this event will be triggered, along with CompletedFullSync
                     */
                    ApplicationEvent["CompletedIncrementalSync"] = "Application:CompletedIncrementalSync";
                    /**
                     * The application has loaded all pending migrations (but not run any, except for the base one),
                     * and consumers may now call hasPendingMigrations
                     */
                    ApplicationEvent["MigrationsLoaded"] = "Application:MigrationsLoaded";
                    /** When StorageService is ready (but NOT yet decrypted) to start servicing read/write requests */
                    ApplicationEvent["StorageReady"] = "Application:StorageReady";
                    ApplicationEvent["PreferencesChanged"] = "Application:PreferencesChanged";
                    ApplicationEvent["LocalPreferencesChanged"] = "Application:LocalPreferencesChanged";
                    ApplicationEvent["UnprotectedSessionBegan"] = "Application:UnprotectedSessionBegan";
                    ApplicationEvent["UserRolesChanged"] = "Application:UserRolesChanged";
                    ApplicationEvent["FeaturesAvailabilityChanged"] = "Application:FeaturesAvailabilityChanged";
                    ApplicationEvent["UnprotectedSessionExpired"] = "Application:UnprotectedSessionExpired";
                    /** Called when the app first launches and after first sync request made after sign in */
                    ApplicationEvent["CompletedInitialSync"] = "Application:CompletedInitialSync";
                    ApplicationEvent["DidPurchaseSubscription"] = "Application:DidPurchaseSubscription";
                    ApplicationEvent["SyncTooManyRequests"] = "Application:SyncTooManyRequests";
                })(ApplicationEvent || (ApplicationEvent = {}));
                // EXTERNAL MODULE: ../features/dist/index.js
                var features_dist = __webpack_require__(80215);
                ; // CONCATENATED MODULE: ../services/src/Domain/Backups/FilesBackupService.ts
                var FilesBackupService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const PlaintextBackupsDirectoryName = 'Plaintext Backups';
                const TextBackupsDirectoryName = 'Text Backups';
                const FileBackupsDirectoryName = 'File Backups';
                class FilesBackupService extends AbstractService {
                    constructor(items, api, encryptor, device, status, crypto, storage, session, payloads, history, directory, internalEventBus) {
                        super(internalEventBus);
                        this.items = items;
                        this.api = api;
                        this.encryptor = encryptor;
                        this.device = device;
                        this.status = status;
                        this.crypto = crypto;
                        this.storage = storage;
                        this.session = session;
                        this.payloads = payloads;
                        this.history = history;
                        this.directory = directory;
                        this.internalEventBus = internalEventBus;
                        this.pendingFiles = new Set();
                        this.filesObserverDisposer = items.addObserver(src.ContentType.TYPES.File, _ref => {
                            let { changed, inserted, source } = _ref;
                            const applicableSources = [models_dist.PayloadEmitSource.LocalDatabaseLoaded, models_dist.PayloadEmitSource.RemoteSaved, models_dist.PayloadEmitSource.RemoteRetrieved];
                            if (applicableSources.includes(source)) {
                                void this.handleChangedFiles([...changed, ...inserted]);
                            }
                        });
                        const noteAndTagSources = [models_dist.PayloadEmitSource.RemoteSaved, models_dist.PayloadEmitSource.RemoteRetrieved, models_dist.PayloadEmitSource.OfflineSyncSaved];
                        this.notesObserverDisposer = items.addObserver(src.ContentType.TYPES.Note, _ref2 => {
                            let { changed, inserted, source } = _ref2;
                            if (noteAndTagSources.includes(source)) {
                                void this.handleChangedNotes([...changed, ...inserted]);
                            }
                        });
                        this.tagsObserverDisposer = items.addObserver(src.ContentType.TYPES.Tag, _ref3 => {
                            let { changed, inserted, source } = _ref3;
                            if (noteAndTagSources.includes(source)) {
                                void this.handleChangedTags([...changed, ...inserted]);
                            }
                        });
                    }
                    handleEvent(event) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            if (event.type === ApplicationEvent.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === ApplicationStage.Launched_10) {
                                    void this.automaticallyEnableTextBackupsIfPreferenceNotSet();
                                }
                            }
                        });
                    }
                    setSuperConverter(converter) {
                        this.markdownConverter = converter;
                    }
                    importWatchedDirectoryChanges(changes) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            for (const change of changes) {
                                const existingItem = this.items.findItem(change.itemUuid);
                                if (!existingItem) {
                                    continue;
                                }
                                if (!(0, models_dist.isNote)(existingItem)) {
                                    continue;
                                }
                                const newContent = Object.assign(Object.assign({}, existingItem.payload.content), {
                                    preview_html: undefined,
                                    preview_plain: undefined,
                                    text: change.content
                                });
                                const payloadCopy = existingItem.payload.copy({
                                    content: newContent
                                });
                                yield this.payloads.importPayloads([payloadCopy], this.history.getHistoryMapCopy());
                            }
                        });
                    }
                    deinit() {
                        super.deinit();
                        this.filesObserverDisposer();
                        this.notesObserverDisposer();
                        this.tagsObserverDisposer();
                        this.items = undefined;
                        this.api = undefined;
                        this.encryptor = undefined;
                        this.device = undefined;
                        this.status = undefined;
                        this.crypto = undefined;
                        this.storage = undefined;
                        this.session = undefined;
                    }
                    automaticallyEnableTextBackupsIfPreferenceNotSet() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            if (this.storage.getValue(StorageKey.TextBackupsEnabled) != undefined) {
                                return;
                            }
                            this.storage.setValue(StorageKey.TextBackupsEnabled, true);
                            const documentsDir = yield this.device.getUserDocumentsDirectory();
                            if (!documentsDir) {
                                return;
                            }
                            const location = yield this.device.joinPaths(documentsDir, yield this.prependWorkspacePathForPath(TextBackupsDirectoryName));
                            this.storage.setValue(StorageKey.TextBackupsLocation, location);
                        });
                    }
                    openAllDirectoriesContainingBackupFiles() {
                        const fileBackupsLocation = this.getFilesBackupsLocation();
                        const plaintextBackupsLocation = this.getPlaintextBackupsLocation();
                        const textBackupsLocation = this.getTextBackupsLocation();
                        if (fileBackupsLocation) {
                            void this.directory.openLocation(fileBackupsLocation);
                        }
                        if (plaintextBackupsLocation) {
                            void this.directory.openLocation(plaintextBackupsLocation);
                        }
                        if (textBackupsLocation) {
                            void this.directory.openLocation(textBackupsLocation);
                        }
                    }
                    isFilesBackupsEnabled() {
                        return this.storage.getValue(StorageKey.FileBackupsEnabled, undefined, false);
                    }
                    getFilesBackupsLocation() {
                        return this.storage.getValue(StorageKey.FileBackupsLocation);
                    }
                    isTextBackupsEnabled() {
                        return this.storage.getValue(StorageKey.TextBackupsEnabled, undefined, true);
                    }
                    prependWorkspacePathForPath(path) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const workspacePath = this.session.getWorkspaceDisplayIdentifier();
                            return this.device.joinPaths(workspacePath, path);
                        });
                    }
                    enableTextBackups() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            let location = this.getTextBackupsLocation();
                            if (!location) {
                                location = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(TextBackupsDirectoryName));
                                if (!location) {
                                    return;
                                }
                            }
                            this.storage.setValue(StorageKey.TextBackupsEnabled, true);
                            this.storage.setValue(StorageKey.TextBackupsLocation, location);
                        });
                    }
                    disableTextBackups() {
                        this.storage.setValue(StorageKey.TextBackupsEnabled, false);
                    }
                    getTextBackupsLocation() {
                        return this.storage.getValue(StorageKey.TextBackupsLocation);
                    }
                    openTextBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getTextBackupsLocation();
                            if (location) {
                                void this.directory.openLocation(location);
                            }
                        });
                    }
                    changeTextBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const oldLocation = this.getTextBackupsLocation();
                            const newLocation = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(TextBackupsDirectoryName), oldLocation);
                            if (!newLocation) {
                                return undefined;
                            }
                            this.storage.setValue(StorageKey.TextBackupsLocation, newLocation);
                            return newLocation;
                        });
                    }
                    saveTextBackupData(data) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getTextBackupsLocation();
                            if (!location) {
                                return;
                            }
                            return this.device.saveTextBackupData(location, data);
                        });
                    }
                    isPlaintextBackupsEnabled() {
                        return this.storage.getValue(StorageKey.PlaintextBackupsEnabled, undefined, false);
                    }
                    enablePlaintextBackups() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            let location = this.getPlaintextBackupsLocation();
                            if (!location) {
                                location = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(PlaintextBackupsDirectoryName));
                                if (!location) {
                                    return;
                                }
                            }
                            this.storage.setValue(StorageKey.PlaintextBackupsEnabled, true);
                            this.storage.setValue(StorageKey.PlaintextBackupsLocation, location);
                            void this.handleChangedNotes(this.items.getItems(src.ContentType.TYPES.Note));
                        });
                    }
                    disablePlaintextBackups() {
                        this.storage.setValue(StorageKey.PlaintextBackupsEnabled, false);
                        this.storage.setValue(StorageKey.PlaintextBackupsLocation, undefined);
                    }
                    getPlaintextBackupsLocation() {
                        return this.storage.getValue(StorageKey.PlaintextBackupsLocation);
                    }
                    openPlaintextBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getPlaintextBackupsLocation();
                            if (location) {
                                void this.directory.openLocation(location);
                            }
                        });
                    }
                    changePlaintextBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const oldLocation = this.getPlaintextBackupsLocation();
                            const newLocation = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(PlaintextBackupsDirectoryName), oldLocation);
                            if (!newLocation) {
                                return undefined;
                            }
                            this.storage.setValue(StorageKey.PlaintextBackupsLocation, newLocation);
                            return newLocation;
                        });
                    }
                    enableFilesBackups() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            let location = this.getFilesBackupsLocation();
                            if (!location) {
                                location = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(FileBackupsDirectoryName));
                                if (!location) {
                                    return;
                                }
                            }
                            this.storage.setValue(StorageKey.FileBackupsEnabled, true);
                            this.storage.setValue(StorageKey.FileBackupsLocation, location);
                            this.backupAllFiles();
                        });
                    }
                    backupAllFiles() {
                        const files = this.items.getItems(src.ContentType.TYPES.File);
                        void this.handleChangedFiles(files);
                    }
                    disableFilesBackups() {
                        this.storage.setValue(StorageKey.FileBackupsEnabled, false);
                    }
                    changeFilesBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const oldLocation = this.getFilesBackupsLocation();
                            const newLocation = yield this.directory.presentDirectoryPickerForLocationChangeAndTransferOld(yield this.prependWorkspacePathForPath(FileBackupsDirectoryName), oldLocation);
                            if (!newLocation) {
                                return undefined;
                            }
                            this.storage.setValue(StorageKey.FileBackupsLocation, newLocation);
                            return newLocation;
                        });
                    }
                    openFilesBackupsLocation() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getFilesBackupsLocation();
                            if (location) {
                                void this.directory.openLocation(location);
                            }
                        });
                    }
                    getBackupsMappingFromDisk() {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getFilesBackupsLocation();
                            if (!location) {
                                return undefined;
                            }
                            const result = (yield this.device.getFilesBackupsMappingFile(location)).files;
                            this.mappingCache = result;
                            return result;
                        });
                    }
                    invalidateMappingCache() {
                        this.mappingCache = undefined;
                    }
                    getBackupsMappingFromCache() {
                        var _a;
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            return (_a = this.mappingCache) !== null && _a !== void 0 ? _a : yield this.getBackupsMappingFromDisk();
                        });
                    }
                    getFileBackupInfo(file) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const mapping = yield this.getBackupsMappingFromCache();
                            if (!mapping) {
                                return undefined;
                            }
                            const record = mapping[file.uuid];
                            return record;
                        });
                    }
                    getFileBackupAbsolutePath(record) {
                        const location = this.getFilesBackupsLocation();
                        if (!location) {
                            throw new dist.ClientDisplayableError('No files backups location set');
                        }
                        return this.device.joinPaths(location, record.relativePath);
                    }
                    openFileBackup(record) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = yield this.getFileBackupAbsolutePath(record);
                            yield this.directory.openLocation(location);
                        });
                    }
                    handleChangedFiles(files) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            if (files.length === 0 || !this.isFilesBackupsEnabled()) {
                                return;
                            }
                            const mapping = yield this.getBackupsMappingFromDisk();
                            if (!mapping) {
                                throw new dist.ClientDisplayableError('No backups mapping found');
                            }
                            for (const file of files) {
                                if (this.pendingFiles.has(file.uuid)) {
                                    continue;
                                }
                                const record = mapping[file.uuid];
                                if (record == undefined) {
                                    this.pendingFiles.add(file.uuid);
                                    yield this.performBackupOperation(file);
                                    this.pendingFiles.delete(file.uuid);
                                }
                            }
                            this.invalidateMappingCache();
                        });
                    }
                    handleChangedNotes(notes) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            if (notes.length === 0 || !this.isPlaintextBackupsEnabled()) {
                                return;
                            }
                            const location = this.getPlaintextBackupsLocation();
                            if (!location) {
                                throw new dist.ClientDisplayableError('No plaintext backups location found');
                            }
                            if (!this.markdownConverter) {
                                throw 'Super markdown converter not initialized';
                            }
                            for (const note of notes) {
                                const tags = this.items.getSortedTagsForItem(note);
                                const tagNames = tags.map(tag => this.items.getTagLongTitle(tag));
                                const text = note.noteType === features_dist.NoteType.Super ? yield this.markdownConverter.convertSuperStringToOtherFormat(note.text, 'md') : note.text;
                                yield this.device.savePlaintextNoteBackup(location, note.uuid, note.title, tagNames, text);
                            }
                            yield this.device.persistPlaintextBackupsMappingFile(location);
                        });
                    }
                    handleChangedTags(tags) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            if (tags.length === 0 || !this.isPlaintextBackupsEnabled()) {
                                return;
                            }
                            for (const tag of tags) {
                                const notes = this.items.referencesForItem(tag, src.ContentType.TYPES.Note);
                                yield this.handleChangedNotes(notes);
                            }
                        });
                    }
                    readEncryptedFileFromBackup(uuid, onChunk) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const fileBackup = yield this.getFileBackupInfo({
                                uuid
                            });
                            if (!fileBackup) {
                                return 'failed';
                            }
                            const fileBackupsLocation = this.getFilesBackupsLocation();
                            if (!fileBackupsLocation) {
                                return 'failed';
                            }
                            const path = yield this.device.joinPaths(fileBackupsLocation, fileBackup.relativePath, fileBackup.binaryFileName);
                            const token = yield this.device.getFileBackupReadToken(path);
                            let readMore = true;
                            let index = 0;
                            while (readMore) {
                                const { chunk, isLast, progress } = yield this.device.readNextChunk(token);
                                yield onChunk({
                                    data: chunk,
                                    index,
                                    isLast,
                                    progress
                                });
                                readMore = !isLast;
                                index++;
                            }
                            return 'success';
                        });
                    }
                    performBackupOperation(file) {
                        return FilesBackupService_awaiter(this, void 0, void 0, function* () {
                            const location = this.getFilesBackupsLocation();
                            if (!location) {
                                return 'failed';
                            }
                            const messageId = this.status.addMessage("Backing up file ".concat(file.name, "..."));
                            const encryptedFile = yield this.encryptor.encryptSplitSingle({
                                usesItemsKeyWithKeyLookup: {
                                    items: [file.payload]
                                }
                            });
                            const itemsKey = this.items.getDisplayableItemsKeys().find(k => k.uuid === encryptedFile.items_key_id);
                            if (!itemsKey) {
                                this.status.removeMessage(messageId);
                                return 'failed';
                            }
                            const encryptedItemsKey = yield this.encryptor.encryptSplitSingle({
                                usesRootKeyWithKeyLookup: {
                                    items: [itemsKey.payload]
                                }
                            });
                            const token = yield this.api.createUserFileValetToken(file.remoteIdentifier, dist.ValetTokenOperation.Read);
                            if (token instanceof dist.ClientDisplayableError) {
                                this.status.removeMessage(messageId);
                                return 'failed';
                            }
                            const metaFile = {
                                info: {
                                    warning: 'Do not edit this file.',
                                    information: 'The file and key data below is encrypted with your account password.',
                                    instructions: 'Drag and drop this metadata file into the File Backups preferences pane in the Standard Notes desktop or web application interface.'
                                },
                                file: (0, models_dist.CreateEncryptedBackupFileContextPayload)(encryptedFile.ejected()),
                                itemsKey: (0, models_dist.CreateEncryptedBackupFileContextPayload)(encryptedItemsKey.ejected()),
                                version: '1.0.0'
                            };
                            const metaFileAsString = JSON.stringify(metaFile, null, 2);
                            const downloadType = !file.user_uuid || file.user_uuid === this.session.getSureUser().uuid ? 'user' : 'shared-vault';
                            const result = yield this.device.saveFilesBackupsFile(location, file.uuid, metaFileAsString, {
                                chunkSizes: file.encryptedChunkSizes,
                                url: this.api.getFilesDownloadUrl(downloadType),
                                valetToken: token
                            });
                            this.status.removeMessage(messageId);
                            if (result === 'failed') {
                                const failMessageId = this.status.addMessage("Failed to back up ".concat(file.name, "..."));
                                setTimeout(() => {
                                    this.status.removeMessage(failMessageId);
                                }, 2000);
                            }
                            return result;
                        });
                    }
                    /**
                     * Not presently used or enabled. It works, but presently has the following edge cases:
                     * 1. Editing the note directly in SN triggers an immediate backup which triggers a file change which triggers the observer
                     * 2. Since changes are based on filenames, a note with the same title as another may not properly map to the correct uuid
                     * 3. Opening the file triggers a watch event from Node's watch API.
                     * 4. Gives web code ability to monitor arbitrary locations. Needs whitelisting mechanism.
                     */
                    disabledExperimental_monitorPlaintextBackups() {
                        const location = this.getPlaintextBackupsLocation();
                        if (location) {
                            void this.device.monitorPlaintextBackupsLocationForChanges(location);
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Strings/Messages.ts
                const API_MESSAGE_GENERIC_INVALID_LOGIN = 'A server error occurred while trying to sign in. Please try again.';
                const API_MESSAGE_GENERIC_REGISTRATION_FAIL = 'A server error occurred while trying to register. Please try again.';
                const API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL = 'Something went wrong while changing your credentials. Your credentials were not changed. Please try again.';
                const API_MESSAGE_GENERIC_SYNC_FAIL = 'Could not connect to server.';
                const ServerErrorStrings = {
                    DeleteAccountError: 'Your account was unable to be deleted due to an error. Please try your request again.'
                };
                const API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL = 'Could not check your data integrity with the server.';
                const API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL = 'Could not retrieve item.';
                const API_MESSAGE_REGISTRATION_IN_PROGRESS = 'An existing registration request is already in progress.';
                const API_MESSAGE_LOGIN_IN_PROGRESS = 'An existing sign in request is already in progress.';
                const API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS = 'An existing change credentials request is already in progress.';
                const API_MESSAGE_FALLBACK_LOGIN_FAIL = 'Invalid email or password.';
                const API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL = 'A server error occurred while trying to refresh your session. Please try again.';
                const API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS = 'Your account session is being renewed with the server. Please try your request again.';
                const API_MESSAGE_RATE_LIMITED = 'Too many successive server requests. Please wait a few minutes and try again.';
                const API_MESSAGE_INVALID_SESSION = 'Please sign in to an account in order to continue with your request.';
                const API_MESSAGE_FAILED_GET_SETTINGS = 'Failed to get settings.';
                const API_MESSAGE_FAILED_UPDATE_SETTINGS = 'Failed to update settings.';
                const API_MESSAGE_FAILED_LISTED_REGISTRATION = 'Unable to register for Listed. Please try again later.';
                const API_MESSAGE_FAILED_CREATE_FILE_TOKEN = 'Failed to create file token.';
                const API_MESSAGE_FAILED_SUBSCRIPTION_INFO = "Failed to get subscription's information.";
                const API_MESSAGE_FAILED_ACCESS_PURCHASE = 'Failed to access purchase flow.';
                const API_MESSAGE_FAILED_OFFLINE_FEATURES = 'Failed to get offline features.';
                const API_MESSAGE_UNTRUSTED_EXTENSIONS_WARNING = "The extension you are attempting to install comes from an\n  untrusted source. Untrusted extensions may lower the security of your data. Do you want to continue?";
                const API_MESSAGE_FAILED_DOWNLOADING_EXTENSION = "Error downloading package details. Please check the\n  extension link and try again.";
                const API_MESSAGE_FAILED_OFFLINE_ACTIVATION = 'An unknown issue occurred during offline activation. Please download your activation code again and try once more.';
                const INVALID_EXTENSION_URL = 'Invalid extension URL.';
                const UNSUPPORTED_PROTOCOL_VERSION = 'This version of the application does not support your newer account type. Please upgrade to the latest version of Standard Notes to sign in.';
                const EXPIRED_PROTOCOL_VERSION = 'The protocol version associated with your account is outdated and no longer supported by this application. Please visit standardnotes.com/help/security for more information.';
                const UNSUPPORTED_KEY_DERIVATION = 'Your account was created on a platform with higher security capabilities than this browser supports. If we attempted to generate your login keys here, it would take hours. Please use a browser with more up to date security capabilities, like Google Chrome or Firefox, to log in.';
                const INVALID_PASSWORD_COST = 'Unable to sign in due to insecure password parameters. Please visit standardnotes.com/help/security for more information.';
                const INVALID_PASSWORD = 'Invalid password.';
                const OUTDATED_PROTOCOL_ALERT_IGNORE = 'Sign In';
                const UPGRADING_ENCRYPTION = "Upgrading your account's encryption version…";
                const SETTING_PASSCODE = 'Setting passcode…';
                const CHANGING_PASSCODE = 'Changing passcode…';
                const REMOVING_PASSCODE = 'Removing passcode…';
                const DO_NOT_CLOSE_APPLICATION = 'Do not close the application until this process completes.';
                const UNKNOWN_ERROR = 'Unknown error.';
                function InsufficientPasswordMessage(minimum) {
                    return "Your password must be at least ".concat(minimum, " characters in length. For your security, please choose a longer password or, ideally, a passphrase, and try again.");
                }
                function StrictSignInFailed(current, latest) {
                    return "Strict Sign In has refused the server's sign-in parameters. The latest account version is ".concat(latest, ", but the server is reporting a version of ").concat(current, " for your account. If you'd like to proceed with sign in anyway, please disable Strict Sign In and try again.");
                }
                const CredentialsChangeStrings = {
                    PasscodeRequired: 'Your passcode is required to process your credentials change.',
                    Failed: 'Unable to change your credentials due to a sync error. Please try again.'
                };
                const RegisterStrings = {
                    PasscodeRequired: 'Your passcode is required in order to register for an account.'
                };
                const SignInStrings = {
                    PasscodeRequired: 'Your passcode is required in order to sign in to your account.',
                    IncorrectMfa: 'Incorrect two-factor authentication code. Please try again.',
                    SignInCanceledMissingMfa: 'Your sign in request has been canceled.'
                };
                const ProtocolUpgradeStrings = {
                    SuccessAccount: "Your encryption version has been successfully upgraded. You may be asked to enter your credentials again on other devices you're signed into.",
                    SuccessPasscodeOnly: 'Your encryption version has been successfully upgraded.',
                    Fail: 'Unable to upgrade encryption version. Please try again.',
                    UpgradingPasscode: 'Upgrading local encryption...'
                };
                const ChallengeModalTitle = {
                    Generic: 'Authentication Required',
                    Migration: 'Storage Update'
                };
                const SessionStrings = {
                    EnterEmailAndPassword: 'Please enter your account email and password.',
                    RecoverSession(email) {
                        return email ? "Your credentials are needed for ".concat(email, " to refresh your session with the server.") : 'Your credentials are needed to refresh your session with the server.';
                    },
                    SessionRestored: 'Your session has been successfully restored.',
                    EnterMfa: 'Please enter your two-factor authentication code.',
                    InputU2FDevice: 'Please authenticate with your hardware security key.',
                    MfaInputPlaceholder: 'Two-factor authentication code',
                    EmailInputPlaceholder: 'Email',
                    PasswordInputPlaceholder: 'Password',
                    KeychainRecoveryErrorTitle: 'Invalid Credentials',
                    KeychainRecoveryError: 'The email or password you entered is incorrect.\n\nPlease note that this sign-in request is made against the default server. If you are using a custom server, you must uninstall the app then reinstall, and sign back into your account.',
                    RevokeTitle: 'Revoke this session?',
                    RevokeConfirmButton: 'Revoke',
                    RevokeCancelButton: 'Cancel',
                    RevokeText: 'The associated app will be signed out and all data removed ' + 'from the device when it is next launched. You can sign back in on that ' + 'device at any time.',
                    CurrentSessionRevoked: 'Your session has been revoked and all local data has been removed ' + 'from this device.'
                };
                const ChallengeStrings = {
                    UnlockApplication: 'Authentication is required to unlock the application',
                    NoteAccess: 'Authentication is required to view this note',
                    FileAccess: 'Authentication is required to access this file',
                    ImportFile: 'Authentication is required to import a backup file',
                    AddPasscode: 'Authentication is required to add a passcode',
                    RemovePasscode: 'Authentication is required to remove your passcode',
                    ChangePasscode: 'Authentication is required to change your passcode',
                    ChangeAutolockInterval: 'Authentication is required to change autolock timer duration',
                    RevokeSession: 'Authentication is required to revoke a session',
                    EnterAccountPassword: 'Enter your account password',
                    EnterLocalPasscode: 'Enter your application passcode',
                    EnterPasscodeForMigration: 'Your application passcode is required to perform an upgrade of your local data storage structure.',
                    EnterPasscodeForRootResave: 'Enter your application passcode to continue',
                    EnterCredentialsForProtocolUpgrade: 'Enter your credentials to perform encryption upgrade',
                    EnterCredentialsForDecryptedBackupDownload: 'Enter your credentials to download a decrypted backup',
                    AccountPasswordPlaceholder: 'Account Password',
                    LocalPasscodePlaceholder: 'Application Passcode',
                    DecryptEncryptedFile: 'Enter the account password associated with the import file',
                    ExportBackup: 'Authentication is required to export a backup',
                    DisableBiometrics: 'Authentication is required to disable biometrics',
                    UnprotectNote: 'Authentication is required to unprotect a note',
                    UnprotectFile: 'Authentication is required to unprotect a file',
                    SearchProtectedNotesText: 'Authentication is required to search protected contents',
                    SelectProtectedNote: 'Authentication is required to select a protected note',
                    DisableMfa: 'Authentication is required to disable two-factor authentication',
                    DeleteAccount: 'Authentication is required to delete your account',
                    ListedAuthorization: 'Authentication is required to approve this note for Listed',
                    UnlockVault: vaultName => "Unlock ".concat(vaultName),
                    DeleteVault: vaultName => "Delete ".concat(vaultName),
                    EnterVaultPassword: 'Enter the password for this vault'
                };
                const ErrorAlertStrings = {
                    MissingSessionTitle: 'Missing Session',
                    MissingSessionBody: 'We were unable to load your server session. This represents an inconsistency with your application state. Please take an opportunity to backup your data, then sign out and sign back in to resolve this issue.',
                    StorageDecryptErrorTitle: 'Storage Error',
                    StorageDecryptErrorBody: "We were unable to decrypt your local storage. Please restart the app and try again. If you're unable to resolve this issue, and you have an account, you may try uninstalling the app then reinstalling, then signing back into your account. Otherwise, please contact help@standardnotes.com for support."
                };
                const KeychainRecoveryStrings = {
                    Title: 'Restore Keychain',
                    Text: email => "We've detected that your keychain has been wiped. This can happen when restoring your device from a backup. Please enter your account password for \"".concat(email, "\" to restore your account keys.")
                };
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Types/ChallengeReason.ts
                /* istanbul ignore file */
                var ChallengeReason;
                (function (ChallengeReason) {
                    ChallengeReason[ChallengeReason["AccessProtectedFile"] = 0] = "AccessProtectedFile";
                    ChallengeReason[ChallengeReason["AccessProtectedNote"] = 1] = "AccessProtectedNote";
                    ChallengeReason[ChallengeReason["AddPasscode"] = 2] = "AddPasscode";
                    ChallengeReason[ChallengeReason["ApplicationUnlock"] = 3] = "ApplicationUnlock";
                    ChallengeReason[ChallengeReason["ChangeAutolockInterval"] = 4] = "ChangeAutolockInterval";
                    ChallengeReason[ChallengeReason["ChangePasscode"] = 5] = "ChangePasscode";
                    ChallengeReason[ChallengeReason["CreateDecryptedBackupWithProtectedItems"] = 6] = "CreateDecryptedBackupWithProtectedItems";
                    ChallengeReason[ChallengeReason["Custom"] = 7] = "Custom";
                    ChallengeReason[ChallengeReason["DecryptEncryptedFile"] = 8] = "DecryptEncryptedFile";
                    ChallengeReason[ChallengeReason["DisableBiometrics"] = 9] = "DisableBiometrics";
                    ChallengeReason[ChallengeReason["DisableMfa"] = 10] = "DisableMfa";
                    ChallengeReason[ChallengeReason["ExportBackup"] = 11] = "ExportBackup";
                    ChallengeReason[ChallengeReason["ImportFile"] = 12] = "ImportFile";
                    ChallengeReason[ChallengeReason["Migration"] = 13] = "Migration";
                    ChallengeReason[ChallengeReason["ProtocolUpgrade"] = 14] = "ProtocolUpgrade";
                    ChallengeReason[ChallengeReason["RemovePasscode"] = 15] = "RemovePasscode";
                    ChallengeReason[ChallengeReason["ResaveRootKey"] = 16] = "ResaveRootKey";
                    ChallengeReason[ChallengeReason["RevokeSession"] = 17] = "RevokeSession";
                    ChallengeReason[ChallengeReason["SearchProtectedNotesText"] = 18] = "SearchProtectedNotesText";
                    ChallengeReason[ChallengeReason["SelectProtectedNote"] = 19] = "SelectProtectedNote";
                    ChallengeReason[ChallengeReason["UnprotectFile"] = 20] = "UnprotectFile";
                    ChallengeReason[ChallengeReason["UnprotectNote"] = 21] = "UnprotectNote";
                    ChallengeReason[ChallengeReason["DeleteAccount"] = 22] = "DeleteAccount";
                    ChallengeReason[ChallengeReason["AuthorizeNoteForListed"] = 23] = "AuthorizeNoteForListed";
                })(ChallengeReason || (ChallengeReason = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Challenge.ts
                /**
                 * A challenge is a stateless description of what the client needs to provide
                 * in order to proceed.
                 */
                class Challenge {
                    constructor(prompts, reason, cancelable, _heading, _subheading) {
                        this.prompts = prompts;
                        this.reason = reason;
                        this.cancelable = cancelable;
                        this._heading = _heading;
                        this._subheading = _subheading;
                        this.id = Math.random();
                    }
                    /** Outside of the modal, this is the title of the modal itself */
                    get modalTitle() {
                        switch (this.reason) {
                            case ChallengeReason.Migration:
                                return ChallengeModalTitle.Migration;
                            default:
                                return ChallengeModalTitle.Generic;
                        }
                    }
                    /** Inside of the modal, this is the H1 */
                    get heading() {
                        if (this._heading) {
                            return this._heading;
                        }
                        else {
                            switch (this.reason) {
                                case ChallengeReason.ApplicationUnlock:
                                    return ChallengeStrings.UnlockApplication;
                                case ChallengeReason.Migration:
                                    return ChallengeStrings.EnterLocalPasscode;
                                case ChallengeReason.ResaveRootKey:
                                    return ChallengeStrings.EnterPasscodeForRootResave;
                                case ChallengeReason.ProtocolUpgrade:
                                    return ChallengeStrings.EnterCredentialsForProtocolUpgrade;
                                case ChallengeReason.AccessProtectedNote:
                                    return ChallengeStrings.NoteAccess;
                                case ChallengeReason.AccessProtectedFile:
                                    return ChallengeStrings.FileAccess;
                                case ChallengeReason.ImportFile:
                                    return ChallengeStrings.ImportFile;
                                case ChallengeReason.AddPasscode:
                                    return ChallengeStrings.AddPasscode;
                                case ChallengeReason.RemovePasscode:
                                    return ChallengeStrings.RemovePasscode;
                                case ChallengeReason.ChangePasscode:
                                    return ChallengeStrings.ChangePasscode;
                                case ChallengeReason.ChangeAutolockInterval:
                                    return ChallengeStrings.ChangeAutolockInterval;
                                case ChallengeReason.CreateDecryptedBackupWithProtectedItems:
                                    return ChallengeStrings.EnterCredentialsForDecryptedBackupDownload;
                                case ChallengeReason.RevokeSession:
                                    return ChallengeStrings.RevokeSession;
                                case ChallengeReason.DecryptEncryptedFile:
                                    return ChallengeStrings.DecryptEncryptedFile;
                                case ChallengeReason.ExportBackup:
                                    return ChallengeStrings.ExportBackup;
                                case ChallengeReason.DisableBiometrics:
                                    return ChallengeStrings.DisableBiometrics;
                                case ChallengeReason.UnprotectNote:
                                    return ChallengeStrings.UnprotectNote;
                                case ChallengeReason.UnprotectFile:
                                    return ChallengeStrings.UnprotectFile;
                                case ChallengeReason.SearchProtectedNotesText:
                                    return ChallengeStrings.SearchProtectedNotesText;
                                case ChallengeReason.SelectProtectedNote:
                                    return ChallengeStrings.SelectProtectedNote;
                                case ChallengeReason.DisableMfa:
                                    return ChallengeStrings.DisableMfa;
                                case ChallengeReason.DeleteAccount:
                                    return ChallengeStrings.DeleteAccount;
                                case ChallengeReason.AuthorizeNoteForListed:
                                    return ChallengeStrings.ListedAuthorization;
                                case ChallengeReason.Custom:
                                    return '';
                                default:
                                    return (0, utils_dist.assertUnreachable)(this.reason);
                            }
                        }
                    }
                    /** Inside of the modal, this is the H2 */
                    get subheading() {
                        if (this._subheading) {
                            return this._subheading;
                        }
                        switch (this.reason) {
                            case ChallengeReason.Migration:
                                return ChallengeStrings.EnterPasscodeForMigration;
                            default:
                                return undefined;
                        }
                    }
                    hasPromptForValidationType(type) {
                        for (const prompt of this.prompts) {
                            if (prompt.validation === type) {
                                return true;
                            }
                        }
                        return false;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Types/ChallengeValidation.ts
                /* istanbul ignore file */
                var ChallengeValidation;
                (function (ChallengeValidation) {
                    ChallengeValidation[ChallengeValidation["None"] = 0] = "None";
                    ChallengeValidation[ChallengeValidation["LocalPasscode"] = 1] = "LocalPasscode";
                    ChallengeValidation[ChallengeValidation["AccountPassword"] = 2] = "AccountPassword";
                    ChallengeValidation[ChallengeValidation["Biometric"] = 3] = "Biometric";
                    ChallengeValidation[ChallengeValidation["ProtectionSessionDuration"] = 4] = "ProtectionSessionDuration";
                    ChallengeValidation[ChallengeValidation["Authenticator"] = 5] = "Authenticator";
                })(ChallengeValidation || (ChallengeValidation = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Prompt/PromptTitles.ts
                /* istanbul ignore file */
                const ChallengePromptTitle = {
                    AccountPassword: 'Account Password',
                    LocalPasscode: 'Application Passcode',
                    Biometrics: 'Biometrics',
                    RememberFor: 'Remember For',
                    Mfa: 'Two-factor Authentication Code',
                    U2F: 'Security Key'
                };
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Prompt/ChallengePrompt.ts
                /* istanbul ignore file */
                class ChallengePrompt {
                    constructor(validation, title, placeholder) {
                        let secureTextEntry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                        let keyboardType = arguments.length > 4 ? arguments[4] : undefined;
                        let initialValue = arguments.length > 5 ? arguments[5] : undefined;
                        let contextData = arguments.length > 6 ? arguments[6] : undefined;
                        this.validation = validation;
                        this.secureTextEntry = secureTextEntry;
                        this.keyboardType = keyboardType;
                        this.initialValue = initialValue;
                        this.contextData = contextData;
                        this.id = Math.random();
                        switch (this.validation) {
                            case ChallengeValidation.AccountPassword:
                                this.title = title !== null && title !== void 0 ? title : ChallengePromptTitle.AccountPassword;
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : ChallengePromptTitle.AccountPassword;
                                this.validates = true;
                                break;
                            case ChallengeValidation.LocalPasscode:
                                this.title = title !== null && title !== void 0 ? title : ChallengePromptTitle.LocalPasscode;
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : ChallengePromptTitle.LocalPasscode;
                                this.validates = true;
                                break;
                            case ChallengeValidation.Biometric:
                                this.title = title !== null && title !== void 0 ? title : ChallengePromptTitle.Biometrics;
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : '';
                                this.validates = true;
                                break;
                            case ChallengeValidation.Authenticator:
                                this.title = title !== null && title !== void 0 ? title : ChallengePromptTitle.U2F;
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : '';
                                this.validates = true;
                                break;
                            case ChallengeValidation.ProtectionSessionDuration:
                                this.title = title !== null && title !== void 0 ? title : ChallengePromptTitle.RememberFor;
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : '';
                                this.validates = true;
                                break;
                            case ChallengeValidation.None:
                                this.title = title !== null && title !== void 0 ? title : '';
                                this.placeholder = placeholder !== null && placeholder !== void 0 ? placeholder : '';
                                this.validates = false;
                                break;
                            default:
                                (0, utils_dist.assertUnreachable)(this.validation);
                        }
                        Object.freeze(this);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Types/ChallengeKeyboardType.ts
                /* istanbul ignore file */
                /** For mobile */
                var ChallengeKeyboardType;
                (function (ChallengeKeyboardType) {
                    ChallengeKeyboardType["Alphanumeric"] = "default";
                    ChallengeKeyboardType["Numeric"] = "numeric";
                })(ChallengeKeyboardType || (ChallengeKeyboardType = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/Types/ChallengeValue.ts
                /* istanbul ignore file */
                function CreateChallengeValue(prompt, value) {
                    return {
                        prompt,
                        value
                    };
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Challenge/index.ts
                ; // CONCATENATED MODULE: ../services/src/Domain/Component/ComponentViewerError.ts
                var ComponentViewerError;
                (function (ComponentViewerError) {
                    ComponentViewerError["OfflineRestricted"] = "OfflineRestricted";
                    ComponentViewerError["MissingUrl"] = "MissingUrl";
                })(ComponentViewerError || (ComponentViewerError = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Component/ComponentViewerItem.ts
                function isComponentViewerItemReadonlyItem(item) {
                    return 'readonlyItem' in item;
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/CollaborationID.ts
                const Version1CollaborationId = '1';
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/ContactService.ts
                var ContactService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ContactService extends AbstractService {
                    constructor(sync, mutator, session, crypto, user, selfContactManager, encryption, _deleteContact, _findContact, _getAllContacts, _createOrEditContact, _editContact, _validateItemSigner, eventBus) {
                        super(eventBus);
                        this.sync = sync;
                        this.mutator = mutator;
                        this.session = session;
                        this.crypto = crypto;
                        this.user = user;
                        this.selfContactManager = selfContactManager;
                        this.encryption = encryption;
                        this._deleteContact = _deleteContact;
                        this._findContact = _findContact;
                        this._getAllContacts = _getAllContacts;
                        this._createOrEditContact = _createOrEditContact;
                        this._editContact = _editContact;
                        this._validateItemSigner = _validateItemSigner;
                    }
                    deinit() {
                        super.deinit();
                        this.sync = undefined;
                        this.mutator = undefined;
                        this.session = undefined;
                        this.crypto = undefined;
                        this.user = undefined;
                        this.selfContactManager = undefined;
                        this.encryption = undefined;
                        this._findContact = undefined;
                        this._getAllContacts = undefined;
                        this._createOrEditContact = undefined;
                        this._editContact = undefined;
                        this._validateItemSigner = undefined;
                    }
                    getSelfContact() {
                        return this.selfContactManager.selfContact;
                    }
                    isCollaborationEnabled() {
                        return !this.session.isUserMissingKeyPair();
                    }
                    enableCollaboration() {
                        return ContactService_awaiter(this, void 0, void 0, function* () {
                            yield this.user.updateAccountWithFirstTimeKeyPair();
                        });
                    }
                    getCollaborationID() {
                        const publicKey = this.session.getPublicKey();
                        if (!publicKey) {
                            throw new Error('Collaboration not enabled');
                        }
                        return this.buildCollaborationId({
                            version: Version1CollaborationId,
                            userUuid: this.session.getSureUser().uuid,
                            publicKey,
                            signingPublicKey: this.session.getSigningPublicKey()
                        });
                    }
                    buildCollaborationId(params) {
                        const string = "".concat(params.version, ":").concat(params.userUuid, ":").concat(params.publicKey, ":").concat(params.signingPublicKey);
                        return this.crypto.base64Encode(string);
                    }
                    parseCollaborationID(collaborationID) {
                        const decoded = this.crypto.base64Decode(collaborationID);
                        const [version, userUuid, publicKey, signingPublicKey] = decoded.split(':');
                        return {
                            version,
                            userUuid,
                            publicKey,
                            signingPublicKey
                        };
                    }
                    getCollaborationIDFromInvite(invite) {
                        const publicKeySet = this.encryption.getSenderPublicKeySetFromAsymmetricallyEncryptedString(invite.encrypted_message);
                        return this.buildCollaborationId({
                            version: Version1CollaborationId,
                            userUuid: invite.sender_uuid,
                            publicKey: publicKeySet.encryption,
                            signingPublicKey: publicKeySet.signing
                        });
                    }
                    addTrustedContactFromCollaborationID(collaborationID, name) {
                        const { userUuid, publicKey, signingPublicKey } = this.parseCollaborationID(collaborationID);
                        if (userUuid === this.user.getUserUuid()) {
                            throw new dist.ClientDisplayableError('You cannot add yourself as a trusted contact');
                        }
                        return this.createOrEditTrustedContact({
                            name: name !== null && name !== void 0 ? name : '',
                            contactUuid: userUuid,
                            publicKey,
                            signingPublicKey
                        });
                    }
                    editTrustedContactFromCollaborationID(contact, params) {
                        return ContactService_awaiter(this, void 0, void 0, function* () {
                            const { publicKey, signingPublicKey, userUuid } = this.parseCollaborationID(params.collaborationID);
                            if (userUuid !== contact.contactUuid) {
                                throw new Error("Collaboration ID's user uuid does not match contact UUID");
                            }
                            const updatedContact = yield this.mutator.changeItem(contact, mutator => {
                                mutator.name = params.name;
                                if (publicKey !== contact.publicKeySet.encryption || signingPublicKey !== contact.publicKeySet.signing) {
                                    mutator.addPublicKey({
                                        encryption: publicKey,
                                        signing: signingPublicKey
                                    });
                                }
                            });
                            yield this.sync.sync();
                            return updatedContact;
                        });
                    }
                    updateTrustedContact(contact, params) {
                        return ContactService_awaiter(this, void 0, void 0, function* () {
                            const updatedContact = yield this._editContact.execute(contact, params);
                            void this.sync.sync();
                            return updatedContact;
                        });
                    }
                    createOrEditTrustedContact(params) {
                        return ContactService_awaiter(this, void 0, void 0, function* () {
                            const contact = yield this._createOrEditContact.execute(params);
                            void this.sync.sync();
                            return contact;
                        });
                    }
                    deleteContact(contact) {
                        return ContactService_awaiter(this, void 0, void 0, function* () {
                            return this._deleteContact.execute({
                                contact,
                                ownUserUuid: this.session.userUuid
                            });
                        });
                    }
                    getAllContacts() {
                        return this._getAllContacts.execute().getValue();
                    }
                    findContact(userUuid) {
                        const result = this._findContact.execute({
                            userUuid
                        });
                        if (result.isFailed()) {
                            return undefined;
                        }
                        return result.getValue();
                    }
                    findContactForServerUser(user) {
                        return this.findContact(user.user_uuid);
                    }
                    findContactForInvite(invite) {
                        return this.findContact(invite.user_uuid);
                    }
                    findSenderContactForInvite(invite) {
                        return this.findContact(invite.sender_uuid);
                    }
                    getCollaborationIDForTrustedContact(contact) {
                        return this.buildCollaborationId({
                            version: Version1CollaborationId,
                            userUuid: contact.content.contactUuid,
                            publicKey: contact.content.publicKeySet.encryption,
                            signingPublicKey: contact.content.publicKeySet.signing
                        });
                    }
                    getItemSignatureStatus(item) {
                        return this._validateItemSigner.execute(item);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/ContactServiceInterface.ts
                var ContactServiceEvent;
                (function (ContactServiceEvent) { })(ContactServiceEvent || (ContactServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/InternalFeatures/InternalFeature.ts
                var InternalFeature;
                (function (InternalFeature) {
                    InternalFeature["Vaults"] = "vaults";
                })(InternalFeature || (InternalFeature = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/InternalFeatures/InternalFeatureService.ts
                let sharedInstance;
                class InternalFeatureService {
                    constructor() {
                        this.enabledFeatures = new Set();
                    }
                    static get() {
                        if (!sharedInstance) {
                            sharedInstance = new InternalFeatureService();
                        }
                        return sharedInstance;
                    }
                    isFeatureEnabled(feature) {
                        return this.enabledFeatures.has(feature);
                    }
                    enableFeature(feature) {
                        console.warn("Enabling internal feature: ".concat(feature));
                        this.enabledFeatures.add(feature);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/SelfContactManager.ts
                var SelfContactManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const SelfContactName = 'Me';
                class SelfContactManager {
                    constructor(sync, items, session, singletons) {
                        this.session = session;
                        this.singletons = singletons;
                        this.isReloadingSelfContact = false;
                        this.eventDisposers = [];
                        this.eventDisposers.push(sync.addEventObserver(event => {
                            if (event === SyncEvent.LocalDataIncrementalLoad) {
                                this.loadSelfContactFromDatabase();
                            }
                            if (event === SyncEvent.SyncCompletedWithAllItemsUploaded) {
                                void this.reloadSelfContactAndCreateIfNecessary();
                            }
                        }));
                        this.eventDisposers.push(items.addObserver(src.ContentType.TYPES.TrustedContact, () => {
                            const updatedReference = this.singletons.findSingleton(src.ContentType.TYPES.TrustedContact, models_dist.TrustedContact.singletonPredicate);
                            if (updatedReference) {
                                this.selfContact = updatedReference;
                            }
                        }));
                    }
                    handleEvent(event) {
                        return SelfContactManager_awaiter(this, void 0, void 0, function* () {
                            if (event.type === ApplicationEvent.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === ApplicationStage.LoadedDatabase_12) {
                                    this.loadSelfContactFromDatabase();
                                }
                            }
                        });
                    }
                    loadSelfContactFromDatabase() {
                        if (this.selfContact) {
                            return;
                        }
                        this.selfContact = this.singletons.findSingleton(src.ContentType.TYPES.TrustedContact, models_dist.TrustedContact.singletonPredicate);
                    }
                    reloadSelfContactAndCreateIfNecessary() {
                        return SelfContactManager_awaiter(this, void 0, void 0, function* () {
                            if (!InternalFeatureService.get().isFeatureEnabled(InternalFeature.Vaults)) {
                                return;
                            }
                            if (this.selfContact) {
                                return;
                            }
                            if (this.isReloadingSelfContact) {
                                return;
                            }
                            if (!this.session.isSignedIn()) {
                                return;
                            }
                            if (this.session.isUserMissingKeyPair()) {
                                return;
                            }
                            this.isReloadingSelfContact = true;
                            const content = {
                                name: SelfContactName,
                                isMe: true,
                                contactUuid: this.session.getSureUser().uuid,
                                publicKeySet: models_dist.ContactPublicKeySet.FromJson({
                                    encryption: this.session.getPublicKey(),
                                    signing: this.session.getSigningPublicKey(),
                                    timestamp: new Date()
                                })
                            };
                            this.selfContact = yield this.singletons.findOrCreateSingleton(models_dist.TrustedContact.singletonPredicate, src.ContentType.TYPES.TrustedContact, (0, models_dist.FillItemContent)(content));
                            this.isReloadingSelfContact = false;
                        });
                    }
                    deinit() {
                        this.eventDisposers.forEach(disposer => disposer());
                        this.session = undefined;
                        this.singletons = undefined;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UnknownContactName.ts
                const UnknownContactName = 'Unnamed contact';
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/CreateOrEditContact.ts
                var CreateOrEditContact_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateOrEditContact {
                    constructor(mutator, findContact, editContact) {
                        this.mutator = mutator;
                        this.findContact = findContact;
                        this.editContact = editContact;
                    }
                    execute(params) {
                        var _a, _b, _c;
                        return CreateOrEditContact_awaiter(this, void 0, void 0, function* () {
                            const existingContact = this.findContact.execute({
                                userUuid: params.contactUuid
                            });
                            if (!existingContact.isFailed()) {
                                yield this.editContact.execute(existingContact.getValue(), Object.assign(Object.assign({}, params), {
                                    name: (_a = params.name) !== null && _a !== void 0 ? _a : existingContact.getValue().name
                                }));
                                return existingContact.getValue();
                            }
                            const content = {
                                name: (_b = params.name) !== null && _b !== void 0 ? _b : UnknownContactName,
                                publicKeySet: models_dist.ContactPublicKeySet.FromJson({
                                    encryption: params.publicKey,
                                    signing: params.signingPublicKey,
                                    timestamp: new Date()
                                }),
                                contactUuid: params.contactUuid,
                                isMe: (_c = params.isMe) !== null && _c !== void 0 ? _c : false
                            };
                            const contact = yield this.mutator.createItem(src.ContentType.TYPES.TrustedContact, (0, models_dist.FillItemContent)(content), true);
                            return contact;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/DeleteContact.ts
                var DeleteContact_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteContact {
                    constructor(mutator, sync, getOwnedVaults, contactBelongsToVault) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this.getOwnedVaults = getOwnedVaults;
                        this.contactBelongsToVault = contactBelongsToVault;
                    }
                    execute(dto) {
                        return DeleteContact_awaiter(this, void 0, void 0, function* () {
                            if (dto.contact.isMe) {
                                throw new Error('Cannot delete self');
                            }
                            const vaults = this.getOwnedVaults.execute();
                            if (vaults.isFailed()) {
                                return src.Result.fail('Failed to get owned vaults');
                            }
                            for (const vault of vaults.getValue()) {
                                const contactBelongsToVault = yield this.contactBelongsToVault.execute({
                                    contact: dto.contact,
                                    vault: vault
                                });
                                if (contactBelongsToVault.isFailed()) {
                                    return src.Result.fail('Failed to check contact membership');
                                }
                                if (contactBelongsToVault.getValue()) {
                                    return src.Result.fail('Cannot delete contact that belongs to an owned vault');
                                }
                            }
                            yield this.mutator.setItemToBeDeleted(dto.contact);
                            yield this.sync.sync();
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/EditContact.ts
                var EditContact_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class EditContact {
                    constructor(mutator) {
                        this.mutator = mutator;
                    }
                    execute(contact, params) {
                        return EditContact_awaiter(this, void 0, void 0, function* () {
                            const updatedContact = yield this.mutator.changeItem(contact, mutator => {
                                mutator.name = params.name;
                                if (params.publicKey !== contact.publicKeySet.encryption || params.signingPublicKey !== contact.publicKeySet.signing) {
                                    mutator.addPublicKey({
                                        encryption: params.publicKey,
                                        signing: params.signingPublicKey
                                    });
                                }
                            });
                            return updatedContact;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/FindContact.ts
                class FindContact {
                    constructor(items) {
                        this.items = items;
                    }
                    execute(query) {
                        if ('userUuid' in query && query.userUuid) {
                            const contacts = this.items.itemsMatchingPredicate(src.ContentType.TYPES.TrustedContact, new models_dist.Predicate('contactUuid', '=', query.userUuid));
                            if (contacts.length === 0) {
                                return src.Result.fail("Contact not found for user ".concat(query.userUuid));
                            }
                            if (contacts.length > 1) {
                                return src.Result.fail("Multiple contacts found for user ".concat(query.userUuid));
                            }
                            return src.Result.ok(contacts[0]);
                        }
                        if ('signingPublicKey' in query && query.signingPublicKey) {
                            const allContacts = this.items.getItems(src.ContentType.TYPES.TrustedContact);
                            const contact = allContacts.find(contact => contact.hasCurrentOrPreviousSigningPublicKey(query.signingPublicKey));
                            if (contact) {
                                return src.Result.ok(contact);
                            }
                            else {
                                return src.Result.fail('Contact not found');
                            }
                        }
                        throw new Error('Invalid query');
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/GetAllContacts.ts
                class GetAllContacts {
                    constructor(items) {
                        this.items = items;
                    }
                    execute() {
                        return src.Result.ok(this.items.getItems(src.ContentType.TYPES.TrustedContact));
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/HandleKeyPairChange.ts
                var HandleKeyPairChange_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class HandleKeyPairChange {
                    constructor(selfContactManager, invitesServer, messageServer, _reuploadAllInvites, _resendAllMessages, _getAllContacts, _sendOwnContactChangedMessage, _createOrEditContact, logger) {
                        this.selfContactManager = selfContactManager;
                        this.invitesServer = invitesServer;
                        this.messageServer = messageServer;
                        this._reuploadAllInvites = _reuploadAllInvites;
                        this._resendAllMessages = _resendAllMessages;
                        this._getAllContacts = _getAllContacts;
                        this._sendOwnContactChangedMessage = _sendOwnContactChangedMessage;
                        this._createOrEditContact = _createOrEditContact;
                        this.logger = logger;
                    }
                    execute(dto) {
                        return HandleKeyPairChange_awaiter(this, void 0, void 0, function* () {
                            yield this.updateSelfContact({
                                encryption: dto.newKeys.encryption.publicKey,
                                signing: dto.newKeys.signing.publicKey
                            });
                            const results = yield Promise.all([this._reuploadAllInvites.execute({
                                    keys: dto.newKeys,
                                    previousKeys: dto.previousKeys
                                }), this._resendAllMessages.execute({
                                    keys: dto.newKeys,
                                    previousKeys: dto.previousKeys
                                })]);
                            for (const result of results) {
                                if (result.isFailed()) {
                                    this.logger.error(result.getError());
                                }
                            }
                            yield this.sendOwnContactChangeEventToAllContacts(dto);
                            const deleteResponses = yield Promise.all([this.messageServer.deleteAllInboundMessages(), this.invitesServer.deleteAllInboundInvites()]);
                            for (const response of deleteResponses) {
                                if ((0, dist.isErrorResponse)(response)) {
                                    this.logger.error(JSON.stringify(response));
                                }
                            }
                            return src.Result.ok();
                        });
                    }
                    updateSelfContact(publicKeySet) {
                        return HandleKeyPairChange_awaiter(this, void 0, void 0, function* () {
                            if (!InternalFeatureService.get().isFeatureEnabled(InternalFeature.Vaults)) {
                                return;
                            }
                            const selfContact = this.selfContactManager.selfContact;
                            if (!selfContact) {
                                return;
                            }
                            yield this._createOrEditContact.execute({
                                contactUuid: selfContact.contactUuid,
                                publicKey: publicKeySet.encryption,
                                signingPublicKey: publicKeySet.signing
                            });
                        });
                    }
                    sendOwnContactChangeEventToAllContacts(data) {
                        return HandleKeyPairChange_awaiter(this, void 0, void 0, function* () {
                            if (!data.previousKeys) {
                                return;
                            }
                            const contacts = this._getAllContacts.execute();
                            if (contacts.isFailed()) {
                                return;
                            }
                            for (const contact of contacts.getValue()) {
                                if (contact.isMe) {
                                    continue;
                                }
                                yield this._sendOwnContactChangedMessage.execute({
                                    senderOldKeyPair: data.previousKeys.encryption,
                                    senderOldSigningKeyPair: data.previousKeys.signing,
                                    senderNewKeyPair: data.newKeys.encryption,
                                    senderNewSigningKeyPair: data.newKeys.signing,
                                    contact
                                });
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/ReplaceContactData.ts
                var ReplaceContactData_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ReplaceContactData {
                    constructor(mutator, sync, findContact) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this.findContact = findContact;
                    }
                    execute(data) {
                        return ReplaceContactData_awaiter(this, void 0, void 0, function* () {
                            const contactResult = this.findContact.execute({
                                userUuid: data.contactUuid
                            });
                            if (contactResult.isFailed()) {
                                const newContact = yield this.mutator.createItem(src.ContentType.TYPES.TrustedContact, (0, models_dist.FillItemContent)(data), true);
                                yield this.sync.sync();
                                return src.Result.ok(newContact);
                            }
                            const existingContact = contactResult.getValue();
                            if (existingContact.isMe) {
                                return src.Result.fail('Cannot replace data for me contact');
                            }
                            const updatedContact = yield this.mutator.changeItem(existingContact, mutator => {
                                mutator.name = data.name;
                                mutator.replacePublicKeySet(data.publicKeySet);
                            }, models_dist.MutationType.UpdateUserTimestamps, models_dist.PayloadEmitSource.RemoteRetrieved);
                            yield this.sync.sync();
                            return src.Result.ok(updatedContact);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/SendOwnContactChangeMessage.ts
                var SendOwnContactChangeMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SendOwnContactChangeMessage {
                    constructor(encryptMessage, sendMessage) {
                        this.encryptMessage = encryptMessage;
                        this.sendMessage = sendMessage;
                    }
                    execute(params) {
                        return SendOwnContactChangeMessage_awaiter(this, void 0, void 0, function* () {
                            const message = {
                                type: models_dist.AsymmetricMessagePayloadType.SenderKeypairChanged,
                                data: {
                                    recipientUuid: params.contact.contactUuid,
                                    newEncryptionPublicKey: params.senderNewKeyPair.publicKey,
                                    newSigningPublicKey: params.senderNewSigningKeyPair.publicKey
                                }
                            };
                            const encryptedMessage = this.encryptMessage.execute({
                                message: message,
                                keys: {
                                    encryption: params.senderOldKeyPair,
                                    signing: params.senderOldSigningKeyPair
                                },
                                recipientPublicKey: params.contact.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const sendMessageResult = yield this.sendMessage.execute({
                                recipientUuid: params.contact.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                replaceabilityIdentifier: undefined
                            });
                            return sendMessageResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/Types/ItemSignatureValidationResult.ts
                var ItemSignatureValidationResult;
                (function (ItemSignatureValidationResult) {
                    ItemSignatureValidationResult["NotApplicable"] = "NotApplicable";
                    ItemSignatureValidationResult["Trusted"] = "Trusted";
                    ItemSignatureValidationResult["SignedWithNonCurrentKey"] = "SignedWithNonCurrentKey";
                    ItemSignatureValidationResult["NotTrusted"] = "NotTrusted";
                })(ItemSignatureValidationResult || (ItemSignatureValidationResult = {}));
                // EXTERNAL MODULE: ../encryption/src/Domain/Operator/004/V004AlgorithmHelpers.ts
                var V004AlgorithmHelpers = __webpack_require__(73936);
                ; // CONCATENATED MODULE: ../services/src/Domain/Contacts/UseCase/ValidateItemSigner.ts
                class ValidateItemSigner {
                    constructor(findContact) {
                        this.findContact = findContact;
                    }
                    execute(item) {
                        const uuidOfLastEditor = item.last_edited_by_uuid;
                        if (uuidOfLastEditor) {
                            return this.validateSignatureWithLastEditedByUuid(item, uuidOfLastEditor);
                        }
                        else {
                            return this.validateSignatureWithNoLastEditedByUuid(item);
                        }
                    }
                    isItemLocallyCreatedAndDoesNotRequireSignature(item) {
                        return item.payload.source === models_dist.PayloadSource.Constructor;
                    }
                    isItemResutOfRemoteSaveAndDoesNotRequireSignature(item) {
                        return item.payload.source === models_dist.PayloadSource.RemoteSaved;
                    }
                    validateSignatureWithLastEditedByUuid(item, uuidOfLastEditor) {
                        const requiresSignature = (0, V004AlgorithmHelpers /* doesPayloadRequireSigning */.q)(item);
                        const trustedContact = this.findContact.execute({
                            userUuid: uuidOfLastEditor
                        });
                        if (trustedContact.isFailed()) {
                            if (requiresSignature) {
                                return ItemSignatureValidationResult.NotTrusted;
                            }
                            else {
                                return ItemSignatureValidationResult.NotApplicable;
                            }
                        }
                        if (!item.signatureData) {
                            if (this.isItemLocallyCreatedAndDoesNotRequireSignature(item) || this.isItemResutOfRemoteSaveAndDoesNotRequireSignature(item)) {
                                return ItemSignatureValidationResult.NotApplicable;
                            }
                            if (requiresSignature) {
                                return ItemSignatureValidationResult.NotTrusted;
                            }
                            return ItemSignatureValidationResult.NotApplicable;
                        }
                        const signatureData = item.signatureData;
                        if (!signatureData.result) {
                            if (signatureData.required) {
                                return ItemSignatureValidationResult.NotTrusted;
                            }
                            return ItemSignatureValidationResult.NotApplicable;
                        }
                        const signatureResult = signatureData.result;
                        if (!signatureResult.passes) {
                            return ItemSignatureValidationResult.NotTrusted;
                        }
                        const signerPublicKey = signatureResult.publicKey;
                        const trustStatus = trustedContact.getValue().getTrustStatusForSigningPublicKey(signerPublicKey);
                        if (trustStatus === models_dist.PublicKeyTrustStatus.Trusted) {
                            return ItemSignatureValidationResult.Trusted;
                        }
                        else if (trustStatus === models_dist.PublicKeyTrustStatus.Previous) {
                            return ItemSignatureValidationResult.SignedWithNonCurrentKey;
                        }
                        return ItemSignatureValidationResult.NotTrusted;
                    }
                    validateSignatureWithNoLastEditedByUuid(item) {
                        const requiresSignature = (0, V004AlgorithmHelpers /* doesPayloadRequireSigning */.q)(item);
                        if (!item.signatureData) {
                            if (this.isItemLocallyCreatedAndDoesNotRequireSignature(item) || this.isItemResutOfRemoteSaveAndDoesNotRequireSignature(item)) {
                                return ItemSignatureValidationResult.NotApplicable;
                            }
                            if (requiresSignature) {
                                return ItemSignatureValidationResult.NotTrusted;
                            }
                            return ItemSignatureValidationResult.NotApplicable;
                        }
                        const signatureData = item.signatureData;
                        if (!signatureData.result) {
                            if (signatureData.required) {
                                return ItemSignatureValidationResult.NotTrusted;
                            }
                            return ItemSignatureValidationResult.NotApplicable;
                        }
                        const signatureResult = signatureData.result;
                        if (!signatureResult.passes) {
                            return ItemSignatureValidationResult.NotTrusted;
                        }
                        const signerPublicKey = signatureResult.publicKey;
                        const trustedContact = this.findContact.execute({
                            signingPublicKey: signerPublicKey
                        });
                        if (trustedContact.isFailed()) {
                            return ItemSignatureValidationResult.NotTrusted;
                        }
                        const trustStatus = trustedContact.getValue().getTrustStatusForSigningPublicKey(signerPublicKey);
                        if (trustStatus === models_dist.PublicKeyTrustStatus.Trusted) {
                            return ItemSignatureValidationResult.Trusted;
                        }
                        else if (trustStatus === models_dist.PublicKeyTrustStatus.Previous) {
                            return ItemSignatureValidationResult.SignedWithNonCurrentKey;
                        }
                        return ItemSignatureValidationResult.NotTrusted;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Device/DatabaseLoadOptions.ts
                function isChunkFullEntry(x) {
                    return x.entries !== undefined;
                }
                function isFullEntryLoadChunkResponse(x) {
                    return x.fullEntries !== undefined;
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Device/DatabaseLoadSorter.ts
                /**
                 * Sorts payloads according by most recently modified first, according to the priority,
                 * whereby the earlier a content_type appears in the priorityList,
                 * the earlier it will appear in the resulting sorted array.
                 */
                function SortPayloadsByRecentAndContentPriority(payloads, contentTypePriorityList) {
                    return payloads.sort((a, b) => {
                        const dateResult = new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
                        let aPriority = 0;
                        let bPriority = 0;
                        aPriority = contentTypePriorityList.indexOf(a.content_type);
                        bPriority = contentTypePriorityList.indexOf(b.content_type);
                        if (aPriority === -1) {
                            aPriority = contentTypePriorityList.length;
                        }
                        if (bPriority === -1) {
                            bPriority = contentTypePriorityList.length;
                        }
                        if (aPriority === bPriority) {
                            return dateResult;
                        }
                        if (aPriority < bPriority) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    });
                }
                /**
                 * Sorts payloads according by most recently modified first, according to the priority,
                 * whereby the earlier a uuid appears in the priorityList,
                 * the earlier it will appear in the resulting sorted array.
                 */
                function SortPayloadsByRecentAndUuidPriority(payloads, uuidPriorityList) {
                    return payloads.sort((a, b) => {
                        const dateResult = new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
                        let aPriority = 0;
                        let bPriority = 0;
                        aPriority = uuidPriorityList.indexOf(a.uuid);
                        bPriority = uuidPriorityList.indexOf(b.uuid);
                        if (aPriority === -1) {
                            aPriority = uuidPriorityList.length;
                        }
                        if (bPriority === -1) {
                            bPriority = uuidPriorityList.length;
                        }
                        if (aPriority === bPriority) {
                            return dateResult;
                        }
                        if (aPriority < bPriority) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    });
                }
                function GetSortedPayloadsByPriority(payloads, options) {
                    const itemsKeyPayloads = [];
                    const keySystemRootKeyPayloads = [];
                    const keySystemItemsKeyPayloads = [];
                    const contentTypePriorityPayloads = [];
                    const remainingPayloads = [];
                    for (let index = 0; index < payloads.length; index++) {
                        const payload = payloads[index];
                        if (payload.content_type === src.ContentType.TYPES.KeySystemRootKey) {
                            keySystemRootKeyPayloads.push(payload);
                        }
                        else if (payload.content_type === src.ContentType.TYPES.KeySystemItemsKey) {
                            keySystemItemsKeyPayloads.push(payload);
                        }
                        else if (payload.content_type === src.ContentType.TYPES.ItemsKey) {
                            itemsKeyPayloads.push(payload);
                        }
                        else if (options.contentTypePriority.includes(payload.content_type)) {
                            contentTypePriorityPayloads.push(payload);
                        }
                        else {
                            remainingPayloads.push(payload);
                        }
                    }
                    return {
                        itemsKeyPayloads,
                        keySystemRootKeyPayloads,
                        keySystemItemsKeyPayloads,
                        contentTypePriorityPayloads: SortPayloadsByRecentAndContentPriority(contentTypePriorityPayloads, options.contentTypePriority),
                        remainingPayloads: SortPayloadsByRecentAndUuidPriority(remainingPayloads, options.uuidPriority)
                    };
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Device/DesktopDeviceInterface.ts
                /* istanbul ignore file */
                function isDesktopDevice(x) {
                    return x.environment === models_dist.Environment.Desktop;
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Device/TypeCheck.ts
                /* istanbul ignore file */
                function isMobileDevice(x) {
                    return x.environment === models_dist.Environment.Mobile;
                }
                // EXTERNAL MODULE: ../encryption/src/index.ts + 52 modules
                var encryption_src = __webpack_require__(86999);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var dist_src = __webpack_require__(20875);
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/EncryptionServiceEvent.ts
                var EncryptionServiceEvent;
                (function (EncryptionServiceEvent) {
                    EncryptionServiceEvent["RootKeyStatusChanged"] = "RootKeyStatusChanged";
                })(EncryptionServiceEvent || (EncryptionServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/RootKeyManager/RootKeyManagerEvent.ts
                var RootKeyManagerEvent;
                (function (RootKeyManagerEvent) {
                    RootKeyManagerEvent["RootKeyManagerKeyStatusChanged"] = "RootKeyManagerKeyStatusChanged";
                })(RootKeyManagerEvent || (RootKeyManagerEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/RootKeyManager/KeyMode.ts
                var KeyMode;
                (function (KeyMode) {
                    /** i.e No account and no passcode */
                    KeyMode[KeyMode["RootKeyNone"] = 0] = "RootKeyNone";
                    /** i.e Account but no passcode */
                    KeyMode[KeyMode["RootKeyOnly"] = 1] = "RootKeyOnly";
                    /** i.e Account plus passcode */
                    KeyMode[KeyMode["RootKeyPlusWrapper"] = 2] = "RootKeyPlusWrapper";
                    /** i.e No account, but passcode */
                    KeyMode[KeyMode["WrapperOnly"] = 3] = "WrapperOnly";
                })(KeyMode || (KeyMode = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/EncryptionService.ts
                var EncryptionService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The encryption service is responsible for the encryption and decryption of payloads, and
                 * handles delegation of a task to the respective protocol operator. Each version of the protocol
                 * (001, 002, 003, 004, etc) uses a respective operator version to perform encryption operations.
                 * Operators are located in /protocol/operator.
                 * The protocol service depends on the keyManager for determining which key to use for the
                 * encryption and decryption of a particular payload.
                 * The protocol service is also responsible for dictating which protocol versions are valid,
                 * and which are no longer valid or not supported.
                
                 * The key manager is responsible for managing root key and root key wrapper states.
                 * When the key manager is initialized, it initiates itself with a keyMode, which
                 * dictates the entire flow of key management. The key manager's responsibilities include:
                 * - interacting with the device keychain to save or clear the root key
                 * - interacting with storage to save root key params or wrapper params, or the wrapped root key.
                 * - exposing methods that allow the application to unwrap the root key (unlock the application)
                 *
                 * It also exposes two primary methods for determining what key should be used to encrypt
                 * or decrypt a particular payload. Some payloads are encrypted directly with the rootKey
                 * (such as itemsKeys and encryptedStorage). Others are encrypted with itemsKeys (notes, tags, etc).
                
                 * The items key manager manages the lifecycle of items keys.
                 * It is responsible for creating the default items key when conditions call for it
                 * (such as after the first sync completes and no key exists).
                 * It also exposes public methods that allows consumers to retrieve an items key
                 * for a particular payload, and also retrieve all available items keys.
                */
                class EncryptionService extends AbstractService {
                    constructor(items, mutator, payloads, operators, itemsEncryption, rootKeyManager, crypto, _createNewItemsKeyWithRollback, _findDefaultItemsKey, _rootKeyEncryptPayloadWithKeyLookup, _rootKeyEncryptPayload, _rootKeyDecryptPayload, _rootKeyDecryptPayloadWithKeyLookup, _createDefaultItemsKey, _getKeyPairs, internalEventBus) {
                        super(internalEventBus);
                        this.items = items;
                        this.mutator = mutator;
                        this.payloads = payloads;
                        this.operators = operators;
                        this.itemsEncryption = itemsEncryption;
                        this.rootKeyManager = rootKeyManager;
                        this.crypto = crypto;
                        this._createNewItemsKeyWithRollback = _createNewItemsKeyWithRollback;
                        this._findDefaultItemsKey = _findDefaultItemsKey;
                        this._rootKeyEncryptPayloadWithKeyLookup = _rootKeyEncryptPayloadWithKeyLookup;
                        this._rootKeyEncryptPayload = _rootKeyEncryptPayload;
                        this._rootKeyDecryptPayload = _rootKeyDecryptPayload;
                        this._rootKeyDecryptPayloadWithKeyLookup = _rootKeyDecryptPayloadWithKeyLookup;
                        this._createDefaultItemsKey = _createDefaultItemsKey;
                        this._getKeyPairs = _getKeyPairs;
                        this.internalEventBus = internalEventBus;
                        internalEventBus.addEventHandler(this, RootKeyManagerEvent.RootKeyManagerKeyStatusChanged);
                        utils_dist.UuidGenerator.SetGenerator(this.crypto.generateUUID);
                    }
                    handleEvent(event) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            if (event.type === RootKeyManagerEvent.RootKeyManagerKeyStatusChanged) {
                                this.itemsEncryption.userVersion = this.getUserVersion();
                                void this.notifyEvent(EncryptionServiceEvent.RootKeyStatusChanged);
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.items = undefined;
                        this.payloads = undefined;
                        this.operators = undefined;
                        this.itemsEncryption = undefined;
                        this.rootKeyManager = undefined;
                        this.crypto = undefined;
                        this._createNewItemsKeyWithRollback = undefined;
                        this._findDefaultItemsKey = undefined;
                        this._rootKeyEncryptPayloadWithKeyLookup = undefined;
                        this._rootKeyEncryptPayload = undefined;
                        this._rootKeyDecryptPayload = undefined;
                        this._rootKeyDecryptPayloadWithKeyLookup = undefined;
                        this._createDefaultItemsKey = undefined;
                        super.deinit();
                    }
                    hasSigningKeyPair() {
                        var _a;
                        return !!((_a = this.getRootKey()) === null || _a === void 0 ? void 0 : _a.signingKeyPair);
                    }
                    initialize() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            yield this.rootKeyManager.initialize();
                        });
                    }
                    /**
                     * Returns encryption protocol display name for active account/wrapper
                     */
                    getEncryptionDisplayName() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const version = yield this.rootKeyManager.getEncryptionSourceVersion();
                            if (version) {
                                return this.operators.operatorForVersion(version).getEncryptionDisplayName();
                            }
                            throw Error('Attempting to access encryption display name wtihout source');
                        });
                    }
                    getLatestVersion() {
                        return dist_src.ProtocolVersionLatest;
                    }
                    /** Unlike SessionManager.isSignedIn, hasAccount can be read before the application is unlocked and is based on the key state */
                    hasAccount() {
                        return this.rootKeyManager.hasAccount();
                    }
                    hasRootKeyEncryptionSource() {
                        return this.rootKeyManager.hasRootKeyEncryptionSource();
                    }
                    getUserVersion() {
                        return this.rootKeyManager.getUserVersion();
                    }
                    upgradeAvailable() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const accountUpgradeAvailable = this.accountUpgradeAvailable();
                            const passcodeUpgradeAvailable = yield this.passcodeUpgradeAvailable();
                            return accountUpgradeAvailable || passcodeUpgradeAvailable;
                        });
                    }
                    getSureDefaultItemsKey() {
                        return this.itemsEncryption.getDefaultItemsKey();
                    }
                    repersistAllItems() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.itemsEncryption.repersistAllItems();
                        });
                    }
                    createNewItemsKeyWithRollback() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this._createNewItemsKeyWithRollback.execute();
                        });
                    }
                    itemsKeyForEncryptedPayload(payload) {
                        return this.itemsEncryption.itemsKeyForEncryptedPayload(payload);
                    }
                    defaultItemsKeyForItemVersion(version, fromKeys) {
                        return this.itemsEncryption.defaultItemsKeyForItemVersion(version, fromKeys);
                    }
                    encryptSplitSingle(split) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return (yield this.encryptSplit(split))[0];
                        });
                    }
                    encryptSplit(split) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const allEncryptedParams = [];
                            const { usesRootKey, usesItemsKey, usesKeySystemRootKey, usesRootKeyWithKeyLookup, usesItemsKeyWithKeyLookup, usesKeySystemRootKeyWithKeyLookup } = split;
                            const keys = this._getKeyPairs.execute();
                            const signingKeyPair = keys.isFailed() ? undefined : keys.getValue().signing;
                            if (usesRootKey) {
                                const rootKeyEncrypted = yield this._rootKeyEncryptPayload.executeMany(usesRootKey.items, usesRootKey.key, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, rootKeyEncrypted);
                            }
                            if (usesRootKeyWithKeyLookup) {
                                const rootKeyEncrypted = yield this._rootKeyEncryptPayloadWithKeyLookup.executeMany(usesRootKeyWithKeyLookup.items, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, rootKeyEncrypted);
                            }
                            if (usesKeySystemRootKey) {
                                const keySystemRootKeyEncrypted = yield this._rootKeyEncryptPayload.executeMany(usesKeySystemRootKey.items, usesKeySystemRootKey.key, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, keySystemRootKeyEncrypted);
                            }
                            if (usesKeySystemRootKeyWithKeyLookup) {
                                const keySystemRootKeyEncrypted = yield this._rootKeyEncryptPayloadWithKeyLookup.executeMany(usesKeySystemRootKeyWithKeyLookup.items, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, keySystemRootKeyEncrypted);
                            }
                            if (usesItemsKey) {
                                const itemsKeyEncrypted = yield this.itemsEncryption.encryptPayloads(usesItemsKey.items, usesItemsKey.key, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, itemsKeyEncrypted);
                            }
                            if (usesItemsKeyWithKeyLookup) {
                                const itemsKeyEncrypted = yield this.itemsEncryption.encryptPayloadsWithKeyLookup(usesItemsKeyWithKeyLookup.items, signingKeyPair);
                                (0, utils_dist.extendArray)(allEncryptedParams, itemsKeyEncrypted);
                            }
                            const packagedEncrypted = allEncryptedParams.map(encryptedParams => {
                                const original = (0, encryption_src /* FindPayloadInEncryptionSplit */.G6)(encryptedParams.uuid, split);
                                return new models_dist.EncryptedPayload(Object.assign(Object.assign(Object.assign({}, original), encryptedParams), {
                                    waitingForKey: false,
                                    errorDecrypting: false
                                }));
                            });
                            return packagedEncrypted;
                        });
                    }
                    decryptSplitSingle(split) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const results = yield this.decryptSplit(split);
                            return results[0];
                        });
                    }
                    decryptSplit(split) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const resultParams = [];
                            const { usesRootKey, usesItemsKey, usesKeySystemRootKey, usesRootKeyWithKeyLookup, usesItemsKeyWithKeyLookup, usesKeySystemRootKeyWithKeyLookup } = split;
                            if (usesRootKey) {
                                const rootKeyDecrypted = yield this._rootKeyDecryptPayload.executeMany(usesRootKey.items, usesRootKey.key);
                                (0, utils_dist.extendArray)(resultParams, rootKeyDecrypted);
                            }
                            if (usesRootKeyWithKeyLookup) {
                                const rootKeyDecrypted = yield this._rootKeyDecryptPayloadWithKeyLookup.executeMany(usesRootKeyWithKeyLookup.items);
                                (0, utils_dist.extendArray)(resultParams, rootKeyDecrypted);
                            }
                            if (usesKeySystemRootKey) {
                                const keySystemRootKeyDecrypted = yield this._rootKeyDecryptPayload.executeMany(usesKeySystemRootKey.items, usesKeySystemRootKey.key);
                                (0, utils_dist.extendArray)(resultParams, keySystemRootKeyDecrypted);
                            }
                            if (usesKeySystemRootKeyWithKeyLookup) {
                                const keySystemRootKeyDecrypted = yield this._rootKeyDecryptPayloadWithKeyLookup.executeMany(usesKeySystemRootKeyWithKeyLookup.items);
                                (0, utils_dist.extendArray)(resultParams, keySystemRootKeyDecrypted);
                            }
                            if (usesItemsKey) {
                                const itemsKeyDecrypted = yield this.itemsEncryption.decryptPayloads(usesItemsKey.items, usesItemsKey.key);
                                (0, utils_dist.extendArray)(resultParams, itemsKeyDecrypted);
                            }
                            if (usesItemsKeyWithKeyLookup) {
                                const itemsKeyDecrypted = yield this.itemsEncryption.decryptPayloadsWithKeyLookup(usesItemsKeyWithKeyLookup.items);
                                (0, utils_dist.extendArray)(resultParams, itemsKeyDecrypted);
                            }
                            const packagedResults = resultParams.map(params => {
                                const original = (0, encryption_src /* FindPayloadInDecryptionSplit */.sP)(params.uuid, split);
                                if ((0, encryption_src /* isErrorDecryptingParameters */.XL)(params)) {
                                    return new models_dist.EncryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                                else {
                                    return new models_dist.DecryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                            });
                            return packagedResults;
                        });
                    }
                    decryptPayloadWithKeyLookup(payload) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const decryptedParameters = yield this.itemsEncryption.decryptPayloadWithKeyLookup(payload);
                            if ((0, encryption_src /* isErrorDecryptingParameters */.XL)(decryptedParameters)) {
                                return {
                                    parameters: decryptedParameters,
                                    payload: new models_dist.EncryptedPayload(Object.assign(Object.assign({}, payload.ejected()), decryptedParameters))
                                };
                            }
                            else {
                                return {
                                    parameters: decryptedParameters,
                                    payload: new models_dist.DecryptedPayload(Object.assign(Object.assign({}, payload.ejected()), decryptedParameters))
                                };
                            }
                        });
                    }
                    /**
                     * Returns true if the user's account protocol version is not equal to the latest version.
                     */
                    accountUpgradeAvailable() {
                        const userVersion = this.getUserVersion();
                        if (!userVersion) {
                            return false;
                        }
                        return userVersion !== dist_src.ProtocolVersionLatest;
                    }
                    /**
                     * Returns true if the user's account protocol version is not equal to the latest version.
                     */
                    passcodeUpgradeAvailable() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.passcodeUpgradeAvailable();
                        });
                    }
                    /**
                     * Determines whether the current environment is capable of supporting
                     * key derivation.
                     */
                    platformSupportsKeyDerivation(keyParams) {
                        /**
                         * If the version is 003 or lower, key derivation is supported unless the browser is
                         * IE or Edge (or generally, where WebCrypto is not available) or React Native environment is detected.
                         *
                         * Versions 004 and above are always supported.
                         */
                        if ((0, dist_src.compareVersions)(keyParams.version, dist_src.ProtocolVersion.V004) >= 0) {
                            /* keyParams.version >= 004 */
                            return true;
                        }
                        else {
                            return !!(0, utils_dist.isWebCryptoAvailable)() || (0, utils_dist.isReactNativeEnvironment)();
                        }
                    }
                    supportedVersions() {
                        return [dist_src.ProtocolVersion.V001, dist_src.ProtocolVersion.V002, dist_src.ProtocolVersion.V003, dist_src.ProtocolVersion.V004];
                    }
                    /**
                     * Determines whether the input version is greater than the latest supported library version.
                     */
                    isVersionNewerThanLibraryVersion(version) {
                        const libraryVersion = dist_src.ProtocolVersionLatest;
                        return (0, dist_src.compareVersions)(version, libraryVersion) === 1;
                    }
                    /**
                     * Versions 001 and 002 of the protocol supported dynamic costs, as reported by the server.
                     * This function returns the client-enforced minimum cost, to prevent the server from
                     * overwhelmingly under-reporting the cost.
                     */
                    costMinimumForVersion(version) {
                        if ((0, dist_src.compareVersions)(version, dist_src.ProtocolVersion.V003) >= 0) {
                            throw 'Cost minimums only apply to versions <= 002';
                        }
                        if (version === dist_src.ProtocolVersion.V001) {
                            return encryption_src /* V001Algorithm */.xo.PbkdfMinCost;
                        }
                        else if (version === dist_src.ProtocolVersion.V002) {
                            return encryption_src /* V002Algorithm */.$4.PbkdfMinCost;
                        }
                        else {
                            throw "Invalid version for cost minimum: ".concat(version);
                        }
                    }
                    /**
                     * Computes a root key given a password and key params.
                     * Delegates computation to respective protocol operator.
                     */
                    computeRootKey(password, keyParams) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.computeRootKey(password, keyParams);
                        });
                    }
                    /**
                     * Creates a root key using the latest protocol version
                     */
                    createRootKey(identifier, password, origination, version) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.createRootKey(identifier, password, origination, version);
                        });
                    }
                    createRandomizedKeySystemRootKey(dto) {
                        return this.operators.defaultOperator().createRandomizedKeySystemRootKey(dto);
                    }
                    createUserInputtedKeySystemRootKey(dto) {
                        return this.operators.defaultOperator().createUserInputtedKeySystemRootKey(dto);
                    }
                    deriveUserInputtedKeySystemRootKey(dto) {
                        return this.operators.defaultOperator().deriveUserInputtedKeySystemRootKey(dto);
                    }
                    createKeySystemItemsKey(uuid, keySystemIdentifier, sharedVaultUuid, rootKeyToken) {
                        return this.operators.defaultOperator().createKeySystemItemsKey(uuid, keySystemIdentifier, sharedVaultUuid, rootKeyToken);
                    }
                    asymmetricSignatureVerifyDetached(encryptedString) {
                        const defaultOperator = this.operators.defaultOperator();
                        const version = defaultOperator.versionForAsymmetricallyEncryptedString(encryptedString);
                        const keyOperator = this.operators.operatorForVersion(version);
                        return keyOperator.asymmetricSignatureVerifyDetached(encryptedString);
                    }
                    getSenderPublicKeySetFromAsymmetricallyEncryptedString(string) {
                        const defaultOperator = this.operators.defaultOperator();
                        const version = defaultOperator.versionForAsymmetricallyEncryptedString(string);
                        const keyOperator = this.operators.operatorForVersion(version);
                        return keyOperator.getSenderPublicKeySetFromAsymmetricallyEncryptedString(string);
                    }
                    /**
                     * Creates a key params object from a raw object
                     * @param keyParams - The raw key params object to create a KeyParams object from
                     */
                    createKeyParams(keyParams) {
                        return (0, encryption_src /* CreateAnyKeyParams */.jl)(keyParams);
                    }
                    hasPasscode() {
                        return this.rootKeyManager.hasPasscode();
                    }
                    /**
                     * @returns True if the root key has not yet been unwrapped (passcode locked).
                     */
                    isPasscodeLocked() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return (yield this.rootKeyManager.hasRootKeyWrapper()) && this.rootKeyManager.getRootKey() == undefined;
                        });
                    }
                    getRootKeyParams() {
                        return this.rootKeyManager.getRootKeyParams();
                    }
                    getAccountKeyParams() {
                        return this.rootKeyManager.getMemoizedRootKeyParams();
                    }
                    /**
                     * Computes the root key wrapping key given a passcode.
                     * Wrapping key params are read from disk.
                     */
                    computeWrappingKey(passcode) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            const keyParams = this.rootKeyManager.getSureRootKeyWrapperKeyParams();
                            const key = yield this.computeRootKey(passcode, keyParams);
                            return key;
                        });
                    }
                    /**
                     * Unwraps the persisted root key value using the supplied wrappingKey.
                     * Application interfaces must check to see if the root key requires unwrapping on load.
                     * If so, they must generate the unwrapping key by getting our saved wrapping key keyParams.
                     * After unwrapping, the root key is automatically loaded.
                     */
                    unwrapRootKey(wrappingKey) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.unwrapRootKey(wrappingKey);
                        });
                    }
                    /**
                     * Encrypts rootKey and saves it in storage instead of keychain, and then
                     * clears keychain. This is because we don't want to store large encrypted
                     * payloads in the keychain. If the root key is not wrapped, it is stored
                     * in plain form in the user's secure keychain.
                     */
                    setNewRootKeyWrapper(wrappingKey) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.setNewRootKeyWrapper(wrappingKey);
                        });
                    }
                    removePasscode() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            yield this.rootKeyManager.removeRootKeyWrapper();
                        });
                    }
                    setRootKey(key, wrappingKey) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            yield this.rootKeyManager.setRootKey(key, wrappingKey);
                        });
                    }
                    /**
                     * Returns the in-memory root key value.
                     */
                    getRootKey() {
                        return this.rootKeyManager.getRootKey();
                    }
                    getSureRootKey() {
                        return this.rootKeyManager.getRootKey();
                    }
                    /**
                     * Deletes root key and wrapper from keychain. Used when signing out of application.
                     */
                    deleteWorkspaceSpecificKeyStateFromDevice() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            yield this.rootKeyManager.deleteWorkspaceSpecificKeyStateFromDevice();
                        });
                    }
                    validateAccountPassword(password) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.validateAccountPassword(password);
                        });
                    }
                    validatePasscode(passcode) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this.rootKeyManager.validatePasscode(passcode);
                        });
                    }
                    getEmbeddedPayloadAuthenticatedData(payload) {
                        const version = payload.version;
                        if (!version) {
                            return undefined;
                        }
                        const operator = this.operators.operatorForVersion(version);
                        const authenticatedData = operator.getPayloadAuthenticatedDataForExternalUse((0, encryption_src /* encryptedInputParametersFromPayload */.xi)(payload));
                        return authenticatedData;
                    }
                    /** Returns the key params attached to this key's encrypted payload */
                    getKeyEmbeddedKeyParamsFromItemsKey(key) {
                        const authenticatedData = this.getEmbeddedPayloadAuthenticatedData(key);
                        if (!authenticatedData) {
                            return undefined;
                        }
                        if ((0, dist_src.isVersionLessThanOrEqualTo)(key.version, dist_src.ProtocolVersion.V003)) {
                            const rawKeyParams = authenticatedData;
                            return this.createKeyParams(rawKeyParams);
                        }
                        else {
                            const rawKeyParams = authenticatedData.kp;
                            return this.createKeyParams(rawKeyParams);
                        }
                    }
                    /**
                     * A new rootkey-based items key is needed if a user changes their account password
                     * on an 003 client and syncs on a signed in 004 client.
                     */
                    needsNewRootKeyBasedItemsKey() {
                        if (!this.hasAccount()) {
                            return false;
                        }
                        const rootKey = this.rootKeyManager.getRootKey();
                        if (!rootKey) {
                            return false;
                        }
                        if ((0, dist_src.compareVersions)(rootKey.keyVersion, dist_src.ProtocolVersionLastNonrootItemsKey) > 0) {
                            /** Is >= 004, not needed */
                            return false;
                        }
                        /**
                         * A new root key based items key is needed if our default items key content
                         * isnt equal to our current root key
                         */
                        const defaultItemsKey = this._findDefaultItemsKey.execute(this.itemsEncryption.getItemsKeys()).getValue();
                        /** Shouldn't be undefined, but if it is, we'll take the corrective action */
                        if (!defaultItemsKey) {
                            return true;
                        }
                        return defaultItemsKey.itemsKey !== rootKey.itemsKey;
                    }
                    createNewDefaultItemsKey() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            return this._createDefaultItemsKey.execute();
                        });
                    }
                    getPasswordCreatedDate() {
                        const rootKey = this.getRootKey();
                        return rootKey ? rootKey.keyParams.createdDate : undefined;
                    }
                    onSyncEvent(eventName) {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            if (eventName === SyncEvent.SyncCompletedWithAllItemsUploaded) {
                                yield this.handleFullSyncCompletion();
                            }
                            if (eventName === SyncEvent.DownloadFirstSyncCompleted) {
                                yield this.handleDownloadFirstSyncCompletion();
                            }
                        });
                    }
                    /**
                     * When a download-first sync completes, it means we've completed a (potentially multipage)
                     * sync where we only downloaded what the server had before uploading anything. We will be
                     * allowed to make local accomadations here before the server begins with the upload
                     * part of the sync (automatically runs after download-first sync completes).
                     * We use this to see if the server has any default itemsKeys, and if so, allows us to
                     * delete any never-synced items keys we have here locally.
                     */
                    handleDownloadFirstSyncCompletion() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            if (!this.hasAccount()) {
                                return;
                            }
                            const itemsKeys = this.itemsEncryption.getItemsKeys();
                            const neverSyncedKeys = itemsKeys.filter(key => {
                                return key.neverSynced;
                            });
                            const syncedKeys = itemsKeys.filter(key => {
                                return !key.neverSynced;
                            });
                            /**
                             * Find isDefault items key that have been previously synced.
                             * If we find one, this means we can delete any non-synced keys.
                             */
                            const defaultSyncedKey = syncedKeys.find(key => {
                                return key.isDefault;
                            });
                            const hasSyncedItemsKey = !(0, utils_dist.isNullOrUndefined)(defaultSyncedKey);
                            if (hasSyncedItemsKey) {
                                /** Delete all never synced keys */
                                yield this.mutator.setItemsToBeDeleted(neverSyncedKeys);
                            }
                            else {
                                /**
                                 * No previous synced items key.
                                 * We can keep the one(s) we have, only if their version is equal to our root key
                                 * version. If their version is not equal to our root key version, delete them. If
                                 * we end up with 0 items keys, create a new one. This covers the case when you open
                                 * the app offline and it creates an 004 key, and then you sign into an 003 account.
                                 */
                                const rootKeyParams = this.getRootKeyParams();
                                if (rootKeyParams) {
                                    /** If neverSynced.version != rootKey.version, delete. */
                                    const toDelete = neverSyncedKeys.filter(itemsKey => {
                                        return itemsKey.keyVersion !== rootKeyParams.version;
                                    });
                                    if (toDelete.length > 0) {
                                        yield this.mutator.setItemsToBeDeleted(toDelete);
                                    }
                                    if (this.itemsEncryption.getItemsKeys().length === 0) {
                                        yield this.createNewDefaultItemsKey();
                                    }
                                }
                            }
                            /** If we do not have an items key for our current account version, create one */
                            const userVersion = this.getUserVersion();
                            const accountVersionedKey = this.itemsEncryption.getItemsKeys().find(key => key.keyVersion === userVersion);
                            if ((0, utils_dist.isNullOrUndefined)(accountVersionedKey)) {
                                yield this.createNewDefaultItemsKey();
                            }
                            this.syncUnsyncedItemsKeys();
                        });
                    }
                    handleFullSyncCompletion() {
                        return EncryptionService_awaiter(this, void 0, void 0, function* () {
                            /** Always create a new items key after full sync, if no items key is found */
                            const currentItemsKey = this._findDefaultItemsKey.execute(this.itemsEncryption.getItemsKeys()).getValue();
                            if (!currentItemsKey) {
                                yield this.createNewDefaultItemsKey();
                                if (this.rootKeyManager.getKeyMode() === KeyMode.WrapperOnly) {
                                    return this.itemsEncryption.repersistAllItems();
                                }
                            }
                        });
                    }
                    /**
                     * There is presently an issue where an items key created while signed out of account (
                     * or possibly signed in but with invalid session), then signing into account, results in that
                     * items key never syncing to the account even though it is being used to encrypt synced items.
                     * Until we can determine its cause, this corrective function will find any such keys and sync them.
                     */
                    syncUnsyncedItemsKeys() {
                        if (!this.hasAccount()) {
                            return;
                        }
                        const unsyncedKeys = this.itemsEncryption.getItemsKeys().filter(key => key.neverSynced && !key.dirty);
                        if (unsyncedKeys.length > 0) {
                            void this.mutator.setItemsDirty(unsyncedKeys);
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/Functions.ts
                var Functions_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function DecryptItemsKeyWithUserFallback(itemsKey, encryptor, challengor) {
                    return Functions_awaiter(this, void 0, void 0, function* () {
                        const decryptionResult = yield encryptor.decryptSplitSingle({
                            usesRootKeyWithKeyLookup: {
                                items: [itemsKey]
                            }
                        });
                        if ((0, models_dist.isDecryptedPayload)(decryptionResult)) {
                            return decryptionResult;
                        }
                        const secondDecryptionResult = yield DecryptItemsKeyByPromptingUser(itemsKey, encryptor, challengor);
                        if (secondDecryptionResult === 'aborted' || secondDecryptionResult === 'failed') {
                            return secondDecryptionResult;
                        }
                        return secondDecryptionResult.decryptedKey;
                    });
                }
                function DecryptItemsKeyByPromptingUser(itemsKey, encryptor, challengor, keyParams) {
                    return Functions_awaiter(this, void 0, void 0, function* () {
                        if (!keyParams) {
                            keyParams = encryptor.getKeyEmbeddedKeyParamsFromItemsKey(itemsKey);
                        }
                        if (!keyParams) {
                            return 'failed';
                        }
                        const challenge = challengor.createChallenge([new ChallengePrompt(ChallengeValidation.None, undefined, undefined, true)], ChallengeReason.Custom, true, encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryLoginFlowPrompt(keyParams), encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryPasswordRequired);
                        const response = yield challengor.promptForChallengeResponse(challenge);
                        if (!response) {
                            return 'aborted';
                        }
                        const password = response.values[0].value;
                        const rootKey = yield encryptor.computeRootKey(password, keyParams);
                        const secondDecryptionResult = yield encryptor.decryptSplitSingle({
                            usesRootKey: {
                                items: [itemsKey],
                                key: rootKey
                            }
                        });
                        challengor.completeChallenge(challenge);
                        if ((0, models_dist.isDecryptedPayload)(secondDecryptionResult)) {
                            return {
                                decryptedKey: secondDecryptionResult,
                                rootKey
                            };
                        }
                        return 'failed';
                    });
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/Asymmetric/DecryptMessage.ts
                class DecryptMessage {
                    constructor(operators) {
                        this.operators = operators;
                    }
                    execute(dto) {
                        const defaultOperator = this.operators.defaultOperator();
                        const version = defaultOperator.versionForAsymmetricallyEncryptedString(dto.message);
                        const keyOperator = this.operators.operatorForVersion(version);
                        const decryptedResult = keyOperator.asymmetricDecrypt({
                            stringToDecrypt: dto.message,
                            recipientSecretKey: dto.privateKey
                        });
                        if (!decryptedResult) {
                            return src.Result.fail('Failed to decrypt message');
                        }
                        if (!decryptedResult.signatureVerified) {
                            return src.Result.fail('Failed to verify signature');
                        }
                        if (dto.sender) {
                            const publicKeyTrustStatus = dto.sender.getTrustStatusForPublicKey(decryptedResult.senderPublicKey);
                            if (publicKeyTrustStatus !== models_dist.PublicKeyTrustStatus.Trusted) {
                                return src.Result.fail('Sender public key is not trusted');
                            }
                            const signingKeyTrustStatus = dto.sender.getTrustStatusForSigningPublicKey(decryptedResult.signaturePublicKey);
                            if (signingKeyTrustStatus !== models_dist.PublicKeyTrustStatus.Trusted) {
                                return src.Result.fail('Signature public key is not trusted');
                            }
                        }
                        return src.Result.ok(JSON.parse(decryptedResult.plaintext));
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/Asymmetric/DecryptOwnMessage.ts
                class DecryptOwnMessage {
                    constructor(operators) {
                        this.operators = operators;
                    }
                    execute(dto) {
                        const defaultOperator = this.operators.defaultOperator();
                        const version = defaultOperator.versionForAsymmetricallyEncryptedString(dto.message);
                        const keyOperator = this.operators.operatorForVersion(version);
                        const result = keyOperator.asymmetricDecryptOwnMessage({
                            message: dto.message,
                            ownPrivateKey: dto.privateKey,
                            recipientPublicKey: dto.recipientPublicKey
                        });
                        if (result.isFailed()) {
                            return src.Result.fail(result.getError());
                        }
                        const decryptedObject = result.getValue();
                        if (!decryptedObject.signatureVerified) {
                            return src.Result.fail('Failed to verify signature');
                        }
                        return src.Result.ok(JSON.parse(decryptedObject.plaintext));
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/Asymmetric/EncryptMessage.ts
                class EncryptMessage {
                    constructor(operators) {
                        this.operators = operators;
                    }
                    execute(dto) {
                        const operator = this.operators.defaultOperator();
                        const encrypted = operator.asymmetricEncrypt({
                            stringToEncrypt: JSON.stringify(dto.message),
                            senderKeyPair: dto.keys.encryption,
                            senderSigningKeyPair: dto.keys.signing,
                            recipientPublicKey: dto.recipientPublicKey
                        });
                        return src.Result.ok(encrypted);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/Asymmetric/GetMessageAdditionalData.ts
                class GetMessageAdditionalData {
                    constructor(operators) {
                        this.operators = operators;
                    }
                    execute(dto) {
                        const operator = this.operators.defaultOperator();
                        return operator.asymmetricStringGetAdditionalData({
                            encryptedString: dto.message
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/DecryptErroredPayloads.ts
                var DecryptErroredPayloads_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptErroredPayloads {
                    constructor(itemsEncryption, _decryptErroredRootPayloads) {
                        this.itemsEncryption = itemsEncryption;
                        this._decryptErroredRootPayloads = _decryptErroredRootPayloads;
                    }
                    execute() {
                        return DecryptErroredPayloads_awaiter(this, void 0, void 0, function* () {
                            yield this._decryptErroredRootPayloads.execute();
                            yield this.itemsEncryption.decryptErroredItemPayloads();
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/GetKeyPairs.ts
                class GetKeyPairs {
                    constructor(rootKeyManager) {
                        this.rootKeyManager = rootKeyManager;
                    }
                    execute() {
                        const rootKey = this.rootKeyManager.getRootKey();
                        if (!(rootKey === null || rootKey === void 0 ? void 0 : rootKey.encryptionKeyPair) || !(rootKey === null || rootKey === void 0 ? void 0 : rootKey.signingKeyPair)) {
                            return src.Result.fail('Account keypair not found');
                        }
                        return src.Result.ok({
                            encryption: rootKey.encryptionKeyPair,
                            signing: rootKey.signingKeyPair
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/ItemsKey/CreateNewDefaultItemsKey.ts
                var CreateNewDefaultItemsKey_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * Creates a new random items key to use for item encryption, and adds it to model management.
                 * Consumer must call sync. If the protocol version <= 003, only one items key should be created,
                 * and its .itemsKey value should be equal to the root key masterKey value.
                 */
                class CreateNewDefaultItemsKey {
                    constructor(mutator, items, operators, rootKeyManager) {
                        this.mutator = mutator;
                        this.items = items;
                        this.operators = operators;
                        this.rootKeyManager = rootKeyManager;
                    }
                    execute() {
                        return CreateNewDefaultItemsKey_awaiter(this, void 0, void 0, function* () {
                            const rootKey = this.rootKeyManager.getSureRootKey();
                            const operatorVersion = rootKey ? rootKey.keyVersion : dist_src.ProtocolVersionLatest;
                            let itemTemplate;
                            if ((0, dist_src.compareVersions)(operatorVersion, dist_src.ProtocolVersionLastNonrootItemsKey) <= 0) {
                                /** Create root key based items key */
                                const payload = new models_dist.DecryptedPayload(Object.assign({
                                    uuid: utils_dist.UuidGenerator.GenerateUuid(),
                                    content_type: src.ContentType.TYPES.ItemsKey,
                                    content: (0, models_dist.FillItemContentSpecialized)({
                                        itemsKey: rootKey.masterKey,
                                        dataAuthenticationKey: rootKey.dataAuthenticationKey,
                                        version: operatorVersion
                                    })
                                }, (0, models_dist.PayloadTimestampDefaults)()));
                                itemTemplate = (0, models_dist.CreateDecryptedItemFromPayload)(payload);
                            }
                            else {
                                /** Create independent items key */
                                itemTemplate = this.operators.operatorForVersion(operatorVersion).createItemsKey();
                            }
                            const itemsKeys = this.items.getDisplayableItemsKeys();
                            const defaultKeys = itemsKeys.filter(key => {
                                return key.isDefault;
                            });
                            for (const key of defaultKeys) {
                                yield this.mutator.changeItemsKey(key, mutator => {
                                    mutator.isDefault = false;
                                });
                            }
                            const itemsKey = yield this.mutator.insertItem(itemTemplate);
                            yield this.mutator.changeItemsKey(itemsKey, mutator => {
                                mutator.isDefault = true;
                            });
                            return itemsKey;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/ItemsKey/CreateNewItemsKeyWithRollback.ts
                var CreateNewItemsKeyWithRollback_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateNewItemsKeyWithRollback {
                    constructor(mutator, items, _createDefaultItemsKey, _discardItemsLocally, _findDefaultItemsKey) {
                        this.mutator = mutator;
                        this.items = items;
                        this._createDefaultItemsKey = _createDefaultItemsKey;
                        this._discardItemsLocally = _discardItemsLocally;
                        this._findDefaultItemsKey = _findDefaultItemsKey;
                    }
                    execute() {
                        return CreateNewItemsKeyWithRollback_awaiter(this, void 0, void 0, function* () {
                            const currentDefaultItemsKey = this._findDefaultItemsKey.execute(this.items.getDisplayableItemsKeys()).getValue();
                            const newDefaultItemsKey = yield this._createDefaultItemsKey.execute();
                            const rollback = () => CreateNewItemsKeyWithRollback_awaiter(this, void 0, void 0, function* () {
                                yield this._discardItemsLocally.execute([newDefaultItemsKey]);
                                if (currentDefaultItemsKey) {
                                    yield this.mutator.changeItem(currentDefaultItemsKey, mutator => {
                                        mutator.isDefault = true;
                                    });
                                }
                            });
                            return rollback;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/ItemsKey/FindDefaultItemsKey.ts
                class FindDefaultItemsKey {
                    execute(itemsKeys) {
                        if (itemsKeys.length === 1) {
                            return src.Result.ok(itemsKeys[0]);
                        }
                        const defaultKeys = itemsKeys.filter(key => {
                            return key.isDefault;
                        });
                        if (defaultKeys.length === 0) {
                            return src.Result.ok(undefined);
                        }
                        if (defaultKeys.length === 1) {
                            return src.Result.ok(defaultKeys[0]);
                        }
                        /**
                         * Prioritize one that is synced, as neverSynced keys will likely be deleted after
                         * DownloadFirst sync.
                         */
                        const syncedKeys = defaultKeys.filter(key => !key.neverSynced);
                        if (syncedKeys.length > 0) {
                            return src.Result.ok(syncedKeys[0]);
                        }
                        return src.Result.ok(undefined);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/DecryptErroredPayloads.ts
                var TypeA_DecryptErroredPayloads_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptErroredTypeAPayloads {
                    constructor(payloads, _decryptTypeAPayloadWithKeyLookup) {
                        this.payloads = payloads;
                        this._decryptTypeAPayloadWithKeyLookup = _decryptTypeAPayloadWithKeyLookup;
                    }
                    execute() {
                        return TypeA_DecryptErroredPayloads_awaiter(this, void 0, void 0, function* () {
                            const erroredRootPayloads = this.payloads.invalidPayloads.filter(i => (0, models_dist.ContentTypeUsesRootKeyEncryption)(i.content_type) || (0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(i.content_type));
                            if (erroredRootPayloads.length === 0) {
                                return;
                            }
                            const resultParams = yield this._decryptTypeAPayloadWithKeyLookup.executeMany(erroredRootPayloads);
                            const decryptedPayloads = resultParams.map(params => {
                                const original = (0, models_dist.SureFindPayload)(erroredRootPayloads, params.uuid);
                                if ((0, encryption_src /* isErrorDecryptingParameters */.XL)(params)) {
                                    return new models_dist.EncryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                                else {
                                    return new models_dist.DecryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                            });
                            yield this.payloads.emitPayloads(decryptedPayloads, models_dist.PayloadEmitSource.LocalChanged);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/DecryptPayload.ts
                var DecryptPayload_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptTypeAPayload {
                    constructor(operatorManager) {
                        this.operatorManager = operatorManager;
                    }
                    executeOne(payload, key) {
                        return DecryptPayload_awaiter(this, void 0, void 0, function* () {
                            return (0, encryption_src /* decryptPayload */.oO)(payload, key, this.operatorManager);
                        });
                    }
                    executeMany(payloads, key) {
                        return DecryptPayload_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.executeOne(payload, key)));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/DecryptPayloadWithKeyLookup.ts
                var DecryptPayloadWithKeyLookup_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptTypeAPayloadWithKeyLookup {
                    constructor(operators, keySystemKeyManager, rootKeyManager, logger) {
                        this.operators = operators;
                        this.keySystemKeyManager = keySystemKeyManager;
                        this.rootKeyManager = rootKeyManager;
                        this.logger = logger;
                    }
                    executeOne(payload) {
                        return DecryptPayloadWithKeyLookup_awaiter(this, void 0, void 0, function* () {
                            let key;
                            if ((0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(payload.content_type)) {
                                if (!payload.key_system_identifier) {
                                    this.logger.error('Payload is missing key system identifier', payload);
                                    return {
                                        uuid: payload.uuid,
                                        errorDecrypting: true
                                    };
                                }
                                key = this.keySystemKeyManager.getPrimaryKeySystemRootKey(payload.key_system_identifier);
                            }
                            else {
                                key = this.rootKeyManager.getRootKey();
                            }
                            if (key == undefined) {
                                return {
                                    uuid: payload.uuid,
                                    errorDecrypting: true,
                                    waitingForKey: true
                                };
                            }
                            const usecase = new DecryptTypeAPayload(this.operators);
                            return usecase.executeOne(payload, key);
                        });
                    }
                    executeMany(payloads) {
                        return DecryptPayloadWithKeyLookup_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.executeOne(payload)));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/EncryptPayload.ts
                var EncryptPayload_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class EncryptTypeAPayload {
                    constructor(operators) {
                        this.operators = operators;
                    }
                    executeOne(payload, key, signingKeyPair) {
                        return EncryptPayload_awaiter(this, void 0, void 0, function* () {
                            return (0, encryption_src /* encryptPayload */.Gl)(payload, key, this.operators, signingKeyPair);
                        });
                    }
                    executeMany(payloads, key, signingKeyPair) {
                        return EncryptPayload_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.executeOne(payload, key, signingKeyPair)));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/EncryptPayloadWithKeyLookup.ts
                var EncryptPayloadWithKeyLookup_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class EncryptTypeAPayloadWithKeyLookup {
                    constructor(operators, keySystemKeyManager, rootKeyManager) {
                        this.operators = operators;
                        this.keySystemKeyManager = keySystemKeyManager;
                        this.rootKeyManager = rootKeyManager;
                    }
                    executeOne(payload, signingKeyPair) {
                        return EncryptPayloadWithKeyLookup_awaiter(this, void 0, void 0, function* () {
                            let key;
                            if ((0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(payload.content_type)) {
                                if (!payload.key_system_identifier) {
                                    throw Error("Key system-encrypted payload ".concat(payload.content_type, "is missing a key_system_identifier"));
                                }
                                key = this.keySystemKeyManager.getPrimaryKeySystemRootKey(payload.key_system_identifier);
                            }
                            else {
                                key = this.rootKeyManager.getRootKey();
                            }
                            if (key == undefined) {
                                throw Error('Attempting root key encryption with no root key');
                            }
                            const usecase = new EncryptTypeAPayload(this.operators);
                            return usecase.executeOne(payload, key, signingKeyPair);
                        });
                    }
                    executeMany(payloads, signingKeyPair) {
                        return EncryptPayloadWithKeyLookup_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.executeOne(payload, signingKeyPair)));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Encryption/UseCase/TypeA/ReencryptTypeAItems.ts
                var ReencryptTypeAItems_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * When the user root key changes, we must re-encrypt all relevant items with this new root key (by simply re-syncing).
                 */
                class ReencryptTypeAItems {
                    constructor(items, mutator) {
                        this.items = items;
                        this.mutator = mutator;
                    }
                    execute() {
                        return ReencryptTypeAItems_awaiter(this, void 0, void 0, function* () {
                            const items = this.items.getItems((0, models_dist.ContentTypesUsingRootKeyEncryption)());
                            if (items.length > 0) {
                                /**
                                 * Do not call sync after marking dirty.
                                 * Re-encrypting items keys is called by consumers who have specific flows who
                                 * will sync on their own timing
                                 */
                                yield this.mutator.setItemsDirty(items);
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Event/WebAppEvent.ts
                var WebAppEvent;
                (function (WebAppEvent) {
                    WebAppEvent["NewUpdateAvailable"] = "NewUpdateAvailable";
                    WebAppEvent["EditorDidFocus"] = "EditorDidFocus";
                    WebAppEvent["BeganBackupDownload"] = "BeganBackupDownload";
                    WebAppEvent["EndedBackupDownload"] = "EndedBackupDownload";
                    WebAppEvent["PanelResized"] = "PanelResized";
                    WebAppEvent["WindowDidFocus"] = "WindowDidFocus";
                    WebAppEvent["WindowDidBlur"] = "WindowDidBlur";
                    WebAppEvent["MobileKeyboardDidChangeFrame"] = "MobileKeyboardDidChangeFrame";
                    WebAppEvent["MobileKeyboardWillChangeFrame"] = "MobileKeyboardWillChangeFrame";
                })(WebAppEvent || (WebAppEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Feature/FeaturesEvent.ts
                var FeaturesEvent;
                (function (FeaturesEvent) {
                    FeaturesEvent["UserRolesChanged"] = "UserRolesChanged";
                    FeaturesEvent["FeaturesAvailabilityChanged"] = "Features:FeaturesAvailabilityChanged";
                    FeaturesEvent["DidPurchaseSubscription"] = "DidPurchaseSubscription";
                })(FeaturesEvent || (FeaturesEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Feature/FeatureStatus.ts
                var FeatureStatus;
                (function (FeatureStatus) {
                    FeatureStatus["NoUserSubscription"] = "NoUserSubscription";
                    FeatureStatus["NotInCurrentPlan"] = "NotInCurrentPlan";
                    FeatureStatus["InCurrentPlanButExpired"] = "InCurrentPlanButExpired";
                    FeatureStatus["Entitled"] = "Entitled";
                })(FeatureStatus || (FeatureStatus = {}));
                // EXTERNAL MODULE: ../files/src/index.ts + 15 modules
                var files_src = __webpack_require__(86311);
                // EXTERNAL MODULE: ../api/dist/index.js
                var api_dist = __webpack_require__(70781);
                ; // CONCATENATED MODULE: ../services/src/Domain/Files/FileService.ts
                var FileService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const OneHundredMb = 100 * 1000000;
                class FileService extends AbstractService {
                    constructor(api, mutator, sync, encryptor, challengor, http, alertService, crypto, internalEventBus, logger, backupsService) {
                        super(internalEventBus);
                        this.api = api;
                        this.mutator = mutator;
                        this.sync = sync;
                        this.encryptor = encryptor;
                        this.challengor = challengor;
                        this.alertService = alertService;
                        this.crypto = crypto;
                        this.internalEventBus = internalEventBus;
                        this.logger = logger;
                        this.backupsService = backupsService;
                        this.encryptedCache = new files_src /* FileMemoryCache */.F9(OneHundredMb);
                        this.sharedVault = new api_dist.SharedVaultServer(http);
                    }
                    deinit() {
                        super.deinit();
                        this.encryptedCache.clear();
                        this.encryptedCache = undefined;
                        this.api = undefined;
                        this.encryptor = undefined;
                        this.sync = undefined;
                        this.alertService = undefined;
                        this.challengor = undefined;
                        this.crypto = undefined;
                    }
                    minimumChunkSize() {
                        return 5000000;
                    }
                    createUserValetToken(remoteIdentifier, operation, unencryptedFileSizeForUpload) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            return this.api.createUserFileValetToken(remoteIdentifier, operation, unencryptedFileSizeForUpload);
                        });
                    }
                    createSharedVaultValetToken(params) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            if (params.operation !== dist.ValetTokenOperation.Write && !params.fileUuidRequiredForExistingFiles) {
                                throw new Error('File UUID is required for for non-write operations');
                            }
                            const valetTokenResponse = yield this.sharedVault.createSharedVaultFileValetToken({
                                sharedVaultUuid: params.sharedVaultUuid,
                                sharedVaultOwnerUuid: params.sharedVaultOwnerUuid,
                                fileUuid: params.fileUuidRequiredForExistingFiles,
                                remoteIdentifier: params.remoteIdentifier,
                                operation: params.operation,
                                unencryptedFileSize: params.unencryptedFileSizeForUpload,
                                moveOperationType: params.moveOperationType,
                                sharedVaultToSharedVaultMoveTargetUuid: params.sharedVaultToSharedVaultMoveTargetUuid
                            });
                            if ((0, dist.isErrorResponse)(valetTokenResponse)) {
                                return new dist.ClientDisplayableError('Could not create valet token');
                            }
                            return valetTokenResponse.data.valetToken;
                        });
                    }
                    moveFileToSharedVault(file, sharedVault) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const valetTokenResult = yield this.createSharedVaultValetToken({
                                sharedVaultUuid: file.shared_vault_uuid ? file.shared_vault_uuid : sharedVault.sharing.sharedVaultUuid,
                                sharedVaultOwnerUuid: sharedVault.sharing.ownerUserUuid,
                                remoteIdentifier: file.remoteIdentifier,
                                operation: dist.ValetTokenOperation.Move,
                                fileUuidRequiredForExistingFiles: file.uuid,
                                moveOperationType: file.shared_vault_uuid ? 'shared-vault-to-shared-vault' : 'user-to-shared-vault',
                                sharedVaultToSharedVaultMoveTargetUuid: file.shared_vault_uuid ? sharedVault.sharing.sharedVaultUuid : undefined
                            });
                            if ((0, dist.isClientDisplayableError)(valetTokenResult)) {
                                return valetTokenResult;
                            }
                            const moveResult = yield this.api.moveFile(valetTokenResult);
                            if (!moveResult) {
                                return new dist.ClientDisplayableError('Could not move file');
                            }
                        });
                    }
                    moveFileOutOfSharedVault(file) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            if (!file.shared_vault_uuid) {
                                return new dist.ClientDisplayableError('File is not in a shared vault');
                            }
                            const valetTokenResult = yield this.createSharedVaultValetToken({
                                sharedVaultUuid: file.shared_vault_uuid,
                                remoteIdentifier: file.remoteIdentifier,
                                operation: dist.ValetTokenOperation.Move,
                                fileUuidRequiredForExistingFiles: file.uuid,
                                moveOperationType: 'shared-vault-to-user'
                            });
                            if ((0, dist.isClientDisplayableError)(valetTokenResult)) {
                                return valetTokenResult;
                            }
                            const moveResult = yield this.api.moveFile(valetTokenResult);
                            if (!moveResult) {
                                return new dist.ClientDisplayableError('Could not move file');
                            }
                        });
                    }
                    beginNewFileUpload(sizeInBytes, vault) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const remoteIdentifier = utils_dist.UuidGenerator.GenerateUuid();
                            const valetTokenResult = vault && vault.isSharedVaultListing() ? yield this.createSharedVaultValetToken({
                                sharedVaultUuid: vault.sharing.sharedVaultUuid,
                                sharedVaultOwnerUuid: vault.sharing.ownerUserUuid,
                                remoteIdentifier,
                                operation: dist.ValetTokenOperation.Write,
                                unencryptedFileSizeForUpload: sizeInBytes
                            }) : yield this.createUserValetToken(remoteIdentifier, dist.ValetTokenOperation.Write, sizeInBytes);
                            if (valetTokenResult instanceof dist.ClientDisplayableError) {
                                return valetTokenResult;
                            }
                            const key = this.crypto.generateRandomKey(models_dist.FileProtocolV1Constants.KeySize);
                            const fileParams = {
                                key,
                                remoteIdentifier,
                                decryptedSize: sizeInBytes
                            };
                            const uploadOperation = new files_src /* EncryptAndUploadFileOperation */.y4(fileParams, valetTokenResult, this.crypto, this.api, vault);
                            const uploadSessionStarted = yield this.api.startUploadSession(valetTokenResult, vault && vault.isSharedVaultListing() ? 'shared-vault' : 'user');
                            if ((0, dist.isErrorResponse)(uploadSessionStarted) || !uploadSessionStarted.data.uploadId) {
                                return new dist.ClientDisplayableError('Could not start upload session');
                            }
                            return uploadOperation;
                        });
                    }
                    pushBytesForUpload(operation, bytes, chunkId, isFinalChunk) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const success = yield operation.pushBytes(bytes, chunkId, isFinalChunk);
                            if (!success) {
                                return new dist.ClientDisplayableError('Failed to push file bytes to server');
                            }
                            return undefined;
                        });
                    }
                    finishUpload(operation, fileMetadata, uuid) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const uploadSessionClosed = yield this.api.closeUploadSession(operation.getValetToken(), operation.vault && operation.vault.isSharedVaultListing() ? 'shared-vault' : 'user');
                            if (!uploadSessionClosed) {
                                return new dist.ClientDisplayableError('Could not close upload session');
                            }
                            const result = operation.getResult();
                            const fileContent = {
                                decryptedSize: result.finalDecryptedSize,
                                encryptedChunkSizes: operation.encryptedChunkSizes,
                                encryptionHeader: result.encryptionHeader,
                                key: result.key,
                                mimeType: fileMetadata.mimeType,
                                name: fileMetadata.name,
                                remoteIdentifier: result.remoteIdentifier
                            };
                            const filePayload = new models_dist.DecryptedPayload(Object.assign(Object.assign({
                                uuid,
                                content_type: src.ContentType.TYPES.File,
                                content: (0, models_dist.FillItemContent)((0, models_dist.FillItemContentSpecialized)(fileContent)),
                                dirty: true
                            }, (0, models_dist.PayloadVaultOverrides)(operation.vault)), (0, models_dist.PayloadTimestampDefaults)()));
                            const fileItem = (0, models_dist.CreateItemFromPayload)(filePayload);
                            const insertedItem = yield this.mutator.insertItem(fileItem);
                            yield this.sync.sync();
                            return insertedItem;
                        });
                    }
                    decryptCachedEntry(file, entry) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const decryptOperation = new files_src /* FileDecryptor */.YT(file, this.crypto);
                            let decryptedAggregate = new Uint8Array();
                            const orderedChunker = new files_src /* OrderedByteChunker */.WE(file.encryptedChunkSizes, 'memcache', chunk => FileService_awaiter(this, void 0, void 0, function* () {
                                const decryptedBytes = decryptOperation.decryptBytes(chunk.data);
                                if (decryptedBytes) {
                                    decryptedAggregate = new Uint8Array([...decryptedAggregate, ...decryptedBytes.decryptedBytes]);
                                }
                            }));
                            yield orderedChunker.addBytes(entry.encryptedBytes);
                            return {
                                decryptedBytes: decryptedAggregate
                            };
                        });
                    }
                    downloadFile(file, onDecryptedBytes) {
                        var _a;
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const cachedBytes = this.encryptedCache.get(file.uuid);
                            if (cachedBytes) {
                                const decryptedBytes = yield this.decryptCachedEntry(file, cachedBytes);
                                yield onDecryptedBytes(decryptedBytes.decryptedBytes, {
                                    encryptedFileSize: cachedBytes.encryptedBytes.length,
                                    encryptedBytesDownloaded: cachedBytes.encryptedBytes.length,
                                    encryptedBytesRemaining: 0,
                                    percentComplete: 100,
                                    source: 'memcache'
                                });
                                return undefined;
                            }
                            const fileBackup = yield (_a = this.backupsService) === null || _a === void 0 ? void 0 : _a.getFileBackupInfo(file);
                            if (this.backupsService && fileBackup) {
                                this.logger.info('Downloading file from backup', fileBackup);
                                yield (0, files_src /* readAndDecryptBackupFileUsingBackupService */.mQ)(file, this.backupsService, this.crypto, chunk => FileService_awaiter(this, void 0, void 0, function* () {
                                    this.logger.info('Got local file chunk', chunk.progress);
                                    return onDecryptedBytes(chunk.data, chunk.progress);
                                }));
                                this.logger.info('Finished downloading file from backup');
                                return undefined;
                            }
                            else {
                                this.logger.info('Downloading file from network');
                                const addToCache = file.encryptedSize < this.encryptedCache.maxSize;
                                let cacheEntryAggregate = new Uint8Array();
                                const tokenResult = file.shared_vault_uuid ? yield this.createSharedVaultValetToken({
                                    sharedVaultUuid: file.shared_vault_uuid,
                                    remoteIdentifier: file.remoteIdentifier,
                                    operation: dist.ValetTokenOperation.Read,
                                    fileUuidRequiredForExistingFiles: file.uuid
                                }) : yield this.createUserValetToken(file.remoteIdentifier, dist.ValetTokenOperation.Read);
                                if (tokenResult instanceof dist.ClientDisplayableError) {
                                    return tokenResult;
                                }
                                const operation = new files_src /* DownloadAndDecryptFileOperation */.BI(file, this.crypto, this.api, tokenResult);
                                const result = yield operation.run(_ref => {
                                    let { decrypted, encrypted, progress } = _ref;
                                    return FileService_awaiter(this, void 0, void 0, function* () {
                                        if (addToCache) {
                                            cacheEntryAggregate = new Uint8Array([...cacheEntryAggregate, ...encrypted.encryptedBytes]);
                                        }
                                        return onDecryptedBytes(decrypted.decryptedBytes, progress);
                                    });
                                });
                                if (addToCache && cacheEntryAggregate.byteLength > 0) {
                                    this.encryptedCache.add(file.uuid, {
                                        encryptedBytes: cacheEntryAggregate
                                    });
                                }
                                return result.error;
                            }
                        });
                    }
                    deleteFile(file) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            this.encryptedCache.remove(file.uuid);
                            const tokenResult = file.shared_vault_uuid ? yield this.createSharedVaultValetToken({
                                sharedVaultUuid: file.shared_vault_uuid,
                                remoteIdentifier: file.remoteIdentifier,
                                operation: dist.ValetTokenOperation.Delete,
                                fileUuidRequiredForExistingFiles: file.uuid
                            }) : yield this.createUserValetToken(file.remoteIdentifier, dist.ValetTokenOperation.Delete);
                            if (tokenResult instanceof dist.ClientDisplayableError) {
                                return tokenResult;
                            }
                            const result = yield this.api.deleteFile(tokenResult, file.shared_vault_uuid ? 'shared-vault' : 'user');
                            if ((0, dist.isErrorResponse)(result)) {
                                const deleteAnyway = yield this.alertService.confirm((0, utils_dist.spaceSeparatedStrings)('This file could not be deleted from the server, possibly because you are attempting to delete a file item', 'that was imported from another account. Would you like to remove this file item from your account anyway?', "If you're sure the file is yours and still exists on the server, do not choose this option,", 'and instead try to delete it again.'), 'Unable to Delete', 'Delete Anyway', ButtonType.Danger);
                                if (!deleteAnyway) {
                                    return dist.ClientDisplayableError.FromNetworkError(result);
                                }
                            }
                            yield this.mutator.setItemToBeDeleted(file);
                            yield this.sync.sync();
                            return undefined;
                        });
                    }
                    isFileNameFileBackupRelated(name) {
                        if (name === files_src /* FileBackupsConstantsV1 */.yW.MetadataFileName) {
                            return 'metadata';
                        }
                        else if (name === files_src /* FileBackupsConstantsV1 */.yW.BinaryFileName) {
                            return 'binary';
                        }
                        return false;
                    }
                    decryptBackupMetadataFile(metdataFile) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const encryptedItemsKey = new models_dist.EncryptedPayload(Object.assign(Object.assign({}, metdataFile.itemsKey), {
                                waitingForKey: false,
                                errorDecrypting: false
                            }));
                            const decryptedItemsKeyResult = yield DecryptItemsKeyWithUserFallback(encryptedItemsKey, this.encryptor, this.challengor);
                            if (decryptedItemsKeyResult === 'failed' || decryptedItemsKeyResult === 'aborted') {
                                return undefined;
                            }
                            const encryptedFile = new models_dist.EncryptedPayload(Object.assign(Object.assign({}, metdataFile.file), {
                                waitingForKey: false,
                                errorDecrypting: false
                            }));
                            const itemsKey = new encryption_src /* SNItemsKey */.rU(decryptedItemsKeyResult);
                            const decryptedFile = yield this.encryptor.decryptSplitSingle({
                                usesItemsKey: {
                                    items: [encryptedFile],
                                    key: itemsKey
                                }
                            });
                            if ((0, models_dist.isEncryptedPayload)(decryptedFile)) {
                                return undefined;
                            }
                            return new models_dist.FileItem(decryptedFile);
                        });
                    }
                    selectFile(fileSystem) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const result = yield fileSystem.selectFile();
                            return result;
                        });
                    }
                    readBackupFileAndSaveDecrypted(fileHandle, file, fileSystem) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            const destinationDirectoryHandle = yield fileSystem.selectDirectory();
                            if (destinationDirectoryHandle === 'aborted' || destinationDirectoryHandle === 'failed') {
                                return destinationDirectoryHandle;
                            }
                            const destinationFileHandle = yield fileSystem.createFile(destinationDirectoryHandle, file.name);
                            if (destinationFileHandle === 'aborted' || destinationFileHandle === 'failed') {
                                return destinationFileHandle;
                            }
                            const result = yield (0, files_src /* readAndDecryptBackupFileUsingFileSystemAPI */.Qf)(fileHandle, file, fileSystem, this.crypto, decryptedBytes => FileService_awaiter(this, void 0, void 0, function* () {
                                yield fileSystem.saveBytes(destinationFileHandle, decryptedBytes);
                            }));
                            yield fileSystem.closeFileWriteStream(destinationFileHandle);
                            return result;
                        });
                    }
                    readBackupFileBytesDecrypted(fileHandle, file, fileSystem) {
                        return FileService_awaiter(this, void 0, void 0, function* () {
                            let bytes = new Uint8Array();
                            yield (0, files_src /* readAndDecryptBackupFileUsingFileSystemAPI */.Qf)(fileHandle, file, fileSystem, this.crypto, decryptedBytes => FileService_awaiter(this, void 0, void 0, function* () {
                                bytes = new Uint8Array([...bytes, ...decryptedBytes]);
                            }));
                            return bytes;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/HomeServer/HomeServerService.ts
                var HomeServerService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class HomeServerService extends AbstractService {
                    constructor(desktopDevice, platform, internalEventBus) {
                        super(internalEventBus);
                        this.desktopDevice = desktopDevice;
                        this.platform = platform;
                        this.internalEventBus = internalEventBus;
                        this.HOME_SERVER_DATA_DIRECTORY_NAME = '.homeserver';
                    }
                    handleEvent(event) {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            if (event.type === ApplicationEvent.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                switch (stage) {
                                    case ApplicationStage.StorageDecrypted_09:
                                        {
                                            yield this.setHomeServerDataLocationOnDevice();
                                            break;
                                        }
                                    case ApplicationStage.Launched_10:
                                        {
                                            yield this.startHomeServerIfItIsEnabled();
                                            break;
                                        }
                                }
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.desktopDevice = undefined;
                        super.deinit();
                    }
                    getHomeServerStatus() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const isHomeServerRunning = yield this.desktopDevice.isHomeServerRunning();
                            if (!isHomeServerRunning) {
                                return {
                                    status: 'off',
                                    errorMessage: yield this.desktopDevice.getHomeServerLastErrorMessage()
                                };
                            }
                            return {
                                status: 'on',
                                url: yield this.getHomeServerUrl()
                            };
                        });
                    }
                    getHomeServerLogs() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.getHomeServerLogs();
                        });
                    }
                    getHomeServerUrl() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.getHomeServerUrl();
                        });
                    }
                    startHomeServer() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.startHomeServer();
                        });
                    }
                    stopHomeServer() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.stopHomeServer();
                        });
                    }
                    isHomeServerRunning() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.isHomeServerRunning();
                        });
                    }
                    activatePremiumFeatures(username, subscriptionId) {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.desktopDevice.activatePremiumFeatures(username, subscriptionId);
                            if (result !== undefined) {
                                return src.Result.fail(result);
                            }
                            return src.Result.ok('Premium features activated');
                        });
                    }
                    setHomeServerConfiguration(config) {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            yield this.desktopDevice.setHomeServerConfiguration(JSON.stringify(config));
                        });
                    }
                    getHomeServerConfiguration() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const configurationJSONString = yield this.desktopDevice.getHomeServerConfiguration();
                            if (!configurationJSONString) {
                                return undefined;
                            }
                            return JSON.parse(configurationJSONString);
                        });
                    }
                    enableHomeServer() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            yield this.desktopDevice.setRawStorageValue(RawStorageKey.HomeServerEnabled, 'true');
                            yield this.startHomeServer();
                        });
                    }
                    isHomeServerEnabled() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const value = yield this.desktopDevice.getRawStorageValue(RawStorageKey.HomeServerEnabled);
                            return value === 'true';
                        });
                    }
                    getHomeServerDataLocation() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            return this.desktopDevice.getRawStorageValue(RawStorageKey.HomeServerDataLocation);
                        });
                    }
                    disableHomeServer() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            yield this.desktopDevice.setRawStorageValue(RawStorageKey.HomeServerEnabled, 'false');
                            const result = yield this.stopHomeServer();
                            if (result !== undefined) {
                                return src.Result.fail(result);
                            }
                            return src.Result.ok('Home server disabled');
                        });
                    }
                    changeHomeServerDataLocation() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const oldLocation = yield this.getHomeServerDataLocation();
                            const newLocation = yield this.desktopDevice.presentDirectoryPickerForLocationChangeAndTransferOld(this.HOME_SERVER_DATA_DIRECTORY_NAME, oldLocation);
                            if (!newLocation) {
                                const lastErrorMessage = yield this.desktopDevice.getDirectoryManagerLastErrorMessage();
                                return src.Result.fail(lastErrorMessage !== null && lastErrorMessage !== void 0 ? lastErrorMessage : 'No location selected');
                            }
                            yield this.desktopDevice.setRawStorageValue(RawStorageKey.HomeServerDataLocation, newLocation);
                            yield this.desktopDevice.setHomeServerDataLocation(newLocation);
                            return src.Result.ok(newLocation);
                        });
                    }
                    openHomeServerDataLocation() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const location = yield this.getHomeServerDataLocation();
                            if (location) {
                                void this.desktopDevice.openLocation(location);
                            }
                        });
                    }
                    startHomeServerIfItIsEnabled() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            const homeServerIsEnabled = yield this.isHomeServerEnabled();
                            if (homeServerIsEnabled) {
                                yield this.startHomeServer();
                            }
                        });
                    }
                    setHomeServerDataLocationOnDevice() {
                        return HomeServerService_awaiter(this, void 0, void 0, function* () {
                            let location = yield this.getHomeServerDataLocation();
                            if (!location) {
                                const documentsDirectory = yield this.desktopDevice.getUserDocumentsDirectory();
                                if (!documentsDirectory) {
                                    return;
                                }
                                const separator = this.platform === models_dist.Platform.WindowsDesktop ? '\\' : '/';
                                location = "".concat(documentsDirectory).concat(separator).concat(this.HOME_SERVER_DATA_DIRECTORY_NAME);
                            }
                            yield this.desktopDevice.setRawStorageValue(RawStorageKey.HomeServerDataLocation, location);
                            yield this.desktopDevice.setHomeServerDataLocation(location);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/DecryptBackupFile.ts
                var DecryptBackupFile_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptBackupFile {
                    constructor(encryption, keys, _getBackupFileType, _decryptBackupPayloads) {
                        this.encryption = encryption;
                        this.keys = keys;
                        this._getBackupFileType = _getBackupFileType;
                        this._decryptBackupPayloads = _decryptBackupPayloads;
                    }
                    execute(file, password) {
                        return DecryptBackupFile_awaiter(this, void 0, void 0, function* () {
                            const payloads = this.convertToPayloads(file);
                            const type = this._getBackupFileType.execute(file, payloads).getValue();
                            if (type === encryption_src /* BackupFileType */.qX.Corrupt) {
                                return src.Result.fail('Invalid backup file.');
                            }
                            const { encrypted, decrypted } = (0, models_dist.CreatePayloadSplit)(payloads);
                            if (type === encryption_src /* BackupFileType */.qX.FullyDecrypted) {
                                return src.Result.ok([...decrypted, ...encrypted]);
                            }
                            if (type === encryption_src /* BackupFileType */.qX.EncryptedWithNonEncryptedItemsKey) {
                                const result = yield this.handleEncryptedWithNonEncryptedItemsKeyFileType(payloads);
                                if (result.isFailed()) {
                                    return src.Result.fail(result.getError());
                                }
                                return src.Result.ok([...decrypted, ...result.getValue()]);
                            }
                            if (!password) {
                                throw Error('Attempting to decrypt encrypted file with no password');
                            }
                            const results = yield this.handleEncryptedFileType({
                                payloads: encrypted,
                                file,
                                password
                            });
                            if (results.isFailed()) {
                                return src.Result.fail(results.getError());
                            }
                            return src.Result.ok([...decrypted, ...results.getValue()]);
                        });
                    }
                    /** This is a backup file made from a session which had an encryption source, such as an account or a passcode. */
                    handleEncryptedFileType(dto) {
                        var _a;
                        return DecryptBackupFile_awaiter(this, void 0, void 0, function* () {
                            const keyParams = (0, encryption_src /* CreateAnyKeyParams */.jl)(dto.file.keyParams || dto.file.auth_params);
                            const rootKey = yield this.encryption.computeRootKey(dto.password, keyParams);
                            const results = [];
                            const { rootKeyEncryption, itemsKeyEncryption, keySystemRootKeyEncryption } = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(dto.payloads);
                            /** Decrypts items encrypted with a user root key, such as contacts, synced vault root keys, and items keys */
                            const rootKeyBasedDecryptionResults = yield this.encryption.decryptSplit({
                                usesRootKey: {
                                    items: rootKeyEncryption || [],
                                    key: rootKey
                                }
                            });
                            /** Extract items keys and synced vault root keys from root key decryption results */
                            const recentlyDecryptedKeys = rootKeyBasedDecryptionResults.filter(x => (0, encryption_src /* isItemsKey */.dS)(x) || (0, models_dist.isKeySystemRootKey)(x)).filter(models_dist.isDecryptedPayload).map(p => (0, models_dist.CreateDecryptedItemFromPayload)(p));
                            /**
                             * Now handle encrypted keySystemRootKeyEncryption items (vault items keys).  For every encrypted vault items key
                             * find the respective vault root key, either from recently decrypted above, or from the key manager. Decrypt the
                             * vault items key, and if successful, add it to recentlyDecryptedKeys so that it can be used to decrypt subsequent items
                             */
                            for (const payload of keySystemRootKeyEncryption !== null && keySystemRootKeyEncryption !== void 0 ? keySystemRootKeyEncryption : []) {
                                if (!payload.key_system_identifier) {
                                    throw new Error('Attempting to decrypt key system root key encrypted payload with no key system identifier');
                                }
                                const keys = rootKeyBasedDecryptionResults.filter(models_dist.isDecryptedPayload).filter(models_dist.isKeySystemRootKey).map(p => (0, models_dist.CreateDecryptedItemFromPayload)(p));
                                const key = (_a = keys.find(k => k.systemIdentifier === payload.key_system_identifier)) !== null && _a !== void 0 ? _a : this.keys.getPrimaryKeySystemRootKey(payload.key_system_identifier);
                                if (!key) {
                                    results.push(payload.copy({
                                        errorDecrypting: true
                                    }));
                                    continue;
                                }
                                const result = yield this.encryption.decryptSplitSingle({
                                    usesKeySystemRootKey: {
                                        items: [payload],
                                        key
                                    }
                                });
                                if ((0, models_dist.isDecryptedPayload)(result) && (0, encryption_src /* isKeySystemItemsKey */.mX)(result)) {
                                    recentlyDecryptedKeys.push((0, models_dist.CreateDecryptedItemFromPayload)(result));
                                }
                                results.push(result);
                            }
                            (0, utils_dist.extendArray)(results, rootKeyBasedDecryptionResults);
                            const payloadsToDecrypt = [...(itemsKeyEncryption !== null && itemsKeyEncryption !== void 0 ? itemsKeyEncryption : [])];
                            const decryptedPayloads = yield this._decryptBackupPayloads.execute({
                                payloads: payloadsToDecrypt,
                                recentlyDecryptedKeys: recentlyDecryptedKeys,
                                keyParams: keyParams,
                                rootKey: rootKey
                            });
                            if (decryptedPayloads.isFailed()) {
                                return src.Result.fail(decryptedPayloads.getError());
                            }
                            (0, utils_dist.extendArray)(results, decryptedPayloads.getValue());
                            return src.Result.ok(results);
                        });
                    }
                    /**
                     * These are backup files made when not signed into an account and without an encryption source such as a passcode.
                     * In this case the items key exists in the backup in plaintext, but the items are encrypted with this items key.
                     */
                    handleEncryptedWithNonEncryptedItemsKeyFileType(payloads) {
                        return DecryptBackupFile_awaiter(this, void 0, void 0, function* () {
                            const decryptedItemsKeys = [];
                            const encryptedPayloads = [];
                            payloads.forEach(payload => {
                                if (payload.content_type === src.ContentType.TYPES.ItemsKey && (0, models_dist.isDecryptedPayload)(payload)) {
                                    decryptedItemsKeys.push(payload);
                                }
                                else if ((0, models_dist.isEncryptedPayload)(payload)) {
                                    encryptedPayloads.push(payload);
                                }
                            });
                            const itemsKeys = decryptedItemsKeys.map(p => (0, models_dist.CreateDecryptedItemFromPayload)(p));
                            return this._decryptBackupPayloads.execute({
                                payloads: encryptedPayloads,
                                recentlyDecryptedKeys: itemsKeys,
                                rootKey: undefined
                            });
                        });
                    }
                    convertToPayloads(file) {
                        return file.items.map(item => {
                            if ((0, models_dist.isEncryptedTransferPayload)(item)) {
                                return new models_dist.EncryptedPayload(item);
                            }
                            else if ((0, models_dist.isDecryptedTransferPayload)(item)) {
                                return new models_dist.DecryptedPayload(item);
                            }
                            else {
                                throw Error('Unhandled case in DecryptBackupFile');
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/DecryptBackupPayloads.ts
                var DecryptBackupPayloads_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DecryptBackupPayloads {
                    constructor(encryption, _determineKeyToUse, logger) {
                        this.encryption = encryption;
                        this._determineKeyToUse = _determineKeyToUse;
                        this.logger = logger;
                    }
                    execute(dto) {
                        return DecryptBackupPayloads_awaiter(this, void 0, void 0, function* () {
                            const results = [];
                            for (const encryptedPayload of dto.payloads) {
                                try {
                                    const key = this._determineKeyToUse.execute({
                                        payload: encryptedPayload,
                                        recentlyDecryptedKeys: dto.recentlyDecryptedKeys,
                                        keyParams: dto.keyParams,
                                        rootKey: dto.rootKey
                                    }).getValue();
                                    if (!key) {
                                        results.push(encryptedPayload.copy({
                                            errorDecrypting: true
                                        }));
                                        continue;
                                    }
                                    if ((0, encryption_src /* isItemsKey */.dS)(key) || (0, encryption_src /* isKeySystemItemsKey */.mX)(key)) {
                                        const decryptedPayload = yield this.encryption.decryptSplitSingle({
                                            usesItemsKey: {
                                                items: [encryptedPayload],
                                                key: key
                                            }
                                        });
                                        results.push(decryptedPayload);
                                    }
                                    else if ((0, models_dist.isKeySystemRootKey)(key)) {
                                        const decryptedPayload = yield this.encryption.decryptSplitSingle({
                                            usesKeySystemRootKey: {
                                                items: [encryptedPayload],
                                                key: key
                                            }
                                        });
                                        results.push(decryptedPayload);
                                    }
                                    else {
                                        const decryptedPayload = yield this.encryption.decryptSplitSingle({
                                            usesRootKey: {
                                                items: [encryptedPayload],
                                                key: key
                                            }
                                        });
                                        results.push(decryptedPayload);
                                    }
                                }
                                catch (e) {
                                    results.push(encryptedPayload.copy({
                                        errorDecrypting: true
                                    }));
                                    this.logger.error('Error decrypting payload', encryptedPayload, e);
                                }
                            }
                            return src.Result.ok(results);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/DetermineKeyToUse.ts
                class DetermineKeyToUse {
                    constructor(encryption, keys) {
                        this.encryption = encryption;
                        this.keys = keys;
                    }
                    execute(dto) {
                        if ((0, models_dist.ContentTypeUsesRootKeyEncryption)(dto.payload.content_type)) {
                            if (!dto.rootKey) {
                                throw new Error('Attempting to decrypt root key encrypted payload with no root key');
                            }
                            return src.Result.ok(dto.rootKey);
                        }
                        if ((0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(dto.payload.content_type)) {
                            if (!dto.payload.key_system_identifier) {
                                throw new Error('Attempting to decrypt key system root key encrypted payload with no key system identifier');
                            }
                            try {
                                const recentlyDecrypted = dto.recentlyDecryptedKeys.filter(models_dist.isKeySystemRootKey);
                                let keySystemRootKey = recentlyDecrypted.find(key => key.systemIdentifier === dto.payload.key_system_identifier);
                                if (!keySystemRootKey) {
                                    keySystemRootKey = this.keys.getPrimaryKeySystemRootKey(dto.payload.key_system_identifier);
                                }
                                return src.Result.ok(keySystemRootKey);
                            }
                            catch (error) {
                                return src.Result.fail(JSON.stringify(error));
                            }
                        }
                        if (dto.payload.key_system_identifier) {
                            const keySystemItemsKey = dto.recentlyDecryptedKeys.find(key => key.key_system_identifier === dto.payload.key_system_identifier);
                            if (keySystemItemsKey) {
                                return src.Result.ok(keySystemItemsKey);
                            }
                        }
                        let itemsKey;
                        itemsKey = dto.recentlyDecryptedKeys.filter(encryption_src /* isItemsKey */.dS).find(itemsKeyPayload => {
                            return dto.payload.items_key_id === itemsKeyPayload.uuid;
                        });
                        if (itemsKey) {
                            return src.Result.ok(itemsKey);
                        }
                        if (dto.payload.items_key_id) {
                            itemsKey = this.encryption.itemsKeyForEncryptedPayload(dto.payload);
                            if (itemsKey) {
                                return src.Result.ok(itemsKey);
                            }
                        }
                        if (itemsKey) {
                            return src.Result.ok(itemsKey);
                        }
                        if (!dto.keyParams) {
                            return src.Result.ok(undefined);
                        }
                        const payloadVersion = dto.payload.version;
                        /**
                         * Payloads with versions <= 003 use root key directly for encryption.
                         * However, if the incoming key params are >= 004, this means we should
                         * have an items key based off the 003 root key. We can't use the 004
                         * root key directly because it's missing dataAuthenticationKey.
                         */
                        if ((0, dist_src.leftVersionGreaterThanOrEqualToRight)(dto.keyParams.version, dist_src.ProtocolVersion.V004)) {
                            itemsKey = this.encryption.defaultItemsKeyForItemVersion(payloadVersion, dto.recentlyDecryptedKeys.filter(encryption_src /* isItemsKey */.dS));
                        }
                        else if ((0, dist_src.compareVersions)(payloadVersion, dist_src.ProtocolVersion.V003) <= 0) {
                            itemsKey = dto.rootKey;
                        }
                        return src.Result.ok(itemsKey);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/GetBackupFileType.ts
                class GetBackupFileType {
                    execute(file, payloads) {
                        if (file.keyParams || file.auth_params) {
                            return src.Result.ok(encryption_src /* BackupFileType */.qX.Encrypted);
                        }
                        const hasEncryptedItem = payloads.find(models_dist.isEncryptedPayload);
                        const hasDecryptedItemsKey = payloads.find(payload => payload.content_type === src.ContentType.TYPES.ItemsKey && (0, models_dist.isDecryptedPayload)(payload));
                        if (hasEncryptedItem && hasDecryptedItemsKey) {
                            return src.Result.ok(encryption_src /* BackupFileType */.qX.EncryptedWithNonEncryptedItemsKey);
                        }
                        else if (!hasEncryptedItem) {
                            return src.Result.ok(encryption_src /* BackupFileType */.qX.FullyDecrypted);
                        }
                        else {
                            return src.Result.ok(encryption_src /* BackupFileType */.qX.Corrupt);
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/Strings.ts
                const Strings = {
                    UnsupportedBackupFileVersion: 'This backup file was created using a newer version of the application and cannot be imported here. Please update your application and try again.',
                    BackupFileMoreRecentThanAccount: "This backup file was created using a newer encryption version than your account's. Please run the available encryption upgrade and try again.",
                    FileAccountPassword: 'File account password'
                };
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/GetFilePassword.ts
                var GetFilePassword_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetFilePassword {
                    constructor(challenges) {
                        this.challenges = challenges;
                    }
                    execute() {
                        return GetFilePassword_awaiter(this, void 0, void 0, function* () {
                            const challenge = new Challenge([new ChallengePrompt(ChallengeValidation.None, Strings.FileAccountPassword, undefined, true)], ChallengeReason.DecryptEncryptedFile, true);
                            const passwordResponse = yield this.challenges.promptForChallengeResponse(challenge);
                            if (passwordResponse == undefined) {
                                return src.Result.fail('Import aborted due to canceled password prompt');
                            }
                            this.challenges.completeChallenge(challenge);
                            return src.Result.ok(passwordResponse === null || passwordResponse === void 0 ? void 0 : passwordResponse.values[0].value);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/ImportData.ts
                var ImportData_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ImportData {
                    constructor(items, sync, protections, encryption, payloads, history, _decryptBackFile, _getFilePassword) {
                        this.items = items;
                        this.sync = sync;
                        this.protections = protections;
                        this.encryption = encryption;
                        this.payloads = payloads;
                        this.history = history;
                        this._decryptBackFile = _decryptBackFile;
                        this._getFilePassword = _getFilePassword;
                    }
                    execute(data) {
                        let awaitSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return ImportData_awaiter(this, void 0, void 0, function* () {
                            const versionValidation = this.validateFileVersion(data);
                            if (versionValidation.isFailed()) {
                                return src.Result.fail(versionValidation.getError());
                            }
                            const decryptedPayloadsOrError = yield this.decryptData(data);
                            if (decryptedPayloadsOrError.isFailed()) {
                                return src.Result.fail(decryptedPayloadsOrError.getError());
                            }
                            const valid = this.getValidPayloadsToImportFromDecryptedResult(decryptedPayloadsOrError.getValue());
                            if (!(yield this.protections.authorizeFileImport())) {
                                return src.Result.fail('Import aborted');
                            }
                            const affectedUuids = yield this.payloads.importPayloads(valid, this.history.getHistoryMapCopy());
                            const promise = this.sync.sync();
                            if (awaitSync) {
                                yield promise;
                            }
                            const affectedItems = this.items.findItems(affectedUuids);
                            return src.Result.ok({
                                affectedItems: affectedItems,
                                errorCount: decryptedPayloadsOrError.getValue().length - valid.length
                            });
                        });
                    }
                    validateFileVersion(data) {
                        if (data.version) {
                            const result = this.validateVersion(data.version);
                            if (result.isFailed()) {
                                return src.Result.fail(result.getError());
                            }
                        }
                        return src.Result.ok();
                    }
                    decryptData(data) {
                        return ImportData_awaiter(this, void 0, void 0, function* () {
                            let password;
                            if (data.auth_params || data.keyParams) {
                                const passwordResult = yield this._getFilePassword.execute();
                                if (passwordResult.isFailed()) {
                                    return src.Result.fail(passwordResult.getError());
                                }
                                password = passwordResult.getValue();
                            }
                            this.cleanImportData(data);
                            const decryptedPayloadsOrError = yield this._decryptBackFile.execute(data, password);
                            if (decryptedPayloadsOrError.isFailed()) {
                                return src.Result.fail(decryptedPayloadsOrError.getError());
                            }
                            return src.Result.ok(decryptedPayloadsOrError.getValue());
                        });
                    }
                    getValidPayloadsToImportFromDecryptedResult(results) {
                        const decrypted = results.filter(models_dist.isDecryptedPayload);
                        const encrypted = results.filter(models_dist.isEncryptedPayload);
                        const vaulted = encrypted.filter(payload => {
                            return payload.key_system_identifier !== undefined;
                        });
                        const valid = [...decrypted, ...vaulted];
                        return valid;
                    }
                    cleanImportData(data) {
                        data.items = data.items.map(item => {
                            if ((0, models_dist.isEncryptedTransferPayload)(item)) {
                                return (0, models_dist.CreateEncryptedBackupFileContextPayload)(item);
                            }
                            else {
                                return (0, models_dist.CreateDecryptedBackupFileContextPayload)(item);
                            }
                        });
                    }
                    /**
                     * Prior to 003 backup files did not have a version field so we cannot
                     * stop importing if there is no backup file version, only if there is
                     * an unsupported version.
                     */
                    validateVersion(version) {
                        const supportedVersions = this.encryption.supportedVersions();
                        if (!supportedVersions.includes(version)) {
                            return src.Result.fail(Strings.UnsupportedBackupFileVersion);
                        }
                        const userVersion = this.encryption.getUserVersion();
                        if (userVersion && (0, dist_src.compareVersions)(version, userVersion) === 1) {
                            /** File was made with a greater version than the user's account */
                            return src.Result.fail(Strings.BackupFileMoreRecentThanAccount);
                        }
                        return src.Result.ok();
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/CreateDecryptedBackupFile.ts
                var CreateDecryptedBackupFile_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateDecryptedBackupFile {
                    constructor(payloads, protections) {
                        this.payloads = payloads;
                        this.protections = protections;
                    }
                    execute() {
                        return CreateDecryptedBackupFile_awaiter(this, void 0, void 0, function* () {
                            if (!(yield this.protections.authorizeBackupCreation())) {
                                return src.Result.fail('Failed to authorize backup creation');
                            }
                            const payloads = this.payloads.nonDeletedItems.filter(item => item.content_type !== src.ContentType.TYPES.ItemsKey);
                            const data = {
                                version: dist_src.ProtocolVersionLatest,
                                items: payloads.map(payload => {
                                    if ((0, models_dist.isDecryptedPayload)(payload)) {
                                        return (0, models_dist.CreateDecryptedBackupFileContextPayload)(payload);
                                    }
                                    else if ((0, models_dist.isEncryptedPayload)(payload)) {
                                        return (0, models_dist.CreateEncryptedBackupFileContextPayload)(payload);
                                    }
                                    return undefined;
                                }).filter(utils_dist.isNotUndefined)
                            };
                            return src.Result.ok(data);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Import/CreateEncryptedBackupFile.ts
                var CreateEncryptedBackupFile_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateEncryptedBackupFile {
                    constructor(items, protections, encryption) {
                        this.items = items;
                        this.protections = protections;
                        this.encryption = encryption;
                    }
                    execute() {
                        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            skipAuthorization: false
                        };
                        return CreateEncryptedBackupFile_awaiter(this, void 0, void 0, function* () {
                            if (!params.skipAuthorization && !(yield this.protections.authorizeBackupCreation())) {
                                return src.Result.fail('Failed to authorize backup creation');
                            }
                            const payloads = this.items.items.map(item => item.payload);
                            const split = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(payloads);
                            const keyLookupSplit = (0, encryption_src /* CreateEncryptionSplitWithKeyLookup */.Ak)(split);
                            const result = yield this.encryption.encryptSplit(keyLookupSplit);
                            const ejected = result.map(payload => (0, models_dist.CreateEncryptedBackupFileContextPayload)(payload));
                            const data = {
                                version: dist_src.ProtocolVersionLatest,
                                items: ejected
                            };
                            const keyParams = this.encryption.getRootKeyParams();
                            data.keyParams = keyParams === null || keyParams === void 0 ? void 0 : keyParams.getPortableValue();
                            return src.Result.ok(data);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Integrity/IntegrityEvent.ts
                /* istanbul ignore file */
                var IntegrityEvent;
                (function (IntegrityEvent) {
                    IntegrityEvent["IntegrityCheckCompleted"] = "IntegrityCheckCompleted";
                })(IntegrityEvent || (IntegrityEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Integrity/IntegrityService.ts
                var IntegrityService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class IntegrityService extends AbstractService {
                    constructor(integrityApi, itemApi, payloadManager, logger, internalEventBus) {
                        super(internalEventBus);
                        this.integrityApi = integrityApi;
                        this.itemApi = itemApi;
                        this.payloadManager = payloadManager;
                        this.logger = logger;
                        this.internalEventBus = internalEventBus;
                    }
                    handleEvent(event) {
                        var _a, _b;
                        return IntegrityService_awaiter(this, void 0, void 0, function* () {
                            if (event.type !== SyncEvent.SyncRequestsIntegrityCheck) {
                                return;
                            }
                            const integrityCheckResponse = yield this.integrityApi.checkIntegrity(this.payloadManager.integrityPayloads);
                            if ((0, dist.isErrorResponse)(integrityCheckResponse)) {
                                this.logger.error("Could not obtain integrity check: ".concat((_a = integrityCheckResponse.data.error) === null || _a === void 0 ? void 0 : _a.message));
                                return;
                            }
                            const serverItemResponsePromises = [];
                            for (const mismatch of integrityCheckResponse.data.mismatches) {
                                serverItemResponsePromises.push(this.itemApi.getSingleItem(mismatch.uuid));
                            }
                            const serverItemResponses = yield Promise.all(serverItemResponsePromises);
                            const rawPayloads = [];
                            for (const serverItemResponse of serverItemResponses) {
                                if (serverItemResponse.data == undefined || (0, dist.isErrorResponse)(serverItemResponse) || !('item' in serverItemResponse.data)) {
                                    this.logger.error("Could not obtain item for integrity adjustments: ".concat((0, dist.isErrorResponse)(serverItemResponse) ? (_b = serverItemResponse.data.error) === null || _b === void 0 ? void 0 : _b.message : ''));
                                    continue;
                                }
                                rawPayloads.push(serverItemResponse.data.item);
                            }
                            yield this.notifyEventSync(IntegrityEvent.IntegrityCheckCompleted, {
                                rawPayloads: rawPayloads,
                                source: event.payload.source
                            });
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Internal/InternalEventBus.ts
                var InternalEventBus_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class InternalEventBus {
                    constructor() {
                        this.eventHandlers = new Map();
                    }
                    deinit() {
                        ;
                        this.eventHandlers = undefined;
                    }
                    addEventHandler(handler, eventType) {
                        let handlersForEventType = this.eventHandlers.get(eventType);
                        if (handlersForEventType === undefined) {
                            handlersForEventType = [];
                        }
                        handlersForEventType.push(handler);
                        this.eventHandlers.set(eventType, handlersForEventType);
                    }
                    publish(event) {
                        const handlersForEventType = this.eventHandlers.get(event.type);
                        if (handlersForEventType === undefined) {
                            return;
                        }
                        for (const handlerForEventType of handlersForEventType) {
                            void handlerForEventType.handleEvent(event);
                        }
                    }
                    publishSync(event, strategy) {
                        return InternalEventBus_awaiter(this, void 0, void 0, function* () {
                            const handlersForEventType = this.eventHandlers.get(event.type);
                            if (handlersForEventType === undefined) {
                                return;
                            }
                            if (strategy === InternalEventPublishStrategy.SEQUENCE) {
                                for (const handlerForEventType of handlersForEventType) {
                                    yield handlerForEventType.handleEvent(event);
                                }
                            }
                            if (strategy === InternalEventPublishStrategy.ASYNC) {
                                const handlerPromises = [];
                                for (const handlerForEventType of handlersForEventType) {
                                    handlerPromises.push(handlerForEventType.handleEvent(event));
                                }
                                yield Promise.all(handlerPromises);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Item/ItemRelationshipDirection.ts
                /* istanbul ignore file */
                var ItemRelationshipDirection;
                (function (ItemRelationshipDirection) {
                    ItemRelationshipDirection[ItemRelationshipDirection["AReferencesB"] = 0] = "AReferencesB";
                    ItemRelationshipDirection[ItemRelationshipDirection["BReferencesA"] = 1] = "BReferencesA";
                    ItemRelationshipDirection[ItemRelationshipDirection["NoRelationship"] = 2] = "NoRelationship";
                })(ItemRelationshipDirection || (ItemRelationshipDirection = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Item/StaticItemCounter.ts
                class StaticItemCounter {
                    countNotesAndTags(items) {
                        const counts = {
                            notes: 0,
                            archived: 0,
                            deleted: 0,
                            tags: 0
                        };
                        for (const item of items) {
                            if (item.trashed) {
                                counts.deleted++;
                                continue;
                            }
                            if (item.archived) {
                                counts.archived++;
                                continue;
                            }
                            if (item.content_type === src.ContentType.TYPES.Note && !item.conflictOf) {
                                counts.notes++;
                                continue;
                            }
                            if (item.content_type === src.ContentType.TYPES.Tag) {
                                counts.tags++;
                                continue;
                            }
                        }
                        return counts;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/ItemsEncryption/ItemsEncryption.ts
                var ItemsEncryption_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ItemsEncryptionService extends AbstractService {
                    constructor(items, payloads, storage, operators, keys, _findDefaultItemsKey, internalEventBus) {
                        super(internalEventBus);
                        this.items = items;
                        this.payloads = payloads;
                        this.storage = storage;
                        this.operators = operators;
                        this.keys = keys;
                        this._findDefaultItemsKey = _findDefaultItemsKey;
                        this.internalEventBus = internalEventBus;
                        this.removeItemsObserver = this.items.addObserver([src.ContentType.TYPES.ItemsKey], _ref => {
                            let { changed, inserted } = _ref;
                            if (changed.concat(inserted).length > 0) {
                                void this.decryptErroredItemPayloads();
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.items = undefined;
                        this.payloads = undefined;
                        this.storage = undefined;
                        this.operators = undefined;
                        this.keys = undefined;
                        this.removeItemsObserver();
                        this.removeItemsObserver = undefined;
                        super.deinit();
                    }
                    /**
                     * If encryption status changes (esp. on mobile, where local storage encryption
                     * can be disabled), consumers may call this function to repersist all items to
                     * disk using latest encryption status.
                     */
                    repersistAllItems() {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            const items = this.items.items;
                            const payloads = items.map(item => item.payload);
                            return this.storage.savePayloads(payloads);
                        });
                    }
                    getItemsKeys() {
                        return this.items.getDisplayableItemsKeys();
                    }
                    itemsKeyForEncryptedPayload(payload) {
                        const itemsKeys = this.getItemsKeys();
                        const keySystemItemsKeys = this.items.getItems(src.ContentType.TYPES.KeySystemItemsKey);
                        return [...itemsKeys, ...keySystemItemsKeys].find(key => key.uuid === payload.items_key_id || key.duplicateOf === payload.items_key_id);
                    }
                    getDefaultItemsKey() {
                        return this._findDefaultItemsKey.execute(this.getItemsKeys()).getValue();
                    }
                    keyToUseForItemEncryption(payload) {
                        if (payload.key_system_identifier) {
                            const keySystemItemsKey = this.keys.getPrimaryKeySystemItemsKey(payload.key_system_identifier);
                            if (!keySystemItemsKey) {
                                return new encryption_src /* StandardException */.KX('Cannot find key system items key to use for encryption');
                            }
                            return keySystemItemsKey;
                        }
                        const defaultKey = this.getDefaultItemsKey();
                        let result = undefined;
                        if (this.userVersion && this.userVersion !== (defaultKey === null || defaultKey === void 0 ? void 0 : defaultKey.keyVersion)) {
                            /**
                             * The default key appears to be either newer or older than the user's account version
                             * We could throw an exception here, but will instead fall back to a corrective action:
                             * return any items key that corresponds to the user's version
                             */
                            const itemsKeys = this.getItemsKeys();
                            result = itemsKeys.find(key => key.keyVersion === this.userVersion);
                        }
                        else {
                            result = defaultKey;
                        }
                        if (!result) {
                            return new encryption_src /* StandardException */.KX('Cannot find items key to use for encryption');
                        }
                        return result;
                    }
                    keyToUseForDecryptionOfPayload(payload) {
                        if (payload.items_key_id) {
                            const itemsKey = this.itemsKeyForEncryptedPayload(payload);
                            return itemsKey;
                        }
                        const defaultKey = this.defaultItemsKeyForItemVersion(payload.version);
                        return defaultKey;
                    }
                    encryptPayloadWithKeyLookup(payload, signingKeyPair) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            const key = this.keyToUseForItemEncryption(payload);
                            if (key instanceof encryption_src /* StandardException */.KX) {
                                throw Error(key.message);
                            }
                            return this.encryptPayload(payload, key, signingKeyPair);
                        });
                    }
                    encryptPayload(payload, key, signingKeyPair) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            if ((0, models_dist.isEncryptedPayload)(payload)) {
                                throw Error('Attempting to encrypt already encrypted payload.');
                            }
                            if (!payload.content) {
                                throw Error('Attempting to encrypt payload with no content.');
                            }
                            if (!payload.uuid) {
                                throw Error('Attempting to encrypt payload with no UuidGenerator.');
                            }
                            return (0, encryption_src /* encryptPayload */.Gl)(payload, key, this.operators, signingKeyPair);
                        });
                    }
                    encryptPayloads(payloads, key, signingKeyPair) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.encryptPayload(payload, key, signingKeyPair)));
                        });
                    }
                    encryptPayloadsWithKeyLookup(payloads, signingKeyPair) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.encryptPayloadWithKeyLookup(payload, signingKeyPair)));
                        });
                    }
                    decryptPayloadWithKeyLookup(payload) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            const key = this.keyToUseForDecryptionOfPayload(payload);
                            if (key == undefined) {
                                return {
                                    uuid: payload.uuid,
                                    errorDecrypting: true,
                                    waitingForKey: true
                                };
                            }
                            return this.decryptPayload(payload, key);
                        });
                    }
                    decryptPayload(payload, key) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            if (!payload.content) {
                                return {
                                    uuid: payload.uuid,
                                    errorDecrypting: true
                                };
                            }
                            return (0, encryption_src /* decryptPayload */.oO)(payload, key, this.operators);
                        });
                    }
                    decryptPayloadsWithKeyLookup(payloads) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.decryptPayloadWithKeyLookup(payload)));
                        });
                    }
                    decryptPayloads(payloads, key) {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(payload => this.decryptPayload(payload, key)));
                        });
                    }
                    decryptErroredItemPayloads() {
                        return ItemsEncryption_awaiter(this, void 0, void 0, function* () {
                            const erroredItemPayloads = this.payloads.invalidPayloads.filter(i => !(0, models_dist.ContentTypeUsesRootKeyEncryption)(i.content_type) && !(0, models_dist.ContentTypeUsesKeySystemRootKeyEncryption)(i.content_type));
                            if (erroredItemPayloads.length === 0) {
                                return;
                            }
                            const resultParams = yield this.decryptPayloadsWithKeyLookup(erroredItemPayloads);
                            const decryptedPayloads = resultParams.map(params => {
                                const original = (0, models_dist.SureFindPayload)(erroredItemPayloads, params.uuid);
                                if ((0, encryption_src /* isErrorDecryptingParameters */.XL)(params)) {
                                    return new models_dist.EncryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                                else {
                                    return new models_dist.DecryptedPayload(Object.assign(Object.assign({}, original.ejected()), params));
                                }
                            });
                            yield this.payloads.emitPayloads(decryptedPayloads, models_dist.PayloadEmitSource.LocalChanged);
                        });
                    }
                    /**
                     * When migrating from non-items key architecture, many items will not have a
                     * relationship with any key object. For those items, we can be sure that only 1 key
                     * object will correspond to that protocol version.
                     * @returns The items key object to decrypt items encrypted
                     * with previous protocol version.
                     */
                    defaultItemsKeyForItemVersion(version, fromKeys) {
                        /** Try to find one marked default first */
                        const searchKeys = fromKeys || this.getItemsKeys();
                        const priorityKey = searchKeys.find(key => {
                            return key.isDefault && key.keyVersion === version;
                        });
                        if (priorityKey) {
                            return priorityKey;
                        }
                        return searchKeys.find(key => {
                            return key.keyVersion === version;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/KeySystem/KeySystemKeyManager.ts
                var KeySystemKeyManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const RootKeyStorageKeyPrefix = 'key-system-root-key-';
                class KeySystemKeyManager extends AbstractService {
                    constructor(items, mutator, storage, _removeItemsFromMemory, eventBus) {
                        super(eventBus);
                        this.items = items;
                        this.mutator = mutator;
                        this.storage = storage;
                        this._removeItemsFromMemory = _removeItemsFromMemory;
                        this.rootKeyMemoryCache = {};
                    }
                    deinit() {
                        ;
                        this.items = undefined;
                        this.mutator = undefined;
                        this.storage = undefined;
                        this._removeItemsFromMemory = undefined;
                        super.deinit();
                    }
                    handleEvent(event) {
                        return KeySystemKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (event.type === ApplicationEvent.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === ApplicationStage.StorageDecrypted_09) {
                                    this.loadRootKeysFromStorage();
                                }
                            }
                        });
                    }
                    loadRootKeysFromStorage() {
                        const storageKeys = this.storage.getAllKeys().filter(key => key.startsWith(RootKeyStorageKeyPrefix));
                        const keyRawPayloads = storageKeys.map(key => this.storage.getValue(key));
                        const keyPayloads = keyRawPayloads.map(rawPayload => new models_dist.DecryptedPayload(rawPayload));
                        const keys = keyPayloads.map(payload => new models_dist.KeySystemRootKey(payload));
                        for (const key of keys) {
                            this.rootKeyMemoryCache[key.systemIdentifier] = key;
                        }
                    }
                    getRootKeyFromStorageForVault(keySystemIdentifier) {
                        const payload = this.storage.getValue(this.storageKeyForRootKey(keySystemIdentifier));
                        if (!payload) {
                            return undefined;
                        }
                        const keyPayload = new models_dist.DecryptedPayload(payload);
                        const key = new models_dist.KeySystemRootKey(keyPayload);
                        return key;
                    }
                    getMemCachedRootKey(systemIdentifier) {
                        return this.rootKeyMemoryCache[systemIdentifier];
                    }
                    storageKeyForRootKey(systemIdentifier) {
                        return "".concat(RootKeyStorageKeyPrefix).concat(systemIdentifier);
                    }
                    /**
                     * When the key system root key changes, we must re-encrypt all vault items keys
                     * with this new key system root key (by simply re-syncing).
                     */
                    queueVaultItemsKeysForReencryption(keySystemIdentifier) {
                        return KeySystemKeyManager_awaiter(this, void 0, void 0, function* () {
                            const keySystemItemsKeys = this.getKeySystemItemsKeys(keySystemIdentifier);
                            if (keySystemItemsKeys.length > 0) {
                                yield this.mutator.setItemsDirty(keySystemItemsKeys);
                            }
                        });
                    }
                    cacheKey(key, storage) {
                        this.rootKeyMemoryCache[key.systemIdentifier] = key;
                        if (storage === models_dist.KeySystemRootKeyStorageMode.Local) {
                            this.storage.setValue(this.storageKeyForRootKey(key.systemIdentifier), key.payload.ejected());
                        }
                    }
                    removeKeyFromCache(systemIdentifier) {
                        delete this.rootKeyMemoryCache[systemIdentifier];
                        void this.storage.removeValue(this.storageKeyForRootKey(systemIdentifier));
                    }
                    getAllSyncedKeySystemRootKeys() {
                        return this.items.getItems(src.ContentType.TYPES.KeySystemRootKey);
                    }
                    wipeVaultKeysFromMemory(vault) {
                        return KeySystemKeyManager_awaiter(this, void 0, void 0, function* () {
                            delete this.rootKeyMemoryCache[vault.systemIdentifier];
                            const itemsKeys = this.getKeySystemItemsKeys(vault.systemIdentifier);
                            yield this._removeItemsFromMemory.execute(itemsKeys);
                        });
                    }
                    getSyncedKeySystemRootKeysForVault(systemIdentifier) {
                        return this.items.itemsMatchingPredicate(src.ContentType.TYPES.KeySystemRootKey, new models_dist.Predicate('systemIdentifier', '=', systemIdentifier));
                    }
                    getAllKeySystemRootKeysForVault(systemIdentifier) {
                        const synced = this.getSyncedKeySystemRootKeysForVault(systemIdentifier);
                        const memory = this.rootKeyMemoryCache[systemIdentifier] ? [this.rootKeyMemoryCache[systemIdentifier]] : [];
                        return [...synced, ...memory];
                    }
                    deleteNonPersistentSystemRootKeysForVault(systemIdentifier) {
                        return KeySystemKeyManager_awaiter(this, void 0, void 0, function* () {
                            delete this.rootKeyMemoryCache[systemIdentifier];
                            yield this.storage.removeValue(this.storageKeyForRootKey(systemIdentifier));
                        });
                    }
                    deleteAllSyncedKeySystemRootKeys(systemIdentifier) {
                        return KeySystemKeyManager_awaiter(this, void 0, void 0, function* () {
                            const keys = this.getSyncedKeySystemRootKeysForVault(systemIdentifier);
                            yield this.mutator.setItemsToBeDeleted(keys);
                        });
                    }
                    getPrimaryKeySystemRootKey(systemIdentifier) {
                        const keys = this.getAllKeySystemRootKeysForVault(systemIdentifier);
                        const sortedByNewestFirst = keys.sort((a, b) => b.keyParams.creationTimestamp - a.keyParams.creationTimestamp);
                        return sortedByNewestFirst[0];
                    }
                    getAllKeySystemItemsKeys() {
                        const decryptedItems = this.items.getItems(src.ContentType.TYPES.KeySystemItemsKey);
                        const encryptedItems = this.items.invalidItems.filter(item => item.content_type === src.ContentType.TYPES.KeySystemItemsKey);
                        return [...decryptedItems, ...encryptedItems];
                    }
                    getKeySystemItemsKeys(systemIdentifier) {
                        return this.items.getItems(src.ContentType.TYPES.KeySystemItemsKey).filter(key => key.key_system_identifier === systemIdentifier);
                    }
                    getPrimaryKeySystemItemsKey(systemIdentifier) {
                        const rootKey = this.getPrimaryKeySystemRootKey(systemIdentifier);
                        if (!rootKey) {
                            throw new Error('No primary key system root key found');
                        }
                        const matchingItemsKeys = this.getKeySystemItemsKeys(systemIdentifier).filter(key => key.rootKeyToken === rootKey.token);
                        const sortedByNewestFirst = matchingItemsKeys.sort((a, b) => b.creationTimestamp - a.creationTimestamp);
                        return sortedByNewestFirst[0];
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Preferences/LocalPrefKey.ts
                var LocalPrefKey;
                (function (LocalPrefKey) {
                    LocalPrefKey["ActiveThemes"] = "activeThemes";
                    LocalPrefKey["UseSystemColorScheme"] = "useSystemColorScheme";
                    LocalPrefKey["UseTranslucentUI"] = "useTranslucentUI";
                    LocalPrefKey["AutoLightThemeIdentifier"] = "autoLightThemeIdentifier";
                    LocalPrefKey["AutoDarkThemeIdentifier"] = "autoDarkThemeIdentifier";
                    LocalPrefKey["EditorMonospaceEnabled"] = "monospaceFont";
                    LocalPrefKey["EditorLineHeight"] = "editorLineHeight";
                    LocalPrefKey["EditorLineWidth"] = "editorLineWidth";
                    LocalPrefKey["EditorFontSize"] = "editorFontSize";
                })(LocalPrefKey || (LocalPrefKey = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Preferences/PreferenceServiceInterface.ts
                var PreferencesServiceEvent;
                (function (PreferencesServiceEvent) {
                    PreferencesServiceEvent["LocalPreferencesChanged"] = "LocalPreferencesChanged";
                    PreferencesServiceEvent["PreferencesChanged"] = "PreferencesChanged";
                })(PreferencesServiceEvent || (PreferencesServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Protection/MobileUnlockTiming.ts
                var MobileUnlockTiming;
                (function (MobileUnlockTiming) {
                    MobileUnlockTiming["Immediately"] = "immediately";
                    MobileUnlockTiming["OnQuit"] = "on-quit";
                })(MobileUnlockTiming || (MobileUnlockTiming = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Protection/ProtectionEvent.ts
                var ProtectionEvent;
                (function (ProtectionEvent) {
                    ProtectionEvent["UnprotectedSessionBegan"] = "Protection:UnprotectedSessionBegan";
                    ProtectionEvent["UnprotectedSessionExpired"] = "Protection:UnprotectedSessionExpired";
                    ProtectionEvent["BiometricsSoftLockEngaged"] = "Protection:BiometricsSoftLockEngaged";
                    ProtectionEvent["BiometricsSoftLockDisengaged"] = "Protection:BiometricsSoftLockDisengaged";
                })(ProtectionEvent || (ProtectionEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Revision/RevisionManager.ts
                var RevisionManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RevisionManager extends AbstractService {
                    constructor(revisionApiService, internalEventBus) {
                        super(internalEventBus);
                        this.revisionApiService = revisionApiService;
                        this.internalEventBus = internalEventBus;
                    }
                    listRevisions(itemUuid) {
                        return RevisionManager_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.revisionApiService.listRevisions(itemUuid.value);
                            if ((0, dist.isErrorResponse)(result)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(result).message);
                            }
                            return result.data.revisions;
                        });
                    }
                    deleteRevision(itemUuid, revisionUuid) {
                        return RevisionManager_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.revisionApiService.deleteRevision(itemUuid.value, revisionUuid.value);
                            if ((0, dist.isErrorResponse)(result)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(result).message);
                            }
                            return result.data.message;
                        });
                    }
                    getRevision(itemUuid, revisionUuid) {
                        return RevisionManager_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.revisionApiService.getRevision(itemUuid.value, revisionUuid.value);
                            if ((0, dist.isErrorResponse)(result)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(result).message);
                            }
                            return result.data.revision;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Storage/StorageTypes.ts
                /* istanbul ignore file */
                var StoragePersistencePolicies;
                (function (StoragePersistencePolicies) {
                    StoragePersistencePolicies[StoragePersistencePolicies["Default"] = 1] = "Default";
                    StoragePersistencePolicies[StoragePersistencePolicies["Ephemeral"] = 2] = "Ephemeral";
                })(StoragePersistencePolicies || (StoragePersistencePolicies = {}));
                var StorageValueModes;
                (function (StorageValueModes) {
                    /** Stored inside wrapped encrypted storage object */
                    StorageValueModes[StorageValueModes["Default"] = 1] = "Default";
                    /** Stored outside storage object, unencrypted */
                    StorageValueModes[StorageValueModes["Nonwrapped"] = 2] = "Nonwrapped";
                })(StorageValueModes || (StorageValueModes = {}));
                var ValueModesKeys;
                (function (ValueModesKeys) {
                    /* Is encrypted */
                    ValueModesKeys["Wrapped"] = "wrapped";
                    /* Is decrypted */
                    ValueModesKeys["Unwrapped"] = "unwrapped";
                    /* Lives outside of wrapped/unwrapped */
                    ValueModesKeys["Nonwrapped"] = "nonwrapped";
                })(ValueModesKeys || (ValueModesKeys = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/RootKeyManager/RootKeyManager.ts
                var RootKeyManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RootKeyManager extends AbstractService {
                    constructor(device, storage, operators, identifier, _reencryptTypeAItems, eventBus) {
                        super(eventBus);
                        this.device = device;
                        this.storage = storage;
                        this.operators = operators;
                        this.identifier = identifier;
                        this._reencryptTypeAItems = _reencryptTypeAItems;
                        this.keyMode = KeyMode.RootKeyNone;
                    }
                    deinit() {
                        super.deinit();
                        this.device = undefined;
                        this.storage = undefined;
                        this.operators = undefined;
                        this.identifier = undefined;
                        this._reencryptTypeAItems = undefined;
                        this.rootKey = undefined;
                        this.memoizedRootKeyParams = undefined;
                    }
                    initialize() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const wrappedRootKey = this.getWrappedRootKey();
                            const accountKeyParams = this.recomputeAccountKeyParams();
                            const hasWrapper = yield this.hasRootKeyWrapper();
                            const hasRootKey = wrappedRootKey != undefined || accountKeyParams != undefined;
                            if (hasWrapper && hasRootKey) {
                                this.keyMode = KeyMode.RootKeyPlusWrapper;
                            }
                            else if (hasWrapper && !hasRootKey) {
                                this.keyMode = KeyMode.WrapperOnly;
                            }
                            else if (!hasWrapper && hasRootKey) {
                                this.keyMode = KeyMode.RootKeyOnly;
                            }
                            else if (!hasWrapper && !hasRootKey) {
                                this.keyMode = KeyMode.RootKeyNone;
                            }
                            else {
                                throw 'Invalid key mode condition';
                            }
                            if (this.keyMode === KeyMode.RootKeyOnly) {
                                this.setRootKeyInstance(yield this.getRootKeyFromKeychain());
                                yield this.handleKeyStatusChange();
                            }
                        });
                    }
                    getMemoizedRootKeyParams() {
                        return this.memoizedRootKeyParams;
                    }
                    getKeyMode() {
                        return this.keyMode;
                    }
                    hasRootKeyWrapper() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const wrapper = this.getRootKeyWrapperKeyParams();
                            return wrapper != undefined;
                        });
                    }
                    getRootKeyWrapperKeyParams() {
                        const rawKeyParams = this.storage.getValue(StorageKey.RootKeyWrapperKeyParams, StorageValueModes.Nonwrapped);
                        if (!rawKeyParams) {
                            return undefined;
                        }
                        return (0, encryption_src /* CreateAnyKeyParams */.jl)(rawKeyParams);
                    }
                    passcodeUpgradeAvailable() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const passcodeParams = this.getRootKeyWrapperKeyParams();
                            if (!passcodeParams) {
                                return false;
                            }
                            return passcodeParams.version !== dist_src.ProtocolVersionLatest;
                        });
                    }
                    hasAccount() {
                        switch (this.keyMode) {
                            case KeyMode.RootKeyNone:
                            case KeyMode.WrapperOnly:
                                return false;
                            case KeyMode.RootKeyOnly:
                            case KeyMode.RootKeyPlusWrapper:
                                return true;
                            default:
                                throw Error('Unhandled keyMode value.');
                        }
                    }
                    getUserVersion() {
                        const keyParams = this.memoizedRootKeyParams;
                        return keyParams === null || keyParams === void 0 ? void 0 : keyParams.version;
                    }
                    hasRootKeyEncryptionSource() {
                        return this.hasAccount() || this.hasPasscode();
                    }
                    computeRootKey(password, keyParams) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const version = keyParams.version;
                            const operator = this.operators.operatorForVersion(version);
                            return operator.computeRootKey(password, keyParams);
                        });
                    }
                    /**
                     * Deletes root key and wrapper from keychain. Used when signing out of application.
                     */
                    deleteWorkspaceSpecificKeyStateFromDevice() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            yield this.device.clearNamespacedKeychainValue(this.identifier);
                            yield this.storage.removeValue(StorageKey.WrappedRootKey, StorageValueModes.Nonwrapped);
                            yield this.storage.removeValue(StorageKey.RootKeyWrapperKeyParams, StorageValueModes.Nonwrapped);
                            yield this.storage.removeValue(StorageKey.RootKeyParams, StorageValueModes.Nonwrapped);
                            this.keyMode = KeyMode.RootKeyNone;
                            this.setRootKeyInstance(undefined);
                            yield this.handleKeyStatusChange();
                        });
                    }
                    createRootKey(identifier, password, origination, version) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const operator = version ? this.operators.operatorForVersion(version) : this.operators.defaultOperator();
                            return operator.createRootKey(identifier, password, origination);
                        });
                    }
                    validateAccountPassword(password) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const key = yield this.computeRootKey(password, this.memoizedRootKeyParams);
                            const valid = this.getSureRootKey().compare(key);
                            if (valid) {
                                return {
                                    valid,
                                    artifacts: {
                                        rootKey: key
                                    }
                                };
                            }
                            else {
                                return {
                                    valid: false
                                };
                            }
                        });
                    }
                    validatePasscode(passcode) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const keyParams = this.getSureRootKeyWrapperKeyParams();
                            const key = yield this.computeRootKey(passcode, keyParams);
                            const valid = yield this.validateWrappingKey(key);
                            if (valid) {
                                return {
                                    valid,
                                    artifacts: {
                                        wrappingKey: key
                                    }
                                };
                            }
                            else {
                                return {
                                    valid: false
                                };
                            }
                        });
                    }
                    getEncryptionSourceVersion() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (this.hasAccount()) {
                                return this.getSureUserVersion();
                            }
                            else if (this.hasPasscode()) {
                                const passcodeParams = this.getSureRootKeyWrapperKeyParams();
                                return passcodeParams.version;
                            }
                            throw Error('Attempting to access encryption source version without source');
                        });
                    }
                    getSureUserVersion() {
                        const keyParams = this.memoizedRootKeyParams;
                        return keyParams.version;
                    }
                    handleKeyStatusChange() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            this.recomputeAccountKeyParams();
                            void this.notifyEvent(RootKeyManagerEvent.RootKeyManagerKeyStatusChanged);
                        });
                    }
                    hasPasscode() {
                        return this.keyMode === KeyMode.WrapperOnly || this.keyMode === KeyMode.RootKeyPlusWrapper;
                    }
                    recomputeAccountKeyParams() {
                        const rawKeyParams = this.storage.getValue(StorageKey.RootKeyParams, StorageValueModes.Nonwrapped);
                        if (!rawKeyParams) {
                            return;
                        }
                        this.memoizedRootKeyParams = (0, encryption_src /* CreateAnyKeyParams */.jl)(rawKeyParams);
                        return this.memoizedRootKeyParams;
                    }
                    getSureRootKeyWrapperKeyParams() {
                        return this.getRootKeyWrapperKeyParams();
                    }
                    /**
                     * Wraps the current in-memory root key value using the wrappingKey,
                     * then persists the wrapped value to disk.
                     */
                    wrapAndPersistRootKey(wrappingKey) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const rootKey = this.getSureRootKey();
                            const value = Object.assign(Object.assign({}, rootKey.payload.ejected()), {
                                content: (0, models_dist.FillItemContentSpecialized)(rootKey.persistableValueWhenWrapping())
                            });
                            const payload = new models_dist.DecryptedPayload(value);
                            const usecase = new EncryptTypeAPayload(this.operators);
                            const wrappedKey = yield usecase.executeOne(payload, wrappingKey);
                            const wrappedKeyPayload = new models_dist.EncryptedPayload(Object.assign(Object.assign(Object.assign({}, payload.ejected()), wrappedKey), {
                                errorDecrypting: false,
                                waitingForKey: false
                            }));
                            this.storage.setValue(StorageKey.WrappedRootKey, wrappedKeyPayload.ejected(), StorageValueModes.Nonwrapped);
                        });
                    }
                    unwrapRootKey(wrappingKey) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (this.keyMode === KeyMode.WrapperOnly) {
                                this.setRootKeyInstance(wrappingKey);
                                return;
                            }
                            if (this.keyMode !== KeyMode.RootKeyPlusWrapper) {
                                throw 'Invalid key mode condition for unwrapping.';
                            }
                            const wrappedKey = this.getWrappedRootKey();
                            const payload = new models_dist.EncryptedPayload(wrappedKey);
                            const usecase = new DecryptTypeAPayload(this.operators);
                            const decrypted = yield usecase.executeOne(payload, wrappingKey);
                            if ((0, encryption_src /* isErrorDecryptingParameters */.XL)(decrypted)) {
                                throw Error('Unable to decrypt root key with provided wrapping key.');
                            }
                            else {
                                const decryptedPayload = new models_dist.DecryptedPayload(Object.assign(Object.assign({}, payload.ejected()), decrypted));
                                this.setRootKeyInstance(new encryption_src /* SNRootKey */.t$(decryptedPayload));
                                yield this.handleKeyStatusChange();
                            }
                        });
                    }
                    /**
                     * Encrypts rootKey and saves it in storage instead of keychain, and then
                     * clears keychain. This is because we don't want to store large encrypted
                     * payloads in the keychain. If the root key is not wrapped, it is stored
                     * in plain form in the user's secure keychain.
                     */
                    setNewRootKeyWrapper(wrappingKey) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (this.keyMode === KeyMode.RootKeyNone) {
                                this.keyMode = KeyMode.WrapperOnly;
                            }
                            else if (this.keyMode === KeyMode.RootKeyOnly) {
                                this.keyMode = KeyMode.RootKeyPlusWrapper;
                            }
                            else {
                                throw Error('Attempting to set wrapper on already wrapped key.');
                            }
                            yield this.device.clearNamespacedKeychainValue(this.identifier);
                            if (this.keyMode === KeyMode.WrapperOnly || this.keyMode === KeyMode.RootKeyPlusWrapper) {
                                if (this.keyMode === KeyMode.WrapperOnly) {
                                    this.setRootKeyInstance(wrappingKey);
                                    yield this._reencryptTypeAItems.execute();
                                }
                                else {
                                    yield this.wrapAndPersistRootKey(wrappingKey);
                                }
                                this.storage.setValue(StorageKey.RootKeyWrapperKeyParams, wrappingKey.keyParams.getPortableValue(), StorageValueModes.Nonwrapped);
                                yield this.handleKeyStatusChange();
                            }
                            else {
                                throw Error('Invalid keyMode on setNewRootKeyWrapper');
                            }
                        });
                    }
                    /**
                     * Removes root key wrapper from local storage and stores root key bare in secure keychain.
                     */
                    removeRootKeyWrapper() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (this.keyMode !== KeyMode.WrapperOnly && this.keyMode !== KeyMode.RootKeyPlusWrapper) {
                                throw Error('Attempting to remove root key wrapper on unwrapped key.');
                            }
                            if (this.keyMode === KeyMode.WrapperOnly) {
                                this.keyMode = KeyMode.RootKeyNone;
                                this.setRootKeyInstance(undefined);
                            }
                            else if (this.keyMode === KeyMode.RootKeyPlusWrapper) {
                                this.keyMode = KeyMode.RootKeyOnly;
                            }
                            yield this.storage.removeValue(StorageKey.WrappedRootKey, StorageValueModes.Nonwrapped);
                            yield this.storage.removeValue(StorageKey.RootKeyWrapperKeyParams, StorageValueModes.Nonwrapped);
                            if (this.keyMode === KeyMode.RootKeyOnly) {
                                yield this.saveRootKeyToKeychain();
                            }
                            yield this.handleKeyStatusChange();
                        });
                    }
                    setRootKey(key, wrappingKey) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (!key.keyParams) {
                                throw Error('keyParams must be supplied if setting root key.');
                            }
                            if (this.getRootKey() === key) {
                                throw Error('Attempting to set root key as same current value.');
                            }
                            if (this.keyMode === KeyMode.WrapperOnly) {
                                this.keyMode = KeyMode.RootKeyPlusWrapper;
                            }
                            else if (this.keyMode === KeyMode.RootKeyNone) {
                                this.keyMode = KeyMode.RootKeyOnly;
                            }
                            else if (this.keyMode === KeyMode.RootKeyOnly || this.keyMode === KeyMode.RootKeyPlusWrapper) {
                                /** Root key is simply changing, mode stays the same */
                                /** this.keyMode = this.keyMode; */
                            }
                            else {
                                throw Error('Unhandled key mode for setNewRootKey');
                            }
                            this.setRootKeyInstance(key);
                            this.storage.setValue(StorageKey.RootKeyParams, key.keyParams.getPortableValue(), StorageValueModes.Nonwrapped);
                            if (this.keyMode === KeyMode.RootKeyOnly) {
                                yield this.saveRootKeyToKeychain();
                            }
                            else if (this.keyMode === KeyMode.RootKeyPlusWrapper) {
                                if (!wrappingKey) {
                                    throw Error('wrappingKey must be supplied');
                                }
                                yield this.wrapAndPersistRootKey(wrappingKey);
                            }
                            yield this.handleKeyStatusChange();
                        });
                    }
                    getRootKeyParams() {
                        if (this.keyMode === KeyMode.WrapperOnly) {
                            return this.getRootKeyWrapperKeyParams();
                        }
                        else if (this.keyMode === KeyMode.RootKeyOnly || this.keyMode === KeyMode.RootKeyPlusWrapper) {
                            return this.recomputeAccountKeyParams();
                        }
                        else if (this.keyMode === KeyMode.RootKeyNone) {
                            return undefined;
                        }
                        else {
                            throw 'Unhandled key mode for getRootKeyParams';
                        }
                    }
                    getSureRootKeyParams() {
                        return this.getRootKeyParams();
                    }
                    saveRootKeyToKeychain() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            if (this.getRootKey() == undefined) {
                                throw 'Attempting to non-existent root key to the keychain.';
                            }
                            if (this.keyMode !== KeyMode.RootKeyOnly) {
                                throw 'Should not be persisting wrapped key to keychain.';
                            }
                            const rawKey = this.getSureRootKey().getKeychainValue();
                            return this.executeCriticalFunction(() => {
                                return this.device.setNamespacedKeychainValue(rawKey, this.identifier);
                            });
                        });
                    }
                    /**
                     * We know a wrappingKey is correct if it correctly decrypts
                     * wrapped root key.
                     */
                    validateWrappingKey(wrappingKey) {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const wrappedRootKey = this.getWrappedRootKey();
                            /** If wrapper only, storage is encrypted directly with wrappingKey */
                            if (this.keyMode === KeyMode.WrapperOnly) {
                                return this.storage.canDecryptWithKey(wrappingKey);
                            }
                            else if (this.keyMode === KeyMode.RootKeyOnly || this.keyMode === KeyMode.RootKeyPlusWrapper) {
                                /**
                                 * In these modes, storage is encrypted with account keys, and
                                 * account keys are encrypted with wrappingKey. Here we validate
                                 * by attempting to decrypt account keys.
                                 */
                                const wrappedKeyPayload = new models_dist.EncryptedPayload(wrappedRootKey);
                                const usecase = new DecryptTypeAPayload(this.operators);
                                const decrypted = yield usecase.executeOne(wrappedKeyPayload, wrappingKey);
                                return !(0, encryption_src /* isErrorDecryptingParameters */.XL)(decrypted);
                            }
                            else {
                                throw 'Unhandled case in validateWrappingKey';
                            }
                        });
                    }
                    getWrappedRootKey() {
                        return this.storage.getValue(StorageKey.WrappedRootKey, StorageValueModes.Nonwrapped);
                    }
                    setRootKeyInstance(rootKey) {
                        this.rootKey = rootKey;
                    }
                    getRootKey() {
                        return this.rootKey;
                    }
                    getSureRootKey() {
                        return this.rootKey;
                    }
                    getRootKeyFromKeychain() {
                        return RootKeyManager_awaiter(this, void 0, void 0, function* () {
                            const rawKey = yield this.device.getNamespacedKeychainValue(this.identifier);
                            if (rawKey == undefined) {
                                return undefined;
                            }
                            const keyParams = this.getSureRootKeyParams();
                            return (0, encryption_src /* CreateNewRootKey */.C4)(Object.assign(Object.assign({}, rawKey), {
                                keyParams: keyParams.getPortableValue()
                            }));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Session/SessionEvent.ts
                var SessionEvent;
                (function (SessionEvent) {
                    SessionEvent["Restored"] = "SessionEvent:SessionRestored";
                    SessionEvent["Revoked"] = "SessionEvent:SessionRevoked";
                    SessionEvent["UserKeyPairChanged"] = "SessionEvent:UserKeyPairChanged";
                })(SessionEvent || (SessionEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/SharedVaultServiceEvent.ts
                var SharedVaultServiceEvent;
                (function (SharedVaultServiceEvent) {
                    SharedVaultServiceEvent["SharedVaultStatusChanged"] = "SharedVaultStatusChanged";
                    SharedVaultServiceEvent["SharedVaultFileStorageUsageChanged"] = "SharedVaultFileStorageUsageChanged";
                })(SharedVaultServiceEvent || (SharedVaultServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/UserEvent/NotificationServiceEvent.ts
                var NotificationServiceEvent;
                (function (NotificationServiceEvent) {
                    NotificationServiceEvent["NotificationReceived"] = "NotificationReceived";
                })(NotificationServiceEvent || (NotificationServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/SharedVaultService.ts
                var SharedVaultService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SharedVaultService extends AbstractService {
                    constructor(items, session, vaultUsers, _syncLocalVaultsWithRemoteSharedVaults, _getVault, _getOwnedSharedVaults, _createSharedVault, _handleKeyPairChange, _findContact, _deleteThirdPartyVault, _shareContactWithVault, _convertToSharedVault, _deleteSharedVault, _discardItemsLocally, eventBus) {
                        super(eventBus);
                        this.items = items;
                        this.session = session;
                        this.vaultUsers = vaultUsers;
                        this._syncLocalVaultsWithRemoteSharedVaults = _syncLocalVaultsWithRemoteSharedVaults;
                        this._getVault = _getVault;
                        this._getOwnedSharedVaults = _getOwnedSharedVaults;
                        this._createSharedVault = _createSharedVault;
                        this._handleKeyPairChange = _handleKeyPairChange;
                        this._findContact = _findContact;
                        this._deleteThirdPartyVault = _deleteThirdPartyVault;
                        this._shareContactWithVault = _shareContactWithVault;
                        this._convertToSharedVault = _convertToSharedVault;
                        this._deleteSharedVault = _deleteSharedVault;
                        this._discardItemsLocally = _discardItemsLocally;
                        this.eventDisposers.push(items.addObserver(src.ContentType.TYPES.TrustedContact, _ref => {
                            let { changed, source } = _ref;
                            return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                                if (source === models_dist.PayloadEmitSource.LocalChanged && changed.length > 0) {
                                    void this.handleTrustedContactsChange(changed);
                                }
                            });
                        }));
                    }
                    deinit() {
                        super.deinit();
                        this.items = undefined;
                        this.session = undefined;
                        this._syncLocalVaultsWithRemoteSharedVaults = undefined;
                        this._getVault = undefined;
                        this._createSharedVault = undefined;
                        this._handleKeyPairChange = undefined;
                        this._findContact = undefined;
                        this._deleteThirdPartyVault = undefined;
                        this._shareContactWithVault = undefined;
                        this._convertToSharedVault = undefined;
                        this._deleteSharedVault = undefined;
                    }
                    handleEvent(event) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case SessionEvent.UserKeyPairChanged:
                                    {
                                        const eventData = event.payload;
                                        void this._handleKeyPairChange.execute({
                                            newKeys: eventData.current,
                                            previousKeys: eventData.previous
                                        });
                                        break;
                                    }
                                case NotificationServiceEvent.NotificationReceived:
                                    yield this.handleNotification(event.payload);
                                    break;
                                case SyncEvent.ReceivedRemoteSharedVaults:
                                    void this.notifyEvent(SharedVaultServiceEvent.SharedVaultStatusChanged);
                                    break;
                            }
                        });
                    }
                    handleNotification(event) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            switch (event.eventPayload.props.type.value) {
                                case src.NotificationType.TYPES.SelfRemovedFromSharedVault:
                                    {
                                        const vault = this._getVault.execute({
                                            sharedVaultUuid: event.eventPayload.props.primaryIdentifier.value
                                        });
                                        if (!vault.isFailed()) {
                                            yield this._deleteThirdPartyVault.execute(vault.getValue());
                                        }
                                        break;
                                    }
                                case src.NotificationType.TYPES.UserRemovedFromSharedVault:
                                    {
                                        const vaultOrError = this._getVault.execute({
                                            sharedVaultUuid: event.eventPayload.props.primaryIdentifier.value
                                        });
                                        if (!vaultOrError.isFailed()) {
                                            const vault = vaultOrError.getValue();
                                            this.vaultUsers.invalidateVaultUsersCache(event.eventPayload.props.primaryIdentifier.value).catch(console.error);
                                            yield this._syncLocalVaultsWithRemoteSharedVaults.execute([vault]);
                                            void this.notifyEvent(SharedVaultServiceEvent.SharedVaultStatusChanged);
                                        }
                                        break;
                                    }
                                case src.NotificationType.TYPES.SharedVaultItemRemoved:
                                    {
                                        const item = this.items.findItem(event.eventPayload.props.secondaryIdentifier.value);
                                        if (item) {
                                            void this._discardItemsLocally.execute([item]);
                                        }
                                        break;
                                    }
                                case src.NotificationType.TYPES.SharedVaultFileRemoved:
                                case src.NotificationType.TYPES.SharedVaultFileUploaded:
                                case src.NotificationType.TYPES.UserDesignatedAsSurvivor:
                                    {
                                        const vaultOrError = this._getVault.execute({
                                            sharedVaultUuid: event.eventPayload.props.primaryIdentifier.value
                                        });
                                        if (!vaultOrError.isFailed()) {
                                            yield this._syncLocalVaultsWithRemoteSharedVaults.execute([vaultOrError.getValue()]);
                                            void this.notifyEvent(SharedVaultServiceEvent.SharedVaultStatusChanged);
                                        }
                                        break;
                                    }
                            }
                        });
                    }
                    createSharedVault(dto) {
                        var _a;
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            return this._createSharedVault.execute({
                                vaultName: dto.name,
                                vaultDescription: dto.description,
                                vaultIcon: dto.iconString,
                                userInputtedPassword: dto.userInputtedPassword,
                                storagePreference: (_a = dto.storagePreference) !== null && _a !== void 0 ? _a : models_dist.KeySystemRootKeyStorageMode.Synced
                            });
                        });
                    }
                    convertVaultToSharedVault(vault) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            return this._convertToSharedVault.execute({
                                vault
                            });
                        });
                    }
                    handleTrustedContactsChange(contacts) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            for (const contact of contacts) {
                                if (contact.isMe) {
                                    continue;
                                }
                                yield this.shareContactWithVaults(contact);
                            }
                        });
                    }
                    deleteSharedVault(sharedVault) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            return this._deleteSharedVault.execute({
                                sharedVault
                            });
                        });
                    }
                    shareContactWithVaults(contact) {
                        return SharedVaultService_awaiter(this, void 0, void 0, function* () {
                            if (contact.isMe) {
                                throw new Error('Cannot share self contact');
                            }
                            const ownedVaults = this._getOwnedSharedVaults.execute().getValue();
                            for (const vault of ownedVaults) {
                                yield this._shareContactWithVault.execute({
                                    sharedVault: vault,
                                    contactToShare: contact
                                });
                            }
                        });
                    }
                    getItemLastEditedBy(item) {
                        if (!item.last_edited_by_uuid) {
                            return undefined;
                        }
                        const contact = this._findContact.execute({
                            userUuid: item.last_edited_by_uuid
                        });
                        return contact.isFailed() ? undefined : contact.getValue();
                    }
                    getItemSharedBy(item) {
                        if (!item.user_uuid || item.user_uuid === this.session.getSureUser().uuid) {
                            return undefined;
                        }
                        const contact = this._findContact.execute({
                            userUuid: item.user_uuid
                        });
                        return contact.isFailed() ? undefined : contact.getValue();
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/ContactBelongsToVault.ts
                var ContactBelongsToVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ContactBelongsToVault {
                    constructor(getVaultUsers) {
                        this.getVaultUsers = getVaultUsers;
                    }
                    execute(dto) {
                        return ContactBelongsToVault_awaiter(this, void 0, void 0, function* () {
                            const users = yield this.getVaultUsers.execute({
                                sharedVaultUuid: dto.vault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (users.isFailed()) {
                                return src.Result.fail('Failed to get vault users');
                            }
                            return src.Result.ok(users.getValue().some(u => u.user_uuid === dto.contact.contactUuid));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/ConvertToSharedVault.ts
                var ConvertToSharedVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ConvertToSharedVault {
                    constructor(mutator, sharedVaultServer, _moveItemsToVault, _getVaultItems) {
                        this.mutator = mutator;
                        this.sharedVaultServer = sharedVaultServer;
                        this._moveItemsToVault = _moveItemsToVault;
                        this._getVaultItems = _getVaultItems;
                    }
                    execute(dto) {
                        return ConvertToSharedVault_awaiter(this, void 0, void 0, function* () {
                            if (dto.vault.isSharedVaultListing()) {
                                throw new Error('Cannot convert a shared vault to a shared vault');
                            }
                            const serverResult = yield this.sharedVaultServer.createSharedVault();
                            if ((0, dist.isErrorResponse)(serverResult)) {
                                return dist.ClientDisplayableError.FromString("Failed to convert to shared vault ".concat(JSON.stringify(serverResult)));
                            }
                            const serverVaultHash = serverResult.data.sharedVault;
                            const sharedVaultListing = yield this.mutator.changeItem(dto.vault, mutator => {
                                mutator.sharing = {
                                    sharedVaultUuid: serverVaultHash.uuid,
                                    ownerUserUuid: serverVaultHash.user_uuid,
                                    fileBytesUsed: serverVaultHash.file_upload_bytes_used,
                                    designatedSurvivor: null
                                };
                            });
                            const vaultItems = this._getVaultItems.execute(sharedVaultListing).getValue();
                            yield this._moveItemsToVault.execute({
                                vault: sharedVaultListing,
                                items: vaultItems
                            });
                            return sharedVaultListing;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/CreateSharedVault.ts
                var CreateSharedVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateSharedVault {
                    constructor(mutator, sharedVaultServer, _createVault, _moveItemsToVault, _getVaultItems) {
                        this.mutator = mutator;
                        this.sharedVaultServer = sharedVaultServer;
                        this._createVault = _createVault;
                        this._moveItemsToVault = _moveItemsToVault;
                        this._getVaultItems = _getVaultItems;
                    }
                    execute(dto) {
                        var _a;
                        return CreateSharedVault_awaiter(this, void 0, void 0, function* () {
                            const privateVault = yield this._createVault.execute({
                                vaultName: dto.vaultName,
                                vaultDescription: dto.vaultDescription,
                                vaultIcon: dto.vaultIcon,
                                userInputtedPassword: dto.userInputtedPassword,
                                storagePreference: dto.storagePreference
                            });
                            const serverResult = yield this.sharedVaultServer.createSharedVault();
                            if ((0, dist.isErrorResponse)(serverResult)) {
                                return dist.ClientDisplayableError.FromString("Failed to create shared vault: ".concat((_a = serverResult.data.error) === null || _a === void 0 ? void 0 : _a.message));
                            }
                            const serverVaultHash = serverResult.data.sharedVault;
                            const sharedVaultListing = yield this.mutator.changeItem(privateVault, mutator => {
                                mutator.sharing = {
                                    sharedVaultUuid: serverVaultHash.uuid,
                                    ownerUserUuid: serverVaultHash.user_uuid,
                                    fileBytesUsed: serverVaultHash.file_upload_bytes_used,
                                    designatedSurvivor: null
                                };
                            });
                            const vaultItems = this._getVaultItems.execute(sharedVaultListing).getValue();
                            yield this._moveItemsToVault.execute({
                                vault: sharedVaultListing,
                                items: vaultItems
                            });
                            return sharedVaultListing;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/DeleteExternalSharedVault.ts
                var DeleteExternalSharedVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteThirdPartyVault {
                    constructor(items, mutator, keys, sync, _discardItemsLocally) {
                        this.items = items;
                        this.mutator = mutator;
                        this.keys = keys;
                        this.sync = sync;
                        this._discardItemsLocally = _discardItemsLocally;
                    }
                    execute(vault) {
                        return DeleteExternalSharedVault_awaiter(this, void 0, void 0, function* () {
                            yield this.deleteDataSharedByVaultUsers(vault);
                            yield this.deleteDataOwnedByThisUser(vault);
                            yield this.keys.deleteNonPersistentSystemRootKeysForVault(vault.systemIdentifier);
                            void this.sync.sync({
                                sourceDescription: 'Not awaiting due to this event handler running from sync response'
                            });
                        });
                    }
                    /**
                     * This data is shared with all vault users and does not belong to this particular user
                     * The data will be removed locally without syncing the items
                     */
                    deleteDataSharedByVaultUsers(vault) {
                        return DeleteExternalSharedVault_awaiter(this, void 0, void 0, function* () {
                            const vaultItems = this.items.allTrackedItems().filter(item => item.key_system_identifier === vault.systemIdentifier);
                            const itemsKeys = this.keys.getKeySystemItemsKeys(vault.systemIdentifier);
                            yield this._discardItemsLocally.execute([...vaultItems, ...itemsKeys]);
                        });
                    }
                    deleteDataOwnedByThisUser(vault) {
                        return DeleteExternalSharedVault_awaiter(this, void 0, void 0, function* () {
                            const rootKeys = this.keys.getSyncedKeySystemRootKeysForVault(vault.systemIdentifier);
                            yield this.mutator.setItemsToBeDeleted(rootKeys);
                            yield this.mutator.setItemToBeDeleted(vault);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/DeleteSharedVault.ts
                var DeleteSharedVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteSharedVault {
                    constructor(sharedVaultServer, sync, deleteVault) {
                        this.sharedVaultServer = sharedVaultServer;
                        this.sync = sync;
                        this.deleteVault = deleteVault;
                    }
                    execute(params) {
                        return DeleteSharedVault_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.sharedVaultServer.deleteSharedVault({
                                sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return dist.ClientDisplayableError.FromString("Failed to delete vault ".concat(JSON.stringify(response)));
                            }
                            yield this.deleteVault.execute(params.sharedVault);
                            yield this.sync.sync();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/GetOwnedSharedVaults.ts
                class GetOwnedSharedVaults {
                    constructor(_getSharedVaults, _isVaultOwnwer) {
                        this._getSharedVaults = _getSharedVaults;
                        this._isVaultOwnwer = _isVaultOwnwer;
                    }
                    execute() {
                        const sharedVaults = this._getSharedVaults.execute().getValue();
                        const ownedVaults = sharedVaults.filter(vault => {
                            return this._isVaultOwnwer.execute(vault).getValue();
                        });
                        return src.Result.ok(ownedVaults);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/GetSharedVaults.ts
                class GetSharedVaults {
                    constructor(getVaults) {
                        this.getVaults = getVaults;
                    }
                    execute() {
                        const vaults = this.getVaults.execute().getValue().filter(vault => vault.isSharedVaultListing());
                        return src.Result.ok(vaults);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/NotifyVaultUsersOfKeyRotation.ts
                var NotifyVaultUsersOfKeyRotation_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class NotifyVaultUsersOfKeyRotation {
                    constructor(_findContact, _sendKeyChangedMessage, _inviteToVault, _inviteServer, _getVaultContacts, _decryptOwnMessage, _getKeyPairs) {
                        this._findContact = _findContact;
                        this._sendKeyChangedMessage = _sendKeyChangedMessage;
                        this._inviteToVault = _inviteToVault;
                        this._inviteServer = _inviteServer;
                        this._getVaultContacts = _getVaultContacts;
                        this._decryptOwnMessage = _decryptOwnMessage;
                        this._getKeyPairs = _getKeyPairs;
                    }
                    execute(params) {
                        return NotifyVaultUsersOfKeyRotation_awaiter(this, void 0, void 0, function* () {
                            yield this.reinvitePendingInvites(params);
                            yield this.performSendKeyChangeMessage(params);
                            return src.Result.ok();
                        });
                    }
                    reinvitePendingInvites(params) {
                        return NotifyVaultUsersOfKeyRotation_awaiter(this, void 0, void 0, function* () {
                            const existingInvites = yield this.getExistingInvites(params.sharedVault.sharing.sharedVaultUuid);
                            if (existingInvites.isFailed()) {
                                return existingInvites;
                            }
                            yield this.deleteAllInvites(params.sharedVault.sharing.sharedVaultUuid);
                            const contacts = yield this._getVaultContacts.execute({
                                sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return src.Result.fail('Cannot send metadata changed message; keys not found');
                            }
                            for (const invite of existingInvites.getValue()) {
                                const recipient = this._findContact.execute({
                                    userUuid: invite.user_uuid
                                });
                                if (recipient.isFailed()) {
                                    continue;
                                }
                                const decryptedPreviousInvite = this._decryptOwnMessage.execute({
                                    message: invite.encrypted_message,
                                    privateKey: keys.getValue().encryption.privateKey,
                                    recipientPublicKey: recipient.getValue().publicKeySet.encryption
                                });
                                if (decryptedPreviousInvite.isFailed()) {
                                    return src.Result.fail(decryptedPreviousInvite.getError());
                                }
                                yield this._inviteToVault.execute({
                                    sharedVault: params.sharedVault,
                                    sharedVaultContacts: !contacts.isFailed() ? contacts.getValue() : [],
                                    recipient: recipient.getValue(),
                                    permission: invite.permission
                                });
                            }
                            return src.Result.ok();
                        });
                    }
                    performSendKeyChangeMessage(params) {
                        return NotifyVaultUsersOfKeyRotation_awaiter(this, void 0, void 0, function* () {
                            const result = yield this._sendKeyChangedMessage.execute({
                                keySystemIdentifier: params.sharedVault.systemIdentifier,
                                sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid
                            });
                            if (result.isFailed()) {
                                return result;
                            }
                            return src.Result.ok();
                        });
                    }
                    deleteAllInvites(sharedVaultUuid) {
                        return NotifyVaultUsersOfKeyRotation_awaiter(this, void 0, void 0, function* () {
                            const response = yield this._inviteServer.deleteAllSharedVaultInvites({
                                sharedVaultUuid: sharedVaultUuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to delete existing invites ".concat(JSON.stringify(response)));
                            }
                            return src.Result.ok();
                        });
                    }
                    getExistingInvites(sharedVaultUuid) {
                        return NotifyVaultUsersOfKeyRotation_awaiter(this, void 0, void 0, function* () {
                            const response = yield this._inviteServer.getOutboundUserInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to get outbound user invites ".concat(JSON.stringify(response)));
                            }
                            const invites = response.data.invites;
                            return src.Result.ok(invites.filter(invite => invite.shared_vault_uuid === sharedVaultUuid));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/AsymmetricMessage/UseCase/GetReplaceabilityIdentifier.ts
                const TypesUsingReplaceableIdentifiers = [models_dist.AsymmetricMessagePayloadType.SharedVaultRootKeyChanged, models_dist.AsymmetricMessagePayloadType.SharedVaultMetadataChanged];
                function GetReplaceabilityIdentifier(type, sharedVaultUuid, keySystemIdentifier) {
                    if (!TypesUsingReplaceableIdentifiers.includes(type)) {
                        return undefined;
                    }
                    return [type, sharedVaultUuid, keySystemIdentifier].join(':');
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/SendVaultDataChangedMessage.ts
                var SendVaultDataChangedMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SendVaultDataChangedMessage {
                    constructor(users, _encryptMessage, _findContact, _getVaultUsers, _sendMessage, _isVaultOwner, _getKeyPairs) {
                        this.users = users;
                        this._encryptMessage = _encryptMessage;
                        this._findContact = _findContact;
                        this._getVaultUsers = _getVaultUsers;
                        this._sendMessage = _sendMessage;
                        this._isVaultOwner = _isVaultOwner;
                        this._getKeyPairs = _getKeyPairs;
                    }
                    execute(params) {
                        return SendVaultDataChangedMessage_awaiter(this, void 0, void 0, function* () {
                            const isOwner = this._isVaultOwner.execute(params.vault).getValue();
                            if (!isOwner) {
                                return src.Result.ok();
                            }
                            const users = yield this._getVaultUsers.execute({
                                sharedVaultUuid: params.vault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (users.isFailed()) {
                                return src.Result.fail('Cannot send metadata changed message; users not found');
                            }
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return src.Result.fail('Cannot send metadata changed message; keys not found');
                            }
                            const errors = [];
                            for (const user of users.getValue()) {
                                if (user.user_uuid === this.users.sureUser.uuid) {
                                    continue;
                                }
                                const trustedContact = this._findContact.execute({
                                    userUuid: user.user_uuid
                                });
                                if (trustedContact.isFailed()) {
                                    continue;
                                }
                                const sendMessageResult = yield this.sendToContact({
                                    vault: params.vault,
                                    keys: keys.getValue(),
                                    contact: trustedContact.getValue()
                                });
                                if (sendMessageResult.isFailed()) {
                                    errors.push(sendMessageResult.getError());
                                }
                            }
                            if (errors.length > 0) {
                                return src.Result.fail(errors.join(', '));
                            }
                            return src.Result.ok();
                        });
                    }
                    sendToContact(params) {
                        return SendVaultDataChangedMessage_awaiter(this, void 0, void 0, function* () {
                            const message = {
                                type: models_dist.AsymmetricMessagePayloadType.SharedVaultMetadataChanged,
                                data: {
                                    recipientUuid: params.contact.contactUuid,
                                    sharedVaultUuid: params.vault.sharing.sharedVaultUuid,
                                    name: params.vault.name,
                                    description: params.vault.description
                                }
                            };
                            const encryptedMessage = this._encryptMessage.execute({
                                message: message,
                                keys: params.keys,
                                recipientPublicKey: params.contact.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const replaceabilityIdentifier = GetReplaceabilityIdentifier(models_dist.AsymmetricMessagePayloadType.SharedVaultMetadataChanged, params.vault.sharing.sharedVaultUuid, params.vault.systemIdentifier);
                            const sendMessageResult = yield this._sendMessage.execute({
                                recipientUuid: params.contact.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                replaceabilityIdentifier
                            });
                            return sendMessageResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/SendVaultKeyChangedMessage.ts
                var SendVaultKeyChangedMessage_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SendVaultKeyChangedMessage {
                    constructor(users, keyManager, _encryptMessage, _findContact, _sendMessage, _getVaultUsers, _getKeyPairs) {
                        this.users = users;
                        this.keyManager = keyManager;
                        this._encryptMessage = _encryptMessage;
                        this._findContact = _findContact;
                        this._sendMessage = _sendMessage;
                        this._getVaultUsers = _getVaultUsers;
                        this._getKeyPairs = _getKeyPairs;
                    }
                    execute(params) {
                        return SendVaultKeyChangedMessage_awaiter(this, void 0, void 0, function* () {
                            const users = yield this._getVaultUsers.execute({
                                sharedVaultUuid: params.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (users.isFailed()) {
                                return src.Result.fail('Cannot send root key changed message; users not found');
                            }
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return src.Result.fail('Cannot send root key changed message; keys not found');
                            }
                            const errors = [];
                            for (const user of users.getValue()) {
                                if (user.user_uuid === this.users.sureUser.uuid) {
                                    continue;
                                }
                                const trustedContact = this._findContact.execute({
                                    userUuid: user.user_uuid
                                });
                                if (trustedContact.isFailed()) {
                                    continue;
                                }
                                const result = yield this.sendToContact({
                                    keySystemIdentifier: params.keySystemIdentifier,
                                    sharedVaultUuid: params.sharedVaultUuid,
                                    keys: keys.getValue(),
                                    contact: trustedContact.getValue()
                                });
                                if (result.isFailed()) {
                                    errors.push(result.getError());
                                }
                            }
                            if (errors.length > 0) {
                                return src.Result.fail(errors.join(', '));
                            }
                            return src.Result.ok();
                        });
                    }
                    sendToContact(params) {
                        return SendVaultKeyChangedMessage_awaiter(this, void 0, void 0, function* () {
                            const keySystemRootKey = this.keyManager.getPrimaryKeySystemRootKey(params.keySystemIdentifier);
                            if (!keySystemRootKey) {
                                throw new Error("Vault key not found for keySystemIdentifier ".concat(params.keySystemIdentifier));
                            }
                            const message = {
                                type: models_dist.AsymmetricMessagePayloadType.SharedVaultRootKeyChanged,
                                data: {
                                    recipientUuid: params.contact.contactUuid,
                                    rootKey: keySystemRootKey.content
                                }
                            };
                            const encryptedMessage = this._encryptMessage.execute({
                                message: message,
                                keys: params.keys,
                                recipientPublicKey: params.contact.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const replaceabilityIdentifier = GetReplaceabilityIdentifier(models_dist.AsymmetricMessagePayloadType.SharedVaultRootKeyChanged, params.sharedVaultUuid, params.keySystemIdentifier);
                            const sendMessageResult = yield this._sendMessage.execute({
                                recipientUuid: params.contact.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                replaceabilityIdentifier
                            });
                            return sendMessageResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/ShareContactWithVault.ts
                var ShareContactWithVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ShareContactWithVault {
                    constructor(users, _findContact, _encryptMessage, _sendMessage, _getVaultUsers, _getKeyPairs) {
                        this.users = users;
                        this._findContact = _findContact;
                        this._encryptMessage = _encryptMessage;
                        this._sendMessage = _sendMessage;
                        this._getVaultUsers = _getVaultUsers;
                        this._getKeyPairs = _getKeyPairs;
                    }
                    execute(params) {
                        return ShareContactWithVault_awaiter(this, void 0, void 0, function* () {
                            if (params.sharedVault.sharing.ownerUserUuid !== this.users.sureUser.uuid) {
                                return src.Result.fail('Cannot share contact; user is not the owner of the shared vault');
                            }
                            const users = yield this._getVaultUsers.execute({
                                sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (users.isFailed()) {
                                return src.Result.fail('Cannot share contact; shared vault users not found');
                            }
                            if (users.getValue().length === 0) {
                                return src.Result.ok();
                            }
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return src.Result.fail('Cannot share contact; keys not found');
                            }
                            for (const vaultUser of users.getValue()) {
                                if (vaultUser.user_uuid === this.users.sureUser.uuid) {
                                    continue;
                                }
                                if (vaultUser.user_uuid === params.contactToShare.contactUuid) {
                                    continue;
                                }
                                const vaultUserAsContact = this._findContact.execute({
                                    userUuid: vaultUser.user_uuid
                                });
                                if (vaultUserAsContact.isFailed()) {
                                    continue;
                                }
                                const encryptedMessage = this._encryptMessage.execute({
                                    message: {
                                        type: models_dist.AsymmetricMessagePayloadType.ContactShare,
                                        data: {
                                            recipientUuid: vaultUserAsContact.getValue().contactUuid,
                                            trustedContact: params.contactToShare.content
                                        }
                                    },
                                    keys: keys.getValue(),
                                    recipientPublicKey: vaultUserAsContact.getValue().publicKeySet.encryption
                                });
                                if (encryptedMessage.isFailed()) {
                                    continue;
                                }
                                yield this._sendMessage.execute({
                                    recipientUuid: vaultUserAsContact.getValue().contactUuid,
                                    encryptedMessage: encryptedMessage.getValue(),
                                    replaceabilityIdentifier: undefined
                                });
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/SharedVaults/UseCase/SyncLocalVaultsWithRemoteSharedVaults.ts
                var SyncLocalVaultsWithRemoteSharedVaults_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SyncLocalVaultsWithRemoteSharedVaults {
                    constructor(sharedVaultServer, mutator) {
                        this.sharedVaultServer = sharedVaultServer;
                        this.mutator = mutator;
                    }
                    execute(localVaults) {
                        return SyncLocalVaultsWithRemoteSharedVaults_awaiter(this, void 0, void 0, function* () {
                            const remoteVaultsResponse = yield this.sharedVaultServer.getSharedVaults();
                            if ((0, dist.isErrorResponse)(remoteVaultsResponse)) {
                                return src.Result.fail(remoteVaultsResponse.data.error.message);
                            }
                            const remoteVaults = remoteVaultsResponse.data.sharedVaults;
                            const designatedSurvivors = remoteVaultsResponse.data.designatedSurvivors || [];
                            for (const localVault of localVaults) {
                                if (!localVault.isSharedVaultListing()) {
                                    continue;
                                }
                                const remoteVault = remoteVaults.find(vault => vault.uuid === localVault.sharing.sharedVaultUuid);
                                if (remoteVault) {
                                    const designatedSurvivor = designatedSurvivors.find(survivor => survivor.sharedVaultUuid === remoteVault.uuid);
                                    yield this.mutator.changeItem(localVault, mutator => {
                                        /* istanbul ignore next */
                                        mutator.sharing = {
                                            sharedVaultUuid: remoteVault.uuid,
                                            ownerUserUuid: remoteVault.user_uuid,
                                            fileBytesUsed: remoteVault.file_upload_bytes_used,
                                            designatedSurvivor: designatedSurvivor ? designatedSurvivor.userUuid : null
                                        };
                                    });
                                }
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Status/StatusServiceInterface.ts
                /* istanbul ignore file */
                var StatusServiceEvent;
                (function (StatusServiceEvent) {
                    StatusServiceEvent["MessageChanged"] = "MessageChanged";
                    StatusServiceEvent["PreferencesBubbleCountChanged"] = "PreferencesBubbleCountChanged";
                })(StatusServiceEvent || (StatusServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Status/StatusService.ts
                /* istanbul ignore file */
                class StatusService extends AbstractService {
                    constructor() {
                        super(...arguments);
                        this.preferencesBubbleCounts = {
                            general: 0,
                            account: 0,
                            security: 0,
                            'home-server': 0,
                            vaults: 0,
                            appearance: 0,
                            backups: 0,
                            listed: 0,
                            shortcuts: 0,
                            plugins: 0,
                            accessibility: 0,
                            'get-free-month': 0,
                            'help-feedback': 0,
                            'whats-new': 0
                        };
                        this._message = '';
                        this.dynamicMessages = [];
                    }
                    getPreferencesBubbleCount(preferencePaneId) {
                        return this.preferencesBubbleCounts[preferencePaneId];
                    }
                    setPreferencesBubbleCount(preferencePaneId, count) {
                        this.preferencesBubbleCounts[preferencePaneId] = count;
                        const totalCount = this.totalPreferencesBubbleCount;
                        void this.notifyEvent(StatusServiceEvent.PreferencesBubbleCountChanged, totalCount > 0 ? totalCount.toString() : undefined);
                    }
                    get totalPreferencesBubbleCount() {
                        return Object.values(this.preferencesBubbleCounts).reduce((total, count) => total + count, 0);
                    }
                    get message() {
                        return this._message;
                    }
                    setMessage(message) {
                        this.directSetMessage = message;
                        this.recomputeMessage();
                    }
                    addMessage(message) {
                        this.dynamicMessages.push(message);
                        this.recomputeMessage();
                        return message;
                    }
                    removeMessage(message) {
                        (0, utils_dist.removeFromArray)(this.dynamicMessages, message);
                        this.recomputeMessage();
                    }
                    recomputeMessage() {
                        const messages = [...this.dynamicMessages];
                        if (this.directSetMessage) {
                            messages.unshift(this.directSetMessage);
                        }
                        this._message = this.messageFromArray(messages);
                        void this.notifyEvent(StatusServiceEvent.MessageChanged, this._message);
                    }
                    messageFromArray(messages) {
                        let message = '';
                        messages.forEach((value, index) => {
                            const isLast = index === messages.length - 1;
                            message += value;
                            if (!isLast) {
                                message += ', ';
                            }
                        });
                        return message;
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Storage/InMemoryStore.ts
                class InMemoryStore {
                    constructor() {
                        this.values = new Map();
                    }
                    setValue(key, value) {
                        this.values.set(key, value);
                    }
                    getValue(key) {
                        return this.values.get(key);
                    }
                    removeValue(key) {
                        this.values.delete(key);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Storage/UseCase/RemoveItemsFromMemory.ts
                var RemoveItemsFromMemory_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RemoveItemsFromMemory {
                    constructor(storage, items, payloads) {
                        this.storage = storage;
                        this.items = items;
                        this.payloads = payloads;
                    }
                    execute(items) {
                        return RemoveItemsFromMemory_awaiter(this, void 0, void 0, function* () {
                            this.items.removeItemsFromMemory(items);
                            const rawPayloads = yield this.storage.getRawPayloads((0, utils_dist.Uuids)(items));
                            const encryptedPayloads = rawPayloads.map(payload => (0, models_dist.CreatePayload)(payload, models_dist.PayloadSource.LocalDatabaseLoaded));
                            yield this.payloads.emitPayloads(encryptedPayloads, models_dist.PayloadEmitSource.LocalDatabaseLoaded);
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Strings/InfoStrings.ts
                const InfoStrings = {
                    AccountDeleted: 'Your account has been successfully deleted.',
                    InvalidNote: "The note you are attempting to save can not be found or has been deleted. Changes you make will not be synced. Please copy this note's text and start a new note."
                };
                ; // CONCATENATED MODULE: ../services/src/Domain/Subscription/AppleIAPProductId.ts
                var AppleIAPProductId;
                (function (AppleIAPProductId) {
                    AppleIAPProductId["ProPlanYearly"] = "pro_plan_yearly";
                    AppleIAPProductId["PlusPlanYearly"] = "plus_plan_yearly";
                })(AppleIAPProductId || (AppleIAPProductId = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Subscription/SubscriptionManagerEvent.ts
                var SubscriptionManagerEvent;
                (function (SubscriptionManagerEvent) {
                    SubscriptionManagerEvent["DidFetchSubscription"] = "Subscription:DidFetchSubscription";
                })(SubscriptionManagerEvent || (SubscriptionManagerEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Subscription/SubscriptionManager.ts
                var SubscriptionManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SubscriptionManager extends AbstractService {
                    constructor(subscriptionApiService, sessions, storage, isApplicationUsingThirdPartyHostUseCase, internalEventBus) {
                        super(internalEventBus);
                        this.subscriptionApiService = subscriptionApiService;
                        this.sessions = sessions;
                        this.storage = storage;
                        this.isApplicationUsingThirdPartyHostUseCase = isApplicationUsingThirdPartyHostUseCase;
                        this.internalEventBus = internalEventBus;
                    }
                    handleEvent(event) {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case ApplicationEvent.Launched:
                                    {
                                        void this.fetchOnlineSubscription();
                                        const isThirdPartyHostUsedOrError = this.isApplicationUsingThirdPartyHostUseCase.execute();
                                        if (isThirdPartyHostUsedOrError.isFailed()) {
                                            break;
                                        }
                                        const isThirdPartyHostUsed = isThirdPartyHostUsedOrError.getValue();
                                        if (!isThirdPartyHostUsed) {
                                            void this.fetchAvailableSubscriptions();
                                        }
                                        break;
                                    }
                                case ApplicationEvent.UserRolesChanged:
                                case SessionEvent.Restored:
                                case ApplicationEvent.SignedIn:
                                    void this.fetchOnlineSubscription();
                                    break;
                                case ApplicationEvent.ApplicationStageChanged:
                                    {
                                        const stage = event.payload.stage;
                                        if (stage === ApplicationStage.StorageDecrypted_09) {
                                            this.loadSubscriptionFromStorage();
                                        }
                                    }
                            }
                        });
                    }
                    loadSubscriptionFromStorage() {
                        this.onlineSubscription = this.storage.getValue(StorageKey.Subscription);
                        void this.notifyEvent(SubscriptionManagerEvent.DidFetchSubscription);
                    }
                    hasOnlineSubscription() {
                        return this.onlineSubscription != undefined;
                    }
                    getOnlineSubscription() {
                        return this.onlineSubscription;
                    }
                    getAvailableSubscriptions() {
                        return this.availableSubscriptions;
                    }
                    get userSubscriptionName() {
                        if (!this.onlineSubscription) {
                            throw new Error('Attempting to get subscription name without a subscription.');
                        }
                        if (this.availableSubscriptions && this.availableSubscriptions[this.onlineSubscription.planName]) {
                            return this.availableSubscriptions[this.onlineSubscription.planName].name;
                        }
                        return '';
                    }
                    get userSubscriptionExpirationDate() {
                        if (!this.onlineSubscription) {
                            return undefined;
                        }
                        return new Date((0, utils_dist.convertTimestampToMilliseconds)(this.onlineSubscription.endsAt));
                    }
                    get isUserSubscriptionExpired() {
                        if (!this.onlineSubscription) {
                            throw new Error('Attempting to check subscription expiration without a subscription.');
                        }
                        if (!this.userSubscriptionExpirationDate) {
                            return false;
                        }
                        return this.userSubscriptionExpirationDate.getTime() < new Date().getTime();
                    }
                    get isUserSubscriptionCanceled() {
                        if (!this.onlineSubscription) {
                            throw new Error('Attempting to check subscription expiration without a subscription.');
                        }
                        return this.onlineSubscription.cancelled;
                    }
                    acceptInvitation(inviteUuid) {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.subscriptionApiService.acceptInvite(inviteUuid);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return {
                                        success: false,
                                        message: (0, dist.getErrorFromErrorResponse)(result).message
                                    };
                                }
                                return result.data;
                            }
                            catch (error) {
                                return {
                                    success: false,
                                    message: 'Could not accept invitation.'
                                };
                            }
                        });
                    }
                    listSubscriptionInvitations() {
                        var _a;
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.subscriptionApiService.listInvites();
                                if ((0, dist.isErrorResponse)(result)) {
                                    return [];
                                }
                                return (_a = result.data.invitations) !== null && _a !== void 0 ? _a : [];
                            }
                            catch (error) {
                                return [];
                            }
                        });
                    }
                    inviteToSubscription(inviteeEmail) {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.subscriptionApiService.invite(inviteeEmail);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                return result.data.success === true;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    cancelInvitation(inviteUuid) {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.subscriptionApiService.cancelInvite(inviteUuid);
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                return result.data.success === true;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    fetchOnlineSubscription() {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            if (!this.sessions.isSignedIn()) {
                                return;
                            }
                            try {
                                const result = yield this.subscriptionApiService.getUserSubscription({
                                    userUuid: this.sessions.userUuid
                                });
                                if ((0, dist.isErrorResponse)(result)) {
                                    return;
                                }
                                const subscription = result.data.subscription;
                                this.handleReceivedOnlineSubscriptionFromServer(subscription);
                            }
                            catch (error) {
                                void error;
                            }
                        });
                    }
                    handleReceivedOnlineSubscriptionFromServer(subscription) {
                        this.onlineSubscription = subscription;
                        this.storage.setValue(StorageKey.Subscription, subscription);
                        void this.notifyEvent(SubscriptionManagerEvent.DidFetchSubscription);
                    }
                    fetchAvailableSubscriptions() {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const response = yield this.subscriptionApiService.getAvailableSubscriptions();
                                if ((0, dist.isErrorResponse)(response)) {
                                    return;
                                }
                                this.availableSubscriptions = response.data;
                            }
                            catch (error) {
                                void error;
                            }
                        });
                    }
                    confirmAppleIAP(params, subscriptionToken) {
                        return SubscriptionManager_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = yield this.subscriptionApiService.confirmAppleIAP(Object.assign(Object.assign({}, params), {
                                    subscription_token: subscriptionToken
                                }));
                                if ((0, dist.isErrorResponse)(result)) {
                                    return {
                                        success: false,
                                        message: (0, dist.getErrorFromErrorResponse)(result).message
                                    };
                                }
                                return result.data;
                            }
                            catch (error) {
                                return {
                                    success: false,
                                    message: 'Could not confirm IAP.'
                                };
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Sync/SyncBackoffService.ts
                class SyncBackoffService {
                    constructor() {
                        this.backoffPenalties = new Map();
                        this.backoffStartTimestamps = new Map();
                    }
                    isItemInBackoff(item) {
                        const backoffStartingTimestamp = this.backoffStartTimestamps.get(item.uuid);
                        if (!backoffStartingTimestamp) {
                            return false;
                        }
                        const backoffPenalty = this.backoffPenalties.get(item.uuid);
                        if (!backoffPenalty) {
                            return false;
                        }
                        const backoffEndTimestamp = backoffStartingTimestamp + backoffPenalty;
                        return backoffEndTimestamp > Date.now();
                    }
                    backoffItem(item) {
                        const backoffPenalty = this.backoffPenalties.get(item.uuid) || 0;
                        const newBackoffPenalty = backoffPenalty === 0 ? 1000 : backoffPenalty * 2;
                        this.backoffPenalties.set(item.uuid, newBackoffPenalty);
                        this.backoffStartTimestamps.set(item.uuid, Date.now());
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Sync/SyncMode.ts
                /* istanbul ignore file */
                var SyncMode;
                (function (SyncMode) {
                    /**
                     * Performs a standard sync, uploading any dirty items and retrieving items.
                     */
                    SyncMode["Default"] = "Default";
                    /**
                     * The first sync for an account, where we first want to download all remote items first
                     * before uploading any dirty items. This allows a consumer, for example, to download
                     * all data to see if user has an items key, and if not, only then create a new one.
                     */
                    SyncMode["DownloadFirst"] = "DownloadFirst";
                    SyncMode["LocalOnly"] = "LocalOnly";
                })(SyncMode || (SyncMode = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Sync/SyncOpStatus.ts
                /* eslint-disable @typescript-eslint/no-explicit-any */
                const HEALTHY_SYNC_DURATION_THRESHOLD_S = 5;
                const TIMING_MONITOR_POLL_FREQUENCY_MS = 500;
                class SyncOpStatus {
                    constructor(interval, receiver) {
                        this.completedUpload = 0;
                        this.totalUpload = 0;
                        this.downloaded = 0;
                        this.databaseLoadCurrent = 0;
                        this.databaseLoadTotal = 0;
                        this.databaseLoadDone = false;
                        this.syncing = false;
                        this.interval = interval;
                        this.receiver = receiver;
                    }
                    deinit() {
                        this.stopTimingMonitor();
                    }
                    setUploadStatus(completed, total) {
                        this.completedUpload = completed;
                        this.totalUpload = total;
                        this.receiver(SyncEvent.StatusChanged);
                    }
                    setDownloadStatus(downloaded) {
                        this.downloaded += downloaded;
                        this.receiver(SyncEvent.StatusChanged);
                    }
                    setDatabaseLoadStatus(current, total, done) {
                        this.databaseLoadCurrent = current;
                        this.databaseLoadTotal = total;
                        this.databaseLoadDone = done;
                        if (done) {
                            this.receiver(SyncEvent.LocalDataLoaded);
                        }
                        else {
                            this.receiver(SyncEvent.LocalDataIncrementalLoad);
                        }
                    }
                    getStats() {
                        return {
                            uploadCompletionCount: this.completedUpload,
                            uploadTotalCount: this.totalUpload,
                            downloadCount: this.downloaded,
                            localDataDone: this.databaseLoadDone,
                            localDataCurrent: this.databaseLoadCurrent,
                            localDataTotal: this.databaseLoadTotal
                        };
                    }
                    setDidBegin() {
                        this.syncing = true;
                        this.syncStart = new Date();
                    }
                    setDidEnd() {
                        this.syncing = false;
                    }
                    get syncInProgress() {
                        return this.syncing === true;
                    }
                    get secondsSinceSyncStart() {
                        return (new Date().getTime() - this.syncStart.getTime()) / 1000;
                    }
                    /**
                     * Notifies receiver if current sync request is taking too long to complete.
                     */
                    startTimingMonitor() {
                        if (this.timingMonitor) {
                            this.stopTimingMonitor();
                        }
                        this.timingMonitor = this.interval(() => {
                            if (this.secondsSinceSyncStart > HEALTHY_SYNC_DURATION_THRESHOLD_S) {
                                this.receiver(SyncEvent.SyncTakingTooLong);
                                this.stopTimingMonitor();
                            }
                        }, TIMING_MONITOR_POLL_FREQUENCY_MS);
                    }
                    stopTimingMonitor() {
                        if (Object.prototype.hasOwnProperty.call(this.interval, 'cancel')) {
                            this.interval.cancel(this.timingMonitor);
                        }
                        else {
                            clearInterval(this.timingMonitor);
                        }
                        this.timingMonitor = null;
                    }
                    hasError() {
                        return !!this.error;
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setError(error) {
                        this.error = error;
                    }
                    clearError() {
                        this.error = null;
                    }
                    reset() {
                        this.downloaded = 0;
                        this.completedUpload = 0;
                        this.totalUpload = 0;
                        this.syncing = false;
                        this.error = null;
                        this.stopTimingMonitor();
                        this.receiver(SyncEvent.StatusChanged);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Sync/SyncQueueStrategy.ts
                /* istanbul ignore file */
                var SyncQueueStrategy;
                (function (SyncQueueStrategy) {
                    /**
                     * Promise will be resolved on the next sync request after the current one completes.
                     * If there is no scheduled sync request, one will be scheduled.
                     */
                    SyncQueueStrategy[SyncQueueStrategy["ResolveOnNext"] = 1] = "ResolveOnNext";
                    /**
                     * A new sync request is guarenteed to be generated for your request, no matter how long it takes.
                     * Promise will be resolved whenever this sync request is processed in the serial queue.
                     */
                    SyncQueueStrategy[SyncQueueStrategy["ForceSpawnNew"] = 2] = "ForceSpawnNew";
                })(SyncQueueStrategy || (SyncQueueStrategy = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/Sync/SyncSource.ts
                /* istanbul ignore file */
                var SyncSource;
                (function (SyncSource) {
                    SyncSource["External"] = "External";
                    SyncSource["SpawnQueue"] = "SpawnQueue";
                    SyncSource["ResolveQueue"] = "ResolveQueue";
                    SyncSource["MoreDirtyItems"] = "MoreDirtyItems";
                    SyncSource["DownloadFirst"] = "DownloadFirst";
                    SyncSource["AfterDownloadFirst"] = "AfterDownloadFirst";
                    SyncSource["IntegrityCheck"] = "IntegrityCheck";
                    SyncSource["ResolveOutOfSync"] = "ResolveOutOfSync";
                })(SyncSource || (SyncSource = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/ChangeAndSaveItem.ts
                var ChangeAndSaveItem_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ChangeAndSaveItem {
                    constructor(items, mutator, sync) {
                        this.items = items;
                        this.mutator = mutator;
                        this.sync = sync;
                    }
                    execute(itemToLookupUuidFor, mutate) {
                        let updateTimestamps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                        let emitSource = arguments.length > 3 ? arguments[3] : undefined;
                        let syncOptions = arguments.length > 4 ? arguments[4] : undefined;
                        return ChangeAndSaveItem_awaiter(this, void 0, void 0, function* () {
                            yield this.mutator.changeItems([itemToLookupUuidFor], mutate, updateTimestamps ? models_dist.MutationType.UpdateUserTimestamps : models_dist.MutationType.NoUpdateUserTimestamps, emitSource);
                            yield this.sync.sync(syncOptions);
                            return src.Result.ok(this.items.findItem(itemToLookupUuidFor.uuid));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/DiscardItemsLocally.ts
                var DiscardItemsLocally_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DiscardItemsLocally {
                    constructor(items, storage) {
                        this.items = items;
                        this.storage = storage;
                    }
                    execute(items) {
                        return DiscardItemsLocally_awaiter(this, void 0, void 0, function* () {
                            this.items.removeItemsFromMemory(items);
                            yield this.storage.deletePayloadsWithUuids((0, utils_dist.Uuids)(items));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/GenerateUuid.ts
                class GenerateUuid {
                    constructor(crypto) {
                        this.crypto = crypto;
                    }
                    execute() {
                        const uuid = this.crypto.generateUUID();
                        return src.Result.ok(uuid);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/GetHost.ts
                class GetHost {
                    constructor(legacyApi) {
                        this.legacyApi = legacyApi;
                    }
                    execute() {
                        return src.Result.ok(this.legacyApi.getHost());
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/IsApplicationUsingThirdPartyHost.ts
                class IsApplicationUsingThirdPartyHost {
                    constructor(getHostUseCase) {
                        this.getHostUseCase = getHostUseCase;
                        this.APPLICATION_DEFAULT_HOSTS = ['api.standardnotes.com', 'sync.standardnotes.org', 'localhost:3123'];
                        this.FILES_DEFAULT_HOSTS = ['files.standardnotes.com'];
                    }
                    execute() {
                        const result = this.getHostUseCase.execute();
                        if (result.isFailed()) {
                            return src.Result.fail(result.getError());
                        }
                        const host = result.getValue();
                        return src.Result.ok(!this.isUrlFirstParty(host));
                    }
                    isUrlFirstParty(url) {
                        try {
                            const { host } = new URL(url);
                            return this.APPLICATION_DEFAULT_HOSTS.includes(host) || this.FILES_DEFAULT_HOSTS.includes(host);
                        }
                        catch (error) {
                            return false;
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UseCase/SetHost.ts
                var SetHost_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SetHost {
                    constructor(http, legacyApi) {
                        this.http = http;
                        this.legacyApi = legacyApi;
                    }
                    execute(host) {
                        return SetHost_awaiter(this, void 0, void 0, function* () {
                            this.http.setHost(host);
                            yield this.legacyApi.setHost(host);
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/User/AccountEvent.ts
                var AccountEvent;
                (function (AccountEvent) {
                    AccountEvent["SignedInOrRegistered"] = "SignedInOrRegistered";
                    AccountEvent["SignedOut"] = "SignedOut";
                })(AccountEvent || (AccountEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/User/UserService.ts
                var UserService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const cleanedEmailString = email => {
                    return email.trim().toLowerCase();
                };
                class UserService extends AbstractService {
                    constructor(sessions, sync, storage, items, encryption, alerts, challenges, protections, userApi, _reencryptTypeAItems, _decryptErroredPayloads, internalEventBus) {
                        super(internalEventBus);
                        this.sessions = sessions;
                        this.sync = sync;
                        this.storage = storage;
                        this.items = items;
                        this.encryption = encryption;
                        this.alerts = alerts;
                        this.challenges = challenges;
                        this.protections = protections;
                        this.userApi = userApi;
                        this._reencryptTypeAItems = _reencryptTypeAItems;
                        this._decryptErroredPayloads = _decryptErroredPayloads;
                        this.internalEventBus = internalEventBus;
                        this.signingIn = false;
                        this.registering = false;
                        this.MINIMUM_PASSCODE_LENGTH = 1;
                        this.MINIMUM_PASSWORD_LENGTH = 8;
                    }
                    deinit() {
                        super.deinit();
                        this.sessions = undefined;
                        this.sync = undefined;
                        this.storage = undefined;
                        this.items = undefined;
                        this.encryption = undefined;
                        this.alerts = undefined;
                        this.challenges = undefined;
                        this.protections = undefined;
                        this.userApi = undefined;
                        this._reencryptTypeAItems = undefined;
                        this._decryptErroredPayloads = undefined;
                    }
                    handleEvent(event) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (event.type === AccountEvent.SignedInOrRegistered) {
                                const payload = event.payload.payload;
                                this.sync.resetSyncState();
                                yield this.storage.setPersistencePolicy(payload.ephemeral ? StoragePersistencePolicies.Ephemeral : StoragePersistencePolicies.Default);
                                if (payload.mergeLocal) {
                                    yield this.sync.markAllItemsAsNeedingSyncAndPersist();
                                }
                                else {
                                    void this.items.removeAllItemsFromMemory();
                                    yield this.clearDatabase();
                                }
                                this.unlockSyncing();
                                const syncPromise = this.sync.downloadFirstSync(1000, {
                                    checkIntegrity: payload.checkIntegrity,
                                    awaitAll: payload.awaitSync
                                }).then(() => {
                                    if (!payload.awaitSync) {
                                        void this._decryptErroredPayloads.execute();
                                    }
                                });
                                if (payload.awaitSync) {
                                    yield syncPromise;
                                    yield this._decryptErroredPayloads.execute();
                                }
                            }
                        });
                    }
                    get user() {
                        return this.sessions.getUser();
                    }
                    get sureUser() {
                        return this.sessions.getSureUser();
                    }
                    getUserUuid() {
                        return this.sessions.userUuid;
                    }
                    isSignedIn() {
                        return this.sessions.isSignedIn();
                    }
                    /**
                     *  @param mergeLocal  Whether to merge existing offline data into account. If false,
                     *                     any pre-existing data will be fully deleted upon success.
                     */
                    register(email, password, hvmToken) {
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let mergeLocal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (this.encryption.hasAccount()) {
                                throw Error('Tried to register when an account already exists.');
                            }
                            if (this.registering) {
                                throw Error('Already registering.');
                            }
                            this.registering = true;
                            try {
                                this.lockSyncing();
                                const response = yield this.sessions.register(email, password, hvmToken, ephemeral);
                                yield this.notifyEventSync(AccountEvent.SignedInOrRegistered, {
                                    payload: {
                                        ephemeral,
                                        mergeLocal,
                                        awaitSync: true,
                                        checkIntegrity: false
                                    }
                                });
                                this.registering = false;
                                return response;
                            }
                            catch (error) {
                                this.unlockSyncing();
                                this.registering = false;
                                throw error;
                            }
                        });
                    }
                    /**
                     * @param mergeLocal  Whether to merge existing offline data into account.
                     * If false, any pre-existing data will be fully deleted upon success.
                     */
                    signIn(email, password) {
                        let strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let mergeLocal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                        let awaitSync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                        let hvmToken = arguments.length > 6 ? arguments[6] : undefined;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (this.encryption.hasAccount()) {
                                throw Error('Tried to sign in when an account already exists.');
                            }
                            if (this.signingIn) {
                                throw Error('Already signing in.');
                            }
                            this.signingIn = true;
                            try {
                                /** Prevent a timed sync from occuring while signing in. */
                                this.lockSyncing();
                                const { response } = yield this.sessions.signIn(email, password, strict, ephemeral, undefined, hvmToken);
                                if (!(0, dist.isErrorResponse)(response)) {
                                    const notifyingFunction = awaitSync ? this.notifyEventSync.bind(this) : this.notifyEvent.bind(this);
                                    yield notifyingFunction(AccountEvent.SignedInOrRegistered, {
                                        payload: {
                                            mergeLocal,
                                            awaitSync,
                                            ephemeral,
                                            checkIntegrity: true
                                        }
                                    });
                                }
                                else {
                                    this.unlockSyncing();
                                }
                                return response;
                            }
                            finally {
                                this.signingIn = false;
                            }
                        });
                    }
                    deleteAccount() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (!(yield this.protections.authorizeAction(ChallengeReason.DeleteAccount, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: true,
                                forcePrompt: false
                            }))) {
                                return {
                                    error: true,
                                    message: INVALID_PASSWORD
                                };
                            }
                            const uuid = this.sessions.getSureUser().uuid;
                            const response = yield this.userApi.deleteAccount(uuid);
                            if ((0, dist.isErrorResponse)(response)) {
                                return {
                                    error: true,
                                    message: (0, dist.getErrorFromErrorResponse)(response).message
                                };
                            }
                            yield this.signOut(true);
                            if (this.alerts) {
                                void this.alerts.alert(InfoStrings.AccountDeleted);
                            }
                            return {
                                error: false
                            };
                        });
                    }
                    submitUserRequest(requestType) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const userUuid = this.sessions.getSureUser().uuid;
                            try {
                                const result = yield this.userApi.submitUserRequest({
                                    userUuid,
                                    requestType
                                });
                                if ((0, dist.isErrorResponse)(result)) {
                                    return false;
                                }
                                return result.data.success;
                            }
                            catch (error) {
                                return false;
                            }
                        });
                    }
                    /**
                     * A sign in request that occurs while the user was previously signed in, to correct
                     * for missing keys or storage values. Unlike regular sign in, this doesn't worry about
                     * performing one of marking all items as needing sync or deleting all local data.
                     */
                    correctiveSignIn(rootKey) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            this.lockSyncing();
                            const response = yield this.sessions.bypassChecksAndSignInWithRootKey(rootKey.keyParams.identifier, rootKey, false);
                            if (!(0, dist.isErrorResponse)(response)) {
                                yield this.notifyEvent(AccountEvent.SignedInOrRegistered, {
                                    payload: {
                                        mergeLocal: true,
                                        awaitSync: true,
                                        ephemeral: false,
                                        checkIntegrity: true
                                    }
                                });
                            }
                            this.unlockSyncing();
                            return response;
                        });
                    }
                    /**
                     * @param passcode - Changing the account password or email requires the local
                     * passcode if configured (to rewrap the account key with passcode). If the passcode
                     * is not passed in, the user will be prompted for the passcode. However if the consumer
                     * already has reference to the passcode, they can pass it in here so that the user
                     * is not prompted again.
                     */
                    changeCredentials(parameters) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.performCredentialsChange(parameters);
                            if (result.error) {
                                void this.alerts.alert(result.error.message);
                            }
                            return result;
                        });
                    }
                    signOut() {
                        let force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DeinitSource.SignOut;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const performSignOut = () => UserService_awaiter(this, void 0, void 0, function* () {
                                yield this.sessions.signOut();
                                yield this.encryption.deleteWorkspaceSpecificKeyStateFromDevice();
                                yield this.storage.clearAllData();
                                yield this.notifyEvent(AccountEvent.SignedOut, {
                                    payload: {
                                        source
                                    }
                                });
                            });
                            if (force) {
                                yield performSignOut();
                                return;
                            }
                            const dirtyItems = this.items.getDirtyItems();
                            if (dirtyItems.length > 0) {
                                const singular = dirtyItems.length === 1;
                                const didConfirm = yield this.alerts.confirm("There ".concat(singular ? 'is' : 'are', " ").concat(dirtyItems.length, " ").concat(singular ? 'item' : 'items', " with unsynced changes. If you sign out, these changes will be lost forever. Are you sure you want to sign out?"));
                                if (didConfirm) {
                                    yield performSignOut();
                                }
                            }
                            else {
                                yield performSignOut();
                            }
                        });
                    }
                    updateAccountWithFirstTimeKeyPair() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (!this.sessions.isUserMissingKeyPair()) {
                                throw Error('Cannot update account with first time keypair if user already has a keypair');
                            }
                            const result = yield this.performProtocolUpgrade();
                            return result;
                        });
                    }
                    performProtocolUpgrade() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const hasPasscode = this.encryption.hasPasscode();
                            const hasAccount = this.encryption.hasAccount();
                            const prompts = [];
                            if (hasPasscode) {
                                prompts.push(new ChallengePrompt(ChallengeValidation.LocalPasscode, undefined, ChallengeStrings.LocalPasscodePlaceholder));
                            }
                            if (hasAccount) {
                                prompts.push(new ChallengePrompt(ChallengeValidation.AccountPassword, undefined, ChallengeStrings.AccountPasswordPlaceholder));
                            }
                            const challenge = new Challenge(prompts, ChallengeReason.ProtocolUpgrade, true);
                            const response = yield this.challenges.promptForChallengeResponse(challenge);
                            if (!response) {
                                return {
                                    canceled: true
                                };
                            }
                            const dismissBlockingDialog = yield this.alerts.blockingDialog(DO_NOT_CLOSE_APPLICATION, UPGRADING_ENCRYPTION);
                            try {
                                let passcode;
                                if (hasPasscode) {
                                    /* Upgrade passcode version */
                                    const value = response.getValueForType(ChallengeValidation.LocalPasscode);
                                    passcode = value.value;
                                }
                                if (hasAccount) {
                                    /* Upgrade account version */
                                    const value = response.getValueForType(ChallengeValidation.AccountPassword);
                                    const password = value.value;
                                    const changeResponse = yield this.changeCredentials({
                                        currentPassword: password,
                                        newPassword: password,
                                        passcode,
                                        origination: dist_src.KeyParamsOrigination.ProtocolUpgrade,
                                        validateNewPasswordStrength: false
                                    });
                                    if (changeResponse === null || changeResponse === void 0 ? void 0 : changeResponse.error) {
                                        return {
                                            error: changeResponse.error
                                        };
                                    }
                                }
                                if (hasPasscode) {
                                    /* Upgrade passcode version */
                                    yield this.removePasscodeWithoutWarning();
                                    yield this.setPasscodeWithoutWarning(passcode, dist_src.KeyParamsOrigination.ProtocolUpgrade);
                                }
                                return {
                                    success: true
                                };
                            }
                            catch (error) {
                                return {
                                    error: error
                                };
                            }
                            finally {
                                dismissBlockingDialog();
                            }
                        });
                    }
                    addPasscode(passcode) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (passcode.length < this.MINIMUM_PASSCODE_LENGTH) {
                                return false;
                            }
                            if (!(yield this.protections.authorizeAddingPasscode())) {
                                return false;
                            }
                            const dismissBlockingDialog = yield this.alerts.blockingDialog(DO_NOT_CLOSE_APPLICATION, SETTING_PASSCODE);
                            try {
                                yield this.setPasscodeWithoutWarning(passcode, dist_src.KeyParamsOrigination.PasscodeCreate);
                                return true;
                            }
                            finally {
                                dismissBlockingDialog();
                            }
                        });
                    }
                    removePasscode() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (!(yield this.protections.authorizeRemovingPasscode())) {
                                return false;
                            }
                            const dismissBlockingDialog = yield this.alerts.blockingDialog(DO_NOT_CLOSE_APPLICATION, REMOVING_PASSCODE);
                            try {
                                yield this.removePasscodeWithoutWarning();
                                return true;
                            }
                            finally {
                                dismissBlockingDialog();
                            }
                        });
                    }
                    /**
                     * @returns whether the passcode was successfuly changed or not
                     */
                    changePasscode(newPasscode) {
                        let origination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dist_src.KeyParamsOrigination.PasscodeChange;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            if (newPasscode.length < this.MINIMUM_PASSCODE_LENGTH) {
                                return false;
                            }
                            if (!(yield this.protections.authorizeChangingPasscode())) {
                                return false;
                            }
                            const dismissBlockingDialog = yield this.alerts.blockingDialog(DO_NOT_CLOSE_APPLICATION, origination === dist_src.KeyParamsOrigination.ProtocolUpgrade ? ProtocolUpgradeStrings.UpgradingPasscode : CHANGING_PASSCODE);
                            try {
                                yield this.removePasscodeWithoutWarning();
                                yield this.setPasscodeWithoutWarning(newPasscode, origination);
                                return true;
                            }
                            finally {
                                dismissBlockingDialog();
                            }
                        });
                    }
                    populateSessionFromDemoShareToken(token) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            yield this.sessions.populateSessionFromDemoShareToken(token);
                            yield this.notifyEvent(AccountEvent.SignedInOrRegistered, {
                                payload: {
                                    ephemeral: false,
                                    mergeLocal: false,
                                    checkIntegrity: false,
                                    awaitSync: true
                                }
                            });
                        });
                    }
                    setPasscodeWithoutWarning(passcode, origination) {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const identifier = utils_dist.UuidGenerator.GenerateUuid();
                            const key = yield this.encryption.createRootKey(identifier, passcode, origination);
                            yield this.encryption.setNewRootKeyWrapper(key);
                            yield this.rewriteItemsKeys();
                            yield this.sync.sync();
                        });
                    }
                    removePasscodeWithoutWarning() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            yield this.encryption.removePasscode();
                            yield this.rewriteItemsKeys();
                        });
                    }
                    /**
                     * Allows items keys to be rewritten to local db on local credential status change,
                     * such as if passcode is added, changed, or removed.
                     * This allows IndexedDB unencrypted logs to be deleted
                     * `deletePayloads` will remove data from backing store,
                     * but not from working memory See:
                     * https://github.com/standardnotes/desktop/issues/131
                     */
                    rewriteItemsKeys() {
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const itemsKeys = this.items.getDisplayableItemsKeys();
                            const payloads = itemsKeys.map(key => key.payloadRepresentation());
                            yield this.storage.deletePayloads(payloads);
                            yield this.sync.persistPayloads(payloads);
                        });
                    }
                    lockSyncing() {
                        this.sync.lockSyncing();
                    }
                    unlockSyncing() {
                        this.sync.unlockSyncing();
                    }
                    clearDatabase() {
                        return this.storage.clearAllPayloads();
                    }
                    performCredentialsChange(parameters) {
                        var _a;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const { wrappingKey, canceled } = yield this.challenges.getWrappingKeyIfApplicable(parameters.passcode);
                            if (canceled) {
                                return {
                                    error: Error(CredentialsChangeStrings.PasscodeRequired)
                                };
                            }
                            if (parameters.newPassword !== undefined && parameters.validateNewPasswordStrength) {
                                if (parameters.newPassword.length < this.MINIMUM_PASSWORD_LENGTH) {
                                    return {
                                        error: Error(InsufficientPasswordMessage(this.MINIMUM_PASSWORD_LENGTH))
                                    };
                                }
                            }
                            const accountPasswordValidation = yield this.encryption.validateAccountPassword(parameters.currentPassword);
                            if (!accountPasswordValidation.valid) {
                                return {
                                    error: Error(INVALID_PASSWORD)
                                };
                            }
                            const newEmail = parameters.newEmail ? cleanedEmailString(parameters.newEmail) : undefined;
                            const user = this.sessions.getUser();
                            const currentEmail = user.email;
                            const { currentRootKey, newRootKey } = yield this.recomputeRootKeysForCredentialChange({
                                currentPassword: parameters.currentPassword,
                                currentEmail,
                                origination: parameters.origination,
                                newEmail: newEmail,
                                newPassword: parameters.newPassword
                            });
                            this.lockSyncing();
                            const { response } = yield this.sessions.changeCredentials({
                                currentServerPassword: currentRootKey.serverPassword,
                                newRootKey: newRootKey,
                                wrappingKey,
                                newEmail: newEmail
                            });
                            this.unlockSyncing();
                            if ((0, dist.isErrorResponse)(response)) {
                                return {
                                    error: Error((_a = response.data.error) === null || _a === void 0 ? void 0 : _a.message)
                                };
                            }
                            const rollback = yield this.encryption.createNewItemsKeyWithRollback();
                            yield this._reencryptTypeAItems.execute();
                            yield this.sync.sync({
                                awaitAll: true
                            });
                            const defaultItemsKey = this.encryption.getSureDefaultItemsKey();
                            const itemsKeyWasSynced = !defaultItemsKey.neverSynced;
                            if (!itemsKeyWasSynced) {
                                yield this.sessions.changeCredentials({
                                    currentServerPassword: newRootKey.serverPassword,
                                    newRootKey: currentRootKey,
                                    wrappingKey
                                });
                                yield this._reencryptTypeAItems.execute();
                                yield rollback();
                                yield this.sync.sync({
                                    awaitAll: true
                                });
                                return {
                                    error: Error(CredentialsChangeStrings.Failed)
                                };
                            }
                            return {};
                        });
                    }
                    recomputeRootKeysForCredentialChange(parameters) {
                        var _a, _b;
                        return UserService_awaiter(this, void 0, void 0, function* () {
                            const currentRootKey = yield this.encryption.computeRootKey(parameters.currentPassword, this.encryption.getRootKeyParams());
                            const newRootKey = yield this.encryption.createRootKey((_a = parameters.newEmail) !== null && _a !== void 0 ? _a : parameters.currentEmail, (_b = parameters.newPassword) !== null && _b !== void 0 ? _b : parameters.currentPassword, parameters.origination);
                            return {
                                currentRootKey,
                                newRootKey
                            };
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/UserEvent/NotificationService.ts
                var NotificationService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class NotificationService extends AbstractService {
                    constructor(internalEventBus) {
                        super(internalEventBus);
                        this.handledNotifications = new Set();
                    }
                    handleEvent(event) {
                        return NotificationService_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case SyncEvent.ReceivedNotifications:
                                    return this.handleReceivedNotifications(event.payload);
                                case WebSocketsServiceEvent.NotificationAddedForUser:
                                    return this.handleReceivedNotifications([event.payload.notification]);
                                default:
                                    break;
                            }
                        });
                    }
                    handleReceivedNotifications(notifications) {
                        return NotificationService_awaiter(this, void 0, void 0, function* () {
                            if (notifications.length === 0) {
                                return;
                            }
                            for (const notification of notifications) {
                                if (this.handledNotifications.has(notification.uuid)) {
                                    continue;
                                }
                                this.handledNotifications.add(notification.uuid);
                                const eventPayloadOrError = src.NotificationPayload.createFromString(notification.payload);
                                if (eventPayloadOrError.isFailed()) {
                                    continue;
                                }
                                const payload = eventPayloadOrError.getValue();
                                const serviceEvent = {
                                    eventPayload: payload
                                };
                                yield this.notifyEventSync(NotificationServiceEvent.NotificationReceived, serviceEvent);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/AuthorizeVaultDeletion.ts
                var AuthorizeVaultDeletion_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AuthorizeVaultDeletion {
                    constructor(vaultLocks, protection, challenges, _validateVaultPassword) {
                        this.vaultLocks = vaultLocks;
                        this.protection = protection;
                        this.challenges = challenges;
                        this._validateVaultPassword = _validateVaultPassword;
                    }
                    execute(vault) {
                        return AuthorizeVaultDeletion_awaiter(this, void 0, void 0, function* () {
                            if (!this.vaultLocks.isVaultLockable(vault)) {
                                const authorized = yield this.protection.authorizeAction(ChallengeReason.Custom, {
                                    fallBackToAccountPassword: true,
                                    requireAccountPassword: false,
                                    forcePrompt: true
                                });
                                return src.Result.ok(authorized);
                            }
                            const challenge = new Challenge([new ChallengePrompt(ChallengeValidation.None, undefined, 'Password')], ChallengeReason.Custom, true, ChallengeStrings.DeleteVault(vault.name), ChallengeStrings.EnterVaultPassword);
                            return new Promise(resolve => {
                                this.challenges.addChallengeObserver(challenge, {
                                    onCancel() {
                                        resolve(src.Result.ok(false));
                                    },
                                    onNonvalidatedSubmit: challengeResponse => AuthorizeVaultDeletion_awaiter(this, void 0, void 0, function* () {
                                        const value = challengeResponse.getDefaultValue();
                                        if (!value) {
                                            this.challenges.completeChallenge(challenge);
                                            resolve(src.Result.ok(false));
                                            return;
                                        }
                                        const password = value.value;
                                        if (this.vaultLocks.isVaultLocked(vault)) {
                                            const unlocked = yield this.vaultLocks.unlockNonPersistentVault(vault, password);
                                            if (unlocked) {
                                                this.challenges.completeChallenge(challenge);
                                                resolve(src.Result.ok(true));
                                                return;
                                            }
                                        }
                                        const validPassword = this._validateVaultPassword.execute(vault, password).getValue();
                                        if (!validPassword) {
                                            this.challenges.setValidationStatusForChallenge(challenge, value, false);
                                            resolve(src.Result.ok(false));
                                            return;
                                        }
                                        this.challenges.completeChallenge(challenge);
                                        resolve(src.Result.ok(true));
                                    })
                                });
                                void this.challenges.promptForChallengeResponse(challenge);
                            });
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/ChangeVaultKeyOptions.ts
                var ChangeVaultKeyOptions_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ChangeVaultKeyOptions {
                    constructor(sync, _rotateVaultKey, _changeVaultStorageMode) {
                        this.sync = sync;
                        this._rotateVaultKey = _rotateVaultKey;
                        this._changeVaultStorageMode = _changeVaultStorageMode;
                    }
                    execute(dto) {
                        return ChangeVaultKeyOptions_awaiter(this, void 0, void 0, function* () {
                            let newStorageMode = dto.newStorageMode;
                            let vault = dto.vault;
                            if (dto.newPasswordOptions) {
                                if (dto.newPasswordOptions.passwordType === models_dist.KeySystemPasswordType.Randomized && dto.newStorageMode && dto.newStorageMode !== models_dist.KeySystemRootKeyStorageMode.Synced) {
                                    return src.Result.fail('Cannot change storage mode to non-synced for randomized vault');
                                }
                                if (dto.newPasswordOptions.passwordType === models_dist.KeySystemPasswordType.UserInputted && !dto.newPasswordOptions.userInputtedPassword) {
                                    return src.Result.fail('User inputted password required');
                                }
                                const result = yield this._rotateVaultKey.execute({
                                    vault: dto.vault,
                                    userInputtedPassword: dto.newPasswordOptions.passwordType === models_dist.KeySystemPasswordType.UserInputted ? dto.newPasswordOptions.userInputtedPassword : undefined
                                });
                                if (result.isFailed()) {
                                    return result;
                                }
                                vault = result.getValue();
                                if (dto.newPasswordOptions.passwordType === models_dist.KeySystemPasswordType.Randomized) {
                                    newStorageMode = models_dist.KeySystemRootKeyStorageMode.Synced;
                                }
                            }
                            if (newStorageMode && newStorageMode !== vault.keyStorageMode) {
                                const result = yield this._changeVaultStorageMode.execute({
                                    vault: vault,
                                    newStorageMode: newStorageMode
                                });
                                if (result.isFailed()) {
                                    return result;
                                }
                            }
                            yield this.sync.sync();
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/ChangeVaultStorageMode.ts
                var ChangeVaultStorageMode_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ChangeVaultStorageMode {
                    constructor(mutator, sync, keys, _getVault) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this.keys = keys;
                        this._getVault = _getVault;
                    }
                    execute(dto) {
                        return ChangeVaultStorageMode_awaiter(this, void 0, void 0, function* () {
                            const result = this._getVault.execute({
                                keySystemIdentifier: dto.vault.systemIdentifier
                            });
                            if (result.isFailed()) {
                                return src.Result.fail('Vault not found');
                            }
                            const vault = result.getValue();
                            if (vault.keyPasswordType === models_dist.KeySystemPasswordType.Randomized && dto.newStorageMode !== models_dist.KeySystemRootKeyStorageMode.Synced) {
                                return src.Result.fail('Cannot change storage mode to non-synced for randomized vault');
                            }
                            const latestVault = result.getValue();
                            if (dto.newStorageMode === latestVault.keyStorageMode) {
                                return src.Result.fail('Vault already uses this storage preference');
                            }
                            if (dto.newStorageMode === models_dist.KeySystemRootKeyStorageMode.Local || dto.newStorageMode === models_dist.KeySystemRootKeyStorageMode.Ephemeral) {
                                const result = yield this.changeStorageModeToLocalOrEphemeral(latestVault, dto.newStorageMode);
                                if (result.isFailed()) {
                                    return result;
                                }
                            }
                            else if (dto.newStorageMode === models_dist.KeySystemRootKeyStorageMode.Synced) {
                                const result = yield this.changeStorageModeToSynced(latestVault);
                                if (result.isFailed()) {
                                    return result;
                                }
                            }
                            return src.Result.ok();
                        });
                    }
                    changeStorageModeToLocalOrEphemeral(vault, newStorageMode) {
                        return ChangeVaultStorageMode_awaiter(this, void 0, void 0, function* () {
                            const primaryKey = this.keys.getPrimaryKeySystemRootKey(vault.systemIdentifier);
                            if (!primaryKey) {
                                return src.Result.fail('No primary key found');
                            }
                            if (newStorageMode === models_dist.KeySystemRootKeyStorageMode.Ephemeral) {
                                this.keys.removeKeyFromCache(vault.systemIdentifier);
                            }
                            this.keys.cacheKey(primaryKey, newStorageMode);
                            yield this.keys.deleteAllSyncedKeySystemRootKeys(vault.systemIdentifier);
                            const updatedVault = yield this.mutator.changeItem(vault, mutator => {
                                mutator.keyStorageMode = newStorageMode;
                            });
                            yield this.sync.sync();
                            return src.Result.ok(updatedVault);
                        });
                    }
                    changeStorageModeToSynced(vault) {
                        return ChangeVaultStorageMode_awaiter(this, void 0, void 0, function* () {
                            const allRootKeys = this.keys.getAllKeySystemRootKeysForVault(vault.systemIdentifier);
                            const syncedRootKeys = this.keys.getSyncedKeySystemRootKeysForVault(vault.systemIdentifier);
                            this.keys.removeKeyFromCache(vault.systemIdentifier);
                            for (const key of allRootKeys) {
                                const existingSyncedKey = syncedRootKeys.find(syncedKey => syncedKey.token === key.token);
                                if (existingSyncedKey) {
                                    continue;
                                }
                                yield this.mutator.insertItem(key);
                            }
                            const updatedVault = yield this.mutator.changeItem(vault, mutator => {
                                mutator.keyStorageMode = models_dist.KeySystemRootKeyStorageMode.Synced;
                            });
                            return src.Result.ok(updatedVault);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/CreateVault.ts
                var CreateVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class CreateVault {
                    constructor(mutator, encryption, keys, sync) {
                        this.mutator = mutator;
                        this.encryption = encryption;
                        this.keys = keys;
                        this.sync = sync;
                    }
                    execute(dto) {
                        return CreateVault_awaiter(this, void 0, void 0, function* () {
                            const keySystemIdentifier = utils_dist.UuidGenerator.GenerateUuid();
                            const rootKey = yield this.createKeySystemRootKey({
                                keySystemIdentifier,
                                vaultName: dto.vaultName,
                                vaultDescription: dto.vaultDescription,
                                userInputtedPassword: dto.userInputtedPassword,
                                storagePreference: dto.storagePreference
                            });
                            yield this.createKeySystemItemsKey(keySystemIdentifier, rootKey.token);
                            const vaultListing = yield this.createVaultListing({
                                keySystemIdentifier,
                                vaultName: dto.vaultName,
                                vaultDescription: dto.vaultDescription,
                                vaultIcon: dto.vaultIcon,
                                passwordType: dto.userInputtedPassword ? models_dist.KeySystemPasswordType.UserInputted : models_dist.KeySystemPasswordType.Randomized,
                                rootKeyParams: rootKey.keyParams,
                                storage: dto.storagePreference
                            });
                            yield this.sync.sync();
                            return vaultListing;
                        });
                    }
                    createVaultListing(dto) {
                        return CreateVault_awaiter(this, void 0, void 0, function* () {
                            const content = {
                                systemIdentifier: dto.keySystemIdentifier,
                                rootKeyParams: dto.rootKeyParams,
                                keyStorageMode: dto.storage,
                                name: dto.vaultName,
                                description: dto.vaultDescription,
                                iconString: dto.vaultIcon
                            };
                            return this.mutator.createItem(src.ContentType.TYPES.VaultListing, (0, models_dist.FillItemContentSpecialized)(content), true);
                        });
                    }
                    createKeySystemItemsKey(keySystemIdentifier, rootKeyToken) {
                        return CreateVault_awaiter(this, void 0, void 0, function* () {
                            const keySystemItemsKey = this.encryption.createKeySystemItemsKey(utils_dist.UuidGenerator.GenerateUuid(), keySystemIdentifier, undefined, rootKeyToken);
                            yield this.mutator.insertItem(keySystemItemsKey);
                        });
                    }
                    createKeySystemRootKey(dto) {
                        return CreateVault_awaiter(this, void 0, void 0, function* () {
                            let newRootKey;
                            if (dto.userInputtedPassword) {
                                newRootKey = this.encryption.createUserInputtedKeySystemRootKey({
                                    systemIdentifier: dto.keySystemIdentifier,
                                    userInputtedPassword: dto.userInputtedPassword
                                });
                            }
                            else {
                                newRootKey = this.encryption.createRandomizedKeySystemRootKey({
                                    systemIdentifier: dto.keySystemIdentifier
                                });
                            }
                            if (dto.storagePreference === models_dist.KeySystemRootKeyStorageMode.Synced) {
                                yield this.mutator.insertItem(newRootKey, true);
                            }
                            else {
                                this.keys.cacheKey(newRootKey, dto.storagePreference);
                            }
                            return newRootKey;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/DeleteVault.ts
                var DeleteVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteVault {
                    constructor(mutator, keys, _getVaultItems) {
                        this.mutator = mutator;
                        this.keys = keys;
                        this._getVaultItems = _getVaultItems;
                    }
                    execute(vault) {
                        return DeleteVault_awaiter(this, void 0, void 0, function* () {
                            if (!vault.systemIdentifier) {
                                throw new Error('Vault system identifier is missing');
                            }
                            yield this.keys.deleteNonPersistentSystemRootKeysForVault(vault.systemIdentifier);
                            const rootKeys = this.keys.getSyncedKeySystemRootKeysForVault(vault.systemIdentifier);
                            yield this.mutator.setItemsToBeDeleted(rootKeys);
                            const itemsKeys = this.keys.getKeySystemItemsKeys(vault.systemIdentifier);
                            yield this.mutator.setItemsToBeDeleted(itemsKeys);
                            const vaultItems = this._getVaultItems.execute(vault).getValue();
                            yield this.mutator.setItemsToBeDeleted(vaultItems);
                            yield this.mutator.setItemToBeDeleted(vault);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/GetVault.ts
                class GetVault {
                    constructor(items) {
                        this.items = items;
                    }
                    execute(query) {
                        const vaults = this.items.getItems(src.ContentType.TYPES.VaultListing);
                        if ('keySystemIdentifier' in query) {
                            const result = vaults.find(listing => listing.systemIdentifier === query.keySystemIdentifier);
                            if (!result) {
                                return src.Result.fail('Vault not found');
                            }
                            return src.Result.ok(result);
                        }
                        else {
                            const result = vaults.find(listing => {
                                var _a;
                                return ((_a = listing.sharing) === null || _a === void 0 ? void 0 : _a.sharedVaultUuid) === query.sharedVaultUuid;
                            });
                            if (!result) {
                                return src.Result.fail('Shared vault not found');
                            }
                            return src.Result.ok(result);
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/GetVaultItems.ts
                class GetVaultItems {
                    constructor(items) {
                        this.items = items;
                    }
                    execute(vault) {
                        return src.Result.ok(this.items.items.filter(item => item.key_system_identifier === vault.systemIdentifier));
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/GetVaults.ts
                class GetVaults {
                    constructor(items) {
                        this.items = items;
                    }
                    execute() {
                        const vaults = this.items.getItems(src.ContentType.TYPES.VaultListing).sort((a, b) => {
                            return a.name.localeCompare(b.name);
                        });
                        return src.Result.ok(vaults);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/MoveItemsToVault.ts
                var MoveItemsToVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class MoveItemsToVault {
                    constructor(mutator, sync, files) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this.files = files;
                    }
                    execute(dto) {
                        return MoveItemsToVault_awaiter(this, void 0, void 0, function* () {
                            for (const item of dto.items) {
                                yield this.mutator.changeItem(item, mutator => {
                                    mutator.key_system_identifier = dto.vault.systemIdentifier;
                                    mutator.shared_vault_uuid = dto.vault.isSharedVaultListing() ? dto.vault.sharing.sharedVaultUuid : undefined;
                                });
                            }
                            yield this.sync.sync();
                            for (const item of dto.items) {
                                if (item.content_type !== src.ContentType.TYPES.File) {
                                    continue;
                                }
                                if (dto.vault.isSharedVaultListing()) {
                                    yield this.files.moveFileToSharedVault(item, dto.vault);
                                }
                                else {
                                    const itemPreviouslyBelongedToSharedVault = item.shared_vault_uuid;
                                    if (itemPreviouslyBelongedToSharedVault) {
                                        yield this.files.moveFileOutOfSharedVault(item);
                                    }
                                }
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/RemoveItemFromVault.ts
                var RemoveItemFromVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RemoveItemFromVault {
                    constructor(mutator, sync, files) {
                        this.mutator = mutator;
                        this.sync = sync;
                        this.files = files;
                    }
                    execute(dto) {
                        return RemoveItemFromVault_awaiter(this, void 0, void 0, function* () {
                            yield this.mutator.changeItem(dto.item, mutator => {
                                mutator.key_system_identifier = undefined;
                                mutator.shared_vault_uuid = undefined;
                            });
                            yield this.sync.sync();
                            if (dto.item.content_type === src.ContentType.TYPES.File) {
                                yield this.files.moveFileOutOfSharedVault(dto.item);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/UseCase/RotateVaultKey.ts
                var RotateVaultKey_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RotateVaultKey {
                    constructor(mutator, encryption, keys, _notifyVaultUsersOfKeyRotation, _isVaultOwner) {
                        this.mutator = mutator;
                        this.encryption = encryption;
                        this.keys = keys;
                        this._notifyVaultUsersOfKeyRotation = _notifyVaultUsersOfKeyRotation;
                        this._isVaultOwner = _isVaultOwner;
                    }
                    execute(params) {
                        return RotateVaultKey_awaiter(this, void 0, void 0, function* () {
                            const { newRootKey, updatedVault } = yield this.updateRootKeyparams(params);
                            yield this.createNewKeySystemItemsKey({
                                keySystemIdentifier: updatedVault.systemIdentifier,
                                sharedVaultUuid: updatedVault.isSharedVaultListing() ? updatedVault.sharing.sharedVaultUuid : undefined,
                                rootKeyToken: newRootKey.token
                            });
                            yield this.keys.queueVaultItemsKeysForReencryption(updatedVault.systemIdentifier);
                            const shareResult = yield this.shareNewKeyWithMembers({
                                vault: updatedVault,
                                newRootKey
                            });
                            if (shareResult.isFailed()) {
                                return src.Result.fail(shareResult.getError());
                            }
                            return src.Result.ok(updatedVault);
                        });
                    }
                    updateRootKeyparams(params) {
                        return RotateVaultKey_awaiter(this, void 0, void 0, function* () {
                            const currentRootKey = this.keys.getPrimaryKeySystemRootKey(params.vault.systemIdentifier);
                            if (!currentRootKey) {
                                throw new Error('Cannot rotate key system root key; key system root key not found');
                            }
                            let newRootKey;
                            if (params.userInputtedPassword) {
                                newRootKey = this.encryption.createUserInputtedKeySystemRootKey({
                                    systemIdentifier: params.vault.systemIdentifier,
                                    userInputtedPassword: params.userInputtedPassword
                                });
                            }
                            else {
                                newRootKey = this.encryption.createRandomizedKeySystemRootKey({
                                    systemIdentifier: params.vault.systemIdentifier
                                });
                            }
                            if (!newRootKey) {
                                throw new Error('Cannot rotate key system root key; new root key not created');
                            }
                            if (!params.userInputtedPassword || params.vault.keyStorageMode === models_dist.KeySystemRootKeyStorageMode.Synced) {
                                yield this.mutator.insertItem(newRootKey, true);
                            }
                            else {
                                this.keys.cacheKey(newRootKey, params.vault.keyStorageMode);
                            }
                            const updatedVault = yield this.mutator.changeItem(params.vault, mutator => {
                                (0, utils_dist.assert)(newRootKey);
                                mutator.rootKeyParams = newRootKey.keyParams;
                            });
                            return {
                                newRootKey,
                                updatedVault
                            };
                        });
                    }
                    createNewKeySystemItemsKey(params) {
                        return RotateVaultKey_awaiter(this, void 0, void 0, function* () {
                            const newItemsKeyUuid = utils_dist.UuidGenerator.GenerateUuid();
                            const newItemsKey = this.encryption.createKeySystemItemsKey(newItemsKeyUuid, params.keySystemIdentifier, params.sharedVaultUuid, params.rootKeyToken);
                            yield this.mutator.insertItem(newItemsKey);
                        });
                    }
                    shareNewKeyWithMembers(params) {
                        return RotateVaultKey_awaiter(this, void 0, void 0, function* () {
                            if (!params.vault.isSharedVaultListing()) {
                                return src.Result.ok();
                            }
                            const isOwner = this._isVaultOwner.execute(params.vault).getValue();
                            if (!isOwner) {
                                return src.Result.ok();
                            }
                            const result = yield this._notifyVaultUsersOfKeyRotation.execute({
                                sharedVault: params.vault
                            });
                            return result;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/VaultService.ts
                var VaultService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class VaultService extends AbstractService {
                    constructor(sync, items, mutator, vaultLocks, alerts, _getVault, _getVaults, _changeVaultKeyOptions, _moveItemsToVault, _createVault, _removeItemFromVault, _deleteVault, _rotateVaultKey, _sendVaultDataChangeMessage, _isVaultOwner, _validateVaultPassword, _authorizeVaultDeletion, eventBus) {
                        super(eventBus);
                        this.sync = sync;
                        this.items = items;
                        this.mutator = mutator;
                        this.vaultLocks = vaultLocks;
                        this.alerts = alerts;
                        this._getVault = _getVault;
                        this._getVaults = _getVaults;
                        this._changeVaultKeyOptions = _changeVaultKeyOptions;
                        this._moveItemsToVault = _moveItemsToVault;
                        this._createVault = _createVault;
                        this._removeItemFromVault = _removeItemFromVault;
                        this._deleteVault = _deleteVault;
                        this._rotateVaultKey = _rotateVaultKey;
                        this._sendVaultDataChangeMessage = _sendVaultDataChangeMessage;
                        this._isVaultOwner = _isVaultOwner;
                        this._validateVaultPassword = _validateVaultPassword;
                        this._authorizeVaultDeletion = _authorizeVaultDeletion;
                    }
                    deinit() {
                        super.deinit();
                        this.sync = undefined;
                        this.items = undefined;
                        this.mutator = undefined;
                        this.vaultLocks = undefined;
                        this.alerts = undefined;
                        this._getVault = undefined;
                        this._getVaults = undefined;
                        this._changeVaultKeyOptions = undefined;
                        this._moveItemsToVault = undefined;
                        this._createVault = undefined;
                        this._removeItemFromVault = undefined;
                        this._deleteVault = undefined;
                        this._rotateVaultKey = undefined;
                    }
                    getVaults() {
                        return this._getVaults.execute().getValue();
                    }
                    getVault(dto) {
                        return this._getVault.execute(dto);
                    }
                    createRandomizedVault(dto) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            return this.createVaultWithParameters({
                                name: dto.name,
                                description: dto.description,
                                iconString: dto.iconString,
                                userInputtedPassword: undefined,
                                storagePreference: models_dist.KeySystemRootKeyStorageMode.Synced
                            });
                        });
                    }
                    createUserInputtedPasswordVault(dto) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            return this.createVaultWithParameters(dto);
                        });
                    }
                    createVaultWithParameters(dto) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this._createVault.execute({
                                vaultName: dto.name,
                                vaultDescription: dto.description,
                                vaultIcon: dto.iconString,
                                userInputtedPassword: dto.userInputtedPassword,
                                storagePreference: dto.storagePreference
                            });
                            return result;
                        });
                    }
                    moveItemToVault(vault, item) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            if (this.vaultLocks.isVaultLocked(vault)) {
                                throw new Error('Attempting to add item to locked vault');
                            }
                            if ((0, models_dist.isNote)(item) || (0, models_dist.isFile)(item)) {
                                const linkedFiles = this.items.getItemLinkedFiles(item);
                                const linkedNotes = this.items.getItemLinkedNotes(item);
                                const linkedTags = this.items.getUnsortedTagsForItem(item);
                                const areAnyLinkedItemsInOtherVaults = [...linkedFiles, ...linkedNotes, ...linkedTags].some(linkedItem => {
                                    return linkedItem.key_system_identifier !== vault.systemIdentifier;
                                });
                                if (areAnyLinkedItemsInOtherVaults) {
                                    const reason = 'This item is linked to other items that are not in the same vault. Please move those items to this vault first.';
                                    this.alerts.alertV2({
                                        title: 'Cannot move item to vault',
                                        text: reason
                                    }).catch(console.error);
                                    return src.Result.fail(reason);
                                }
                            }
                            let moveableSubtags = [];
                            if ((0, models_dist.isTag)(item)) {
                                const deepSubtags = this.items.getDeepTagChildren(item);
                                const anySubtagIsInOtherVault = deepSubtags.some(subtag => {
                                    return subtag.key_system_identifier && subtag.key_system_identifier !== vault.systemIdentifier;
                                });
                                if (anySubtagIsInOtherVault) {
                                    const reason = 'One or more subtags are in other vaults. Please remove those subtags from the vaults or move them to this vault first.';
                                    this.alerts.alertV2({
                                        title: 'Cannot move item to vault',
                                        text: reason
                                    }).catch(console.error);
                                    return src.Result.fail(reason);
                                }
                                moveableSubtags = deepSubtags;
                            }
                            yield this._moveItemsToVault.execute({
                                vault,
                                items: [item, ...moveableSubtags]
                            });
                            return src.Result.ok(this.items.findSureItem(item.uuid));
                        });
                    }
                    removeItemFromVault(item) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            const vault = this.getItemVault(item);
                            if (!vault) {
                                throw new Error('Cannot find vault to remove item from');
                            }
                            if (this.vaultLocks.isVaultLocked(vault)) {
                                throw new Error('Attempting to remove item from locked vault');
                            }
                            if ((0, models_dist.isTag)(item)) {
                                const deepSubtags = this.items.getDeepTagChildren(item);
                                for (const subtag of deepSubtags) {
                                    yield this._removeItemFromVault.execute({
                                        item: subtag
                                    });
                                }
                            }
                            yield this._removeItemFromVault.execute({
                                item
                            });
                            return this.items.findSureItem(item.uuid);
                        });
                    }
                    authorizeVaultDeletion(vault) {
                        return this._authorizeVaultDeletion.execute(vault);
                    }
                    deleteVault(vault) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            if (vault.isSharedVaultListing()) {
                                throw new Error('Shared vault must be deleted through SharedVaultService');
                            }
                            const error = yield this._deleteVault.execute(vault);
                            if ((0, dist.isClientDisplayableError)(error)) {
                                return false;
                            }
                            yield this.sync.sync();
                            return true;
                        });
                    }
                    changeVaultMetadata(vault, params) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            const updatedVault = yield this.mutator.changeItem(vault, mutator => {
                                mutator.name = params.name;
                                mutator.description = params.description;
                                mutator.iconString = params.iconString;
                            });
                            yield this.sync.sync();
                            if (updatedVault.isSharedVaultListing()) {
                                yield this._sendVaultDataChangeMessage.execute({
                                    vault: updatedVault
                                });
                            }
                            return updatedVault;
                        });
                    }
                    rotateVaultRootKey(vault, vaultPassword) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            if (this.vaultLocks.isVaultLocked(vault)) {
                                throw new Error('Cannot rotate root key of locked vault');
                            }
                            yield this._rotateVaultKey.execute({
                                vault,
                                userInputtedPassword: vaultPassword
                            });
                            yield this.sync.sync();
                        });
                    }
                    isItemInVault(item) {
                        return item.key_system_identifier !== undefined;
                    }
                    getItemVault(item) {
                        const latestItem = this.items.findItem(item.uuid);
                        if (this.items.isTemplateItem(item)) {
                            return undefined;
                        }
                        if (!latestItem) {
                            throw new Error('Cannot find latest version of item to get vault for');
                        }
                        if (!latestItem.key_system_identifier) {
                            return undefined;
                        }
                        const vault = this.getVault({
                            keySystemIdentifier: latestItem.key_system_identifier
                        });
                        if (vault.isFailed()) {
                            throw new Error('Cannot find vault for item');
                        }
                        return vault.getValue();
                    }
                    changeVaultKeyOptions(dto) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            if (this.vaultLocks.isVaultLocked(dto.vault)) {
                                throw new Error('Attempting to change vault options on a locked vault');
                            }
                            if (!this._isVaultOwner.execute(dto.vault).getValue()) {
                                throw new Error('Third party vault options should be changed via changeThirdPartyVaultStorageOptions');
                            }
                            const result = yield this._changeVaultKeyOptions.execute(dto);
                            return result;
                        });
                    }
                    changeThirdPartyVaultStorageOptions(dto) {
                        return VaultService_awaiter(this, void 0, void 0, function* () {
                            if (this.vaultLocks.isVaultLocked(dto.vault)) {
                                throw new Error('Attempting to change vault options on a locked vault');
                            }
                            if (this._isVaultOwner.execute(dto.vault).getValue()) {
                                throw new Error('First party vault options should be changed via changeVaultKeyOptions');
                            }
                            const validPassword = this._validateVaultPassword.execute(dto.vault, dto.vaultPassword).getValue();
                            if (!validPassword) {
                                return src.Result.fail('Invalid vault password');
                            }
                            const result = yield this._changeVaultKeyOptions.execute({
                                vault: dto.vault,
                                newStorageMode: dto.newStorageMode,
                                newPasswordOptions: undefined
                            });
                            return result;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/Vault/VaultServiceEvent.ts
                var VaultServiceEvent;
                (function (VaultServiceEvent) { })(VaultServiceEvent || (VaultServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/AcceptVaultInvite.ts
                var AcceptVaultInvite_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AcceptVaultInvite {
                    constructor(inviteServer, processInvite) {
                        this.inviteServer = inviteServer;
                        this.processInvite = processInvite;
                    }
                    execute(dto) {
                        return AcceptVaultInvite_awaiter(this, void 0, void 0, function* () {
                            const acceptResponse = yield this.inviteServer.acceptInvite({
                                sharedVaultUuid: dto.invite.shared_vault_uuid,
                                inviteUuid: dto.invite.uuid
                            });
                            if ((0, dist.isErrorResponse)(acceptResponse)) {
                                return src.Result.fail("Could not accept vault invitation: ".concat((0, dist.getErrorFromErrorResponse)(acceptResponse).message));
                            }
                            yield this.processInvite.execute(dto.message, dto.invite.shared_vault_uuid, dto.invite.sender_uuid);
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/InviteToVault.ts
                var InviteToVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class InviteToVault {
                    constructor(keyManager, _encryptMessage, _sendInvite, _shareContact, _getKeyPairs) {
                        this.keyManager = keyManager;
                        this._encryptMessage = _encryptMessage;
                        this._sendInvite = _sendInvite;
                        this._shareContact = _shareContact;
                        this._getKeyPairs = _getKeyPairs;
                    }
                    execute(params) {
                        return InviteToVault_awaiter(this, void 0, void 0, function* () {
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return src.Result.fail('Cannot invite contact; keys not found');
                            }
                            const createInviteResult = yield this.inviteContact({
                                keys: keys.getValue(),
                                sharedVault: params.sharedVault,
                                sharedVaultContacts: params.sharedVaultContacts,
                                recipient: params.recipient,
                                permission: params.permission
                            });
                            if (createInviteResult.isFailed()) {
                                return createInviteResult;
                            }
                            yield this.shareContactWithOtherVaultMembers({
                                contact: params.recipient,
                                keys: keys.getValue(),
                                sharedVault: params.sharedVault
                            });
                            return createInviteResult;
                        });
                    }
                    shareContactWithOtherVaultMembers(params) {
                        return InviteToVault_awaiter(this, void 0, void 0, function* () {
                            const result = yield this._shareContact.execute({
                                sharedVault: params.sharedVault,
                                contactToShare: params.contact
                            });
                            return result;
                        });
                    }
                    inviteContact(params) {
                        return InviteToVault_awaiter(this, void 0, void 0, function* () {
                            const permissionOrError = src.SharedVaultUserPermission.create(params.permission);
                            if (permissionOrError.isFailed()) {
                                return src.Result.fail(permissionOrError.getError());
                            }
                            const permission = permissionOrError.getValue();
                            const keySystemRootKey = this.keyManager.getPrimaryKeySystemRootKey(params.sharedVault.systemIdentifier);
                            if (!keySystemRootKey) {
                                return src.Result.fail('Cannot invite contact; key system root key not found');
                            }
                            const meContact = params.sharedVaultContacts.find(contact => contact.isMe);
                            if (!meContact) {
                                return src.Result.fail('Cannot invite contact; me contact not found');
                            }
                            const meContactContent = {
                                name: undefined,
                                contactUuid: meContact.contactUuid,
                                publicKeySet: meContact.publicKeySet
                            };
                            const delegatedContacts = params.sharedVaultContacts.filter(contact => !contact.isMe && contact.contactUuid !== params.recipient.contactUuid).map(contact => {
                                return {
                                    name: contact.name,
                                    contactUuid: contact.contactUuid,
                                    publicKeySet: contact.publicKeySet
                                };
                            });
                            const encryptedMessage = this._encryptMessage.execute({
                                message: {
                                    type: models_dist.AsymmetricMessagePayloadType.SharedVaultInvite,
                                    data: {
                                        recipientUuid: params.recipient.contactUuid,
                                        rootKey: keySystemRootKey.content,
                                        trustedContacts: [meContactContent, ...delegatedContacts],
                                        metadata: {
                                            name: params.sharedVault.name,
                                            description: params.sharedVault.description,
                                            iconString: params.sharedVault.iconString,
                                            fileBytesUsed: params.sharedVault.sharing.fileBytesUsed,
                                            designatedSurvivor: params.sharedVault.sharing.designatedSurvivor
                                        }
                                    }
                                },
                                keys: params.keys,
                                recipientPublicKey: params.recipient.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const createInviteResult = yield this._sendInvite.execute({
                                sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid,
                                recipientUuid: params.recipient.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                permission: permission.value
                            });
                            return createInviteResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/ReuploadAllInvites.ts
                var ReuploadAllInvites_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ReuploadAllInvites {
                    constructor(reuploadInvite, findContact, inviteServer) {
                        this.reuploadInvite = reuploadInvite;
                        this.findContact = findContact;
                        this.inviteServer = inviteServer;
                    }
                    execute(params) {
                        return ReuploadAllInvites_awaiter(this, void 0, void 0, function* () {
                            const invites = yield this.getExistingInvites();
                            if (invites.isFailed()) {
                                return invites;
                            }
                            const deleteResult = yield this.deleteExistingInvites();
                            if (deleteResult.isFailed()) {
                                return deleteResult;
                            }
                            const errors = [];
                            for (const invite of invites.getValue()) {
                                const recipient = this.findContact.execute({
                                    userUuid: invite.user_uuid
                                });
                                if (recipient.isFailed()) {
                                    errors.push("Contact not found for invite ".concat(invite.user_uuid));
                                    continue;
                                }
                                const result = yield this.reuploadInvite.execute({
                                    keys: params.keys,
                                    previousKeys: params.previousKeys,
                                    recipient: recipient.getValue(),
                                    previousInvite: invite
                                });
                                if (result.isFailed()) {
                                    errors.push(result.getError());
                                }
                            }
                            if (errors.length > 0) {
                                return src.Result.fail(errors.join(', '));
                            }
                            return src.Result.ok();
                        });
                    }
                    getExistingInvites() {
                        return ReuploadAllInvites_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.inviteServer.getOutboundUserInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to get outbound user invites ".concat(JSON.stringify(response)));
                            }
                            const invites = response.data.invites;
                            return src.Result.ok(invites);
                        });
                    }
                    deleteExistingInvites() {
                        return ReuploadAllInvites_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.inviteServer.deleteAllOutboundInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to delete existing invites ".concat(JSON.stringify(response)));
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/ReuploadInvite.ts
                var ReuploadInvite_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ReuploadInvite {
                    constructor(decryptOwnMessage, sendInvite, encryptMessage) {
                        this.decryptOwnMessage = decryptOwnMessage;
                        this.sendInvite = sendInvite;
                        this.encryptMessage = encryptMessage;
                    }
                    execute(params) {
                        var _a, _b;
                        return ReuploadInvite_awaiter(this, void 0, void 0, function* () {
                            const decryptedPreviousInvite = this.decryptOwnMessage.execute({
                                message: params.previousInvite.encrypted_message,
                                privateKey: (_b = (_a = params.previousKeys) === null || _a === void 0 ? void 0 : _a.encryption.privateKey) !== null && _b !== void 0 ? _b : params.keys.encryption.privateKey,
                                recipientPublicKey: params.recipient.publicKeySet.encryption
                            });
                            if (decryptedPreviousInvite.isFailed()) {
                                return src.Result.fail(decryptedPreviousInvite.getError());
                            }
                            const encryptedMessage = this.encryptMessage.execute({
                                message: decryptedPreviousInvite.getValue(),
                                keys: params.keys,
                                recipientPublicKey: params.recipient.publicKeySet.encryption
                            });
                            if (encryptedMessage.isFailed()) {
                                return src.Result.fail(encryptedMessage.getError());
                            }
                            const createInviteResult = yield this.sendInvite.execute({
                                sharedVaultUuid: params.previousInvite.shared_vault_uuid,
                                recipientUuid: params.recipient.contactUuid,
                                encryptedMessage: encryptedMessage.getValue(),
                                permission: params.previousInvite.permission
                            });
                            return createInviteResult;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/ReuploadVaultInvites.ts
                var ReuploadVaultInvites_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ReuploadVaultInvites {
                    constructor(reuploadInvite, findContact, inviteServer) {
                        this.reuploadInvite = reuploadInvite;
                        this.findContact = findContact;
                        this.inviteServer = inviteServer;
                    }
                    execute(params) {
                        return ReuploadVaultInvites_awaiter(this, void 0, void 0, function* () {
                            const existingInvites = yield this.getExistingInvites(params.sharedVault.sharing.sharedVaultUuid);
                            if (existingInvites.isFailed()) {
                                return existingInvites;
                            }
                            const deleteResult = yield this.deleteExistingInvites(params.sharedVault.sharing.sharedVaultUuid);
                            if (deleteResult.isFailed()) {
                                return deleteResult;
                            }
                            const errors = [];
                            for (const invite of existingInvites.getValue()) {
                                const recipient = this.findContact.execute({
                                    userUuid: invite.user_uuid
                                });
                                if (recipient.isFailed()) {
                                    errors.push("Contact not found for invite ".concat(invite.user_uuid));
                                    continue;
                                }
                                const result = yield this.reuploadInvite.execute({
                                    keys: params.keys,
                                    recipient: recipient.getValue(),
                                    previousInvite: invite
                                });
                                if (result.isFailed()) {
                                    errors.push(result.getError());
                                }
                            }
                            if (errors.length > 0) {
                                return src.Result.fail(errors.join(', '));
                            }
                            return src.Result.ok();
                        });
                    }
                    getExistingInvites(sharedVaultUuid) {
                        return ReuploadVaultInvites_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.inviteServer.getOutboundUserInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to get outbound user invites ".concat(JSON.stringify(response)));
                            }
                            const invites = response.data.invites;
                            return src.Result.ok(invites.filter(invite => invite.shared_vault_uuid === sharedVaultUuid));
                        });
                    }
                    deleteExistingInvites(sharedVaultUuid) {
                        return ReuploadVaultInvites_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.inviteServer.deleteAllSharedVaultInvites({
                                sharedVaultUuid: sharedVaultUuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail("Failed to delete existing invites ".concat(JSON.stringify(response)));
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/UseCase/SendVaultInvite.ts
                var SendVaultInvite_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SendVaultInvite {
                    constructor(vaultInvitesServer) {
                        this.vaultInvitesServer = vaultInvitesServer;
                    }
                    execute(params) {
                        return SendVaultInvite_awaiter(this, void 0, void 0, function* () {
                            const permissionOrError = src.SharedVaultUserPermission.create(params.permission);
                            if (permissionOrError.isFailed()) {
                                return src.Result.fail(permissionOrError.getError());
                            }
                            const permission = permissionOrError.getValue();
                            const response = yield this.vaultInvitesServer.createInvite({
                                sharedVaultUuid: params.sharedVaultUuid,
                                recipientUuid: params.recipientUuid,
                                encryptedMessage: params.encryptedMessage,
                                permission: permission
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return src.Result.ok(response.data.invite);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/VaultInviteServiceEvent.ts
                var VaultInviteServiceEvent;
                (function (VaultInviteServiceEvent) {
                    VaultInviteServiceEvent["InviteSent"] = "VaultInviteServiceEvent.InviteSent";
                    VaultInviteServiceEvent["InvitesReloaded"] = "VaultInviteServiceEvent.InvitesReloaded";
                })(VaultInviteServiceEvent || (VaultInviteServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultInvite/VaultInviteService.ts
                var VaultInviteService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class VaultInviteService extends AbstractService {
                    constructor(items, session, vaultUsers, sync, invitesServer, status, _getAllContacts, _getVault, _getVaultContacts, _inviteToVault, _getTrustedPayload, _getUntrustedPayload, _findContact, _acceptVaultInvite, _getKeyPairs, _decryptErroredPayloads, eventBus) {
                        super(eventBus);
                        this.session = session;
                        this.vaultUsers = vaultUsers;
                        this.sync = sync;
                        this.invitesServer = invitesServer;
                        this.status = status;
                        this._getAllContacts = _getAllContacts;
                        this._getVault = _getVault;
                        this._getVaultContacts = _getVaultContacts;
                        this._inviteToVault = _inviteToVault;
                        this._getTrustedPayload = _getTrustedPayload;
                        this._getUntrustedPayload = _getUntrustedPayload;
                        this._findContact = _findContact;
                        this._acceptVaultInvite = _acceptVaultInvite;
                        this._getKeyPairs = _getKeyPairs;
                        this._decryptErroredPayloads = _decryptErroredPayloads;
                        this.pendingInvites = {};
                        this.eventDisposers.push(items.addObserver(src.ContentType.TYPES.TrustedContact, _ref => {
                            let { inserted, source } = _ref;
                            return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                                if (source === models_dist.PayloadEmitSource.LocalChanged && inserted.length > 0) {
                                    void this.downloadInboundInvites();
                                }
                                yield this.reprocessCachedInvitesTrustStatusAfterTrustedContactsChange();
                            });
                        }));
                    }
                    deinit() {
                        super.deinit();
                        this.session = undefined;
                        this.vaultUsers = undefined;
                        this.sync = undefined;
                        this.invitesServer = undefined;
                        this._getAllContacts = undefined;
                        this._getVault = undefined;
                        this._getVaultContacts = undefined;
                        this._inviteToVault = undefined;
                        this._getTrustedPayload = undefined;
                        this._getUntrustedPayload = undefined;
                        this._findContact = undefined;
                        this._acceptVaultInvite = undefined;
                        this._getKeyPairs = undefined;
                        this._decryptErroredPayloads = undefined;
                        this.pendingInvites = {};
                    }
                    updatePendingInviteCount() {
                        this.status.setPreferencesBubbleCount('vaults', Object.keys(this.pendingInvites).length);
                    }
                    addPendingInvite(invite) {
                        this.pendingInvites[invite.invite.uuid] = invite;
                        this.updatePendingInviteCount();
                    }
                    removePendingInvite(uuid) {
                        delete this.pendingInvites[uuid];
                        this.updatePendingInviteCount();
                    }
                    handleEvent(event) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case SyncEvent.ReceivedSharedVaultInvites:
                                    yield this.processInboundInvites(event.payload);
                                    break;
                                case ApplicationEvent.Launched:
                                    if (!this.session.isSignedIn()) {
                                        return;
                                    }
                                    void this.downloadInboundInvites();
                                    break;
                                case NotificationServiceEvent.NotificationReceived:
                                    yield this.handleNotification(event.payload);
                                    break;
                                case WebSocketsServiceEvent.UserInvitedToSharedVault:
                                    yield this.processInboundInvites([event.payload.invite]);
                                    break;
                            }
                        });
                    }
                    handleNotification(event) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            switch (event.eventPayload.props.type.value) {
                                case src.NotificationType.TYPES.SharedVaultInviteCanceled:
                                    {
                                        this.removePendingInvite(event.eventPayload.props.primaryIdentifier.value);
                                        void this.notifyEvent(VaultInviteServiceEvent.InvitesReloaded);
                                        break;
                                    }
                            }
                        });
                    }
                    getCachedPendingInviteRecords() {
                        return Object.values(this.pendingInvites);
                    }
                    downloadInboundInvites() {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.invitesServer.getInboundUserInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return dist.ClientDisplayableError.FromString("Failed to get inbound user invites ".concat(JSON.stringify(response)));
                            }
                            this.pendingInvites = {};
                            yield this.processInboundInvites(response.data.invites);
                            return response.data.invites;
                        });
                    }
                    getOutboundInvites(sharedVault) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.invitesServer.getOutboundUserInvites();
                            if ((0, dist.isErrorResponse)(response)) {
                                return dist.ClientDisplayableError.FromString("Failed to get outbound user invites ".concat(JSON.stringify(response)));
                            }
                            if (sharedVault) {
                                return response.data.invites.filter(invite => invite.shared_vault_uuid === sharedVault.sharing.sharedVaultUuid);
                            }
                            return response.data.invites;
                        });
                    }
                    acceptInvite(pendingInvite) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            if (!pendingInvite.trusted) {
                                return src.Result.fail('Cannot accept untrusted invite');
                            }
                            const acceptResult = yield this._acceptVaultInvite.execute({
                                invite: pendingInvite.invite,
                                message: pendingInvite.message
                            });
                            if (acceptResult.isFailed()) {
                                return src.Result.fail(acceptResult.getError());
                            }
                            this.removePendingInvite(pendingInvite.invite.uuid);
                            this.sync.sync().catch(console.error);
                            this.vaultUsers.invalidateVaultUsersCache(pendingInvite.invite.shared_vault_uuid).catch(console.error);
                            yield this._decryptErroredPayloads.execute();
                            yield this.sync.syncSharedVaultsFromScratch([pendingInvite.invite.shared_vault_uuid]);
                            return src.Result.ok();
                        });
                    }
                    getInvitableContactsForSharedVault(sharedVault) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const users = yield this.vaultUsers.getSharedVaultUsersFromServer(sharedVault);
                            if (!users) {
                                return [];
                            }
                            const contacts = this._getAllContacts.execute();
                            if (contacts.isFailed()) {
                                return [];
                            }
                            const outboundInvites = yield this.getOutboundInvites(sharedVault);
                            if ((0, dist.isClientDisplayableError)(outboundInvites)) {
                                return [];
                            }
                            return contacts.getValue().filter(contact => {
                                const isContactAlreadyInVault = users.some(user => user.user_uuid === contact.contactUuid);
                                const isContactAlreadyInvited = outboundInvites.some(invite => invite.user_uuid === contact.contactUuid);
                                return !isContactAlreadyInVault && !isContactAlreadyInvited;
                            });
                        });
                    }
                    inviteContactToSharedVault(sharedVault, contact, permission) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const contactsResult = yield this._getVaultContacts.execute({
                                sharedVaultUuid: sharedVault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (contactsResult.isFailed()) {
                                return src.Result.fail(contactsResult.getError());
                            }
                            const contacts = contactsResult.getValue();
                            const result = yield this._inviteToVault.execute({
                                sharedVault,
                                recipient: contact,
                                sharedVaultContacts: contacts,
                                permission
                            });
                            if (result.isFailed()) {
                                return src.Result.fail(result.getError());
                            }
                            void this.notifyEvent(VaultInviteServiceEvent.InviteSent);
                            yield this.sync.sync();
                            return result;
                        });
                    }
                    isVaultUserOwner(user) {
                        const result = this._getVault.execute({
                            sharedVaultUuid: user.shared_vault_uuid
                        });
                        if (result.isFailed()) {
                            return false;
                        }
                        const vault = result.getValue();
                        return vault != undefined && vault.sharing.ownerUserUuid === user.user_uuid;
                    }
                    deleteInvite(invite) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.invitesServer.deleteInvite({
                                sharedVaultUuid: invite.shared_vault_uuid,
                                inviteUuid: invite.uuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return dist.ClientDisplayableError.FromString("Failed to delete invite ".concat(JSON.stringify(response)));
                            }
                            this.removePendingInvite(invite.uuid);
                        });
                    }
                    reprocessCachedInvitesTrustStatusAfterTrustedContactsChange() {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            const cachedInvites = this.getCachedPendingInviteRecords().map(record => record.invite);
                            yield this.processInboundInvites(cachedInvites);
                        });
                    }
                    processInboundInvites(invites) {
                        return VaultInviteService_awaiter(this, void 0, void 0, function* () {
                            if (invites.length === 0) {
                                this.updatePendingInviteCount();
                                return;
                            }
                            const keys = this._getKeyPairs.execute();
                            if (keys.isFailed()) {
                                return;
                            }
                            for (const invite of invites) {
                                delete this.pendingInvites[invite.uuid];
                                const sender = this._findContact.execute({
                                    userUuid: invite.sender_uuid
                                });
                                if (!sender.isFailed()) {
                                    const trustedMessage = this._getTrustedPayload.execute({
                                        payload: invite,
                                        privateKey: keys.getValue().encryption.privateKey,
                                        ownUserUuid: this.session.userUuid,
                                        sender: sender.getValue()
                                    });
                                    if (!trustedMessage.isFailed()) {
                                        this.addPendingInvite({
                                            invite,
                                            message: trustedMessage.getValue(),
                                            trusted: true
                                        });
                                        continue;
                                    }
                                }
                                const untrustedMessage = this._getUntrustedPayload.execute({
                                    payload: invite,
                                    privateKey: keys.getValue().encryption.privateKey
                                });
                                if (!untrustedMessage.isFailed()) {
                                    this.addPendingInvite({
                                        invite,
                                        message: untrustedMessage.getValue(),
                                        trusted: false
                                    });
                                }
                            }
                            void this.notifyEvent(VaultInviteServiceEvent.InvitesReloaded);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultLock/UseCase/ValidateVaultPassword.ts
                class ValidateVaultPassword {
                    constructor(encryption, keys) {
                        this.encryption = encryption;
                        this.keys = keys;
                    }
                    execute(vault, password) {
                        if (vault.keyPasswordType !== models_dist.KeySystemPasswordType.UserInputted) {
                            throw new Error('Vault uses randomized password and cannot be validated with password');
                        }
                        const rootKey = this.keys.getPrimaryKeySystemRootKey(vault.systemIdentifier);
                        if (!rootKey) {
                            return src.Result.ok(false);
                        }
                        const derivedRootKey = this.encryption.deriveUserInputtedKeySystemRootKey({
                            keyParams: vault.rootKeyParams,
                            userInputtedPassword: password
                        });
                        return src.Result.ok(rootKey.isEqual(derivedRootKey));
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultLock/VaultLockServiceEvent.ts
                var VaultLockServiceEvent;
                (function (VaultLockServiceEvent) {
                    VaultLockServiceEvent["VaultUnlocked"] = "VaultUnlocked";
                    VaultLockServiceEvent["VaultLocked"] = "VaultLocked";
                })(VaultLockServiceEvent || (VaultLockServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultLock/VaultLockService.ts
                var VaultLockService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class VaultLockService extends AbstractService {
                    constructor(items, encryption, keys, _getVaults, _decryptErroredPayloads, _removeItemsFromMemory, _getVaultItems, eventBus) {
                        super(eventBus);
                        this.encryption = encryption;
                        this.keys = keys;
                        this._getVaults = _getVaults;
                        this._decryptErroredPayloads = _decryptErroredPayloads;
                        this._removeItemsFromMemory = _removeItemsFromMemory;
                        this._getVaultItems = _getVaultItems;
                        this.lockMap = new Map();
                        this.recomputeAllVaultsLockingState = () => VaultLockService_awaiter(this, void 0, void 0, function* () {
                            const vaults = this._getVaults.execute().getValue();
                            for (const vault of vaults) {
                                const locked = this.computeVaultLockState(vault) === 'locked';
                                if (this.lockMap.get(vault.uuid) !== locked) {
                                    this.lockMap.set(vault.uuid, locked);
                                    if (locked) {
                                        void this.notifyEvent(VaultLockServiceEvent.VaultLocked, {
                                            vault
                                        });
                                    }
                                    else {
                                        void this.notifyEvent(VaultLockServiceEvent.VaultUnlocked, {
                                            vault
                                        });
                                    }
                                }
                            }
                        });
                        items.addObserver([src.ContentType.TYPES.KeySystemItemsKey, src.ContentType.TYPES.KeySystemRootKey, src.ContentType.TYPES.VaultListing], () => {
                            void this.recomputeAllVaultsLockingState();
                        });
                    }
                    deinit() {
                        super.deinit();
                        this.encryption = undefined;
                        this.keys = undefined;
                        this._getVaults = undefined;
                        this._decryptErroredPayloads = undefined;
                        this._removeItemsFromMemory = undefined;
                        this._getVaultItems = undefined;
                        this.lockMap.clear();
                    }
                    getLockedvaults() {
                        const vaults = this._getVaults.execute().getValue();
                        return vaults.filter(vault => this.isVaultLocked(vault));
                    }
                    isVaultLocked(vault) {
                        return this.lockMap.get(vault.uuid) === true;
                    }
                    isVaultLockable(vault) {
                        return vault.keyPasswordType === models_dist.KeySystemPasswordType.UserInputted;
                    }
                    lockNonPersistentVault(vault) {
                        return VaultLockService_awaiter(this, void 0, void 0, function* () {
                            if (vault.keyStorageMode === models_dist.KeySystemRootKeyStorageMode.Synced) {
                                throw new Error('Vault uses synced key storage and cannot be locked');
                            }
                            if (vault.keyPasswordType !== models_dist.KeySystemPasswordType.UserInputted) {
                                throw new Error('Vault uses randomized password and cannot be locked');
                            }
                            yield this.keys.wipeVaultKeysFromMemory(vault);
                            const vaultItems = this._getVaultItems.execute(vault).getValue();
                            yield this._removeItemsFromMemory.execute(vaultItems);
                            this.lockMap.set(vault.uuid, true);
                            void this.notifyEventSync(VaultLockServiceEvent.VaultLocked, {
                                vault
                            });
                        });
                    }
                    unlockNonPersistentVault(vault, password) {
                        return VaultLockService_awaiter(this, void 0, void 0, function* () {
                            if (vault.keyPasswordType !== models_dist.KeySystemPasswordType.UserInputted) {
                                throw new Error('Vault uses randomized password and cannot be unlocked with user inputted password');
                            }
                            if (vault.keyStorageMode === models_dist.KeySystemRootKeyStorageMode.Synced) {
                                throw new Error('Vault uses synced root key and cannot be unlocked with user inputted password');
                            }
                            const derivedRootKey = this.encryption.deriveUserInputtedKeySystemRootKey({
                                keyParams: vault.rootKeyParams,
                                userInputtedPassword: password
                            });
                            this.keys.cacheKey(derivedRootKey, vault.keyStorageMode);
                            yield this._decryptErroredPayloads.execute();
                            if (this.computeVaultLockState(vault) === 'locked') {
                                this.keys.removeKeyFromCache(vault.systemIdentifier);
                                return false;
                            }
                            this.lockMap.set(vault.uuid, false);
                            void this.notifyEventSync(VaultLockServiceEvent.VaultUnlocked, {
                                vault
                            });
                            return true;
                        });
                    }
                    computeVaultLockState(vault) {
                        const rootKey = this.keys.getPrimaryKeySystemRootKey(vault.systemIdentifier);
                        if (!rootKey) {
                            return 'locked';
                        }
                        const itemsKey = this.keys.getPrimaryKeySystemItemsKey(vault.systemIdentifier);
                        if (!itemsKey) {
                            return 'locked';
                        }
                        return 'unlocked';
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/DesignateSurvivor/DesignateSurvivor.ts
                var DesignateSurvivor_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DesignateSurvivor {
                    constructor(sharedVaultUserServer) {
                        this.sharedVaultUserServer = sharedVaultUserServer;
                    }
                    execute(dto) {
                        return DesignateSurvivor_awaiter(this, void 0, void 0, function* () {
                            const sharedVaultUuidOrError = src.Uuid.create(dto.sharedVaultUuid);
                            if (sharedVaultUuidOrError.isFailed()) {
                                return src.Result.fail(sharedVaultUuidOrError.getError());
                            }
                            const sharedVaultUuid = sharedVaultUuidOrError.getValue();
                            const sharedVaultMemberUuidOrError = src.Uuid.create(dto.sharedVaultMemberUuid);
                            if (sharedVaultMemberUuidOrError.isFailed()) {
                                return src.Result.fail(sharedVaultMemberUuidOrError.getError());
                            }
                            const sharedVaultMemberUuid = sharedVaultMemberUuidOrError.getValue();
                            const response = yield this.sharedVaultUserServer.designateSurvivor({
                                sharedVaultUuid,
                                sharedVaultMemberUuid
                            });
                            if (response.status !== dist.HttpStatusCode.Success) {
                                return src.Result.fail('Failed to mark designated survivor on the server');
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/GetVaultContacts.ts
                var GetVaultContacts_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetVaultContacts {
                    constructor(_findContact, _getVaultUsers) {
                        this._findContact = _findContact;
                        this._getVaultUsers = _getVaultUsers;
                    }
                    execute(dto) {
                        return GetVaultContacts_awaiter(this, void 0, void 0, function* () {
                            const users = yield this._getVaultUsers.execute({
                                sharedVaultUuid: dto.sharedVaultUuid,
                                readFromCache: dto.readFromCache
                            });
                            if (users.isFailed()) {
                                return src.Result.fail('Failed to get vault users');
                            }
                            const contacts = users.getValue().map(user => this._findContact.execute({
                                userUuid: user.user_uuid
                            })).map(result => result.isFailed() ? undefined : result.getValue()).filter(utils_dist.isNotUndefined);
                            return src.Result.ok(contacts);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/GetVaultUsers.ts
                var GetVaultUsers_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetVaultUsers {
                    constructor(vaultUsersServer, cache) {
                        this.vaultUsersServer = vaultUsersServer;
                        this.cache = cache;
                    }
                    execute(params) {
                        return GetVaultUsers_awaiter(this, void 0, void 0, function* () {
                            if (params.readFromCache) {
                                const cachedUsers = this.cache.get(params.sharedVaultUuid);
                                if (cachedUsers) {
                                    return src.Result.ok(cachedUsers);
                                }
                            }
                            const response = yield this.vaultUsersServer.getSharedVaultUsers({
                                sharedVaultUuid: params.sharedVaultUuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            this.cache.set(params.sharedVaultUuid, response.data.users);
                            return src.Result.ok(response.data.users);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/IsReadonlyVaultMember.ts
                class IsReadonlyVaultMember {
                    constructor(users, cache) {
                        this.users = users;
                        this.cache = cache;
                    }
                    execute(vault) {
                        var _a;
                        if (!vault.sharing) {
                            return src.Result.ok(true);
                        }
                        if (!vault.sharing.ownerUserUuid) {
                            throw new Error("Shared vault ".concat(vault.sharing.sharedVaultUuid, " does not have an owner user uuid"));
                        }
                        const user = this.users.sureUser;
                        const vaultUsers = this.cache.get(vault.sharing.sharedVaultUuid);
                        const userPermission = (_a = vaultUsers === null || vaultUsers === void 0 ? void 0 : vaultUsers.find(vaultUser => vaultUser.user_uuid === user.uuid)) === null || _a === void 0 ? void 0 : _a.permission;
                        return src.Result.ok(userPermission === src.SharedVaultUserPermission.PERMISSIONS.Read);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/IsVaultAdmin.ts
                class IsVaultAdmin {
                    constructor(users, cache) {
                        this.users = users;
                        this.cache = cache;
                    }
                    execute(vault) {
                        var _a;
                        if (!vault.sharing) {
                            return src.Result.ok(true);
                        }
                        if (!vault.sharing.ownerUserUuid) {
                            throw new Error("Shared vault ".concat(vault.sharing.sharedVaultUuid, " does not have an owner user uuid"));
                        }
                        const user = this.users.sureUser;
                        const vaultUsers = this.cache.get(vault.sharing.sharedVaultUuid);
                        const userPermission = (_a = vaultUsers === null || vaultUsers === void 0 ? void 0 : vaultUsers.find(vaultUser => vaultUser.user_uuid === user.uuid)) === null || _a === void 0 ? void 0 : _a.permission;
                        return src.Result.ok(userPermission === src.SharedVaultUserPermission.PERMISSIONS.Admin || vault.sharing.ownerUserUuid === user.uuid);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/IsVaultOwner.ts
                class IsVaultOwner {
                    constructor(users) {
                        this.users = users;
                    }
                    execute(vault) {
                        if (!vault.sharing) {
                            return src.Result.ok(true);
                        }
                        if (!vault.sharing.ownerUserUuid) {
                            throw new Error("Shared vault ".concat(vault.sharing.sharedVaultUuid, " does not have an owner user uuid"));
                        }
                        const user = this.users.sureUser;
                        return src.Result.ok(vault.sharing.ownerUserUuid === user.uuid);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/LeaveSharedVault.ts
                var LeaveSharedVault_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class LeaveVault {
                    constructor(users, vaultUserServer, items, _deleteThirdPartyVault) {
                        this.users = users;
                        this.vaultUserServer = vaultUserServer;
                        this.items = items;
                        this._deleteThirdPartyVault = _deleteThirdPartyVault;
                    }
                    execute(params) {
                        return LeaveSharedVault_awaiter(this, void 0, void 0, function* () {
                            const latestVaultListing = this.items.findItem(params.sharedVault.uuid);
                            if (!latestVaultListing) {
                                throw new Error("LeaveVaultUseCase: Could not find vault ".concat(params.sharedVault.uuid));
                            }
                            const response = yield this.vaultUserServer.deleteSharedVaultUser({
                                sharedVaultUuid: latestVaultListing.sharing.sharedVaultUuid,
                                userUuid: this.users.sureUser.uuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return dist.ClientDisplayableError.FromString("Failed to leave vault ".concat(JSON.stringify(response)));
                            }
                            yield this._deleteThirdPartyVault.execute(latestVaultListing);
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/UseCase/RemoveSharedVaultMember.ts
                var RemoveSharedVaultMember_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RemoveVaultMember {
                    constructor(vaultUserServer) {
                        this.vaultUserServer = vaultUserServer;
                    }
                    execute(params) {
                        return RemoveSharedVaultMember_awaiter(this, void 0, void 0, function* () {
                            const response = yield this.vaultUserServer.deleteSharedVaultUser({
                                sharedVaultUuid: params.sharedVaultUuid,
                                userUuid: params.userUuid
                            });
                            if ((0, dist.isErrorResponse)(response)) {
                                return src.Result.fail((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return src.Result.ok();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/VaultUserCache.ts
                class VaultUserCache {
                    constructor() {
                        this.cache = new Map();
                    }
                    get(sharedVaultUuid) {
                        return this.cache.get(sharedVaultUuid);
                    }
                    set(sharedVaultUuid, users) {
                        this.cache.set(sharedVaultUuid, users);
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/VaultUserServiceEvent.ts
                var VaultUserServiceEvent;
                (function (VaultUserServiceEvent) {
                    VaultUserServiceEvent["UsersChanged"] = "VaultUserServiceEvent.UsersChanged";
                    VaultUserServiceEvent["InvalidatedAllUserCache"] = "VaultUserServiceEvent.InvalidatedUserCache";
                    VaultUserServiceEvent["InvalidatedUserCacheForVault"] = "VaultUserServiceEvent.InvalidatedUserCacheForVault";
                })(VaultUserServiceEvent || (VaultUserServiceEvent = {}));
                ; // CONCATENATED MODULE: ../services/src/Domain/VaultUser/VaultUserService.ts
                var VaultUserService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class VaultUserService extends AbstractService {
                    constructor(vaults, vaultLocks, _getVaultUsers, _removeVaultMember, _isVaultOwner, _isVaultAdmin, _isReadonlyVaultMember, _getVault, _leaveVault, designateSurvivorUseCase, eventBus) {
                        super(eventBus);
                        this.vaults = vaults;
                        this.vaultLocks = vaultLocks;
                        this._getVaultUsers = _getVaultUsers;
                        this._removeVaultMember = _removeVaultMember;
                        this._isVaultOwner = _isVaultOwner;
                        this._isVaultAdmin = _isVaultAdmin;
                        this._isReadonlyVaultMember = _isReadonlyVaultMember;
                        this._getVault = _getVault;
                        this._leaveVault = _leaveVault;
                        this.designateSurvivorUseCase = designateSurvivorUseCase;
                    }
                    deinit() {
                        super.deinit();
                        this.vaults = undefined;
                        this._getVaultUsers = undefined;
                        this._removeVaultMember = undefined;
                        this._isVaultOwner = undefined;
                        this._getVault = undefined;
                        this._leaveVault = undefined;
                    }
                    designateSurvivor(sharedVault, userUuid) {
                        return VaultUserService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.designateSurvivorUseCase.execute({
                                sharedVaultMemberUuid: userUuid,
                                sharedVaultUuid: sharedVault.sharing.sharedVaultUuid
                            });
                            if (result.isFailed()) {
                                return src.Result.fail("Could not designate survivor: ".concat(result.getError()));
                            }
                            return src.Result.ok();
                        });
                    }
                    invalidateVaultUsersCache(sharedVaultUuid) {
                        return VaultUserService_awaiter(this, void 0, void 0, function* () {
                            if (sharedVaultUuid) {
                                yield this._getVaultUsers.execute({
                                    sharedVaultUuid: sharedVaultUuid,
                                    readFromCache: false
                                });
                                void this.notifyEvent(VaultUserServiceEvent.InvalidatedUserCacheForVault, sharedVaultUuid);
                                return;
                            }
                            yield Promise.all(this.vaults.getVaults().map(vault => VaultUserService_awaiter(this, void 0, void 0, function* () {
                                if (!vault.isSharedVaultListing()) {
                                    return;
                                }
                                yield this._getVaultUsers.execute({
                                    sharedVaultUuid: vault.sharing.sharedVaultUuid,
                                    readFromCache: false
                                });
                                void this.notifyEvent(VaultUserServiceEvent.InvalidatedUserCacheForVault, vault.sharing.sharedVaultUuid);
                            })));
                            void this.notifyEvent(VaultUserServiceEvent.InvalidatedAllUserCache);
                        });
                    }
                    getSharedVaultUsersFromServer(sharedVault) {
                        return VaultUserService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this._getVaultUsers.execute({
                                sharedVaultUuid: sharedVault.sharing.sharedVaultUuid,
                                readFromCache: false
                            });
                            if (result.isFailed()) {
                                return undefined;
                            }
                            return result.getValue();
                        });
                    }
                    isCurrentUserSharedVaultOwner(sharedVault) {
                        return this._isVaultOwner.execute(sharedVault).getValue();
                    }
                    isCurrentUserSharedVaultAdmin(sharedVault) {
                        return this._isVaultAdmin.execute(sharedVault).getValue();
                    }
                    isCurrentUserReadonlyVaultMember(vault) {
                        if (!vault.isSharedVaultListing()) {
                            return false;
                        }
                        return this._isReadonlyVaultMember.execute(vault).getValue();
                    }
                    removeUserFromSharedVault(sharedVault, userUuid) {
                        return VaultUserService_awaiter(this, void 0, void 0, function* () {
                            if (!this.isCurrentUserSharedVaultOwner(sharedVault)) {
                                throw new Error('Only vault admins can remove users');
                            }
                            if (this.vaultLocks.isVaultLocked(sharedVault)) {
                                throw new Error('Cannot remove user from locked vault');
                            }
                            const result = yield this._removeVaultMember.execute({
                                sharedVaultUuid: sharedVault.sharing.sharedVaultUuid,
                                userUuid
                            });
                            if (result.isFailed()) {
                                return result;
                            }
                            void this.notifyEvent(VaultUserServiceEvent.UsersChanged);
                            yield this.vaults.rotateVaultRootKey(sharedVault);
                            return result;
                        });
                    }
                    isVaultUserOwner(user) {
                        const result = this._getVault.execute({
                            sharedVaultUuid: user.shared_vault_uuid
                        });
                        if (result.isFailed()) {
                            return false;
                        }
                        const vault = result.getValue();
                        return vault != undefined && vault.sharing.ownerUserUuid === user.user_uuid;
                    }
                    leaveSharedVault(sharedVault) {
                        return VaultUserService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this._leaveVault.execute({
                                sharedVault: sharedVault
                            });
                            if ((0, dist.isClientDisplayableError)(result)) {
                                return result;
                            }
                            void this.notifyEvent(VaultUserServiceEvent.UsersChanged);
                        });
                    }
                    getFormattedMemberPermission(permission) {
                        switch (permission) {
                            case 'admin':
                                return 'Admin';
                            case 'write':
                                return 'Read / Write';
                            case 'read':
                                return 'Read-only';
                            default:
                                return 'Unknown';
                        }
                    }
                }
                ; // CONCATENATED MODULE: ../services/src/Domain/index.ts
                ; // CONCATENATED MODULE: ../services/src/index.ts
                /***/ 
            }),
            /***/ 8430: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91440: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 21404: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 63180: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(8430), exports);
                __exportStar(__webpack_require__(91440), exports);
                __exportStar(__webpack_require__(21404), exports);
                /***/ 
            }),
            /***/ 45575: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 83372: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(45575), exports);
                /***/ 
            }),
            /***/ 41335: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 90176: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.timingSafeEqual = void 0;
                /**
                 * Constant-time string comparison
                 * @param a
                 * @param b
                 */
                function timingSafeEqual(a, b) {
                    const strA = String(a);
                    let strB = String(b);
                    const lenA = strA.length;
                    let result = 0;
                    if (lenA !== strB.length) {
                        strB = strA;
                        result = 1;
                    }
                    for (let i = 0; i < lenA; i++) {
                        result |= strA.charCodeAt(i) ^ strB.charCodeAt(i);
                    }
                    return result === 0;
                }
                exports.timingSafeEqual = timingSafeEqual;
                /***/ 
            }),
            /***/ 78492: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(41335), exports);
                __exportStar(__webpack_require__(90176), exports);
                /***/ 
            }),
            /***/ 26734: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 68101: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(26734), exports);
                /***/ 
            }),
            /***/ 88602: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 84370: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 1282: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 69422: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 51234: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SodiumConstant = void 0;
                exports.SodiumConstant = {
                    CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_STATEBYTES: 52,
                    CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_ABYTES: 17,
                    CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_HEADERBYTES: 24,
                    CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_KEYBYTES: 32,
                    CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_MESSAGEBYTES_MAX: 0x3fffffff80,
                    crypto_box_SEEDBYTES: 32,
                    crypto_sign_SEEDBYTES: 32,
                    crypto_generichash_KEYBYTES: 32
                };
                /***/ 
            }),
            /***/ 58081: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 42565: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.SodiumTag = void 0;
                var SodiumTag;
                (function (SodiumTag) {
                    SodiumTag[SodiumTag["CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_PUSH"] = 0] = "CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_PUSH";
                    SodiumTag[SodiumTag["CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_PULL"] = 1] = "CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_PULL";
                    SodiumTag[SodiumTag["CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_REKEY"] = 2] = "CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_REKEY";
                    SodiumTag[SodiumTag["CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_FINAL"] = 3] = "CRYPTO_SECRETSTREAM_XCHACHA20POLY1305_TAG_FINAL";
                })(SodiumTag || (exports.SodiumTag = SodiumTag = {}));
                /***/ 
            }),
            /***/ 67918: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 39296: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91338: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 83395: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 21084: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 30418: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(88602), exports);
                __exportStar(__webpack_require__(84370), exports);
                __exportStar(__webpack_require__(1282), exports);
                __exportStar(__webpack_require__(69422), exports);
                __exportStar(__webpack_require__(51234), exports);
                __exportStar(__webpack_require__(58081), exports);
                __exportStar(__webpack_require__(42565), exports);
                __exportStar(__webpack_require__(67918), exports);
                __exportStar(__webpack_require__(39296), exports);
                __exportStar(__webpack_require__(91338), exports);
                __exportStar(__webpack_require__(83395), exports);
                __exportStar(__webpack_require__(21084), exports);
                /***/ 
            }),
            /***/ 98418: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(63180), exports);
                __exportStar(__webpack_require__(83372), exports);
                __exportStar(__webpack_require__(78492), exports);
                __exportStar(__webpack_require__(68101), exports);
                __exportStar(__webpack_require__(30418), exports);
                /***/ 
            }),
            /***/ 13979: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ v: () => ( /* binding */TYPES)
                    /* harmony export */ 
                });
                const TYPES = {
                    // System
                    DeviceInterface: Symbol.for('DeviceInterface'),
                    AlertService: Symbol.for('AlertService'),
                    Crypto: Symbol.for('Crypto'),
                    // Services
                    InternalEventBus: Symbol.for('InternalEventBus'),
                    PayloadManager: Symbol.for('PayloadManager'),
                    ItemManager: Symbol.for('ItemManager'),
                    MutatorService: Symbol.for('MutatorService'),
                    DiskStorageService: Symbol.for('DiskStorageService'),
                    NotificationService: Symbol.for('NotificationService'),
                    InMemoryStore: Symbol.for('InMemoryStore'),
                    KeySystemKeyManager: Symbol.for('KeySystemKeyManager'),
                    EncryptionService: Symbol.for('EncryptionService'),
                    ChallengeService: Symbol.for('ChallengeService'),
                    DeprecatedHttpService: Symbol.for('DeprecatedHttpService'),
                    HttpService: Symbol.for('HttpService'),
                    LegacyApiService: Symbol.for('LegacyApiService'),
                    UserServer: Symbol.for('UserServer'),
                    UserRequestServer: Symbol.for('UserRequestServer'),
                    UserApiService: Symbol.for('UserApiService'),
                    SubscriptionServer: Symbol.for('SubscriptionServer'),
                    SubscriptionApiService: Symbol.for('SubscriptionApiService'),
                    WebSocketServer: Symbol.for('WebSocketServer'),
                    WebSocketApiService: Symbol.for('WebSocketApiService'),
                    WebSocketsService: Symbol.for('WebSocketsService'),
                    SessionManager: Symbol.for('SessionManager'),
                    SubscriptionManager: Symbol.for('SubscriptionManager'),
                    HistoryManager: Symbol.for('HistoryManager'),
                    SyncFrequencyGuard: Symbol.for('SyncFrequencyGuard'),
                    SyncBackoffService: Symbol.for('SyncBackoffService'),
                    SyncService: Symbol.for('SyncService'),
                    ProtectionService: Symbol.for('ProtectionService'),
                    UserService: Symbol.for('UserService'),
                    KeyRecoveryService: Symbol.for('KeyRecoveryService'),
                    SingletonManager: Symbol.for('SingletonManager'),
                    PreferencesService: Symbol.for('PreferencesService'),
                    SettingsService: Symbol.for('SettingsService'),
                    FeaturesService: Symbol.for('FeaturesService'),
                    ComponentManager: Symbol.for('ComponentManager'),
                    MfaService: Symbol.for('MfaService'),
                    StatusService: Symbol.for('StatusService'),
                    MigrationService: Symbol.for('MigrationService'),
                    FileService: Symbol.for('FileService'),
                    IntegrityService: Symbol.for('IntegrityService'),
                    ListedService: Symbol.for('ListedService'),
                    ActionsService: Symbol.for('ActionsService'),
                    AuthenticatorApiService: Symbol.for('AuthenticatorApiService'),
                    AuthenticatorManager: Symbol.for('AuthenticatorManager'),
                    AuthApiService: Symbol.for('AuthApiService'),
                    AuthManager: Symbol.for('AuthManager'),
                    RevisionApiService: Symbol.for('RevisionApiService'),
                    RevisionManager: Symbol.for('RevisionManager'),
                    ContactService: Symbol.for('ContactService'),
                    VaultService: Symbol.for('VaultService'),
                    SharedVaultService: Symbol.for('SharedVaultService'),
                    AsymmetricMessageService: Symbol.for('AsymmetricMessageService'),
                    SelfContactManager: Symbol.for('SelfContactManager'),
                    EncryptionOperators: Symbol.for('EncryptionOperators'),
                    RootKeyManager: Symbol.for('RootKeyManager'),
                    ItemsEncryptionService: Symbol.for('ItemsEncryptionService'),
                    VaultUserService: Symbol.for('VaultUserService'),
                    VaultInviteService: Symbol.for('VaultInviteService'),
                    VaultUserCache: Symbol.for('VaultUserCache'),
                    VaultLockService: Symbol.for('VaultLockService'),
                    Logger: Symbol.for('Logger'),
                    // Servers
                    RevisionServer: Symbol.for('RevisionServer'),
                    AuthenticatorServer: Symbol.for('AuthenticatorServer'),
                    AuthServer: Symbol.for('AuthServer'),
                    SharedVaultInvitesServer: Symbol.for('SharedVaultInvitesServer'),
                    SharedVaultServer: Symbol.for('SharedVaultServer'),
                    SharedVaultUsersServer: Symbol.for('SharedVaultUsersServer'),
                    AsymmetricMessageServer: Symbol.for('AsymmetricMessageServer'),
                    // Desktop Services
                    FilesBackupService: Symbol.for('FilesBackupService'),
                    HomeServerService: Symbol.for('HomeServerService'),
                    // Usecases
                    SignInWithRecoveryCodes: Symbol.for('SignInWithRecoveryCodes'),
                    GetRecoveryCodes: Symbol.for('GetRecoveryCodes'),
                    AddAuthenticator: Symbol.for('AddAuthenticator'),
                    ListAuthenticators: Symbol.for('ListAuthenticators'),
                    DeleteAuthenticator: Symbol.for('DeleteAuthenticator'),
                    GetAuthenticatorAuthenticationOptions: Symbol.for('GetAuthenticatorAuthenticationOptions'),
                    GetAuthenticatorAuthenticationResponse: Symbol.for('GetAuthenticatorAuthenticationResponse'),
                    ListRevisions: Symbol.for('ListRevisions'),
                    GetRevision: Symbol.for('GetRevision'),
                    DeleteRevision: Symbol.for('DeleteRevision'),
                    ImportData: Symbol.for('ImportData'),
                    DiscardItemsLocally: Symbol.for('DiscardItemsLocally'),
                    FindContact: Symbol.for('FindContact'),
                    GetAllContacts: Symbol.for('GetAllContacts'),
                    CreateOrEditContact: Symbol.for('CreateOrEditContact'),
                    EditContact: Symbol.for('EditContact'),
                    ValidateItemSigner: Symbol.for('ValidateItemSigner'),
                    GetVault: Symbol.for('GetVault'),
                    GetVaults: Symbol.for('GetVaults'),
                    SyncLocalVaultsWithRemoteSharedVaults: Symbol.for('SyncLocalVaultsWithRemoteSharedVaults'),
                    GetSharedVaults: Symbol.for('GetSharedVaults'),
                    GetOwnedSharedVaults: Symbol.for('GetOwnedSharedVaults'),
                    ChangeVaultKeyOptions: Symbol.for('ChangeVaultKeyOptions'),
                    MoveItemsToVault: Symbol.for('MoveItemsToVault'),
                    CreateVault: Symbol.for('CreateVault'),
                    DeleteContact: Symbol.for('DeleteContact'),
                    ContactBelongsToVault: Symbol.for('ContactBelongsToVault'),
                    RemoveItemFromVault: Symbol.for('RemoveItemFromVault'),
                    DeleteVault: Symbol.for('DeleteVault'),
                    RotateVaultKey: Symbol.for('RotateVaultKey'),
                    CreateSharedVault: Symbol.for('CreateSharedVault'),
                    HandleKeyPairChange: Symbol.for('HandleKeyPairChange'),
                    NotifyVaultUsersOfKeyRotation: Symbol.for('NotifyVaultUsersOfKeyRotation'),
                    SendVaultDataChangedMessage: Symbol.for('SendVaultDataChangedMessage'),
                    SendVaultKeyChangedMessage: Symbol.for('SendVaultKeyChangedMessage'),
                    GetTrustedPayload: Symbol.for('GetTrustedPayload'),
                    GetUntrustedPayload: Symbol.for('GetUntrustedPayload'),
                    GetVaultContacts: Symbol.for('GetVaultContacts'),
                    AcceptVaultInvite: Symbol.for('AcceptVaultInvite'),
                    InviteToVault: Symbol.for('InviteToVault'),
                    LeaveVault: Symbol.for('LeaveVault'),
                    DeleteThirdPartyVault: Symbol.for('DeleteThirdPartyVault'),
                    ShareContactWithVault: Symbol.for('ShareContactWithVault'),
                    ConvertToSharedVault: Symbol.for('ConvertToSharedVault'),
                    DeleteSharedVault: Symbol.for('DeleteSharedVault'),
                    RemoveVaultMember: Symbol.for('RemoveVaultMember'),
                    DesignateSurvivor: Symbol.for('DesignateSurvivor'),
                    GetVaultUsers: Symbol.for('GetSharedVaultUsers'),
                    ResendAllMessages: Symbol.for('ResendAllMessages'),
                    ReuploadAllInvites: Symbol.for('ReuploadAllInvites'),
                    ReuploadInvite: Symbol.for('ReuploadInvite'),
                    GetInboundMessages: Symbol.for('GetInboundMessages'),
                    GetOutboundMessages: Symbol.for('GetOutboundMessages'),
                    HandleRootKeyChangedMessage: Symbol.for('HandleRootKeyChangedMessage'),
                    ProcessAcceptedVaultInvite: Symbol.for('ProcessAcceptedVaultInvite'),
                    ResendMessage: Symbol.for('ResendMessage'),
                    SendMessage: Symbol.for('SendMessage'),
                    SendOwnContactChangeMessage: Symbol.for('SendOwnContactChangeMessage'),
                    DecryptMessage: Symbol.for('DecryptMessage'),
                    DecryptOwnMessage: Symbol.for('DecryptOwnMessage'),
                    EncryptMessage: Symbol.for('EncryptMessage'),
                    GetMessageAdditionalData: Symbol.for('GetMessageAdditionalData'),
                    SendVaultInvite: Symbol.for('SendVaultInvite'),
                    ReplaceContactData: Symbol.for('ReplaceContactData'),
                    CreateNewDefaultItemsKey: Symbol.for('CreateNewDefaultItemsKey'),
                    CreateNewItemsKeyWithRollback: Symbol.for('CreateNewItemsKeyWithRollback'),
                    FindDefaultItemsKey: Symbol.for('FindDefaultItemsKey'),
                    DecryptErroredTypeAPayloads: Symbol.for('DecryptErroredTypeAPayloads'),
                    DecryptTypeAPayload: Symbol.for('DecryptTypeAPayload'),
                    DecryptTypeAPayloadWithKeyLookup: Symbol.for('DecryptTypeAPayloadWithKeyLookup'),
                    EncryptTypeAPayload: Symbol.for('EncryptTypeAPayload'),
                    EncryptTypeAPayloadWithKeyLookup: Symbol.for('EncryptTypeAPayloadWithKeyLookup'),
                    DecryptBackupFile: Symbol.for('DecryptBackupFile'),
                    IsVaultOwner: Symbol.for('IsVaultOwner'),
                    IsVaultAdmin: Symbol.for('IsVaultAdmin'),
                    IsReadonlyVaultMember: Symbol.for('IsReadonlyVaultMember'),
                    RemoveItemsFromMemory: Symbol.for('RemoveItemsFromMemory'),
                    ReencryptTypeAItems: Symbol.for('ReencryptTypeAItems'),
                    DecryptErroredPayloads: Symbol.for('DecryptErroredPayloads'),
                    GetKeyPairs: Symbol.for('GetKeyPairs'),
                    ChangeVaultStorageMode: Symbol.for('ChangeVaultStorageMode'),
                    ChangeAndSaveItem: Symbol.for('ChangeAndSaveItem'),
                    GetHost: Symbol.for('GetHost'),
                    IsApplicationUsingThirdPartyHost: Symbol.for('IsApplicationUsingThirdPartyHost'),
                    SetHost: Symbol.for('SetHost'),
                    GenerateUuid: Symbol.for('GenerateUuid'),
                    GetVaultItems: Symbol.for('GetVaultItems'),
                    ValidateVaultPassword: Symbol.for('ValidateVaultPassword'),
                    DecryptBackupPayloads: Symbol.for('DecryptBackupPayloads'),
                    DetermineKeyToUse: Symbol.for('DetermineKeyToUse'),
                    GetBackupFileType: Symbol.for('GetBackupFileType'),
                    GetFilePassword: Symbol.for('GetFilePassword'),
                    AuthorizeVaultDeletion: Symbol.for('AuthorizeVaultDeletion'),
                    CreateDecryptedBackupFile: Symbol.for('CreateDecryptedBackupFile'),
                    CreateEncryptedBackupFile: Symbol.for('CreateEncryptedBackupFile'),
                    // Mappers
                    SessionStorageMapper: Symbol.for('SessionStorageMapper'),
                    LegacySessionStorageMapper: Symbol.for('LegacySessionStorageMapper')
                };
                /***/ 
            }),
            /***/ 2256: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Ak: () => ( /* binding */isEnvironmentWebOrDesktop),
                    /* harmony export */ FB: () => ( /* binding */platformFromString),
                    /* harmony export */ Im: () => ( /* binding */isEnvironmentMobile),
                    /* harmony export */ _e: () => ( /* binding */platformToString),
                    /* harmony export */ g: () => ( /* binding */environmentToString)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__);
                function platformFromString(string) {
                    const map = {
                        'mac-web': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.MacWeb,
                        'mac-desktop': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.MacDesktop,
                        'linux-web': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.LinuxWeb,
                        'linux-desktop': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.LinuxDesktop,
                        'windows-web': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.WindowsWeb,
                        'windows-desktop': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.WindowsDesktop,
                        'ios-web': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.Ios,
                        'android-web': _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.Android
                    };
                    return map[string];
                }
                function platformToString(platform) {
                    const map = {
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.MacWeb]: 'mac-web',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.MacDesktop]: 'mac-desktop',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.LinuxWeb]: 'linux-web',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.LinuxDesktop]: 'linux-desktop',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.WindowsWeb]: 'windows-web',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.WindowsDesktop]: 'windows-desktop',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.Ios]: 'ios',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Platform.Android]: 'android'
                    };
                    return map[platform];
                }
                function environmentToString(environment) {
                    const map = {
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Web]: 'web',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Desktop]: 'desktop',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Mobile]: 'native-mobile-web',
                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Clipper]: 'clipper'
                    };
                    return map[environment];
                }
                function isEnvironmentWebOrDesktop(environment) {
                    return environment === _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Web || environment === _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Desktop;
                }
                function isEnvironmentMobile(environment) {
                    return environment === _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.Environment.Mobile;
                }
                /***/ 
            }),
            /***/ 85593: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    J5: () => ( /* reexport */LiveItem),
                    UC: () => ( /* reexport */SNApplication),
                    ie: () => ( /* reexport */applicationEventForSyncEvent),
                    g: () => ( /* reexport */Platforms /* environmentToString */.g),
                    Im: () => ( /* reexport */Platforms /* isEnvironmentMobile */.Im),
                    Ak: () => ( /* reexport */Platforms /* isEnvironmentWebOrDesktop */.Ak),
                    FB: () => ( /* reexport */Platforms /* platformFromString */.FB),
                    _e: () => ( /* reexport */Platforms /* platformToString */._e)
                });
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var src = __webpack_require__(20875);
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var services_src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../models/dist/index.js
                var dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                ; // CONCATENATED MODULE: ./lib/Application/Event.ts
                const map = {
                    [services_src /* SyncEvent */.wMo.SyncCompletedWithAllItemsUploaded]: services_src /* ApplicationEvent */.n9K.CompletedFullSync,
                    [services_src /* SyncEvent */.wMo.PaginatedSyncRequestCompleted]: services_src /* ApplicationEvent */.n9K.CompletedIncrementalSync,
                    [services_src /* SyncEvent */.wMo.SyncError]: services_src /* ApplicationEvent */.n9K.FailedSync,
                    [services_src /* SyncEvent */.wMo.SyncTakingTooLong]: services_src /* ApplicationEvent */.n9K.HighLatencySync,
                    [services_src /* SyncEvent */.wMo.EnterOutOfSync]: services_src /* ApplicationEvent */.n9K.EnteredOutOfSync,
                    [services_src /* SyncEvent */.wMo.ExitOutOfSync]: services_src /* ApplicationEvent */.n9K.ExitedOutOfSync,
                    [services_src /* SyncEvent */.wMo.LocalDataLoaded]: services_src /* ApplicationEvent */.n9K.LocalDataLoaded,
                    [services_src /* SyncEvent */.wMo.MajorDataChange]: services_src /* ApplicationEvent */.n9K.MajorDataChange,
                    [services_src /* SyncEvent */.wMo.LocalDataIncrementalLoad]: services_src /* ApplicationEvent */.n9K.LocalDataIncrementalLoad,
                    [services_src /* SyncEvent */.wMo.StatusChanged]: services_src /* ApplicationEvent */.n9K.SyncStatusChanged,
                    [services_src /* SyncEvent */.wMo.SyncDidBeginProcessing]: services_src /* ApplicationEvent */.n9K.WillSync,
                    [services_src /* SyncEvent */.wMo.InvalidSession]: services_src /* ApplicationEvent */.n9K.InvalidSyncSession,
                    [services_src /* SyncEvent */.wMo.DatabaseReadError]: services_src /* ApplicationEvent */.n9K.LocalDatabaseReadError,
                    [services_src /* SyncEvent */.wMo.DatabaseWriteError]: services_src /* ApplicationEvent */.n9K.LocalDatabaseWriteError,
                    [services_src /* SyncEvent */.wMo.DownloadFirstSyncCompleted]: services_src /* ApplicationEvent */.n9K.CompletedInitialSync,
                    [services_src /* SyncEvent */.wMo.TooManyRequests]: services_src /* ApplicationEvent */.n9K.SyncTooManyRequests
                };
                function applicationEventForSyncEvent(syncEvent) {
                    return map[syncEvent];
                }
                // EXTERNAL MODULE: ../encryption/src/index.ts + 52 modules
                var encryption_src = __webpack_require__(86999);
                // EXTERNAL MODULE: ./lib/Log.ts
                var Log = __webpack_require__(43361);
                // EXTERNAL MODULE: ./lib/Services/Actions/ActionsService.ts
                var ActionsService = __webpack_require__(19820);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/DeleteRevision/DeleteRevision.ts
                var DeleteRevision = __webpack_require__(46390);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/GetRevision/GetRevision.ts
                var GetRevision = __webpack_require__(51383);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/ListRevisions/ListRevisions.ts
                var ListRevisions = __webpack_require__(9704);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/GetAuthenticatorAuthenticationResponse/GetAuthenticatorAuthenticationResponse.ts
                var GetAuthenticatorAuthenticationResponse = __webpack_require__(84526);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/GetAuthenticatorAuthenticationOptions/GetAuthenticatorAuthenticationOptions.ts
                var GetAuthenticatorAuthenticationOptions = __webpack_require__(12473);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/DeleteAuthenticator/DeleteAuthenticator.ts
                var DeleteAuthenticator = __webpack_require__(58875);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/ListAuthenticators/ListAuthenticators.ts
                var ListAuthenticators = __webpack_require__(43252);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/AddAuthenticator/AddAuthenticator.ts
                var AddAuthenticator = __webpack_require__(68704);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/GetRecoveryCodes/GetRecoveryCodes.ts
                var GetRecoveryCodes = __webpack_require__(79327);
                // EXTERNAL MODULE: ./lib/Domain/UseCase/SignInWithRecoveryCodes/SignInWithRecoveryCodes.ts
                var SignInWithRecoveryCodes = __webpack_require__(32274);
                // EXTERNAL MODULE: ./lib/Services/Listed/ListedService.ts
                var ListedService = __webpack_require__(81679);
                // EXTERNAL MODULE: ./lib/Services/Migration/MigrationService.ts
                var MigrationService = __webpack_require__(8740);
                // EXTERNAL MODULE: ./lib/Services/Mfa/MfaService.ts
                var MfaService = __webpack_require__(3876);
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/ComponentManager.ts + 7 modules
                var ComponentManager = __webpack_require__(74987);
                // EXTERNAL MODULE: ./lib/Services/Features/FeaturesService.ts + 3 modules
                var FeaturesService = __webpack_require__(6314);
                // EXTERNAL MODULE: ./lib/Services/Settings/SNSettingsService.ts + 2 modules
                var SNSettingsService = __webpack_require__(98116);
                // EXTERNAL MODULE: ./lib/Services/Preferences/PreferencesService.ts
                var PreferencesService = __webpack_require__(30693);
                // EXTERNAL MODULE: ./lib/Services/Singleton/SingletonManager.ts
                var SingletonManager = __webpack_require__(15109);
                // EXTERNAL MODULE: ./lib/Services/KeyRecovery/KeyRecoveryService.ts + 3 modules
                var KeyRecoveryService = __webpack_require__(80738);
                // EXTERNAL MODULE: ./lib/Services/Protection/ProtectionService.ts
                var ProtectionService = __webpack_require__(51271);
                // EXTERNAL MODULE: ./lib/Services/Sync/SyncService.ts + 1 modules
                var SyncService = __webpack_require__(37486);
                // EXTERNAL MODULE: ./lib/Services/History/HistoryManager.ts
                var HistoryManager = __webpack_require__(29675);
                // EXTERNAL MODULE: ./lib/Services/Session/SessionManager.ts + 1 modules
                var SessionManager = __webpack_require__(53218);
                // EXTERNAL MODULE: ./lib/Services/Api/ApiService.ts
                var ApiService = __webpack_require__(54911);
                // EXTERNAL MODULE: ./lib/Version.ts
                var Version = __webpack_require__(94986);
                // EXTERNAL MODULE: ./lib/Services/Api/DeprecatedHttpService.ts
                var DeprecatedHttpService = __webpack_require__(78734);
                // EXTERNAL MODULE: ./lib/Services/Challenge/ChallengeService.ts
                var ChallengeService = __webpack_require__(40278);
                // EXTERNAL MODULE: ./lib/Services/Storage/DiskStorageService.ts
                var DiskStorageService = __webpack_require__(28559);
                // EXTERNAL MODULE: ./lib/Services/Mutator/MutatorService.ts
                var MutatorService = __webpack_require__(28178);
                // EXTERNAL MODULE: ./lib/Services/Items/ItemManager.ts
                var ItemManager = __webpack_require__(45447);
                // EXTERNAL MODULE: ./lib/Services/Payloads/PayloadManager.ts
                var PayloadManager = __webpack_require__(64892);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var dist_src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ./lib/Services/Mapping/LegacySessionStorageMapper.ts
                class LegacySessionStorageMapper {
                    toDomain(projection) {
                        const { jwt } = projection;
                        const legacySessionOrError = dist_src.LegacySession.create(jwt);
                        if (legacySessionOrError.isFailed()) {
                            throw new Error(legacySessionOrError.getError());
                        }
                        return legacySessionOrError.getValue();
                    }
                    toProjection(domain) {
                        return {
                            jwt: domain.accessToken
                        };
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/Mapping/SessionStorageMapper.ts
                class SessionStorageMapper {
                    toDomain(projection) {
                        const accessTokenOrError = dist_src.SessionToken.create(projection.accessToken, projection.accessExpiration);
                        if (accessTokenOrError.isFailed()) {
                            throw new Error(accessTokenOrError.getError());
                        }
                        const accessToken = accessTokenOrError.getValue();
                        const refreshTokenOrError = dist_src.SessionToken.create(projection.refreshToken, projection.refreshExpiration);
                        if (refreshTokenOrError.isFailed()) {
                            throw new Error(refreshTokenOrError.getError());
                        }
                        const refreshToken = refreshTokenOrError.getValue();
                        const session = dist_src.Session.create(accessToken, refreshToken, projection.readonlyAccess);
                        if (session.isFailed()) {
                            throw new Error(session.getError());
                        }
                        return session.getValue();
                    }
                    toProjection(domain) {
                        return {
                            accessToken: domain.accessToken.value,
                            refreshToken: domain.refreshToken.value,
                            accessExpiration: domain.accessToken.expiresAt,
                            refreshExpiration: domain.refreshToken.expiresAt,
                            readonlyAccess: domain.isReadOnly()
                        };
                    }
                }
                // EXTERNAL MODULE: ../api/dist/index.js
                var api_dist = __webpack_require__(70781);
                // EXTERNAL MODULE: ./lib/Application/Dependencies/Types.ts
                var Types = __webpack_require__(13979);
                ; // CONCATENATED MODULE: ./lib/Services/Sync/SyncFrequencyGuard.ts
                class SyncFrequencyGuard {
                    constructor(syncCallsThresholdPerMinute) {
                        this.syncCallsThresholdPerMinute = syncCallsThresholdPerMinute;
                        this.callsPerMinuteMap = new Map();
                    }
                    isSyncCallsThresholdReachedThisMinute() {
                        const stringDateToTheMinute = this.getCallsPerMinuteKey();
                        const persistedCallsCount = this.callsPerMinuteMap.get(stringDateToTheMinute) || 0;
                        return persistedCallsCount >= this.syncCallsThresholdPerMinute;
                    }
                    incrementCallsPerMinute() {
                        const stringDateToTheMinute = this.getCallsPerMinuteKey();
                        const persistedCallsCount = this.callsPerMinuteMap.get(stringDateToTheMinute);
                        const newMinuteStarted = persistedCallsCount === undefined;
                        if (newMinuteStarted) {
                            this.clear();
                            this.callsPerMinuteMap.set(stringDateToTheMinute, 1);
                        }
                        else {
                            this.callsPerMinuteMap.set(stringDateToTheMinute, persistedCallsCount + 1);
                        }
                    }
                    clear() {
                        this.callsPerMinuteMap.clear();
                    }
                    getCallsPerMinuteKey() {
                        const now = new Date();
                        return "".concat(now.getFullYear(), "-").concat(now.getMonth(), "-").concat(now.getDate(), "T").concat(now.getHours(), ":").concat(now.getMinutes());
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Application/Dependencies/Dependencies.ts
                class Dependencies {
                    constructor(options) {
                        this.options = options;
                        this.factory = new Map();
                        this.dependencies = new Map();
                        this.DEFAULT_SYNC_CALLS_THRESHOLD_PER_MINUTE = 200;
                        this.dependencies.set(Types /* TYPES */.v.DeviceInterface, options.deviceInterface);
                        this.dependencies.set(Types /* TYPES */.v.AlertService, options.alertService);
                        this.dependencies.set(Types /* TYPES */.v.Crypto, options.crypto);
                        this.registerServiceMakers();
                        this.registerUseCaseMakers();
                    }
                    deinit() {
                        this.factory.clear();
                        const deps = this.getAll();
                        for (const dep of deps) {
                            if ((0, utils_dist.isDeinitable)(dep)) {
                                dep.deinit();
                            }
                        }
                        this.dependencies.clear();
                    }
                    getAll() {
                        return Array.from(this.dependencies.values()).filter(utils_dist.isNotUndefined);
                    }
                    get(sym) {
                        const dep = this.dependencies.get(sym);
                        if (dep) {
                            return dep;
                        }
                        const maker = this.factory.get(sym);
                        if (!maker) {
                            throw new Error("No dependency maker found for ".concat(sym.toString()));
                        }
                        const instance = maker();
                        if (!instance) {
                            /** Could be optional */
                            return undefined;
                        }
                        this.dependencies.set(sym, instance);
                        return instance;
                    }
                    registerUseCaseMakers() {
                        this.factory.set(Types /* TYPES */.v.DecryptBackupPayloads, () => {
                            return new services_src /* DecryptBackupPayloads */.ZXN(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.DetermineKeyToUse), this.get(Types /* TYPES */.v.Logger));
                        });
                        this.factory.set(Types /* TYPES */.v.DetermineKeyToUse, () => {
                            return new services_src /* DetermineKeyToUse */.WEs(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager));
                        });
                        this.factory.set(Types /* TYPES */.v.GetBackupFileType, () => {
                            return new services_src /* GetBackupFileType */.KCz();
                        });
                        this.factory.set(Types /* TYPES */.v.GetFilePassword, () => {
                            return new services_src /* GetFilePassword */.DZq(this.get(Types /* TYPES */.v.ChallengeService));
                        });
                        this.factory.set(Types /* TYPES */.v.ValidateVaultPassword, () => {
                            return new services_src /* ValidateVaultPassword */.EGP(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthorizeVaultDeletion, () => {
                            return new services_src /* AuthorizeVaultDeletion */.D$B(this.get(Types /* TYPES */.v.VaultLockService), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.ValidateVaultPassword));
                        });
                        this.factory.set(Types /* TYPES */.v.GenerateUuid, () => {
                            return new services_src /* GenerateUuid */.ug$(this.get(Types /* TYPES */.v.Crypto));
                        });
                        this.factory.set(Types /* TYPES */.v.GetVaultItems, () => {
                            return new services_src /* GetVaultItems */.$qZ(this.get(Types /* TYPES */.v.ItemManager));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptErroredPayloads, () => {
                            return new services_src /* DecryptErroredPayloads */.eyx(this.get(Types /* TYPES */.v.ItemsEncryptionService), this.get(Types /* TYPES */.v.DecryptErroredTypeAPayloads));
                        });
                        this.factory.set(Types /* TYPES */.v.GetHost, () => {
                            return new services_src /* GetHost */.cdY(this.get(Types /* TYPES */.v.LegacyApiService));
                        });
                        this.factory.set(Types /* TYPES */.v.IsApplicationUsingThirdPartyHost, () => {
                            return new services_src /* IsApplicationUsingThirdPartyHost */.Y8x(this.get(Types /* TYPES */.v.GetHost));
                        });
                        this.factory.set(Types /* TYPES */.v.SetHost, () => {
                            return new services_src /* SetHost */.q62(this.get(Types /* TYPES */.v.HttpService), this.get(Types /* TYPES */.v.LegacyApiService));
                        });
                        this.factory.set(Types /* TYPES */.v.GetKeyPairs, () => {
                            return new services_src /* GetKeyPairs */.Byj(this.get(Types /* TYPES */.v.RootKeyManager));
                        });
                        this.factory.set(Types /* TYPES */.v.ReencryptTypeAItems, () => {
                            return new services_src /* ReencryptTypeAItems */.HSp(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateDecryptedBackupFile, () => {
                            return new services_src /* CreateDecryptedBackupFile */.ocI(this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.ProtectionService));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateEncryptedBackupFile, () => {
                            return new services_src /* CreateEncryptedBackupFile */.D6l(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.EncryptionService));
                        });
                        this.factory.set(Types /* TYPES */.v.ImportData, () => {
                            return new services_src /* ImportData */.Ens(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.HistoryManager), this.get(Types /* TYPES */.v.DecryptBackupFile), this.get(Types /* TYPES */.v.GetFilePassword));
                        });
                        this.factory.set(Types /* TYPES */.v.IsVaultOwner, () => {
                            return new services_src /* IsVaultOwner */.hjk(this.get(Types /* TYPES */.v.UserService));
                        });
                        this.factory.set(Types /* TYPES */.v.IsVaultAdmin, () => {
                            return new services_src /* IsVaultAdmin */.o1e(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.VaultUserCache));
                        });
                        this.factory.set(Types /* TYPES */.v.IsReadonlyVaultMember, () => {
                            return new services_src /* IsReadonlyVaultMember */.hEi(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.VaultUserCache));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptBackupFile, () => {
                            return new services_src /* DecryptBackupFile */.vV3(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.GetBackupFileType), this.get(Types /* TYPES */.v.DecryptBackupPayloads));
                        });
                        this.factory.set(Types /* TYPES */.v.DiscardItemsLocally, () => {
                            return new services_src /* DiscardItemsLocally */.Ydb(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.DiskStorageService));
                        });
                        this.factory.set(Types /* TYPES */.v.RemoveItemsFromMemory, () => {
                            return new services_src /* RemoveItemsFromMemory */.$sG(this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.PayloadManager));
                        });
                        this.factory.set(Types /* TYPES */.v.FindContact, () => {
                            return new services_src /* FindContact */.VD3(this.get(Types /* TYPES */.v.ItemManager));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteContact, () => {
                            return new services_src /* DeleteContact */.z8s(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.GetOwnedSharedVaults), this.get(Types /* TYPES */.v.ContactBelongsToVault));
                        });
                        this.factory.set(Types /* TYPES */.v.EditContact, () => {
                            return new services_src /* EditContact */.ZQj(this.get(Types /* TYPES */.v.MutatorService));
                        });
                        this.factory.set(Types /* TYPES */.v.GetAllContacts, () => {
                            return new services_src /* GetAllContacts */.s$_(this.get(Types /* TYPES */.v.ItemManager));
                        });
                        this.factory.set(Types /* TYPES */.v.ValidateItemSigner, () => {
                            return new services_src /* ValidateItemSigner */.Lv2(this.get(Types /* TYPES */.v.FindContact));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateOrEditContact, () => {
                            return new services_src /* CreateOrEditContact */.Dk4(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.EditContact));
                        });
                        this.factory.set(Types /* TYPES */.v.GetVault, () => {
                            return new services_src /* GetVault */.dDs(this.get(Types /* TYPES */.v.ItemManager));
                        });
                        this.factory.set(Types /* TYPES */.v.GetVaults, () => {
                            return new services_src /* GetVaults */.r0l(this.get(Types /* TYPES */.v.ItemManager));
                        });
                        this.factory.set(Types /* TYPES */.v.SyncLocalVaultsWithRemoteSharedVaults, () => {
                            return new services_src /* SyncLocalVaultsWithRemoteSharedVaults */._Jh(this.get(Types /* TYPES */.v.SharedVaultServer), this.get(Types /* TYPES */.v.MutatorService));
                        });
                        this.factory.set(Types /* TYPES */.v.ChangeAndSaveItem, () => {
                            return new services_src /* ChangeAndSaveItem */.EdL(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService));
                        });
                        this.factory.set(Types /* TYPES */.v.GetSharedVaults, () => {
                            return new services_src /* GetSharedVaults */.Tog(this.get(Types /* TYPES */.v.GetVaults));
                        });
                        this.factory.set(Types /* TYPES */.v.GetOwnedSharedVaults, () => {
                            return new services_src /* GetOwnedSharedVaults */.tlz(this.get(Types /* TYPES */.v.GetSharedVaults), this.get(Types /* TYPES */.v.IsVaultOwner));
                        });
                        this.factory.set(Types /* TYPES */.v.ContactBelongsToVault, () => {
                            return new services_src /* ContactBelongsToVault */.euo(this.get(Types /* TYPES */.v.GetVaultUsers));
                        });
                        this.factory.set(Types /* TYPES */.v.ChangeVaultStorageMode, () => {
                            return new services_src /* ChangeVaultStorageMode */.KH1(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.GetVault));
                        });
                        this.factory.set(Types /* TYPES */.v.ChangeVaultKeyOptions, () => {
                            return new services_src /* ChangeVaultKeyOptions */.tuB(this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.RotateVaultKey), this.get(Types /* TYPES */.v.ChangeVaultStorageMode));
                        });
                        this.factory.set(Types /* TYPES */.v.MoveItemsToVault, () => {
                            return new services_src /* MoveItemsToVault */.cZu(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.FileService));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateVault, () => {
                            return new services_src /* CreateVault */.TQm(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.SyncService));
                        });
                        this.factory.set(Types /* TYPES */.v.RemoveItemFromVault, () => {
                            return new services_src /* RemoveItemFromVault */.fF_(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.FileService));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteVault, () => {
                            return new services_src /* DeleteVault */.Rws(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.GetVaultItems));
                        });
                        this.factory.set(Types /* TYPES */.v.RotateVaultKey, () => {
                            return new services_src /* RotateVaultKey */.PqX(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.NotifyVaultUsersOfKeyRotation), this.get(Types /* TYPES */.v.IsVaultOwner));
                        });
                        this.factory.set(Types /* TYPES */.v.ReuploadInvite, () => {
                            return new services_src /* ReuploadInvite */.afr(this.get(Types /* TYPES */.v.DecryptOwnMessage), this.get(Types /* TYPES */.v.SendVaultInvite), this.get(Types /* TYPES */.v.EncryptMessage));
                        });
                        this.factory.set(Types /* TYPES */.v.ReuploadAllInvites, () => {
                            return new services_src /* ReuploadAllInvites */.F0Y(this.get(Types /* TYPES */.v.ReuploadInvite), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.SharedVaultInvitesServer));
                        });
                        this.factory.set(Types /* TYPES */.v.ResendAllMessages, () => {
                            return new services_src /* ResendAllMessages */.HLD(this.get(Types /* TYPES */.v.ResendMessage), this.get(Types /* TYPES */.v.DecryptOwnMessage), this.get(Types /* TYPES */.v.AsymmetricMessageServer), this.get(Types /* TYPES */.v.FindContact));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateSharedVault, () => {
                            return new services_src /* CreateSharedVault */.zEM(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SharedVaultServer), this.get(Types /* TYPES */.v.CreateVault), this.get(Types /* TYPES */.v.MoveItemsToVault), this.get(Types /* TYPES */.v.GetVaultItems));
                        });
                        this.factory.set(Types /* TYPES */.v.HandleKeyPairChange, () => {
                            return new services_src /* HandleKeyPairChange */.qjc(this.get(Types /* TYPES */.v.SelfContactManager), this.get(Types /* TYPES */.v.SharedVaultInvitesServer), this.get(Types /* TYPES */.v.AsymmetricMessageServer), this.get(Types /* TYPES */.v.ReuploadAllInvites), this.get(Types /* TYPES */.v.ResendAllMessages), this.get(Types /* TYPES */.v.GetAllContacts), this.get(Types /* TYPES */.v.SendOwnContactChangeMessage), this.get(Types /* TYPES */.v.CreateOrEditContact), this.get(Types /* TYPES */.v.Logger));
                        });
                        this.factory.set(Types /* TYPES */.v.NotifyVaultUsersOfKeyRotation, () => {
                            return new services_src /* NotifyVaultUsersOfKeyRotation */.cVV(this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.SendVaultKeyChangedMessage), this.get(Types /* TYPES */.v.InviteToVault), this.get(Types /* TYPES */.v.SharedVaultInvitesServer), this.get(Types /* TYPES */.v.GetVaultContacts), this.get(Types /* TYPES */.v.DecryptOwnMessage), this.get(Types /* TYPES */.v.GetKeyPairs));
                        });
                        this.factory.set(Types /* TYPES */.v.SendVaultKeyChangedMessage, () => {
                            return new services_src /* SendVaultKeyChangedMessage */.Foy(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.EncryptMessage), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.SendMessage), this.get(Types /* TYPES */.v.GetVaultUsers), this.get(Types /* TYPES */.v.GetKeyPairs));
                        });
                        this.factory.set(Types /* TYPES */.v.SendVaultDataChangedMessage, () => {
                            return new services_src /* SendVaultDataChangedMessage */.$SL(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.EncryptMessage), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.GetVaultUsers), this.get(Types /* TYPES */.v.SendMessage), this.get(Types /* TYPES */.v.IsVaultOwner), this.get(Types /* TYPES */.v.GetKeyPairs));
                        });
                        this.factory.set(Types /* TYPES */.v.ReplaceContactData, () => {
                            return new services_src /* ReplaceContactData */.xRL(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.FindContact));
                        });
                        this.factory.set(Types /* TYPES */.v.GetTrustedPayload, () => {
                            return new services_src /* GetTrustedPayload */.pqE(this.get(Types /* TYPES */.v.DecryptMessage));
                        });
                        this.factory.set(Types /* TYPES */.v.GetUntrustedPayload, () => {
                            return new services_src /* GetUntrustedPayload */.P9M(this.get(Types /* TYPES */.v.DecryptMessage));
                        });
                        this.factory.set(Types /* TYPES */.v.GetVaultContacts, () => {
                            return new services_src /* GetVaultContacts */.bDv(this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.GetVaultUsers));
                        });
                        this.factory.set(Types /* TYPES */.v.AcceptVaultInvite, () => {
                            return new services_src /* AcceptVaultInvite */.nmV(this.get(Types /* TYPES */.v.SharedVaultInvitesServer), this.get(Types /* TYPES */.v.ProcessAcceptedVaultInvite));
                        });
                        this.factory.set(Types /* TYPES */.v.InviteToVault, () => {
                            return new services_src /* InviteToVault */.RAe(this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.EncryptMessage), this.get(Types /* TYPES */.v.SendVaultInvite), this.get(Types /* TYPES */.v.ShareContactWithVault), this.get(Types /* TYPES */.v.GetKeyPairs));
                        });
                        this.factory.set(Types /* TYPES */.v.SendVaultInvite, () => {
                            return new services_src /* SendVaultInvite */.Iup(this.get(Types /* TYPES */.v.SharedVaultInvitesServer));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteThirdPartyVault, () => {
                            return new services_src /* DeleteThirdPartyVault */.jGD(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.DiscardItemsLocally));
                        });
                        this.factory.set(Types /* TYPES */.v.LeaveVault, () => {
                            return new services_src /* LeaveVault */.Z7G(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.SharedVaultUsersServer), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.DeleteThirdPartyVault));
                        });
                        this.factory.set(Types /* TYPES */.v.ShareContactWithVault, () => {
                            return new services_src /* ShareContactWithVault */.uLb(this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.EncryptMessage), this.get(Types /* TYPES */.v.SendMessage), this.get(Types /* TYPES */.v.GetVaultUsers), this.get(Types /* TYPES */.v.GetKeyPairs));
                        });
                        this.factory.set(Types /* TYPES */.v.ConvertToSharedVault, () => {
                            return new services_src /* ConvertToSharedVault */.b$E(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SharedVaultServer), this.get(Types /* TYPES */.v.MoveItemsToVault), this.get(Types /* TYPES */.v.GetVaultItems));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteSharedVault, () => {
                            return new services_src /* DeleteSharedVault */.KLn(this.get(Types /* TYPES */.v.SharedVaultServer), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.DeleteVault));
                        });
                        this.factory.set(Types /* TYPES */.v.RemoveVaultMember, () => {
                            return new services_src /* RemoveVaultMember */.YxU(this.get(Types /* TYPES */.v.SharedVaultUsersServer));
                        });
                        this.factory.set(Types /* TYPES */.v.DesignateSurvivor, () => {
                            return new services_src /* DesignateSurvivor */.X2V(this.get(Types /* TYPES */.v.SharedVaultUsersServer));
                        });
                        this.factory.set(Types /* TYPES */.v.GetVaultUsers, () => {
                            return new services_src /* GetVaultUsers */.PDt(this.get(Types /* TYPES */.v.SharedVaultUsersServer), this.get(Types /* TYPES */.v.VaultUserCache));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptOwnMessage, () => {
                            return new services_src /* DecryptOwnMessage */.EQN(this.get(Types /* TYPES */.v.EncryptionOperators));
                        });
                        this.factory.set(Types /* TYPES */.v.EncryptMessage, () => {
                            return new services_src /* EncryptMessage */.S1n(this.get(Types /* TYPES */.v.EncryptionOperators));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptMessage, () => {
                            return new services_src /* DecryptMessage */.$M4(this.get(Types /* TYPES */.v.EncryptionOperators));
                        });
                        this.factory.set(Types /* TYPES */.v.ResendMessage, () => {
                            return new services_src /* ResendMessage */.IF$(this.get(Types /* TYPES */.v.SendMessage), this.get(Types /* TYPES */.v.EncryptMessage));
                        });
                        this.factory.set(Types /* TYPES */.v.SendMessage, () => {
                            return new services_src /* SendMessage */.uzh(this.get(Types /* TYPES */.v.AsymmetricMessageServer));
                        });
                        this.factory.set(Types /* TYPES */.v.ProcessAcceptedVaultInvite, () => {
                            return new services_src /* ProcessAcceptedVaultInvite */.Klw(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.CreateOrEditContact));
                        });
                        this.factory.set(Types /* TYPES */.v.HandleRootKeyChangedMessage, () => {
                            return new services_src /* HandleRootKeyChangedMessage */.cjV(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.DecryptErroredPayloads));
                        });
                        this.factory.set(Types /* TYPES */.v.SendOwnContactChangeMessage, () => {
                            return new services_src /* SendOwnContactChangeMessage */.u3X(this.get(Types /* TYPES */.v.EncryptMessage), this.get(Types /* TYPES */.v.SendMessage));
                        });
                        this.factory.set(Types /* TYPES */.v.GetOutboundMessages, () => {
                            return new services_src /* GetOutboundMessages */.WUT(this.get(Types /* TYPES */.v.AsymmetricMessageServer));
                        });
                        this.factory.set(Types /* TYPES */.v.GetInboundMessages, () => {
                            return new services_src /* GetInboundMessages */.Vxn(this.get(Types /* TYPES */.v.AsymmetricMessageServer));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateNewDefaultItemsKey, () => {
                            return new services_src /* CreateNewDefaultItemsKey */.Nwx(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.EncryptionOperators), this.get(Types /* TYPES */.v.RootKeyManager));
                        });
                        this.factory.set(Types /* TYPES */.v.CreateNewItemsKeyWithRollback, () => {
                            return new services_src /* CreateNewItemsKeyWithRollback */.Yw(this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.CreateNewDefaultItemsKey), this.get(Types /* TYPES */.v.DiscardItemsLocally), this.get(Types /* TYPES */.v.FindDefaultItemsKey));
                        });
                        this.factory.set(Types /* TYPES */.v.FindDefaultItemsKey, () => {
                            return new services_src /* FindDefaultItemsKey */.iPu();
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptErroredTypeAPayloads, () => {
                            return new services_src /* DecryptErroredTypeAPayloads */.suI(this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.DecryptTypeAPayloadWithKeyLookup));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptTypeAPayload, () => {
                            return new services_src /* DecryptTypeAPayload */.gzl(this.get(Types /* TYPES */.v.EncryptionOperators));
                        });
                        this.factory.set(Types /* TYPES */.v.DecryptTypeAPayloadWithKeyLookup, () => {
                            return new services_src /* DecryptTypeAPayloadWithKeyLookup */.qXV(this.get(Types /* TYPES */.v.EncryptionOperators), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.RootKeyManager), this.get(Types /* TYPES */.v.Logger));
                        });
                        this.factory.set(Types /* TYPES */.v.EncryptTypeAPayload, () => {
                            return new services_src /* EncryptTypeAPayload */.i6C(this.get(Types /* TYPES */.v.EncryptionOperators));
                        });
                        this.factory.set(Types /* TYPES */.v.EncryptTypeAPayloadWithKeyLookup, () => {
                            return new services_src /* EncryptTypeAPayloadWithKeyLookup */.k6d(this.get(Types /* TYPES */.v.EncryptionOperators), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.RootKeyManager));
                        });
                    }
                    registerServiceMakers() {
                        this.factory.set(Types /* TYPES */.v.Logger, () => {
                            return new utils_dist.Logger(this.options.identifier);
                        });
                        this.factory.set(Types /* TYPES */.v.UserServer, () => {
                            return new api_dist.UserServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.RootKeyManager, () => {
                            return new services_src /* RootKeyManager */.wtP(this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.EncryptionOperators), this.options.identifier, this.get(Types /* TYPES */.v.ReencryptTypeAItems), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ItemsEncryptionService, () => {
                            return new services_src /* ItemsEncryptionService */.oQ4(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.EncryptionOperators), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.FindDefaultItemsKey), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.EncryptionOperators, () => {
                            return new encryption_src /* EncryptionOperators */.$l(this.get(Types /* TYPES */.v.Crypto));
                        });
                        this.factory.set(Types /* TYPES */.v.SharedVaultInvitesServer, () => {
                            return new api_dist.SharedVaultInvitesServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.SharedVaultServer, () => {
                            return new api_dist.SharedVaultServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.AsymmetricMessageServer, () => {
                            return new api_dist.AsymmetricMessageServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.SharedVaultUsersServer, () => {
                            return new api_dist.SharedVaultUsersServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.VaultUserService, () => {
                            return new services_src /* VaultUserService */.igb(this.get(Types /* TYPES */.v.VaultService), this.get(Types /* TYPES */.v.VaultLockService), this.get(Types /* TYPES */.v.GetVaultUsers), this.get(Types /* TYPES */.v.RemoveVaultMember), this.get(Types /* TYPES */.v.IsVaultOwner), this.get(Types /* TYPES */.v.IsVaultAdmin), this.get(Types /* TYPES */.v.IsReadonlyVaultMember), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.LeaveVault), this.get(Types /* TYPES */.v.DesignateSurvivor), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.VaultUserCache, () => {
                            return new services_src /* VaultUserCache */.k7Z();
                        });
                        this.factory.set(Types /* TYPES */.v.VaultInviteService, () => {
                            return new services_src /* VaultInviteService */.hZp(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.VaultUserService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.SharedVaultInvitesServer), this.get(Types /* TYPES */.v.StatusService), this.get(Types /* TYPES */.v.GetAllContacts), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.GetVaultContacts), this.get(Types /* TYPES */.v.InviteToVault), this.get(Types /* TYPES */.v.GetTrustedPayload), this.get(Types /* TYPES */.v.GetUntrustedPayload), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.AcceptVaultInvite), this.get(Types /* TYPES */.v.GetKeyPairs), this.get(Types /* TYPES */.v.DecryptErroredPayloads), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.AsymmetricMessageService, () => {
                            return new services_src /* AsymmetricMessageService */.WXh(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.AsymmetricMessageServer), this.get(Types /* TYPES */.v.CreateOrEditContact), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.ReplaceContactData), this.get(Types /* TYPES */.v.GetTrustedPayload), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.HandleRootKeyChangedMessage), this.get(Types /* TYPES */.v.GetOutboundMessages), this.get(Types /* TYPES */.v.GetInboundMessages), this.get(Types /* TYPES */.v.GetUntrustedPayload), this.get(Types /* TYPES */.v.GetKeyPairs), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SharedVaultService, () => {
                            return new services_src /* SharedVaultService */.cnh(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.VaultUserService), this.get(Types /* TYPES */.v.SyncLocalVaultsWithRemoteSharedVaults), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.GetOwnedSharedVaults), this.get(Types /* TYPES */.v.CreateSharedVault), this.get(Types /* TYPES */.v.HandleKeyPairChange), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.DeleteThirdPartyVault), this.get(Types /* TYPES */.v.ShareContactWithVault), this.get(Types /* TYPES */.v.ConvertToSharedVault), this.get(Types /* TYPES */.v.DeleteSharedVault), this.get(Types /* TYPES */.v.DiscardItemsLocally), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.VaultLockService, () => {
                            return new services_src /* VaultLockService */.PHC(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.KeySystemKeyManager), this.get(Types /* TYPES */.v.GetVaults), this.get(Types /* TYPES */.v.DecryptErroredPayloads), this.get(Types /* TYPES */.v.RemoveItemsFromMemory), this.get(Types /* TYPES */.v.GetVaultItems), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.VaultService, () => {
                            return new services_src /* VaultService */.RDE(this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.VaultLockService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.GetVault), this.get(Types /* TYPES */.v.GetVaults), this.get(Types /* TYPES */.v.ChangeVaultKeyOptions), this.get(Types /* TYPES */.v.MoveItemsToVault), this.get(Types /* TYPES */.v.CreateVault), this.get(Types /* TYPES */.v.RemoveItemFromVault), this.get(Types /* TYPES */.v.DeleteVault), this.get(Types /* TYPES */.v.RotateVaultKey), this.get(Types /* TYPES */.v.SendVaultDataChangedMessage), this.get(Types /* TYPES */.v.IsVaultOwner), this.get(Types /* TYPES */.v.ValidateVaultPassword), this.get(Types /* TYPES */.v.AuthorizeVaultDeletion), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SelfContactManager, () => {
                            return new services_src /* SelfContactManager */.Ld1(this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.SingletonManager));
                        });
                        this.factory.set(Types /* TYPES */.v.ContactService, () => {
                            return new services_src /* ContactService */.yqc(this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.SelfContactManager), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.DeleteContact), this.get(Types /* TYPES */.v.FindContact), this.get(Types /* TYPES */.v.GetAllContacts), this.get(Types /* TYPES */.v.CreateOrEditContact), this.get(Types /* TYPES */.v.EditContact), this.get(Types /* TYPES */.v.ValidateItemSigner), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SignInWithRecoveryCodes, () => {
                            return new SignInWithRecoveryCodes /* SignInWithRecoveryCodes */.Y(this.get(Types /* TYPES */.v.AuthManager), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.InMemoryStore), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.GetRecoveryCodes, () => {
                            return new GetRecoveryCodes /* GetRecoveryCodes */.u(this.get(Types /* TYPES */.v.AuthManager), this.get(Types /* TYPES */.v.SettingsService));
                        });
                        this.factory.set(Types /* TYPES */.v.AddAuthenticator, () => {
                            return new AddAuthenticator /* AddAuthenticator */.f(this.get(Types /* TYPES */.v.AuthenticatorManager), this.options.u2fAuthenticatorRegistrationPromptFunction);
                        });
                        this.factory.set(Types /* TYPES */.v.ListAuthenticators, () => {
                            return new ListAuthenticators /* ListAuthenticators */.F(this.get(Types /* TYPES */.v.AuthenticatorManager));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteAuthenticator, () => {
                            return new DeleteAuthenticator /* DeleteAuthenticator */.c(this.get(Types /* TYPES */.v.AuthenticatorManager));
                        });
                        this.factory.set(Types /* TYPES */.v.GetAuthenticatorAuthenticationOptions, () => {
                            return new GetAuthenticatorAuthenticationOptions /* GetAuthenticatorAuthenticationOptions */.V(this.get(Types /* TYPES */.v.AuthenticatorManager));
                        });
                        this.factory.set(Types /* TYPES */.v.GetAuthenticatorAuthenticationResponse, () => {
                            return new GetAuthenticatorAuthenticationResponse /* GetAuthenticatorAuthenticationResponse */.F(this.get(Types /* TYPES */.v.GetAuthenticatorAuthenticationOptions), this.options.u2fAuthenticatorVerificationPromptFunction);
                        });
                        this.factory.set(Types /* TYPES */.v.ListRevisions, () => {
                            return new ListRevisions /* ListRevisions */.G(this.get(Types /* TYPES */.v.RevisionManager));
                        });
                        this.factory.set(Types /* TYPES */.v.GetRevision, () => {
                            return new GetRevision /* GetRevision */.X(this.get(Types /* TYPES */.v.RevisionManager), this.get(Types /* TYPES */.v.EncryptionService));
                        });
                        this.factory.set(Types /* TYPES */.v.DeleteRevision, () => {
                            return new DeleteRevision /* DeleteRevision */.g(this.get(Types /* TYPES */.v.RevisionManager));
                        });
                        this.factory.set(Types /* TYPES */.v.RevisionServer, () => {
                            return new api_dist.RevisionServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.RevisionApiService, () => {
                            return new api_dist.RevisionApiService(this.get(Types /* TYPES */.v.RevisionServer));
                        });
                        this.factory.set(Types /* TYPES */.v.RevisionManager, () => {
                            return new services_src /* RevisionManager */.t9U(this.get(Types /* TYPES */.v.RevisionApiService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthServer, () => {
                            return new api_dist.AuthServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthApiService, () => {
                            return new api_dist.AuthApiService(this.get(Types /* TYPES */.v.AuthServer), this.options.apiVersion);
                        });
                        this.factory.set(Types /* TYPES */.v.AuthManager, () => {
                            return new services_src /* AuthManager */.El(this.get(Types /* TYPES */.v.AuthApiService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthenticatorServer, () => {
                            return new api_dist.AuthenticatorServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthenticatorApiService, () => {
                            return new api_dist.AuthenticatorApiService(this.get(Types /* TYPES */.v.AuthenticatorServer));
                        });
                        this.factory.set(Types /* TYPES */.v.AuthenticatorManager, () => {
                            return new services_src /* AuthenticatorManager */.F8w(this.get(Types /* TYPES */.v.AuthenticatorApiService), this.get(Types /* TYPES */.v.PreferencesService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ActionsService, () => {
                            return new ActionsService /* ActionsService */.b(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.DeprecatedHttpService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ListedService, () => {
                            return new ListedService /* ListedService */.o(this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SettingsService), this.get(Types /* TYPES */.v.DeprecatedHttpService), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.IntegrityService, () => {
                            return new services_src /* IntegrityService */.yim(this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.FileService, () => {
                            return new services_src /* FileService */.IpN(this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.HttpService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.InternalEventBus), this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.FilesBackupService));
                        });
                        this.factory.set(Types /* TYPES */.v.MigrationService, () => {
                            return new MigrationService /* MigrationService */.H({
                                encryptionService: this.get(Types /* TYPES */.v.EncryptionService),
                                deviceInterface: this.get(Types /* TYPES */.v.DeviceInterface),
                                storageService: this.get(Types /* TYPES */.v.DiskStorageService),
                                sessionManager: this.get(Types /* TYPES */.v.SessionManager),
                                challengeService: this.get(Types /* TYPES */.v.ChallengeService),
                                itemManager: this.get(Types /* TYPES */.v.ItemManager),
                                mutator: this.get(Types /* TYPES */.v.MutatorService),
                                singletonManager: this.get(Types /* TYPES */.v.SingletonManager),
                                featuresService: this.get(Types /* TYPES */.v.FeaturesService),
                                environment: this.options.environment,
                                platform: this.options.platform,
                                identifier: this.options.identifier,
                                internalEventBus: this.get(Types /* TYPES */.v.InternalEventBus),
                                legacySessionStorageMapper: this.get(Types /* TYPES */.v.LegacySessionStorageMapper),
                                backups: this.get(Types /* TYPES */.v.FilesBackupService),
                                preferences: this.get(Types /* TYPES */.v.PreferencesService)
                            });
                        });
                        this.factory.set(Types /* TYPES */.v.HomeServerService, () => {
                            if (!(0, services_src /* isDesktopDevice */.dse)(this.get(Types /* TYPES */.v.DeviceInterface))) {
                                return undefined;
                            }
                            return new services_src /* HomeServerService */.tGH(this.get(Types /* TYPES */.v.DeviceInterface), this.options.platform, this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.FilesBackupService, () => {
                            if (!(0, services_src /* isDesktopDevice */.dse)(this.get(Types /* TYPES */.v.DeviceInterface))) {
                                return undefined;
                            }
                            return new services_src /* FilesBackupService */.exs(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.StatusService), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.HistoryManager), this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.StatusService, () => {
                            return new services_src /* StatusService */.Bjn(this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.MfaService, () => {
                            return new MfaService /* MfaService */.p(this.get(Types /* TYPES */.v.SettingsService), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.FeaturesService), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ComponentManager, () => {
                            return new ComponentManager /* ComponentManager */.y(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.FeaturesService), this.get(Types /* TYPES */.v.PreferencesService), this.get(Types /* TYPES */.v.AlertService), this.options.environment, this.options.platform, this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.FeaturesService, () => {
                            return new FeaturesService /* FeaturesService */.k(this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SubscriptionManager), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.WebSocketsService), this.get(Types /* TYPES */.v.SettingsService), this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.IsApplicationUsingThirdPartyHost), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SettingsService, () => {
                            return new SNSettingsService /* SettingsService */.g(this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.PreferencesService, () => {
                            return new PreferencesService /* PreferencesService */.y(this.get(Types /* TYPES */.v.SingletonManager), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SingletonManager, () => {
                            return new SingletonManager /* SingletonManager */.W(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.KeyRecoveryService, () => {
                            return new KeyRecoveryService /* KeyRecoveryService */.D(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.UserService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.UserService, () => {
                            return new services_src /* UserService */.KDu(this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.SyncService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.ProtectionService), this.get(Types /* TYPES */.v.UserApiService), this.get(Types /* TYPES */.v.ReencryptTypeAItems), this.get(Types /* TYPES */.v.DecryptErroredPayloads), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ProtectionService, () => {
                            return new ProtectionService /* ProtectionService */.n(this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.WebSocketsService, () => {
                            return new services_src /* WebSocketsService */.BV4(this.get(Types /* TYPES */.v.DiskStorageService), this.options.webSocketUrl, this.get(Types /* TYPES */.v.WebSocketApiService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SyncFrequencyGuard, () => {
                            var _a;
                            return new SyncFrequencyGuard((_a = this.options.syncCallsThresholdPerMinute) !== null && _a !== void 0 ? _a : this.DEFAULT_SYNC_CALLS_THRESHOLD_PER_MINUTE);
                        });
                        this.factory.set(Types /* TYPES */.v.SyncBackoffService, () => {
                            return new services_src /* SyncBackoffService */.XEg();
                        });
                        this.factory.set(Types /* TYPES */.v.SyncService, () => {
                            return new SyncService /* SyncService */._(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.HistoryManager), this.get(Types /* TYPES */.v.DeviceInterface), this.options.identifier, {
                                loadBatchSize: this.options.loadBatchSize,
                                sleepBetweenBatches: this.options.sleepBetweenBatches
                            }, this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.WebSocketsService), this.get(Types /* TYPES */.v.SyncFrequencyGuard), this.get(Types /* TYPES */.v.SyncBackoffService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.HistoryManager, () => {
                            return new HistoryManager /* HistoryManager */.E(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.DeviceInterface), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SubscriptionManager, () => {
                            return new services_src /* SubscriptionManager */.LF2(this.get(Types /* TYPES */.v.SubscriptionApiService), this.get(Types /* TYPES */.v.SessionManager), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.IsApplicationUsingThirdPartyHost), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SessionManager, () => {
                            return new SessionManager /* SessionManager */.Sj(this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.LegacyApiService), this.get(Types /* TYPES */.v.UserApiService), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.ChallengeService), this.get(Types /* TYPES */.v.WebSocketsService), this.get(Types /* TYPES */.v.HttpService), this.get(Types /* TYPES */.v.SessionStorageMapper), this.get(Types /* TYPES */.v.LegacySessionStorageMapper), this.options.identifier, this.get(Types /* TYPES */.v.GetKeyPairs), this.get(Types /* TYPES */.v.IsApplicationUsingThirdPartyHost), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.WebSocketApiService, () => {
                            return new api_dist.WebSocketApiService(this.get(Types /* TYPES */.v.WebSocketServer));
                        });
                        this.factory.set(Types /* TYPES */.v.WebSocketServer, () => {
                            return new api_dist.WebSocketServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.SubscriptionApiService, () => {
                            return new api_dist.SubscriptionApiService(this.get(Types /* TYPES */.v.SubscriptionServer), this.options.apiVersion);
                        });
                        this.factory.set(Types /* TYPES */.v.UserApiService, () => {
                            return new api_dist.UserApiService(this.get(Types /* TYPES */.v.UserServer), this.get(Types /* TYPES */.v.UserRequestServer), this.options.apiVersion);
                        });
                        this.factory.set(Types /* TYPES */.v.SubscriptionServer, () => {
                            return new api_dist.SubscriptionServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.UserRequestServer, () => {
                            return new api_dist.UserRequestServer(this.get(Types /* TYPES */.v.HttpService));
                        });
                        this.factory.set(Types /* TYPES */.v.InternalEventBus, () => {
                            return new services_src /* InternalEventBus */.Ehg();
                        });
                        this.factory.set(Types /* TYPES */.v.PayloadManager, () => {
                            return new PayloadManager /* PayloadManager */.O(this.get(Types /* TYPES */.v.Logger), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ItemManager, () => {
                            return new ItemManager /* ItemManager */.A(this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.MutatorService, () => {
                            return new MutatorService /* MutatorService */.V(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.AlertService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.DiskStorageService, () => {
                            return new DiskStorageService /* DiskStorageService */.e(this.get(Types /* TYPES */.v.DeviceInterface), this.options.identifier, this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.NotificationService, () => {
                            return new services_src /* NotificationService */.gqp(this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.InMemoryStore, () => {
                            return new services_src /* InMemoryStore */.CEH();
                        });
                        this.factory.set(Types /* TYPES */.v.KeySystemKeyManager, () => {
                            return new services_src /* KeySystemKeyManager */.Pn4(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.RemoveItemsFromMemory), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.ChallengeService, () => {
                            return new ChallengeService /* ChallengeService */.P(this.get(Types /* TYPES */.v.DiskStorageService), this.get(Types /* TYPES */.v.EncryptionService), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.EncryptionService, () => {
                            return new services_src /* EncryptionService */.C6q(this.get(Types /* TYPES */.v.ItemManager), this.get(Types /* TYPES */.v.MutatorService), this.get(Types /* TYPES */.v.PayloadManager), this.get(Types /* TYPES */.v.EncryptionOperators), this.get(Types /* TYPES */.v.ItemsEncryptionService), this.get(Types /* TYPES */.v.RootKeyManager), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.CreateNewItemsKeyWithRollback), this.get(Types /* TYPES */.v.FindDefaultItemsKey), this.get(Types /* TYPES */.v.EncryptTypeAPayloadWithKeyLookup), this.get(Types /* TYPES */.v.EncryptTypeAPayload), this.get(Types /* TYPES */.v.DecryptTypeAPayload), this.get(Types /* TYPES */.v.DecryptTypeAPayloadWithKeyLookup), this.get(Types /* TYPES */.v.CreateNewDefaultItemsKey), this.get(Types /* TYPES */.v.GetKeyPairs), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.DeprecatedHttpService, () => {
                            return new DeprecatedHttpService /* DeprecatedHttpService */.q(this.options.environment, this.options.appVersion, this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.HttpService, () => {
                            return new api_dist.HttpService(this.options.environment, this.options.appVersion, Version /* SnjsVersion */["in"], this.options.apiVersion, this.get(Types /* TYPES */.v.Logger));
                        });
                        this.factory.set(Types /* TYPES */.v.LegacyApiService, () => {
                            return new ApiService /* LegacyApiService */.A(this.get(Types /* TYPES */.v.HttpService), this.get(Types /* TYPES */.v.DiskStorageService), this.options.defaultHost, this.get(Types /* TYPES */.v.InMemoryStore), this.get(Types /* TYPES */.v.Crypto), this.get(Types /* TYPES */.v.SessionStorageMapper), this.get(Types /* TYPES */.v.LegacySessionStorageMapper), this.get(Types /* TYPES */.v.InternalEventBus));
                        });
                        this.factory.set(Types /* TYPES */.v.SessionStorageMapper, () => {
                            return new SessionStorageMapper();
                        });
                        this.factory.set(Types /* TYPES */.v.LegacySessionStorageMapper, () => {
                            return new LegacySessionStorageMapper();
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Application/Dependencies/DependencyEvents.ts
                function RegisterApplicationServicesEvents(container, events) {
                    events.addEventHandler(container.get(Types /* TYPES */.v.AsymmetricMessageService), services_src /* SyncEvent */.wMo.ReceivedAsymmetricMessages);
                    events.addEventHandler(container.get(Types /* TYPES */.v.AsymmetricMessageService), services_src /* WebSocketsServiceEvent */.fAX.MessageSentToUser);
                    events.addEventHandler(container.get(Types /* TYPES */.v.DiskStorageService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.FeaturesService), services_src /* ApiServiceEvent */.Sf$.MetaReceived);
                    events.addEventHandler(container.get(Types /* TYPES */.v.FeaturesService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.IntegrityService), services_src /* SyncEvent */.wMo.SyncRequestsIntegrityCheck);
                    events.addEventHandler(container.get(Types /* TYPES */.v.KeyRecoveryService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.KeySystemKeyManager), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.MigrationService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.NotificationService), services_src /* SyncEvent */.wMo.ReceivedNotifications);
                    events.addEventHandler(container.get(Types /* TYPES */.v.NotificationService), services_src /* WebSocketsServiceEvent */.fAX.NotificationAddedForUser);
                    events.addEventHandler(container.get(Types /* TYPES */.v.PreferencesService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.ProtectionService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.ProtectionService), services_src /* ApplicationEvent */.n9K.Started);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SelfContactManager), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SessionManager), services_src /* ApiServiceEvent */.Sf$.SessionRefreshed);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SessionManager), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SharedVaultService), services_src /* NotificationServiceEvent */.JQe.NotificationReceived);
                    events.addEventHandler(container.get(Types /* TYPES */.v.VaultInviteService), services_src /* NotificationServiceEvent */.JQe.NotificationReceived);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SharedVaultService), services_src /* SessionEvent */.Pxr.UserKeyPairChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SharedVaultService), services_src /* SyncEvent */.wMo.ReceivedRemoteSharedVaults);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SubscriptionManager), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SubscriptionManager), services_src /* ApplicationEvent */.n9K.Launched);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SubscriptionManager), services_src /* ApplicationEvent */.n9K.SignedIn);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SubscriptionManager), services_src /* ApplicationEvent */.n9K.UserRolesChanged);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SubscriptionManager), services_src /* SessionEvent */.Pxr.Restored);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SyncService), services_src /* IntegrityEvent */.ezr.IntegrityCheckCompleted);
                    events.addEventHandler(container.get(Types /* TYPES */.v.SyncService), services_src /* WebSocketsServiceEvent */.fAX.ItemsChangedOnServer);
                    events.addEventHandler(container.get(Types /* TYPES */.v.UserService), services_src /* AccountEvent */.oF7.SignedInOrRegistered);
                    events.addEventHandler(container.get(Types /* TYPES */.v.VaultInviteService), services_src /* ApplicationEvent */.n9K.Launched);
                    events.addEventHandler(container.get(Types /* TYPES */.v.VaultInviteService), services_src /* SyncEvent */.wMo.ReceivedSharedVaultInvites);
                    events.addEventHandler(container.get(Types /* TYPES */.v.VaultInviteService), services_src /* WebSocketsServiceEvent */.fAX.UserInvitedToSharedVault);
                    if (container.get(Types /* TYPES */.v.FilesBackupService)) {
                        events.addEventHandler(container.get(Types /* TYPES */.v.FilesBackupService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    }
                    if (container.get(Types /* TYPES */.v.HomeServerService)) {
                        events.addEventHandler(container.get(Types /* TYPES */.v.HomeServerService), services_src /* ApplicationEvent */.n9K.ApplicationStageChanged);
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Application/Application.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SNApplication {
                    constructor(options) {
                        /**
                         * A runtime based identifier for each dynamic instantiation of the application instance.
                         * This differs from the persistent application.identifier which persists in storage
                         * across instantiations.
                         */
                        this.ephemeralIdentifier = (0, utils_dist.nonSecureRandomIdentifier)();
                        this.eventHandlers = [];
                        this.serviceObservers = [];
                        this.managedSubscribers = [];
                        /** True if the result of deviceInterface.openDatabase yields a new database being created */
                        this.createdNewDatabase = false;
                        /** True if the application has started (but not necessarily launched) */
                        this.started = false;
                        /** True if the application has launched */
                        this.launched = false;
                        /** Whether the application has been destroyed via .deinit() */
                        this.dealloced = false;
                        this.revokingSession = false;
                        this.handledFullSyncStage = false;
                        const allOptions = Object.assign(Object.assign({}, services_src /* ApplicationOptionsDefaults */.U3K), options);
                        if (!Log /* SNLog */.W.onLog) {
                            throw Error('SNLog.onLog must be set.');
                        }
                        if (!Log /* SNLog */.W.onError) {
                            throw Error('SNLog.onError must be set.');
                        }
                        const requiredOptions = ['deviceInterface', 'environment', 'platform', 'crypto', 'alertService', 'identifier', 'defaultHost', 'appVersion', 'apiVersion'];
                        for (const optionName of requiredOptions) {
                            if (!allOptions[optionName]) {
                                throw Error("".concat(optionName, " must be supplied when creating an application."));
                            }
                        }
                        this.environment = options.environment;
                        this.platform = options.platform;
                        this.identifier = options.identifier;
                        this.options = Object.freeze(allOptions);
                        this.dependencies = new Dependencies(this.options);
                        const logger = this.dependencies.get(Types /* TYPES */.v.Logger);
                        logger.setLevel('error');
                        this.registerServiceObservers();
                        RegisterApplicationServicesEvents(this.dependencies, this.events);
                    }
                    registerServiceObservers() {
                        const encryptionService = this.dependencies.get(Types /* TYPES */.v.EncryptionService);
                        this.serviceObservers.push(encryptionService.addEventObserver(event => __awaiter(this, void 0, void 0, function* () {
                            if (event === services_src /* EncryptionServiceEvent */.fa_.RootKeyStatusChanged) {
                                yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.KeyStatusChanged);
                            }
                        })));
                        this.dependencies.get(Types /* TYPES */.v.DiskStorageService).provideEncryptionProvider(encryptionService);
                        const apiService = this.dependencies.get(Types /* TYPES */.v.LegacyApiService);
                        this.dependencies.get(Types /* TYPES */.v.HttpService).setCallbacks(apiService.processMetaObject.bind(apiService), apiService.setSession.bind(apiService));
                        this.serviceObservers.push(this.dependencies.get(Types /* TYPES */.v.SessionManager).addEventObserver(event => __awaiter(this, void 0, void 0, function* () {
                            switch (event) {
                                case services_src /* SessionEvent */.Pxr.Restored:
                                    {
                                        void (() => __awaiter(this, void 0, void 0, function* () {
                                            yield this.sync.sync({
                                                sourceDescription: 'Session restored pre key creation'
                                            });
                                            if (encryptionService.needsNewRootKeyBasedItemsKey()) {
                                                void encryptionService.createNewDefaultItemsKey().then(() => {
                                                    void this.sync.sync({
                                                        sourceDescription: 'Session restored post key creation'
                                                    });
                                                });
                                            }
                                        }))();
                                        break;
                                    }
                                case services_src /* SessionEvent */.Pxr.Revoked:
                                    {
                                        yield this.handleRevokedSession();
                                        break;
                                    }
                                case services_src /* SessionEvent */.Pxr.UserKeyPairChanged:
                                    break;
                                default:
                                    {
                                        (0, utils_dist.assertUnreachable)(event);
                                    }
                            }
                        })));
                        const syncEventCallback = (eventName, data) => __awaiter(this, void 0, void 0, function* () {
                            const appEvent = applicationEventForSyncEvent(eventName);
                            if (appEvent) {
                                yield encryptionService.onSyncEvent(eventName);
                                yield this.notifyEvent(appEvent, data);
                                if (appEvent === services_src /* ApplicationEvent */.n9K.CompletedFullSync) {
                                    if (!this.handledFullSyncStage) {
                                        this.handledFullSyncStage = true;
                                        yield this.handleStage(services_src /* ApplicationStage */.Ugm.FullSyncCompleted_13);
                                    }
                                }
                            }
                        });
                        const syncService = this.dependencies.get(Types /* TYPES */.v.SyncService);
                        const uninstall = syncService.addEventObserver(syncEventCallback);
                        this.serviceObservers.push(uninstall);
                        const protectionService = this.dependencies.get(Types /* TYPES */.v.ProtectionService);
                        this.serviceObservers.push(protectionService.addEventObserver(event => {
                            if (event === services_src /* ProtectionEvent */.Hh3.UnprotectedSessionBegan) {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.UnprotectedSessionBegan);
                            }
                            else if (event === services_src /* ProtectionEvent */.Hh3.UnprotectedSessionExpired) {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.UnprotectedSessionExpired);
                            }
                        }));
                        const userService = this.dependencies.get(Types /* TYPES */.v.UserService);
                        this.serviceObservers.push(userService.addEventObserver((event, data) => __awaiter(this, void 0, void 0, function* () {
                            switch (event) {
                                case services_src /* AccountEvent */.oF7.SignedInOrRegistered:
                                    {
                                        void this.notifyEvent(services_src /* ApplicationEvent */.n9K.SignedIn);
                                        break;
                                    }
                                case services_src /* AccountEvent */.oF7.SignedOut:
                                    {
                                        yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.SignedOut);
                                        yield this.prepareForDeinit();
                                        this.deinit(this.getDeinitMode(), (data === null || data === void 0 ? void 0 : data.payload.source) || services_src /* DeinitSource */.u4P.SignOut);
                                        break;
                                    }
                                default:
                                    {
                                        (0, utils_dist.assertUnreachable)(event);
                                    }
                            }
                        })));
                        const preferencesService = this.dependencies.get(Types /* TYPES */.v.PreferencesService);
                        this.serviceObservers.push(preferencesService.addEventObserver(event => {
                            if (event === services_src /* PreferencesServiceEvent */.WZd.PreferencesChanged) {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.PreferencesChanged);
                            }
                            else if (event === services_src /* PreferencesServiceEvent */.WZd.LocalPreferencesChanged) {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.LocalPreferencesChanged);
                            }
                        }));
                        const featuresService = this.dependencies.get(Types /* TYPES */.v.FeaturesService);
                        this.serviceObservers.push(featuresService.addEventObserver(event => {
                            switch (event) {
                                case services_src /* FeaturesEvent */.Usi.UserRolesChanged:
                                    {
                                        void this.notifyEvent(services_src /* ApplicationEvent */.n9K.UserRolesChanged);
                                        break;
                                    }
                                case services_src /* FeaturesEvent */.Usi.FeaturesAvailabilityChanged:
                                    {
                                        void this.notifyEvent(services_src /* ApplicationEvent */.n9K.FeaturesAvailabilityChanged);
                                        break;
                                    }
                                case services_src /* FeaturesEvent */.Usi.DidPurchaseSubscription:
                                    {
                                        void this.notifyEvent(services_src /* ApplicationEvent */.n9K.DidPurchaseSubscription);
                                        break;
                                    }
                                default:
                                    {
                                        (0, utils_dist.assertUnreachable)(event);
                                    }
                            }
                        }));
                    }
                    computePrivateUsername(username) {
                        return (0, encryption_src /* ComputePrivateUsername */.lx)(this.options.crypto, username);
                    }
                    /**
                     * The first thing consumers should call when starting their app.
                     * This function will load all services in their correct order.
                     */
                    prepareForLaunch(callback) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.launched) {
                                throw new Error('Attempting to prelaunch already launched application');
                            }
                            yield this.options.crypto.initialize();
                            this.setLaunchCallback(callback);
                            const databaseResult = yield this.device.openDatabase(this.identifier).catch(error => {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.LocalDatabaseReadError, error);
                                return undefined;
                            });
                            this.createdNewDatabase = (0, utils_dist.useBoolean)(databaseResult === null || databaseResult === void 0 ? void 0 : databaseResult.isNewDatabase, false);
                            yield this.migrations.initialize();
                            yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.MigrationsLoaded);
                            yield this.handleStage(services_src /* ApplicationStage */.Ugm.PreparingForLaunch_0);
                            yield this.storage.initializeFromDisk();
                            yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.StorageReady);
                            yield this.encryption.initialize();
                            yield this.handleStage(services_src /* ApplicationStage */.Ugm.ReadyForLaunch_05);
                            this.started = true;
                            yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.Started);
                        });
                    }
                    setLaunchCallback(callback) {
                        this.challenges.sendChallenge = callback.receiveChallenge;
                    }
                    /**
                     * Handles device authentication, unlocks application, and
                     * issues a callback if a device activation requires user input
                     * (i.e local passcode or fingerprint).
                     * @param awaitDatabaseLoad
                     * Option to await database load before marking the app as ready.
                     */
                    launch() {
                        let awaitDatabaseLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.launched) {
                                throw new Error('Attempting to launch already launched application');
                            }
                            this.launched = false;
                            const launchChallenge = this.getLaunchChallenge();
                            if (launchChallenge) {
                                const response = yield this.challenges.promptForChallengeResponse(launchChallenge);
                                if (!response) {
                                    throw Error('Launch challenge was cancelled.');
                                }
                                yield this.handleLaunchChallengeResponse(response);
                            }
                            if (this.storage.isStorageWrapped()) {
                                try {
                                    yield this.storage.decryptStorage();
                                }
                                catch (_error) {
                                    void this.alerts.alert(services_src /* ErrorAlertStrings */.kov.StorageDecryptErrorBody, services_src /* ErrorAlertStrings */.kov.StorageDecryptErrorTitle);
                                }
                            }
                            yield this.handleStage(services_src /* ApplicationStage */.Ugm.StorageDecrypted_09);
                            const host = this.legacyApi.loadHost();
                            this.http.setHost(host);
                            this.sockets.loadWebSocketUrl();
                            this.settings.initializeFromDisk();
                            this.launched = true;
                            yield this.notifyEvent(services_src /* ApplicationEvent */.n9K.Launched);
                            yield this.handleStage(services_src /* ApplicationStage */.Ugm.Launched_10);
                            yield this.handleStage(services_src /* ApplicationStage */.Ugm.LoadingDatabase_11);
                            if (this.createdNewDatabase) {
                                yield this.sync.onNewDatabaseCreated();
                            }
                            /**
                             * We don't want to await this, as we want to begin allowing the app to function
                             * before local data has been loaded fully.
                             */
                            const loadPromise = this.sync.loadDatabasePayloads().then(() => __awaiter(this, void 0, void 0, function* () {
                                if (this.dealloced) {
                                    throw 'Application has been destroyed.';
                                }
                                yield this.handleStage(services_src /* ApplicationStage */.Ugm.LoadedDatabase_12);
                                this.sync.beginAutoSyncTimer();
                                yield this.sync.sync({
                                    mode: services_src /* SyncMode */.YCg.DownloadFirst,
                                    source: services_src /* SyncSource */.Lbd.External,
                                    sourceDescription: 'Application Launch'
                                });
                                this.vaultUsers.invalidateVaultUsersCache().catch(console.error);
                            })).catch(error => {
                                void this.notifyEvent(services_src /* ApplicationEvent */.n9K.LocalDatabaseReadError, error);
                                throw error;
                            });
                            if (awaitDatabaseLoad) {
                                yield loadPromise;
                            }
                        });
                    }
                    onStart() {
                        // optional override
                    }
                    onLaunch() {
                        // optional override
                    }
                    getLaunchChallenge() {
                        return this.protections.createLaunchChallenge();
                    }
                    handleLaunchChallengeResponse(response) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (response.challenge.hasPromptForValidationType(services_src /* ChallengeValidation */.tQn.LocalPasscode)) {
                                let wrappingKey = (_a = response.artifacts) === null || _a === void 0 ? void 0 : _a.wrappingKey;
                                if (!wrappingKey) {
                                    const value = response.getValueForType(services_src /* ChallengeValidation */.tQn.LocalPasscode);
                                    wrappingKey = yield this.encryption.computeWrappingKey(value.value);
                                }
                                yield this.encryption.unwrapRootKey(wrappingKey);
                            }
                        });
                    }
                    handleStage(stage) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.events.publishSync({
                                type: services_src /* ApplicationEvent */.n9K.ApplicationStageChanged,
                                payload: {
                                    stage
                                }
                            }, services_src /* InternalEventPublishStrategy */.WNP.SEQUENCE);
                        });
                    }
                    /**
                     * @param singleEvent Whether to only listen for a particular event.
                     */
                    addEventObserver(callback, singleEvent) {
                        const observer = {
                            callback,
                            singleEvent
                        };
                        this.eventHandlers.push(observer);
                        return () => {
                            (0, utils_dist.removeFromArray)(this.eventHandlers, observer);
                        };
                    }
                    addSingleEventObserver(event, callback) {
                        const filteredCallback = firedEvent => __awaiter(this, void 0, void 0, function* () {
                            if (firedEvent === event) {
                                void callback(event);
                            }
                        });
                        return this.addEventObserver(filteredCallback, event);
                    }
                    notifyEvent(event, data) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event === services_src /* ApplicationEvent */.n9K.Started) {
                                this.onStart();
                            }
                            else if (event === services_src /* ApplicationEvent */.n9K.Launched) {
                                this.onLaunch();
                            }
                            for (const observer of this.eventHandlers.slice()) {
                                if (observer.singleEvent && observer.singleEvent === event || !observer.singleEvent) {
                                    yield observer.callback(event, data || {});
                                }
                            }
                            this.events.publish({
                                type: event,
                                payload: data
                            });
                            void this.migrations.handleApplicationEvent(event);
                        });
                    }
                    getSessions() {
                        return this.sessions.getSessionsList();
                    }
                    revokeSession(sessionId) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (yield this.protections.authorizeSessionRevoking()) {
                                return this.sessions.revokeSession(sessionId);
                            }
                            return undefined;
                        });
                    }
                    /**
                     * Revokes all sessions except the current one.
                     */
                    revokeAllOtherSessions() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.sessions.revokeAllOtherSessions();
                        });
                    }
                    userCanManageSessions() {
                        const userVersion = this.getUserVersion();
                        if ((0, utils_dist.isNullOrUndefined)(userVersion)) {
                            return false;
                        }
                        return (0, src.compareVersions)(userVersion, src.ProtocolVersion.V004) >= 0;
                    }
                    setCustomHost(host, websocketUrl) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.setHost.execute(host);
                            this.sockets.setWebSocketUrl(websocketUrl);
                        });
                    }
                    getUserPasswordCreationDate() {
                        return this.encryption.getPasswordCreatedDate();
                    }
                    getProtocolEncryptionDisplayName() {
                        return this.encryption.getEncryptionDisplayName();
                    }
                    getUserVersion() {
                        return this.encryption.getUserVersion();
                    }
                    /**
                     * Returns true if there is an upgrade available for the account or passcode
                     */
                    protocolUpgradeAvailable() {
                        return this.encryption.upgradeAvailable();
                    }
                    /**
                     * Returns true if there is an encryption source available
                     */
                    isEncryptionAvailable() {
                        return this.hasAccount() || this.hasPasscode();
                    }
                    upgradeProtocolVersion() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.user.performProtocolUpgrade();
                            if (result.success) {
                                if (this.hasAccount()) {
                                    void this.alerts.alert(services_src /* ProtocolUpgradeStrings */.GUt.SuccessAccount);
                                }
                                else {
                                    void this.alerts.alert(services_src /* ProtocolUpgradeStrings */.GUt.SuccessPasscodeOnly);
                                }
                            }
                            else if (result.error) {
                                void this.alerts.alert(services_src /* ProtocolUpgradeStrings */.GUt.Fail);
                            }
                            return result;
                        });
                    }
                    hasAccount() {
                        return this.encryption.hasAccount();
                    }
                    /**
                     * @returns true if the user has a source of protection available, such as a
                     * passcode, password, or biometrics.
                     */
                    hasProtectionSources() {
                        return this.protections.hasProtectionSources();
                    }
                    /**
                     * When a user specifies a non-zero remember duration on a protection
                     * challenge, a session will be started during which protections are disabled.
                     */
                    getProtectionSessionExpiryDate() {
                        return this.protections.getSessionExpiryDate();
                    }
                    clearProtectionSession() {
                        return this.protections.clearSession();
                    }
                    authorizeProtectedActionForNotes(notes, challengeReason) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return yield this.protections.authorizeProtectedActionForItems(notes, challengeReason);
                        });
                    }
                    /**
                     * @returns whether note access has been granted or not
                     */
                    authorizeNoteAccess(note) {
                        return this.protections.authorizeItemAccess(note);
                    }
                    authorizeAutolockIntervalChange() {
                        return this.protections.authorizeAutolockIntervalChange();
                    }
                    isEphemeralSession() {
                        return this.storage.isEphemeralSession();
                    }
                    setValue(key, value, mode) {
                        return this.storage.setValue(key, value, mode);
                    }
                    getValue(key, mode) {
                        return this.storage.getValue(key, mode);
                    }
                    removeValue(key, mode) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.storage.removeValue(key, mode);
                        });
                    }
                    getPreference(key, defaultValue) {
                        return this.preferences.getValue(key, defaultValue);
                    }
                    setPreference(key, value) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.preferences.setValue(key, value);
                        });
                    }
                    /**
                     * Gives services a chance to complete any sensitive operations before yielding
                     * @param maxWait The maximum number of milliseconds to wait for services
                     * to finish tasks. 0 means no limit.
                     */
                    prepareForDeinit() {
                        let maxWait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        return __awaiter(this, void 0, void 0, function* () {
                            const deps = this.dependencies.getAll().filter(utils_dist.canBlockDeinit);
                            const promise = Promise.all(deps.map(service => service.blockDeinit()));
                            if (maxWait === 0) {
                                yield promise;
                            }
                            else {
                                /** Await up to maxWait. If not resolved by then, return. */
                                yield Promise.race([promise, (0, utils_dist.sleep)(maxWait, false, 'Preparing for deinit...')]);
                            }
                        });
                    }
                    addChallengeObserver(challenge, observer) {
                        return this.challenges.addChallengeObserver(challenge, observer);
                    }
                    submitValuesForChallenge(challenge, values) {
                        return this.challenges.submitValuesForChallenge(challenge, values);
                    }
                    cancelChallenge(challenge) {
                        this.challenges.cancelChallenge(challenge);
                    }
                    setOnDeinit(onDeinit) {
                        this.onDeinit = onDeinit;
                    }
                    /**
                     * Destroys the application instance.
                     */
                    deinit(mode, source) {
                        var _a;
                        this.dealloced = true;
                        for (const uninstallObserver of this.serviceObservers) {
                            uninstallObserver();
                        }
                        for (const uninstallSubscriber of this.managedSubscribers) {
                            uninstallSubscriber();
                        }
                        this.options.crypto.deinit();
                        this.options = undefined;
                        this.createdNewDatabase = false;
                        this.serviceObservers.length = 0;
                        this.managedSubscribers.length = 0;
                        this.started = false;
                        this.dependencies.deinit();
                        (_a = this.onDeinit) === null || _a === void 0 ? void 0 : _a.call(this, this, mode, source);
                        this.onDeinit = undefined;
                    }
                    /**
                     *  @param mergeLocal  Whether to merge existing offline data into account. If false,
                     *                     any pre-existing data will be fully deleted upon success.
                     */
                    register(email, password, hvmToken) {
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let mergeLocal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.register(email, password, hvmToken, ephemeral, mergeLocal);
                        });
                    }
                    /**
                     * @param mergeLocal  Whether to merge existing offline data into account.
                     * If false, any pre-existing data will be fully deleted upon success.
                     */
                    signIn(email, password) {
                        let strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let mergeLocal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                        let awaitSync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                        let hvmToken = arguments.length > 6 ? arguments[6] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.signIn(email, password, strict, ephemeral, mergeLocal, awaitSync, hvmToken);
                        });
                    }
                    getCaptchaUrl() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.legacyApi.getCaptchaUrl();
                        });
                    }
                    changeEmail(newEmail, currentPassword, passcode) {
                        let origination = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : src.KeyParamsOrigination.EmailChange;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.changeCredentials({
                                currentPassword,
                                newEmail,
                                passcode,
                                origination,
                                validateNewPasswordStrength: false
                            });
                        });
                    }
                    changePassword(currentPassword, newPassword, passcode) {
                        let origination = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : src.KeyParamsOrigination.PasswordChange;
                        let validateNewPasswordStrength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.changeCredentials({
                                currentPassword,
                                newPassword,
                                passcode,
                                origination,
                                validateNewPasswordStrength
                            });
                        });
                    }
                    importData(data) {
                        let awaitSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            const usecase = this.dependencies.get(Types /* TYPES */.v.ImportData);
                            return usecase.execute(data, awaitSync);
                        });
                    }
                    handleRevokedSession() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /**
                             * Because multiple API requests can come back at the same time
                             * indicating revoked session we only want to do this once.
                             */
                            if (this.revokingSession) {
                                return;
                            }
                            this.revokingSession = true;
                            /** Keep a reference to the soon-to-be-cleared alertService */
                            const alertService = this.alerts;
                            yield this.user.signOut(true);
                            void alertService.alert(services_src /* SessionStrings */.K9E.CurrentSessionRevoked);
                        });
                    }
                    validateAccountPassword(password) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { valid } = yield this.encryption.validateAccountPassword(password);
                            return valid;
                        });
                    }
                    isStarted() {
                        return this.started;
                    }
                    isLaunched() {
                        return this.launched;
                    }
                    hasPasscode() {
                        return this.encryption.hasPasscode();
                    }
                    lock() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /**
                             * Because locking is a critical operation, we want to try to do it safely,
                             * but only up to a certain limit.
                             */
                            const MaximumWaitTime = 500;
                            yield this.prepareForDeinit(MaximumWaitTime);
                            return this.deinit(this.getDeinitMode(), services_src /* DeinitSource */.u4P.Lock);
                        });
                    }
                    isNativeMobileWeb() {
                        return this.environment === dist.Environment.Mobile;
                    }
                    getDeinitMode() {
                        const value = this.getValue(services_src /* StorageKey */.QtK.DeinitMode);
                        if (value === 'hard') {
                            return services_src /* DeinitMode */.CYv.Hard;
                        }
                        return services_src /* DeinitMode */.CYv.Soft;
                    }
                    addPasscode(passcode) {
                        return this.user.addPasscode(passcode);
                    }
                    /**
                     * @returns whether the passcode was successfuly removed
                     */
                    removePasscode() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.removePasscode();
                        });
                    }
                    changePasscode(newPasscode) {
                        let origination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : src.KeyParamsOrigination.PasscodeChange;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.user.changePasscode(newPasscode, origination);
                        });
                    }
                    enableEphemeralPersistencePolicy() {
                        return this.storage.setPersistencePolicy(services_src /* StoragePersistencePolicies */.eIN.Ephemeral);
                    }
                    hasPendingMigrations() {
                        return this.migrations.hasPendingMigrations();
                    }
                    presentKeyRecoveryWizard() {
                        const service = this.dependencies.get(Types /* TYPES */.v.KeyRecoveryService);
                        return service.presentKeyRecoveryWizard();
                    }
                    canAttemptDecryptionOfItem(item) {
                        const service = this.dependencies.get(Types /* TYPES */.v.KeyRecoveryService);
                        return service.canAttemptDecryptionOfItem(item);
                    }
                    isUsingHomeServer() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const homeServerService = this.dependencies.get(Types /* TYPES */.v.HomeServerService);
                            if (!homeServerService) {
                                return false;
                            }
                            return this.getHost.execute().getValue() === (yield homeServerService.getHomeServerUrl());
                        });
                    }
                    get device() {
                        return this.dependencies.get(Types /* TYPES */.v.DeviceInterface);
                    }
                    get subscriptions() {
                        return this.dependencies.get(Types /* TYPES */.v.SubscriptionManager);
                    }
                    get signInWithRecoveryCodes() {
                        return this.dependencies.get(Types /* TYPES */.v.SignInWithRecoveryCodes);
                    }
                    get getRecoveryCodes() {
                        return this.dependencies.get(Types /* TYPES */.v.GetRecoveryCodes);
                    }
                    get addAuthenticator() {
                        return this.dependencies.get(Types /* TYPES */.v.AddAuthenticator);
                    }
                    get listAuthenticators() {
                        return this.dependencies.get(Types /* TYPES */.v.ListAuthenticators);
                    }
                    get deleteAuthenticator() {
                        return this.dependencies.get(Types /* TYPES */.v.DeleteAuthenticator);
                    }
                    get getAuthenticatorAuthenticationOptions() {
                        return this.dependencies.get(Types /* TYPES */.v.GetAuthenticatorAuthenticationOptions);
                    }
                    get getAuthenticatorAuthenticationResponse() {
                        return this.dependencies.get(Types /* TYPES */.v.GetAuthenticatorAuthenticationResponse);
                    }
                    get listRevisions() {
                        return this.dependencies.get(Types /* TYPES */.v.ListRevisions);
                    }
                    get getRevision() {
                        return this.dependencies.get(Types /* TYPES */.v.GetRevision);
                    }
                    get deleteRevision() {
                        return this.dependencies.get(Types /* TYPES */.v.DeleteRevision);
                    }
                    get files() {
                        return this.dependencies.get(Types /* TYPES */.v.FileService);
                    }
                    get features() {
                        return this.dependencies.get(Types /* TYPES */.v.FeaturesService);
                    }
                    get items() {
                        return this.dependencies.get(Types /* TYPES */.v.ItemManager);
                    }
                    get payloads() {
                        return this.dependencies.get(Types /* TYPES */.v.PayloadManager);
                    }
                    get protections() {
                        return this.dependencies.get(Types /* TYPES */.v.ProtectionService);
                    }
                    get sync() {
                        return this.dependencies.get(Types /* TYPES */.v.SyncService);
                    }
                    get user() {
                        return this.dependencies.get(Types /* TYPES */.v.UserService);
                    }
                    get settings() {
                        return this.dependencies.get(Types /* TYPES */.v.SettingsService);
                    }
                    get mutator() {
                        return this.dependencies.get(Types /* TYPES */.v.MutatorService);
                    }
                    get sessions() {
                        return this.dependencies.get(Types /* TYPES */.v.SessionManager);
                    }
                    get status() {
                        return this.dependencies.get(Types /* TYPES */.v.StatusService);
                    }
                    get fileBackups() {
                        return this.dependencies.get(Types /* TYPES */.v.FilesBackupService);
                    }
                    get componentManager() {
                        return this.dependencies.get(Types /* TYPES */.v.ComponentManager);
                    }
                    get listed() {
                        return this.dependencies.get(Types /* TYPES */.v.ListedService);
                    }
                    get alerts() {
                        return this.dependencies.get(Types /* TYPES */.v.AlertService);
                    }
                    get storage() {
                        return this.dependencies.get(Types /* TYPES */.v.DiskStorageService);
                    }
                    get actions() {
                        return this.dependencies.get(Types /* TYPES */.v.ActionsService);
                    }
                    get challenges() {
                        return this.dependencies.get(Types /* TYPES */.v.ChallengeService);
                    }
                    get asymmetric() {
                        return this.dependencies.get(Types /* TYPES */.v.AsymmetricMessageService);
                    }
                    get homeServer() {
                        return this.dependencies.get(Types /* TYPES */.v.HomeServerService);
                    }
                    get preferences() {
                        return this.dependencies.get(Types /* TYPES */.v.PreferencesService);
                    }
                    get history() {
                        return this.dependencies.get(Types /* TYPES */.v.HistoryManager);
                    }
                    get encryption() {
                        return this.dependencies.get(Types /* TYPES */.v.EncryptionService);
                    }
                    get events() {
                        return this.dependencies.get(Types /* TYPES */.v.InternalEventBus);
                    }
                    get vaults() {
                        return this.dependencies.get(Types /* TYPES */.v.VaultService);
                    }
                    get vaultLocks() {
                        return this.dependencies.get(Types /* TYPES */.v.VaultLockService);
                    }
                    get vaultUsers() {
                        return this.dependencies.get(Types /* TYPES */.v.VaultUserService);
                    }
                    get vaultInvites() {
                        return this.dependencies.get(Types /* TYPES */.v.VaultInviteService);
                    }
                    get contacts() {
                        return this.dependencies.get(Types /* TYPES */.v.ContactService);
                    }
                    get sharedVaults() {
                        return this.dependencies.get(Types /* TYPES */.v.SharedVaultService);
                    }
                    get changeAndSaveItem() {
                        return this.dependencies.get(Types /* TYPES */.v.ChangeAndSaveItem);
                    }
                    get getHost() {
                        return this.dependencies.get(Types /* TYPES */.v.GetHost);
                    }
                    get setHost() {
                        return this.dependencies.get(Types /* TYPES */.v.SetHost);
                    }
                    get legacyApi() {
                        return this.dependencies.get(Types /* TYPES */.v.LegacyApiService);
                    }
                    get mfa() {
                        return this.dependencies.get(Types /* TYPES */.v.MfaService);
                    }
                    get generateUuid() {
                        return this.dependencies.get(Types /* TYPES */.v.GenerateUuid);
                    }
                    get createDecryptedBackupFile() {
                        return this.dependencies.get(Types /* TYPES */.v.CreateDecryptedBackupFile);
                    }
                    get createEncryptedBackupFile() {
                        return this.dependencies.get(Types /* TYPES */.v.CreateEncryptedBackupFile);
                    }
                    get migrations() {
                        return this.dependencies.get(Types /* TYPES */.v.MigrationService);
                    }
                    get http() {
                        return this.dependencies.get(Types /* TYPES */.v.HttpService);
                    }
                    get sockets() {
                        return this.dependencies.get(Types /* TYPES */.v.WebSocketsService);
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Application/LiveItem.ts
                /** Keeps an item reference up to date with changes */
                class LiveItem {
                    constructor(uuid, items, onChange) {
                        this.item = items.findSureItem(uuid);
                        onChange && onChange(this.item);
                        this.removeObserver = items.streamItems(this.item.content_type, _ref => {
                            let { changed, inserted } = _ref;
                            const matchingItem = [...changed, ...inserted].find(item => {
                                return item.uuid === uuid;
                            });
                            if (matchingItem) {
                                this.item = matchingItem;
                                onChange && onChange(this.item);
                            }
                        });
                    }
                    deinit() {
                        if (!this.removeObserver) {
                            console.error('A LiveItem is attempting to be deinited more than once.');
                        }
                        else {
                            this.removeObserver();
                            this.removeObserver = undefined;
                        }
                    }
                }
                // EXTERNAL MODULE: ./lib/Application/Platforms.ts
                var Platforms = __webpack_require__(2256);
                ; // CONCATENATED MODULE: ./lib/Application/index.ts
                /***/ 
            }),
            /***/ 58181: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    $: () => ( /* reexport */ApplicationGroupEvent),
                    R: () => ( /* reexport */SNApplicationGroup)
                });
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var dist = __webpack_require__(87901);
                ; // CONCATENATED MODULE: ./lib/ApplicationGroup/ApplicationGroupEvent.ts
                var ApplicationGroupEvent;
                (function (ApplicationGroupEvent) {
                    ApplicationGroupEvent["PrimaryApplicationSet"] = "PrimaryApplicationSet";
                    ApplicationGroupEvent["DescriptorsDataChanged"] = "DescriptorsDataChanged";
                    ApplicationGroupEvent["DeviceWillRestart"] = "DeviceWillRestart";
                })(ApplicationGroupEvent || (ApplicationGroupEvent = {}));
                ; // CONCATENATED MODULE: ./lib/ApplicationGroup/ApplicationGroup.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SNApplicationGroup extends src /* AbstractService */.wcN {
                    constructor(device, internalEventBus) {
                        if (internalEventBus === undefined) {
                            internalEventBus = new src /* InternalEventBus */.Ehg();
                        }
                        super(internalEventBus);
                        this.device = device;
                        this.onApplicationDeinit = (application, mode, source) => {
                            if (this.primaryApplication === application) {
                                ;
                                this.primaryApplication = undefined;
                            }
                            const performSyncronously = () => __awaiter(this, void 0, void 0, function* () {
                                if (source === src /* DeinitSource */.u4P.SignOut) {
                                    void this.removeDescriptor(this.descriptorForApplication(application));
                                }
                                const descriptors = this.getDescriptors();
                                if (descriptors.length === 0 || source === src /* DeinitSource */.u4P.SignOutAll) {
                                    const identifiers = descriptors.map(d => d.identifier);
                                    this.descriptorRecord = {};
                                    const { killsApplication } = yield this.device.clearAllDataFromDevice(identifiers);
                                    if (killsApplication) {
                                        return;
                                    }
                                }
                                const device = this.device;
                                void this.notifyEvent(ApplicationGroupEvent.DeviceWillRestart, {
                                    source,
                                    mode
                                });
                                this.deinit();
                                if (mode === src /* DeinitMode */.CYv.Hard) {
                                    device.performHardReset();
                                }
                                else {
                                    device.performSoftReset();
                                }
                            });
                            void performSyncronously();
                        };
                    }
                    deinit() {
                        super.deinit();
                        this.device.deinit();
                        this.device = undefined;
                        this.callback = undefined;
                        this.primaryApplication = undefined;
                        this.onApplicationDeinit = undefined;
                    }
                    initialize(callback) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.device.isDeviceDestroyed()) {
                                throw 'Attempting to initialize new application while device is destroyed.';
                            }
                            this.callback = callback;
                            this.descriptorRecord = yield this.device.getJsonParsedRawStorageValue(src /* RawStorageKey */.Bq2.DescriptorRecord);
                            if (!this.descriptorRecord) {
                                yield this.createNewDescriptorRecord();
                            }
                            let primaryDescriptor = this.findPrimaryDescriptor();
                            if (!primaryDescriptor) {
                                console.error('No primary application descriptor found. Ensure migrations have been run.');
                                primaryDescriptor = this.getDescriptors()[0];
                                this.setDescriptorAsPrimary(primaryDescriptor);
                                yield this.persistDescriptors();
                            }
                            const application = yield this.buildApplication(primaryDescriptor);
                            this.primaryApplication = application;
                            application.addEventObserver(() => __awaiter(this, void 0, void 0, function* () {
                                this.renameDescriptor(primaryDescriptor, application.sessions.getWorkspaceDisplayIdentifier());
                            }), src /* ApplicationEvent */.n9K.SignedIn);
                            yield this.notifyEvent(ApplicationGroupEvent.PrimaryApplicationSet, {
                                application: application
                            });
                        });
                    }
                    createNewDescriptorRecord() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /**
                             * The identifier 'standardnotes' is used because this was the
                             * database name of Standard Notes web/desktop
                             * */
                            const identifier = 'standardnotes';
                            const descriptorRecord = {
                                [identifier]: {
                                    identifier: identifier,
                                    label: 'Main Workspace',
                                    primary: true
                                }
                            };
                            void this.device.setRawStorageValue(src /* RawStorageKey */.Bq2.DescriptorRecord, JSON.stringify(descriptorRecord));
                            this.descriptorRecord = descriptorRecord;
                            yield this.persistDescriptors();
                        });
                    }
                    getDescriptors() {
                        return Object.values(this.descriptorRecord);
                    }
                    findPrimaryDescriptor() {
                        for (const descriptor of this.getDescriptors()) {
                            if (descriptor.primary) {
                                return descriptor;
                            }
                        }
                        return undefined;
                    }
                    signOutAllWorkspaces() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.primaryApplication.user.signOut(false, src /* DeinitSource */.u4P.SignOutAll);
                        });
                    }
                    setDescriptorAsPrimary(primaryDescriptor) {
                        for (const descriptor of this.getDescriptors()) {
                            descriptor.primary = descriptor === primaryDescriptor;
                        }
                    }
                    persistDescriptors() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.device.setRawStorageValue(src /* RawStorageKey */.Bq2.DescriptorRecord, JSON.stringify(this.descriptorRecord));
                            void this.notifyEvent(ApplicationGroupEvent.DescriptorsDataChanged, {
                                descriptors: this.descriptorRecord
                            });
                        });
                    }
                    renameDescriptor(descriptor, label) {
                        descriptor.label = label;
                        void this.persistDescriptors();
                    }
                    removeDescriptor(descriptor) {
                        delete this.descriptorRecord[descriptor.identifier];
                        const descriptors = this.getDescriptors();
                        if (descriptor.primary && descriptors.length > 0) {
                            this.setDescriptorAsPrimary(descriptors[0]);
                        }
                        return this.persistDescriptors();
                    }
                    removeAllDescriptors() {
                        this.descriptorRecord = {};
                        return this.persistDescriptors();
                    }
                    descriptorForApplication(application) {
                        return this.descriptorRecord[application.identifier];
                    }
                    createNewApplicationDescriptor(label) {
                        const identifier = dist.UuidGenerator.GenerateUuid();
                        const index = this.getDescriptors().length + 1;
                        const descriptor = {
                            identifier: identifier,
                            label: label || "Workspace ".concat(index),
                            primary: false
                        };
                        return descriptor;
                    }
                    createNewPrimaryDescriptor(label) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const descriptor = this.createNewApplicationDescriptor(label);
                            this.descriptorRecord[descriptor.identifier] = descriptor;
                            this.setDescriptorAsPrimary(descriptor);
                            yield this.persistDescriptors();
                        });
                    }
                    unloadCurrentAndCreateNewDescriptor(label) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.createNewPrimaryDescriptor(label);
                            if (this.primaryApplication) {
                                this.primaryApplication.deinit(this.primaryApplication.getDeinitMode(), src /* DeinitSource */.u4P.SwitchWorkspace);
                            }
                        });
                    }
                    unloadCurrentAndActivateDescriptor(descriptor) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.setDescriptorAsPrimary(descriptor);
                            yield this.persistDescriptors();
                            if (this.primaryApplication) {
                                this.primaryApplication.deinit(this.primaryApplication.getDeinitMode(), src /* DeinitSource */.u4P.SwitchWorkspace);
                            }
                        });
                    }
                    buildApplication(descriptor) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const application = yield this.callback.applicationCreator(descriptor, this.device);
                            application.setOnDeinit(this.onApplicationDeinit);
                            return application;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/ApplicationGroup/index.ts
                /***/ 
            }),
            /***/ 29159: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    Z: () => ( /* reexport */ReactNativeToWebEvent)
                });
                ; // CONCATENATED MODULE: ./lib/Client/ReactNativeToWebEvent.ts
                var ReactNativeToWebEvent;
                (function (ReactNativeToWebEvent) {
                    ReactNativeToWebEvent["EnteringBackground"] = "EnteringBackground";
                    ReactNativeToWebEvent["ResumingFromBackground"] = "ResumingFromBackground";
                    ReactNativeToWebEvent["GainingFocus"] = "GainingFocus";
                    ReactNativeToWebEvent["LosingFocus"] = "LosingFocus";
                    ReactNativeToWebEvent["AndroidBackButtonPressed"] = "AndroidBackButtonPressed";
                    ReactNativeToWebEvent["ColorSchemeChanged"] = "ColorSchemeChanged";
                    ReactNativeToWebEvent["KeyboardFrameWillChange"] = "KeyboardFrameWillChange";
                    ReactNativeToWebEvent["KeyboardFrameDidChange"] = "KeyboardFrameDidChange";
                    ReactNativeToWebEvent["KeyboardWillShow"] = "KeyboardWillShow";
                    ReactNativeToWebEvent["KeyboardWillHide"] = "KeyboardWillHide";
                    ReactNativeToWebEvent["ReceivedFile"] = "ReceivedFile";
                    ReactNativeToWebEvent["ReceivedLink"] = "ReceivedLink";
                    ReactNativeToWebEvent["ReceivedText"] = "ReceivedText";
                    ReactNativeToWebEvent["OpenFilePreview"] = "OpenFilePreview";
                })(ReactNativeToWebEvent || (ReactNativeToWebEvent = {}));
                ; // CONCATENATED MODULE: ./lib/Client/index.ts
                /***/ 
            }),
            /***/ 68704: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ f: () => ( /* binding */AddAuthenticator)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class AddAuthenticator {
                    constructor(authenticatorClient, authenticatorRegistrationPromptFunction) {
                        this.authenticatorClient = authenticatorClient;
                        this.authenticatorRegistrationPromptFunction = authenticatorRegistrationPromptFunction;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.authenticatorRegistrationPromptFunction) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not generate authenticator registration options: No authenticator registration prompt function provided');
                            }
                            const userUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.userUuid);
                            if (userUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not generate authenticator registration options: ".concat(userUuidOrError.getError()));
                            }
                            const userUuid = userUuidOrError.getValue();
                            const authenticatorNameValidatorResult = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Validator.isNotEmpty(dto.authenticatorName);
                            if (authenticatorNameValidatorResult.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not generate authenticator registration options: ".concat(authenticatorNameValidatorResult.getError()));
                            }
                            const registrationOptions = yield this.authenticatorClient.generateRegistrationOptions();
                            if (registrationOptions === null) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not generate authenticator registration options');
                            }
                            let authenticatorResponse;
                            try {
                                authenticatorResponse = yield this.authenticatorRegistrationPromptFunction(registrationOptions);
                            }
                            catch (error) {
                                if (error.name === 'InvalidStateError') {
                                    return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Authenticator was probably already registered by user');
                                }
                                else {
                                    return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not generate authenticator registration options: ".concat(error.message));
                                }
                            }
                            const verificationResponse = yield this.authenticatorClient.verifyRegistrationResponse(userUuid, dto.authenticatorName, authenticatorResponse);
                            if (!verificationResponse) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not verify authenticator registration response');
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok();
                        });
                    }
                }
                /***/ 
            }),
            /***/ 58875: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ c: () => ( /* binding */DeleteAuthenticator)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteAuthenticator {
                    constructor(authenticatorClient) {
                        this.authenticatorClient = authenticatorClient;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const authenticatorIdOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.authenticatorId);
                            if (authenticatorIdOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not delete authenticator: ".concat(authenticatorIdOrError.getError()));
                            }
                            const authenticatorId = authenticatorIdOrError.getValue();
                            const result = yield this.authenticatorClient.delete(authenticatorId);
                            if (!result) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not delete authenticator');
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok();
                        });
                    }
                }
                /***/ 
            }),
            /***/ 46390: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ g: () => ( /* binding */DeleteRevision)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class DeleteRevision {
                    constructor(revisionManager) {
                        this.revisionManager = revisionManager;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const itemUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.itemUuid);
                            if (itemUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not delete revision: ".concat(itemUuidOrError.getError()));
                            }
                            const itemUuid = itemUuidOrError.getValue();
                            const revisionUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.revisionUuid);
                            if (revisionUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not delete revision: ".concat(revisionUuidOrError.getError()));
                            }
                            const revisionUuid = revisionUuidOrError.getValue();
                            try {
                                yield this.revisionManager.deleteRevision(itemUuid, revisionUuid);
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok();
                            }
                            catch (error) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not delete revision: ".concat(error.message));
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 12473: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ V: () => ( /* binding */GetAuthenticatorAuthenticationOptions)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetAuthenticatorAuthenticationOptions {
                    constructor(authenticatorClient) {
                        this.authenticatorClient = authenticatorClient;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const usernameOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Username.create(dto.username);
                            if (usernameOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not generate authenticator authentication options: ".concat(usernameOrError.getError()));
                            }
                            const username = usernameOrError.getValue();
                            const authenticationOptions = yield this.authenticatorClient.generateAuthenticationOptions(username);
                            if (authenticationOptions === null) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not generate authenticator authentication options');
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(authenticationOptions);
                        });
                    }
                }
                /***/ 
            }),
            /***/ 84526: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ F: () => ( /* binding */GetAuthenticatorAuthenticationResponse)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetAuthenticatorAuthenticationResponse {
                    constructor(getAuthenticatorAuthenticationOptions, authenticatorVerificationPromptFunction) {
                        this.getAuthenticatorAuthenticationOptions = getAuthenticatorAuthenticationOptions;
                        this.authenticatorVerificationPromptFunction = authenticatorVerificationPromptFunction;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.authenticatorVerificationPromptFunction) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not generate authenticator authentication options: No authenticator verification prompt function provided');
                            }
                            const authenticationOptionsOrError = yield this.getAuthenticatorAuthenticationOptions.execute({
                                username: dto.username
                            });
                            if (authenticationOptionsOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail(authenticationOptionsOrError.getError());
                            }
                            const authenticationOptions = authenticationOptionsOrError.getValue();
                            let authenticatorResponse;
                            try {
                                authenticatorResponse = yield this.authenticatorVerificationPromptFunction(authenticationOptions);
                            }
                            catch (error) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not generate authenticator authentication options: ".concat(error.message));
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(authenticatorResponse);
                        });
                    }
                }
                /***/ 
            }),
            /***/ 79327: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ u: () => ( /* binding */GetRecoveryCodes)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetRecoveryCodes {
                    constructor(authClient, settingsClient) {
                        this.authClient = authClient;
                        this.settingsClient = settingsClient;
                    }
                    execute() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const existingRecoveryCodes = yield this.settingsClient.getSetting(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.SettingName.create(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.SettingName.NAMES.RecoveryCodes).getValue());
                            if (existingRecoveryCodes !== undefined) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(existingRecoveryCodes);
                            }
                            const generatedRecoveryCodes = yield this.authClient.generateRecoveryCodes();
                            if (generatedRecoveryCodes === false) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not generate recovery code');
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(generatedRecoveryCodes);
                        });
                    }
                }
                /***/ 
            }),
            /***/ 51383: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ X: () => ( /* binding */GetRevision)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class GetRevision {
                    constructor(revisionManager, encryptionService) {
                        this.revisionManager = revisionManager;
                        this.encryptionService = encryptionService;
                    }
                    execute(dto) {
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function* () {
                            const itemUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.itemUuid);
                            if (itemUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not get revision: ".concat(itemUuidOrError.getError()));
                            }
                            const itemUuid = itemUuidOrError.getValue();
                            const revisionUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.revisionUuid);
                            if (revisionUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not get revision: ".concat(revisionUuidOrError.getError()));
                            }
                            const revisionUuid = revisionUuidOrError.getValue();
                            let revision;
                            try {
                                revision = yield this.revisionManager.getRevision(itemUuid, revisionUuid);
                            }
                            catch (error) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not get revision: ".concat(error.message));
                            }
                            if (!revision) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not get revision: Revision not found');
                            }
                            const serverPayload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.EncryptedPayload(Object.assign(Object.assign({}, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadTimestampDefaults)()), {
                                uuid: revision.uuid,
                                content: revision.content,
                                enc_item_key: revision.enc_item_key,
                                items_key_id: revision.items_key_id,
                                auth_hash: revision.auth_hash,
                                content_type: revision.content_type,
                                updated_at: new Date(revision.updated_at),
                                created_at: new Date(revision.created_at),
                                key_system_identifier: (_a = revision.key_system_identifier) !== null && _a !== void 0 ? _a : undefined,
                                shared_vault_uuid: (_b = revision.shared_vault_uuid) !== null && _b !== void 0 ? _b : undefined,
                                waitingForKey: false,
                                errorDecrypting: false
                            }));
                            /**
                             * When an item is duplicated, its revisions also carry over to the newly created item.
                             * However since the new item has a different UUID than the source item, we must decrypt
                             * these olders revisions (which have not been mutated after copy) with the source item's
                             * uuid.
                             */
                            const embeddedParams = this.encryptionService.getEmbeddedPayloadAuthenticatedData(serverPayload);
                            const sourceItemUuid = embeddedParams === null || embeddedParams === void 0 ? void 0 : embeddedParams.u;
                            const payload = serverPayload.copy({
                                uuid: sourceItemUuid || revision.item_uuid
                            });
                            const remotePayloadAllowedResult = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.checkRemotePayloadAllowed)(payload);
                            if (remotePayloadAllowedResult.disallowed !== undefined) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Remote payload is disallowed: ".concat(JSON.stringify(payload)));
                            }
                            const encryptedPayload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.EncryptedPayload(payload);
                            const decryptedPayload = yield this.encryptionService.decryptSplitSingle({
                                usesItemsKeyWithKeyLookup: {
                                    items: [encryptedPayload]
                                }
                            });
                            if ((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isErrorDecryptingPayload)(decryptedPayload)) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not decrypt revision.');
                            }
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.HistoryEntry(decryptedPayload));
                        });
                    }
                }
                /***/ 
            }),
            /***/ 43252: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ F: () => ( /* binding */ListAuthenticators)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ListAuthenticators {
                    constructor(authenticatorClient) {
                        this.authenticatorClient = authenticatorClient;
                    }
                    execute() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const authenticators = yield this.authenticatorClient.list();
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(authenticators);
                        });
                    }
                }
                /***/ 
            }),
            /***/ 9704: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ G: () => ( /* binding */ListRevisions)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ListRevisions {
                    constructor(revisionManager) {
                        this.revisionManager = revisionManager;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const itemUuidOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Uuid.create(dto.itemUuid);
                            if (itemUuidOrError.isFailed()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not list item revisions: ".concat(itemUuidOrError.getError()));
                            }
                            const itemUuid = itemUuidOrError.getValue();
                            try {
                                const revisions = yield this.revisionManager.listRevisions(itemUuid);
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok(revisions);
                            }
                            catch (error) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail("Could not list item revisions: ".concat(error.message));
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 32274: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Y: () => ( /* binding */SignInWithRecoveryCodes)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86999);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SignInWithRecoveryCodes {
                    constructor(authManager, encryptionService, inMemoryStore, crypto, sessionManager, internalEventBus) {
                        this.authManager = authManager;
                        this.encryptionService = encryptionService;
                        this.inMemoryStore = inMemoryStore;
                        this.crypto = crypto;
                        this.sessionManager = sessionManager;
                        this.internalEventBus = internalEventBus;
                    }
                    execute(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.encryptionService.hasAccount()) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Tried to sign in when an account already exists.');
                            }
                            const codeVerifier = this.crypto.generateRandomKey(256);
                            this.inMemoryStore.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.CodeVerifier, codeVerifier);
                            const codeChallenge = this.crypto.base64URLEncode(yield this.crypto.sha256(codeVerifier));
                            const recoveryKeyParams = yield this.authManager.recoveryKeyParams(Object.assign({
                                codeChallenge
                            }, dto));
                            if (recoveryKeyParams === false) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not retrieve recovery key params');
                            }
                            const rootKeyParams = (0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_3__ /* .CreateAnyKeyParams */.jl)(recoveryKeyParams);
                            if (!this.encryptionService.supportedVersions().includes(rootKeyParams.version)) {
                                if (this.encryptionService.isVersionNewerThanLibraryVersion(rootKeyParams.version)) {
                                    return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .UNSUPPORTED_PROTOCOL_VERSION */.fnl);
                                }
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .EXPIRED_PROTOCOL_VERSION */.R53);
                            }
                            if (!this.encryptionService.platformSupportsKeyDerivation(rootKeyParams)) {
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .UNSUPPORTED_KEY_DERIVATION */.VnT);
                            }
                            const rootKey = yield this.encryptionService.computeRootKey(dto.password, rootKeyParams);
                            const signInResult = yield this.authManager.signInWithRecoveryCodes({
                                codeVerifier,
                                recoveryCodes: dto.recoveryCodes,
                                username: dto.username,
                                password: rootKey.serverPassword,
                                hvmToken: dto.hvmToken
                            });
                            if (signInResult.success === false) {
                                if (signInResult.captchaURL) {
                                    return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail(JSON.stringify({
                                        captchaURL: signInResult.captchaURL
                                    }));
                                }
                                return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.fail('Could not sign in with recovery code');
                            }
                            this.inMemoryStore.removeValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.CodeVerifier);
                            const expandedRootKey = new _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_3__ /* .SNRootKey */.t$((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CopyPayloadWithContentOverride)(rootKey.payload, {
                                keyParams: signInResult.keyParams
                            }));
                            yield this.sessionManager.handleAuthentication({
                                session: signInResult.session,
                                user: signInResult.user,
                                rootKey: expandedRootKey
                            });
                            yield this.internalEventBus.publishSync({
                                type: _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AccountEvent */.oF7.SignedInOrRegistered,
                                payload: {
                                    payload: {
                                        ephemeral: false,
                                        mergeLocal: false,
                                        awaitSync: true,
                                        checkIntegrity: false
                                    }
                                }
                            }, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .InternalEventPublishStrategy */.WNP.SEQUENCE);
                            return _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.Result.ok();
                        });
                    }
                }
                /***/ 
            }),
            /***/ 67199: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ FL: () => ( /* reexport safe */_UseCase_ListAuthenticators_ListAuthenticators__WEBPACK_IMPORTED_MODULE_7__.F),
                    /* harmony export */ FV: () => ( /* reexport safe */_UseCase_GetAuthenticatorAuthenticationResponse_GetAuthenticatorAuthenticationResponse__WEBPACK_IMPORTED_MODULE_4__.F),
                    /* harmony export */ GU: () => ( /* reexport safe */_UseCase_ListRevisions_ListRevisions__WEBPACK_IMPORTED_MODULE_8__.G),
                    /* harmony export */ VQ: () => ( /* reexport safe */_UseCase_GetAuthenticatorAuthenticationOptions_GetAuthenticatorAuthenticationOptions__WEBPACK_IMPORTED_MODULE_3__.V),
                    /* harmony export */ Xc: () => ( /* reexport safe */_UseCase_GetRevision_GetRevision__WEBPACK_IMPORTED_MODULE_6__.X),
                    /* harmony export */ Y_: () => ( /* reexport safe */_UseCase_SignInWithRecoveryCodes_SignInWithRecoveryCodes__WEBPACK_IMPORTED_MODULE_9__.Y),
                    /* harmony export */ cx: () => ( /* reexport safe */_UseCase_DeleteAuthenticator_DeleteAuthenticator__WEBPACK_IMPORTED_MODULE_1__.c),
                    /* harmony export */ fC: () => ( /* reexport safe */_UseCase_AddAuthenticator_AddAuthenticator__WEBPACK_IMPORTED_MODULE_0__.f),
                    /* harmony export */ gS: () => ( /* reexport safe */_UseCase_DeleteRevision_DeleteRevision__WEBPACK_IMPORTED_MODULE_2__.g),
                    /* harmony export */ u2: () => ( /* reexport safe */_UseCase_GetRecoveryCodes_GetRecoveryCodes__WEBPACK_IMPORTED_MODULE_5__.u)
                    /* harmony export */ 
                });
                /* harmony import */ var _UseCase_AddAuthenticator_AddAuthenticator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68704);
                /* harmony import */ var _UseCase_DeleteAuthenticator_DeleteAuthenticator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58875);
                /* harmony import */ var _UseCase_DeleteRevision_DeleteRevision__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46390);
                /* harmony import */ var _UseCase_GetAuthenticatorAuthenticationOptions_GetAuthenticatorAuthenticationOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12473);
                /* harmony import */ var _UseCase_GetAuthenticatorAuthenticationResponse_GetAuthenticatorAuthenticationResponse__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84526);
                /* harmony import */ var _UseCase_GetRecoveryCodes_GetRecoveryCodes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79327);
                /* harmony import */ var _UseCase_GetRevision_GetRevision__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51383);
                /* harmony import */ var _UseCase_ListAuthenticators_ListAuthenticators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43252);
                /* harmony import */ var _UseCase_ListRevisions_ListRevisions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9704);
                /* harmony import */ var _UseCase_SignInWithRecoveryCodes_SignInWithRecoveryCodes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32274);
                /***/ 
            }),
            /***/ 43361: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ W: () => ( /* binding */SNLog)
                    /* harmony export */ 
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */
                /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
                class SNLog {
                    static log() {
                        this.onLog(...arguments);
                    }
                    static error(error) {
                        this.onError(error);
                        return error;
                    }
                }
                /***/ 
            }),
            /***/ 38529: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ l: () => ( /* binding */TagsToFoldersMigrationApplicator)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class TagsToFoldersMigrationApplicator {
                    static isApplicableToCurrentData(itemManager) {
                        const tags = itemManager.getItems(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.Tag);
                        for (const tag of tags) {
                            if (tag.title.includes(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.TagFolderDelimitter) && !tag.parentId) {
                                return true;
                            }
                        }
                        return false;
                    }
                    static run(itemManager, mutator) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const tags = itemManager.getItems(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.Tag);
                            const sortedTags = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.sortByKey)(tags, 'title');
                            for (const tag of sortedTags) {
                                const hierarchy = tag.title.split(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.TagFolderDelimitter);
                                const hasSimpleTitle = hierarchy.length === 1;
                                const hasParent = !!tag.parentId;
                                const hasUnsupportedTitle = hierarchy.some(title => title.length === 0);
                                if (hasParent || hasSimpleTitle || hasUnsupportedTitle) {
                                    continue;
                                }
                                const parents = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.withoutLastElement)(hierarchy);
                                const newTitle = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.lastElement)(hierarchy);
                                if (!newTitle) {
                                    return;
                                }
                                const parent = yield mutator.findOrCreateTagParentChain(parents);
                                yield mutator.changeItem(tag, mutator => {
                                    mutator.title = newTitle;
                                    if (parent) {
                                        mutator.makeChildOf(parent);
                                    }
                                });
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 58386: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    _: () => ( /* binding */BaseMigration)
                });
                // NAMESPACE OBJECT: ./lib/Migrations/StorageReaders/Versions/index.ts
                var Versions_namespaceObject = {};
                __webpack_require__.r(Versions_namespaceObject);
                __webpack_require__.d(Versions_namespaceObject, {
                    StorageReader2_0_0: () => (StorageReader2_0_0)
                });
                // EXTERNAL MODULE: ../models/dist/index.js
                var dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ./lib/Version.ts
                var Version = __webpack_require__(94986);
                // EXTERNAL MODULE: ./lib/Migrations/Migration.ts
                var Migration = __webpack_require__(15078);
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                ; // CONCATENATED MODULE: ./lib/Migrations/StorageReaders/Reader.ts
                /**
                 * A storage reader reads storage via a device interface
                 * given a specific version of SNJS
                 */
                class StorageReader {
                    constructor(deviceInterface, identifier, environment) {
                        this.deviceInterface = deviceInterface;
                        this.identifier = identifier;
                        this.environment = environment;
                    }
                    static version() {
                        throw Error('Must override');
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/StorageReaders/Versions/Reader2_0_0.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class StorageReader2_0_0 extends StorageReader {
                    static version() {
                        return Version /* PreviousSnjsVersion2_0_0 */.Oq;
                    }
                    getStorage() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const storageKey = (0, src /* namespacedKey */.xLN)(this.identifier, src /* RawStorageKey */.Bq2.StorageObject);
                            const storage = yield this.deviceInterface.getRawStorageValue(storageKey);
                            const values = storage ? JSON.parse(storage) : undefined;
                            return values;
                        });
                    }
                    getNonWrappedValue(key) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            const values = yield this.getStorage();
                            if (!values) {
                                return undefined;
                            }
                            return (_a = values[src /* ValueModesKeys */.dDH.Nonwrapped]) === null || _a === void 0 ? void 0 : _a[key];
                        });
                    }
                    /**
                     * In 2.0.0+, account key params are stored in NonWrapped storage
                     */
                    getAccountKeyParams() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.getNonWrappedValue(src /* StorageKey */.QtK.RootKeyParams);
                        });
                    }
                    hasNonWrappedAccountKeys() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const value = yield this.deviceInterface.getNamespacedKeychainValue(this.identifier);
                            return !(0, utils_dist.isNullOrUndefined)(value);
                        });
                    }
                    hasPasscode() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const wrappedRootKey = yield this.getNonWrappedValue(src /* StorageKey */.QtK.WrappedRootKey);
                            return !(0, utils_dist.isNullOrUndefined)(wrappedRootKey);
                        });
                    }
                    usesKeychain() {
                        return true;
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/StorageReaders/Versions/index.ts
                ; // CONCATENATED MODULE: ./lib/Migrations/StorageReaders/Functions.ts
                function ReaderClassForVersion(version) {
                    /** Sort readers by newest first */
                    const allReaders = Object.values(Versions_namespaceObject).sort((a, b) => {
                        return (0, Version /* compareSemVersions */.D8)(a.version(), b.version()) * -1;
                    });
                    for (const reader of allReaders) {
                        if (reader.version() === version) {
                            return reader;
                        }
                        if ((0, Version /* isRightVersionGreaterThanLeft */.jV)(reader.version(), version)) {
                            return reader;
                        }
                    }
                    throw Error("Cannot find reader for version ".concat(version));
                }
                function CreateReader(version, deviceInterface, identifier, environment) {
                    const readerClass = ReaderClassForVersion(version);
                    return new readerClass(deviceInterface, identifier, environment);
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Base.ts
                var Base_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** A key that was briefly present in Snjs version 2.0.0 but removed in 2.0.1 */
                const LastMigrationTimeStampKey2_0_0 = 'last_migration_timestamp';
                /**
                 * The base migration always runs during app initialization. It is meant as a way
                 * to set up all other migrations.
                 */
                class BaseMigration extends Migration /* Migration */.U {
                    constructor() {
                        super(...arguments);
                        this.didPreRun = false;
                    }
                    preRun() {
                        return Base_awaiter(this, void 0, void 0, function* () {
                            yield this.storeVersionNumber();
                            this.didPreRun = true;
                        });
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.PreparingForLaunch_0, () => Base_awaiter(this, void 0, void 0, function* () {
                            if (yield this.needsKeychainRepair()) {
                                yield this.repairMissingKeychain();
                            }
                            this.markDone();
                        }));
                    }
                    getStoredVersion() {
                        const storageKey = (0, src /* namespacedKey */.xLN)(this.services.identifier, src /* RawStorageKey */.Bq2.SnjsVersion);
                        return this.services.deviceInterface.getRawStorageValue(storageKey);
                    }
                    /**
                     * In Snjs 1.x, and Snjs 2.0.0, version numbers were not stored (as they were introduced
                     * in 2.0.1). Because migrations can now rely on this value, we want to establish a base
                     * value if we do not find it in storage.
                     */
                    storeVersionNumber() {
                        return Base_awaiter(this, void 0, void 0, function* () {
                            const storageKey = (0, src /* namespacedKey */.xLN)(this.services.identifier, src /* RawStorageKey */.Bq2.SnjsVersion);
                            const version = yield this.getStoredVersion();
                            if (!version) {
                                /** Determine if we are 1.0.0 or 2.0.0 */
                                /** If any of these keys exist in raw storage, we are coming from a 1.x architecture */
                                const possibleLegacyKeys = ['migrations', 'ephemeral', 'user', 'cachedThemes', 'syncToken', 'encryptedStorage'];
                                let hasLegacyValue = false;
                                for (const legacyKey of possibleLegacyKeys) {
                                    const value = yield this.services.deviceInterface.getRawStorageValue(legacyKey);
                                    if (value) {
                                        hasLegacyValue = true;
                                        break;
                                    }
                                }
                                if (hasLegacyValue) {
                                    /** Coming from 1.0.0 */
                                    yield this.services.deviceInterface.setRawStorageValue(storageKey, Version /* PreviousSnjsVersion1_0_0 */.DU);
                                }
                                else {
                                    /** Coming from 2.0.0 (which did not store version) OR is brand new application */
                                    const migrationKey = (0, src /* namespacedKey */.xLN)(this.services.identifier, LastMigrationTimeStampKey2_0_0);
                                    const migrationValue = yield this.services.deviceInterface.getRawStorageValue(migrationKey);
                                    const is_2_0_0_application = migrationValue != undefined;
                                    if (is_2_0_0_application) {
                                        yield this.services.deviceInterface.setRawStorageValue(storageKey, Version /* PreviousSnjsVersion2_0_0 */.Oq);
                                        yield this.services.deviceInterface.removeRawStorageValue(LastMigrationTimeStampKey2_0_0);
                                    }
                                    else {
                                        /** Is new application, use current version as not to run any migrations */
                                        yield this.services.deviceInterface.setRawStorageValue(storageKey, Version /* SnjsVersion */["in"]);
                                    }
                                }
                            }
                        });
                    }
                    loadReader() {
                        return Base_awaiter(this, void 0, void 0, function* () {
                            if (this.reader) {
                                return;
                            }
                            const version = yield this.getStoredVersion();
                            this.reader = CreateReader(version, this.services.deviceInterface, this.services.identifier, this.services.environment);
                        });
                    }
                    /**
                     * If the keychain is empty, and the user does not have a passcode,
                     * AND there appear to be stored account key params, this indicates
                     * a launch where the keychain was wiped due to restoring device
                     * from cloud backup which did not include keychain. This typically occurs
                     * on mobile when restoring from iCloud, but we'll also follow this same behavior
                     * on desktop/web as well, since we recently introduced keychain to desktop.
                     *
                     * We must prompt user for account password, and validate based on ability to decrypt
                     * an item. We cannot validate based on storage because 1.x mobile applications did
                     * not use encrypted storage, although we did on 2.x. But instead of having two methods
                     * of validations best to use one that works on both.
                     *
                     * The item is randomly chosen, but for 2.x applications, it must be an items key item
                     * (since only item keys are encrypted directly with account password)
                     */
                    needsKeychainRepair() {
                        return Base_awaiter(this, void 0, void 0, function* () {
                            if (this.memoizedNeedsKeychainRepair != undefined) {
                                return this.memoizedNeedsKeychainRepair;
                            }
                            if (!this.didPreRun) {
                                throw Error('Attempting to access specialized function before prerun');
                            }
                            if (!this.reader) {
                                yield this.loadReader();
                            }
                            const usesKeychain = this.reader.usesKeychain;
                            if (!usesKeychain) {
                                /** Doesn't apply if this version did not use a keychain to begin with */
                                this.memoizedNeedsKeychainRepair = false;
                                return this.memoizedNeedsKeychainRepair;
                            }
                            const rawAccountParams = yield this.reader.getAccountKeyParams();
                            const hasAccountKeyParams = rawAccountParams != undefined;
                            if (!hasAccountKeyParams) {
                                /** Doesn't apply if account is not involved */
                                this.memoizedNeedsKeychainRepair = false;
                                return this.memoizedNeedsKeychainRepair;
                            }
                            const hasPasscode = yield this.reader.hasPasscode();
                            if (hasPasscode) {
                                /** Doesn't apply if using passcode, as keychain would be bypassed in that case */
                                this.memoizedNeedsKeychainRepair = false;
                                return this.memoizedNeedsKeychainRepair;
                            }
                            const accountKeysMissing = !(yield this.reader.hasNonWrappedAccountKeys());
                            if (!accountKeysMissing) {
                                this.memoizedNeedsKeychainRepair = false;
                                return this.memoizedNeedsKeychainRepair;
                            }
                            this.memoizedNeedsKeychainRepair = true;
                            return this.memoizedNeedsKeychainRepair;
                        });
                    }
                    repairMissingKeychain() {
                        return Base_awaiter(this, void 0, void 0, function* () {
                            const rawAccountParams = yield this.reader.getAccountKeyParams();
                            /** Choose an item to decrypt against */
                            const allItems = (yield this.services.deviceInterface.getAllDatabaseEntries(this.services.identifier)).map(p => new dist.EncryptedPayload(p));
                            let itemToDecrypt = allItems.find(item => {
                                return (0, dist.ContentTypeUsesRootKeyEncryption)(item.content_type);
                            });
                            if (!itemToDecrypt) {
                                /** If no root key encrypted item, choose any item */
                                itemToDecrypt = allItems[0];
                            }
                            if (!itemToDecrypt) {
                                /**
                                 * No items to decrypt, user probably cleared their browser data. Only choice is to clear storage
                                 * as any remainign account data is useless without items
                                 */
                                yield this.services.storageService.clearValues();
                                return;
                            }
                            /** Prompt for account password */
                            const challenge = new src /* Challenge */.tv4([new src /* ChallengePrompt */.FEo(src /* ChallengeValidation */.tQn.None, undefined, src /* SessionStrings */.K9E.PasswordInputPlaceholder, true)], src /* ChallengeReason */.Ps8.Custom, false, src /* KeychainRecoveryStrings */.mHn.Title, src /* KeychainRecoveryStrings */.mHn.Text(rawAccountParams.identifier));
                            return new Promise(resolve => {
                                this.services.challengeService.addChallengeObserver(challenge, {
                                    onNonvalidatedSubmit: challengeResponse => Base_awaiter(this, void 0, void 0, function* () {
                                        const password = challengeResponse.values[0].value;
                                        const accountParams = this.services.encryptionService.createKeyParams(rawAccountParams);
                                        const rootKey = yield this.services.encryptionService.computeRootKey(password, accountParams);
                                        /** TS can't detect we returned early above if itemToDecrypt is null */
                                        (0, utils_dist.assert)(itemToDecrypt);
                                        const decryptedPayload = yield this.services.encryptionService.decryptSplitSingle({
                                            usesRootKey: {
                                                items: [itemToDecrypt],
                                                key: rootKey
                                            }
                                        });
                                        if ((0, dist.isErrorDecryptingPayload)(decryptedPayload)) {
                                            /** Wrong password, try again */
                                            this.services.challengeService.setValidationStatusForChallenge(challenge, challengeResponse.values[0], false);
                                        }
                                        else {
                                            /**
                                             * If decryption succeeds, store the generated account key where it is expected.
                                             */
                                            const rawKey = rootKey.getKeychainValue();
                                            yield this.services.deviceInterface.setNamespacedKeychainValue(rawKey, this.services.identifier);
                                            resolve(true);
                                            this.services.challengeService.completeChallenge(challenge);
                                        }
                                    })
                                });
                                void this.services.challengeService.promptForChallengeResponse(challenge);
                            });
                        });
                    }
                }
                /***/ 
            }),
            /***/ 15078: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ U: () => ( /* binding */Migration)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55668);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration {
                    constructor(services) {
                        this.services = services;
                        this.stageHandlers = {};
                        this.registerStageHandlers();
                    }
                    static version() {
                        throw 'Must override migration version';
                    }
                    registerStageHandler(stage, handler) {
                        this.stageHandlers[stage] = handler;
                    }
                    markDone() {
                        var _a;
                        (_a = this.onDoneHandler) === null || _a === void 0 ? void 0 : _a.call(this);
                        this.onDoneHandler = undefined;
                    }
                    promptForPasscodeUntilCorrect(validationCallback) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const challenge = new _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .Challenge */.tv4([new _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ChallengeValidation */.tQn.None)], _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ChallengeReason */.Ps8.Migration, false);
                            return new Promise(resolve => {
                                this.services.challengeService.addChallengeObserver(challenge, {
                                    onNonvalidatedSubmit: challengeResponse => __awaiter(this, void 0, void 0, function* () {
                                        const value = challengeResponse.values[0];
                                        const passcode = value.value;
                                        const valid = yield validationCallback(passcode);
                                        if (valid) {
                                            this.services.challengeService.completeChallenge(challenge);
                                            resolve(passcode);
                                        }
                                        else {
                                            this.services.challengeService.setValidationStatusForChallenge(challenge, value, false);
                                        }
                                    })
                                });
                                void this.services.challengeService.promptForChallengeResponse(challenge);
                            });
                        });
                    }
                    onDone(callback) {
                        this.onDoneHandler = callback;
                    }
                    handleStage(stage) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const handler = this.stageHandlers[stage];
                            if (handler) {
                                yield handler();
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 42798: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    ly: () => ( /* reexport */Migration2_0_15),
                    wg: () => ( /* reexport */Migration2_167_6),
                    aL: () => ( /* reexport */Migration2_168_6),
                    od: () => ( /* reexport */Migration2_202_1),
                    Jb: () => ( /* reexport */Migration2_208_0),
                    Lp: () => ( /* reexport */Migration2_209_0),
                    kK: () => ( /* reexport */Migration2_20_0),
                    qW: () => ( /* reexport */Migration2_36_0),
                    Ni: () => ( /* reexport */Migration2_42_0),
                    pI: () => ( /* reexport */Migration2_7_0),
                    R_: () => ( /* binding */MigrationClasses)
                });
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ./lib/Migrations/Migration.ts
                var Migration = __webpack_require__(15078);
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_0_15.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_0_15 extends Migration /* Migration */.U {
                    static version() {
                        return '2.0.15';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.LoadedDatabase_12, () => __awaiter(this, void 0, void 0, function* () {
                            yield this.createNewDefaultItemsKeyIfNecessary();
                            this.markDone();
                        }));
                    }
                    createNewDefaultItemsKeyIfNecessary() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.services.encryptionService.needsNewRootKeyBasedItemsKey()) {
                                yield this.services.encryptionService.createNewDefaultItemsKey();
                            }
                        });
                    }
                }
                // EXTERNAL MODULE: ../models/dist/index.js
                var dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var dist_src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_7_0.ts
                var _2_7_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_7_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.7.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.FullSyncCompleted_13, () => _2_7_0_awaiter(this, void 0, void 0, function* () {
                            yield this.deleteBatchManagerSingleton();
                            this.markDone();
                        }));
                    }
                    deleteBatchManagerSingleton() {
                        return _2_7_0_awaiter(this, void 0, void 0, function* () {
                            const batchMgrId = 'org.standardnotes.batch-manager';
                            const batchMgrPred = new dist.CompoundPredicate('and', [new dist.Predicate('content_type', '=', dist_src.ContentType.TYPES.Component), new dist.Predicate('identifier', '=', batchMgrId)]);
                            const batchMgrSingleton = this.services.singletonManager.findSingleton(dist_src.ContentType.TYPES.Component, batchMgrPred);
                            if (batchMgrSingleton) {
                                yield this.services.mutator.setItemToBeDeleted(batchMgrSingleton);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_20_0.ts
                var _2_20_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_20_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.20.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.LoadedDatabase_12, () => _2_20_0_awaiter(this, void 0, void 0, function* () {
                            yield this.deleteMfaItems();
                            this.markDone();
                        }));
                    }
                    deleteMfaItems() {
                        return _2_20_0_awaiter(this, void 0, void 0, function* () {
                            const contentType = 'SF|MFA';
                            const items = this.services.itemManager.getItems(contentType);
                            for (const item of items) {
                                this.services.itemManager.removeItemFromMemory(item);
                                yield this.services.storageService.deletePayloadWithUuid(item.uuid);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_36_0.ts
                var _2_36_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_36_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.36.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.LoadedDatabase_12, () => _2_36_0_awaiter(this, void 0, void 0, function* () {
                            yield this.removeServerExtensionsLocally();
                            this.markDone();
                        }));
                    }
                    removeServerExtensionsLocally() {
                        return _2_36_0_awaiter(this, void 0, void 0, function* () {
                            const contentType = 'SF|Extension';
                            const items = this.services.itemManager.getItems(contentType);
                            for (const item of items) {
                                this.services.itemManager.removeItemFromMemory(item);
                                yield this.services.storageService.deletePayloadWithUuid(item.uuid);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_42_0.ts
                var _2_42_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const NoDistractionIdentifier = 'org.standardnotes.theme-no-distraction';
                class Migration2_42_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.42.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.FullSyncCompleted_13, () => _2_42_0_awaiter(this, void 0, void 0, function* () {
                            yield this.deleteNoDistraction();
                            this.markDone();
                        }));
                    }
                    deleteNoDistraction() {
                        return _2_42_0_awaiter(this, void 0, void 0, function* () {
                            const themes = this.services.itemManager.getItems(dist_src.ContentType.TYPES.Theme).filter(theme => {
                                return theme.identifier === NoDistractionIdentifier;
                            });
                            for (const theme of themes) {
                                yield this.services.mutator.setItemToBeDeleted(theme);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_167_6.ts
                var _2_167_6_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_167_6 extends Migration /* Migration */.U {
                    static version() {
                        return '2.167.6';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.Launched_10, () => _2_167_6_awaiter(this, void 0, void 0, function* () {
                            yield this.migrateStorageKeysForDesktopBackups();
                            this.markDone();
                        }));
                    }
                    migrateStorageKeysForDesktopBackups() {
                        return _2_167_6_awaiter(this, void 0, void 0, function* () {
                            const device = this.services.deviceInterface;
                            if (!(0, src /* isDesktopDevice */.dse)(device) || !this.services.backups) {
                                return;
                            }
                            const fileBackupsEnabled = yield device.isLegacyFilesBackupsEnabled();
                            this.services.storageService.setValue(src /* StorageKey */.QtK.FileBackupsEnabled, fileBackupsEnabled);
                            if (fileBackupsEnabled) {
                                const legacyLocation = yield device.getLegacyFilesBackupsLocation();
                                const newLocation = yield device.joinPaths(legacyLocation, yield this.services.backups.prependWorkspacePathForPath(src /* FileBackupsDirectoryName */.aax));
                                yield device.migrateLegacyFileBackupsToNewStructure(newLocation);
                                this.services.storageService.setValue(src /* StorageKey */.QtK.FileBackupsLocation, newLocation);
                            }
                            const wasLegacyDisabled = yield device.wasLegacyTextBackupsExplicitlyDisabled();
                            if (wasLegacyDisabled) {
                                this.services.storageService.setValue(src /* StorageKey */.QtK.TextBackupsEnabled, false);
                            }
                            else {
                                const newTextBackupsLocation = yield device.joinPaths(yield device.getLegacyTextBackupsLocation(), yield this.services.backups.prependWorkspacePathForPath(src /* TextBackupsDirectoryName */.OU3));
                                this.services.storageService.setValue(src /* StorageKey */.QtK.TextBackupsLocation, newTextBackupsLocation);
                                this.services.storageService.setValue(src /* StorageKey */.QtK.TextBackupsEnabled, true);
                            }
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_168_6.ts
                var _2_168_6_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_168_6 extends Migration /* Migration */.U {
                    static version() {
                        return '2.168.6';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.Launched_10, () => _2_168_6_awaiter(this, void 0, void 0, function* () {
                            yield this.migrateErroneousWindowsPathFromPreviousMigration();
                            this.markDone();
                        }));
                    }
                    migrateErroneousWindowsPathFromPreviousMigration() {
                        return _2_168_6_awaiter(this, void 0, void 0, function* () {
                            const device = this.services.deviceInterface;
                            if (!(0, src /* isDesktopDevice */.dse)(device) || !this.services.backups) {
                                return;
                            }
                            if (this.services.platform !== dist.Platform.WindowsDesktop) {
                                return;
                            }
                            const textBackupsLocation = this.services.backups.getTextBackupsLocation();
                            if (textBackupsLocation) {
                                const parts = textBackupsLocation.split('/');
                                if (parts.length > 1) {
                                    const newLocation = yield device.joinPaths(...parts);
                                    this.services.storageService.setValue(src /* StorageKey */.QtK.TextBackupsLocation, newLocation);
                                }
                            }
                            const fileBackupsLocation = this.services.backups.getFilesBackupsLocation();
                            if (fileBackupsLocation) {
                                const parts = fileBackupsLocation.split('/');
                                if (parts.length > 1) {
                                    const newLocation = yield device.joinPaths(...parts);
                                    this.services.storageService.setValue(src /* StorageKey */.QtK.FileBackupsLocation, newLocation);
                                }
                            }
                            const plaintextBackupsLocation = this.services.backups.getPlaintextBackupsLocation();
                            if (plaintextBackupsLocation) {
                                const parts = plaintextBackupsLocation.split('/');
                                if (parts.length > 1) {
                                    const newLocation = yield device.joinPaths(...parts);
                                    this.services.storageService.setValue(src /* StorageKey */.QtK.PlaintextBackupsLocation, newLocation);
                                }
                            }
                        });
                    }
                }
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ../features/dist/index.js
                var features_dist = __webpack_require__(80215);
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_202_1.ts
                var _2_202_1_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_202_1 extends Migration /* Migration */.U {
                    static version() {
                        return '2.202.1';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.FullSyncCompleted_13, () => _2_202_1_awaiter(this, void 0, void 0, function* () {
                            yield this.migrateComponentDataToUserPreferences();
                            yield this.migrateActiveComponentsToUserPreferences();
                            this.markDone();
                        }));
                    }
                    migrateComponentDataToUserPreferences() {
                        var _a, _b;
                        return _2_202_1_awaiter(this, void 0, void 0, function* () {
                            const components = this.services.itemManager.getItems(dist_src.ContentType.TYPES.Component);
                            if (components.length === 0) {
                                return;
                            }
                            const mutablePreferencesValue = (0, utils_dist.Copy)((_a = this.services.preferences.getValue(dist.PrefKey.ComponentPreferences)) !== null && _a !== void 0 ? _a : {});
                            for (const component of components) {
                                const componentData = component.legacyComponentData;
                                if (!componentData) {
                                    continue;
                                }
                                if (Object.keys(componentData).length === 0) {
                                    continue;
                                }
                                const preferencesLookupKey = (0, features_dist.FindNativeFeature)(component.identifier) ? component.identifier : component.uuid;
                                const componentPreferences = (_b = mutablePreferencesValue[preferencesLookupKey]) !== null && _b !== void 0 ? _b : {};
                                for (const key of Object.keys(componentData)) {
                                    componentPreferences[key] = componentData[key];
                                }
                                mutablePreferencesValue[preferencesLookupKey] = componentPreferences;
                            }
                            yield this.services.preferences.setValueDetached(dist.PrefKey.ComponentPreferences, mutablePreferencesValue);
                        });
                    }
                    migrateActiveComponentsToUserPreferences() {
                        return _2_202_1_awaiter(this, void 0, void 0, function* () {
                            const allActiveitems = [...this.services.itemManager.getItems(dist_src.ContentType.TYPES.Component), ...this.services.itemManager.getItems(dist_src.ContentType.TYPES.Theme)].filter(component => component.legacyActive);
                            if (allActiveitems.length === 0) {
                                return;
                            }
                            const activeThemes = allActiveitems.filter(component => component.isTheme());
                            const activeComponents = allActiveitems.filter(component => !component.isTheme());
                            yield this.services.preferences.setValueDetached(dist.PrefKey.DEPRECATED_ActiveThemes, (0, utils_dist.Uuids)(activeThemes));
                            yield this.services.preferences.setValueDetached(dist.PrefKey.ActiveComponents, (0, utils_dist.Uuids)(activeComponents));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_208_0.ts
                var _2_208_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_208_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.208.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.FullSyncCompleted_13, () => _2_208_0_awaiter(this, void 0, void 0, function* () {
                            yield this.migrateSyncedPreferencesToLocal();
                            this.markDone();
                        }));
                    }
                    migrateSyncedPreferencesToLocal() {
                        return _2_208_0_awaiter(this, void 0, void 0, function* () {
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.ActiveThemes, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_ActiveThemes, dist.PrefDefaults[dist.PrefKey.DEPRECATED_ActiveThemes]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.UseSystemColorScheme, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_UseSystemColorScheme, dist.PrefDefaults[dist.PrefKey.DEPRECATED_UseSystemColorScheme]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.AutoLightThemeIdentifier, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_AutoLightThemeIdentifier, dist.PrefDefaults[dist.PrefKey.DEPRECATED_AutoLightThemeIdentifier]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.AutoDarkThemeIdentifier, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_AutoDarkThemeIdentifier, dist.PrefDefaults[dist.PrefKey.DEPRECATED_AutoDarkThemeIdentifier]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.UseTranslucentUI, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_UseTranslucentUI, dist.PrefDefaults[dist.PrefKey.DEPRECATED_UseTranslucentUI]));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/2_209_0.ts
                var _2_209_0_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class Migration2_209_0 extends Migration /* Migration */.U {
                    static version() {
                        return '2.209.0';
                    }
                    registerStageHandlers() {
                        this.registerStageHandler(src /* ApplicationStage */.Ugm.FullSyncCompleted_13, () => _2_209_0_awaiter(this, void 0, void 0, function* () {
                            yield this.migrateSyncedPreferencesToLocal();
                            this.markDone();
                        }));
                    }
                    migrateSyncedPreferencesToLocal() {
                        return _2_209_0_awaiter(this, void 0, void 0, function* () {
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.EditorMonospaceEnabled, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_EditorMonospaceEnabled, dist.PrefDefaults[src /* LocalPrefKey */.dH$.EditorMonospaceEnabled]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.EditorFontSize, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_EditorFontSize, dist.PrefDefaults[src /* LocalPrefKey */.dH$.EditorFontSize]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.EditorLineWidth, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_EditorLineWidth, dist.PrefDefaults[src /* LocalPrefKey */.dH$.EditorLineWidth]));
                            this.services.preferences.setLocalValue(src /* LocalPrefKey */.dH$.EditorLineHeight, this.services.preferences.getValue(dist.PrefKey.DEPRECATED_EditorLineHeight, dist.PrefDefaults[src /* LocalPrefKey */.dH$.EditorLineHeight]));
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Migrations/Versions/index.ts
                const MigrationClasses = [Migration2_0_15, Migration2_7_0, Migration2_20_0, Migration2_36_0, Migration2_42_0, Migration2_167_6, Migration2_168_6, Migration2_202_1, Migration2_208_0, Migration2_209_0];
                /***/ 
            }),
            /***/ 90693: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Jb: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.Jb),
                    /* harmony export */ Lp: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.Lp),
                    /* harmony export */ Ni: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.Ni),
                    /* harmony export */ R_: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.R_),
                    /* harmony export */ _r: () => ( /* reexport safe */_Base__WEBPACK_IMPORTED_MODULE_0__._),
                    /* harmony export */ aL: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.aL),
                    /* harmony export */ kK: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.kK),
                    /* harmony export */ ly: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.ly),
                    /* harmony export */ od: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.od),
                    /* harmony export */ pI: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.pI),
                    /* harmony export */ qW: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.qW),
                    /* harmony export */ wg: () => ( /* reexport safe */_Versions__WEBPACK_IMPORTED_MODULE_1__.wg)
                    /* harmony export */ 
                });
                /* harmony import */ var _Base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58386);
                /* harmony import */ var _Versions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42798);
                /***/ 
            }),
            /***/ 19820: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ b: () => ( /* binding */ActionsService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The Actions Service allows clients to interact with action-based extensions.
                 * Action-based extensions are mostly RESTful actions that can push a local value or
                 * retrieve a remote value and act on it accordingly.
                 * There are 4 action types:
                 * `get`: performs a GET request on an endpoint to retrieve an item value, and merges the
                 *      value onto the local item value. For example, you can GET an item's older revision
                 *      value and replace the current value with the revision.
                 * `render`: performs a GET request, and displays the result in the UI. This action does not
                 *         affect data unless action is taken explicitely in the UI after the data is presented.
                 * `show`: opens the action's URL in a browser.
                 * `post`: sends an item's data to a remote service. This is used for example by Listed
                 *       to allow publishing a note to a user's blog.
                 */
                class ActionsService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(itemManager, alertService, device, httpService, encryptionService, challengeService, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.alertService = alertService;
                        this.device = device;
                        this.httpService = httpService;
                        this.encryptionService = encryptionService;
                        this.challengeService = challengeService;
                        this.internalEventBus = internalEventBus;
                        this.previousPasswords = [];
                        this.payloadRequestHandlers = [];
                        this.previousPasswords = [];
                    }
                    deinit() {
                        ;
                        this.itemManager = undefined;
                        this.alertService = undefined;
                        this.device = undefined;
                        this.httpService = undefined;
                        this.challengeService = undefined;
                        this.encryptionService = undefined;
                        this.payloadRequestHandlers.length = 0;
                        this.previousPasswords.length = 0;
                        super.deinit();
                    }
                    addPayloadRequestHandler(handler) {
                        this.payloadRequestHandlers.push(handler);
                        return () => {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.removeFromArray)(this.payloadRequestHandlers, handler);
                        };
                    }
                    getExtensions() {
                        const extensionItems = this.itemManager.getItems(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.ContentType.TYPES.ActionsExtension);
                        const excludingListed = extensionItems.filter(extension => !extension.isListedExtension);
                        return excludingListed;
                    }
                    extensionsInContextOfItem(item) {
                        return this.getExtensions().filter(ext => {
                            return ext.supported_types.includes(item.content_type) || ext.actionsWithContextForItem(item).length > 0;
                        });
                    }
                    /**
                     * Loads an extension in the context of a certain item.
                     * The server then has the chance to respond with actions that are
                     * relevant just to this item. The response extension is not saved,
                     * just displayed as a one-time thing.
                     */
                    loadExtensionInContextOfItem(extension, item) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const params = {
                                content_type: item.content_type,
                                item_uuid: item.uuid
                            };
                            const response = yield this.httpService.getAbsolute(extension.url, params).catch(response => {
                                console.error('Error loading extension', response);
                                return undefined;
                            });
                            if (!response) {
                                return;
                            }
                            const description = response.description || extension.description;
                            const supported_types = response.supported_types || extension.supported_types;
                            const actions = response.actions || [];
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ActionsExtensionMutator(extension, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.MutationType.UpdateUserTimestamps);
                            mutator.deprecation = response.deprecation;
                            mutator.description = description;
                            mutator.supported_types = supported_types;
                            mutator.actions = actions;
                            const payloadResult = mutator.getResult();
                            return (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateDecryptedItemFromPayload)(payloadResult);
                        });
                    }
                    runAction(action, item) {
                        return __awaiter(this, void 0, void 0, function* () {
                            let result;
                            switch (action.verb) {
                                case 'render':
                                    result = yield this.handleRenderAction(action);
                                    break;
                                case 'show':
                                    result = this.handleShowAction(action);
                                    break;
                                case 'post':
                                    result = yield this.handlePostAction(action, item);
                                    break;
                                default:
                                    break;
                            }
                            return result;
                        });
                    }
                    handleRenderAction(action) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.httpService.getAbsolute(action.url).then(response => __awaiter(this, void 0, void 0, function* () {
                                const payload = yield this.payloadByDecryptingResponse(response);
                                if (payload) {
                                    const item = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateDecryptedItemFromPayload)(payload);
                                    return Object.assign(Object.assign({}, response), {
                                        item
                                    });
                                }
                                else {
                                    return undefined;
                                }
                            })).catch(response => {
                                const error = response && response.error || {
                                    message: 'An issue occurred while processing this action. Please try again.'
                                };
                                void this.alertService.alert(error.message);
                                return {
                                    error
                                };
                            });
                            return response;
                        });
                    }
                    payloadByDecryptingResponse(response, rootKey) {
                        let triedPasswords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!response.item || response.item.deleted || response.item.content == undefined) {
                                return undefined;
                            }
                            const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.EncryptedPayload(response.item);
                            if (!payload.enc_item_key) {
                                void this.alertService.alert('This revision is missing its key and cannot be recovered.');
                                return;
                            }
                            let decryptedPayload = yield this.encryptionService.decryptSplitSingle({
                                usesItemsKeyWithKeyLookup: {
                                    items: [payload]
                                }
                            });
                            if (!(0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isErrorDecryptingPayload)(decryptedPayload)) {
                                return decryptedPayload;
                            }
                            if (rootKey) {
                                decryptedPayload = yield this.encryptionService.decryptSplitSingle({
                                    usesRootKey: {
                                        items: [payload],
                                        key: rootKey
                                    }
                                });
                                if (!(0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isErrorDecryptingPayload)(decryptedPayload)) {
                                    return decryptedPayload;
                                }
                            }
                            for (const itemsKey of this.itemManager.getDisplayableItemsKeys()) {
                                const decryptedPayload = yield this.encryptionService.decryptSplitSingle({
                                    usesItemsKey: {
                                        items: [payload],
                                        key: itemsKey
                                    }
                                });
                                if (!(0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isErrorDecryptingPayload)(decryptedPayload)) {
                                    return decryptedPayload;
                                }
                            }
                            const keyParamsData = response.keyParams || response.auth_params;
                            if (!keyParamsData) {
                                /**
                                 * In some cases revisions were missing auth params.
                                 * Instruct the user to email us to get this remedied.
                                 */
                                void this.alertService.alert('We were unable to decrypt this revision using your current keys, ' + 'and this revision is missing metadata that would allow us to try different ' + 'keys to decrypt it. This can likely be fixed with some manual intervention. ' + 'Please email help@standardnotes.com for assistance.');
                                return undefined;
                            }
                            const keyParams = this.encryptionService.createKeyParams(keyParamsData);
                            /* Try previous passwords */
                            for (const passwordCandidate of this.previousPasswords) {
                                if (triedPasswords.includes(passwordCandidate)) {
                                    continue;
                                }
                                triedPasswords.push(passwordCandidate);
                                const key = yield this.encryptionService.computeRootKey(passwordCandidate, keyParams);
                                if (!key) {
                                    continue;
                                }
                                const nestedResponse = yield this.payloadByDecryptingResponse(response, key, triedPasswords);
                                if (nestedResponse) {
                                    return nestedResponse;
                                }
                            }
                            /** Prompt for other passwords */
                            const password = yield this.promptForLegacyPassword();
                            if (!password) {
                                return undefined;
                            }
                            if (this.previousPasswords.includes(password)) {
                                return undefined;
                            }
                            this.previousPasswords.push(password);
                            return this.payloadByDecryptingResponse(response, rootKey);
                        });
                    }
                    promptForLegacyPassword() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const challenge = new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4([new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.None, 'Previous Password', undefined, true)], _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.Custom, true, 'Unable to find key for revision. Please enter the account password you may have used at the time of the revision.');
                            const response = yield this.challengeService.promptForChallengeResponse(challenge);
                            return response === null || response === void 0 ? void 0 : response.getDefaultValue().value;
                        });
                    }
                    handlePostAction(action, item) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const decrypted = action.access_type === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ActionAccessType.Decrypted;
                            const itemParams = yield this.outgoingPayloadForItem(item, decrypted);
                            const params = {
                                items: [itemParams]
                            };
                            return this.httpService.postAbsolute(action.url, params).then(response => {
                                return response;
                            }).catch(response => {
                                console.error('Action error response:', response);
                                void this.alertService.alert('An issue occurred while processing this action. Please try again.');
                                return response;
                            });
                        });
                    }
                    handleShowAction(action) {
                        void this.device.openUrl(action.url);
                        return {};
                    }
                    outgoingPayloadForItem(item) {
                        let decrypted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            const payloadFromHandler = this.getPayloadFromRequestHandlers(item.uuid);
                            if (payloadFromHandler) {
                                return payloadFromHandler;
                            }
                            if (decrypted) {
                                return item.payload.ejected();
                            }
                            const encrypted = yield this.encryptionService.encryptSplitSingle({
                                usesItemsKeyWithKeyLookup: {
                                    items: [item.payload]
                                }
                            });
                            return (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateEncryptedBackupFileContextPayload)(encrypted);
                        });
                    }
                    getPayloadFromRequestHandlers(uuid) {
                        for (const handler of this.payloadRequestHandlers) {
                            const payload = handler(uuid);
                            if (payload) {
                                return payload;
                            }
                        }
                        return undefined;
                    }
                }
                /***/ 
            }),
            /***/ 54911: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ A: () => ( /* binding */LegacyApiService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95658);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var _Paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98361);
                /* harmony import */ var _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52450);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** Legacy api version field to be specified in params when calling v0 APIs. */
                const V0_API_VERSION = '20240226';
                class LegacyApiService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .AbstractService */.wcN {
                    constructor(httpService, storageService, host, inMemoryStore, crypto, sessionStorageMapper, legacySessionStorageMapper, internalEventBus) {
                        super(internalEventBus);
                        this.httpService = httpService;
                        this.storageService = storageService;
                        this.host = host;
                        this.inMemoryStore = inMemoryStore;
                        this.crypto = crypto;
                        this.sessionStorageMapper = sessionStorageMapper;
                        this.legacySessionStorageMapper = legacySessionStorageMapper;
                        this.internalEventBus = internalEventBus;
                        this.authenticating = false;
                        this.changing = false;
                        this.refreshingSession = false;
                        this.session = null;
                    }
                    deinit() {
                        ;
                        this.httpService = undefined;
                        this.storageService = undefined;
                        this.invalidSessionObserver = undefined;
                        this.session = null;
                        super.deinit();
                    }
                    setUser(user) {
                        this.user = user;
                    }
                    /**
                     * When a we receive a 401 error from the server, we'll notify the observer.
                     * Note that this applies only to sessions that are totally invalid. Sessions that
                     * are expired but can be renewed are still considered to be valid. In those cases,
                     * the server response is 498.
                     * If the session has been revoked, then the observer will have its first
                     * argument set to true.
                     */
                    setInvalidSessionObserver(observer) {
                        this.invalidSessionObserver = observer;
                    }
                    loadHost() {
                        const storedValue = this.storageService.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.ServerHost);
                        this.host = storedValue || this.host;
                        return this.host;
                    }
                    setHost(host) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.host = host;
                            this.storageService.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.ServerHost, host);
                        });
                    }
                    getHost() {
                        return this.host;
                    }
                    getFilesHost() {
                        if (!this.filesHost) {
                            throw Error('Attempting to access undefined filesHost');
                        }
                        return this.filesHost;
                    }
                    setSession(session) {
                        let persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        this.session = session;
                        if (persist) {
                            let sessionProjection;
                            if (session instanceof _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.Session) {
                                sessionProjection = this.sessionStorageMapper.toProjection(session);
                            }
                            else {
                                sessionProjection = this.legacySessionStorageMapper.toProjection(session);
                            }
                            this.storageService.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.Session, sessionProjection);
                        }
                    }
                    getSession() {
                        return this.session;
                    }
                    get apiVersion() {
                        return V0_API_VERSION;
                    }
                    params(inParams) {
                        const params = Object.assign(Object.assign({}, inParams), {
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.ApiVersion]: this.apiVersion
                        });
                        return params;
                    }
                    createErrorResponse(message, status, tag) {
                        return {
                            data: {
                                error: {
                                    message,
                                    tag
                                }
                            },
                            status: status !== null && status !== void 0 ? status : _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest
                        };
                    }
                    errorResponseWithFallbackMessage(response, message) {
                        if (response.data.error && !response.data.error.message) {
                            response.data.error.message = message;
                        }
                        return response;
                    }
                    processMetaObject(meta) {
                        var _a, _b;
                        if (meta.auth && meta.auth.userUuid && meta.auth.roles) {
                            void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .ApiServiceEvent */.Sf$.MetaReceived, {
                                userUuid: meta.auth.userUuid,
                                userRoles: meta.auth.roles
                            });
                        }
                        if ((_a = meta.server) === null || _a === void 0 ? void 0 : _a.filesServerUrl) {
                            this.filesHost = (_b = meta.server) === null || _b === void 0 ? void 0 : _b.filesServerUrl;
                        }
                    }
                    processSuccessResponseForMetaBody(response) {
                        if (response.meta) {
                            this.processMetaObject(response.meta);
                        }
                    }
                    request(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            try {
                                const response = yield this.httpService.runHttp(params);
                                if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                    return this.errorResponseWithFallbackMessage(response, params.fallbackErrorMessage);
                                }
                                else {
                                    this.processSuccessResponseForMetaBody(response);
                                    return response;
                                }
                            }
                            catch (errorResponse) {
                                return this.errorResponseWithFallbackMessage(errorResponse, params.fallbackErrorMessage);
                            }
                        });
                    }
                    /**
                     * @param mfaCode     The mfa challenge response value.
                     */
                    getAccountKeyParams(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const codeVerifier = this.crypto.generateRandomKey(256);
                            this.inMemoryStore.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.CodeVerifier, codeVerifier);
                            const codeChallenge = this.crypto.base64URLEncode(yield this.crypto.sha256(codeVerifier));
                            const params = this.params({
                                email: dto.email,
                                code_challenge: codeChallenge
                            });
                            if (dto.mfaCode !== undefined) {
                                params['mfa_code'] = dto.mfaCode;
                            }
                            if (dto.authenticatorResponse) {
                                params.authenticator_response = dto.authenticatorResponse;
                            }
                            return this.request({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v2.keyParams),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_INVALID_LOGIN */.VpG,
                                params,
                                /** A session is optional here, if valid, endpoint bypasses 2FA and returns additional params */
                                authentication: this.getSessionAccessToken()
                            });
                        });
                    }
                    signIn(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.authenticating) {
                                return this.createErrorResponse(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_LOGIN_IN_PROGRESS */.TYJ, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest);
                            }
                            this.authenticating = true;
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v2.signIn);
                            const params = this.params({
                                email: dto.email,
                                password: dto.serverPassword,
                                ephemeral: dto.ephemeral,
                                code_verifier: this.inMemoryStore.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.CodeVerifier),
                                hvm_token: dto.hvmToken
                            });
                            const response = yield this.request({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                params,
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_INVALID_LOGIN */.VpG
                            });
                            this.authenticating = false;
                            this.inMemoryStore.removeValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.CodeVerifier);
                            return response;
                        });
                    }
                    signOut() {
                        return this.httpService.post(_Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.signOut, undefined, {
                            authentication: this.getSessionAccessToken()
                        });
                    }
                    changeCredentials(parameters) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.changing) {
                                return this.createErrorResponse(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS */.WLG, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest);
                            }
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            this.changing = true;
                            const path = _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.changeCredentials(parameters.userUuid);
                            const params = this.params(Object.assign({
                                current_password: parameters.currentServerPassword,
                                new_password: parameters.newServerPassword,
                                new_email: parameters.newEmail
                            }, parameters.newKeyParams.getPortableValue()));
                            const response = yield this.httpService.put(path, params, {
                                authentication: this.getSessionAccessToken()
                            });
                            this.changing = false;
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return this.errorResponseWithFallbackMessage(response, _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL */.Z15);
                            }
                            this.processSuccessResponseForMetaBody(response);
                            return response;
                        });
                    }
                    sync(payloads, lastSyncToken, paginationToken, limit, sharedVaultUuids) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            const request = this.getSyncHttpRequest(payloads, lastSyncToken, paginationToken, limit, sharedVaultUuids);
                            const response = yield this.httpService.runHttp(request);
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                this.preprocessAuthenticatedErrorResponse(response);
                                return this.errorResponseWithFallbackMessage(response, _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_SYNC_FAIL */.gEn);
                            }
                            this.processSuccessResponseForMetaBody(response);
                            return response;
                        });
                    }
                    getSyncHttpRequest(payloads, lastSyncToken, paginationToken, limit, sharedVaultUuids) {
                        const path = _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.sync;
                        const params = this.params({
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.SyncPayloads]: payloads,
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.LastSyncToken]: lastSyncToken,
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.PaginationToken]: paginationToken,
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.SyncDlLimit]: limit,
                            [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ApiEndpointParam.SharedVaultUuids]: sharedVaultUuids
                        });
                        return {
                            url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, path),
                            params,
                            verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                            authentication: this.getSessionAccessToken()
                        };
                    }
                    /**
                     * @deprecated
                     *
                     * This function should be replaced with @standardnotes/api's `HttpService::refreshSession` function.
                     */
                    deprecatedRefreshSessionOnlyUsedInE2eTests() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            this.refreshingSession = true;
                            const session = this.session;
                            const params = this.params({
                                access_token: session.accessToken.value,
                                refresh_token: session.refreshToken.value
                            });
                            const response = yield this.httpService.post(_Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.refreshSession, params).then(response => __awaiter(this, void 0, void 0, function* () {
                                if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response) || !response.data.session) {
                                    return response;
                                }
                                const accessTokenOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.SessionToken.create(response.data.session.access_token, response.data.session.access_expiration);
                                if (accessTokenOrError.isFailed()) {
                                    return null;
                                }
                                const accessToken = accessTokenOrError.getValue();
                                const refreshTokenOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.SessionToken.create(response.data.session.refresh_token, response.data.session.refresh_expiration);
                                if (refreshTokenOrError.isFailed()) {
                                    return null;
                                }
                                const refreshToken = refreshTokenOrError.getValue();
                                const sessionOrError = _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.Session.create(accessToken, refreshToken, response.data.session.readonly_access);
                                if (sessionOrError.isFailed()) {
                                    return null;
                                }
                                const session = sessionOrError.getValue();
                                this.session = session;
                                this.setSession(session);
                                this.processSuccessResponseForMetaBody(response);
                                yield this.notifyEventSync(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .ApiServiceEvent */.Sf$.SessionRefreshed, {
                                    session
                                });
                                return response;
                            }));
                            this.refreshingSession = false;
                            if (response === null) {
                                return this.createErrorResponse(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_INVALID_SESSION */.aXB, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest);
                            }
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                this.preprocessAuthenticatedErrorResponse(response);
                                return this.errorResponseWithFallbackMessage(response, _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL */.lO_);
                            }
                            return response;
                        });
                    }
                    getSessionsList() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            const path = _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.sessions;
                            const response = yield this.httpService.get(path, {}, {
                                authentication: this.getSessionAccessToken()
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                this.preprocessAuthenticatedErrorResponse(response);
                                return this.errorResponseWithFallbackMessage(response, _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_SYNC_FAIL */.gEn);
                            }
                            this.processSuccessResponseForMetaBody(response);
                            return response;
                        });
                    }
                    deleteSession(sessionId) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            const path = _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.session(sessionId);
                            const response = yield this.httpService.delete(path, {
                                uuid: sessionId
                            }, {
                                authentication: this.getSessionAccessToken()
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                this.preprocessAuthenticatedErrorResponse(response);
                                return this.errorResponseWithFallbackMessage(response, _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_SYNC_FAIL */.gEn);
                            }
                            this.processSuccessResponseForMetaBody(response);
                            return response;
                        });
                    }
                    tokenRefreshableRequest(params) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const preprocessingError = this.preprocessingError();
                            if (preprocessingError) {
                                return preprocessingError;
                            }
                            const response = yield this.httpService.runHttp(params);
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                this.preprocessAuthenticatedErrorResponse(response);
                                return this.errorResponseWithFallbackMessage(response, params.fallbackErrorMessage);
                            }
                            this.processSuccessResponseForMetaBody(response);
                            return response;
                        });
                    }
                    listSettings(userUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.settings(userUuid)),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_GET_SETTINGS */.Zq2,
                                authentication: this.getSessionAccessToken()
                            });
                        });
                    }
                    updateSetting(userUuid, settingName, settingValue, sensitive) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const params = {
                                name: settingName,
                                value: settingValue,
                                sensitive: sensitive
                            };
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Put,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.settings(userUuid)),
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_UPDATE_SETTINGS */.oBV,
                                params
                            });
                        });
                    }
                    getSetting(userUuid, settingName) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.setting(userUuid, settingName.toLowerCase())),
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_GET_SETTINGS */.Zq2
                            });
                        });
                    }
                    getSubscriptionSetting(userUuid, settingName) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.subscriptionSetting(userUuid, settingName.toLowerCase())),
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_GET_SETTINGS */.Zq2
                            });
                        });
                    }
                    updateSubscriptionSetting(userUuid, settingName, settingValue, sensitive) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const params = {
                                name: settingName,
                                value: settingValue,
                                sensitive: sensitive
                            };
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Put,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.subscriptionSettings(userUuid)),
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_UPDATE_SETTINGS */.oBV,
                                params
                            });
                        });
                    }
                    deleteSetting(userUuid, settingName) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Delete,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.setting(userUuid, settingName)),
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_UPDATE_SETTINGS */.oBV
                            });
                        });
                    }
                    downloadFeatureUrl(url) {
                        return this.request({
                            verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                            url,
                            external: true,
                            fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_INVALID_LOGIN */.VpG
                        });
                    }
                    getNewSubscriptionToken() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.subscriptionTokens);
                            const response = yield this.request({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_ACCESS_PURCHASE */.gQA
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return undefined;
                            }
                            return response.data.token;
                        });
                    }
                    downloadOfflineFeaturesFromRepo(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            try {
                                const featuresUrl = dto.repo.offlineFeaturesUrl;
                                const extensionKey = dto.repo.offlineKey;
                                if (!featuresUrl || !extensionKey) {
                                    throw Error('Cannot download offline repo without url and offlineKEy');
                                }
                                const TRUSTED_FEATURE_HOSTS = ['api.standardnotes.com', 'localhost'];
                                const { hostname } = new URL(featuresUrl);
                                if (!TRUSTED_FEATURE_HOSTS.includes(hostname)) {
                                    return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError("The offline features host ".concat(hostname, " is not in the trusted allowlist."));
                                }
                                const response = yield this.request({
                                    verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                    url: featuresUrl,
                                    fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_OFFLINE_FEATURES */.WZ6,
                                    customHeaders: [{
                                            key: 'x-offline-token',
                                            value: extensionKey
                                        }]
                                });
                                if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                    return _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError.FromNetworkError(response);
                                }
                                const data = response.data;
                                return {
                                    features: (data === null || data === void 0 ? void 0 : data.features) || [],
                                    roles: (data === null || data === void 0 ? void 0 : data.roles) || []
                                };
                            }
                            catch (_a) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_OFFLINE_ACTIVATION */.iMd);
                            }
                        });
                    }
                    registerForListedAccount() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.user) {
                                throw Error('Cannot register for Listed without user account.');
                            }
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.listedRegistration(this.user.uuid)),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_LISTED_REGISTRATION */.EaW,
                                authentication: this.getSessionAccessToken()
                            });
                        });
                    }
                    createUserFileValetToken(remoteIdentifier, operation, unencryptedFileSize) {
                        var _a, _b, _c, _d, _e, _f;
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.createUserFileValetToken);
                            const params = {
                                operation,
                                resources: [{
                                        remoteIdentifier,
                                        unencryptedFileSize: unencryptedFileSize || 0
                                    }]
                            };
                            const response = yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url: url,
                                authentication: this.getSessionAccessToken(),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_FAILED_CREATE_FILE_TOKEN */.qIx,
                                params
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message);
                            }
                            if (!((_c = response.data) === null || _c === void 0 ? void 0 : _c.success)) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError((_d = response.data) === null || _d === void 0 ? void 0 : _d.reason, undefined, (_e = response.data) === null || _e === void 0 ? void 0 : _e.reason);
                            }
                            return (_f = response.data) === null || _f === void 0 ? void 0 : _f.valetToken;
                        });
                    }
                    startUploadSession(valetToken, ownershipType) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), ownershipType === 'user' ? _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.startUploadSession : _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.startSharedVaultUploadSession);
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }],
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedStartUploadSession
                            });
                        });
                    }
                    deleteFile(valetToken, ownershipType) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), ownershipType === 'user' ? _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.deleteFile : _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.deleteSharedVaultFile);
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Delete,
                                url,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }],
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedDeleteFile
                            });
                        });
                    }
                    uploadFileBytes(valetToken, ownershipType, chunkId, encryptedBytes) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (chunkId === 0) {
                                throw Error('chunkId must start with 1');
                            }
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), ownershipType === 'user' ? _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.uploadFileChunk : _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.uploadSharedVaultFileChunk);
                            const response = yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                rawBytes: encryptedBytes,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }, {
                                        key: 'x-chunk-id',
                                        value: chunkId.toString()
                                    }, {
                                        key: 'Content-Type',
                                        value: 'application/octet-stream'
                                    }],
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedUploadFileChunk
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return false;
                            }
                            return response.data.success;
                        });
                    }
                    closeUploadSession(valetToken, ownershipType) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), ownershipType === 'user' ? _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.closeUploadSession : _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.closeSharedVaultUploadSession);
                            const response = yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }],
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedCloseUploadSession
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return false;
                            }
                            return response.data.success;
                        });
                    }
                    moveFile(valetToken) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.moveFile);
                            const response = yield this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }],
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedCloseUploadSession
                            });
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return false;
                            }
                            return response.data.success;
                        });
                    }
                    getFilesDownloadUrl(ownershipType) {
                        if (ownershipType === 'user') {
                            return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.downloadFileChunk);
                        }
                        else if (ownershipType === 'shared-vault') {
                            return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.getFilesHost(), _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.downloadSharedVaultFileChunk);
                        }
                        else {
                            throw Error('Invalid download type');
                        }
                    }
                    downloadFile(_ref) {
                        let { file, chunkIndex, valetToken, ownershipType, contentRangeStart, onBytesReceived } = _ref;
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function* () {
                            const url = this.getFilesDownloadUrl(ownershipType);
                            const pullChunkSize = file.encryptedChunkSizes[chunkIndex];
                            const request = {
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                url,
                                customHeaders: [{
                                        key: 'x-valet-token',
                                        value: valetToken
                                    }, {
                                        key: 'x-chunk-size',
                                        value: pullChunkSize.toString()
                                    }, {
                                        key: 'range',
                                        value: "bytes=".concat(contentRangeStart, "-")
                                    }],
                                responseType: 'arraybuffer'
                            };
                            const response = yield this.tokenRefreshableRequest(Object.assign(Object.assign({}, request), {
                                fallbackErrorMessage: _Lib_Strings__WEBPACK_IMPORTED_MODULE_5__ /* .Strings */.e.Network.Files.FailedDownloadFileChunk
                            }));
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.isErrorResponse)(response)) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message);
                            }
                            const contentRangeHeader = response.headers.get('content-range');
                            if (!contentRangeHeader) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError('Could not obtain content-range header while downloading file chunk');
                            }
                            const matches = contentRangeHeader.match(/(^[a-zA-Z][\w]*)\s+(\d+)\s?-\s?(\d+)?\s?\/?\s?(\d+|\*)?/);
                            if (!matches || matches.length !== 5) {
                                return new _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ClientDisplayableError('Malformed content-range header in response when downloading file chunk');
                            }
                            const rangeStart = +matches[2];
                            const rangeEnd = +matches[3];
                            const totalSize = +matches[4];
                            const bytesReceived = new Uint8Array(response.data);
                            yield onBytesReceived(bytesReceived);
                            if (rangeEnd < totalSize - 1) {
                                return this.downloadFile({
                                    file,
                                    chunkIndex: ++chunkIndex,
                                    valetToken,
                                    ownershipType,
                                    contentRangeStart: rangeStart + pullChunkSize,
                                    onBytesReceived
                                });
                            }
                            return undefined;
                        });
                    }
                    checkIntegrity(integrityPayloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Post,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.checkIntegrity),
                                params: {
                                    integrityPayloads
                                },
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL */.oe5,
                                authentication: this.getSessionAccessToken()
                            });
                        });
                    }
                    getSingleItem(itemUuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.tokenRefreshableRequest({
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpVerb.Get,
                                url: (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.joinPaths)(this.host, _Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.getSingleItem(itemUuid)),
                                fallbackErrorMessage: _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL */.TwN,
                                authentication: this.getSessionAccessToken()
                            });
                        });
                    }
                    preprocessingError() {
                        if (this.refreshingSession) {
                            return this.createErrorResponse(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS */.z6z, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest);
                        }
                        if (!this.session) {
                            return this.createErrorResponse(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .API_MESSAGE_INVALID_SESSION */.aXB, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.BadRequest);
                        }
                        return undefined;
                    }
                    preprocessAuthenticatedErrorResponse(response) {
                        var _a, _b;
                        if (!this.session) {
                            return;
                        }
                        /**
                         * In most cases the ExpiredAccessToken erorr shouldn't reach this function, since if a 498 is caught, a refresh
                         * will automatically take place. However there does appear to be rare cases where for some reason the 498 falls through,
                         * perhaps because for example the server responds to a refresh request with a 498. In those cases, we'll just
                         * fallback here to the invalid session observer so that the user can be reprompted for auth.
                         */
                        if (response.status === _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.Unauthorized || response.status === _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.HttpStatusCode.ExpiredAccessToken) {
                            (_a = this.invalidSessionObserver) === null || _a === void 0 ? void 0 : _a.call(this, ((_b = response.data.error) === null || _b === void 0 ? void 0 : _b.tag) === _standardnotes_responses__WEBPACK_IMPORTED_MODULE_2__.ErrorTag.RevokedSession);
                        }
                    }
                    getSessionAccessToken() {
                        if (!this.session) {
                            return undefined;
                        }
                        if (this.session instanceof _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.Session) {
                            return this.session.accessToken.value;
                        }
                        return this.session.accessToken;
                    }
                    getCaptchaUrl() {
                        const response = this.httpService.get(_Paths__WEBPACK_IMPORTED_MODULE_4__ /* .Paths */.n.v1.meta);
                        return response;
                    }
                }
                /***/ 
            }),
            /***/ 78734: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ q: () => ( /* binding */DeprecatedHttpService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95658);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _Lib_Version__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94986);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_4__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const REQUEST_READY_STATE_COMPLETED = 4;
                /**
                 * A non-SNJS specific wrapper for XMLHttpRequests
                 */
                class DeprecatedHttpService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .AbstractService */.wcN {
                    constructor(environment, appVersion, internalEventBus) {
                        super(internalEventBus);
                        this.environment = environment;
                        this.appVersion = appVersion;
                        this.internalEventBus = internalEventBus;
                    }
                    getAbsolute(url, params, authentication) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Get,
                                authentication
                            });
                        });
                    }
                    postAbsolute(url, params, authentication) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Post,
                                authentication
                            });
                        });
                    }
                    putAbsolute(url, params, authentication) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Put,
                                authentication
                            });
                        });
                    }
                    patchAbsolute(url, params, authentication) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Patch,
                                authentication
                            });
                        });
                    }
                    deleteAbsolute(url, params, authentication) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.runHttp({
                                url,
                                params,
                                verb: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Delete,
                                authentication
                            });
                        });
                    }
                    runHttp(httpRequest) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const request = this.createXmlRequest(httpRequest);
                            return this.runRequest(request, this.createRequestBody(httpRequest));
                        });
                    }
                    createRequestBody(httpRequest) {
                        if (httpRequest.params !== undefined && [_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Post, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Put, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Patch, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Delete].includes(httpRequest.verb)) {
                            return JSON.stringify(httpRequest.params);
                        }
                        return httpRequest.rawBytes;
                    }
                    createXmlRequest(httpRequest) {
                        var _a;
                        const request = new XMLHttpRequest();
                        if (httpRequest.params && httpRequest.verb === _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.HttpVerb.Get && Object.keys(httpRequest.params).length > 0) {
                            httpRequest.url = this.urlForUrlAndParams(httpRequest.url, httpRequest.params);
                        }
                        request.open(httpRequest.verb, httpRequest.url, true);
                        request.responseType = (_a = httpRequest.responseType) !== null && _a !== void 0 ? _a : '';
                        if (!httpRequest.external) {
                            request.setRequestHeader('X-SNJS-Version', _Lib_Version__WEBPACK_IMPORTED_MODULE_2__ /* .SnjsVersion */["in"]);
                            const appVersionHeaderValue = "".concat(_standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.Environment[this.environment], "-").concat(this.appVersion);
                            request.setRequestHeader('X-Application-Version', appVersionHeaderValue);
                            if (httpRequest.authentication) {
                                request.setRequestHeader('Authorization', 'Bearer ' + httpRequest.authentication);
                            }
                        }
                        let contenTypeIsSet = false;
                        if (httpRequest.customHeaders && httpRequest.customHeaders.length > 0) {
                            httpRequest.customHeaders.forEach(_ref => {
                                let { key, value } = _ref;
                                request.setRequestHeader(key, value);
                                if (key === 'Content-Type') {
                                    contenTypeIsSet = true;
                                }
                            });
                        }
                        if (!contenTypeIsSet && !httpRequest.external) {
                            request.setRequestHeader('Content-Type', 'application/json');
                        }
                        return request;
                    }
                    runRequest(request, body) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return new Promise((resolve, reject) => {
                                request.onreadystatechange = () => {
                                    this.stateChangeHandlerForRequest(request, resolve, reject);
                                };
                                request.send(body);
                            });
                        });
                    }
                    stateChangeHandlerForRequest(request, resolve, reject) {
                        var _a, _b, _c;
                        if (request.readyState !== REQUEST_READY_STATE_COMPLETED) {
                            return;
                        }
                        const httpStatus = request.status;
                        const response = {
                            status: httpStatus,
                            headers: new Map()
                        };
                        const responseHeaderLines = (_a = request.getAllResponseHeaders()) === null || _a === void 0 ? void 0 : _a.trim().split(/[\r\n]+/);
                        responseHeaderLines === null || responseHeaderLines === void 0 ? void 0 : responseHeaderLines.forEach(responseHeaderLine => {
                            const parts = responseHeaderLine.split(': ');
                            const name = parts.shift();
                            const value = parts.join(': ');
                            response.headers.set(name, value);
                        });
                        try {
                            if (httpStatus !== _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.DeprecatedStatusCode.HttpStatusNoContent) {
                                let body;
                                const contentTypeHeader = ((_b = response.headers) === null || _b === void 0 ? void 0 : _b.get('content-type')) || ((_c = response.headers) === null || _c === void 0 ? void 0 : _c.get('Content-Type'));
                                if (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.includes('application/json')) {
                                    body = JSON.parse(request.responseText);
                                }
                                else {
                                    body = request.response;
                                }
                                /**
                                 * v0 APIs do not have a `data` top-level object. In such cases, mimic
                                 * the newer response body style by putting all the top-level
                                 * properties inside a `data` object.
                                 */
                                if (!body.data) {
                                    response.data = body;
                                }
                                if (!(0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.isString)(body)) {
                                    Object.assign(response, body);
                                }
                            }
                        }
                        catch (error) {
                            console.error(error);
                        }
                        if (httpStatus >= _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.DeprecatedStatusCode.HttpStatusMinSuccess && httpStatus <= _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.DeprecatedStatusCode.HttpStatusMaxSuccess) {
                            resolve(response);
                        }
                        else {
                            if (httpStatus === _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.DeprecatedStatusCode.HttpStatusForbidden) {
                                response.error = {
                                    message: _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .API_MESSAGE_RATE_LIMITED */.jN7,
                                    status: httpStatus
                                };
                            }
                            else if (response.error == undefined) {
                                if (response.data == undefined || response.data.error == undefined) {
                                    try {
                                        response.error = {
                                            message: request.responseText || _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .UNKNOWN_ERROR */.I4j,
                                            status: httpStatus
                                        };
                                    }
                                    catch (error) {
                                        response.error = {
                                            message: _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .UNKNOWN_ERROR */.I4j,
                                            status: httpStatus
                                        };
                                    }
                                }
                                else {
                                    response.error = response.data.error;
                                }
                            }
                            reject(response);
                        }
                    }
                    urlForUrlAndParams(url, params) {
                        const keyValueString = Object.keys(params).map(key => {
                            return key + '=' + encodeURIComponent(params[key]);
                        }).join('&');
                        if (url.includes('?')) {
                            return url + '&' + keyValueString;
                        }
                        else {
                            return url + '?' + keyValueString;
                        }
                    }
                }
                /***/ 
            }),
            /***/ 98361: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ n: () => ( /* binding */Paths)
                    /* harmony export */ 
                });
                const FilesPaths = {
                    closeUploadSession: '/v1/files/upload/close-session',
                    createUserFileValetToken: '/v1/files/valet-tokens',
                    deleteFile: '/v1/files',
                    downloadFileChunk: '/v1/files',
                    downloadVaultFileChunk: '/v1/vaults/files',
                    startUploadSession: '/v1/files/upload/create-session',
                    uploadFileChunk: '/v1/files/upload/chunk'
                };
                const SharedVaultFilesPaths = {
                    closeSharedVaultUploadSession: '/v1/shared-vault/files/upload/close-session',
                    deleteSharedVaultFile: '/v1/shared-vault/files',
                    downloadSharedVaultFileChunk: '/v1/shared-vault/files',
                    startSharedVaultUploadSession: '/v1/shared-vault/files/upload/create-session',
                    uploadSharedVaultFileChunk: '/v1/shared-vault/files/upload/chunk',
                    moveFile: '/v1/shared-vault/files/move'
                };
                const UserPaths = {
                    changeCredentials: userUuid => "/v1/users/".concat(userUuid, "/attributes/credentials"),
                    deleteAccount: userUuid => "/v1/users/".concat(userUuid),
                    keyParams: '/v1/login-params',
                    refreshSession: '/v1/sessions/refresh',
                    register: '/v1/users',
                    session: sessionUuid => "/v1/sessions/".concat(sessionUuid),
                    sessions: '/v1/sessions',
                    signIn: '/v1/login',
                    signOut: '/v1/logout'
                };
                const ItemsPaths = {
                    checkIntegrity: '/v1/items/check-integrity',
                    getSingleItem: uuid => "/v1/items/".concat(uuid),
                    itemRevisions: itemUuid => "/v1/items/".concat(itemUuid, "/revisions"),
                    itemRevision: (itemUuid, revisionUuid) => "/v1/items/".concat(itemUuid, "/revisions/").concat(revisionUuid),
                    sync: '/v1/items'
                };
                const SettingsPaths = {
                    settings: userUuid => "/v1/users/".concat(userUuid, "/settings"),
                    setting: (userUuid, settingName) => "/v1/users/".concat(userUuid, "/settings/").concat(settingName),
                    subscriptionSetting: (userUuid, settingName) => "/v1/users/".concat(userUuid, "/subscription-settings/").concat(settingName),
                    subscriptionSettings: userUuid => "/v1/users/".concat(userUuid, "/subscription-settings")
                };
                const SubscriptionPaths = {
                    offlineFeatures: '/v1/offline/features',
                    purchase: '/v1/purchase',
                    subscription: userUuid => "/v1/users/".concat(userUuid, "/subscription"),
                    subscriptionTokens: '/v1/subscription-tokens'
                };
                const UserPathsV2 = {
                    keyParams: '/v2/login-params',
                    signIn: '/v2/login'
                };
                const ListedPaths = {
                    listedRegistration: userUuid => "/v1/users/".concat(userUuid, "/integrations/listed")
                };
                const Paths = {
                    v1: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, FilesPaths), SharedVaultFilesPaths), ItemsPaths), ListedPaths), SettingsPaths), SubscriptionPaths), UserPaths), {
                        meta: '/v1/meta'
                    }),
                    v2: Object.assign({}, UserPathsV2)
                };
                /***/ 
            }),
            /***/ 68625: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ n: () => ( /* binding */ChallengeOperation)
                    /* harmony export */ 
                });
                /* harmony import */ var _ChallengeResponse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59472);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /**
                 * A challenge operation stores user-submitted values and callbacks.
                 * When its values are updated, it will trigger the associated callbacks (valid/invalid/complete)
                 */
                class ChallengeOperation {
                    constructor(challenge, onValidValue, onInvalidValue, onNonvalidatedSubmit, onComplete, onCancel) {
                        this.challenge = challenge;
                        this.onValidValue = onValidValue;
                        this.onInvalidValue = onInvalidValue;
                        this.onNonvalidatedSubmit = onNonvalidatedSubmit;
                        this.onComplete = onComplete;
                        this.onCancel = onCancel;
                        this.nonvalidatedValues = [];
                        this.validValues = [];
                        this.invalidValues = [];
                        this.artifacts = {};
                    }
                    deinit() {
                        ;
                        this.challenge = undefined;
                        this.onValidValue = undefined;
                        this.onInvalidValue = undefined;
                        this.onNonvalidatedSubmit = undefined;
                        this.onComplete = undefined;
                        this.onCancel = undefined;
                        this.nonvalidatedValues = undefined;
                        this.validValues = undefined;
                        this.invalidValues = undefined;
                        this.artifacts = undefined;
                    }
                    /**
                     * Mark this challenge as complete, triggering the resolve function,
                     * as well as notifying the client
                     */
                    complete(response) {
                        var _a;
                        if (!response) {
                            response = new _ChallengeResponse__WEBPACK_IMPORTED_MODULE_0__ /* .ChallengeResponse */.a(this.challenge, this.validValues, this.artifacts);
                        }
                        (_a = this.onComplete) === null || _a === void 0 ? void 0 : _a.call(this, response);
                    }
                    nonvalidatedSubmit() {
                        var _a;
                        const response = new _ChallengeResponse__WEBPACK_IMPORTED_MODULE_0__ /* .ChallengeResponse */.a(this.challenge, this.nonvalidatedValues.slice(), this.artifacts);
                        (_a = this.onNonvalidatedSubmit) === null || _a === void 0 ? void 0 : _a.call(this, response);
                        /** Reset values */
                        this.nonvalidatedValues = [];
                    }
                    cancel() {
                        var _a;
                        (_a = this.onCancel) === null || _a === void 0 ? void 0 : _a.call(this);
                    }
                    /**
                     * @returns Returns true if the challenge has received all valid responses
                     */
                    isFinished() {
                        return this.validValues.length === this.challenge.prompts.length;
                    }
                    nonvalidatedPrompts() {
                        return this.challenge.prompts.filter(p => !p.validates);
                    }
                    addNonvalidatedValue(value) {
                        const valuesArray = this.nonvalidatedValues;
                        const matching = valuesArray.find(v => v.prompt.id === value.prompt.id);
                        if (matching) {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.removeFromArray)(valuesArray, matching);
                        }
                        valuesArray.push(value);
                        if (this.nonvalidatedValues.length === this.nonvalidatedPrompts().length) {
                            this.nonvalidatedSubmit();
                        }
                    }
                    /**
                     * Sets the values validation status, as well as handles subsequent actions,
                     * such as completing the operation if all valid values are supplied, as well as
                     * notifying the client of this new value's validation status.
                     */
                    setValueStatus(value, valid, artifacts) {
                        var _a, _b;
                        const valuesArray = valid ? this.validValues : this.invalidValues;
                        const matching = valuesArray.find(v => v.prompt.validation === value.prompt.validation);
                        if (matching) {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.removeFromArray)(valuesArray, matching);
                        }
                        valuesArray.push(value);
                        Object.assign(this.artifacts, artifacts);
                        if (this.isFinished()) {
                            this.complete();
                        }
                        else {
                            if (valid) {
                                (_a = this.onValidValue) === null || _a === void 0 ? void 0 : _a.call(this, value);
                            }
                            else {
                                (_b = this.onInvalidValue) === null || _b === void 0 ? void 0 : _b.call(this, value);
                            }
                        }
                    }
                }
                /***/ 
            }),
            /***/ 59472: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ a: () => ( /* binding */ChallengeResponse)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                class ChallengeResponse {
                    constructor(challenge, values, artifacts) {
                        this.challenge = challenge;
                        this.values = values;
                        this.artifacts = artifacts;
                        Object.freeze(this);
                    }
                    getValueForType(type) {
                        const value = this.values.find(value => value.prompt.validation === type);
                        if ((0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.isNullOrUndefined)(value)) {
                            throw Error('Could not find value for validation type ' + type);
                        }
                        return value;
                    }
                    getDefaultValue() {
                        if (this.values.length > 1) {
                            throw Error('Attempting to retrieve default response value when more than one value exists');
                        }
                        return this.values[0];
                    }
                }
                /***/ 
            }),
            /***/ 40278: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ P: () => ( /* binding */ChallengeService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _Protection_isValidProtectionSessionLength__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17956);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _ChallengeOperation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68625);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const clearChallengeObserver = observer => {
                    observer.onCancel = undefined;
                    observer.onComplete = undefined;
                    observer.onValidValue = undefined;
                    observer.onInvalidValue = undefined;
                    observer.onNonvalidatedSubmit = undefined;
                };
                /**
                 * The challenge service creates, updates and keeps track of running challenge operations.
                 */
                class ChallengeService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(storageService, encryptionService, internalEventBus) {
                        super(internalEventBus);
                        this.storageService = storageService;
                        this.encryptionService = encryptionService;
                        this.internalEventBus = internalEventBus;
                        this.challengeOperations = {};
                        this.challengeObservers = {};
                    }
                    deinit() {
                        ;
                        this.storageService = undefined;
                        this.encryptionService = undefined;
                        this.sendChallenge = undefined;
                        this.challengeOperations = undefined;
                        this.challengeObservers = undefined;
                        super.deinit();
                    }
                    promptForChallengeResponse(challenge) {
                        return new Promise(resolve => {
                            this.createOrGetChallengeOperation(challenge, resolve);
                            this.sendChallenge(challenge);
                        });
                    }
                    createChallenge(prompts, reason, cancelable, heading, subheading) {
                        return new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4(prompts, reason, cancelable, heading, subheading);
                    }
                    validateChallengeValue(value) {
                        return __awaiter(this, void 0, void 0, function* () {
                            switch (value.prompt.validation) {
                                case _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.LocalPasscode:
                                    return this.encryptionService.validatePasscode(value.value);
                                case _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.AccountPassword:
                                    return this.encryptionService.validateAccountPassword(value.value);
                                case _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.Biometric:
                                    return {
                                        valid: value.value === true
                                    };
                                case _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.Authenticator:
                                    return {
                                        valid: 'id' in value.value
                                    };
                                case _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.ProtectionSessionDuration:
                                    return {
                                        valid: (0, _Protection_isValidProtectionSessionLength__WEBPACK_IMPORTED_MODULE_1__ /* .isValidProtectionSessionLength */.z)(value.value)
                                    };
                                default:
                                    throw Error("Unhandled validation mode ".concat(value.prompt.validation));
                            }
                        });
                    }
                    promptForCorrectPasscode(reason) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const challenge = new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4([new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.LocalPasscode)], reason, true);
                            const response = yield this.promptForChallengeResponse(challenge);
                            if (!response) {
                                return undefined;
                            }
                            const value = response.getValueForType(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.LocalPasscode);
                            return value.value;
                        });
                    }
                    promptForAccountPassword() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.encryptionService.hasAccount()) {
                                throw Error('Requiring account password for challenge with no account');
                            }
                            const response = yield this.promptForChallengeResponse(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4([new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.AccountPassword)], _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.Custom, true, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeStrings */.NiJ.EnterAccountPassword));
                            return (_a = response === null || response === void 0 ? void 0 : response.getValueForType(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.AccountPassword)) === null || _a === void 0 ? void 0 : _a.value;
                        });
                    }
                    /**
                     * Returns the wrapping key for operations that require resaving the root key
                     * (changing the account password, signing in, registering, or upgrading protocol)
                     * Returns empty object if no passcode is configured.
                     * Otherwise returns {cancled: true} if the operation is canceled, or
                     * {wrappingKey} with the result.
                     * @param passcode - If the consumer already has access to the passcode,
                     * they can pass it here so that the user is not prompted again.
                     */
                    getWrappingKeyIfApplicable(passcode) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.encryptionService.hasPasscode()) {
                                return {};
                            }
                            if (!passcode) {
                                passcode = yield this.promptForCorrectPasscode(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ResaveRootKey);
                                if (!passcode) {
                                    return {
                                        canceled: true
                                    };
                                }
                            }
                            const wrappingKey = yield this.encryptionService.computeWrappingKey(passcode);
                            return {
                                wrappingKey
                            };
                        });
                    }
                    addChallengeObserver(challenge, observer) {
                        const observers = this.challengeObservers[challenge.id] || [];
                        observers.push(observer);
                        this.challengeObservers[challenge.id] = observers;
                        return () => {
                            clearChallengeObserver(observer);
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.removeFromArray)(observers, observer);
                        };
                    }
                    createOrGetChallengeOperation(challenge, resolve) {
                        let operation = this.getChallengeOperation(challenge);
                        if (!operation) {
                            operation = new _ChallengeOperation__WEBPACK_IMPORTED_MODULE_3__ /* .ChallengeOperation */.n(challenge, value => {
                                this.onChallengeValidValue(challenge, value);
                            }, value => {
                                this.onChallengeInvalidValue(challenge, value);
                            }, response => {
                                this.onChallengeNonvalidatedSubmit(challenge, response);
                                resolve(response);
                            }, response => {
                                this.onChallengeComplete(challenge, response);
                                resolve(response);
                            }, () => {
                                this.onChallengeCancel(challenge);
                                resolve(undefined);
                            });
                            this.challengeOperations[challenge.id] = operation;
                        }
                        return operation;
                    }
                    performOnObservers(challenge, perform) {
                        const observers = this.challengeObservers[challenge.id] || [];
                        for (const observer of observers) {
                            perform(observer);
                        }
                    }
                    onChallengeValidValue(challenge, value) {
                        this.performOnObservers(challenge, observer => {
                            var _a;
                            (_a = observer.onValidValue) === null || _a === void 0 ? void 0 : _a.call(observer, value);
                        });
                    }
                    onChallengeInvalidValue(challenge, value) {
                        this.performOnObservers(challenge, observer => {
                            var _a;
                            (_a = observer.onInvalidValue) === null || _a === void 0 ? void 0 : _a.call(observer, value);
                        });
                    }
                    onChallengeNonvalidatedSubmit(challenge, response) {
                        this.performOnObservers(challenge, observer => {
                            var _a;
                            (_a = observer.onNonvalidatedSubmit) === null || _a === void 0 ? void 0 : _a.call(observer, response);
                        });
                    }
                    onChallengeComplete(challenge, response) {
                        this.performOnObservers(challenge, observer => {
                            var _a;
                            (_a = observer.onComplete) === null || _a === void 0 ? void 0 : _a.call(observer, response);
                        });
                    }
                    onChallengeCancel(challenge) {
                        this.performOnObservers(challenge, observer => {
                            var _a;
                            (_a = observer.onCancel) === null || _a === void 0 ? void 0 : _a.call(observer);
                        });
                    }
                    getChallengeOperation(challenge) {
                        return this.challengeOperations[challenge.id];
                    }
                    deleteChallengeOperation(operation) {
                        const challenge = operation.challenge;
                        challenge.customHandler = undefined;
                        operation.deinit();
                        delete this.challengeOperations[challenge.id];
                    }
                    cancelChallenge(challenge) {
                        const operation = this.challengeOperations[challenge.id];
                        operation.cancel();
                        this.deleteChallengeOperation(operation);
                    }
                    completeChallenge(challenge) {
                        const operation = this.challengeOperations[challenge.id];
                        operation.complete();
                        this.deleteChallengeOperation(operation);
                    }
                    submitValuesForChallenge(challenge, values) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (values.length === 0) {
                                throw Error('Attempting to submit 0 values for challenge');
                            }
                            for (const value of values) {
                                if (!value.prompt.validates) {
                                    const operation = this.getChallengeOperation(challenge);
                                    operation.addNonvalidatedValue(value);
                                }
                                else {
                                    const { valid, artifacts } = yield this.validateChallengeValue(value);
                                    this.setValidationStatusForChallenge(challenge, value, valid, artifacts);
                                }
                            }
                        });
                    }
                    setValidationStatusForChallenge(challenge, value, valid, artifacts) {
                        const operation = this.getChallengeOperation(challenge);
                        operation.setValueStatus(value, valid, artifacts);
                        if (operation.isFinished()) {
                            this.deleteChallengeOperation(operation);
                            const observers = this.challengeObservers[challenge.id] || [];
                            observers.forEach(clearChallengeObserver);
                            observers.length = 0;
                            delete this.challengeObservers[challenge.id];
                        }
                    }
                }
                /***/ 
            }),
            /***/ 74987: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    y: () => ( /* binding */ComponentManager)
                });
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var src = __webpack_require__(82648);
                // EXTERNAL MODULE: ../models/dist/index.js
                var dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../features/dist/index.js
                var features_dist = __webpack_require__(80215);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var utils_dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/ComponentViewer.ts
                var ComponentViewer = __webpack_require__(56297);
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var services_src = __webpack_require__(55668);
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/UseCase/GetFeatureUrl.ts
                const DESKTOP_URL_PREFIX = 'sn://';
                const LOCAL_HOST = 'localhost';
                const CUSTOM_LOCAL_HOST = 'sn.local';
                const ANDROID_LOCAL_HOST = '10.0.2.2';
                class GetFeatureUrl {
                    constructor(desktopManager, environment, platform) {
                        this.desktopManager = desktopManager;
                        this.environment = environment;
                        this.platform = platform;
                    }
                    execute(uiFeature) {
                        if (this.desktopManager) {
                            return this.urlForFeatureOnDesktop(uiFeature);
                        }
                        if (uiFeature.isNativeFeature) {
                            return this.urlForNativeComponent(uiFeature.featureDescription.identifier, uiFeature.featureDescription.index_path);
                        }
                        if (uiFeature.asComponent.offlineOnly) {
                            return undefined;
                        }
                        const url = uiFeature.asComponent.hosted_url || uiFeature.asComponent.legacy_url;
                        if (!url) {
                            if (uiFeature.asComponent.package_info.identifier && uiFeature.asComponent.package_info.index_path) {
                                return this.urlForNativeComponent(uiFeature.asComponent.package_info.identifier, uiFeature.asComponent.package_info.index_path);
                            }
                            return undefined;
                        }
                        if (this.isMobile) {
                            const localReplacement = this.platform === dist.Platform.Ios ? LOCAL_HOST : ANDROID_LOCAL_HOST;
                            return url.replace(LOCAL_HOST, localReplacement).replace(CUSTOM_LOCAL_HOST, localReplacement);
                        }
                        return url;
                    }
                    urlForFeatureOnDesktop(uiFeature) {
                        if (!this.desktopManager) {
                            throw new Error('Desktop manager is not defined');
                        }
                        if (uiFeature.isNativeFeature) {
                            return "".concat(this.desktopManager.getExtServerHost(), "/components/").concat(uiFeature.featureIdentifier, "/").concat(uiFeature.featureDescription.index_path);
                        }
                        else {
                            if (uiFeature.asComponent.local_url) {
                                return uiFeature.asComponent.local_url.replace(DESKTOP_URL_PREFIX, this.desktopManager.getExtServerHost() + '/');
                            }
                            return uiFeature.asComponent.hosted_url || uiFeature.asComponent.legacy_url;
                        }
                    }
                    urlForNativeComponent(identifier, index_path) {
                        if (this.isMobile) {
                            const baseUrlRequiredForThemesInsideEditors = window.location.href.split('/index.html')[0];
                            return "".concat(baseUrlRequiredForThemesInsideEditors, "/web-src/components/assets/").concat(identifier, "/").concat(index_path);
                        }
                        else {
                            const baseUrlRequiredForThemesInsideEditors = window.location.origin;
                            return "".concat(baseUrlRequiredForThemesInsideEditors, "/components/assets/").concat(identifier, "/").concat(index_path);
                        }
                    }
                    get isMobile() {
                        return this.environment === dist.Environment.Mobile;
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/ComponentManagerEvent.ts
                var ComponentManagerEvent;
                (function (ComponentManagerEvent) {
                    ComponentManagerEvent["ViewerDidFocus"] = "ViewerDidFocus";
                })(ComponentManagerEvent || (ComponentManagerEvent = {}));
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/Types.ts
                var Types = __webpack_require__(20549);
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/permissionsStringForPermissions.ts
                function permissionsStringForPermissions(permissions, component) {
                    if (permissions.length === 0) {
                        return '.';
                    }
                    let contentTypeStrings = [];
                    let contextAreaStrings = [];
                    permissions.forEach(permission => {
                        switch (permission.name) {
                            case features_dist.ComponentAction.StreamItems:
                                if (!permission.content_types) {
                                    return;
                                }
                                permission.content_types.forEach(contentTypeString => {
                                    const contentTypeOrError = src.ContentType.create(contentTypeString);
                                    if (contentTypeOrError.isFailed()) {
                                        return;
                                    }
                                    const contentType = contentTypeOrError.getValue();
                                    const desc = contentType.getDisplayName();
                                    if (desc) {
                                        contentTypeStrings.push("".concat(desc, "s"));
                                    }
                                    else {
                                        contentTypeStrings.push("items of type ".concat(contentType.value));
                                    }
                                });
                                break;
                            case features_dist.ComponentAction.StreamContextItem:
                                {
                                    const componentAreaMapping = {
                                        [features_dist.ComponentArea.EditorStack]: 'working note',
                                        [features_dist.ComponentArea.Editor]: 'working note',
                                        [features_dist.ComponentArea.Themes]: 'Unknown'
                                    };
                                    contextAreaStrings.push(componentAreaMapping[component.area]);
                                }
                                break;
                        }
                    });
                    contentTypeStrings = (0, utils_dist.uniqueArray)(contentTypeStrings);
                    contextAreaStrings = (0, utils_dist.uniqueArray)(contextAreaStrings);
                    if (contentTypeStrings.length === 0 && contextAreaStrings.length === 0) {
                        return '.';
                    }
                    return contentTypeStrings.concat(contextAreaStrings).join(', ') + '.';
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/UseCase/RunWithPermissionsUseCase.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class RunWithPermissionsUseCase {
                    constructor(permissionDialogUIHandler, alerts, mutator, sync, items) {
                        this.permissionDialogUIHandler = permissionDialogUIHandler;
                        this.alerts = alerts;
                        this.mutator = mutator;
                        this.sync = sync;
                        this.items = items;
                        this.permissionDialogs = [];
                        this.pendingErrorAlerts = new Set();
                    }
                    deinit() {
                        this.permissionDialogs = [];
                        this.permissionDialogUIHandler = undefined;
                        this.alerts = undefined;
                        this.mutator = undefined;
                        this.sync = undefined;
                        this.items = undefined;
                    }
                    execute(componentIdentifier, requiredPermissions, runFunction) {
                        const uiFeature = this.findUIFeature(componentIdentifier);
                        if (!uiFeature) {
                            if (!this.pendingErrorAlerts.has(componentIdentifier)) {
                                this.pendingErrorAlerts.add(componentIdentifier);
                                void this.alerts.alert("Unable to find component with ID ".concat(componentIdentifier, ". Please restart the app and try again."), 'An unexpected error occurred').then(() => {
                                    this.pendingErrorAlerts.delete(componentIdentifier);
                                });
                            }
                            return;
                        }
                        if (uiFeature.isNativeFeature) {
                            runFunction();
                            return;
                        }
                        if (!this.areRequestedPermissionsValid(uiFeature, requiredPermissions)) {
                            console.error('Component is requesting invalid permissions', componentIdentifier, requiredPermissions);
                            return;
                        }
                        const acquiredPermissions = uiFeature.acquiredPermissions;
                        /* Make copy as not to mutate input values */
                        requiredPermissions = (0, utils_dist.Copy)(requiredPermissions);
                        for (const required of requiredPermissions.slice()) {
                            /* Remove anything we already have */
                            const respectiveAcquired = acquiredPermissions.find(candidate => candidate.name === required.name);
                            if (!respectiveAcquired) {
                                continue;
                            }
                            /* We now match on name, lets substract from required.content_types anything we have in acquired. */
                            const requiredContentTypes = required.content_types;
                            if (!requiredContentTypes) {
                                /* If this permission does not require any content types (i.e stream-context-item)
                                  then we can remove this from required since we match by name (respectiveAcquired.name === required.name) */
                                (0, utils_dist.filterFromArray)(requiredPermissions, required);
                                continue;
                            }
                            for (const acquiredContentType of respectiveAcquired.content_types) {
                                (0, utils_dist.removeFromArray)(requiredContentTypes, acquiredContentType);
                            }
                            if (requiredContentTypes.length === 0) {
                                /* We've removed all acquired and end up with zero, means we already have all these permissions */
                                (0, utils_dist.filterFromArray)(requiredPermissions, required);
                            }
                        }
                        if (requiredPermissions.length > 0) {
                            this.promptForPermissionsWithDeferredRendering(uiFeature.asComponent, requiredPermissions, 
                            // eslint-disable-next-line @typescript-eslint/require-await
                            approved => __awaiter(this, void 0, void 0, function* () {
                                if (approved) {
                                    runFunction();
                                }
                            }));
                        }
                        else {
                            runFunction();
                        }
                    }
                    setPermissionDialogUIHandler(handler) {
                        this.permissionDialogUIHandler = handler;
                    }
                    areRequestedPermissionsValid(uiFeature, permissions) {
                        var _a;
                        for (const permission of permissions) {
                            if (permission.name === features_dist.ComponentAction.StreamItems) {
                                if (!Types /* AllowedBatchStreaming */.h6.includes(uiFeature.featureIdentifier)) {
                                    return false;
                                }
                                const hasNonAllowedBatchPermission = (_a = permission.content_types) === null || _a === void 0 ? void 0 : _a.some(type => !Types /* AllowedBatchContentTypes */.Jg.includes(type));
                                if (hasNonAllowedBatchPermission) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    }
                    promptForPermissionsWithDeferredRendering(component, permissions, callback) {
                        setTimeout(() => {
                            this.promptForPermissions(component, permissions, callback);
                        });
                    }
                    promptForPermissions(component, permissions, callback) {
                        const params = {
                            component: component,
                            permissions: permissions,
                            permissionsString: permissionsStringForPermissions(permissions, component),
                            actionBlock: callback,
                            callback: approved => __awaiter(this, void 0, void 0, function* () {
                                const latestComponent = this.items.findItem(component.uuid);
                                if (!latestComponent) {
                                    return;
                                }
                                if (approved) {
                                    const componentPermissions = (0, utils_dist.Copy)(latestComponent.permissions);
                                    for (const permission of permissions) {
                                        const matchingPermission = componentPermissions.find(candidate => candidate.name === permission.name);
                                        if (!matchingPermission) {
                                            componentPermissions.push(permission);
                                        }
                                        else {
                                            /* Permission already exists, but content_types may have been expanded */
                                            const contentTypes = matchingPermission.content_types || [];
                                            matchingPermission.content_types = (0, utils_dist.uniqueArray)(contentTypes.concat(permission.content_types));
                                        }
                                    }
                                    yield this.mutator.changeItem(component, m => {
                                        const mutator = m;
                                        mutator.permissions = componentPermissions;
                                    });
                                    void this.sync.sync();
                                }
                                this.permissionDialogs = this.permissionDialogs.filter(pendingDialog => {
                                    /* Remove self */
                                    if (pendingDialog === params) {
                                        pendingDialog.actionBlock && pendingDialog.actionBlock(approved);
                                        return false;
                                    }
                                    const containsObjectSubset = (source, target) => {
                                        return !target.some(val => !source.find(candidate => JSON.stringify(candidate) === JSON.stringify(val)));
                                    };
                                    if (pendingDialog.component === component) {
                                        /* remove pending dialogs that are encapsulated by already approved permissions, and run its function */
                                        if (pendingDialog.permissions === permissions || containsObjectSubset(permissions, pendingDialog.permissions)) {
                                            /* If approved, run the action block. Otherwise, if canceled, cancel any
                                            pending ones as well, since the user was explicit in their intentions */
                                            if (approved) {
                                                pendingDialog.actionBlock && pendingDialog.actionBlock(approved);
                                            }
                                            return false;
                                        }
                                    }
                                    return true;
                                });
                                if (this.permissionDialogs.length > 0) {
                                    this.permissionDialogUIHandler(this.permissionDialogs[0]);
                                }
                            })
                        };
                        /**
                         * Since these calls are asyncronous, multiple dialogs may be requested at the same time.
                         * We only want to present one and trigger all callbacks based on one modal result
                         */
                        const existingDialog = this.permissionDialogs.find(dialog => dialog.component === component);
                        this.permissionDialogs.push(params);
                        if (!existingDialog) {
                            this.permissionDialogUIHandler(params);
                        }
                    }
                    findUIFeature(identifier) {
                        const nativeFeature = (0, features_dist.FindNativeFeature)(identifier);
                        if (nativeFeature) {
                            return new dist.UIFeature(nativeFeature);
                        }
                        const componentItem = this.items.findItem(identifier);
                        if (componentItem) {
                            return new dist.UIFeature(componentItem);
                        }
                        return undefined;
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/UseCase/EditorForNote.ts
                class EditorForNoteUseCase {
                    constructor(items) {
                        this.items = items;
                    }
                    execute(note) {
                        if (note.noteType === features_dist.NoteType.Plain) {
                            return new dist.UIFeature((0, features_dist.GetPlainNoteFeature)());
                        }
                        if (note.noteType === features_dist.NoteType.Super) {
                            return new dist.UIFeature((0, features_dist.GetSuperNoteFeature)());
                        }
                        if (note.editorIdentifier) {
                            const result = this.componentOrNativeFeatureForIdentifier(note.editorIdentifier);
                            if (result) {
                                return result;
                            }
                        }
                        if (note.noteType && note.noteType !== features_dist.NoteType.Unknown) {
                            const result = this.nativeEditorForNoteType(note.noteType);
                            if (result) {
                                return new dist.UIFeature(result);
                            }
                        }
                        const legacyResult = this.legacyGetEditorForNote(note);
                        if (legacyResult) {
                            return new dist.UIFeature(legacyResult);
                        }
                        return new dist.UIFeature((0, features_dist.GetPlainNoteFeature)());
                    }
                    componentOrNativeFeatureForIdentifier(identifier) {
                        const nativeFeature = (0, features_dist.FindNativeFeature)(identifier);
                        if (nativeFeature) {
                            return new dist.UIFeature(nativeFeature);
                        }
                        const component = this.items.getDisplayableComponents().find(component => {
                            return component.identifier === identifier;
                        });
                        if (component) {
                            return new dist.UIFeature(component);
                        }
                        return undefined;
                    }
                    nativeEditorForNoteType(noteType) {
                        const nativeEditors = (0, features_dist.GetIframeAndNativeEditors)();
                        return nativeEditors.find(editor => editor.note_type === noteType);
                    }
                    /** Uses legacy approach of note/editor association. New method uses note.editorIdentifier and note.noteType directly. */
                    legacyGetEditorForNote(note) {
                        const editors = this.thirdPartyComponentsForArea(features_dist.ComponentArea.Editor);
                        for (const editor of editors) {
                            if (editor.isExplicitlyEnabledForItem(note.uuid)) {
                                return editor;
                            }
                        }
                        const defaultEditor = this.legacyGetDefaultEditor();
                        if (defaultEditor && !defaultEditor.isExplicitlyDisabledForItem(note.uuid)) {
                            return defaultEditor;
                        }
                        else {
                            return undefined;
                        }
                    }
                    legacyGetDefaultEditor() {
                        const editors = this.thirdPartyComponentsForArea(features_dist.ComponentArea.Editor);
                        return editors.filter(e => e.legacyIsDefaultEditor())[0];
                    }
                    thirdPartyComponentsForArea(area) {
                        return this.items.getDisplayableComponents().filter(component => {
                            return component.area === area;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/UseCase/GetDefaultEditorIdentifier.ts
                class GetDefaultEditorIdentifier {
                    constructor(preferences, items) {
                        this.preferences = preferences;
                        this.items = items;
                    }
                    execute(currentTag) {
                        var _a;
                        if (currentTag) {
                            const editorIdentifier = (_a = currentTag === null || currentTag === void 0 ? void 0 : currentTag.preferences) === null || _a === void 0 ? void 0 : _a.editorIdentifier;
                            if (editorIdentifier) {
                                return src.Result.ok(editorIdentifier);
                            }
                        }
                        const preferenceValue = this.preferences.getValue(dist.PrefKey.DefaultEditorIdentifier);
                        if (preferenceValue) {
                            return src.Result.ok(preferenceValue);
                        }
                        const editors = this.thirdPartyComponentsForArea(features_dist.ComponentArea.Editor);
                        const matchingEditor = editors.filter(e => e.legacyIsDefaultEditor())[0];
                        if (matchingEditor) {
                            return src.Result.ok(matchingEditor.identifier);
                        }
                        return src.Result.ok(features_dist.NativeFeatureIdentifier.TYPES.PlainEditor);
                    }
                    thirdPartyComponentsForArea(area) {
                        return this.items.getDisplayableComponents().filter(component => {
                            return component.area === area;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/UseCase/DoesEditorChangeRequireAlert.ts
                class DoesEditorChangeRequireAlertUseCase {
                    execute(from, to) {
                        if (!from || !to) {
                            return false;
                        }
                        const fromFileType = from.fileType;
                        const toFileType = to.fileType;
                        const isEitherMarkdown = fromFileType === 'md' || toFileType === 'md';
                        const areBothHtml = fromFileType === 'html' && toFileType === 'html';
                        if (isEitherMarkdown || areBothHtml) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/ComponentManager.ts
                var ComponentManager_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * Responsible for orchestrating component functionality, including editors, themes,
                 * and other components. The component manager primarily deals with iframes, and orchestrates
                 * sending and receiving messages to and from frames via the postMessage API.
                 */
                class ComponentManager extends services_src /* AbstractService */.wcN {
                    constructor(items, mutator, sync, features, preferences, alerts, environment, platform, device, logger, internalEventBus) {
                        super(internalEventBus);
                        this.items = items;
                        this.mutator = mutator;
                        this.sync = sync;
                        this.features = features;
                        this.preferences = preferences;
                        this.alerts = alerts;
                        this.environment = environment;
                        this.platform = platform;
                        this.device = device;
                        this.logger = logger;
                        this.internalEventBus = internalEventBus;
                        this.viewers = [];
                        this.permissionDialogUIHandler = () => {
                            throw 'Must call setPermissionDialogUIHandler';
                        };
                        this.runWithPermissionsUseCase = new RunWithPermissionsUseCase(this.permissionDialogUIHandler, this.alerts, this.mutator, this.sync, this.items);
                        this.detectFocusChange = () => {
                            const activeIframes = Array.from(document.getElementsByTagName('iframe'));
                            for (const iframe of activeIframes) {
                                if (document.activeElement === iframe) {
                                    setTimeout(() => {
                                        const viewer = this.findComponentViewer(iframe.dataset.componentViewerId);
                                        void this.notifyEvent(ComponentManagerEvent.ViewerDidFocus, {
                                            componentViewer: viewer
                                        });
                                    });
                                    return;
                                }
                            }
                        };
                        this.onWindowMessage = event => {
                            var _a;
                            const data = event.data;
                            if (data.sessionKey) {
                                this.logger.info('Component manager received message', data);
                                (_a = this.componentViewerForSessionKey(data.sessionKey)) === null || _a === void 0 ? void 0 : _a.handleMessage(data);
                            }
                        };
                        this.loggingEnabled = false;
                        this.addSyncedComponentItemObserver();
                        this.registerMobileNativeComponentUrls();
                        this.registerDeprecatedEditorUrlsForAndroid();
                        this.eventDisposers.push(preferences.addEventObserver(event => {
                            if (event === services_src /* PreferencesServiceEvent */.WZd.PreferencesChanged) {
                                this.postActiveThemesToAllViewers();
                            }
                        }));
                        window.addEventListener ? window.addEventListener('focus', this.detectFocusChange, true) : window.attachEvent('onfocusout', this.detectFocusChange);
                        window.addEventListener ? window.addEventListener('blur', this.detectFocusChange, true) : window.attachEvent('onblur', this.detectFocusChange);
                        window.addEventListener('message', this.onWindowMessage, true);
                    }
                    deinit() {
                        super.deinit();
                        for (const viewer of this.viewers) {
                            viewer.destroy();
                        }
                        this.viewers.length = 0;
                        this.runWithPermissionsUseCase.deinit();
                        this.desktopManager = undefined;
                        this.items = undefined;
                        this.features = undefined;
                        this.sync = undefined;
                        this.alerts = undefined;
                        this.preferences = undefined;
                        this.permissionDialogUIHandler = undefined;
                        if (window) {
                            window.removeEventListener('focus', this.detectFocusChange, true);
                            window.removeEventListener('blur', this.detectFocusChange, true);
                            window.removeEventListener('message', this.onWindowMessage, true);
                        }
                        ;
                        this.detectFocusChange = undefined;
                        this.onWindowMessage = undefined;
                    }
                    setPermissionDialogUIHandler(handler) {
                        this.permissionDialogUIHandler = handler;
                        this.runWithPermissionsUseCase.setPermissionDialogUIHandler(handler);
                    }
                    thirdPartyComponentsForArea(area) {
                        return this.items.getDisplayableComponents().filter(component => {
                            return component.area === area;
                        });
                    }
                    createComponentViewer(component, item, actionObserver) {
                        var _a;
                        const viewer = new ComponentViewer /* ComponentViewer */.S(component, {
                            items: this.items,
                            mutator: this.mutator,
                            sync: this.sync,
                            alerts: this.alerts,
                            preferences: this.preferences,
                            features: this.features,
                            logger: this.logger
                        }, {
                            url: (_a = this.urlForFeature(component)) !== null && _a !== void 0 ? _a : '',
                            item,
                            actionObserver
                        }, {
                            environment: this.environment,
                            platform: this.platform,
                            componentManagerFunctions: {
                                runWithPermissionsUseCase: this.runWithPermissionsUseCase,
                                urlsForActiveThemes: this.urlsForActiveThemes.bind(this),
                                setComponentPreferences: this.setComponentPreferences.bind(this),
                                getComponentPreferences: this.getComponentPreferences.bind(this)
                            }
                        });
                        this.viewers.push(viewer);
                        return viewer;
                    }
                    destroyComponentViewer(viewer) {
                        viewer.destroy();
                        (0, utils_dist.removeFromArray)(this.viewers, viewer);
                    }
                    setDesktopManager(desktopManager) {
                        this.desktopManager = desktopManager;
                        this.configureForDesktop();
                    }
                    handleChangedComponents(components, source) {
                        const acceptableSources = [dist.PayloadEmitSource.LocalChanged, dist.PayloadEmitSource.RemoteRetrieved, dist.PayloadEmitSource.LocalDatabaseLoaded, dist.PayloadEmitSource.LocalInserted];
                        if (components.length === 0 || !acceptableSources.includes(source)) {
                            return;
                        }
                        if (this.desktopManager) {
                            const thirdPartyComponents = components.filter(component => {
                                const nativeFeature = (0, features_dist.FindNativeFeature)(component.identifier);
                                return nativeFeature ? false : true;
                            });
                            if (thirdPartyComponents.length > 0) {
                                this.desktopManager.syncComponentsInstallation(thirdPartyComponents);
                            }
                        }
                        const themes = components.filter(c => c.isTheme());
                        if (themes.length > 0) {
                            this.postActiveThemesToAllViewers();
                        }
                    }
                    addSyncedComponentItemObserver() {
                        this.eventDisposers.push(this.items.addObserver([src.ContentType.TYPES.Component, src.ContentType.TYPES.Theme], _ref => {
                            let { changed, inserted, removed, source } = _ref;
                            const items = [...changed, ...inserted];
                            this.handleChangedComponents(items, source);
                            this.updateMobileRegisteredComponentUrls(inserted, removed);
                        }));
                    }
                    updateMobileRegisteredComponentUrls(inserted, removed) {
                        if (!(0, services_src /* isMobileDevice */.s2G)(this.device)) {
                            return;
                        }
                        for (const component of inserted) {
                            const feature = new dist.UIFeature(component);
                            const url = this.urlForFeature(feature);
                            if (url) {
                                this.device.registerComponentUrl(component.uuid, url);
                            }
                        }
                        for (const component of removed) {
                            this.device.deregisterComponentUrl(component.uuid);
                        }
                    }
                    registerMobileNativeComponentUrls() {
                        if (!(0, services_src /* isMobileDevice */.s2G)(this.device)) {
                            return;
                        }
                        const nativeComponents = [...(0, features_dist.GetIframeEditors)(), ...(0, features_dist.GetNativeThemes)()];
                        for (const component of nativeComponents) {
                            const feature = new dist.UIFeature(component);
                            const url = this.urlForFeature(feature);
                            if (url) {
                                this.device.registerComponentUrl(feature.uniqueIdentifier.value, url);
                            }
                        }
                    }
                    registerDeprecatedEditorUrlsForAndroid() {
                        if (!(0, services_src /* isMobileDevice */.s2G)(this.device)) {
                            return;
                        }
                        const deprecatedEditors = [...(0, features_dist.GetDeprecatedEditors)()];
                        for (const component of deprecatedEditors) {
                            const feature = new dist.UIFeature(component);
                            const url = this.urlForFeature(feature);
                            if (url) {
                                this.device.registerComponentUrl(feature.uniqueIdentifier.value, url);
                            }
                        }
                    }
                    configureForDesktop() {
                        if (!this.desktopManager) {
                            throw new Error('Desktop manager is not defined');
                        }
                        this.desktopManager.registerUpdateObserver(component => {
                            const activeComponents = this.getActiveComponents();
                            const isComponentActive = activeComponents.find(candidate => candidate.uuid === component.uuid);
                            if (isComponentActive && component.isTheme()) {
                                this.postActiveThemesToAllViewers();
                            }
                        });
                    }
                    postActiveThemesToAllViewers() {
                        for (const viewer of this.viewers) {
                            viewer.postActiveThemes();
                        }
                    }
                    urlForFeature(uiFeature) {
                        const usecase = new GetFeatureUrl(this.desktopManager, this.environment, this.platform);
                        return usecase.execute(uiFeature);
                    }
                    urlsForActiveThemes() {
                        const themes = this.getActiveThemes();
                        const urls = [];
                        for (const theme of themes) {
                            const url = this.urlForFeature(theme);
                            if (url) {
                                urls.push(url);
                            }
                        }
                        return urls;
                    }
                    findComponentViewer(identifier) {
                        return this.viewers.find(viewer => viewer.identifier === identifier);
                    }
                    findComponentWithPackageIdentifier(identifier) {
                        return this.items.getDisplayableComponents().find(component => {
                            return component.identifier === identifier;
                        });
                    }
                    componentViewerForSessionKey(key) {
                        return this.viewers.find(viewer => viewer.sessionKey === key);
                    }
                    toggleOtherNonLayerableThemes(uiFeature) {
                        const activeThemes = this.getActiveThemes();
                        for (const candidate of activeThemes) {
                            if (candidate.featureIdentifier === uiFeature.featureIdentifier) {
                                continue;
                            }
                            if (!candidate.layerable) {
                                this.removeActiveTheme(candidate);
                            }
                        }
                    }
                    toggleTheme(uiFeature) {
                        let skipEntitlementCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            this.logger.info('Toggling theme', uiFeature.uniqueIdentifier);
                            if (this.isThemeActive(uiFeature)) {
                                this.removeActiveTheme(uiFeature);
                                return;
                            }
                            const featureStatus = this.features.getFeatureStatus(uiFeature.uniqueIdentifier);
                            if (!skipEntitlementCheck && featureStatus !== services_src /* FeatureStatus */.iKc.Entitled) {
                                return;
                            }
                            /* Activate current before deactivating others, so as not to flicker */
                            this.addActiveTheme(uiFeature);
                            /* Deactive currently active theme(s) if new theme is not layerable */
                            if (!uiFeature.layerable) {
                                yield (0, utils_dist.sleep)(10);
                                this.toggleOtherNonLayerableThemes(uiFeature);
                            }
                        });
                    }
                    getActiveThemes() {
                        const { features, uuids } = this.getActiveThemesIdentifiers();
                        const thirdPartyThemes = uuids.map(uuid => {
                            const component = this.items.findItem(uuid.value);
                            if (component) {
                                return new dist.UIFeature(component);
                            }
                            return undefined;
                        }).filter(utils_dist.isNotUndefined);
                        const nativeThemes = features.map(identifier => {
                            return (0, features_dist.FindNativeTheme)(identifier.value);
                        }).filter(utils_dist.isNotUndefined).map(theme => new dist.UIFeature(theme));
                        const entitledThemes = [...thirdPartyThemes, ...nativeThemes].filter(theme => {
                            return this.features.getFeatureStatus(theme.uniqueIdentifier) === services_src /* FeatureStatus */.iKc.Entitled;
                        });
                        return entitledThemes;
                    }
                    getActiveThemesIdentifiers() {
                        const features = [];
                        const uuids = [];
                        const strings = new Set(this.preferences.getLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, []));
                        for (const string of strings) {
                            const nativeIdentifier = features_dist.NativeFeatureIdentifier.create(string);
                            if (!nativeIdentifier.isFailed()) {
                                features.push(nativeIdentifier.getValue());
                            }
                            const uuid = src.Uuid.create(string);
                            if (!uuid.isFailed()) {
                                uuids.push(uuid.getValue());
                            }
                        }
                        return {
                            features,
                            uuids
                        };
                    }
                    toggleComponent(component) {
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            this.logger.info('Toggling component', component.uuid);
                            if (this.isComponentActive(component)) {
                                yield this.removeActiveComponent(component);
                            }
                            else {
                                yield this.addActiveComponent(component);
                            }
                        });
                    }
                    editorForNote(note) {
                        const usecase = new EditorForNoteUseCase(this.items);
                        return usecase.execute(note);
                    }
                    getDefaultEditorIdentifier(currentTag) {
                        const usecase = new GetDefaultEditorIdentifier(this.preferences, this.items);
                        return usecase.execute(currentTag).getValue();
                    }
                    doesEditorChangeRequireAlert(from, to) {
                        const usecase = new DoesEditorChangeRequireAlertUseCase();
                        return usecase.execute(from, to);
                    }
                    showEditorChangeAlert() {
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            const shouldChangeEditor = yield this.alerts.confirm('Doing so might result in minor formatting changes.', "Are you sure you want to change this note's type?", 'Yes, change it');
                            return shouldChangeEditor;
                        });
                    }
                    setComponentPreferences(uiFeature, preferences) {
                        var _a;
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            const mutablePreferencesValue = (0, utils_dist.Copy)((_a = this.preferences.getValue(dist.PrefKey.ComponentPreferences, undefined)) !== null && _a !== void 0 ? _a : {});
                            const preferencesLookupKey = uiFeature.uniqueIdentifier.value;
                            mutablePreferencesValue[preferencesLookupKey] = preferences;
                            yield this.preferences.setValue(dist.PrefKey.ComponentPreferences, mutablePreferencesValue);
                        });
                    }
                    getComponentPreferences(component) {
                        const preferences = this.preferences.getValue(dist.PrefKey.ComponentPreferences, undefined);
                        if (!preferences) {
                            return undefined;
                        }
                        const preferencesLookupKey = component.uniqueIdentifier.value;
                        return preferences[preferencesLookupKey];
                    }
                    addActiveTheme(theme) {
                        const activeThemes = this.preferences.getLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, []).slice();
                        activeThemes.push(theme.uniqueIdentifier.value);
                        this.preferences.setLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, activeThemes);
                    }
                    replaceActiveTheme(theme) {
                        this.preferences.setLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, [theme.uniqueIdentifier.value]);
                    }
                    removeActiveTheme(theme) {
                        const activeThemes = this.preferences.getLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, []);
                        const filteredThemes = activeThemes.filter(activeTheme => activeTheme !== theme.uniqueIdentifier.value);
                        this.preferences.setLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, filteredThemes);
                    }
                    isThemeActive(theme) {
                        if (this.features.getFeatureStatus(theme.uniqueIdentifier) !== services_src /* FeatureStatus */.iKc.Entitled) {
                            return false;
                        }
                        const activeThemes = this.preferences.getLocalValue(services_src /* LocalPrefKey */.dH$.ActiveThemes, []);
                        return activeThemes.includes(theme.uniqueIdentifier.value);
                    }
                    addActiveComponent(component) {
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            const activeComponents = this.preferences.getValue(dist.PrefKey.ActiveComponents, []).slice();
                            activeComponents.push(component.uuid);
                            yield this.preferences.setValue(dist.PrefKey.ActiveComponents, activeComponents);
                        });
                    }
                    removeActiveComponent(component) {
                        var _a;
                        return ComponentManager_awaiter(this, void 0, void 0, function* () {
                            const activeComponents = (_a = this.preferences.getValue(dist.PrefKey.ActiveComponents, undefined)) !== null && _a !== void 0 ? _a : [];
                            const filteredComponents = activeComponents.filter(activeComponent => activeComponent !== component.uuid);
                            yield this.preferences.setValue(dist.PrefKey.ActiveComponents, filteredComponents);
                        });
                    }
                    getActiveComponents() {
                        var _a;
                        const activeComponents = (_a = this.preferences.getValue(dist.PrefKey.ActiveComponents, undefined)) !== null && _a !== void 0 ? _a : [];
                        return this.items.findItems(activeComponents);
                    }
                    isComponentActive(component) {
                        var _a;
                        const activeComponents = (_a = this.preferences.getValue(dist.PrefKey.ActiveComponents, undefined)) !== null && _a !== void 0 ? _a : [];
                        return activeComponents.includes(component.uuid);
                    }
                }
                /***/ 
            }),
            /***/ 56297: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ S: () => ( /* binding */ComponentViewer)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _Lib_Application_Platforms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2256);
                /* harmony import */ var _Types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20549);
                /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80215);
                /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_6__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ComponentViewer {
                    constructor(componentOrFeature, services, options, config) {
                        this.componentOrFeature = componentOrFeature;
                        this.services = services;
                        this.options = options;
                        this.config = config;
                        this.identifier = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.nonSecureRandomIdentifier)();
                        this.actionObservers = [];
                        this.eventObservers = [];
                        this.dealloced = false;
                        this.readonly = false;
                        this.lockReadonly = false;
                        if ((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .isComponentViewerItemReadonlyItem */.qr4)(options.item)) {
                            this.setReadonly(true);
                            this.lockReadonly = true;
                        }
                        this.removeItemObserver = this.services.items.addObserver(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_6__.ContentType.TYPES.Any, _ref => {
                            let { changed, inserted, removed, source, sourceKey } = _ref;
                            if (this.dealloced) {
                                return;
                            }
                            const items = [...changed, ...inserted, ...removed];
                            this.handleChangesInItems(items, source, sourceKey);
                        });
                        if (options.actionObserver) {
                            this.actionObservers.push(options.actionObserver);
                        }
                        this.removeFeaturesObserver = services.features.addEventObserver(event => {
                            if (this.dealloced) {
                                return;
                            }
                            if (event === _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .FeaturesEvent */.Usi.FeaturesAvailabilityChanged) {
                                this.postActiveThemes();
                                this.notifyEventObservers(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentViewerEvent.FeatureStatusUpdated);
                            }
                        });
                        this.services.logger.info('Constructor', this);
                    }
                    getComponentOrFeatureItem() {
                        return this.componentOrFeature;
                    }
                    get url() {
                        return this.options.url;
                    }
                    get isDesktop() {
                        return this.config.environment === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.Environment.Desktop;
                    }
                    get isMobile() {
                        return this.config.environment === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.Environment.Mobile;
                    }
                    destroy() {
                        this.services.logger.info('Destroying', this);
                        this.deinit();
                    }
                    deinit() {
                        this.dealloced = true;
                        this.componentOrFeature = undefined;
                        this.services = undefined;
                        this.config = undefined;
                        this.options = undefined;
                        this.eventObservers.length = 0;
                        this.actionObservers.length = 0;
                        this.removeFeaturesObserver();
                        this.removeFeaturesObserver = undefined;
                        this.removeItemObserver();
                        this.removeItemObserver = undefined;
                    }
                    addEventObserver(observer) {
                        this.eventObservers.push(observer);
                        const thislessChangeObservers = this.eventObservers;
                        return () => {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.removeFromArray)(thislessChangeObservers, observer);
                        };
                    }
                    notifyEventObservers(event) {
                        for (const observer of this.eventObservers) {
                            observer(event);
                        }
                    }
                    addActionObserver(observer) {
                        this.actionObservers.push(observer);
                        const thislessChangeObservers = this.actionObservers;
                        return () => {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.removeFromArray)(thislessChangeObservers, observer);
                        };
                    }
                    setReadonly(readonly) {
                        if (this.lockReadonly) {
                            throw Error('Attempting to set readonly on lockedReadonly component viewer');
                        }
                        this.readonly = readonly;
                    }
                    get componentUniqueIdentifier() {
                        return this.componentOrFeature.uniqueIdentifier;
                    }
                    getFeatureStatus() {
                        return this.services.features.getFeatureStatus(this.componentUniqueIdentifier, {
                            inContextOfItem: this.getContextItem()
                        });
                    }
                    getContextItem() {
                        if ((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .isComponentViewerItemReadonlyItem */.qr4)(this.options.item)) {
                            return this.options.item.readonlyItem;
                        }
                        const matchingItem = this.services.items.findItem(this.options.item.uuid);
                        return matchingItem;
                    }
                    isOfflineRestricted() {
                        return this.componentOrFeature.isComponent && this.componentOrFeature.asComponent.offlineOnly && !this.isDesktop;
                    }
                    hasUrlError() {
                        if (!this.componentOrFeature.isComponent) {
                            return false;
                        }
                        return this.isDesktop ? !this.componentOrFeature.asComponent.local_url && !this.componentOrFeature.asComponent.hasValidHostedUrl : !this.componentOrFeature.asComponent.hasValidHostedUrl;
                    }
                    shouldRender() {
                        return this.getError() == undefined;
                    }
                    getError() {
                        if (this.isOfflineRestricted()) {
                            return _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ComponentViewerError */.kQg.OfflineRestricted;
                        }
                        if (this.hasUrlError()) {
                            return _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ComponentViewerError */.kQg.MissingUrl;
                        }
                        return undefined;
                    }
                    updateOurComponentRefFromChangedItems(items) {
                        if (!this.componentOrFeature.isComponent) {
                            return;
                        }
                        const updatedComponent = items.find(item => item.uuid === this.componentUniqueIdentifier.value);
                        if (!updatedComponent) {
                            return;
                        }
                        const item = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.UIFeature(updatedComponent);
                        this.componentOrFeature = item;
                    }
                    handleChangesInItems(items, source, sourceKey) {
                        const nonencryptedItems = items.filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isNotEncryptedItem);
                        const nondeletedItems = nonencryptedItems.filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isDecryptedItem);
                        this.updateOurComponentRefFromChangedItems(nondeletedItems);
                        const areWeOriginator = sourceKey && sourceKey === this.componentUniqueIdentifier.value;
                        if (areWeOriginator) {
                            return;
                        }
                        if (this.streamItems) {
                            const relevantItems = nonencryptedItems.filter(item => {
                                var _a;
                                return (_a = this.streamItems) === null || _a === void 0 ? void 0 : _a.includes(item.content_type);
                            });
                            if (relevantItems.length > 0) {
                                this.sendManyItemsThroughBridge(relevantItems);
                            }
                        }
                        if (this.streamContextItemOriginalMessage) {
                            const optionsItem = this.options.item;
                            if ((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .isComponentViewerItemReadonlyItem */.qr4)(optionsItem)) {
                                return;
                            }
                            const matchingItem = nondeletedItems.find(item => item.uuid === optionsItem.uuid);
                            if (matchingItem) {
                                this.sendContextItemThroughBridge(matchingItem, source);
                            }
                        }
                    }
                    sendManyItemsThroughBridge(items) {
                        var _a;
                        const requiredPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems,
                                content_types: (_a = this.streamItems) === null || _a === void 0 ? void 0 : _a.sort()
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => {
                            this.sendItemsInReply(items, this.streamItemsOriginalMessage);
                        });
                    }
                    sendContextItemThroughBridge(item, source) {
                        const requiredContextPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamContextItem
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredContextPermissions, () => {
                            this.services.logger.info('Send context item in reply', 'component:', this.componentOrFeature, 'item: ', item, 'originalMessage: ', this.streamContextItemOriginalMessage);
                            const response = {
                                item: this.jsonForItem(item, source)
                            };
                            this.replyToMessage(this.streamContextItemOriginalMessage, response);
                        });
                    }
                    sendItemsInReply(items, message, source) {
                        this.services.logger.info('Send items in reply', this.componentOrFeature, items, message);
                        const responseData = {};
                        const mapped = items.map(item => {
                            return this.jsonForItem(item, source);
                        });
                        responseData.items = mapped;
                        this.replyToMessage(message, responseData);
                    }
                    jsonForItem(item, source) {
                        const isMetadatUpdate = source === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.RemoteSaved || source === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.OfflineSyncSaved || source === _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.PreSyncSave;
                        const params = {
                            uuid: item.uuid,
                            content_type: item.content_type,
                            created_at: item.created_at,
                            updated_at: item.serverUpdatedAt,
                            isMetadataUpdate: isMetadatUpdate
                        };
                        if ((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isDecryptedItem)(item)) {
                            params.content = this.contentForItem(item);
                            params.clientData = this.getClientData(item);
                        }
                        else {
                            params.deleted = true;
                        }
                        return this.responseItemsByRemovingPrivateProperties([params])[0];
                    }
                    getClientData(item) {
                        const globalComponentData = item.getDomainData(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentDataDomain) || {};
                        const thisComponentData = globalComponentData[this.componentUniqueIdentifier.value] || {};
                        return thisComponentData;
                    }
                    contentForItem(item) {
                        if ((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.isNote)(item)) {
                            const content = item.content;
                            const spellcheck = item.spellcheck != undefined ? item.spellcheck : this.services.preferences.getValue(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PrefKey.EditorSpellcheck, true);
                            return Object.assign(Object.assign({}, content), {
                                spellcheck
                            });
                        }
                        return item.content;
                    }
                    replyToMessage(originalMessage, replyData) {
                        const reply = {
                            action: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.Reply,
                            original: originalMessage,
                            data: replyData
                        };
                        this.sendMessage(reply);
                    }
                    /**
                     * @param essential If the message is non-essential, no alert will be shown
                     *  if we can no longer find the window.
                     */
                    sendMessage(message) {
                        let essential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        if (!this.window && message.action === _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.Reply) {
                            this.services.logger.info('Component has been deallocated in between message send and reply', this.componentOrFeature, message);
                            return;
                        }
                        this.services.logger.info('Send message to component', this.componentOrFeature, 'message: ', message);
                        if (!this.window) {
                            if (essential) {
                                void this.services.alerts.alert("Standard Notes is trying to communicate with ".concat(this.componentOrFeature.displayName, ", ") + 'but an error is occurring. Please restart this extension and try again.');
                            }
                            return;
                        }
                        /** Because iframes do not allow-same-origin, their origin is `null`, and so we can't target their explicit origin */
                        const nullOrigin = '*';
                        /* Mobile messaging requires json */
                        this.window.postMessage(this.isMobile ? JSON.stringify(message) : message, nullOrigin);
                    }
                    responseItemsByRemovingPrivateProperties(responseItems) {
                        let removeUrls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        /* Don't allow component to overwrite these properties. */
                        let privateContentProperties = ['autoupdateDisabled', 'permissions', 'active'];
                        if (removeUrls) {
                            privateContentProperties = privateContentProperties.concat(['hosted_url', 'local_url']);
                        }
                        return responseItems.map(responseItem => {
                            const privateProperties = privateContentProperties.slice();
                            /** Server extensions are allowed to modify url property */
                            if (removeUrls) {
                                privateProperties.push('url');
                            }
                            if (!responseItem.content || (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.isString)(responseItem.content)) {
                                return responseItem;
                            }
                            let content = {};
                            for (const [key, value] of Object.entries(responseItem.content)) {
                                if (!privateProperties.includes(key)) {
                                    content = Object.assign(Object.assign({}, content), {
                                        [key]: value
                                    });
                                }
                            }
                            return Object.assign(Object.assign({}, responseItem), {
                                content: content
                            });
                        });
                    }
                    /** Called by client when the iframe is ready */
                    setWindow(window) {
                        var _a;
                        if (this.window) {
                            throw Error('Attempting to override component viewer window. Create a new component viewer instead.');
                        }
                        this.services.logger.info('setWindow', 'component: ', this.componentOrFeature, 'window: ', window);
                        this.window = window;
                        this.sessionKey = _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.UuidGenerator.GenerateUuid();
                        const componentData = (_a = this.config.componentManagerFunctions.getComponentPreferences(this.componentOrFeature)) !== null && _a !== void 0 ? _a : {};
                        this.sendMessage({
                            action: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.ComponentRegistered,
                            sessionKey: this.sessionKey,
                            componentData: componentData,
                            data: {
                                uuid: this.componentUniqueIdentifier.value,
                                environment: (0, _Lib_Application_Platforms__WEBPACK_IMPORTED_MODULE_2__ /* .environmentToString */.g)(this.config.environment),
                                platform: (0, _Lib_Application_Platforms__WEBPACK_IMPORTED_MODULE_2__ /* .platformToString */._e)(this.config.platform),
                                activeThemeUrls: this.config.componentManagerFunctions.urlsForActiveThemes()
                            }
                        });
                        this.services.logger.info('setWindow got new sessionKey', this.sessionKey);
                        this.postActiveThemes();
                    }
                    postActiveThemes() {
                        const urls = this.config.componentManagerFunctions.urlsForActiveThemes();
                        const data = {
                            themes: urls
                        };
                        const message = {
                            action: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.ActivateThemes,
                            data: data
                        };
                        this.sendMessage(message, false);
                    }
                    handleMessage(message) {
                        this.services.logger.info('Handle message', message, this);
                        if (!this.componentOrFeature) {
                            this.services.logger.info('Component not defined for message, returning', message);
                            void this.services.alerts.alert('A component is trying to communicate with Standard Notes, ' + 'but there is an error establishing a bridge. Please restart the app and try again.');
                            return;
                        }
                        if (this.readonly && _Types__WEBPACK_IMPORTED_MODULE_3__ /* .ReadwriteActions */.wJ.includes(message.action)) {
                            void this.services.alerts.alert("".concat(this.componentOrFeature.displayName, " is trying to save, but it is in a locked state and cannot accept changes."));
                            return;
                        }
                        const messageHandlers = {
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems]: this.handleStreamItemsMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamContextItem]: this.handleStreamContextItemMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.SetComponentData]: this.handleSetComponentPreferencesMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.DeleteItems]: this.handleDeleteItemsMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.CreateItems]: this.handleCreateItemsMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.CreateItem]: this.handleCreateItemsMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.SaveItems]: this.handleSaveItemsMessage.bind(this),
                            [_standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.SetSize]: this.handleSetSizeEvent.bind(this)
                        };
                        const handler = messageHandlers[message.action];
                        handler === null || handler === void 0 ? void 0 : handler(message);
                        for (const observer of this.actionObservers) {
                            observer(message.action, message.data);
                        }
                    }
                    handleStreamItemsMessage(message) {
                        const data = message.data;
                        const types = data.content_types.filter(type => _Types__WEBPACK_IMPORTED_MODULE_3__ /* .AllowedBatchContentTypes */.Jg.includes(type)).sort();
                        const requiredPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems,
                                content_types: types
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => {
                            if (!this.streamItems) {
                                this.streamItems = types;
                                this.streamItemsOriginalMessage = message;
                            }
                            /* Push immediately now */
                            const items = [];
                            for (const contentType of types) {
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.extendArray)(items, this.services.items.getItems(contentType));
                            }
                            this.sendItemsInReply(items, message);
                        });
                    }
                    handleStreamContextItemMessage(message) {
                        const requiredPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamContextItem
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => {
                            if (!this.streamContextItemOriginalMessage) {
                                this.streamContextItemOriginalMessage = message;
                            }
                            const matchingItem = (0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .isComponentViewerItemReadonlyItem */.qr4)(this.options.item) ? this.options.item.readonlyItem : this.services.items.findItem(this.options.item.uuid);
                            if (matchingItem) {
                                this.sendContextItemThroughBridge(matchingItem);
                            }
                        });
                    }
                    /**
                     * Save items is capable of saving existing items, and also creating new ones
                     * if they don't exist.
                     */
                    handleSaveItemsMessage(message) {
                        let responsePayloads = message.data.items;
                        const requiredPermissions = [];
                        /* Pending as in needed to be accounted for in permissions. */
                        const pendingResponseItems = responsePayloads.slice();
                        if ((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .isComponentViewerItemReadonlyItem */.qr4)(this.options.item)) {
                            return;
                        }
                        for (const responseItem of responsePayloads.slice()) {
                            if (responseItem.uuid === this.options.item.uuid) {
                                requiredPermissions.push({
                                    name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamContextItem
                                });
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.removeFromArray)(pendingResponseItems, responseItem);
                                /* We break because there can only be one context item */
                                break;
                            }
                        }
                        /* Check to see if additional privileges are required */
                        if (pendingResponseItems.length > 0) {
                            const requiredContentTypes = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.uniqueArray)(pendingResponseItems.map(item => {
                                return item.content_type;
                            })).sort();
                            requiredPermissions.push({
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems,
                                content_types: requiredContentTypes
                            });
                        }
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => __awaiter(this, void 0, void 0, function* () {
                            responsePayloads = this.responseItemsByRemovingPrivateProperties(responsePayloads, true);
                            /* Filter locked items */
                            const uuids = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.Uuids)(responsePayloads);
                            const items = this.services.items.findItemsIncludingBlanks(uuids);
                            let lockedCount = 0;
                            let lockedNoteCount = 0;
                            for (const item of items) {
                                if (!item) {
                                    continue;
                                }
                                if (item.locked) {
                                    responsePayloads = responsePayloads.filter(responseItem => {
                                        return responseItem.uuid !== item.uuid;
                                    });
                                    lockedCount++;
                                    if (item.content_type === _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_6__.ContentType.TYPES.Note) {
                                        lockedNoteCount++;
                                    }
                                }
                            }
                            if (lockedNoteCount === 1) {
                                void this.services.alerts.alert('The note you are attempting to save has editing disabled', 'Note has Editing Disabled');
                                return;
                            }
                            else if (lockedCount > 0) {
                                const itemNoun = lockedCount === 1 ? 'item' : lockedNoteCount === lockedCount ? 'notes' : 'items';
                                const auxVerb = lockedCount === 1 ? 'has' : 'have';
                                void this.services.alerts.alert("".concat(lockedCount, " ").concat(itemNoun, " you are attempting to save ").concat(auxVerb, " editing disabled."), 'Items have Editing Disabled');
                                return;
                            }
                            const contextualPayloads = responsePayloads.map(responseItem => {
                                return (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateComponentRetrievedContextPayload)(responseItem);
                            });
                            for (const contextualPayload of contextualPayloads) {
                                const item = this.services.items.findItem(contextualPayload.uuid);
                                if (!item) {
                                    const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DecryptedPayload(Object.assign(Object.assign({}, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadTimestampDefaults)()), contextualPayload));
                                    const template = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateDecryptedItemFromPayload)(payload);
                                    yield this.services.mutator.insertItem(template);
                                }
                                else {
                                    if (contextualPayload.content_type !== item.content_type) {
                                        throw Error('Extension is trying to modify content type of item.');
                                    }
                                }
                            }
                            yield this.services.mutator.changeItems(items.filter(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.isNotUndefined), mutator => {
                                const contextualPayload = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.sureSearchArray)(contextualPayloads, {
                                    uuid: mutator.getUuid()
                                });
                                mutator.setCustomContent(contextualPayload.content);
                                const responseItem = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.sureSearchArray)(responsePayloads, {
                                    uuid: mutator.getUuid()
                                });
                                if (responseItem.clientData) {
                                    const allComponentData = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.Copy)(mutator.getItem().getDomainData(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentDataDomain) || {});
                                    allComponentData[this.componentUniqueIdentifier.value] = responseItem.clientData;
                                    mutator.setDomainData(allComponentData, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentDataDomain);
                                }
                            }, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.MutationType.UpdateUserTimestamps, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.ComponentRetrieved, this.componentUniqueIdentifier.value);
                            this.services.sync.sync({
                                onPresyncSave: () => {
                                    this.replyToMessage(message, {});
                                }
                            }).catch(() => {
                                this.replyToMessage(message, {
                                    error: 'save-error'
                                });
                            });
                        }));
                    }
                    handleCreateItemsMessage(message) {
                        let responseItems = message.data.item ? [message.data.item] : message.data.items;
                        const uniqueContentTypes = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.uniqueArray)(responseItems.map(item => {
                            return item.content_type;
                        }));
                        const requiredPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems,
                                content_types: uniqueContentTypes
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => __awaiter(this, void 0, void 0, function* () {
                            responseItems = this.responseItemsByRemovingPrivateProperties(responseItems);
                            const processedItems = [];
                            for (const responseItem of responseItems) {
                                if (!responseItem.uuid) {
                                    responseItem.uuid = _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.UuidGenerator.GenerateUuid();
                                }
                                const contextualPayload = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.createComponentCreatedContextPayload)(responseItem);
                                const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DecryptedPayload(Object.assign(Object.assign({}, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadTimestampDefaults)()), contextualPayload));
                                const template = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateDecryptedItemFromPayload)(payload);
                                const item = yield this.services.mutator.insertItem(template);
                                yield this.services.mutator.changeItem(item, mutator => {
                                    if (responseItem.clientData) {
                                        const allComponentClientData = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.Copy)(item.getDomainData(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentDataDomain) || {});
                                        allComponentClientData[this.componentUniqueIdentifier.value] = responseItem.clientData;
                                        mutator.setDomainData(allComponentClientData, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ComponentDataDomain);
                                    }
                                }, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.MutationType.UpdateUserTimestamps, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.ComponentCreated, this.componentUniqueIdentifier.value);
                                processedItems.push(item);
                            }
                            void this.services.sync.sync();
                            const reply = message.action === _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.CreateItem ? {
                                item: this.jsonForItem(processedItems[0])
                            } : {
                                items: processedItems.map(item => {
                                    return this.jsonForItem(item);
                                })
                            };
                            this.replyToMessage(message, reply);
                        }));
                    }
                    handleDeleteItemsMessage(message) {
                        const data = message.data;
                        const items = data.items.filter(item => _Types__WEBPACK_IMPORTED_MODULE_3__ /* .AllowedBatchContentTypes */.Jg.includes(item.content_type));
                        const requiredContentTypes = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.uniqueArray)(items.map(item => item.content_type)).sort();
                        const requiredPermissions = [{
                                name: _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentAction.StreamItems,
                                content_types: requiredContentTypes
                            }];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, requiredPermissions, () => __awaiter(this, void 0, void 0, function* () {
                            const itemsData = items;
                            const noun = itemsData.length === 1 ? 'item' : 'items';
                            let reply = null;
                            const didConfirm = yield this.services.alerts.confirm("Are you sure you want to delete ".concat(itemsData.length, " ").concat(noun, "?"));
                            if (didConfirm) {
                                /* Filter for any components and deactivate before deleting */
                                for (const itemData of itemsData) {
                                    const item = this.services.items.findItem(itemData.uuid);
                                    if (!item) {
                                        void this.services.alerts.alert('The item you are trying to delete cannot be found.');
                                        continue;
                                    }
                                    yield this.services.mutator.setItemToBeDeleted(item, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.PayloadEmitSource.ComponentRetrieved);
                                }
                                void this.services.sync.sync();
                                reply = {
                                    deleted: true
                                };
                            }
                            else {
                                /* Rejected by user */
                                reply = {
                                    deleted: false
                                };
                            }
                            this.replyToMessage(message, reply);
                        }));
                    }
                    handleSetComponentPreferencesMessage(message) {
                        const noPermissionsRequired = [];
                        this.config.componentManagerFunctions.runWithPermissionsUseCase.execute(this.componentUniqueIdentifier.value, noPermissionsRequired, () => __awaiter(this, void 0, void 0, function* () {
                            const newPreferences = message.data.componentData;
                            if (!newPreferences) {
                                return;
                            }
                            yield this.config.componentManagerFunctions.setComponentPreferences(this.componentOrFeature, newPreferences);
                        }));
                    }
                    handleSetSizeEvent(message) {
                        var _a;
                        if (this.componentOrFeature.area !== _standardnotes_features__WEBPACK_IMPORTED_MODULE_4__.ComponentArea.EditorStack) {
                            return;
                        }
                        const parent = (_a = this.getIframe()) === null || _a === void 0 ? void 0 : _a.parentElement;
                        if (!parent) {
                            return;
                        }
                        const data = message.data;
                        const widthString = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.isString)(data.width) ? data.width : "".concat(data.width, "px");
                        const heightString = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.isString)(data.height) ? data.height : "".concat(data.height, "px");
                        if (parent) {
                            parent.setAttribute('style', "width:".concat(widthString, "; height:").concat(heightString, ";"));
                        }
                    }
                    getIframe() {
                        return Array.from(document.getElementsByTagName('iframe')).find(iframe => iframe.dataset.componentViewerId === this.identifier);
                    }
                }
                /***/ 
            }),
            /***/ 20549: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Jg: () => ( /* binding */AllowedBatchContentTypes),
                    /* harmony export */ h6: () => ( /* binding */AllowedBatchStreaming),
                    /* harmony export */ wJ: () => ( /* binding */ReadwriteActions)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80215);
                /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_features__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__);
                const ReadwriteActions = [_standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.ComponentAction.SaveItems, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.ComponentAction.CreateItem, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.ComponentAction.CreateItems, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.ComponentAction.DeleteItems, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.ComponentAction.SetComponentData];
                /**
                 * Extensions allowed to batch stream AllowedBatchContentTypes
                 */
                const AllowedBatchStreaming = Object.freeze([_standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.NativeFeatureIdentifier.TYPES.LegacyFileSafeIdentifier, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.NativeFeatureIdentifier.TYPES.DeprecatedFileSafe, _standardnotes_features__WEBPACK_IMPORTED_MODULE_0__.NativeFeatureIdentifier.TYPES.DeprecatedBoldEditor]);
                /**
                 * Content types which are allowed to be managed/streamed in bulk by a component.
                 */
                const AllowedBatchContentTypes = Object.freeze([_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.ContentType.TYPES.FilesafeCredentials, _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.ContentType.TYPES.FilesafeFileMetadata, _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.ContentType.TYPES.FilesafeIntegration]);
                /***/ 
            }),
            /***/ 6314: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    k: () => ( /* binding */FeaturesService)
                });
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ./lib/Services/Features/UseCase/MigrateFeatureRepoToUserSetting.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class MigrateFeatureRepoToUserSettingUseCase {
                    constructor(mutator, settings) {
                        this.mutator = mutator;
                        this.settings = settings;
                    }
                    execute() {
                        let featureRepos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        return __awaiter(this, void 0, void 0, function* () {
                            for (const item of featureRepos) {
                                if (item.migratedToUserSetting) {
                                    continue;
                                }
                                if (!item.onlineUrl) {
                                    continue;
                                }
                                const repoUrl = item.onlineUrl;
                                const userKeyMatch = repoUrl.match(/\w{32,64}/);
                                if (userKeyMatch && userKeyMatch.length > 0) {
                                    const userKey = userKeyMatch[0];
                                    yield this.settings.updateSetting(src.SettingName.create(src.SettingName.NAMES.ExtensionKey).getValue(), userKey, true);
                                    yield this.mutator.changeFeatureRepo(item, m => {
                                        m.migratedToUserSetting = true;
                                    });
                                }
                            }
                        });
                    }
                }
                // EXTERNAL MODULE: ../utils/dist/index.js
                var dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ../responses/dist/index.js
                var responses_dist = __webpack_require__(95658);
                // EXTERNAL MODULE: ../features/dist/index.js
                var features_dist = __webpack_require__(80215);
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var services_src = __webpack_require__(55668);
                ; // CONCATENATED MODULE: ./lib/Services/Features/UseCase/MigrateFeatureRepoToOfflineEntitlements.ts
                var MigrateFeatureRepoToOfflineEntitlements_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class MigrateFeatureRepoToOfflineEntitlementsUseCase {
                    constructor(mutator) {
                        this.mutator = mutator;
                        this.LEGACY_PROD_EXT_ORIGIN = 'https://extensions.standardnotes.org';
                    }
                    execute(dto) {
                        return MigrateFeatureRepoToOfflineEntitlements_awaiter(this, void 0, void 0, function* () {
                            const updatedRepos = [];
                            for (const item of dto.featureRepos) {
                                if (item.migratedToOfflineEntitlements) {
                                    continue;
                                }
                                if (!item.onlineUrl) {
                                    continue;
                                }
                                const repoUrl = item.onlineUrl;
                                const { origin } = new URL(repoUrl);
                                if (!origin.includes(this.LEGACY_PROD_EXT_ORIGIN)) {
                                    continue;
                                }
                                const userKeyMatch = repoUrl.match(/\w{32,64}/);
                                if (userKeyMatch && userKeyMatch.length > 0) {
                                    const userKey = userKeyMatch[0];
                                    const updatedRepo = yield this.mutator.changeFeatureRepo(item, m => {
                                        m.offlineFeaturesUrl = dto.prodOfflineFeaturesUrl;
                                        m.offlineKey = userKey;
                                        m.migratedToOfflineEntitlements = true;
                                    });
                                    updatedRepos.push(updatedRepo);
                                }
                            }
                            return updatedRepos;
                        });
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/Features/UseCase/GetFeatureStatus.ts
                class GetFeatureStatusUseCase {
                    constructor(items) {
                        this.items = items;
                    }
                    execute(dto) {
                        if (this.isFreeFeature(dto.featureId)) {
                            return services_src /* FeatureStatus */.iKc.Entitled;
                        }
                        const nativeFeature = this.findNativeFeature(dto.featureId);
                        if (!nativeFeature) {
                            return this.getThirdPartyFeatureStatus(dto.featureId);
                        }
                        if (nativeFeature.deprecated) {
                            return this.getDeprecatedNativeFeatureStatus({
                                nativeFeature,
                                hasPaidAnyPartyOnlineOrOfflineSubscription: dto.hasPaidAnyPartyOnlineOrOfflineSubscription
                            });
                        }
                        return this.getNativeFeatureFeatureStatus({
                            nativeFeature,
                            firstPartyOnlineSubscription: dto.firstPartyOnlineSubscription,
                            firstPartyRoles: dto.firstPartyRoles,
                            inContextOfItem: dto.inContextOfItem
                        });
                    }
                    findNativeFeature(featureId) {
                        return (0, features_dist.FindNativeFeature)(featureId.value);
                    }
                    getDeprecatedNativeFeatureStatus(dto) {
                        if (dto.hasPaidAnyPartyOnlineOrOfflineSubscription) {
                            return services_src /* FeatureStatus */.iKc.Entitled;
                        }
                        else {
                            return services_src /* FeatureStatus */.iKc.NoUserSubscription;
                        }
                    }
                    getNativeFeatureFeatureStatus(dto) {
                        if (dto.inContextOfItem) {
                            const isSharedVaultItem = dto.inContextOfItem.shared_vault_uuid !== undefined;
                            if (isSharedVaultItem) {
                                return services_src /* FeatureStatus */.iKc.Entitled;
                            }
                        }
                        if (!dto.firstPartyOnlineSubscription && !dto.firstPartyRoles) {
                            return services_src /* FeatureStatus */.iKc.NoUserSubscription;
                        }
                        const roles = !dto.firstPartyRoles ? undefined : 'online' in dto.firstPartyRoles ? dto.firstPartyRoles.online : dto.firstPartyRoles.offline;
                        if (dto.nativeFeature.availableInRoles && roles) {
                            const hasRole = roles.some(role => {
                                var _a;
                                return (_a = dto.nativeFeature.availableInRoles) === null || _a === void 0 ? void 0 : _a.includes(role);
                            });
                            if (!hasRole) {
                                return services_src /* FeatureStatus */.iKc.NotInCurrentPlan;
                            }
                        }
                        if (dto.firstPartyOnlineSubscription) {
                            const isSubscriptionExpired = new Date((0, dist.convertTimestampToMilliseconds)(dto.firstPartyOnlineSubscription.endsAt)) < new Date();
                            if (isSubscriptionExpired) {
                                return services_src /* FeatureStatus */.iKc.InCurrentPlanButExpired;
                            }
                        }
                        return services_src /* FeatureStatus */.iKc.Entitled;
                    }
                    getThirdPartyFeatureStatus(uuid) {
                        const component = this.items.getDisplayableComponents().find(candidate => candidate.uuid === uuid.value);
                        if (!component) {
                            return services_src /* FeatureStatus */.iKc.NoUserSubscription;
                        }
                        if (component.isExpired) {
                            return services_src /* FeatureStatus */.iKc.InCurrentPlanButExpired;
                        }
                        return services_src /* FeatureStatus */.iKc.Entitled;
                    }
                    isFreeFeature(featureId) {
                        return [features_dist.NativeFeatureIdentifier.TYPES.DarkTheme, features_dist.NativeFeatureIdentifier.TYPES.PlainEditor, features_dist.NativeFeatureIdentifier.TYPES.ProtonTheme].includes(featureId.value);
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/Features/FeaturesService.ts
                var FeaturesService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class FeaturesService extends services_src /* AbstractService */.wcN {
                    constructor(storage, items, mutator, subscriptions, api, sockets, settings, user, sync, alerts, sessions, crypto, logger, isApplicationUsingThirdPartyHostUseCase, internalEventBus) {
                        super(internalEventBus);
                        this.storage = storage;
                        this.items = items;
                        this.mutator = mutator;
                        this.subscriptions = subscriptions;
                        this.api = api;
                        this.settings = settings;
                        this.user = user;
                        this.sync = sync;
                        this.alerts = alerts;
                        this.sessions = sessions;
                        this.crypto = crypto;
                        this.logger = logger;
                        this.isApplicationUsingThirdPartyHostUseCase = isApplicationUsingThirdPartyHostUseCase;
                        this.internalEventBus = internalEventBus;
                        this.onlineRoles = [];
                        this.offlineRoles = [];
                        this.enabledExperimentalFeatures = [];
                        this.getFeatureStatusUseCase = new GetFeatureStatusUseCase(this.items);
                        this.PROD_OFFLINE_FEATURES_URL = 'https://api.standardnotes.com/v1/offline/features';
                        this.eventDisposers.push(sockets.addEventObserver((eventName, data) => FeaturesService_awaiter(this, void 0, void 0, function* () {
                            if (eventName === services_src /* WebSocketsServiceEvent */.fAX.UserRoleMessageReceived) {
                                const currentRoles = data.payload.currentRoles;
                                void this.updateOnlineRolesWithNewValues(currentRoles);
                            }
                        })));
                        this.eventDisposers.push(subscriptions.addEventObserver(event => {
                            if (event === services_src /* SubscriptionManagerEvent */.lKe.DidFetchSubscription) {
                                void this.notifyEvent(services_src /* FeaturesEvent */.Usi.FeaturesAvailabilityChanged);
                            }
                        }));
                        this.eventDisposers.push(this.items.addObserver(src.ContentType.TYPES.ExtensionRepo, _ref => {
                            let { changed, inserted, source } = _ref;
                            return FeaturesService_awaiter(this, void 0, void 0, function* () {
                                const sources = [models_dist.PayloadEmitSource.InitialObserverRegistrationPush, models_dist.PayloadEmitSource.LocalInserted, models_dist.PayloadEmitSource.LocalDatabaseLoaded, models_dist.PayloadEmitSource.RemoteRetrieved, models_dist.PayloadEmitSource.FileImport];
                                if (sources.includes(source)) {
                                    const items = [...changed, ...inserted];
                                    if (this.sessions.isSignedIntoFirstPartyServer()) {
                                        void this.migrateFeatureRepoToUserSetting(items);
                                    }
                                    else {
                                        void this.migrateFeatureRepoToOfflineEntitlements(items);
                                    }
                                }
                            });
                        }));
                        this.eventDisposers.push(this.user.addEventObserver(eventName => {
                            if (eventName === services_src /* AccountEvent */.oF7.SignedInOrRegistered) {
                                const featureRepos = this.items.getItems(src.ContentType.TYPES.ExtensionRepo);
                                const isThirdPartyHostUsedOrError = this.isApplicationUsingThirdPartyHostUseCase.execute();
                                if (isThirdPartyHostUsedOrError.isFailed()) {
                                    return;
                                }
                                const isThirdPartyHostUsed = isThirdPartyHostUsedOrError.getValue();
                                if (!isThirdPartyHostUsed) {
                                    void this.migrateFeatureRepoToUserSetting(featureRepos);
                                }
                            }
                        }));
                    }
                    initializeFromDisk() {
                        this.onlineRoles = this.storage.getValue(services_src /* StorageKey */.QtK.UserRoles, undefined, []);
                        this.offlineRoles = this.storage.getValue(services_src /* StorageKey */.QtK.OfflineUserRoles, undefined, []);
                        this.enabledExperimentalFeatures = this.storage.getValue(services_src /* StorageKey */.QtK.ExperimentalFeatures, undefined, []);
                    }
                    handleEvent(event) {
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case services_src /* ApiServiceEvent */.Sf$.MetaReceived:
                                    {
                                        if (!this.sync) {
                                            this.logger.warn('Handling events interrupted. Sync service is not yet initialized.', event);
                                            return;
                                        }
                                        const { userRoles } = event.payload;
                                        void this.updateOnlineRolesWithNewValues(userRoles.map(role => role.name));
                                        break;
                                    }
                                case services_src /* ApplicationEvent */.n9K.ApplicationStageChanged:
                                    {
                                        const stage = event.payload.stage;
                                        switch (stage) {
                                            case services_src /* ApplicationStage */.Ugm.StorageDecrypted_09:
                                                {
                                                    this.initializeFromDisk();
                                                    break;
                                                }
                                            case services_src /* ApplicationStage */.Ugm.FullSyncCompleted_13:
                                                {
                                                    if (!this.hasFirstPartyOnlineSubscription()) {
                                                        const offlineRepo = this.getOfflineRepo();
                                                        if (offlineRepo) {
                                                            void this.downloadOfflineRoles(offlineRepo);
                                                        }
                                                    }
                                                    break;
                                                }
                                        }
                                    }
                            }
                        });
                    }
                    enableExperimentalFeature(identifier) {
                        this.enabledExperimentalFeatures.push(identifier);
                        void this.storage.setValue(services_src /* StorageKey */.QtK.ExperimentalFeatures, this.enabledExperimentalFeatures);
                        void this.notifyEvent(services_src /* FeaturesEvent */.Usi.FeaturesAvailabilityChanged);
                    }
                    disableExperimentalFeature(identifier) {
                        (0, dist.removeFromArray)(this.enabledExperimentalFeatures, identifier);
                        void this.storage.setValue(services_src /* StorageKey */.QtK.ExperimentalFeatures, this.enabledExperimentalFeatures);
                        const component = this.items.getItems([src.ContentType.TYPES.Component, src.ContentType.TYPES.Theme]).find(component => component.identifier === identifier);
                        if (!component) {
                            return;
                        }
                        void this.mutator.setItemToBeDeleted(component).then(() => {
                            void this.sync.sync();
                        });
                        void this.notifyEvent(services_src /* FeaturesEvent */.Usi.FeaturesAvailabilityChanged);
                    }
                    toggleExperimentalFeature(identifier) {
                        if (this.isExperimentalFeatureEnabled(identifier)) {
                            this.disableExperimentalFeature(identifier);
                        }
                        else {
                            this.enableExperimentalFeature(identifier);
                        }
                    }
                    getExperimentalFeatures() {
                        return features_dist.ExperimentalFeatures;
                    }
                    isExperimentalFeature(featureId) {
                        return this.getExperimentalFeatures().includes(featureId);
                    }
                    getEnabledExperimentalFeatures() {
                        return this.enabledExperimentalFeatures;
                    }
                    isExperimentalFeatureEnabled(featureId) {
                        return this.enabledExperimentalFeatures.includes(featureId);
                    }
                    setOfflineFeaturesCode(code) {
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            try {
                                const result = this.parseOfflineEntitlementsCode(code);
                                if (result instanceof responses_dist.ClientDisplayableError) {
                                    return result;
                                }
                                const offlineRepo = yield this.mutator.createItem(src.ContentType.TYPES.ExtensionRepo, (0, models_dist.FillItemContent)({
                                    offlineFeaturesUrl: result.featuresUrl,
                                    offlineKey: result.extensionKey,
                                    migratedToOfflineEntitlements: true
                                }), true);
                                void this.sync.sync();
                                return this.downloadOfflineRoles(offlineRepo);
                            }
                            catch (err) {
                                return new responses_dist.ClientDisplayableError("".concat(services_src /* API_MESSAGE_FAILED_OFFLINE_ACTIVATION */.iMd, ", ").concat(JSON.stringify(err)));
                            }
                        });
                    }
                    getOfflineRepo() {
                        const repos = this.items.getItems(src.ContentType.TYPES.ExtensionRepo);
                        return repos.filter(repo => repo.migratedToOfflineEntitlements)[0];
                    }
                    hasOfflineRepo() {
                        return this.getOfflineRepo() != undefined;
                    }
                    deleteOfflineFeatureRepo() {
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            const repo = this.getOfflineRepo();
                            if (repo) {
                                yield this.mutator.setItemToBeDeleted(repo);
                                void this.sync.sync();
                            }
                        });
                    }
                    parseOfflineEntitlementsCode(code) {
                        try {
                            const activationCodeWithoutSpaces = code.replace(/\s/g, '');
                            const decodedData = this.crypto.base64Decode(activationCodeWithoutSpaces);
                            const { featuresUrl, extensionKey, subscriptionId } = JSON.parse(decodedData);
                            return {
                                featuresUrl,
                                extensionKey,
                                subscriptionId
                            };
                        }
                        catch (error) {
                            return new responses_dist.ClientDisplayableError(services_src /* API_MESSAGE_FAILED_OFFLINE_ACTIVATION */.iMd);
                        }
                    }
                    downloadOfflineRoles(repo) {
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            const result = yield this.api.downloadOfflineFeaturesFromRepo({
                                repo
                            });
                            if (result instanceof responses_dist.ClientDisplayableError) {
                                return result;
                            }
                            this.setOfflineRoles(result.roles);
                        });
                    }
                    migrateFeatureRepoToUserSetting() {
                        let featureRepos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            const usecase = new MigrateFeatureRepoToUserSettingUseCase(this.mutator, this.settings);
                            yield usecase.execute(featureRepos);
                        });
                    }
                    migrateFeatureRepoToOfflineEntitlements() {
                        let featureRepos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            const usecase = new MigrateFeatureRepoToOfflineEntitlementsUseCase(this.mutator);
                            const updatedRepos = yield usecase.execute({
                                featureRepos,
                                prodOfflineFeaturesUrl: this.PROD_OFFLINE_FEATURES_URL
                            });
                            if (updatedRepos.length > 0) {
                                yield this.downloadOfflineRoles(updatedRepos[0]);
                            }
                            for (const repo of featureRepos) {
                                yield this.downloadOfflineRoles(repo);
                            }
                        });
                    }
                    hasPaidAnyPartyOnlineOrOfflineSubscription() {
                        return this.onlineRolesIncludePaidSubscription() || this.hasOfflineRepo() || this.hasFirstPartyOnlineSubscription();
                    }
                    hasFirstPartyOnlineSubscription() {
                        return this.sessions.isSignedIntoFirstPartyServer() && this.subscriptions.hasOnlineSubscription();
                    }
                    hasFirstPartyOfflineSubscription() {
                        const offlineRepo = this.getOfflineRepo();
                        if (!offlineRepo || !offlineRepo.content.offlineFeaturesUrl) {
                            return false;
                        }
                        const hasFirstPartyOfflineSubscription = offlineRepo.content.offlineFeaturesUrl === this.PROD_OFFLINE_FEATURES_URL;
                        return hasFirstPartyOfflineSubscription || new URL(offlineRepo.content.offlineFeaturesUrl).hostname === 'localhost';
                    }
                    updateOnlineRolesWithNewValues(roles) {
                        return FeaturesService_awaiter(this, void 0, void 0, function* () {
                            const previousRoles = this.onlineRoles;
                            const userRolesChanged = roles.some(role => !this.onlineRoles.includes(role)) || this.onlineRoles.some(role => !roles.includes(role));
                            if (!userRolesChanged) {
                                return;
                            }
                            this.setOnlineRoles(roles);
                            const isInitialLoadRolesChange = previousRoles.length === 0;
                            if (!isInitialLoadRolesChange) {
                                const changedRoles = roles.filter(role => !previousRoles.includes(role));
                                const changedRolesIncludePaidSubscription = this.rolesIncludePaidSubscription(changedRoles);
                                if (changedRolesIncludePaidSubscription) {
                                    yield this.notifyEvent(services_src /* FeaturesEvent */.Usi.DidPurchaseSubscription);
                                }
                            }
                        });
                    }
                    setOnlineRoles(roles) {
                        const rolesChanged = !(0, dist.arraysEqual)(this.onlineRoles, roles);
                        this.onlineRoles = roles;
                        if (rolesChanged) {
                            void this.notifyEvent(services_src /* FeaturesEvent */.Usi.UserRolesChanged);
                        }
                        this.storage.setValue(services_src /* StorageKey */.QtK.UserRoles, this.onlineRoles);
                    }
                    setOfflineRoles(roles) {
                        const rolesChanged = !(0, dist.arraysEqual)(this.offlineRoles, roles);
                        this.offlineRoles = roles;
                        if (rolesChanged) {
                            void this.notifyEvent(services_src /* FeaturesEvent */.Usi.UserRolesChanged);
                        }
                        this.storage.setValue(services_src /* StorageKey */.QtK.OfflineUserRoles, this.offlineRoles);
                    }
                    isThirdPartyFeature(identifier) {
                        const isNativeFeature = !!(0, features_dist.FindNativeFeature)(identifier);
                        return !isNativeFeature;
                    }
                    rolesIncludePaidSubscription(roles) {
                        const paidRoles = [src.RoleName.NAMES.PlusUser, src.RoleName.NAMES.ProUser];
                        return roles.some(role => paidRoles.includes(role));
                    }
                    onlineRolesIncludePaidSubscription() {
                        return this.rolesIncludePaidSubscription(this.onlineRoles);
                    }
                    rolesBySorting(roles) {
                        return Object.values(src.RoleName.NAMES).filter(role => roles.includes(role));
                    }
                    hasRole(roleName) {
                        return this.onlineRoles.includes(roleName.value) || this.offlineRoles.includes(roleName.value);
                    }
                    hasMinimumRole(role) {
                        const sortedAllRoles = Object.values(src.RoleName.NAMES);
                        const sortedUserRoles = this.rolesBySorting(this.hasFirstPartyOnlineSubscription() ? this.onlineRoles : this.offlineRoles);
                        const highestUserRoleIndex = sortedAllRoles.indexOf((0, dist.lastElement)(sortedUserRoles));
                        const indexOfRoleToCheck = sortedAllRoles.indexOf(role);
                        return indexOfRoleToCheck <= highestUserRoleIndex;
                    }
                    getFeatureStatus(featureId) {
                        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        return this.getFeatureStatusUseCase.execute({
                            featureId,
                            firstPartyRoles: this.hasFirstPartyOnlineSubscription() ? {
                                online: this.onlineRoles
                            } : this.hasFirstPartyOfflineSubscription() ? {
                                offline: this.offlineRoles
                            } : undefined,
                            hasPaidAnyPartyOnlineOrOfflineSubscription: this.hasPaidAnyPartyOnlineOrOfflineSubscription(),
                            firstPartyOnlineSubscription: this.hasFirstPartyOnlineSubscription() ? this.subscriptions.getOnlineSubscription() : undefined,
                            inContextOfItem: options.inContextOfItem
                        });
                    }
                    deinit() {
                        super.deinit();
                        this.onlineRoles = undefined;
                        this.offlineRoles = undefined;
                        this.storage = undefined;
                        this.items = undefined;
                        this.mutator = undefined;
                        this.api = undefined;
                        this.subscriptions = undefined;
                        this.settings = undefined;
                        this.user = undefined;
                        this.sync = undefined;
                        this.alerts = undefined;
                        this.sessions = undefined;
                        this.crypto = undefined;
                    }
                }
                /***/ 
            }),
            /***/ 29675: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ E: () => ( /* binding */HistoryManager)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                /** The amount of revisions per item above which should call for an optimization. */
                const DefaultItemRevisionsThreshold = 20;
                /**
                 * The amount of characters added or removed that
                 * constitute a keepable entry after optimization.
                 */
                const LargeEntryDeltaThreshold = 25;
                /**
                 * The history manager is responsible for:
                 * 1. Transient session history, which include keeping track of changes made in the
                 *    current application session. These change logs (unless otherwise configured) are
                 *    ephemeral and do not persist past application restart. Session history entries are
                 *    added via change observers that trigger when an item changes.
                 * 2. Remote server history. Entries are automatically added by the server and must be
                 *    retrieved per item via an API call.
                 */
                class HistoryManager extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(itemManager, storageService, deviceInterface, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.storageService = storageService;
                        this.deviceInterface = deviceInterface;
                        this.internalEventBus = internalEventBus;
                        /**
                         * When no history exists for an item yet, we first put it in the staging map.
                         * Then, the next time the item changes and it has no history, we check the staging map.
                         * If the entry from the staging map differs from the incoming change, we now add the incoming
                         * change to the history map and remove it from staging. This is a way to detect when the first
                         * actual change of an item occurs (especially new items), rather than tracking a change
                         * as an item propagating through the different PayloadSource
                         * lifecycles (created, local saved, presyncsave, etc)
                         */
                        this.historyStaging = {};
                        this.history = {};
                        this.itemRevisionThreshold = DefaultItemRevisionsThreshold;
                        this.removeChangeObserver = this.itemManager.addObserver(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.ContentType.TYPES.Note, _ref => {
                            let { changed, inserted } = _ref;
                            this.recordNewHistoryForItems(changed.concat(inserted));
                        });
                    }
                    deinit() {
                        ;
                        this.itemManager = undefined;
                        this.storageService = undefined;
                        this.history = undefined;
                        if (this.removeChangeObserver) {
                            this.removeChangeObserver();
                            this.removeChangeObserver = undefined;
                        }
                        super.deinit();
                    }
                    recordNewHistoryForItems(items) {
                        for (const item of items) {
                            const itemHistory = this.history[item.uuid] || [];
                            const latestEntry = _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.historyMapFunctions.getNewestRevision(itemHistory);
                            const historyPayload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DecryptedPayload(item.payload);
                            const currentValueEntry = _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateHistoryEntryForPayload(historyPayload, latestEntry);
                            if (currentValueEntry.isDiscardable()) {
                                continue;
                            }
                            /**
                             * For every change that comes in, first add it to the staging area.
                             * Then, only on the next subsequent change do we add this previously
                             * staged entry
                             */
                            const stagedEntry = this.historyStaging[item.uuid];
                            /** Add prospective to staging, and consider now adding previously staged as new revision */
                            this.historyStaging[item.uuid] = currentValueEntry;
                            if (!stagedEntry) {
                                continue;
                            }
                            if (stagedEntry.isSameAsEntry(currentValueEntry)) {
                                continue;
                            }
                            if (latestEntry && stagedEntry.isSameAsEntry(latestEntry)) {
                                continue;
                            }
                            itemHistory.unshift(stagedEntry);
                            this.history[item.uuid] = itemHistory;
                            this.optimizeHistoryForItem(item.uuid);
                        }
                    }
                    sessionHistoryForItem(item) {
                        return this.history[item.uuid] || [];
                    }
                    getHistoryMapCopy() {
                        const copy = Object.assign({}, this.history);
                        for (const [key, value] of Object.entries(copy)) {
                            copy[key] = value.slice();
                        }
                        return Object.freeze(copy);
                    }
                    /**
                     * Clean up if there are too many revisions. Note itemRevisionThreshold
                     * is the amount of revisions which above, call for an optimization. An
                     * optimization may not remove entries above this threshold. It will
                     * determine what it should keep and what it shouldn't. So, it is possible
                     * to have a threshold of 60 but have 600 entries, if the item history deems
                     * those worth keeping.
                     *
                     * Rules:
                     * - Keep an entry if it is the oldest entry
                     * - Keep an entry if it is the latest entry
                     * - Keep an entry if it is Significant
                     * - If an entry is Significant and it is a deletion change, keep the entry before this entry.
                     */
                    optimizeHistoryForItem(uuid) {
                        const entries = this.history[uuid] || [];
                        if (entries.length <= this.itemRevisionThreshold) {
                            return;
                        }
                        const isEntrySignificant = entry => {
                            return entry.deltaSize() > LargeEntryDeltaThreshold;
                        };
                        const keepEntries = [];
                        const processEntry = (entry, index, keep) => {
                            /**
                             * Entries may be processed retrospectively, meaning it can be
                             * decided to be deleted, then an upcoming processing can change that.
                             */
                            if (keep) {
                                keepEntries.unshift(entry);
                                if (isEntrySignificant(entry) && entry.operationVector() === -1) {
                                    /** This is a large negative change. Hang on to the previous entry. */
                                    const previousEntry = entries[index + 1];
                                    if (previousEntry) {
                                        keepEntries.unshift(previousEntry);
                                    }
                                }
                            }
                            else {
                                /** Don't keep, remove if in keep */
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.removeFromArray)(keepEntries, entry);
                            }
                        };
                        for (let index = entries.length - 1; index >= 0; index--) {
                            const entry = entries[index];
                            const isSignificant = index === 0 || index === entries.length - 1 || isEntrySignificant(entry);
                            processEntry(entry, index, isSignificant);
                        }
                        const filtered = entries.filter(entry => {
                            return keepEntries.includes(entry);
                        });
                        this.history[uuid] = filtered;
                    }
                }
                /***/ 
            }),
            /***/ 45447: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ A: () => ( /* binding */ItemManager)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _Migrations_Applicators_TagsToFolders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38529);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The item manager is backed by the payload manager. It listens for change events from the
                 * global payload manager, and converts any payloads to items, then propagates those items to
                 * listeners on the item manager. When the item manager makes a change to an item, it will modify
                 * items using a mutator, then emit those payloads to the payload manager. The payload manager
                 * will then notify its observers (which is us), we'll convert the payloads to items,
                 * and then we'll propagate them to our listeners.
                 */
                class ItemManager extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .AbstractService */.wcN {
                    constructor(payloadManager, internalEventBus) {
                        super(internalEventBus);
                        this.payloadManager = payloadManager;
                        this.internalEventBus = internalEventBus;
                        this.observers = [];
                        this.streamDisposers = [];
                        this.payloadManager = payloadManager;
                        this.systemSmartViews = this.rebuildSystemSmartViews({});
                        this.createCollection();
                        this.unsubChangeObserver = this.payloadManager.addObserver(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Any, this.setPayloads.bind(this));
                    }
                    rebuildSystemSmartViews(criteria) {
                        this.systemSmartViews = _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.BuildSmartViews(criteria);
                        return this.systemSmartViews;
                    }
                    getCollection() {
                        return this.collection;
                    }
                    createCollection() {
                        var _a;
                        this.collection = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemCollection();
                        this.navigationDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Note, _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.File], {
                            sortBy: 'created_at',
                            sortDirection: 'dsc',
                            hiddenContentTypes: []
                        });
                        this.tagDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Tag], {
                            sortBy: 'title',
                            sortDirection: 'asc'
                        });
                        this.itemsKeyDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.ItemsKey], {
                            sortBy: 'created_at',
                            sortDirection: 'asc'
                        });
                        this.componentDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Component], {
                            sortBy: 'created_at',
                            sortDirection: 'asc'
                        });
                        this.themeDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Theme], {
                            sortBy: 'title',
                            sortDirection: 'asc'
                        });
                        this.smartViewDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.SmartView], {
                            sortBy: 'title',
                            sortDirection: 'asc'
                        });
                        this.fileDisplayController = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemDisplayController(this.collection, [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.File], {
                            sortBy: 'title',
                            sortDirection: 'asc'
                        });
                        this.itemCounter = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ItemCounter(this.collection, (_a = this.itemCounter) === null || _a === void 0 ? void 0 : _a.observers);
                    }
                    get allDisplayControllers() {
                        return [this.navigationDisplayController, this.tagDisplayController, this.itemsKeyDisplayController, this.componentDisplayController, this.themeDisplayController, this.smartViewDisplayController, this.fileDisplayController];
                    }
                    get invalidItems() {
                        return this.collection.invalidElements();
                    }
                    get invalidNonVaultedItems() {
                        return this.invalidItems.filter(item => !item.key_system_identifier);
                    }
                    createItemFromPayload(payload) {
                        return _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CreateDecryptedItemFromPayload(payload);
                    }
                    createPayloadFromObject(object) {
                        return new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DecryptedPayload(object);
                    }
                    setPrimaryItemDisplayOptions(options) {
                        var _a, _b;
                        const override = {};
                        const additionalFilters = [];
                        if (options.views && options.views.find(view => view.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.AllNotes)) {
                            if (options.includeArchived === undefined) {
                                override.includeArchived = false;
                            }
                            if (options.includeTrashed === undefined) {
                                override.includeTrashed = false;
                            }
                        }
                        if (options.views && options.views.find(view => view.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.ArchivedNotes)) {
                            if (options.includeTrashed === undefined) {
                                override.includeTrashed = false;
                            }
                        }
                        if (options.views && options.views.find(view => view.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.TrashedNotes)) {
                            if (!options.includeArchived) {
                                override.includeArchived = true;
                            }
                        }
                        if (options.views && options.views.find(view => view.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.Conflicts)) {
                            additionalFilters.push(item => this.collection.conflictsOf(item.uuid).length > 0);
                        }
                        this.rebuildSystemSmartViews(Object.assign(Object.assign({}, options), override));
                        const mostRecentVersionOfTags = (_a = options.tags) === null || _a === void 0 ? void 0 : _a.map(tag => {
                            return this.collection.find(tag.uuid);
                        }).filter(tag => tag != undefined);
                        const mostRecentVersionOfViews = (_b = options.views) === null || _b === void 0 ? void 0 : _b.map(view => {
                            if (_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isSystemView(view)) {
                                return this.systemSmartViews.find(systemView => systemView.uuid === view.uuid);
                            }
                            return this.collection.find(view.uuid);
                        }).filter(view => view != undefined);
                        const updatedOptions = Object.assign(Object.assign(Object.assign({}, options), override), {
                            tags: mostRecentVersionOfTags,
                            views: mostRecentVersionOfViews,
                            hiddenContentTypes: [_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Tag]
                        });
                        if (updatedOptions.sortBy === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CollectionSort.Title) {
                            updatedOptions.sortDirection = updatedOptions.sortDirection === 'asc' ? 'dsc' : 'asc';
                        }
                        this.navigationDisplayController.setDisplayOptions(Object.assign({
                            customFilter: _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.computeUnifiedFilterForDisplayOptions(updatedOptions, this.collection, additionalFilters)
                        }, updatedOptions));
                        this.itemCounter.setDisplayOptions(updatedOptions);
                    }
                    setTagsAndViewsDisplayOptions(options) {
                        const updatedOptions = Object.assign({
                            customFilter: _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.computeUnifiedFilterForDisplayOptions(options, this.collection)
                        }, options);
                        this.tagDisplayController.setDisplayOptions(updatedOptions);
                        this.smartViewDisplayController.setDisplayOptions(updatedOptions);
                    }
                    setVaultDisplayOptions(options) {
                        this.navigationDisplayController.setVaultDisplayOptions(options);
                        this.tagDisplayController.setVaultDisplayOptions(options);
                        this.smartViewDisplayController.setVaultDisplayOptions(options);
                        this.fileDisplayController.setVaultDisplayOptions(options);
                        this.itemCounter.setVaultDisplayOptions(options);
                    }
                    getDisplayableNotes() {
                        (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.assert)(this.navigationDisplayController.contentTypes.length === 2);
                        return this.navigationDisplayController.items().filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isNote);
                    }
                    getDisplayableFiles() {
                        return this.fileDisplayController.items();
                    }
                    getDisplayableNotesAndFiles() {
                        return this.navigationDisplayController.items();
                    }
                    getDisplayableTags() {
                        return this.tagDisplayController.items();
                    }
                    getDisplayableItemsKeys() {
                        return this.itemsKeyDisplayController.items();
                    }
                    getDisplayableComponents() {
                        return [...this.componentDisplayController.items(), ...this.themeDisplayController.items()];
                    }
                    deinit() {
                        this.unsubChangeObserver();
                        this.streamDisposers.length = 0;
                        this.unsubChangeObserver = undefined;
                        this.payloadManager = undefined;
                        this.collection = undefined;
                        this.itemCounter = undefined;
                        this.tagDisplayController = undefined;
                        this.navigationDisplayController = undefined;
                        this.itemsKeyDisplayController = undefined;
                        this.componentDisplayController = undefined;
                        this.themeDisplayController = undefined;
                        this.fileDisplayController = undefined;
                        this.smartViewDisplayController = undefined;
                    }
                    resetState() {
                        this.createCollection();
                    }
                    findItem(uuid) {
                        const itemFromCollection = this.collection.findDecrypted(uuid);
                        return itemFromCollection || this.findSystemSmartView(uuid);
                    }
                    findAnyItem(uuid) {
                        const itemFromCollection = this.collection.find(uuid);
                        return itemFromCollection || this.findSystemSmartView(uuid);
                    }
                    findAnyItems(uuids) {
                        return this.collection.findAll(uuids);
                    }
                    findSystemSmartView(uuid) {
                        return this.systemSmartViews.find(view => view.uuid === uuid);
                    }
                    findSureItem(uuid) {
                        return this.findItem(uuid);
                    }
                    findItems(uuids) {
                        return this.collection.findAllDecrypted(uuids);
                    }
                    findItemsIncludingBlanks(uuids) {
                        return this.collection.findAllDecryptedWithBlanks(uuids);
                    }
                    get items() {
                        return this.collection.nondeletedElements().filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDecryptedItem);
                    }
                    /** Unlock .items, this function includes error decrypting items */
                    allTrackedItems() {
                        return this.collection.all();
                    }
                    hasTagsNeedingFoldersMigration() {
                        return _Migrations_Applicators_TagsToFolders__WEBPACK_IMPORTED_MODULE_1__ /* .TagsToFoldersMigrationApplicator */.l.isApplicableToCurrentData(this);
                    }
                    addNoteCountChangeObserver(observer) {
                        return this.itemCounter.addCountChangeObserver(observer);
                    }
                    allCountableNotesCount() {
                        return this.itemCounter.allCountableNotesCount();
                    }
                    allCountableFilesCount() {
                        return this.itemCounter.allCountableFilesCount();
                    }
                    countableNotesForTag(tag) {
                        if (tag instanceof _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SmartView) {
                            if (tag.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.AllNotes) {
                                return this.itemCounter.allCountableNotesCount();
                            }
                            throw Error('countableItemsForTag is not meant to be used for smart views.');
                        }
                        return this.itemCounter.countableItemsForTag(tag);
                    }
                    getNoteCount() {
                        return this.noteCount;
                    }
                    addObserver(contentType, callback) {
                        if (!Array.isArray(contentType)) {
                            contentType = [contentType];
                        }
                        const observer = {
                            contentType,
                            callback
                        };
                        this.observers.push(observer);
                        const thislessObservers = this.observers;
                        return () => {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.removeFromArray)(thislessObservers, observer);
                        };
                    }
                    /**
                     * Returns the items that reference the given item, or an empty array if no results.
                     */
                    itemsReferencingItem(itemToLookupUuidFor, contentType) {
                        const uuids = this.collection.uuidsThatReferenceUuid(itemToLookupUuidFor.uuid);
                        let referencing = this.findItems(uuids);
                        if (contentType) {
                            referencing = referencing.filter(ref => {
                                return (ref === null || ref === void 0 ? void 0 : ref.content_type) === contentType;
                            });
                        }
                        return referencing;
                    }
                    /**
                     * Returns all items that an item directly references
                     */
                    referencesForItem(itemToLookupUuidFor, contentType) {
                        const item = this.findSureItem(itemToLookupUuidFor.uuid);
                        const uuids = item.references.map(ref => ref.uuid);
                        let references = this.findItems(uuids);
                        if (contentType) {
                            references = references.filter(ref => {
                                return (ref === null || ref === void 0 ? void 0 : ref.content_type) === contentType;
                            });
                        }
                        return references;
                    }
                    setPayloads(data) {
                        const { changed, inserted, discarded, ignored, unerrored, source, sourceKey } = data;
                        const createItem = payload => {
                            return _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CreateItemFromPayload(payload);
                        };
                        const affectedContentTypes = new Set();
                        const changedItems = changed.map(p => {
                            affectedContentTypes.add(p.content_type);
                            return createItem(p);
                        });
                        const insertedItems = inserted.map(p => {
                            affectedContentTypes.add(p.content_type);
                            return createItem(p);
                        });
                        const discardedItems = discarded.map(p => {
                            affectedContentTypes.add(p.content_type);
                            return new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DeletedItem(p);
                        });
                        const ignoredItems = ignored.map(p => {
                            affectedContentTypes.add(p.content_type);
                            return new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.EncryptedItem(p);
                        });
                        const unerroredItems = unerrored.map(p => {
                            affectedContentTypes.add(p.content_type);
                            return _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CreateDecryptedItemFromPayload(p);
                        });
                        const delta = {
                            changed: changedItems,
                            inserted: insertedItems,
                            discarded: discardedItems,
                            ignored: ignoredItems,
                            unerrored: unerroredItems
                        };
                        this.collection.onChange(delta);
                        this.itemCounter.onChange(delta);
                        const affectedContentTypesArray = Array.from(affectedContentTypes.values());
                        for (const controller of this.allDisplayControllers) {
                            if (controller.contentTypes.some(ct => affectedContentTypesArray.includes(ct))) {
                                controller.onCollectionChange(delta);
                            }
                        }
                        this.notifyObserversByUiAdjustingDelta(delta, source, sourceKey);
                    }
                    notifyObserversByUiAdjustingDelta(delta, source, sourceKey) {
                        const changedItems = [];
                        const insertedItems = [];
                        const changedDeleted = [];
                        const insertedDeleted = [];
                        const changedToEncrypted = [];
                        for (const item of delta.changed) {
                            if (_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDeletedItem(item)) {
                                changedDeleted.push(item);
                            }
                            else if (_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDecryptedItem(item)) {
                                changedItems.push(item);
                            }
                            else {
                                changedToEncrypted.push(item);
                            }
                        }
                        for (const item of delta.inserted) {
                            if (_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDeletedItem(item)) {
                                insertedDeleted.push(item);
                            }
                            else if (_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDecryptedItem(item)) {
                                insertedItems.push(item);
                            }
                        }
                        const itemsToRemoveFromUI = [...delta.discarded, ...changedDeleted, ...insertedDeleted, ...changedToEncrypted];
                        this.notifyObservers(changedItems, insertedItems, itemsToRemoveFromUI, delta.ignored, delta.unerrored, source, sourceKey);
                    }
                    notifyObservers(changed, inserted, removed, ignored, unerrored, source, sourceKey) {
                        const filter = (items, types) => {
                            return items.filter(item => {
                                return types.includes(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Any) || types.includes(item.content_type);
                            });
                        };
                        const frozenObservers = this.observers.slice();
                        for (const observer of frozenObservers) {
                            const filteredChanged = filter(changed, observer.contentType);
                            const filteredInserted = filter(inserted, observer.contentType);
                            const filteredDiscarded = filter(removed, observer.contentType);
                            const filteredIgnored = filter(ignored, observer.contentType);
                            const filteredUnerrored = filter(unerrored, observer.contentType);
                            if (filteredChanged.length === 0 && filteredInserted.length === 0 && filteredDiscarded.length === 0 && filteredIgnored.length === 0 && filteredUnerrored.length === 0) {
                                continue;
                            }
                            observer.callback({
                                changed: filteredChanged,
                                inserted: filteredInserted,
                                removed: filteredDiscarded,
                                ignored: filteredIgnored,
                                unerrored: filteredUnerrored,
                                source,
                                sourceKey
                            });
                        }
                    }
                    /**
                     * Returns an array of items that need to be synced.
                     */
                    getDirtyItems() {
                        return this.collection.dirtyElements().filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDecryptedOrDeletedItem);
                    }
                    createTemplateItem(contentType, content, override) {
                        const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DecryptedPayload(Object.assign(Object.assign({
                            uuid: _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.UuidGenerator.GenerateUuid(),
                            content_type: contentType,
                            content: _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.FillItemContent(content || {})
                        }, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadTimestampDefaults()), override));
                        const item = _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CreateDecryptedItemFromPayload(payload);
                        return item;
                    }
                    /**
                     * @param item item to be checked
                     * @returns Whether the item is a template (unmanaged)
                     */
                    isTemplateItem(item) {
                        return !this.findItem(item.uuid);
                    }
                    getItems(contentType) {
                        return this.collection.allDecrypted(contentType);
                    }
                    getAnyItems(contentType) {
                        return this.collection.all(contentType);
                    }
                    itemsMatchingPredicate(contentType, predicate) {
                        return this.itemsMatchingPredicates(contentType, [predicate]);
                    }
                    itemsMatchingPredicates(contentType, predicates) {
                        const subItems = this.getItems(contentType);
                        return this.subItemsMatchingPredicates(subItems, predicates);
                    }
                    subItemsMatchingPredicates(items, predicates) {
                        const results = items.filter(item => {
                            for (const predicate of predicates) {
                                if (!item.satisfiesPredicate(predicate)) {
                                    return false;
                                }
                            }
                            return true;
                        });
                        return results;
                    }
                    getRootTags() {
                        return this.getDisplayableTags().filter(tag => tag.parentId === undefined);
                    }
                    findTagByTitle(title) {
                        const lowerCaseTitle = title.toLowerCase();
                        return this.getDisplayableTags().find(tag => {
                            var _a;
                            return ((_a = tag.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === lowerCaseTitle;
                        });
                    }
                    findTagByTitleAndParent(title, parentItemToLookupUuidFor) {
                        const lowerCaseTitle = title.toLowerCase();
                        const tags = parentItemToLookupUuidFor ? this.getTagChildren(parentItemToLookupUuidFor) : this.getRootTags();
                        return tags.find(tag => {
                            var _a;
                            return ((_a = tag.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === lowerCaseTitle;
                        });
                    }
                    /**
                     * Finds tags with title or component starting with a search query and (optionally) not associated with a note
                     * @param searchQuery - The query string to match
                     * @param note - The note whose tags should be omitted from results
                     * @returns Array containing tags matching search query and not associated with note
                     */
                    searchTags(searchQuery, note) {
                        return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.naturalSort)(this.getDisplayableTags().filter(tag => {
                            const expandedTitle = this.getTagLongTitle(tag);
                            const matchesQuery = expandedTitle.toLowerCase().includes(searchQuery.toLowerCase());
                            const tagInNote = note ? this.itemsReferencingItem(note).some(item => (item === null || item === void 0 ? void 0 : item.uuid) === tag.uuid) : false;
                            return matchesQuery && !tagInNote;
                        }), 'title');
                    }
                    getTagParent(itemToLookupUuidFor) {
                        const tag = this.findItem(itemToLookupUuidFor.uuid);
                        if (!tag) {
                            return undefined;
                        }
                        const parentId = tag.parentId;
                        if (parentId) {
                            return this.findItem(parentId);
                        }
                        return undefined;
                    }
                    getDisplayableTagParent(itemToLookupUuidFor) {
                        const tag = this.findItem(itemToLookupUuidFor.uuid);
                        if (!tag) {
                            return undefined;
                        }
                        const parentId = tag.parentId;
                        if (parentId) {
                            return this.tagDisplayController.items().find(displayableTag => displayableTag.uuid === parentId);
                        }
                        return undefined;
                    }
                    getTagPrefixTitle(tag) {
                        const hierarchy = this.getTagParentChain(tag);
                        if (hierarchy.length === 0) {
                            return undefined;
                        }
                        const prefixTitle = hierarchy.map(tag => tag.title).join('/');
                        return "".concat(prefixTitle, "/");
                    }
                    getTagLongTitle(tag) {
                        const hierarchy = this.getTagParentChain(tag);
                        const tags = [...hierarchy, tag];
                        const longTitle = tags.map(tag => tag.title).join('/');
                        return longTitle;
                    }
                    getTagParentChain(itemToLookupUuidFor) {
                        const tag = this.findItem(itemToLookupUuidFor.uuid);
                        if (!tag) {
                            return [];
                        }
                        let parentId = tag.parentId;
                        const chain = [];
                        while (parentId) {
                            const parent = this.findItem(parentId);
                            if (!parent) {
                                return chain;
                            }
                            chain.unshift(parent);
                            parentId = parent.parentId;
                        }
                        return chain;
                    }
                    getTagChildren(itemToLookupUuidFor) {
                        const tag = this.findItem(itemToLookupUuidFor.uuid);
                        if (!tag) {
                            return [];
                        }
                        const tags = this.collection.elementsReferencingElement(tag, _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Tag);
                        return tags.filter(tag => tag.parentId === itemToLookupUuidFor.uuid);
                    }
                    getDeepTagChildren(itemToLookupUuidFor) {
                        const allChildren = [];
                        const children = this.getTagChildren(itemToLookupUuidFor);
                        for (const child of children) {
                            allChildren.push(child);
                            allChildren.push(...this.getDeepTagChildren(child));
                        }
                        return allChildren;
                    }
                    isTagAncestor(tagToLookUpUuidFor, childToLookUpUuidFor) {
                        const tag = this.findItem(childToLookUpUuidFor.uuid);
                        if (!tag) {
                            return false;
                        }
                        let parentId = tag.parentId;
                        while (parentId) {
                            if (parentId === tagToLookUpUuidFor.uuid) {
                                return true;
                            }
                            const parent = this.findItem(parentId);
                            if (!parent) {
                                return false;
                            }
                            parentId = parent.parentId;
                        }
                        return false;
                    }
                    isValidTagParent(parentTagToLookUpUuidFor, childToLookUpUuidFor) {
                        if (parentTagToLookUpUuidFor.uuid === childToLookUpUuidFor.uuid) {
                            return false;
                        }
                        if (this.isTagAncestor(childToLookUpUuidFor, parentTagToLookUpUuidFor)) {
                            return false;
                        }
                        return true;
                    }
                    /**
                     * Get tags for a note sorted in natural order
                     * @param item - The item whose tags will be returned
                     * @returns Array containing tags associated with an item
                     */
                    getSortedTagsForItem(item) {
                        return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.naturalSort)(this.itemsReferencingItem(item).filter(ref => {
                            return (ref === null || ref === void 0 ? void 0 : ref.content_type) === _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Tag;
                        }), 'title');
                    }
                    getUnsortedTagsForItem(item) {
                        return this.itemsReferencingItem(item).filter(ref => {
                            return (ref === null || ref === void 0 ? void 0 : ref.content_type) === _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Tag;
                        });
                    }
                    isSmartViewTitle(title) {
                        return title.startsWith(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SMART_TAG_DSL_PREFIX);
                    }
                    notesMatchingSmartView(view) {
                        const criteria = {
                            views: [view]
                        };
                        return _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.notesAndFilesMatchingOptions(criteria, this.collection.allDecrypted(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Note), this.collection);
                    }
                    get allNotesSmartView() {
                        return this.systemSmartViews.find(tag => tag.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.AllNotes);
                    }
                    get archivedSmartView() {
                        return this.systemSmartViews.find(tag => tag.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.ArchivedNotes);
                    }
                    get trashSmartView() {
                        return this.systemSmartViews.find(tag => tag.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.TrashedNotes);
                    }
                    get untaggedNotesSmartView() {
                        return this.systemSmartViews.find(tag => tag.uuid === _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.SystemViewId.UntaggedNotes);
                    }
                    get trashedItems() {
                        return this.notesMatchingSmartView(this.trashSmartView);
                    }
                    /**
                     * Returns all smart views, sorted by title.
                     */
                    getSmartViews() {
                        const userTags = this.smartViewDisplayController.items();
                        return this.systemSmartViews.concat(userTags);
                    }
                    /**
                     * The number of notes currently managed
                     */
                    get noteCount() {
                        return this.collection.all(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.Note).length;
                    }
                    /**
                     * Immediately removes all items from mapping state and notifies observers
                     * Used primarily when signing into an account and wanting to discard any current
                     * local data.
                     */
                    removeAllItemsFromMemory() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const uuids = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.Uuids)(this.items);
                            const results = [];
                            for (const uuid of uuids) {
                                const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DeleteItemMutator(this.findSureItem(uuid), /** We don't want to set as dirty, since we want to dispose of immediately. */ _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.MutationType.NonDirtying);
                                results.push(mutator.getDeletedResult());
                            }
                            yield this.payloadManager.emitPayloads(results, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadEmitSource.LocalChanged);
                            this.resetState();
                            this.payloadManager.resetState();
                        });
                    }
                    /**
                     * Important: Caller must coordinate with storage service separately to delete item from persistent database.
                     */
                    removeItemFromMemory(item) {
                        this.removeItemsFromMemory([item]);
                    }
                    /**
                     * Important: Caller must coordinate with storage service separately to delete item from persistent database.
                     */
                    removeItemsFromMemory(items) {
                        this.collection.discard(items);
                        this.payloadManager.removePayloadLocally(items.map(item => item.payload));
                        const delta = _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.CreateItemDelta({
                            discarded: items
                        });
                        const affectedContentTypes = items.map(item => item.content_type);
                        for (const controller of this.allDisplayControllers) {
                            if (controller.contentTypes.some(ct => affectedContentTypes.includes(ct))) {
                                controller.onCollectionChange(delta);
                            }
                        }
                    }
                    relationshipDirectionBetweenItems(itemA, itemB) {
                        const itemAReferencesItemB = !!itemA.references.find(reference => reference.uuid === itemB.uuid);
                        const itemBReferencesItemA = !!itemB.references.find(reference => reference.uuid === itemA.uuid);
                        return itemAReferencesItemB ? _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ItemRelationshipDirection */.uMm.AReferencesB : itemBReferencesItemA ? _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ItemRelationshipDirection */.uMm.BReferencesA : _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ItemRelationshipDirection */.uMm.NoRelationship;
                    }
                    conflictsOf(uuid) {
                        return this.collection.conflictsOf(uuid);
                    }
                    numberOfNotesWithConflicts() {
                        const uuids = this.collection.uuidsOfItemsWithConflicts();
                        const items = this.navigationDisplayController.hasExclusiveVaultOptions() ? this.navigationDisplayController.items().filter(item => _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isNote(item) && this.collection.uuidsOfItemsWithConflicts().includes(item.uuid)) : this.findItems(uuids).filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isNote);
                        return items.length;
                    }
                    getItemLinkedFiles(item) {
                        return item.content_type === _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.File ? this.referencesForItem(item).filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isFile) : this.itemsReferencingItem(item).filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isFile);
                    }
                    getItemLinkedNotes(item) {
                        return this.referencesForItem(item).filter(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isNote);
                    }
                    /**
                     * Begin streaming items to display in the UI. The stream callback will be called
                     * immediately with the present items that match the constraint, and over time whenever
                     * items matching the constraint are added, changed, or deleted.
                     */
                    streamItems(contentType, stream) {
                        const removeItemManagerObserver = this.addObserver(contentType, _ref => {
                            let { changed, inserted, removed, source } = _ref;
                            stream({
                                changed,
                                inserted,
                                removed,
                                source
                            });
                        });
                        const matches = this.getItems(contentType);
                        stream({
                            inserted: matches,
                            changed: [],
                            removed: [],
                            source: _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadEmitSource.InitialObserverRegistrationPush
                        });
                        this.streamDisposers.push(removeItemManagerObserver);
                        return () => {
                            removeItemManagerObserver();
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.removeFromArray)(this.streamDisposers, removeItemManagerObserver);
                        };
                    }
                }
                /***/ 
            }),
            /***/ 80738: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    D: () => ( /* binding */KeyRecoveryService)
                });
                // EXTERNAL MODULE: ../utils/dist/index.js
                var dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var src = __webpack_require__(20875);
                ; // CONCATENATED MODULE: ./lib/Services/KeyRecovery/Utils.ts
                function serverKeyParamsAreSafe(serverParams, clientParams) {
                    return (0, src.leftVersionGreaterThanOrEqualToRight)(serverParams.version, clientParams.version);
                }
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var services_src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var dist_src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ./lib/Services/KeyRecovery/KeyRecoveryOperation.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class KeyRecoveryOperation {
                    constructor(queueItem, itemManager, encryptionService, challengeService, clientParams, serverParams) {
                        this.queueItem = queueItem;
                        this.itemManager = itemManager;
                        this.encryptionService = encryptionService;
                        this.challengeService = challengeService;
                        this.clientParams = clientParams;
                        this.serverParams = serverParams;
                    }
                    run() {
                        return __awaiter(this, void 0, void 0, function* () {
                            let replaceLocalRootKeyWithResult = false;
                            const queueItemKeyParamsAreBetterOrEqualToClients = this.serverParams && this.clientParams && !this.clientParams.compare(this.serverParams) && this.queueItem.keyParams.compare(this.serverParams) && serverKeyParamsAreSafe(this.serverParams, this.clientParams);
                            if (queueItemKeyParamsAreBetterOrEqualToClients) {
                                const latestDecryptedItemsKey = (0, dist.dateSorted)(this.itemManager.getItems(dist_src.ContentType.TYPES.ItemsKey), 'created_at', false)[0];
                                if (!latestDecryptedItemsKey) {
                                    replaceLocalRootKeyWithResult = true;
                                }
                                else {
                                    replaceLocalRootKeyWithResult = this.queueItem.encryptedKey.created_at > latestDecryptedItemsKey.created_at;
                                }
                            }
                            const decryptionResult = yield (0, services_src /* DecryptItemsKeyByPromptingUser */.zW4)(this.queueItem.encryptedKey, this.encryptionService, this.challengeService, this.queueItem.keyParams);
                            if (decryptionResult === 'aborted') {
                                return {
                                    aborted: true
                                };
                            }
                            if (decryptionResult === 'failed') {
                                return {
                                    aborted: false
                                };
                            }
                            return {
                                rootKey: decryptionResult.rootKey,
                                replaceLocalRootKeyWithResult,
                                decryptedItemsKey: decryptionResult.decryptedKey
                            };
                        });
                    }
                }
                // EXTERNAL MODULE: ../encryption/src/index.ts + 52 modules
                var encryption_src = __webpack_require__(86999);
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../responses/dist/index.js
                var responses_dist = __webpack_require__(95658);
                ; // CONCATENATED MODULE: ./lib/Services/KeyRecovery/Types.ts
                function isSuccessResult(x) {
                    return 'rootKey' in x;
                }
                var KeyRecoveryEvent;
                (function (KeyRecoveryEvent) {
                    KeyRecoveryEvent["KeysRecovered"] = "KeysRecovered";
                })(KeyRecoveryEvent || (KeyRecoveryEvent = {}));
                ; // CONCATENATED MODULE: ./lib/Services/KeyRecovery/KeyRecoveryService.ts
                var KeyRecoveryService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The key recovery service listens to items key changes to detect any that cannot be decrypted.
                 * If it detects an items key that is not properly decrypted, it will present a key recovery
                 * wizard (using existing UI like Challenges and AlertService) that will attempt to recover
                 * the root key for those keys.
                 *
                 * When we encounter an items key we cannot decrypt, this is a sign that the user's password may
                 * have recently changed (even though their session is still valid). If the user has been
                 * previously signed in, we take this opportunity to reach out to the server to get the
                 * user's current key_params. We ensure these key params' version is equal to or greater than our own.
                
                 * - If this key's key params are equal to the retrieved parameters,
                    and this keys created date is greater than any existing valid items key,
                    or if we do not have any items keys:
                       1. Use the decryption of this key as a source of validation
                       2. If valid, replace our local root key with this new root key and emit the decrypted items key
                 * - Else, if the key params are not equal,
                     or its created date is less than an existing valid items key
                        1. Attempt to decrypt this key using its attached key paramas
                        2. If valid, emit decrypted items key. DO NOT replace local root key.
                 * - If by the end we did not find an items key with matching key params to the retrieved
                     key params, AND the retrieved key params are newer than what we have locally, we must
                     issue a sign in request to the server.
                
                 * If the user is not signed in and we detect an undecryptable items key, we present a detached
                 * recovery wizard that doesn't affect our local root key.
                 *
                 * When an items key is emitted, protocol service will automatically try to decrypt any
                 * related items that are in an errored state.
                 *
                 * In the item observer, `ignored` items represent items who have encrypted overwrite
                 * protection enabled (only items keys). This means that if the incoming payload is errored,
                 * but our current copy is not, we will ignore the incoming value until we can properly
                 * decrypt it.
                 */
                class KeyRecoveryService extends services_src /* AbstractService */.wcN {
                    constructor(itemManager, payloadManager, apiService, encryptionService, challengeService, alertService, storageService, sync, userService, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.payloadManager = payloadManager;
                        this.apiService = apiService;
                        this.encryptionService = encryptionService;
                        this.challengeService = challengeService;
                        this.alertService = alertService;
                        this.storageService = storageService;
                        this.sync = sync;
                        this.userService = userService;
                        this.internalEventBus = internalEventBus;
                        this.decryptionQueue = [];
                        this.isProcessingQueue = false;
                        this.removeItemObserver = this.payloadManager.addObserver([dist_src.ContentType.TYPES.ItemsKey], _ref => {
                            let { changed, inserted, ignored, source } = _ref;
                            if (source === models_dist.PayloadEmitSource.LocalChanged) {
                                return;
                            }
                            const changedOrInserted = changed.concat(inserted).filter(models_dist.isErrorDecryptingPayload);
                            if (changedOrInserted.length > 0) {
                                void this.handleUndecryptableItemsKeys(changedOrInserted);
                            }
                            if (ignored.length > 0) {
                                void this.handleIgnoredItemsKeys(ignored);
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.itemManager = undefined;
                        this.payloadManager = undefined;
                        this.apiService = undefined;
                        this.encryptionService = undefined;
                        this.challengeService = undefined;
                        this.alertService = undefined;
                        this.storageService = undefined;
                        this.sync = undefined;
                        this.userService = undefined;
                        this.removeItemObserver();
                        this.removeItemObserver = undefined;
                        super.deinit();
                    }
                    handleEvent(event) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            if (event.type === services_src /* ApplicationEvent */.n9K.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === services_src /* ApplicationStage */.Ugm.LoadedDatabase_12) {
                                    void this.processPersistedUndecryptables();
                                }
                            }
                        });
                    }
                    /**
                     * Ignored items keys are items keys which arrived from a remote source, which we were
                     * not able to decrypt, and for which we already had an existing items key that was
                     * properly decrypted. Since items keys key contents are immutable, if we already have a
                     * successfully decrypted version, yet we can't decrypt the new version, we should
                     * temporarily ignore the new version until we can properly decrypt it (through the recovery flow),
                     * and not overwrite the local copy.
                     *
                     * Ignored items are persisted to disk in isolated storage so that they may be decrypted
                     * whenever. When they are finally decryptable, we will emit them and update our database
                     * with the new decrypted value.
                     *
                     * When the app first launches, we will query the isolated storage to see if there are any
                     * keys we need to decrypt.
                     */
                    handleIgnoredItemsKeys(keys) {
                        let persistIncoming = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            /**
                             * Persist the keys locally in isolated storage, so that if we don't properly decrypt
                             * them in this app session, the user has a chance to later. If there already exists
                             * the same items key in this storage, replace it with this latest incoming value.
                             */
                            if (persistIncoming) {
                                this.saveToUndecryptables(keys);
                            }
                            this.addKeysToQueue(keys);
                            yield this.beginKeyRecovery();
                        });
                    }
                    handleUndecryptableItemsKeys(keys) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            this.addKeysToQueue(keys);
                            yield this.beginKeyRecovery();
                        });
                    }
                    presentKeyRecoveryWizard() {
                        const invalidKeys = this.itemManager.invalidItems.filter(i => i.content_type === dist_src.ContentType.TYPES.ItemsKey).map(i => i.payload);
                        void this.handleIgnoredItemsKeys(invalidKeys, false);
                    }
                    canAttemptDecryptionOfItem(item) {
                        if ((0, models_dist.ContentTypeUsesRootKeyEncryption)(item.content_type)) {
                            return true;
                        }
                        const keyId = item.payload.items_key_id;
                        if (!keyId) {
                            return new responses_dist.ClientDisplayableError('This item cannot be recovered.');
                        }
                        const key = this.payloadManager.findOne(keyId);
                        if (!key) {
                            return new responses_dist.ClientDisplayableError("Unable to find key ".concat(keyId, " for this item. You may try signing out and back in; if that doesn't help, check your backup files for a key with this ID and import it."));
                        }
                        return true;
                    }
                    processPersistedUndecryptables() {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            const record = this.getUndecryptables();
                            const rawPayloads = Object.values(record);
                            if (rawPayloads.length === 0) {
                                return;
                            }
                            const keys = rawPayloads.map(raw => new models_dist.EncryptedPayload(raw));
                            return this.handleIgnoredItemsKeys(keys, false);
                        });
                    }
                    getUndecryptables() {
                        return this.storageService.getValue(services_src /* StorageKey */.QtK.KeyRecoveryUndecryptableItems, services_src /* StorageValueModes */.qt7.Default, {});
                    }
                    persistUndecryptables(record) {
                        this.storageService.setValue(services_src /* StorageKey */.QtK.KeyRecoveryUndecryptableItems, record);
                    }
                    saveToUndecryptables(keys) {
                        const record = this.getUndecryptables();
                        for (const key of keys) {
                            record[key.uuid] = key.ejected();
                        }
                        this.persistUndecryptables(record);
                    }
                    removeFromUndecryptables(keyIds) {
                        const record = this.getUndecryptables();
                        for (const id of keyIds) {
                            delete record[id];
                        }
                        this.persistUndecryptables(record);
                    }
                    getClientKeyParams() {
                        return this.encryptionService.getAccountKeyParams();
                    }
                    performServerSignIn() {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            const accountPasswordChallenge = new services_src /* Challenge */.tv4([new services_src /* ChallengePrompt */.FEo(services_src /* ChallengeValidation */.tQn.None, undefined, undefined, true)], services_src /* ChallengeReason */.Ps8.Custom, true, encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryLoginFlowReason);
                            const challengeResponse = yield this.challengeService.promptForChallengeResponse(accountPasswordChallenge);
                            if (!challengeResponse) {
                                return undefined;
                            }
                            this.challengeService.completeChallenge(accountPasswordChallenge);
                            const password = challengeResponse.values[0].value;
                            const clientParams = this.getClientKeyParams();
                            const serverParams = yield this.getLatestKeyParamsFromServer(clientParams.identifier);
                            if (!serverParams || !serverKeyParamsAreSafe(serverParams, clientParams)) {
                                return;
                            }
                            const rootKey = yield this.encryptionService.computeRootKey(password, serverParams);
                            const signInResponse = yield this.userService.correctiveSignIn(rootKey);
                            if (!(0, responses_dist.isErrorResponse)(signInResponse)) {
                                void this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryRootKeyReplaced);
                                return rootKey;
                            }
                            else {
                                yield this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryLoginFlowInvalidPassword);
                                return this.performServerSignIn();
                            }
                        });
                    }
                    getWrappingKeyIfApplicable() {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            if (!this.encryptionService.hasPasscode()) {
                                return undefined;
                            }
                            const { wrappingKey, canceled } = yield this.challengeService.getWrappingKeyIfApplicable();
                            if (canceled) {
                                yield this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryPasscodeRequiredText, encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryPasscodeRequiredTitle);
                                return this.getWrappingKeyIfApplicable();
                            }
                            return wrappingKey;
                        });
                    }
                    addKeysToQueue(keys) {
                        for (const key of keys) {
                            const keyParams = this.encryptionService.getKeyEmbeddedKeyParamsFromItemsKey(key);
                            if (!keyParams) {
                                continue;
                            }
                            const queueItem = {
                                encryptedKey: key,
                                keyParams
                            };
                            this.decryptionQueue.push(queueItem);
                        }
                    }
                    readdQueueItem(queueItem) {
                        this.decryptionQueue.unshift(queueItem);
                    }
                    getLatestKeyParamsFromServer(identifier) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            const paramsResponse = yield this.apiService.getAccountKeyParams({
                                email: identifier
                            });
                            if (!(0, responses_dist.isErrorResponse)(paramsResponse)) {
                                return (0, encryption_src /* KeyParamsFromApiResponse */.LW)(paramsResponse.data);
                            }
                            else {
                                return undefined;
                            }
                        });
                    }
                    beginKeyRecovery() {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            if (this.isProcessingQueue) {
                                return;
                            }
                            this.isProcessingQueue = true;
                            const clientParams = this.getClientKeyParams();
                            let serverParams = undefined;
                            if (clientParams) {
                                serverParams = yield this.getLatestKeyParamsFromServer(clientParams.identifier);
                            }
                            const deallocedAfterNetworkRequest = this.encryptionService == undefined;
                            if (deallocedAfterNetworkRequest) {
                                return;
                            }
                            const credentialsMissing = !this.encryptionService.hasAccount() && !this.encryptionService.hasPasscode();
                            if (credentialsMissing) {
                                const rootKey = yield this.performServerSignIn();
                                if (rootKey) {
                                    const replaceLocalRootKeyWithResult = true;
                                    yield this.handleDecryptionOfAllKeysMatchingCorrectRootKey(rootKey, replaceLocalRootKeyWithResult, serverParams);
                                }
                            }
                            yield this.processQueue(serverParams);
                            if (serverParams) {
                                yield this.potentiallyPerformFallbackSignInToUpdateOutdatedLocalRootKey(serverParams);
                            }
                            if (this.sync.isOutOfSync()) {
                                void this.sync.sync({
                                    checkIntegrity: true
                                });
                            }
                        });
                    }
                    potentiallyPerformFallbackSignInToUpdateOutdatedLocalRootKey(serverParams) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            const latestClientParamsAfterAllRecoveryOperations = this.getClientKeyParams();
                            if (!latestClientParamsAfterAllRecoveryOperations) {
                                return;
                            }
                            const serverParamsDiffer = !serverParams.compare(latestClientParamsAfterAllRecoveryOperations);
                            if (serverParamsDiffer && serverKeyParamsAreSafe(serverParams, latestClientParamsAfterAllRecoveryOperations)) {
                                yield this.performServerSignIn();
                            }
                        });
                    }
                    processQueue(serverParams) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            let queueItem = this.decryptionQueue[0];
                            while (queueItem) {
                                const result = yield this.processQueueItem(queueItem, serverParams);
                                (0, dist.removeFromArray)(this.decryptionQueue, queueItem);
                                if (!isSuccessResult(result) && result.aborted) {
                                    this.isProcessingQueue = false;
                                    return;
                                }
                                queueItem = this.decryptionQueue[0];
                            }
                            this.isProcessingQueue = false;
                        });
                    }
                    processQueueItem(queueItem, serverParams) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            const clientParams = this.getClientKeyParams();
                            const operation = new KeyRecoveryOperation(queueItem, this.itemManager, this.encryptionService, this.challengeService, clientParams, serverParams);
                            const result = yield operation.run();
                            if (!isSuccessResult(result)) {
                                if (!result.aborted) {
                                    yield this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryUnableToRecover);
                                    this.readdQueueItem(queueItem);
                                }
                                return result;
                            }
                            yield this.handleDecryptionOfAllKeysMatchingCorrectRootKey(result.rootKey, result.replaceLocalRootKeyWithResult, serverParams);
                            return result;
                        });
                    }
                    handleDecryptionOfAllKeysMatchingCorrectRootKey(rootKey, replacesRootKey, serverParams) {
                        return KeyRecoveryService_awaiter(this, void 0, void 0, function* () {
                            if (replacesRootKey) {
                                const wrappingKey = yield this.getWrappingKeyIfApplicable();
                                yield this.encryptionService.setRootKey(rootKey, wrappingKey);
                            }
                            const clientKeyParams = this.getClientKeyParams();
                            const clientParamsMatchServer = clientKeyParams && serverParams && clientKeyParams.compare(serverParams);
                            const matchingKeys = this.removeElementsFromQueueForMatchingKeyParams(rootKey.keyParams).map(qItem => {
                                const needsResync = clientParamsMatchServer && !serverParams.compare(qItem.keyParams);
                                return needsResync ? qItem.encryptedKey.copy({
                                    dirty: true,
                                    dirtyIndex: (0, models_dist.getIncrementedDirtyIndex)()
                                }) : qItem.encryptedKey;
                            });
                            const matchingResults = yield this.encryptionService.decryptSplit({
                                usesRootKey: {
                                    items: matchingKeys,
                                    key: rootKey
                                }
                            });
                            const decryptedMatching = matchingResults.filter(models_dist.isDecryptedPayload);
                            void this.payloadManager.emitPayloads(decryptedMatching, models_dist.PayloadEmitSource.LocalChanged);
                            yield this.storageService.savePayloads(decryptedMatching);
                            if (replacesRootKey) {
                                void this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryRootKeyReplaced);
                            }
                            else {
                                void this.alertService.alert(encryption_src /* KeyRecoveryStrings */.fD.KeyRecoveryKeyRecovered);
                            }
                            if (decryptedMatching.some(p => p.dirty)) {
                                yield this.sync.sync();
                            }
                            yield this.notifyEvent(KeyRecoveryEvent.KeysRecovered, decryptedMatching);
                            void this.removeFromUndecryptables((0, dist.Uuids)(decryptedMatching));
                        });
                    }
                    removeElementsFromQueueForMatchingKeyParams(keyParams) {
                        const matching = [];
                        const nonmatching = [];
                        for (const queueItem of this.decryptionQueue) {
                            if (queueItem.keyParams.compare(keyParams)) {
                                matching.push(queueItem);
                            }
                            else {
                                nonmatching.push(queueItem);
                            }
                        }
                        this.decryptionQueue = nonmatching;
                        return matching;
                    }
                    getDiagnostics() {
                        return Promise.resolve({
                            keyRecovery: {
                                queueLength: this.decryptionQueue.length,
                                isProcessingQueue: this.isProcessingQueue
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 81679: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ o: () => ( /* binding */ListedService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95658);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ListedService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(apiService, itemManager, settingsService, httpSerivce, protectionService, mutator, sync, internalEventBus) {
                        super(internalEventBus);
                        this.apiService = apiService;
                        this.itemManager = itemManager;
                        this.settingsService = settingsService;
                        this.httpSerivce = httpSerivce;
                        this.protectionService = protectionService;
                        this.mutator = mutator;
                        this.sync = sync;
                        this.internalEventBus = internalEventBus;
                    }
                    deinit() {
                        ;
                        this.itemManager = undefined;
                        this.settingsService = undefined;
                        this.apiService = undefined;
                        this.httpSerivce = undefined;
                        this.protectionService = undefined;
                        this.mutator = undefined;
                        super.deinit();
                    }
                    canRegisterNewListedAccount() {
                        return this.apiService.user != undefined;
                    }
                    isNoteAuthorizedForListed(note) {
                        return note.authorizedForListed;
                    }
                    authorizeNoteForListed(note) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.protectionService.authorizeListedPublishing();
                            if (result === false) {
                                return false;
                            }
                            yield this.mutator.changeItem(note, mutator => {
                                mutator.authorizedForListed = true;
                            });
                            void this.sync.sync();
                            return true;
                        });
                    }
                    /**
                     * Account creation is asyncronous on the backend due to message-based nature of architecture.
                     * In order to get the newly created account, we poll the server to check for new accounts.
                     */
                    requestNewListedAccount() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const accountsBeforeRequest = yield this.getSettingsBasedListedAccounts();
                            const response = yield this.apiService.registerForListedAccount();
                            if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_1__.isErrorResponse)(response)) {
                                return undefined;
                            }
                            const MaxAttempts = 4;
                            const DelayBetweenRequests = 3000;
                            for (let i = 0; i < MaxAttempts; i++) {
                                const accounts = yield this.getSettingsBasedListedAccounts();
                                if (accounts.length > accountsBeforeRequest.length) {
                                    return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.lastElement)(accounts);
                                }
                                else {
                                    yield (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.sleep)(DelayBetweenRequests, false);
                                }
                            }
                            return undefined;
                        });
                    }
                    getListedAccounts() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const settingsBasedAccounts = yield this.getSettingsBasedListedAccounts();
                            const legacyAccounts = this.getLegacyListedAccounts();
                            return [...settingsBasedAccounts, ...legacyAccounts];
                        });
                    }
                    getListedAccountInfo(account, inContextOfItem) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            const hostUrl = account.hostUrl;
                            let url = "".concat(hostUrl, "/authors/").concat(account.authorId, "/extension?secret=").concat(account.secret);
                            if (inContextOfItem) {
                                url += "&item_uuid=".concat(inContextOfItem);
                            }
                            const response = yield this.httpSerivce.getAbsolute(url).catch(error => {
                                console.error(error);
                            });
                            if (!response || ((_a = response.data) === null || _a === void 0 ? void 0 : _a.error) || !response.data || (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.isString)(response.data)) {
                                return undefined;
                            }
                            return response;
                        });
                    }
                    getSettingsBasedListedAccounts() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsService.getSetting(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.SettingName.create(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.SettingName.NAMES.ListedAuthorSecrets).getValue());
                            if (!response) {
                                return [];
                            }
                            const accounts = JSON.parse(response);
                            return accounts;
                        });
                    }
                    getLegacyListedAccounts() {
                        const extensions = this.itemManager.getItems(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.ContentType.TYPES.ActionsExtension).filter(extension => extension.isListedExtension);
                        const accounts = [];
                        for (const extension of extensions) {
                            const urlString = extension.url;
                            const url = new URL(urlString);
                            /** Expected path format: '/authors/647/extension/' */
                            const path = url.pathname;
                            const authorId = path.split('/')[2];
                            /** Expected query string format: '?secret=xxx&type=sn&name=Listed' */
                            const queryString = url.search;
                            const key = queryString.split('secret=')[1].split('&')[0];
                            accounts.push({
                                secret: key,
                                authorId,
                                hostUrl: url.origin
                            });
                        }
                        return accounts;
                    }
                }
                /***/ 
            }),
            /***/ 3876: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ p: () => ( /* binding */MfaService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class MfaService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .AbstractService */.wcN {
                    constructor(settingsService, crypto, featuresService, protections, internalEventBus) {
                        super(internalEventBus);
                        this.settingsService = settingsService;
                        this.crypto = crypto;
                        this.featuresService = featuresService;
                        this.protections = protections;
                        this.internalEventBus = internalEventBus;
                    }
                    saveMfaSetting(secret) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return yield this.settingsService.updateSetting(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.create(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.NAMES.MfaSecret).getValue(), secret, true);
                        });
                    }
                    isMfaActivated() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const mfaSetting = yield this.settingsService.getDoesSensitiveSettingExist(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.create(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.NAMES.MfaSecret).getValue());
                            return mfaSetting != false;
                        });
                    }
                    generateMfaSecret() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.crypto.generateOtpSecret();
                        });
                    }
                    getOtpToken(secret) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.crypto.totpToken(secret, Date.now(), 6, 30);
                        });
                    }
                    enableMfa(secret, otpToken) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const otpTokenValid = otpToken != undefined && otpToken === (yield this.getOtpToken(secret));
                            if (!otpTokenValid) {
                                throw new Error(_standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .SignInStrings */.Mwm.IncorrectMfa);
                            }
                            return this.saveMfaSetting(secret);
                        });
                    }
                    disableMfa() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!(yield this.protections.authorizeMfaDisable())) {
                                return;
                            }
                            return yield this.settingsService.deleteSetting(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.create(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_1__.SettingName.NAMES.MfaSecret).getValue());
                        });
                    }
                    deinit() {
                        ;
                        this.settingsService = undefined;
                        this.crypto = undefined;
                        this.featuresService = undefined;
                        super.deinit();
                    }
                }
                /***/ 
            }),
            /***/ 8740: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ H: () => ( /* binding */MigrationService)
                    /* harmony export */ 
                });
                /* harmony import */ var _Lib_Migrations_Base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58386);
                /* harmony import */ var _Lib_Version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94986);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55668);
                /* harmony import */ var _Lib_Log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43361);
                /* harmony import */ var _Lib_Migrations_Versions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42798);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The migration service orchestrates the execution of multi-stage migrations.
                 * Migrations are registered during initial application launch, and listen for application
                 * life-cycle events, and act accordingly. Migrations operate on the app-level, and not global level.
                 * For example, a single migration may perform a unique set of steps when the application
                 * first launches, and also other steps after the application is unlocked, or after the
                 * first sync completes. Migrations live under /migrations and inherit from the base Migration class.
                 */
                class MigrationService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .AbstractService */.wcN {
                    constructor(services) {
                        super(services.internalEventBus);
                        this.services = services;
                    }
                    deinit() {
                        ;
                        this.services = undefined;
                        if (this.activeMigrations) {
                            this.activeMigrations.length = 0;
                        }
                        super.deinit();
                    }
                    initialize() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.runBaseMigrationPreRun();
                            const requiredMigrations = MigrationService.getRequiredMigrations(yield this.getStoredSnjsVersion());
                            this.activeMigrations = this.instantiateMigrationClasses(requiredMigrations);
                            if (this.activeMigrations.length > 0) {
                                const lastMigration = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__.lastElement)(this.activeMigrations);
                                lastMigration.onDone(() => __awaiter(this, void 0, void 0, function* () {
                                    yield this.markMigrationsAsDone();
                                }));
                            }
                            else {
                                yield this.markMigrationsAsDone();
                            }
                        });
                    }
                    markMigrationsAsDone() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.services.deviceInterface.setRawStorageValue((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .namespacedKey */.xLN)(this.services.identifier, _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .RawStorageKey */.Bq2.SnjsVersion), _Lib_Version__WEBPACK_IMPORTED_MODULE_1__ /* .SnjsVersion */["in"]);
                        });
                    }
                    runBaseMigrationPreRun() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.baseMigration = new _Lib_Migrations_Base__WEBPACK_IMPORTED_MODULE_0__ /* .BaseMigration */._(this.services);
                            yield this.baseMigration.preRun();
                        });
                    }
                    handleEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event.type === _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ApplicationEvent */.n9K.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                yield this.handleStage(stage);
                            }
                        });
                    }
                    /**
                     * Called by application
                     */
                    handleApplicationEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event === _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ApplicationEvent */.n9K.SignedIn) {
                                yield this.handleStage(_standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .ApplicationStage */.Ugm.SignedIn_30);
                            }
                        });
                    }
                    hasPendingMigrations() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const requiredMigrations = MigrationService.getRequiredMigrations(yield this.getStoredSnjsVersion());
                            return requiredMigrations.length > 0 || (yield this.baseMigration.needsKeychainRepair());
                        });
                    }
                    getStoredSnjsVersion() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const version = yield this.services.deviceInterface.getRawStorageValue((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .namespacedKey */.xLN)(this.services.identifier, _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .RawStorageKey */.Bq2.SnjsVersion));
                            if (!version) {
                                throw _Lib_Log__WEBPACK_IMPORTED_MODULE_5__ /* .SNLog */.W.error(Error('Snjs version missing from storage, run base migration.'));
                            }
                            return version;
                        });
                    }
                    static getRequiredMigrations(storedVersion) {
                        const resultingClasses = [];
                        const sortedClasses = _Lib_Migrations_Versions__WEBPACK_IMPORTED_MODULE_4__ /* .MigrationClasses */.R_.sort((a, b) => {
                            return (0, _Lib_Version__WEBPACK_IMPORTED_MODULE_1__ /* .compareSemVersions */.D8)(a.version(), b.version());
                        });
                        for (const migrationClass of sortedClasses) {
                            const migrationVersion = migrationClass.version();
                            if (migrationVersion === storedVersion) {
                                continue;
                            }
                            if ((0, _Lib_Version__WEBPACK_IMPORTED_MODULE_1__ /* .isRightVersionGreaterThanLeft */.jV)(storedVersion, migrationVersion)) {
                                resultingClasses.push(migrationClass);
                            }
                        }
                        return resultingClasses;
                    }
                    instantiateMigrationClasses(classes) {
                        return classes.map(migrationClass => {
                            return new migrationClass(this.services);
                        });
                    }
                    handleStage(stage) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.baseMigration.handleStage(stage);
                            if (!this.activeMigrations) {
                                throw new Error('Invalid active migrations');
                            }
                            for (const migration of this.activeMigrations) {
                                yield migration.handleStage(stage);
                            }
                        });
                    }
                    getDiagnostics() {
                        return Promise.resolve({
                            migrations: {
                                activeMigrations: this.activeMigrations && this.activeMigrations.map(m => typeof m)
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 28178: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ V: () => ( /* binding */MutatorService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86999);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var _Lib_Migrations_Applicators_TagsToFolders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38529);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_4__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class MutatorService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .AbstractService */.wcN {
                    constructor(itemManager, payloadManager, alerts, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.payloadManager = payloadManager;
                        this.alerts = alerts;
                        this.internalEventBus = internalEventBus;
                    }
                    deinit() {
                        super.deinit();
                        this.itemManager = undefined;
                        this.payloadManager = undefined;
                    }
                    /**
                     * Consumers wanting to modify an item should run it through this block,
                     * so that data is properly mapped through our function, and latest state
                     * is properly reconciled.
                     */
                    changeItem(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const results = yield this.changeItems([itemToLookupUuidFor], mutate, mutationType, emitSource, payloadSourceKey);
                            return results[0];
                        });
                    }
                    /**
                     * @param mutate If not supplied, the intention would simply be to mark the item as dirty.
                     */
                    changeItems(itemsToLookupUuidsFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const items = this.itemManager.findItemsIncludingBlanks((0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.Uuids)(itemsToLookupUuidsFor));
                            const payloads = [];
                            for (const item of items) {
                                if (!item) {
                                    throw Error('Attempting to change non-existant item');
                                }
                                const mutator = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.CreateDecryptedMutatorForItem)(item, mutationType);
                                if (mutate) {
                                    mutate(mutator);
                                }
                                const payload = mutator.getResult();
                                payloads.push(payload);
                            }
                            yield this.payloadManager.emitPayloads(payloads, emitSource, payloadSourceKey);
                            const results = this.itemManager.findItems(payloads.map(p => p.uuid));
                            return results;
                        });
                    }
                    /**
                     * Run unique mutations per each item in the array, then only propagate all changes
                     * once all mutations have been run. This differs from `changeItems` in that changeItems
                     * runs the same mutation on all items.
                     */
                    runTransactionalMutations(transactions) {
                        let emitSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 2 ? arguments[2] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const payloads = [];
                            for (const transaction of transactions) {
                                const item = this.itemManager.findItem(transaction.itemUuid);
                                if (!item) {
                                    continue;
                                }
                                const mutator = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.CreateDecryptedMutatorForItem)(item, transaction.mutationType || _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps);
                                transaction.mutate(mutator);
                                const payload = mutator.getResult();
                                payloads.push(payload);
                            }
                            yield this.payloadManager.emitPayloads(payloads, emitSource, payloadSourceKey);
                            const results = this.itemManager.findItems(payloads.map(p => p.uuid));
                            return results;
                        });
                    }
                    runTransactionalMutation(transaction) {
                        let emitSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 2 ? arguments[2] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const item = this.itemManager.findSureItem(transaction.itemUuid);
                            const mutator = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.CreateDecryptedMutatorForItem)(item, transaction.mutationType || _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps);
                            transaction.mutate(mutator);
                            const payload = mutator.getResult();
                            yield this.payloadManager.emitPayloads([payload], emitSource, payloadSourceKey);
                            const result = this.itemManager.findItem(payload.uuid);
                            return result;
                        });
                    }
                    changeNote(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const note = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!note) {
                                throw Error('Attempting to change non-existant note');
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.NoteMutator(note, mutationType);
                            return this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                        });
                    }
                    changeTag(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const tag = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!tag) {
                                throw Error('Attempting to change non-existant tag');
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.TagMutator(tag, mutationType);
                            yield this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                            return this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                        });
                    }
                    changeComponent(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const component = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!component) {
                                throw Error('Attempting to change non-existant component');
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.ComponentMutator(component, mutationType);
                            yield this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                            return this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                        });
                    }
                    changeFeatureRepo(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const repo = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!repo) {
                                throw Error('Attempting to change non-existant repo');
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.FeatureRepoMutator(repo, mutationType);
                            yield this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                            return this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                        });
                    }
                    changeActionsExtension(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const extension = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!extension) {
                                throw Error('Attempting to change non-existant extension');
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.ActionsExtensionMutator(extension, mutationType);
                            yield this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                            return this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                        });
                    }
                    changeItemsKey(itemToLookupUuidFor, mutate) {
                        let mutationType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps;
                        let emitSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 4 ? arguments[4] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const itemsKey = this.itemManager.findItem(itemToLookupUuidFor.uuid);
                            if (!itemsKey) {
                                throw Error('Attempting to change non-existant itemsKey');
                            }
                            const mutator = new _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .ItemsKeyMutator */.tn(itemsKey, mutationType);
                            yield this.applyTransform(mutator, mutate, emitSource, payloadSourceKey);
                            return this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                        });
                    }
                    applyTransform(mutator, mutate) {
                        let emitSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        let payloadSourceKey = arguments.length > 3 ? arguments[3] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            mutate(mutator);
                            const payload = mutator.getResult();
                            return this.payloadManager.emitPayload(payload, emitSource, payloadSourceKey);
                        });
                    }
                    /**
                     * Sets the item as needing sync. The item is then run through the mapping function,
                     * and propagated to mapping observers.
                     * @param isUserModified - Whether to update the item's "user modified date"
                     */
                    setItemDirty(itemToLookupUuidFor) {
                        let isUserModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.setItemsDirty([itemToLookupUuidFor], isUserModified);
                            return result[0];
                        });
                    }
                    setItemsDirty(itemsToLookupUuidsFor) {
                        let isUserModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.changeItems(itemsToLookupUuidsFor, undefined, isUserModified ? _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.NoUpdateUserTimestamps);
                        });
                    }
                    /**
                     * Duplicates an item and maps it, thus propagating the item to observers.
                     * @param isConflict - Whether to mark the duplicate as a conflict of the original.
                     */
                    duplicateItem(itemToLookupUuidFor) {
                        let isConflict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        let additionalContent = arguments.length > 2 ? arguments[2] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const item = this.itemManager.findSureItem(itemToLookupUuidFor.uuid);
                            const payload = item.payload.copy();
                            const resultingPayloads = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadsByDuplicating)({
                                payload,
                                baseCollection: this.payloadManager.getMasterCollection(),
                                isConflict,
                                additionalContent: Object.assign({
                                    appData: {
                                        [_standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.DefaultAppDomain]: {
                                            [_standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.AppDataField.UserModifiedDate]: new Date()
                                        }
                                    }
                                }, additionalContent)
                            });
                            yield this.payloadManager.emitPayloads(resultingPayloads, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged);
                            const duplicate = this.itemManager.findSureItem(resultingPayloads[0].uuid);
                            return duplicate;
                        });
                    }
                    createItem(contentType, content) {
                        let needsSync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let vault = arguments.length > 3 ? arguments[3] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.DecryptedPayload(Object.assign(Object.assign({
                                uuid: _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.UuidGenerator.GenerateUuid(),
                                content_type: contentType,
                                content: (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.FillItemContent)(content),
                                dirty: needsSync
                            }, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadVaultOverrides)(vault)), (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadTimestampDefaults)()));
                            yield this.payloadManager.emitPayload(payload, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalInserted);
                            return this.itemManager.findSureItem(payload.uuid);
                        });
                    }
                    insertItem(item) {
                        let setDirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        return __awaiter(this, void 0, void 0, function* () {
                            const existingItem = this.itemManager.findItem(item.uuid);
                            if (existingItem) {
                                throw Error('Attempting to insert item that already exists');
                            }
                            if (setDirty) {
                                const mutator = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.CreateDecryptedMutatorForItem)(item, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps);
                                const dirtiedPayload = mutator.getResult();
                                const insertedItem = yield this.emitItemFromPayload(dirtiedPayload, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalInserted);
                                return insertedItem;
                            }
                            else {
                                return this.emitItemFromPayload(item.payload, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged);
                            }
                        });
                    }
                    insertItems(items) {
                        let emitSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalInserted;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.emitItemsFromPayloads(items.map(item => item.payload), emitSource);
                        });
                    }
                    emitItemFromPayload(payload, emitSource) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.payloadManager.emitPayload(payload, emitSource);
                            const result = this.itemManager.findSureItem(payload.uuid);
                            if (!result) {
                                throw Error("Emitted item can't be found");
                            }
                            return result;
                        });
                    }
                    emitItemsFromPayloads(payloads, emitSource) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.payloadManager.emitPayloads(payloads, emitSource);
                            const uuids = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_5__.Uuids)(payloads);
                            return this.itemManager.findItems(uuids);
                        });
                    }
                    setItemToBeDeleted(itemToLookupUuidFor) {
                        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.PayloadEmitSource.LocalChanged;
                        return __awaiter(this, void 0, void 0, function* () {
                            const referencingIdsCapturedBeforeChanges = this.itemManager.getCollection().uuidsThatReferenceUuid(itemToLookupUuidFor.uuid);
                            const item = this.itemManager.findAnyItem(itemToLookupUuidFor.uuid);
                            if (!item) {
                                return;
                            }
                            const mutator = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.DeleteItemMutator(item, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.MutationType.UpdateUserTimestamps);
                            const deletedPayload = mutator.getDeletedResult();
                            yield this.payloadManager.emitPayload(deletedPayload, source);
                            for (const referencingId of referencingIdsCapturedBeforeChanges) {
                                const referencingItem = this.itemManager.findItem(referencingId);
                                if (referencingItem) {
                                    yield this.changeItem(referencingItem, mutator => {
                                        mutator.removeItemAsRelationship(item);
                                    });
                                }
                            }
                        });
                    }
                    setItemsToBeDeleted(itemsToLookupUuidsFor) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield Promise.all(itemsToLookupUuidsFor.map(item => this.setItemToBeDeleted(item)));
                        });
                    }
                    findOrCreateTagParentChain(titlesHierarchy) {
                        return __awaiter(this, void 0, void 0, function* () {
                            let current = undefined;
                            for (const title of titlesHierarchy) {
                                current = yield this.findOrCreateTagByTitle({
                                    title,
                                    parentItemToLookupUuidFor: current
                                });
                            }
                            if (!current) {
                                throw new Error('Invalid tag hierarchy');
                            }
                            return current;
                        });
                    }
                    createTag(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const newTag = yield this.createItem(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.Tag, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.FillItemContent)({
                                title: dto.title
                            }), true, dto.createInVault);
                            if (dto.parentItemToLookupUuidFor) {
                                const parentTag = this.itemManager.findItem(dto.parentItemToLookupUuidFor.uuid);
                                if (!parentTag) {
                                    throw new Error('Invalid parent tag');
                                }
                                return this.changeTag(newTag, m => {
                                    m.makeChildOf(parentTag);
                                });
                            }
                            return newTag;
                        });
                    }
                    createSmartView(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.createItem(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.SmartView, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.FillItemContent)({
                                title: dto.title,
                                predicate: dto.predicate.toJson(),
                                iconString: dto.iconString || _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.SmartViewDefaultIconName
                            }), true, dto.vault);
                        });
                    }
                    createSmartViewFromDSL(dsl, vault) {
                        return __awaiter(this, void 0, void 0, function* () {
                            let components = null;
                            try {
                                components = JSON.parse(dsl.substring(1, dsl.length));
                            }
                            catch (e) {
                                throw Error('Invalid smart view syntax');
                            }
                            const title = components[0];
                            const predicate = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_4__.predicateFromDSLString)(dsl);
                            return this.createSmartView({
                                title,
                                predicate,
                                vault
                            });
                        });
                    }
                    createTagOrSmartView(title, vault) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.itemManager.isSmartViewTitle(title)) {
                                return this.createSmartViewFromDSL(title, vault);
                            }
                            else {
                                return this.createTag({
                                    title,
                                    createInVault: vault
                                });
                            }
                        });
                    }
                    findOrCreateTagByTitle(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const tag = this.itemManager.findTagByTitleAndParent(dto.title, dto.parentItemToLookupUuidFor);
                            return tag || this.createTag(dto);
                        });
                    }
                    renameFile(file, name) {
                        return this.changeItem(file, mutator => {
                            mutator.name = name;
                        });
                    }
                    mergeItem(item, source) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.emitItemFromPayload(item.payloadRepresentation(), source);
                        });
                    }
                    setItemNeedsSync(item) {
                        let updateTimestamps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.setItemDirty(item, updateTimestamps);
                        });
                    }
                    setItemsNeedsSync(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.setItemsDirty(items);
                        });
                    }
                    deleteItem(item) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.deleteItems([item]);
                        });
                    }
                    deleteItems(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.setItemsToBeDeleted(items);
                        });
                    }
                    /**
                     * Permanently deletes any items currently in the trash. Consumer must manually call sync.
                     */
                    emptyTrash() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const notes = this.itemManager.trashedItems;
                            yield this.setItemsToBeDeleted(notes);
                        });
                    }
                    migrateTagsToFolders() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield _Lib_Migrations_Applicators_TagsToFolders__WEBPACK_IMPORTED_MODULE_3__ /* .TagsToFoldersMigrationApplicator */.l.run(this.itemManager, this);
                        });
                    }
                    findOrCreateTag(title, createInVault) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.findOrCreateTagByTitle({
                                title,
                                createInVault
                            });
                        });
                    }
                    /**
                     * @returns The changed child tag
                     */
                    setTagParent(parentTag, childTag) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (parentTag.uuid === childTag.uuid) {
                                throw new Error('Can not set a tag parent of itself');
                            }
                            if (this.itemManager.isTagAncestor(childTag, parentTag)) {
                                throw new Error('Can not set a tag ancestor of itself');
                            }
                            return this.changeTag(childTag, m => {
                                m.makeChildOf(parentTag);
                            });
                        });
                    }
                    /**
                     * @returns The changed child tag
                     */
                    unsetTagParent(childTag) {
                        const parentTag = this.itemManager.getTagParent(childTag);
                        if (!parentTag) {
                            return Promise.resolve(childTag);
                        }
                        return this.changeTag(childTag, m => {
                            m.unsetParent();
                        });
                    }
                    associateFileWithNote(file, note) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const isVaultConflict = file.key_system_identifier && note.key_system_identifier && file.key_system_identifier !== note.key_system_identifier;
                            if (isVaultConflict) {
                                void this.alerts.alert('The items you are trying to link belong to different vaults and cannot be linked');
                                return undefined;
                            }
                            return this.changeItem(file, mutator => {
                                mutator.addNote(note);
                            });
                        });
                    }
                    disassociateFileWithNote(file, note) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.changeItem(file, mutator => {
                                mutator.removeNote(note);
                            });
                        });
                    }
                    addTagToNote(note, tag, addHierarchy) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (tag.key_system_identifier !== note.key_system_identifier) {
                                void this.alerts.alert('The items you are trying to link belong to different vaults and cannot be linked');
                                return undefined;
                            }
                            let tagsToAdd = [tag];
                            if (addHierarchy) {
                                const parentChainTags = this.itemManager.getTagParentChain(tag);
                                tagsToAdd = [...parentChainTags, tag];
                            }
                            return Promise.all(tagsToAdd.map(tagToAdd => {
                                return this.changeTag(tagToAdd, mutator => {
                                    mutator.addNote(note);
                                });
                            }));
                        });
                    }
                    addTagToFile(file, tag, addHierarchy) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (tag.key_system_identifier !== file.key_system_identifier) {
                                void this.alerts.alert('The items you are trying to link belong to different vaults and cannot be linked');
                                return undefined;
                            }
                            let tagsToAdd = [tag];
                            if (addHierarchy) {
                                const parentChainTags = this.itemManager.getTagParentChain(tag);
                                tagsToAdd = [...parentChainTags, tag];
                            }
                            return Promise.all(tagsToAdd.map(tagToAdd => {
                                return this.changeTag(tagToAdd, mutator => {
                                    mutator.addFile(file);
                                });
                            }));
                        });
                    }
                    linkNoteToNote(note, otherNote) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.changeItem(note, mutator => {
                                mutator.addNote(otherNote);
                            });
                        });
                    }
                    linkFileToFile(file, otherFile) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.changeItem(file, mutator => {
                                mutator.addFile(otherFile);
                            });
                        });
                    }
                    unlinkItems(itemA, itemB) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const relationshipDirection = this.itemManager.relationshipDirectionBetweenItems(itemA, itemB);
                            if (relationshipDirection === _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ItemRelationshipDirection */.uMm.NoRelationship) {
                                throw new Error('Trying to unlink already unlinked items');
                            }
                            const itemToChange = relationshipDirection === _standardnotes_services__WEBPACK_IMPORTED_MODULE_0__ /* .ItemRelationshipDirection */.uMm.AReferencesB ? itemA : itemB;
                            const itemToRemove = itemToChange === itemA ? itemB : itemA;
                            return this.changeItem(itemToChange, mutator => {
                                mutator.removeItemAsRelationship(itemToRemove);
                            });
                        });
                    }
                }
                /***/ 
            }),
            /***/ 64892: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ O: () => ( /* binding */PayloadManager)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_2__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55668);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The payload manager is responsible for keeping state regarding what items exist in the
                 * global application state. It does so by exposing functions that allow consumers to 'map'
                 * a detached payload into global application state. Whenever a change is made or retrieved
                 * from any source, it must be mapped in order to be properly reflected in global application state.
                 * The model manager deals only with in-memory state, and does not deal directly with storage.
                 * It also serves as a query store, and can be queried for current notes, tags, etc.
                 * It exposes methods that allow consumers to listen to mapping events. This is how
                 * applications 'stream' items to display in the interface.
                 */
                class PayloadManager extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_3__ /* .AbstractService */.wcN {
                    constructor(logger, internalEventBus) {
                        super(internalEventBus);
                        this.logger = logger;
                        this.internalEventBus = internalEventBus;
                        this.changeObservers = [];
                        this.emitQueue = [];
                        this.collection = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadCollection();
                    }
                    /**
                     * Our payload collection keeps the latest mapped payload for every payload
                     * that passes through our mapping function. Use this to query current state
                     * as needed to make decisions, like about duplication or uuid alteration.
                     */
                    getMasterCollection() {
                        return _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.ImmutablePayloadCollection.FromCollection(this.collection);
                    }
                    deinit() {
                        super.deinit();
                        this.changeObservers.length = 0;
                        this.resetState();
                    }
                    resetState() {
                        this.collection = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadCollection();
                    }
                    find(uuids) {
                        return this.collection.findAll(uuids);
                    }
                    findOne(uuid) {
                        return this.collection.findAll([uuid])[0];
                    }
                    all(contentType) {
                        return this.collection.all(contentType);
                    }
                    get integrityPayloads() {
                        return this.collection.integrityPayloads();
                    }
                    get nonDeletedItems() {
                        return this.collection.nondeletedElements();
                    }
                    get invalidPayloads() {
                        return this.collection.invalidElements();
                    }
                    emitDeltaEmit(emit, sourceKey) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (emit.emits.length === 0 && ((_a = emit.ignored) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                                return [];
                            }
                            return new Promise(resolve => {
                                const element = {
                                    emit: emit,
                                    sourceKey,
                                    resolve
                                };
                                this.emitQueue.push(element);
                                if (this.emitQueue.length === 1) {
                                    void this.popQueue();
                                }
                            });
                        });
                    }
                    /**
                     * One of many mapping helpers available.
                     * This function maps a payload to an item
                     * @returns every paylod altered as a result of this operation, to be
                     * saved to storage by the caller
                     */
                    emitPayload(payload, source, sourceKey) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.emitPayloads([payload], source, sourceKey);
                        });
                    }
                    /**
                     * This function maps multiple payloads to items, and is the authoratative mapping
                     * function that all other mapping helpers rely on
                     * @returns every paylod altered as a result of this operation, to be
                     * saved to storage by the caller
                     */
                    emitPayloads(payloads, source, sourceKey) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const emit = {
                                emits: payloads,
                                source: source
                            };
                            return this.emitDeltaEmit(emit, sourceKey);
                        });
                    }
                    popQueue() {
                        const first = this.emitQueue[0];
                        const { changed, inserted, discarded, unerrored } = this.applyPayloads(first.emit.emits);
                        this.notifyChangeObservers(changed, inserted, discarded, first.emit.ignored || [], unerrored, first.emit.source, first.sourceKey);
                        (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.removeFromArray)(this.emitQueue, first);
                        first.resolve([...changed, ...inserted, ...discarded]);
                        if (this.emitQueue.length > 0) {
                            void this.popQueue();
                        }
                    }
                    applyPayloads(applyPayloads) {
                        const changed = [];
                        const inserted = [];
                        const discarded = [];
                        const unerrored = [];
                        for (const apply of applyPayloads) {
                            if (!apply.uuid || !apply.content_type) {
                                console.error('Payload is corrupt', apply);
                                continue;
                            }
                            this.logger.debug('applying payload', apply.uuid, 'globalDirtyIndexAtLastSync', apply.globalDirtyIndexAtLastSync, 'dirtyIndex', apply.dirtyIndex, 'dirty', apply.dirty);
                            const base = this.collection.find(apply.uuid);
                            if ((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDeletedPayload)(apply) && apply.discardable) {
                                this.collection.discard(apply);
                                discarded.push(apply);
                            }
                            else {
                                this.collection.set(apply);
                                if (base) {
                                    changed.push(apply);
                                    if ((0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isEncryptedPayload)(base) && (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.isDecryptedPayload)(apply)) {
                                        unerrored.push(apply);
                                    }
                                }
                                else {
                                    inserted.push(apply);
                                }
                            }
                        }
                        return {
                            changed,
                            inserted,
                            discarded,
                            unerrored
                        };
                    }
                    /**
                     * Notifies observers when an item has been mapped.
                     * @param types - An array of content types to listen for
                     * @param priority - The lower the priority, the earlier the function is called
                     *  wrt to other observers
                     */
                    addObserver(types, callback) {
                        let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                        if (!Array.isArray(types)) {
                            types = [types];
                        }
                        const observer = {
                            types,
                            priority,
                            callback
                        };
                        this.changeObservers.push(observer);
                        const thislessChangeObservers = this.changeObservers;
                        return () => {
                            (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.removeFromArray)(thislessChangeObservers, observer);
                        };
                    }
                    /**
                     * This function is mostly for internal use, but can be used externally by consumers who
                     * explicitely understand what they are doing (want to propagate model state without mapping)
                     */
                    notifyChangeObservers(changed, inserted, discarded, ignored, unerrored, source, sourceKey) {
                        /** Slice the observers array as sort modifies in-place */
                        const observers = this.changeObservers.slice().sort((a, b) => {
                            return a.priority < b.priority ? -1 : 1;
                        });
                        const filter = (payloads, types) => {
                            return types.includes(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_0__.ContentType.TYPES.Any) ? payloads.slice() : payloads.slice().filter(payload => {
                                return types.includes(payload.content_type);
                            });
                        };
                        for (const observer of observers) {
                            observer.callback({
                                changed: filter(changed, observer.types),
                                inserted: filter(inserted, observer.types),
                                discarded: filter(discarded, observer.types),
                                ignored: filter(ignored, observer.types),
                                unerrored: filter(unerrored, observer.types),
                                source,
                                sourceKey
                            });
                        }
                    }
                    /**
                     * Imports an array of payloads from an external source (such as a backup file)
                     * and marks the items as dirty.
                     */
                    importPayloads(payloads, historyMap) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const sourcedPayloads = payloads.map(p => p.copy(undefined, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadSource.FileImport));
                            const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DeltaFileImport(this.getMasterCollection(), sourcedPayloads, historyMap);
                            const emit = delta.result();
                            yield this.emitDeltaEmit(emit);
                            return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.Uuids)(payloads);
                        });
                    }
                    removePayloadLocally(payload) {
                        this.collection.discard(payload);
                    }
                    erroredPayloadsForContentType(contentType) {
                        return this.collection.invalidElements().filter(p => p.content_type === contentType);
                    }
                    deleteErroredPayloads(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const deleted = payloads.map(payload => new _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.DeletedPayload(Object.assign(Object.assign({}, payload.ejected()), {
                                deleted: true,
                                content: undefined,
                                dirty: true,
                                dirtyIndex: (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.getIncrementedDirtyIndex)()
                            }), payload.source));
                            yield this.emitPayloads(deleted, _standardnotes_models__WEBPACK_IMPORTED_MODULE_2__.PayloadEmitSource.LocalChanged);
                        });
                    }
                    getDiagnostics() {
                        return Promise.resolve({
                            payloads: {
                                integrityPayloads: this.integrityPayloads,
                                nonDeletedItemCount: this.nonDeletedItems.length,
                                invalidPayloadsCount: this.invalidPayloads.length
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 30693: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ y: () => ( /* binding */PreferencesService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class PreferencesService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .AbstractService */.wcN {
                    constructor(singletons, items, mutator, sync, storage, internalEventBus) {
                        super(internalEventBus);
                        this.singletons = singletons;
                        this.mutator = mutator;
                        this.sync = sync;
                        this.storage = storage;
                        this.internalEventBus = internalEventBus;
                        this.shouldReload = true;
                        this.reloading = false;
                        this.localPreferences = {};
                        this.removeItemObserver = items.addObserver(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.UserPrefs, () => {
                            this.shouldReload = true;
                        });
                        this.removeSyncObserver = sync.addEventObserver(event => {
                            if (event === _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .SyncEvent */.wMo.SyncCompletedWithAllItemsUploaded || event === _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .SyncEvent */.wMo.LocalDataIncrementalLoad) {
                                void this.reload();
                            }
                        });
                    }
                    deinit() {
                        var _a, _b;
                        (_a = this.removeItemObserver) === null || _a === void 0 ? void 0 : _a.call(this);
                        (_b = this.removeSyncObserver) === null || _b === void 0 ? void 0 : _b.call(this);
                        this.singletons = undefined;
                        this.mutator = undefined;
                        super.deinit();
                    }
                    handleEvent(event) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event.type === _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .ApplicationEvent */.n9K.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .ApplicationStage */.Ugm.LoadedDatabase_12) {
                                    /** Try to read preferences singleton from storage */
                                    this.preferences = this.singletons.findSingleton(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.UserPrefs, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.SNUserPrefs.singletonPredicate);
                                    if (this.preferences) {
                                        void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .PreferencesServiceEvent */.WZd.PreferencesChanged);
                                    }
                                }
                                else if (stage === _standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .ApplicationStage */.Ugm.StorageDecrypted_09) {
                                    this.localPreferences = (_a = this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.LocalPreferences)) !== null && _a !== void 0 ? _a : {};
                                    void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .PreferencesServiceEvent */.WZd.LocalPreferencesChanged);
                                }
                            }
                        });
                    }
                    getLocalValue(key, defaultValue) {
                        var _a;
                        return (_a = this.localPreferences[key]) !== null && _a !== void 0 ? _a : defaultValue;
                    }
                    getValue(key, defaultValue) {
                        var _a, _b;
                        return (_b = (_a = this.preferences) === null || _a === void 0 ? void 0 : _a.getPref(key)) !== null && _b !== void 0 ? _b : defaultValue;
                    }
                    setLocalValue(key, value) {
                        this.localPreferences[key] = value;
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .StorageKey */.QtK.LocalPreferences, this.localPreferences);
                        void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .PreferencesServiceEvent */.WZd.LocalPreferencesChanged);
                    }
                    setValue(key, value) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.setValueDetached(key, value);
                            void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .PreferencesServiceEvent */.WZd.PreferencesChanged);
                            void this.sync.sync({
                                sourceDescription: 'PreferencesService.setValue'
                            });
                        });
                    }
                    setValueDetached(key, value) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.preferences) {
                                return;
                            }
                            this.preferences = yield this.mutator.changeItem(this.preferences, m => {
                                m.setPref(key, value);
                            });
                        });
                    }
                    reload() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.shouldReload || this.reloading) {
                                return;
                            }
                            this.reloading = true;
                            try {
                                const previousRef = this.preferences;
                                this.preferences = yield this.singletons.findOrCreateContentTypeSingleton(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_2__.ContentType.TYPES.UserPrefs, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.FillItemContent)({}));
                                if ((previousRef === null || previousRef === void 0 ? void 0 : previousRef.uuid) !== this.preferences.uuid || this.preferences.userModifiedDate > previousRef.userModifiedDate) {
                                    void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_1__ /* .PreferencesServiceEvent */.WZd.PreferencesChanged);
                                }
                                this.shouldReload = false;
                            }
                            finally {
                                this.reloading = false;
                            }
                        });
                    }
                }
                /***/ 
            }),
            /***/ 51271: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ n: () => ( /* binding */ProtectionService)
                    /* harmony export */ 
                });
                /* harmony import */ var _Lib_Log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43361);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var _isValidProtectionSessionLength__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17956);
                /* harmony import */ var _UnprotectedAccessSecondsDuration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97210);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * Enforces certain actions to require extra authentication,
                 * like viewing a protected note, as well as managing how long that
                 * authentication should be valid for.
                 */
                class ProtectionService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(encryption, mutator, challenges, storage, internalEventBus) {
                        super(internalEventBus);
                        this.encryption = encryption;
                        this.mutator = mutator;
                        this.challenges = challenges;
                        this.storage = storage;
                        this.internalEventBus = internalEventBus;
                        this.sessionExpiryTimeout = -1;
                        this.mobilePasscodeTiming = _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit;
                        this.mobileBiometricsTiming = _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit;
                        this.isBiometricsSoftLockEngaged = false;
                        this.applicationStarted = false;
                    }
                    deinit() {
                        clearTimeout(this.sessionExpiryTimeout);
                        this.encryption = undefined;
                        this.challenges = undefined;
                        this.storage = undefined;
                        super.deinit();
                    }
                    handleEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event.type === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ApplicationEvent */.n9K.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ApplicationStage */.Ugm.LoadedDatabase_12) {
                                    this.updateSessionExpiryTimer(this.getSessionExpiryDate());
                                    this.mobilePasscodeTiming = this.getMobilePasscodeTiming();
                                    this.mobileBiometricsTiming = this.getMobileBiometricsTiming();
                                }
                            }
                            else if (event.type === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ApplicationEvent */.n9K.Started) {
                                this.applicationStarted = true;
                            }
                        });
                    }
                    isLocked() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.applicationStarted) {
                                return true;
                            }
                            const isPasscodeLocked = yield this.encryption.isPasscodeLocked();
                            return isPasscodeLocked || this.isBiometricsSoftLockEngaged;
                        });
                    }
                    softLockBiometrics() {
                        const challenge = new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4([new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.Biometric)], _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ApplicationUnlock, false);
                        void this.challenges.promptForChallengeResponse(challenge);
                        this.isBiometricsSoftLockEngaged = true;
                        void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ProtectionEvent */.Hh3.BiometricsSoftLockEngaged);
                        this.challenges.addChallengeObserver(challenge, {
                            onComplete: () => {
                                this.isBiometricsSoftLockEngaged = false;
                                void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ProtectionEvent */.Hh3.BiometricsSoftLockDisengaged);
                            }
                        });
                    }
                    hasProtectionSources() {
                        return this.encryption.hasAccount() || this.encryption.hasPasscode() || this.hasBiometricsEnabled();
                    }
                    hasUnprotectedAccessSession() {
                        if (!this.hasProtectionSources()) {
                            return true;
                        }
                        return this.getSessionExpiryDate() > new Date();
                    }
                    hasBiometricsEnabled() {
                        const biometricsState = this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.BiometricsState, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped);
                        return Boolean(biometricsState);
                    }
                    enableBiometrics() {
                        if (this.hasBiometricsEnabled()) {
                            _Lib_Log__WEBPACK_IMPORTED_MODULE_6__ /* .SNLog */.W.onError(Error('Tried to enable biometrics when they already are enabled.'));
                            return false;
                        }
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.BiometricsState, true, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped);
                        return true;
                    }
                    disableBiometrics() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.hasBiometricsEnabled()) {
                                _Lib_Log__WEBPACK_IMPORTED_MODULE_6__ /* .SNLog */.W.onError(Error('Tried to disable biometrics when they already are disabled.'));
                                return false;
                            }
                            if (yield this.validateOrRenewSession(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.DisableBiometrics)) {
                                this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.BiometricsState, false, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped);
                                return true;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    createLaunchChallenge() {
                        const prompts = [];
                        if (this.hasBiometricsEnabled()) {
                            prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.Biometric));
                        }
                        if (this.encryption.hasPasscode()) {
                            prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.LocalPasscode));
                        }
                        if (prompts.length > 0) {
                            return new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4(prompts, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ApplicationUnlock, false);
                        }
                        else {
                            return undefined;
                        }
                    }
                    authorizeProtectedActionForItems(items, challengeReason) {
                        return __awaiter(this, void 0, void 0, function* () {
                            let sessionValidation;
                            const authorizedItems = [];
                            for (const item of items) {
                                const needsAuthorization = item.protected && !this.hasUnprotectedAccessSession();
                                if (needsAuthorization && !sessionValidation) {
                                    sessionValidation = this.validateOrRenewSession(challengeReason);
                                }
                                if (!needsAuthorization || (yield sessionValidation)) {
                                    authorizedItems.push(item);
                                }
                            }
                            return authorizedItems;
                        });
                    }
                    authorizeItemAccess(item) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!item.protected) {
                                return true;
                            }
                            return this.authorizeAction(item.content_type === _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.ContentType.TYPES.Note ? _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.AccessProtectedNote : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.AccessProtectedFile, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: false
                            });
                        });
                    }
                    authorizeAddingPasscode() {
                        return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.AddPasscode, {
                            fallBackToAccountPassword: true,
                            requireAccountPassword: false,
                            forcePrompt: false
                        });
                    }
                    authorizeChangingPasscode() {
                        return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ChangePasscode, {
                            fallBackToAccountPassword: true,
                            requireAccountPassword: false,
                            forcePrompt: false
                        });
                    }
                    authorizeRemovingPasscode() {
                        return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.RemovePasscode, {
                            fallBackToAccountPassword: true,
                            requireAccountPassword: false,
                            forcePrompt: false
                        });
                    }
                    authorizeSearchingProtectedNotesText() {
                        return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.SearchProtectedNotesText, {
                            fallBackToAccountPassword: true,
                            requireAccountPassword: false,
                            forcePrompt: false
                        });
                    }
                    authorizeFileImport() {
                        return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ImportFile, {
                            fallBackToAccountPassword: true,
                            requireAccountPassword: false,
                            forcePrompt: false
                        });
                    }
                    authorizeBackupCreation() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ExportBackup, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: false
                            });
                        });
                    }
                    authorizeMfaDisable() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.DisableMfa, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: true,
                                forcePrompt: false
                            });
                        });
                    }
                    authorizeAutolockIntervalChange() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.ChangeAutolockInterval, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: false
                            });
                        });
                    }
                    authorizeSessionRevoking() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.RevokeSession, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: false
                            });
                        });
                    }
                    authorizeListedPublishing() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.authorizeAction(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.AuthorizeNoteForListed, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: true
                            });
                        });
                    }
                    authorizeAction(reason, dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.validateOrRenewSession(reason, dto);
                        });
                    }
                    getMobilePasscodeTimingOptions() {
                        return [{
                                title: 'Immediately',
                                key: _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.Immediately,
                                selected: this.mobilePasscodeTiming === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.Immediately
                            }, {
                                title: 'On Quit',
                                key: _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit,
                                selected: this.mobilePasscodeTiming === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit
                            }];
                    }
                    getMobileBiometricsTimingOptions() {
                        return [{
                                title: 'Immediately',
                                key: _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.Immediately,
                                selected: this.mobileBiometricsTiming === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.Immediately
                            }, {
                                title: 'On Quit',
                                key: _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit,
                                selected: this.mobileBiometricsTiming === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit
                            }];
                    }
                    getMobileBiometricsTiming() {
                        return this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobileBiometricsTiming, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit);
                    }
                    getMobilePasscodeTiming() {
                        return this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobilePasscodeTiming, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .MobileUnlockTiming */.sNv.OnQuit);
                    }
                    setMobileBiometricsTiming(timing) {
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobileBiometricsTiming, timing, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped);
                        this.mobileBiometricsTiming = timing;
                    }
                    setMobilePasscodeTiming(timing) {
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobilePasscodeTiming, timing, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped);
                        this.mobilePasscodeTiming = timing;
                    }
                    setMobileScreenshotPrivacyEnabled(isEnabled) {
                        return this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobileScreenshotPrivacyEnabled, isEnabled, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default);
                    }
                    getMobileScreenshotPrivacyEnabled() {
                        return this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.MobileScreenshotPrivacyEnabled, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default, false);
                    }
                    validateOrRenewSession(reason) {
                        let { fallBackToAccountPassword = true, requireAccountPassword = false, forcePrompt = false } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.getSessionExpiryDate() > new Date() && !forcePrompt) {
                                return true;
                            }
                            const prompts = [];
                            if (this.hasBiometricsEnabled()) {
                                prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.Biometric));
                            }
                            if (this.encryption.hasPasscode()) {
                                prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.LocalPasscode));
                            }
                            if (requireAccountPassword) {
                                if (!this.encryption.hasAccount()) {
                                    throw Error('Requiring account password for challenge with no account');
                                }
                                prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.AccountPassword));
                            }
                            if (prompts.length === 0) {
                                if (fallBackToAccountPassword && this.encryption.hasAccount()) {
                                    prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.AccountPassword));
                                }
                                else {
                                    return true;
                                }
                            }
                            const lastSessionLength = this.getLastSessionLength();
                            const chosenSessionLength = (0, _isValidProtectionSessionLength__WEBPACK_IMPORTED_MODULE_4__ /* .isValidProtectionSessionLength */.z)(lastSessionLength) ? lastSessionLength : _UnprotectedAccessSecondsDuration__WEBPACK_IMPORTED_MODULE_5__ /* .UnprotectedAccessSecondsDuration */.F.OneMinute;
                            prompts.push(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengePrompt */.FEo(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.ProtectionSessionDuration, undefined, undefined, undefined, undefined, chosenSessionLength));
                            const response = yield this.challenges.promptForChallengeResponse(new _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .Challenge */.tv4(prompts, reason, true));
                            if (response) {
                                const length = (_a = response.values.find(value => value.prompt.validation === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeValidation */.tQn.ProtectionSessionDuration)) === null || _a === void 0 ? void 0 : _a.value;
                                if ((0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.isNullOrUndefined)(length)) {
                                    _Lib_Log__WEBPACK_IMPORTED_MODULE_6__ /* .SNLog */.W.error(Error('No valid protection session length found. Got ' + length));
                                }
                                else {
                                    this.setSessionLength(length);
                                }
                                return true;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    getSessionExpiryDate() {
                        const expiresAt = this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.ProtectionExpirey);
                        if (expiresAt) {
                            return new Date(expiresAt);
                        }
                        else {
                            return new Date();
                        }
                    }
                    clearSession() {
                        void this.setSessionExpiryDate(new Date());
                        return this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ProtectionEvent */.Hh3.UnprotectedSessionExpired);
                    }
                    setSessionExpiryDate(date) {
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.ProtectionExpirey, date);
                    }
                    getLastSessionLength() {
                        return this.storage.getValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.ProtectionSessionLength);
                    }
                    setSessionLength(length) {
                        this.storage.setValue(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageKey */.QtK.ProtectionSessionLength, length);
                        const expiresAt = new Date();
                        expiresAt.setSeconds(expiresAt.getSeconds() + length);
                        this.setSessionExpiryDate(expiresAt);
                        this.updateSessionExpiryTimer(expiresAt);
                        void this.notifyEvent(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ProtectionEvent */.Hh3.UnprotectedSessionBegan);
                    }
                    updateSessionExpiryTimer(expiryDate) {
                        clearTimeout(this.sessionExpiryTimeout);
                        const timer = () => {
                            void this.clearSession();
                        };
                        this.sessionExpiryTimeout = setTimeout(timer, expiryDate.getTime() - Date.now());
                    }
                    protectItems(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const protectedItems = yield this.mutator.changeItems(items, mutator => {
                                mutator.protected = true;
                            }, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.MutationType.NoUpdateUserTimestamps);
                            return protectedItems;
                        });
                    }
                    unprotectItems(items, reason) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!(yield this.authorizeAction(reason, {
                                fallBackToAccountPassword: true,
                                requireAccountPassword: false,
                                forcePrompt: false
                            }))) {
                                return undefined;
                            }
                            const unprotectedItems = yield this.mutator.changeItems(items, mutator => {
                                mutator.protected = false;
                            }, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.MutationType.NoUpdateUserTimestamps);
                            return unprotectedItems;
                        });
                    }
                    protectNote(note) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.protectItems([note]);
                            return result[0];
                        });
                    }
                    unprotectNote(note) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.unprotectItems([note], _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.UnprotectNote);
                            return result ? result[0] : undefined;
                        });
                    }
                    protectNotes(notes) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.protectItems(notes);
                        });
                    }
                    unprotectNotes(notes) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const results = yield this.unprotectItems(notes, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.UnprotectNote);
                            return results || [];
                        });
                    }
                    protectFile(file) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.protectItems([file]);
                            return result[0];
                        });
                    }
                    unprotectFile(file) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.unprotectItems([file], _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ChallengeReason */.Ps8.UnprotectFile);
                            return result ? result[0] : undefined;
                        });
                    }
                }
                /***/ 
            }),
            /***/ 97210: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ F: () => ( /* binding */UnprotectedAccessSecondsDuration)
                    /* harmony export */ 
                });
                var UnprotectedAccessSecondsDuration;
                (function (UnprotectedAccessSecondsDuration) {
                    UnprotectedAccessSecondsDuration[UnprotectedAccessSecondsDuration["OneMinute"] = 60] = "OneMinute";
                    UnprotectedAccessSecondsDuration[UnprotectedAccessSecondsDuration["FiveMinutes"] = 300] = "FiveMinutes";
                    UnprotectedAccessSecondsDuration[UnprotectedAccessSecondsDuration["OneHour"] = 3600] = "OneHour";
                    UnprotectedAccessSecondsDuration[UnprotectedAccessSecondsDuration["OneWeek"] = 604800] = "OneWeek";
                })(UnprotectedAccessSecondsDuration || (UnprotectedAccessSecondsDuration = {}));
                /***/ 
            }),
            /***/ 17956: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ z: () => ( /* binding */isValidProtectionSessionLength)
                    /* harmony export */ 
                });
                /* harmony import */ var _UnprotectedAccessSecondsDuration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97210);
                function isValidProtectionSessionLength(number) {
                    return typeof number === 'number' && Object.values(_UnprotectedAccessSecondsDuration__WEBPACK_IMPORTED_MODULE_0__ /* .UnprotectedAccessSecondsDuration */.F).includes(number);
                }
                /***/ 
            }),
            /***/ 53218: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    aM: () => ( /* binding */MINIMUM_PASSWORD_LENGTH),
                    Sn: () => ( /* binding */MissingAccountParams),
                    Sj: () => ( /* binding */SessionManager)
                });
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../responses/dist/index.js
                var dist = __webpack_require__(95658);
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var dist_src = __webpack_require__(82648);
                // EXTERNAL MODULE: ../encryption/src/index.ts + 52 modules
                var encryption_src = __webpack_require__(86999);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var common_dist_src = __webpack_require__(20875);
                // EXTERNAL MODULE: ./lib/Strings/index.ts + 2 modules
                var Strings = __webpack_require__(52450);
                // EXTERNAL MODULE: ../api/dist/index.js
                var api_dist = __webpack_require__(70781);
                ; // CONCATENATED MODULE: ./lib/Services/Session/cleanedEmailString.ts
                const cleanedEmailString = email => {
                    return email.trim().toLowerCase();
                };
                ; // CONCATENATED MODULE: ./lib/Services/Session/SessionManager.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const MINIMUM_PASSWORD_LENGTH = 8;
                const MissingAccountParams = 'missing-params';
                const ThirtyMinutes = 30 * 60 * 1000;
                /**
                 * The session manager is responsible for loading initial user state, and any relevant
                 * server credentials, such as the session token. It also exposes methods for registering
                 * for a new account, signing into an existing one, or changing an account password.
                 */
                class SessionManager extends src /* AbstractService */.wcN {
                    constructor(storage, apiService, userApiService, alertService, encryptionService, crypto, challengeService, webSocketsService, httpService, sessionStorageMapper, legacySessionStorageMapper, workspaceIdentifier, _getKeyPairs, isApplicationUsingThirdPartyHostUseCase, internalEventBus) {
                        super(internalEventBus);
                        this.storage = storage;
                        this.apiService = apiService;
                        this.userApiService = userApiService;
                        this.alertService = alertService;
                        this.encryptionService = encryptionService;
                        this.crypto = crypto;
                        this.challengeService = challengeService;
                        this.webSocketsService = webSocketsService;
                        this.httpService = httpService;
                        this.sessionStorageMapper = sessionStorageMapper;
                        this.legacySessionStorageMapper = legacySessionStorageMapper;
                        this.workspaceIdentifier = workspaceIdentifier;
                        this._getKeyPairs = _getKeyPairs;
                        this.isApplicationUsingThirdPartyHostUseCase = isApplicationUsingThirdPartyHostUseCase;
                        this.internalEventBus = internalEventBus;
                        this.isSessionRenewChallengePresented = false;
                        apiService.setInvalidSessionObserver(revoked => {
                            if (revoked) {
                                void this.notifyEvent(src /* SessionEvent */.Pxr.Revoked);
                            }
                            else {
                                void this.reauthenticateInvalidSession();
                            }
                        });
                    }
                    handleEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case src /* ApiServiceEvent */.Sf$.SessionRefreshed:
                                    this.httpService.setSession(event.payload.session);
                                    break;
                                case src /* ApplicationEvent */.n9K.ApplicationStageChanged:
                                    {
                                        const stage = event.payload.stage;
                                        if (stage === src /* ApplicationStage */.Ugm.StorageDecrypted_09) {
                                            yield this.initializeFromDisk();
                                        }
                                    }
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.encryptionService = undefined;
                        this.storage = undefined;
                        this.apiService = undefined;
                        this.alertService = undefined;
                        this.challengeService = undefined;
                        this.webSocketsService = undefined;
                        this.user = undefined;
                        super.deinit();
                    }
                    getWorkspaceDisplayIdentifier() {
                        if (this.user) {
                            return this.user.email;
                        }
                        else {
                            return this.workspaceIdentifier;
                        }
                    }
                    memoizeUser(user) {
                        this.user = user;
                        this.apiService.setUser(user);
                    }
                    initializeFromDisk() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.memoizeUser(this.storage.getValue(src /* StorageKey */.QtK.User));
                            if (!this.user) {
                                const legacyUuidLookup = this.storage.getValue(src /* StorageKey */.QtK.LegacyUuid);
                                if (legacyUuidLookup) {
                                    this.memoizeUser({
                                        uuid: legacyUuidLookup,
                                        email: legacyUuidLookup
                                    });
                                }
                            }
                            const serverHost = this.storage.getValue(src /* StorageKey */.QtK.ServerHost);
                            if (serverHost) {
                                void this.apiService.setHost(serverHost);
                                this.httpService.setHost(serverHost);
                            }
                            const rawSession = this.storage.getValue(src /* StorageKey */.QtK.Session);
                            if (rawSession) {
                                try {
                                    const session = 'jwt' in rawSession ? this.legacySessionStorageMapper.toDomain(rawSession) : this.sessionStorageMapper.toDomain(rawSession);
                                    this.setSession(session, false);
                                }
                                catch (error) {
                                    console.error("Could not deserialize session from storage: ".concat(error.message));
                                }
                            }
                        });
                    }
                    setSession(session) {
                        let persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        this.session = session;
                        this.httpService.setSession(session);
                        this.apiService.setSession(session, persist);
                        if (this.isSignedIntoFirstPartyServer()) {
                            void this.webSocketsService.startWebSocketConnection();
                        }
                    }
                    online() {
                        return !this.offline();
                    }
                    offline() {
                        return this.apiService.getSession() == undefined;
                    }
                    getUser() {
                        return this.user;
                    }
                    getSureUser() {
                        return this.user;
                    }
                    isUserMissingKeyPair() {
                        try {
                            return this.getPublicKey() == undefined;
                        }
                        catch (error) {
                            return true;
                        }
                    }
                    getPublicKey() {
                        const keys = this._getKeyPairs.execute();
                        return keys.getValue().encryption.publicKey;
                    }
                    getSigningPublicKey() {
                        const keys = this._getKeyPairs.execute();
                        return keys.getValue().signing.publicKey;
                    }
                    get userUuid() {
                        const user = this.getUser();
                        if (!user) {
                            throw Error('Attempting to access userUuid when user is undefined');
                        }
                        return user.uuid;
                    }
                    isCurrentSessionReadOnly() {
                        if (this.session === undefined) {
                            return undefined;
                        }
                        if (this.session instanceof dist_src.LegacySession) {
                            return false;
                        }
                        return this.session.isReadOnly();
                    }
                    getSession() {
                        return this.apiService.getSession();
                    }
                    signOut() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.memoizeUser(undefined);
                            const session = this.apiService.getSession();
                            if (session && session instanceof dist_src.Session) {
                                yield this.apiService.signOut();
                                this.webSocketsService.closeWebSocketConnection();
                            }
                        });
                    }
                    /** Unlike EncryptionService.hasAccount, isSignedIn can only be read once the application is unlocked */
                    isSignedIn() {
                        return this.getUser() != undefined;
                    }
                    isSignedOut() {
                        return !this.isSignedIn();
                    }
                    isSignedIntoFirstPartyServer() {
                        const isThirdPartyHostUsedOrError = this.isApplicationUsingThirdPartyHostUseCase.execute();
                        if (isThirdPartyHostUsedOrError.isFailed()) {
                            return false;
                        }
                        const isThirdPartyHostUsed = isThirdPartyHostUsedOrError.getValue();
                        return this.isSignedIn() && !isThirdPartyHostUsed;
                    }
                    reauthenticateInvalidSession() {
                        let cancelable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        let onResponse = arguments.length > 1 ? arguments[1] : undefined;
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.isSessionRenewChallengePresented) {
                                return;
                            }
                            this.isSessionRenewChallengePresented = true;
                            const challenge = new src /* Challenge */.tv4([new src /* ChallengePrompt */.FEo(src /* ChallengeValidation */.tQn.None, undefined, src /* SessionStrings */.K9E.EmailInputPlaceholder, false), new src /* ChallengePrompt */.FEo(src /* ChallengeValidation */.tQn.None, undefined, src /* SessionStrings */.K9E.PasswordInputPlaceholder)], src /* ChallengeReason */.Ps8.Custom, cancelable, src /* SessionStrings */.K9E.EnterEmailAndPassword, src /* SessionStrings */.K9E.RecoverSession((_a = this.getUser()) === null || _a === void 0 ? void 0 : _a.email));
                            return new Promise(resolve => {
                                this.challengeService.addChallengeObserver(challenge, {
                                    onCancel: () => {
                                        this.isSessionRenewChallengePresented = false;
                                    },
                                    onComplete: () => {
                                        this.isSessionRenewChallengePresented = false;
                                    },
                                    onNonvalidatedSubmit: challengeResponse => __awaiter(this, void 0, void 0, function* () {
                                        const email = challengeResponse.values[0].value;
                                        const password = challengeResponse.values[1].value;
                                        const currentKeyParams = this.encryptionService.getAccountKeyParams();
                                        const { response } = yield this.signIn(email, password, false, this.storage.isEphemeralSession(), currentKeyParams === null || currentKeyParams === void 0 ? void 0 : currentKeyParams.version);
                                        if ((0, dist.isErrorResponse)(response)) {
                                            this.challengeService.setValidationStatusForChallenge(challenge, challengeResponse.values[1], false);
                                            onResponse === null || onResponse === void 0 ? void 0 : onResponse(response);
                                        }
                                        else {
                                            resolve();
                                            this.challengeService.completeChallenge(challenge);
                                            void this.notifyEvent(src /* SessionEvent */.Pxr.Restored);
                                            void this.alertService.alert(src /* SessionStrings */.K9E.SessionRestored);
                                        }
                                    })
                                });
                                void this.challengeService.promptForChallengeResponse(challenge);
                            });
                        });
                    }
                    promptForU2FVerification(username) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const challenge = new src /* Challenge */.tv4([new src /* ChallengePrompt */.FEo(src /* ChallengeValidation */.tQn.Authenticator, src /* ChallengePromptTitle */.fD2.U2F, undefined, false, undefined, undefined, {
                                    username
                                })], src /* ChallengeReason */.Ps8.Custom, true, src /* SessionStrings */.K9E.InputU2FDevice);
                            const response = yield this.challengeService.promptForChallengeResponse(challenge);
                            if (!response) {
                                return undefined;
                            }
                            return response.values[0].value;
                        });
                    }
                    promptForMfaValue() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const challenge = new src /* Challenge */.tv4([new src /* ChallengePrompt */.FEo(src /* ChallengeValidation */.tQn.None, src /* ChallengePromptTitle */.fD2.Mfa, src /* SessionStrings */.K9E.MfaInputPlaceholder, false, src /* ChallengeKeyboardType */.gqK.Numeric)], src /* ChallengeReason */.Ps8.Custom, true, src /* SessionStrings */.K9E.EnterMfa);
                            const response = yield this.challengeService.promptForChallengeResponse(challenge);
                            if (response) {
                                this.challengeService.completeChallenge(challenge);
                                return response.values[0].value;
                            }
                            return undefined;
                        });
                    }
                    register(email, password, hvmToken, ephemeral) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (password.length < MINIMUM_PASSWORD_LENGTH) {
                                throw new api_dist.ApiCallError(api_dist.ErrorMessage.InsufficientPasswordMessage.replace('%LENGTH%', MINIMUM_PASSWORD_LENGTH.toString()));
                            }
                            const { wrappingKey, canceled } = yield this.challengeService.getWrappingKeyIfApplicable();
                            if (canceled) {
                                throw new api_dist.ApiCallError(api_dist.ErrorMessage.PasscodeRequired);
                            }
                            email = cleanedEmailString(email);
                            const rootKey = yield this.encryptionService.createRootKey(email, password, common_dist_src.KeyParamsOrigination.Registration);
                            const serverPassword = rootKey.serverPassword;
                            const keyParams = rootKey.keyParams;
                            const registerResponse = yield this.userApiService.register({
                                email,
                                serverPassword,
                                hvmToken,
                                keyParams,
                                ephemeral
                            });
                            if ((0, dist.isErrorResponse)(registerResponse)) {
                                throw new api_dist.ApiCallError((0, dist.getErrorFromErrorResponse)(registerResponse).message);
                            }
                            yield this.handleAuthentication({
                                rootKey,
                                wrappingKey,
                                session: registerResponse.data.session,
                                user: registerResponse.data.user
                            });
                            return registerResponse.data;
                        });
                    }
                    retrieveKeyParams(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.apiService.getAccountKeyParams(dto);
                            if ((0, dist.isErrorResponse)(response) || !response.data) {
                                if (dto.mfaCode) {
                                    yield this.alertService.alert(src /* SignInStrings */.Mwm.IncorrectMfa);
                                }
                                const error = (0, dist.isErrorResponse)(response) ? response.data.error : undefined;
                                if (response.data && [dist.ErrorTag.U2FRequired, dist.ErrorTag.MfaRequired].includes(error === null || error === void 0 ? void 0 : error.tag)) {
                                    const isU2FRequired = (error === null || error === void 0 ? void 0 : error.tag) === dist.ErrorTag.U2FRequired;
                                    const result = isU2FRequired ? yield this.promptForU2FVerification(dto.email) : yield this.promptForMfaValue();
                                    if (!result) {
                                        return {
                                            response: this.apiService.createErrorResponse(src /* SignInStrings */.Mwm.SignInCanceledMissingMfa, undefined, dist.ErrorTag.ClientCanceledMfa)
                                        };
                                    }
                                    return this.retrieveKeyParams({
                                        email: dto.email,
                                        mfaCode: isU2FRequired ? undefined : result,
                                        authenticatorResponse: isU2FRequired ? result : undefined
                                    });
                                }
                                else {
                                    return {
                                        response
                                    };
                                }
                            }
                            /** Make sure to use client value for identifier/email */
                            const keyParams = (0, encryption_src /* KeyParamsFromApiResponse */.LW)(response.data, dto.email);
                            if (!keyParams || !keyParams.version) {
                                return {
                                    response: this.apiService.createErrorResponse(src /* API_MESSAGE_FALLBACK_LOGIN_FAIL */.aWs)
                                };
                            }
                            return {
                                keyParams,
                                response,
                                mfaCode: dto.mfaCode
                            };
                        });
                    }
                    signIn(email, password) {
                        let strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let minAllowedVersion = arguments.length > 4 ? arguments[4] : undefined;
                        let hvmToken = arguments.length > 5 ? arguments[5] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.performSignIn(email, password, strict, ephemeral, minAllowedVersion, hvmToken);
                            if ((0, dist.isErrorResponse)(result.response) && (0, dist.getErrorFromErrorResponse)(result.response).tag !== dist.ErrorTag.ClientValidationError && (0, dist.getErrorFromErrorResponse)(result.response).tag !== dist.ErrorTag.ClientCanceledMfa) {
                                const cleanedEmail = cleanedEmailString(email);
                                if (cleanedEmail !== email) {
                                    /**
                                     * Try signing in with trimmed + lowercase version of email
                                     */
                                    return this.performSignIn(cleanedEmail, password, strict, ephemeral, minAllowedVersion, hvmToken);
                                }
                                else {
                                    return result;
                                }
                            }
                            else {
                                return result;
                            }
                        });
                    }
                    performSignIn(email, password) {
                        let strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let ephemeral = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        let minAllowedVersion = arguments.length > 4 ? arguments[4] : undefined;
                        let hvmToken = arguments.length > 5 ? arguments[5] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const paramsResult = yield this.retrieveKeyParams({
                                email
                            });
                            if ((0, dist.isErrorResponse)(paramsResult.response)) {
                                return {
                                    response: paramsResult.response
                                };
                            }
                            const keyParams = paramsResult.keyParams;
                            if (!this.encryptionService.supportedVersions().includes(keyParams.version)) {
                                if (this.encryptionService.isVersionNewerThanLibraryVersion(keyParams.version)) {
                                    return {
                                        response: this.apiService.createErrorResponse(src /* UNSUPPORTED_PROTOCOL_VERSION */.fnl)
                                    };
                                }
                                else {
                                    return {
                                        response: this.apiService.createErrorResponse(src /* EXPIRED_PROTOCOL_VERSION */.R53)
                                    };
                                }
                            }
                            if (common_dist_src.isProtocolVersionExpired(keyParams.version)) {
                                /* Cost minimums only apply to now outdated versions (001 and 002) */
                                const minimum = this.encryptionService.costMinimumForVersion(keyParams.version);
                                if (keyParams.content002.pw_cost < minimum) {
                                    return {
                                        response: this.apiService.createErrorResponse(src /* INVALID_PASSWORD_COST */.nIe)
                                    };
                                }
                                const expiredMessages = Strings /* Strings */.e.Confirm.ProtocolVersionExpired(keyParams.version);
                                const confirmed = yield this.alertService.confirm(expiredMessages.Message, expiredMessages.Title, expiredMessages.ConfirmButton);
                                if (!confirmed) {
                                    return {
                                        response: this.apiService.createErrorResponse(src /* API_MESSAGE_FALLBACK_LOGIN_FAIL */.aWs)
                                    };
                                }
                            }
                            if (!this.encryptionService.platformSupportsKeyDerivation(keyParams)) {
                                return {
                                    response: this.apiService.createErrorResponse(src /* UNSUPPORTED_KEY_DERIVATION */.VnT)
                                };
                            }
                            if (strict) {
                                minAllowedVersion = this.encryptionService.getLatestVersion();
                            }
                            if (minAllowedVersion != undefined) {
                                if (!common_dist_src.leftVersionGreaterThanOrEqualToRight(keyParams.version, minAllowedVersion)) {
                                    return {
                                        response: this.apiService.createErrorResponse((0, src /* StrictSignInFailed */.OC4)(keyParams.version, minAllowedVersion))
                                    };
                                }
                            }
                            const rootKey = yield this.encryptionService.computeRootKey(password, keyParams);
                            const signInResponse = yield this.bypassChecksAndSignInWithRootKey(email, rootKey, ephemeral, hvmToken);
                            return {
                                response: signInResponse
                            };
                        });
                    }
                    bypassChecksAndSignInWithRootKey(email, rootKey) {
                        let ephemeral = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        let hvmToken = arguments.length > 3 ? arguments[3] : undefined;
                        return __awaiter(this, void 0, void 0, function* () {
                            const { wrappingKey, canceled } = yield this.challengeService.getWrappingKeyIfApplicable();
                            if (canceled) {
                                return this.apiService.createErrorResponse(src /* SignInStrings */.Mwm.PasscodeRequired, undefined, dist.ErrorTag.ClientValidationError);
                            }
                            const signInResponse = yield this.apiService.signIn({
                                email,
                                serverPassword: rootKey.serverPassword,
                                ephemeral,
                                hvmToken
                            });
                            if (!signInResponse.data || (0, dist.isErrorResponse)(signInResponse)) {
                                return signInResponse;
                            }
                            const updatedKeyParams = signInResponse.data.key_params;
                            const expandedRootKey = new encryption_src /* SNRootKey */.t$((0, models_dist.CopyPayloadWithContentOverride)(rootKey.payload, {
                                keyParams: updatedKeyParams || rootKey.keyParams.getPortableValue()
                            }));
                            yield this.handleSuccessAuthResponse(signInResponse, expandedRootKey, wrappingKey);
                            return signInResponse;
                        });
                    }
                    changeCredentials(parameters) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const userUuid = this.getSureUser().uuid;
                            const rawResponse = yield this.apiService.changeCredentials({
                                userUuid,
                                currentServerPassword: parameters.currentServerPassword,
                                newServerPassword: parameters.newRootKey.serverPassword,
                                newKeyParams: parameters.newRootKey.keyParams,
                                newEmail: parameters.newEmail ? cleanedEmailString(parameters.newEmail) : undefined
                            });
                            const oldKeys = this._getKeyPairs.execute();
                            const processedResponse = yield this.processChangeCredentialsResponse(rawResponse, parameters.newRootKey, parameters.wrappingKey);
                            if (!(0, dist.isErrorResponse)(rawResponse)) {
                                if (src /* InternalFeatureService */.BbS.get().isFeatureEnabled(src /* InternalFeature */.KK4.Vaults)) {
                                    const eventData = {
                                        previous: !oldKeys.isFailed() ? {
                                            encryption: oldKeys.getValue().encryption,
                                            signing: oldKeys.getValue().signing
                                        } : undefined,
                                        current: {
                                            encryption: parameters.newRootKey.encryptionKeyPair,
                                            signing: parameters.newRootKey.signingKeyPair
                                        }
                                    };
                                    void this.notifyEvent(src /* SessionEvent */.Pxr.UserKeyPairChanged, eventData);
                                }
                            }
                            return processedResponse;
                        });
                    }
                    getSessionsList() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.apiService.getSessionsList();
                            if ((0, dist.isErrorResponse)(response)) {
                                return response;
                            }
                            response.data = response.data.sort((s1, s2) => {
                                return new Date(s1.updated_at) < new Date(s2.updated_at) ? 1 : -1;
                            });
                            return response;
                        });
                    }
                    revokeSession(sessionId) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.apiService.deleteSession(sessionId);
                        });
                    }
                    revokeAllOtherSessions() {
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.getSessionsList();
                            if ((0, dist.isErrorResponse)(response) || !response.data) {
                                const error = (0, dist.isErrorResponse)(response) ? (_a = response.data) === null || _a === void 0 ? void 0 : _a.error : undefined;
                                throw new Error((_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : src /* API_MESSAGE_GENERIC_SYNC_FAIL */.gEn);
                            }
                            const otherSessions = response.data.filter(session => !session.current);
                            yield Promise.all(otherSessions.map(session => this.revokeSession(session.uuid)));
                        });
                    }
                    processChangeCredentialsResponse(response, newRootKey, wrappingKey) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if ((0, dist.isErrorResponse)(response)) {
                                return {
                                    response: response
                                };
                            }
                            yield this.handleSuccessAuthResponse(response, newRootKey, wrappingKey);
                            return {
                                response: response,
                                keyParams: (_a = response.data) === null || _a === void 0 ? void 0 : _a.key_params
                            };
                        });
                    }
                    decodeDemoShareToken(token) {
                        const jsonString = this.crypto.base64Decode(token);
                        return JSON.parse(jsonString);
                    }
                    populateSessionFromDemoShareToken(token) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const sharePayload = this.decodeDemoShareToken(token);
                            yield this.signIn(sharePayload.email, sharePayload.password, false, true);
                        });
                    }
                    populateSession(rootKey, user, session, host, wrappingKey) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.encryptionService.setRootKey(rootKey, wrappingKey);
                            this.memoizeUser(user);
                            this.storage.setValue(src /* StorageKey */.QtK.User, user);
                            void this.apiService.setHost(host);
                            this.httpService.setHost(host);
                            this.setSession(session);
                        });
                    }
                    handleAuthentication(dto) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const sessionOrError = this.createSession(dto.session.access_token, dto.session.access_expiration, dto.session.refresh_token, dto.session.refresh_expiration, dto.session.readonly_access);
                            if (sessionOrError.isFailed()) {
                                console.error(sessionOrError.getError());
                                return;
                            }
                            yield this.populateSession(dto.rootKey, dto.user, sessionOrError.getValue(), this.apiService.getHost(), dto.wrappingKey);
                        });
                    }
                    /**
                     * @deprecated use handleAuthentication instead
                     */
                    handleSuccessAuthResponse(response, rootKey, wrappingKey) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { data } = response;
                            const user = data.user;
                            const isLegacyJwtResponse = data.token != undefined;
                            if (isLegacyJwtResponse) {
                                const sessionOrError = dist_src.LegacySession.create(data.token);
                                if (!sessionOrError.isFailed() && user) {
                                    yield this.populateSession(rootKey, user, sessionOrError.getValue(), this.apiService.getHost(), wrappingKey);
                                }
                            }
                            else if (data.session) {
                                const sessionOrError = this.createSession(data.session.access_token, data.session.access_expiration, data.session.refresh_token, data.session.refresh_expiration, data.session.readonly_access);
                                if (sessionOrError.isFailed()) {
                                    console.error(sessionOrError.getError());
                                    return;
                                }
                                if (!user) {
                                    console.error('No user in response');
                                    return;
                                }
                                yield this.populateSession(rootKey, user, sessionOrError.getValue(), this.apiService.getHost(), wrappingKey);
                            }
                        });
                    }
                    createSession(accessTokenValue, accessExpiration, refreshTokenValue, refreshExpiration, readonlyAccess) {
                        const accessTokenOrError = dist_src.SessionToken.create(accessTokenValue, accessExpiration);
                        if (accessTokenOrError.isFailed()) {
                            return dist_src.Result.fail("Could not create session: ".concat(accessTokenOrError.getError()));
                        }
                        const accessToken = accessTokenOrError.getValue();
                        const refreshTokenOrError = dist_src.SessionToken.create(refreshTokenValue, refreshExpiration);
                        if (refreshTokenOrError.isFailed()) {
                            return dist_src.Result.fail("Could not create session: ".concat(refreshTokenOrError.getError()));
                        }
                        const refreshToken = refreshTokenOrError.getValue();
                        const sessionOrError = dist_src.Session.create(accessToken, refreshToken, readonlyAccess);
                        if (sessionOrError.isFailed()) {
                            return dist_src.Result.fail("Could not create session: ".concat(sessionOrError.getError()));
                        }
                        return dist_src.Result.ok(sessionOrError.getValue());
                    }
                    refreshSessionIfExpiringSoon() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const session = this.getSession();
                            if (!session) {
                                return false;
                            }
                            if (session instanceof dist_src.LegacySession) {
                                return false;
                            }
                            const accessTokenExpiration = new Date(session.accessToken.expiresAt);
                            const refreshTokenExpiration = new Date(session.refreshToken.expiresAt);
                            const willAccessTokenExpireSoon = accessTokenExpiration.getTime() - Date.now() < ThirtyMinutes;
                            const willRefreshTokenExpireSoon = refreshTokenExpiration.getTime() - Date.now() < ThirtyMinutes;
                            if (willAccessTokenExpireSoon || willRefreshTokenExpireSoon) {
                                const refreshSessionResultOrError = yield this.httpService.refreshSession();
                                if (refreshSessionResultOrError.isFailed()) {
                                    return false;
                                }
                                const refreshSessionResult = refreshSessionResultOrError.getValue();
                                return (0, dist.isErrorResponse)(refreshSessionResult);
                            }
                            return false;
                        });
                    }
                }
                /***/ 
            }),
            /***/ 98116: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    g: () => ( /* binding */SettingsService)
                });
                ; // CONCATENATED MODULE: ./lib/Services/Settings/SettingsList.ts
                class SettingsList {
                    constructor(settings) {
                        this.map = {};
                        for (const setting of settings) {
                            this.map[setting.name] = setting;
                        }
                    }
                    getSettingValue(settingName, defaultValue) {
                        const settingData = this.map[settingName.value];
                        return (settingData === null || settingData === void 0 ? void 0 : settingData.value) || defaultValue;
                    }
                }
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../responses/dist/index.js
                var dist = __webpack_require__(95658);
                ; // CONCATENATED MODULE: ./lib/Services/Settings/SettingsGateway.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * SettingsGateway coordinates communication with the API service
                 * wrapping the userUuid provision for simpler consumption
                 */
                class SettingsGateway {
                    constructor(settingsApi, userProvider) {
                        this.settingsApi = settingsApi;
                        this.userProvider = userProvider;
                    }
                    isReadyForModification() {
                        return this.getUser() != undefined;
                    }
                    getUser() {
                        return this.userProvider.getUser();
                    }
                    get userUuid() {
                        const user = this.getUser();
                        if (user == undefined || user.uuid == undefined) {
                            throw new Error(src /* API_MESSAGE_INVALID_SESSION */.aXB);
                        }
                        return user.uuid;
                    }
                    listSettings() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsApi.listSettings(this.userUuid);
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            if (response.data == undefined || response.data.settings == undefined) {
                                return new SettingsList([]);
                            }
                            const settings = new SettingsList(response.data.settings);
                            return settings;
                        });
                    }
                    getSetting(name) {
                        var _a, _b, _c;
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsApi.getSetting(this.userUuid, name.value);
                            if (response.status === dist.HttpStatusCode.BadRequest) {
                                return undefined;
                            }
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.setting) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : undefined;
                        });
                    }
                    getSubscriptionSetting(name) {
                        var _a, _b, _c;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!name.isASubscriptionSetting()) {
                                throw new Error("Setting ".concat(name.value, " is not a subscription setting"));
                            }
                            const response = yield this.settingsApi.getSubscriptionSetting(this.userUuid, name.value);
                            if (response.status === dist.HttpStatusCode.BadRequest) {
                                return undefined;
                            }
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.setting) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : undefined;
                        });
                    }
                    updateSubscriptionSetting(name, payload, sensitive) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsApi.updateSubscriptionSetting(this.userUuid, name.value, payload, sensitive);
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                        });
                    }
                    getDoesSensitiveSettingExist(name) {
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!name.isSensitive()) {
                                throw new Error("Setting ".concat(name.value, " is not sensitive"));
                            }
                            const response = yield this.settingsApi.getSetting(this.userUuid, name.value);
                            if (response.status === dist.HttpStatusCode.BadRequest) {
                                return false;
                            }
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                            return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.success) !== null && _b !== void 0 ? _b : false;
                        });
                    }
                    updateSetting(name, payload, sensitive) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsApi.updateSetting(this.userUuid, name.value, payload, sensitive);
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                        });
                    }
                    deleteSetting(name) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const response = yield this.settingsApi.deleteSetting(this.userUuid, name.value);
                            if ((0, dist.isErrorResponse)(response)) {
                                throw new Error((0, dist.getErrorFromErrorResponse)(response).message);
                            }
                        });
                    }
                    deinit() {
                        ;
                        this.settingsApi = undefined;
                        this.userProvider = undefined;
                    }
                }
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/settings/dist/src/index.js
                var dist_src = __webpack_require__(73606);
                ; // CONCATENATED MODULE: ./lib/Services/Settings/SNSettingsService.ts
                var SNSettingsService_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class SettingsService extends src /* AbstractService */.wcN {
                    constructor(sessionManager, apiService, internalEventBus) {
                        super(internalEventBus);
                        this.sessionManager = sessionManager;
                        this.apiService = apiService;
                        this.internalEventBus = internalEventBus;
                        this.frequencyOptionsLabels = {
                            [dist_src.EmailBackupFrequency.Disabled]: 'No email backups',
                            [dist_src.EmailBackupFrequency.Daily]: 'Daily',
                            [dist_src.EmailBackupFrequency.Weekly]: 'Weekly'
                        };
                    }
                    initializeFromDisk() {
                        this.provider = new SettingsGateway(this.apiService, this.sessionManager);
                    }
                    listSettings() {
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.listSettings();
                        });
                    }
                    getSetting(name) {
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.getSetting(name);
                        });
                    }
                    getSubscriptionSetting(name) {
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.getSubscriptionSetting(name);
                        });
                    }
                    updateSubscriptionSetting(name, payload) {
                        let sensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.updateSubscriptionSetting(name, payload, sensitive);
                        });
                    }
                    updateSetting(name, payload) {
                        let sensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.updateSetting(name, payload, sensitive);
                        });
                    }
                    getDoesSensitiveSettingExist(name) {
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.getDoesSensitiveSettingExist(name);
                        });
                    }
                    deleteSetting(name) {
                        return SNSettingsService_awaiter(this, void 0, void 0, function* () {
                            return this.provider.deleteSetting(name);
                        });
                    }
                    getEmailBackupFrequencyOptionLabel(frequency) {
                        return this.frequencyOptionsLabels[frequency];
                    }
                    deinit() {
                        var _a;
                        (_a = this.provider) === null || _a === void 0 ? void 0 : _a.deinit();
                        this.provider = undefined;
                        this.sessionManager = undefined;
                        this.apiService = undefined;
                    }
                }
                /***/ 
            }),
            /***/ 15109: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ W: () => ( /* binding */SingletonManager)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The singleton manager allow consumers to ensure that only 1 item exists of a certain
                 * predicate. For example, consumers may want to ensure that only one item of contentType
                 * UserPreferences exist. The singleton manager allows consumers to do this via 2 methods:
                 * 1. Consumers may use `findOrCreateContentTypeSingleton` to retrieve an item if it exists, or create
                 *    it otherwise. While this method may serve most cases, it does not allow the consumer
                 *    to subscribe to changes, such as if after this method is called, a UserPreferences object
                 *    is downloaded from a remote source.
                 * 2. Items can override isSingleton, singletonPredicate, and strategyWhenConflictingWithItem (optional)
                 *    to automatically gain singleton resolution.
                 */
                class SingletonManager extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(itemManager, mutator, payloadManager, sync, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.mutator = mutator;
                        this.payloadManager = payloadManager;
                        this.sync = sync;
                        this.internalEventBus = internalEventBus;
                        this.resolveQueue = [];
                        this.addObservers();
                    }
                    deinit() {
                        ;
                        this.sync = undefined;
                        this.mutator = undefined;
                        this.itemManager = undefined;
                        this.payloadManager = undefined;
                        this.resolveQueue.length = 0;
                        this.removeItemObserver();
                        this.removeItemObserver = undefined;
                        this.removeSyncObserver();
                        this.removeSyncObserver = undefined;
                        super.deinit();
                    }
                    popResolveQueue() {
                        const queue = this.resolveQueue.slice();
                        this.resolveQueue = [];
                        return queue;
                    }
                    /**
                     * We only want to resolve singletons for items that are newly created (because this
                     * is when items proliferate). However, we don't want to resolve immediately on creation,
                     * but instead wait for the next full sync to complete. This is so that when you download
                     * a singleton and create the object, but the items key for the item has not yet been
                     * downloaded, the singleton will be errorDecrypting, and would be mishandled in the
                     * overall singleton logic. By waiting for a full sync to complete, we can be sure that
                     * all items keys have been downloaded.
                     */
                    addObservers() {
                        this.removeItemObserver = this.itemManager.addObserver(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_3__.ContentType.TYPES.Any, _ref => {
                            let { inserted, unerrored } = _ref;
                            if (unerrored.length > 0) {
                                this.resolveQueue = this.resolveQueue.concat(unerrored);
                            }
                            if (inserted.length > 0) {
                                this.resolveQueue = this.resolveQueue.concat(inserted);
                            }
                        });
                        this.removeSyncObserver = this.sync.addEventObserver(eventName => __awaiter(this, void 0, void 0, function* () {
                            if (eventName === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .SyncEvent */.wMo.DownloadFirstSyncCompleted || eventName === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .SyncEvent */.wMo.SyncCompletedWithAllItemsUploaded) {
                                yield this.resolveSingletonsForItems(this.popResolveQueue(), eventName);
                            }
                        }));
                    }
                    validItemsMatchingPredicate(contentType, predicate) {
                        return this.itemManager.itemsMatchingPredicate(contentType, predicate);
                    }
                    resolveSingletonsForItems(items, eventSource) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (items.length === 0) {
                                return;
                            }
                            const handled = [];
                            for (const item of items) {
                                if (handled.includes(item) || !item.isSingleton) {
                                    continue;
                                }
                                const matchingItems = this.validItemsMatchingPredicate(item.content_type, item.singletonPredicate());
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.extendArray)(handled, matchingItems || []);
                                if (!matchingItems || matchingItems.length <= 1) {
                                    continue;
                                }
                                yield this.handleStrategy(matchingItems, item.singletonStrategy);
                            }
                            /**
                             * Only sync if event source is SyncCompletedWithAllItemsUploaded.
                             * If it is on DownloadFirstSyncCompleted, we don't need to sync,
                             * as a sync request will automatically be made as part of the second phase
                             * of a download-first request.
                             */
                            if (handled.length > 0 && eventSource === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .SyncEvent */.wMo.SyncCompletedWithAllItemsUploaded) {
                                yield (_a = this.sync) === null || _a === void 0 ? void 0 : _a.sync({
                                    sourceDescription: 'Resolve singletons for items'
                                });
                            }
                        });
                    }
                    handleStrategy(items, strategy) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (strategy !== _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.SingletonStrategy.KeepEarliest) {
                                throw 'Unhandled singleton strategy';
                            }
                            const earliestFirst = items.sort((a, b) => {
                                /** -1: a comes first, 1: b comes first */
                                return a.created_at < b.created_at ? -1 : 1;
                            });
                            const deleteItems = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.arrayByRemovingFromIndex)(earliestFirst, 0);
                            yield this.mutator.setItemsToBeDeleted(deleteItems);
                        });
                    }
                    findSingleton(contentType, predicate) {
                        const matchingItems = this.validItemsMatchingPredicate(contentType, predicate);
                        if (matchingItems.length > 0) {
                            return matchingItems[0];
                        }
                        return undefined;
                    }
                    findOrCreateContentTypeSingleton(contentType, createContent) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const existingItems = this.itemManager.getItems(contentType);
                            if (existingItems.length > 0) {
                                return existingItems[0];
                            }
                            /** Item not found, safe to create after full sync has completed */
                            if (!this.sync.getLastSyncDate()) {
                                /**
                                 * Add a temporary observer in case of long-running sync request, where
                                 * the item we're looking for ends up resolving early or in the middle.
                                 */
                                let matchingItem;
                                const removeObserver = this.itemManager.addObserver(contentType, _ref2 => {
                                    let { inserted } = _ref2;
                                    if (inserted.length > 0) {
                                        const matchingItems = inserted.filter(i => i.content_type === contentType);
                                        if (matchingItems.length > 0) {
                                            matchingItem = matchingItems[0];
                                        }
                                    }
                                });
                                yield this.sync.sync({
                                    sourceDescription: 'Find or create singleton, before any sync has completed'
                                });
                                removeObserver();
                                if (matchingItem) {
                                    return matchingItem;
                                }
                                /** Check again */
                                const refreshedItems = this.itemManager.getItems(contentType);
                                if (refreshedItems.length > 0) {
                                    return refreshedItems[0];
                                }
                            }
                            /** Delete any items that are errored */
                            const errorDecrypting = this.payloadManager.erroredPayloadsForContentType(contentType);
                            if (errorDecrypting.length) {
                                yield this.payloadManager.deleteErroredPayloads(errorDecrypting);
                            }
                            /** Safe to create */
                            const dirtyPayload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.DecryptedPayload(Object.assign({
                                uuid: _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.UuidGenerator.GenerateUuid(),
                                content_type: contentType,
                                content: createContent,
                                dirty: true,
                                dirtyIndex: (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.getIncrementedDirtyIndex)()
                            }, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.PayloadTimestampDefaults)()));
                            const item = yield this.mutator.emitItemFromPayload(dirtyPayload, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.PayloadEmitSource.LocalInserted);
                            void this.sync.sync({
                                sourceDescription: 'After find or create singleton'
                            });
                            return item;
                        });
                    }
                    findOrCreateSingleton(predicate, contentType, createContent) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const existingItems = this.itemManager.itemsMatchingPredicate(contentType, predicate);
                            if (existingItems.length > 0) {
                                return existingItems[0];
                            }
                            /** Item not found, safe to create after full sync has completed */
                            if (!this.sync.getLastSyncDate()) {
                                /**
                                 * Add a temporary observer in case of long-running sync request, where
                                 * the item we're looking for ends up resolving early or in the middle.
                                 */
                                let matchingItem;
                                const removeObserver = this.itemManager.addObserver(contentType, _ref3 => {
                                    let { inserted } = _ref3;
                                    if (inserted.length > 0) {
                                        const matchingItems = inserted.filter(i => i.satisfiesPredicate(predicate));
                                        if (matchingItems.length > 0) {
                                            matchingItem = matchingItems[0];
                                        }
                                    }
                                });
                                yield this.sync.sync({
                                    sourceDescription: 'Find or create singleton, before any sync has completed'
                                });
                                removeObserver();
                                if (matchingItem) {
                                    return matchingItem;
                                }
                                /** Check again */
                                const refreshedItems = this.itemManager.itemsMatchingPredicate(contentType, predicate);
                                if (refreshedItems.length > 0) {
                                    return refreshedItems[0];
                                }
                            }
                            /** Safe to create */
                            const dirtyPayload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.DecryptedPayload(Object.assign({
                                uuid: _standardnotes_utils__WEBPACK_IMPORTED_MODULE_1__.UuidGenerator.GenerateUuid(),
                                content_type: contentType,
                                content: createContent,
                                dirty: true,
                                dirtyIndex: (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.getIncrementedDirtyIndex)()
                            }, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.PayloadTimestampDefaults)()));
                            const item = yield this.mutator.emitItemFromPayload(dirtyPayload, _standardnotes_models__WEBPACK_IMPORTED_MODULE_0__.PayloadEmitSource.LocalInserted);
                            void this.sync.sync({
                                sourceDescription: 'After find or create singleton'
                            });
                            return item;
                        });
                    }
                }
                /***/ 
            }),
            /***/ 28559: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ e: () => ( /* binding */DiskStorageService)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _Log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43361);
                /* harmony import */ var _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86999);
                /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55668);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_3__);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82648);
                /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /**
                 * The storage service is responsible for persistence of both simple key-values, and payload
                 * storage. It does so by relying on deviceInterface to save and retrieve raw values and payloads.
                 * For simple key/values, items are grouped together in an in-memory hash, and persisted to disk
                 * as a single object (encrypted, when possible). It handles persisting payloads in the local
                 * database by encrypting the payloads when possible.
                 * The storage service also exposes methods that allow the application to initially
                 * decrypt the persisted key/values, and also a method to determine whether a particular
                 * key can decrypt wrapped storage.
                 */
                class DiskStorageService extends _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .AbstractService */.wcN {
                    constructor(device, identifier, internalEventBus) {
                        super(internalEventBus);
                        this.device = device;
                        this.identifier = identifier;
                        this.internalEventBus = internalEventBus;
                        this.storagePersistable = false;
                        this.needsPersist = false;
                        void this.setPersistencePolicy(_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Default);
                    }
                    provideEncryptionProvider(provider) {
                        this.encryptionProvider = provider;
                    }
                    deinit() {
                        ;
                        this.device = undefined;
                        this.encryptionProvider = undefined;
                        this.storagePersistable = false;
                        super.deinit();
                    }
                    handleEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (event.type === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ApplicationEvent */.n9K.ApplicationStageChanged) {
                                const stage = event.payload.stage;
                                if (stage === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ApplicationStage */.Ugm.Launched_10) {
                                    this.storagePersistable = true;
                                    if (this.needsPersist) {
                                        void this.persistValuesToDisk();
                                    }
                                }
                            }
                        });
                    }
                    setPersistencePolicy(persistencePolicy) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.persistencePolicy = persistencePolicy;
                            if (this.persistencePolicy === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Ephemeral) {
                                yield this.device.clearNamespacedKeychainValue(this.identifier);
                                yield this.device.removeAllDatabaseEntries(this.identifier);
                                yield this.device.removeRawStorageValuesForIdentifier(this.identifier);
                                yield this.clearAllPayloads();
                            }
                        });
                    }
                    isEphemeralSession() {
                        return this.persistencePolicy === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Ephemeral;
                    }
                    initializeFromDisk() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const value = yield this.device.getRawStorageValue(this.getPersistenceKey());
                            const values = value ? JSON.parse(value) : undefined;
                            yield this.setInitialValues(values);
                        });
                    }
                    setInitialValues(values) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const sureValues = values || this.defaultValuesObject();
                            if (!sureValues[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped]) {
                                sureValues[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped] = {};
                            }
                            this.values = sureValues;
                            if (!this.isStorageWrapped()) {
                                this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped] = Object.assign(Object.assign({}, this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped].content), this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped]);
                            }
                        });
                    }
                    isStorageWrapped() {
                        const wrappedValue = this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped];
                        return wrappedValue != undefined && (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.isEncryptedLocalStoragePayload)(wrappedValue);
                    }
                    canDecryptWithKey(key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const wrappedValue = this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped];
                            if (!(0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.isEncryptedLocalStoragePayload)(wrappedValue)) {
                                throw Error('Attempting to decrypt non decrypted storage value');
                            }
                            const decryptedPayload = yield this.decryptWrappedValue(wrappedValue, key);
                            return !(0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .isErrorDecryptingParameters */.XL)(decryptedPayload);
                        });
                    }
                    decryptWrappedValue(wrappedValue, key) {
                        return __awaiter(this, void 0, void 0, function* () {
                            /**
                             * The read content type doesn't matter, so long as we know it responds
                             * to content type. This allows a more seamless transition when both web
                             * and mobile used different content types for encrypted storage.
                             */
                            if (!(wrappedValue === null || wrappedValue === void 0 ? void 0 : wrappedValue.content_type)) {
                                throw Error('Attempting to decrypt nonexistent wrapped value');
                            }
                            const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.EncryptedPayload(Object.assign(Object.assign(Object.assign({}, wrappedValue), (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.PayloadTimestampDefaults)()), {
                                content_type: _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.EncryptedStorage
                            }));
                            const split = key ? {
                                usesRootKey: {
                                    items: [payload],
                                    key: key
                                }
                            } : {
                                usesRootKeyWithKeyLookup: {
                                    items: [payload]
                                }
                            };
                            const decryptedPayload = yield this.encryptionProvider.decryptSplitSingle(split);
                            return decryptedPayload;
                        });
                    }
                    decryptStorage() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const wrappedValue = this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped];
                            if (!(0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.isEncryptedLocalStoragePayload)(wrappedValue)) {
                                throw Error('Attempting to decrypt already decrypted storage');
                            }
                            const decryptedPayload = yield this.decryptWrappedValue(wrappedValue);
                            if ((0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .isErrorDecryptingParameters */.XL)(decryptedPayload)) {
                                throw _Log__WEBPACK_IMPORTED_MODULE_5__ /* .SNLog */.W.error(Error('Unable to decrypt storage.'));
                            }
                            this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped] = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.Copy)(decryptedPayload.content);
                        });
                    }
                    /** @todo This function should be debounced. */
                    persistValuesToDisk() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.storagePersistable) {
                                this.needsPersist = true;
                                return;
                            }
                            if (this.persistencePolicy === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Ephemeral) {
                                return;
                            }
                            yield this.currentPersistPromise;
                            this.needsPersist = false;
                            const values = yield this.immediatelyPersistValuesToDisk();
                            /** Save the persisted value so we have access to it in memory (for unit tests afawk) */
                            this.values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped] = values[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped];
                        });
                    }
                    awaitPersist() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.currentPersistPromise;
                        });
                    }
                    immediatelyPersistValuesToDisk() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.currentPersistPromise = this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                                var _a;
                                const values = yield this.generatePersistableValues();
                                const persistencePolicySuddenlyChanged = this.persistencePolicy === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Ephemeral;
                                if (persistencePolicySuddenlyChanged) {
                                    return values;
                                }
                                yield (_a = this.device) === null || _a === void 0 ? void 0 : _a.setRawStorageValue(this.getPersistenceKey(), JSON.stringify(values));
                                return values;
                            }));
                            return this.currentPersistPromise;
                        });
                    }
                    /**
                     * Generates a payload that can be persisted to disk,
                     * either as a plain object, or an encrypted item.
                     */
                    generatePersistableValues() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const rawContent = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.Copy)(this.values);
                            const valuesToWrap = rawContent[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped];
                            rawContent[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped] = undefined;
                            const payload = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.DecryptedPayload(Object.assign({
                                uuid: _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.UuidGenerator.GenerateUuid(),
                                content: valuesToWrap,
                                content_type: _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_4__.ContentType.TYPES.EncryptedStorage
                            }, (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.PayloadTimestampDefaults)()));
                            if (this.encryptionProvider.hasRootKeyEncryptionSource()) {
                                const split = {
                                    usesRootKeyWithKeyLookup: {
                                        items: [payload]
                                    }
                                };
                                const encryptedPayload = yield this.encryptionProvider.encryptSplitSingle(split);
                                rawContent[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped] = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreateEncryptedLocalStorageContextPayload)(encryptedPayload);
                            }
                            else {
                                rawContent[_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped] = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreateDecryptedLocalStorageContextPayload)(payload);
                            }
                            return rawContent;
                        });
                    }
                    setValue(key, value) {
                        let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        this.setValueWithNoPersist(key, value, mode);
                        void this.persistValuesToDisk();
                    }
                    setValueAndAwaitPersist(key, value) {
                        let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        return __awaiter(this, void 0, void 0, function* () {
                            this.setValueWithNoPersist(key, value, mode);
                            yield this.persistValuesToDisk();
                        });
                    }
                    setValueWithNoPersist(key, value) {
                        let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        if (!this.values) {
                            throw Error("Attempting to set storage key ".concat(key, " before loading local storage."));
                        }
                        const domainKey = this.domainKeyForMode(mode);
                        const domainStorage = this.values[domainKey];
                        domainStorage[key] = value;
                    }
                    getValue(key) {
                        let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        let defaultValue = arguments.length > 2 ? arguments[2] : undefined;
                        if (!this.values) {
                            throw Error("Attempting to get storage key ".concat(key, " before loading local storage."));
                        }
                        if (!this.values[this.domainKeyForMode(mode)]) {
                            throw Error("Storage domain mode not available ".concat(mode, " for key ").concat(key));
                        }
                        const value = this.values[this.domainKeyForMode(mode)][key];
                        return value != undefined ? value : defaultValue;
                    }
                    getAllKeys() {
                        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        if (!this.values) {
                            throw Error('Attempting to get all keys before loading local storage.');
                        }
                        return Object.keys(this.values[this.domainKeyForMode(mode)]);
                    }
                    removeValue(key) {
                        let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default;
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.values) {
                                throw Error("Attempting to remove storage key ".concat(key, " before loading local storage."));
                            }
                            const domain = this.values[this.domainKeyForMode(mode)];
                            if (domain === null || domain === void 0 ? void 0 : domain[key]) {
                                delete domain[key];
                                return this.persistValuesToDisk();
                            }
                        });
                    }
                    /**
                     * Default persistence key. Platforms can override as needed.
                     */
                    getPersistenceKey() {
                        return (0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .namespacedKey */.xLN)(this.identifier, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .RawStorageKey */.Bq2.StorageObject);
                    }
                    defaultValuesObject(wrapped, unwrapped, nonwrapped) {
                        return DiskStorageService.DefaultValuesObject(wrapped, unwrapped, nonwrapped);
                    }
                    static DefaultValuesObject() {
                        let wrapped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        let unwrapped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        let nonwrapped = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        return {
                            [_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Wrapped]: wrapped,
                            [_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped]: unwrapped,
                            [_standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Nonwrapped]: nonwrapped
                        };
                    }
                    domainKeyForMode(mode) {
                        if (mode === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Default) {
                            return _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Unwrapped;
                        }
                        else if (mode === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StorageValueModes */.qt7.Nonwrapped) {
                            return _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .ValueModesKeys */.dDH.Nonwrapped;
                        }
                        else {
                            throw Error('Invalid mode');
                        }
                    }
                    /**
                     * Clears simple values from storage only. Does not affect payloads.
                     */
                    clearValues() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.setInitialValues();
                            yield this.immediatelyPersistValuesToDisk();
                        });
                    }
                    getAllRawPayloads() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.device.getAllDatabaseEntries(this.identifier);
                        });
                    }
                    getRawPayloads(uuids) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.device.getDatabaseEntries(this.identifier, uuids);
                        });
                    }
                    savePayload(payload) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.savePayloads([payload]);
                        });
                    }
                    savePayloads(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.persistencePolicy === _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .StoragePersistencePolicies */.eIN.Ephemeral) {
                                return;
                            }
                            const { encrypted, decrypted, deleted, discardable } = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreatePayloadSplitWithDiscardables)(payloads);
                            const rootKeyEncryptionAvailable = this.encryptionProvider.hasRootKeyEncryptionSource();
                            const encryptable = [];
                            const unencryptable = [];
                            const { rootKeyEncryption, keySystemRootKeyEncryption, itemsKeyEncryption } = (0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .SplitPayloadsByEncryptionType */.xg)(decrypted);
                            if (itemsKeyEncryption) {
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.extendArray)(encryptable, itemsKeyEncryption);
                            }
                            if (keySystemRootKeyEncryption) {
                                (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.extendArray)(encryptable, keySystemRootKeyEncryption);
                            }
                            if (rootKeyEncryption) {
                                if (!rootKeyEncryptionAvailable) {
                                    (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.extendArray)(unencryptable, rootKeyEncryption);
                                }
                                else {
                                    (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.extendArray)(encryptable, rootKeyEncryption);
                                }
                            }
                            if (discardable.length > 0) {
                                yield this.deletePayloads(discardable);
                            }
                            const encryptableSplit = (0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .SplitPayloadsByEncryptionType */.xg)(encryptable);
                            const keyLookupSplit = (0, _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_1__ /* .CreateEncryptionSplitWithKeyLookup */.Ak)(encryptableSplit);
                            const encryptedResults = yield this.encryptionProvider.encryptSplit(keyLookupSplit);
                            const exportedEncrypted = [...encrypted, ...encryptedResults].map(_standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreateEncryptedLocalStorageContextPayload);
                            const exportedDecrypted = unencryptable.map(_standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreateDecryptedLocalStorageContextPayload);
                            const exportedDeleted = deleted.map(_standardnotes_models__WEBPACK_IMPORTED_MODULE_3__.CreateDeletedLocalStorageContextPayload);
                            return this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                                var _a;
                                return (_a = this.device) === null || _a === void 0 ? void 0 : _a.saveDatabaseEntries([...exportedEncrypted, ...exportedDecrypted, ...exportedDeleted], this.identifier);
                            }));
                        });
                    }
                    deletePayloads(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.deletePayloadsWithUuids((0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.Uuids)(payloads));
                        });
                    }
                    deletePayloadsWithUuids(uuids) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                                yield Promise.all(uuids.map(uuid => this.device.removeDatabaseEntry(uuid, this.identifier)));
                            }));
                        });
                    }
                    deletePayloadWithUuid(uuid) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                                yield this.device.removeDatabaseEntry(uuid, this.identifier);
                            }));
                        });
                    }
                    clearAllPayloads() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                                return this.device.removeAllDatabaseEntries(this.identifier);
                            }));
                        });
                    }
                    clearAllData() {
                        return this.executeCriticalFunction(() => __awaiter(this, void 0, void 0, function* () {
                            yield this.clearValues();
                            yield this.clearAllPayloads();
                            yield this.device.removeRawStorageValue((0, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .namespacedKey */.xLN)(this.identifier, _standardnotes_services__WEBPACK_IMPORTED_MODULE_2__ /* .RawStorageKey */.Bq2.SnjsVersion));
                            yield this.device.removeRawStorageValue(this.getPersistenceKey());
                        }));
                    }
                }
                /***/ 
            }),
            /***/ 37185: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ U: () => ( /* binding */AccountSyncOperation),
                    /* harmony export */ j: () => ( /* binding */SyncUpDownLimit)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _Lib_Services_Sync_Account_Response__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87570);
                /* harmony import */ var _Lib_Services_Sync_Signals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60215);
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const SyncUpDownLimit = 150;
                /**
                 * A long running operation that handles multiple roundtrips from a server,
                 * emitting a stream of values that should be acted upon in real time.
                 */
                class AccountSyncOperation {
                    /**
                     * @param payloads   An array of payloads to send to the server
                     * @param receiver   A function that receives callback multiple times during the operation
                     */
                    constructor(payloads, receiver, apiService, options) {
                        this.payloads = payloads;
                        this.receiver = receiver;
                        this.apiService = apiService;
                        this.options = options;
                        this.id = (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.nonSecureRandomIdentifier)();
                        this.responses = [];
                        this.pendingPayloads = payloads.slice();
                    }
                    /**
                     * Read the payloads that have been saved, or are currently in flight.
                     */
                    get payloadsSavedOrSaving() {
                        return (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.arrayByDifference)(this.payloads, this.pendingPayloads);
                    }
                    popPayloads(count) {
                        const payloads = this.pendingPayloads.slice(0, count);
                        (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_0__.subtractFromArray)(this.pendingPayloads, payloads);
                        return payloads;
                    }
                    run() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.receiver(_Lib_Services_Sync_Signals__WEBPACK_IMPORTED_MODULE_2__ /* .SyncSignal */._.StatusChanged, undefined, {
                                completedUploadCount: this.totalUploadCount - this.pendingUploadCount,
                                totalUploadCount: this.totalUploadCount
                            });
                            const payloads = this.popPayloads(this.upLimit);
                            const rawResponse = yield this.apiService.sync(payloads, this.options.syncToken, this.options.paginationToken, this.downLimit, this.options.sharedVaultUuids);
                            const response = new _Lib_Services_Sync_Account_Response__WEBPACK_IMPORTED_MODULE_1__ /* .ServerSyncResponse */.F(rawResponse);
                            this.responses.push(response);
                            this.options.syncToken = response.lastSyncToken;
                            this.options.paginationToken = response.paginationToken;
                            try {
                                yield this.receiver(_Lib_Services_Sync_Signals__WEBPACK_IMPORTED_MODULE_2__ /* .SyncSignal */._.Response, response);
                            }
                            catch (error) {
                                console.error('Sync handle response error', error);
                            }
                            if (!this.done) {
                                return this.run();
                            }
                        });
                    }
                    get done() {
                        return this.pendingPayloads.length === 0 && !this.options.paginationToken;
                    }
                    get pendingUploadCount() {
                        return this.pendingPayloads.length;
                    }
                    get totalUploadCount() {
                        return this.payloads.length;
                    }
                    get upLimit() {
                        return SyncUpDownLimit;
                    }
                    get downLimit() {
                        return SyncUpDownLimit;
                    }
                    get numberOfItemsInvolved() {
                        let total = 0;
                        for (const response of this.responses) {
                            total += response.numberOfItemsInvolved;
                        }
                        return total;
                    }
                }
                /***/ 
            }),
            /***/ 87570: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ F: () => ( /* binding */ServerSyncResponse)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95658);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87901);
                /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__);
                class ServerSyncResponse {
                    constructor(rawResponse) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        this.rawResponse = rawResponse;
                        if (!(0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.isErrorResponse)(rawResponse)) {
                            this.successResponseData = rawResponse.data;
                        }
                        const conflicts = ((_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a.conflicts) || [];
                        const legacyConflicts = ((_b = this.successResponseData) === null || _b === void 0 ? void 0 : _b.unsaved) || [];
                        this.rawConflictObjects = conflicts.concat(legacyConflicts);
                        const disallowedPayloads = [];
                        const savedItemsFilteringResult = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.FilterDisallowedRemotePayloadsAndMap)(((_c = this.successResponseData) === null || _c === void 0 ? void 0 : _c.saved_items) || []);
                        this.savedPayloads = savedItemsFilteringResult.filtered.map(rawItem => {
                            return (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.CreateServerSyncSavedPayload)(rawItem);
                        });
                        disallowedPayloads.push(...savedItemsFilteringResult.disallowed);
                        const retrievedItemsFilteringResult = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.FilterDisallowedRemotePayloadsAndMap)(((_d = this.successResponseData) === null || _d === void 0 ? void 0 : _d.retrieved_items) || []);
                        this.retrievedPayloads = retrievedItemsFilteringResult.filtered;
                        disallowedPayloads.push(...retrievedItemsFilteringResult.disallowed);
                        this.conflicts = this.filterConflictsAndDisallowedPayloads(disallowedPayloads);
                        this.vaults = ((_e = this.successResponseData) === null || _e === void 0 ? void 0 : _e.shared_vaults) || [];
                        this.vaultInvites = ((_f = this.successResponseData) === null || _f === void 0 ? void 0 : _f.shared_vault_invites) || [];
                        this.asymmetricMessages = ((_g = this.successResponseData) === null || _g === void 0 ? void 0 : _g.messages) || [];
                        this.userEvents = ((_h = this.successResponseData) === null || _h === void 0 ? void 0 : _h.notifications) || [];
                        (0, _standardnotes_utils__WEBPACK_IMPORTED_MODULE_2__.deepFreeze)(this);
                    }
                    filterConflictsAndDisallowedPayloads(disallowedPayloads) {
                        const conflicts = this.rawConflictObjects;
                        const trustedConflicts = {};
                        trustedConflicts[_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem] = [];
                        const invalidServerConflictsArray = trustedConflicts[_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem];
                        for (const payload of disallowedPayloads) {
                            invalidServerConflictsArray.push({
                                type: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem,
                                server_item: payload
                            });
                        }
                        for (const conflict of conflicts) {
                            let serverItem;
                            let unsavedItem;
                            if (conflict.unsaved_item) {
                                const unsavedItemFilteringResult = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.FilterDisallowedRemotePayloadsAndMap)([conflict.unsaved_item]);
                                if (unsavedItemFilteringResult.filtered.length === 1) {
                                    unsavedItem = unsavedItemFilteringResult.filtered[0];
                                }
                                if (unsavedItemFilteringResult.disallowed.length === 1) {
                                    invalidServerConflictsArray.push({
                                        type: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem,
                                        unsaved_item: unsavedItemFilteringResult.disallowed[0]
                                    });
                                }
                            }
                            if (conflict.server_item) {
                                const serverItemFilteringResult = (0, _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.FilterDisallowedRemotePayloadsAndMap)([conflict.server_item]);
                                if (serverItemFilteringResult.filtered.length === 1) {
                                    serverItem = serverItemFilteringResult.filtered[0];
                                }
                                if (serverItemFilteringResult.disallowed.length === 1) {
                                    invalidServerConflictsArray.push({
                                        type: _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem,
                                        server_item: serverItemFilteringResult.disallowed[0]
                                    });
                                }
                            }
                            if (!trustedConflicts[conflict.type]) {
                                trustedConflicts[conflict.type] = [];
                            }
                            const conflictArray = trustedConflicts[conflict.type];
                            if (conflictArray) {
                                const entry = {
                                    type: conflict.type,
                                    server_item: serverItem,
                                    unsaved_item: unsavedItem
                                };
                                conflictArray.push(entry);
                            }
                        }
                        return trustedConflicts;
                    }
                    get error() {
                        if ((0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.isErrorResponse)(this.rawResponse)) {
                            return (0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.getErrorFromErrorResponse)(this.rawResponse);
                        }
                        else {
                            return undefined;
                        }
                    }
                    get status() {
                        return this.rawResponse.status;
                    }
                    get lastSyncToken() {
                        var _a;
                        return (_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a[_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ApiEndpointParam.LastSyncToken];
                    }
                    get paginationToken() {
                        var _a;
                        return (_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a[_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ApiEndpointParam.PaginationToken];
                    }
                    get numberOfItemsInvolved() {
                        const allPayloads = [...this.retrievedPayloads, ...this.rawConflictObjects];
                        return allPayloads.length;
                    }
                    get hasError() {
                        return (0, _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.isErrorResponse)(this.rawResponse);
                    }
                }
                /***/ 
            }),
            /***/ 73822: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ y: () => ( /* binding */ServerSyncResponseResolver)
                    /* harmony export */ 
                });
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95658);
                /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22325);
                /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_1__);
                /**
                 * Given a remote sync response, the resolver applies the incoming changes on top
                 * of the current base state, and returns what the new global state should look like.
                 * The response resolver is purely functional and does not modify global state, but instead
                 * offers the 'recommended' new global state given a sync response and a current base state.
                 */
                class ServerSyncResponseResolver {
                    constructor(payloadSet, baseCollection, payloadsSavedOrSaving, historyMap) {
                        this.payloadSet = payloadSet;
                        this.baseCollection = baseCollection;
                        this.payloadsSavedOrSaving = payloadsSavedOrSaving;
                        this.historyMap = historyMap;
                    }
                    result() {
                        const emits = [];
                        emits.push(this.processRetrievedPayloads());
                        emits.push(this.processSavedPayloads());
                        emits.push(this.processUuidConflictUnsavedPayloads());
                        emits.push(this.processDataConflictServerPayloads());
                        emits.push(this.processRejectedPayloads());
                        return emits;
                    }
                    processSavedPayloads() {
                        const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DeltaRemoteSaved(this.baseCollection, this.payloadSet.savedPayloads);
                        return delta.result();
                    }
                    processRetrievedPayloads() {
                        const collection = _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.ImmutablePayloadCollection.WithPayloads(this.payloadSet.retrievedPayloads);
                        const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DeltaRemoteRetrieved(this.baseCollection, collection, this.payloadsSavedOrSaving, this.historyMap);
                        return delta.result();
                    }
                    getConflictsForType(type) {
                        const results = this.payloadSet.conflicts[type] || [];
                        return results;
                    }
                    processDataConflictServerPayloads() {
                        const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DeltaRemoteDataConflicts(this.baseCollection, this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.ConflictingData), this.historyMap);
                        return delta.result();
                    }
                    processUuidConflictUnsavedPayloads() {
                        const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DeltaRemoteUuidConflicts(this.baseCollection, this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.UuidConflict));
                        return delta.result();
                    }
                    processRejectedPayloads() {
                        const conflicts = [...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.ContentTypeError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.ContentError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.ReadOnlyError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.UuidError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.SharedVaultSnjsVersionError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.SharedVaultInsufficientPermissionsError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.SharedVaultNotMemberError), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.SharedVaultInvalidState), ...this.getConflictsForType(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_0__.ConflictType.InvalidServerItem)];
                        const delta = new _standardnotes_models__WEBPACK_IMPORTED_MODULE_1__.DeltaRemoteRejected(this.baseCollection, conflicts);
                        const result = delta.result();
                        return result;
                    }
                }
                /***/ 
            }),
            /***/ 48671: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    B: () => ( /* binding */OfflineSyncOperation)
                });
                // EXTERNAL MODULE: ../models/dist/index.js
                var dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ./lib/Services/Sync/Signals.ts
                var Signals = __webpack_require__(60215);
                ; // CONCATENATED MODULE: ./lib/Services/Sync/Offline/Response.ts
                class OfflineSyncResponse {
                    constructor(savedPayloads) {
                        this.savedPayloads = savedPayloads;
                    }
                }
                ; // CONCATENATED MODULE: ./lib/Services/Sync/Offline/Operation.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class OfflineSyncOperation {
                    /**
                     * @param payloads  An array of payloads to sync offline
                     * @param receiver  A function that receives callback multiple times during the operation
                     */
                    constructor(payloads, receiver) {
                        this.payloads = payloads;
                        this.receiver = receiver;
                    }
                    run() {
                        return __awaiter(this, void 0, void 0, function* () {
                            const responsePayloads = this.payloads.map(payload => {
                                return (0, dist.CreateOfflineSyncSavedPayload)(payload);
                            });
                            const response = new OfflineSyncResponse(responsePayloads);
                            yield this.receiver(Signals /* SyncSignal */._.Response, response);
                        });
                    }
                }
                /***/ 
            }),
            /***/ 60215: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ _: () => ( /* binding */SyncSignal)
                    /* harmony export */ 
                });
                var SyncSignal;
                (function (SyncSignal) {
                    SyncSignal[SyncSignal["Response"] = 1] = "Response";
                    SyncSignal[SyncSignal["StatusChanged"] = 2] = "StatusChanged";
                })(SyncSignal || (SyncSignal = {}));
                /***/ 
            }),
            /***/ 37486: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    _: () => ( /* binding */SyncService)
                });
                // EXTERNAL MODULE: ./lib/Services/Sync/Account/Operation.ts
                var Operation = __webpack_require__(37185);
                // EXTERNAL MODULE: ../utils/dist/index.js
                var dist = __webpack_require__(87901);
                // EXTERNAL MODULE: ./lib/Services/Sync/Offline/Operation.ts + 1 modules
                var Offline_Operation = __webpack_require__(48671);
                // EXTERNAL MODULE: ./lib/Log.ts
                var Log = __webpack_require__(43361);
                // EXTERNAL MODULE: ./lib/Services/Sync/Account/ResponseResolver.ts
                var ResponseResolver = __webpack_require__(73822);
                // EXTERNAL MODULE: ./lib/Services/Sync/Signals.ts
                var Signals = __webpack_require__(60215);
                // EXTERNAL MODULE: ../models/dist/index.js
                var models_dist = __webpack_require__(22325);
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                // EXTERNAL MODULE: ../encryption/src/index.ts + 52 modules
                var encryption_src = __webpack_require__(86999);
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/domain-core/dist/src/index.js
                var dist_src = __webpack_require__(82648);
                ; // CONCATENATED MODULE: ./lib/Services/Sync/Account/Utilities.ts
                function CreatePayloadFromRawServerItem(rawItem, source) {
                    if (rawItem.deleted) {
                        return dist_src.Result.ok(new models_dist.DeletedPayload(Object.assign(Object.assign({}, rawItem), {
                            content: undefined,
                            deleted: true
                        }), source));
                    }
                    else if (rawItem.content != undefined) {
                        try {
                            return dist_src.Result.ok(new models_dist.EncryptedPayload(Object.assign(Object.assign({}, rawItem), {
                                items_key_id: rawItem.items_key_id,
                                content: rawItem.content,
                                deleted: false,
                                errorDecrypting: false,
                                waitingForKey: false
                            }), source));
                        }
                        catch (error) {
                            return dist_src.Result.fail(JSON.stringify(error));
                        }
                    }
                    return dist_src.Result.fail('Unhandled case in createPayloadFromRawItem');
                }
                ; // CONCATENATED MODULE: ./lib/Services/Sync/SyncService.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const DEFAULT_MAJOR_CHANGE_THRESHOLD = 15;
                const INVALID_SESSION_RESPONSE_STATUS = 401;
                const TOO_MANY_REQUESTS_RESPONSE_STATUS = 429;
                const DEFAULT_AUTO_SYNC_INTERVAL = 30000;
                /** Content types appearing first are always mapped first */
                const ContentTypeLocalLoadPriorty = [dist_src.ContentType.TYPES.ItemsKey, dist_src.ContentType.TYPES.KeySystemRootKey, dist_src.ContentType.TYPES.KeySystemItemsKey, dist_src.ContentType.TYPES.VaultListing, dist_src.ContentType.TYPES.TrustedContact, dist_src.ContentType.TYPES.UserPrefs, dist_src.ContentType.TYPES.Component, dist_src.ContentType.TYPES.Theme];
                /**
                 * The sync service orchestrates with the model manager, api service, and storage service
                 * to ensure consistent state between the three. When a change is made to an item, consumers
                 * call the sync service's sync function to first persist pending changes to local storage.
                 * Then, the items are uploaded to the server. The sync service handles server responses,
                 * including mapping any retrieved items to application state via model manager mapping.
                 * After each sync request, any changes made or retrieved are also persisted locally.
                 * The sync service largely does not perform any task unless it is called upon.
                 */
                class SyncService extends src /* AbstractService */.wcN {
                    constructor(itemManager, sessionManager, encryptionService, storageService, payloadManager, apiService, historyService, device, identifier, options, logger, sockets, syncFrequencyGuard, syncBackoffService, internalEventBus) {
                        super(internalEventBus);
                        this.itemManager = itemManager;
                        this.sessionManager = sessionManager;
                        this.encryptionService = encryptionService;
                        this.storageService = storageService;
                        this.payloadManager = payloadManager;
                        this.apiService = apiService;
                        this.historyService = historyService;
                        this.device = device;
                        this.identifier = identifier;
                        this.options = options;
                        this.logger = logger;
                        this.sockets = sockets;
                        this.syncFrequencyGuard = syncFrequencyGuard;
                        this.syncBackoffService = syncBackoffService;
                        this.internalEventBus = internalEventBus;
                        this.outOfSync = false;
                        this.resolveQueue = [];
                        this.spawnQueue = [];
                        /* A DownloadFirst sync must always be the first sync completed */
                        this.completedOnlineDownloadFirstSync = false;
                        this.majorChangeThreshold = DEFAULT_MAJOR_CHANGE_THRESHOLD;
                        this.clientLocked = false;
                        this.databaseLoaded = false;
                        this.syncLock = false;
                        this.dealloced = false;
                        this.wasNotifiedOfItemsChangeOnServer = false;
                        this.opStatus = this.initializeStatus();
                    }
                    /**
                     * If the database has been newly created (because its new or was previously destroyed)
                     * we want to reset any sync tokens we have.
                     */
                    onNewDatabaseCreated() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (yield this.getLastSyncToken()) {
                                yield this.clearSyncPositionTokens();
                            }
                        });
                    }
                    get launchPriorityUuids() {
                        var _a;
                        return (_a = this.storageService.getValue(src /* StorageKey */.QtK.LaunchPriorityUuids)) !== null && _a !== void 0 ? _a : [];
                    }
                    setLaunchPriorityUuids(launchPriorityUuids) {
                        this.storageService.setValue(src /* StorageKey */.QtK.LaunchPriorityUuids, launchPriorityUuids);
                    }
                    deinit() {
                        this.dealloced = true;
                        if (this.autoSyncInterval) {
                            clearInterval(this.autoSyncInterval);
                        }
                        ;
                        this.autoSyncInterval = undefined;
                        this.sessionManager = undefined;
                        this.itemManager = undefined;
                        this.encryptionService = undefined;
                        this.payloadManager = undefined;
                        this.storageService = undefined;
                        this.apiService = undefined;
                        this.opStatus.reset();
                        this.opStatus = undefined;
                        this.resolveQueue.length = 0;
                        this.spawnQueue.length = 0;
                        super.deinit();
                    }
                    initializeStatus() {
                        return new src /* SyncOpStatus */.BUK(setInterval, event => {
                            void this.notifyEvent(event);
                        });
                    }
                    lockSyncing() {
                        this.clientLocked = true;
                    }
                    unlockSyncing() {
                        this.clientLocked = false;
                    }
                    isOutOfSync() {
                        return this.outOfSync;
                    }
                    getLastSyncDate() {
                        return this.lastSyncDate;
                    }
                    getSyncStatus() {
                        return this.opStatus;
                    }
                    /**
                     * Called by application when sign in or registration occurs.
                     */
                    resetSyncState() {
                        this.dirtyIndexAtLastPresyncSave = undefined;
                        this.lastSyncDate = undefined;
                        this.outOfSync = false;
                    }
                    isDatabaseLoaded() {
                        return this.databaseLoaded;
                    }
                    processPriorityItemsForDatabaseLoad(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (items.length === 0) {
                                return;
                            }
                            const encryptedPayloads = items.filter(models_dist.isEncryptedPayload);
                            const alreadyDecryptedPayloads = items.filter(models_dist.isDecryptedPayload);
                            const encryptionSplit = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(encryptedPayloads);
                            const decryptionSplit = (0, encryption_src /* CreateDecryptionSplitWithKeyLookup */.nJ)(encryptionSplit);
                            const newlyDecryptedPayloads = yield this.encryptionService.decryptSplit(decryptionSplit);
                            yield this.payloadManager.emitPayloads([...alreadyDecryptedPayloads, ...newlyDecryptedPayloads], models_dist.PayloadEmitSource.LocalDatabaseLoaded);
                        });
                    }
                    loadDatabasePayloads() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.logger.debug('Loading database payloads');
                            if (this.databaseLoaded) {
                                throw 'Attempting to initialize already initialized local database.';
                            }
                            const chunks = yield this.device.getDatabaseLoadChunks({
                                batchSize: this.options.loadBatchSize,
                                contentTypePriority: ContentTypeLocalLoadPriorty,
                                uuidPriority: this.launchPriorityUuids
                            }, this.identifier);
                            const itemsKeyEntries = (0, src /* isFullEntryLoadChunkResponse */.Or9)(chunks) ? chunks.fullEntries.itemsKeys.entries : yield this.device.getDatabaseEntries(this.identifier, chunks.keys.itemsKeys.keys);
                            const keySystemRootKeyEntries = (0, src /* isFullEntryLoadChunkResponse */.Or9)(chunks) ? chunks.fullEntries.keySystemRootKeys.entries : yield this.device.getDatabaseEntries(this.identifier, chunks.keys.keySystemRootKeys.keys);
                            const keySystemItemsKeyEntries = (0, src /* isFullEntryLoadChunkResponse */.Or9)(chunks) ? chunks.fullEntries.keySystemItemsKeys.entries : yield this.device.getDatabaseEntries(this.identifier, chunks.keys.keySystemItemsKeys.keys);
                            const createPayloadFromEntry = entry => {
                                try {
                                    return (0, models_dist.CreatePayload)(entry, models_dist.PayloadSource.LocalDatabaseLoaded);
                                }
                                catch (e) {
                                    console.error('Creating payload failed', e);
                                    return undefined;
                                }
                            };
                            yield this.processPriorityItemsForDatabaseLoad(itemsKeyEntries.map(createPayloadFromEntry).filter(dist.isNotUndefined));
                            yield this.processPriorityItemsForDatabaseLoad(keySystemRootKeyEntries.map(createPayloadFromEntry).filter(dist.isNotUndefined));
                            yield this.processPriorityItemsForDatabaseLoad(keySystemItemsKeyEntries.map(createPayloadFromEntry).filter(dist.isNotUndefined));
                            /**
                             * Map in batches to give interface a chance to update. Note that total decryption
                             * time is constant regardless of batch size. Decrypting 3000 items all at once or in
                             * batches will result in the same time spent. It's the emitting/painting/rendering
                             * that requires batch size optimization.
                             */
                            const payloadCount = chunks.remainingChunksItemCount;
                            let totalProcessedCount = 0;
                            const remainingChunks = (0, src /* isFullEntryLoadChunkResponse */.Or9)(chunks) ? chunks.fullEntries.remainingChunks : chunks.keys.remainingChunks;
                            let chunkIndex = 0;
                            const ChunkIndexOfContentTypePriorityItems = 0;
                            for (const chunk of remainingChunks) {
                                const dbEntries = (0, src /* isChunkFullEntry */.ufS)(chunk) ? chunk.entries : yield this.device.getDatabaseEntries(this.identifier, chunk.keys);
                                const payloads = dbEntries.map(entry => {
                                    try {
                                        return (0, models_dist.CreatePayload)(entry, models_dist.PayloadSource.LocalDatabaseLoaded);
                                    }
                                    catch (e) {
                                        console.error('Creating payload failed', e);
                                        return undefined;
                                    }
                                }).filter(dist.isNotUndefined);
                                yield this.processPayloadBatch(payloads, totalProcessedCount, payloadCount);
                                const shouldSleepOnlyAfterFirstRegularBatch = chunkIndex > ChunkIndexOfContentTypePriorityItems;
                                if (shouldSleepOnlyAfterFirstRegularBatch) {
                                    yield (0, dist.sleep)(this.options.sleepBetweenBatches, false, 'Sleeping to allow interface to update');
                                }
                                totalProcessedCount += payloads.length;
                                chunkIndex++;
                            }
                            this.databaseLoaded = true;
                            this.opStatus.setDatabaseLoadStatus(0, 0, true);
                        });
                    }
                    beginAutoSyncTimer() {
                        this.autoSyncInterval = setInterval(this.autoSync.bind(this), DEFAULT_AUTO_SYNC_INTERVAL);
                    }
                    autoSync() {
                        if (!this.sockets.isWebSocketConnectionOpen()) {
                            this.logger.debug('WebSocket connection is closed, doing autosync');
                            void this.sync({
                                sourceDescription: 'Auto Sync'
                            });
                            return;
                        }
                        if (this.wasNotifiedOfItemsChangeOnServer) {
                            this.logger.debug('Was notified of items changed on server, doing autosync');
                            this.wasNotifiedOfItemsChangeOnServer = false;
                            void this.sync({
                                sourceDescription: 'WebSockets Event - Items Changed On Server'
                            });
                        }
                    }
                    processPayloadBatch(batch, currentPosition, payloadCount) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.logger.debug('Processing batch at index', currentPosition, 'length', batch.length);
                            const encrypted = [];
                            const nonencrypted = [];
                            for (const payload of batch) {
                                if ((0, models_dist.isEncryptedPayload)(payload)) {
                                    encrypted.push(payload);
                                }
                                else {
                                    nonencrypted.push(payload);
                                }
                            }
                            const encryptionSplit = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(encrypted);
                            const decryptionSplit = (0, encryption_src /* CreateDecryptionSplitWithKeyLookup */.nJ)(encryptionSplit);
                            const results = yield this.encryptionService.decryptSplit(decryptionSplit);
                            yield this.payloadManager.emitPayloads([...nonencrypted, ...results], models_dist.PayloadEmitSource.LocalDatabaseLoaded);
                            void this.notifyEvent(src /* SyncEvent */.wMo.LocalDataIncrementalLoad);
                            if (currentPosition != undefined && payloadCount != undefined) {
                                this.opStatus.setDatabaseLoadStatus(currentPosition, payloadCount, false);
                            }
                        });
                    }
                    setLastSyncToken(token) {
                        this.syncToken = token;
                        return this.storageService.setValue(src /* StorageKey */.QtK.LastSyncToken, token);
                    }
                    setPaginationToken(token) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.cursorToken = token;
                            if (token) {
                                return this.storageService.setValue(src /* StorageKey */.QtK.PaginationToken, token);
                            }
                            else {
                                return this.storageService.removeValue(src /* StorageKey */.QtK.PaginationToken);
                            }
                        });
                    }
                    getLastSyncToken() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.syncToken) {
                                this.syncToken = yield this.storageService.getValue(src /* StorageKey */.QtK.LastSyncToken);
                            }
                            return this.syncToken;
                        });
                    }
                    getPaginationToken() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (!this.cursorToken) {
                                this.cursorToken = yield this.storageService.getValue(src /* StorageKey */.QtK.PaginationToken);
                            }
                            return this.cursorToken;
                        });
                    }
                    clearSyncPositionTokens() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.syncToken = undefined;
                            this.cursorToken = undefined;
                            yield this.storageService.removeValue(src /* StorageKey */.QtK.LastSyncToken);
                            yield this.storageService.removeValue(src /* StorageKey */.QtK.PaginationToken);
                        });
                    }
                    itemsNeedingSync() {
                        const dirtyItems = this.itemManager.getDirtyItems();
                        const itemsWithoutBackoffPenalty = dirtyItems.filter(item => !this.syncBackoffService.isItemInBackoff(item));
                        return itemsWithoutBackoffPenalty;
                    }
                    markAllItemsAsNeedingSyncAndPersist() {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.logger.debug('Marking all items as needing sync');
                            const items = this.itemManager.items;
                            const payloads = items.map(item => {
                                return new models_dist.DecryptedPayload(Object.assign(Object.assign({}, item.payload.ejected()), {
                                    dirty: true,
                                    dirtyIndex: (0, models_dist.getIncrementedDirtyIndex)()
                                }));
                            });
                            yield this.payloadManager.emitPayloads(payloads, models_dist.PayloadEmitSource.LocalChanged);
                            /**
                             * When signing into an 003 account (or an account that is not the latest), the temporary items key will be 004
                             * and will not match user account version, triggering a key not found exception. This error resolves once the
                             * download first sync completes and the correct key is downloaded. We suppress any persistence
                             * exceptions here to avoid showing an error to the user.
                             */
                            const hidePersistErrorDueToWaitingOnKeyDownload = true;
                            yield this.persistPayloads(payloads, {
                                throwError: !hidePersistErrorDueToWaitingOnKeyDownload
                            });
                        });
                    }
                    /**
                     * Return the payloads that need local persistence, before beginning a sync.
                     * This way, if the application is closed before a sync request completes,
                     * pending data will be saved to disk, and synced the next time the app opens.
                     */
                    popPayloadsNeedingPreSyncSave(from) {
                        const lastPreSyncSave = this.dirtyIndexAtLastPresyncSave;
                        if (lastPreSyncSave == undefined) {
                            return from;
                        }
                        const payloads = from.filter(candidate => {
                            return !candidate.dirtyIndex || candidate.dirtyIndex > lastPreSyncSave;
                        });
                        this.dirtyIndexAtLastPresyncSave = (0, models_dist.getCurrentDirtyIndex)();
                        return payloads;
                    }
                    queueStrategyResolveOnNext() {
                        return new Promise((resolve, reject) => {
                            this.resolveQueue.push({
                                resolve,
                                reject
                            });
                        });
                    }
                    queueStrategyForceSpawnNew(options) {
                        return new Promise((resolve, reject) => {
                            this.spawnQueue.push({
                                resolve,
                                reject,
                                options
                            });
                        });
                    }
                    /**
                     * For timing strategy SyncQueueStrategy.ForceSpawnNew, we will execute a whole sync request
                     * and pop it from the queue.
                     */
                    popSpawnQueue() {
                        if (this.spawnQueue.length === 0) {
                            return null;
                        }
                        const promise = this.spawnQueue[0];
                        (0, dist.removeFromIndex)(this.spawnQueue, 0);
                        this.logger.debug('Syncing again from spawn queue');
                        return this.sync(Object.assign({
                            queueStrategy: src /* SyncQueueStrategy */.Sii.ForceSpawnNew,
                            source: src /* SyncSource */.Lbd.SpawnQueue
                        }, promise.options)).then(() => {
                            promise.resolve();
                        }).catch(() => {
                            promise.reject();
                        });
                    }
                    payloadsByPreparingForServer(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const payloadSplit = (0, models_dist.CreatePayloadSplit)(payloads);
                            const encryptionSplit = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(payloadSplit.decrypted);
                            const keyLookupSplit = (0, encryption_src /* CreateEncryptionSplitWithKeyLookup */.Ak)(encryptionSplit);
                            const encryptedResults = yield this.encryptionService.encryptSplit(keyLookupSplit);
                            const contextPayloads = [...encryptedResults.map(models_dist.CreateEncryptedServerSyncPushPayload), ...payloadSplit.deleted.map(models_dist.CreateDeletedServerSyncPushPayload)];
                            return contextPayloads;
                        });
                    }
                    downloadFirstSync(waitTimeOnFailureMs, otherSyncOptions) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const maxTries = 5;
                            for (let i = 0; i < maxTries; i++) {
                                yield this.sync(Object.assign({
                                    mode: src /* SyncMode */.YCg.DownloadFirst,
                                    queueStrategy: src /* SyncQueueStrategy */.Sii.ForceSpawnNew,
                                    source: src /* SyncSource */.Lbd.External
                                }, otherSyncOptions)).catch(console.error);
                                if (this.completedOnlineDownloadFirstSync) {
                                    return;
                                }
                                else {
                                    yield (0, dist.sleep)(waitTimeOnFailureMs);
                                }
                            }
                            console.error("Failed downloadFirstSync after ".concat(maxTries, " tries"));
                        });
                    }
                    awaitCurrentSyncs() {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.lastSyncInvokationPromise;
                            yield this.currentSyncRequestPromise;
                        });
                    }
                    sync() {
                        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.clientLocked) {
                                this.logger.debug('Sync locked by client');
                                return;
                            }
                            const fullyResolvedOptions = Object.assign({
                                source: src /* SyncSource */.Lbd.External
                            }, options);
                            this.lastSyncInvokationPromise = this.performSync(fullyResolvedOptions);
                            return this.lastSyncInvokationPromise;
                        });
                    }
                    prepareForSync(options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const items = this.itemsNeedingSync();
                            /**
                             * Freeze the begin date immediately after getting items needing sync. This way an
                             * item dirtied at any point after this date is marked as needing another sync
                             */
                            const beginDate = new Date();
                            const frozenDirtyIndex = (0, models_dist.getCurrentDirtyIndex)();
                            /**
                             * Items that have never been synced and marked as deleted should not be
                             * uploaded to server, and instead deleted directly after sync completion.
                             */
                            const neverSyncedDeleted = items.filter(item => {
                                return item.neverSynced && (0, models_dist.isDeletedItem)(item);
                            });
                            (0, dist.subtractFromArray)(items, neverSyncedDeleted);
                            const decryptedPayloads = items.map(item => {
                                return item.payloadRepresentation();
                            });
                            const payloadsNeedingSave = this.popPayloadsNeedingPreSyncSave(decryptedPayloads);
                            const hidePersistErrorDueToWaitingOnKeyDownload = options.mode === src /* SyncMode */.YCg.DownloadFirst;
                            yield this.persistPayloads(payloadsNeedingSave, {
                                throwError: !hidePersistErrorDueToWaitingOnKeyDownload
                            });
                            if (options.onPresyncSave) {
                                options.onPresyncSave();
                            }
                            return {
                                items,
                                beginDate,
                                frozenDirtyIndex,
                                neverSyncedDeleted
                            };
                        });
                    }
                    /**
                     * Allows us to lock this function from triggering duplicate network requests.
                     * There are two types of locking checks:
                     * 1. syncLocked(): If a call to sync() call has begun preparing to be sent to the server.
                     *                  but not yet completed all the code below before reaching that point.
                     *                  (before reaching opStatus.setDidBegin).
                     * 2. syncOpInProgress: If a sync() call is in flight to the server.
                     */
                    configureSyncLock(options) {
                        const syncInProgress = this.opStatus.syncInProgress;
                        const databaseLoaded = this.databaseLoaded;
                        const canExecuteSync = !this.syncLock;
                        const syncLimitReached = this.syncFrequencyGuard.isSyncCallsThresholdReachedThisMinute();
                        const shouldExecuteSync = canExecuteSync && databaseLoaded && !syncInProgress && !syncLimitReached;
                        if (shouldExecuteSync) {
                            this.syncLock = true;
                        }
                        else {
                            this.logger.debug(!canExecuteSync ? 'Another function call has begun preparing for sync.' : syncInProgress ? 'Attempting to sync while existing sync in progress.' : 'Attempting to sync before local database has loaded.', options);
                        }
                        const releaseLock = () => {
                            this.syncLock = false;
                        };
                        return {
                            shouldExecuteSync,
                            releaseLock
                        };
                    }
                    deferSyncRequest(options) {
                        const useStrategy = !(0, dist.isNullOrUndefined)(options.queueStrategy) ? options.queueStrategy : src /* SyncQueueStrategy */.Sii.ResolveOnNext;
                        if (useStrategy === src /* SyncQueueStrategy */.Sii.ResolveOnNext) {
                            return this.queueStrategyResolveOnNext();
                        }
                        else if (useStrategy === src /* SyncQueueStrategy */.Sii.ForceSpawnNew) {
                            return this.queueStrategyForceSpawnNew(options);
                        }
                        else {
                            throw Error('Unhandled timing strategy');
                        }
                    }
                    prepareForSyncExecution(items, inTimeResolveQueue, beginDate, frozenDirtyIndex) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.opStatus.setDidBegin();
                            yield this.notifyEvent(src /* SyncEvent */.wMo.SyncDidBeginProcessing);
                            /**
                             * Subtract from array as soon as we're sure they'll be called.
                             * resolves are triggered at the end of this function call
                             */
                            (0, dist.subtractFromArray)(this.resolveQueue, inTimeResolveQueue);
                            /**
                             * lastSyncBegan must be set *after* any point we may have returned above.
                             * Setting this value means the item was 100% sent to the server.
                             */
                            if (items.length > 0) {
                                return this.setLastSyncBeganForItems(items, beginDate, frozenDirtyIndex);
                            }
                            else {
                                return items;
                            }
                        });
                    }
                    setLastSyncBeganForItems(itemsToLookupUuidsFor, date, globalDirtyIndex) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const uuids = (0, dist.Uuids)(itemsToLookupUuidsFor);
                            const items = this.itemManager.getCollection().findAll(uuids).filter(models_dist.isDecryptedOrDeletedItem);
                            const payloads = [];
                            for (const item of items) {
                                const mutator = new models_dist.ItemMutator(item, models_dist.MutationType.NonDirtying);
                                mutator.setBeginSync(date, globalDirtyIndex);
                                const payload = mutator.getResult();
                                payloads.push(payload);
                            }
                            yield this.payloadManager.emitPayloads(payloads, models_dist.PayloadEmitSource.PreSyncSave);
                            return this.itemManager.findAnyItems(uuids);
                        });
                    }
                    /**
                     * The InTime resolve queue refers to any sync requests that were made while we still
                     * have not sent out the current request. So, anything in the InTime resolve queue
                     * will have made it "in time" to piggyback on the current request. Anything that comes
                     * after InTime will schedule a new sync request.
                     */
                    getPendingRequestsMadeInTimeToPiggyBackOnCurrentRequest() {
                        return this.resolveQueue.slice();
                    }
                    getOfflineSyncParameters(payloads) {
                        let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : src /* SyncMode */.YCg.Default;
                        const uploadPayloads = mode === src /* SyncMode */.YCg.Default ? payloads : [];
                        return {
                            uploadPayloads
                        };
                    }
                    createOfflineSyncOperation(payloads, options) {
                        this.logger.debug('Syncing offline user', 'source:', src /* SyncSource */.Lbd[options.source], 'sourceDesc', options.sourceDescription, 'mode:', options.mode && src /* SyncMode */.YCg[options.mode], 'payloads:', payloads);
                        const operation = new Offline_Operation /* OfflineSyncOperation */.B(payloads, (type, response) => __awaiter(this, void 0, void 0, function* () {
                            if (this.dealloced) {
                                return;
                            }
                            if (type === Signals /* SyncSignal */._.Response && response) {
                                yield this.handleOfflineResponse(response);
                            }
                        }));
                        return operation;
                    }
                    getOnlineSyncParameters(payloads) {
                        let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : src /* SyncMode */.YCg.Default;
                        return __awaiter(this, void 0, void 0, function* () {
                            const useMode = !this.completedOnlineDownloadFirstSync ? src /* SyncMode */.YCg.DownloadFirst : mode;
                            if (useMode === src /* SyncMode */.YCg.Default && !this.completedOnlineDownloadFirstSync) {
                                throw Error('Attempting to default mode sync without having completed initial.');
                            }
                            const uploadPayloads = useMode === src /* SyncMode */.YCg.Default ? yield this.payloadsByPreparingForServer(payloads) : [];
                            return {
                                uploadPayloads,
                                syncMode: useMode
                            };
                        });
                    }
                    createServerSyncOperation(payloads, options) {
                        let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : src /* SyncMode */.YCg.Default;
                        return __awaiter(this, void 0, void 0, function* () {
                            const syncToken = options.sharedVaultUuids && options.sharedVaultUuids.length > 0 && options.syncSharedVaultsFromScratch ? undefined : yield this.getLastSyncToken();
                            const paginationToken = options.sharedVaultUuids && options.syncSharedVaultsFromScratch ? undefined : yield this.getPaginationToken();
                            const operation = new Operation /* AccountSyncOperation */.U(payloads, (type, response, stats) => __awaiter(this, void 0, void 0, function* () {
                                switch (type) {
                                    case Signals /* SyncSignal */._.Response:
                                        if (this.dealloced) {
                                            return;
                                        }
                                        if (response === null || response === void 0 ? void 0 : response.hasError) {
                                            this.handleErrorServerResponse(response);
                                        }
                                        else if (response) {
                                            yield this.handleSuccessServerResponse(operation, response);
                                        }
                                        break;
                                    case Signals /* SyncSignal */._.StatusChanged:
                                        if (stats) {
                                            this.opStatus.setUploadStatus(stats.completedUploadCount, stats.totalUploadCount);
                                        }
                                        break;
                                }
                            }), this.apiService, {
                                syncToken,
                                paginationToken,
                                sharedVaultUuids: options.sharedVaultUuids
                            });
                            this.logger.debug('Syncing online user', 'source', src /* SyncSource */.Lbd[options.source], 'operation id', operation.id, 'integrity check', options.checkIntegrity, 'mode', src /* SyncMode */.YCg[mode], 'syncToken', syncToken, 'cursorToken', paginationToken, 'payloads', payloads);
                            return operation;
                        });
                    }
                    createSyncOperation(payloads, online, options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (online) {
                                const { uploadPayloads, syncMode } = yield this.getOnlineSyncParameters(payloads, options.mode);
                                return {
                                    operation: yield this.createServerSyncOperation(uploadPayloads, options, syncMode),
                                    mode: syncMode
                                };
                            }
                            else {
                                const { uploadPayloads } = this.getOfflineSyncParameters(payloads, options.mode);
                                return {
                                    operation: this.createOfflineSyncOperation(uploadPayloads, options),
                                    mode: options.mode || src /* SyncMode */.YCg.Default
                                };
                            }
                        });
                    }
                    performSync(options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { shouldExecuteSync, releaseLock } = this.configureSyncLock(options);
                            const { items, beginDate, frozenDirtyIndex, neverSyncedDeleted } = yield this.prepareForSync(options);
                            if (options.mode === src /* SyncMode */.YCg.LocalOnly) {
                                this.logger.debug('Syncing local only, skipping remote sync request');
                                releaseLock();
                                return;
                            }
                            const inTimeResolveQueue = this.getPendingRequestsMadeInTimeToPiggyBackOnCurrentRequest();
                            if (!shouldExecuteSync) {
                                return this.deferSyncRequest(options);
                            }
                            if (this.dealloced) {
                                return;
                            }
                            const latestItems = yield this.prepareForSyncExecution(items, inTimeResolveQueue, beginDate, frozenDirtyIndex);
                            const online = this.sessionManager.online();
                            const { operation, mode: syncMode } = yield this.createSyncOperation(latestItems.map(i => i.payloadRepresentation()), online, options);
                            const operationPromise = operation.run();
                            this.currentSyncRequestPromise = operationPromise;
                            yield operationPromise;
                            if (this.dealloced) {
                                return;
                            }
                            releaseLock();
                            const { hasError } = yield this.handleSyncOperationFinish(operation, options, neverSyncedDeleted, syncMode);
                            if (hasError) {
                                return;
                            }
                            const didSyncAgain = yield this.potentiallySyncAgainAfterSyncCompletion(syncMode, options, inTimeResolveQueue, online);
                            if (didSyncAgain) {
                                return;
                            }
                            if (options.checkIntegrity && online) {
                                yield this.notifyEventSync(src /* SyncEvent */.wMo.SyncRequestsIntegrityCheck, {
                                    source: options.source
                                });
                            }
                            yield this.notifyEventSync(src /* SyncEvent */.wMo.SyncCompletedWithAllItemsUploadedAndDownloaded, {
                                source: options.source,
                                options
                            });
                            this.resolvePendingSyncRequestsThatMadeItInTimeOfCurrentRequest(inTimeResolveQueue);
                            return undefined;
                        });
                    }
                    getRawSyncRequestForExternalUse(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this.dealloced) {
                                return;
                            }
                            const online = this.sessionManager.online();
                            if (!online) {
                                return;
                            }
                            const payloads = yield this.payloadsByPreparingForServer(items.map(i => i.payloadRepresentation()));
                            const syncToken = yield this.getLastSyncToken();
                            const paginationToken = yield this.getPaginationToken();
                            return this.apiService.getSyncHttpRequest(payloads, syncToken, paginationToken, 150);
                        });
                    }
                    handleOfflineResponse(response) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.logger.debug('Offline Sync Response', response);
                            const masterCollection = this.payloadManager.getMasterCollection();
                            const delta = new models_dist.DeltaOfflineSaved(masterCollection, response.savedPayloads);
                            const emit = delta.result();
                            const payloadsToPersist = yield this.payloadManager.emitDeltaEmit(emit);
                            yield this.persistPayloads(payloadsToPersist);
                            this.opStatus.clearError();
                            yield this.notifyEvent(src /* SyncEvent */.wMo.PaginatedSyncRequestCompleted, response);
                        });
                    }
                    handleErrorServerResponse(response) {
                        var _a;
                        this.logger.debug('Sync Error', response);
                        if (response.status === INVALID_SESSION_RESPONSE_STATUS) {
                            void this.notifyEvent(src /* SyncEvent */.wMo.InvalidSession);
                        }
                        if (response.status === TOO_MANY_REQUESTS_RESPONSE_STATUS) {
                            void this.notifyEvent(src /* SyncEvent */.wMo.TooManyRequests);
                        }
                        (_a = this.opStatus) === null || _a === void 0 ? void 0 : _a.setError(response.error);
                        void this.notifyEvent(src /* SyncEvent */.wMo.SyncError, response);
                    }
                    handleSuccessServerResponse(operation, response) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (this._simulate_latency) {
                                yield (0, dist.sleep)(this._simulate_latency.latency);
                            }
                            this.opStatus.clearError();
                            this.opStatus.setDownloadStatus(response.retrievedPayloads.length);
                            const masterCollection = this.payloadManager.getMasterCollection();
                            const historyMap = this.historyService.getHistoryMapCopy();
                            if (response.userEvents && response.userEvents.length > 0) {
                                yield this.notifyEventSync(src /* SyncEvent */.wMo.ReceivedNotifications, response.userEvents);
                            }
                            if (response.asymmetricMessages && response.asymmetricMessages.length > 0) {
                                yield this.notifyEventSync(src /* SyncEvent */.wMo.ReceivedAsymmetricMessages, response.asymmetricMessages);
                            }
                            if (response.vaults && response.vaults.length > 0) {
                                yield this.notifyEventSync(src /* SyncEvent */.wMo.ReceivedRemoteSharedVaults, response.vaults);
                            }
                            if (response.vaultInvites && response.vaultInvites.length > 0) {
                                yield this.notifyEventSync(src /* SyncEvent */.wMo.ReceivedSharedVaultInvites, response.vaultInvites);
                            }
                            const resolver = new ResponseResolver /* ServerSyncResponseResolver */.y({
                                retrievedPayloads: yield this.processServerPayloads(response.retrievedPayloads, models_dist.PayloadSource.RemoteRetrieved),
                                savedPayloads: response.savedPayloads,
                                conflicts: yield this.decryptServerConflicts(response.conflicts)
                            }, masterCollection, operation.payloadsSavedOrSaving, historyMap);
                            this.logger.debug('Online Sync Response', 'Operator ID', operation.id, response.rawResponse.data, 'Decrypted payloads', resolver['payloadSet']);
                            const emits = resolver.result();
                            for (const emit of emits) {
                                const payloadsToPersist = yield this.payloadManager.emitDeltaEmit(emit);
                                yield this.persistPayloads(payloadsToPersist);
                            }
                            if (!operation.options.sharedVaultUuids) {
                                yield Promise.all([this.setLastSyncToken(response.lastSyncToken), this.setPaginationToken(response.paginationToken)]);
                            }
                            yield this.notifyEvent(src /* SyncEvent */.wMo.PaginatedSyncRequestCompleted, Object.assign(Object.assign({}, response), {
                                uploadedPayloads: operation.payloads,
                                options: operation.options
                            }));
                        });
                    }
                    decryptServerConflicts(conflictMap) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const decrypted = {};
                            for (const conflictType of Object.keys(conflictMap)) {
                                const conflictsForType = conflictMap[conflictType];
                                if (!conflictsForType) {
                                    continue;
                                }
                                if (!decrypted[conflictType]) {
                                    decrypted[conflictType] = [];
                                }
                                const decryptedConflictsForType = decrypted[conflictType];
                                if (!decryptedConflictsForType) {
                                    throw Error('Decrypted conflicts for type should exist');
                                }
                                for (const conflict of conflictsForType) {
                                    const decryptedUnsavedItem = conflict.unsaved_item ? yield this.processServerPayload(conflict.unsaved_item, models_dist.PayloadSource.RemoteRetrieved) : undefined;
                                    const decryptedServerItem = conflict.server_item ? yield this.processServerPayload(conflict.server_item, models_dist.PayloadSource.RemoteRetrieved) : undefined;
                                    const decryptedEntry = {
                                        type: conflict.type,
                                        unsaved_item: decryptedUnsavedItem,
                                        server_item: decryptedServerItem
                                    };
                                    decryptedConflictsForType.push(decryptedEntry);
                                }
                            }
                            return decrypted;
                        });
                    }
                    processServerPayload(item, source) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const result = yield this.processServerPayloads([item], source);
                            return result[0];
                        });
                    }
                    processServerPayloads(items, source) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const payloads = items.map(i => {
                                const result = CreatePayloadFromRawServerItem(i, source);
                                return result.isFailed() ? undefined : result.getValue();
                            }).filter(dist.isNotUndefined);
                            const { encrypted, deleted } = (0, models_dist.CreateNonDecryptedPayloadSplit)(payloads);
                            const results = [...deleted];
                            const { rootKeyEncryption, itemsKeyEncryption, keySystemRootKeyEncryption } = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(encrypted);
                            const { results: rootKeyDecryptionResults, map: processedItemsKeys } = yield this.decryptServerItemsKeys(rootKeyEncryption || []);
                            (0, dist.extendArray)(results, rootKeyDecryptionResults);
                            const { results: keySystemRootKeyDecryptionResults, map: processedKeySystemItemsKeys } = yield this.decryptServerKeySystemItemsKeys(keySystemRootKeyEncryption || []);
                            (0, dist.extendArray)(results, keySystemRootKeyDecryptionResults);
                            if (itemsKeyEncryption) {
                                const decryptionResults = yield this.decryptProcessedServerPayloads(itemsKeyEncryption, Object.assign(Object.assign({}, processedItemsKeys), processedKeySystemItemsKeys));
                                (0, dist.extendArray)(results, decryptionResults);
                            }
                            return results;
                        });
                    }
                    decryptServerItemsKeys(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const map = {};
                            if (payloads.length === 0) {
                                return {
                                    results: [],
                                    map
                                };
                            }
                            const rootKeySplit = {
                                usesRootKeyWithKeyLookup: {
                                    items: payloads
                                }
                            };
                            const results = yield this.encryptionService.decryptSplit(rootKeySplit);
                            results.forEach(result => {
                                if ((0, models_dist.isDecryptedPayload)(result) && result.content_type === dist_src.ContentType.TYPES.ItemsKey) {
                                    map[result.uuid] = result;
                                }
                            });
                            return {
                                results,
                                map
                            };
                        });
                    }
                    decryptServerKeySystemItemsKeys(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const map = {};
                            if (payloads.length === 0) {
                                return {
                                    results: [],
                                    map
                                };
                            }
                            const keySystemRootKeySplit = {
                                usesKeySystemRootKeyWithKeyLookup: {
                                    items: payloads
                                }
                            };
                            const results = yield this.encryptionService.decryptSplit(keySystemRootKeySplit);
                            results.forEach(result => {
                                if ((0, models_dist.isDecryptedPayload)(result) && result.content_type === dist_src.ContentType.TYPES.KeySystemItemsKey) {
                                    map[result.uuid] = result;
                                }
                            });
                            return {
                                results,
                                map
                            };
                        });
                    }
                    decryptProcessedServerPayloads(payloads, map) {
                        return __awaiter(this, void 0, void 0, function* () {
                            return Promise.all(payloads.map(encrypted => __awaiter(this, void 0, void 0, function* () {
                                const previouslyProcessedItemsKey = map[encrypted.items_key_id];
                                const itemsKey = previouslyProcessedItemsKey ? (0, models_dist.CreateDecryptedItemFromPayload)(previouslyProcessedItemsKey) : undefined;
                                const keyedSplit = {};
                                if (itemsKey) {
                                    keyedSplit.usesItemsKey = {
                                        items: [encrypted],
                                        key: itemsKey
                                    };
                                }
                                else {
                                    keyedSplit.usesItemsKeyWithKeyLookup = {
                                        items: [encrypted]
                                    };
                                }
                                return this.encryptionService.decryptSplitSingle(keyedSplit);
                            })));
                        });
                    }
                    handleSyncOperationFinish(operation, options, neverSyncedDeleted, syncMode) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.opStatus.setDidEnd();
                            if (this.opStatus.hasError()) {
                                return {
                                    hasError: true
                                };
                            }
                            this.opStatus.reset();
                            this.lastSyncDate = new Date();
                            this.syncFrequencyGuard.incrementCallsPerMinute();
                            if (operation instanceof Operation /* AccountSyncOperation */.U && operation.numberOfItemsInvolved >= this.majorChangeThreshold) {
                                void this.notifyEvent(src /* SyncEvent */.wMo.MajorDataChange);
                            }
                            if (neverSyncedDeleted.length > 0) {
                                yield this.handleNeverSyncedDeleted(neverSyncedDeleted);
                            }
                            if (syncMode !== src /* SyncMode */.YCg.DownloadFirst) {
                                yield this.notifyEvent(src /* SyncEvent */.wMo.SyncCompletedWithAllItemsUploaded, {
                                    source: options.source
                                });
                            }
                            return {
                                hasError: false
                            };
                        });
                    }
                    handleDownloadFirstCompletionAndSyncAgain(online, options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (online) {
                                this.completedOnlineDownloadFirstSync = true;
                            }
                            yield this.notifyEvent(src /* SyncEvent */.wMo.DownloadFirstSyncCompleted);
                            yield this.sync({
                                source: src /* SyncSource */.Lbd.AfterDownloadFirst,
                                checkIntegrity: true,
                                awaitAll: options.awaitAll
                            });
                        });
                    }
                    syncAgainByHandlingRequestsWaitingInResolveQueue(options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            this.logger.debug('Syncing again from resolve queue');
                            const promise = this.sync({
                                source: src /* SyncSource */.Lbd.ResolveQueue,
                                checkIntegrity: options.checkIntegrity
                            });
                            if (options.awaitAll) {
                                yield promise;
                            }
                        });
                    }
                    /**
                     * As part of the just concluded sync operation, more items may have
                     * been dirtied (like conflicts), and the caller may want to await the
                     * full resolution of these items.
                     */
                    syncAgainByHandlingNewDirtyItems(options) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.sync({
                                source: src /* SyncSource */.Lbd.MoreDirtyItems,
                                checkIntegrity: options.checkIntegrity,
                                awaitAll: options.awaitAll
                            });
                        });
                    }
                    /**
                     * For timing strategy SyncQueueStrategy.ResolveOnNext.
                     * Execute any callbacks pulled before this sync request began.
                     * Calling resolve on the callbacks should be the last thing we do in this function,
                     * to simulate calling .sync as if it went through straight to the end without having
                     * to be queued.
                     */
                    resolvePendingSyncRequestsThatMadeItInTimeOfCurrentRequest(inTimeResolveQueue) {
                        for (const callback of inTimeResolveQueue) {
                            callback.resolve();
                        }
                    }
                    potentiallySyncAgainAfterSyncCompletion(syncMode, options, inTimeResolveQueue, online) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (syncMode === src /* SyncMode */.YCg.DownloadFirst) {
                                yield this.handleDownloadFirstCompletionAndSyncAgain(online, options);
                                this.resolvePendingSyncRequestsThatMadeItInTimeOfCurrentRequest(inTimeResolveQueue);
                                return true;
                            }
                            const didSpawnNewRequest = this.popSpawnQueue();
                            const resolveQueueHasRequestsThatDidntMakeItInTime = this.resolveQueue.length > 0;
                            if (!didSpawnNewRequest && resolveQueueHasRequestsThatDidntMakeItInTime) {
                                yield this.syncAgainByHandlingRequestsWaitingInResolveQueue(options);
                                this.resolvePendingSyncRequestsThatMadeItInTimeOfCurrentRequest(inTimeResolveQueue);
                                return true;
                            }
                            const newItemsNeedingSync = this.itemsNeedingSync();
                            if (newItemsNeedingSync.length > 0) {
                                yield this.syncAgainByHandlingNewDirtyItems(options);
                                this.resolvePendingSyncRequestsThatMadeItInTimeOfCurrentRequest(inTimeResolveQueue);
                                return true;
                            }
                            return false;
                        });
                    }
                    /**
                     * Items that have never been synced and marked as deleted should be cleared
                     * as dirty, mapped, then removed from storage.
                     */
                    handleNeverSyncedDeleted(items) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const payloads = items.map(item => {
                                return item.payloadRepresentation({
                                    dirty: false
                                });
                            });
                            yield this.payloadManager.emitPayloads(payloads, models_dist.PayloadEmitSource.LocalChanged);
                            yield this.persistPayloads(payloads);
                        });
                    }
                    persistPayloads(payloads) {
                        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                            throwError: true
                        };
                        return __awaiter(this, void 0, void 0, function* () {
                            if (payloads.length === 0 || this.dealloced) {
                                return;
                            }
                            return this.storageService.savePayloads(payloads).catch(error => {
                                if (options.throwError) {
                                    void this.notifyEvent(src /* SyncEvent */.wMo.DatabaseWriteError, error);
                                    Log /* SNLog */.W.error(error);
                                }
                            });
                        });
                    }
                    setInSync(isInSync) {
                        if (isInSync === !this.outOfSync) {
                            return;
                        }
                        if (isInSync) {
                            this.outOfSync = false;
                            void this.notifyEvent(src /* SyncEvent */.wMo.ExitOutOfSync);
                        }
                        else {
                            this.outOfSync = true;
                            void this.notifyEvent(src /* SyncEvent */.wMo.EnterOutOfSync);
                        }
                    }
                    handleEvent(event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            switch (event.type) {
                                case src /* IntegrityEvent */.ezr.IntegrityCheckCompleted:
                                    yield this.handleIntegrityCheckEventResponse(event.payload);
                                    break;
                                case src /* WebSocketsServiceEvent */.fAX.ItemsChangedOnServer:
                                    this.wasNotifiedOfItemsChangeOnServer = true;
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                    handleIntegrityCheckEventResponse(eventPayload) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const rawPayloads = eventPayload.rawPayloads;
                            if (rawPayloads.length === 0) {
                                this.setInSync(true);
                                return;
                            }
                            const rawPayloadsFilteringResult = (0, models_dist.FilterDisallowedRemotePayloadsAndMap)(rawPayloads);
                            const receivedPayloads = rawPayloadsFilteringResult.filtered.map(rawPayload => {
                                const result = CreatePayloadFromRawServerItem(rawPayload, models_dist.PayloadSource.RemoteRetrieved);
                                if (result.isFailed()) {
                                    return undefined;
                                }
                                return result.getValue();
                            }).filter(dist.isNotUndefined);
                            const payloadSplit = (0, models_dist.CreateNonDecryptedPayloadSplit)(receivedPayloads);
                            const encryptionSplit = (0, encryption_src /* SplitPayloadsByEncryptionType */.xg)(payloadSplit.encrypted);
                            const keyedSplit = (0, encryption_src /* CreateDecryptionSplitWithKeyLookup */.nJ)(encryptionSplit);
                            const decryptionResults = yield this.encryptionService.decryptSplit(keyedSplit);
                            this.setInSync(false);
                            yield this.emitOutOfSyncRemotePayloads([...decryptionResults, ...payloadSplit.deleted]);
                            const shouldCheckIntegrityAgainAfterSync = eventPayload.source !== src /* SyncSource */.Lbd.ResolveOutOfSync;
                            yield this.sync({
                                checkIntegrity: shouldCheckIntegrityAgainAfterSync,
                                source: src /* SyncSource */.Lbd.ResolveOutOfSync
                            });
                        });
                    }
                    emitOutOfSyncRemotePayloads(payloads) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const delta = new models_dist.DeltaOutOfSync(this.payloadManager.getMasterCollection(), models_dist.ImmutablePayloadCollection.WithPayloads(payloads), this.historyService.getHistoryMapCopy());
                            const emit = delta.result();
                            yield this.payloadManager.emitDeltaEmit(emit);
                            yield this.persistPayloads(emit.emits);
                        });
                    }
                    syncSharedVaultsFromScratch(sharedVaultUuids) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield this.sync({
                                sharedVaultUuids: sharedVaultUuids,
                                syncSharedVaultsFromScratch: true,
                                queueStrategy: src /* SyncQueueStrategy */.Sii.ForceSpawnNew,
                                awaitAll: true
                            });
                        });
                    }
                    /** @e2e_testing */
                    // eslint-disable-next-line camelcase
                    ut_setDatabaseLoaded(loaded) {
                        this.databaseLoaded = loaded;
                    }
                    /** @e2e_testing */
                    // eslint-disable-next-line camelcase
                    ut_clearLastSyncDate() {
                        this.lastSyncDate = undefined;
                    }
                    /** @e2e_testing */
                    // eslint-disable-next-line camelcase
                    ut_beginLatencySimulator(latency) {
                        this._simulate_latency = {
                            latency: latency || 1000,
                            enabled: true
                        };
                    }
                    /** @e2e_testing */
                    // eslint-disable-next-line camelcase
                    ut_endLatencySimulator() {
                        this._simulate_latency = undefined;
                    }
                }
                /***/ 
            }),
            /***/ 91096: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    U8: () => ( /* reexport */Operation /* AccountSyncOperation */.U),
                    bQ: () => ( /* reexport */ActionsService /* ActionsService */.b),
                    Jg: () => ( /* reexport */Types /* AllowedBatchContentTypes */.Jg),
                    h6: () => ( /* reexport */Types /* AllowedBatchStreaming */.h6),
                    IX: () => ( /* reexport */ApplicationService),
                    ne: () => ( /* reexport */ChallengeOperation /* ChallengeOperation */.n),
                    ap: () => ( /* reexport */ChallengeResponse /* ChallengeResponse */.a),
                    PJ: () => ( /* reexport */ChallengeService /* ChallengeService */.P),
                    yW: () => ( /* reexport */ComponentManager /* ComponentManager */.y),
                    SV: () => ( /* reexport */ComponentViewer /* ComponentViewer */.S),
                    ql: () => ( /* reexport */DeprecatedHttpService /* DeprecatedHttpService */.q),
                    e5: () => ( /* reexport */DiskStorageService /* DiskStorageService */.e),
                    kq: () => ( /* reexport */FeaturesService /* FeaturesService */.k),
                    EO: () => ( /* reexport */HistoryManager /* HistoryManager */.E),
                    A: () => ( /* reexport */ItemManager /* ItemManager */.A),
                    D0: () => ( /* reexport */KeyRecoveryService /* KeyRecoveryService */.D),
                    Af: () => ( /* reexport */ApiService /* LegacyApiService */.A),
                    o8: () => ( /* reexport */ListedService /* ListedService */.o),
                    aM: () => ( /* reexport */SessionManager /* MINIMUM_PASSWORD_LENGTH */.aM),
                    pY: () => ( /* reexport */MfaService /* MfaService */.p),
                    HK: () => ( /* reexport */MigrationService /* MigrationService */.H),
                    Sn: () => ( /* reexport */SessionManager /* MissingAccountParams */.Sn),
                    Vu: () => ( /* reexport */MutatorService /* MutatorService */.V),
                    Bi: () => ( /* reexport */Offline_Operation /* OfflineSyncOperation */.B),
                    nB: () => ( /* reexport */Paths /* Paths */.n),
                    Ot: () => ( /* reexport */PayloadManager /* PayloadManager */.O),
                    KJ: () => ( /* reexport */PreferencesService /* PreferencesService */.y),
                    Ps: () => ( /* reexport */ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction),
                    nT: () => ( /* reexport */ProtectionService /* ProtectionService */.n),
                    jg: () => ( /* reexport */ProtectionSessionDurations),
                    wJ: () => ( /* reexport */Types /* ReadwriteActions */.wJ),
                    Fi: () => ( /* reexport */Response /* ServerSyncResponse */.F),
                    y0: () => ( /* reexport */ResponseResolver /* ServerSyncResponseResolver */.y),
                    Sj: () => ( /* reexport */SessionManager /* SessionManager */.Sj),
                    gb: () => ( /* reexport */SNSettingsService /* SettingsService */.g),
                    Wz: () => ( /* reexport */SingletonManager /* SingletonManager */.W),
                    _U: () => ( /* reexport */SyncService /* SyncService */._),
                    jH: () => ( /* reexport */Operation /* SyncUpDownLimit */.j),
                    Fr: () => ( /* reexport */UnprotectedAccessSecondsDuration /* UnprotectedAccessSecondsDuration */.F),
                    z4: () => ( /* reexport */isValidProtectionSessionLength /* isValidProtectionSessionLength */.z)
                });
                // EXTERNAL MODULE: ./lib/Services/Actions/ActionsService.ts
                var ActionsService = __webpack_require__(19820);
                // EXTERNAL MODULE: ./lib/Services/Api/ApiService.ts
                var ApiService = __webpack_require__(54911);
                // EXTERNAL MODULE: ./lib/Services/Api/DeprecatedHttpService.ts
                var DeprecatedHttpService = __webpack_require__(78734);
                // EXTERNAL MODULE: ./lib/Services/Api/Paths.ts
                var Paths = __webpack_require__(98361);
                // EXTERNAL MODULE: ./lib/Services/Session/SessionManager.ts + 1 modules
                var SessionManager = __webpack_require__(53218);
                ; // CONCATENATED MODULE: ./lib/Services/Api/index.ts
                // EXTERNAL MODULE: ../services/src/index.ts + 181 modules
                var src = __webpack_require__(55668);
                ; // CONCATENATED MODULE: ./lib/Services/AppService/ApplicationService.ts
                var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                class ApplicationService extends src /* AbstractService */.wcN {
                    constructor(application, internalEventBus) {
                        super(internalEventBus);
                        this.application = application;
                        this.internalEventBus = internalEventBus;
                        this.addAppEventObserverAfterSubclassesFinishConstructing();
                    }
                    deinit() {
                        ;
                        this.application = undefined;
                        this.unsubApp();
                        this.unsubApp = undefined;
                        super.deinit();
                    }
                    addAppEventObserverAfterSubclassesFinishConstructing() {
                        setTimeout(() => {
                            this.addAppEventObserver();
                        }, 0);
                    }
                    addAppEventObserver() {
                        if (this.application.isStarted()) {
                            void this.onAppStart();
                        }
                        if (this.application.isLaunched()) {
                            void this.onAppLaunch();
                        }
                        this.unsubApp = this.application.addEventObserver(event => __awaiter(this, void 0, void 0, function* () {
                            yield this.onAppEvent(event);
                            if (event === src /* ApplicationEvent */.n9K.Started) {
                                void this.onAppStart();
                            }
                            else if (event === src /* ApplicationEvent */.n9K.Launched) {
                                void this.onAppLaunch();
                            }
                            else if (event === src /* ApplicationEvent */.n9K.CompletedFullSync) {
                                this.onAppFullSync();
                            }
                            else if (event === src /* ApplicationEvent */.n9K.CompletedIncrementalSync) {
                                this.onAppIncrementalSync();
                            }
                            else if (event === src /* ApplicationEvent */.n9K.KeyStatusChanged) {
                                void this.onAppKeyChange();
                            }
                        }));
                    }
                    onAppEvent(_event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** Optional override */
                        });
                    }
                    onAppStart() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** Optional override */
                        });
                    }
                    onAppLaunch() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** Optional override */
                        });
                    }
                    onAppKeyChange() {
                        return __awaiter(this, void 0, void 0, function* () {
                            /** Optional override */
                        });
                    }
                    onAppIncrementalSync() {
                        /** Optional override */
                    }
                    onAppFullSync() {
                        /** Optional override */
                    }
                }
                // EXTERNAL MODULE: ./lib/Services/Challenge/ChallengeOperation.ts
                var ChallengeOperation = __webpack_require__(68625);
                // EXTERNAL MODULE: ./lib/Services/Challenge/ChallengeResponse.ts
                var ChallengeResponse = __webpack_require__(59472);
                // EXTERNAL MODULE: ./lib/Services/Challenge/ChallengeService.ts
                var ChallengeService = __webpack_require__(40278);
                ; // CONCATENATED MODULE: ./lib/Services/Challenge/index.ts
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/ComponentManager.ts + 7 modules
                var ComponentManager = __webpack_require__(74987);
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/ComponentViewer.ts
                var ComponentViewer = __webpack_require__(56297);
                // EXTERNAL MODULE: ./lib/Services/ComponentManager/Types.ts
                var Types = __webpack_require__(20549);
                ; // CONCATENATED MODULE: ./lib/Services/ComponentManager/index.ts
                // EXTERNAL MODULE: ./lib/Services/Features/FeaturesService.ts + 3 modules
                var FeaturesService = __webpack_require__(6314);
                ; // CONCATENATED MODULE: ./lib/Services/Features/index.ts
                // EXTERNAL MODULE: ./lib/Services/History/HistoryManager.ts
                var HistoryManager = __webpack_require__(29675);
                ; // CONCATENATED MODULE: ./lib/Services/History/index.ts
                // EXTERNAL MODULE: ./lib/Services/Items/ItemManager.ts
                var ItemManager = __webpack_require__(45447);
                ; // CONCATENATED MODULE: ./lib/Services/Items/index.ts
                // EXTERNAL MODULE: ./lib/Services/KeyRecovery/KeyRecoveryService.ts + 3 modules
                var KeyRecoveryService = __webpack_require__(80738);
                // EXTERNAL MODULE: ./lib/Services/Listed/ListedService.ts
                var ListedService = __webpack_require__(81679);
                ; // CONCATENATED MODULE: ./lib/Services/Listed/index.ts
                // EXTERNAL MODULE: ./lib/Services/Mfa/MfaService.ts
                var MfaService = __webpack_require__(3876);
                // EXTERNAL MODULE: ./lib/Services/Migration/MigrationService.ts
                var MigrationService = __webpack_require__(8740);
                // EXTERNAL MODULE: ./lib/Services/Mutator/MutatorService.ts
                var MutatorService = __webpack_require__(28178);
                ; // CONCATENATED MODULE: ./lib/Services/Mutator/index.ts
                // EXTERNAL MODULE: ./lib/Services/Payloads/PayloadManager.ts
                var PayloadManager = __webpack_require__(64892);
                ; // CONCATENATED MODULE: ./lib/Services/Payloads/index.ts
                // EXTERNAL MODULE: ./lib/Services/Preferences/PreferencesService.ts
                var PreferencesService = __webpack_require__(30693);
                // EXTERNAL MODULE: ./lib/Services/Protection/ProtectionService.ts
                var ProtectionService = __webpack_require__(51271);
                ; // CONCATENATED MODULE: ./lib/Services/Protection/ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction.ts
                const ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction = 30;
                // EXTERNAL MODULE: ./lib/Services/Protection/UnprotectedAccessSecondsDuration.ts
                var UnprotectedAccessSecondsDuration = __webpack_require__(97210);
                ; // CONCATENATED MODULE: ./lib/Services/Protection/ProtectionSessionDurations.ts
                const ProtectionSessionDurations = [{
                        valueInSeconds: UnprotectedAccessSecondsDuration /* UnprotectedAccessSecondsDuration */.F.OneMinute,
                        label: '1 Minute'
                    }, {
                        valueInSeconds: UnprotectedAccessSecondsDuration /* UnprotectedAccessSecondsDuration */.F.FiveMinutes,
                        label: '5 Minutes'
                    }, {
                        valueInSeconds: UnprotectedAccessSecondsDuration /* UnprotectedAccessSecondsDuration */.F.OneHour,
                        label: '1 Hour'
                    }, {
                        valueInSeconds: UnprotectedAccessSecondsDuration /* UnprotectedAccessSecondsDuration */.F.OneWeek,
                        label: '1 Week'
                    }];
                // EXTERNAL MODULE: ./lib/Services/Protection/isValidProtectionSessionLength.ts
                var isValidProtectionSessionLength = __webpack_require__(17956);
                ; // CONCATENATED MODULE: ./lib/Services/Protection/index.ts
                ; // CONCATENATED MODULE: ./lib/Services/Session/index.ts
                // EXTERNAL MODULE: ./lib/Services/Settings/SNSettingsService.ts + 2 modules
                var SNSettingsService = __webpack_require__(98116);
                ; // CONCATENATED MODULE: ./lib/Services/Settings/index.ts
                // EXTERNAL MODULE: ./lib/Services/Singleton/SingletonManager.ts
                var SingletonManager = __webpack_require__(15109);
                // EXTERNAL MODULE: ./lib/Services/Storage/DiskStorageService.ts
                var DiskStorageService = __webpack_require__(28559);
                // EXTERNAL MODULE: ./lib/Services/Sync/SyncService.ts + 1 modules
                var SyncService = __webpack_require__(37486);
                // EXTERNAL MODULE: ./lib/Services/Sync/Account/Operation.ts
                var Operation = __webpack_require__(37185);
                // EXTERNAL MODULE: ./lib/Services/Sync/Account/ResponseResolver.ts
                var ResponseResolver = __webpack_require__(73822);
                // EXTERNAL MODULE: ./lib/Services/Sync/Offline/Operation.ts + 1 modules
                var Offline_Operation = __webpack_require__(48671);
                // EXTERNAL MODULE: ./lib/Services/Sync/Account/Response.ts
                var Response = __webpack_require__(87570);
                ; // CONCATENATED MODULE: ./lib/Services/Sync/index.ts
                ; // CONCATENATED MODULE: ./lib/Services/index.ts
                /***/ 
            }),
            /***/ 52450: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    e: () => ( /* binding */Strings)
                });
                // EXTERNAL MODULE: ../../node_modules/@standardnotes/common/dist/src/index.js
                var src = __webpack_require__(20875);
                ; // CONCATENATED MODULE: ./lib/Strings/Confirm.ts
                const ConfirmStrings = {
                    ProtocolVersionExpired(version) {
                        var _a;
                        return {
                            Message: 'The encryption version for your account is outdated and requires upgrade. ' + 'You may proceed with login, but are advised to perform a security update using the web or desktop application.\n\n' + "If your account was created after ".concat((_a = src.ProtocolExpirationDates[version]) === null || _a === void 0 ? void 0 : _a.toLocaleString(), ", it may not be safe to continue signing in. ") + 'In that case, please discontinue your sign in request and contact support.\n\n' + 'For more information, visit standardnotes.com/help/security.',
                            Title: 'Update Recommended',
                            ConfirmButton: 'Sign In'
                        };
                    }
                };
                ; // CONCATENATED MODULE: ./lib/Strings/Network.ts
                const NetworkStrings = {
                    Files: {
                        FailedStartUploadSession: 'Failed to start an upload session.',
                        FailedCloseUploadSession: 'Failed to close an upload session.',
                        FailedUploadFileChunk: 'Failed to upload file chunk.',
                        FailedDownloadFileChunk: 'Failed to download file chunk.',
                        FailedDeleteFile: 'Failed to delete file.'
                    }
                };
                ; // CONCATENATED MODULE: ./lib/Strings/index.ts
                const Strings = {
                    Network: NetworkStrings,
                    Confirm: ConfirmStrings
                };
                /***/ 
            }),
            /***/ 34146: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    M: () => ( /* reexport */DefaultHost)
                });
                ; // CONCATENATED MODULE: ./lib/Url/DefaultHost.ts
                var DefaultHost;
                (function (DefaultHost) {
                    DefaultHost["Api"] = "https://api.standardnotes.com";
                    DefaultHost["WebSocket"] = "wss://sockets.standardnotes.com";
                })(DefaultHost || (DefaultHost = {}));
                ; // CONCATENATED MODULE: ./lib/Url/index.ts
                /***/ 
            }),
            /***/ 94986: 
            /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ D8: () => ( /* binding */compareSemVersions),
                    /* harmony export */ DU: () => ( /* binding */PreviousSnjsVersion1_0_0),
                    /* harmony export */ Oq: () => ( /* binding */PreviousSnjsVersion2_0_0),
                    /* harmony export */ "in": () => ( /* binding */SnjsVersion),
                    /* harmony export */ jV: () => ( /* binding */isRightVersionGreaterThanLeft)
                    /* harmony export */ 
                });
                /* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27374);
                /* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(semver__WEBPACK_IMPORTED_MODULE_0__);
                const SnjsVersion = "2.209.5";
                /**
                 * Legacy architecture (pre-3.5 clients)
                 */
                const PreviousSnjsVersion1_0_0 = '1.0.0';
                /**
                 * First release of new architecture, did not automatically store version
                 */
                const PreviousSnjsVersion2_0_0 = '2.0.0';
                /**
                 * Returns true if the version string on the right is greater than the one
                 * on the left. Accepts any format version number, like 2, 2.0, 2.0.0, or even 2.0.0.01
                 */
                function isRightVersionGreaterThanLeft(left, right) {
                    return compareSemVersions(left, right) === -1;
                }
                /**
                 *  -1 if a < b
                 *  0 if a == b
                 *  1 if a > b
                 */
                function compareSemVersions(left, right) {
                    if ((0, semver__WEBPACK_IMPORTED_MODULE_0__.eq)(left, right)) {
                        return 0;
                    }
                    if ((0, semver__WEBPACK_IMPORTED_MODULE_0__.gt)(left, right)) {
                        return 1;
                    }
                    return -1;
                }
                /***/ 
            }),
            /***/ 81346: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.addYearsToDate = exports.addMonthsToDate = exports.addDaysToDate = exports.addHoursToDate = void 0;
                function addHoursToDate(date, hours) {
                    const result = new Date(date);
                    result.setHours(result.getHours() + hours);
                    return result;
                }
                exports.addHoursToDate = addHoursToDate;
                /** Negative numbers are supported as well */
                function addDaysToDate(date, days) {
                    const result = new Date(date);
                    result.setDate(result.getDate() + days);
                    return result;
                }
                exports.addDaysToDate = addDaysToDate;
                function addMonthsToDate(date, months) {
                    const result = new Date(date);
                    result.setMonth(result.getMonth() + months);
                    return result;
                }
                exports.addMonthsToDate = addMonthsToDate;
                function addYearsToDate(date, years) {
                    const result = new Date(date);
                    result.setFullYear(result.getFullYear() + years);
                    return result;
                }
                exports.addYearsToDate = addYearsToDate;
                /***/ 
            }),
            /***/ 90622: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Deferred = void 0;
                const Deferred = () => {
                    let resolve;
                    let reject;
                    const promise = new Promise((res, rej) => {
                        resolve = res;
                        reject = rej;
                    });
                    return {
                        resolve,
                        reject,
                        promise
                    };
                };
                exports.Deferred = Deferred;
                /***/ 
            }),
            /***/ 75760: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.DependencyContainer = void 0;
                const Utils_1 = __webpack_require__(37225);
                const isDeinitable_1 = __webpack_require__(75807);
                class DependencyContainer {
                    constructor() {
                        this.factory = new Map();
                        this.dependencies = new Map();
                    }
                    deinit() {
                        this.factory.clear();
                        const deps = this.getAll();
                        for (const dep of deps) {
                            if ((0, isDeinitable_1.isDeinitable)(dep)) {
                                dep.deinit();
                            }
                        }
                        this.dependencies.clear();
                    }
                    getAll() {
                        return Array.from(this.dependencies.values()).filter(Utils_1.isNotUndefined);
                    }
                    bind(sym, maker) {
                        this.factory.set(sym, maker);
                    }
                    get(sym) {
                        const dep = this.dependencies.get(sym);
                        if (dep) {
                            return dep;
                        }
                        const maker = this.factory.get(sym);
                        if (!maker) {
                            throw new Error("No dependency maker found for ".concat(sym.toString()));
                        }
                        const instance = maker();
                        if (!instance) {
                            /** Could be optional */
                            return undefined;
                        }
                        this.dependencies.set(sym, instance);
                        return instance;
                    }
                }
                exports.DependencyContainer = DependencyContainer;
                /***/ 
            }),
            /***/ 75807: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.canBlockDeinit = exports.isDeinitable = void 0;
                function isDeinitable(service) {
                    if (!service) {
                        throw new Error('Service is undefined');
                    }
                    return typeof service.deinit === 'function';
                }
                exports.isDeinitable = isDeinitable;
                function canBlockDeinit(service) {
                    if (!service) {
                        throw new Error('Service is undefined');
                    }
                    return typeof service.blockDeinit === 'function';
                }
                exports.canBlockDeinit = canBlockDeinit;
                /***/ 
            }),
            /***/ 12377: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.parseAndCreateZippableFileName = exports.createZippableFileName = exports.truncateFileName = exports.sanitizeFileName = exports.parseFileName = void 0;
                function parseFileName(fileName) {
                    const pattern = /(?:\.([^.]+))$/;
                    const extMatches = pattern.exec(fileName);
                    const ext = (extMatches === null || extMatches === void 0 ? void 0 : extMatches[1]) || '';
                    const name = fileName.includes('.') ? fileName.substring(0, fileName.lastIndexOf('.')) : fileName;
                    return {
                        name,
                        ext
                    };
                }
                exports.parseFileName = parseFileName;
                function sanitizeFileName(name) {
                    return name.trim().replace(/[.\\/:"?*|<>]/g, '_');
                }
                exports.sanitizeFileName = sanitizeFileName;
                function truncateFileName(name, maxLength) {
                    return name.length > maxLength ? name.slice(0, maxLength) : name;
                }
                exports.truncateFileName = truncateFileName;
                const MaxFileNameLength = 100;
                function createZippableFileName(name) {
                    let suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                    let format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'txt';
                    let maxLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MaxFileNameLength;
                    const sanitizedName = sanitizeFileName(name);
                    const truncatedName = truncateFileName(sanitizedName, maxLength);
                    const nameEnd = suffix + '.' + format;
                    return truncatedName + nameEnd;
                }
                exports.createZippableFileName = createZippableFileName;
                function parseAndCreateZippableFileName(name) {
                    let suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                    const { name: parsedName, ext } = parseFileName(name);
                    return createZippableFileName(parsedName, suffix, ext);
                }
                exports.parseAndCreateZippableFileName = parseAndCreateZippableFileName;
                /***/ 
            }),
            /***/ 33638: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 91379: 
            /***/ ((__unused_webpack_module, exports) => {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Logger = void 0;
                class Logger {
                    constructor(appIdentifier) {
                        this.appIdentifier = appIdentifier;
                        this.level = 'none';
                    }
                    canLog(level) {
                        if (this.level === 'none') {
                            return false;
                        }
                        const levels = ['debug', 'info', 'warn', 'error'];
                        return levels.indexOf(level) >= levels.indexOf(this.level);
                    }
                    setLevel(level) {
                        this.level = level;
                    }
                    debug(message) {
                        if (this.canLog('debug')) {
                            for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                optionalParams[_key - 1] = arguments[_key];
                            }
                            this.logWithColor(message, ...optionalParams);
                        }
                    }
                    info(message) {
                        if (this.canLog('info')) {
                            for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                                optionalParams[_key2 - 1] = arguments[_key2];
                            }
                            this.logWithColor(message, ...optionalParams);
                        }
                    }
                    warn(message) {
                        if (this.canLog('warn')) {
                            for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                                optionalParams[_key3 - 1] = arguments[_key3];
                            }
                            console.warn(message, ...optionalParams);
                        }
                    }
                    error(message) {
                        if (this.canLog('error')) {
                            for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                                optionalParams[_key4 - 1] = arguments[_key4];
                            }
                            console.error(message, ...optionalParams);
                        }
                    }
                    logWithColor() {
                        const date = new Date();
                        const timeString = "".concat(date.toLocaleTimeString().replace(' PM', '').replace(' AM', ''), ".").concat(date.getMilliseconds());
                        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                            args[_key5] = arguments[_key5];
                        }
                        this.customLog("%c".concat(this.appIdentifier, "%c").concat(timeString), 'color: font-weight: bold; margin-right: 4px', 'color: gray', ...args);
                    }
                    customLog() {
                        for (var _len6 = arguments.length, _args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                            _args[_key6] = arguments[_key6];
                        }
                        // eslint-disable-next-line no-console, prefer-rest-params
                        Function.prototype.apply.call(console.log, console, arguments);
                    }
                }
                exports.Logger = Logger;
                exports["default"] = Logger;
                /***/ 
            }),
            /***/ 13777: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                /***/ 
            }),
            /***/ 47887: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.classNames = void 0;
                const Utils_1 = __webpack_require__(37225);
                const classNames = function classNames() {
                    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
                        values[_key] = arguments[_key];
                    }
                    return values.map(value => typeof value === 'string' ? value : null).filter(Utils_1.isNotUndefined).join(' ');
                };
                exports.classNames = classNames;
                /***/ 
            }),
            /***/ 92484: 
            /***/ ((__unused_webpack_module, exports) => {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                /**
                 * MIT License
                
                Copyright (c) 2017 Jakub Chodorowicz
                
                Permission is hereby granted, free of charge, to any person obtaining a copy
                of this software and associated documentation files (the "Software"), to deal
                in the Software without restriction, including without limitation the rights
                to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                copies of the Software, and to permit persons to whom the Software is
                furnished to do so, subject to the following conditions:
                
                The above copyright notice and this permission notice shall be included in all
                copies or substantial portions of the Software.
                
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                SOFTWARE.
                 */
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.debounce = void 0;
                function debounce(func) {
                    let waitMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
                    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    var _a, _b;
                    let timeoutId;
                    const isImmediate = (_a = options.isImmediate) !== null && _a !== void 0 ? _a : false;
                    const callback = (_b = options.callback) !== null && _b !== void 0 ? _b : false;
                    const maxWait = options.maxWait;
                    let lastInvokeTime = Date.now();
                    let promises = [];
                    function nextInvokeTimeout() {
                        if (maxWait !== undefined) {
                            const timeSinceLastInvocation = Date.now() - lastInvokeTime;
                            if (timeSinceLastInvocation + waitMilliseconds >= maxWait) {
                                return maxWait - timeSinceLastInvocation;
                            }
                        }
                        return waitMilliseconds;
                    }
                    const debouncedFunction = function debouncedFunction() {
                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }
                        // eslint-disable-next-line no-invalid-this, @typescript-eslint/no-this-alias
                        const context = this;
                        return new Promise((resolve, reject) => {
                            const invokeFunction = function invokeFunction() {
                                timeoutId = undefined;
                                lastInvokeTime = Date.now();
                                if (!isImmediate) {
                                    const result = func.apply(context, args);
                                    callback && callback(result);
                                    promises.forEach(_ref => {
                                        let { resolve } = _ref;
                                        return resolve(result);
                                    });
                                    promises = [];
                                }
                            };
                            const shouldCallNow = isImmediate && timeoutId === undefined;
                            if (timeoutId !== undefined) {
                                clearTimeout(timeoutId);
                            }
                            timeoutId = setTimeout(invokeFunction, nextInvokeTimeout());
                            if (shouldCallNow) {
                                const result = func.apply(context, args);
                                callback && callback(result);
                                return resolve(result);
                            }
                            promises.push({
                                resolve,
                                reject
                            });
                        });
                    };
                    debouncedFunction.cancel = function (reason) {
                        if (timeoutId !== undefined) {
                            clearTimeout(timeoutId);
                        }
                        promises.forEach(_ref2 => {
                            let { reject } = _ref2;
                            return reject(reason);
                        });
                        promises = [];
                    };
                    return debouncedFunction;
                }
                exports.debounce = debounce;
                /***/ 
            }),
            /***/ 37225: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function (resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function (resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            }
                            catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.assertUnreachable = exports.sleep = exports.truncateHexString = exports.hasGetter = exports.isValidUrl = exports.deepFreeze = exports.pickByCopy = exports.deepMerge = exports.Copy = exports.joinPaths = exports.omitByCopy = exports.omitInPlace = exports.withoutLastElement = exports.jsonParseEmbeddedKeys = exports.topLevelCompare = exports.dateSorted = exports.omitUndefinedCopy = exports.sortByKey = exports.sortedCopy = exports.objectToValueArray = exports.arrayByRemovingFromIndex = exports.addAtIndex = exports.removeFromIndex = exports.compareValues = exports.compareArrayReferences = exports.arrayByDifference = exports.filterFromArray = exports.addIfUnique = exports.removeFromArray = exports.subtractFromArray = exports.extendArray = exports.lastElement = exports.uniqueArrayByKey = exports.uniqueArray = exports.uniqCombineObjArrays = exports.greaterOfTwoDates = exports.isString = exports.isEmpty = exports.isNotUndefined = exports.isNullOrUndefined = exports.isFunction = exports.isObject = exports.sureSearchArray = exports.searchArray = exports.findInArray = exports.isReactNativeEnvironment = exports.isWebCryptoAvailable = exports.isWebEnvironment = exports.dictToArray = exports.getGlobalScope = void 0;
                exports.pluralize = exports.spaceSeparatedStrings = exports.useBoolean = exports.assert = exports.logWithColor = exports.log = exports.secondHalfOfString = exports.firstHalfOfString = exports.splitString = exports.nonSecureRandomIdentifier = exports.dateToLocalizedString = exports.sanitizeHtmlString = exports.convertTimestampToMilliseconds = exports.arraysEqual = exports.naturalSort = exports.isSameDay = void 0;
                /* eslint-disable @typescript-eslint/no-explicit-any */
                const dompurify_1 = __webpack_require__(59154);
                const lodash_1 = __webpack_require__(84213);
                const collator = typeof Intl !== 'undefined' ? new Intl.Collator('en', {
                    numeric: true
                }) : undefined;
                function getGlobalScope() {
                    return typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : null;
                }
                exports.getGlobalScope = getGlobalScope;
                function dictToArray(dict) {
                    return Object.values(dict);
                }
                exports.dictToArray = dictToArray;
                /**
                 * Whether we are in a web browser
                 */
                function isWebEnvironment() {
                    return getGlobalScope() !== null;
                }
                exports.isWebEnvironment = isWebEnvironment;
                /**
                 * @returns true if WebCrypto is available
                 */
                function isWebCryptoAvailable() {
                    return isWebEnvironment() && !isReactNativeEnvironment() && !(document && document.documentMode) || /Edge/.test(navigator.userAgent) && window.crypto && !!window.crypto.subtle;
                }
                exports.isWebCryptoAvailable = isWebCryptoAvailable;
                /**
                 * Whether we are in React Native app
                 */
                function isReactNativeEnvironment() {
                    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
                }
                exports.isReactNativeEnvironment = isReactNativeEnvironment;
                /**
                 * Searches array of objects for first object where object[key] === value
                 * @returns Matching object or null if not found
                 */
                function findInArray(array, key, value) {
                    return array.find(item => item[key] === value);
                }
                exports.findInArray = findInArray;
                /**
                 * Searches array of objects for first object where object[key] === value
                 * @returns Matching object or null if not found
                 */
                function searchArray(array, predicate) {
                    return (0, lodash_1.find)(array, predicate);
                }
                exports.searchArray = searchArray;
                function sureSearchArray(array, predicate) {
                    return searchArray(array, predicate);
                }
                exports.sureSearchArray = sureSearchArray;
                /**
                 * @returns Whether the value is a function or object
                 */
                function isObject(value) {
                    if (value === null) {
                        return false;
                    }
                    return typeof value === 'function' || typeof value === 'object';
                }
                exports.isObject = isObject;
                /**
                 * @returns Whether the value is a function
                 */
                function isFunction(value) {
                    if (value === null) {
                        return false;
                    }
                    return typeof value === 'function';
                }
                exports.isFunction = isFunction;
                /**
                 * @returns True if the object is null or undefined, otherwise false
                 */
                function isNullOrUndefined(value) {
                    return value === null || value === undefined;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNotUndefined(val) {
                    return val != undefined;
                }
                exports.isNotUndefined = isNotUndefined;
                /**
                 * @returns True if the string is empty or undefined
                 */
                function isEmpty(string) {
                    return !string || string.length === 0;
                }
                exports.isEmpty = isEmpty;
                /**
                 * @returns Whether the value is a string
                 */
                function isString(value) {
                    return typeof value === 'string' || value instanceof String;
                }
                exports.isString = isString;
                /**
                 * @returns The greater of the two dates
                 */
                function greaterOfTwoDates(dateA, dateB) {
                    if (dateA > dateB) {
                        return dateA;
                    }
                    else {
                        return dateB;
                    }
                }
                exports.greaterOfTwoDates = greaterOfTwoDates;
                /**
                 * Returns a new array containing only unique values by combining the two input arrays.
                 * Elements are unique based on the values of `equalityKeys`.
                 * @param equalityKeys - Keys to determine element equality
                 * @returns Array containing unique values
                 */
                function uniqCombineObjArrays(arrayA, arrayB, equalityKeys) {
                    return (0, lodash_1.uniqWith)(arrayA.concat(arrayB), (a, b) => {
                        for (const key of equalityKeys) {
                            if (a[key] !== b[key]) {
                                return false;
                            }
                        }
                        return true;
                    });
                }
                exports.uniqCombineObjArrays = uniqCombineObjArrays;
                /**
                 * Returns a new array containing only unique values
                 * @returns Array containing unique values
                 */
                function uniqueArray(array) {
                    return (0, lodash_1.uniq)(array);
                }
                exports.uniqueArray = uniqueArray;
                /**
                 * Returns a new array containing only unique values
                 * @returns Array containing unique values
                 */
                function uniqueArrayByKey(array, key) {
                    return (0, lodash_1.uniqWith)(array, (a, b) => {
                        return a[key] === b[key];
                    });
                }
                exports.uniqueArrayByKey = uniqueArrayByKey;
                /**
                 * Returns the last element in the array.
                 * @returns The last element in the array
                 */
                function lastElement(array) {
                    return array[array.length - 1];
                }
                exports.lastElement = lastElement;
                /**
                 * Adds all items from otherArray into inArray, in-place.
                 * Does not return a value.
                 */
                function extendArray(inArray, otherArray) {
                    for (const value of otherArray) {
                        inArray.push(value);
                    }
                }
                exports.extendArray = extendArray;
                /**
                 * Removes all items appearing in toSubtract from inArray, in-place
                 * @param toSubtract - The list of items to remove from inArray
                 */
                function subtractFromArray(inArray, toSubtract) {
                    for (const value of toSubtract) {
                        removeFromArray(inArray, value);
                    }
                }
                exports.subtractFromArray = subtractFromArray;
                /**
                 * Removes the first matching element of an array by strict equality.
                 * If no matchin element is found, the array is left unchanged.
                 */
                function removeFromArray(array, value) {
                    const valueIndex = array.indexOf(value);
                    if (valueIndex === -1) {
                        return;
                    }
                    array.splice(valueIndex, 1);
                }
                exports.removeFromArray = removeFromArray;
                /**
                 * Adds the element to the array if the array does not already include the value.
                 * The array is searched via array.indexOf
                 * @returns true if value was added
                 */
                function addIfUnique(array, value) {
                    if (!array.includes(value)) {
                        array.push(value);
                        return true;
                    }
                    return false;
                }
                exports.addIfUnique = addIfUnique;
                /**
                 * Removes an object from the array in-place by searching for an object where all the
                 * key/values in predicate match with the candidate element.
                 */
                function filterFromArray(array, predicate) {
                    (0, lodash_1.remove)(array, predicate);
                }
                exports.filterFromArray = filterFromArray;
                /**
                 * Returns a new array by removing all elements in subtract from array
                 */
                function arrayByDifference(array, subtract) {
                    return array.filter(x => !subtract.includes(x)).concat(subtract.filter(x => !array.includes(x)));
                }
                exports.arrayByDifference = arrayByDifference;
                function compareArrayReferences(arr1, arr2) {
                    return arr1.length === arr2.length && arr1.every((val, index) => val === arr2[index]);
                }
                exports.compareArrayReferences = compareArrayReferences;
                function compareValues(left, right) {
                    if (left && !right || !left && right) {
                        return false;
                    }
                    if (left instanceof Date && right instanceof Date) {
                        return left.getTime() === right.getTime();
                    }
                    else if (left instanceof String && right instanceof String) {
                        return left === right;
                    }
                    else {
                        return topLevelCompare(left, right);
                    }
                }
                exports.compareValues = compareValues;
                /**
                 * Removes the value from the array at the given index, in-place.
                 */
                function removeFromIndex(array, index) {
                    array.splice(index, 1);
                }
                exports.removeFromIndex = removeFromIndex;
                /**
                 * Adds the value from the array at the given index, in-place.
                 */
                function addAtIndex(array, element, index) {
                    array.splice(index, 0, element);
                }
                exports.addAtIndex = addAtIndex;
                /**
                 * Returns a new array by removeing the value from the array at the given index
                 */
                function arrayByRemovingFromIndex(array, index) {
                    const copy = array.slice();
                    removeFromIndex(copy, index);
                    return copy;
                }
                exports.arrayByRemovingFromIndex = arrayByRemovingFromIndex;
                /**
                 * Returns an array where each element is the value of a top-level
                 * object key.
                 * Example: objectToValueArray({a: 1, b: 2}) returns [1, 2]
                 */
                function objectToValueArray(object) {
                    const values = [];
                    for (const key of Object.keys(object)) {
                        values.push(object[key]);
                    }
                    return values;
                }
                exports.objectToValueArray = objectToValueArray;
                /**
                 * Returns a key-sorted copy of the object.
                 * For example, sortedCopy({b: '1', a: '2'}) returns {a: '2', b: '1'}
                 */
                function sortedCopy(object) {
                    const keys = Object.keys(object).sort();
                    const result = {};
                    for (const key of keys) {
                        result[key] = object[key];
                    }
                    return Copy(result);
                }
                exports.sortedCopy = sortedCopy;
                const sortByKey = (input, key) => {
                    const compare = (a, b) => {
                        const valueA = a[key];
                        const valueB = b[key];
                        if (valueA < valueB) {
                            return -1;
                        }
                        if (valueA > valueB) {
                            return 1;
                        }
                        return 0;
                    };
                    const newArray = [...input];
                    newArray.sort(compare);
                    return newArray;
                };
                exports.sortByKey = sortByKey;
                /** Returns a new object by omitting any keys which have an undefined or null value  */
                function omitUndefinedCopy(object) {
                    const result = {};
                    for (const key of Object.keys(object)) {
                        if (!isNullOrUndefined(object[key])) {
                            result[key] = object[key];
                        }
                    }
                    return result;
                }
                exports.omitUndefinedCopy = omitUndefinedCopy;
                /**
                 * Returns a new array by sorting an array of elements based on a date property,
                 * as indicated by the input key value.
                 */
                function dateSorted(elements, key) {
                    let ascending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                    return elements.sort((a, b) => {
                        const aTimestamp = a[key].getTime();
                        const bTimestamp = b[key].getTime();
                        const vector = ascending ? 1 : -1;
                        if (aTimestamp < bTimestamp) {
                            return -1 * vector;
                        }
                        else if (aTimestamp > bTimestamp) {
                            return 1 * vector;
                        }
                        else {
                            return 0;
                        }
                    });
                }
                exports.dateSorted = dateSorted;
                /** Compares for equality by comparing top-level keys value equality (===) */
                function topLevelCompare(left, right) {
                    if (!left && !right) {
                        return true;
                    }
                    if (!left || !right) {
                        return false;
                    }
                    const leftKeys = Object.keys(left);
                    const rightKeys = Object.keys(right);
                    if (leftKeys.length !== rightKeys.length) {
                        return false;
                    }
                    for (const key of leftKeys) {
                        if (left[key] !== right[key]) {
                            return false;
                        }
                    }
                    return true;
                }
                exports.topLevelCompare = topLevelCompare;
                /**
                 * Returns a new object by attempting to JSON.parse any top-level object keys.
                 */
                function jsonParseEmbeddedKeys(object) {
                    const result = {};
                    for (const key of Object.keys(object)) {
                        let value;
                        try {
                            value = JSON.parse(object[key]);
                        }
                        catch (error) {
                            value = object[key];
                        }
                        result[key] = value;
                    }
                    return result;
                }
                exports.jsonParseEmbeddedKeys = jsonParseEmbeddedKeys;
                const withoutLastElement = array => {
                    return array.slice(0, -1);
                };
                exports.withoutLastElement = withoutLastElement;
                /**
                 * Deletes keys of the input object.
                 */
                function omitInPlace(object, keys) {
                    if (!object) {
                        return;
                    }
                    for (const key of keys) {
                        delete object[key];
                    }
                }
                exports.omitInPlace = omitInPlace;
                /**
                 * Creates a new object by omitting `keys` from `object`
                 */
                function omitByCopy(object, keys) {
                    if (isNullOrUndefined(object)) {
                        return undefined;
                    }
                    const newObject = Object.assign({}, object);
                    /**
                     * Lodash's omit, which was previously used, seems to cause unexpected behavior
                     * when payload is an ES6 item class. So we instead manually omit each key.
                     */
                    for (const key of keys) {
                        delete newObject[key];
                    }
                    return newObject;
                }
                exports.omitByCopy = omitByCopy;
                /**
                 * Similiar to Node's path.join, this function combines an array of paths into
                 * one resolved path.
                 */
                function joinPaths() {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }
                    return args.map((part, i) => {
                        if (i === 0) {
                            return part.trim().replace(/[/]*$/g, '');
                        }
                        else {
                            return part.trim().replace(/(^[/]*|[/]*$)/g, '');
                        }
                    }).filter(x => x.length).join('/');
                }
                exports.joinPaths = joinPaths;
                /**
                 * Creates a copy of the input object by JSON stringifying the object then JSON parsing
                 * the string (if the input is an object). If input is date, a Date copy will be created,
                 * and if input is a primitive value, it will be returned as-is.
                 */
                function Copy(object) {
                    if (object instanceof Date) {
                        return new Date(object);
                    }
                    else if (isObject(object)) {
                        return JSON.parse(JSON.stringify(object));
                    }
                    else {
                        return object;
                    }
                }
                exports.Copy = Copy;
                /**
                 * Merges the second object parameter into the first object, in-place.
                 * @returns The now modified first object parameter passed into the function.
                 */
                function deepMerge(a, b) {
                    /**
                     * lodash.merge will not merge a full array with an empty one.
                     * deepMerge will replace arrays wholesale
                     */
                    if (!a || !b) {
                        throw 'Attempting to deepMerge with null values';
                    }
                    const customizer = (aValue, bValue) => {
                        if ((0, lodash_1.isArray)(aValue)) {
                            return bValue;
                        }
                    };
                    (0, lodash_1.mergeWith)(a, b, customizer);
                    return a;
                }
                exports.deepMerge = deepMerge;
                /**
                 * Returns a new object by selecting certain keys from input object.
                 */
                function pickByCopy(object, keys) {
                    const result = {};
                    for (const key of keys) {
                        result[key] = object[key];
                    }
                    return Copy(result);
                }
                exports.pickByCopy = pickByCopy;
                /**
                 * Recursively makes an object immutable via Object.freeze
                 */
                function deepFreeze(object) {
                    const propNames = Object.getOwnPropertyNames(object);
                    for (const name of propNames) {
                        const value = object[name];
                        if (value && typeof value === 'object' && !Object.isFrozen(value)) {
                            object[name] = deepFreeze(value);
                        }
                        else {
                            object[name] = value;
                        }
                    }
                    return Object.freeze(object);
                }
                exports.deepFreeze = deepFreeze;
                function isValidUrl(url) {
                    try {
                        new URL(url);
                        return true;
                    }
                    catch (error) {
                        return false;
                    }
                }
                exports.isValidUrl = isValidUrl;
                /**
                 * Determines if an object has a getter defined for a given property
                 */
                function hasGetter(object, property) {
                    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(object), property);
                    return descriptor && !isNullOrUndefined(descriptor.get);
                }
                exports.hasGetter = hasGetter;
                /**
                 * Truncates a hex string into a desired number of bits
                 * @returns A hexadecimal string truncated to the number of desired bits
                 */
                function truncateHexString(string, desiredBits) {
                    const BITS_PER_HEX_CHAR = 4;
                    const desiredCharLength = desiredBits / BITS_PER_HEX_CHAR;
                    return string.substring(0, desiredCharLength);
                }
                exports.truncateHexString = truncateHexString;
                /**
                 * When awaited, this function allows code execution to pause for a set time.
                 * Should be used primarily for testing.
                 */
                function sleep(milliseconds) {
                    let warn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    let desc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                    return __awaiter(this, void 0, void 0, function* () {
                        if (warn) {
                            console.warn("Sleeping for ".concat(milliseconds, "ms ").concat(desc));
                        }
                        return new Promise(resolve => {
                            setTimeout(function () {
                                resolve();
                            }, milliseconds);
                        });
                    });
                }
                exports.sleep = sleep;
                function assertUnreachable(uncheckedCase) {
                    throw Error('Unchecked case ' + uncheckedCase);
                }
                exports.assertUnreachable = assertUnreachable;
                /**
                 * Returns a boolean representing whether two dates are on the same day
                 */
                function isSameDay(dateA, dateB) {
                    return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate();
                }
                exports.isSameDay = isSameDay;
                /**
                 * Sorts an array of objects in natural order
                 * @param items - The array of objects to sort
                 * @param property - The objects' property to sort by
                 * @param direction - The sorting direction, either ascending (default) or descending
                 * @returns Array of objects sorted in natural order
                 */
                function naturalSort(items, property) {
                    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
                    switch (direction) {
                        case 'asc':
                            return [...items].sort(collator ? (a, b) => collator.compare(a[property], b[property]) : (a, b) => a[property].localeCompare(b[property], 'en', {
                                numeric: true
                            }));
                        case 'desc':
                            return [...items].sort(collator ? (a, b) => collator.compare(b[property], a[property]) : (a, b) => b[property].localeCompare(a[property], 'en', {
                                numeric: true
                            }));
                    }
                }
                exports.naturalSort = naturalSort;
                function arraysEqual(left, right) {
                    if (left.length !== right.length) {
                        return false;
                    }
                    return left.every(item => right.includes(item)) && right.every(item => left.includes(item));
                }
                exports.arraysEqual = arraysEqual;
                const MicrosecondsInAMillisecond = 1000;
                const MillisecondsInASecond = 1000;
                var TimestampDigits;
                (function (TimestampDigits) {
                    TimestampDigits[TimestampDigits["Seconds"] = 10] = "Seconds";
                    TimestampDigits[TimestampDigits["Milliseconds"] = 13] = "Milliseconds";
                    TimestampDigits[TimestampDigits["Microseconds"] = 16] = "Microseconds";
                })(TimestampDigits || (TimestampDigits = {}));
                function convertTimestampToMilliseconds(timestamp) {
                    const digits = String(timestamp).length;
                    switch (digits) {
                        case TimestampDigits.Seconds:
                            return timestamp * MillisecondsInASecond;
                        case TimestampDigits.Milliseconds:
                            return timestamp;
                        case TimestampDigits.Microseconds:
                            return Math.floor(timestamp / MicrosecondsInAMillisecond);
                        default:
                            throw "Unhandled timestamp precision: ".concat(timestamp);
                    }
                }
                exports.convertTimestampToMilliseconds = convertTimestampToMilliseconds;
                function sanitizeHtmlString(html) {
                    return (0, dompurify_1.sanitize)(html);
                }
                exports.sanitizeHtmlString = sanitizeHtmlString;
                let sharedDateFormatter;
                function dateToLocalizedString(date) {
                    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat && typeof navigator !== 'undefined') {
                        if (!sharedDateFormatter) {
                            const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
                            sharedDateFormatter = new Intl.DateTimeFormat(locale, {
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                weekday: 'long',
                                hour: '2-digit',
                                minute: '2-digit'
                            });
                        }
                        return sharedDateFormatter.format(date);
                    }
                    else {
                        // IE < 11, Safari <= 9.0.
                        // In English, this generates the string most similar to
                        // the toLocaleDateString() result above.
                        return date.toDateString() + ' ' + date.toLocaleTimeString();
                    }
                }
                exports.dateToLocalizedString = dateToLocalizedString;
                function nonSecureRandomIdentifier() {
                    return "".concat(Math.random() * 100).replace('.', '');
                }
                exports.nonSecureRandomIdentifier = nonSecureRandomIdentifier;
                function splitString(string, parts) {
                    const outputLength = string.length;
                    const partLength = outputLength / parts;
                    const partitions = [];
                    for (let i = 0; i < parts; i++) {
                        const partition = string.slice(partLength * i, partLength * (i + 1));
                        partitions.push(partition);
                    }
                    return partitions;
                }
                exports.splitString = splitString;
                function firstHalfOfString(string) {
                    return string.substring(0, string.length / 2);
                }
                exports.firstHalfOfString = firstHalfOfString;
                function secondHalfOfString(string) {
                    return string.substring(string.length / 2, string.length);
                }
                exports.secondHalfOfString = secondHalfOfString;
                function log(namespace) {
                    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                        args[_key2 - 1] = arguments[_key2];
                    }
                    logWithColor(namespace, 'black', ...args);
                }
                exports.log = log;
                function logWithColor(namespace, namespaceColor) {
                    const date = new Date();
                    const timeString = "".concat(date.toLocaleTimeString().replace(' PM', '').replace(' AM', ''), ".").concat(date.getMilliseconds());
                    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                        args[_key3 - 2] = arguments[_key3];
                    }
                    customLog("%c".concat(namespace, "%c").concat(timeString), "color: ".concat(namespaceColor, "; font-weight: bold; margin-right: 4px"), 'color: gray', ...args);
                }
                exports.logWithColor = logWithColor;
                function customLog() {
                    for (var _len4 = arguments.length, _args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        _args[_key4] = arguments[_key4];
                    }
                    // eslint-disable-next-line no-console, prefer-rest-params
                    Function.prototype.apply.call(console.log, console, arguments);
                }
                function assert(value) {
                    if (value === undefined) {
                        throw new Error('Assertion failed; value must be defined');
                    }
                }
                exports.assert = assert;
                function useBoolean(value, defaultValue) {
                    return value != undefined ? value : defaultValue;
                }
                exports.useBoolean = useBoolean;
                function spaceSeparatedStrings() {
                    for (var _len5 = arguments.length, strings = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        strings[_key5] = arguments[_key5];
                    }
                    return strings.join(' ');
                }
                exports.spaceSeparatedStrings = spaceSeparatedStrings;
                function pluralize(count, singular, plural) {
                    return count === 1 ? singular : plural;
                }
                exports.pluralize = pluralize;
                /***/ 
            }),
            /***/ 49095: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.Uuids = void 0;
                function Uuids(items) {
                    return items.map(item => {
                        return item.uuid;
                    });
                }
                exports.Uuids = Uuids;
                /***/ 
            }),
            /***/ 57865: 
            /***/ ((__unused_webpack_module, exports) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UuidGenerator = void 0;
                /**
                 * An abstract class with no instance methods. Used globally to generate uuids by any
                 * consumer. Application must call SetGenerator before use.
                 */
                class UuidGenerator {
                    /**
                     * @param {function} syncImpl - A syncronous function that returns a UUID.
                     */
                    static SetGenerator(syncImpl) {
                        this.syncUuidFunc = syncImpl;
                    }
                    /**
                     * Generates a UUID string asyncronously.
                     */
                    static GenerateUuid() {
                        return this.syncUuidFunc();
                    }
                }
                exports.UuidGenerator = UuidGenerator;
                /***/ 
            }),
            /***/ 28569: 
            /***/ ((__unused_webpack_module, exports, __webpack_require__) => {
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                exports.UuidMap = void 0;
                const Utils_1 = __webpack_require__(37225);
                /**
                 * Maps a UUID to an array of UUIDS to establish either direct or inverse
                 * relationships between UUID strings (represantative of items or payloads).
                 */
                class UuidMap {
                    constructor() {
                        /** uuid to uuids that we have a relationship with */
                        this.directMap = new Map();
                        /** uuid to uuids that have a relationship with us */
                        this.inverseMap = new Map();
                    }
                    get directMapSize() {
                        return this.directMap.size;
                    }
                    get inverseMapSize() {
                        return this.inverseMap.size;
                    }
                    makeCopy() {
                        const copy = new UuidMap();
                        copy.directMap = new Map(this.directMap);
                        copy.inverseMap = new Map(this.inverseMap);
                        return copy;
                    }
                    existsInDirectMap(uuid) {
                        return this.directMap.has(uuid);
                    }
                    existsInInverseMap(uuid) {
                        return this.inverseMap.has(uuid);
                    }
                    getDirectRelationships(uuid) {
                        return this.directMap.get(uuid) || [];
                    }
                    getAllDirectKeys() {
                        return Array.from(this.directMap.keys());
                    }
                    getInverseRelationships(uuid) {
                        return this.inverseMap.get(uuid) || [];
                    }
                    establishRelationship(uuidA, uuidB) {
                        this.establishDirectRelationship(uuidA, uuidB);
                        this.establishInverseRelationship(uuidA, uuidB);
                    }
                    deestablishRelationship(uuidA, uuidB) {
                        this.deestablishDirectRelationship(uuidA, uuidB);
                        this.deestablishInverseRelationship(uuidA, uuidB);
                    }
                    setAllRelationships(uuid, relationships) {
                        const previousDirect = this.directMap.get(uuid) || [];
                        this.directMap.set(uuid, relationships);
                        /** Remove all previous values in case relationships have changed
                         * The updated references will be added afterwards.
                         */
                        for (const previousRelationship of previousDirect) {
                            this.deestablishInverseRelationship(uuid, previousRelationship);
                        }
                        /** Now map current relationships */
                        for (const newRelationship of relationships) {
                            this.establishInverseRelationship(uuid, newRelationship);
                        }
                    }
                    removeFromMap(uuid) {
                        /** Items that we reference */
                        const directReferences = this.directMap.get(uuid) || [];
                        for (const directReference of directReferences) {
                            (0, Utils_1.removeFromArray)(this.inverseMap.get(directReference) || [], uuid);
                        }
                        this.directMap.delete(uuid);
                        /** Items that are referencing us */
                        const inverseReferences = this.inverseMap.get(uuid) || [];
                        for (const inverseReference of inverseReferences) {
                            (0, Utils_1.removeFromArray)(this.directMap.get(inverseReference) || [], uuid);
                        }
                        this.inverseMap.delete(uuid);
                    }
                    establishDirectRelationship(uuidA, uuidB) {
                        const index = this.directMap.get(uuidA) || [];
                        (0, Utils_1.addIfUnique)(index, uuidB);
                        this.directMap.set(uuidA, index);
                    }
                    establishInverseRelationship(uuidA, uuidB) {
                        const inverseIndex = this.inverseMap.get(uuidB) || [];
                        (0, Utils_1.addIfUnique)(inverseIndex, uuidA);
                        this.inverseMap.set(uuidB, inverseIndex);
                    }
                    deestablishDirectRelationship(uuidA, uuidB) {
                        const index = this.directMap.get(uuidA) || [];
                        (0, Utils_1.removeFromArray)(index, uuidB);
                        this.directMap.set(uuidA, index);
                    }
                    deestablishInverseRelationship(uuidA, uuidB) {
                        const inverseIndex = this.inverseMap.get(uuidB) || [];
                        (0, Utils_1.removeFromArray)(inverseIndex, uuidA);
                        this.inverseMap.set(uuidB, inverseIndex);
                    }
                }
                exports.UuidMap = UuidMap;
                /***/ 
            }),
            /***/ 31800: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(81346), exports);
                __exportStar(__webpack_require__(90622), exports);
                __exportStar(__webpack_require__(75760), exports);
                __exportStar(__webpack_require__(75807), exports);
                __exportStar(__webpack_require__(91379), exports);
                __exportStar(__webpack_require__(13777), exports);
                __exportStar(__webpack_require__(33638), exports);
                __exportStar(__webpack_require__(47887), exports);
                __exportStar(__webpack_require__(92484), exports);
                __exportStar(__webpack_require__(37225), exports);
                __exportStar(__webpack_require__(49095), exports);
                __exportStar(__webpack_require__(57865), exports);
                __exportStar(__webpack_require__(28569), exports);
                __exportStar(__webpack_require__(12377), exports);
                /***/ 
            }),
            /***/ 87901: 
            /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                        desc = {
                            enumerable: true,
                            get: function get() {
                                return m[k];
                            }
                        };
                    }
                    Object.defineProperty(o, k2, desc);
                } : function (o, m, k, k2) {
                    if (k2 === undefined)
                        k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function (m, exports) {
                    for (var p in m)
                        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
                            __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", ({
                    value: true
                }));
                __exportStar(__webpack_require__(31800), exports);
                /***/ 
            })
            /******/ 
        });
        /************************************************************************/
        /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) {
                /******/ return cachedModule.exports;
                /******/ }
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
                /******/ 
            };
            /******/
            /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Flag the module as loaded
            /******/ module.loaded = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/ 
        }
        /******/
        /************************************************************************/
        /******/ /* webpack/runtime/compat get default export */
        /******/ (() => {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = (module) => {
                /******/ var getter = module && module.__esModule ?
                    /******/ () => (module['default']) :
                    /******/ () => (module);
                /******/ __webpack_require__.d(getter, { a: getter });
                /******/ return getter;
                /******/ 
            };
            /******/ 
        })();
        /******/
        /******/ /* webpack/runtime/define property getters */
        /******/ (() => {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition) => {
                /******/ for (var key in definition) {
                    /******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                        /******/ Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
                        /******/ }
                    /******/ }
                /******/ 
            };
            /******/ 
        })();
        /******/
        /******/ /* webpack/runtime/global */
        /******/ (() => {
            /******/ __webpack_require__.g = (function () {
                /******/ if (typeof globalThis === 'object')
                    return globalThis;
                /******/ try {
                    /******/ return this || new Function('return this')();
                    /******/ }
                catch (e) {
                    /******/ if (typeof window === 'object')
                        return window;
                    /******/ }
                /******/ 
            })();
            /******/ 
        })();
        /******/
        /******/ /* webpack/runtime/hasOwnProperty shorthand */
        /******/ (() => {
            /******/ __webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop));
            /******/ 
        })();
        /******/
        /******/ /* webpack/runtime/make namespace object */
        /******/ (() => {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports) => {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                    /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                    /******/ }
                /******/ Object.defineProperty(exports, '__esModule', { value: true });
                /******/ 
            };
            /******/ 
        })();
        /******/
        /******/ /* webpack/runtime/node module decorator */
        /******/ (() => {
            /******/ __webpack_require__.nmd = (module) => {
                /******/ module.paths = [];
                /******/ if (!module.children)
                    module.children = [];
                /******/ return module;
                /******/ 
            };
            /******/ 
        })();
        /******/
        /************************************************************************/
        var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (() => {
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WLG),
                /* harmony export */ API_MESSAGE_FAILED_ACCESS_PURCHASE: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.gQA),
                /* harmony export */ API_MESSAGE_FAILED_CREATE_FILE_TOKEN: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qIx),
                /* harmony export */ API_MESSAGE_FAILED_DOWNLOADING_EXTENSION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.mvL),
                /* harmony export */ API_MESSAGE_FAILED_GET_SETTINGS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Zq2),
                /* harmony export */ API_MESSAGE_FAILED_LISTED_REGISTRATION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.EaW),
                /* harmony export */ API_MESSAGE_FAILED_OFFLINE_ACTIVATION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.iMd),
                /* harmony export */ API_MESSAGE_FAILED_OFFLINE_FEATURES: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WZ6),
                /* harmony export */ API_MESSAGE_FAILED_SUBSCRIPTION_INFO: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.BMD),
                /* harmony export */ API_MESSAGE_FAILED_UPDATE_SETTINGS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.oBV),
                /* harmony export */ API_MESSAGE_FALLBACK_LOGIN_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.aWs),
                /* harmony export */ API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Z15),
                /* harmony export */ API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.oe5),
                /* harmony export */ API_MESSAGE_GENERIC_INVALID_LOGIN: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.VpG),
                /* harmony export */ API_MESSAGE_GENERIC_REGISTRATION_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Cj$),
                /* harmony export */ API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.TwN),
                /* harmony export */ API_MESSAGE_GENERIC_SYNC_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.gEn),
                /* harmony export */ API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.lO_),
                /* harmony export */ API_MESSAGE_INVALID_SESSION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.aXB),
                /* harmony export */ API_MESSAGE_LOGIN_IN_PROGRESS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.TYJ),
                /* harmony export */ API_MESSAGE_RATE_LIMITED: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.jN7),
                /* harmony export */ API_MESSAGE_REGISTRATION_IN_PROGRESS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.vfv),
                /* harmony export */ API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.z6z),
                /* harmony export */ API_MESSAGE_UNTRUSTED_EXTENSIONS_WARNING: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.CV),
                /* harmony export */ AbstractService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.wcN),
                /* harmony export */ AcceptVaultInvite: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.nmV),
                /* harmony export */ AccountEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.oF7),
                /* harmony export */ AccountSyncOperation: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.U8),
                /* harmony export */ ActionsService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.bQ),
                /* harmony export */ AddAuthenticator: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.fC),
                /* harmony export */ AlertService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.c9N),
                /* harmony export */ AllowedBatchContentTypes: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Jg),
                /* harmony export */ AllowedBatchStreaming: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.h6),
                /* harmony export */ ApiServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Sf$),
                /* harmony export */ AppleIAPProductId: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.mxT),
                /* harmony export */ ApplicationEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.n9K),
                /* harmony export */ ApplicationGroupEvent: () => ( /* reexport safe */_ApplicationGroup__WEBPACK_IMPORTED_MODULE_2__.$),
                /* harmony export */ ApplicationOptionsDefaults: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.U3K),
                /* harmony export */ ApplicationService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.IX),
                /* harmony export */ ApplicationStage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ugm),
                /* harmony export */ AsymmetricMessageService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WXh),
                /* harmony export */ AuthManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.El),
                /* harmony export */ AuthenticatorManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.F8w),
                /* harmony export */ AuthorizeVaultDeletion: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.D$B),
                /* harmony export */ BackupFileType: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.qX),
                /* harmony export */ BaseMigration: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__._r),
                /* harmony export */ ButtonType: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.L$3),
                /* harmony export */ ByteChunker: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.M1),
                /* harmony export */ CHANGING_PASSCODE: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.V1G),
                /* harmony export */ Challenge: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.tv4),
                /* harmony export */ ChallengeKeyboardType: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.gqK),
                /* harmony export */ ChallengeModalTitle: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.GnZ),
                /* harmony export */ ChallengeOperation: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.ne),
                /* harmony export */ ChallengePrompt: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.FEo),
                /* harmony export */ ChallengePromptTitle: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.fD2),
                /* harmony export */ ChallengeReason: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ps8),
                /* harmony export */ ChallengeResponse: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.ap),
                /* harmony export */ ChallengeService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.PJ),
                /* harmony export */ ChallengeStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.NiJ),
                /* harmony export */ ChallengeValidation: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.tQn),
                /* harmony export */ ChangeAndSaveItem: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.EdL),
                /* harmony export */ ChangeVaultKeyOptions: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.tuB),
                /* harmony export */ ChangeVaultStorageMode: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KH1),
                /* harmony export */ ComponentManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.yW),
                /* harmony export */ ComponentViewer: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.SV),
                /* harmony export */ ComponentViewerError: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.kQg),
                /* harmony export */ ComputePrivateUsername: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.lx),
                /* harmony export */ ContactBelongsToVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.euo),
                /* harmony export */ ContactService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.yqc),
                /* harmony export */ ContactServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.EFn),
                /* harmony export */ ConvertToSharedVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.b$E),
                /* harmony export */ Create001KeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Nv),
                /* harmony export */ Create002KeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.H$),
                /* harmony export */ Create003KeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.mU),
                /* harmony export */ Create004KeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.ao),
                /* harmony export */ CreateAnyKeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.jl),
                /* harmony export */ CreateChallengeValue: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KL0),
                /* harmony export */ CreateDecryptedBackupFile: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ocI),
                /* harmony export */ CreateDecryptionSplitWithKeyLookup: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.nJ),
                /* harmony export */ CreateEncryptedBackupFile: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.D6l),
                /* harmony export */ CreateEncryptionSplitWithKeyLookup: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Ak),
                /* harmony export */ CreateNewDefaultItemsKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Nwx),
                /* harmony export */ CreateNewItemsKeyWithRollback: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Yw),
                /* harmony export */ CreateNewRootKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.C4),
                /* harmony export */ CreateOrEditContact: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Dk4),
                /* harmony export */ CreateSharedVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.zEM),
                /* harmony export */ CreateVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.TQm),
                /* harmony export */ CredentialsChangeStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Y7C),
                /* harmony export */ DO_NOT_CLOSE_APPLICATION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.liL),
                /* harmony export */ DecryptBackupFile: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.vV3),
                /* harmony export */ DecryptBackupPayloads: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ZXN),
                /* harmony export */ DecryptErroredPayloads: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.eyx),
                /* harmony export */ DecryptErroredTypeAPayloads: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.suI),
                /* harmony export */ DecryptItemsKeyByPromptingUser: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.zW4),
                /* harmony export */ DecryptItemsKeyWithUserFallback: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.nGw),
                /* harmony export */ DecryptMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$M4),
                /* harmony export */ DecryptOwnMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.EQN),
                /* harmony export */ DecryptTypeAPayload: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.gzl),
                /* harmony export */ DecryptTypeAPayloadWithKeyLookup: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qXV),
                /* harmony export */ DefaultHost: () => ( /* reexport safe */_Url__WEBPACK_IMPORTED_MODULE_8__.M),
                /* harmony export */ DeinitMode: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.CYv),
                /* harmony export */ DeinitSource: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.u4P),
                /* harmony export */ DeleteAuthenticator: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.cx),
                /* harmony export */ DeleteContact: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.z8s),
                /* harmony export */ DeleteRevision: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.gS),
                /* harmony export */ DeleteSharedVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KLn),
                /* harmony export */ DeleteThirdPartyVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.jGD),
                /* harmony export */ DeleteVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Rws),
                /* harmony export */ DeprecatedHttpService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.ql),
                /* harmony export */ DesignateSurvivor: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.X2V),
                /* harmony export */ DetermineKeyToUse: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WEs),
                /* harmony export */ DiscardItemsLocally: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ydb),
                /* harmony export */ DiskStorageService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.e5),
                /* harmony export */ DownloadAndDecryptFileOperation: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.BI),
                /* harmony export */ EXPIRED_PROTOCOL_VERSION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.R53),
                /* harmony export */ EditContact: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ZQj),
                /* harmony export */ EncryptAndUploadFileOperation: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.y4),
                /* harmony export */ EncryptMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.S1n),
                /* harmony export */ EncryptTypeAPayload: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.i6C),
                /* harmony export */ EncryptTypeAPayloadWithKeyLookup: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.k6d),
                /* harmony export */ EncryptionOperators: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.$l),
                /* harmony export */ EncryptionService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.C6q),
                /* harmony export */ EncryptionServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.fa_),
                /* harmony export */ ErrorAlertStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.kov),
                /* harmony export */ FeatureStatus: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.iKc),
                /* harmony export */ FeaturesEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Usi),
                /* harmony export */ FeaturesService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.kq),
                /* harmony export */ FileBackupsConstantsV1: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.yW),
                /* harmony export */ FileBackupsDirectoryName: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.aax),
                /* harmony export */ FileDecryptor: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.YT),
                /* harmony export */ FileDownloader: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.VA),
                /* harmony export */ FileEncryptor: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.IL),
                /* harmony export */ FileMemoryCache: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.F9),
                /* harmony export */ FileService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.IpN),
                /* harmony export */ FileUploader: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.bA),
                /* harmony export */ FilesBackupService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.exs),
                /* harmony export */ FillRootKeyContent: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.FX),
                /* harmony export */ FindContact: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.VD3),
                /* harmony export */ FindDefaultItemsKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.iPu),
                /* harmony export */ FindPayloadInDecryptionSplit: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.sP),
                /* harmony export */ FindPayloadInEncryptionSplit: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.G6),
                /* harmony export */ GenerateUuid: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ug$),
                /* harmony export */ GetAllContacts: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.s$_),
                /* harmony export */ GetAuthenticatorAuthenticationOptions: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.VQ),
                /* harmony export */ GetAuthenticatorAuthenticationResponse: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.FV),
                /* harmony export */ GetBackupFileType: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KCz),
                /* harmony export */ GetFilePassword: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.DZq),
                /* harmony export */ GetHost: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cdY),
                /* harmony export */ GetInboundMessages: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Vxn),
                /* harmony export */ GetKeyPairs: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Byj),
                /* harmony export */ GetMessageAdditionalData: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qk9),
                /* harmony export */ GetOutboundMessages: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WUT),
                /* harmony export */ GetOwnedSharedVaults: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.tlz),
                /* harmony export */ GetRecoveryCodes: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.u2),
                /* harmony export */ GetRevision: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.Xc),
                /* harmony export */ GetSharedVaults: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Tog),
                /* harmony export */ GetSortedPayloadsByPriority: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.xOS),
                /* harmony export */ GetTrustedPayload: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.pqE),
                /* harmony export */ GetUntrustedPayload: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.P9M),
                /* harmony export */ GetVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.dDs),
                /* harmony export */ GetVaultContacts: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.bDv),
                /* harmony export */ GetVaultItems: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$qZ),
                /* harmony export */ GetVaultUsers: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.PDt),
                /* harmony export */ GetVaults: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.r0l),
                /* harmony export */ HandleKeyPairChange: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qjc),
                /* harmony export */ HandleRootKeyChangedMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cjV),
                /* harmony export */ HistoryManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.EO),
                /* harmony export */ HomeServerService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.tGH),
                /* harmony export */ INVALID_EXTENSION_URL: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$cH),
                /* harmony export */ INVALID_PASSWORD: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.CVE),
                /* harmony export */ INVALID_PASSWORD_COST: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.nIe),
                /* harmony export */ ImportData: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ens),
                /* harmony export */ InMemoryStore: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.CEH),
                /* harmony export */ InfoStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.l4I),
                /* harmony export */ InsufficientPasswordMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Bw1),
                /* harmony export */ IntegrityEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ezr),
                /* harmony export */ IntegrityService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.yim),
                /* harmony export */ InternalEventBus: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ehg),
                /* harmony export */ InternalEventPublishStrategy: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WNP),
                /* harmony export */ InternalFeature: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KK4),
                /* harmony export */ InternalFeatureService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.BbS),
                /* harmony export */ InviteToVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.RAe),
                /* harmony export */ IsApplicationUsingThirdPartyHost: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Y8x),
                /* harmony export */ IsReadonlyVaultMember: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.hEi),
                /* harmony export */ IsVaultAdmin: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.o1e),
                /* harmony export */ IsVaultOwner: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.hjk),
                /* harmony export */ ItemManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.A),
                /* harmony export */ ItemRelationshipDirection: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.uMm),
                /* harmony export */ ItemSignatureValidationResult: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.kNl),
                /* harmony export */ ItemsEncryptionService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.oQ4),
                /* harmony export */ ItemsKeyMutator: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.tn),
                /* harmony export */ KeyMode: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.UEW),
                /* harmony export */ KeyParamsFromApiResponse: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.LW),
                /* harmony export */ KeyParamsOrigination: () => ( /* reexport safe */_standardnotes_common__WEBPACK_IMPORTED_MODULE_10__.KeyParamsOrigination),
                /* harmony export */ KeyRecoveryService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.D0),
                /* harmony export */ KeyRecoveryStrings: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.fD),
                /* harmony export */ KeySystemItemsKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.yv),
                /* harmony export */ KeySystemItemsKeyMutator: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.NC),
                /* harmony export */ KeySystemKeyManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Pn4),
                /* harmony export */ KeychainRecoveryStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.mHn),
                /* harmony export */ LeaveVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Z7G),
                /* harmony export */ LegacyApiService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Af),
                /* harmony export */ LegacyKeys1_0_0: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Icj),
                /* harmony export */ ListAuthenticators: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.FL),
                /* harmony export */ ListRevisions: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.GU),
                /* harmony export */ ListedService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.o8),
                /* harmony export */ LiveItem: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.J5),
                /* harmony export */ LocalPrefKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.dH$),
                /* harmony export */ MINIMUM_PASSWORD_LENGTH: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.aM),
                /* harmony export */ MfaService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.pY),
                /* harmony export */ Migration2_0_15: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.ly),
                /* harmony export */ Migration2_167_6: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.wg),
                /* harmony export */ Migration2_168_6: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.aL),
                /* harmony export */ Migration2_202_1: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.od),
                /* harmony export */ Migration2_208_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.Jb),
                /* harmony export */ Migration2_209_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.Lp),
                /* harmony export */ Migration2_20_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.kK),
                /* harmony export */ Migration2_36_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.qW),
                /* harmony export */ Migration2_42_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.Ni),
                /* harmony export */ Migration2_7_0: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.pI),
                /* harmony export */ MigrationClasses: () => ( /* reexport safe */_Migrations__WEBPACK_IMPORTED_MODULE_6__.R_),
                /* harmony export */ MigrationService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.HK),
                /* harmony export */ MissingAccountParams: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Sn),
                /* harmony export */ MobileUnlockTiming: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.sNv),
                /* harmony export */ MoveItemsToVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cZu),
                /* harmony export */ MutatorService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Vu),
                /* harmony export */ NonwrappedStorageKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cU9),
                /* harmony export */ NotificationService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.gqp),
                /* harmony export */ NotificationServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.JQe),
                /* harmony export */ NotifyVaultUsersOfKeyRotation: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cVV),
                /* harmony export */ OUTDATED_PROTOCOL_ALERT_IGNORE: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__._Bl),
                /* harmony export */ OfflineSyncOperation: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Bi),
                /* harmony export */ OrderedByteChunker: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.WE),
                /* harmony export */ Paths: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.nB),
                /* harmony export */ PayloadManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Ot),
                /* harmony export */ PreferencesService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.KJ),
                /* harmony export */ PreferencesServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.WZd),
                /* harmony export */ PreviousSnjsVersion1_0_0: () => ( /* reexport safe */_Version__WEBPACK_IMPORTED_MODULE_9__.DU),
                /* harmony export */ PreviousSnjsVersion2_0_0: () => ( /* reexport safe */_Version__WEBPACK_IMPORTED_MODULE_9__.Oq),
                /* harmony export */ ProcessAcceptedVaultInvite: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Klw),
                /* harmony export */ ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Ps),
                /* harmony export */ ProtectionEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Hh3),
                /* harmony export */ ProtectionService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.nT),
                /* harmony export */ ProtectionSessionDurations: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.jg),
                /* harmony export */ ProtocolUpgradeStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.GUt),
                /* harmony export */ ProtocolVersionForKeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.nx),
                /* harmony export */ REMOVING_PASSCODE: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.vL5),
                /* harmony export */ RawStorageKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Bq2),
                /* harmony export */ ReactNativeToWebEvent: () => ( /* reexport safe */_Client__WEBPACK_IMPORTED_MODULE_3__.Z),
                /* harmony export */ ReadwriteActions: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.wJ),
                /* harmony export */ ReencryptTypeAItems: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.HSp),
                /* harmony export */ RegisterStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.rc1),
                /* harmony export */ RemoveItemFromVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.fF_),
                /* harmony export */ RemoveItemsFromMemory: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$sG),
                /* harmony export */ RemoveVaultMember: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.YxU),
                /* harmony export */ ReplaceContactData: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.xRL),
                /* harmony export */ ResendAllMessages: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.HLD),
                /* harmony export */ ResendMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.IF$),
                /* harmony export */ ReuploadAllInvites: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.F0Y),
                /* harmony export */ ReuploadInvite: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.afr),
                /* harmony export */ ReuploadVaultInvites: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.s7t),
                /* harmony export */ RevisionManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.t9U),
                /* harmony export */ RootKeyManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.wtP),
                /* harmony export */ RotateVaultKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.PqX),
                /* harmony export */ SETTING_PASSCODE: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.TpP),
                /* harmony export */ SNApplication: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.UC),
                /* harmony export */ SNApplicationGroup: () => ( /* reexport safe */_ApplicationGroup__WEBPACK_IMPORTED_MODULE_2__.R),
                /* harmony export */ SNItemsKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.rU),
                /* harmony export */ SNLog: () => ( /* reexport safe */_Log__WEBPACK_IMPORTED_MODULE_5__.W),
                /* harmony export */ SNProtocolOperator001: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.d1),
                /* harmony export */ SNProtocolOperator002: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.QR),
                /* harmony export */ SNProtocolOperator003: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Er),
                /* harmony export */ SNProtocolOperator004: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.iN),
                /* harmony export */ SNRootKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.t$),
                /* harmony export */ SNRootKeyParams: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Gw),
                /* harmony export */ SelfContactManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Ld1),
                /* harmony export */ SendMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.uzh),
                /* harmony export */ SendOwnContactChangeMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.u3X),
                /* harmony export */ SendVaultDataChangedMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$SL),
                /* harmony export */ SendVaultInvite: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Iup),
                /* harmony export */ SendVaultKeyChangedMessage: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Foy),
                /* harmony export */ ServerErrorStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.VxG),
                /* harmony export */ ServerSyncResponse: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Fi),
                /* harmony export */ ServerSyncResponseResolver: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.y0),
                /* harmony export */ SessionEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Pxr),
                /* harmony export */ SessionManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Sj),
                /* harmony export */ SessionStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.K9E),
                /* harmony export */ SetHost: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.q62),
                /* harmony export */ SettingsService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.gb),
                /* harmony export */ ShareContactWithVault: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.uLb),
                /* harmony export */ SharedVaultService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.cnh),
                /* harmony export */ SharedVaultServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.$_C),
                /* harmony export */ SignInStrings: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Mwm),
                /* harmony export */ SignInWithRecoveryCodes: () => ( /* reexport safe */_Domain__WEBPACK_IMPORTED_MODULE_4__.Y_),
                /* harmony export */ SingletonManager: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Wz),
                /* harmony export */ SnjsVersion: () => ( /* reexport safe */_Version__WEBPACK_IMPORTED_MODULE_9__["in"]),
                /* harmony export */ SplitPayloadsByEncryptionType: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.xg),
                /* harmony export */ StandardException: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.KX),
                /* harmony export */ StaticItemCounter: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.kNs),
                /* harmony export */ StatusService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Bjn),
                /* harmony export */ StatusServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.rW4),
                /* harmony export */ StorageKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.QtK),
                /* harmony export */ StoragePersistencePolicies: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.eIN),
                /* harmony export */ StorageValueModes: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qt7),
                /* harmony export */ StrictSignInFailed: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.OC4),
                /* harmony export */ SubscriptionManager: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.LF2),
                /* harmony export */ SubscriptionManagerEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.lKe),
                /* harmony export */ SyncBackoffService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.XEg),
                /* harmony export */ SyncEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.wMo),
                /* harmony export */ SyncLocalVaultsWithRemoteSharedVaults: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__._Jh),
                /* harmony export */ SyncMode: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.YCg),
                /* harmony export */ SyncOpStatus: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.BUK),
                /* harmony export */ SyncQueueStrategy: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Sii),
                /* harmony export */ SyncService: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__._U),
                /* harmony export */ SyncSource: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Lbd),
                /* harmony export */ SyncUpDownLimit: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.jH),
                /* harmony export */ TYPES: () => ( /* reexport safe */_Application_Dependencies_Types__WEBPACK_IMPORTED_MODULE_1__.v),
                /* harmony export */ TextBackupsDirectoryName: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.OU3),
                /* harmony export */ UNKNOWN_ERROR: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.I4j),
                /* harmony export */ UNSUPPORTED_KEY_DERIVATION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.VnT),
                /* harmony export */ UNSUPPORTED_PROTOCOL_VERSION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.fnl),
                /* harmony export */ UPGRADING_ENCRYPTION: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.RsP),
                /* harmony export */ UnprotectedAccessSecondsDuration: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.Fr),
                /* harmony export */ UserService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.KDu),
                /* harmony export */ V001Algorithm: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.xo),
                /* harmony export */ V002Algorithm: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.$4),
                /* harmony export */ V003Algorithm: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__._0),
                /* harmony export */ V004Algorithm: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.eC),
                /* harmony export */ ValidKeyParamsKeys: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Am),
                /* harmony export */ ValidateItemSigner: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Lv2),
                /* harmony export */ ValidateVaultPassword: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.EGP),
                /* harmony export */ ValueModesKeys: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.dDH),
                /* harmony export */ VaultInviteService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.hZp),
                /* harmony export */ VaultInviteServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Z$T),
                /* harmony export */ VaultLockService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.PHC),
                /* harmony export */ VaultLockServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.h21),
                /* harmony export */ VaultService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.RDE),
                /* harmony export */ VaultServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ccW),
                /* harmony export */ VaultUserCache: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.k7Z),
                /* harmony export */ VaultUserService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.igb),
                /* harmony export */ VaultUserServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.UR5),
                /* harmony export */ WebAppEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.B5f),
                /* harmony export */ WebSocketsService: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.BV4),
                /* harmony export */ WebSocketsServiceEvent: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.fAX),
                /* harmony export */ applicationEventForSyncEvent: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.ie),
                /* harmony export */ compareSemVersions: () => ( /* reexport safe */_Version__WEBPACK_IMPORTED_MODULE_9__.D8),
                /* harmony export */ createOperatorForVersion: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.ZP),
                /* harmony export */ deconstructEncryptedPayloadString: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.UH),
                /* harmony export */ decryptPayload: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.oO),
                /* harmony export */ doesPayloadRequireSigning: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.qw),
                /* harmony export */ encryptPayload: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.Gl),
                /* harmony export */ encryptedInputParametersFromPayload: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.xi),
                /* harmony export */ environmentToString: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.g),
                /* harmony export */ fileProgressToHumanReadableString: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.Qc),
                /* harmony export */ isChunkFullEntry: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.ufS),
                /* harmony export */ isComponentViewerItemReadonlyItem: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.qr4),
                /* harmony export */ isDesktopDevice: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.dse),
                /* harmony export */ isEnvironmentMobile: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.Im),
                /* harmony export */ isEnvironmentWebOrDesktop: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.Ak),
                /* harmony export */ isErrorDecryptingParameters: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.XL),
                /* harmony export */ isFullEntryLoadChunkResponse: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.Or9),
                /* harmony export */ isItemsKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.dS),
                /* harmony export */ isKeySystemItemsKey: () => ( /* reexport safe */_standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__.mX),
                /* harmony export */ isMobileDevice: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.s2G),
                /* harmony export */ isRightVersionGreaterThanLeft: () => ( /* reexport safe */_Version__WEBPACK_IMPORTED_MODULE_9__.jV),
                /* harmony export */ isValidProtectionSessionLength: () => ( /* reexport safe */_Services__WEBPACK_IMPORTED_MODULE_7__.z4),
                /* harmony export */ namespacedKey: () => ( /* reexport safe */_standardnotes_services__WEBPACK_IMPORTED_MODULE_18__.xLN),
                /* harmony export */ platformFromString: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__.FB),
                /* harmony export */ platformToString: () => ( /* reexport safe */_Application__WEBPACK_IMPORTED_MODULE_0__._e),
                /* harmony export */ readAndDecryptBackupFileUsingBackupService: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.mQ),
                /* harmony export */ readAndDecryptBackupFileUsingFileSystemAPI: () => ( /* reexport safe */_standardnotes_files__WEBPACK_IMPORTED_MODULE_15__.Qf)
                /* harmony export */ 
            });
            /* harmony import */ var _Application__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85593);
            /* harmony import */ var _Application_Dependencies_Types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13979);
            /* harmony import */ var _ApplicationGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58181);
            /* harmony import */ var _Client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29159);
            /* harmony import */ var _Domain__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67199);
            /* harmony import */ var _Log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43361);
            /* harmony import */ var _Migrations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90693);
            /* harmony import */ var _Services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91096);
            /* harmony import */ var _Url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34146);
            /* harmony import */ var _Version__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94986);
            /* harmony import */ var _standardnotes_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20875);
            /* harmony import */ var _standardnotes_common__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_common__WEBPACK_IMPORTED_MODULE_10__);
            /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82648);
            /* harmony import */ var _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_11__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_11__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_domain_core__WEBPACK_IMPORTED_MODULE_11__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70781);
            /* harmony import */ var _standardnotes_api__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_api__WEBPACK_IMPORTED_MODULE_12__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_api__WEBPACK_IMPORTED_MODULE_12__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_api__WEBPACK_IMPORTED_MODULE_12__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_encryption__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86999);
            /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80215);
            /* harmony import */ var _standardnotes_features__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_features__WEBPACK_IMPORTED_MODULE_14__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_features__WEBPACK_IMPORTED_MODULE_14__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft", "BackupFileType", "ComputePrivateUsername", "Create001KeyParams", "Create002KeyParams", "Create003KeyParams", "Create004KeyParams", "CreateAnyKeyParams", "CreateDecryptionSplitWithKeyLookup", "CreateEncryptionSplitWithKeyLookup", "CreateNewRootKey", "EncryptionOperators", "FillRootKeyContent", "FindPayloadInDecryptionSplit", "FindPayloadInEncryptionSplit", "ItemsKeyMutator", "KeyParamsFromApiResponse", "KeyRecoveryStrings", "KeySystemItemsKey", "KeySystemItemsKeyMutator", "ProtocolVersionForKeyParams", "SNItemsKey", "SNProtocolOperator001", "SNProtocolOperator002", "SNProtocolOperator003", "SNProtocolOperator004", "SNRootKey", "SNRootKeyParams", "SplitPayloadsByEncryptionType", "StandardException", "V001Algorithm", "V002Algorithm", "V003Algorithm", "V004Algorithm", "ValidKeyParamsKeys", "createOperatorForVersion", "deconstructEncryptedPayloadString", "decryptPayload", "doesPayloadRequireSigning", "encryptPayload", "encryptedInputParametersFromPayload", "isErrorDecryptingParameters", "isItemsKey", "isKeySystemItemsKey"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_features__WEBPACK_IMPORTED_MODULE_14__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_files__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86311);
            /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22325);
            /* harmony import */ var _standardnotes_models__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_models__WEBPACK_IMPORTED_MODULE_16__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_models__WEBPACK_IMPORTED_MODULE_16__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft", "BackupFileType", "ComputePrivateUsername", "Create001KeyParams", "Create002KeyParams", "Create003KeyParams", "Create004KeyParams", "CreateAnyKeyParams", "CreateDecryptionSplitWithKeyLookup", "CreateEncryptionSplitWithKeyLookup", "CreateNewRootKey", "EncryptionOperators", "FillRootKeyContent", "FindPayloadInDecryptionSplit", "FindPayloadInEncryptionSplit", "ItemsKeyMutator", "KeyParamsFromApiResponse", "KeyRecoveryStrings", "KeySystemItemsKey", "KeySystemItemsKeyMutator", "ProtocolVersionForKeyParams", "SNItemsKey", "SNProtocolOperator001", "SNProtocolOperator002", "SNProtocolOperator003", "SNProtocolOperator004", "SNRootKey", "SNRootKeyParams", "SplitPayloadsByEncryptionType", "StandardException", "V001Algorithm", "V002Algorithm", "V003Algorithm", "V004Algorithm", "ValidKeyParamsKeys", "createOperatorForVersion", "deconstructEncryptedPayloadString", "decryptPayload", "doesPayloadRequireSigning", "encryptPayload", "encryptedInputParametersFromPayload", "isErrorDecryptingParameters", "isItemsKey", "isKeySystemItemsKey", "ByteChunker", "DownloadAndDecryptFileOperation", "EncryptAndUploadFileOperation", "FileBackupsConstantsV1", "FileDecryptor", "FileDownloader", "FileEncryptor", "FileMemoryCache", "FileUploader", "OrderedByteChunker", "fileProgressToHumanReadableString", "readAndDecryptBackupFileUsingBackupService", "readAndDecryptBackupFileUsingFileSystemAPI"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_models__WEBPACK_IMPORTED_MODULE_16__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(95658);
            /* harmony import */ var _standardnotes_responses__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_responses__WEBPACK_IMPORTED_MODULE_17__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_responses__WEBPACK_IMPORTED_MODULE_17__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft", "BackupFileType", "ComputePrivateUsername", "Create001KeyParams", "Create002KeyParams", "Create003KeyParams", "Create004KeyParams", "CreateAnyKeyParams", "CreateDecryptionSplitWithKeyLookup", "CreateEncryptionSplitWithKeyLookup", "CreateNewRootKey", "EncryptionOperators", "FillRootKeyContent", "FindPayloadInDecryptionSplit", "FindPayloadInEncryptionSplit", "ItemsKeyMutator", "KeyParamsFromApiResponse", "KeyRecoveryStrings", "KeySystemItemsKey", "KeySystemItemsKeyMutator", "ProtocolVersionForKeyParams", "SNItemsKey", "SNProtocolOperator001", "SNProtocolOperator002", "SNProtocolOperator003", "SNProtocolOperator004", "SNRootKey", "SNRootKeyParams", "SplitPayloadsByEncryptionType", "StandardException", "V001Algorithm", "V002Algorithm", "V003Algorithm", "V004Algorithm", "ValidKeyParamsKeys", "createOperatorForVersion", "deconstructEncryptedPayloadString", "decryptPayload", "doesPayloadRequireSigning", "encryptPayload", "encryptedInputParametersFromPayload", "isErrorDecryptingParameters", "isItemsKey", "isKeySystemItemsKey", "ByteChunker", "DownloadAndDecryptFileOperation", "EncryptAndUploadFileOperation", "FileBackupsConstantsV1", "FileDecryptor", "FileDownloader", "FileEncryptor", "FileMemoryCache", "FileUploader", "OrderedByteChunker", "fileProgressToHumanReadableString", "readAndDecryptBackupFileUsingBackupService", "readAndDecryptBackupFileUsingFileSystemAPI"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_responses__WEBPACK_IMPORTED_MODULE_17__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_services__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55668);
            /* harmony import */ var _standardnotes_settings__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(73606);
            /* harmony import */ var _standardnotes_settings__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_settings__WEBPACK_IMPORTED_MODULE_19__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_settings__WEBPACK_IMPORTED_MODULE_19__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft", "BackupFileType", "ComputePrivateUsername", "Create001KeyParams", "Create002KeyParams", "Create003KeyParams", "Create004KeyParams", "CreateAnyKeyParams", "CreateDecryptionSplitWithKeyLookup", "CreateEncryptionSplitWithKeyLookup", "CreateNewRootKey", "EncryptionOperators", "FillRootKeyContent", "FindPayloadInDecryptionSplit", "FindPayloadInEncryptionSplit", "ItemsKeyMutator", "KeyParamsFromApiResponse", "KeyRecoveryStrings", "KeySystemItemsKey", "KeySystemItemsKeyMutator", "ProtocolVersionForKeyParams", "SNItemsKey", "SNProtocolOperator001", "SNProtocolOperator002", "SNProtocolOperator003", "SNProtocolOperator004", "SNRootKey", "SNRootKeyParams", "SplitPayloadsByEncryptionType", "StandardException", "V001Algorithm", "V002Algorithm", "V003Algorithm", "V004Algorithm", "ValidKeyParamsKeys", "createOperatorForVersion", "deconstructEncryptedPayloadString", "decryptPayload", "doesPayloadRequireSigning", "encryptPayload", "encryptedInputParametersFromPayload", "isErrorDecryptingParameters", "isItemsKey", "isKeySystemItemsKey", "ByteChunker", "DownloadAndDecryptFileOperation", "EncryptAndUploadFileOperation", "FileBackupsConstantsV1", "FileDecryptor", "FileDownloader", "FileEncryptor", "FileMemoryCache", "FileUploader", "OrderedByteChunker", "fileProgressToHumanReadableString", "readAndDecryptBackupFileUsingBackupService", "readAndDecryptBackupFileUsingFileSystemAPI", "API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS", "API_MESSAGE_FAILED_ACCESS_PURCHASE", "API_MESSAGE_FAILED_CREATE_FILE_TOKEN", "API_MESSAGE_FAILED_DOWNLOADING_EXTENSION", "API_MESSAGE_FAILED_GET_SETTINGS", "API_MESSAGE_FAILED_LISTED_REGISTRATION", "API_MESSAGE_FAILED_OFFLINE_ACTIVATION", "API_MESSAGE_FAILED_OFFLINE_FEATURES", "API_MESSAGE_FAILED_SUBSCRIPTION_INFO", "API_MESSAGE_FAILED_UPDATE_SETTINGS", "API_MESSAGE_FALLBACK_LOGIN_FAIL", "API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL", "API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL", "API_MESSAGE_GENERIC_INVALID_LOGIN", "API_MESSAGE_GENERIC_REGISTRATION_FAIL", "API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL", "API_MESSAGE_GENERIC_SYNC_FAIL", "API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL", "API_MESSAGE_INVALID_SESSION", "API_MESSAGE_LOGIN_IN_PROGRESS", "API_MESSAGE_RATE_LIMITED", "API_MESSAGE_REGISTRATION_IN_PROGRESS", "API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS", "API_MESSAGE_UNTRUSTED_EXTENSIONS_WARNING", "AbstractService", "AcceptVaultInvite", "AccountEvent", "AlertService", "ApiServiceEvent", "AppleIAPProductId", "ApplicationEvent", "ApplicationOptionsDefaults", "ApplicationStage", "AsymmetricMessageService", "AuthManager", "AuthenticatorManager", "AuthorizeVaultDeletion", "ButtonType", "CHANGING_PASSCODE", "Challenge", "ChallengeKeyboardType", "ChallengeModalTitle", "ChallengePrompt", "ChallengePromptTitle", "ChallengeReason", "ChallengeStrings", "ChallengeValidation", "ChangeAndSaveItem", "ChangeVaultKeyOptions", "ChangeVaultStorageMode", "ComponentViewerError", "ContactBelongsToVault", "ContactService", "ContactServiceEvent", "ConvertToSharedVault", "CreateChallengeValue", "CreateDecryptedBackupFile", "CreateEncryptedBackupFile", "CreateNewDefaultItemsKey", "CreateNewItemsKeyWithRollback", "CreateOrEditContact", "CreateSharedVault", "CreateVault", "CredentialsChangeStrings", "DO_NOT_CLOSE_APPLICATION", "DecryptBackupFile", "DecryptBackupPayloads", "DecryptErroredPayloads", "DecryptErroredTypeAPayloads", "DecryptItemsKeyByPromptingUser", "DecryptItemsKeyWithUserFallback", "DecryptMessage", "DecryptOwnMessage", "DecryptTypeAPayload", "DecryptTypeAPayloadWithKeyLookup", "DeinitMode", "DeinitSource", "DeleteContact", "DeleteSharedVault", "DeleteThirdPartyVault", "DeleteVault", "DesignateSurvivor", "DetermineKeyToUse", "DiscardItemsLocally", "EXPIRED_PROTOCOL_VERSION", "EditContact", "EncryptMessage", "EncryptTypeAPayload", "EncryptTypeAPayloadWithKeyLookup", "EncryptionService", "EncryptionServiceEvent", "ErrorAlertStrings", "FeatureStatus", "FeaturesEvent", "FileBackupsDirectoryName", "FileService", "FilesBackupService", "FindContact", "FindDefaultItemsKey", "GenerateUuid", "GetAllContacts", "GetBackupFileType", "GetFilePassword", "GetHost", "GetInboundMessages", "GetKeyPairs", "GetMessageAdditionalData", "GetOutboundMessages", "GetOwnedSharedVaults", "GetSharedVaults", "GetSortedPayloadsByPriority", "GetTrustedPayload", "GetUntrustedPayload", "GetVault", "GetVaultContacts", "GetVaultItems", "GetVaultUsers", "GetVaults", "HandleKeyPairChange", "HandleRootKeyChangedMessage", "HomeServerService", "INVALID_EXTENSION_URL", "INVALID_PASSWORD", "INVALID_PASSWORD_COST", "ImportData", "InMemoryStore", "InfoStrings", "InsufficientPasswordMessage", "IntegrityEvent", "IntegrityService", "InternalEventBus", "InternalEventPublishStrategy", "InternalFeature", "InternalFeatureService", "InviteToVault", "IsApplicationUsingThirdPartyHost", "IsReadonlyVaultMember", "IsVaultAdmin", "IsVaultOwner", "ItemRelationshipDirection", "ItemSignatureValidationResult", "ItemsEncryptionService", "KeyMode", "KeySystemKeyManager", "KeychainRecoveryStrings", "LeaveVault", "LegacyKeys1_0_0", "LocalPrefKey", "MobileUnlockTiming", "MoveItemsToVault", "NonwrappedStorageKey", "NotificationService", "NotificationServiceEvent", "NotifyVaultUsersOfKeyRotation", "OUTDATED_PROTOCOL_ALERT_IGNORE", "PreferencesServiceEvent", "ProcessAcceptedVaultInvite", "ProtectionEvent", "ProtocolUpgradeStrings", "REMOVING_PASSCODE", "RawStorageKey", "ReencryptTypeAItems", "RegisterStrings", "RemoveItemFromVault", "RemoveItemsFromMemory", "RemoveVaultMember", "ReplaceContactData", "ResendAllMessages", "ResendMessage", "ReuploadAllInvites", "ReuploadInvite", "ReuploadVaultInvites", "RevisionManager", "RootKeyManager", "RotateVaultKey", "SETTING_PASSCODE", "SelfContactManager", "SendMessage", "SendOwnContactChangeMessage", "SendVaultDataChangedMessage", "SendVaultInvite", "SendVaultKeyChangedMessage", "ServerErrorStrings", "SessionEvent", "SessionStrings", "SetHost", "ShareContactWithVault", "SharedVaultService", "SharedVaultServiceEvent", "SignInStrings", "StaticItemCounter", "StatusService", "StatusServiceEvent", "StorageKey", "StoragePersistencePolicies", "StorageValueModes", "StrictSignInFailed", "SubscriptionManager", "SubscriptionManagerEvent", "SyncBackoffService", "SyncEvent", "SyncLocalVaultsWithRemoteSharedVaults", "SyncMode", "SyncOpStatus", "SyncQueueStrategy", "SyncSource", "TextBackupsDirectoryName", "UNKNOWN_ERROR", "UNSUPPORTED_KEY_DERIVATION", "UNSUPPORTED_PROTOCOL_VERSION", "UPGRADING_ENCRYPTION", "UserService", "ValidateItemSigner", "ValidateVaultPassword", "ValueModesKeys", "VaultInviteService", "VaultInviteServiceEvent", "VaultLockService", "VaultLockServiceEvent", "VaultService", "VaultServiceEvent", "VaultUserCache", "VaultUserService", "VaultUserServiceEvent", "WebAppEvent", "WebSocketsService", "WebSocketsServiceEvent", "isChunkFullEntry", "isComponentViewerItemReadonlyItem", "isDesktopDevice", "isFullEntryLoadChunkResponse", "isMobileDevice", "namespacedKey"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_settings__WEBPACK_IMPORTED_MODULE_19__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
            /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87901);
            /* harmony import */ var _standardnotes_utils__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/ __webpack_require__.n(_standardnotes_utils__WEBPACK_IMPORTED_MODULE_20__);
            /* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
            /* harmony reexport (unknown) */ for (const __WEBPACK_IMPORT_KEY__ in _standardnotes_utils__WEBPACK_IMPORTED_MODULE_20__)
                if (["default", "KeyParamsOrigination", "LiveItem", "SNApplication", "applicationEventForSyncEvent", "environmentToString", "isEnvironmentMobile", "isEnvironmentWebOrDesktop", "platformFromString", "platformToString", "TYPES", "ApplicationGroupEvent", "SNApplicationGroup", "ReactNativeToWebEvent", "AddAuthenticator", "DeleteAuthenticator", "DeleteRevision", "GetAuthenticatorAuthenticationOptions", "GetAuthenticatorAuthenticationResponse", "GetRecoveryCodes", "GetRevision", "ListAuthenticators", "ListRevisions", "SignInWithRecoveryCodes", "SNLog", "BaseMigration", "Migration2_0_15", "Migration2_167_6", "Migration2_168_6", "Migration2_202_1", "Migration2_208_0", "Migration2_209_0", "Migration2_20_0", "Migration2_36_0", "Migration2_42_0", "Migration2_7_0", "MigrationClasses", "AccountSyncOperation", "ActionsService", "AllowedBatchContentTypes", "AllowedBatchStreaming", "ApplicationService", "ChallengeOperation", "ChallengeResponse", "ChallengeService", "ComponentManager", "ComponentViewer", "DeprecatedHttpService", "DiskStorageService", "FeaturesService", "HistoryManager", "ItemManager", "KeyRecoveryService", "LegacyApiService", "ListedService", "MINIMUM_PASSWORD_LENGTH", "MfaService", "MigrationService", "MissingAccountParams", "MutatorService", "OfflineSyncOperation", "Paths", "PayloadManager", "PreferencesService", "ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction", "ProtectionService", "ProtectionSessionDurations", "ReadwriteActions", "ServerSyncResponse", "ServerSyncResponseResolver", "SessionManager", "SettingsService", "SingletonManager", "SyncService", "SyncUpDownLimit", "UnprotectedAccessSecondsDuration", "isValidProtectionSessionLength", "DefaultHost", "PreviousSnjsVersion1_0_0", "PreviousSnjsVersion2_0_0", "SnjsVersion", "compareSemVersions", "isRightVersionGreaterThanLeft", "BackupFileType", "ComputePrivateUsername", "Create001KeyParams", "Create002KeyParams", "Create003KeyParams", "Create004KeyParams", "CreateAnyKeyParams", "CreateDecryptionSplitWithKeyLookup", "CreateEncryptionSplitWithKeyLookup", "CreateNewRootKey", "EncryptionOperators", "FillRootKeyContent", "FindPayloadInDecryptionSplit", "FindPayloadInEncryptionSplit", "ItemsKeyMutator", "KeyParamsFromApiResponse", "KeyRecoveryStrings", "KeySystemItemsKey", "KeySystemItemsKeyMutator", "ProtocolVersionForKeyParams", "SNItemsKey", "SNProtocolOperator001", "SNProtocolOperator002", "SNProtocolOperator003", "SNProtocolOperator004", "SNRootKey", "SNRootKeyParams", "SplitPayloadsByEncryptionType", "StandardException", "V001Algorithm", "V002Algorithm", "V003Algorithm", "V004Algorithm", "ValidKeyParamsKeys", "createOperatorForVersion", "deconstructEncryptedPayloadString", "decryptPayload", "doesPayloadRequireSigning", "encryptPayload", "encryptedInputParametersFromPayload", "isErrorDecryptingParameters", "isItemsKey", "isKeySystemItemsKey", "ByteChunker", "DownloadAndDecryptFileOperation", "EncryptAndUploadFileOperation", "FileBackupsConstantsV1", "FileDecryptor", "FileDownloader", "FileEncryptor", "FileMemoryCache", "FileUploader", "OrderedByteChunker", "fileProgressToHumanReadableString", "readAndDecryptBackupFileUsingBackupService", "readAndDecryptBackupFileUsingFileSystemAPI", "API_MESSAGE_CHANGE_CREDENTIALS_IN_PROGRESS", "API_MESSAGE_FAILED_ACCESS_PURCHASE", "API_MESSAGE_FAILED_CREATE_FILE_TOKEN", "API_MESSAGE_FAILED_DOWNLOADING_EXTENSION", "API_MESSAGE_FAILED_GET_SETTINGS", "API_MESSAGE_FAILED_LISTED_REGISTRATION", "API_MESSAGE_FAILED_OFFLINE_ACTIVATION", "API_MESSAGE_FAILED_OFFLINE_FEATURES", "API_MESSAGE_FAILED_SUBSCRIPTION_INFO", "API_MESSAGE_FAILED_UPDATE_SETTINGS", "API_MESSAGE_FALLBACK_LOGIN_FAIL", "API_MESSAGE_GENERIC_CHANGE_CREDENTIALS_FAIL", "API_MESSAGE_GENERIC_INTEGRITY_CHECK_FAIL", "API_MESSAGE_GENERIC_INVALID_LOGIN", "API_MESSAGE_GENERIC_REGISTRATION_FAIL", "API_MESSAGE_GENERIC_SINGLE_ITEM_SYNC_FAIL", "API_MESSAGE_GENERIC_SYNC_FAIL", "API_MESSAGE_GENERIC_TOKEN_REFRESH_FAIL", "API_MESSAGE_INVALID_SESSION", "API_MESSAGE_LOGIN_IN_PROGRESS", "API_MESSAGE_RATE_LIMITED", "API_MESSAGE_REGISTRATION_IN_PROGRESS", "API_MESSAGE_TOKEN_REFRESH_IN_PROGRESS", "API_MESSAGE_UNTRUSTED_EXTENSIONS_WARNING", "AbstractService", "AcceptVaultInvite", "AccountEvent", "AlertService", "ApiServiceEvent", "AppleIAPProductId", "ApplicationEvent", "ApplicationOptionsDefaults", "ApplicationStage", "AsymmetricMessageService", "AuthManager", "AuthenticatorManager", "AuthorizeVaultDeletion", "ButtonType", "CHANGING_PASSCODE", "Challenge", "ChallengeKeyboardType", "ChallengeModalTitle", "ChallengePrompt", "ChallengePromptTitle", "ChallengeReason", "ChallengeStrings", "ChallengeValidation", "ChangeAndSaveItem", "ChangeVaultKeyOptions", "ChangeVaultStorageMode", "ComponentViewerError", "ContactBelongsToVault", "ContactService", "ContactServiceEvent", "ConvertToSharedVault", "CreateChallengeValue", "CreateDecryptedBackupFile", "CreateEncryptedBackupFile", "CreateNewDefaultItemsKey", "CreateNewItemsKeyWithRollback", "CreateOrEditContact", "CreateSharedVault", "CreateVault", "CredentialsChangeStrings", "DO_NOT_CLOSE_APPLICATION", "DecryptBackupFile", "DecryptBackupPayloads", "DecryptErroredPayloads", "DecryptErroredTypeAPayloads", "DecryptItemsKeyByPromptingUser", "DecryptItemsKeyWithUserFallback", "DecryptMessage", "DecryptOwnMessage", "DecryptTypeAPayload", "DecryptTypeAPayloadWithKeyLookup", "DeinitMode", "DeinitSource", "DeleteContact", "DeleteSharedVault", "DeleteThirdPartyVault", "DeleteVault", "DesignateSurvivor", "DetermineKeyToUse", "DiscardItemsLocally", "EXPIRED_PROTOCOL_VERSION", "EditContact", "EncryptMessage", "EncryptTypeAPayload", "EncryptTypeAPayloadWithKeyLookup", "EncryptionService", "EncryptionServiceEvent", "ErrorAlertStrings", "FeatureStatus", "FeaturesEvent", "FileBackupsDirectoryName", "FileService", "FilesBackupService", "FindContact", "FindDefaultItemsKey", "GenerateUuid", "GetAllContacts", "GetBackupFileType", "GetFilePassword", "GetHost", "GetInboundMessages", "GetKeyPairs", "GetMessageAdditionalData", "GetOutboundMessages", "GetOwnedSharedVaults", "GetSharedVaults", "GetSortedPayloadsByPriority", "GetTrustedPayload", "GetUntrustedPayload", "GetVault", "GetVaultContacts", "GetVaultItems", "GetVaultUsers", "GetVaults", "HandleKeyPairChange", "HandleRootKeyChangedMessage", "HomeServerService", "INVALID_EXTENSION_URL", "INVALID_PASSWORD", "INVALID_PASSWORD_COST", "ImportData", "InMemoryStore", "InfoStrings", "InsufficientPasswordMessage", "IntegrityEvent", "IntegrityService", "InternalEventBus", "InternalEventPublishStrategy", "InternalFeature", "InternalFeatureService", "InviteToVault", "IsApplicationUsingThirdPartyHost", "IsReadonlyVaultMember", "IsVaultAdmin", "IsVaultOwner", "ItemRelationshipDirection", "ItemSignatureValidationResult", "ItemsEncryptionService", "KeyMode", "KeySystemKeyManager", "KeychainRecoveryStrings", "LeaveVault", "LegacyKeys1_0_0", "LocalPrefKey", "MobileUnlockTiming", "MoveItemsToVault", "NonwrappedStorageKey", "NotificationService", "NotificationServiceEvent", "NotifyVaultUsersOfKeyRotation", "OUTDATED_PROTOCOL_ALERT_IGNORE", "PreferencesServiceEvent", "ProcessAcceptedVaultInvite", "ProtectionEvent", "ProtocolUpgradeStrings", "REMOVING_PASSCODE", "RawStorageKey", "ReencryptTypeAItems", "RegisterStrings", "RemoveItemFromVault", "RemoveItemsFromMemory", "RemoveVaultMember", "ReplaceContactData", "ResendAllMessages", "ResendMessage", "ReuploadAllInvites", "ReuploadInvite", "ReuploadVaultInvites", "RevisionManager", "RootKeyManager", "RotateVaultKey", "SETTING_PASSCODE", "SelfContactManager", "SendMessage", "SendOwnContactChangeMessage", "SendVaultDataChangedMessage", "SendVaultInvite", "SendVaultKeyChangedMessage", "ServerErrorStrings", "SessionEvent", "SessionStrings", "SetHost", "ShareContactWithVault", "SharedVaultService", "SharedVaultServiceEvent", "SignInStrings", "StaticItemCounter", "StatusService", "StatusServiceEvent", "StorageKey", "StoragePersistencePolicies", "StorageValueModes", "StrictSignInFailed", "SubscriptionManager", "SubscriptionManagerEvent", "SyncBackoffService", "SyncEvent", "SyncLocalVaultsWithRemoteSharedVaults", "SyncMode", "SyncOpStatus", "SyncQueueStrategy", "SyncSource", "TextBackupsDirectoryName", "UNKNOWN_ERROR", "UNSUPPORTED_KEY_DERIVATION", "UNSUPPORTED_PROTOCOL_VERSION", "UPGRADING_ENCRYPTION", "UserService", "ValidateItemSigner", "ValidateVaultPassword", "ValueModesKeys", "VaultInviteService", "VaultInviteServiceEvent", "VaultLockService", "VaultLockServiceEvent", "VaultService", "VaultServiceEvent", "VaultUserCache", "VaultUserService", "VaultUserServiceEvent", "WebAppEvent", "WebSocketsService", "WebSocketsServiceEvent", "isChunkFullEntry", "isComponentViewerItemReadonlyItem", "isDesktopDevice", "isFullEntryLoadChunkResponse", "isMobileDevice", "namespacedKey"].indexOf(__WEBPACK_IMPORT_KEY__) < 0)
                    __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _standardnotes_utils__WEBPACK_IMPORTED_MODULE_20__[__WEBPACK_IMPORT_KEY__];
            /* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
        })();
        /******/ return __webpack_exports__;
        /******/ 
    })();
});
